/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 535);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pug_has_own_property = Object.prototype.hasOwnProperty;

/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

exports.merge = pug_merge;
function pug_merge(a, b) {
  if (arguments.length === 1) {
    var attrs = a[0];
    for (var i = 1; i < a.length; i++) {
      attrs = pug_merge(attrs, a[i]);
    }
    return attrs;
  }

  for (var key in b) {
    if (key === 'class') {
      var valA = a[key] || [];
      a[key] = (Array.isArray(valA) ? valA : [valA]).concat(b[key] || []);
    } else if (key === 'style') {
      var valA = pug_style(a[key]);
      var valB = pug_style(b[key]);
      a[key] = valA + valB;
    } else {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Process array, object, or string as a string of classes delimited by a space.
 *
 * If `val` is an array, all members of it and its subarrays are counted as
 * classes. If `escaping` is an array, then whether or not the item in `val` is
 * escaped depends on the corresponding item in `escaping`. If `escaping` is
 * not an array, no escaping is done.
 *
 * If `val` is an object, all the keys whose value is truthy are counted as
 * classes. No escaping is done.
 *
 * If `val` is a string, it is counted as a class. No escaping is done.
 *
 * @param {(Array.<string>|Object.<string, boolean>|string)} val
 * @param {?Array.<string>} escaping
 * @return {String}
 */
exports.classes = pug_classes;
function pug_classes_array(val, escaping) {
  var classString = '', className, padding = '', escapeEnabled = Array.isArray(escaping);
  for (var i = 0; i < val.length; i++) {
    className = pug_classes(val[i]);
    if (!className) continue;
    escapeEnabled && escaping[i] && (className = pug_escape(className));
    classString = classString + padding + className;
    padding = ' ';
  }
  return classString;
}
function pug_classes_object(val) {
  var classString = '', padding = '';
  for (var key in val) {
    if (key && val[key] && pug_has_own_property.call(val, key)) {
      classString = classString + padding + key;
      padding = ' ';
    }
  }
  return classString;
}
function pug_classes(val, escaping) {
  if (Array.isArray(val)) {
    return pug_classes_array(val, escaping);
  } else if (val && typeof val === 'object') {
    return pug_classes_object(val);
  } else {
    return val || '';
  }
}

/**
 * Convert object or string to a string of CSS styles delimited by a semicolon.
 *
 * @param {(Object.<string, string>|string)} val
 * @return {String}
 */

exports.style = pug_style;
function pug_style(val) {
  if (!val) return '';
  if (typeof val === 'object') {
    var out = '';
    for (var style in val) {
      /* istanbul ignore else */
      if (pug_has_own_property.call(val, style)) {
        out = out + style + ':' + val[style] + ';';
      }
    }
    return out;
  } else {
    val += '';
    if (val[val.length - 1] !== ';') 
      return val + ';';
    return val;
  }
};

/**
 * Render the given attribute.
 *
 * @param {String} key
 * @param {String} val
 * @param {Boolean} escaped
 * @param {Boolean} terse
 * @return {String}
 */
exports.attr = pug_attr;
function pug_attr(key, val, escaped, terse) {
  if (val === false || val == null || !val && (key === 'class' || key === 'style')) {
    return '';
  }
  if (val === true) {
    return ' ' + (terse ? key : key + '="' + key + '"');
  }
  if (typeof val.toJSON === 'function') {
    val = val.toJSON();
  }
  if (typeof val !== 'string') {
    val = JSON.stringify(val);
    if (!escaped && val.indexOf('"') !== -1) {
      return ' ' + key + '=\'' + val.replace(/'/g, '&#39;') + '\'';
    }
  }
  if (escaped) val = pug_escape(val);
  return ' ' + key + '="' + val + '"';
};

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} terse whether to use HTML5 terse boolean attributes
 * @return {String}
 */
exports.attrs = pug_attrs;
function pug_attrs(obj, terse){
  var attrs = '';

  for (var key in obj) {
    if (pug_has_own_property.call(obj, key)) {
      var val = obj[key];

      if ('class' === key) {
        val = pug_classes(val);
        attrs = pug_attr(key, val, false, terse) + attrs;
        continue;
      }
      if ('style' === key) {
        val = pug_style(val);
      }
      attrs += pug_attr(key, val, false, terse);
    }
  }

  return attrs;
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

var pug_match_html = /["&<>]/;
exports.escape = pug_escape;
function pug_escape(_html){
  var html = '' + _html;
  var regexResult = pug_match_html.exec(html);
  if (!regexResult) return _html;

  var result = '';
  var i, lastIndex, escape;
  for (i = regexResult.index, lastIndex = 0; i < html.length; i++) {
    switch (html.charCodeAt(i)) {
      case 34: escape = '&quot;'; break;
      case 38: escape = '&amp;'; break;
      case 60: escape = '&lt;'; break;
      case 62: escape = '&gt;'; break;
      default: continue;
    }
    if (lastIndex !== i) result += html.substring(lastIndex, i);
    lastIndex = i + 1;
    result += escape;
  }
  if (lastIndex !== i) return result + html.substring(lastIndex, i);
  else return result;
};

/**
 * Re-throw the given `err` in context to the
 * the pug in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @param {String} str original source
 * @api private
 */

exports.rethrow = pug_rethrow;
function pug_rethrow(err, filename, lineno, str){
  if (!(err instanceof Error)) throw err;
  if ((typeof window != 'undefined' || !filename) && !str) {
    err.message += ' on line ' + lineno;
    throw err;
  }
  try {
    str = str || __webpack_require__(1145).readFileSync(filename, 'utf8')
  } catch (ex) {
    pug_rethrow(err, null, lineno)
  }
  var context = 3
    , lines = str.split('\n')
    , start = Math.max(lineno - context, 0)
    , end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Pug') + ':' + lineno
    + '\n' + context + '\n\n' + err.message;
  throw err;
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(87);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(12)
  , core      = __webpack_require__(97)
  , hide      = __webpack_require__(35)
  , redefine  = __webpack_require__(54)
  , ctx       = __webpack_require__(43)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__section__ = __webpack_require__(576);


var options = {
  container: '.site-content'
};
var instance = new __WEBPACK_IMPORTED_MODULE_0__section__["a" /* default */](options);

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 4 */
/***/ (function(module, exports) {


/**
 * Expose `parse`.
 */

module.exports = parse;

/**
 * Tests for browser support.
 */

var innerHTMLBug = false;
var bugTestDiv;
if (typeof document !== 'undefined') {
  bugTestDiv = document.createElement('div');
  // Setup
  bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
  // Make sure that link elements get serialized correctly by innerHTML
  // This requires a wrapper element in IE
  innerHTMLBug = !bugTestDiv.getElementsByTagName('link').length;
  bugTestDiv = undefined;
}

/**
 * Wrap map from jquery.
 */

var map = {
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  // for script/link/style tags to work in IE6-8, you have to wrap
  // in a div with a non-whitespace character in front, ha!
  _default: innerHTMLBug ? [1, 'X<div>', '</div>'] : [0, '', '']
};

map.td =
map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option =
map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead =
map.tbody =
map.colgroup =
map.caption =
map.tfoot = [1, '<table>', '</table>'];

map.polyline =
map.ellipse =
map.polygon =
map.circle =
map.text =
map.line =
map.path =
map.rect =
map.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">','</svg>'];

/**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */

function parse(html, doc) {
  if ('string' != typeof html) throw new TypeError('String expected');

  // default to the global `document` object
  if (!doc) doc = document;

  // tag name
  var m = /<([\w:]+)/.exec(html);
  if (!m) return doc.createTextNode(html);

  html = html.replace(/^\s+|\s+$/g, ''); // Remove leading/trailing whitespace

  var tag = m[1];

  // body support
  if (tag == 'body') {
    var el = doc.createElement('html');
    el.innerHTML = html;
    return el.removeChild(el.lastChild);
  }

  // wrap map
  var wrap = map[tag] || map._default;
  var depth = wrap[0];
  var prefix = wrap[1];
  var suffix = wrap[2];
  var el = doc.createElement('div');
  el.innerHTML = prefix + html + suffix;
  while (depth--) el = el.lastChild;

  // one element
  if (el.firstChild == el.lastChild) {
    return el.removeChild(el.firstChild);
  }

  // several elements
  var fragment = doc.createDocumentFragment();
  while (el.firstChild) {
    fragment.appendChild(el.removeChild(el.firstChild));
  }

  return fragment;
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_exit__ = __webpack_require__(559);
/* eslint-env browser */




var config = window.APP_CONFIG;

function abPage() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var pageArgs = args.map(function (arg) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(arg)) {
      return arg;
    }

    return function (ctx, next) {
      if (ctx.winningFullPageVariantName === 'original') {
        return arg.call(arg, ctx, next);
      }

      return next();
    };
  });

  __WEBPACK_IMPORTED_MODULE_1_page___default.a.apply(__WEBPACK_IMPORTED_MODULE_1_page___default.a, pageArgs);
}

abPage.exit = __WEBPACK_IMPORTED_MODULE_2__page_exit__["a" /* default */];

abPage.redirect = __WEBPACK_IMPORTED_MODULE_1_page___default.a.redirect;

/* harmony default export */ __webpack_exports__["a"] = (config.disable_analytics ? __WEBPACK_IMPORTED_MODULE_1_page___default.a : abPage);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(32);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(112)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scriptloader__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scriptloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scriptloader__);
/* npm version only adapted from https://github.com/cristiandouce/require-global */
/* eslint-env browser */


/**
 * Expose `requireGlobal`
 */

/* harmony default export */ __webpack_exports__["a"] = (requireg);

/**
 * Load global `source` with optional
 * check for a global `namespace` or many
 *
 * @param {String} source
 * @param {String|Array} namespace
 * @param {Function} callback
 * @public
 */

function requireg(source, namespace, callback) {
  if (typeof namespace === 'function') {
    callback = namespace;
    namespace = null;
  }

  if (loaded(namespace)) return callback(null);

  __WEBPACK_IMPORTED_MODULE_0_scriptloader___default()(source, callback);
}

/**
 * Check for an already loaded namespace
 * to avoid overriding or double fetching
 *
 * @param {String|Array} namespace
 * @return {Boolean}
 * @private
 */

function loaded(namespace) {
  if (typeof namespace === 'string') namespace = [namespace];

  for (var i = 0; i < namespace.length; i += 1) {
    var test = new Function('_', 'return _.' + namespace[i] + ' != null');

    try {
      if (!test(window)) return false;
    } catch (err) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var EventEmitter = __webpack_require__(280).EventEmitter;
} catch (err) {
  var Emitter = __webpack_require__(280);
}

/**
 * Noop.
 */

function noop(){}

/**
 * Expose `Batch`.
 */

module.exports = Batch;

/**
 * Create a new Batch.
 */

function Batch() {
  if (!(this instanceof Batch)) return new Batch;
  this.fns = [];
  this.concurrency(Infinity);
  this.throws(true);
  for (var i = 0, len = arguments.length; i < len; ++i) {
    this.push(arguments[i]);
  }
}

/**
 * Inherit from `EventEmitter.prototype`.
 */

if (EventEmitter) {
  Batch.prototype.__proto__ = EventEmitter.prototype;
} else {
  Emitter(Batch.prototype);
}

/**
 * Set concurrency to `n`.
 *
 * @param {Number} n
 * @return {Batch}
 * @api public
 */

Batch.prototype.concurrency = function(n){
  this.n = n;
  return this;
};

/**
 * Queue a function.
 *
 * @param {Function} fn
 * @return {Batch}
 * @api public
 */

Batch.prototype.push = function(fn){
  this.fns.push(fn);
  return this;
};

/**
 * Set wether Batch will or will not throw up.
 *
 * @param  {Boolean} throws
 * @return {Batch}
 * @api public
 */
Batch.prototype.throws = function(throws) {
  this.e = !!throws;
  return this;
};

/**
 * Execute all queued functions in parallel,
 * executing `cb(err, results)`.
 *
 * @param {Function} cb
 * @return {Batch}
 * @api public
 */

Batch.prototype.end = function(cb){
  var self = this
    , total = this.fns.length
    , pending = total
    , results = []
    , errors = []
    , cb = cb || noop
    , fns = this.fns
    , max = this.n
    , throws = this.e
    , index = 0
    , done;

  // empty
  if (!fns.length) return cb(null, results);

  // process
  function next() {
    var i = index++;
    var fn = fns[i];
    if (!fn) return;
    var start = new Date;

    try {
      fn(callback);
    } catch (err) {
      callback(err);
    }

    function callback(err, res){
      if (done) return;
      if (err && throws) return done = true, cb(err);
      var complete = total - pending + 1;
      var end = new Date;

      results[i] = res;
      errors[i] = err;

      self.emit('progress', {
        index: i,
        value: res,
        error: err,
        pending: pending,
        total: total,
        complete: complete,
        percent: complete / total * 100 | 0,
        start: start,
        end: end,
        duration: end - start
      });

      if (--pending) next();
      else if(!throws) cb(errors, results);
      else cb(null, results);
    }
  }

  // concurrency
  for (var i = 0; i < fns.length; i++) {
    if (i == max) break;
    next();
  }

  return this;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMProperty = __webpack_require__(85);
var ReactDOMComponentFlags = __webpack_require__(342);

var invariant = __webpack_require__(5);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(160)('wks')
  , uid        = __webpack_require__(61)
  , Symbol     = __webpack_require__(12).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* eslint-env browser */


var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('auth0:metrics-wrapper');

/**
 * MetricsWrapper constructor
 */

function MetricsWrapper() {
  if (!(this instanceof MetricsWrapper)) {
    return new MetricsWrapper();
  }
}

/**
 * Retrieve `window.metricsLib`
 */

MetricsWrapper.prototype.lib = function () {
  return window.metricsLib;
};

/**
 * Page.js middleware constructor
 */

MetricsWrapper.prototype.middleware = function (opts) {
  opts = opts || {};
  var m = this.lib();
  return function middleware(ctx, next) {
    try {
      debug('Middleware page track');
      m.page();
    } catch (e) {
      debug('Caugth error at middleware: %s\n%s', e.message, e.stack);
    } finally {
      if (!opts.end) {
        return next();
      }
    }
  };
};

/**
 * Register page:render event
 */

MetricsWrapper.prototype.onPageRenderEvent = function () {
  var m = window.metricsLib;
  try {
    debug('Middleware page track');
    m.page();
  } catch (e) {
    debug('Caugth error at middleware: %s\n%s', e.message, e.stack);
  }
};

/**
 * Expose `MetricsWrapper` constructor
 */

/* harmony default export */ __webpack_exports__["a"] = (MetricsWrapper());

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(14)
  , IE8_DOM_DEFINE = __webpack_require__(262)
  , toPrimitive    = __webpack_require__(103)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(30) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {  /* globals require, module */

  

  /**
   * Module dependencies.
   */

  var pathtoRegexp = __webpack_require__(888);

  /**
   * Module exports.
   */

  module.exports = page;

  /**
   * Detect click event
   */
  var clickEvent = ('undefined' !== typeof document) && document.ontouchstart ? 'touchstart' : 'click';

  /**
   * To work properly with the URL
   * history.location generated polyfill in https://github.com/devote/HTML5-History-API
   */

  var location = ('undefined' !== typeof window) && (window.history.location || window.location);

  /**
   * Perform initial dispatch.
   */

  var dispatch = true;


  /**
   * Decode URL components (query string, pathname, hash).
   * Accommodates both regular percent encoding and x-www-form-urlencoded format.
   */
  var decodeURLComponents = true;

  /**
   * Base path.
   */

  var base = '';

  /**
   * Running flag.
   */

  var running;

  /**
   * HashBang option
   */

  var hashbang = false;

  /**
   * Previous context, for capturing
   * page exit events.
   */

  var prevContext;

  /**
   * Register `path` with callback `fn()`,
   * or route `path`, or redirection,
   * or `page.start()`.
   *
   *   page(fn);
   *   page('*', fn);
   *   page('/user/:id', load, user);
   *   page('/user/' + user.id, { some: 'thing' });
   *   page('/user/' + user.id);
   *   page('/from', '/to')
   *   page();
   *
   * @param {string|!Function|!Object} path
   * @param {Function=} fn
   * @api public
   */

  function page(path, fn) {
    // <callback>
    if ('function' === typeof path) {
      return page('*', path);
    }

    // route <path> to <callback ...>
    if ('function' === typeof fn) {
      var route = new Route(/** @type {string} */ (path));
      for (var i = 1; i < arguments.length; ++i) {
        page.callbacks.push(route.middleware(arguments[i]));
      }
      // show <path> with [state]
    } else if ('string' === typeof path) {
      page['string' === typeof fn ? 'redirect' : 'show'](path, fn);
      // start [options]
    } else {
      page.start(path);
    }
  }

  /**
   * Callback functions.
   */

  page.callbacks = [];
  page.exits = [];

  /**
   * Current path being processed
   * @type {string}
   */
  page.current = '';

  /**
   * Number of pages navigated to.
   * @type {number}
   *
   *     page.len == 0;
   *     page('/login');
   *     page.len == 1;
   */

  page.len = 0;

  /**
   * Get or set basepath to `path`.
   *
   * @param {string} path
   * @api public
   */

  page.base = function(path) {
    if (0 === arguments.length) return base;
    base = path;
  };

  /**
   * Bind with the given `options`.
   *
   * Options:
   *
   *    - `click` bind to click events [true]
   *    - `popstate` bind to popstate [true]
   *    - `dispatch` perform initial dispatch [true]
   *
   * @param {Object} options
   * @api public
   */

  page.start = function(options) {
    options = options || {};
    if (running) return;
    running = true;
    if (false === options.dispatch) dispatch = false;
    if (false === options.decodeURLComponents) decodeURLComponents = false;
    if (false !== options.popstate) window.addEventListener('popstate', onpopstate, false);
    if (false !== options.click) {
      document.addEventListener(clickEvent, onclick, false);
    }
    if (true === options.hashbang) hashbang = true;
    if (!dispatch) return;
    var url = (hashbang && ~location.hash.indexOf('#!')) ? location.hash.substr(2) + location.search : location.pathname + location.search + location.hash;
    page.replace(url, null, true, dispatch);
  };

  /**
   * Unbind click and popstate event handlers.
   *
   * @api public
   */

  page.stop = function() {
    if (!running) return;
    page.current = '';
    page.len = 0;
    running = false;
    document.removeEventListener(clickEvent, onclick, false);
    window.removeEventListener('popstate', onpopstate, false);
  };

  /**
   * Show `path` with optional `state` object.
   *
   * @param {string} path
   * @param {Object=} state
   * @param {boolean=} dispatch
   * @param {boolean=} push
   * @return {!Context}
   * @api public
   */

  page.show = function(path, state, dispatch, push) {
    var ctx = new Context(path, state);
    page.current = ctx.path;
    if (false !== dispatch) page.dispatch(ctx);
    if (false !== ctx.handled && false !== push) ctx.pushState();
    return ctx;
  };

  /**
   * Goes back in the history
   * Back should always let the current route push state and then go back.
   *
   * @param {string} path - fallback path to go back if no more history exists, if undefined defaults to page.base
   * @param {Object=} state
   * @api public
   */

  page.back = function(path, state) {
    if (page.len > 0) {
      // this may need more testing to see if all browsers
      // wait for the next tick to go back in history
      history.back();
      page.len--;
    } else if (path) {
      setTimeout(function() {
        page.show(path, state);
      });
    }else{
      setTimeout(function() {
        page.show(base, state);
      });
    }
  };


  /**
   * Register route to redirect from one path to other
   * or just redirect to another route
   *
   * @param {string} from - if param 'to' is undefined redirects to 'from'
   * @param {string=} to
   * @api public
   */
  page.redirect = function(from, to) {
    // Define route from a path to another
    if ('string' === typeof from && 'string' === typeof to) {
      page(from, function(e) {
        setTimeout(function() {
          page.replace(/** @type {!string} */ (to));
        }, 0);
      });
    }

    // Wait for the push state and replace it with another
    if ('string' === typeof from && 'undefined' === typeof to) {
      setTimeout(function() {
        page.replace(from);
      }, 0);
    }
  };

  /**
   * Replace `path` with optional `state` object.
   *
   * @param {string} path
   * @param {Object=} state
   * @param {boolean=} init
   * @param {boolean=} dispatch
   * @return {!Context}
   * @api public
   */


  page.replace = function(path, state, init, dispatch) {
    var ctx = new Context(path, state);
    page.current = ctx.path;
    ctx.init = init;
    ctx.save(); // save before dispatching, which may redirect
    if (false !== dispatch) page.dispatch(ctx);
    return ctx;
  };

  /**
   * Dispatch the given `ctx`.
   *
   * @param {Context} ctx
   * @api private
   */
  page.dispatch = function(ctx) {
    var prev = prevContext,
      i = 0,
      j = 0;

    prevContext = ctx;

    function nextExit() {
      var fn = page.exits[j++];
      if (!fn) return nextEnter();
      fn(prev, nextExit);
    }

    function nextEnter() {
      var fn = page.callbacks[i++];

      if (ctx.path !== page.current) {
        ctx.handled = false;
        return;
      }
      if (!fn) return unhandled(ctx);
      fn(ctx, nextEnter);
    }

    if (prev) {
      nextExit();
    } else {
      nextEnter();
    }
  };

  /**
   * Unhandled `ctx`. When it's not the initial
   * popstate then redirect. If you wish to handle
   * 404s on your own use `page('*', callback)`.
   *
   * @param {Context} ctx
   * @api private
   */
  function unhandled(ctx) {
    if (ctx.handled) return;
    var current;

    if (hashbang) {
      current = base + location.hash.replace('#!', '');
    } else {
      current = location.pathname + location.search;
    }

    if (current === ctx.canonicalPath) return;
    page.stop();
    ctx.handled = false;
    location.href = ctx.canonicalPath;
  }

  /**
   * Register an exit route on `path` with
   * callback `fn()`, which will be called
   * on the previous context when a new
   * page is visited.
   */
  page.exit = function(path, fn) {
    if (typeof path === 'function') {
      return page.exit('*', path);
    }

    var route = new Route(path);
    for (var i = 1; i < arguments.length; ++i) {
      page.exits.push(route.middleware(arguments[i]));
    }
  };

  /**
   * Remove URL encoding from the given `str`.
   * Accommodates whitespace in both x-www-form-urlencoded
   * and regular percent-encoded form.
   *
   * @param {string} val - URL component to decode
   */
  function decodeURLEncodedURIComponent(val) {
    if (typeof val !== 'string') { return val; }
    return decodeURLComponents ? decodeURIComponent(val.replace(/\+/g, ' ')) : val;
  }

  /**
   * Initialize a new "request" `Context`
   * with the given `path` and optional initial `state`.
   *
   * @constructor
   * @param {string} path
   * @param {Object=} state
   * @api public
   */

  function Context(path, state) {
    if ('/' === path[0] && 0 !== path.indexOf(base)) path = base + (hashbang ? '#!' : '') + path;
    var i = path.indexOf('?');

    this.canonicalPath = path;
    this.path = path.replace(base, '') || '/';
    if (hashbang) this.path = this.path.replace('#!', '') || '/';

    this.title = document.title;
    this.state = state || {};
    this.state.path = path;
    this.querystring = ~i ? decodeURLEncodedURIComponent(path.slice(i + 1)) : '';
    this.pathname = decodeURLEncodedURIComponent(~i ? path.slice(0, i) : path);
    this.params = {};

    // fragment
    this.hash = '';
    if (!hashbang) {
      if (!~this.path.indexOf('#')) return;
      var parts = this.path.split('#');
      this.path = parts[0];
      this.hash = decodeURLEncodedURIComponent(parts[1]) || '';
      this.querystring = this.querystring.split('#')[0];
    }
  }

  /**
   * Expose `Context`.
   */

  page.Context = Context;

  /**
   * Push state.
   *
   * @api private
   */

  Context.prototype.pushState = function() {
    page.len++;
    history.pushState(this.state, this.title, hashbang && this.path !== '/' ? '#!' + this.path : this.canonicalPath);
  };

  /**
   * Save the context state.
   *
   * @api public
   */

  Context.prototype.save = function() {
    history.replaceState(this.state, this.title, hashbang && this.path !== '/' ? '#!' + this.path : this.canonicalPath);
  };

  /**
   * Initialize `Route` with the given HTTP `path`,
   * and an array of `callbacks` and `options`.
   *
   * Options:
   *
   *   - `sensitive`    enable case-sensitive routes
   *   - `strict`       enable strict matching for trailing slashes
   *
   * @constructor
   * @param {string} path
   * @param {Object=} options
   * @api private
   */

  function Route(path, options) {
    options = options || {};
    this.path = (path === '*') ? '(.*)' : path;
    this.method = 'GET';
    this.regexp = pathtoRegexp(this.path,
      this.keys = [],
      options);
  }

  /**
   * Expose `Route`.
   */

  page.Route = Route;

  /**
   * Return route middleware with
   * the given callback `fn()`.
   *
   * @param {Function} fn
   * @return {Function}
   * @api public
   */

  Route.prototype.middleware = function(fn) {
    var self = this;
    return function(ctx, next) {
      if (self.match(ctx.path, ctx.params)) return fn(ctx, next);
      next();
    };
  };

  /**
   * Check if this route matches `path`, if so
   * populate `params`.
   *
   * @param {string} path
   * @param {Object} params
   * @return {boolean}
   * @api private
   */

  Route.prototype.match = function(path, params) {
    var keys = this.keys,
      qsIndex = path.indexOf('?'),
      pathname = ~qsIndex ? path.slice(0, qsIndex) : path,
      m = this.regexp.exec(decodeURIComponent(pathname));

    if (!m) return false;

    for (var i = 1, len = m.length; i < len; ++i) {
      var key = keys[i - 1];
      var val = decodeURLEncodedURIComponent(m[i]);
      if (val !== undefined || !(hasOwnProperty.call(params, key.name))) {
        params[key.name] = val;
      }
    }

    return true;
  };


  /**
   * Handle "populate" events.
   */

  var onpopstate = (function () {
    var loaded = false;
    if ('undefined' === typeof window) {
      return;
    }
    if (document.readyState === 'complete') {
      loaded = true;
    } else {
      window.addEventListener('load', function() {
        setTimeout(function() {
          loaded = true;
        }, 0);
      });
    }
    return function onpopstate(e) {
      if (!loaded) return;
      if (e.state) {
        var path = e.state.path;
        page.replace(path, e.state);
      } else {
        page.show(location.pathname + location.hash, undefined, undefined, false);
      }
    };
  })();
  /**
   * Handle "click" events.
   */

  function onclick(e) {

    if (1 !== which(e)) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;



    // ensure link
    // use shadow dom when available
    var el = e.path ? e.path[0] : e.target;
    while (el && 'A' !== el.nodeName) el = el.parentNode;
    if (!el || 'A' !== el.nodeName) return;



    // Ignore if tag has
    // 1. "download" attribute
    // 2. rel="external" attribute
    if (el.hasAttribute('download') || el.getAttribute('rel') === 'external') return;

    // ensure non-hash for the same path
    var link = el.getAttribute('href');
    if (!hashbang && el.pathname === location.pathname && (el.hash || '#' === link)) return;



    // Check for mailto: in the href
    if (link && link.indexOf('mailto:') > -1) return;

    // check target
    if (el.target) return;

    // x-origin
    if (!sameOrigin(el.href)) return;



    // rebuild path
    var path = el.pathname + el.search + (el.hash || '');

    // strip leading "/[drive letter]:" on NW.js on Windows
    if (typeof process !== 'undefined' && path.match(/^\/[a-zA-Z]:\//)) {
      path = path.replace(/^\/[a-zA-Z]:\//, '/');
    }

    // same page
    var orig = path;

    if (path.indexOf(base) === 0) {
      path = path.substr(base.length);
    }

    if (hashbang) path = path.replace('#!', '');

    if (base && orig === path) return;

    e.preventDefault();
    page.show(orig);
  }

  /**
   * Event button.
   */

  function which(e) {
    e = e || window.event;
    return null === e.which ? e.button : e.which;
  }

  /**
   * Check if `href` is the same origin.
   */

  function sameOrigin(href) {
    var origin = location.protocol + '//' + location.hostname;
    if (location.port) origin += ':' + location.port;
    return (href && (0 === href.indexOf(origin)));
  }

  page.sameOrigin = sameOrigin;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(306);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(78)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PromiseState = exports.connect = undefined;

var _connect = __webpack_require__(1051);

var _connect2 = _interopRequireDefault(_connect);

var _PromiseState = __webpack_require__(359);

var _PromiseState2 = _interopRequireDefault(_PromiseState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.connect = _connect2.default;
exports.PromiseState = _PromiseState2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(711)
__webpack_require__(701)
__webpack_require__(702)
__webpack_require__(703)
__webpack_require__(704)
__webpack_require__(705)
__webpack_require__(706)
__webpack_require__(710)
__webpack_require__(707)
__webpack_require__(708)
__webpack_require__(709)
__webpack_require__(700)

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var bind = __webpack_require__(227);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is a Node Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Node Buffer, otherwise false
 */
function isBuffer(val) {
  return ((typeof Buffer !== 'undefined') && (Buffer.isBuffer) && (Buffer.isBuffer(val)));
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(713).Buffer))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(736);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if ('env' in (process || {})) {
    r = process.env.DEBUG;
  }
  
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_emitter__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_emitter__);
/* npm version only adapted from https://github.com/component/bus */



/**
 * Expose the event bus.
 */

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_component_emitter___default.a());

/***/ }),
/* 34 */
/***/ (function(module, exports) {

function one(selector, el) {
  return el.querySelector(selector);
}

exports = module.exports = function(selector, el){
  el = el || document;
  return one(selector, el);
};

exports.all = function(selector, el){
  el = el || document;
  return el.querySelectorAll(selector);
};

exports.engine = function(obj){
  if (!obj.one) throw new Error('.one callback required');
  if (!obj.all) throw new Error('.all callback required');
  one = obj.one;
  exports.all = obj.all;
  return exports;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(20)
  , createDesc = __webpack_require__(53);
module.exports = __webpack_require__(30) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1000);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */

var assert = __webpack_require__(49);
var objectAssign = __webpack_require__(501);

function pick(object, keys) {
  return keys.reduce(function (prev, key) {
    if (object[key]) {
      prev[key] = object[key];
    }
    return prev;
  }, {});
}

function getKeysNotIn(obj, allowedKeys) {
  var notAllowed = [];
  for (var key in obj) {
    if (allowedKeys.indexOf(key) === -1) {
      notAllowed.push(key);
    }
  }
  return notAllowed;
}

function objectValues(obj) {
  var values = [];
  for (var key in obj) {
    values.push(obj[key]);
  }
  return values;
}

function extend() {
  var params = objectValues(arguments);
  params.unshift({});
  return objectAssign.get().apply(undefined, params);
}

function merge(object, keys) {
  return {
    base: keys ? pick(object, keys) : object,
    with: function (object2, keys2) {
      object2 = keys2 ? pick(object2, keys2) : object2;
      return extend(this.base, object2);
    }
  };
}

function blacklist(object, blacklistedKeys) {
  return Object.keys(object).reduce(function (p, key) {
    if (blacklistedKeys.indexOf(key) === -1) {
      p[key] = object[key];
    }
    return p;
  }, {});
}

function camelToSnake(str) {
  var newKey = '';
  var index = 0;
  var code;
  var wasPrevNumber = true;
  var wasPrevUppercase = true;

  while (index < str.length) {
    code = str.charCodeAt(index);
    if ((!wasPrevUppercase && code >= 65 && code <= 90) || (!wasPrevNumber && code >= 48 && code <= 57)) {
      newKey += '_';
      newKey += str[index].toLowerCase();
    } else {
      newKey += str[index].toLowerCase();
    }
    wasPrevNumber = (code >= 48 && code <= 57);
    wasPrevUppercase = (code >= 65 && code <= 90);
    index++;
  }

  return newKey;
}

function snakeToCamel(str) {
  var parts = str.split('_');
  return parts.reduce(function (p, c) {
    return p + c.charAt(0).toUpperCase() + c.slice(1);
  }, parts.shift());
}

function toSnakeCase(object, exceptions) {
  if (typeof object !== 'object' || assert.isArray(object) || object === null) {
    return object;
  }
  exceptions = exceptions || [];

  return Object.keys(object).reduce(function (p, key) {
    var newKey = exceptions.indexOf(key) === -1 ? camelToSnake(key) : key;
    p[newKey] = toSnakeCase(object[key]);
    return p;
  }, {});
}

function toCamelCase(object, exceptions) {
  if (typeof object !== 'object' || assert.isArray(object) || object === null) {
    return object;
  }

  exceptions = exceptions || [];

  return Object.keys(object).reduce(function (p, key) {
    var newKey = exceptions.indexOf(key) === -1 ? snakeToCamel(key) : key;
    p[newKey] = toCamelCase(object[key]);
    return p;
  }, {});
}

module.exports = {
  toSnakeCase: toSnakeCase,
  toCamelCase: toCamelCase,
  blacklist: blacklist,
  merge: merge,
  pick: pick,
  getKeysNotIn: getKeysNotIn,
  extend: extend
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImageCard__ = __webpack_require__(649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__ImageCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardContainer__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CardContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Resource__ = __webpack_require__(659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__Resource__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DownloadLink__ = __webpack_require__(645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__DownloadLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainResources__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__MainResources__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SecondaryResources__ = __webpack_require__(667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__SecondaryResources__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResourcesContainer__ = __webpack_require__(661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__ResourcesContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Loader__ = __webpack_require__(653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchArticles__ = __webpack_require__(663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_10__SearchArticles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchField__ = __webpack_require__(665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__SearchField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Dropdown__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PromiseStateContainer__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__PromiseStateContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardFetchContainer___ = __webpack_require__(643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__CardFetchContainer___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SimpleList__ = __webpack_require__(669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_15__SimpleList__["a"]; });

































/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(155)
  , defined = __webpack_require__(51);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var CallbackQueue = __webpack_require__(340);
var PooledClass = __webpack_require__(65);
var ReactFeatureFlags = __webpack_require__(345);
var ReactReconciler = __webpack_require__(86);
var Transaction = __webpack_require__(135);

var invariant = __webpack_require__(5);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(59);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if(__webpack_require__(30)){
  var LIBRARY             = __webpack_require__(73)
    , global              = __webpack_require__(12)
    , fails               = __webpack_require__(19)
    , $export             = __webpack_require__(2)
    , $typed              = __webpack_require__(164)
    , $buffer             = __webpack_require__(278)
    , ctx                 = __webpack_require__(43)
    , anInstance          = __webpack_require__(70)
    , propertyDesc        = __webpack_require__(53)
    , hide                = __webpack_require__(35)
    , redefineAll         = __webpack_require__(75)
    , toInteger           = __webpack_require__(78)
    , toLength            = __webpack_require__(25)
    , toIndex             = __webpack_require__(77)
    , toPrimitive         = __webpack_require__(103)
    , has                 = __webpack_require__(24)
    , same                = __webpack_require__(274)
    , classof             = __webpack_require__(150)
    , isObject            = __webpack_require__(16)
    , toObject            = __webpack_require__(60)
    , isArrayIter         = __webpack_require__(156)
    , create              = __webpack_require__(99)
    , getPrototypeOf      = __webpack_require__(101)
    , gOPN                = __webpack_require__(100).f
    , getIterFn           = __webpack_require__(165)
    , uid                 = __webpack_require__(61)
    , wks                 = __webpack_require__(17)
    , createArrayMethod   = __webpack_require__(96)
    , createArrayIncludes = __webpack_require__(149)
    , speciesConstructor  = __webpack_require__(161)
    , ArrayIterators      = __webpack_require__(138)
    , Iterators           = __webpack_require__(72)
    , $iterDetect         = __webpack_require__(120)
    , setSpecies          = __webpack_require__(122)
    , arrayFill           = __webpack_require__(148)
    , arrayCopyWithin     = __webpack_require__(258)
    , $DP                 = __webpack_require__(20)
    , $GOPD               = __webpack_require__(52)
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(890)();
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var PooledClass = __webpack_require__(65);

var emptyFunction = __webpack_require__(32);
var warning = __webpack_require__(7);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(214),__webpack_require__(8)):"function"==typeof define&&define.amd?define(["jquery","lodash"],t):"object"==typeof exports?exports.Auth0ContactForm=t(require("jquery"),require("lodash")):e.Auth0ContactForm=t(e.jquery,e.lodash)}(this,function(e,t){return function(e){function t(o){if(n[o])return n[o].exports;var a=n[o]={exports:{},id:o,loaded:!1};return e[o].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(2)},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function r(e,t){var n=window.location,o=n.href,a=n.search,r=function(e){return a.indexOf(e)>-1};if(r("contact=true")){var i=new f(e);i.show(t);var l=i.getElements(),s=l.modalRoot;s.on("hidden.bs.modal",function(){var e=o.replace("?contact=true",""),t=o.replace("contact=true",""),n=o!==e?e:t;window.history.pushState({path:n},"",n)})}}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}();t.handleQueryString=r;var l=n(6),s=o(l),c=n(7),u=n(4),m=o(u);n(3);var d=s.default,f=function(){function e(t){var n=this;a(this,e),this.options={onModalOpen:function(){},onFormSuccess:function(){},onFormFail:function(){},postUrl:"https://auth0-marketing.run.webtask.io/contact-form",modalTitle:"Contact Sales Team",name:"",includePhoneField:!1,includeRoleField:!1,email:"",phone:"",company:"",role:"",message:"",roles:["Software Developer","Engineering Exec / Management","C-Level","IT operations","Product Management","Sales","Marketing","Security & Compliance","Other"],source:"pricing",dictionary:{name:"Name",email:"Email address",phone:"Phone Number",company:"Company",role:"Role",message:"Message",send:"Send"}},this.onInput=function(e){if(e){var t=n.getElements(),o=t.companyElement,a=!!e.attr("required"),r="email"===e.attr("type"),i=function(){var t=e.val().trim(),i=!!t,l=!a||i,s=!a&&!i||n.isValidEmail(t),c=function(){return r?s:l}();if(c?e.removeClass("has-error"):e.addClass("has-error"),r&&c){var u=t.replace(/.*@/,"");n.isFreeEmail(u)?o.val(""):n.autocompleteCompanyElement(u)}return c};e.on("input",i),e.on("invalid",function(){return n.setSubmitButtonState("error")})}};var o=(0,c.assign)({},this.options.dictionary,t.dictionary);this.options=(0,c.assign)({},this.options,t,{dictionary:o})}return i(e,[{key:"show",value:function(e){this.options=(0,c.assign)({},this.options,e),this.reset();var t=this.getElements(),n=t.modalRoot,o=t.elements,a=this.options,r=a.onModalOpen,i=a.onFormSuccess,l=a.onFormFail;n.on("shown.bs.modal",function(){return o[0].focus()}),n.modal(),r();var s=function(e){setTimeout(function(){return n.modal("hide")},4e3),i(e)},u=function(e){l(e)};this.setEventHandlers(s,u)}},{key:"reset",value:function(){var e=this.options,t=e.modalTitle,n=e.name,o=e.email,a=e.phone,r=e.company,i=e.role,l=e.roles,s=e.message,c=e.dictionary,u=e.includePhoneField,f=e.includeRoleField,p=this.getElements(),h=p.modalRoot;h.remove(),d("body").append((0,m.default)({modalTitle:t,name:n,email:o,phone:a,company:r,role:i,roles:l,message:s,dictionary:c,includePhoneField:u,includeRoleField:f}))}},{key:"getElements",value:function(){var e={modalRoot:d("#contact-form-modal"),formRoot:d("#contact-form-modal__form"),companyElement:d("#contact-form-modal__company"),elements:[d("#contact-form-modal__name"),d("#contact-form-modal__email"),d("#contact-form-modal__company"),d("#contact-form-modal__message")],submitButton:d("#contact-form-modal__submit")};return this.options.includePhoneField&&e.elements.push(d("#contact-form-modal__phone")),this.options.includeRoleField&&e.elements.push(d("#contact-form-modal__role")),e}},{key:"setEventHandlers",value:function(e,t){var n=this.getElements(),o=n.elements;o.forEach(this.onInput),this.onSubmit(e,t)}},{key:"isValidEmail",value:function(e){var t=new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);return t.test(e)}},{key:"isFreeEmail",value:function(e){var t=["gmail.com","live.com","hotmail.com","outlook.com","yahoo.com","aol.com","icloud.com","gmx.com","gmx.us","lycos.com","mail.com","inbox.com"];return t.indexOf(e)>-1}},{key:"autocompleteCompanyElement",value:function(e){var t=this.getElements(),n=t.companyElement,o=function(e){e.length&&n.val(e[0].name)};d.get("https://autocomplete.clearbit.com/v1/companies/suggest?query="+e,o)}},{key:"onSubmit",value:function(e,t){var n=this,o=this.options.postUrl,a=this.getElements(),r=a.elements,i=a.formRoot;i.submit(function(a){if(a.preventDefault(),n.setSubmitButtonState("process"),!n.checkElementsValidation())return n.setSubmitButtonState("error");var i=n.getData(r),l=i.data,s=i.metricsData;return d.ajax({type:"POST",url:o,data:l}).done(function(){n.setSubmitButtonState("success"),n.cleanElementsValue(),e(s)}).fail(function(){n.setSubmitButtonState("error"),t(s)})})}},{key:"cleanElementsValue",value:function(){var e=this.getElements(),t=e.elements;t.filter(function(e){return!e.is("select")}).forEach(function(e){return e.val("")})}},{key:"setSubmitButtonState",value:function(e){var t=this,n=this.getElements(),o=n.submitButton;switch(e){case"success":o.removeClass("btn-danger shake btn-loading").addClass("btn-success success tada").html('<span aria-hidden="true" class="btn-icon icon-budicon-390"></span> Sent'),setTimeout(function(){return t.setSubmitButtonState("initial")},3e3);break;case"error":o.removeClass("btn-success success btn-loading tada").addClass("btn-danger shake").html('<span aria-hidden="true" class="btn-icon icon-budicon-389"></span> Error'),setTimeout(function(){return t.setSubmitButtonState("initial")},2e3);break;case"process":o.removeClass("success btn-danger").addClass("btn-loading").html('<span aria-hidden="true" class="icon-rotating icon-budicon-330"></span>');break;default:o.removeClass("success btn-danger btn-loading tada shake").addClass("btn-success").html("Send")}}},{key:"checkElementsValidation",value:function(){var e=this.getElements(),t=e.elements,n=t.map(this.checkElementValidation),o=n.every(function(e){return!!e});return o}},{key:"checkElementValidation",value:function(e){var t=e.hasClass("has-error"),n=!!e.attr("required"),o=!!e.val().trim(),a=!t&&n&&o;return a}},{key:"getData",value:function(){var e=this.getElements(),t=e.elements,n={},o={path:window.location.pathname,url:window.location.toString(),title:document.title,referrer:document.referrer};return t.forEach(function(e){var t=e.attr("name");o[t]=n[t]=e.val()}),n.subject=this.options.source||"New contact from: "+window.location.pathname,n.source=this.options.source,n.referrer=window.location.pathname,this.options.test&&(n.test=!0),o.trackData=o.email,o.track_data2=o.message,o.track_data3=o.name,o.track_data4=o.company,o.track_data5=o.role,o.track_data6=o.phone,{data:n,metricsData:o}}}]),e}();t.default=f},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.handleQueryString=t.default=void 0;var a=n(1),r=o(a);t.default=r.default,t.handleQueryString=a.handleQueryString},function(e,t){},function(e,t,n){var o=n(5);e.exports=function(e){var t,n=[],a=e||{};return function(e,a,r,i,l,s,c,u,m,d,f,p){n.push('<div id="contact-form-modal" tabindex="-1" role="dialog" aria-labelledby="contact-form-title" class="modal fade contact-form-modal"><div class="modal-dialog"><form id="contact-form-modal__form" class="modal-content contact-form-modal__form"><div class="modal-header has-border"><button type="button" data-dismiss="modal" aria-label="Close" class="close close"><span aria-hidden="true">&times;</span></button><h4 id="contact-form-title" class="modal-title">'+o.escape(null==(t=c)?"":t)+'</h4></div><div class="modal-body"><div class="form-group"><label for="contact-form-modal__name" class="sr-only">'+o.escape(null==(t=a.name)?"":t)+'</label><input id="contact-form-modal__name" type="text"'+o.attr("placeholder",""+a.name,!0,!0)+' autocomplete="section-contact name" name="name"'+o.attr("value",""+u,!0,!0)+' required class="form-control contact-form-modal__name"><span class="required">*</span></div><div class="form-group"><label for="contact-form-modal__email" class="sr-only">'+o.escape(null==(t=a.email)?"":t)+'</label><input id="contact-form-modal__email" type="email"'+o.attr("placeholder",""+a.email,!0,!0)+' autocomplete="section-contact email" name="email"'+o.attr("value",""+r,!0,!0)+' required class="form-control contact-form-modal__email"><span class="required">*</span></div>'),i&&n.push('<div class="form-group"><label for="contact-form-modal__phone" class="sr-only">'+o.escape(null==(t=a.phone)?"":t)+'</label><input id="contact-form-modal__phone" type="text"'+o.attr("placeholder",""+a.phone,!0,!0)+' autocomplete="section-contact phone" name="phone"'+o.attr("value",""+m,!0,!0)+' required class="form-control contact-form-modal__phone"><span class="required">*</span></div>'),n.push('<div class="form-group"><label for="contact-form-modal__company" class="sr-only">'+o.escape(null==(t=a.company)?"":t)+'</label><input id="contact-form-modal__company" type="text"'+o.attr("placeholder",""+a.company,!0,!0)+' autocomplete="section-contact organization" name="company"'+o.attr("value",""+e,!0,!0)+' required class="form-control contact-form-modal__company"><span class="required">*</span></div>'),l&&(n.push('<div class="form-group"><label for="contact-form-modal__role" class="sr-only">'+o.escape(null==(t=a.role)?"":t)+'</label><div class="acf-custom-select"><select id="contact-form-modal__role" name="role" required class="form-control contact-form-modal__role">'),function(){var e=f;if("number"==typeof e.length)for(var a=0,r=e.length;a<r;a++){var i=e[a];n.push("<option"+o.attr("selected",i==d,!0,!0)+">"+o.escape(null==(t=i)?"":t)+"</option>")}else{var r=0;for(var a in e){r++;var i=e[a];n.push("<option"+o.attr("selected",i==d,!0,!0)+">"+o.escape(null==(t=i)?"":t)+"</option>")}}}.call(this),n.push('</select></div><span class="required">*</span></div>')),n.push('<div class="form-group"><label for="contact-form-modal__message" class="sr-only">'+o.escape(null==(t=a.message)?"":t)+'</label><textarea id="contact-form-modal__message" rows="4"'+o.attr("placeholder",""+a.message,!0,!0)+' name="message" required class="form-control contact-form-modal__message">'+o.escape(null==(t=s)?"":t)+'</textarea><span class="required">*</span></div></div><div class="modal-footer"><button id="contact-form-modal__submit" type="submit" class="btn btn-success btn-lg animated contact-form-modal__submit">'+o.escape(null==(t=a.send)?"":t)+"</button></div></form></div></div>")}.call(this,"company"in a?a.company:"undefined"!=typeof company?company:void 0,"dictionary"in a?a.dictionary:"undefined"!=typeof dictionary?dictionary:void 0,"email"in a?a.email:"undefined"!=typeof email?email:void 0,"includePhoneField"in a?a.includePhoneField:"undefined"!=typeof includePhoneField?includePhoneField:void 0,"includeRoleField"in a?a.includeRoleField:"undefined"!=typeof includeRoleField?includeRoleField:void 0,"message"in a?a.message:"undefined"!=typeof message?message:void 0,"modalTitle"in a?a.modalTitle:"undefined"!=typeof modalTitle?modalTitle:void 0,"name"in a?a.name:"undefined"!=typeof name?name:void 0,"phone"in a?a.phone:"undefined"!=typeof phone?phone:void 0,"role"in a?a.role:"undefined"!=typeof role?role:void 0,"roles"in a?a.roles:"undefined"!=typeof roles?roles:void 0,"undefined"in a?a.undefined:void 0),n.join("")}},function(e,t,n){"use strict";function o(e){return null!=e&&""!==e}function a(e){return(Array.isArray(e)?e.map(a):e&&"object"==typeof e?Object.keys(e).filter(function(t){return e[t]}):[e]).filter(o).join(" ")}function r(e){return l[e]||e}function i(e){var t=String(e).replace(s,r);return t===""+e?e:t}t.merge=function e(t,n){if(1===arguments.length){for(var a=t[0],r=1;r<t.length;r++)a=e(a,t[r]);return a}var i=t.class,l=n.class;(i||l)&&(i=i||[],l=l||[],Array.isArray(i)||(i=[i]),Array.isArray(l)||(l=[l]),t.class=i.concat(l).filter(o));for(var s in n)"class"!=s&&(t[s]=n[s]);return t},t.joinClasses=a,t.cls=function(e,n){for(var o=[],r=0;r<e.length;r++)n&&n[r]?o.push(t.escape(a([e[r]]))):o.push(a(e[r]));var i=a(o);return i.length?' class="'+i+'"':""},t.style=function(e){return e&&"object"==typeof e?Object.keys(e).map(function(t){return t+":"+e[t]}).join(";"):e},t.attr=function(e,n,o,a){return"style"===e&&(n=t.style(n)),"boolean"==typeof n||null==n?n?" "+(a?e:e+'="'+e+'"'):"":0==e.indexOf("data")&&"string"!=typeof n?(JSON.stringify(n).indexOf("&")!==-1&&console.warn("Since Jade 2.0.0, ampersands (`&`) in data attributes will be escaped to `&amp;`"),n&&"function"==typeof n.toISOString&&console.warn("Jade will eliminate the double quotes around dates in ISO form after 2.0.0")," "+e+"='"+JSON.stringify(n).replace(/'/g,"&apos;")+"'"):o?(n&&"function"==typeof n.toISOString&&console.warn("Jade will stringify dates in ISO form after 2.0.0")," "+e+'="'+t.escape(n)+'"'):(n&&"function"==typeof n.toISOString&&console.warn("Jade will stringify dates in ISO form after 2.0.0")," "+e+'="'+n+'"')},t.attrs=function(e,n){var o=[],r=Object.keys(e);if(r.length)for(var i=0;i<r.length;++i){var l=r[i],s=e[l];"class"==l?(s=a(s))&&o.push(" "+l+'="'+s+'"'):o.push(t.attr(l,s,!1,n))}return o.join("")};var l={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"},s=/[&<>"]/g;t.escape=i,t.rethrow=function e(t,o,a,r){if(!(t instanceof Error))throw t;if(!("undefined"==typeof window&&o||r))throw t.message+=" on line "+a,t;try{r=r||n(8).readFileSync(o,"utf8")}catch(n){e(t,null,a)}var i=3,l=r.split("\n"),s=Math.max(a-i,0),c=Math.min(l.length,a+i),i=l.slice(s,c).map(function(e,t){var n=t+s+1;return(n==a?"  > ":"    ")+n+"| "+e}).join("\n");throw t.path=o,t.message=(o||"Jade")+":"+a+"\n"+i+"\n\n"+t.message,t},t.DebugItem=function(e,t){this.lineno=e,this.filename=t}},function(e,t){e.exports=__webpack_require__(214)},function(e,t){e.exports=__webpack_require__(8)},function(e,t){}])});


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString;

function attribute(o, attr, type, text) {
  type = type === 'array' ? 'object' : type;
  if (o && typeof o[attr] !== type) {
    throw new Error(text);
  }
}

function variable(o, type, text) {
  if (typeof o !== type) {
    throw new Error(text);
  }
}

function value(o, values, text) {
  if (values.indexOf(o) === -1) {
    throw new Error(text);
  }
}

function check(o, config, attributes) {
  if (!config.optional || o) {
    variable(o, config.type, config.message);
  }
  if (config.type === 'object' && attributes) {
    var keys = Object.keys(attributes);

    for (var index = 0; index < keys.length; index++) {
      var a = keys[index];
      if (!attributes[a].optional || o[a]) {
        if (!attributes[a].condition || attributes[a].condition(o)) {
          attribute(o, a, attributes[a].type, attributes[a].message);
          if (attributes[a].values) {
            value(o[a], attributes[a].values, attributes[a].value_message);
          }
        }
      }
    }
  }
}

/**
 * Wrap `Array.isArray` Polyfill for IE9
 * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
 *
 * @param {Array} array
 * @private
 */
function isArray(array) {
  if (this.supportsIsArray()) {
    return Array.isArray(array);
  }

  return toString.call(array) === '[object Array]';
}

function supportsIsArray() {
  return (Array.isArray != null);
}

module.exports = {
  check: check,
  attribute: attribute,
  variable: variable,
  value: value,
  isArray: isArray,
  supportsIsArray: supportsIsArray
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__(605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Hero__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchField__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__SearchField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LettersBar__ = __webpack_require__(609);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__LettersBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBar__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__SearchBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListItem__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__ListItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimpleListItem__ = __webpack_require__(623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__SimpleListItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Loader__ = __webpack_require__(613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PromiseStateContainer__ = __webpack_require__(617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__PromiseStateContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GlossaryDetail__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__GlossaryDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modal__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TermModal__ = __webpack_require__(625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__TermModal__["a"]; });

























/***/ }),
/* 51 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(102)
  , createDesc     = __webpack_require__(53)
  , toIObject      = __webpack_require__(40)
  , toPrimitive    = __webpack_require__(103)
  , has            = __webpack_require__(24)
  , IE8_DOM_DEFINE = __webpack_require__(262)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(30) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(12)
  , hide      = __webpack_require__(35)
  , has       = __webpack_require__(24)
  , SRC       = __webpack_require__(61)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(97).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {function redirect(url) {
  global.window.location = url;
}

function getDocument() {
  return global.window.document;
}

function getWindow() {
  return global.window;
}

module.exports = {
  redirect: redirect,
  getDocument: getDocument,
  getWindow: getWindow
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LockPlayground__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__LockPlayground__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LockHomeDemo__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__LockHomeDemo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LockPlaygroundHomepage__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__LockPlaygroundHomepage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactUsForm__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__ContactUsForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PromiseStateContainer__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__PromiseStateContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Loader__["a"]; });













/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(51);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(780),
    getValue = __webpack_require__(815);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, context, definition) {
  if (typeof module !== 'undefined' && module.exports) module.exports = definition();
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  else context[name] = definition();
})('urljoin', this, function () {

  function normalize (str, options) {

    // make sure protocol is followed by two slashes
    str = str.replace(/:\//g, '://');

    // remove consecutive slashes
    str = str.replace(/([^:\s])\/+/g, '$1/');

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    str = str.replace(/(\?.+)\?/g, '$1&');

    return str;
  }

  return function () {
    var input = arguments;
    var options = {};

    if (typeof arguments[0] === 'object') {
      // new syntax with array and options
      input = arguments[0];
      options = arguments[1] || {};
    }

    var joined = [].slice.call(input, 0).join('/');
    return normalize(joined, options);
  };

});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var error = __webpack_require__(220);
var objectHelper = __webpack_require__(38);

function wrapCallback(cb, options) {
  options = options || {};
  options.ignoreCasing = options.ignoreCasing ? options.ignoreCasing : false;

  return function (err, data) {
    var errObj;

    if (!err && !data) {
      return cb(error.buildResponse('generic_error', 'Something went wrong'));
    }

    if (!err && data.err) {
      err = data.err;
      data = null;
    }

    if (!err && data.error) {
      err = data;
      data = null;
    }

    if (err) {
      errObj = {
        original: err
      };

      if (err.response && err.response.statusCode) {
        errObj.statusCode = err.response.statusCode;
      }

      if (err.response && err.response.statusText) {
        errObj.statusText = err.response.statusText;
      }

      if (err.response && err.response.body) {
        err = err.response.body;
      }

      if (err.err) {
        err = err.err;
      }

      errObj.code = err.error || err.code || err.error_code || err.status || null;
      errObj.description = err.errorDescription || err.error_description || err.description || err.error || err.details || err.err || null;

      if (err.name) {
        errObj.name = err.name;
      }

      if (err.policy) {
        errObj.policy = err.policy;
      }

      return cb(errObj);
    }

    if (data.type && (data.type === 'text/html' || data.type === 'text/plain')) {
      return cb(null, data.text);
    }

    if (options.ignoreCasing) {
      return cb(null, data.body || data);
    }

    return cb(null, objectHelper.toCamelCase(data.body || data));
  };
}

module.exports = wrapCallback;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(17)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(35)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(271)
  , enumBugKeys = __webpack_require__(153);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(54);
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f
  , has = __webpack_require__(24)
  , TAG = __webpack_require__(17)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    getRawTag = __webpack_require__(814),
    objectToString = __webpack_require__(846);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(105);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(986);
var parse = __webpack_require__(985);
var formats = __webpack_require__(337);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(195);
var setInnerHTML = __webpack_require__(137);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(203);
var setTextContent = __webpack_require__(357);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(1023);
var ReactInstrumentation = __webpack_require__(37);

var warning = __webpack_require__(7);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var ReactChildren = __webpack_require__(1067);
var ReactComponent = __webpack_require__(210);
var ReactPureComponent = __webpack_require__(1072);
var ReactClass = __webpack_require__(1068);
var ReactDOMFactories = __webpack_require__(1069);
var ReactElement = __webpack_require__(88);
var ReactPropTypes = __webpack_require__(1071);
var ReactVersion = __webpack_require__(1073);

var onlyChild = __webpack_require__(1076);
var warning = __webpack_require__(7);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

// TODO: Fix tests so that this deprecation warning doesn't cause failures.
if (false) {
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });
  }
}

module.exports = React;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(47);

var warning = __webpack_require__(7);
var canDefineProperty = __webpack_require__(366);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(365);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(94);
var RequestBase = __webpack_require__(1082);
var isObject = __webpack_require__(212);
var isFunction = __webpack_require__(1081);
var ResponseBase = __webpack_require__(1083);
var shouldRetry = __webpack_require__(1084);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
      status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if(this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can substitute for options
    options = pass;
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    }
  }

  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
      
    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
    break;  
  }
  return this;
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  // console.log(this._retries, this._maxRetries)
  if (this._maxRetries && this._retries++ < this._maxRetries && shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if (isFunction(this._sort)) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._appendQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn){
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(518);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Query;
/**
 * Creates Query class
 */

function Query() {}

Query.prototype.lt = function (version) {
  return this.version && this.version < version;
};

Query.prototype.lte = function (version) {
  return this.version && this.version <= version;
};

Query.prototype.gt = function (version) {
  return this.version && this.version > version;
};

Query.prototype.gte = function (version) {
  return this.version && this.version >= version;
};

Query.prototype.eq = function (version) {
  return this.version && this.version == version;
};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAllBlogPosts */
/* unused harmony export orderByFullDate */
/* harmony export (immutable) */ __webpack_exports__["c"] = filterByYear;
/* harmony export (immutable) */ __webpack_exports__["f"] = articlesGroupByMonthYear;
/* harmony export (immutable) */ __webpack_exports__["g"] = dateFormat;
/* harmony export (immutable) */ __webpack_exports__["b"] = dateCardFormat;
/* harmony export (immutable) */ __webpack_exports__["a"] = fullDateFormat;
/* harmony export (immutable) */ __webpack_exports__["d"] = fullDateFormat2;
/* harmony export (immutable) */ __webpack_exports__["e"] = fullDateFormat3;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var blogUrl = 'https://auth0.com/blog/';

function getAllBlogPosts() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get(blogUrl + 'press-release.json').end(function (err, res) {
      if (err) {
        return resolve([]);
      }

      return resolve(JSON.parse(res.text));
    });
  });
}

function orderByFullDate(collection) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(collection, function (item) {
    return -new Date(item.fullDate).getTime();
  });
}

function filterByYear(collection, year) {
  var yearValue = Number(year);
  return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(collection, function (item) {
    return new Date(item.fullDate).getFullYear() === yearValue;
  });
}

function articlesGroupByMonthYear(articles) {
  var list = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(articles, function (item) {
    return -new Date(item.fullDate).getTime();
  });
  var result = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(list, function (item) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.fullDate, 'YYYY-MM-DD').format('MM-YYYY');
  });
  var data = [];
  __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(result, function (value, key) {
    data.push({
      textDate: key,
      dates: value
    });
  });
  return data;
}

function dateFormat(str) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, 'YYYY-MM-DD').format('MMMM YYYY');
}

function dateCardFormat(str) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, 'YYYY-MM-DD').format('MMM DD, YYYY');
}

function fullDateFormat(str) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, 'YYYY-MM-DD').format('MM/DD/YYYY');
}

function fullDateFormat2(str) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, 'YYYY-MM-DD').format('MM-DD-YYYY');
}

function fullDateFormat3(str) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, 'YYYY-MM-DD').format('MMMM Do YYYY');
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  getAllBlogPosts: getAllBlogPosts,
  orderByFullDate: orderByFullDate
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(43)
  , IObject  = __webpack_require__(155)
  , toObject = __webpack_require__(60)
  , toLength = __webpack_require__(25)
  , asc      = __webpack_require__(718);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(61)('meta')
  , isObject = __webpack_require__(16)
  , has      = __webpack_require__(24)
  , setDesc  = __webpack_require__(20).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(19)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(14)
  , dPs         = __webpack_require__(726)
  , enumBugKeys = __webpack_require__(153)
  , IE_PROTO    = __webpack_require__(159)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(152)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(261).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(271)
  , hiddenKeys = __webpack_require__(153).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(24)
  , toObject    = __webpack_require__(60)
  , IE_PROTO    = __webpack_require__(159)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(16);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(292),
    baseAssignValue = __webpack_require__(294);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isObjectLike = __webpack_require__(63);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(196);
var EventPluginUtils = __webpack_require__(197);
var ReactErrorUtils = __webpack_require__(201);

var accumulateInto = __webpack_require__(351);
var forEachAccumulated = __webpack_require__(352);
var invariant = __webpack_require__(5);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(106);
var EventPluginUtils = __webpack_require__(197);

var accumulateInto = __webpack_require__(351);
var forEachAccumulated = __webpack_require__(352);
var warning = __webpack_require__(7);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(46);

var getEventTarget = __webpack_require__(206);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/



Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(36);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(1050);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(42);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsDefaultArrowRenderer = __webpack_require__(1062);

var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);

var _utilsDefaultFilterOptions = __webpack_require__(361);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(362);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var _utilsDefaultClearRenderer = __webpack_require__(1063);

var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);

var _Async = __webpack_require__(1057);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(1058);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(1059);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(1060);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(1061);

var _Value2 = _interopRequireDefault(_Value);

function stringifyValue(value) {
	var valueType = typeof value;
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);

var instanceId = 1;

var Select = _react2['default'].createClass({

	displayName: 'Select',

	propTypes: {
		addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-label': _react2['default'].PropTypes.string, // Aria label (for assistive tech)
		'aria-labelledby': _react2['default'].PropTypes.string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _react2['default'].PropTypes.func, // Create drop-down caret element
		autoBlur: _react2['default'].PropTypes.bool, // automatically blur the component when an option is selected
		autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
		autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
		backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _react2['default'].PropTypes.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _react2['default'].PropTypes.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _react2['default'].PropTypes.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
		deleteRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
		delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
		escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
		filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
		filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
		ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
		inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
		inputRenderer: _react2['default'].PropTypes.func, // returns a custom input component
		instanceId: _react2['default'].PropTypes.string, // set the components instanceId
		isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
		matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
		matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
		menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
		menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
		menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
		multi: _react2['default'].PropTypes.bool, // multi-value input
		name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
		onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
		onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
		onCloseResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
		onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _react2['default'].PropTypes.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
		onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
		openOnFocus: _react2['default'].PropTypes.bool, // always open options menu on focus
		optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
		optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
		options: _react2['default'].PropTypes.array, // array of options
		pageSize: _react2['default'].PropTypes.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
		resetValue: _react2['default'].PropTypes.any, // value to use when you clear the control
		scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
		simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _react2['default'].PropTypes.object, // optional style to apply to the control
		tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
		tabSelectsValue: _react2['default'].PropTypes.bool, // whether to treat tabbing out while focused to be value selection
		value: _react2['default'].PropTypes.any, // initial field value
		valueComponent: _react2['default'].PropTypes.func, // value component to render
		valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
		valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
		wrapperStyle: _react2['default'].PropTypes.object },

	// optional style to apply to the component wrapper
	statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _utilsDefaultArrowRenderer2['default'],
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _utilsDefaultClearRenderer2['default'],
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _utilsDefaultFilterOptions2['default'],
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			openAfterFocus: false,
			optionComponent: _Option2['default'],
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2['default'],
			valueKey: 'value'
		};
	},

	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},

	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},

	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
			var menuNode = _reactDom2['default'].findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
			var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},

	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},

	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},

	focus: function focus() {
		if (!this.input) return;
		this.input.focus();

		if (this.props.openAfterFocus) {
			this.setState({
				isOpen: true
			});
		}
	},

	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},

	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},

	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = true;
			this.focus();
		}
	},

	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.state.inputValue
			});
		}
		this.hasScrolledToOption = false;
	},

	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},

	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = '';
		}
		this.setState(onBlurredState);
	},

	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
			var nextState = this.props.onInputChange(newInputValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && typeof nextState !== 'object') {
				newInputValue = '' + nextState;
			}
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},

	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},

	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},

	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},

	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},

	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},

	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = typeof nextProps === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},

	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value;
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options;
		var valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},

	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},

	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: '',
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: '',
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},

	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},

	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},

	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},

	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: ''
		}, this.focus);
	},

	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},

	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},

	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},

	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},

	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},

	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},

	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},

	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},

	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},

	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},

	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},

	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},

	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
			_react2['default'].createElement('span', { className: 'Select-loading' })
		);
	},

	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2['default'].createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_react2['default'].createElement(
						'span',
						{ className: 'Select-aria-only' },
						' '
					)
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2['default'].createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},

	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = _extends({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref) {
				return _this5.input = _ref;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps;
			var inputClassName = _props$inputProps.inputClassName;

			var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			return _react2['default'].createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': isOpen ? this._instancePrefix + '-list' : this._instancePrefix + '-value',
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function (ref) {
					return _this5.input = ref;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2['default'].createElement(
			'div',
			{ className: className },
			_react2['default'].createElement('input', inputProps)
		);
	},

	renderClear: function renderClear() {
		if (!this.props.clearable || !this.props.value || this.props.value === 0 || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2['default'].createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},

	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2['default'].createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},

	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},

	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},

	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2['default'].createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},

	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', {
				type: 'hidden',
				ref: function (ref) {
					return _this6.value = ref;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2['default'].createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},

	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = options.indexOf(focusedOption);
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},

	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this7.menuContainer = ref;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menu = ref;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},

	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2['default'])('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2['default'].createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this8.wrapper = ref;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.control = ref;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2['default'].createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}

});

exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function load (doc, src, fn) {
  if (typeof doc === 'string') {
    fn = src
    src = doc
    doc = document
  }

  var script = doc.createElement('script')
  script.type = 'text/javascript'
  script.src = src
  if (fn) onLoad(script, fn)
  script.onLoad = function (fn) {
    return onLoad(script, fn)
  }
  doc.body.appendChild(script)
  return script
}

function onLoad (script, fn) {
  script.addEventListener('load', function () {
    fn(null, script)
  })
  script.addEventListener('error', function (err) {
    fn(new Error('Failed loading script: ' + script.src + '\n' + err))
  })
  return script
}


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/* eslint-disable no-console */

function Warn(options) {
  this.disableWarnings = options.disableWarnings;
}

Warn.prototype.warning = function (message) {
  if (this.disableWarnings) {
    return;
  }

  console.warn(message);
};

module.exports = Warn;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(252);
} catch (err) {
  var index = __webpack_require__(252);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

var bind = window.addEventListener ? 'addEventListener' : 'attachEvent',
    unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent',
    prefix = bind !== 'addEventListener' ? 'on' : '';

/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.bind = function(el, type, fn, capture){
  el[bind](prefix + type, fn, capture || false);
  return fn;
};

/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.unbind = function(el, type, fn, capture){
  el[unbind](prefix + type, fn, capture || false);
  return fn;
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(12)
  , $export           = __webpack_require__(2)
  , redefine          = __webpack_require__(54)
  , redefineAll       = __webpack_require__(75)
  , meta              = __webpack_require__(98)
  , forOf             = __webpack_require__(118)
  , anInstance        = __webpack_require__(70)
  , isObject          = __webpack_require__(16)
  , fails             = __webpack_require__(19)
  , $iterDetect       = __webpack_require__(120)
  , setToStringTag    = __webpack_require__(76)
  , inheritIfRequired = __webpack_require__(722);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(35)
  , redefine = __webpack_require__(54)
  , fails    = __webpack_require__(19)
  , defined  = __webpack_require__(51)
  , wks      = __webpack_require__(17);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(43)
  , call        = __webpack_require__(266)
  , isArrayIter = __webpack_require__(156)
  , anObject    = __webpack_require__(14)
  , toLength    = __webpack_require__(25)
  , getIterFn   = __webpack_require__(165)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(17)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(12)
  , dP          = __webpack_require__(20)
  , DESCRIPTORS = __webpack_require__(30)
  , SPECIES     = __webpack_require__(17)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(1092);
module.exports = self.fetch.bind(self);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(831),
    listCacheDelete = __webpack_require__(832),
    listCacheGet = __webpack_require__(833),
    listCacheHas = __webpack_require__(834),
    listCacheSet = __webpack_require__(835);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(187);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isKey = __webpack_require__(184),
    stringToPath = __webpack_require__(323),
    toString = __webpack_require__(331);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(126),
    isObject = __webpack_require__(55);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(828);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(290),
    baseKeys = __webpack_require__(297),
    isArrayLike = __webpack_require__(326);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var EventPluginRegistry = __webpack_require__(196);
var ReactEventEmitterMixin = __webpack_require__(1015);
var ViewportMetrics = __webpack_require__(350);

var getVendorPrefixedEventName = __webpack_require__(1047);
var isEventSupported = __webpack_require__(207);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(109);
var ViewportMetrics = __webpack_require__(350);

var getEventModifierState = __webpack_require__(205);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);
var DOMNamespaces = __webpack_require__(195);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(203);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(69)
  , step             = __webpack_require__(268)
  , Iterators        = __webpack_require__(72)
  , toIObject        = __webpack_require__(40);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(267)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-param-reassign */
var request = __webpack_require__(90);
var base64Url = __webpack_require__(219);
var version = __webpack_require__(140);

// ------------------------------------------------ RequestWrapper

function RequestWrapper(req) {
  this.request = req;
  this.method = req.method;
  this.url = req.url;
  this.body = req._data;
  this.headers = req._header;
}

RequestWrapper.prototype.abort = function () {
  this.request.abort();
};

RequestWrapper.prototype.getMethod = function () {
  return this.method;
};

RequestWrapper.prototype.getBody = function () {
  return this.body;
};

RequestWrapper.prototype.getUrl = function () {
  return this.url;
};

RequestWrapper.prototype.getHeaders = function () {
  return this.headers;
};

// ------------------------------------------------ RequestObj

function RequestObj(req) {
  this.request = req;
}

RequestObj.prototype.set = function (key, value) {
  this.request = this.request.set(key, value);
  return this;
};

RequestObj.prototype.send = function (body) {
  this.request = this.request.send(body);
  return this;
};

RequestObj.prototype.withCredentials = function () {
  this.request = this.request.withCredentials();
  return this;
};

RequestObj.prototype.end = function (cb) {
  this.request = this.request.end(cb);
  return new RequestWrapper(this.request);
};

// ------------------------------------------------ RequestBuilder

function RequestBuilder(options) {
  this._sendTelemetry = options._sendTelemetry === false ? options._sendTelemetry : true;
  this._telemetryInfo = options._telemetryInfo || null;
  this.headers = options.headers || {};
}

RequestBuilder.prototype.setCommonConfiguration = function (ongoingRequest, options) {
  options = options || {};

  if (options.noHeaders) {
    return ongoingRequest;
  }

  var headers = this.headers;
  ongoingRequest = ongoingRequest.set('Content-Type', 'application/json');

  var keys = Object.keys(this.headers);

  for (var a = 0; a < keys.length; a++) {
    ongoingRequest = ongoingRequest.set(keys[a], headers[keys[a]]);
  }

  if (this._sendTelemetry) {
    ongoingRequest = ongoingRequest.set('Auth0-Client', this.getTelemetryData());
  }
  return ongoingRequest;
};

RequestBuilder.prototype.getTelemetryData = function () {
  var clientInfo = this._telemetryInfo || { name: 'auth0.js', version: version.raw };
  var jsonClientInfo = JSON.stringify(clientInfo);
  return base64Url.encode(jsonClientInfo);
};

RequestBuilder.prototype.get = function (url, options) {
  return new RequestObj(this.setCommonConfiguration(request.get(url), options));
};

RequestBuilder.prototype.post = function (url, options) {
  return new RequestObj(this.setCommonConfiguration(request.post(url), options));
};

RequestBuilder.prototype.patch = function (url, options) {
  return new RequestObj(this.setCommonConfiguration(request.patch(url), options));
};

module.exports = RequestBuilder;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = { raw: '8.5.0' };


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(29);
var normalizeHeaderName = __webpack_require__(532);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(223);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(223);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Widget__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Widget__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Credentials__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Credentials__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dots__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__Dots__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Notification__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Notification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProfileList__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__ProfileList__["a"]; });













/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_emitter__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__ = __webpack_require__(33);



/* harmony default export */ __webpack_exports__["a"] = (new LoggedIn());

function LoggedIn() {
  var _this = this;

  this.loggedin = false;

  __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].on('sso', function (data) {
    _this.loggedin = !!(data && data.sso);
    _this.emit('change', _this.loggedin);
  });
}

__WEBPACK_IMPORTED_MODULE_0_component_emitter___default()(LoggedIn.prototype);

LoggedIn.prototype.onChange = function (fn) {
  if (this.loggedin) {
    fn(this.loggedin);
  }

  this.on('change', fn);
};

LoggedIn.prototype.removeChangeListener = function (fn) {
  this.off('change', fn);
};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthButton__ = __webpack_require__(229);
/* unused harmony reexport AuthButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignupForm___ = __webpack_require__(582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SignupForm___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SocialButtonsPane__ = __webpack_require__(586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__SocialButtonsPane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignupPane__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__SignupPane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Input__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Input__["a"]; });











/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List__ = __webpack_require__(684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchBar__ = __webpack_require__(686);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__SearchBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Hero__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Hero__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResult__ = __webpack_require__(688);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__SearchResult__["a"]; });











/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/**
 * toString ref.
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

module.exports = function(val){
  switch (toString.call(val)) {
    case '[object Date]': return 'date';
    case '[object RegExp]': return 'regexp';
    case '[object Arguments]': return 'arguments';
    case '[object Array]': return 'array';
    case '[object Error]': return 'error';
  }

  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (val !== val) return 'nan';
  if (val && val.nodeType === 1) return 'element';

  if (isBuffer(val)) return 'buffer';

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val);

  return typeof val;
};

// code borrowed from https://github.com/feross/is-buffer/blob/master/index.js
function isBuffer(obj) {
  return !!(obj != null &&
    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
      (obj.constructor &&
      typeof obj.constructor.isBuffer === 'function' &&
      obj.constructor.isBuffer(obj))
    ))
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(60)
  , toIndex  = __webpack_require__(77)
  , toLength = __webpack_require__(25);
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(40)
  , toLength  = __webpack_require__(25)
  , toIndex   = __webpack_require__(77);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(71)
  , TAG = __webpack_require__(17)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(20)
  , createDesc      = __webpack_require__(53);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16)
  , document = __webpack_require__(12).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(17)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(71);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(72)
  , ITERATOR   = __webpack_require__(17)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(160)('keys')
  , uid    = __webpack_require__(61);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(14)
  , aFunction = __webpack_require__(59)
  , SPECIES   = __webpack_require__(17)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(265)
  , defined  = __webpack_require__(51);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(43)
  , invoke             = __webpack_require__(119)
  , html               = __webpack_require__(261)
  , cel                = __webpack_require__(152)
  , global             = __webpack_require__(12)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(71)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12)
  , hide   = __webpack_require__(35)
  , uid    = __webpack_require__(61)
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(150)
  , ITERATOR  = __webpack_require__(17)('iterator')
  , Iterators = __webpack_require__(72);
module.exports = __webpack_require__(97).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @license
 * Fuse - Lightweight fuzzy-search
 *
 * Copyright (c) 2012-2016 Kirollos Risk <kirollos@gmail.com>.
 * All Rights Reserved. Apache Software License 2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License")
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
;(function (global) {
  'use strict'

  /** @type {function(...*)} */
  function log () {
    console.log.apply(console, arguments)
  }

  var defaultOptions = {
    // The name of the identifier property. If specified, the returned result will be a list
    // of the items' dentifiers, otherwise it will be a list of the items.
    id: null,

    // Indicates whether comparisons should be case sensitive.

    caseSensitive: false,

    // An array of values that should be included from the searcher's output. When this array
    // contains elements, each result in the list will be of the form `{ item: ..., include1: ..., include2: ... }`.
    // Values you can include are `score`, `matchedLocations`
    include: [],

    // Whether to sort the result list, by score
    shouldSort: true,

    // The search function to use
    // Note that the default search function ([[Function]]) must conform to the following API:
    //
    //  @param pattern The pattern string to search
    //  @param options The search option
    //  [[Function]].constructor = function(pattern, options)
    //
    //  @param text: the string to search in for the pattern
    //  @return Object in the form of:
    //    - isMatch: boolean
    //    - score: Int
    //  [[Function]].prototype.search = function(text)
    searchFn: BitapSearcher,

    // Default sort function
    sortFn: function (a, b) {
      return a.score - b.score
    },

    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: deepValue,

    // List of properties that will be searched. This also supports nested properties.
    keys: [],

    // Will print to the console. Useful for debugging.
    verbose: false,

    // When true, the search algorithm will search individual words **and** the full string,
    // computing the final score as a function of both. Note that when `tokenize` is `true`,
    // the `threshold`, `distance`, and `location` are inconsequential for individual tokens.
    tokenize: false,

    // When true, the result set will only include records that match all tokens. Will only work
    // if `tokenize` is also true.
    matchAllTokens: false,

    // Regex used to separate words when searching. Only applicable when `tokenize` is `true`.
    tokenSeparator: / +/g,

    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1,

    // When true, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    findAllMatches: false
  }

  /**
   * @constructor
   * @param {!Array} list
   * @param {!Object<string, *>} options
   */
  function Fuse (list, options) {
    var key

    this.list = list
    this.options = options = options || {}

    for (key in defaultOptions) {
      if (!defaultOptions.hasOwnProperty(key)) {
        continue;
      }
      // Add boolean type options
      if (typeof defaultOptions[key] === 'boolean') {
        this.options[key] = key in options ? options[key] : defaultOptions[key];
      // Add all other options
      } else {
        this.options[key] = options[key] || defaultOptions[key]
      }
    }
  }

  Fuse.VERSION = '2.6.2'

  /**
   * Sets a new list for Fuse to match against.
   * @param {!Array} list
   * @return {!Array} The newly set list
   * @public
   */
  Fuse.prototype.set = function (list) {
    this.list = list
    return list
  }

  Fuse.prototype.search = function (pattern) {
    if (this.options.verbose) log('\nSearch term:', pattern, '\n')

    this.pattern = pattern
    this.results = []
    this.resultMap = {}
    this._keyMap = null

    this._prepareSearchers()
    this._startSearch()
    this._computeScore()
    this._sort()

    var output = this._format()
    return output
  }

  Fuse.prototype._prepareSearchers = function () {
    var options = this.options
    var pattern = this.pattern
    var searchFn = options.searchFn
    var tokens = pattern.split(options.tokenSeparator)
    var i = 0
    var len = tokens.length

    if (this.options.tokenize) {
      this.tokenSearchers = []
      for (; i < len; i++) {
        this.tokenSearchers.push(new searchFn(tokens[i], options))
      }
    }
    this.fullSeacher = new searchFn(pattern, options)
  }

  Fuse.prototype._startSearch = function () {
    var options = this.options
    var getFn = options.getFn
    var list = this.list
    var listLen = list.length
    var keys = this.options.keys
    var keysLen = keys.length
    var key
    var weight
    var item = null
    var i
    var j

    // Check the first item in the list, if it's a string, then we assume
    // that every item in the list is also a string, and thus it's a flattened array.
    if (typeof list[0] === 'string') {
      // Iterate over every item
      for (i = 0; i < listLen; i++) {
        this._analyze('', list[i], i, i)
      }
    } else {
      this._keyMap = {}
      // Otherwise, the first item is an Object (hopefully), and thus the searching
      // is done on the values of the keys of each item.
      // Iterate over every item
      for (i = 0; i < listLen; i++) {
        item = list[i]
        // Iterate over every key
        for (j = 0; j < keysLen; j++) {
          key = keys[j]
          if (typeof key !== 'string') {
            weight = (1 - key.weight) || 1
            this._keyMap[key.name] = {
              weight: weight
            }
            if (key.weight <= 0 || key.weight > 1) {
              throw new Error('Key weight has to be > 0 and <= 1')
            }
            key = key.name
          } else {
            this._keyMap[key] = {
              weight: 1
            }
          }
          this._analyze(key, getFn(item, key, []), item, i)
        }
      }
    }
  }

  Fuse.prototype._analyze = function (key, text, entity, index) {
    var options = this.options
    var words
    var scores
    var exists = false
    var existingResult
    var averageScore
    var finalScore
    var scoresLen
    var mainSearchResult
    var tokenSearcher
    var termScores
    var word
    var tokenSearchResult
    var hasMatchInText
    var checkTextMatches
    var i
    var j

    // Check if the text can be searched
    if (text === undefined || text === null) {
      return
    }

    scores = []

    var numTextMatches = 0

    if (typeof text === 'string') {
      words = text.split(options.tokenSeparator)

      if (options.verbose) log('---------\nKey:', key)

      if (this.options.tokenize) {
        for (i = 0; i < this.tokenSearchers.length; i++) {
          tokenSearcher = this.tokenSearchers[i]

          if (options.verbose) log('Pattern:', tokenSearcher.pattern)

          termScores = []
          hasMatchInText = false

          for (j = 0; j < words.length; j++) {
            word = words[j]
            tokenSearchResult = tokenSearcher.search(word)
            var obj = {}
            if (tokenSearchResult.isMatch) {
              obj[word] = tokenSearchResult.score
              exists = true
              hasMatchInText = true
              scores.push(tokenSearchResult.score)
            } else {
              obj[word] = 1
              if (!this.options.matchAllTokens) {
                scores.push(1)
              }
            }
            termScores.push(obj)
          }

          if (hasMatchInText) {
            numTextMatches++
          }

          if (options.verbose) log('Token scores:', termScores)
        }

        averageScore = scores[0]
        scoresLen = scores.length
        for (i = 1; i < scoresLen; i++) {
          averageScore += scores[i]
        }
        averageScore = averageScore / scoresLen

        if (options.verbose) log('Token score average:', averageScore)
      }

      mainSearchResult = this.fullSeacher.search(text)
      if (options.verbose) log('Full text score:', mainSearchResult.score)

      finalScore = mainSearchResult.score
      if (averageScore !== undefined) {
        finalScore = (finalScore + averageScore) / 2
      }

      if (options.verbose) log('Score average:', finalScore)

      checkTextMatches = (this.options.tokenize && this.options.matchAllTokens) ? numTextMatches >= this.tokenSearchers.length : true

      if (options.verbose) log('Check Matches', checkTextMatches)

      // If a match is found, add the item to <rawResults>, including its score
      if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
        // Check if the item already exists in our results
        existingResult = this.resultMap[index]

        if (existingResult) {
          // Use the lowest score
          // existingResult.score, bitapResult.score
          existingResult.output.push({
            key: key,
            score: finalScore,
            matchedIndices: mainSearchResult.matchedIndices
          })
        } else {
          // Add it to the raw result list
          this.resultMap[index] = {
            item: entity,
            output: [{
              key: key,
              score: finalScore,
              matchedIndices: mainSearchResult.matchedIndices
            }]
          }

          this.results.push(this.resultMap[index])
        }
      }
    } else if (isArray(text)) {
      for (i = 0; i < text.length; i++) {
        this._analyze(key, text[i], entity, index)
      }
    }
  }

  Fuse.prototype._computeScore = function () {
    var i
    var j
    var keyMap = this._keyMap
    var totalScore
    var output
    var scoreLen
    var score
    var weight
    var results = this.results
    var bestScore
    var nScore

    if (this.options.verbose) log('\n\nComputing score:\n')

    for (i = 0; i < results.length; i++) {
      totalScore = 0
      output = results[i].output
      scoreLen = output.length

      bestScore = 1

      for (j = 0; j < scoreLen; j++) {
        score = output[j].score
        weight = keyMap ? keyMap[output[j].key].weight : 1

        nScore = score * weight

        if (weight !== 1) {
          bestScore = Math.min(bestScore, nScore)
        } else {
          totalScore += nScore
          output[j].nScore = nScore
        }
      }

      if (bestScore === 1) {
        results[i].score = totalScore / scoreLen
      } else {
        results[i].score = bestScore
      }

      if (this.options.verbose) log(results[i])
    }
  }

  Fuse.prototype._sort = function () {
    var options = this.options
    if (options.shouldSort) {
      if (options.verbose) log('\n\nSorting....')
      this.results.sort(options.sortFn)
    }
  }

  Fuse.prototype._format = function () {
    var options = this.options
    var getFn = options.getFn
    var finalOutput = []
    var item
    var i
    var len
    var results = this.results
    var replaceValue
    var getItemAtIndex
    var include = options.include

    if (options.verbose) log('\n\nOutput:\n\n', results)

    // Helper function, here for speed-up, which replaces the item with its value,
    // if the options specifies it,
    replaceValue = options.id ? function (index) {
      results[index].item = getFn(results[index].item, options.id, [])[0]
    } : function () {}

    getItemAtIndex = function (index) {
      var record = results[index]
      var data
      var j
      var output
      var _item
      var _result

      // If `include` has values, put the item in the result
      if (include.length > 0) {
        data = {
          item: record.item
        }
        if (include.indexOf('matches') !== -1) {
          output = record.output
          data.matches = []
          for (j = 0; j < output.length; j++) {
            _item = output[j]
            _result = {
              indices: _item.matchedIndices
            }
            if (_item.key) {
              _result.key = _item.key
            }
            data.matches.push(_result)
          }
        }

        if (include.indexOf('score') !== -1) {
          data.score = results[index].score
        }

      } else {
        data = record.item
      }

      return data
    }

    // From the results, push into a new array only the item identifier (if specified)
    // of the entire item.  This is because we don't want to return the <results>,
    // since it contains other metadata
    for (i = 0, len = results.length; i < len; i++) {
      replaceValue(i)
      item = getItemAtIndex(i)
      finalOutput.push(item)
    }

    return finalOutput
  }

  // Helpers

  function deepValue (obj, path, list) {
    var firstSegment
    var remaining
    var dotIndex
    var value
    var i
    var len

    if (!path) {
      // If there's no path left, we've gotten to the object we care about.
      list.push(obj)
    } else {
      dotIndex = path.indexOf('.')

      if (dotIndex !== -1) {
        firstSegment = path.slice(0, dotIndex)
        remaining = path.slice(dotIndex + 1)
      } else {
        firstSegment = path
      }

      value = obj[firstSegment]
      if (value !== null && value !== undefined) {
        if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
          list.push(value)
        } else if (isArray(value)) {
          // Search each item in the array.
          for (i = 0, len = value.length; i < len; i++) {
            deepValue(value[i], remaining, list)
          }
        } else if (remaining) {
          // An object. Recurse further.
          deepValue(value, remaining, list)
        }
      }
    }

    return list
  }

  function isArray (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]'
  }

  /**
   * Adapted from "Diff, Match and Patch", by Google
   *
   *   http://code.google.com/p/google-diff-match-patch/
   *
   * Modified by: Kirollos Risk <kirollos@gmail.com>
   * -----------------------------------------------
   * Details: the algorithm and structure was modified to allow the creation of
   * <Searcher> instances with a <search> method which does the actual
   * bitap search. The <pattern> (the string that is searched for) is only defined
   * once per instance and thus it eliminates redundant re-creation when searching
   * over a list of strings.
   *
   * Licensed under the Apache License, Version 2.0 (the "License")
   * you may not use this file except in compliance with the License.
   *
   * @constructor
   */
  function BitapSearcher (pattern, options) {
    options = options || {}
    this.options = options
    this.options.location = options.location || BitapSearcher.defaultOptions.location
    this.options.distance = 'distance' in options ? options.distance : BitapSearcher.defaultOptions.distance
    this.options.threshold = 'threshold' in options ? options.threshold : BitapSearcher.defaultOptions.threshold
    this.options.maxPatternLength = options.maxPatternLength || BitapSearcher.defaultOptions.maxPatternLength

    this.pattern = options.caseSensitive ? pattern : pattern.toLowerCase()
    this.patternLen = pattern.length

    if (this.patternLen <= this.options.maxPatternLength) {
      this.matchmask = 1 << (this.patternLen - 1)
      this.patternAlphabet = this._calculatePatternAlphabet()
    }
  }

  BitapSearcher.defaultOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,

    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100,

    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,

    // Machine word size
    maxPatternLength: 32
  }

  /**
   * Initialize the alphabet for the Bitap algorithm.
   * @return {Object} Hash of character locations.
   * @private
   */
  BitapSearcher.prototype._calculatePatternAlphabet = function () {
    var mask = {},
      i = 0

    for (i = 0; i < this.patternLen; i++) {
      mask[this.pattern.charAt(i)] = 0
    }

    for (i = 0; i < this.patternLen; i++) {
      mask[this.pattern.charAt(i)] |= 1 << (this.pattern.length - i - 1)
    }

    return mask
  }

  /**
   * Compute and return the score for a match with `e` errors and `x` location.
   * @param {number} errors Number of errors in match.
   * @param {number} location Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  BitapSearcher.prototype._bitapScore = function (errors, location) {
    var accuracy = errors / this.patternLen,
      proximity = Math.abs(this.options.location - location)

    if (!this.options.distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy
    }
    return accuracy + (proximity / this.options.distance)
  }

  /**
   * Compute and return the result of the search
   * @param {string} text The text to search in
   * @return {{isMatch: boolean, score: number}} Literal containing:
   *                          isMatch - Whether the text is a match or not
   *                          score - Overall score for the match
   * @public
   */
  BitapSearcher.prototype.search = function (text) {
    var options = this.options
    var i
    var j
    var textLen
    var findAllMatches
    var location
    var threshold
    var bestLoc
    var binMin
    var binMid
    var binMax
    var start, finish
    var bitArr
    var lastBitArr
    var charMatch
    var score
    var locations
    var matches
    var isMatched
    var matchMask
    var matchedIndices
    var matchesLen
    var match

    text = options.caseSensitive ? text : text.toLowerCase()

    if (this.pattern === text) {
      // Exact match
      return {
        isMatch: true,
        score: 0,
        matchedIndices: [[0, text.length - 1]]
      }
    }

    // When pattern length is greater than the machine word length, just do a a regex comparison
    if (this.patternLen > options.maxPatternLength) {
      matches = text.match(new RegExp(this.pattern.replace(options.tokenSeparator, '|')))
      isMatched = !!matches

      if (isMatched) {
        matchedIndices = []
        for (i = 0, matchesLen = matches.length; i < matchesLen; i++) {
          match = matches[i]
          matchedIndices.push([text.indexOf(match), match.length - 1])
        }
      }

      return {
        isMatch: isMatched,
        // TODO: revisit this score
        score: isMatched ? 0.5 : 1,
        matchedIndices: matchedIndices
      }
    }

    findAllMatches = options.findAllMatches

    location = options.location
    // Set starting location at beginning text and initialize the alphabet.
    textLen = text.length
    // Highest score beyond which we give up.
    threshold = options.threshold
    // Is there a nearby exact match? (speedup)
    bestLoc = text.indexOf(this.pattern, location)

    // a mask of the matches
    matchMask = []
    for (i = 0; i < textLen; i++) {
      matchMask[i] = 0
    }

    if (bestLoc != -1) {
      threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
      // What about in the other direction? (speed up)
      bestLoc = text.lastIndexOf(this.pattern, location + this.patternLen)

      if (bestLoc != -1) {
        threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
      }
    }

    bestLoc = -1
    score = 1
    locations = []
    binMax = this.patternLen + textLen

    for (i = 0; i < this.patternLen; i++) {
      // Scan for the best match; each iteration allows for one more error.
      // Run a binary search to determine how far from the match location we can stray
      // at this error level.
      binMin = 0
      binMid = binMax
      while (binMin < binMid) {
        if (this._bitapScore(i, location + binMid) <= threshold) {
          binMin = binMid
        } else {
          binMax = binMid
        }
        binMid = Math.floor((binMax - binMin) / 2 + binMin)
      }

      // Use the result from this iteration as the maximum for the next.
      binMax = binMid
      start = Math.max(1, location - binMid + 1)
      if (findAllMatches) {
        finish = textLen;
      } else {
        finish = Math.min(location + binMid, textLen) + this.patternLen
      }

      // Initialize the bit array
      bitArr = Array(finish + 2)

      bitArr[finish + 1] = (1 << i) - 1

      for (j = finish; j >= start; j--) {
        charMatch = this.patternAlphabet[text.charAt(j - 1)]

        if (charMatch) {
          matchMask[j - 1] = 1
        }

        if (i === 0) {
          // First pass: exact match.
          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch
        } else {
          // Subsequent passes: fuzzy match.
          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch | (((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1) | lastBitArr[j + 1]
        }
        if (bitArr[j] & this.matchmask) {
          score = this._bitapScore(i, j - 1)

          // This match will almost certainly be better than any existing match.
          // But check anyway.
          if (score <= threshold) {
            // Indeed it is
            threshold = score
            bestLoc = j - 1
            locations.push(bestLoc)

            if (bestLoc > location) {
              // When passing loc, don't exceed our current distance from loc.
              start = Math.max(1, 2 * location - bestLoc)
            } else {
              // Already passed loc, downhill from here on in.
              break
            }
          }
        }
      }

      // No hope for a (better) match at greater error levels.
      if (this._bitapScore(i + 1, location) > threshold) {
        break
      }
      lastBitArr = bitArr
    }

    matchedIndices = this._getMatchedIndices(matchMask)

    // Count exact matches (those with a score of 0) to be "almost" exact
    return {
      isMatch: bestLoc >= 0,
      score: score === 0 ? 0.001 : score,
      matchedIndices: matchedIndices
    }
  }

  BitapSearcher.prototype._getMatchedIndices = function (matchMask) {
    var matchedIndices = []
    var start = -1
    var end = -1
    var i = 0
    var match
    var len = matchMask.length
    for (; i < len; i++) {
      match = matchMask[i]
      if (match && start === -1) {
        start = i
      } else if (!match && start !== -1) {
        end = i - 1
        if ((end - start) + 1 >= this.options.minMatchCharLength) {
            matchedIndices.push([start, end])
        }
        start = -1
      }
    }
    if (matchMask[i - 1]) {
      if ((i-1 - start) + 1 >= this.options.minMatchCharLength) {
        matchedIndices.push([start, i - 1])
      }
    }
    return matchedIndices
  }

  // Export to Common JS Loader
  if (true) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = Fuse
  } else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(function () {
      return Fuse
    })
  } else {
    // Browser globals (root is window)
    global.Fuse = Fuse
  }

})(this);


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(126),
    baseLodash = __webpack_require__(178);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(836),
    mapCacheDelete = __webpack_require__(837),
    mapCacheGet = __webpack_require__(838),
    mapCacheHas = __webpack_require__(839),
    mapCacheSet = __webpack_require__(840);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(124),
    stackClear = __webpack_require__(853),
    stackDelete = __webpack_require__(854),
    stackGet = __webpack_require__(855),
    stackHas = __webpack_require__(856),
    stackSet = __webpack_require__(857);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(171),
    arrayEach = __webpack_require__(173),
    assignValue = __webpack_require__(292),
    baseAssign = __webpack_require__(293),
    baseAssignIn = __webpack_require__(771),
    cloneBuffer = __webpack_require__(795),
    copyArray = __webpack_require__(128),
    copySymbols = __webpack_require__(802),
    copySymbolsIn = __webpack_require__(803),
    getAllKeys = __webpack_require__(307),
    getAllKeysIn = __webpack_require__(308),
    getTag = __webpack_require__(312),
    initCloneArray = __webpack_require__(823),
    initCloneByTag = __webpack_require__(824),
    initCloneObject = __webpack_require__(825),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(190),
    isObject = __webpack_require__(55),
    keys = __webpack_require__(132);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    toKey = __webpack_require__(82);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(288);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(298),
    createBind = __webpack_require__(806),
    createCurry = __webpack_require__(807),
    createHybrid = __webpack_require__(301),
    createPartial = __webpack_require__(808),
    getData = __webpack_require__(309),
    mergeData = __webpack_require__(842),
    setData = __webpack_require__(318),
    setWrapToString = __webpack_require__(321),
    toInteger = __webpack_require__(330);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(317);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(768),
    stubArray = __webpack_require__(329);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(105);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(776),
    isObjectLike = __webpack_require__(63);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23),
    stubFalse = __webpack_require__(881);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isObject = __webpack_require__(55);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(84);
var Danger = __webpack_require__(992);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstrumentation = __webpack_require__(37);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(203);
var setInnerHTML = __webpack_require__(137);
var setTextContent = __webpack_require__(357);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: { toIndex: update.toIndex, content: update.content.toString() }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactErrorUtils = __webpack_require__(201);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(1021);
var propTypesFactory = __webpack_require__(332);

var React = __webpack_require__(87);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(47);
var ReactInstanceMap = __webpack_require__(108);
var ReactInstrumentation = __webpack_require__(37);
var ReactUpdates = __webpack_require__(41);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var emptyFunction = __webpack_require__(32);
var warning = __webpack_require__(7);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(89);

var ReactNoopUpdateQueue = __webpack_require__(211);

var canDefineProperty = __webpack_require__(366);
var emptyObject = __webpack_require__(79);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(7);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


var toSpace = __webpack_require__(1088);


/**
 * Expose `toCamelCase`.
 */

module.exports = toCamelCase;


/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */


function toCamelCase (string) {
  return toSpace(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase();
  });
}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_ab_express_cookie_metrics__ = __webpack_require__(558);
/* eslint-env browser, jquery */








var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('auth0:ab');
/**
 * AbTestingWrapper constructor
 */

function AbTestingWrapper() {
  if (!(this instanceof AbTestingWrapper)) {
    var wrapper = new AbTestingWrapper();
    wrapper.initialize = __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.resolve();

    return wrapper;
  }
}

/**
 * Retrieve `window.abTestingLib`
 */

AbTestingWrapper.prototype.lib = function () {
  return window.abTestingLib;
};

AbTestingWrapper.prototype.computeExperiments = function computeExperiments() {
  var _this = this;
  var ab = _this.lib();
  var metricsLib = __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib();

  // If metrics or ab fails, do nothing
  if (!metricsLib || !ab || !ab.integration) return function (ctx, next) {
    return next();
  };

  ab.integration('auth0metrics').start({ metrics: metricsLib });
  _this.initialize = ab.start().then(function () {
    enhanceAnalytics(ab.analytics);
  });

  return function (ctx, next) {
    ctx.winningFullPageVariantName = 'original';

    _this.initialize.then(function () {
      try {
        var pathname = document.location.pathname;
        var experiments = ab.getExperiments().runAllByPath(pathname).experiments || [];
        ctx.winningVariants = experiments.map(function (e) {
          return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.assign(e.getCurrentVariant(), {
            pathname: pathname,
            experiment: e.name,
            fullPage: e.name.indexOf('full-page-ab') === 0
          });
        });
        ctx.winningFullPageVariantName = getWinningFullPageVariantName(ctx.winningVariants);
      } catch (e) {
        debug('Error running experiments for %s', ctx.path);
      }

      next();
    });
  };
};

/**
 * Execute javascript code for each winning variant
 */

AbTestingWrapper.prototype.executeExperiments = function executeExperiments() {
  var _this = this;

  return function (ctx, next) {
    _this.initialize.then(function () {
      if (ctx.notFound) {
        return next();
      }

      debug('Computing experiments for %s', ctx.pathname);

      if (!ctx.winningVariants) {
        return;
      }

      try {
        var pathname = document.location.pathname;
        var variantContext = { $: $, bus: __WEBPACK_IMPORTED_MODULE_5_modules_npm_component_bus__["a" /* default */], page: __WEBPACK_IMPORTED_MODULE_1_page___default.a };

        ctx.winningVariants.forEach(function (variant) {
          var properties = variant.getPropertiesByType('js');
          if (properties && properties[0] && variant.pathname === pathname) {
            properties[0].runInContext(variantContext);
          }
        });
      } catch (e) {
        debug('Error computing experiments for %s', ctx.path);
      }
    });
  };
};

AbTestingWrapper.prototype.executeExperiment = function executeExperiment(experimentName, callback) {
  var _this = this;
  var ab = _this.lib();

  _this.initialize.then(function () {
    debug('Running single experiment %s', experimentName);

    if (!experimentName) {
      return callback && callback(null);
    }

    var experiment = ab.experiments.findByName(experimentName);
    if (!experiment) {
      return callback && callback(null);
    }

    var variant = experiment.run();
    var properties = variant.getPropertiesByType('js');

    try {
      if (properties && properties[0]) {
        var variantContext = { $: $, bus: __WEBPACK_IMPORTED_MODULE_5_modules_npm_component_bus__["a" /* default */], page: __WEBPACK_IMPORTED_MODULE_1_page___default.a };
        properties[0].runInContext(variantContext);
      }
    } catch (e) {
      debug('Error computing experiment %s', experimentName);
    }

    return callback && callback(variant);
  });
};

function enhanceAnalytics(analytics) {
  var cookieAnalytics = new __WEBPACK_IMPORTED_MODULE_6_modules_ab_express_cookie_metrics__["a" /* default */]();

  var originalSetCurrentVariantName = analytics.setCurrentVariantName.bind(analytics);
  var originalGetCurrentVariantName = analytics.getCurrentVariantName.bind(analytics);

  var enhancedSetCurrentVariantName = function enhancedSetCurrentVariantName(variantName, value) {
    cookieAnalytics.setCurrentVariantName(variantName, value);
    originalSetCurrentVariantName(variantName, value);
  };

  var enhancedGetCurrentVariantName = function enhancedGetCurrentVariantName(variantName) {
    var originalValue = originalGetCurrentVariantName(variantName);
    var cookieValue = cookieAnalytics.getCurrentVariantName(variantName);

    if (originalValue !== cookieValue) {
      originalSetCurrentVariantName(variantName, cookieValue);
    }

    return cookieValue;
  };

  analytics.setCurrentVariantName = enhancedSetCurrentVariantName;
  analytics.getCurrentVariantName = enhancedGetCurrentVariantName;
  window.setVariant = enhancedSetCurrentVariantName;
  window.getVariant = enhancedGetCurrentVariantName;
}

function getWinningFullPageVariantName(variants) {
  var winningFullPageVariant = variants.filter(function (v) {
    return v.fullPage;
  })[0];

  return winningFullPageVariant ? winningFullPageVariant.name : 'original';
}

/**
 * Expose `AbTestingWrapper` constructor
 */

/* harmony default export */ __webpack_exports__["a"] = (AbTestingWrapper());

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
/* unused harmony export signup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_locks__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_auth0_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_bus__ = __webpack_require__(33);
/* eslint-env jquery, browser */
// import debug from 'debug';





// const error = debug('auth0:sso');
var AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
var AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;

var client = new __WEBPACK_IMPORTED_MODULE_2_auth0_js___default.a.Authentication({
  domain: AUTH0_DOMAIN,
  clientID: AUTH0_CLIENT_ID
});

client.getSSOData(false, function (err, data) {
  __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_bus__["a" /* default */].emit('sso', data);
});

__WEBPACK_IMPORTED_MODULE_1_modules_locks__["a" /* main */].lock.on('signup ready', function () {
  __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('open:signup', { cateogry: 'lock' });
});

__WEBPACK_IMPORTED_MODULE_1_modules_locks__["a" /* main */].lock.on('signin ready', function () {
  __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('open:signin', { category: 'lock' });
});

var login = window.login = function () {
  __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('click:signin', { category: 'button' });
  __WEBPACK_IMPORTED_MODULE_1_modules_locks__["a" /* main */].show();
};

var signup = window.signup = function (btn, options) {
  var data = { category: 'button' };

  if (btn) {
    data.trackData = $(btn).data('track');
  }

  __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('click:signup', data);
  __WEBPACK_IMPORTED_MODULE_1_modules_locks__["a" /* main */].signup(options);
};

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Header__["a"]; });
/* eslint-env browser */






var _window$APP_STATE = window.APP_STATE,
    headerFeaturedLink = _window$APP_STATE.headerFeaturedLink,
    headerFeaturedTitle = _window$APP_STATE.headerFeaturedTitle,
    headerFeaturedDescription = _window$APP_STATE.headerFeaturedDescription,
    headerFeaturedCTA = _window$APP_STATE.headerFeaturedCTA,
    headerFeaturedIconColor = _window$APP_STATE.headerFeaturedIconColor,
    talkToSalesButtonText = _window$APP_STATE.talkToSalesButtonText;


var headerProps = {
  featuredLink: headerFeaturedLink,
  featuredTitle: headerFeaturedTitle,
  featuredDescription: headerFeaturedDescription,
  featuredCTA: headerFeaturedCTA,
  featuredIconColor: headerFeaturedIconColor,
  talkToSalesButtonText: talkToSalesButtonText
};

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["assign"])(props, headerProps)), document.getElementById('header'));
});



/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);

var RequestBuilder = __webpack_require__(139);
var qs = __webpack_require__(83);
var objectHelper = __webpack_require__(38);
var assert = __webpack_require__(49);
var responseHandler = __webpack_require__(67);
var parametersWhitelist = __webpack_require__(502);
var Warn = __webpack_require__(113);

var PasswordlessAuthentication = __webpack_require__(498);
var DBConnection = __webpack_require__(497);

/**
 * Creates a new Auth0 Authentication API client
 * @constructor
 * @param {Object} options
 * @param {String} options.domain your Auth0 domain
 * @param {String} options.clientID your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @see {@link https://auth0.com/docs/api/authentication}
 */
function Authentication(options) {
  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    domain: { type: 'string', message: 'domain option is required' },
    clientID: { type: 'string', message: 'clientID option is required' },
    responseType: { optional: true, type: 'string', message: 'responseType is not valid' },
    responseMode: { optional: true, type: 'string', message: 'responseMode is not valid' },
    redirectUri: { optional: true, type: 'string', message: 'redirectUri is not valid' },
    scope: { optional: true, type: 'string', message: 'scope is not valid' },
    audience: { optional: true, type: 'string', message: 'audience is not valid' },
    _disableDeprecationWarnings: { optional: true, type: 'boolean', message: '_disableDeprecationWarnings option is not valid' },
    _sendTelemetry: { optional: true, type: 'boolean', message: '_sendTelemetry option is not valid' },
    _telemetryInfo: { optional: true, type: 'object', message: '_telemetryInfo option is not valid' }
  });
  /* eslint-enable */

  this.baseOptions = options;

  this.baseOptions._sendTelemetry = this.baseOptions._sendTelemetry === false ?
                                        this.baseOptions._sendTelemetry : true;

  this.baseOptions.rootUrl = 'https://' + this.baseOptions.domain;

  this.request = new RequestBuilder(this.baseOptions);

  this.passwordless = new PasswordlessAuthentication(this.request, this.baseOptions);
  this.dbConnection = new DBConnection(this.request, this.baseOptions);

  this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  });
}

/**
 * Builds and returns the `/authorize` url in order to initialize a new authN/authZ transaction
 *
 * @method buildAuthorizeUrl
 * @param {Object} options
 * @param {String} [options.domain] your Auth0 domain
 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
 * @see {@link https://auth0.com/docs/api/authentication#social}
 */
Authentication.prototype.buildAuthorizeUrl = function (options) {
  var params;
  var qString;

  assert.check(options, { type: 'object', message: 'options parameter is not valid' });

  params = objectHelper.merge(this.baseOptions, [
    'clientID',
    'responseType',
    'responseMode',
    'redirectUri',
    'scope',
    'audience'
  ]).with(options);

  /* eslint-disable */
  assert.check(params, { type: 'object', message: 'options parameter is not valid' }, {
    clientID: { type: 'string', message: 'clientID option is required' },
    redirectUri: { optional: true, type: 'string', message: 'redirectUri option is required' },
    responseType: { type: 'string', message: 'responseType option is required' },
    nonce: { type: 'string', message: 'nonce option is required', condition: function(o) {
      return o.responseType.indexOf('code') === -1 && o.responseType.indexOf('id_token') !== -1;
    } },
    scope: { optional: true, type: 'string', message: 'scope option is required' },
    audience: { optional: true, type: 'string', message: 'audience option is required' }
  });
  /* eslint-enable */

  // eslint-disable-next-line
  if (this.baseOptions._sendTelemetry) {
    params.auth0Client = this.request.getTelemetryData();
  }

  if (params.connection_scope && assert.isArray(params.connection_scope)) {
    params.connection_scope = params.connection_scope.join(',');
  }

  params = objectHelper.toSnakeCase(params, ['auth0Client']);
  params = parametersWhitelist.oauthAuthorizeParams(this.warn, params);

  qString = qs.stringify(params);

  return urljoin(this.baseOptions.rootUrl, 'authorize', '?' + qString);
};

/**
 * Builds and returns the Logout url in order to initialize a new authN/authZ transaction
 *
 * If you want to navigate the user to a specific URL after the logout, set that URL at the returnTo parameter. The URL should be included in any the appropriate Allowed Logout URLs list:
 *
 * - If the client_id parameter is included, the returnTo URL must be listed in the Allowed Logout URLs set at the client level (see Setting Allowed Logout URLs at the App Level).
 * - If the client_id parameter is NOT included, the returnTo URL must be listed in the Allowed Logout URLs set at the account level (see Setting Allowed Logout URLs at the Account Level).
 * @method buildLogoutUrl
 * @param {Object} options
 * @param {String} [options.clientID] identifier of your client
 * @param {String} [options.returnTo] URL to be redirected after the logout
 * @param {Boolean} [options.federated] tells Auth0 if it should logout the user also from the IdP.
 * @see {@link https://auth0.com/docs/api/authentication#logout}
 */
Authentication.prototype.buildLogoutUrl = function (options) {
  var params;
  var qString;

  assert.check(options, {
    optional: true,
    type: 'object',
    message: 'options parameter is not valid'
  });

  params = objectHelper.merge(this.baseOptions, ['clientID'])
                .with(options || {});

  // eslint-disable-next-line
  if (this.baseOptions._sendTelemetry) {
    params.auth0Client = this.request.getTelemetryData();
  }

  params = objectHelper.toSnakeCase(params, ['auth0Client', 'returnTo']);

  qString = qs.stringify(params);

  return urljoin(this.baseOptions.rootUrl, 'v2', 'logout', '?' + qString);
};

/**
 * @callback authorizeCallback
 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
 * @param {Object} [result] result of the Auth request
 * @param {String} [result.accessToken] token that allows access to the specified resource server (identified by the audience parameter or by default Auth0's /userinfo endpoint)
 * @param {Number} [result.expiresIn] number of seconds until the access token expires
 * @param {String} [result.idToken] token that identifies the user
 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all clients can request them or the resource server might not allow them.
 */

/**
 * @callback tokenCallback
 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
 * @param {Object} [result] result of the Auth request
 * @param {String} result.accessToken token that allows access to the specified resource server (identified by the audience parameter or by default Auth0's /userinfo endpoint)
 * @param {Number} result.expiresIn number of seconds until the access token expires
 * @param {String} [result.idToken] token that identifies the user
 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all clients can request them or the resource server might not allow them.
 */

/**
 * Makes a call to the `oauth/token` endpoint with `password` grant type to login to the default directory.
 *
 * @method loginWithDefaultDirectory
 * @param {Object} options
 * @param {String} options.username email or username of the user that will perform Auth
 * @param {String} options.password the password of the user that will perform Auth
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @param {tokenCallback} cb function called with the result of the request
 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
 */
Authentication.prototype.loginWithDefaultDirectory = function (options, cb) {
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    username: { type: 'string', message: 'username option is required' },
    password: { type: 'string', message: 'password option is required' },
    scope: { optional: true, type: 'string', message: 'scope option is required' },
    audience: { optional: true, type: 'string', message: 'audience option is required' }
  });

  options.grantType = 'password';

  return this.oauthToken(options, cb);
};

/**
 * Makes a call to the `oauth/token` endpoint with `password-realm` grant type
 *
 * @method login
 * @param {Object} options
 * @param {String} options.username email or username of the user that will perform Auth
 * @param {String} options.password the password of the user that will perform Auth
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @param {Object} options.realm the HRD domain or the connection name where the user belongs to. e.g. `Username-Password-Authentication`
 * @param {tokenCallback} cb function called with the result of the request
 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
 */
Authentication.prototype.login = function (options, cb) {
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    username: { type: 'string', message: 'username option is required' },
    password: { type: 'string', message: 'password option is required' },
    realm: { type: 'string', message: 'realm option is required' },
    scope: { optional: true, type: 'string', message: 'scope option is required' },
    audience: { optional: true, type: 'string', message: 'audience option is required' }
  });

  options.grantType = 'http://auth0.com/oauth/grant-type/password-realm';

  return this.oauthToken(options, cb);
};

/**
 * Makes a call to the `oauth/token` endpoint
 *
 * @method oauthToken
 * @private
 */
Authentication.prototype.oauthToken = function (options, cb) {
  var url;
  var body;

  assert.check(options, { type: 'object', message: 'options parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'oauth', 'token');

  body = objectHelper.merge(this.baseOptions, [
    'clientID',
    'scope',
    'audience'
  ]).with(options);

  assert.check(body, { type: 'object', message: 'options parameter is not valid' }, {
    clientID: { type: 'string', message: 'clientID option is required' },
    grantType: { type: 'string', message: 'grantType option is required' },
    scope: { optional: true, type: 'string', message: 'scope option is required' },
    audience: { optional: true, type: 'string', message: 'audience option is required' }
  });

  body = objectHelper.toSnakeCase(body, ['auth0Client']);
  body = parametersWhitelist.oauthTokenParams(this.warn, body);

  body.grant_type = body.grant_type;

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

/**
 * Performs authentication calling `/oauth/ro` endpoint with username
 * and password for a given connection name.
 *
 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
 * you should use {@link login} or {@link loginWithDefaultDirectory}.
 *
 * @method loginWithResourceOwner
 * @param {Object} options
 * @param {String} options.username email or username of the user that will perform Auth
 * @param {String} options.password the password of the user that will perform Auth
 * @param {Object} options.connection the connection name where the user belongs to. e.g. `Username-Password-Authentication`
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.device] name of the device/browser where the Auth was requested
 * @param {tokenCallback} cb function called with the result of the request
 */
Authentication.prototype.loginWithResourceOwner = function (options, cb) {
  var url;
  var body;

  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    username: { type: 'string', message: 'username option is required' },
    password: { type: 'string', message: 'password option is required' },
    connection: { type: 'string', message: 'connection option is required' },
    scope: { optional: true, type: 'string', message: 'scope option is required' }
  });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'oauth', 'ro');

  body = objectHelper.merge(this.baseOptions, [
    'clientID',
    'scope'
  ]).with(options, ['username', 'password', 'scope', 'connection', 'device']);

  body = objectHelper.toSnakeCase(body, ['auth0Client']);

  body.grant_type = body.grant_type || 'password';

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

/**
 * Makes a call to the `/ssodata` endpoint.
 * We recommend to avoid using this method and rely on your tenant hosted login page and using prompt=none via {@link renewAuth} method.
 *
 * @method getSSOData
 * @param {Boolean} withActiveDirectories tells Auth0 to return AD data
 * @param {Function} cb
 */
Authentication.prototype.getSSOData = function (withActiveDirectories, cb) {
  var url;
  var params = '';

  if (typeof withActiveDirectories === 'function') {
    cb = withActiveDirectories;
    withActiveDirectories = false;
  }

  assert.check(withActiveDirectories, { type: 'boolean', message: 'withActiveDirectories parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  if (withActiveDirectories) {
    params = '?' + qs.stringify({
      ldaps: 1,
      client_id: this.baseOptions.clientID
    });
  }

  url = urljoin(this.baseOptions.rootUrl, 'user', 'ssodata', params);

  return this.request
    .get(url, { noHeaders: true })
    .withCredentials()
    .end(responseHandler(cb));
};

/**
 * @callback userInfoCallback
 * @param {Error} [err] error returned by Auth0
 * @param {Object} [userInfo] user information
 */

/**
 * Makes a call to the `/userinfo` endpoint and returns the user profile
 *
 * @method userInfo
 * @param {String} accessToken token issued to a user after Auth
 * @param {userInfoCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#get-user-info}
 */
Authentication.prototype.userInfo = function (accessToken, cb) {
  var url;

  assert.check(accessToken, { type: 'string', message: 'accessToken parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'userinfo');

  return this.request
    .get(url)
    .set('Authorization', 'Bearer ' + accessToken)
    .end(responseHandler(cb, { ignoreCasing: true }));
};

/**
 * @callback delegationCallback
 * @param {Error} [err] error returned by Auth0 with the reason why the delegation failed
 * @param {Object} [result] result of the delegation request. The payload depends on what ai type was used
 */

/**
 * Makes a call to the `/delegation` endpoint with either an `id_token` or `refresh_token`
 *
 * @method delegation
 * @param {Object} options
 * @param {String} [options.clientID] client identifier
 * @param {String} options.grantType  grant type used for delegation. The only valid value is `urn:ietf:params:oauth:grant-type:jwt-bearer`
 * @param {String} [options.idToken] valid token of the user issued after Auth. If no `refresh_token` is provided this parameter is required
 * @param {String} [options.refreshToken] valid refresh token of the user issued after Auth. If no `id_token` is provided this parameter is required
 * @param {String} [options.target] the target client id of the delegation
 * @param {String} [options.scope] either `openid` or `openid profile email`
 * @param {String} [options.apiType] the api to be called
 * @param {delegationCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#delegation}
 */
Authentication.prototype.delegation = function (options, cb) {
  var url;
  var body;

  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    grant_type: { type: 'string', message: 'grant_type option is required' }
  });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'delegation');

  body = objectHelper.merge(this.baseOptions, ['clientID'])
                .with(options);

  body = objectHelper.toSnakeCase(body, ['auth0Client']);

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

/**
 * Fetches the user country based on the ip.
 *
 * @method getUserCountry
 * @private
 * @param {Function} cb
 */
Authentication.prototype.getUserCountry = function (cb) {
  var url;

  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'user', 'geoloc', 'country');

  return this.request
    .get(url)
    .end(responseHandler(cb));
};

module.exports = Authentication;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var base64 = __webpack_require__(146);

function padding(str) {
  var mod = (str.length % 4);
  var pad = 4 - mod;

  if (mod === 0) {
    return str;
  }

  return str + (new Array(1 + pad)).join('=');
}

function stringToByteArray(str) {
  var arr = new Array(str.length);
  for (var a = 0; a < str.length; a++) {
    arr[a] = str.charCodeAt(a);
  }
  return arr;
}

function byteArrayToString(array) {
  var result = '';
  for (var i = 0; i < array.length; i++) {
    result += String.fromCharCode(array[i]);
  }
  return result;
}

function encode(str) {
  return base64.fromByteArray(stringToByteArray(str))
      .replace(/\+/g, '-') // Convert '+' to '-'
      .replace(/\//g, '_'); // Convert '/' to '_'
}

function decode(str) {
  str = padding(str)
    .replace(/-/g, '+') // Convert '-' to '+'
    .replace(/_/g, '/'); // Convert '_' to '/'

  return byteArrayToString(base64.toByteArray(str));
}

module.exports = {
  encode: encode,
  decode: decode
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

function buildResponse(error, description) {
  return {
    error: error,
    errorDescription: description
  };
}

function invalidJwt(description) {
  return buildResponse('invalid_token', description);
}

module.exports = {
  buildResponse: buildResponse,
  invalidJwt: invalidJwt
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var Authentication = __webpack_require__(218);
var Management = __webpack_require__(511);
var WebAuth = __webpack_require__(512);
var version = __webpack_require__(140);

module.exports = {
  Authentication: Authentication,
  Management: Management,
  WebAuth: WebAuth,
  version: version.raw
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var random = __webpack_require__(505);
var storage = __webpack_require__(506);

var DEFAULT_NAMESPACE = 'com.auth0.auth.';

function TransactionManager(options) {
  options = options || {};
  this.namespace = options.namespace || DEFAULT_NAMESPACE;
  this.keyLength = options.keyLength || 32;
}

TransactionManager.prototype.process = function (options) {
  var transaction;

  if (options.responseType.indexOf('code') !== -1) {
    return options;
  }

  if (options.responseType.indexOf('id_token') !== -1 && !!options.nonce) {
    return options;
  }

  transaction = this.generateTransaction(options.appState, options.state, options.nonce);

  options.state = transaction.state;

  if (options.responseType.indexOf('id_token') !== -1) {
    options.nonce = transaction.nonce;
  }

  return options;
};

TransactionManager.prototype.generateTransaction = function (appState, state, nonce) {
  var transaction = state || random.randomString(this.keyLength);
  nonce = nonce || random.randomString(this.keyLength);

  storage.setItem(this.namespace + transaction, {
    nonce: nonce,
    appState: appState
  });

  return {
    state: transaction,
    nonce: nonce
  };
};

TransactionManager.prototype.getStoredTransaction = function (transaction) {
  var transactionData;

  transactionData = storage.getItem(this.namespace + transaction);
  storage.removeItem(this.namespace + transaction);
  return transactionData;
};

module.exports = TransactionManager;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var settle = __webpack_require__(524);
var buildURL = __webpack_require__(527);
var parseHeaders = __webpack_require__(533);
var isURLSameOrigin = __webpack_require__(531);
var createError = __webpack_require__(226);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(526);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(529);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(523);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['authenticate']);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthButton__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthButton__["a"]; });



/***/ }),
/* 230 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
	Base.js, version 1.1a
	Copyright 2006-2010, Dean Edwards
	License: http://www.opensource.org/licenses/mit-license.php
*/

var Base = function Base() {
	// dummy
};

Base.extend = function (_instance, _static) {
	// subclass

	"use strict";

	var extend = Base.prototype.extend;

	// build the prototype
	Base._prototyping = true;

	var proto = new this();

	extend.call(proto, _instance);

	proto.base = function () {
		// call this method from any other method to invoke that method's ancestor
	};

	delete Base._prototyping;

	// create the wrapper for the constructor function
	//var constructor = proto.constructor.valueOf(); //-dean
	var constructor = proto.constructor;
	var klass = proto.constructor = function () {
		if (!Base._prototyping) {
			if (this._constructing || this.constructor == klass) {
				// instantiation
				this._constructing = true;
				constructor.apply(this, arguments);
				delete this._constructing;
			} else if (arguments[0] !== null) {
				// casting
				return (arguments[0].extend || extend).call(arguments[0], proto);
			}
		}
	};

	// build the class interface
	klass.ancestor = this;
	klass.extend = this.extend;
	klass.forEach = this.forEach;
	klass.implement = this.implement;
	klass.prototype = proto;
	klass.toString = this.toString;
	klass.valueOf = function (type) {
		//return (type == "object") ? klass : constructor; //-dean
		return type == "object" ? klass : constructor.valueOf();
	};
	extend.call(klass, _static);
	// class initialisation
	if (typeof klass.init == "function") klass.init();
	return klass;
};

Base.prototype = {
	extend: function extend(source, value) {
		if (arguments.length > 1) {
			// extending with a name/value pair
			var ancestor = this[source];
			if (ancestor && typeof value == "function" && ( // overriding a method?
			// the valueOf() comparison is to avoid circular references
			!ancestor.valueOf || ancestor.valueOf() != value.valueOf()) && /\bbase\b/.test(value)) {
				// get the underlying method
				var method = value.valueOf();
				// override
				value = function value() {
					var previous = this.base || Base.prototype.base;
					this.base = ancestor;
					var returnValue = method.apply(this, arguments);
					this.base = previous;
					return returnValue;
				};
				// point to the underlying method
				value.valueOf = function (type) {
					return type == "object" ? value : method;
				};
				value.toString = Base.toString;
			}
			this[source] = value;
		} else if (source) {
			// extending with an object literal
			var extend = Base.prototype.extend;
			// if this object has a customised extend method then use it
			if (!Base._prototyping && typeof this != "function") {
				extend = this.extend || extend;
			}
			var proto = { toSource: null };
			// do the "toString" and other methods manually
			var hidden = ["constructor", "toString", "valueOf"];
			// if we are prototyping then include the constructor
			var i = Base._prototyping ? 0 : 1;
			while (key = hidden[i++]) {
				if (source[key] != proto[key]) {
					extend.call(this, key, source[key]);
				}
			}
			// copy each of the source object's properties to this object
			for (var key in source) {
				if (!proto[key]) extend.call(this, key, source[key]);
			}
		}
		return this;
	}
};

// initialise
Base = Base.extend({
	constructor: function constructor() {
		this.extend(arguments[0]);
	}
}, {
	ancestor: Object,
	version: "1.1",

	forEach: function forEach(object, block, context) {
		for (var key in object) {
			if (this.prototype[key] === undefined) {
				block.call(context, object[key], key, object);
			}
		}
	},

	implement: function implement() {
		for (var i = 0; i < arguments.length; i++) {
			if (typeof arguments[i] == "function") {
				// if it's a function, call it
				arguments[i](this.prototype);
			} else {
				// add the interface using the extend method
				this.prototype.extend(arguments[i]);
			}
		}
		return this;
	},

	toString: function toString() {
		return String(this.valueOf());
	}
});
/*jshint smarttabs:true */

var _FlipClock;

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * FlipFlock Helper
  *
  * @param  object  A jQuery object or CSS select
  * @param  int     An integer used to start the clock (no. seconds)
  * @param  object  An object of properties to override the default
  */

	_FlipClock = function FlipClock(obj, digit, options) {
		if (digit instanceof Object && digit instanceof Date === false) {
			options = digit;
			digit = 0;
		}

		return new _FlipClock.Factory(obj, digit, options);
	};

	/**
  * The global FlipClock.Lang object
  */

	_FlipClock.Lang = {};

	/**
  * The Base FlipClock class is used to extend all other FlipFlock
  * classes. It handles the callbacks and the basic setters/getters
  *
  * @param 	object  An object of the default properties
  * @param 	object  An object of properties to override the default
  */

	_FlipClock.Base = Base.extend({

		/**
   * Build Date
   */

		buildDate: '2014-12-12',

		/**
   * Version
   */

		version: '0.7.7',

		/**
   * Sets the default options
   *
   * @param	object 	The default options
   * @param	object 	The override options
   */

		constructor: function constructor(_default, options) {
			if ((typeof _default === "undefined" ? "undefined" : _typeof(_default)) !== "object") {
				_default = {};
			}
			if ((typeof options === "undefined" ? "undefined" : _typeof(options)) !== "object") {
				options = {};
			}
			this.setOptions($.extend(true, {}, _default, options));
		},

		/**
   * Delegates the callback to the defined method
   *
   * @param	object 	The default options
   * @param	object 	The override options
   */

		callback: function callback(method) {
			if (typeof method === "function") {
				var args = [];

				for (var x = 1; x <= arguments.length; x++) {
					if (arguments[x]) {
						args.push(arguments[x]);
					}
				}

				method.apply(this, args);
			}
		},

		/**
   * Log a string into the console if it exists
   *
   * @param 	string 	The name of the option
   * @return	mixed
   */

		log: function log(str) {
			if (window.console && console.log) {
				console.log(str);
			}
		},

		/**
   * Get an single option value. Returns false if option does not exist
   *
   * @param 	string 	The name of the option
   * @return	mixed
   */

		getOption: function getOption(index) {
			if (this[index]) {
				return this[index];
			}
			return false;
		},

		/**
   * Get all options
   *
   * @return	bool
   */

		getOptions: function getOptions() {
			return this;
		},

		/**
   * Set a single option value
   *
   * @param 	string 	The name of the option
   * @param 	mixed 	The value of the option
   */

		setOption: function setOption(index, value) {
			this[index] = value;
		},

		/**
   * Set a multiple options by passing a JSON object
   *
   * @param 	object 	The object with the options
   * @param 	mixed 	The value of the option
   */

		setOptions: function setOptions(options) {
			for (var key in options) {
				if (typeof options[key] !== "undefined") {
					this.setOption(key, options[key]);
				}
			}
		}

	});
})(jQuery);

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * The FlipClock Face class is the base class in which to extend
  * all other FlockClock.Face classes.
  *
  * @param 	object  The parent FlipClock.Factory object
  * @param 	object  An object of properties to override the default
  */

	_FlipClock.Face = _FlipClock.Base.extend({

		/**
   * Sets whether or not the clock should start upon instantiation
   */

		autoStart: true,

		/**
   * An array of jQuery objects used for the dividers (the colons)
   */

		dividers: [],

		/**
   * An array of FlipClock.List objects
   */

		factory: false,

		/**
   * An array of FlipClock.List objects
   */

		lists: [],

		/**
   * Constructor
   *
   * @param 	object  The parent FlipClock.Factory object
   * @param 	object  An object of properties to override the default
   */

		constructor: function constructor(factory, options) {
			this.dividers = [];
			this.lists = [];
			this.base(options);
			this.factory = factory;
		},

		/**
   * Build the clock face
   */

		build: function build() {
			if (this.autoStart) {
				this.start();
			}
		},

		/**
   * Creates a jQuery object used for the digit divider
   *
   * @param	mixed 	The divider label text
   * @param	mixed	Set true to exclude the dots in the divider.
   *					If not set, is false.
   */

		createDivider: function createDivider(label, css, excludeDots) {
			if (typeof css == "boolean" || !css) {
				excludeDots = css;
				css = label;
			}

			var dots = ['<span class="' + this.factory.classes.dot + ' top"></span>', '<span class="' + this.factory.classes.dot + ' bottom"></span>'].join('');

			if (excludeDots) {
				dots = '';
			}

			label = this.factory.localize(label);

			var html = ['<span class="' + this.factory.classes.divider + ' ' + (css ? css : '').toLowerCase() + '">', '<span class="' + this.factory.classes.label + '">' + (label ? label : '') + '</span>', dots, '</span>'];

			var $html = $(html.join(''));

			this.dividers.push($html);

			return $html;
		},

		/**
   * Creates a FlipClock.List object and appends it to the DOM
   *
   * @param	mixed 	The digit to select in the list
   * @param	object  An object to override the default properties
   */

		createList: function createList(digit, options) {
			if ((typeof digit === "undefined" ? "undefined" : _typeof(digit)) === "object") {
				options = digit;
				digit = 0;
			}

			var obj = new _FlipClock.List(this.factory, digit, options);

			this.lists.push(obj);

			return obj;
		},

		/**
   * Triggers when the clock is reset
   */

		reset: function reset() {
			this.factory.time = new _FlipClock.Time(this.factory, this.factory.original ? Math.round(this.factory.original) : 0, {
				minimumDigits: this.factory.minimumDigits
			});

			this.flip(this.factory.original, false);
		},

		/**
   * Append a newly created list to the clock
   */

		appendDigitToClock: function appendDigitToClock(obj) {
			obj.$el.append(false);
		},

		/**
   * Add a digit to the clock face
   */

		addDigit: function addDigit(digit) {
			var obj = this.createList(digit, {
				classes: {
					active: this.factory.classes.active,
					before: this.factory.classes.before,
					flip: this.factory.classes.flip
				}
			});

			this.appendDigitToClock(obj);
		},

		/**
   * Triggers when the clock is started
   */

		start: function start() {},

		/**
   * Triggers when the time on the clock stops
   */

		stop: function stop() {},

		/**
   * Auto increments/decrements the value of the clock face
   */

		autoIncrement: function autoIncrement() {
			if (!this.factory.countdown) {
				this.increment();
			} else {
				this.decrement();
			}
		},

		/**
   * Increments the value of the clock face
   */

		increment: function increment() {
			this.factory.time.addSecond();
		},

		/**
   * Decrements the value of the clock face
   */

		decrement: function decrement() {
			if (this.factory.time.getTimeSeconds() == 0) {
				this.factory.stop();
			} else {
				this.factory.time.subSecond();
			}
		},

		/**
   * Triggers when the numbers on the clock flip
   */

		flip: function flip(time, doNotAddPlayClass) {
			var t = this;

			$.each(time, function (i, digit) {
				var list = t.lists[i];

				if (list) {
					if (!doNotAddPlayClass && digit != list.digit) {
						list.play();
					}

					list.select(digit);
				} else {
					t.addDigit(digit);
				}
			});
		}

	});
})(jQuery);

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * The FlipClock Factory class is used to build the clock and manage
  * all the public methods.
  *
  * @param 	object  A jQuery object or CSS selector used to fetch
  				    the wrapping DOM nodes
  * @param 	mixed   This is the digit used to set the clock. If an
  				    object is passed, 0 will be used.
  * @param 	object  An object of properties to override the default
  */

	_FlipClock.Factory = _FlipClock.Base.extend({

		/**
   * The clock's animation rate.
   *
   * Note, currently this property doesn't do anything.
   * This property is here to be used in the future to
   * programmaticaly set the clock's animation speed
   */

		animationRate: 1000,

		/**
   * Auto start the clock on page load (True|False)
   */

		autoStart: true,

		/**
   * The callback methods
   */

		callbacks: {
			destroy: false,
			create: false,
			init: false,
			interval: false,
			start: false,
			stop: false,
			reset: false
		},

		/**
   * The CSS classes
   */

		classes: {
			active: 'flip-clock-active',
			before: 'flip-clock-before',
			divider: 'flip-clock-divider',
			dot: 'flip-clock-dot',
			label: 'flip-clock-label',
			flip: 'flip',
			play: 'play',
			wrapper: 'flip-clock-wrapper'
		},

		/**
   * The name of the clock face class in use
   */

		clockFace: 'HourlyCounter',

		/**
   * The name of the clock face class in use
   */

		countdown: false,

		/**
   * The name of the default clock face class to use if the defined
   * clockFace variable is not a valid FlipClock.Face object
   */

		defaultClockFace: 'HourlyCounter',

		/**
   * The default language
   */

		defaultLanguage: 'english',

		/**
   * The jQuery object
   */

		$el: false,

		/**
   * The FlipClock.Face object
   */

		face: true,

		/**
   * The language object after it has been loaded
   */

		lang: false,

		/**
   * The language being used to display labels (string)
   */

		language: 'english',

		/**
   * The minimum digits the clock must have
   */

		minimumDigits: 0,

		/**
   * The original starting value of the clock. Used for the reset method.
   */

		original: false,

		/**
   * Is the clock running? (True|False)
   */

		running: false,

		/**
   * The FlipClock.Time object
   */

		time: false,

		/**
   * The FlipClock.Timer object
   */

		timer: false,

		/**
   * The jQuery object (depcrecated)
   */

		$wrapper: false,

		/**
   * Constructor
   *
   * @param   object  The wrapping jQuery object
   * @param	object  Number of seconds used to start the clock
   * @param	object 	An object override options
   */

		constructor: function constructor(obj, digit, options) {

			if (!options) {
				options = {};
			}

			this.lists = [];
			this.running = false;
			this.base(options);

			this.$el = $(obj).addClass(this.classes.wrapper);

			// Depcrated support of the $wrapper property.
			this.$wrapper = this.$el;

			this.original = digit instanceof Date ? digit : digit ? Math.round(digit) : 0;

			this.time = new _FlipClock.Time(this, this.original, {
				minimumDigits: this.minimumDigits,
				animationRate: this.animationRate
			});

			this.timer = new _FlipClock.Timer(this, options);

			this.loadLanguage(this.language);

			this.loadClockFace(this.clockFace, options);

			if (this.autoStart) {
				this.start();
			}
		},

		/**
   * Load the FlipClock.Face object
   *
   * @param	object  The name of the FlickClock.Face class
   * @param	object 	An object override options
   */

		loadClockFace: function loadClockFace(name, options) {
			var face,
			    suffix = 'Face',
			    hasStopped = false;

			name = name.ucfirst() + suffix;

			if (this.face.stop) {
				this.stop();
				hasStopped = true;
			}

			this.$el.html('');

			this.time.minimumDigits = this.minimumDigits;

			if (_FlipClock[name]) {
				face = new _FlipClock[name](this, options);
			} else {
				face = new _FlipClock[this.defaultClockFace + suffix](this, options);
			}

			face.build();

			this.face = face;

			if (hasStopped) {
				this.start();
			}

			return this.face;
		},

		/**
   * Load the FlipClock.Lang object
   *
   * @param	object  The name of the language to load
   */

		loadLanguage: function loadLanguage(name) {
			var lang;

			if (_FlipClock.Lang[name.ucfirst()]) {
				lang = _FlipClock.Lang[name.ucfirst()];
			} else if (_FlipClock.Lang[name]) {
				lang = _FlipClock.Lang[name];
			} else {
				lang = _FlipClock.Lang[this.defaultLanguage];
			}

			return this.lang = lang;
		},

		/**
   * Localize strings into various languages
   *
   * @param	string  The index of the localized string
   * @param	object  Optionally pass a lang object
   */

		localize: function localize(index, obj) {
			var lang = this.lang;

			if (!index) {
				return null;
			}

			var lindex = index.toLowerCase();

			if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) == "object") {
				lang = obj;
			}

			if (lang && lang[lindex]) {
				return lang[lindex];
			}

			return index;
		},

		/**
   * Starts the clock
   */

		start: function start(callback) {
			var t = this;

			if (!t.running && (!t.countdown || t.countdown && t.time.time > 0)) {
				t.face.start(t.time);
				t.timer.start(function () {
					t.flip();

					if (typeof callback === "function") {
						callback();
					}
				});
			} else {
				t.log('Trying to start timer when countdown already at 0');
			}
		},

		/**
   * Stops the clock
   */

		stop: function stop(callback) {
			this.face.stop();
			this.timer.stop(callback);

			for (var x in this.lists) {
				if (this.lists.hasOwnProperty(x)) {
					this.lists[x].stop();
				}
			}
		},

		/**
   * Reset the clock
   */

		reset: function reset(callback) {
			this.timer.reset(callback);
			this.face.reset();
		},

		/**
   * Sets the clock time
   */

		setTime: function setTime(time) {
			this.time.time = time;
			this.flip(true);
		},

		/**
   * Get the clock time
   *
   * @return  object  Returns a FlipClock.Time object
   */

		getTime: function getTime(time) {
			return this.time;
		},

		/**
   * Changes the increment of time to up or down (add/sub)
   */

		setCountdown: function setCountdown(value) {
			var running = this.running;

			this.countdown = value ? true : false;

			if (running) {
				this.stop();
				this.start();
			}
		},

		/**
   * Flip the digits on the clock
   *
   * @param  array  An array of digits
   */
		flip: function flip(doNotAddPlayClass) {
			this.face.flip(false, doNotAddPlayClass);
		}

	});
})(jQuery);

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * The FlipClock List class is used to build the list used to create
  * the card flip effect. This object fascilates selecting the correct
  * node by passing a specific digit.
  *
  * @param 	object  A FlipClock.Factory object
  * @param 	mixed   This is the digit used to set the clock. If an
  *				    object is passed, 0 will be used.
  * @param 	object  An object of properties to override the default
  */

	_FlipClock.List = _FlipClock.Base.extend({

		/**
   * The digit (0-9)
   */

		digit: 0,

		/**
   * The CSS classes
   */

		classes: {
			active: 'flip-clock-active',
			before: 'flip-clock-before',
			flip: 'flip'
		},

		/**
   * The parent FlipClock.Factory object
   */

		factory: false,

		/**
   * The jQuery object
   */

		$el: false,

		/**
   * The jQuery object (deprecated)
   */

		$obj: false,

		/**
   * The items in the list
   */

		items: [],

		/**
   * The last digit
   */

		lastDigit: 0,

		/**
   * Constructor
   *
   * @param  object  A FlipClock.Factory object
   * @param  int     An integer use to select the correct digit
   * @param  object  An object to override the default properties
   */

		constructor: function constructor(factory, digit, options) {
			this.factory = factory;
			this.digit = digit;
			this.lastDigit = digit;
			this.$el = this.createList();

			// Depcrated support of the $obj property.
			this.$obj = this.$el;

			if (digit > 0) {
				this.select(digit);
			}

			this.factory.$el.append(this.$el);
		},

		/**
   * Select the digit in the list
   *
   * @param  int  A digit 0-9
   */

		select: function select(digit) {
			if (typeof digit === "undefined") {
				digit = this.digit;
			} else {
				this.digit = digit;
			}

			if (this.digit != this.lastDigit) {
				var $delete = this.$el.find('.' + this.classes.before).removeClass(this.classes.before);

				this.$el.find('.' + this.classes.active).removeClass(this.classes.active).addClass(this.classes.before);

				this.appendListItem(this.classes.active, this.digit);

				$delete.remove();

				this.lastDigit = this.digit;
			}
		},

		/**
   * Adds the play class to the DOM object
   */

		play: function play() {
			this.$el.addClass(this.factory.classes.play);
		},

		/**
   * Removes the play class to the DOM object
   */

		stop: function stop() {
			var t = this;

			setTimeout(function () {
				t.$el.removeClass(t.factory.classes.play);
			}, this.factory.timer.interval);
		},

		/**
   * Creates the list item HTML and returns as a string
   */

		createListItem: function createListItem(css, value) {
			return ['<li class="' + (css ? css : '') + '">', '<a href="#">', '<div class="up">', '<div class="shadow"></div>', '<div class="inn">' + (value ? value : '') + '</div>', '</div>', '<div class="down">', '<div class="shadow"></div>', '<div class="inn">' + (value ? value : '') + '</div>', '</div>', '</a>', '</li>'].join('');
		},

		/**
   * Append the list item to the parent DOM node
   */

		appendListItem: function appendListItem(css, value) {
			var html = this.createListItem(css, value);

			this.$el.append(html);
		},

		/**
   * Create the list of digits and appends it to the DOM object
   */

		createList: function createList() {

			var lastDigit = this.getPrevDigit() ? this.getPrevDigit() : this.digit;

			var html = $(['<ul class="' + this.classes.flip + ' ' + (this.factory.running ? this.factory.classes.play : '') + '">', this.createListItem(this.classes.before, lastDigit), this.createListItem(this.classes.active, this.digit), '</ul>'].join(''));

			return html;
		},

		getNextDigit: function getNextDigit() {
			return this.digit == 9 ? 0 : this.digit + 1;
		},

		getPrevDigit: function getPrevDigit() {
			return this.digit == 0 ? 9 : this.digit - 1;
		}

	});
})(jQuery);

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * Capitalize the first letter in a string
  *
  * @return string
  */

	String.prototype.ucfirst = function () {
		return this.substr(0, 1).toUpperCase() + this.substr(1);
	};

	/**
  * jQuery helper method
  *
  * @param  int     An integer used to start the clock (no. seconds)
  * @param  object  An object of properties to override the default
  */

	$.fn.FlipClock = function (digit, options) {
		return new _FlipClock($(this), digit, options);
	};

	/**
  * jQuery helper method
  *
  * @param  int     An integer used to start the clock (no. seconds)
  * @param  object  An object of properties to override the default
  */

	$.fn.flipClock = function (digit, options) {
		return $.fn.FlipClock(digit, options);
	};
})(jQuery);

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * The FlipClock Time class is used to manage all the time
  * calculations.
  *
  * @param 	object  A FlipClock.Factory object
  * @param 	mixed   This is the digit used to set the clock. If an
  *				    object is passed, 0 will be used.
  * @param 	object  An object of properties to override the default
  */

	_FlipClock.Time = _FlipClock.Base.extend({

		/**
   * The time (in seconds) or a date object
   */

		time: 0,

		/**
   * The parent FlipClock.Factory object
   */

		factory: false,

		/**
   * The minimum number of digits the clock face must have
   */

		minimumDigits: 0,

		/**
   * Constructor
   *
   * @param  object  A FlipClock.Factory object
   * @param  int     An integer use to select the correct digit
   * @param  object  An object to override the default properties
   */

		constructor: function constructor(factory, time, options) {
			if ((typeof options === "undefined" ? "undefined" : _typeof(options)) != "object") {
				options = {};
			}

			if (!options.minimumDigits) {
				options.minimumDigits = factory.minimumDigits;
			}

			this.base(options);
			this.factory = factory;

			if (time) {
				this.time = time;
			}
		},

		/**
   * Convert a string or integer to an array of digits
   *
   * @param   mixed  String or Integer of digits
   * @return  array  An array of digits
   */

		convertDigitsToArray: function convertDigitsToArray(str) {
			var data = [];

			str = str.toString();

			for (var x = 0; x < str.length; x++) {
				if (str[x].match(/^\d*$/g)) {
					data.push(str[x]);
				}
			}

			return data;
		},

		/**
   * Get a specific digit from the time integer
   *
   * @param   int    The specific digit to select from the time
   * @return  mixed  Returns FALSE if no digit is found, otherwise
   *				   the method returns the defined digit
   */

		digit: function digit(i) {
			var timeStr = this.toString();
			var length = timeStr.length;

			if (timeStr[length - i]) {
				return timeStr[length - i];
			}

			return false;
		},

		/**
   * Formats any array of digits into a valid array of digits
   *
   * @param   mixed  An array of digits
   * @return  array  An array of digits
   */

		digitize: function digitize(obj) {
			var data = [];

			$.each(obj, function (i, value) {
				value = value.toString();

				if (value.length == 1) {
					value = '0' + value;
				}

				for (var x = 0; x < value.length; x++) {
					data.push(value.charAt(x));
				}
			});

			if (data.length > this.minimumDigits) {
				this.minimumDigits = data.length;
			}

			if (this.minimumDigits > data.length) {
				for (var x = data.length; x < this.minimumDigits; x++) {
					data.unshift('0');
				}
			}

			return data;
		},

		/**
   * Gets a new Date object for the current time
   *
   * @return  array  Returns a Date object
   */

		getDateObject: function getDateObject() {
			if (this.time instanceof Date) {
				return this.time;
			}

			return new Date(new Date().getTime() + this.getTimeSeconds() * 1000);
		},

		/**
   * Gets a digitized daily counter
   *
   * @return  object  Returns a digitized object
   */

		getDayCounter: function getDayCounter(includeSeconds) {
			var digits = [this.getDays(), this.getHours(true), this.getMinutes(true)];

			if (includeSeconds) {
				digits.push(this.getSeconds(true));
			}

			return this.digitize(digits);
		},

		/**
   * Gets number of days
   *
   * @param   bool  Should perform a modulus? If not sent, then no.
   * @return  int   Retuns a floored integer
   */

		getDays: function getDays(mod) {
			var days = this.getTimeSeconds() / 60 / 60 / 24;

			if (mod) {
				days = days % 7;
			}

			return Math.floor(days);
		},

		/**
   * Gets an hourly breakdown
   *
   * @return  object  Returns a digitized object
   */

		getHourCounter: function getHourCounter() {
			var obj = this.digitize([this.getHours(), this.getMinutes(true), this.getSeconds(true)]);

			return obj;
		},

		/**
   * Gets an hourly breakdown
   *
   * @return  object  Returns a digitized object
   */

		getHourly: function getHourly() {
			return this.getHourCounter();
		},

		/**
   * Gets number of hours
   *
   * @param   bool  Should perform a modulus? If not sent, then no.
   * @return  int   Retuns a floored integer
   */

		getHours: function getHours(mod) {
			var hours = this.getTimeSeconds() / 60 / 60;

			if (mod) {
				hours = hours % 24;
			}

			return Math.floor(hours);
		},

		/**
   * Gets the twenty-four hour time
   *
   * @return  object  returns a digitized object
   */

		getMilitaryTime: function getMilitaryTime(date, showSeconds) {
			if (typeof showSeconds === "undefined") {
				showSeconds = true;
			}

			if (!date) {
				date = this.getDateObject();
			}

			var data = [date.getHours(), date.getMinutes()];

			if (showSeconds === true) {
				data.push(date.getSeconds());
			}

			return this.digitize(data);
		},

		/**
   * Gets number of minutes
   *
   * @param   bool  Should perform a modulus? If not sent, then no.
   * @return  int   Retuns a floored integer
   */

		getMinutes: function getMinutes(mod) {
			var minutes = this.getTimeSeconds() / 60;

			if (mod) {
				minutes = minutes % 60;
			}

			return Math.floor(minutes);
		},

		/**
   * Gets a minute breakdown
   */

		getMinuteCounter: function getMinuteCounter() {
			var obj = this.digitize([this.getMinutes(), this.getSeconds(true)]);

			return obj;
		},

		/**
   * Gets time count in seconds regardless of if targetting date or not.
   *
   * @return  int   Returns a floored integer
   */

		getTimeSeconds: function getTimeSeconds(date) {
			if (!date) {
				date = new Date();
			}

			if (this.time instanceof Date) {
				if (this.factory.countdown) {
					return Math.max(this.time.getTime() / 1000 - date.getTime() / 1000, 0);
				} else {
					return date.getTime() / 1000 - this.time.getTime() / 1000;
				}
			} else {
				return this.time;
			}
		},

		/**
   * Gets the current twelve hour time
   *
   * @return  object  Returns a digitized object
   */

		getTime: function getTime(date, showSeconds) {
			if (typeof showSeconds === "undefined") {
				showSeconds = true;
			}

			if (!date) {
				date = this.getDateObject();
			}

			console.log(date);

			var hours = date.getHours();
			var merid = hours > 12 ? 'PM' : 'AM';
			var data = [hours > 12 ? hours - 12 : hours === 0 ? 12 : hours, date.getMinutes()];

			if (showSeconds === true) {
				data.push(date.getSeconds());
			}

			return this.digitize(data);
		},

		/**
   * Gets number of seconds
   *
   * @param   bool  Should perform a modulus? If not sent, then no.
   * @return  int   Retuns a ceiled integer
   */

		getSeconds: function getSeconds(mod) {
			var seconds = this.getTimeSeconds();

			if (mod) {
				if (seconds == 60) {
					seconds = 0;
				} else {
					seconds = seconds % 60;
				}
			}

			return Math.ceil(seconds);
		},

		/**
   * Gets number of weeks
   *
   * @param   bool  Should perform a modulus? If not sent, then no.
   * @return  int   Retuns a floored integer
   */

		getWeeks: function getWeeks(mod) {
			var weeks = this.getTimeSeconds() / 60 / 60 / 24 / 7;

			if (mod) {
				weeks = weeks % 52;
			}

			return Math.floor(weeks);
		},

		/**
   * Removes a specific number of leading zeros from the array.
   * This method prevents you from removing too many digits, even
   * if you try.
   *
   * @param   int    Total number of digits to remove
   * @return  array  An array of digits
   */

		removeLeadingZeros: function removeLeadingZeros(totalDigits, digits) {
			var total = 0;
			var newArray = [];

			$.each(digits, function (i, digit) {
				if (i < totalDigits) {
					total += parseInt(digits[i], 10);
				} else {
					newArray.push(digits[i]);
				}
			});

			if (total === 0) {
				return newArray;
			}

			return digits;
		},

		/**
   * Adds X second to the current time
   */

		addSeconds: function addSeconds(x) {
			if (this.time instanceof Date) {
				this.time.setSeconds(this.time.getSeconds() + x);
			} else {
				this.time += x;
			}
		},

		/**
   * Adds 1 second to the current time
   */

		addSecond: function addSecond() {
			this.addSeconds(1);
		},

		/**
   * Substracts X seconds from the current time
   */

		subSeconds: function subSeconds(x) {
			if (this.time instanceof Date) {
				this.time.setSeconds(this.time.getSeconds() - x);
			} else {
				this.time -= x;
			}
		},

		/**
   * Substracts 1 second from the current time
   */

		subSecond: function subSecond() {
			this.subSeconds(1);
		},

		/**
   * Converts the object to a human readable string
   */

		toString: function toString() {
			return this.getTimeSeconds().toString();
		}

		/*
  getYears: function() {
  	return Math.floor(this.time / 60 / 60 / 24 / 7 / 52);
  },
  	getDecades: function() {
  	return Math.floor(this.getWeeks() / 10);
  }*/
	});
})(jQuery);

/*jshint smarttabs:true */

/**
 * FlipClock.js
 *
 * @author     Justin Kimbrell
 * @copyright  2013 - Objective HTML, LLC
 * @licesnse   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {

	"use strict";

	/**
  * The FlipClock.Timer object managers the JS timers
  *
  * @param	object  The parent FlipClock.Factory object
  * @param	object  Override the default options
  */

	_FlipClock.Timer = _FlipClock.Base.extend({

		/**
   * Callbacks
   */

		callbacks: {
			destroy: false,
			create: false,
			init: false,
			interval: false,
			start: false,
			stop: false,
			reset: false
		},

		/**
   * FlipClock timer count (how many intervals have passed)
   */

		count: 0,

		/**
   * The parent FlipClock.Factory object
   */

		factory: false,

		/**
   * Timer interval (1 second by default)
   */

		interval: 1000,

		/**
   * The rate of the animation in milliseconds (not currently in use)
   */

		animationRate: 1000,

		/**
   * Constructor
   *
   * @return	void
   */

		constructor: function constructor(factory, options) {
			this.base(options);
			this.factory = factory;
			this.callback(this.callbacks.init);
			this.callback(this.callbacks.create);
		},

		/**
   * This method gets the elapsed the time as an interger
   *
   * @return	void
   */

		getElapsed: function getElapsed() {
			return this.count * this.interval;
		},

		/**
   * This method gets the elapsed the time as a Date object
   *
   * @return	void
   */

		getElapsedTime: function getElapsedTime() {
			return new Date(this.time + this.getElapsed());
		},

		/**
   * This method is resets the timer
   *
   * @param 	callback  This method resets the timer back to 0
   * @return	void
   */

		reset: function reset(callback) {
			clearInterval(this.timer);
			this.count = 0;
			this._setInterval(callback);
			this.callback(this.callbacks.reset);
		},

		/**
   * This method is starts the timer
   *
   * @param 	callback  A function that is called once the timer is destroyed
   * @return	void
   */

		start: function start(callback) {
			this.factory.running = true;
			this._createTimer(callback);
			this.callback(this.callbacks.start);
		},

		/**
   * This method is stops the timer
   *
   * @param 	callback  A function that is called once the timer is destroyed
   * @return	void
   */

		stop: function stop(callback) {
			this.factory.running = false;
			this._clearInterval(callback);
			this.callback(this.callbacks.stop);
			this.callback(callback);
		},

		/**
   * Clear the timer interval
   *
   * @return	void
   */

		_clearInterval: function _clearInterval() {
			clearInterval(this.timer);
		},

		/**
   * Create the timer object
   *
   * @param 	callback  A function that is called once the timer is created
   * @return	void
   */

		_createTimer: function _createTimer(callback) {
			this._setInterval(callback);
		},

		/**
   * Destroy the timer object
   *
   * @param 	callback  A function that is called once the timer is destroyed
   * @return	void
   */

		_destroyTimer: function _destroyTimer(callback) {
			this._clearInterval();
			this.timer = false;
			this.callback(callback);
			this.callback(this.callbacks.destroy);
		},

		/**
   * This method is called each time the timer interval is ran
   *
   * @param 	callback  A function that is called once the timer is destroyed
   * @return	void
   */

		_interval: function _interval(callback) {
			this.callback(this.callbacks.interval);
			this.callback(callback);
			this.count++;
		},

		/**
   * This sets the timer interval
   *
   * @param 	callback  A function that is called once the timer is destroyed
   * @return	void
   */

		_setInterval: function _setInterval(callback) {
			var t = this;

			t._interval(callback);

			t.timer = setInterval(function () {
				t._interval(callback);
			}, this.interval);
		}

	});
})(jQuery);

(function ($) {

	/**
  * Twenty-Four Hour Clock Face
  *
  * This class will generate a twenty-four our clock for FlipClock.js
  *
  * @param  object  The parent FlipClock.Factory object
  * @param  object  An object of properties to override the default
  */

	_FlipClock.TwentyFourHourClockFace = _FlipClock.Face.extend({

		/**
   * Constructor
   *
   * @param  object  The parent FlipClock.Factory object
   * @param  object  An object of properties to override the default
   */

		constructor: function constructor(factory, options) {
			this.base(factory, options);
		},

		/**
   * Build the clock face
   *
   * @param  object  Pass the time that should be used to display on the clock.
   */

		build: function build(time) {
			var t = this;
			var children = this.factory.$el.find('ul');

			if (!this.factory.time.time) {
				this.factory.original = new Date();

				this.factory.time = new _FlipClock.Time(this.factory, this.factory.original);
			}

			var time = time ? time : this.factory.time.getMilitaryTime(false, this.showSeconds);

			if (time.length > children.length) {
				$.each(time, function (i, digit) {
					t.createList(digit);
				});
			}

			this.createDivider();
			this.createDivider();

			$(this.dividers[0]).insertBefore(this.lists[this.lists.length - 2].$el);
			$(this.dividers[1]).insertBefore(this.lists[this.lists.length - 4].$el);

			this.base();
		},

		/**
   * Flip the clock face
   */

		flip: function flip(time, doNotAddPlayClass) {
			this.autoIncrement();

			time = time ? time : this.factory.time.getMilitaryTime(false, this.showSeconds);

			this.base(time, doNotAddPlayClass);
		}

	});
})(jQuery);
(function ($) {

	/**
  * Counter Clock Face
  *
  * This class will generate a generice flip counter. The timer has been
  * disabled. clock.increment() and clock.decrement() have been added.
  *
  * @param  object  The parent FlipClock.Factory object
  * @param  object  An object of properties to override the default
  */

	_FlipClock.CounterFace = _FlipClock.Face.extend({

		/**
   * Tells the counter clock face if it should auto-increment
   */

		shouldAutoIncrement: false,

		/**
   * Constructor
   *
   * @param  object  The parent FlipClock.Factory object
   * @param  object  An object of properties to override the default
   */

		constructor: function constructor(factory, options) {

			if ((typeof options === "undefined" ? "undefined" : _typeof(options)) != "object") {
				options = {};
			}

			factory.autoStart = options.autoStart ? true : false;

			if (options.autoStart) {
				this.shouldAutoIncrement = true;
			}

			factory.increment = function () {
				factory.countdown = false;
				factory.setTime(factory.getTime().getTimeSeconds() + 1);
			};

			factory.decrement = function () {
				factory.countdown = true;
				var time = factory.getTime().getTimeSeconds();
				if (time > 0) {
					factory.setTime(time - 1);
				}
			};

			factory.setValue = function (digits) {
				factory.setTime(digits);
			};

			factory.setCounter = function (digits) {
				factory.setTime(digits);
			};

			this.base(factory, options);
		},

		/**
   * Build the clock face
   */

		build: function build() {
			var t = this;
			var children = this.factory.$el.find('ul');
			var time = this.factory.getTime().digitize([this.factory.getTime().time]);

			if (time.length > children.length) {
				$.each(time, function (i, digit) {
					var list = t.createList(digit);

					list.select(digit);
				});
			}

			$.each(this.lists, function (i, list) {
				list.play();
			});

			this.base();
		},

		/**
   * Flip the clock face
   */

		flip: function flip(time, doNotAddPlayClass) {
			if (this.shouldAutoIncrement) {
				this.autoIncrement();
			}

			if (!time) {
				time = this.factory.getTime().digitize([this.factory.getTime().time]);
			}

			this.base(time, doNotAddPlayClass);
		},

		/**
   * Reset the clock face
   */

		reset: function reset() {
			this.factory.time = new _FlipClock.Time(this.factory, this.factory.original ? Math.round(this.factory.original) : 0);

			this.flip();
		}
	});
})(jQuery);
(function ($) {

	/**
  * Daily Counter Clock Face
  *
  * This class will generate a daily counter for FlipClock.js. A
  * daily counter will track days, hours, minutes, and seconds. If
  * the number of available digits is exceeded in the count, a new
  * digit will be created.
  *
  * @param  object  The parent FlipClock.Factory object
  * @param  object  An object of properties to override the default
  */

	_FlipClock.DailyCounterFace = _FlipClock.Face.extend({

		showSeconds: true,

		/**
   * Constructor
   *
   * @param  object  The parent FlipClock.Factory object
   * @param  object  An object of properties to override the default
   */

		constructor: function constructor(factory, options) {
			this.base(factory, options);
		},

		/**
   * Build the clock face
   */

		build: function build(time) {
			var t = this;
			var children = this.factory.$el.find('ul');
			var offset = 0;

			time = time ? time : this.factory.time.getDayCounter(this.showSeconds);

			if (time.length > children.length) {
				$.each(time, function (i, digit) {
					t.createList(digit);
				});
			}

			if (this.showSeconds) {
				$(this.createDivider('Seconds')).insertBefore(this.lists[this.lists.length - 2].$el);
			} else {
				offset = 2;
			}

			$(this.createDivider('Minutes')).insertBefore(this.lists[this.lists.length - 4 + offset].$el);
			$(this.createDivider('Hours')).insertBefore(this.lists[this.lists.length - 6 + offset].$el);
			$(this.createDivider('Days', true)).insertBefore(this.lists[0].$el);

			this.base();
		},

		/**
   * Flip the clock face
   */

		flip: function flip(time, doNotAddPlayClass) {
			if (!time) {
				time = this.factory.time.getDayCounter(this.showSeconds);
			}

			this.autoIncrement();

			this.base(time, doNotAddPlayClass);
		}

	});
})(jQuery);
(function ($) {

	/**
  * Hourly Counter Clock Face
  *
  * This class will generate an hourly counter for FlipClock.js. An
  * hour counter will track hours, minutes, and seconds. If number of
  * available digits is exceeded in the count, a new digit will be
  * created.
  *
  * @param  object  The parent FlipClock.Factory object
  * @param  object  An object of properties to override the default
  */

	_FlipClock.HourlyCounterFace = _FlipClock.Face.extend({

		// clearExcessDigits: true,

		/**
   * Constructor
   *
   * @param  object  The parent FlipClock.Factory object
   * @param  object  An object of properties to override the default
   */

		constructor: function constructor(factory, options) {
			this.base(factory, options);
		},

		/**
   * Build the clock face
   */

		build: function build(excludeHours, time) {
			var t = this;
			var children = this.factory.$el.find('ul');

			time = time ? time : this.factory.time.getHourCounter();

			if (time.length > children.length) {
				$.each(time, function (i, digit) {
					t.createList(digit);
				});
			}

			$(this.createDivider('Seconds')).insertBefore(this.lists[this.lists.length - 2].$el);
			$(this.createDivider('Minutes')).insertBefore(this.lists[this.lists.length - 4].$el);

			if (!excludeHours) {
				$(this.createDivider('Hours', true)).insertBefore(this.lists[0].$el);
			}

			this.base();
		},

		/**
   * Flip the clock face
   */

		flip: function flip(time, doNotAddPlayClass) {
			if (!time) {
				time = this.factory.time.getHourCounter();
			}

			this.autoIncrement();

			this.base(time, doNotAddPlayClass);
		},

		/**
   * Append a newly created list to the clock
   */

		appendDigitToClock: function appendDigitToClock(obj) {
			this.base(obj);

			this.dividers[0].insertAfter(this.dividers[0].next());
		}

	});
})(jQuery);
(function ($) {

	/**
  * Minute Counter Clock Face
  *
  * This class will generate a minute counter for FlipClock.js. A
  * minute counter will track minutes and seconds. If an hour is
  * reached, the counter will reset back to 0. (4 digits max)
  *
  * @param  object  The parent FlipClock.Factory object
  * @param  object  An object of properties to override the default
  */

	_FlipClock.MinuteCounterFace = _FlipClock.HourlyCounterFace.extend({

		clearExcessDigits: false,

		/**
   * Constructor
   *
   * @param  object  The parent FlipClock.Factory object
   * @param  object  An object of properties to override the default
   */

		constructor: function constructor(factory, options) {
			this.base(factory, options);
		},

		/**
   * Build the clock face
   */

		build: function build() {
			this.base(true, this.factory.time.getMinuteCounter());
		},

		/**
   * Flip the clock face
   */

		flip: function flip(time, doNotAddPlayClass) {
			if (!time) {
				time = this.factory.time.getMinuteCounter();
			}

			this.base(time, doNotAddPlayClass);
		}

	});
})(jQuery);
(function ($) {

	/**
  * Twelve Hour Clock Face
  *
  * This class will generate a twelve hour clock for FlipClock.js
  *
  * @param  object  The parent FlipClock.Factory object
  * @param  object  An object of properties to override the default
  */

	_FlipClock.TwelveHourClockFace = _FlipClock.TwentyFourHourClockFace.extend({

		/**
   * The meridium jQuery DOM object
   */

		meridium: false,

		/**
   * The meridium text as string for easy access
   */

		meridiumText: 'AM',

		/**
   * Build the clock face
   *
   * @param  object  Pass the time that should be used to display on the clock.
   */

		build: function build() {
			var t = this;

			var time = this.factory.time.getTime(false, this.showSeconds);

			this.base(time);
			this.meridiumText = this.getMeridium();
			this.meridium = $(['<ul class="flip-clock-meridium">', '<li>', '<a href="#">' + this.meridiumText + '</a>', '</li>', '</ul>'].join(''));

			this.meridium.insertAfter(this.lists[this.lists.length - 1].$el);
		},

		/**
   * Flip the clock face
   */

		flip: function flip(time, doNotAddPlayClass) {
			if (this.meridiumText != this.getMeridium()) {
				this.meridiumText = this.getMeridium();
				this.meridium.find('a').html(this.meridiumText);
			}
			this.base(this.factory.time.getTime(false, this.showSeconds), doNotAddPlayClass);
		},

		/**
   * Get the current meridium
   *
   * @return  string  Returns the meridium (AM|PM)
   */

		getMeridium: function getMeridium() {
			return new Date().getHours() >= 12 ? 'PM' : 'AM';
		},

		/**
   * Is it currently in the post-medirium?
   *
   * @return  bool  Returns true or false
   */

		isPM: function isPM() {
			return this.getMeridium() == 'PM' ? true : false;
		},

		/**
   * Is it currently before the post-medirium?
   *
   * @return  bool  Returns true or false
   */

		isAM: function isAM() {
			return this.getMeridium() == 'AM' ? true : false;
		}

	});
})(jQuery);
(function ($) {

	/**
  * FlipClock Arabic Language Pack
  *
  * This class will be used to translate tokens into the Arabic language.
  *
  */

	_FlipClock.Lang.Arabic = {

		'years': 'سنوات',
		'months': 'شهور',
		'days': 'أيام',
		'hours': 'ساعات',
		'minutes': 'دقائق',
		'seconds': 'ثواني'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['ar'] = _FlipClock.Lang.Arabic;
	_FlipClock.Lang['ar-ar'] = _FlipClock.Lang.Arabic;
	_FlipClock.Lang['arabic'] = _FlipClock.Lang.Arabic;
})(jQuery);
(function ($) {

	/**
  * FlipClock Danish Language Pack
  *
  * This class will used to translate tokens into the Danish language.
  *
  */

	_FlipClock.Lang.Danish = {

		'years': 'År',
		'months': 'Måneder',
		'days': 'Dage',
		'hours': 'Timer',
		'minutes': 'Minutter',
		'seconds': 'Sekunder'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['da'] = _FlipClock.Lang.Danish;
	_FlipClock.Lang['da-dk'] = _FlipClock.Lang.Danish;
	_FlipClock.Lang['danish'] = _FlipClock.Lang.Danish;
})(jQuery);
(function ($) {

	/**
  * FlipClock German Language Pack
  *
  * This class will used to translate tokens into the German language.
  *
  */

	_FlipClock.Lang.German = {

		'years': 'Jahre',
		'months': 'Monate',
		'days': 'Tage',
		'hours': 'Stunden',
		'minutes': 'Minuten',
		'seconds': 'Sekunden'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['de'] = _FlipClock.Lang.German;
	_FlipClock.Lang['de-de'] = _FlipClock.Lang.German;
	_FlipClock.Lang['german'] = _FlipClock.Lang.German;
})(jQuery);
(function ($) {

	/**
  * FlipClock English Language Pack
  *
  * This class will used to translate tokens into the English language.
  *
  */

	_FlipClock.Lang.English = {

		'years': 'Years',
		'months': 'Months',
		'days': 'Days',
		'hours': 'Hours',
		'minutes': 'Minutes',
		'seconds': 'Seconds'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['en'] = _FlipClock.Lang.English;
	_FlipClock.Lang['en-us'] = _FlipClock.Lang.English;
	_FlipClock.Lang['english'] = _FlipClock.Lang.English;
})(jQuery);
(function ($) {

	/**
  * FlipClock Spanish Language Pack
  *
  * This class will used to translate tokens into the Spanish language.
  *
  */

	_FlipClock.Lang.Spanish = {

		'years': 'A&#241;os',
		'months': 'Meses',
		'days': 'D&#205;as',
		'hours': 'Horas',
		'minutes': 'Minutos',
		'seconds': 'Segundo'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['es'] = _FlipClock.Lang.Spanish;
	_FlipClock.Lang['es-es'] = _FlipClock.Lang.Spanish;
	_FlipClock.Lang['spanish'] = _FlipClock.Lang.Spanish;
})(jQuery);
(function ($) {

	/**
  * FlipClock Finnish Language Pack
  *
  * This class will used to translate tokens into the Finnish language.
  *
  */

	_FlipClock.Lang.Finnish = {

		'years': 'Vuotta',
		'months': 'Kuukautta',
		'days': 'Päivää',
		'hours': 'Tuntia',
		'minutes': 'Minuuttia',
		'seconds': 'Sekuntia'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['fi'] = _FlipClock.Lang.Finnish;
	_FlipClock.Lang['fi-fi'] = _FlipClock.Lang.Finnish;
	_FlipClock.Lang['finnish'] = _FlipClock.Lang.Finnish;
})(jQuery);

(function ($) {

	/**
  * FlipClock Canadian French Language Pack
  *
  * This class will used to translate tokens into the Canadian French language.
  *
  */

	_FlipClock.Lang.French = {

		'years': 'Ans',
		'months': 'Mois',
		'days': 'Jours',
		'hours': 'Heures',
		'minutes': 'Minutes',
		'seconds': 'Secondes'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['fr'] = _FlipClock.Lang.French;
	_FlipClock.Lang['fr-ca'] = _FlipClock.Lang.French;
	_FlipClock.Lang['french'] = _FlipClock.Lang.French;
})(jQuery);

(function ($) {

	/**
  * FlipClock Italian Language Pack
  *
  * This class will used to translate tokens into the Italian language.
  *
  */

	_FlipClock.Lang.Italian = {

		'years': 'Anni',
		'months': 'Mesi',
		'days': 'Giorni',
		'hours': 'Ore',
		'minutes': 'Minuti',
		'seconds': 'Secondi'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['it'] = _FlipClock.Lang.Italian;
	_FlipClock.Lang['it-it'] = _FlipClock.Lang.Italian;
	_FlipClock.Lang['italian'] = _FlipClock.Lang.Italian;
})(jQuery);

(function ($) {

	/**
  * FlipClock Latvian Language Pack
  *
  * This class will used to translate tokens into the Latvian language.
  *
  */

	_FlipClock.Lang.Latvian = {

		'years': 'Gadi',
		'months': 'Mēneši',
		'days': 'Dienas',
		'hours': 'Stundas',
		'minutes': 'Minūtes',
		'seconds': 'Sekundes'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['lv'] = _FlipClock.Lang.Latvian;
	_FlipClock.Lang['lv-lv'] = _FlipClock.Lang.Latvian;
	_FlipClock.Lang['latvian'] = _FlipClock.Lang.Latvian;
})(jQuery);
(function ($) {

	/**
  * FlipClock Dutch Language Pack
  *
  * This class will used to translate tokens into the Dutch language.
  */

	_FlipClock.Lang.Dutch = {

		'years': 'Jaren',
		'months': 'Maanden',
		'days': 'Dagen',
		'hours': 'Uren',
		'minutes': 'Minuten',
		'seconds': 'Seconden'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['nl'] = _FlipClock.Lang.Dutch;
	_FlipClock.Lang['nl-be'] = _FlipClock.Lang.Dutch;
	_FlipClock.Lang['dutch'] = _FlipClock.Lang.Dutch;
})(jQuery);

(function ($) {

	/**
  * FlipClock Norwegian-Bokmål Language Pack
  *
  * This class will used to translate tokens into the Norwegian language.
  *
  */

	_FlipClock.Lang.Norwegian = {

		'years': 'År',
		'months': 'Måneder',
		'days': 'Dager',
		'hours': 'Timer',
		'minutes': 'Minutter',
		'seconds': 'Sekunder'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['no'] = _FlipClock.Lang.Norwegian;
	_FlipClock.Lang['nb'] = _FlipClock.Lang.Norwegian;
	_FlipClock.Lang['no-nb'] = _FlipClock.Lang.Norwegian;
	_FlipClock.Lang['norwegian'] = _FlipClock.Lang.Norwegian;
})(jQuery);

(function ($) {

	/**
  * FlipClock Portuguese Language Pack
  *
  * This class will used to translate tokens into the Portuguese language.
  *
  */

	_FlipClock.Lang.Portuguese = {

		'years': 'Anos',
		'months': 'Meses',
		'days': 'Dias',
		'hours': 'Horas',
		'minutes': 'Minutos',
		'seconds': 'Segundos'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['pt'] = _FlipClock.Lang.Portuguese;
	_FlipClock.Lang['pt-br'] = _FlipClock.Lang.Portuguese;
	_FlipClock.Lang['portuguese'] = _FlipClock.Lang.Portuguese;
})(jQuery);
(function ($) {

	/**
  * FlipClock Russian Language Pack
  *
  * This class will used to translate tokens into the Russian language.
  *
  */

	_FlipClock.Lang.Russian = {

		'years': 'лет',
		'months': 'месяцев',
		'days': 'дней',
		'hours': 'часов',
		'minutes': 'минут',
		'seconds': 'секунд'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['ru'] = _FlipClock.Lang.Russian;
	_FlipClock.Lang['ru-ru'] = _FlipClock.Lang.Russian;
	_FlipClock.Lang['russian'] = _FlipClock.Lang.Russian;
})(jQuery);
(function ($) {

	/**
  * FlipClock Swedish Language Pack
  *
  * This class will used to translate tokens into the Swedish language.
  *
  */

	_FlipClock.Lang.Swedish = {

		'years': 'År',
		'months': 'Månader',
		'days': 'Dagar',
		'hours': 'Timmar',
		'minutes': 'Minuter',
		'seconds': 'Sekunder'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['sv'] = _FlipClock.Lang.Swedish;
	_FlipClock.Lang['sv-se'] = _FlipClock.Lang.Swedish;
	_FlipClock.Lang['swedish'] = _FlipClock.Lang.Swedish;
})(jQuery);

(function ($) {

	/**
  * FlipClock Chinese Language Pack
  *
  * This class will used to translate tokens into the Chinese language.
  *
  */

	_FlipClock.Lang.Chinese = {

		'years': '年',
		'months': '月',
		'days': '日',
		'hours': '时',
		'minutes': '分',
		'seconds': '秒'

	};

	/* Create various aliases for convenience */

	_FlipClock.Lang['zh'] = _FlipClock.Lang.Chinese;
	_FlipClock.Lang['zh-cn'] = _FlipClock.Lang.Chinese;
	_FlipClock.Lang['chinese'] = _FlipClock.Lang.Chinese;
})(jQuery);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return glossaryConnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return termDetailConnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);



var glossaryConnect = function glossaryConnect(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function () {
    return {
      glossaryFetch: '/identity-glossary/api/terms'
    };
  })(Component);
};

var termDetailConnect = function termDetailConnect(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function (props) {
    return {
      termDetailFetch: '/identity-glossary/api/' + props.route
    };
  })(Component);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  glossaryConnect: glossaryConnect,
  termDetailConnect: termDetailConnect
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Glossary__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Glossary__["a"]; });





/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setGlossaryList;
/* harmony export (immutable) */ __webpack_exports__["a"] = findById;
/* harmony export (immutable) */ __webpack_exports__["c"] = objectIsEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function setGlossaryList(list) {
  var colors = ['blue', 'yellow', 'orange', 'green', 'purple'];
  var glossary = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(list, function (item) {
    return item.letter;
  });
  var index = 0;
  var newList = [];
  __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(glossary, function (value, key) {
    index = index === 5 ? 0 : index;
    newList.push({
      letter: key,
      items: value,
      color: colors[index]
    });
    index = index + 1;
  });
  return newList;
}

function findById(list, id) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(list, function (item) {
    return item.id === id;
  });
}

function objectIsEmpty(o) {
  return Object.keys(o).length === 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  setGlossaryList: setGlossaryList,
  findById: findById,
  objectIsEmpty: objectIsEmpty
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newsConnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return announcementsConnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return articlesConnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);



var newsConnect = function newsConnect(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function () {
    return {
      newsFetch: '/press/api/news'
    };
  })(Component);
};

var announcementsConnect = function announcementsConnect(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function () {
    return {
      announcementsFetch: '/press/api/announcements'
    };
  })(Component);
};

var articlesConnect = function articlesConnect(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function (props) {
    return {
      articlesFetch: '/press/api/' + props.route
    };
  })(Component);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  newsConnect: newsConnect,
  announcementsConnect: announcementsConnect,
  articlesConnect: articlesConnect
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Details__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Details__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Articles__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Articles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__App__["a"]; });







/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__(692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Resource__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__App__["a"]; });





/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isSafariBrowser; });
/* harmony export (immutable) */ __webpack_exports__["b"] = scrollToDOMElement;
/* eslint-env browser */
var isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function scrollToDOMElement(node) {
  if (node) node.scrollIntoView();
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  isSafariBrowser: isSafariBrowser,
  scrollToDOMElement: scrollToDOMElement
});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2017 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.0
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule");
var Queue = _dereq_("./queue");
var util = _dereq_("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

},{"./queue":26,"./schedule":29,"./util":36}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise":22}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var args = [].slice.call(arguments, 1);;
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":36}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":36}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util");
var getKeys = _dereq_("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":13,"./util":36}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = _dereq_("./errors").Warning;
var util = _dereq_("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (true ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

},{"./errors":12,"./util":36}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],11:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],12:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":13,"./util":36}],13:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],14:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
var util = _dereq_("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret === NEXT_FILTER) {
            return ret;
        } else if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};


Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

Promise.prototype.tapCatch = function (handlerOrPredicate) {
    var len = arguments.length;
    if(len === 1) {
        return this._passThrough(handlerOrPredicate,
                                 1,
                                 undefined,
                                 finallyHandler);
    } else {
         var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(new TypeError(
                    "tapCatch statement predicate: "
                    + "expecting an object but got " + util.classString(item)
                ));
            }
        }
        catchInstances.length = j;
        var handler = arguments[i];
        return this._passThrough(catchFilter(catchInstances, handler, this),
                                 1,
                                 undefined,
                                 finallyHandler);
    }

};

return PassThroughHandlerContext;
};

},{"./catch_filter":7,"./util":36}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = _dereq_("./errors");
var TypeError = errors.TypeError;
var util = _dereq_("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":12,"./util":36}],17:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = _dereq_("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var args = [].slice.call(arguments);;
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":36}],18:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":36}],19:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":36}],20:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors");
var OperationalError = errors.OperationalError;
var es5 = _dereq_("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var args = [].slice.call(arguments, 1);;
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":12,"./es5":13,"./util":36}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":36}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = _dereq_("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = _dereq_("./es5");
var Async = _dereq_("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = _dereq_("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = _dereq_("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = _dereq_("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);
var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = _dereq_("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (self == null || self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }

}

function Promise(executor) {
    if (executor !== INTERNAL) {
        check(this, executor);
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._resolveFromExecutor(executor);
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("Catch statement predicate: " +
                    "expecting an object but got " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    if (executor === INTERNAL) return;
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
_dereq_("./direct_resolve")(Promise);
_dereq_("./synchronous_inspection")(Promise);
_dereq_("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.5.0";
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./call_get.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
_dereq_('./timers.js')(Promise, INTERNAL, debug);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
_dereq_('./nodeify.js')(Promise);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
_dereq_('./settle.js')(Promise, PromiseArray, debug);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./filter.js')(Promise, INTERNAL);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = _dereq_("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    case -6: return new Map();
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":36}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util");
var nodebackForPromise = _dereq_("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");
var isObject = util.isObject;
var es5 = _dereq_("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, isMap ? -6 : -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":13,"./util":36}],26:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":36}],28:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = _dereq_("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":36}],29:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
            toggleScheduled = true;
            div2.classList.toggle("foo");
        };

        return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":36}],30:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":36}],31:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util");
var RangeError = _dereq_("./errors").RangeError;
var AggregateError = _dereq_("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":12,"./util":36}],32:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],33:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":36}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = _dereq_("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":36}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = _dereq_("./util");
    var TypeError = _dereq_("./errors").TypeError;
    var inherits = _dereq_("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":12,"./util":36}],36:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string";
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5":13}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64), __webpack_require__(56), __webpack_require__(1090).setImmediate))

/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module Dependencies
 */

try {
  var matches = __webpack_require__(253)
} catch (err) {
  var matches = __webpack_require__(253)
}

/**
 * Export `closest`
 */

module.exports = closest

/**
 * Closest
 *
 * @param {Element} el
 * @param {String} selector
 * @param {Element} scope (optional)
 */

function closest (el, selector, scope) {
  scope = scope || document.documentElement;

  // walk up the dom
  while (el && el !== scope) {
    if (matches(el, selector)) return el;
    el = el.parentNode;
  }

  // check scope for match
  return matches(el, selector) ? el : null;
}


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module Dependencies
 */

var debug = __webpack_require__(31)('css');
var set = __webpack_require__(246);
var get = __webpack_require__(243);

/**
 * Expose `css`
 */

module.exports = css;

/**
 * Get and set css values
 *
 * @param {Element} el
 * @param {String|Object} prop
 * @param {Mixed} val
 * @return {Element} el
 * @api public
 */

function css(el, prop, val) {
  if (!el) return;

  if (undefined !== val) {
    var obj = {};
    obj[prop] = val;
    debug('setting styles %j', obj);
    return setStyles(el, obj);
  }

  if ('object' == typeof prop) {
    debug('setting styles %j', prop);
    return setStyles(el, prop);
  }

  debug('getting %s', prop);
  return get(el, prop);
}

/**
 * Set the styles on an element
 *
 * @param {Element} el
 * @param {Object} props
 * @return {Element} el
 */

function setStyles(el, props) {
  for (var prop in props) {
    set(el, prop, props[prop]);
  }

  return el;
}


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module Dependencies
 */

var debug = __webpack_require__(31)('css:computed');
var withinDocument = __webpack_require__(1093);
var styles = __webpack_require__(247);

/**
 * Expose `computed`
 */

module.exports = computed;

/**
 * Get the computed style
 *
 * @param {Element} el
 * @param {String} prop
 * @param {Array} precomputed (optional)
 * @return {Array}
 * @api private
 */

function computed(el, prop, precomputed) {
  var computed = precomputed || styles(el);
  var ret;
  
  if (!computed) return;

  if (computed.getPropertyValue) {
    ret = computed.getPropertyValue(prop) || computed[prop];
  } else {
    ret = computed[prop];
  }

  if ('' === ret && !withinDocument(el)) {
    debug('element not within document, try finding from style attribute');
    var style = __webpack_require__(246);
    ret = style(el, prop);
  }

  debug('computed value of %s: %s', prop, ret);

  // Support: IE
  // IE returns zIndex value as an integer.
  return undefined === ret ? ret : ret + '';
}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module Dependencies
 */

var debug = __webpack_require__(31)('css:css');
var camelcase = __webpack_require__(213);
var computed = __webpack_require__(242);
var property = __webpack_require__(245);

/**
 * Expose `css`
 */

module.exports = css;

/**
 * CSS Normal Transforms
 */

var cssNormalTransform = {
  letterSpacing: 0,
  fontWeight: 400
};

/**
 * Get a CSS value
 *
 * @param {Element} el
 * @param {String} prop
 * @param {Mixed} extra
 * @param {Array} styles
 * @return {String}
 */

function css(el, prop, extra, styles) {
  var hooks = __webpack_require__(244);
  var orig = camelcase(prop);
  var style = el.style;
  var val;

  prop = property(prop, style);
  var hook = hooks[prop] || hooks[orig];

  // If a hook was provided get the computed value from there
  if (hook && hook.get) {
    debug('get hook provided. use that');
    val = hook.get(el, true, extra);
  }

  // Otherwise, if a way to get the computed value exists, use that
  if (undefined == val) {
    debug('fetch the computed value of %s', prop);
    val = computed(el, prop);
  }

  if ('normal' == val && cssNormalTransform[prop]) {
    val = cssNormalTransform[prop];
    debug('normal => %s', val);
  }

  // Return, converting to number if forced or a qualifier was provided and val looks numeric
  if ('' == extra || extra) {
    debug('converting value: %s into a number', val);
    var num = parseFloat(val);
    return true === extra || isNumeric(num) ? num || 0 : val;
  }

  return val;
}

/**
 * Is Numeric
 *
 * @param {Mixed} obj
 * @return {Boolean}
 */

function isNumeric(obj) {
  return !isNan(parseFloat(obj)) && isFinite(obj);
}


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module Dependencies
 */

try {
  var each = __webpack_require__(250);
} catch (err) {
  var each = __webpack_require__(250);
}
var css = __webpack_require__(243);
var cssShow = { position: 'absolute', visibility: 'hidden', display: 'block' };
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
var rnumnonpx = new RegExp( '^(' + pnum + ')(?!px)[a-z%]+$', 'i');
var rnumsplit = new RegExp( '^(' + pnum + ')(.*)$', 'i');
var rdisplayswap = /^(none|table(?!-c[ea]).+)/;
var styles = __webpack_require__(247);
var support = __webpack_require__(248);
var swap = __webpack_require__(714);
var computed = __webpack_require__(242);
var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

/**
 * Height & Width
 */

each(['width', 'height'], function(name) {
  exports[name] = {};

  exports[name].get = function(el, compute, extra) {
    if (!compute) return;
    // certain elements can have dimension info if we invisibly show them
    // however, it must have a current display style that would benefit from this
    return 0 == el.offsetWidth && rdisplayswap.test(css(el, 'display'))
      ? swap(el, cssShow, function() { return getWidthOrHeight(el, name, extra); })
      : getWidthOrHeight(el, name, extra);
  }

  exports[name].set = function(el, val, extra) {
    var styles = extra && styles(el);
    return setPositiveNumber(el, val, extra
      ? augmentWidthOrHeight(el, name, extra, 'border-box' == css(el, 'boxSizing', false, styles), styles)
      : 0
    );
  };

});

/**
 * Opacity
 */

exports.opacity = {};
exports.opacity.get = function(el, compute) {
  if (!compute) return;
  var ret = computed(el, 'opacity');
  return '' == ret ? '1' : ret;
}

/**
 * Utility: Set Positive Number
 *
 * @param {Element} el
 * @param {Mixed} val
 * @param {Number} subtract
 * @return {Number}
 */

function setPositiveNumber(el, val, subtract) {
  var matches = rnumsplit.exec(val);
  return matches ?
    // Guard against undefined 'subtract', e.g., when used as in cssHooks
    Math.max(0, matches[1]) + (matches[2] || 'px') :
    val;
}

/**
 * Utility: Get the width or height
 *
 * @param {Element} el
 * @param {String} prop
 * @param {Mixed} extra
 * @return {String}
 */

function getWidthOrHeight(el, prop, extra) {
  // Start with offset property, which is equivalent to the border-box value
  var valueIsBorderBox = true;
  var val = prop === 'width' ? el.offsetWidth : el.offsetHeight;
  var styles = computed(el);
  var isBorderBox = support.boxSizing && css(el, 'boxSizing') === 'border-box';

  // some non-html elements return undefined for offsetWidth, so check for null/undefined
  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
  if (val <= 0 || val == null) {
    // Fall back to computed then uncomputed css if necessary
    val = computed(el, prop, styles);

    if (val < 0 || val == null) {
      val = el.style[prop];
    }

    // Computed unit is not pixels. Stop here and return.
    if (rnumnonpx.test(val)) {
      return val;
    }

    // we need the check for style in case a browser which returns unreliable values
    // for getComputedStyle silently falls back to the reliable el.style
    valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === el.style[prop]);

    // Normalize ', auto, and prepare for extra
    val = parseFloat(val) || 0;
  }

  // use the active box-sizing model to add/subtract irrelevant styles
  extra = extra || (isBorderBox ? 'border' : 'content');
  val += augmentWidthOrHeight(el, prop, extra, valueIsBorderBox, styles);
  return val + 'px';
}

/**
 * Utility: Augment the width or the height
 *
 * @param {Element} el
 * @param {String} prop
 * @param {Mixed} extra
 * @param {Boolean} isBorderBox
 * @param {Array} styles
 */

function augmentWidthOrHeight(el, prop, extra, isBorderBox, styles) {
  // If we already have the right measurement, avoid augmentation,
  // Otherwise initialize for horizontal or vertical properties
  var i = extra === (isBorderBox ? 'border' : 'content') ? 4 : 'width' == prop ? 1 : 0;
  var val = 0;

  for (; i < 4; i += 2) {
    // both box models exclude margin, so add it if we want it
    if (extra === 'margin') {
      val += css(el, extra + cssExpand[i], true, styles);
    }

    if (isBorderBox) {
      // border-box includes padding, so remove it if we want content
      if (extra === 'content') {
        val -= css(el, 'padding' + cssExpand[i], true, styles);
      }

      // at this point, extra isn't border nor margin, so remove border
      if (extra !== 'margin') {
        val -= css(el, 'border' + cssExpand[i] + 'Width', true, styles);
      }
    } else {
      // at this point, extra isn't content, so add padding
      val += css(el, 'padding' + cssExpand[i], true, styles);

      // at this point, extra isn't content nor padding, so add border
      if (extra !== 'padding') {
        val += css(el, 'border' + cssExpand[i] + 'Width', true, styles);
      }
    }
  }

  return val;
}


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(31)('css:prop');
var camelcase = __webpack_require__(213);
var vendor = __webpack_require__(715);

/**
 * Export `prop`
 */

module.exports = prop;

/**
 * Normalize Properties
 */

var cssProps = {
  'float': 'cssFloat' in document.documentElement.style ? 'cssFloat' : 'styleFloat'
};

/**
 * Get the vendor prefixed property
 *
 * @param {String} prop
 * @param {String} style
 * @return {String} prop
 * @api private
 */

function prop(prop, style) {
  prop = cssProps[prop] || (cssProps[prop] = vendor(prop, style));
  debug('transform property: %s => %s', prop, style);
  return prop;
}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module Dependencies
 */

var debug = __webpack_require__(31)('css:style');
var camelcase = __webpack_require__(213);
var support = __webpack_require__(248);
var property = __webpack_require__(245);
var hooks = __webpack_require__(244);

/**
 * Expose `style`
 */

module.exports = style;

/**
 * Possibly-unitless properties
 *
 * Don't automatically add 'px' to these properties
 */

var cssNumber = {
  "columnCount": true,
  "fillOpacity": true,
  "fontWeight": true,
  "lineHeight": true,
  "opacity": true,
  "order": true,
  "orphans": true,
  "widows": true,
  "zIndex": true,
  "zoom": true
};

/**
 * Set a css value
 *
 * @param {Element} el
 * @param {String} prop
 * @param {Mixed} val
 * @param {Mixed} extra
 */

function style(el, prop, val, extra) {
  // Don't set styles on text and comment nodes
  if (!el || el.nodeType === 3 || el.nodeType === 8 || !el.style ) return;

  var orig = camelcase(prop);
  var style = el.style;
  var type = typeof val;

  if (!val) return get(el, prop, orig, extra);

  prop = property(prop, style);

  var hook = hooks[prop] || hooks[orig];

  // If a number was passed in, add 'px' to the (except for certain CSS properties)
  if ('number' == type && !cssNumber[orig]) {
    debug('adding "px" to end of number');
    val += 'px';
  }

  // Fixes jQuery #8908, it can be done more correctly by specifying setters in cssHooks,
  // but it would mean to define eight (for every problematic property) identical functions
  if (!support.clearCloneStyle && '' === val && 0 === prop.indexOf('background')) {
    debug('set property (%s) value to "inherit"', prop);
    style[prop] = 'inherit';
  }

  // If a hook was provided, use that value, otherwise just set the specified value
  if (!hook || !hook.set || undefined !== (val = hook.set(el, val, extra))) {
    // Support: Chrome, Safari
    // Setting style to blank string required to delete "style: x !important;"
    debug('set hook defined. setting property (%s) to %s', prop, val);
    style[prop] = '';
    style[prop] = val;
  }

}

/**
 * Get the style
 *
 * @param {Element} el
 * @param {String} prop
 * @param {String} orig
 * @param {Mixed} extra
 * @return {String}
 */

function get(el, prop, orig, extra) {
  var style = el.style;
  var hook = hooks[prop] || hooks[orig];
  var ret;

  if (hook && hook.get && undefined !== (ret = hook.get(el, false, extra))) {
    debug('get hook defined, returning: %s', ret);
    return ret;
  }

  ret = style[prop];
  debug('getting %s', ret);
  return ret;
}


/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * Expose `styles`
 */

module.exports = styles;

/**
 * Get all the styles
 *
 * @param {Element} el
 * @return {Array}
 */

function styles(el) {
  if (window.getComputedStyle) {
    return el.ownerDocument.defaultView.getComputedStyle(el, null);
  } else {
    return el.currentStyle;
  }
}


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * Support values
 */

var reliableMarginRight;
var boxSizingReliableVal;
var pixelPositionVal;
var clearCloneStyle;

/**
 * Container setup
 */

var docElem = document.documentElement;
var container = document.createElement('div');
var div = document.createElement('div');

/**
 * Clear clone style
 */

div.style.backgroundClip = 'content-box';
div.cloneNode(true).style.backgroundClip = '';
exports.clearCloneStyle = div.style.backgroundClip === 'content-box';

container.style.cssText = 'border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px';
container.appendChild(div);

/**
 * Pixel position
 *
 * Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
 * getComputedStyle returns percent when specified for top/left/bottom/right
 * rather than make the css module depend on the offset module, we just check for it here
 */

exports.pixelPosition = function() {
  if (undefined == pixelPositionVal) computePixelPositionAndBoxSizingReliable();
  return pixelPositionVal;
}

/**
 * Reliable box sizing
 */

exports.boxSizingReliable = function() {
  if (undefined == boxSizingReliableVal) computePixelPositionAndBoxSizingReliable();
  return boxSizingReliableVal;
}

/**
 * Reliable margin right
 *
 * Support: Android 2.3
 * Check if div with explicit width and no margin-right incorrectly
 * gets computed margin-right based on width of container. (#3333)
 * WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
 * This support function is only executed once so no memoizing is needed.
 *
 * @return {Boolean}
 */

exports.reliableMarginRight = function() {
  var ret;
  var marginDiv = div.appendChild(document.createElement("div" ));

  marginDiv.style.cssText = div.style.cssText = divReset;
  marginDiv.style.marginRight = marginDiv.style.width = "0";
  div.style.width = "1px";
  docElem.appendChild(container);

  ret = !parseFloat(window.getComputedStyle(marginDiv, null).marginRight);

  docElem.removeChild(container);

  // Clean up the div for other support tests.
  div.innerHTML = "";

  return ret;
}

/**
 * Executing both pixelPosition & boxSizingReliable tests require only one layout
 * so they're executed at the same time to save the second computation.
 */

function computePixelPositionAndBoxSizingReliable() {
  // Support: Firefox, Android 2.3 (Prefixed box-sizing versions).
  div.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
    "box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;" +
    "position:absolute;top:1%";
  docElem.appendChild(container);

  var divStyle = window.getComputedStyle(div, null);
  pixelPositionVal = divStyle.top !== "1%";
  boxSizingReliableVal = divStyle.width === "4px";

  docElem.removeChild(container);
}




/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var closest = __webpack_require__(240);
} catch(err) {
  var closest = __webpack_require__(240);
}

try {
  var event = __webpack_require__(115);
} catch(err) {
  var event = __webpack_require__(115);
}

/**
 * Delegate event `type` to `selector`
 * and invoke `fn(e)`. A callback function
 * is returned which may be passed to `.unbind()`.
 *
 * @param {Element} el
 * @param {String} selector
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.bind = function(el, selector, type, fn, capture){
  return event.bind(el, type, function(e){
    var target = e.target || e.srcElement;
    e.delegateTarget = closest(target, selector, true, el);
    if (e.delegateTarget) fn.call(el, e);
  }, capture);
};

/**
 * Unbind event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */

exports.unbind = function(el, type, fn, capture){
  event.unbind(el, type, fn, capture);
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

try {
  var type = __webpack_require__(147);
} catch (err) {
  var type = __webpack_require__(147);
}

var toFunction = __webpack_require__(1086);

/**
 * HOP reference.
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Iterate the given `obj` and invoke `fn(val, i)`
 * in optional context `ctx`.
 *
 * @param {String|Array|Object} obj
 * @param {Function} fn
 * @param {Object} [ctx]
 * @api public
 */

module.exports = function(obj, fn, ctx){
  fn = toFunction(fn);
  ctx = ctx || this;
  switch (type(obj)) {
    case 'array':
      return array(obj, fn, ctx);
    case 'object':
      if ('number' == typeof obj.length) return array(obj, fn, ctx);
      return object(obj, fn, ctx);
    case 'string':
      return string(obj, fn, ctx);
  }
};

/**
 * Iterate string chars.
 *
 * @param {String} obj
 * @param {Function} fn
 * @param {Object} ctx
 * @api private
 */

function string(obj, fn, ctx) {
  for (var i = 0; i < obj.length; ++i) {
    fn.call(ctx, obj.charAt(i), i);
  }
}

/**
 * Iterate object keys.
 *
 * @param {Object} obj
 * @param {Function} fn
 * @param {Object} ctx
 * @api private
 */

function object(obj, fn, ctx) {
  for (var key in obj) {
    if (has.call(obj, key)) {
      fn.call(ctx, key, obj[key]);
    }
  }
}

/**
 * Iterate array-ish.
 *
 * @param {Array|Object} obj
 * @param {Function} fn
 * @param {Object} ctx
 * @api private
 */

function array(obj, fn, ctx) {
  for (var i = 0; i < obj.length; ++i) {
    fn.call(ctx, obj[i], i);
  }
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

try {
  var events = __webpack_require__(115);
} catch(err) {
  var events = __webpack_require__(115);
}

try {
  var delegate = __webpack_require__(249);
} catch(err) {
  var delegate = __webpack_require__(249);
}

/**
 * Expose `Events`.
 */

module.exports = Events;

/**
 * Initialize an `Events` with the given
 * `el` object which events will be bound to,
 * and the `obj` which will receive method calls.
 *
 * @param {Object} el
 * @param {Object} obj
 * @api public
 */

function Events(el, obj) {
  if (!(this instanceof Events)) return new Events(el, obj);
  if (!el) throw new Error('element required');
  if (!obj) throw new Error('object required');
  this.el = el;
  this.obj = obj;
  this._events = {};
}

/**
 * Subscription helper.
 */

Events.prototype.sub = function(event, method, cb){
  this._events[event] = this._events[event] || {};
  this._events[event][method] = cb;
};

/**
 * Bind to `event` with optional `method` name.
 * When `method` is undefined it becomes `event`
 * with the "on" prefix.
 *
 * Examples:
 *
 *  Direct event handling:
 *
 *    events.bind('click') // implies "onclick"
 *    events.bind('click', 'remove')
 *    events.bind('click', 'sort', 'asc')
 *
 *  Delegated event handling:
 *
 *    events.bind('click li > a')
 *    events.bind('click li > a', 'remove')
 *    events.bind('click a.sort-ascending', 'sort', 'asc')
 *    events.bind('click a.sort-descending', 'sort', 'desc')
 *
 * @param {String} event
 * @param {String|function} [method]
 * @return {Function} callback
 * @api public
 */

Events.prototype.bind = function(event, method){
  var e = parse(event);
  var el = this.el;
  var obj = this.obj;
  var name = e.name;
  var method = method || 'on' + name;
  var args = [].slice.call(arguments, 2);

  // callback
  function cb(){
    var a = [].slice.call(arguments).concat(args);
    obj[method].apply(obj, a);
  }

  // bind
  if (e.selector) {
    cb = delegate.bind(el, e.selector, name, cb);
  } else {
    events.bind(el, name, cb);
  }

  // subscription for unbinding
  this.sub(name, method, cb);

  return cb;
};

/**
 * Unbind a single binding, all bindings for `event`,
 * or all bindings within the manager.
 *
 * Examples:
 *
 *  Unbind direct handlers:
 *
 *     events.unbind('click', 'remove')
 *     events.unbind('click')
 *     events.unbind()
 *
 * Unbind delegate handlers:
 *
 *     events.unbind('click', 'remove')
 *     events.unbind('click')
 *     events.unbind()
 *
 * @param {String|Function} [event]
 * @param {String|Function} [method]
 * @api public
 */

Events.prototype.unbind = function(event, method){
  if (0 == arguments.length) return this.unbindAll();
  if (1 == arguments.length) return this.unbindAllOf(event);

  // no bindings for this event
  var bindings = this._events[event];
  if (!bindings) return;

  // no bindings for this method
  var cb = bindings[method];
  if (!cb) return;

  events.unbind(this.el, event, cb);
};

/**
 * Unbind all events.
 *
 * @api private
 */

Events.prototype.unbindAll = function(){
  for (var event in this._events) {
    this.unbindAllOf(event);
  }
};

/**
 * Unbind all events for `event`.
 *
 * @param {String} event
 * @api private
 */

Events.prototype.unbindAllOf = function(event){
  var bindings = this._events[event];
  if (!bindings) return;

  for (var method in bindings) {
    this.unbind(event, method);
  }
};

/**
 * Parse `event`.
 *
 * @param {String} event
 * @return {Object}
 * @api private
 */

function parse(event) {
  var parts = event.split(/ +/);
  return {
    name: parts.shift(),
    selector: parts.join(' ')
  }
}


/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var query = __webpack_require__(34);
} catch (err) {
  var query = __webpack_require__(34);
}

/**
 * Element prototype.
 */

var proto = Element.prototype;

/**
 * Vendor function.
 */

var vendor = proto.matches
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

/**
 * Expose `match()`.
 */

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (!el || el.nodeType !== 1) return false;
  if (vendor) return vendor.call(el, selector);
  var nodes = query.all(selector, el.parentNode);
  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) return true;
  }
  return false;
}


/***/ }),
/* 254 */
/***/ (function(module, exports) {

/**
 * Global Names
 */

var globals = /\b(Array|Date|Object|Math|JSON)\b/g;

/**
 * Return immediate identifiers parsed from `str`.
 *
 * @param {String} str
 * @param {String|Function} map function or prefix
 * @return {Array}
 * @api public
 */

module.exports = function(str, fn){
  var p = unique(props(str));
  if (fn && 'string' == typeof fn) fn = prefixed(fn);
  if (fn) return map(str, p, fn);
  return p;
};

/**
 * Return immediate identifiers in `str`.
 *
 * @param {String} str
 * @return {Array}
 * @api private
 */

function props(str) {
  return str
    .replace(/\.\w+|\w+ *\(|"[^"]*"|'[^']*'|\/([^/]+)\//g, '')
    .replace(globals, '')
    .match(/[a-zA-Z_]\w*/g)
    || [];
}

/**
 * Return `str` with `props` mapped with `fn`.
 *
 * @param {String} str
 * @param {Array} props
 * @param {Function} fn
 * @return {String}
 * @api private
 */

function map(str, props, fn) {
  var re = /\.\w+|\w+ *\(|"[^"]*"|'[^']*'|\/([^/]+)\/|[a-zA-Z_]\w*/g;
  return str.replace(re, function(_){
    if ('(' == _[_.length - 1]) return fn(_);
    if (!~props.indexOf(_)) return _;
    return fn(_);
  });
}

/**
 * Return unique array.
 *
 * @param {Array} arr
 * @return {Array}
 * @api private
 */

function unique(arr) {
  var ret = [];

  for (var i = 0; i < arr.length; i++) {
    if (~ret.indexOf(arr[i])) continue;
    ret.push(arr[i]);
  }

  return ret;
}

/**
 * Map with prefix `str`.
 */

function prefixed(str) {
  return function(_){
    return str + _;
  };
}


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Expose `requestAnimationFrame()`.
 */

exports = module.exports = window.requestAnimationFrame
  || window.webkitRequestAnimationFrame
  || window.mozRequestAnimationFrame
  || fallback;

/**
 * Fallback implementation.
 */

var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime();
  var ms = Math.max(0, 16 - (curr - prev));
  var req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

/**
 * Cancel.
 */

var cancel = window.cancelAnimationFrame
  || window.webkitCancelAnimationFrame
  || window.mozCancelAnimationFrame
  || window.clearTimeout;

exports.cancel = function(id){
  cancel.call(window, id);
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var css = __webpack_require__(241);
} catch (err) {
  var css = __webpack_require__(241);
}

try {
  var bind = __webpack_require__(239);
} catch (err) {
  var bind = __webpack_require__(239);
}

try {
  var query = __webpack_require__(34);
} catch (err) {
  var query = __webpack_require__(34);
}

try {
  var events = __webpack_require__(251);
} catch (err) {
  var events = __webpack_require__(251);
}

try {
  var Emitter = __webpack_require__(94);
} catch (err) {
  var Emitter = __webpack_require__(94);
}

try {
  var classes = __webpack_require__(114);
} catch (err) {
  var classes = __webpack_require__(114);
}

try {
  var raf = __webpack_require__(255);
} catch (err) {
  var raf = __webpack_require__(255);
}

var domify = __webpack_require__(4);
var getBoundingClientRect = __webpack_require__(712);

var html = domify(__webpack_require__(752));


// inspired by https://github.com/jkroso/viewport
function updateViewport( v ) {
  v.top = window.scrollY;
  v.left = window.scrollX;
  v.width = window.innerWidth;
  v.height = window.innerHeight;
  v.right = v.left + v.width;
  v.bottom = v.top + v.height;
  return v;
}

var viewport = updateViewport({});

function onViewportChange() {
  updateViewport( viewport );
}

// don't debounce these because they don't so any work that requires layout
window.addEventListener('resize', onViewportChange, true)
window.addEventListener('scroll', onViewportChange, true)


/**
 * Expose `Tip`.
 */

module.exports = Tip;

/**
 * Apply the average use-case of simply
 * showing a tool-tip on `el` hover.
 *
 * Options:
 *
 *  - `delay` hide delay in milliseconds [0]
 *  - `value` defaulting to the element's title attribute
 *
 * @param {Mixed} elem
 * @param {Object|String} options or value
 * @api public
 */

function tip(elem, options) {
  if ('string' == typeof options) options = { value : options };
  var els = ('string' == typeof elem) ? query.all(elem) : [elem];
  for(var i = 0, el; el = els[i]; i++) {
    var val = options.value || el.getAttribute('title');
    var tip = new Tip(val, options);
    el.setAttribute('title', '');
    tip.cancelHideOnHover();
    tip.attach(el);
  }
}

/**
 * Initialize a `Tip` with the given `content`.
 *
 * @param {Mixed} content
 * @api public
 */

function Tip(content, options) {
  options = options || {};
  if (!(this instanceof Tip)) return tip(content, options);
  Emitter.call(this);
  this.classname = '';
  this.delay = options.delay || 300;
  this.pad = null == options.pad ? 15 : options.pad;
  this.el = html.cloneNode(true);
  this.events = events(this.el, this);
  this.classes = classes(this.el);
  this.reposition = bind( this, Tip.prototype.reposition );
  this.inner = query('.tip-inner', this.el);
  this.message(content);
  this.position('top');
  this.static = !!options.static;
  if (Tip.effect) this.effect(Tip.effect);
}

/**
 * Mixin emitter.
 */

Emitter(Tip.prototype);

/**
 * Set tip `content`.
 *
 * @param {String|Element} content
 * @return {Tip} self
 * @api public
 */

Tip.prototype.message = function(content){
  if ('string' == typeof content) content = domify(content);
  this.inner.appendChild(content);
  return this;
};

/**
 * Attach to the given `el` with optional hide `delay`.
 *
 * @param {Element} el
 * @param {Number} delay
 * @return {Tip}
 * @api public
 */

Tip.prototype.attach = function(el){
  this.target = el;
  this.handleEvents = events(el, this);
  this.handleEvents.bind('mouseover');
  this.handleEvents.bind('mouseout');
  return this;
};

/**
 * On mouse over
 *
 * @param {Event} e
 * @return {Tip}
 * @api private
 */

Tip.prototype.onmouseover = function() {
  this.show(this.target);
  this.cancelHide();
};

/**
 * On mouse out
 *
 * @param {Event} e
 * @return {Tip}
 * @api private
 */

Tip.prototype.onmouseout = function() {
  this.hide(this.delay);
};

/**
 * Cancel hide on hover, hide with the given `delay`.
 *
 * @param {Number} delay
 * @return {Tip}
 * @api public
 */

Tip.prototype.cancelHideOnHover = function(){
  this.events.bind('mouseover', 'cancelHide');
  this.events.bind('mouseout', 'hide');
  return this;
};

/**
 * Set the effect to `type`.
 *
 * @param {String} type
 * @return {Tip}
 * @api public
 */

Tip.prototype.effect = function(type){
  this._effect = type;
  this.classes.add(type);
  return this;
};

/**
 * Set position:
 *
 *  - `top`
 *  - `top left`
 *  - `top right`
 *  - `bottom`
 *  - `bottom left`
 *  - `bottom right`
 *  - `left`
 *  - `right`
 *
 * @param {String} pos
 * @param {Object} options
 * @return {Tip}
 * @api public
 */

Tip.prototype.position = function(pos, options){
  options = options || {};
  this._position = pos;
  this._auto = false != options.auto;
  this.replaceClass(pos);
  this.emit('reposition');
  return this;
};

/**
 * Show the tip attached to `el`.
 *
 * Emits "show" (el) event.
 *
 * @param {String|Element|Number} el or x
 * @param {Number} [y]
 * @return {Tip}
 * @api public
 */

Tip.prototype.show = function(el){
  if ('string' == typeof el) el = query(el);

  // show it
  document.body.appendChild(this.el);
  this.classes.add('tip-' + this._position.replace(/\s+/g, '-'));
  this.classes.remove('tip-hide');

  // x,y
  if ('number' == typeof el) {
    var x = arguments[0];
    var y = arguments[1];
    this.emit('show');
    css(this.el, {
      top: y,
      left: x
    });
    return this;
  }

  // el
  this.target = el;
  this.reposition();
  this.emit('show', this.target);

  if (!this.winEvents && !this.static) {
    this.winEvents = events(window, this);
    this.winEvents.bind('resize', 'debouncedReposition');
    this.winEvents.bind('scroll', 'debouncedReposition');
  }

  return this;
};

/**
 * Reposition the tip if necessary.
 *
 * @api private
 */

Tip.prototype.reposition = function(){
  this.willReposition = null;
  var pos = this._position;
  if (this._auto) pos = this.suggested(pos);
  this.replaceClass(pos);
  this.emit('reposition');
  css(this.el, constrainLeft( this.offset(pos), this.el ) );
};

/**
 * Reposition the tip on the next available animation frame
 *
 * @api private
 */
Tip.prototype.debouncedReposition = function() {
  this.willReposition = raf( this.reposition );
}

/**
 * Compute the "suggested" position favouring `pos`.
 *
 * Returns `pos` if no suggestion can be determined.
 *
 * @param {String} pos
 * @param {Object} offset
 * @return {String}
 * @api private
 */

Tip.prototype.suggested = function(pos){
  var target = getBoundingClientRect(this.target);
  var h = this.el.clientHeight;
  var w = this.el.clientWidth;

  // see where we have spare room
  var room = {
    top: target.top - h,
    bottom: viewport.height - target.bottom - h,
    left: target.left - w,
    right: viewport.width - target.right - w
  };

  var positions = pos.split(/\s+/);
  var primary = choosePrimary(positions[0], room);
  if( positions[1] === primary || positions[1] === opposite[primary] ) {
    positions[1] = null;
  }
  return chooseSecondary(primary, positions[1], this, w, h) || pos;
};

function choosePrimary(prefered, room){
  // top, bottom, left, right in order of preference
  var order = [prefered, opposite[prefered], adjacent[prefered], opposite[adjacent[prefered]]];
  var best = -Infinity;
  var bestPos
  for (var i = 0, len = order.length; i < len; i++) {
    var prefered = order[i];
    var space = room[prefered];
    // the first side it fits completely
    if (space > 0) return prefered;
    // less chopped of than other sides
    if (space > best) best = space, bestPos = prefered;
  }
  return bestPos;
}

function chooseSecondary(primary, prefered, tip, w, h){
  // top, top left, top right in order of preference
  var order = prefered
    ? [primary + ' ' + prefered, primary, primary + ' ' + opposite[prefered]]
    : [primary, primary + ' ' + adjacent[primary], primary + ' ' + opposite[adjacent[primary]]];
  var bestPos;
  var best = 0;
  var max = w * h;
  for (var i = 0, len = order.length; i < len; i++) {
    var pos = order[i];
    var off = tip.offset(pos);
    var offRight = off.left + w;
    var offBottom = off.top + h;
    var yVisible = Math.min(off.top < viewport.top ? offBottom - viewport.top : viewport.bottom - off.top, h);
    var xVisible = Math.min(off.left < viewport.left ? offRight - viewport.left : viewport.right - off.left, w);
    var area = xVisible * yVisible;
    // the first position that shows all the tip
    if (area == max) return pos;
    // shows more of the tip than the other positions
    if (area > best) best = area, bestPos = pos;
  }
  return bestPos;
}

var opposite = {
  top: 'bottom', bottom: 'top',
  left: 'right', right: 'left'
};

var adjacent = {
  top: 'right',
  left: 'top',
  bottom: 'left',
  right: 'bottom'
};

/**
 * Replace position class `name`.
 *
 * @param {String} name
 * @api private
 */

Tip.prototype.replaceClass = function(name){
  name = name.split(' ').join('-');
  var classname = this.classname + ' tip tip-' + name;
  if (this._effect) classname += ' ' + this._effect;
  this.el.setAttribute('class', classname);
};

/**
 * Compute the offset for `.target`
 * based on the given `pos`.
 *
 * @param {String} pos
 * @return {Object}
 * @api private
 */

Tip.prototype.offset = function(pos){
  var pad = this.pad;

  var tipRect = getBoundingClientRect(this.el);
  if (!tipRect) throw new Error('could not get bounding client rect of Tip element');
  var ew = tipRect.width;
  var eh = tipRect.height;

  var targetRect = getBoundingClientRect(this.target);
  if (!targetRect) throw new Error('could not get bounding client rect of `target`');
  var tw = targetRect.width;
  var th = targetRect.height;

  var to = offset(targetRect, document);
  if (!to) throw new Error('could not determine page offset of `target`');

  var pos;
  switch (pos) {
    case 'top':
      pos = {
        top: to.top - eh,
        left: to.left + tw / 2 - ew / 2
      };
      break;
    case 'bottom':
      pos = {
        top: to.top + th,
        left: to.left + tw / 2 - ew / 2
      };
      break;
    case 'right':
      pos = {
        top: to.top + th / 2 - eh / 2,
        left: to.left + tw
      };
      break;
    case 'left':
      pos = {
        top: to.top + th / 2 - eh / 2,
        left: to.left - ew
      };
      break;
    case 'top left':
      pos = {
        top: to.top - eh,
        left: to.left + tw / 2 - ew + pad
      };
      break;
    case 'top right':
      pos = {
        top: to.top - eh,
        left: to.left + tw / 2 - pad
      };
      break;
    case 'bottom left':
      pos = {
        top: to.top + th,
        left: to.left + tw / 2 - ew + pad
      };
      break;
    case 'bottom right':
      pos = {
        top: to.top + th,
        left: to.left + tw / 2 - pad
      };
      break;
    case 'left top':
      pos = {
        top: to.top + th / 2 - eh,
        left: to.left - ew
      };
      break;
    case 'left bottom':
      pos = {
        top: to.top + th / 2,
        left: to.left - ew
      };
      break;
    case 'right top':
      pos = {
        top: to.top + th / 2 - eh,
        left: to.left + tw
      };
      break;
    case 'right bottom':
      pos = {
        top: to.top + th / 2,
        left: to.left + tw
      };
      break;
    default:
      throw new Error('invalid position "' + pos + '"');
  }
  return pos;
};

/**
 * Cancel the `.hide()` timeout.
 *
 * @api private
 */

Tip.prototype.cancelHide = function(){
  clearTimeout(this._hide);
};

/**
 * Hide the tip with optional `ms` delay.
 *
 * Emits "hide" event.
 *
 * @param {Number} ms
 * @return {Tip}
 * @api public
 */

Tip.prototype.hide = function(ms){
  var self = this;

  this.emit('hiding');

  // duration
  if (ms) {
    this._hide = setTimeout(bind(this, this.hide), ms);
    return this;
  }

  // hide
  this.classes.add('tip-hide');
  if (this._effect) {
    setTimeout(bind(this, this.remove), 300);
  } else {
    self.remove();
  }

  return this;
};

/**
 * Hide the tip without potential animation.
 *
 * @return {Tip}
 * @api public
 */

Tip.prototype.remove = function(){
  if (this.winEvents) {
    this.winEvents.unbind();
    this.winEvents = null;
  }
  if (this._willReposition) {
    raf.cancel( this.willReposition );
    this.willReposition = null;
  }
  this.emit('hide');

  var parent = this.el.parentNode;
  if (parent) parent.removeChild(this.el);
  return this;
};

/**
 * Extracted from `timoxley/offset`, but directly using a
 * TextRectangle instead of getting another version.
 *
 * @param {TextRectangle} box - result from a `getBoundingClientRect()` call
 * @param {Document} doc - Document instance to use
 * @return {Object} an object with `top` and `left` Number properties
 * @api private
 */

function offset (box, doc) {
  var body = doc.body || doc.getElementsByTagName('body')[0];
  var docEl = doc.documentElement || body.parentNode;
  var clientTop  = docEl.clientTop  || body.clientTop  || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollTop  = window.pageYOffset || docEl.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft;

  return {
    top: box.top  + scrollTop  - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}

/**
 * Constrain a left to keep the element in the window
 * @param  {Object} pl proposed left
 * @param  {Number} ew tip element width
 * @return {Number}    the best width
 */
function constrainLeft ( off, el ) {
  var ew = getBoundingClientRect(el).width;
  off.left = Math.max( 0, Math.min( off.left, viewport.width - ew ) );
  return off;
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var cookie = __webpack_require__(716);

module.exports = function () {
  return {
    set: function (name, value, options) {
      return document.cookie = cookie.serialize(name, value, options);
    },

    get: function (name) {
      return cookie.parse(document.cookie)[name];
    },

    remove: function (name, options) {
      var opts = options || {};
      opts.expires = new Date(0);

      return !!(document.cookie = cookie.serialize(name, '', opts));
    },

    all: function () {
      return cookie.parse(document.cookie);
    }
  }
}



/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(60)
  , toIndex  = __webpack_require__(77)
  , toLength = __webpack_require__(25);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(20).f
  , create      = __webpack_require__(99)
  , redefineAll = __webpack_require__(75)
  , ctx         = __webpack_require__(43)
  , anInstance  = __webpack_require__(70)
  , defined     = __webpack_require__(51)
  , forOf       = __webpack_require__(118)
  , $iterDefine = __webpack_require__(267)
  , step        = __webpack_require__(268)
  , setSpecies  = __webpack_require__(122)
  , DESCRIPTORS = __webpack_require__(30)
  , fastKey     = __webpack_require__(98).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll       = __webpack_require__(75)
  , getWeak           = __webpack_require__(98).getWeak
  , anObject          = __webpack_require__(14)
  , isObject          = __webpack_require__(16)
  , anInstance        = __webpack_require__(70)
  , forOf             = __webpack_require__(118)
  , createArrayMethod = __webpack_require__(96)
  , $has              = __webpack_require__(24)
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12).document && document.documentElement;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(30) && !__webpack_require__(19)(function(){
  return Object.defineProperty(__webpack_require__(152)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(71);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(16)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(16)
  , cof      = __webpack_require__(71)
  , MATCH    = __webpack_require__(17)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(14);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(73)
  , $export        = __webpack_require__(2)
  , redefine       = __webpack_require__(54)
  , hide           = __webpack_require__(35)
  , has            = __webpack_require__(24)
  , Iterators      = __webpack_require__(72)
  , $iterCreate    = __webpack_require__(723)
  , setToStringTag = __webpack_require__(76)
  , getPrototypeOf = __webpack_require__(101)
  , ITERATOR       = __webpack_require__(17)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(74)
  , gOPS     = __webpack_require__(121)
  , pIE      = __webpack_require__(102)
  , toObject = __webpack_require__(60)
  , IObject  = __webpack_require__(155)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(19)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(24)
  , toIObject    = __webpack_require__(40)
  , arrayIndexOf = __webpack_require__(149)(false)
  , IE_PROTO     = __webpack_require__(159)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(74)
  , toIObject = __webpack_require__(40)
  , isEnum    = __webpack_require__(102).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(100)
  , gOPS     = __webpack_require__(121)
  , anObject = __webpack_require__(14)
  , Reflect  = __webpack_require__(12).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(16)
  , anObject = __webpack_require__(14);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(43)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(25)
  , repeat   = __webpack_require__(277)
  , defined  = __webpack_require__(51);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(78)
  , defined   = __webpack_require__(51);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(12)
  , DESCRIPTORS    = __webpack_require__(30)
  , LIBRARY        = __webpack_require__(73)
  , $typed         = __webpack_require__(164)
  , hide           = __webpack_require__(35)
  , redefineAll    = __webpack_require__(75)
  , fails          = __webpack_require__(19)
  , anInstance     = __webpack_require__(70)
  , toInteger      = __webpack_require__(78)
  , toLength       = __webpack_require__(25)
  , gOPN           = __webpack_require__(100).f
  , dP             = __webpack_require__(20).f
  , arrayFill      = __webpack_require__(148)
  , setToStringTag = __webpack_require__(76)
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(17);

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(32);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var base64 = __webpack_require__(146);

function padding(str) {
  var mod = (str.length % 4);
  var pad = 4 - mod;

  if (mod === 0) {
    return str;
  }

  return str + (new Array(1 + pad)).join('=');
}

function byteArrayToString(array) {
  var result = "";
  for (var i = 0; i < array.length; i++) {
    result += String.fromCharCode(array[i]);
  }
  return result;
}

function stringToByteArray(str) {
  var arr = new Array(str.length);
  for (var a = 0; a < str.length; a++) {
    arr[a] = str.charCodeAt(a);
  }
  return arr;
}

function byteArrayToHex(raw) {
  var HEX = '';

  for (var i = 0; i < raw.length; i++) {
    var _hex = raw[i].toString(16);
    HEX += (_hex.length === 2 ? _hex : '0' + _hex);
  }

  return HEX;
}

function encodeString(str) {
  return base64.fromByteArray(stringToByteArray(str))
      .replace(/\+/g, '-') // Convert '+' to '-'
      .replace(/\//g, '_'); // Convert '/' to '_'
}


function decodeToString(str) {
  str = padding(str)
    .replace(/\-/g, '+') // Convert '-' to '+'
    .replace(/_/g, '/'); // Convert '_' to '/'

  return byteArrayToString(base64.toByteArray(str));
}


function decodeToHEX(str) {
  return byteArrayToHex(base64.toByteArray(padding(str)));
}

module.exports = {
  encodeString: encodeString,
  decodeToString: decodeToString,
  byteArrayToString: byteArrayToString,
  stringToByteArray: stringToByteArray,
  padding: padding,
  byteArrayToHex: byteArrayToHex,
  decodeToHEX: decodeToHEX
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(126),
    baseLodash = __webpack_require__(178);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(790),
    isArguments = __webpack_require__(189),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(190),
    isIndex = __webpack_require__(183),
    isTypedArray = __webpack_require__(327);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(294),
    eq = __webpack_require__(187);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(104),
    keys = __webpack_require__(132);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(303);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(175),
    isArray = __webpack_require__(26);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(777),
    isObjectLike = __webpack_require__(63);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(185),
    nativeKeys = __webpack_require__(843);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(188),
    metaMap = __webpack_require__(316);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(299),
    composeArgsRight = __webpack_require__(300),
    countHolders = __webpack_require__(805),
    createCtor = __webpack_require__(129),
    createRecurry = __webpack_require__(302),
    getHolder = __webpack_require__(310),
    reorder = __webpack_require__(850),
    replaceHolders = __webpack_require__(186),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(829),
    setData = __webpack_require__(318),
    setWrapToString = __webpack_require__(321);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(765),
    arraySome = __webpack_require__(770),
    cacheHas = __webpack_require__(794);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(865),
    overRest = __webpack_require__(847),
    setToString = __webpack_require__(320);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(295),
    getSymbols = __webpack_require__(182),
    keys = __webpack_require__(132);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(295),
    getSymbolsIn = __webpack_require__(311),
    keysIn = __webpack_require__(328);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(316),
    noop = __webpack_require__(877);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(175),
    getPrototype = __webpack_require__(181),
    getSymbols = __webpack_require__(182),
    stubArray = __webpack_require__(329);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(761),
    Map = __webpack_require__(169),
    Promise = __webpack_require__(763),
    Set = __webpack_require__(764),
    WeakMap = __webpack_require__(289),
    baseGetTag = __webpack_require__(81),
    toSource = __webpack_require__(324);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(289);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(298),
    shortOut = __webpack_require__(322);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(788),
    shortOut = __webpack_require__(322);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(816),
    insertWrapDetails = __webpack_require__(826),
    setToString = __webpack_require__(320),
    updateWrapDetails = __webpack_require__(859);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(841);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(191),
    isLength = __webpack_require__(192);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(781),
    baseUnary = __webpack_require__(792),
    nodeUtil = __webpack_require__(845);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(290),
    baseKeysIn = __webpack_require__(783),
    isArrayLike = __webpack_require__(326);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(882);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(791);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(891);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (playgroundLock) {pug_html = pug_html + "\u003Cdiv id=\"playground-next\"\u003E" + (null == (pug_interp = playgroundLock) ? "" : pug_interp) + "\u003Cdiv class=\"playground-next-loading\"\u003E\u003Cdiv class=\"spinner spinner-md\"\u003E\u003Cdiv class=\"circle\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"playgroundLock" in locals_for_with?locals_for_with.playgroundLock:typeof playgroundLock!=="undefined"?playgroundLock:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csvg width=\"1242px\" height=\"1299px\" viewBox=\"-745 -149 1242 1299\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\"\u003E\n\u003C!-- Generator: Sketch 41 (35326) - http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch --\u003E\n\u003Cdesc\u003ECreated with Sketch.\u003C\u002Fdesc\u003E\n\u003Cdefs\u003E\u003C\u002Fdefs\u003E\n\u003Cg id=\"left\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-744.000000, -148.000000)\"\u003E\n\u003Cg id=\"inner-orbit\" transform=\"translate(296.000000, 327.000000)\"\u003E\n\u003Cellipse id=\"inner-circle\" stroke=\"#DDDDDD\" cx=\"321.175\" cy=\"321.149587\" rx=\"318.45\" ry=\"318.398446\"\u003E\u003C\u002Fellipse\u003E\n\u003Ccircle id=\"Oval\" fill=\"#9E9E9E\" cx=\"335.935111\" cy=\"3.13369229\" r=\"2.5\"\u003E\u003C\u002Fcircle\u003E\n\u003Cellipse id=\"Oval\" fill=\"#9E9E9E\" cx=\"90.6499939\" cy=\"101.536964\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Ccircle id=\"Oval\" fill=\"#9E9E9E\" cx=\"2.75\" cy=\"323.899587\" r=\"2.75\"\u003E\u003C\u002Fcircle\u003E\n\u003Cellipse id=\"Oval\" fill=\"#9E9E9E\" cx=\"639.550003\" cy=\"323.399223\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#9E9E9E\" cx=\"335.685111\" cy=\"639.449648\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#9E9E9E\" cx=\"90.124333\" cy=\"540.108245\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cellipse id=\"dotted-circle\" stroke=\"#DDDDDD\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"round\" stroke-dasharray=\"1,10\" cx=\"617.5\" cy=\"647.82464\" rx=\"374.5\" ry=\"374.439372\"\u003E\u003C\u002Fellipse\u003E\n\u003Cg id=\"rect-circles\" transform=\"translate(0.000000, 28.000000)\" stroke=\"#DBDCDD\"\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.75\" x=\"182.025\" y=\"182.145508\" width=\"876.225\" height=\"876.083147\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.750003961\" transform=\"translate(620.139849, 620.189609) rotate(-4.999973) translate(-620.139849, -620.189609) \" x=\"182.025035\" y=\"182.145722\" width=\"876.229628\" height=\"876.087774\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749988\" transform=\"translate(620.122695, 620.174693) rotate(-9.997359) translate(-620.122695, -620.174693) \" x=\"182.017205\" y=\"182.140128\" width=\"876.21098\" height=\"876.06913\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749977593\" transform=\"translate(620.142791, 620.170745) rotate(-14.999329) translate(-620.142791, -620.170745) \" x=\"182.04338\" y=\"182.142258\" width=\"876.198822\" height=\"876.056974\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.750000034\" transform=\"translate(620.139634, 620.185346) rotate(-19.998771) translate(-620.139634, -620.185346) \" x=\"182.027114\" y=\"182.143752\" width=\"876.225039\" height=\"876.083187\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749988919\" transform=\"translate(620.146264, 620.177411) rotate(-24.999240) translate(-620.146264, -620.177411) \" x=\"182.040237\" y=\"182.14231\" width=\"876.212054\" height=\"876.070203\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.7499835\" transform=\"translate(620.160900, 620.170883) rotate(-30.000728) translate(-620.160900, -620.170883) \" x=\"182.058039\" y=\"182.138947\" width=\"876.205723\" height=\"876.063873\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.750039599\" transform=\"translate(620.162024, 620.207928) rotate(-34.999530) translate(-620.162024, -620.207928) \" x=\"182.026393\" y=\"182.143226\" width=\"876.271263\" height=\"876.129403\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.74998044\" transform=\"translate(620.175630, 620.160625) rotate(-40.002181) translate(-620.175630, -620.160625) \" x=\"182.074556\" y=\"182.130476\" width=\"876.202148\" height=\"876.060299\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749992807\" transform=\"translate(620.162468, 620.172923) rotate(-45.000000) translate(-620.162468, -620.172923) \" x=\"182.054169\" y=\"182.13555\" width=\"876.216597\" height=\"876.074745\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.74998044\" transform=\"translate(620.143710, 620.173013) rotate(-49.997819) translate(-620.143710, -620.173013) \" x=\"182.042636\" y=\"182.142864\" width=\"876.202148\" height=\"876.060299\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.750039599\" transform=\"translate(620.187390, 620.191926) rotate(-55.000470) translate(-620.187390, -620.191926) \" x=\"182.051759\" y=\"182.127224\" width=\"876.271263\" height=\"876.129403\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.7499835\" transform=\"translate(620.158800, 620.165334) rotate(-59.999272) translate(-620.158800, -620.165334) \" x=\"182.055938\" y=\"182.133398\" width=\"876.205723\" height=\"876.063873\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749988919\" transform=\"translate(620.171944, 620.156992) rotate(-65.000760) translate(-620.171944, -620.156992) \" x=\"182.065917\" y=\"182.121891\" width=\"876.212054\" height=\"876.070203\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.750000034\" transform=\"translate(620.180839, 620.155778) rotate(-70.001229) translate(-620.180839, -620.155778) \" x=\"182.06832\" y=\"182.114184\" width=\"876.225039\" height=\"876.083187\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749977593\" transform=\"translate(620.166131, 620.147431) rotate(-75.000671) translate(-620.166131, -620.147431) \" x=\"182.06672\" y=\"182.118944\" width=\"876.198822\" height=\"876.056974\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.749988\" transform=\"translate(620.180550, 620.133690) rotate(-80.002641) translate(-620.180550, -620.133690) \" x=\"182.07506\" y=\"182.099125\" width=\"876.21098\" height=\"876.06913\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" stroke-width=\"0.750003961\" transform=\"translate(620.178862, 620.155431) rotate(-85.000027) translate(-620.178862, -620.155431) \" x=\"182.064048\" y=\"182.111544\" width=\"876.229628\" height=\"876.087774\"\u003E\u003C\u002Frect\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-3\" transform=\"translate(946.000000, 342.000000)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"234.625\" cy=\"44.366974\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"241.25\" cy=\"127.678485\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"283.3\" cy=\"198.542011\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"162.5\" cy=\"174.670714\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"62.75\" cy=\"4.698397\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"89\" cy=\"135.177271\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"2.75\" cy=\"3.19864\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"134.9\" cy=\"37.618067\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-3\" transform=\"translate(146.000000, 439.000000) scale(-1, 1) translate(-146.000000, -439.000000) translate(8.000000, 335.000000)\"\u003E\n\u003Cpath d=\"M225.625,53.6166098 C226.867641,53.6166098 227.875,52.6094135 227.875,51.366974 C227.875,50.1245345 226.867641,49.1173382 225.625,49.1173382 C224.382359,49.1173382 223.375,50.1245345 223.375,51.366974 C223.375,52.6094135 224.382359,53.6166098 225.625,53.6166098 Z\" id=\"Oval\" fill=\"#EB5424\"\u003E\u003C\u002Fpath\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"234.25\" cy=\"134.678485\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"273.3\" cy=\"205.542011\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"152.5\" cy=\"182.670714\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"55.75\" cy=\"11.698397\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"82\" cy=\"142.177271\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"2.75\" cy=\"3.19864\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"126.9\" cy=\"45.618067\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-3\" transform=\"translate(808.349993, 145.368770) rotate(5.000000) translate(-808.349993, -145.368770) translate(661.349993, 40.368770)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"215.246301\" cy=\"40.6933367\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"227.072455\" cy=\"137.515795\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"291.129699\" cy=\"207.545245\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"160.276791\" cy=\"184.462155\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"57.7614159\" cy=\"4.95986423\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"84.9587132\" cy=\"146.135413\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"2.7423894\" cy=\"3.02432851\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"131.256234\" cy=\"41.7771573\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-3\" transform=\"translate(809.800708, 1150.976333) scale(1, -1) rotate(5.000000) translate(-809.800708, -1150.976333) translate(662.300708, 1045.476333)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"214.246301\" cy=\"40.6933367\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"228.064844\" cy=\"137.341483\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"292.209244\" cy=\"208.367128\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"161.356336\" cy=\"185.284038\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"55.852377\" cy=\"6.04321467\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"86.0382583\" cy=\"146.957296\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"2.73858409\" cy=\"2.93717277\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"130.343389\" cy=\"42.773352\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-3\" transform=\"translate(356.633359, 179.984963) rotate(314.000000) translate(-356.633359, -179.984963) translate(211.133359, 71.984963)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"214.313205\" cy=\"44.4396657\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"224.633775\" cy=\"138.905111\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"288.616975\" cy=\"213.176556\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"157.838111\" cy=\"185.851472\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"56.5761467\" cy=\"6.68469249\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"83.9587132\" cy=\"146.135413\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"2.57799634\" cy=\"3.24800286\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"130.434975\" cy=\"45.1056829\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-3\" transform=\"translate(357.340358, 1116.173316) scale(1, -1) rotate(314.000000) translate(-357.340358, -1116.173316) translate(211.340358, 1007.673316)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"213.593865\" cy=\"45.1343241\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"226.693069\" cy=\"142.477129\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"289.311634\" cy=\"213.895896\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"158.508088\" cy=\"187.98481\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"55.8568069\" cy=\"7.37935086\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"84.6286901\" cy=\"148.268751\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"2.57799634\" cy=\"3.24800286\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"130.434975\" cy=\"45.1056829\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group-4\" transform=\"translate(55.154782, 717.074372)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"152.911779\" cy=\"247.328909\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"127.281997\" cy=\"112.668448\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"17.3917132\" cy=\"3.11314911\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"3.00213185\" cy=\"192.726522\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Group\" transform=\"translate(998.000000, 667.000000)\"\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FFE480\" cx=\"203.3\" cy=\"192.542011\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#FCB83F\" cx=\"106.5\" cy=\"206.670714\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"3\" cy=\"249.177271\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"141\" cy=\"3.177271\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#EB5424\" cx=\"61\" cy=\"349.177271\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse id=\"Oval\" fill=\"#DDDDDD\" cx=\"238.25\" cy=\"35.2496357\" rx=\"2.25\" ry=\"2.24963575\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fsvg\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 336 */,
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

exports.arrayToObject = function (source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function (target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (Object.prototype.hasOwnProperty.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)] + hexTable[0x80 | ((c >> 12) & 0x3F)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]; // eslint-disable-line max-len
    }

    return out;
};

exports.compact = function (obj, references) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0; i < obj.length; ++i) {
            if (obj[i] && typeof obj[i] === 'object') {
                compacted.push(exports.compact(obj[i], refs));
            } else if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        obj[key] = exports.compact(obj[key], refs);
    });

    return obj;
};

exports.isRegExp = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function (obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(65);

var invariant = __webpack_require__(5);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(85);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstrumentation = __webpack_require__(37);

var quoteAttributeValueForBrowser = __webpack_require__(1048);
var warning = __webpack_require__(7);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var LinkedValueUtils = __webpack_require__(199);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var warning = __webpack_require__(7);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(1008);

var containsNode = __webpack_require__(739);
var focusNode = __webpack_require__(282);
var getActiveElement = __webpack_require__(283);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(84);
var DOMProperty = __webpack_require__(85);
var React = __webpack_require__(87);
var ReactBrowserEventEmitter = __webpack_require__(133);
var ReactCurrentOwner = __webpack_require__(47);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMContainerInfo = __webpack_require__(1002);
var ReactDOMFeatureFlags = __webpack_require__(1004);
var ReactFeatureFlags = __webpack_require__(345);
var ReactInstanceMap = __webpack_require__(108);
var ReactInstrumentation = __webpack_require__(37);
var ReactMarkupChecksum = __webpack_require__(1018);
var ReactReconciler = __webpack_require__(86);
var ReactUpdateQueue = __webpack_require__(202);
var ReactUpdates = __webpack_require__(41);

var emptyObject = __webpack_require__(79);
var instantiateReactComponent = __webpack_require__(355);
var invariant = __webpack_require__(5);
var setInnerHTML = __webpack_require__(137);
var shouldUpdateReactComponent = __webpack_require__(208);
var warning = __webpack_require__(7);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var React = __webpack_require__(87);

var invariant = __webpack_require__(5);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(349);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var ReactCompositeComponent = __webpack_require__(999);
var ReactEmptyComponent = __webpack_require__(344);
var ReactHostComponent = __webpack_require__(346);

var getNextDebugID = __webpack_require__(1075);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);
var escapeTextContentForBrowser = __webpack_require__(136);
var setInnerHTML = __webpack_require__(137);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(47);
var REACT_ELEMENT_TYPE = __webpack_require__(1014);

var getIteratorFn = __webpack_require__(1045);
var invariant = __webpack_require__(5);
var KeyEscapeUtils = __webpack_require__(198);
var warning = __webpack_require__(7);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PromiseState = function () {

  // creates a new PromiseState that is pending

  PromiseState.create = function create(meta) {
    return new PromiseState({
      pending: true,
      meta: meta
    });
  };

  // creates as PromiseState that is refreshing
  // can be called without a previous PromiseState and will be both pending and refreshing

  PromiseState.refresh = function refresh(previous, meta) {
    var p = previous || PromiseState.create(meta);

    return new PromiseState({
      pending: p.pending,
      refreshing: true,
      fulfilled: p.fulfilled,
      rejected: p.rejected,
      value: p.value,
      reason: p.reason,
      meta: p.meta
    });
  };

  // creates a PromiseState that is resolved with the given value.
  // if the given value is already a PromiseState,
  // it will be returned as is and ignore the provided meta.

  PromiseState.resolve = function resolve(value, meta) {
    if (value instanceof PromiseState) {
      return value;
    }

    return new PromiseState({
      fulfilled: true,
      value: value,
      meta: meta
    });
  };

  // creates a PromiseState that is rejected with the given reason

  PromiseState.reject = function reject(reason, meta) {
    return new PromiseState({
      rejected: true,
      reason: reason,
      meta: meta
    });
  };

  // The PromiseState.all(iterable) method returns a PromiseState
  // that resolves when all of the PromiseStates in the iterable
  // argument have resolved, or rejects with the reason of the
  // first passed PromiseState that rejects.

  PromiseState.all = function all(iterable) {
    if (!Array.isArray(iterable)) {
      iterable = Array.from(iterable);
    }

    return new PromiseState({
      pending: iterable.some(function (ps) {
        return ps.pending;
      }),
      refreshing: iterable.some(function (ps) {
        return ps.refreshing;
      }),
      fulfilled: iterable.every(function (ps) {
        return ps.fulfilled;
      }),
      rejected: iterable.some(function (ps) {
        return ps.rejected;
      }),
      value: iterable.map(function (ps) {
        return ps.value;
      }),
      reason: (iterable.find(function (ps) {
        return ps.reason;
      }) || {}).reason,
      meta: iterable.map(function (ps) {
        return ps.meta;
      })
    });
  };

  // The PromiseState.race(iterable) method returns a PromiseState
  // that resolves or rejects as soon as one of the PromiseStates in
  // the iterable resolves or rejects, with the value or reason
  // from that PromiseState.

  PromiseState.race = function race(iterable) {
    if (!Array.isArray(iterable)) {
      iterable = Array.from(iterable);
    }

    var winner = iterable.find(function (ps) {
      return ps.settled;
    });

    return new PromiseState({
      pending: !winner && iterable.some(function (ps) {
        return ps.pending;
      }),
      refreshing: !winner && iterable.some(function (ps) {
        return ps.refreshing;
      }),
      fulfilled: winner && winner.fulfilled,
      rejected: winner && winner.rejected,
      value: winner && winner.value,
      reason: winner && winner.reason,
      meta: winner && winner.meta
    });
  };

  // Constructor for creating a raw PromiseState. DO NOT USE DIRECTLY. Instead, use PromiseState.create() or other static constructors

  function PromiseState(_ref) {
    var _ref$pending = _ref.pending;
    var pending = _ref$pending === undefined ? false : _ref$pending;
    var _ref$refreshing = _ref.refreshing;
    var refreshing = _ref$refreshing === undefined ? false : _ref$refreshing;
    var _ref$fulfilled = _ref.fulfilled;
    var fulfilled = _ref$fulfilled === undefined ? false : _ref$fulfilled;
    var _ref$rejected = _ref.rejected;
    var rejected = _ref$rejected === undefined ? false : _ref$rejected;
    var _ref$value = _ref.value;
    var value = _ref$value === undefined ? null : _ref$value;
    var _ref$reason = _ref.reason;
    var reason = _ref$reason === undefined ? null : _ref$reason;
    var _ref$meta = _ref.meta;
    var meta = _ref$meta === undefined ? {} : _ref$meta;

    _classCallCheck(this, PromiseState);

    this.pending = pending;
    this.refreshing = refreshing;
    this.fulfilled = fulfilled;
    this.rejected = rejected;
    this.settled = fulfilled || rejected;
    this.value = value;
    this.reason = reason;
    this.meta = meta;
  }

  // Appends and calls fulfillment and rejection handlers on the PromiseState,
  // and returns a new PromiseState resolving to the return value of the called handler,
  // or to its original settled value if the promise was not handled.
  // The handler functions take the value/reason and meta as parameters.
  // (i.e. if the relevant handler onFulfilled or onRejected is undefined).
  // Note, unlike Promise.then(), these handlers are called immediately.

  PromiseState.prototype.then = function then(onFulFilled, onRejected) {
    if (this.fulfilled && onFulFilled) {
      return PromiseState.resolve(onFulFilled(this.value, this.meta), this.meta);
    }

    if (this.rejected && onRejected) {
      return PromiseState.resolve(onRejected(this.reason, this.meta), this.meta);
    }

    return this;
  };

  // Appends and calls a rejection handler callback to the PromiseState,
  // and returns a new PromiseState resolving to the return value of the
  // callback if it is called, or to its original fulfillment value if
  // the PromiseState is instead fulfilled. The handler function take
  // the reason and meta as parameters. Note, unlike Promise.catch(),
  // this handlers is called immediately.

  PromiseState.prototype.catch = function _catch(onRejected) {
    return this.then(undefined, onRejected);
  };

  return PromiseState;
}();

exports.default = PromiseState;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.default = isPlainObject;
var fnToString = function fnToString(fn) {
  return Function.prototype.toString.call(fn);
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return false;
  }

  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;

  if (proto === null) {
    return true;
  }

  var constructor = proto.constructor;

  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stripDiacritics = __webpack_require__(363);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2['default'])(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classnames = __webpack_require__(42);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption;
	var instancePrefix = _ref.instancePrefix;
	var labelKey = _ref.labelKey;
	var onFocus = _ref.onFocus;
	var onSelect = _ref.onSelect;
	var optionClassName = _ref.optionClassName;
	var optionComponent = _ref.optionComponent;
	var optionRenderer = _ref.optionRenderer;
	var options = _ref.options;
	var valueArray = _ref.valueArray;
	var valueKey = _ref.valueKey;
	var onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2['default'])(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2['default'].createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function (ref) {
					onOptionRef(ref, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(89);

var ReactCurrentOwner = __webpack_require__(47);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(45),__webpack_require__(110),__webpack_require__(8)):"function"==typeof define&&define.amd?define(["react","prop-types","react-select","lodash"],t):"object"==typeof exports?exports.Auth0LockPlayground=t(require("react"),require("prop-types"),require("react-select"),require("lodash")):e.Auth0LockPlayground=t(e.react,e["prop-types"],e["react-select"],e.lodash)}(this,function(e,t,n,a){return function(e){function t(a){if(n[a])return n[a].exports;var l=n[a]={i:a,l:!1,exports:{}};return e[a].call(l.exports,l,l.exports,t),l.l=!0,l.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,a){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=41)}([function(e,t){e.exports=__webpack_require__(1)},function(e,t){e.exports=__webpack_require__(45)},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0,t.LanguageSelector=t.OptionSelector=t.EditorOption=t.Editor=t.CodePenButton=t.MultiSelector=t.FooterLinks=t.Preview=t.default=void 0;var l=n(32),o=a(l),r=n(40),u=a(r),i=n(6),s=a(i),c=n(35),d=a(c),f=n(4),p=a(f),m=n(5),g=a(m),h=n(3),v=a(h),C=n(7),E=a(C),y=n(30),w=a(y);t.default=o.default,t.Preview=u.default,t.FooterLinks=s.default,t.MultiSelector=d.default,t.CodePenButton=p.default,t.Editor=g.default,t.EditorOption=v.default,t.OptionSelector=E.default,t.LanguageSelector=w.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0,t.ColorOption=t.LogoOption=t.SocialButtonStyle=t.LanguageOption=t.LanguageDictionaryOption=t.InitialScreenOption=t.EditorOption=t.ConnectionOption=t.BooleanOption=t.AdditionalSignUpFieldsOption=t.default=void 0;var l=n(21),o=a(l),r=n(17),u=a(r),i=n(18),s=a(i),c=n(20),d=a(c),f=n(22),p=a(f),m=n(23),g=a(m),h=n(24),v=a(h),C=n(26),E=a(C),y=n(25),w=a(y),b=n(19),_=a(b);t.default=o.default,t.AdditionalSignUpFieldsOption=u.default,t.BooleanOption=s.default,t.ConnectionOption=d.default,t.EditorOption=o.default,t.InitialScreenOption=p.default,t.LanguageDictionaryOption=g.default,t.LanguageOption=v.default,t.SocialButtonStyle=E.default,t.LogoOption=w.default,t.ColorOption=_.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0,t.CodePenIcon=t.default=void 0;var l=n(11),o=a(l),r=n(12),u=a(r);t.default=o.default,t.CodePenIcon=u.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0,t.EditorAndroid=t.EditoriOS=t.EditorWeb=t.default=void 0;var l=n(13),o=a(l),r=n(15),u=a(r),i=n(16),s=a(i),c=n(14),d=a(c);t.default=o.default,t.EditorWeb=u.default,t.EditoriOS=s.default,t.EditorAndroid=d.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0,t.ReadIcon=t.default=void 0;var l=n(27),o=a(l),r=n(28),u=a(r);t.default=o.default,t.ReadIcon=u.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0,t.IcoOption=t.IcoValue=t.default=void 0;var l=n(38),o=a(l),r=n(37),u=a(r),i=n(36),s=a(i);t.default=o.default,t.IcoValue=u.default,t.IcoOption=s.default},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t){e.exports=__webpack_require__(110)},function(e,t){},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(4),s=function(e){var t=e.optionsString,n='var lock = new Auth0Lock(\n  "YOUR_CLIENT_ID",\n  "YOUR_AUTH0_DOMAIN",\n  {\n    '+t+"\n  }\n);\n\nlock.show();\n",a=JSON.stringify({title:"Auth0 Lock",description:"Auth0 Lock example. Created from https://auth0.com.",editors:"001",layout:"left",head:'<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />',js:n,js_external:"https://cdn.auth0.com/js/lock/10.16.0/lock.min.js"});return o.default.createElement("form",{target:"_blank",action:"https://codepen.io/pen/define",method:"POST"},o.default.createElement("input",{type:"hidden",name:"data",value:a}),o.default.createElement("button",null,o.default.createElement(i.CodePenIcon,null),o.default.createElement("span",null,"Edit on codepen")))};s.propTypes={optionsString:u.default.string.isRequired},t.default=s},function(e,t,n){"use strict";t.__esModule=!0;var a=n(0),l=function(e){return e&&e.__esModule?e:{default:e}}(a),o=function(){return l.default.createElement("svg",{width:"256px",height:"256px",viewBox:"0 0 256 256",preserveAspectRatio:"xMinYMin meet"},l.default.createElement("g",null,l.default.createElement("path",{d:"M255.806943,87.0866439 C255.748337,86.7763743 255.696625,86.4661047 255.613887,86.1627299 C255.562175,85.9800156 255.500121,85.8076436 255.441515,85.6283767 C255.355329,85.3594764 255.265695,85.0905761 255.158825,84.8285707 C255.082981,84.6458563 254.996795,84.4700369 254.914056,84.2942175 C254.796843,84.0460018 254.676183,83.8012335 254.538285,83.5633602 C254.441757,83.3875407 254.331439,83.2220636 254.224568,83.0531391 C254.076328,82.825608 253.924641,82.6015244 253.759164,82.3843357 C253.638504,82.222306 253.514396,82.0671712 253.383393,81.9120364 C253.211021,81.70519 253.024859,81.5086859 252.838698,81.3156293 C252.693905,81.1708368 252.549113,81.0260443 252.397425,80.8846993 C252.197474,80.701985 251.990627,80.529613 251.773439,80.3641359 C251.607961,80.2365806 251.445932,80.1055779 251.27356,79.9883649 C251.211506,79.9435482 251.156347,79.8918366 251.090845,79.8504673 L134.098521,1.8486897 C130.406313,-0.616229901 125.590239,-0.616229901 121.898031,1.8486897 L4.89881225,79.8470198 C4.83331089,79.8883891 4.78159929,79.9401007 4.71609793,79.9849174 C4.54372593,80.1055779 4.38169625,80.2331331 4.21621913,80.3606884 C4.00247785,80.529613 3.79218401,80.701985 3.59223249,80.8778044 C3.44054513,81.015702 3.29575265,81.1604945 3.15440761,81.3087344 C2.96135097,81.5017911 2.78208409,81.6982951 2.60626464,81.9051415 C2.47526192,82.0602763 2.35115408,82.2154111 2.23049368,82.3877831 C2.06501656,82.6049719 1.9133292,82.825608 1.76508928,83.0565865 C1.65821864,83.2255111 1.551348,83.3909882 1.45137224,83.5668076 C1.31347464,83.804681 1.19281424,84.0494492 1.07904872,84.29077 C0.996310162,84.4665895 0.906676722,84.6458563 0.834280482,84.8251232 C0.727409841,85.0871287 0.634328961,85.356029 0.548142961,85.6249293 C0.489536481,85.8041962 0.427482561,85.9800156 0.379218401,86.1420453 C0.299927281,86.44542 0.2413208,86.7522422 0.18616176,87.0659592 C0.1551348,87.2245415 0.11721296,87.3796763 0.0965283202,87.5417059 C0.0344744001,88.0174527 2.84217094e-14,88.4931994 2.84217094e-14,88.9792884 L2.84217094e-14,166.994856 C2.84217094e-14,167.477497 0.0344744001,167.960139 0.1034232,168.432438 C0.12755528,168.60481 0.172372,168.742708 0.2068464,168.908185 C0.26200544,169.218455 0.310269601,169.528724 0.413692801,169.838994 C0.461956961,170.011366 0.517116001,170.183738 0.586064801,170.373347 C0.672250801,170.649142 0.758436801,170.924937 0.861860002,171.176601 C0.934256242,171.348973 1.034232,171.521345 1.1031808,171.693717 C1.21694632,171.935037 1.3445016,172.176358 1.4823992,172.428021 C1.57892752,172.600393 1.6892456,172.772765 1.7926688,172.931347 C1.94090872,173.172668 2.1029384,173.379515 2.2753104,173.586361 C2.3959708,173.758733 2.5166312,173.896631 2.6545288,174.062108 C2.83034825,174.268954 2.99927281,174.475801 3.20611921,174.658515 C3.34746425,174.796413 3.48191441,174.968785 3.65428641,175.072208 C3.85423793,175.24458 4.06797921,175.416952 4.27482561,175.596219 C4.44030273,175.734116 4.61956961,175.837539 4.75746721,175.97199 C4.82296857,176.006464 4.86089041,176.075413 4.92983921,176.10644 L121.898031,254.146139 C123.745859,255.387218 125.862587,256.007757 128,255.997414 C130.137413,255.987072 132.254141,255.376875 134.101969,254.146139 L251.101188,176.147809 C251.166689,176.10644 251.221848,176.058176 251.283902,176.013359 C251.456274,175.892698 251.618304,175.765143 251.783781,175.637588 C251.997522,175.468663 252.207816,175.292844 252.407768,175.113577 C252.559455,174.979127 252.704247,174.830887 252.84904,174.686094 C253.038649,174.493038 253.221363,174.296534 253.393735,174.089687 C253.524738,173.934553 253.648846,173.779418 253.769506,173.613941 C253.934983,173.396752 254.086671,173.172668 254.234911,172.945137 C254.341781,172.77966 254.448652,172.610736 254.548628,172.441811 C254.686525,172.20049 254.807186,171.955722 254.924399,171.707506 C255.007137,171.531687 255.093323,171.355867 255.169167,171.176601 C255.276038,170.911148 255.365671,170.642247 255.451857,170.373347 C255.510464,170.19408 255.572517,170.018261 255.624229,169.838994 C255.70352,169.535619 255.758679,169.225349 255.817286,168.91508 C255.844865,168.756498 255.886234,168.601363 255.903472,168.439333 C255.965526,167.963586 256,167.48784 256,167.001751 L256,88.9999731 C256,88.513884 255.962078,88.0381373 255.903472,87.5623906 C255.875892,87.393466 255.824181,87.2555684 255.789706,87.0866439 L255.806943,87.0866439 Z M127.996553,154.022139 L89.0921921,128.000862 L127.996553,101.976137 L166.90436,128.000862 L127.996553,154.022139 L127.996553,154.022139 Z M116.999219,82.8669773 L69.3073339,114.76614 L30.8097713,89.0137628 L116.999219,31.5552802 L116.999219,82.8669773 L116.999219,82.8669773 Z M49.5224757,127.997414 L22.0050096,146.403297 L22.0050096,109.591532 L49.5224757,127.997414 L49.5224757,127.997414 Z M69.3073339,141.242479 L116.999219,173.138194 L116.999219,224.449891 L30.8097713,166.984513 L69.3073339,141.235584 L69.3073339,141.242479 Z M138.997334,173.131299 L186.689219,141.235584 L225.190229,166.984513 L138.997334,224.442996 L138.997334,173.131299 L138.997334,173.131299 Z M206.474077,128.004309 L233.99499,109.59498 L233.99499,146.410191 L206.474077,127.997414 L206.474077,128.004309 Z M186.689219,114.76614 L138.997334,82.8704247 L138.997334,31.5552802 L225.190229,89.0137628 L186.689219,114.76614 L186.689219,114.76614 Z",fill:"white"})))};t.default=o},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(2),s=n(5),c=["https://auth0.com/docs/libraries/lock","https://auth0.com/docs/libraries/lock-ios","https://auth0.com/docs/libraries/lock-android"],d=function(e){var t=e.selectedLanguageIndex,n=e.onOptionChange,a=e.options,l=e.defaultColor,r=e.logos,u=e.optionsString,d={onOptionChange:n,options:a,logos:r,defaultColor:l},f=[o.default.createElement(s.EditorWeb,d),o.default.createElement(s.EditoriOS,d),o.default.createElement(s.EditorAndroid,d)];return o.default.createElement("div",{className:"editor"},o.default.createElement("div",{className:"code"},f[t],o.default.createElement("img",{src:"https://cdn.auth0.com/website/playground/others/mobile-lock-example.svg",className:"phone-example",alt:"Phone with lock example"})),o.default.createElement(i.FooterLinks,{docsUrl:c[t],optionsString:u}))};d.propTypes={selectedLanguageIndex:u.default.number.isRequired,onOptionChange:u.default.func.isRequired,options:u.default.array.isRequired,preset:u.default.string.isRequired,logoBaseUrl:u.default.string,defaultColor:u.default.string,logos:u.default.arrayOf(u.default.shape({value:u.default.string.isRequired,label:u.default.string.isRequired,icon:u.default.string.isRequired}).isRequired),hideName:u.default.bool,optionsString:u.default.string.isRequired},t.default=d},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(3),s=function(e,t){return e.find(function(e){return e[0]===t})[1]},c=function(e){var t=e.onOptionChange,n=e.options;return o.default.createElement("ol",{className:"code-container"},o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,'Auth0 account = new Auth0("cid", "domain");')),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"Lock lock = Lock.newBuilder(account, new LockCallback() {…})")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,".allowedConnections(Arrays.asList("),o.default.createElement(i.ConnectionOption,{value:s(n,"allowedConnections"),onChange:t}),o.default.createElement("span",null,"))")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,".build(this);")),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"startActivity(lock.newIntent(this));")))};c.propTypes={onOptionChange:u.default.func.isRequired,options:u.default.array.isRequired,logos:u.default.array,defaultColor:u.default.string},t.default=c},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(3),s=function(e,t){return e.find(function(e){return e[0]===t})[1]},c=function(e){var t=e.onOptionChange,n=e.options,a=e.logos,l=e.defaultColor;return o.default.createElement("ol",{className:"code-container"},o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"var lock = new Auth0Lock(cid, domain, {")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,"allowedConnections: "),o.default.createElement(i.ConnectionOption,{value:s(n,"allowedConnections"),onChange:t})),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,"language:"),o.default.createElement(i.LanguageOption,{value:s(n,"language"),onChange:t})),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,"theme: {")),o.default.createElement("li",{className:"line-row indent-2"},o.default.createElement("span",null,"logo:"),o.default.createElement(i.LogoOption,{value:s(n,"logo"),onChange:t,logos:a})),o.default.createElement("li",{className:"line-row indent-2"},o.default.createElement("span",null,"primaryColor: "),o.default.createElement(i.ColorOption,{value:s(n,"primaryColor"),onChange:t,defaultColor:l})),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,"}")),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"});")),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"lock.show();")))};c.propTypes={onOptionChange:u.default.func.isRequired,options:u.default.array.isRequired,logos:u.default.array,defaultColor:u.default.string},t.default=c},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(3),s=function(e,t){return e.find(function(e){return e[0]===t})[1]},c=function(e){var t=e.onOptionChange,n=e.options,a=e.logos,l=e.defaultColor;return o.default.createElement("ol",{className:"code-container"},o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"Lock")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,'.classic(clientId: "cid", domain: "domain")')),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,".allowedConnections("),o.default.createElement(i.ConnectionOption,{value:s(n,"allowedConnections"),onChange:t}),o.default.createElement("span",null,")")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,".withStyle {")),o.default.createElement("li",{className:"line-row indent-2"},o.default.createElement("span",null,"$0.logo = LazyImage(name:"),o.default.createElement(i.LogoOption,{value:s(n,"logo"),onChange:t,logos:a}),o.default.createElement("span",null,")")),o.default.createElement("li",{className:"line-row indent-2"},o.default.createElement("span",null,"$0.primaryColor = UIColor("),o.default.createElement(i.ColorOption,{value:s(n,"primaryColor"),onChange:t,defaultColor:l}),o.default.createElement("span",null,")")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,"}")),o.default.createElement("li",{className:"line-row indent-1"},o.default.createElement("span",null,".present(from: viewController)")))};c.propTypes={onOptionChange:u.default.func.isRequired,options:u.default.array.isRequired,logos:u.default.array,defaultColor:u.default.string},t.default=c},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=function(){var e=(void 0).props.value,t=e[0],n=t.icon,a=t.name,l=t.options,r=t.placeholder,u=t.type,i=t.validator,s="select"===u&&o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,'type: "select"')),c=i&&o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"validator: ",i.toString())),d=l&&o.default.createElement("div",{className:"line-row"},o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"options: ","{")),o.default.createElement("div",{className:"line-row"},l.map(function(e){return o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"{",'label: "',e.label,'", value: "',e.value,'"',"}"))})),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"}")));return o.default.createElement("div",{className:"line-row"},o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"additionalSignUpFields: [","{")),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,'name: "',a,'"')),s,o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,'placeholder: "',r,'"')),o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,'icon: "',n,'"')),d,c,o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"}","]")))};i.propTypes={value:u.default.array.isRequired},t.default=i},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(2),s=function(e){var t=e.name,n=e.onChange,a=e.value,l=[{value:!0,label:"true"},{value:!1,label:"false"}];return o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,t,":",o.default.createElement(i.OptionSelector,{name:t,onChange:n,options:l,value:a})))};s.propTypes={name:u.default.string.isRequired,onChange:u.default.func.isRequired,value:u.default.bool.isRequired},t.default=s},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(0),i=a(u),s=n(1),c=a(s),d=n(2),f=function(e){function t(){var n,a,r;l(this,t);for(var u=arguments.length,i=Array(u),s=0;s<u;s++)i[s]=arguments[s];return n=a=o(this,e.call.apply(e,[this].concat(i))),a.onChange=function(e,t){a.props.onChange("primaryColor",t)},r=n,o(a,r)}return r(t,e),t.prototype.render=function(){var e=this.props,t=e.value,n=e.defaultColor,a=[{value:"default",label:"default",bg:n||"#EA5323"},{value:"#3A99D8",label:"#3A99D8",bg:"#3A99D8"},{value:"#EC4889",label:"#EC4889",bg:"#EC4889"},{value:"#40DF7D",label:"#40DF7D",bg:"#40DF7D"}];return i.default.createElement(d.OptionSelector,{name:"primaryColor",onChange:this.onChange,options:a,value:t})},t}(u.Component);f.propTypes={onChange:c.default.func.isRequired,value:c.default.string.isRequired,defaultColor:c.default.string},t.default=f},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(0),i=a(u),s=n(1),c=a(s),d=n(2),f=function(){return i.default.createElement("div",{className:"connection-option-item"},i.default.createElement("svg",{width:"15px",height:"16px",viewBox:"0 0 15 16",version:"1.1",xmlns:"http://www.w3.org/2000/svg"},i.default.createElement("path",{d:"M11.2110917,12.9436339 L9.62622483,7.99976169 L13.7748138,4.94511138 L8.64671124,4.94511138 L7.06165623,0.0014298566 L7.06118595,9.53237733e-05 L12.190135,9.53237733e-05 L13.7754722,4.94463476 L13.7754722,4.94453944 L13.776789,4.94377685 C14.6976108,7.81225983 13.7493242,11.0748113 11.2110917,12.9436339 L11.2110917,12.9436339 L11.2110917,12.9436339 Z M2.91203263,12.9436339 L2.91071583,12.9445871 L7.06043349,16 L11.2110917,12.9437292 L7.06175029,9.88822096 L2.91203263,12.9436339 L2.91203263,12.9436339 Z M0.347181866,4.94387217 L0.347181866,4.94387217 C-0.621985404,7.96763758 0.503034949,11.1716602 2.91118611,12.9442058 L2.91156234,12.9426806 L4.49661735,7.99909442 L0.348874899,4.94501606 L5.47575471,4.94501606 L7.06090378,0.00133453282 L7.06128,0 L1.93204876,0 L0.347181866,4.94387217 L0.347181866,4.94387217 Z",id:"Shape",stroke:"none",fill:"#FFFFFF",fillRule:"evenodd"})),i.default.createElement("span",{className:"connection-option-text"},"Auth0"))},p=function(){return i.default.createElement("div",{className:"connection-option-item"},i.default.createElement("svg",{width:"16px",height:"16px",viewBox:"0 1 16 16",version:"1.1",xmlns:"http://www.w3.org/2000/svg"},i.default.createElement("g",{id:"F_icon",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",transform:"translate(0.000000, 1.000000)"},i.default.createElement("g",{id:"Layer_1",fill:"#FFFFFF"},i.default.createElement("path",{d:"M15.0784247,15.9571892 C15.5636139,15.9571892 15.9570656,15.5637375 15.9570656,15.0784247 L15.9570656,0.915027027 C15.9570656,0.42965251 15.5636757,0.0363243243 15.0784247,0.0363243243 L0.915027027,0.0363243243 C0.42965251,0.0363243243 0.0363243243,0.42965251 0.0363243243,0.915027027 L0.0363243243,15.0784247 C0.0363243243,15.5636757 0.429590734,15.9571892 0.915027027,15.9571892 L15.0784247,15.9571892 Z M11.0214054,15.9571892 L11.0214054,9.7917529 L13.0908417,9.7917529 L13.4007104,7.38897297 L11.0214054,7.38897297 L11.0214054,5.85494981 C11.0214054,5.15928958 11.2145792,4.68522008 12.212139,4.68522008 L13.4844788,4.68466409 L13.4844788,2.53559846 C13.2644324,2.5063166 12.5091583,2.44089575 11.6304556,2.44089575 C9.79601544,2.44089575 8.54010811,3.56064865 8.54010811,5.61698842 L8.54010811,7.38897297 L6.46535907,7.38897297 L6.46535907,9.7917529 L8.54010811,9.7917529 L8.54010811,15.9571892 L11.0214054,15.9571892 Z",id:"Combined-Shape"})))),i.default.createElement("span",{className:"connection-option-text"},"Facebook"))},m=function(){return i.default.createElement("div",{className:"connection-option-item"},i.default.createElement("svg",{width:"18px",height:"15px",viewBox:"0 0 18 15",version:"1.1",xmlns:"http://www.w3.org/2000/svg"},i.default.createElement("path",{d:"M15.5845818,4.0192 C15.5845818,3.86523345 15.5814458,3.71196509 15.5745396,3.55938909 C16.2691142,3.05726836 16.8728087,2.43066182 17.3489687,1.71735273 C16.7115869,2.00066327 16.0256815,2.19138327 15.3061469,2.27738182 C16.040576,1.83698618 16.604416,1.14033455 16.8704233,0.309847273 C16.1831215,0.717300364 15.4219869,1.01344 14.6115724,1.17332364 C13.9624378,0.481890909 13.0382778,0.0494254545 12.014976,0.0494254545 C10.0505251,0.0494254545 8.45750691,1.64250182 8.45750691,3.60619636 C8.45750691,3.88534109 8.48871564,4.156864 8.54974836,4.41730909 C5.59323927,4.268544 2.97162473,2.85303273 1.21709382,0.700654545 C0.911592727,1.22635055 0.735435636,1.83700364 0.735435636,2.48858182 C0.735435636,3.72273455 1.36345018,4.81224727 2.31844655,5.44962909 C1.73482473,5.43159738 1.18657745,5.27138909 0.707392,5.00472436 C0.706868364,5.01964916 0.706868364,5.03419985 0.706868364,5.05015098 C0.706868364,6.77291462 1.93305018,8.21128553 3.56074473,8.53722007 C3.26182982,8.61870953 2.94733382,8.66240407 2.62273745,8.66240407 C2.39387345,8.66240407 2.17089745,8.6398784 1.95417018,8.5982528 C2.40704582,10.0116637 3.72027927,11.0402019 5.27722473,11.0689437 C4.059712,12.0232419 2.52598109,12.5916201 0.859072,12.5916201 C0.572293818,12.5916201 0.288989091,12.5753082 0.0105483636,12.5423785 C1.58489018,13.5514839 3.454272,14.1402839 5.46346473,14.1402839 C12.0064,14.1405091 15.5845818,8.71982545 15.5845818,4.0192 Z",id:"Shape",stroke:"none",fill:"#FFFFFF",fillRule:"evenodd"})),i.default.createElement("span",{className:"connection-option-text"},"Twitter"))},g=function(){return i.default.createElement("div",{className:"connection-option-item"},i.default.createElement("svg",{width:"16px",height:"16px",viewBox:"0 0 16 16",version:"1.1",xmlns:"http://www.w3.org/2000/svg"},i.default.createElement("g",{id:"Group",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},i.default.createElement("path",{d:"M15.68,8.18169492 C15.68,7.61457627 15.6291525,7.06881356 15.5345763,6.54542373 L8,6.54542373 L8,9.64 L12.3054237,9.64 C12.12,10.64 11.5562712,11.4871186 10.7091525,12.0545763 L10.7091525,14.0616949 L13.2945763,14.0616949 C14.8074576,12.6688136 15.68,10.6179661 15.68,8.18169492 L15.68,8.18169492 Z",id:"Shape",fill:"#FFFFFF"}),i.default.createElement("path",{d:"M8,16 C10.16,16 11.9708475,15.2837288 13.2945763,14.0616949 L10.7091525,12.0545763 C9.99288136,12.5345763 9.07627119,12.8183051 8,12.8183051 C5.91627119,12.8183051 4.15288136,11.4111864 3.52372881,9.52 L0.850847458,9.52 L0.850847458,11.5928814 C2.16711864,14.2074576 4.87254237,16 8,16 L8,16 Z",id:"Shape",fill:"#FFFFFF"}),i.default.createElement("path",{d:"M3.52372881,9.52 C3.36372881,9.04 3.27288136,8.52711864 3.27288136,8 C3.27288136,7.47288136 3.36372881,6.96 3.52372881,6.48 L3.52372881,4.40711864 L0.850847458,4.40711864 C0.309152542,5.48711864 0,6.70915254 0,8 C0,9.29084746 0.309152542,10.5128814 0.850847458,11.5928814 L3.52372881,9.52 L3.52372881,9.52 Z",id:"Shape",fill:"#FFFFFF"}),i.default.createElement("path",{d:"M8,3.18169492 C9.17457627,3.18169492 10.2291525,3.58542373 11.0583051,4.3779661 L13.3528814,2.08338983 C11.9671186,0.792881356 10.1562712,0 8,0 C4.87288136,0 2.16711864,1.79288136 0.850847458,4.40711864 L3.52372881,6.48 C4.15288136,4.58915254 5.91661017,3.18169492 8,3.18169492 Z",id:"Shape",fill:"#FFFFFF"}),i.default.createElement("polygon",{id:"Shape",points:"0 0 16 0 16 16 0 16"}))),i.default.createElement("span",{className:"connection-option-text"},"Google"))},h=function(e){function t(){var n,a,r;l(this,t);for(var u=arguments.length,i=Array(u),s=0;s<u;s++)i[s]=arguments[s];return n=a=o(this,e.call.apply(e,[this].concat(i))),a.onChange=function(e,t){a.props.onChange("allowedConnections",t)},r=n,o(a,r)}return r(t,e),t.prototype.render=function(){var e=this.props.value,t=[{value:"facebook",label:i.default.createElement(p,null)},{value:"twitter",label:i.default.createElement(m,null)},{value:"google-oauth2",label:i.default.createElement(g,null)},{value:"Username-Password-Authentication",label:i.default.createElement(f,null),clearableValue:!1}];return i.default.createElement(d.MultiSelector,{arrowRenderer:function(){return i.default.createElement("span",{className:"more-arrow"},"+")},name:"allowedConnections",onChange:this.onChange,options:t,value:e})},t}(u.Component);h.propTypes={onChange:c.default.func.isRequired,value:c.default.array.isRequired},t.default=h},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(3),s=function(e){var t=e.name,n=e.value,a=e.onChange,l=e.defaultColor,r=e.logos;switch(t){case"additionalSignUpFields":return o.default.createElement(i.AdditionalSignUpFieldsOption,{value:n,onChange:a});case"allowLogin":case"allowForgotPassword":case"allowSignUp":case"mustAcceptTerms":return o.default.createElement(i.BooleanOption,{name:t,value:n,onChange:a});case"initialScreen":return o.default.createElement(i.InitialScreenOption,{value:n,onChange:a});case"language":return o.default.createElement(i.LanguageOption,{value:n,onChange:a});case"logo":return o.default.createElement(i.LogoOption,{value:n,logos:r,onChange:a});case"primaryColor":return o.default.createElement(i.ColorOption,{value:n,onChange:a,defaultColor:l});case"allowedConnections":return o.default.createElement(i.ConnectionOption,{value:n,onChange:a});default:return o.default.createElement("span",null)}};s.propTypes={name:u.default.string.isRequired,onChange:u.default.func.isRequired,preset:u.default.string.isRequired,value:u.default.any.isRequired,defaultColor:u.default.string,logos:u.default.arrayOf(u.default.shape({value:u.default.string.isRequired,label:u.default.string.isRequired,icon:u.default.string.isRequired}).isRequired)},t.default=s},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(2),s=function(e){var t=e.onChange,n=e.value,a=[{value:"login",label:"login"},{value:"signUp",label:"signUp"},{value:"forgotPassword",label:"forgotPassword"}];return o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"initialScreen:",o.default.createElement(i.OptionSelector,{name:"initialScreen",onChange:t,options:a,value:n})))};s.propTypes={onChange:u.default.func.isRequired,value:u.default.string.isRequired},t.default=s},function(e,t,n){"use strict";(function(e){function a(e){return e&&e.__esModule?e:{default:e}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(0),i=a(u),s=n(1),c=a(s),d=n(42),f=function(t){function n(e){l(this,n);var a=o(this,t.call(this,e));return a.onChange=(0,d.debounce)(function(e,t){var n=(0,d.dup)(a.props.value);n[e]=t,a.props.onChange("languageDictionary",n)},400),a}return r(n,t),n.prototype.renderItem=function(e,t){var n=this;return i.default.createElement("li",{className:"line-row",key:e},i.default.createElement("span",null,e,":",i.default.createElement("input",{className:"text-input",defaultValue:t,onChange:function(t){return n.onChange(e,t.target.value)}})))},n.prototype.render=function(){var t=this,n=this.props.value;return i.default.createElement("div",{className:"line-row"},i.default.createElement("li",{className:"line-row"},i.default.createElement("span",null,"languageDictionary: ","{")),e.Object.keys(n).map(function(e){return t.renderItem(e,n[e])}),i.default.createElement("li",{className:"line-row"},i.default.createElement("span",null,"}")))},n}(u.Component);f.propTypes={onChange:c.default.func.isRequired,value:c.default.object.isRequired},t.default=f}).call(t,n(8))},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(2),s=function(e){var t=e.onChange,n=e.value,a=[{value:"en",label:"en",icon:"https://cdn.auth0.com/website/playground/flags/en-flag.svg"},{value:"zh",label:"zh",icon:"https://cdn.auth0.com/website/playground/flags/zh-flag.svg"},{value:"ja",label:"jp",icon:"https://cdn.auth0.com/website/playground/flags/ja-flag.svg"},{value:"de",label:"de",icon:"https://cdn.auth0.com/website/playground/flags/de-flag.svg"},{value:"fr",label:"fr",icon:"https://cdn.auth0.com/website/playground/flags/fr-flag.svg"},{value:"es",label:"es",icon:"https://cdn.auth0.com/website/playground/flags/es-flag.svg"},{value:"it",label:"it",icon:"https://cdn.auth0.com/website/playground/flags/it-flag.svg"},{value:"pt-br",label:"pt-br",icon:"https://cdn.auth0.com/website/playground/flags/pt-br-flag.svg"}];return o.default.createElement("span",null,o.default.createElement(i.OptionSelector,{name:"language",onChange:t,options:a,value:n}),o.default.createElement("a",{className:"see-all-languages",href:"https://auth0.com/docs/libraries/lock/v10/i18n",target:"_blank",rel:"noopener noreferrer"},"See all Languages"))};s.propTypes={onChange:u.default.func.isRequired,value:u.default.string.isRequired},t.default=s},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(0),i=a(u),s=n(1),c=a(s),d=n(2),f=function(e){function t(){var n,a,r;l(this,t);for(var u=arguments.length,i=Array(u),s=0;s<u;s++)i[s]=arguments[s];return n=a=o(this,e.call.apply(e,[this].concat(i))),a.onChange=function(e,t){a.props.onChange("logo",t)},r=n,o(a,r)}return r(t,e),t.prototype.render=function(){var e=this.props,t=e.value,n=e.logos,a=n||[{value:"default",label:"default",icon:"https://cdn.auth0.com/website/playground/others/auth0-default.svg"},{value:"logo-tmz.svg",label:"logo-tmz.svg",icon:"https://cdn.auth0.com/website/playground/others/logo-tmz.svg"},{value:"safari.svg",label:"safari.svg",icon:"https://cdn.auth0.com/website/playground/others/safari.svg"},{value:"schneider.svg",label:"schneider.svg",icon:"https://cdn.auth0.com/website/playground/others/schneider.svg"}];return i.default.createElement(d.OptionSelector,{name:"logo",onChange:this.onChange,options:a,value:t})},t}(u.Component);f.propTypes={logos:c.default.arrayOf(c.default.shape({value:c.default.string.isRequired,label:c.default.string.isRequired,icon:c.default.string.isRequired}).isRequired),value:c.default.string.isRequired,onChange:c.default.func.isRequired},t.default=f},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(2),s=function(e){var t=e.onChange,n=e.value,a=[{value:"small",label:"small"},{value:"big",label:"big"}];return o.default.createElement("li",{className:"line-row"},o.default.createElement("span",null,"socialButtonStyle:",o.default.createElement(i.OptionSelector,{name:"socialButtonStyle",onChange:t,options:a,value:n})))};s.propTypes={onChange:u.default.func.isRequired,value:u.default.string.isRequired},t.default=s},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(2),s=n(6),c=function(e){var t=e.optionsString,n=e.docsUrl;return o.default.createElement("ul",{className:"footer-links"},o.default.createElement("li",null,o.default.createElement("a",{href:n,target:"_blank",rel:"noopener noreferrer"},o.default.createElement(s.ReadIcon,null),"Read the docs")),o.default.createElement("li",null,o.default.createElement(i.CodePenButton,{optionsString:t})))};c.propTypes={optionsString:u.default.string.isRequired,docsUrl:u.default.string.isRequired},t.default=c},function(e,t,n){"use strict";t.__esModule=!0;var a=n(0),l=function(e){return e&&e.__esModule?e:{default:e}}(a),o=function(){return l.default.createElement("svg",{width:"16px",height:"16px",viewBox:"0 0 16 16"},l.default.createElement("path",{stroke:"none",fill:"#FFFFFF",d:"M2,3.5 L0.5,3.5 L0.5,14 C0.5,14.825 1.175,15.5 2,15.5 L12.5,15.5 L12.5,14 L2,14 L2,3.5 L2,3.5 Z M14,0.5 L5,0.5 C4.175,0.5 3.5,1.175 3.5,2 L3.5,11 C3.5,11.825 4.175,12.5 5,12.5 L14,12.5 C14.825,12.5 15.5,11.825 15.5,11 L15.5,2 C15.5,1.175 14.825,0.5 14,0.5 L14,0.5 Z M13.25,7.25 L5.75,7.25 L5.75,5.75 L13.25,5.75 L13.25,7.25 L13.25,7.25 Z M10.25,10.25 L5.75,10.25 L5.75,8.75 L10.25,8.75 L10.25,10.25 L10.25,10.25 Z M13.25,4.25 L5.75,4.25 L5.75,2.75 L13.25,2.75 L13.25,4.25 L13.25,4.25 Z"}))};t.default=o},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=function(e){var t=e.text,n=e.image,a=e.index,l=e.active,r=e.handleClick;return o.default.createElement("li",{className:"language-selector-item "+(l?"active":""),onClick:function(){return r(a)}},o.default.createElement("img",{src:n,className:"icon",role:"presentation"}),o.default.createElement("span",{className:"text"},t))};i.propTypes={text:u.default.string.isRequired,image:u.default.string.isRequired,active:u.default.bool.isRequired,index:u.default.number.isRequired,handleClick:u.default.func.isRequired};var s=[{text:"Web",image:"https://cdn.auth0.com/website/playground/platforms/lock-web-icon.svg"},{text:"iOS",image:"https://cdn.auth0.com/website/playground/platforms/lock-ios-icon.svg"},{text:"Android",image:"https://cdn.auth0.com/website/playground/platforms/lock-android-icon.svg"}],c=function(e){var t=e.selectedLanguageIndex,n=e.handleItemClick;return o.default.createElement("div",{className:"language-selector"},o.default.createElement("div",{className:"container"},o.default.createElement("ul",{className:"language-selector-list"},s.map(function(e,a){return o.default.createElement(i,{key:e.text,text:e.text,image:e.image,index:a,active:a===t,handleClick:n})}))))};c.propTypes={selectedLanguageIndex:u.default.number.isRequired,handleItemClick:u.default.func.isRequired},t.default=c},function(e,t,n){"use strict";t.__esModule=!0,t.default=void 0;var a=n(29),l=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=l.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function u(e,t){var n=t.defaultColor,a=t.logos,l=t.logoBaseUrl;return e.map(function(e){if("theme"===e[0]){var t={};return"default"!==e[1].logo?t.logo=(l||"")+e[1].logo:a&&(t.logo=a[0].icon),"default"!==e[1].primaryColor?t.primaryColor=e[1].primaryColor:n&&(t.primaryColor=n),e[0]+": "+JSON.stringify(t)}return e[0]+": "+JSON.stringify(e[1])}).join(",\n")}function i(e,t){var n=t.defaultColor,a=t.logos,l=t.logoBaseUrl;return e.reduce(function(e,t){return"theme"===t[0]?(e.theme={},"default"!==t[1].logo?e.theme.logo=(l||"")+t[1].logo:a&&(e.theme.logo=a[0].icon),"default"!==t[1].primaryColor?e.theme.primaryColor=t[1].primaryColor:n&&(e.theme.primaryColor=n)):e[t[0]]=t[1],e},{})}t.__esModule=!0;var s=n(0),c=a(s),d=n(1),f=a(d),p=n(43),m=n(2),g=n(33),h=a(g),v=function(e){function t(){var n,a,r;l(this,t);for(var u=arguments.length,i=Array(u),s=0;s<u;s++)i[s]=arguments[s];return n=a=o(this,e.call.apply(e,[this].concat(i))),a.state={options:h.default.login,preset:"login",selectedLanguageIndex:0},a.setPreset=function(e){var t=h.default[e];t&&a.setState({preset:e,options:t})},a.setOption=function(e,t){var n=a.state.options.map(function(n){return n[0]===e?[e,t]:n});a.setState({options:n})},a.setSelectedType=function(e){a.setState({selectedLanguageIndex:e})},r=n,o(a,r)}return r(t,e),t.prototype.render=function(){var e=this.props,t=e.defaultColor,n=e.logos,a=this.state.options,l=g.themePreset.map(function(e){return e[0]}),o=["theme",(0,p.fromPairs)(a.filter(function(e){return l.includes(e[0])}))],r=a.filter(function(e){return!l.includes(e[0])}).concat([o]),s=u(r,{defaultColor:t,logos:n,logoBaseUrl:this.props.defaultsLogosBaseUrl}),d=i(r,{defaultColor:t,logos:n,logoBaseUrl:this.props.defaultsLogosBaseUrl}),f=c.default.createElement(m.Preview,{optionsString:s,options:d,hideName:this.props.hideName}),h=c.default.createElement(m.Editor,{selectedLanguageIndex:this.state.selectedLanguageIndex,onOptionChange:this.setOption,options:this.state.options,preset:this.state.preset,logoBaseUrl:this.props.defaultsLogosBaseUrl,logos:this.props.logos,defaultColor:this.props.defaultColor,hideName:this.props.hideName,optionsString:s});return c.default.createElement("div",{className:"lock-playground"},c.default.createElement(m.LanguageSelector,{selectedLanguageIndex:this.state.selectedLanguageIndex,handleItemClick:this.setSelectedType}),c.default.createElement("div",{className:"editor-section"},c.default.createElement("div",{className:"container"},c.default.createElement("div",{className:"row"},c.default.createElement("div",{className:"col-xs-12 col-md-7"},h),c.default.createElement("div",{className:"col-md-5 hidden-xs hidden-sm"},f)))))},t}(s.Component);v.propTypes={defaultsLogosBaseUrl:f.default.string,defaultColor:f.default.string,logos:f.default.arrayOf(f.default.shape({value:f.default.string.isRequired,label:f.default.string.isRequired,icon:f.default.string.isRequired}).isRequired),hideName:f.default.bool},v.defaultProps={defaultsLogosBaseUrl:"https://cdn.auth0.com/website/playground/others/"},t.default=v},function(e,t,n){"use strict";t.__esModule=!0,t.default=void 0;var a=n(31),l=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=l.default},function(e,t,n){"use strict";t.__esModule=!0;var a=t.themePreset=[["primaryColor","default"],["logo","default"]],l=["language","en"],o={login:[["allowedConnections",["Username-Password-Authentication","google-oauth2"]],["rememberLastLogin",!1],["socialButtonStyle","big"]].concat(a,[["languageDictionary",{title:"Auth0"}],l])};t.default=o},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(9),s=a(i),c=function(e){var t=e.name,n=e.onChange,a=e.options,l=e.value,r=e.arrowRenderer;return o.default.createElement("div",{className:"option-selector "+t},o.default.createElement(s.default,{autoBlur:!0,name:t,value:l,options:a,onChange:function(e){n(t,e.split(","))},multi:!0,simpleValue:!0,clearable:!1,searchable:!1,arrowRenderer:r}))};c.propTypes={name:u.default.string.isRequired,onChange:u.default.func.isRequired,options:u.default.array.isRequired,value:u.default.array.isRequired,arrowRenderer:u.default.func},t.default=c},function(e,t,n){"use strict";t.__esModule=!0,t.default=void 0;var a=n(34),l=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=l.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=function(e){var t=e.onSelect,n=e.onFocus,a=e.isFocused,l=e.option,r=e.className,u=e.children,i=function(e){e.preventDefault(),e.stopPropagation(),t(l,e)},s=function(e){n(l,e)},c=function(e){a||n(l,e)},d={width:20,height:15,borderRadius:"3px",marginRight:"8px"},f={width:20,height:15,backgroundColor:l.bg,display:"inline-block",borderRadius:"3px",marginRight:"8px",position:"relative",top:"2px"},p=void 0;return p=l.icon?o.default.createElement("img",{src:l.icon,style:d,role:"presentation"}):l.bg?o.default.createElement("span",{style:f}):"",o.default.createElement("div",{className:r,onMouseDown:i,onMouseEnter:s,onMouseMove:c},p," ",u)};i.propTypes={children:u.default.node,className:u.default.string,isDisabled:u.default.bool,isFocused:u.default.bool,isSelected:u.default.bool,onFocus:u.default.func,onSelect:u.default.func,option:u.default.object.isRequired},t.default=i},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=function(e){var t=e.value,n=e.children,a={width:20,height:15,borderRadius:"3px",marginRight:"8px"},l={width:20,height:15,backgroundColor:t.bg,display:"inline-block",borderRadius:"3px",marginRight:"8px"},r=void 0;return r=t.icon?o.default.createElement("img",{src:t.icon,style:a,role:"presentation"}):t.bg?o.default.createElement("span",{style:l}):"",o.default.createElement("div",{className:"Select-value"},o.default.createElement("span",{className:"Select-value-label"},r," ",n))};i.propTypes={children:u.default.node,value:u.default.object},t.default=i},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var l=n(0),o=a(l),r=n(1),u=a(r),i=n(9),s=a(i),c=n(7),d=function(e){var t=e.name,n=e.onChange,a=e.options,l=e.value;return o.default.createElement("div",{className:"option-selector "+t},o.default.createElement(s.default,{autoBlur:!0,name:t,value:l,options:a,optionComponent:c.IcoOption,valueComponent:c.IcoValue,onChange:function(e){n(t,e.value)},clearable:!1,searchable:!1}))};d.propTypes={name:u.default.string.isRequired,onChange:u.default.func.isRequired,options:u.default.array.isRequired,value:u.default.oneOfType([u.default.string,u.default.bool]).isRequired},t.default=d},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var u=n(0),i=a(u),s=n(1),c=a(s),d=function(e){return"\n<style>\n  html {\n    color: white;\n  }\n  body {\n    margin: 0;\n  }\n  .auth0-lock.auth0-lock .auth0-lock-center {\n    display: block !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  "+(e?"\n  .auth0-lock.auth0-lock .auth0-lock-header {\n    padding-top: 26px !important;\n  }\n  .auth0-lock.auth0-lock .auth0-lock-name {\n    display: none;\n  }\n  ":"")+"\n</style>"},f=function(e){function t(){var n,a,r;l(this,t);for(var u=arguments.length,i=Array(u),s=0;s<u;s++)i[s]=arguments[s];return n=a=o(this,e.call.apply(e,[this].concat(i))),a.state={screenMode:"desktop",rendered:!1},a.loadHtml=function(){if(a.desktopIframe){if(a.state.rendered)return void a.desktopIframe.contentWindow.postMessage(a.props.options,"*");var e="\n<head>\n  "+d(a.props.hideName)+'\n</head>\n<body>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/lock.min.js"><\/script>\n\n  <div id="lock-desktop"></div>\n\n  <script>\n    var options = {\n      auth: {\n        redirect: false\n      },\n      container: "lock-desktop",\n      '+a.props.optionsString+'\n    }\n\n    var w = new Auth0Lock(\n      "7I3KXNi6ZeBq6oL0xnlfk1SrW6KntwR5",\n      "pwdlessdemo.auth0.com",\n      options\n    );\n\n    w.show();\n\n    w.on(\'authenticated\', function (authResult) {\n      setTimeout(function () {\n        w.hide();\n        w.show();\n      }, 3000);\n    });\n\n    window.addEventListener(\'message\', function (event) {\n      w.hide();\n      w.show(event.data);\n    }, false);\n  <\/script>\n\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/es.js"><\/script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/it.js"><\/script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/zh.js"><\/script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/fr.js"><\/script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/de.js"><\/script>\n  <script src="https://cdn.auth0.com/js/lock/10.16.0/ja.js"><\/script>\n\n</body>';a.desktopIframe.contentWindow.document.open(),a.desktopIframe.contentWindow.document.write(e),a.desktopIframe.contentWindow.document.close(),a.setState({rendered:!0})}},r=n,o(a,r)}return r(t,e),t.prototype.componentDidMount=function(){this.loadHtml()},t.prototype.componentDidUpdate=function(){this.loadHtml()},t.prototype.render=function(){var e=this;return i.default.createElement("div",{className:"browser-web"},i.default.createElement("iframe",{className:"iframe lock-iframe",ref:function(t){e.desktopIframe=t}}))},t}(u.Component);f.propTypes={optionsString:c.default.string.isRequired,options:c.default.object.isRequired,hideName:c.default.bool},t.default=f},function(e,t,n){"use strict";t.__esModule=!0,t.default=void 0;var a=n(39),l=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=l.default},function(e,t,n){"use strict";t.__esModule=!0,t.default=void 0,n(10);var a=n(2),l=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=l.default},function(e,t,n){"use strict";(function(e){function n(e,t){var n=void 0;return function(){function a(){clearTimeout(n),e.apply(void 0,o)}for(var l=arguments.length,o=Array(l),r=0;r<l;r++)o[r]=arguments[r];clearTimeout(n),n=setTimeout(a,t)}}function a(t){for(var n=arguments.length,a=Array(n>1?n-1:0),l=1;l<n;l++)a[l-1]=arguments[l];return a.forEach(function(n){e.Object.keys(n).forEach(function(e){t[e]=n[e]})}),t}function l(e){return a({},e)}t.__esModule=!0,t.debounce=n,t.dup=l}).call(t,n(8))},function(e,t){e.exports=__webpack_require__(8)}])});


/***/ }),
/* 368 */
/***/ (function(module, exports) {

var WinChan = (function() {
  var RELAY_FRAME_NAME = "__winchan_relay_frame";
  var CLOSE_CMD = "die";

  // a portable addListener implementation
  function addListener(w, event, cb) {
    if(w.attachEvent) w.attachEvent('on' + event, cb);
    else if (w.addEventListener) w.addEventListener(event, cb, false);
  }

  // a portable removeListener implementation
  function removeListener(w, event, cb) {
    if(w.detachEvent) w.detachEvent('on' + event, cb);
    else if (w.removeEventListener) w.removeEventListener(event, cb, false);
  }


  // checking for IE8 or above
  function isInternetExplorer() {
    if (typeof navigator === 'undefined') {
      return false;
    }

    var rv = -1; // Return value assumes failure.
    var ua = navigator.userAgent;
    if (navigator.appName === 'Microsoft Internet Explorer') {
      var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
      if (re.exec(ua) != null)
        rv = parseFloat(RegExp.$1);
    }
    // IE > 11
    else if (ua.indexOf("Trident") > -1) {
      var re = new RegExp("rv:([0-9]{2,2}[\.0-9]{0,})");
      if (re.exec(ua) !== null) {
        rv = parseFloat(RegExp.$1);
      }
    }

    return rv >= 8;
  }

  // checking Mobile Firefox (Fennec)
  function isFennec() {
    try {
      // We must check for both XUL and Java versions of Fennec.  Both have
      // distinct UA strings.
      var userAgent = navigator.userAgent;
      return (userAgent.indexOf('Fennec/') != -1) ||  // XUL
             (userAgent.indexOf('Firefox/') != -1 && userAgent.indexOf('Android') != -1);   // Java
    } catch(e) {}
    return false;
  }

  // feature checking to see if this platform is supported at all
  function isSupported() {
    return (typeof window !== 'undefined' && window.JSON && window.JSON.stringify &&
            window.JSON.parse && window.postMessage);
  }

  // given a URL, extract the origin. Taken from: https://github.com/firebase/firebase-simple-login/blob/d2cb95b9f812d8488bdbfba51c3a7c153ba1a074/js/src/simple-login/transports/WinChan.js#L25-L30
  function extractOrigin(url) {
    if (!/^https?:\/\//.test(url)) url = window.location.href;
    var m = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
    if (m) return m[1];
    return url;
  }

  // find the relay iframe in the opener
  function findRelay() {
    var loc = window.location;
    var frames = window.opener.frames;
    for (var i = frames.length - 1; i >= 0; i--) {
      try {
        if (frames[i].location.protocol === window.location.protocol &&
            frames[i].location.host === window.location.host &&
            frames[i].name === RELAY_FRAME_NAME)
        {
          return frames[i];
        }
      } catch(e) { }
    }
    return;
  }

  var isIE = isInternetExplorer();

  if (isSupported()) {
    /*  General flow:
     *                  0. user clicks
     *  (IE SPECIFIC)   1. caller adds relay iframe (served from trusted domain) to DOM
     *                  2. caller opens window (with content from trusted domain)
     *                  3. window on opening adds a listener to 'message'
     *  (IE SPECIFIC)   4. window on opening finds iframe
     *                  5. window checks if iframe is "loaded" - has a 'doPost' function yet
     *  (IE SPECIFIC5)  5a. if iframe.doPost exists, window uses it to send ready event to caller
     *  (IE SPECIFIC5)  5b. if iframe.doPost doesn't exist, window waits for frame ready
     *  (IE SPECIFIC5)  5bi. once ready, window calls iframe.doPost to send ready event
     *                  6. caller upon reciept of 'ready', sends args
     */
    return {
      open: function(opts, cb) {
        if (!cb) throw "missing required callback argument";

        // test required options
        var err;
        if (!opts.url) err = "missing required 'url' parameter";
        if (!opts.relay_url) err = "missing required 'relay_url' parameter";
        if (err) setTimeout(function() { cb(err); }, 0);

        // supply default options
        if (!opts.window_name) opts.window_name = null;
        if (!opts.window_features || isFennec()) opts.window_features = undefined;

        // opts.params may be undefined

        var iframe;

        // sanity check, are url and relay_url the same origin?
        var origin = opts.origin || extractOrigin(opts.url);
        if (origin !== extractOrigin(opts.relay_url)) {
          return setTimeout(function() {
            cb('invalid arguments: origin of url and relay_url must match');
          }, 0);
        }

        var messageTarget;

        if (isIE) {
          // first we need to add a "relay" iframe to the document that's served
          // from the target domain.  We can postmessage into a iframe, but not a
          // window
          iframe = document.createElement("iframe");
          // iframe.setAttribute('name', framename);
          iframe.setAttribute('src', opts.relay_url);
          iframe.style.display = "none";
          iframe.setAttribute('name', RELAY_FRAME_NAME);
          document.body.appendChild(iframe);
          messageTarget = iframe.contentWindow;
        }

        var w = opts.popup || window.open(opts.url, opts.window_name, opts.window_features);
        if (opts.popup) {
          w.location.href = opts.url;
        }

        if (!messageTarget) messageTarget = w;

        // lets listen in case the window blows up before telling us
        var closeInterval = setInterval(function() {
          if (w && w.closed) {
            cleanup();
            if (cb) {
              cb('User closed the popup window');
              cb = null;
            }
          }
        }, 500);

        var req = JSON.stringify({a: 'request', d: opts.params});

        // cleanup on unload
        function cleanup() {
          if (iframe) document.body.removeChild(iframe);
          iframe = undefined;
          if (closeInterval) closeInterval = clearInterval(closeInterval);
          removeListener(window, 'message', onMessage);
          removeListener(window, 'unload', cleanup);
          if (w) {
            try {
              w.close();
            } catch (securityViolation) {
              // This happens in Opera 12 sometimes
              // see https://github.com/mozilla/browserid/issues/1844
              messageTarget.postMessage(CLOSE_CMD, origin);
            }
          }
          w = messageTarget = undefined;
        }

        addListener(window, 'unload', cleanup);

        function onMessage(e) {
          if (e.origin !== origin) { return; }
          try {
            var d = JSON.parse(e.data);
          } catch(err) {
            if (cb) {
              cb(err);
            } else {
              throw err;
            }
          }

          if (d.a === 'ready') {
            messageTarget.postMessage(req, origin);
          } else if (d.a === 'error') {
            cleanup();
            if (cb) {
              cb(d.d);
              cb = null;
            }
          } else if (d.a === 'response') {
            cleanup();
            if (cb) {
              cb(null, d.d);
              cb = null;
            }
          }
        }

        addListener(window, 'message', onMessage);

        return {
          close: cleanup,
          focus: function() {
            if (w) {
              try {
                w.focus();
              } catch (e) {
                // IE7 blows up here, do nothing
              }
            }
          }
        };
      },
      onOpen: function(cb) {
        var o = "*";
        var msgTarget = isIE ? findRelay() : window.opener;
        if (!msgTarget) throw "can't find relay frame";
        function doPost(msg) {
          msg = JSON.stringify(msg);
          if (isIE) msgTarget.doPost(msg, o);
          else msgTarget.postMessage(msg, o);
        }

        function onMessage(e) {
          // only one message gets through, but let's make sure it's actually
          // the message we're looking for (other code may be using
          // postmessage) - we do this by ensuring the payload can
          // be parsed, and it's got an 'a' (action) value of 'request'.
          var d;
          try {
            d = JSON.parse(e.data);
          } catch(err) { }
          if (!d || d.a !== 'request') return;
          removeListener(window, 'message', onMessage);
          o = e.origin;
          if (cb) {
            // this setTimeout is critically important for IE8 -
            // in ie8 sometimes addListener for 'message' can synchronously
            // cause your callback to be invoked.  awesome.
            setTimeout(function() {
              cb(o, d.d, function(r) {
                cb = undefined;
                doPost({a: 'response', d: r});
              });
            }, 0);
          }
        }

        function onDie(e) {
          if (e.data === CLOSE_CMD) {
            try { window.close(); } catch (o_O) {}
          }
        }
        addListener(isIE ? msgTarget : window, 'message', onMessage);
        addListener(isIE ? msgTarget : window, 'message', onDie);

        // we cannot post to our parent that we're ready before the iframe
        // is loaded. (IE specific possible failure)
        try {
          doPost({a: "ready"});
        } catch(e) {
          // this code should never be exectued outside IE
          addListener(msgTarget, 'load', function(e) {
            doPost({a: "ready"});
          });
        }

        // if window is unloaded and the client hasn't called cb, it's an error
        var onUnload = function() {
          try {
            // IE8 doesn't like this...
            removeListener(isIE ? msgTarget : window, 'message', onDie);
          } catch (ohWell) { }
          if (cb) doPost({ a: 'error', d: 'client closed window' });
          cb = undefined;
          // explicitly close the window, in case the client is trying to reload or nav
          try { window.close(); } catch (e) { }
        };
        addListener(window, 'unload', onUnload);
        return {
          detach: function() {
            removeListener(window, 'unload', onUnload);
          }
        };
      }
    };
  } else {
    return {
      open: function(url, winopts, arg, cb) {
        setTimeout(function() { cb("unsupported browser"); }, 0);
      },
      onOpen: function(cb) {
        setTimeout(function() { cb("unsupported browser"); }, 0);
      }
    };
  }
})();

if (typeof module !== 'undefined' && module.exports) {
  module.exports = WinChan;
}


/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = [
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/4e463e5cabf12fc0e085272abc1c1703",
		"active": true,
		"name": "Dave Wilner",
		"title": "VP of Sales",
		"quote": "Revenue Leader. Team builder. 80s music master."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/c38c5f8f9decc46a0c61a2db3243dd2c?s=200",
		"active": true,
		"name": "Andrew Johnson",
		"title": "Sales System Administrator",
		"quote": "Salesforce.com Mage from the Upper Left Coast of the USA."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5a6d24cf3085ee2cd46a3ad9304b95e0?s=200",
		"active": true,
		"name": "Jordan Chandler",
		"title": "UK & EMEA, Account Development Representative",
		"quote": "Live, Love, Learn & Laugh."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/397f3a7617bc4bd8ab17888648c06f7a?s=200",
		"active": true,
		"name": "Paul Homer",
		"title": "Director of Sales Operations",
		"quote": "Fixing what's broke and improving what ain't."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2c7f6c3eb78ec893ade69318ed26e5b5",
		"active": true,
		"name": "Nelly Delgado",
		"title": "Customer Onboarding Manager",
		"quote": "Jogger, soccer mom, dog lover."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/2011ea0d651fbbd565c0b03501fbf75d?s=200",
		"active": true,
		"name": "James Bang",
		"title": "Marketing Operations Manager",
		"quote": "Marketing automation. Clean design. Ex-ESP. Acai bowls."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/d898527531aa4dc2111f86a2a7da8f77?s=80",
		"active": true,
		"name": "Kevin Kowalkowski",
		"title": "Enterprise Account Manager",
		"quote": "New Sales, Dad, Soccer Coach, Goal: Get into the shape I was in in college."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/27396b3fa24389198ef5d3e7e410e9c4?size=200",
		"active": false,
		"name": "Ricardo Rauch",
		"mail": "ricky@auth0.com",
		"title": "Head of Design",
		"quote": "Designer / Developer. He previously contributed to OSS projects. Sketch, Pug (Jade) & Stylus.",
		"social": {
			"twitter": "https://twitter.com/rickyrauch",
			"git": "https://github.com/rickyrauch",
			"dribble": "https://dribbble.com/rickyrauch"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/1c9619a22f32012221bd59296dc9a1a2?size=200",
		"active": true,
		"name": "Damian Schenkelman",
		"title": "Engineer",
		"quote": "Backend Ranger. Asado Advocate. Joke Teller. Human Reverse Proxy.",
		"social": {
			"twitter": "https://twitter.com/dschenkelman",
			"git": "https://github.com/dschenkelman"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/75685fa1a59cef5672f0c0c16e260142.png?size=200",
		"active": false,
		"name": "Rodrigo López Dato",
		"title": "Engineer",
		"quote": "I write functional programs and bob my head in odd time signatures.",
		"social": {
			"twitter": "https://twitter.com/rolodato",
			"git": "https://github.com/rolodato"
		}
	},
	{
		"avatarUrl": "https://avatars1.githubusercontent.com/u/655409?v=3&s=460",
		"active": true,
		"name": "Sandrino Di Mattia",
		"mail": "sandrino@auth0.com",
		"title": "Product Owner",
		"quote": "Developer. Father of 3. Microsoft Azure MVP.",
		"social": {
			"twitter": "https://www.twitter.com/sandrinodm"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/5196c6f42d47f5583bbce2120affd4b1?size=200",
		"active": true,
		"name": "Matías Woloski",
		"mail": "matias@auth0.com",
		"title": "Co-Founder, CTO",
		"quote": "Crypto Geek. Culture Maker. Piano Player.",
		"social": {
			"twitter": "https://twitter.com/woloski",
			"git": "https://github.com/woloski"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/df6c864847fba9687d962cb80b482764?size=200",
		"active": true,
		"name": "Martín Gontovnikas",
		"title": "VP of Marketing and Analytics",
		"quote": "Software Engineer at ❤️. Conference speaker 🎙. Read my story at https://gon.to 📚",
		"social": {
			"twitter": "https://twitter.com/mgonto",
			"git": "https://github.com/mgonto"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/53f70144dc9d7c76455fa91f858d4cec?size=200",
		"active": true,
		"name": "Tomasz Janczuk",
		"mail": "tomek@auth0.com",
		"title": "Engineer",
		"quote": "Software - shaken, not stirred. Auth0 via MS (12 years), HP (1/2 years), and 47 Chapters.",
		"social": {
			"twitter": "https://twitter.com/tjanczuk",
			"git": "https://github.com/tjanczuk"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/bb92524137114d812aa1cbbe70d35365?size=200",
		"active": true,
		"name": "Geoffrey Goodman",
		"title": "Engineer",
		"quote": "Creater of Plunker. Self-taught programmer and former Big 4 accountant. Off the beaten path.",
		"social": {
			"twitter": "https://twitter.com/filearts",
			"git": "https://github.com/ggoodman"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/355ebc2fef7f2c3d095887cb2920041f?size=200",
		"active": true,
		"name": "Richard Seldon",
		"mail": "richard.seldon@auth0.com",
		"title": "Customer Success Engineer",
		"quote": "Full-Stack Software Engineer. Consultant.",
		"social": {
			"twitter": "https://www.twitter.com/arcseldon"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/34f27c88555c8c99b965d8137e16bfd9?size=200",
		"active": true,
		"name": "Cristian Douce",
		"mail": "cristian@auth0.com",
		"title": "Engineer",
		"quote": "Javascript Mechanic. Node.js zen-monk. OSS contributor. CDD & HRDD.",
		"social": {
			"twitter": "https://twitter.com/cristiandouce",
			"git": "https://github.com/cristiandouce"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/1329d9e3f4bc1d233788c89c04410bfe.png?size=200",
		"active": true,
		"name": "Victor Fernandez",
		"mail": "victor@auth0.com",
		"title": "Lead Designer",
		"quote": "Design fundamentalist. Hipster developer. Lego assembly line expert.",
		"social": {
			"twitter": "https://twitter.com/vctrfrnndz",
			"git": "https://github.com/vctrfrnndz",
			"dribble": "https://dribbble.com/vctrfrnndz"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/b93af62499ed0f76f280acb37913f15d.png?size=200",
		"active": true,
		"name": "Hernan Zalazar",
		"mail": "hernan@auth0.com",
		"title": "Engineer (Native UX)",
		"quote": "Mobile wizard, jack of all trades. Beer & Football fundamentalist. Scotch aficionado.",
		"social": {
			"twitter": "https://twitter.com/hzalaz",
			"git": "https://github.com/hzalaz"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/5a176c2593d9ec66b998ff09e715821d?size=200",
		"active": true,
		"name": "Daniel Lobo",
		"title": "Developer Success Engineer",
		"quote": "Node.js guy. Runner. Nyctophilic.",
		"social": {
			"twitter": "https://twitter.com/daniw0lf",
			"git": "https://github.com/lobo"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/mark-56b6805207.png",
		"active": true,
		"name": "Mark Olson",
		"title": "VP Finance & Operations",
		"quote": "Compliance. Excel is my middle name."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/6c6e0fc118f7fe998f8621165e147d98?size=200",
		"active": false,
		"name": "Federico Jack",
		"title": "Director of Finance & Operations",
		"quote": "Finance. Operations. Ultramarathon runner.",
		"social": {
			"twitter": "https://twitter.com/fedejack"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/4d44bd6c8bbd97dfeb5e9c299aaa68c5?size=200",
		"active": true,
		"name": "Jose Romaniello",
		"title": "Head Of Engineering",
		"mail": "jose@auth0.com",
		"quote": "Coder. Dad. OSS contributor. Fernet Barista.",
		"social": {
			"twitter": "https://twitter.com/jfroma",
			"git": "https://github.com/jfromaniello"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/yvonne-e6eeb0ffc5.jpg",
		"active": true,
		"name": "Yvonne Wilson",
		"title": "Director of Customer Success",
		"quote": "Identity,  Security, Operational Excellence,  Scaling, Tech Adventurer, Cyclist & Quilter."
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/eugenio-06259616c9.png",
		"active": true,
		"name": "Eugenio Pace",
		"title": "Co-Founder, VP Customer Success",
		"quote": "Electrical engineer. Software practitioner. Amateur mechanic & builder. <3 customers.",
		"social": {
			"twitter": "https://twitter.com/eugenio_pace"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/35b47dce0e2c9ced8b500dca20e1a657.png?size=200",
		"active": true,
		"name": "Benjamín Flores",
		"mail": "benjamin@auth0.com",
		"title": "User Interface Developer",
		"quote": "Dev passionate. Geek toys lover. Capital City hater. All is possible with cheerful music.",
		"social": {
			"twitter": "https://twitter.com/beneliflo_"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jon-68721f2363.png",
		"active": true,
		"name": "Jon Gelsey",
		"title": "CEO",
		"quote": "CEO. Ex-Microsoft. Ex-Intel. Ex-Convex. Designer of super computers.",
		"social": {
			"twitter": "https://twitter.com/jgelsey"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jeremy-be009fa940.png",
		"active": true,
		"name": "Jeremy Jacobs",
		"title": "Director of Sales & Business development",
		"quote": "Expert Developer... of Relationships. CRM/Excel Geek. Hit a homerun at Yankee Stadium."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/43103c16a95db00e7bab1f34d4d6ff8c?size=200",
		"active": true,
		"name": "Sebastian Iacomuzzi",
		"mail": "iaco@auth0.com",
		"title": "Engineer",
		"quote": "Backend Dev from Quemu Quemu, La Pampa. I know what \"Zermatt\" means.",
		"social": {
			"twitter": "https://twitter.com/sebasiaco",
			"git": "https://github.com/siacomuzzi"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/fd8e29ed66618ba98de8e0b09e09c353.png?size=200",
		"active": true,
		"name": "Sebastian Rodriguez Guevara",
		"title": "DevOps Engineer",
		"quote": "Linux lover, former sysadmin. Beatles fan."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d48b998c2dce49ca309710eba498c562.png?s=200",
		"active": true,
		"name": "Nathan Totten",
		"title": "Director of Product Management",
		"quote": "Developer, customer success, learning. Formerly, Microsoft and Iowa.",
		"social": {
			"twitter": "http://twitter.com/ntotten",
			"git": "https://github.com/ntotten"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/48537be253912e7348715f32cd21584b.png?s=200",
		"active": true,
		"name": "Federico Molina",
		"title": "Growth & Analytics",
		"quote": "A little bit of Something.",
		"social": {
			"twitter": "https://www.twitter.com/federicomolina"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/647b1eea820b3fc8a5aee0383930b888.png?size=200",
		"active": true,
		"name": "Pablo Terradillos",
		"mail": "pablo.terradillos@auth0.com",
		"title": "Engineer",
		"quote": "Developer. OSS fan. Half actor and Pokemon trainer.",
		"social": {
			"twitter": "https://twitter.com/tehsis",
			"git": "https://github.com/tehsis"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/667b1c82b6cc2241ff176d50c65da603?size=200",
		"active": true,
		"name": "Eugene Kogan",
		"title": "Head of Security",
		"quote": "Information security engineer. Loves the outdoors, especially mountains.",
		"social": {
			"twitter": "https://twitter.com/eugk",
			"git": "https://github.com/eugk"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jared-0dad95f6ee.png",
		"active": true,
		"name": "Jared Hanson",
		"mail": "jared@auth0.com",
		"title": "Engineer",
		"quote": "Developer of Passport.js and other open source Node.js modules.",
		"social": {
			"twitter": "https://twitter.com/jaredhanson",
			"git": "https://github.com/jaredhanson"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/clayton-2e74b049e9.png",
		"active": true,
		"name": "Clayton Moulynox",
		"title": "Director of Partner Cloud MIS Strategy & Programs",
		"quote": "Technology enabler; status quo challenger; ex-Microsoft; an Aussie - G'day mate!",
		"social": {
			"twitter": "https://twitter.com/claytonhm"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/kelsey-03bbe39096.png",
		"active": false,
		"name": "Kelsey Flittner",
		"title": "Director of marketing and communications",
		"quote": "Brand. Marketing. Communications. I love chocolate. The end.",
		"social": {
			"twitter": "https://twitter.com/kelseyoneal"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/german-3aa35d2747.png",
		"active": true,
		"name": "Germán Lena",
		"mail": "german@auth0.com",
		"title": "Engineer",
		"quote": "Love to make things. OSS, data analysis and visualization fan. Surf enthusiast.",
		"social": {
			"twitter": "https://twitter.com/german_lena",
			"git": "https://github.com/glena"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/da735b48d8300a97640149156b650305.png?size=200",
		"active": true,
		"name": "Luciano Balmaceda",
		"mail": "luciano.balmaceda@auth0.com",
		"title": "Mobile Engineer",
		"quote": "NodeJS & Android Developer. I love to home brew beer and even enjoy consuming them!",
		"social": {
			"twitter": "https://twitter.com/balmalucho",
			"git": "https://github.com/lbalmaceda"
		}
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/erin-d40dff3040.png",
		"active": true,
		"name": "Erin Staeger",
		"title": "HR Manager",
		"quote": "Human Resources, Ex-Accountant, Amateur Interior Designer, Dog Lover."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/3f695f9558dd12d86a90dbc59b284f9b.png?size=200",
		"active": true,
		"name": "Leonardo Helman",
		"title": "DevOps Engineer",
		"quote": "Developer. Sysadmin. Technical. Pilot.",
		"social": {
			"git": "https://github.com/lhelman"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/8541998714e3047fb0e52422ba8dff13.png?size=200",
		"active": true,
		"name": "Peter Stromquist",
		"title": "Head of Pre-Sales Engineering",
		"quote": "Family man. Fixed-gear biker. Learn -> Teach -> Learn. Minimalist Platforms and Lightweight Frameworks.",
		"social": {
			"twitter": "https://twitter.com/twistedstream",
			"git": "https://github.com/twistedstream"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/7d590747a0cd8e24a4c86dd5fd9990ef?size=200",
		"active": true,
		"name": "Hernán Tierno",
		"mail": "hernan.tierno@auth0.com",
		"title": "Engineer",
		"quote": "Passionate Software Developer. Love simple solutions and the Unix Philosophy.",
		"social": {
			"twitter": "https://twitter.com/hernanhht",
			"git": "https://github.com/hernanhht"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/05a4170856a6157f81319595e42fdc5b?size=200",
		"active": false,
		"name": "Gabriel Andretta",
		"mail": "gabriel@auth0.com",
		"title": "Engineer",
		"quote": "I like programming languages where parens hug the code.",
		"social": {
			"twitter": "https://twitter.com/gnandretta",
			"git": "https://github.com/gnandretta"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/bb9128fac91692ad4f46a785d772dd39?s=200",
		"active": true,
		"name": "Pablo Seibelt",
		"title": "Data Scientist",
		"quote": "Software Developer, Data Science Specialist & Otaku. Mate and Chipá advocate.",
		"social": {
			"twitter": "https://twitter.com/sicarul",
			"git": "https://github.com/sicarul"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/73beae90bfcfea6bb084d34120e8b9cf?size=200",
		"active": false,
		"name": "Chris Keyser",
		"mail": "chris@auth0.com",
		"title": "Product Owner, Appliance",
		"quote": "Coder. Navy nuke. Harley rider. Lousy golfer.",
		"social": {
			"twitter": "https://twitter.com/chriskeyser"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/977b4137e1b2dd12d168726ede712b68?size=200",
		"active": true,
		"name": "Martin Cabral",
		"mail": "martin.cabral@auth0.com",
		"title": "Engineer",
		"quote": "Code writer. Music Lover. Tennis player wannabe.",
		"social": {
			"twitter": "https://twitter.com/mcabral_",
			"git": "https://github.com/cabralmartin"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2e8f0e9220f907fba93b524a25bdffcb?s=200",
		"active": true,
		"name": "Federico Otero",
		"title": "Data Engineer",
		"quote": "Data engineer, reporting specialist. Guitar Hero."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/ef8017f9c3c5a3264839361d977adcce?s=200",
		"active": true,
		"name": "Tomás Chernov",
		"mail": "tomas.chernov@auth0.com",
		"title": "Front End Developer",
		"quote": "Front end coder, 60fps animations mandatory. Arts enthusiast, tennis lover.",
		"social": {
			"twitter": "https://twitter.com/Shernzs",
			"git": "https://github.com/cherna"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/55ef468c3f2e7394bf451245f59747a5?s=200",
		"active": false,
		"name": "Matthew Durkin",
		"title": "Business Development",
		"quote": "Builds business relationships, empathy for developers, U.S.C.G. Licensed Captain."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/20b7b6bd9a774a96a627324fbc7ebdd7.png?s=200",
		"active": false,
		"name": "Matias Lopez Riglos",
		"title": "DevOps Engineer",
		"quote": "Sysadmin. Linux fan. Husband and father of 2. Futbol as a way of life",
		"social": {
			"git": "https://github.com/mflopez79"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/2b1e18889a07b55e88b518dca0013bd6.png?s=200",
		"active": true,
		"name": "Soledad Pano",
		"title": "Customer Success Engineer",
		"quote": "Full time mother of 2. I enjoy working as a software engineer in my \"spare time\"",
		"social": {
			"twitter": "https://twitter.com/solepano",
			"git": "https://github.com/solepano"
		}
	},
	{
		"avatarUrl": "https://0.gravatar.com/avatar/a1c61dfb3670fa0617364f5179cc13b0.png?s=200",
		"active": true,
		"name": "Damian Fortuna",
		"mail": "damian.fortuna@auth0.com",
		"title": "Front End Developer",
		"quote": "Love coding, running and fixing (actually breaking) things :).",
		"social": {
			"twitter": "https://twitter.com/damifortu"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/4206d30af383e56fb15aa27523c84ac1.png?s=200",
		"active": true,
		"name": "Diego Poza",
		"title": "Head of Content Marketing",
		"quote": "Systems Engineer from Corrientes. Geek. Writer. Speaker. Foodie. Gamer.",
		"social": {
			"twitter": "https://twitter.com/diegopoza",
			"git": "https://github.com/diegopoza"
		}
	},
	{
		"avatarUrl": "https://1.gravatar.com/avatar/7f4ec37467f2f7db6fffc7b4d2cc8dc2?s=250",
		"active": true,
		"name": "Ryan Chenkie",
		"title": "Product Owner",
		"quote": "Coder, guitar player, space nerd. Always learning and teaching what I know.",
		"social": {
			"twitter": "https://twitter.com/ryanchenkie",
			"git": "https://github.com/chenkie"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/56776a9dcc25e1f03aa3124cfc99df01.jpg?s=80",
		"active": true,
		"name": "Valeria Fugante",
		"title": "Accounting Manager",
		"quote": "Accounting Manager. Music and summer lover"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/casas-c7460ec106.png",
		"active": true,
		"name": "Pablo Casas",
		"title": "Data Scientist",
		"quote": "Machine Learning Specialist, helping numbers to be alive."
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/9d676c69f64d4b955dc14e1e8e85ca15?s=80",
		"active": true,
		"name": "Andrew Aviña",
		"title": "Inside Sales Executive",
		"quote": "Customer shepherd. Sports & software enthusiast. Movie quotes make up 95% of my humor."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ca578185f64251739569feed94986612?s=80",
		"active": true,
		"name": "Silvio Massari",
		"mail": "silvio.massari@auth0.com",
		"title": "Engineer",
		"quote": "Backend Dev. Dad and sailboat enthusiast."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/3b02263f5a5cb404c187f0d3f2dbbb19?s=80",
		"active": true,
		"name": "Bárbara Muñoz Cruzado",
		"title": "UI/UX Designer",
		"quote": "UI/UX Designer. Fashion Designer wannabe. Master of cooking since 1992"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/b1a976f8c9a0c7524e8bae1d6181ca05.jpg?s=80",
		"active": true,
		"name": "Hernán Meydac Jean",
		"title": "Release Manager",
		"quote": "Developer and starving writer. Dark side programmer. The answer is 42.",
		"social": {
			"twitter": "https://twitter.com/verlicredclaw",
			"git": "https://github.com/verlic"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/96298957/4431e03ec06ea68cd3f48f34016f8186.jpeg?s=80",
		"active": true,
		"name": "Liqin Mo",
		"title": "Controller",
		"quote": "CPA. Ex ME major."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/6e9c8a65f5b0f9bb57c53cdc40feecac.jpg?s=200",
		"active": true,
		"mail": "marcos.castany@auth0.com",
		"name": "Marcos Castany",
		"title": "Engineer",
		"quote": "Dev, Rugby Player, Asado fan",
		"social": {
			"twitter": "https://twitter.com/totus_hits",
			"git": "https://github.com/mcastany"
		}
	},
	{
		"avatarUrl": "https://es.gravatar.com/userimage/20584812/aa6c2ef56cd36ad3bc497ef8d39ec2f9.jpg",
		"active": true,
		"name": "Yohanna Etchemendy",
		"mail": "yohanna.etchemendy@auth0.com",
		"title": "Product Designer",
		"quote": "Designholic, Dinosaur enthusiast, Karaoke evangelist.",
		"social": {
			"twitter": "https://twitter.com/0xbunny",
			"git": "https://github.com/yohannaje",
			"dribble": "a(href=\"https://dribbble.com/0xbunny\", target=\"_blank\")"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/e5fdabb1d3e1e9e1f1dce56a7175be3e?s=80",
		"active": true,
		"name": "Keith Galloway",
		"title": "Customer Success Engineer",
		"quote": "Create - Break - Fix - Note - Repeat | Practicing the art of Rhythmically Applied Poetry"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/bc94ff6211e645a2bdb4fdc60e23ad85.jpg?s=200",
		"active": false,
		"name": "Kassandra Perch",
		"title": "Developer Evangelist",
		"quote": "Robotics Fanatic. Cat lover. Video Game player. GIF connoisseur.",
		"social": {
			"twitter": "https://twitter.com/nodebotanist",
			"git": "https://github.com/nodebotanist"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/a5878db74baa36ad0ae9cda759f9f2f8.jpg?s=200",
		"active": true,
		"name": "Javier Centurion",
		"mail": "javier.centurion@auth0.com",
		"title": "Engineer",
		"quote": "Developer. Music lover.",
		"social": {
			"twitter": "https://twitter.com/jcenturion86",
			"git": "https://github.com/jcenturion"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/7d41c3b038d67898247bff3e462c42a5?s=200",
		"active": true,
		"name": "Zulfiqar Ahmed",
		"title": "Customer Success Engineer",
		"quote": "Developer, consultant & an eager learner. Ex-Microsoft consultant.",
		"social": {
			"twitter": "https://twitter.com/zahmed",
			"git": "https://github.com/zamd"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/af23b64b853de5ae600f4d6aef7c14e0?s=200",
		"active": true,
		"name": "Alejo Fernandez",
		"title": "Engineer",
		"quote": "Full-stack Javascript developer, continuous learner, amateur cyclist, retired DJ, music lover.",
		"social": {
			"twitter": "https://twitter.com/djseika",
			"git": "https://github.com/alejofernandez"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5c3fd6858cdd6b3c924d1eccb465ee02?s=200",
		"active": true,
		"name": "Ramiro Silveyra d'Avila",
		"title": "Front End Engineer",
		"quote": "Developer, Web lover.",
		"social": {
			"twitter": "https://twitter.com/ramasilveyra",
			"git": "https://github.com/ramasilveyra"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/fa31036c556714acc4a48420117df37f?s=200",
		"active": false,
		"name": "Ignacio Esmite",
		"title": "Engineer",
		"quote": "Software Engineer, enjoy to make things happen and learn new things. Sports lover.",
		"social": {
			"twitter": "https://twitter.com/NachoEsmite",
			"git": "https://github.com/nachoesmite"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/6222081fd7dcea7dfb193788d138c457?s=200",
		"active": true,
		"name": "Jerrie Pelser",
		"title": "Engineer",
		"quote": "Software developer and world traveler.",
		"social": {
			"git": "https://github.com/jerriep"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/09951bbb702cfdad0e1ce7b82dd9a637?s=200",
		"active": true,
		"name": "Nicolas Ulrich",
		"mail": "nicolas.ulrich@auth0.com",
		"title": "Mobile Engineer",
		"quote": "Computer Engineer, open source advocate, electronics and robotics fanatic, tennis player wannabe.",
		"social": {
			"twitter": "https://twitter.com/nikolaseu",
			"git": "https://github.com/nikolaseu"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ea03ba48f7041d9bf675a067806d9d76?size=200",
		"active": true,
		"name": "Dirceu Pereira Tiegs",
		"title": "Engineer",
		"quote": "Developer, book lover, FPS noob.",
		"social": {
			"twitter": "https://twitter.com/dirceu",
			"git": "https://github.com/dirceu"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d8acebfee13c5fe4617dbf77c7058838?size=200",
		"active": true,
		"name": "Nicolas Plessis",
		"title": "Site Reliability Engineer",
		"quote": "DevOps enthusiast, cook, homebrewer & drummer.",
		"social": {
			"twitter": "https://twitter.com/choopooly",
			"git": "https://github.com/choopooly"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/da0d9774051338cb9a5854baafb2e37d?size=200",
		"active": true,
		"name": "Katherine Horne",
		"title": "Technical Writer",
		"quote": "Avid reader, knitter, doer of the New York Times Crossword Puzzles",
		"social": {
			"git": "https://github.com/khorne3"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/bb00217fba01f33cd0d12001f8f4d10f?size=200",
		"active": true,
		"name": "Vikas Jayaram",
		"title": "Developer Success Engineer",
		"quote": "Developer, Cricketer & keen learner.",
		"social": {
			"git": "https://github.com/vikasjayaram"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/3809/7b7ede19b802e02bb4320ea329ae40f2.png?size=200",
		"active": true,
		"name": "Peter Filias",
		"title": "Customer Success Manager",
		"quote": "Gamer, Father of 2, Snowboarder, Mountain Biker, Occasional Runner, Baseball Coach, Scout Leader, Lecturer",
		"social": {
			"twitter": "https://twitter.com/pfilias"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/a403bd0d4d1de0cc57239c416821bb88?size=200",
		"active": true,
		"name": "Mariano Szklanny",
		"title": "Engineering Ops Manager",
		"quote": "Geek, ex-developer, and MBA. Love driving, photography, & music."
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/30146472/88a7c03f7ed5a84757a2799332b7b0de.jpg?size=200",
		"active": true,
		"name": "Ado Kukic",
		"title": "Technical Writer",
		"quote": "VR Enthusiast, Writer, Developer, Teacher, Learner, Gopher",
		"social": {
			"twitter": "https://twitter.com/kukicadnan",
			"git": "https://github.com/kukicadnan"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/20807150/4deb2db17135af46f17d5cda3b58fd0d.png?size=200",
		"active": true,
		"name": "Kim Maida",
		"title": "Technical Writer",
		"quote": "Geek, Mother, Biologist, UI Engineer, Open Sourceror. Loves hiking, cooking, & reading.",
		"social": {
			"twitter": "https://twitter.com/KimMaida",
			"git": "https://github.com/kmaida"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/11032473/d9733dd84d700fefe0161c919e39b245.jpg?size=200",
		"active": false,
		"name": "James Fryman",
		"title": "Infrastructure Product Owner",
		"quote": "Technologist, Entrepreneur, Hacker and General Human. Searching for the meaning of life through science and technology.",
		"social": {
			"twitter": "https://twitter.com/jfryman",
			"git": "https://github.com/jfryman"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/5dbe52812be440138ca34a4dc8bc80c0?s=200",
		"active": true,
		"name": "Alex Stanciu",
		"mail": "alex@auth0.com",
		"title": "Product Owner",
		"quote": "Drinking the digital wine, dancing the electric boogaloo.",
		"social": {
			"twitter": "https://twitter.com/alecks",
			"git": "https://github.com/astanciu"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/102088726/e196809fe9c28d08da3b2bf526b41847.jpg?size=200",
		"active": true,
		"name": "Don Vaughn",
		"mail": "don.vaughn@auth0.com",
		"title": "Enterprise Account Executive",
		"quote": "Techie sales guy, big company refugee, music fan and music man",
		"social": {
			"twitter": "https://twitter.com/donvaughn"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/71313b369e8f23b7ec7b4614acdf3031.png?size=200",
		"active": true,
		"name": "Radosław Karpowicz",
		"mail": "radekk@auth0.com",
		"title": "Security Engineer",
		"quote": "Developer and security guy. Loves snowboarding and his Kawasaki bike.",
		"social": {
			"twitter": "https://twitter.com/radekk",
			"git": "https://github.com/radekk"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/102719873/125879486644022583b8d27e88a8e7d5.jpg?size=200",
		"active": true,
		"name": "Angela Lazar",
		"mail": "angela.lazar@auth0.com",
		"title": "Technical Writer",
		"quote": "Craft enthusiast, music lover, cat whisperer",
		"social": {
			"git": "https://github.com/angelaLazar"
		}
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/7db3b1488c23b208fd5b7b38498bc6d1.png?size=200",
		"active": true,
		"name": "Ashish Dasnurkar",
		"title": "Developer Success Engineer",
		"quote": "JavaScripter. Loves family, street photography, hiking, running, coffee and helping others",
		"social": {
			"git": "https://github.com/ashishdasnurkar",
			"twitter": "https://twitter.com/AshishDasnurkar"
		}
	},
	{
		"avatarUrl": "https://0.gravatar.com/avatar/c5562e4ad0d488fb4d8e1ab8819027d1?size=200",
		"active": true,
		"name": "Robert Rexford",
		"title": "Sales Engineer",
		"quote": "I miss my Amiga.",
		"social": {
			"git": "https://github.com/rrexford"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ee6fb8eb6b74f00f5324410a01f1f97e?s=200",
		"active": true,
		"name": "Prashant Trivedy",
		"title": "Developer Success Engineer",
		"quote": "Actively active in activities...and sleep.",
		"social": {
			"twitter": "https://twitter.com/mrprashantt"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/e42511d0034e0f3936941867ebdd8aea?s=200",
		"active": true,
		"name": "Bob Brumfield",
		"mail": "bob.brumfield@auth0.com@auth0.com",
		"title": "Engineer",
		"quote": "Coder, recovering Windows user, looking for next cup of coffee.",
		"social": {
			"twitter": "https://twitter.com/bobbrum"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d39ab281a5d166f71b97062a7d0d4f38?s=200",
		"active": true,
		"name": "Ariel Gerstein",
		"title": "Front end Developer",
		"quote": "Developer. Love Javascript and the web.",
		"social": {
			"twitter": "https://twitter.com/arielger_",
			"git": "https://github.com/arielger"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/612047918c9324a5b2bf9c3ca72b0110?s=200",
		"active": true,
		"name": "Mauricio Schneider",
		"title": "Developer Success Engineer",
		"quote": "I love fixing things, especially if I broke them in the first place.",
		"social": {
			"twitter": "https://twitter.com/lemavri",
			"git": "https://github.com/lemavri"
		}
	},
	{
		"avatarUrl": "https://en.gravatar.com/userimage/11371420/54f3fecf3ce3bbef2d7a62b4f0496de2.jpg?size=200",
		"active": true,
		"name": "Thameera Senanayaka",
		"title": "Developer Success Engineer",
		"quote": "1x engineer and huge SOAD fan. Life goal: understand monads.",
		"social": {
			"twitter": "https://twitter.com/thameera",
			"git": "https://github.com/thameera"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/fb206ce598852363e610e68b28cdf10a?s=200",
		"active": true,
		"name": "Germán Matosas",
		"title": "Director of Customer Success, Solutions Architecture Team",
		"quote": "Computer Engineer, ex-Microsoft, Delivery Excellence, avid learner.",
		"social": {
			"twitter": "https://twitter.com/german_matosas"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/7ecfffd77474e0d1bafa94656d1458e3?s=200",
		"active": true,
		"name": "Paul Leto",
		"title": "Senior Director of Sales",
		"quote": "Passionate sales leader/coach.  Detroit sports lover and travel fanatic."
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/4ff2f1955778896cc06318b342dabf55?size=200",
		"active": true,
		"name": "Maria Paktiti",
		"mail": "maria@auth0.com",
		"title": "Technical Writer",
		"quote": "Writer. Reader. Developer. Polymath. Dog Lover. Cannot live away from the sea.",
		"social": {
			"twitter": "https://twitter.com/mariap__",
			"git": "https://github.com/mpaktiti"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2240e74e735061332bff7a37c9c7d9c8?size=200",
		"active": true,
		"name": "Rachael Tiow",
		"title": "Corporate Sales",
		"quote": "Evangelist @Auth0, Microlender @Kiva, Sponsor @ Pencil of Promise, Olympic Weightlifter, Yogi, World Traveler & Humble Warrior.",
		"social": {
			"twitter": "https://twitter.com/rachael_tiow"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/28c9ec2561e35b62fab2820e14d1bf46?size=200",
		"active": true,
		"name": "Hugo Arregui",
		"mail": "hugo.arregui@auth0.com",
		"title": "Engineer",
		"quote": "Developer. Loves coding, linux and books.",
		"social": {
			"git": "https://github.com/hugoArregui"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/87daf4c39b1bded1f7ee5a8b4d4827a9?s=200",
		"active": true,
		"mail": "eduardo.diaz@auth0.com",
		"name": "Eduardo Díaz Sanabria",
		"title": "Engineer",
		"quote": "Software development enthusiast",
		"social": {
			"twitter": "https://twitter.com/ziluvatar",
			"git": "https://github.com/ziluvatar"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/9ccf8645ff4daa837dec9ca6fed6a0de?size=200",
		"active": true,
		"name": "Jason Strutz",
		"mail": "jason.strutz@auth0.com",
		"title": "Engineer",
		"quote": "Abstraction collector.  Hammock-driven developer.  Open web advocate.",
		"social": {
			"git": "https://github.com/jstrutz"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/3d5625c035057aa5e2535f6bf6f3c984?size=200",
		"active": false,
		"name": "Ludovic Henin",
		"title": "Engineer",
		"quote": "Lets get coding!",
		"social": {
			"git": "https://github.com/ludohenin",
			"twitter": "https://twitter.com/Ludohen"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/283ecf52eabc2338f848eb2ba4d21ddc?size=200",
		"active": true,
		"name": "Miguel Casas",
		"title": "Engineer",
		"quote": "Developer and Maker by Pasion!",
		"social": {
			"git": "https://github.com/mike-casas",
			"twitter": "https://twitter.com/neneriostb"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/aad15eb1f96fec318b1075a8c743e770?size=200",
		"active": true,
		"name": "Pushp Abrol",
		"title": "Sales Engineer",
		"quote": "Ex Dev Manager, Enjoy tennis, soccer and cricket ofcourse!",
		"social": {
			"git": "https://github.com/pushpabrol",
			"twitter": "https://twitter.com/pushpabrol"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/d70a5ec7c767da9244e702bbfc35e8d8?size=200",
		"active": true,
		"name": "Nicolás Sabena",
		"title": "Developer Success Engineer",
		"quote": "Coder. Father. Amateur pianists. Loves the outdoors, cooking and travelling.",
		"social": {
			"git": "https://github.com/nicosabena"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/e47f591f3ecaf77e1b305926b1813ea4?s=200",
		"active": true,
		"name": "Lucas Crespo",
		"title": "Data Engineer",
		"quote": "Data enthusiast. Traveler. Runner",
		"social": {
			"twitter": "https://twitter.com/LucCrespo"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/625fa32e25fbdd8ca42483f0b9e2756f?size=200",
		"active": true,
		"name": "Abhishek Hingnikar",
		"mail": "abhishek.hingnikar@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Explorer, Browser Fanboy and a Borg Drone",
		"social": {
			"git": "https://github.com/darkyen"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/79a77b32af4483ed74e03b53e1ce578a?size=200",
		"active": true,
		"name": "Sergio Fruto",
		"mail": "sergio.fruto@auth0.com",
		"title": "UI Engineer",
		"quote": "Developer in the making. Technology enthusiast. Movies, series, videogames, sports, dogs. The North Remembers.",
		"social": {
			"git": "https://github.com/sergiofruto"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/19cb9b80e4a76c3930ac3cb8c2f97cd6?size=200",
		"active": false,
		"name": "Sally Lehman",
		"mail": "sally.lehman@auth0.com",
		"title": "Production Engineer",
		"quote": "Developer. Stringer-Together of Things. Happy and still Hungry.",
		"social": {
			"twitter": "https://twitter.com/sllylhmn",
			"git": "https://github.com/rothsa"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/d5365965372e0c5843d836f660b51a84/?size=200",
		"active": true,
		"name": "Jeff Smith",
		"mail": "jeff.smith@auth0.com",
		"title": "Technical Writer",
		"quote": "Developer, writer, reader, tech geek, and forever an amateur tinkerer.",
		"social": {
			"twitter": "https://twitter.com/jeffreylees",
			"git": "https://github.com/jeffreylees"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/f88b270215f1901c4291c1f317f979bc/?size=200",
		"active": true,
		"name": "Prosper Otemuyiwa",
		"mail": "prosper.otemuyiwa@auth0.com",
		"title": "Technical Writer",
		"quote": "Software Developer . Writer . Speaker . Community Builder . Open Sourcerer",
		"social": {
			"twitter": "https://twitter.com/unicodeveloper",
			"git": "https://github.com/unicodeveloper"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/8e5a8216a606127a787669d99de86ee2/?size=200",
		"active": true,
		"name": "Carlos Mostek",
		"mail": "carlos.mostek@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Coder, Family Man (wife and three crazy kids), Soccer Addict (coach and player), Juggler, Gamer, Fun haver",
		"social": {
			"twitter": "https://twitter.com/mostekcm",
			"git": "https://github.com/mostekcm"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/8cdca0cec30a9c736394d143df7a44c2?size=200",
		"active": true,
		"name": "Yamil Asusta",
		"mail": "yamil.asusta@auth0.com",
		"title": "Production Engineer",
		"quote": "Writing and deploying code from a beach in Puerto Rico",
		"social": {
			"twitter": "https://twitter.com/elbuo8",
			"git": "https://github.com/elbuo8"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/36d0024e9a998273f9f5a5986cca232c?size=200",
		"active": true,
		"name": "Samuel Judson",
		"mail": "samuel.judson@auth0.com",
		"title": "Application Security Engineer",
		"quote": "Silently hoping for a constructive P=NP proof.",
		"social": {
			"git": "https://github.com/sjudson-auth0"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/8920d2e0274c7778848cfffcc7873415?s=480",
		"active": true,
		"name": "Annybell Villarroel",
		"mail": "annybell.villarroel@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Electronic Engineer. Software Enthusiast",
		"social": {
			"git": "https://github.com/annyv2"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/e51bcc80714c984d8a1a2a3c572a3467?size=200",
		"active": true,
		"name": "Fredrik Liljegren",
		"mail": "fredrik.liljegren@auth0.com",
		"title": "Engineer",
		"quote": "Hammock Driven Developer 👣",
		"social": {
			"git": "https://github.com/fiddur",
			"twitter": "https://twitter.com/fiddur"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/6215d8cdc86569e007d358589e9ddc76?size=200",
		"active": false,
		"name": "Vinícius Krolow",
		"mail": "vinicius.krolow@auth0.com",
		"title": "Engineer",
		"quote": "Coder and Amateur Fisherman",
		"social": {
			"git": "https://github.com/krolow",
			"twitter": "https://twitter.com/krolow"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/2d1384da60898aa1ee6cb7755eaa6a46?size=200",
		"active": true,
		"name": "Alec Pesola",
		"mail": "alec.pesola@auth0.com",
		"title": "Senior IT Support Engineer",
		"quote": "Hip-hop enthusiast, soccer fan, coffee addict",
		"social": {
			"twitter": "https://twitter.com/alecpesola"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5e137b3e18b512c421edf75eb0f6967f/?size=200",
		"active": true,
		"name": "Guillermo Mesyngier",
		"mail": "guillermo.mesyngier@auth0.com",
		"title": "Front End Developer",
		"quote": "UX and design enthusiast. Photography, illustrations, cook and biker.",
		"social": {
			"twitter": "https://twitter.com/gmesyngier",
			"git": "https://github.com/gmesyngier"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/edd4eda6a3c7d2d18e96f5ca1beea6ad?size=200",
		"active": true,
		"name": "Amaan Cheval",
		"mail": "amaan.cheval@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Aspiring serial neophyte. Interested in information security, foreign languages, kernels, compilers, and other fancy sounding things.",
		"social": {
			"twitter": "https://twitter.com/AmaanC",
			"git": "https://github.com/AmaanC"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/94167463a175f9bb522a432acef01351?s=200",
		"active": true,
		"name": "David Patrick",
		"mail": "david.patrick@auth0.com",
		"title": "Customer Success Engineer",
		"quote": "Developer, Dad, Husband, Coffee Lover, Podcast Listener",
		"social": {
			"git": "https://github.com/davidpatrick",
			"twitter": "https://twitter.com/dponrails"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/a7e145a62540d8e63e275c494b235437?s=200",
		"active": true,
		"name": "Rikaard Hosein",
		"mail": "rikaard.hosein@auth0.com",
		"title": "Engineer",
		"quote": "Developer, Security Enthusiast",
		"social": {
			"git": "https://github.com/rikaardhosein",
			"twitter": "https://twitter.com/RikaardHosein"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/c437963c0352e86575808d558736e200?s=200",
		"active": true,
		"name": "Kerry Ok",
		"mail": "kerry.ok@auth0.com",
		"title": "Sr. Director of Demand Generation",
		"quote": "Marketer + Mom who enjoys football [American], poker and games of all types"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/8bf5b1794bd461911ad8f9ec4e364272?s=200",
		"active": false,
		"name": "Carlos Johnson",
		"mail": "carlos.johnson@auth0.com",
		"title": "Engineer",
		"quote": "Programmer by day; maker by night",
		"social": {
			"git": "https://github.com/callemo"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/3586669b65dcba7785e4339684e81ae8?s=80",
		"active": true,
		"name": "Brandon Thompson",
		"mail": "brandon.thompson@auth0.com",
		"title": "Technical Account Manager",
		"quote": "Soccer, Music, Security get me up",
		"social": {
			"git": "https://github.com/BRVNDXN"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/3a5545879176d44b7ee763931ab05a57?size=200",
		"active": true,
		"name": "Justin Hinerman",
		"mail": "justin.hinerman@auth0.com",
		"title": "Product Owner",
		"quote": "Husband, Father, Coder, Drummer, Rush Fanatic. Always learning.",
		"social": {
			"git": "https://github.com/jhiner"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/38abb7da1b5442e52a1937378c2fae4a?s=200",
		"active": true,
		"name": "Glenn Block",
		"mail": "glenn.block@auth0.com",
		"title": "Director of Product Management, Webtask",
		"quote": "Every day is a chance to learn",
		"social": {
			"git": "https://github.com/glennblock",
			"twitter": "https://twitter.com/gblock"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/7659da9aa715766318710486e5f2d239/?size=200",
		"active": true,
		"name": "Shawn Meyer",
		"mail": "shawn.meyer@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Developer, runner, rec soccer all-start, coffee drinker, and family man",
		"social": {
			"git": "https://github.com/sgmeyer",
			"twitter": "https://twitter.com/sgmeyer"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/969c1c39639503981f3887d3965ae801?size=200",
		"active": true,
		"name": "Sandra Karlsson",
		"mail": "sandra.karlsson@auth0.com",
		"title": "Office Manager",
		"quote": "Travel. Hotels. Food. Fitness."
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/5bdf34cb56195a699562bb1468013154?s=200",
		"active": false,
		"name": "Kunal Batra",
		"mail": "kunal.batra@auth0.com",
		"title": "Head of Developer Evangelism",
		"quote": "Serving Developers on behalf of Auth0. Swift/Python Dev. Taco Bell Enthusiast.",
		"social": {
			"twitter": "https://twitter.com/kunal732",
			"git": "https://github.com/kunal732"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/ca7459e807cfba8abc50edbe758ee1b4?size=200",
		"active": true,
		"name": "Santiago Rodríguez",
		"mail": "santiago.rodriguez.pozo@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Software engineer, baroque violinist, blockchain enthusiast and mead maker",
		"social": {
			"twitter": "https://twitter.com/santiagorp",
			"git": "https://github.com/santiagorp"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/a20ef7cf54247280dd2191d6c10d16c0?size=200",
		"active": true,
		"name": "Fady Abdel Malik",
		"mail": "fady@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Software Engineer. Always passionately curious. Coffee drinker, DJ, music producer, adventurer, traveller, outdoors lover & arts enthusiast. Scotch, neat please.",
		"social": {
			"git": "https://github.com/FadyMak"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b4fb4083b0bfad7e4726e0b57c8840bc?size=200",
		"active": true,
		"name": "Alfredo Villagómez",
		"mail": "alfredo.villagomez@auth0.com",
		"title": "Engineer",
		"quote": "Javascript Developer",
		"social": {
			"twitter": "https://twitter.com/_alfredovm",
			"git": "https://github.com/alfredov"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/fad941dcdbf2d688be87c8164c85b144?size=200",
		"active": true,
		"name": "Guillermo Rodas",
		"mail": "grodas@auth0.com",
		"title": "Engineer",
		"quote": "I like to learn new things.",
		"social": {
			"twitter": "https://twitter.com/garethderioth",
			"git": "https://github.com/garethderioth"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/5e2529582a84c80dcf64c6f56042ad88?size=200",
		"active": true,
		"name": "Juan Pablo Picasso",
		"mail": "jp@auth0.com",
		"title": "Engineer",
		"quote": "Software Engineer. Robotics, AI, Batman!",
		"social": {
			"git": "https://github.com/jotadepicas"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/1b431a32be50c8f1ea8c2297685cf77b?size=200",
		"active": true,
		"name": "Martin Walsh",
		"mail": "martin.walsh@auth0.com",
		"title": "iOS Engineer",
		"quote": "Designer of games, maker of things. Never stop learning and sharing.",
		"social": {
			"twitter": "https://twitter.com/martin64k",
			"git": "https://github.com/cocojoe"
		}
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/f60630ead0e8749e4dbd9ea9a99b5cab?size=200",
		"active": true,
		"name": "Saltuk Alakus",
		"title": "Developer Success Engineer",
		"quote": "Searching the meaning of life in my spare time. Have some rough idea at the moment.",
		"social": {
			"git": "https://github.com/saltukalakus"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/862e7c75b0446f991edf8abcb4ef18bf/?size=200",
		"active": true,
		"name": "Sandeep Neerarambham",
		"mail": "sandeep.neerarambham@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Software Engineer, Learner, History Buff, Star Gazer and Family man",
		"social": {
			"git": "https://github.com/sandeepneerarambham",
			"twitter": "https://twitter.com/sandeepneera"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/4bc19d2134494bc311123c184d816a97/?size=200",
		"active": true,
		"name": "Jake Pyne",
		"mail": "jake.pyne@auth0.com",
		"title": "Engineer",
		"quote": "Full-stack developer",
		"social": {
			"git": "https://github.com/okjake",
			"twitter": "https://twitter.com/jakepyne"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/a7d1140397e42d6dd2621639821d7a9c/?size=200",
		"active": true,
		"name": "Neill Brookman",
		"mail": "neill.brookman@auth0.com",
		"title": "Head of Pre-sales, EMEA",
		"quote": "Husband, father of 3 and technology geek",
		"social": {
			"twitter": "https://twitter.com/Neill_Brookman"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b6b7b936f75e1eeba8aeef306db1f764/?size=200",
		"active": true,
		"name": "José Luis Diaz",
		"mail": "jose.luis.diaz@auth0.com",
		"title": "Engineer",
		"quote": "Programmer who used to be a sysadmin. Linux advocate, open source enthusiast.",
		"social": {
			"git": "https://github.com/joseluisdiaz",
			"twitter": "https://twitter.com/__joselo"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/248cf82624c544843dfdfdf904866b77/?size=200",
		"active": true,
		"name": "Toon De Coninck",
		"mail": "toon@auth0.com",
		"title": "CS Solutions Architect",
		"quote": "Developer, soccer player, trance lover",
		"social": {
			"git": "https://github.com/dctoon",
			"twitter": "https://twitter.com/toondc"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/72956a2f6ee6c25ad00d194cf7543719/?size=200",
		"active": true,
		"name": "Luís Deschamps Rudge",
		"mail": "luis.rudge@auth0.com",
		"title": "Front End Engineer",
		"quote": "Father, Developer and former music producer. Trying not to mix spaces and tabs",
		"social": {
			"git": "https://github.com/luisrudge",
			"twitter": "https://twitter.com/luisrudge"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ee4caa0a15026c9d769038be3b87bd04?s=200",
		"active": true,
		"name": "Chris Dukelow",
		"mail": "duke@auth0.com",
		"title": "CFO",
		"quote": "Startup Junkie, Winemaker, Sailor"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/76ea40cbf67675babe924eecf167b9b8/?size=200",
		"active": true,
		"name": "Bruno Simões Krebs",
		"mail": "bruno.krebs@auth0.com",
		"title": "Technical Writer",
		"quote": "Software developer passionate about open source.",
		"social": {
			"git": "https://github.com/brunokrebs",
			"twitter": "https://twitter.com/brunoskrebs"
		}
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b10474060eb9bc9334e41ad14ac2b73c/?size=200",
		"active": true,
		"name": "Ariel Schapiro",
		"mail": "ari@auth0.com",
		"title": "Business Manager, Customer Success",
		"quote": "Tech lover, idealist, obsessed with balance and disruption...and with my wife and kids.",
		"social": {
			"twitter": "https://twitter.com/aschapiro"
		}
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/3e8ce75cfe7c53f13715df274f63e129?s=200",
		"active": true,
		"name": "Richard Dowinton",
		"mail": "richard.dowinton@auth0.com",
		"title": "Developer Success Engineer",
		"quote": "Software generalist. Always looking to help and influence others."
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/donna-3bb1527770.png",
		"active": true,
		"name": "Donna Joyce",
		"title": "Corporate Account Executive, Sales",
		"quote": "Living life to the full - Passionate Sales Maker ❤️ - Mother of a teenage boy - Partner of a gorgeous man - Horse/Dog & Gin Lover",
		"social": {
			"twitter": "https://twitter.com/DJAuth0"
		}
	}
];

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = [
	{
		"id": "11638",
		"title": "2017-05-01: Auth0 11638",
		"old": false,
		"shasum": "3d4b1e5163ab738986424ac18561f3c1025521d9",
		"mirror": "1492637689874",
		"publishedAt": "2017-05-01"
	},
	{
		"id": "11112",
		"title": "2017-03-21: Auth0 11112",
		"old": false,
		"shasum": "6872e9b2b521ee11323a37928e73136ba0ffb679",
		"mirror": "1486178861666",
		"publishedAt": "2017-03-21"
	},
	{
		"id": "10755",
		"title": "2017-02-20: Auth0 10755",
		"old": false,
		"shasum": "d109f633696573b59c2efe14e7011100269f57c6",
		"mirror": "1486178861666",
		"publishedAt": "2017-02-20"
	},
	{
		"id": "10258",
		"title": "2017-01-16: Auth0 10258",
		"old": false,
		"shasum": "5cd65df99b572fedf591b2012de1ff14c808b150",
		"mirror": "1480444054184",
		"publishedAt": "2017-01-16"
	},
	{
		"id": "9632",
		"title": "2016-11-23: Auth0 9632",
		"old": false,
		"shasum": "202b7f16b45e80527c29ed907e80487d3123c32c",
		"mirror": "1477672903221",
		"publishedAt": "2016-11-23"
	},
	{
		"id": "8986",
		"title": "2016-10-13: Auth0 8986",
		"old": false,
		"shasum": "d3460cc161c3f6cc4edd0ea1272b0b182ec97e91",
		"mirror": "1473972402723",
		"publishedAt": "2016-10-13"
	},
	{
		"id": "8293",
		"title": "2016-09-01: Auth0 8293",
		"old": false,
		"mirror": "1472580222495",
		"shasum": "eda299b18d6ac305d2c70106e7b8296e460172cf",
		"publishedAt": "2016-09-01"
	},
	{
		"id": "7941",
		"title": "2016-08-08: Auth0 7941",
		"old": false,
		"mirror": "1470587956368",
		"shasum": "5a0072a42cd95a1287156d88276a478df99b57de",
		"publishedAt": "2016-08-07"
	},
	{
		"id": "7760",
		"title": "2016-07-27: Auth0 7760",
		"old": true,
		"mirror": "1465852204666",
		"shasum": "1da0189c2876be68f4b8c9184a39024db52ae028",
		"publishedAt": "2016-07-27"
	},
	{
		"id": "7247",
		"title": "2016-06-17: Auth0 7247",
		"old": true,
		"mirror": "1465852204666",
		"publishedAt": "2016-06-17",
		"shasum": "7feeac827363b1abf67d1ac3c719261b67115df3"
	},
	{
		"id": "6975",
		"title": "2016-05-28: Auth0 6975",
		"old": true,
		"mirror": "1463609600464",
		"publishedAt": "2016-05-28",
		"shasum": "1996351c2be7c302565eeb32fbb6c999269f63ba"
	},
	{
		"id": "6868",
		"title": "2016-05-20: Auth0 6868",
		"old": true,
		"mirror": "1463609600464",
		"publishedAt": "2016-05-20",
		"shasum": "3d0f7425a34232b1aaaefcb523327fb08e77d81a"
	},
	{
		"id": "6576",
		"title": "2016-05-02: Auth0 6576",
		"old": true,
		"mirror": "1461857277937",
		"publishedAt": "2016-05-02",
		"shasum": "355835502559444dff0a599b2fdbbc046f6138f1"
	},
	{
		"id": "5970",
		"title": "2016-03-23: Auth0 5970",
		"old": true,
		"mirror": "1457812908404",
		"publishedAt": "2016-03-23",
		"shasum": "e405e4e6857ad8f51d7d962061615d1b9eed80c2"
	},
	{
		"id": "5590",
		"title": "2016-02-17: Auth0 5590",
		"old": true,
		"mirror": "1455030487459",
		"publishedAt": "2016-02-17",
		"shasum": "d6d9db40406a9641a5f51c3d6b6e6db8bdd4fb31"
	},
	{
		"id": "5394",
		"title": "2016-01-26: Auth0 5394",
		"old": true,
		"mirror": "",
		"publishedAt": "2016-01-26",
		"shasum": "3f775e64364207f47622210d9a19be52becce8df"
	},
	{
		"id": "4975",
		"title": "2015-12-15: Auth0 4975",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-12-15",
		"shasum": "492c2d7a7570a6409909f3da9b8f4d1dc0a4b7dc"
	},
	{
		"id": "4605",
		"title": "2015-11-21: Auth0 4605",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-11-21",
		"shasum": "ef440975218f41529ae6e05f6d7e388b3dfcce9e"
	},
	{
		"id": "4341",
		"title": "2015-10-23: Auth0 4341",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-10-23",
		"shasum": "330b88448ef432808b3fb775b2377b1493319841"
	},
	{
		"id": "4323",
		"title": "2015-10-22: Auth0 4323",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-10-22",
		"shasum": "5a02e281e0b10f4945896e490bf5d1f1f1e9acf6"
	},
	{
		"id": "4295",
		"title": "2015-10-20: Auth0 4295",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-10-20",
		"shasum": "d75ad7df354786ee29d0268b22b52702a7098415"
	},
	{
		"id": "4013",
		"title": "2015-09-29: Auth0 4013",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-09-29",
		"shasum": "60a46d4dc4feeae25fe8f0dffd2a66a6e856d7db"
	},
	{
		"id": "3615",
		"title": "2015-08-31: Auth0 3615",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-08-31",
		"shasum": "7d656998a176e91e01a0aa5cdc7ff7559aac023f"
	},
	{
		"id": "3601",
		"title": "2015-08-28: Auth0 3601",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-08-28",
		"shasum": "3445495b6f81db46b410cb6b829edccae11b31a2"
	},
	{
		"id": "3454",
		"title": "2015-08-14: Auth0 3454",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-08-14"
	},
	{
		"id": "3258",
		"title": "2015-07-24: Auth0 3258",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-07-24",
		"shasum": "0abef044e2d1e040788adb17d6a279663253646a"
	},
	{
		"id": "3191",
		"title": "2015-07-17: Auth0 3191",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-07-17",
		"shasum": "3a62d526aa1efae7b84462e9b4af1375f3af9aab"
	},
	{
		"id": "3081",
		"title": "2015-07-06: Auth0 3081",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-07-06",
		"shasum": "2b74b7e9324c92ff4254056ad8ca7953e24302f3"
	},
	{
		"id": "2921",
		"title": "2015-06-18: Auth0 2921",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-06-18",
		"shasum": "4ae949d7ac3e866e1175db7d94065d5aeff38f7b"
	},
	{
		"id": "2783",
		"title": "2015-05-29: Auth0 2783",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-29"
	},
	{
		"id": "2666",
		"title": "2015-05-22: Auth0 2666",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-22"
	},
	{
		"id": "2616",
		"title": "2015-05-15: Auth0 2616",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-15"
	},
	{
		"id": "2562",
		"title": "2015-05-08: Auth0 2562",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-08"
	},
	{
		"id": "2516",
		"title": "2015-05-01: Auth0 2516",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-01"
	},
	{
		"id": "2479",
		"title": "2015-04-25: Auth0 2479",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-25"
	},
	{
		"id": "2425",
		"title": "2015-04-18: Auth0 2425",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-18"
	},
	{
		"id": "2359",
		"title": "2015-04-10: Auth0 2359",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-10"
	},
	{
		"id": "2274",
		"title": "2015-04-03: Auth0 2274",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-03"
	},
	{
		"id": "2223",
		"title": "2015-03-27: Auth0 2223",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-27"
	},
	{
		"id": "2190",
		"title": "2015-03-20: Auth0 2190",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-20"
	},
	{
		"id": "2150",
		"title": "2015-03-13: Auth0 2150",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-13"
	},
	{
		"id": "2086",
		"title": "2015-03-06: Auth0 2086",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-06"
	},
	{
		"id": "2051",
		"title": "2015-02-28: Auth0 2051",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-02-28"
	},
	{
		"id": "1999",
		"title": "2015-02-20: Auth0 1999",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-02-20"
	}
];

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);



__WEBPACK_IMPORTED_MODULE_1_page___default()('*', canonical);

function canonical(ctx, next) {
  if (ctx.init) {
    return next();
  }

  var link = __WEBPACK_IMPORTED_MODULE_0_component_query___default()('link[rel=canonical]');
  if (!link) {
    link = document.createElement('link'); // eslint-disable-line no-undef
  }

  var path = ctx.pathname.split('?')[0];
  var hasSlash = path.charAt(path.length - 1) === '/';

  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', 'https://auth0.com' + path + (hasSlash ? '' : '/'));

  if (!link.parentNode) {
    after(__WEBPACK_IMPORTED_MODULE_0_component_query___default()('title'), link);
  }

  return next();
}

function after(node, element) {
  if (!node.nextSibling) {
    return node.parentNode.appendChild(element);
  }

  return node.parentNode.insertBefore(element, node.nextSibling);
}

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(564);




function localeRedirectionMiddleware(ctx, next) {
  var locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getClientLocale */])();
  var path = ctx.pathname;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* hasLocaleVersion */])(path, locale)) {
    return __WEBPACK_IMPORTED_MODULE_0_page___default.a.redirect('/' + locale + path);
  }

  return next();
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return localeRedirectionMiddleware;
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_agent_ie__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_agent_ff__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_agent_chrome__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_agent_safari__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_agent_mac__ = __webpack_require__(573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__user_agent_ie__["a"]; });
/* unused harmony reexport ff */
/* unused harmony reexport chrome */
/* unused harmony reexport safari */
/* unused harmony reexport mac */
/* npm version only adapted from https://github.com/slifszyc/user-agent */







/**
 * Expose browser constructors
 */



/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie_dough__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie_dough___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie_dough__);
/* global window */


var cookie = __WEBPACK_IMPORTED_MODULE_0_cookie_dough___default()();
var hj = window.hj;

function triggerNotSignedUp() {
  if (!hj) {
    return;
  }

  if (!cookie.get('ajs_user_id') || cookie.get('ajs_user_id') === 'null') {
    triggerNotSignedUpPerPage(window.location.pathname);
  }
}

function triggerNotSignedUpPerPage(pathname) {
  var regex = /^\/authenticate\/.+\/.+\/?$/;

  if (pathname === '/') {
    return trigger('not_signed_up_homepage');
  }

  if (pathname === '/pricing') {
    return trigger('not_signed_up_pricing');
  }

  if (regex.test(pathname)) {
    return trigger('not_signed_up_auth_catalog');
  }

  return null;
}

function trigger(name) {
  console.warn('Triggering ' + name); // eslint-disable-line no-console
  hj('trigger', name);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  triggerNotSignedUp: triggerNotSignedUp
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__new_homepage__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_pricing__ = __webpack_require__(596);
/* eslint-env browser */



var pages = [__WEBPACK_IMPORTED_MODULE_0__new_homepage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__new_pricing__["a" /* default */]];

function register() {
  pages.forEach(function (page) {
    return page();
  });
}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shuffle_array__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shuffle_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shuffle_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__about_page_pug__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__about_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__about_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata_json__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__people_json__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__people_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__people_json__);
/* eslint-env browser, jquery */
/* global WOW */










function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/about', render, loadScripts, initializeTeamSection);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_7__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_0_domify___default()(__WEBPACK_IMPORTED_MODULE_6__about_page_pug___default()({ people: __WEBPACK_IMPORTED_MODULE_8__people_json___default.a })) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/about/resources/jquery-697d69a48e.bxslider.min.js', 'bxslider', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/about/resources/owl-ffaa3c82ad.carousel.min.js', 'owl', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.end(next);
}

function initializeTeamSection(ctx, next) {
  $('.owl-carousel').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    dots: false,
    nav: true,
    mouseDrag: false,
    lazyLoad: true,
    navText: ''
  });

  // Random list
  var $members = $('.team article');
  var $rows = $('.team section, .slider section');
  var list = $members.get();

  __WEBPACK_IMPORTED_MODULE_3_shuffle_array___default()(list);

  $rows.each(function () {
    var $row = $(this);

    $row.empty();

    for (var i = 0; i < list.length; i += 1) {
      $row.append($(list[i]).clone());
    }
  });

  new WOW().init();

  var team = $('.team-slider section').bxSlider({
    minSlides: 3,
    maxSlides: 3,
    moveSlides: 1,
    slideWidth: 240,
    slideMargin: 20,
    pager: false,
    controls: false,
    onSliderLoad: function onSliderLoad(currentIndex) {
      $(".team-slider article:not([class='bx-clone'])").eq(currentIndex + 1).addClass('active-slide');
    },
    onSlideBefore: function onSlideBefore($slideElement) {
      $('.team-slider article').removeClass('active-slide');
      $slideElement.next().addClass('active-slide');
    }
  });

  $('.team article').click(function () {
    $('.team-slider').addClass('active');
    team.goToSlide($(this).index() - 1);
  });

  $('.overlay').click(function () {
    $('.team-slider').removeClass('active');
  });

  // Scroll to href ID
  $('a[data="scroll-to"]').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');
      if ($target.length) {
        $('html,body').animate({
          scrollTop: $target.offset().top
        }, 1000);
        return false;
      }
    }
  });

  next();
}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ambassador_program_pug__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ambassador_program_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ambassador_program_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* eslint-env browser, jquery */








var FORM_SELECTOR = 'form.apply-form';
var BUTTON_SELECTOR = FORM_SELECTOR + ' button';
var FIELDS_SELECTOR = FORM_SELECTOR + ' input, ' + FORM_SELECTOR + ' textarea';

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__["a" /* default */])('/ambassador-program', render, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_2_domify___default()(__WEBPACK_IMPORTED_MODULE_5__ambassador_program_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function snippets(ctx, next) {
  setupContactForm();

  $('.form-apply').on('click', function () {
    scrollAnimated($('#form-apply').offset().top, 600);
  });

  next();
}

function scrollAnimated(to, duration) {
  var start = $(window).scrollTop(),
      change = to - start,
      currentTime = 0,
      increment = 20;

  function easeInOut(currentTime, startValue, change, duration) {
    currentTime /= duration / 2;

    if (currentTime < 1) {
      return change / 2 * currentTime * currentTime + startValue;
    }

    currentTime -= 1;

    return -change / 2 * (currentTime * (currentTime - 2) - 1) + startValue;
  }

  function animateScroll() {
    currentTime += increment;

    var val = easeInOut(currentTime, start, change, duration);

    $(window).scrollTop(val);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  }

  animateScroll();
}

function setupContactForm() {
  $(FORM_SELECTOR).submit(sendForm);
}

function sendForm(e) {
  e.preventDefault();

  var $button = $(BUTTON_SELECTOR);

  if ($button.hasClass('success') || $button.hasClass('btn-danger') || $button.hasClass('btn-loading')) {
    return;
  }

  setSubmitButtonState($button, 'process');

  var bodyFields = ['name', 'email', 'message'];
  var dataFields = ['country', 'city-province', 'link'];
  var fields = $(FIELDS_SELECTOR).toArray().reduce(function (result, current) {
    result[current.name] = current.value;
    return result;
  }, {});

  var initial = {
    source: 'ambassador-program',
    subject: 'Ambassador program contact from ' + fields.name
  };

  var body = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["assign"])(initial, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["pick"])(fields, bodyFields), { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["pick"])(fields, dataFields) });

  return $.post('https://auth0-marketing.run.webtask.io/contact-form', body).done(function () {
    return setSubmitButtonState($button, 'success');
  }).fail(function () {
    return setSubmitButtonState($button, 'error');
  }).always(function () {
    return setTimeout(function () {
      return $(FIELDS_SELECTOR).each(function (idx, field) {
        field.value = '';
      });
    });
  }, 3000);
}

function setSubmitButtonState(submitButton, state) {
  switch (state) {
    case 'success':
      submitButton.removeClass('btn-danger shake btn-loading').addClass('btn-success success tada').html('<span aria-hidden="true" class="btn-icon icon-budicon-390"></span> Sent');
      setTimeout(function () {
        return setSubmitButtonState(submitButton, 'initial');
      }, 3000);
      break;

    case 'error':
      submitButton.removeClass('btn-success success btn-loading tada').addClass('btn-danger shake').html('<span aria-hidden="true" class="btn-icon icon-budicon-389"></span> Error');
      setTimeout(function () {
        return setSubmitButtonState(submitButton, 'initial');
      }, 2000);
      break;

    case 'process':
      submitButton.removeClass('success btn-danger').addClass('btn-loading').html('<span aria-hidden="true" class="icon-rotating icon-budicon-330"></span>');
      break;

    default:
      submitButton.removeClass('success btn-danger btn-loading tada shake').addClass('btn-success').html('APPLY');
  }
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_landing_alias__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_superagent__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_main_pug__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_main_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_main_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__universal_utils__ = __webpack_require__(597);
/* eslint-env browser, jquery */












/**
 * Page.js routes
 */

function register() {
  __WEBPACK_IMPORTED_MODULE_1_modules_landing_alias__["a" /* default */].forEach(function (alias) {
    // Technology index
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/' + alias + '/:technology', initial, render, loadScripts, initializePageSections);
    __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */].exit('/' + alias + '/:technology', exit);

    // Technologies index
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/' + alias, initial, render, loadScripts, initializePageSections);
    __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */].exit('/' + alias, exit);
  });
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  if (ctx.init) {
    var metadata = window.authCatalogIndex && window.authCatalogIndex.metadata;
    __WEBPACK_IMPORTED_MODULE_6_modules_section_content__["a" /* default */].render({ metadata: metadata });

    return next();
  }

  return clientRender(ctx, next);
}

/**
 * For all routes
 */
function render(ctx, next) {
  var refs = updateRefs();

  // Toggle loading flag by removing html's class and minimal header
  refs.$html.addClass('basic-navs-mode').removeClass('auth0-website-loading');

  // Prevent page update on key enter
  refs.$technologiesSearch.submit(function (e) {
    e.preventDefault();
  });

  refs.$input.on('keyup', onKeyUp);
  refs.$window.on('resize', onResize);

  onResize();

  __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_bus__["a" /* default */].emit('page:render');

  return next();

  function onKeyUp(e) {
    return search(e, refs);
  }

  function onResize() {
    setHeights(refs);
  }
}

/**
 * Script loader
 */

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_2_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//twitter.github.io/typeahead.js/releases/latest/typeahead.bundle.js', 'typeahead', done);
  });

  batch.end(next);
}

/**
 * Script page
 */

function initializePageSections(ctx, next) {
  var hoverCard = $('.hover-content');

  hoverCard.mouseenter(function () {
    hoverCard.css('opacity', '0.5');
    $(this).css('opacity', 1);
  });

  hoverCard.mouseleave(function () {
    hoverCard.css('opacity', 1);
  });

  next();
}

/**
 * Exit
 */
function exit(ctx, next) {
  var refs = updateRefs();
  refs.$window.off('resize', setHeights);

  return next();
}

/**
 * Search items
 */
function search(e, refs) {
  if (e.keyCode === 13) {
    // enter
    refs.$input.trigger('blur');
    return true;
  }
  var searchVal = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.trim(refs.$input.val()).toLowerCase();
  if (!searchVal) {
    refs.$items.removeClass('hidden');
    refs.$notfound.removeClass('show');
    setHeights(refs);

    return true;
  }

  for (var i in refs.itemsTitlesIndex) {
    // i = index of element
    var $item = refs.$items.eq(i);

    if (refs.itemsTitlesIndex[i].indexOf(searchVal) > -1) {
      $item.removeClass('hidden');
    } else {
      $item.addClass('hidden');
    }
  }

  setHeights(refs, refs.$items.filter(':visible'));
  refs.$notfound.toggleClass('show', refs.$items.not('.hidden').length === 0);
}

/**
 * Equal height items in rows
 */
function setHeights(refs, items) {
  items = items || refs.$items;
  items.css('height', 'auto');

  var perRow = Math.floor(refs.$container.width() / items.width());

  if (perRow === null || perRow < 2) {
    return true;
  }

  var _loop = function _loop(i, j) {
    var maxHeight = 0;
    var $row = items.slice(i, i + perRow);
    var $hoverContent = $('.hover-content'),
        $hoverContentHeight = $hoverContent.slice(i, i + perRow);

    $row.each(function () {
      var itemHeight = parseInt($(this).outerHeight());
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });
    $row.css('height', maxHeight);
    $hoverContentHeight.css('min-height', maxHeight);
  };

  for (var i = 0, j = items.length; i < j; i += perRow) {
    _loop(i, j);
  }
}

/**
 * Client-side render
 */
function clientRender(ctx, next) {
  if (ctx.state.data) {
    return performClientRender(ctx.state.data, ctx.state.metadata);
  }

  fetchAndRender();

  function fetchAndRender() {
    __WEBPACK_IMPORTED_MODULE_7_superagent___default.a.get('/api/auth-catalog').end(callback);
  }

  function callback(err, res) {
    if (err) {
      return handleError();
    }

    var data = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.clone(res.body);
    var technology = ctx.params.technology || '';
    var technologyTitle = __WEBPACK_IMPORTED_MODULE_10__universal_utils__["a" /* default */].getTechnologyTitle(data.technologies, technology);
    var newMetadata = __WEBPACK_IMPORTED_MODULE_10__universal_utils__["a" /* default */].seo(!!technology, ctx.path, technologyTitle);

    data.technology = technology;
    data.technologyTitle = technologyTitle;
    data.alias = ctx.path.split('/')[1];

    ctx.state.metadata = newMetadata;
    ctx.state.data = data;
    ctx.save();

    return performClientRender(data, newMetadata);
  }

  function handleError() {
    var refs = updateRefs();

    refs.$items.addClass('hidden');
    refs.$tryAgainMessage.addClass('show');
    refs.$tryAgainMessageLink.prop('href', ctx.path).one('click', function (e) {
      fetchAndRender();

      e.preventDefault();
    });

    return false;
  }

  function performClientRender(data, metadata) {
    __WEBPACK_IMPORTED_MODULE_6_modules_section_content__["a" /* default */].render({ view: __WEBPACK_IMPORTED_MODULE_5_domify___default()(__WEBPACK_IMPORTED_MODULE_9__views_main_pug___default()(data)), metadata: metadata });

    return next();
  }
}

/**
 * DOM elements
 */
function updateRefs() {
  var container = $('.technology-list');
  var items = container.find('.technology-list__item');
  var itemsTitle = items.find('.technology__the-title');
  var itemsTitlesIndex = [];

  itemsTitle.each(function () {
    itemsTitlesIndex.push($(this).text().replace(/\s{2,}/g, ' ').toLowerCase());
  });

  return {
    $window: $(window),
    $html: $('html'),
    $technologiesSearch: $('.technologies-search'),
    $input: $('.technologies-search__input'),
    $container: container,
    $items: items,
    $itemsTitle: itemsTitle,
    itemsTitlesIndex: itemsTitlesIndex,
    $notfound: $('.message--notfound'),
    $tryAgainMessage: $('.message--tryagain'),
    $tryAgainMessageLink: $('.message__link')
  };
}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_landing_alias__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__landing_page_pug__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__landing_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__landing_page_pug__);
/* eslint-env browser, jquery */












function register() {
  __WEBPACK_IMPORTED_MODULE_0_modules_landing_alias__["a" /* default */].forEach(function (aname) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__["a" /* default */])('/' + aname + '/:apptype/:idp', getData, initial, render, loadScripts, initializePageSections);
  });
}

function getData(ctx, next) {
  return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get('/api/auth-catalog' + ctx.path).then(function (_ref) {
    var data = _ref.data;

    ctx.data = Object.assign({}, {
      context: {
        origin: window.location.origin
      }
    }, data);
    next();
  });
}

/**
 * Check for initial load and
 * stop or continue with middleware
 * load if not
 */

function initial(ctx, next) {
  var renderOptions = Object.assign({
    metadata: ctx.data.metadata
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_7_domify___default()(__WEBPACK_IMPORTED_MODULE_10__landing_page_pug___default()(ctx.data)) });
  __WEBPACK_IMPORTED_MODULE_8_modules_section_content__["a" /* default */].render(renderOptions);

  if (ctx.init) {
    return next();
  }
  return replace()(ctx, next);
}

/**
  * Page.js middleware for path
  * replacing
  *
  * @param {String} path
  * @return {Function} middleware
  * @api private
  */

function replace(path) {
  return function middleware(ctx, next) {
    var realPath = path || ctx.path;
    window.location.replace(realPath);
    next();
  };
}

function render(ctx, next) {
  // attachScrollTrackEvent();
  __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_bus__["a" /* default */].once('page:change', function () {
    __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(__WEBPACK_IMPORTED_MODULE_2_component_query___default()('html')).remove('basic-navs-mode');

    // $(window).off('scroll', onScroll);
    // detachScrollTrackEvent();
  });

  // toggle loading flag by removing html's class
  __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(__WEBPACK_IMPORTED_MODULE_2_component_query___default()('html')).remove('auth0-website-loading');
  __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(__WEBPACK_IMPORTED_MODULE_2_component_query___default()('html')).add('basic-navs-mode').add('header-dark');

  if (typeof window.prettyPrint === 'function') {
    __WEBPACK_IMPORTED_MODULE_2_component_query___default.a.all('pre').forEach(function (pre) {
      __WEBPACK_IMPORTED_MODULE_1_component_classes___default()(pre).add('prettyprint');
    });
    window.prettyPrint();
  }
  $('pre').addClass('prettyprint-start');
  __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_bus__["a" /* default */].emit('page:render');
  next();
}

// tabs

var $tabsLinks = $('.tabs__link');
var $tabs = $('.tabs__panel');
$tabsLinks.on('click', function (e) {
  e.preventDefault();
  $('.tabs__link.selected').removeClass('selected');
  $('.tabs__panel').removeClass('is-vis');
  $(this).addClass('selected');
  var $tabToShow = $(this).parent('li').index();
  $($tabs[$tabToShow]).addClass('is-vis');
});

/**
 * Script loader
 */

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_5_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/auth-catalog/vendor/highlight-fc8654573f.min.js', 'hljs', done);
  });

  batch.end(next);
}

/**
 * Script page
 */

function initializePageSections() {
  var positionSteps = $('.tutorial-steps').offset().top;
  var stepsHeight = $('.tutorial-steps').innerHeight();
  var tutorialButtonsHeight = void 0;

  hljs.configure({
    classPrefix: ''
  });

  var $itemPreCode = $('.item-content pre code');
  if ($itemPreCode.length > 0) {
    $itemPreCode.each(function (i, block) {
      var $snippet = $(this);

      if (!$snippet.hasClass('hljs')) {
        hljs.highlightBlock(block);
        $snippet.addClass('hljs');
      }

      if ($('.item-content pre code').length == $('.hljs').length) {
        $('.tutorial').addClass('tutorial-start');
      }
    });
  } else {
    $('.tutorial').addClass('tutorial-start');
  }

  // Tutorial section detect and add flag

  $(window).scroll(function () {
    if ($(window).scrollTop() > positionSteps + tutorialButtonsHeight && $(window).scrollTop() < positionSteps + stepsHeight) {
      if (!$('.tutorial-nav-steps').hasClass('opened')) {
        $('.tutorial-nav-steps').addClass('opened');
        $('.tutorial').addClass('opened');
      }

      for (var i = 0, steps = $('.tutorial-steps .item').length; i < steps; i += 1) {
        if ($(window).scrollTop() > $('.item.step-' + i).offset().top - tutorialButtonsHeight - 5 && !$('.buttons-steps-list li[' + i + ']').hasClass('selected')) {
          $('.buttons-steps-list li').removeClass('selected');
          $('.buttons-steps-list li.btn-' + i).addClass('selected');
        }
      }
    } else if ($('.tutorial-nav-steps').hasClass('opened')) {
      $('.tutorial-nav-steps').removeClass('opened');
      $('.tutorial').removeClass('opened');
    }
  });

  // Detect sections and add id

  $('.tutorial-steps .item').each(function (i) {
    $(this).addClass('step-' + i);
  });

  // Add Navbar buttons
  $('.tutorial-nav-steps').append('<div class="container"><ul class="buttons-steps-list"></ul></div>');

  for (var i = 0, steps = $('.tutorial-steps .item').length; i < steps; i += 1) {
    if (i === 0) {
      $('.buttons-steps-list').append('<li class="selected">\n          <div class="num">' + (i + 1) + '</div>\n          <span>' + $('.item.step-' + i + ' h3').text() + '</span>\n        </li>');
    } else {
      $('.buttons-steps-list').append('<li>\n          <div class="num">' + (i + 1) + '</div>\n          <span>' + $('.item.step-' + i + ' h3').text() + '</span>\n        </li>');
    }
    tutorialButtonsHeight = $('.tutorial-nav-steps').innerHeight();
  }

  // Detect btns and add functionality

  $('.buttons-steps-list li').each(function (i) {
    $(this).addClass('btn-' + i);
    $('.btn-' + i).click(function () {
      $('body, html').animate({
        scrollTop: $('.step-' + i).offset().top - tutorialButtonsHeight
      }, 600);
    });
  });
}

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__availability_trust_page_pug__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__availability_trust_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__availability_trust_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/availability-trust', render);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__availability_trust_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_main_pug__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_main_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__view_main_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bodymovin__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bodymovin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bodymovin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_in_view__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_in_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_in_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__animations_funnel_data_json__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__animations_funnel_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__animations_funnel_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__animations_phone_data_json__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__animations_phone_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__animations_phone_data_json__);















var metricsLib = window.metricsLib;
var mouseFlow = window.mouseflow || undefined;

function register() {
  __WEBPACK_IMPORTED_MODULE_1_page___default()('/b2b-enterprise-identity-management', render, snippets);
  __WEBPACK_IMPORTED_MODULE_1_page___default.a.exit('/b2b-enterprise-identity-management', unMountApp);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_9__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_2_domify___default()(__WEBPACK_IMPORTED_MODULE_8__view_main_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);
  /* eslint-env browser */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["f" /* ContactUsForm */], { source: 'b2b', subject: 'New lead from B2B page' }), document.querySelector('.contact-us-app'));
  return next();
}

function snippets(ctx, next) {
  contactFormModals();
  initAnimation();
  return next();
}

function unMountApp(ctx, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_dom__["unmountComponentAtNode"])(document.querySelector('.contact-us-app'));
  return next();
}

function initAnimation() {
  var containerFunnel = document.getElementById('animation-funnel');
  var containerPhone = document.getElementById('animation-phone');

  var params1 = {
    container: containerFunnel,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: __WEBPACK_IMPORTED_MODULE_12__animations_funnel_data_json___default.a
  };

  var params2 = {
    container: containerPhone,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: __WEBPACK_IMPORTED_MODULE_13__animations_phone_data_json___default.a
  };

  var animFunnel = __WEBPACK_IMPORTED_MODULE_10_bodymovin___default.a.loadAnimation(params1);
  var animPhone = __WEBPACK_IMPORTED_MODULE_10_bodymovin___default.a.loadAnimation(params2);

  var funnelPlayState = false;
  var phonePlayState = false;

  __WEBPACK_IMPORTED_MODULE_11_in_view___default.a.threshold(0.5);

  var playAnimationsIfVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["throttle"])(function () {
    if (!funnelPlayState && __WEBPACK_IMPORTED_MODULE_11_in_view___default.a.is(containerFunnel)) {
      animFunnel.play();
    }
    if (!phonePlayState && __WEBPACK_IMPORTED_MODULE_11_in_view___default.a.is(containerPhone)) {
      animPhone.play();
    }
  }, 300);

  playAnimationsIfVisible();

  document.addEventListener('scroll', playAnimationsIfVisible);
}

function contactFormModals() {
  // Contact Sales Form
  var salesContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    source: 'b2b-page'
  };
  var salesContactForm = new __WEBPACK_IMPORTED_MODULE_6_auth0_contact_form___default.a(salesContactFormOptions);

  var salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', function () {
    return salesContactForm.show({ includePhoneField: true });
  });
}

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__b2c_page_pug__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__b2c_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__b2c_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__metadata_json__);
/* eslint-env browser, jquery */
/* global WOW */
// const debug = require('debug')('auth0:b2c');










var metricsLib = window.metricsLib;
var mouseFlow = window.mouseflow || undefined;

function register() {
  __WEBPACK_IMPORTED_MODULE_6_page___default()('/b2c-customer-identity-management', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_8__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_2_domify___default()(__WEBPACK_IMPORTED_MODULE_7__b2c_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/b2c/resources/wow-a26a117ff5.min.js', 'wow', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  var wow = new WOW();
  wow.init();

  $(window).scroll();

  contactFormModals();

  next();
}

function contactFormModals() {
  // Contact Sales Form
  var salesContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    source: 'pricing-page'
  };
  var salesContactForm = new __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form___default.a(salesContactFormOptions);

  $('.open-contact-form-modal').click(function () {
    return salesContactForm.show({ includePhoneField: true });
  });

  // Contact OSS Form
  var ossContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-oss');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    modalTitle: 'Contact OSS team',
    source: 'oss'
  };
  var ossContactForm = new __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form___default.a(ossContactFormOptions);

  $('.open-contact-oss').click(function () {
    return ossContactForm.show({ includePhoneField: true });
  });
}

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* eslint-env browser, jquery */


function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/blog/(.*)?', replace());
}

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx, next) {
    if (ctx.title.toLowerCase().indexOf('not found') === 0) {
      return;
    }

    path = path || ctx.path;
    window.location.replace(path);
  };
}

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__breached_passwords_page_pug__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__breached_passwords_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__breached_passwords_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resources_flipclock_min__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resources_flipclock_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resources_flipclock_min__);
/* eslint-env browser, jquery */
/* global WOW */

// import debugT from 'debug';










// const debug = debugT('auth0:breached-passwords');

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__["a" /* default */])('/breached-passwords', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_8__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_7__breached_passwords_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_5_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var clock = $('.counter').FlipClock(leakedPasswordsCount(), {
    clockFace: 'Counter',
    minimumDigits: ('' + leakedPasswordsCount()).length
  });

  setInterval(function () {
    clock.setTime(leakedPasswordsCount());
  }, 1000);

  window.clock = clock;

  var batch = new __WEBPACK_IMPORTED_MODULE_2_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.end(next);
}

function leakedPasswordsCount() {
  var initialCount = 1135200000;
  var initialDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(1471013548218);
  var diff = Math.round(__WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(initialDate) / 420);

  return initialCount + diff;
}

function snippets(ctx, next) {
  var wow = new WOW();

  wow.init();

  initScrollAnimations();

  playBenefits();

  next();
}

function playBenefits() {
  var $el = $('.js-animate-circles circle');
  var speed = 300;

  function setLoop(counter, duration, backwards) {
    var bounceDuration = duration / 1.2;

    function getCondition() {
      return backwards ? counter >= 0 : counter <= $el.length;
    }

    function removePrev() {
      return backwards ? $el.eq(counter + 1).removeAttr('class') : $el.eq(counter - 1).removeAttr('class');
    }

    return setInterval(function () {
      if (getCondition()) {
        removePrev();

        $el.eq(counter).css({
          '-webkit-transition-duration': bounceDuration + 'ms',
          '-moz-transition-duration': bounceDuration + 'ms',
          'transition-duration': bounceDuration + 'ms'
        });

        $el.eq(counter).attr('class', 'active');

        if (counter === $el.length || counter == 0) {
          var toRemove = counter;

          setTimeout(function () {
            $el.eq(toRemove).removeAttr('class');
          }, duration);
        }

        if (backwards) {
          return counter -= 1;
        }

        return counter += 1;
      }
      if (backwards) {
        return counter = 26;
      }

      return counter = 27;
    }, duration);
  }

  setLoop(26, speed, true);
  setLoop(12, speed, true);

  setLoop(27, speed);
  setLoop(43, speed);
}

function initScrollAnimations() {
  var newsAnimation1 = new WOW({
    boxClass: 'go-down',
    animateClass: 'move'
  });

  var newsAnimation2 = new WOW({
    boxClass: 'go-up',
    animateClass: 'move'
  });

  var switchAnimation = new WOW({
    boxClass: 'switch-container',
    animateClass: 'enabled'
  });

  // video animation

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();
    playVid();
    showRePlay();
  });

  var vid = document.getElementById('breached-video');

  function playVid() {
    vid.play();
  }

  function showRePlay() {
    $('a.play-me-again').hide();
    setTimeout(function () {
      $('a.play-me-again').show();
    }, 9000);
  }

  var lockAnimation = new WOW({
    boxClass: 'example-content',
    mobile: true,
    live: true,
    offset: 200,
    callback: function callback(box) {
      playVid();
      showRePlay();
    }
  });

  // end video animation

  newsAnimation1.init();
  newsAnimation2.init();
  switchAnimation.init();
  lockAnimation.init();
}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__changelog_page_pug__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__changelog_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__changelog_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appliance_page_pug__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appliance_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__appliance_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__oldreleases_page_pug__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__oldreleases_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__oldreleases_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data__ = __webpack_require__(598);
/* eslint-env browser, jquery */
/* global Modernizr, TweenMax, TimelineLite */











function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/changelog', renderChangelog, loadScripts, snippets);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/changelog/appliance', renderAppliance, loadScripts, snippets);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/changelog/appliance/old', renderOldReleases, loadScripts, snippets);
}

function render(html, ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_8__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_0_domify___default()(html) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);
  next();
}

function renderChangelog(ctx, next) {
  render(__WEBPACK_IMPORTED_MODULE_5__changelog_page_pug___default()(Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__data__["a" /* changelogData */])), ctx, next);
}

function renderAppliance(ctx, next) {
  render(__WEBPACK_IMPORTED_MODULE_6__appliance_page_pug___default()(Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__data__["b" /* changelogApplianceData */])), ctx, next);
}

function renderOldReleases(ctx, next) {
  render(__WEBPACK_IMPORTED_MODULE_7__oldreleases_page_pug___default()(Object.assign({}, __WEBPACK_IMPORTED_MODULE_9__data__["c" /* changelogOldData */])), ctx, next);
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('https://cdnjs.cloudflare.com/ajax/libs/gsap/1.15.1/TweenMax.min.js', 'TweenMax', function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('https://cdnjs.cloudflare.com/ajax/libs/SuperScrollorama/1.0.3/jquery.superscrollorama.min.js', '$.superscrollorama', done);
    });
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//ajax.aspnetcdn.com/ajax/modernizr/modernizr-2.8.3.js', 'Modernizr', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('a[data-control="release"]').click(function scrollToRelease() {
    // prevent the default action for the click event
    event.preventDefault();

    // get the full url - like mysitecom/index.htm#home
    var fullUrl = this.href;

    // split the url by # and get the anchor target name - home in mysitecom/index.htm#home
    var parts = fullUrl.split('#');
    var trgt = parts[1];

    // get the top offset of the target anchor
    var targetOffset = $('[name="' + trgt + '"]').offset();
    var targetTop = targetOffset.top;

    // goto that anchor by setting the body scroll top to anchor top
    $('html, body').animate({ scrollTop: targetTop }, 500);
  });

  if (!Modernizr.touch) {
    var controller = $.superscrollorama({
      triggerAtCenter: false,
      playoutAnimations: true
    });

    controller.pin($('#pin'), 16000, {
      anim: new TimelineLite().append(TweenMax.fromTo($('#card1'), 5, { css: { opacity: 1, left: '50%' }, immediateRender: true }, { css: { opacity: 0, left: '200%' } })).append(TweenMax.fromTo($('#card2'), 3, { css: { opacity: 0, left: '200%' }, immediateRender: true }, { css: { opacity: 1, left: '50%' } })).append(TweenMax.fromTo($('#card2'), 5, { css: { left: '50%' }, immediateRender: true }, { css: { opacity: 0, left: '200%' } })).append(TweenMax.fromTo($('#card3'), 3, { css: { opacity: 0, left: '200%' }, immediateRender: true }, { css: { opacity: 1, left: '50%' } }))
    });
  }

  next();
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptloader__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scriptloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customers_page_pug__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customers_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__customers_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__customers_json__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__customers_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__customers_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__js_scroll_manager__ = __webpack_require__(600);
/* eslint-env jquery, browser */
/* global WOW, wistiaJQuery */













function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/customers', render, loadScripts, snippets);
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_7_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/customers/resources/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_2_scriptloader___default()('//fast.wistia.com/assets/external/popover-v1.js', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//fast.wistia.com/assets/external/iframe-api-v1.js', 'wistiaApi', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('body').addClass('loaded');
  var transitioned = 0;

  $('#carousel').swiperight(function () {
    $(this).carousel('prev');
  });

  $('#carousel').swipeleft(function () {
    $(this).carousel('next');
  });

  wistiaJQuery(document).bind('wistia-popover-open', function (ev, iframe) {
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('open:video-popup');
  });

  wistiaJQuery(document).bind('wistia-popover', function (ev, iframe) {
    transitioned = 0;
    var api = iframe.wistiaApi;
    api.bind('secondchange', function (s) {
      transitioned = s;
      if (s && !(s % 10)) {
        // every 10 seconds, we trigger a length event
        __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('viewed:video-length', { value: transitioned });
      }
    });
    api.bind('play', function () {
      __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-play', { value: transitioned });
    });
    api.bind('pause', function () {
      __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-pause', { value: transitioned });
    });
  });

  wistiaJQuery(document).bind('wistia-popover-close', function () {
    $('.banner .container h1, .banner .container p').removeClass('animated fadeOutUp').addClass('animated fadeInDown');
    $('.banner .container a').removeClass('animated fadeOutDown').addClass('animated fadeInUp');
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('close:video-popup', { value: transitioned });
    transitioned = 0;
  });

  var newScrollManager = new __WEBPACK_IMPORTED_MODULE_11__js_scroll_manager__["a" /* default */]();
  newScrollManager.init();

  $('.nav-categories li').click(function () {
    $('.nav-categories li').removeClass('active');
    $(this).addClass('active');
    var linkCategory = $(this).attr('data-category');
    if (linkCategory == 'all') {
      $('.customers-gallery-container .flex-col').each(function () {
        $(this).show();
      });
      return;
    }
    $('.customers-gallery-container .flex-col').each(function () {
      if ($(this).filter('[data-category *= ' + linkCategory + ']').length) {
        $(this).show();
        return;
      }
      $(this).hide();
    });
  });

  $('#search-input').on('keyup', function () {
    var searchVal = $(this).val().toLowerCase();
    $('.customers-gallery-container .flex-col').each(function () {
      if ($(this).filter('[data-search *= ' + searchVal + ']').length > 0 || searchVal.length < 1) {
        $(this).show();
        return;
      }
      $(this).hide();
    });
  });

  next();
}

function render(ctx, next) {
  var view = __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_8__customers_page_pug___default()({ customers: __WEBPACK_IMPORTED_MODULE_10__customers_json___default.a }));
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_9__metadata_json___default.a
  }, ctx.init ? {} : { view: view });
  __WEBPACK_IMPORTED_MODULE_5_modules_section_content__["a" /* default */].render(renderOptions);

  if (window.location.hash) {
    var highlightedElement = $(window.location.hash);
    if (highlightedElement.length <= 0) return; // Check if the highlighted id is in the dom
    $(window).scrollTop($(highlightedElement).offset().top - 100);
  }

  next();
}

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug__);
/* eslint-env browser, jquery */
/* global WOW, imagesLoaded, Wistia, Auth0Lock */
// const debug = require('debug')('auth0:how-it-works');









var playVideoIntent = setTimeout(function () {}, 1),
    switchTabIntent = setTimeout(function () {}, 1);

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/how-it-works', render, loadscripts, onPageReady);
}

function render(ctx, next) {
  preventScrolling(true);
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_3_domify___default()(__WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadscripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/jquery.imagesloaded/4.1.0/imagesloaded.pkgd.min.js', 'imagesLoaded', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//fast.wistia.com/assets/external/E-v1.js', 'Wistia', done);
  });

  batch.end(next);
}

function onPageReady(ctx, next) {
  // global Wistia options
  // for all videos!
  Wistia.options({
    videoQuality: 'hd-only',
    videoFoam: true,
    chromeless: true
  });

  // Tell wistia to initialize videos
  // manually...
  Wistia.embeds.setup();

  imagesLoaded('.dashboard-page .page-hero', function () {
    initCoverPage(0);
  });

  initScrollAnimations();
  attachEvents();
  demoLock();

  next();
}

function demoLock() {
  var auth0IconUrl = 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png';

  var AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
  var AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;
  var AUTH0_CALLBACK_URL = window.APP_CONFIG.AUTH0_CALLBACK_URL;

  var demoOptions = {
    auth: { redirectUrl: AUTH0_CALLBACK_URL },
    theme: {
      logo: auth0IconUrl
    },
    rememberLastLogin: false,
    container: 'iphone',
    integratedWindowsLogin: false,
    socialButtonStyle: 'small',
    languageDictionary: {
      // eslint-disable-next-line max-len
      signUpTerms: 'By signing up, you agree to our <a href="/terms" target="_new">terms of service</a> and <a href="/privacy" target="_new">privacy policy</a>'
    }
  };

  var demo = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, demoOptions);
  demo.show();
}

function preventScrolling(activate) {
  var $body = $('body');

  $body.addClass('no-scroll');
  $body.bind('touchmove', function (e) {
    e.preventDefault();
  });

  if (!activate) {
    $body.removeClass('no-scroll');
    $body.unbind('touchmove');
  }
}

function requestAnimFrame(cb) {
  if (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame) {
    return requestAnimationFrame(cb) || webkitRequestAnimationFrame(cb) || mozRequestAnimationFrame(cb);
  } else {
    return setTimeout(cb, 1000 / 60);
  }
}

function animateEditUsers() {
  var $inputs = $('.js-edit-user-animation input');
  var $modal = $('.js-edit-user-animation .modal-edit-content');
  var $save = $('.js-edit-user-animation .btn');

  var steps = ['Ricardo Rauch', 'ricky@auth0.com', 'RickyRauch', 'Auth0', 'Buenos Aires, Argentina', 'http://auth0.com/'];

  function resetForm() {
    $save.text($save.data('o_val')).removeClass('focused');

    $modal.prepend('<div class="alert alert-success" style="font-size: 14px;">Changes saved</div>');

    setTimeout(function () {
      $modal.find('.alert').remove();
    }, 2000);
  }

  function modifyText(i, value, total) {
    return function () {
      var toCall = parseInt(i) + 1;

      $inputs.eq(i).data('o_val', $inputs.eq(i).val());
      $inputs.eq(i).addClass('focused').val('').delay(700).typetype(value, {
        e: 0.04,
        t: 85,
        callback: function callback() {
          $inputs.eq(i).removeClass('focused');

          if (toCall < total) {
            stack[toCall]();
          } else {
            save();
          }
        }
      });
    };
  }

  function save() {
    setTimeout(function () {
      $save.data('o_val', $save.text());
      $save.text('Saving...').addClass('focused');

      setTimeout(function () {
        resetForm();
      }, 400);
    }, 600);
  }

  var stack = {};

  for (var step in steps) {
    var current = steps[step];

    stack[step] = modifyText(step, current, steps.length);
  }

  stack[0]();
}

function initScrollAnimations() {
  var regularAnimations = new WOW({
    boxClass: 'js-animated',
    animateClass: 'animated',
    offset: 200,
    mobile: false,
    callback: function callback(box) {
      var $after = $(box).siblings().filter('.hide.js-animated-after');

      if ($after.length) {
        setTimeout(function () {
          $after.removeClass('hide').addClass('animated');
        }, 400);
      }

      if ($(box).find('.js-edit-user-animation').length) {
        animateEditUsers();
      }
    }
  });

  var screenshotsAnimation = new WOW({
    boxClass: 'js-contains-videos',
    animateClass: 'animated',
    offset: 0,
    mobile: false,
    callback: function callback(box) {
      var $playOnScroll = $(box).find('.lock-demo'),
          $phoneUp = $('.showcase-area .iphone-lock');

      var whenShowLock = 18;
      var whenChangeLogo = 23;
      var whenChangeSocial = 38;

      if ($playOnScroll.hasClass('wistia_embed')) {
        var video = Wistia.api($playOnScroll.data('source'));
        video && video.bind('secondchange', function (second) {
          if (second === whenShowLock) {
            $phoneUp.removeClass('hide');
          }

          if (second === whenChangeLogo) {
            $phoneUp.find('#iphone .auth0-lock-header-logo').attr('src', 'https://cdn.auth0.com/website/assets/pages/dashboard/img/sharelock-icon-19e529d979.svg');
            $phoneUp.find('.a0-avatar').addClass('a0-hide');
            $phoneUp.find('.a0-image').removeClass('a0-hide');
          }

          if (second === whenChangeSocial) {
            $phoneUp.find('#iphone').removeClass('lock-no-googleplus');
          }
        });

        video.play();
      }
    }
  });

  var profileAutoplay = new WOW({
    boxClass: 'js-switch-profile',
    animateClass: 'triggered',
    offset: -600,
    mobile: false,
    callback: function callback(box) {
      $('.js-switch-profile .profile.right img').trigger('click');

      // autoPlay commented that causes an error

      // setProfileAutoplay(2000);
    }
  });

  regularAnimations.init();
  screenshotsAnimation.init();
  profileAutoplay.init();
}

function profileSwitch(e) {
  var $clicked = $(this),
      $profiles = $('.js-switch-profile .profile'),
      $dots = $('.js-switch-profile .dot');

  if ($clicked.parent().hasClass('right')) {
    goToDirection('right');
  }

  if ($clicked.parent().hasClass('left')) {
    goToDirection('left');
  }

  if ($clicked.hasClass('dot')) {
    goToIndex();
  }

  if (window.profileAutoplay === false) {
    __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:dashboard-profiles');
  }

  function goToIndex() {
    var index = $clicked.index();
    var $target = $profiles.eq(index);

    $clicked = $target.find('img');

    if ($target.hasClass('center')) {
      return;
    }

    if ($target.hasClass('left')) {
      goToDirection('left');
    }

    if ($target.hasClass('right')) {
      goToDirection('right');
    }
  }

  function goToDirection(direction) {
    var inverse = direction === 'left' ? 'right' : 'left';

    $profiles.filter('.back').first().removeClass('back').addClass(direction);
    $profiles.filter('.' + inverse).removeClass(inverse).addClass('back');
    $profiles.filter('.center').removeClass('center').addClass(inverse);

    updateClicked();
  }

  function updateClicked() {
    $dots.removeClass('selected');

    $clicked.parent().removeClass('right left').addClass('center');

    $dots.eq($clicked.parent().index()).addClass('selected');
  }
}

function setProfileAutoplay(time) {
  if (!window.profileAutoplay) {
    window.profileAutoplay = setInterval(play, time);
  }

  $('.js-switch-profile').hover(function () {
    clearInterval(window.profileAutoplay);

    window.profileAutoplay = false;
  }, function () {
    if (!window.profileAutoplay) {
      window.profileAutoplay = setInterval(play, time);
    }
  });

  function play() {
    $('.js-switch-profile .profile.right img').trigger('click');
  }
}

function switchVideos(e) {
  e.preventDefault();
  e.stopPropagation();

  var $clicked = $(this);
  var index = $clicked.index();
  var $videos = $clicked.parents('.js-video-switcher').find('.video-wrapper');
  var $siblings = $videos.eq(index).siblings();

  if ($clicked.hasClass('active')) {
    return false;
  }

  __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:dashboard-tab-switcher', { tab: $clicked[0].className });

  // Set fadeout animation for current slide w/ custom duration
  $siblings.css({
    '-webkit-animation-duration': 400,
    'animation-duration': 400
  });

  $siblings.addClass('fadeOutDownBig');

  clearTimeout(playVideoIntent);
  clearTimeout(switchTabIntent);

  switchTabIntent = setTimeout(function () {
    // Reset animation duration, hide other tabs, remove fadeOut animation
    $siblings.removeAttr('style').addClass('hide').removeClass('fadeOutDownBig');

    $videos.eq(index).removeClass('hide');

    $clicked.siblings().removeClass('active');
    $clicked.addClass('active');

    $videos.eq(index).find('video').get(0).currentTime = 0;
  }, 300);

  // playVideoIntent = setTimeout(function() {
  //     $videos.eq(index).find('video').get(0).play();
  // }, 800);

  playVideoIntent = setTimeout(function () {
    var $videoMarkup = $('.js-video-switcher').find('.dash-demo'),
        $phoneUp = $('.screenshots .iphone-dash');

    if ($videoMarkup.hasClass('wistia_embed')) {
      var videoSource = Wistia.api($videoMarkup.data('source'));
      videoSource.bind('end', function (second) {
        $phoneUp.removeClass('hide');
      });
    }
  }, 300);
}

function attachEvents() {
  $('.dashboard-page').on('click', '.js-switch-profile .profile img', profileSwitch).on('click', '.js-switch-profile .dot', profileSwitch).on('click', '.js-video-switcher .tab-list a', switchVideos);

  $('.mark-red .shape').hover(function () {
    $(this).parent('.mark-red').next('.tooltip').addClass('animated fadeInUp show');
  }, function () {
    $(this).parent('.mark-red').next('.tooltip').removeClass('animated fadeInUp show');
  });

  window.wistiaInit = function (W) {
    var $allVideos = $('.wistia_embed');

    $allVideos.each(function (i, el) {
      var video = W.api($(el).data('source'));

      video && video.bind('play', function () {
        __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:dashboard-video', { video: this.name() });
      });
    });
  };
}

function initCoverPage(time) {
  preventScrolling(false);

  var $stack = $('.dashboard-page .banner').find('.js-animation-stack');

  setTimeout(function () {
    $('.js-intro-text').removeClass('invisible').addClass('scaleIn');
    $('.dashboard-page .spinner-container').fadeOut(300);

    setTimeout(function () {
      $('.dashboard-page .banner .mobile-screen').removeClass('invisible');
      $('.dashboard-page .banner .btn').removeClass('invisible').addClass('animated fadeIn');
      $('.dashboard-page .banner .p-dashboard-1').removeClass('invisible').addClass('animated fadeInUp');
    }, 600);

    setTimeout(function () {
      $('.dashboard-page .banner .p-dashboard-2').removeClass('invisible').addClass('animated fadeInUp');

      if ($stack.length) {
        var wait = 250;

        $stack.find('[data-order]').each(function () {
          var elem = $(this);
          var order = parseInt($(this).attr('data-order'));

          var timeout = setTimeout(function () {
            elem.removeClass('hide').addClass('animated');

            clearTimeout(timeout);
          }, wait * order);
        });
      }
    }, 1200);
  }, time || 600);
}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* eslint-env browser */


function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/docs/(.*)?', replace());
}

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx, next) {
    path = path || ctx.path;
    window.location.replace(path);
  };
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enterprise_page_pug__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enterprise_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__enterprise_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__metadata_json__);
/* eslint-env browser, jquery */
/* global WOW */
// const debug = require('debug')('auth0:enterprise');










function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_ab_page_js__["a" /* default */])('/enterprise', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_8__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_3_domify___default()(__WEBPACK_IMPORTED_MODULE_7__enterprise_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_5_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/enterprise/resources/wow-a26a117ff5.min.js', 'wow', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/enterprise/resources/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  new WOW({
    mobile: false
  }).init();

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    $('.tab-pane').removeClass('animated');
    $('.tab-pane.active').addClass('animated');
  });

  $('#carousel').swiperight(function () {
    $(this).carousel('prev');
  });
  $('#carousel').swipeleft(function () {
    $(this).carousel('next');
  });

  if (window.innerWidth > 992) {
    // Top tabs cycle

    var activeTopTab = $('a[href="#firewall"]');
    var topTabsIntervalID = setInterval(function () {
      var tabToShow = void 0;
      if (!(activeTopTab.attr('href') == '#web-scale')) {
        tabToShow = activeTopTab.parent().next().find('a[href]');
        tabToShow.tab('show');
      } else {
        tabToShow = $('a[href="#firewall"]');
        tabToShow.tab('show');
      }
      activeTopTab = tabToShow;
    }, 10000); // 10 seconds

    $(document).on('click', '.caracteristics-tabs .nav > li > a[href]', function (e) {
      clearInterval(topTabsIntervalID);
      // activeTopTab = $(e.target);
    });

    // Bottom tabs cycle
    var activeBottomTab = $('a[href="#security"]');
    var bottomTabsIntervalID = setInterval(function () {
      var tabToShow = void 0;
      if (!(activeBottomTab.attr('href') == '#interoperates')) {
        tabToShow = activeBottomTab.parent().next().find('a[href]');
        tabToShow.tab('show');
      } else {
        tabToShow = $('a[href="#security"]');
        tabToShow.tab('show');
      }
      activeBottomTab = tabToShow;
    }, 10000); // 10 seconds

    $(document).on('click', '.certifications-tabs .nav > li > a[href]', function () {
      clearInterval(bottomTabsIntervalID);
      // activeBottomTab = $(e.target);
    });

    // Hero learn more smooth scroll

    $('.hero-learn-more').on('click', function (e) {
      var tarHref = $(e.target).attr('href');
      var tarOffset = $(tarHref).offset().top;
      $('html, body').animate({
        scrollTop: tarOffset
      }, 800);
    });

    $(window).scroll();
  }

  // Form functionality

  $('.contact-form').on('submit', function (e) {
    e.preventDefault();

    var $currentForm = $(this);
    var $submitBtn = $(this).find('button[type="submit"]');
    var emailData = void 0,
        nameData = void 0,
        companyData = void 0,
        roleData = void 0,
        messageData = void 0;
    var formData = getFormData();

    function setButtonToSend() {
      $submitBtn.data('orig-text', $submitBtn.text());

      $submitBtn.attr('disabled', 'disabled');
      $submitBtn.text('Sending...');
    }

    function isValidEmail(value) {
      var email = new RegExp(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);

      return email.test(value);
    }

    function getFormData() {
      var str = '';
      var email = $currentForm.find('input[name="email"]').val();

      if (!isValidEmail(email)) {
        return alert('Please enter a valid email');
      }

      emailData = email;

      setButtonToSend();

      $currentForm.find('input, textarea, select').each(function () {
        var $this = $(this);
        var val = $this.val();

        if (val && $this.attr('name')) {
          str += $this.attr('name') + ': ' + val + '\n';
          if ($this.attr('name') == 'name') {
            nameData = val;
          } else if ($this.attr('name') == 'company') {
            companyData = val;
          } else if ($this.attr('name') == 'role') {
            roleData = val;
          } else if ($this.attr('name') == 'message') {
            messageData = val;
          }
        }
      });

      return str;
    }

    function sendForm() {
      var formDataObject = {
        email: emailData,
        name: nameData,
        company: companyData,
        role: roleData,
        message: messageData,
        source: 'enterprise',
        subject: 'New lead from Enterprise page'
      };
      $.ajax({
        type: 'POST',
        url: 'https://auth0-marketing.run.webtask.io/contact-form',
        data: formDataObject
      });

      formDataObject.trackData = emailData;
      formDataObject.formId = '1048';
      formDataObject.lpId = '1133';
      $.ajax({
        type: 'POST',
        url: 'https://webtask.it.auth0.com/api/run/wt-chernatom-gmail_com-0/enterprise-forms?webtask_no_cache=1',
        data: JSON.stringify({
          data: {
            content: formData
          }
        }),
        processData: false,
        contentType: 'application/json',
        success: function success() {
          onFormSent($submitBtn);
          __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('register:lead:enterprise-contact-form', formDataObject);
        },
        error: function error() {
          __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('fail:register:lead:enterprise-contact-form', formDataObject);
          $submitBtn.text($submitBtn.data('orig-text'));

          alert('There was a problem submitting your information. Please try again later.');
        }
      });
    }

    if (formData) {
      sendForm();
    }
  });

  function onFormSent($button) {
    $button.text('Thanks for getting in touch!');
    $button.addClass('success');
  }

  next();
}

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_page_jquerysf_pug__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_page_jquerysf_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__events_page_jquerysf_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__events_page_angularu_pug__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__events_page_angularu_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__events_page_angularu_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__events_page_cascadia_pug__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__events_page_cascadia_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__events_page_cascadia_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__events_page_oscon_pug__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__events_page_oscon_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__events_page_oscon_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events_page_forward_pug__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__events_page_forward_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__events_page_forward_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__events_page_fec15_pug__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__events_page_fec15_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__events_page_fec15_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__events_meta__ = __webpack_require__(601);













function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/events/jquerysf-angular-2', render(__WEBPACK_IMPORTED_MODULE_5__events_page_jquerysf_pug___default.a, __WEBPACK_IMPORTED_MODULE_11__events_meta__["a" /* jquerysfMeta */]), loadScripts);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/events/angularu-single-page-app-authentication', render(__WEBPACK_IMPORTED_MODULE_6__events_page_angularu_pug___default.a, __WEBPACK_IMPORTED_MODULE_11__events_meta__["b" /* angularuMeta */]), loadScripts);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/events/cascadia-client-side-jwt-authentication', render(__WEBPACK_IMPORTED_MODULE_7__events_page_cascadia_pug___default.a, __WEBPACK_IMPORTED_MODULE_11__events_meta__["c" /* cascadiaMeta */]), loadScripts);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/events/oscon-reactive-frontend', render(__WEBPACK_IMPORTED_MODULE_8__events_page_oscon_pug___default.a, __WEBPACK_IMPORTED_MODULE_11__events_meta__["d" /* osconMeta */]), loadScripts);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/events/forwardjs-reactive-frontend', render(__WEBPACK_IMPORTED_MODULE_9__events_page_forward_pug___default.a, __WEBPACK_IMPORTED_MODULE_11__events_meta__["e" /* forwardMeta */]), loadScripts);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/events/fec15-webtask', render(__WEBPACK_IMPORTED_MODULE_10__events_page_fec15_pug___default.a, __WEBPACK_IMPORTED_MODULE_11__events_meta__["f" /* fec15Meta */]), loadScripts);
}

function render(layout, metadata) {
  return function (ctx, next) {
    var renderOptions = Object.assign({
      metadata: metadata
    }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_0_domify___default()(layout()) });
    __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

    next();
  };
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_3_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.end(next);
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__guardian_page_pug__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__guardian_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__guardian_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* eslint-env browser, jquery */
/* global WOW */








function register() {
  __WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__["a" /* default */].redirect('/guardian', '/multifactor-authentication');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__["a" /* default */])('/multifactor-authentication', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_5__guardian_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_2_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js', 'TweenMax', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  // Hero intro animation
  $('.hero-flex-container .browser').addClass('animate');

  // video animation

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();
    playVid();
    showRePlay();
  });

  var vid = document.getElementById('guardian-video');

  function playVid() {
    vid.play();
  }

  function showRePlay() {
    $('a.play-me-again').hide();
    setTimeout(function () {
      $('a.play-me-again').show();
    }, 27000);
  }

  var wow = new WOW({
    boxClass: 'placeholder-media',
    mobile: true,
    live: true,
    callback: function callback(box) {
      playVid();
      showRePlay();
    }
  });

  wow.init();

  // end video animation
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__guest_authors_page_pug__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__guest_authors_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__guest_authors_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata_json__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__metadata_json__);
/* eslint-env browser, jquery */
// const debug = require('debug')('auth0:enterprise');









function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/guest-authors', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_7__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_2_domify___default()(__WEBPACK_IMPORTED_MODULE_6__guest_authors_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.end(next);
}

function snippets(ctx, next) {
  var gallery = document.getElementById('tech-gallery');
  var fullWidth = gallery.scrollWidth;
  var viewPortWidth = window.innerWidth;

  $('.technologies-gallery').scrollLeft(fullWidth / 2 - viewPortWidth / 2);

  // Hero join us smooth scroll

  $('.join-us').on('click', function (e) {
    var tarHref = $(e.target).attr('href');
    var tarOffset = $(tarHref).offset().top;
    $('html, body').animate({
      scrollTop: tarOffset
    }, 800);
  });

  $(window).scroll();

  // Form functionality

  $('.contact-form').on('submit', function (e) {
    e.preventDefault();

    var $currentForm = $(this);
    var $submitBtn = $(this).find('button[type="submit"]');
    var emailData = $currentForm.find('input[name=email]').val();
    var nameData = $currentForm.find('input[name=name]').val();
    var companyData = $currentForm.find('input[name=company]').val();
    var roleData = $currentForm.find('select[name=role]').val();
    var messageData = $currentForm.find('textarea[name=message]').val();

    if (!isValidEmail(emailData)) {
      alert('Please enter a valid email');
      return;
    }

    if (!(emailData && nameData && companyData && roleData && messageData)) {
      alert('please fill all fields');
      return;
    }

    sendForm();

    function sendForm() {
      $submitBtn.data('orig-text', $submitBtn.text());
      $submitBtn.attr('disabled', 'disabled');
      $submitBtn.text('Sending...');

      var formDataObject = {
        email: emailData,
        name: nameData,
        company: companyData,
        role: roleData,
        message: messageData,
        source: 'guest-authors',
        subject: 'New guest author candidate - ' + nameData
      };

      $.ajax({
        type: 'POST',
        url: 'https://auth0-marketing.run.webtask.io/contact-form',
        data: formDataObject,
        success: function success() {
          $submitBtn.text('Thanks for getting in touch!');
          $submitBtn.addClass('success');

          __WEBPACK_IMPORTED_MODULE_1_modules_metrics__["a" /* default */].lib().track('success:guest-author:contact', formDataObject);
        },
        error: function error() {
          $submitBtn.text($submitBtn.data('orig-text'));
          alert('There was a problem submitting your information. Please try again later.');

          __WEBPACK_IMPORTED_MODULE_1_modules_metrics__["a" /* default */].lib().track('guest-author:contact', formDataObject);
        }
      });
    }

    function isValidEmail(value) {
      var email = new RegExp(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);

      return email.test(value);
    }
  });

  next();
}

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity_glossary_page_pug__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity_glossary_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__identity_glossary_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__domUtils__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(233);












function register() {
  __WEBPACK_IMPORTED_MODULE_3_page___default()('/identity-glossary', initial);
  __WEBPACK_IMPORTED_MODULE_3_page___default()('/identity-glossary/:term', initial);

  __WEBPACK_IMPORTED_MODULE_3_page___default.a.exit('/identity-glossary', unMountApp);
  __WEBPACK_IMPORTED_MODULE_3_page___default.a.exit('/identity-glossary/:term', unMountApp);
}

function initial(ctx, next) {
  var view = __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_6__identity_glossary_page_pug___default()());

  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_8__metadata_json___default.a
  }, ctx.init ? {} : { view: view });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  var _ref = window.GLOSSARY_DATA || {},
      glossaryData = _ref.glossaryData;

  var glossaryItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* findById */])(glossaryData, ctx.params.term) || {};
  var props = Object.assign({ glossaryData: glossaryData, glossaryItem: glossaryItem }, { route: ctx.params.term || 'home' });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers__["a" /* App */], props), document.querySelector('.glossary-app'));

  if (ctx.hash !== '') {
    var el = document.getElementById(ctx.hash);
    var searchBarHeight = document.querySelector('.search-bar').offsetHeight;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__domUtils__["a" /* scrollToDOMElement */])(el, searchBarHeight);
  }
  return next();
}

function unMountApp(ctx, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_dom__["unmountComponentAtNode"])(document.querySelector('.glossary-app'));
  return next();
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_superagent__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jobs_page_pug__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jobs_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__jobs_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__culture_json__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__culture_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__culture_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__metadata_json__);
/* eslint-env browser, jquery */
/* global WOW */











var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('auth0:jobs');

var pollTimer = 0;
var numberOfLogins = 0;

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/jobs', loadJobs, render, loadScripts, updateContext);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/jobs/:department', loadJobs, render, loadScripts, opening, updateContext);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/jobs/:department/:opening', loadJobs, render, loadScripts, updateContext);
  __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */].exit('/jobs/(.*)?', unpoll);
}

function render(ctx, next) {
  var alreadyrender = $('.jobs-page #job-openings').length;

  $('html').removeClass('header-dark');

  if (alreadyrender) {
    ctx.rendered = true;
  }

  var view = __WEBPACK_IMPORTED_MODULE_3_domify___default()(__WEBPACK_IMPORTED_MODULE_7__jobs_page_pug___default()({
    jobs: ctx.jobs,
    culture: __WEBPACK_IMPORTED_MODULE_8__culture_json___default.a
  }));

  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_9__metadata_json___default.a
  }, ctx.init ? {} : { view: view });
  __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadJobs(ctx, next) {
  ctx.jobs = [];
  __WEBPACK_IMPORTED_MODULE_6_superagent___default.a.get('/jobs.json').end(function (err, res) {
    if (err) return next();
    if (!res || !res.body || !res.body.length) return next();
    return ctx.jobs = res.body, next();
  });
}

function opening(ctx, next) {
  $('nav.menu-bar a').removeClass('active');
  $('[href="/jobs/' + ctx.params.opening + '"]').addClass('active');
  $('.tab-content .tab-pane').removeClass('active');
  $('[id="' + ctx.params.opening + '"]').addClass('active');

  if (ctx.params.opening) {
    var title = $('[id="' + ctx.params.opening + '"] h3').text();

    setTitle(title);
    setDescription(title);
  }

  if (ctx.rendered) {
    $(window).scrollTop($('#job-openings').offset().top);
  }

  next();
}

function setTitle(text) {
  document.title = 'Jobs - ' + text;
}

function setDescription(text) {
  var $description = $('meta[name=description]');
  $description.attr('content', text + '. We are always looking for talented people to join our team.');
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/jobs/resources/owl-ffaa3c82ad.carousel.min.js', '$.fn.owlCarousel', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/jobs/resources/jquery-78b16ff121.accordion.js', '$.fn.accordion', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/jobs/resources/jquery-0850ae304b.mixitup.min.js', '$.MixItUp', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_npm_component_require_global__["a" /* default */])('//maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js', 'bootstrap', done);
  });

  batch.end(next);
}

function updateContext(ctx, next) {
  $('#owl-banner').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    nav: true,
    mouseDrag: false,
    lazyLoad: true
  });

  $('#owl-who').owlCarousel({
    items: 1,
    responsiveRefreshRate: 10,
    nav: false,
    mouseDrag: false,
    lazyLoad: true
  });

  $('#owl-culture').owlCarousel({
    center: true,
    loop: true,
    lazyLoad: true,
    responsiveRefreshRate: 10,
    mouseDrag: false,
    nav: true,
    dots: false,
    navText: '',
    items: 2
  });

  if (!$('#job-openings').data('initialized')) {
    $('html.jobs-page').on('click', '.jobs__item.mix', function (e) {
      $('#job-openings').data('initialized', true);

      if ($(e.target).parents('.modal').length || $(e.target).hasClass('modal')) {
        return;
      }

      var $link = $(this).find('a.jobs-item__more');

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])($link.attr('href'));
    });
  }

  function updateNumberOfLogins(callback) {
    $.ajax({
      url: '/jobs/counters',
      cache: false
    }).done(function (response) {
      numberOfLogins = response.logins;
      $('.js-join-stats').toggleClass('join-hidden', false);
      $('.js-join-stats').toggleClass('animated fadeInDown', true);

      $('#tokens').text(numberOfLogins.toLocaleString());

      if (typeof callback === 'function') callback();
    });
  }

  function poll() {
    debug("polling in %sms for new counter of jwt's issued", 1000);
    pollTimer = setTimeout(updateNumberOfLogins, 1000, poll);
  }

  updateNumberOfLogins(poll);

  new WOW().init();

  var loc = location.pathname.split('/').pop();

  switch (loc) {
    case 'jobs':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'customer-success':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.customer-success'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'security':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.security'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'engineer':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.engineer'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'h-r':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.h-r'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'marketing':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.marketing'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'design':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.design'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 'r-d':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.r-d'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    case 's-m':
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        load: {
          filter: '.s-m'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;

    default:
      $('.jobs__items').mixItUp({
        layout: {
          display: 'flex'
        },
        callbacks: {
          onMixEnd: function onMixEnd(state) {
            if (state.activeFilter === '.mix') {
              !ctx.params.opening && history.replaceState({ path: 'jobs' }, '', '/jobs');
            } else {
              history.replaceState({ path: 'jobs' }, '', '/jobs/' + state.activeFilter.split('.').pop());
            }
          }
        }
      });
      break;
  }

  $('.modal').each(function () {
    var id = $(this).attr('id');
    if (id === loc) {
      $('#' + id).modal('show');
    }
  });

  $('.modal').on('hidden.bs.modal', function () {
    if ($('span.filter.active').data('filter').split('.').pop() === 'all') {
      history.replaceState({ path: 'jobs' }, '', '/jobs');
    } else {
      history.replaceState({ path: 'jobs' }, '', '/jobs/' + $('span.filter.active').data('filter').split('.').pop());
    }
  });

  $('.modal').on('show.bs.modal', function () {
    var title = $(this).find('.modal-title').text();
    setTitle(title);
    setDescription(title);
  });

  $('.accordion').accordion({
    transitionSpeed: 400,
    singleOpen: false
  }).off('accordion.open').on('accordion.open', function (event) {
    var path = $(event.target).data('path');
    if (ctx.pathname !== path) __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */].replace(path);
  });

  if (ctx.params.opening) {
    $('#' + ctx.params.opening + '.accordion:not(.open) [data-control]').trigger('accordion.toggle');
  }

  // Scroll to href ID
  $('a[data="scroll-to"]').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });

  next();
}

function unpoll(ctx, next) {
  debug("clearing jwt' counter poll timer");
  clearTimeout(pollTimer);
  var modalCloseButton = document.querySelector('.close');
  if (modalCloseButton) modalCloseButton.click();
  debug('leaving page');
  next();
}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__homepage__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breached_passwords__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guardian__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__how_it_works__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__learn__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__why_auth0__ = __webpack_require__(636);





// import pricing from './pricing';


var pages = [__WEBPACK_IMPORTED_MODULE_0__homepage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__breached_passwords__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__guardian__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__how_it_works__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__learn__["a" /* default */],
// pricing,
__WEBPACK_IMPORTED_MODULE_5__why_auth0__["a" /* default */]];

function register() {
  pages.forEach(function (page) {
    return page();
  });
}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lock_page_pug__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lock_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__lock_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__metadata_json__);
/* eslint-env jquery, browser */
/* global Auth0Lock */











function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__["a" /* default */])('/lock', renderPage, loadscripts, snippets);
}

function renderPage(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_9__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_2_domify___default()(__WEBPACK_IMPORTED_MODULE_8__lock_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadscripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_3_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn2.auth0.com/jquery-libs/scrollmagic/js/jquery.scrollmagic.min.js', 'ScrollMagic', function (err) {
      if (err) return done();
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn2.auth0.com/jquery-libs/scrollmagic/js/jquery.scrollmagic.debug.js', 'ScrollMagic', done);
    });
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/lock/vendor/tooltips-a344d1455d.min.js', '$.fn.tooltip', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  var lockX = new Auth0Lock('yKJO1ckwuY1X8gPEhTRfhJXyObfiLxih', 'mdocs.auth0.com', {
    allowedConnections: ['mdocs.io', 'google-oauth2'],
    container: 'iphone-container',
    rememberLastLogin: false,
    theme: {},
    language: 'en'
  });

  lockX.show();

  $(window).load(function () {
    setTimeout(function () {
      $('#iphone-container').addClass('animated fadeIn').css('visibility', 'visible');
    }, 1000);

    setTimeout(function () {
      $('.iphone.iphone-left').addClass('animated fadeInRight').css('visibility', 'visible');
      $('.iphone.iphone-right').addClass('animated fadeInLeft').css('visibility', 'visible');
    }, 1000);
  });

  renderLockPlayground();

  connectionsTabs();

  $('[data-toggle="tooltip"]').tooltip();

  next();
}

function connectionsTabs() {
  $('.tabs-connections li').click(function () {
    $('.tabs-connections li').removeClass('active');
    $(this).addClass('active');
    $('.connection-category').addClass('hide');
    $('#' + $(this).data('target')).removeClass('hide');

    return false;
  });
}

/**
 * Render playground lock
 */
function renderLockPlayground() {
  var el = document.getElementById('playground-next');

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["e" /* LockPlayground */], null), el);
}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mcc_page_pug__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mcc_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mcc_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/mcc', render);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__mcc_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderNotfound__ = __webpack_require__(637);



function register() {
  __WEBPACK_IMPORTED_MODULE_0_page___default()('*', function (ctx, next) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__renderNotfound__["a" /* default */])(ctx, next);
  });
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__opensource_page_pug__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__opensource_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__opensource_page_pug__);
/* eslint-env browser, jquery */
/* global Isotope */









function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/opensource', loadScripts, repos, render);
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('//cdn.jsdelivr.net/isotope/2.0.0/isotope.pkgd.min.js', 'Isotope', done);
  });
  batch.end(next);
}

function repos(ctx, next) {
  ctx.repos = [];
  __WEBPACK_IMPORTED_MODULE_2_superagent___default.a.get('/opensource/repositories').end(function (err, res) {
    if (err) return next();
    if (!res || !res.body || !res.body.length) return next();
    return ctx.repos = res.body, next();
  });
}

function render(ctx, next) {
  var view = __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_7__opensource_page_pug___default()({ repos: ctx.repos }));

  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: view });
  __WEBPACK_IMPORTED_MODULE_3_modules_section_content__["a" /* default */].render(renderOptions);

  masonry();

  next();
}

function masonry() {
  var reposContainer = $('#repos')[0];
  var msnry = new Isotope(reposContainer, {
    // options
    itemSelector: '.repo-card-container',
    getSortData: {
      stars: '.stargazers_count parseInt'
    },
    sortAscending: false,
    sortBy: 'stars'
  });

  $('.masonry-nav ul li a').on('click', function (ev) {
    ev.preventDefault();

    var lang = $(this).attr('href').slice(1);

    $('.masonry-nav li').removeClass('active');
    $(this).parent('.masonry-nav li').addClass('active');

    var filterQuery = '[data-language%s]'.replace('%s', lang ? '=' + lang : '');

    $(reposContainer).isotope({
      filter: filterQuery,
      getSortData: {
        stars: '.stargazers_count parseInt'
      },
      sortAscending: false,
      sortBy: 'stars'
    });
  });
}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners_page_pug__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partners_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);
/* eslint-env browser, jquery */






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/partners', render, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__partners_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function snippets(ctx, next) {
  // "Go to" script
  $('a[data-go-to]').click(function () {
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') || location.hostname === this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });

  // Show on scroll
  var $animation_elements = $('.item .images');
  var $animation_elements_span = $('#ico > span');
  var $window = $(window);

  function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = window_top_position + window_height;

    $.each($animation_elements_span, function () {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = element_top_position + element_height;

      // check to see if this current container is within viewport
      if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
        $element.addClass('animate');
      }
    });

    $.each($animation_elements, function () {
      var $element = $(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = element_top_position + element_height;

      // check to see if this current container is within viewport
      if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
        $element.addClass('animate');
      }
    });
  }

  $window.on('scroll resize', check_if_in_view);
  $window.trigger('scroll');

  // Form stuff
  $('a[data-toggle="tab"]').on('shown.bs.tab', function () {
    $('.tab-pane').removeClass('animated');
    $('.tab-pane.active').addClass('animated');
  });

  $('.section-form form').on('submit', function (e) {
    e.preventDefault();

    var $currentForm = $(this);
    var $submitBtn = $(this).find('button[type="submit"]');
    var formData = getFormData();

    function setButtonToSend() {
      $submitBtn.data('orig-text', $submitBtn.text());

      $submitBtn.attr('disabled', 'disabled');
      $submitBtn.text('Sending...');
    }

    function isValidEmail(val) {
      if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val)) {
        return true;
      }
      return false;
    }

    function getFormData() {
      var str = '';
      var email = $currentForm.find('input[name="email"]').val();

      if (!isValidEmail(email)) {
        return alert('Please enter a valid email');
      }

      setButtonToSend();

      $currentForm.find('input, textarea').each(function () {
        var val = $(this).val();

        if (val && $(this).attr('name')) {
          str += $(this).attr('name') + ': ' + val + '\n';
        }
      });

      return str;
    }

    function sendForm() {
      $.ajax({
        type: 'POST',
        url: 'https://webtask.it.auth0.com/api/run/wt-victorhf-gmail_com-0/partner-to-slack?webtask_no_cache=1',
        data: JSON.stringify({
          data: {
            content: formData
          }
        }),
        processData: false,
        contentType: 'application/json',
        success: function success() {
          onFormSent($submitBtn);
        },
        error: function error() {
          $submitBtn.text($submitBtn.data('orig-text'));

          alert('There was a problem submitting your information. Please try again later.');
        }
      });
    }

    if (formData) {
      sendForm();
    }
  });

  function onFormSent($button) {
    $button.text('Thanks for getting in touch!');
    $button.addClass('success');
  }

  next();
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__passwordless_page_pug__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__passwordless_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__passwordless_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata_json__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__metadata_json__);
/* eslint-env browser, jquery */
/* global hljs, Auth0LockPasswordless, WOW */
// const debug = require('debug')('auth0:passwordless');









var newLockAnimated = void 0;
var hasScrolled = false;

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/passwordless', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_7__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_2_domify___default()(__WEBPACK_IMPORTED_MODULE_6__passwordless_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/passwordless/resources/highlight-fc8654573f.min.js', 'hljs', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/passwordless/resources/wow-a26a117ff5.min.js', 'wow', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn2.auth0.com/website/custom/lock-passwordless-2.min.js', 'lock', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  toggleSwitch();

  hljs.configure({
    classPrefix: ''
  });

  $('pre code').each(function (i, block) {
    hljs.highlightBlock(block);
  });

  var topLock = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  topLock.magiclink({
    container: 'top-iphone-lock',
    rememberLastLogin: false
  });

  var impMagicLink = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  impMagicLink.magiclink({
    container: 'magic-link-inline',
    rememberLastLogin: false
  });

  var impSMS = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  impSMS.sms({
    container: 'sms-inline',
    rememberLastLogin: false
  });

  newLockAnimated = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  newLockAnimated.magiclink({
    container: 'new-lock-animated',
    rememberLastLogin: false
  });

  var sdkIphoneLock = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  sdkIphoneLock.magiclink({
    container: 'sdk-iphone-lock',
    rememberLastLogin: false
  });

  var sdkNexusLock = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  sdkNexusLock.sms({
    container: 'sdk-nexus-lock',
    rememberLastLogin: false
  });

  // Before anything, set a content loaded flag

  var pwdLessElement = $('.passwordless-page');
  pwdLessElement.addClass('content-loaded');

  $('.intro [data-play]').on('click', function () {
    pwdLessElement.addClass('animating');

    setTimeout(function () {
      $('.intro').addClass('animation-start');

      setTimeout(function () {
        initIntroAnimation();
      }, 500);
    }, 1200);

    return false;
  });

  $('.intro [data-replay]').on('click', function () {
    resetAnimation();

    setTimeout(function () {
      $('.intro').removeClass('step1 step2 step3 step4 step5 step6 step7');
      $('section.intro .browser-lock.opened > .browser').attr('style', '');
    }, 500);

    setTimeout(function () {
      initIntroAnimation();
    }, 1500);

    return false;
  });

  // Image load check
  var iphone6Loaded = false,
      iphone5Loaded = false;

  // Create new image
  var iphone6 = new Image(),
      iphone5 = new Image();

  iphone6.onload = function () {
    iphone6Loaded = true;

    if (iphone5Loaded) {
      $('.passwordless-page').addClass('phones-loaded');
    }
  };
  iphone5.onload = function () {
    iphone5Loaded = true;

    if (iphone6Loaded) {
      $('.passwordless-page').addClass('phones-loaded');
    }
  };

  // Attach the source last.
  // The onload function will now trigger once it's loaded.
  iphone6.src = 'https://cdn.auth0.com/website/assets/pages/passwordless/img/iphone-white-f63526398b.png';
  iphone5.src = 'https://cdn.auth0.com/website/assets/pages/passwordless/img/iphone5-top-banner-c865eb6e46.png';

  if ($(iphone6).prop('complete') && $(iphone5).prop('complete')) {
    $('.passwordless-page').addClass('phones-loaded');
  }

  // Init wow

  var wow = new WOW();
  wow.init();

  var currentHash = window.location.hash;
  var qna = $('.qna');
  var qnaQuestions = $('.questions > a');
  var qnaAnswers = $('.answers-inner > div');
  var prevEl = $('.prev-arrow');
  var nextEl = $('.next-arrow');

  prevEl.on('click', function () {
    var current = qnaQuestions.filter('.active');
    current.removeClass('active');

    if (current.prev().length && current.prev()[0].tagName == 'A') {
      current.prev().addClass('active');
      qnaAnswers.filter('.active').removeClass('active').prev().addClass('active');
    } else {
      qnaQuestions.removeClass('active');
      qnaQuestions.eq(qnaQuestions.length - 1).addClass('active');
      qnaAnswers.removeClass('active');
      qnaAnswers.eq(qnaAnswers.length - 1).addClass('active');
    }
  });

  nextEl.on('click', function () {
    var current = qnaQuestions.filter('.active');
    current.removeClass('active');

    if (current.next().length) {
      current.next().addClass('active');
      qnaAnswers.filter('.active').removeClass('active').next().addClass('active');
    } else {
      qnaQuestions.removeClass('active');
      qnaQuestions.eq(0).addClass('active');
      qnaAnswers.removeClass('active');
      qnaAnswers.eq(0).addClass('active');
    }
  });

  qnaQuestions.click(function (e) {
    e.preventDefault();
    if (e.target.tagName !== 'A') {
      var ref = $(e.target).parent()[0].hash;
    } else {
      var ref = e.target.hash;
    }
    history.pushState(null, null, ref);

    qnaQuestions.filter('.active').removeClass('active');
    qnaQuestions.filter('[href="' + ref + '"]').addClass('active');

    qnaAnswers.filter('.active').removeClass('active');
    qnaAnswers.filter(ref).addClass('active');
  });

  if (currentHash) {
    qnaQuestions.filter('[href="' + currentHash + '"]').addClass('active');
    qnaAnswers.filter(currentHash).addClass('active');
  } else {
    qnaQuestions.eq(0).addClass('active');
    qnaAnswers.eq(0).addClass('active');
  }

  next();
}

function initIntroAnimation() {
  var a0LockIntro = $('section.intro');

  a0LockIntro.addClass('step1');

  // After the animation started bind a scroll handler to detect a scroll
  $(document).one('scroll', function () {
    if (!hasScrolled) {
      hasScrolled = true;
    }
  });

  setTimeout(function () {
    a0LockIntro.addClass('step2');
  }, 2000);

  setTimeout(function () {
    a0LockIntro.addClass('step3');
  }, 3500);

  setTimeout(function () {
    a0LockIntro.addClass('step4');

    $('.intro .center-content input.auth0-lock-input').typetype('rickyrauch@gmail.com', {
      e: 0,
      callback: function callback() {
        newLockAnimated.update(function (state) {
          return state.setIn(['cred', 'email', 'email'], 'rickyrauch@gmail.com');
        });
        newLockAnimated.requestGravatar('rickyrauch@gmail.com');
      }
    });
  }, 5800);

  setTimeout(function () {
    a0LockIntro.addClass('step5');

    $('.intro .center-content .auth0-lock-passwordless').addClass('auth0-lock-mode-loading');

    setTimeout(function () {
      $('.intro .center-content .auth0-lock-passwordless').addClass('auth0-lock-mode-completed');
    }, 2500);
  }, 11000);

  setTimeout(function () {
    a0LockIntro.addClass('step6');

    setTimeout(function () {
      a0LockIntro.find('.browser-lock.opened > .browser').hide();
    }, 400);
  }, 15500);

  setTimeout(function () {
    a0LockIntro.addClass('step7');
    $('.intro .center-content input.auth0-lock-input').backspace(20);
    newLockAnimated.update(function (state) {
      return state.setIn(['cred', 'email', 'email'], '');
    });

    if (!hasScrolled) {
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $('#imp').offset().top
        }, 1000);
      }, 4800);
    }
  }, 17500);
}

function resetAnimation() {
  $('.auth0-lock-header-logo').show();
  $('.auth0-lock-header-bg-inner').css('background-image', 'url(https://cdn.auth0.com/website/assets/pages/passwordless/img/badge-967bdae8f4.svg)').removeClass('auth0-lock-no-grayscale');
  $('.auth0-lock-header-avatar').addClass('auth0-lock-hide').removeClass('animated fadeInDown');
  $('.auth0-lock-firstname').addClass('auth0-lock-hide');
  $('.auth0-lock-name').show();

  var animLock = $('.center-content .auth0-lock-passwordless');

  animLock.removeClass('auth0-lock-mode-loading');
  animLock.removeClass('auth0-lock-mode-completed');
}

function toggleSwitch() {
  // Handler for nav
  $('.nav-text > a').click(function (e) {
    e.preventDefault();
    var attr = $(this).attr('href');
    var $content = $('.code-content');
    // $content.removeClass("active");

    $('.get-code .active').removeClass('active');
    // Add active to link
    $(this).addClass('active');
    // Add active to tab
    $('[data-lock="' + attr.slice(1) + '"]').addClass('active');
    // Add active to code example
    $(attr).addClass('active');
  });

  // Handler for tabs
  $('.nav-lock .lock-tab').click(function (e) {
    var data = $(this).data('lock');
    // Remove all actives
    $('.get-code .active').removeClass('active');
    // Add active to link
    var link = $('.nav-text > a').filter('[href="#' + data + '"]');
    link.addClass('active');
    // Add active to tab
    $(this).addClass('active');
    // Add active to code
    $(link.attr('href')).addClass('active');
  });
}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__press_page_pug__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__press_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__press_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers__ = __webpack_require__(235);
/* eslint-env browser */









function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/press', initial);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/press/:data', initial);

  __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */].exit('/press', unMountApp);
  __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */].exit('/press/:data', unMountApp);
}

function initial(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_0_domify___default()(__WEBPACK_IMPORTED_MODULE_5__press_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);
  var props = Object.assign(window.PRESS_DATA || {}, { route: ctx.params.data || 'press' });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers__["a" /* App */], props), document.querySelector('.press-app'));

  return next();
}

function unMountApp(ctx, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["unmountComponentAtNode"])(document.querySelector('.press-app'));
  return next();
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_component_tip__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_component_tip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_component_tip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pricing_pug__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pricing_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pricing_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__metadata_json__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_plans_meta__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__partials_features_features_partial__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__partials_pricing_partial__ = __webpack_require__(678);
/* eslint-env browser, jquery */
















var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('auth0:pricing');

var metricsLib = window.metricsLib;
var mouseFlow = window.mouseflow || undefined;

var track = function track(eventName, props) {
  debug('track', eventName, props);
  __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track(eventName, __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.extend({
    category: 'pricing'
  }, props));
};
var featuresPartial = new __WEBPACK_IMPORTED_MODULE_13__partials_features_features_partial__["a" /* default */]({ track: track });

var pricingPartial = new __WEBPACK_IMPORTED_MODULE_14__partials_pricing_partial__["a" /* default */]({ featuresPartial: featuresPartial, track: track });

function register() {
  // routing
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__["a" /* default */])('/pricing', loadScripts, render, renderPricing, renderFeatures, snippets);
}

// route handlers
// page render!
function render(ctx, next) {
  var view = __WEBPACK_IMPORTED_MODULE_3_domify___default()(__WEBPACK_IMPORTED_MODULE_10__pricing_pug___default()({ planMeta: __WEBPACK_IMPORTED_MODULE_12__models_plans_meta__["a" /* default */].load() }));

  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_11__metadata_json___default.a
  }, ctx.init ? {} : { view: view });
  __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render(renderOptions);

  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_7_batch___default.a();

  pricingPartial.load(batch);
  featuresPartial.load(batch);

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/pricing/resources/tooltips-a344d1455d.min.js', '$.fn.tooltips', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/pricing/resources/modal-3af0dc2fc3.min.js', '$.fn.modal', done);
  });

  batch.end(next);
}

function renderPricing(ctx, next) {
  pricingPartial.activate();
  pricingPartial.render();
  next();
}

function renderFeatures(ctx, next) {
  featuresPartial.activate();
  $('.js-plan-features-container').each(function () {
    var plan = this.getAttribute('data-plan');
    featuresPartial.render(plan);
  });
  // enable tooltips only in desktop view
  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
  }
  next();
}

function getModulesOffsets() {
  var modules = $('.pricing-module');
  var offsets = {};
  var count = 0;

  // Get all the plan groups in the page and asign them a data-sticky number
  modules.each(function (i, el) {
    var $el = $(el);

    // Check if composite module
    if (!$el.hasClass('composite-module')) {
      var elName = $el.attr('data-pricing-category');
      $el.attr('data-sticky', count);
      offsets[elName] = $(el).offset().top;
      count += 1;
      return;
    }

    // add composite module
    var plans = $el.find('[data-plan-group]');

    plans.each(function (i, el) {
      var elName = $(el).attr('data-plan-group');
      $(el).attr('data-sticky', count);
      offsets[elName] = $(el).offset().top;
      count += 1;
    });
  });

  return offsets;
}

// route handlers
// page snippets
function snippets(ctx, next) {
  var $featuresSwitch = $('.features-switch-cont');

  $(window).scroll();

  // Switch functionality
  $featuresSwitch.on('click', function (e) {
    $(this).find('.active').removeClass('active');
    $(e.target).addClass('active');
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(function (ev) {
    ev.preventDefault();
    toggleSwitcher($('.switch-plan[data-view="fixed-plans"] .switch-item:not(.active)'));
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(function (ev) {
    ev.preventDefault();
    if ($(this).hasClass('active')) return;
    toggleSwitcher(this);
  });

  __WEBPACK_IMPORTED_MODULE_5_component_tip___default()('.package-plan-tip');

  $('.js-general-contact-sales').click(function () {
    track('click:contact-sales');
  });

  // Developer Pro Internal-External Switch
  $(".plan-usage-toggle input[type='radio']").change(function () {
    var value = $(this).val();
    $('.developer-pro-external,.developer-pro-internal').toggleClass('hide', true);
    $('.developer-pro-' + value).toggleClass('hide', false);
    $('[name="usage"]').prop('checked', false);
    $('[name="usage"][value="' + value + '"]').prop('checked', function () {
      return $(this).parent().is(':visible');
    });
  });

  contactFormModals();

  next();
}

function toggleSwitcher(el) {
  if ($(el).hasClass('active')) return;

  // toggle buttons
  $('.switch-plan[data-view="fixed-plans"] .switch-item').removeClass('active');
  $(el).addClass('active');

  pricingPartial.setRecurrence($(el).data('interval'));
}

function contactFormModals() {
  // Contact Sales Form
  var salesContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    source: 'pricing-page'
  };
  var salesContactForm = new __WEBPACK_IMPORTED_MODULE_9_auth0_contact_form___default.a(salesContactFormOptions);

  $('.open-contact-form-modal').click(function () {
    return salesContactForm.show({ includePhoneField: true });
  });

  // Contact OSS Form
  var ossContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-oss');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    modalTitle: 'Contact OSS team',
    source: 'oss'
  };
  var ossContactForm = new __WEBPACK_IMPORTED_MODULE_9_auth0_contact_form___default.a(ossContactFormOptions);

  $('.open-contact-oss').click(function () {
    return ossContactForm.show({ includePhoneField: true });
  });
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacy_page_pug__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__privacy_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__privacy_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/privacy', render);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__privacy_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_main_pug__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_main_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_main_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__metadata_json__);










function register() {
  __WEBPACK_IMPORTED_MODULE_2_page___default()('/resources', render, setRoute.bind(null, 'home'));
  __WEBPACK_IMPORTED_MODULE_2_page___default()('/resources/whitepapers', render, setRoute.bind(null, 'whitepapers'));
  __WEBPACK_IMPORTED_MODULE_2_page___default()('/resources/webinars', render, setRoute.bind(null, 'webinars'));
  __WEBPACK_IMPORTED_MODULE_2_page___default()('/resources/ebooks', render, setRoute.bind(null, 'ebooks'));
  __WEBPACK_IMPORTED_MODULE_2_page___default()('/resources/videos', render, setRoute.bind(null, 'videos'));
}

var componentWasRendered = false;
function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_8__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_3_domify___default()(__WEBPACK_IMPORTED_MODULE_7__view_main_pug___default()()) });
  if (!componentWasRendered) {
    __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render(renderOptions);
  }

  /* eslint-env browser */
  var props = window.RESOURCES_APP_STATE;

  if (!componentWasRendered) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers__["a" /* default */], props), document.querySelector('.resource-app'));
    componentWasRendered = true;
  }
  return next();
}

function setRoute(route) {
  __WEBPACK_IMPORTED_MODULE_0_modules_npm_component_bus__["a" /* default */].emit('resources-page-route:' + route);
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_page_pug__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__security_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);
/* eslint-env browser, jquery */






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/security', render);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__security_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_signupForm__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_metadata_json__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_signup_pug__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_signup_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_signup_pug__);
/* eslint-env browser */







function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_ab_page_js__["a" /* default */])('/signup', render);
}

function render(ctx, next) {
  var _window$APP_CONFIG = window.APP_CONFIG,
      AUTH0_CLIENT_ID = _window$APP_CONFIG.AUTH0_CLIENT_ID,
      AUTH0_DOMAIN = _window$APP_CONFIG.AUTH0_DOMAIN,
      AUTH0_CALLBACK_URL = _window$APP_CONFIG.AUTH0_CALLBACK_URL;
  var AUTH0_CONNECTION = window.APP_CONFIG_SIGNUP.AUTH0_CONNECTION;


  var renderOptions = Object.assign({
    signupFormApp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_signupForm__["a" /* default */])({
      clientID: AUTH0_CLIENT_ID,
      domain: AUTH0_DOMAIN,
      callbackURL: AUTH0_CALLBACK_URL,
      dbConnectionName: AUTH0_CONNECTION
    }),
    metadata: __WEBPACK_IMPORTED_MODULE_4__data_metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_5__views_signup_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  return next();
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_metadata_json__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_metadata_json__);
/* eslint-env browser */







/**
 * Routes
 */
function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/subscription-center', initial);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render({ metadata: __WEBPACK_IMPORTED_MODULE_5__data_metadata_json___default.a });

  ctx.email = getEmailFromURL(); // eslint-disable-line no-param-reassign

  return clientRender(ctx, next);
}

/**
 * Get email from url (?email=pepito@auth0.com)
 */
function getEmailFromURL() {
  return window.location.search.substring(1).split('&').filter(function (item) {
    return item.toLowerCase().indexOf('email=') === 0;
  }).map(function (item) {
    return item.replace('email=', '');
  })[0] || '';
}

/**
 * Client render.
 */
function clientRender(ctx, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers__["a" /* default */], { email: ctx.email }), document.getElementById('app'), next);
}

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__terms_page_pug__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__terms_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__terms_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/terms', render);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__terms_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__whitehat_page_pug__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__whitehat_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__whitehat_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__metadata_json__);






function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/whitehat', render);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_4__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_3__whitehat_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptloader__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scriptloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__metadata_json__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__metadata_json__);
/* eslint-env browser, jquery */
/* global wistiaJQuery, WOW, Swiper, TimelineMax, TweenMax, hljs */












var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('auth0:why-auth0');

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_modules_ab_page_js__["a" /* default */])('/why-auth0', render, loadScripts, snippets);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_modules_ab_page_js__["a" /* default */])('/overview', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_10__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_5_domify___default()(__WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_7_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js', 'TweenMax', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TimelineMax.min.js', 'TimelineMax', done);
  });

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_2_scriptloader___default()('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/plugins/TextPlugin.min.js', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/highlight.js/8.4/highlight.min.js', 'hljs', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/Swiper/3.0.5/js/swiper.min.js', 'Swiper', done);
  });

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_2_scriptloader___default()('//fast.wistia.com/assets/external/popover-v1.js', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//fast.wistia.com/assets/external/iframe-api-v1.js', 'wistiaApi', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('body').addClass('loaded');

  if (window.wistiaJQuery) loadWistia();

  var vid = document.getElementById('why-video');

  function playVid() {
    vid.play();
  }

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();
    if (window.TimelineMax && window.TweenMax) scene1().resume();
    if (window.wistiaJQuery) playVid();
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('replay:get-started-animation');
  });

  $('.js-play-track').click(function (e) {
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-banner');
  });

  $('[data-toggle="tab"]').on('show.bs.tab', function (ev) {
    var target = $(this).attr('href');
    if ($(target).hasClass('active')) return;
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('viewed:old-new-tab', { value: target.slice(1) });
  });

  // show banner
  $('.banner .container h1, .banner .container p').addClass('animated fadeInDown').css('visibility', 'visible');
  $('.banner .container a').addClass('animated fadeInUp').css('visibility', 'visible');

  if (window.WOW) {
    var wow = new WOW({
      boxClass: 'start-steps',
      mobile: true,
      live: true,
      callback: function callback() {
        if (window.TimelineMax && window.TweenMax) scene1().resume();
        if (window.wistiaJQuery) playVid();
      }
    });
    wow.init();
  }

  if (window.hljs) hljs.initHighlightingOnLoad();

  $('nav.nav-pills.no-mobile a').hover(function (e) {
    e.preventDefault();
    $('nav.nav-pills.no-mobile a').removeClass('active');
    $(this).click().addClass('active');
  });

  if (window.Swiper) {
    var mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 2,
      centeredSlides: true,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 30,
      onSlideChangeEnd: function onSlideChangeEnd() {
        $('a.swiper-slide').removeClass('active');
        $('a.swiper-slide-active').click().addClass('active');
      }
    });
  }

  next();
}

function loadWistia() {
  var transitioned = 0;
  wistiaJQuery(document).bind('wistia-popover-open', function () {
    $('.banner .container h1, .banner .container p').addClass('animated fadeOutUp');
    $('.banner .container a').addClass('animated fadeOutDown');
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('open:video-popup');
  });

  wistiaJQuery(document).bind('wistia-popover', function (ev, iframe) {
    transitioned = 0;
    var api = iframe.wistiaApi;
    api.bind('secondchange', function (s) {
      transitioned = s;
      if (s && !(s % 10)) {
        // every 10 seconds, we trigger a length event
        __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('viewed:video-length', { value: transitioned });
      }
    });
    api.bind('play', function () {
      __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-play', { value: transitioned });
    });
    api.bind('pause', function () {
      __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-pause', { value: transitioned });
    });
  });

  wistiaJQuery(document).bind('wistia-popover-close', function () {
    $('.banner .container h1, .banner .container p').removeClass('animated fadeOutUp').addClass('animated fadeInDown');
    $('.banner .container a').removeClass('animated fadeOutDown').addClass('animated fadeInUp');
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('close:video-popup', { value: transitioned });
    transitioned = 0;
  });
}

function scene1() {
  var timeline = new TimelineMax({
    onComplete: function onComplete() {
      scene2().resume();
    }
  });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s4').removeClass('active');
  }), 0).to('.play-me-again', 0, {
    display: 'none',
    opacity: 1
  }, 0);

  // end reset

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s1').addClass('active');
  }), 0);

  timeline.pause();
  return timeline;
}

function scene2() {
  var timeline = new TimelineMax({
    onComplete: function onComplete() {
      scene3().resume();
    }
  });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s1').removeClass('active');
  }), 4.7).add(TweenMax.delayedCall(0, function () {
    $('.step.s2').addClass('active');
  }), 4.7);

  timeline.pause();
  return timeline;
}

function scene3() {
  var timeline = new TimelineMax({
    onComplete: function onComplete() {
      scene4().resume();
    }
  });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s2').removeClass('active');
  }), 1.5).add(TweenMax.delayedCall(0, function () {
    $('.step.s3').addClass('active');
  }), 1.5);

  timeline.pause();
  return timeline;
}

function scene4() {
  var timeline = new TimelineMax({ onComplete: stepScenesComplete });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s3').removeClass('active');
  }), 6).add(TweenMax.delayedCall(0, function () {
    $('.step.s4').addClass('active');
  }), 6).to('.play-me-again', 0.5, {
    display: 'block',
    opacity: 1
  }, 15);

  timeline.pause();
  return timeline;
}

function stepScenesComplete() {
  debug('scenes completed succesfully!');
}

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scriptloader__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scriptloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scriptloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_metadata_json__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_main_pug__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_main_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_main_pug__);
/* eslint-env browser, jquery */
/* global Modernizr */










function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_ab_page_js__["a" /* default */])('/wordpress', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__data_metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_0_domify___default()(__WEBPACK_IMPORTED_MODULE_7__views_main_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_3_modules_section_content__["a" /* default */].render(renderOptions);

  return next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_5_batch___default.a();

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_4_scriptloader___default()('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/jquery-3ab5f5c956.event.move.js', function () {
      __WEBPACK_IMPORTED_MODULE_4_scriptloader___default()('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/jquery-69dad42b8b.twentytwenty.js', function () {
        __WEBPACK_IMPORTED_MODULE_4_scriptloader___default()('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/jquery-e175ed3d7c.superscrollorama.js', function () {
          __WEBPACK_IMPORTED_MODULE_4_scriptloader___default()('https://cdn.auth0.com/website/assets/pages/wordpress/vendor/tweenlite-5a0a1d77b2.min.js', done);
        });
      });
    });
  });

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_4_scriptloader___default()('//ajax.aspnetcdn.com/ajax/modernizr/modernizr-2.8.3.js', done);
  });

  return batch.end(next);
}

function snippets(ctx, next) {
  $('#beforeafter').twentytwenty();

  $('a.btn.btn-success.btn-lg').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:download-wordpress-plugin');
  });

  if (!Modernizr.touch) {
    $.superscrollorama({
      triggerAtCenter: false,
      playoutAnimations: true
    });
  }

  next();
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', {copyWithin: __webpack_require__(258)});

__webpack_require__(69)('copyWithin');

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', {fill: __webpack_require__(148)});

__webpack_require__(69)('fill');

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2)
  , $find   = __webpack_require__(96)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(69)(KEY);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2)
  , $find   = __webpack_require__(96)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(69)(KEY);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(43)
  , $export        = __webpack_require__(2)
  , toObject       = __webpack_require__(60)
  , call           = __webpack_require__(266)
  , isArrayIter    = __webpack_require__(156)
  , toLength       = __webpack_require__(25)
  , createProperty = __webpack_require__(151)
  , getIterFn      = __webpack_require__(165);

$export($export.S + $export.F * !__webpack_require__(120)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export        = __webpack_require__(2)
  , createProperty = __webpack_require__(151);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(19)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(20).f
  , createDesc = __webpack_require__(53)
  , has        = __webpack_require__(24)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(30) && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(259);

// 23.1 Map Objects
module.exports = __webpack_require__(116)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2)
  , log1p   = __webpack_require__(269)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2)
  , sign    = __webpack_require__(158);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2)
  , $expm1  = __webpack_require__(157);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(2)
  , sign      = __webpack_require__(158)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(19)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {log1p: __webpack_require__(269)});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {sign: __webpack_require__(158)});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2)
  , expm1   = __webpack_require__(157)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(19)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2)
  , expm1   = __webpack_require__(157)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(2)
  , _isFinite = __webpack_require__(12).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {isInteger: __webpack_require__(264)});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(2)
  , isInteger = __webpack_require__(264)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(270)});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', {is: __webpack_require__(274)});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(73)
  , global             = __webpack_require__(12)
  , ctx                = __webpack_require__(43)
  , classof            = __webpack_require__(150)
  , $export            = __webpack_require__(2)
  , isObject           = __webpack_require__(16)
  , aFunction          = __webpack_require__(59)
  , anInstance         = __webpack_require__(70)
  , forOf              = __webpack_require__(118)
  , speciesConstructor = __webpack_require__(161)
  , task               = __webpack_require__(163).set
  , microtask          = __webpack_require__(725)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(75)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(76)($Promise, PROMISE);
__webpack_require__(122)(PROMISE);
Wrapper = __webpack_require__(97)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(120)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(2)
  , aFunction = __webpack_require__(59)
  , anObject  = __webpack_require__(14)
  , rApply    = (__webpack_require__(12).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(19)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = __webpack_require__(2)
  , create     = __webpack_require__(99)
  , aFunction  = __webpack_require__(59)
  , anObject   = __webpack_require__(14)
  , isObject   = __webpack_require__(16)
  , fails      = __webpack_require__(19)
  , bind       = __webpack_require__(719)
  , rConstruct = (__webpack_require__(12).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = __webpack_require__(20)
  , $export     = __webpack_require__(2)
  , anObject    = __webpack_require__(14)
  , toPrimitive = __webpack_require__(103);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(19)(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(2)
  , gOPD     = __webpack_require__(52).f
  , anObject = __webpack_require__(14);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = __webpack_require__(52)
  , $export  = __webpack_require__(2)
  , anObject = __webpack_require__(14);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(2)
  , getProto = __webpack_require__(101)
  , anObject = __webpack_require__(14);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = __webpack_require__(52)
  , getPrototypeOf = __webpack_require__(101)
  , has            = __webpack_require__(24)
  , $export        = __webpack_require__(2)
  , isObject       = __webpack_require__(16)
  , anObject       = __webpack_require__(14);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(2)
  , anObject      = __webpack_require__(14)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(273)});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(2)
  , anObject           = __webpack_require__(14)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(2)
  , setProto = __webpack_require__(275);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = __webpack_require__(20)
  , gOPD           = __webpack_require__(52)
  , getPrototypeOf = __webpack_require__(101)
  , has            = __webpack_require__(24)
  , $export        = __webpack_require__(2)
  , createDesc     = __webpack_require__(53)
  , anObject       = __webpack_require__(14)
  , isObject       = __webpack_require__(16);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if(__webpack_require__(30) && /./g.flags != 'g')__webpack_require__(20).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(721)
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(117)('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(117)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(117)('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(117)('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = __webpack_require__(265)
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(259);

// 23.2 Set Objects
module.exports = __webpack_require__(116)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2)
  , $at     = __webpack_require__(730)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(2)
  , toLength  = __webpack_require__(25)
  , context   = __webpack_require__(162)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(154)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(2)
  , toIndex        = __webpack_require__(77)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(2)
  , context  = __webpack_require__(162)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(154)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(2)
  , toIObject = __webpack_require__(40)
  , toLength  = __webpack_require__(25);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(277)
});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(2)
  , toLength    = __webpack_require__(25)
  , context     = __webpack_require__(162)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(154)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(12)
  , has            = __webpack_require__(24)
  , DESCRIPTORS    = __webpack_require__(30)
  , $export        = __webpack_require__(2)
  , redefine       = __webpack_require__(54)
  , META           = __webpack_require__(98).KEY
  , $fails         = __webpack_require__(19)
  , shared         = __webpack_require__(160)
  , setToStringTag = __webpack_require__(76)
  , uid            = __webpack_require__(61)
  , wks            = __webpack_require__(17)
  , wksExt         = __webpack_require__(279)
  , wksDefine      = __webpack_require__(731)
  , keyOf          = __webpack_require__(724)
  , enumKeys       = __webpack_require__(720)
  , isArray        = __webpack_require__(263)
  , anObject       = __webpack_require__(14)
  , toIObject      = __webpack_require__(40)
  , toPrimitive    = __webpack_require__(103)
  , createDesc     = __webpack_require__(53)
  , _create        = __webpack_require__(99)
  , gOPNExt        = __webpack_require__(727)
  , $GOPD          = __webpack_require__(52)
  , $DP            = __webpack_require__(20)
  , $keys          = __webpack_require__(74)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(100).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(102).f  = $propertyIsEnumerable;
  __webpack_require__(121).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(73)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(35)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(2)
  , $typed       = __webpack_require__(164)
  , buffer       = __webpack_require__(278)
  , anObject     = __webpack_require__(14)
  , toIndex      = __webpack_require__(77)
  , toLength     = __webpack_require__(25)
  , isObject     = __webpack_require__(16)
  , ArrayBuffer  = __webpack_require__(12).ArrayBuffer
  , speciesConstructor = __webpack_require__(161)
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(19)(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(122)(ARRAY_BUFFER);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each         = __webpack_require__(96)(0)
  , redefine     = __webpack_require__(54)
  , meta         = __webpack_require__(98)
  , assign       = __webpack_require__(270)
  , weak         = __webpack_require__(260)
  , isObject     = __webpack_require__(16)
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(116)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(260);

// 23.4 WeakSet Objects
__webpack_require__(116)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export   = __webpack_require__(2)
  , $includes = __webpack_require__(149)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(69)('includes');

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(2)
  , $entries = __webpack_require__(272)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(2)
  , ownKeys        = __webpack_require__(273)
  , toIObject      = __webpack_require__(40)
  , gOPD           = __webpack_require__(52)
  , createProperty = __webpack_require__(151);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2)
  , $values = __webpack_require__(272)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2)
  , $pad    = __webpack_require__(276);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2)
  , $pad    = __webpack_require__(276);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators    = __webpack_require__(138)
  , redefine      = __webpack_require__(54)
  , global        = __webpack_require__(12)
  , hide          = __webpack_require__(35)
  , Iterators     = __webpack_require__(72)
  , wks           = __webpack_require__(17)
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2)
  , $task   = __webpack_require__(163);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(12)
  , $export    = __webpack_require__(2)
  , invoke     = __webpack_require__(119)
  , partial    = __webpack_require__(728)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(68),__webpack_require__(45),__webpack_require__(91),__webpack_require__(42),__webpack_require__(8)):"function"==typeof define&&define.amd?define(["react","classnames/bind","prop-types","axios","classnames","lodash"],t):"object"==typeof exports?exports.Auth0WebHeader=t(require("react"),require("classnames/bind"),require("prop-types"),require("axios"),require("classnames"),require("lodash")):e.Auth0WebHeader=t(e.react,e["classnames/bind"],e["prop-types"],e.axios,e.classnames,e.lodash)}(this,function(e,t,n,a,r,l){return function(e){function t(a){if(n[a])return n[a].exports;var r=n[a]={i:a,l:!1,exports:{}};return e[a].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,a){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=63)}([function(e,t){e.exports=__webpack_require__(1)},function(e,t){e.exports=__webpack_require__(68)},function(e,t){e.exports=__webpack_require__(45)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(17),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){var n=t||u.default,a=l(n,e);return new f.default(a).select()}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o();return e.filter(function(e){return!e.include||new RegExp(e.include).test(t)})}function o(){return"undefined"!=typeof window&&window.location&&window.location.href?window.location.href:null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var i=n(57),u=a(i),s=n(26),f=a(s)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"16px",width:"16px",version:"1.1",viewBox:"0 0 16 16"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{fill:"#EB5424",transform:"translate(-573.000000, -612.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 363.000000)"},r.default.createElement("g",{transform:"translate(259.000000, 18.000000)"},r.default.createElement("g",{transform:"translate(158.000000, 0.000000)"},r.default.createElement("path",{d:"M14.4288892,24.7873118 L9.98923099,24.7873118 C9.37628068,24.7873118 8.87931643,24.2903182 8.87931643,23.6770541 L8.87931643,19.2371334 C8.87931643,18.6244244 9.37628068,18.1271532 9.98923099,18.1271532 L14.4288892,18.1271532 C15.042117,18.1271532 15.5388038,18.6244244 15.5388038,19.2371334 L15.5388038,23.6770541 C15.5388038,24.2903182 15.042117,24.7873118 14.4288892,24.7873118 L14.4288892,24.7873118 Z M14.4288892,19.7921235 C14.4288892,19.485769 14.1802683,19.2371334 13.8742094,19.2371334 L10.5444657,19.2371334 C10.2378518,19.2371334 9.98923099,19.485769 9.98923099,19.7921235 L9.98923099,23.122619 C9.98923099,23.4289735 10.2378518,23.6770541 10.5444657,23.6770541 L13.8742094,23.6770541 C14.1805458,23.6770541 14.4288892,23.4289735 14.4288892,23.122619 L14.4288892,19.7921235 L14.4288892,19.7921235 Z M14.4288892,15.9074704 L9.98923099,15.9074704 C9.37628068,15.9074704 8.87931643,15.4104768 8.87931643,14.7980452 L8.87931643,10.3581245 C8.87931643,9.74458295 9.37628068,9.24731183 9.98923099,9.24731183 L14.4288892,9.24731183 C15.042117,9.24731183 15.5388038,9.74458295 15.5388038,10.3581245 L15.5388038,14.7980452 C15.5388038,15.4104768 15.042117,15.9074704 14.4288892,15.9074704 L14.4288892,15.9074704 Z M14.4288892,10.9120046 C14.4288892,10.6056501 14.1802683,10.3581245 13.8742094,10.3581245 L10.5444657,10.3581245 C10.2378518,10.3581245 9.98923099,10.6059276 9.98923099,10.9120046 L9.98923099,14.2427776 C9.98923099,14.5488546 10.2378518,14.7980452 10.5444657,14.7980452 L13.8742094,14.7980452 C14.1805458,14.7980452 14.4288892,14.5488546 14.4288892,14.2427776 L14.4288892,10.9120046 L14.4288892,10.9120046 Z M5.54985025,24.7873118 L1.10991455,24.7873118 C0.496964242,24.7873118 0,24.2903182 0,23.6770541 L0,19.2371334 C0,18.6244244 0.496964242,18.1271532 1.10991455,18.1271532 L5.54985025,18.1271532 C6.16280056,18.1271532 6.65948733,18.6244244 6.65948733,19.2371334 L6.65948733,23.6770541 C6.65948733,24.2903182 6.16280056,24.7873118 5.54985025,24.7873118 L5.54985025,24.7873118 Z M5.54985025,19.7921235 C5.54985025,19.485769 5.30122939,19.2371334 4.99489297,19.2371334 L1.66487183,19.2371334 C1.35853541,19.2371334 1.10991455,19.485769 1.10991455,19.7921235 L1.10991455,23.122619 C1.10991455,23.4289735 1.35853541,23.6770541 1.66487183,23.6770541 L4.99489297,23.6770541 C5.30122939,23.6770541 5.54985025,23.4289735 5.54985025,23.122619 L5.54985025,19.7921235 L5.54985025,19.7921235 Z M5.54985025,15.9074704 L1.10991455,15.9074704 C0.496964242,15.9074704 0,15.4104768 0,14.7980452 L0,10.3581245 C0,9.74458295 0.496964242,9.24731183 1.10991455,9.24731183 L5.54985025,9.24731183 C6.16280056,9.24731183 6.65948733,9.74458295 6.65948733,10.3581245 L6.65948733,14.7980452 C6.65948733,15.4104768 6.16280056,15.9074704 5.54985025,15.9074704 L5.54985025,15.9074704 Z M5.54985025,10.9120046 C5.54985025,10.6056501 5.30122939,10.3581245 4.99489297,10.3581245 L1.66487183,10.3581245 C1.35853541,10.3581245 1.10991455,10.6059276 1.10991455,10.9120046 L1.10991455,14.2427776 C1.10991455,14.5488546 1.35853541,14.7980452 1.66487183,14.7980452 L4.99489297,14.7980452 C5.30122939,14.7980452 5.54985025,14.5488546 5.54985025,14.2427776 L5.54985025,10.9120046 L5.54985025,10.9120046 Z"})))))))))};t.default=l},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.getFeaturedVariant=void 0;var r=n(25),l=a(r),o=n(4),i=a(o);t.default=l.default,t.getFeaturedVariant=i.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(12),h=a(m),C=n(10),g=a(C),L=n(3),E=a(L),b=n(47),y=a(b),v=p.default.bind(y.default),_=function(e){function t(){var e,n,a,o;r(this,t);for(var i=arguments.length,u=Array(i),s=0;s<i;s++)u[s]=arguments[s];return n=a=l(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),a.state={highlight:{}},a.setDefaultHighlight=function(){var e=a.props.data,t=e.childrens.filter(function(e){return!!e.default});t.length&&a.setState({highlight:t[0].default})},a.highlightHandler=function(e){e&&a.setState({highlight:e})},o=n,l(a,o)}return o(t,e),i(t,[{key:"componentWillMount",value:function(){this.setDefaultHighlight()}},{key:"componentWillReceiveProps",value:function(){this.setDefaultHighlight()}},{key:"render",value:function(){var e=this,t=this.props,n=t.data,a=t.closeDropdowns,r=t.open;return s.default.createElement("div",{className:v("dropdown",n.dropdownClass,{"is-open":r,twoBlock:n.twoBlockLayout}),"aria-hidden":r?"false":"true"},n.childrens.map(function(t){switch(t.componentType){case"list":return s.default.createElement(h.default,{key:t.key,data:t,parentClass:n.dropdownClass,highlightHandler:e.highlightHandler,closeDropdowns:a});case"highlight":return s.default.createElement(g.default,{key:t.key,data:e.state.highlight,parentClass:n.dropdownClass,closeDropdowns:a});default:return null}}),n.footerLinks?s.default.createElement("footer",{className:v("footer-list",{"footer-highlight":n.footerHighlight})},n.footerLinks.map(function(e){return s.default.createElement(E.default,{key:e.id,footer:e,closeDropdowns:a})})):null)}}]),t}(u.Component);_.propTypes={data:c.default.object,closeDropdowns:c.default.func,open:c.default.bool},_.defaultProps={data:{}},t.default=_},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(7),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=n(0),l=a(r),o=n(2),i=a(o),u=n(1),s=a(u),f=n(48),c=a(f),d=s.default.bind(c.default),p=function(e){var t=e.data,n=e.parentClass,a=e.closeDropdowns;return l.default.createElement("div",{className:d({highlight:"moreDropdown"!==n,moreHighlight:"moreDropdown"===n})},t.componentTitle?l.default.createElement("h4",{className:d("section-title"),dangerouslySetInnerHTML:{__html:t.componentTitle}}):null,l.default.createElement("a",{href:t.link,onClick:a,className:d("content"),rel:t.external?"external":null},l.default.createElement("img",{src:t.thumbnail,alt:t.title}),l.default.createElement("h5",{className:d("title")},t.title),t.excerpt?l.default.createElement("p",{className:d("text")},t.excerpt):null,t.date?l.default.createElement("span",{className:d("time")},t.date):null),l.default.createElement("div",{className:d("content")},(t.morelinks||[]).map(function(e,t){var n=e.href,r=e.text,o=e.external;return l.default.createElement("a",{href:n,className:d("link"),onClick:a,key:t,rel:o?"external":null},r)})))};p.propTypes={data:i.default.object,parentClass:i.default.string,closeDropdowns:i.default.func},t.default=p},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(9),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=n(0),l=a(r),o=n(2),i=a(o),u=n(1),s=a(u),f=n(14),c=a(f),d=n(3),p=a(d),m=n(49),h=a(m),C=s.default.bind(h.default),g=function(e){var t=e.data,n=e.highlightHandler,a=e.parentClass,r=e.closeDropdowns;return l.default.createElement("div",{className:C("dropdownList",{moreDropdownList:"moreDropdown"===a,stackedList:t.stackedList,twoColList:t.twoColLayout,twoColListBig:t.twoColLayoutBig,highlight:t.highlight})},t.title?l.default.createElement("header",{className:C("header-title")},t.titleHref?l.default.createElement("a",{className:C("section-title",{hasArrow:t.titleHref}),href:t.titleHref},t.title):l.default.createElement("h4",{className:C("section-title")},t.title),t.description?l.default.createElement("span",{className:C("section-description"),dangerouslySetInnerHTML:{__html:t.description}}):null):null,t.subItems?l.default.createElement("div",{className:C("multi-list")},t.subItems.map(function(e){return l.default.createElement("ul",{role:"menubar",key:e.titleList},e.titleList?l.default.createElement("span",{className:C("title-list")},e.titleList):null,(e.items||[]).map(function(t){return l.default.createElement(c.default,{key:t.id,item:t,highlightHandler:n,hasArrow:e.hasArrows,parentClass:a,closeDropdowns:r})}))})):null,t.items?l.default.createElement("ul",{role:"menubar"},(t.items||[]).map(function(e){return l.default.createElement(c.default,{key:e.id,item:e,highlightHandler:n,hasArrow:t.hasArrows,parentClass:a,closeDropdowns:r})})):null,t.footerLinks?l.default.createElement("footer",{className:C("footer-list")},t.footerLinks.map(function(e){return l.default.createElement(p.default,{key:e.id,footer:e,closeDropdowns:r})})):null)};g.propTypes={data:i.default.object,highlightHandler:i.default.func,parentClass:i.default.string,closeDropdowns:i.default.func},t.default=g},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(11),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(50),h=a(m),C=n(5),g=a(C),L=n(35),E=a(L),b=n(29),y=a(b),v=n(45),_=a(v),w=n(32),k=a(w),M=n(44),x=a(M),O=n(42),j=a(O),B=n(43),F=a(B),D=n(34),P=a(D),T=n(40),N=a(T),S=n(31),I=a(S),H=n(36),Z=a(H),W=n(46),A=a(W),q=n(37),R=a(q),z=n(38),U=a(z),V=n(41),Q=a(V),G=p.default.bind(h.default),K=function(e){function t(){return r(this,t),l(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"componentDidMount",value:function(){var e=this.props.item;if(e.highlight&&e.highlight.thumbnail){(new Image).src=e.highlight.thumbnail}}},{key:"render",value:function(){var e=this.props,t=e.hasArrow,n=e.parentClass,a=e.highlightHandler,r=e.item,l=e.closeDropdowns,o={webtask:s.default.createElement(N.default,null),guardian:s.default.createElement(P.default,null),b2c:s.default.createElement(F.default,null),b2b:s.default.createElement(j.default,null),b2e:s.default.createElement(x.default,null),logoDefault:s.default.createElement(k.default,null),javascript:s.default.createElement(E.default,null),ios:s.default.createElement(_.default,null),android:s.default.createElement(y.default,null),quickstarts:s.default.createElement(g.default,null),breached:s.default.createElement(I.default,null),lock:s.default.createElement(Z.default,null),mtm:s.default.createElement(A.default,null),multifactor:s.default.createElement(R.default,null),passwordless:s.default.createElement(U.default,null),wordpress:s.default.createElement(Q.default,null)},i=r.external?"external":null;return s.default.createElement("li",{className:G({item:!t,arrowItem:t,moreItem:"moreDropdown"===n}),onMouseEnter:function(){a(r.highlight)},onFocus:function(){a(r.highlight)},role:"menuitem"},s.default.createElement("a",{className:G(r.customClass||""),href:r.href,onClick:l,rel:i},r.icon?s.default.createElement("figure",{className:G("icon")},o[r.icon]):null,s.default.createElement("span",{className:G("text")},r.name,r.prefix?s.default.createElement("span",{className:G("itemPrefix")},r.prefix):null),r.description?s.default.createElement("p",{className:G("item-description")},r.description):null))}}]),t}(u.Component);K.propTypes={item:c.default.object,highlightHandler:c.default.func,hasArrow:c.default.bool,parentClass:c.default.string,closeDropdowns:c.default.func},t.default=K},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(13),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(51),h=a(m),C=n(4),g=a(C),L=p.default.bind(h.default),E=(0,g.default)(),b=function(e){function t(){return r(this,t),l(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"componentWillMount",value:function(){E=(0,g.default)()}},{key:"render",value:function(){var e=this.props,t=e.iconColor,n=e.link,a=e.title,r=e.description,l=e.cta,o=e.theme,i=e.dropdownOpen,u=e.notificationOpen,f=e.closeNotificationHandler;return s.default.createElement("div",{className:L("featured",["theme-"+o],{dropdownOpen:i},{notificationOpen:u})},s.default.createElement("div",{className:L("featured-content")},s.default.createElement("a",{href:n||E.link,rel:"external"},s.default.createElement("span",{className:L("featured-icon"),style:{backgroundColor:t||E.iconColor}}),s.default.createElement("span",{className:L("featured-title")},a||E.title),s.default.createElement("span",{className:L("featured-description")},r||E.description),s.default.createElement("span",{className:L("featured-more")},l||E.cta)),s.default.createElement("button",{type:"button",className:L("close-notification"),onClick:f},s.default.createElement("span",{className:"sr-only"},"Close featured banner"))))}}]),t}(u.Component);b.propTypes={iconColor:c.default.string,link:c.default.string,title:c.default.string,description:c.default.string,cta:c.default.string,theme:c.default.string,dropdownOpen:c.default.bool,notificationOpen:c.default.bool,closeNotificationHandler:c.default.func},b.defaultProps={iconColor:null,link:null,title:null,description:null,cta:null},t.default=b},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(15),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(52),h=a(m),C=n(39),g=a(C),L=n(5),E=a(L),b=n(30),y=a(b),v=n(33),_=a(v),w=p.default.bind(h.default),k=function(e){function t(){return r(this,t),l(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"render",value:function(){var e=this.props,t=e.footer,n=e.closeDropdowns,a={pricing:s.default.createElement(g.default,null),products:s.default.createElement(E.default,null),blog:s.default.createElement(y.default,null),extend:s.default.createElement(_.default,null)},r=t.external?"external":null;return s.default.createElement("a",{className:w("footer-link"),href:t.href,onClick:n,rel:r},t.icon?s.default.createElement("span",{className:w("icon")},a[t.icon]):null,s.default.createElement("span",{className:w("text"),dangerouslySetInnerHTML:{__html:t.name}}))}}]),t}(u.Component);k.propTypes={footer:c.default.object,closeDropdowns:c.default.func},t.default=k},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(53),h=a(m),C=p.default.bind(h.default),g=function(e){function t(){return r(this,t),l(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return o(t,e),i(t,[{key:"render",value:function(){var e=this.props.mobileLinks,t=e.external?"external":null;return s.default.createElement("li",null,s.default.createElement("a",{className:C("mobile-link"),href:e.href,rel:t},e.name))}}]),t}(u.Component);g.propTypes={mobileLinks:c.default.object},t.default=g},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(18),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var r=n(0),l=a(r),o=n(2),i=a(o),u=n(1),s=a(u),f=n(54),c=a(f),d=s.default.bind(c.default),p=function(e){var t=e.toggleDropdownHandler,n=e.dropdownOpen,a=e.theme,r=e.closeHeaderDropdown;return l.default.createElement("div",{className:d("head",["theme-"+a],{dropdownOpen:n})},l.default.createElement("button",{type:"button",className:d("toggleButton","collapsed",{closeButton:n}),onClick:t},l.default.createElement("span",{className:"sr-only"},"Toggle navigation"),l.default.createElement("span",{className:d("iconBar")}),l.default.createElement("span",{className:d("iconBar")}),l.default.createElement("span",{className:d("iconBar")}),l.default.createElement("span",{className:d("iconBar")})),l.default.createElement("h1",{className:d("brand")},l.default.createElement("a",{href:"/",rel:"home",className:d("logo"),onClick:r},l.default.createElement("span",null,"Auth0"))))};p.propTypes={toggleDropdownHandler:i.default.func,dropdownOpen:i.default.bool,theme:i.default.string,closeHeaderDropdown:i.default.func},t.default=p},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(20),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(8),h=a(m),C=n(55),g=a(C),L=p.default.bind(g.default),E=function(e){function t(){var e,n,a,o;r(this,t);for(var i=arguments.length,u=Array(i),s=0;s<i;s++)u[s]=arguments[s];return n=a=l(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),a.state={openDropdown:!1},a.handleDropdown=function(e){var t=a.state.openDropdown,n=a.props.mobile,r=n,l=["mouseenter","focus"].indexOf(e.type)>-1;l===t||r||a.setState({openDropdown:l})},a.closeItemDropdown=function(){var e=!a.props.mobile,t=a.state.openDropdown;e&&t&&a.setState({openDropdown:!1})},a.closeDropdowns=function(){a.closeItemDropdown(),a.props.closeHeaderDropdown()},o=n,l(a,o)}return o(t,e),i(t,[{key:"render",value:function(){var e=this.props,t=e.item,n=e.theme,a=e.simpleList,r=e.mobile,l=s.default.createElement(b,{name:t.name,childrens:t.childrens,theme:n}),o=(r?t.mobileHref:null)||t.href,i=t.external?"external":null;return s.default.createElement("li",{className:L("item",["item-"+t.id],["theme-"+n],{"simple-list":a,"is-dropdown-open":this.state.openDropdown}),onMouseEnter:this.handleDropdown,onFocus:this.handleDropdown,onMouseLeave:this.handleDropdown,onBlur:this.handleDropdown,role:"menuitem","aria-haspopup":"true"},o?s.default.createElement("a",{href:o,onClick:this.closeDropdowns,className:L("link"),rel:i},l):s.default.createElement("span",{tabIndex:"0",className:L("link")},l),t.childrens?s.default.createElement(h.default,{data:t,closeDropdowns:this.closeDropdowns,open:this.state.openDropdown}):null)}}]),t}(u.Component);E.propTypes={item:c.default.shape({id:c.default.string,name:c.default.string,mobileHref:c.default.string,dropdownClass:c.default.string,simpleList:c.default.bool,children:c.default.arrayOf(c.default.object)}),theme:c.default.string,simpleList:c.default.bool,closeHeaderDropdown:c.default.func,mobile:c.default.bool},t.default=E;var b=function(e){var t=e.name,n=e.childrens,a=e.theme;return s.default.createElement("span",null,s.default.createElement("span",{className:L("text")},t),n?s.default.createElement("svg",{width:"8",height:"4",viewBox:"62 7 10 6",className:L("item-caret")},s.default.createElement("path",{d:"M71.884 7.698l-4.56 5.116c-.013.022-.008.05-.026.07-.083.084-.192.12-.3.116-.106.004-.214-.033-.295-.117-.02-.02-.014-.047-.028-.068L62.115 7.7c-.154-.16-.154-.42 0-.58.156-.16.408-.16.563 0L67 11.97l4.322-4.85c.155-.16.406-.16.56 0 .157.16.157.418.002.578z",fill:"dark"===a?"#fff":"#000"})):null,n?s.default.createElement("span",{className:L("dropdown-caret")}):null)};b.propTypes={name:c.default.string,childrens:c.default.array,theme:c.default.string}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(22),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function l(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,n,a){return n&&e(t.prototype,n),a&&e(t,a),t}}(),u=n(0),s=a(u),f=n(2),c=a(f),d=n(1),p=a(d),m=n(61),h=a(m),C=n(60),g=a(C),L=n(21),E=a(L),b=n(16),y=a(b),v=n(23),_=a(v),w=n(19),k=a(w),M=n(58),x=a(M),O=n(59),j=a(O),B=n(56),F=a(B),D=n(28),P=a(D),T=p.default.bind(F.default),N="https://auth0-marketing.run.webtask.io/last-blog-post",S=function(e){function t(){var e,n,a,o;r(this,t);for(var i=arguments.length,u=Array(i),s=0;s<i;s++)u[s]=arguments[s];return n=a=l(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),a.state={navbarDropdownIsOpen:!1,notificationIsOpen:!0,mobileState:!0,menuItems:x.default,menuItemsMobile:j.default},a.setHeightDropdown=function(){var e=a.state.mobileState?window.innerHeight-70+"px":"";a.dropdownContent.style.height=e},a.updateBlogPost=function(){g.default.get(N).then(function(e){return[a.state.menuItems,e.data]}).then(P.default).then(function(e){a.setState({menuItems:e})}).catch(function(e){return console.info("Auth0WebHeader",e)})},a.handleResize=function(){var e=window.innerWidth<a.props.breakpoint;a.setState({mobileState:e},function(){a.addOverflowBody(),a.setHeightDropdown()})},a.navbarDropdownHandler=function(){a.setState({navbarDropdownIsOpen:!a.state.navbarDropdownIsOpen},a.addOverflowBody)},a.closeDropdownOnButtonClick=function(e){return function(t){var n=a.state.mobileState,r=a.state.navbarDropdownIsOpen;e&&e(t),n&&r&&a.navbarDropdownHandler()}},a.handleKeyDown=function(e){9!==e.keyCode||a.state.focusable||a.setState({focusable:!0})},a.notificationHandler=function(){a.setState({notificationIsOpen:!a.state.notificationIsOpen})},o=n,l(a,o)}return o(t,e),i(t,[{key:"componentDidMount",value:function(){this.handleResize(),window.addEventListener("resize",this.handleResize),this.updateBlogPost()}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.handleResize)}},{key:"addOverflowBody",value:function(){var e=this.state,t=e.navbarDropdownIsOpen,n=e.mobileState;t&&n?document.body.classList.add(T("overflow")):document.body.classList.remove(T("overflow"))}},{key:"render",value:function(){var e=this,n=this.props,a=n.className,r=n.children,l=n.theme,o=n.featuredEnable,i=n.featuredIconColor,u=n.featuredLink,f=n.featuredTitle,c=n.featuredDescription,d=n.featuredCTA,p=n.signupButtonEnable,m=n.signupButtonLink,C=n.signupButtonOnClick,g=n.signupButtonText,L=n.talkToSalesButtonEnable,b=n.talkToSalesButtonLink,v=n.talkToSalesButtonOnClick,w=n.talkToSalesButtonText,M=n.loginButtonEnable,x=n.loginButtonLink,O=n.loginButtonOnClick,j=n.loginButtonText,B=this.state,F=B.navbarDropdownIsOpen,D=B.mobileState,P=B.focusable,N=B.menuItems,S=B.menuItemsMobile,I=B.notificationIsOpen,H=t.renderButton(m,this.closeDropdownOnButtonClick(C),g,"btn btn-success btn-sm signup-button"),Z=t.renderButton(b,this.closeDropdownOnButtonClick(v),w,"btn btn-transparent btn-sm talk-button"),W=t.renderButton(x,this.closeDropdownOnButtonClick(O),j,T("login-button",{"login-button--dark":"dark"===l})),A=S.map(function(e,t){return s.default.createElement(k.default,{key:e.id,mobileLinks:e})}),q=N.map(function(t,n){return s.default.createElement(_.default,{key:n+t.id,item:t,theme:l,simpleList:t.simpleList,closeHeaderDropdown:e.closeDropdownOnButtonClick(),mobile:D})});return s.default.createElement("header",{className:T("header-main",{"is-notification-open":I})},o&&s.default.createElement(y.default,{iconColor:i,link:u,title:f,description:c,cta:d,dropdownOpen:F,notificationOpen:I,theme:l,closeNotificationHandler:this.notificationHandler}),s.default.createElement("div",{className:T("header",["theme-"+l],a,{"is-dropdown-open":F,focusable:P}),onKeyDown:this.handleKeyDown},s.default.createElement("div",{className:T("menu",{"is-dropdown-open":F})},s.default.createElement("div",{className:"container"},s.default.createElement(E.default,{toggleDropdownHandler:this.navbarDropdownHandler,dropdownOpen:F,theme:l,closeHeaderDropdown:this.closeDropdownOnButtonClick()}),s.default.createElement("div",{className:T("collapse",{"is-dropdown-open":F}),ref:function(t){e.dropdownContent=t}},s.default.createElement("nav",{className:T("main-navigation"),role:"navigation","aria-label":"Main menu"},s.default.createElement("ul",{className:T("navigation"),role:"menubar"},r||q,s.default.createElement("li",{className:(0,h.default)({"theme-dark":"dark"===l})},L&&Z)),s.default.createElement("div",{className:T("menu-mobile")},L&&Z,s.default.createElement("ul",null,A))),s.default.createElement("div",{className:(0,h.default)(T("buttons-group"),{"theme-dark":"dark"===l})},M&&W,p&&H))))))}}],[{key:"renderButton",value:function(e,t,n,a){return e?s.default.createElement("a",{href:e,className:a,onClick:t},n):s.default.createElement("button",{className:a,onClick:t},n)}}]),t}(u.Component);S.propTypes={className:c.default.string,children:c.default.node,theme:c.default.oneOf(["light","gray","dark"]),featuredEnable:c.default.bool,featuredIconColor:c.default.string,featuredLink:c.default.string,featuredTitle:c.default.string,featuredDescription:c.default.string,featuredCTA:c.default.string,loginButtonEnable:c.default.bool,loginButtonLink:c.default.string,loginButtonOnClick:c.default.func,loginButtonText:c.default.string,signupButtonEnable:c.default.bool,signupButtonLink:c.default.string,signupButtonOnClick:c.default.func,signupButtonText:c.default.string,talkToSalesButtonEnable:c.default.bool,talkToSalesButtonLink:c.default.string,talkToSalesButtonOnClick:c.default.func,talkToSalesButtonText:c.default.string,breakpoint:c.default.number},S.defaultProps={className:"",children:null,theme:"light",featuredEnable:!0,featuredIconColor:null,featuredLink:null,featuredTitle:null,featuredDescription:null,featuredCTA:null,loginButtonEnable:!0,loginButtonLink:"",loginButtonOnClick:function(){},loginButtonText:"Log In",signupButtonEnable:!0,signupButtonLink:"",signupButtonOnClick:function(){},signupButtonText:"Sign up",talkToSalesButtonEnable:!0,talkToSalesButtonLink:"?contact=true",talkToSalesButtonOnClick:function(){},talkToSalesButtonText:"Talk to Sales",breakpoint:992},t.default=S},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(24),r=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=r.default},function(e,t,n){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0}),n(27);var r=function e(t){var n=this;a(this,e),this.select=function(){var e=n.getRandom(),t=n.getIntervals(),a=t.find(function(t){return e>=t.from&&e<t.to});return a?a.variant:null},this.getRandom=function(){return Math.random()},this.getTotal=function(){return n.variants.reduce(function(e,t){return e+t.probability},0)},this.getIntervals=function(){var e=0,t=n.getTotal(),a=n.variants.find(function(e){return 1===e.probability});return n.variants.map(function(n){var r=n.probability,l=e,o=r/t+l;return e=o,a&&1===r&&(l=0,o=1),a&&1!==r&&(l=0,o=0),{variant:n,from:l,to:o}})},this.variants=t};t.default=r},function(e,t,n){"use strict";Array.prototype.find||(Array.prototype.find=function(e){if(null==this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof e)throw new TypeError("predicate must be a function");for(var t,n=Object(this),a=n.length>>>0,r=arguments[1],l=0;l<a;l++)if(t=n[l],e.call(r,t,l,n))return t})},function(e,t,n){"use strict";function a(e){var t=u(e,2),n=t[0],a=t[1],o=[{id:"latest-blog",value:r(a)}];return i(o.map(function(e){return e.id}).map(function(e){return l(e,n)}),o),n}function r(e){return e||(0,s.isObject)(e)?e:null}function l(e,t){var n=[];return t.forEach(function(t){t.childrens&&(n.push(o(t,"childrens",e)),t.childrens.forEach(function(t){t.items&&n.push(o(t,"items",e))}),t.footerLinks&&t.footerLinks.forEach(function(t){t.id===e&&n.push(t)}))}),n.filter(function(e){return!1!==e})[0]}function o(e,t,n){var a=e[t];if(!a)return!1;var r=a.filter(function(e){return e.id===n});return!!r.length&&r[0]}function i(e,t){e.forEach(function(e,n){var a=t[n];e&&(e.name+=a.value.title,e.href=a.value.link)})}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){var n=[],a=!0,r=!1,l=void 0;try{for(var o,i=e[Symbol.iterator]();!(a=(o=i.next()).done)&&(n.push(o.value),!t||n.length!==t);a=!0);}catch(e){r=!0,l=e}finally{try{!a&&i.return&&i.return()}finally{if(r)throw l}}return n}return function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t.default=a;var s=n(62)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"18px",width:"16px",version:"1.1",viewBox:"0 0 16 18"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{fill:"#EB5424",transform:"translate(-2332.000000, -312.000000)"},r.default.createElement("g",{transform:"translate(2297.000000, 116.000000)"},r.default.createElement("g",{transform:"translate(-2.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(35.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(1.000000, 25.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 92.000000)"},r.default.createElement("path",{d:"M2.11077173,84.8220732 C1.49734241,84.8217705 1.00015135,85.3201724 1,85.9331477 L1.00075676,90.5851003 C1.00090811,91.2001945 1.49840187,91.6966288 2.11198255,91.6964774 C2.72586593,91.6964774 3.22320834,91.2000431 3.22260293,90.5852516 L3.22260293,85.9325423 C3.22230023,85.3197183 2.72450377,84.8217705 2.11077173,84.8220732 L2.11077173,84.8220732 Z M11.0697459,80.6444576 L11.8451218,79.2285604 C11.8864408,79.1545493 11.8593488,79.0604084 11.7844296,79.0184839 C11.7087537,78.9783756 11.6153696,79.005619 11.5752613,79.0800841 L10.7920151,80.5108138 C10.1330289,80.2174938 9.39549095,80.0531256 8.61512046,80.0538824 C7.83686889,80.0531256 7.09963369,80.2170397 6.44337177,80.5086949 L5.65921748,79.0815976 C5.61850381,79.0063757 5.52466562,78.9791324 5.45065453,79.0201488 C5.37528128,79.0608624 5.34758388,79.1551547 5.38950836,79.2290144 L6.16518694,80.6440035 C4.64107312,81.429974 3.61127466,82.9268445 3.61218277,84.6454455 L13.619269,84.6442347 C13.6195717,82.9262391 12.5915894,81.4323957 11.0697459,80.6444576 L11.0697459,80.6444576 Z M6.3390903,82.8325523 C6.10888403,82.8320982 5.92090495,82.6447245 5.92090495,82.4131561 C5.92090495,82.1826471 6.10827862,81.9931545 6.33954436,81.9933059 C6.57156685,81.9931545 6.75924323,82.1826471 6.75954593,82.4131561 C6.75954593,82.6444218 6.5714155,82.8324009 6.3390903,82.8325523 L6.3390903,82.8325523 Z M10.8956912,82.8317955 C10.6644254,82.8320982 10.4761437,82.6445732 10.4761437,82.4123993 C10.4770518,82.1823444 10.6641227,81.9928518 10.8958425,81.9919437 C11.1260488,81.9927005 11.3147846,82.1823444 11.3146333,82.4125507 C11.3150873,82.6441191 11.1269569,82.8319468 10.8956912,82.8317955 L10.8956912,82.8317955 Z M3.65304779,85.0319983 L3.65471266,92.241647 C3.65425861,92.8974549 4.18474708,93.4268839 4.84010089,93.4268839 L5.64726068,93.4271866 L5.64816879,95.8887742 C5.64801744,96.5017495 6.14626795,97 6.75833512,97 C7.3722185,97 7.86956091,96.5012954 7.86971226,95.8880175 L7.86910685,93.4270352 L9.36885302,93.4265812 L9.36945842,95.8880175 C9.36945842,96.5005387 9.86786029,96.9998486 10.4800788,96.9986378 C11.0939622,96.9990919 11.5916073,96.5003873 11.5914559,95.8871093 L11.5906992,93.4262785 L12.4007347,93.4256731 C13.054575,93.4259758 13.5864256,92.8959414 13.5867283,92.2399821 L13.5853661,85.0303335 L3.65304779,85.0319983 L3.65304779,85.0319983 Z M16.2355382,85.9314828 C16.2353869,85.3177508 15.7381958,84.8204084 15.1244638,84.8207111 C14.5110345,84.8201057 14.0139948,85.3182048 14.0139948,85.9319369 L14.0149029,90.5841921 C14.0147515,91.1983782 14.5117912,91.6948125 15.1256746,91.6949639 C15.7392553,91.6948125 16.2361436,91.1983782 16.236295,90.5835867 L16.2355382,85.9314828 Z"})))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"16px",width:"16px",version:"1.1",viewBox:"0 0 16 16"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{fill:"#EB5424",transform:"translate(-2329.000000, -421.000000)"},r.default.createElement("g",{transform:"translate(2297.000000, 116.000000)"},r.default.createElement("g",{transform:"translate(-2.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(34.000000, 297.000000)"},r.default.createElement("path",{d:"M14.500049,24 L1.50000507,24 C0.671752271,24 0,23.327458 0,22.4984062 L0,13.4890931 C0,12.6597912 0.671752271,11.9882493 1.50000507,11.9882493 L3.00001014,11.9882493 L3.00001014,9.54784674 C3.00001014,8.69304332 3.67151241,8 4.50001521,8 L14.500049,8 C15.3283018,8 16.0000541,8.69304332 16.0000541,9.54784674 L16.0000541,22.4519032 C16.0000541,23.3067067 15.3283018,24 14.500049,24 L14.500049,24 Z M15.0000507,9.51734483 C15.0000507,9.23107694 14.7760499,8.99981249 14.500049,8.99981249 L4.50001521,8.99981249 C4.22401428,8.99981249 4.00001352,9.23107694 4.00001352,9.51734483 L4.00001352,12.6212888 L4.00001352,12.9663104 L4.00001352,21.9006188 L3.00001014,21.9006188 L3.00001014,12.9663104 L1.50000507,12.9663104 C1.22400414,12.9663104 1.00000338,13.1905744 1.00000338,13.4673417 L1.00000338,22.4971561 C1.00000338,22.7744234 1.22400414,22.9989374 1.50000507,22.9989374 L14.500049,22.9671854 C14.7760499,22.9671854 15.0000507,22.735921 15.0000507,22.4504032 L15.0000507,9.51734483 L15.0000507,9.51734483 Z M4.9997669,19.9957497 L14.0000473,19.9957497 L14.0000473,20.9975623 L4.9997669,20.9975623 L4.9997669,19.9957497 L4.9997669,19.9957497 Z M4.9997669,16.9928121 L14.0000473,16.9928121 L14.0000473,17.9936246 L4.9997669,17.9936246 L4.9997669,16.9928121 L4.9997669,16.9928121 Z M13.0000439,14.9904369 L6.00002028,14.9904369 C5.44776842,14.9904369 5.0000169,14.5421589 5.0000169,13.9898744 L5.0000169,11.9879992 C5.0000169,11.4349647 5.44776842,10.9861866 6.00002028,10.9861866 L13.0000439,10.9861866 C13.5522958,10.9861866 14.0000473,11.4349647 14.0000473,11.9879992 L14.0000473,13.9898744 C14.0000473,14.5421589 13.5520458,14.9904369 13.0000439,14.9904369 L13.0000439,14.9904369 Z M13.0000439,12.4877805 C13.0000439,12.2120133 12.7760432,11.9877492 12.5000423,11.9877492 L6.50002197,11.9877492 C6.22402104,11.9877492 6.00002028,12.2117632 6.00002028,12.4877805 L6.00002028,13.488343 C6.00002028,13.7656104 6.22402104,13.9896244 6.50002197,13.9896244 L12.5000423,13.9896244 C12.7760432,13.9896244 13.0000439,13.7656104 13.0000439,13.488343 L13.0000439,12.4877805 L13.0000439,12.4877805 Z"})))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"53px",width:"53px",version:"1.1",viewBox:"0 0 53 53"},r.default.createElement("g",{fill:"none",stroke:"none",strokeLinecap:"square",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-566.000000, -258.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(39.000000, 29.000000)"},r.default.createElement("g",{transform:"translate(371.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 7.000000)"},r.default.createElement("path",{d:"M52.5093,26.2547 C52.5093,11.7547 40.7543,-0.0003 26.2543,-0.0003 C11.7543,-0.0003 0.0003,11.7547 0.0003,26.2547 C0.0003,40.7547 11.7543,52.5087 26.2543,52.5087 C40.7543,52.5087 52.5093,40.7547 52.5093,26.2547",fill:"#ECECEC"}),r.default.createElement("g",{transform:"translate(13.000000, 17.000000)"},r.default.createElement("path",{d:"M13.2544,0.8172 C7.6294,0.8172 2.8254,4.3162 0.8794,9.2552 C2.8254,14.1932 7.6294,17.6922 13.2544,17.6922 C18.8794,17.6922 23.6834,14.1932 25.6294,9.2552 C23.6834,4.3162 18.8794,0.8172 13.2544,0.8172",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M13.2544,0.8172 C7.6294,0.8172 2.8254,4.3162 0.8794,9.2552 C2.8254,14.1932 7.6294,17.6922 13.2544,17.6922 C18.8794,17.6922 23.6834,14.1932 25.6294,9.2552 C23.6834,4.3162 18.8794,0.8172 13.2544,0.8172 Z",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M13.2544,14.1454 C10.5544,14.1454 8.3634,11.9544 8.3634,9.2544 C8.3634,6.5544 10.5544,4.3634 13.2544,4.3634 C15.9544,4.3634 18.1454,6.5544 18.1454,9.2544 C18.1454,11.9544 15.9544,14.1454 13.2544,14.1454 Z",stroke:"#EC5424",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M13.2544,7.1302 C12.0794,7.1302 11.1304,8.0792 11.1304,9.2552 C11.1304,10.4302 12.0794,11.3792 13.2544,11.3792 C14.4304,11.3792 15.3794,10.4302 15.3794,9.2552 C15.3794,8.0792 14.4304,7.1302 13.2544,7.1302",fill:"#222228"}))))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"54px",width:"53px",version:"1.1",viewBox:"0 0 53 54"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-195.000000, -257.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(39.000000, 33.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 2.000000)"},r.default.createElement("rect",{height:"53.7479069",width:"52.1574875",fill:"#ECECEC",rx:"26.0787437",x:"0",y:"0"}),r.default.createElement("polygon",{points:"12.8445073 14 38.8445073 14 38.8445073 40 12.8445073 40"}),r.default.createElement("g",{transform:"translate(14.000000, 15.000000)"},r.default.createElement("rect",{height:"23.0911239",width:"23.7058594",fill:"#FFFFFF",rx:"3",transform:"translate(11.906452, 11.979060) rotate(90.000000) translate(-11.906452, -11.979060) ",x:"0.0535219254",y:"0.433498242"}),r.default.createElement("path",{d:"M23.7058594,14.7805139 L23.7058594,21.5009299 C23.7058594,23.1333423 22.177815,24.4566741 20.2967733,24.4566741 L3.40908608,24.4566741 C1.52629983,24.4566741 2.48689958e-14,23.1315341 2.48689958e-14,21.5009299 L2.48689958e-14,14.7805139 L23.7058594,14.7805139",fill:"#EB5424"}),r.default.createElement("rect",{height:"1.95687491",width:"12.8562212",fill:"#000000",rx:"0.978437454",x:"5.4",y:"4.45281347"}),r.default.createElement("rect",{height:"1.95687491",width:"12.8562212",fill:"#000000",rx:"0.978437454",x:"5.4",y:"8.56225078"}),r.default.createElement("rect",{height:"1.95687491",width:"7.81455825",fill:"#FFFFFF",rx:"0.978437454",x:"7.94565056",y:"18.7380003"})))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"24px",width:"16px",version:"1.1",viewBox:"0 0 16 24"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-304.000000, -501.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 116.000000)"},r.default.createElement("g",{transform:"translate(-9.000000, 25.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 339.884018)"},r.default.createElement("g",{transform:"translate(157.000000, 17.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 4.000000)"},r.default.createElement("path",{d:"M13.5162632,6.53763667 L13.5162632,13.8240367 C13.5162632,15.7422367 12.0219474,17.2970367 10.1783684,17.2970367 L8.50942105,17.2970367 L8.50942105,21.8119367 L5.17152632,21.8119367 L5.17152632,17.2970367 L3.50257895,17.2970367 C1.65973684,17.2970367 0.164684211,15.7422367 0.164684211,13.8240367 L0.164684211,6.53073667 L1.49984211,6.53073667 L4.17015789,6.53073667 L9.51078947,6.53073667 L12.1811053,6.53073667 L13.5162632,6.53763667 Z",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M13.5162632,6.53763667 L13.5162632,13.8240367 C13.5162632,15.7422367 12.0219474,17.2970367 10.1783684,17.2970367 L8.50942105,17.2970367 L8.50942105,21.8119367 L5.17152632,21.8119367 L5.17152632,17.2970367 L3.50257895,17.2970367 C1.65973684,17.2970367 0.164684211,15.7422367 0.164684211,13.8240367 L0.164684211,6.53073667 L1.49984211,6.53073667 L4.17015789,6.53073667 L9.51078947,6.53073667 L12.1811053,6.53073667 L13.5162632,6.53763667 Z",stroke:"#222228",strokeWidth:"1.155"}),r.default.createElement("path",{d:"M3.65915789,6.53089 L3.65915789,0.0939566667",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M3.65915789,6.53089 L3.65915789,0.0939566667",stroke:"#222228",strokeLinecap:"round",strokeWidth:"1.155"}),r.default.createElement("path",{d:"M10.0220105,6.53089 L10.0220105,0.0939566667",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M10.0220105,6.53089 L10.0220105,0.0939566667",stroke:"#222228",strokeLinecap:"round",strokeWidth:"1.155"}),r.default.createElement("path",{d:"M3.65775789,10.03816 L10.0218632,10.03816",stroke:"#3445DC",strokeWidth:"1.155"}),r.default.createElement("path",{d:"M4.91304211,12.3879167 L8.76672632,12.3879167",stroke:"#3445DC",strokeWidth:"1.155"})))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"70px",width:"71px",version:"1.1",viewBox:"0 0 71 70"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-249.000000, -367.000000)"},r.default.createElement("g",{transform:"translate(96.000000, 367.000000)"},r.default.createElement("g",{transform:"translate(153.000000, 0.000000)"},r.default.createElement("path",{d:"M18.6794258,70 L51.3684211,70 C61.6847177,70 70.0478469,61.6425833 70.0478469,51.3333333 L70.0478469,18.6666667 C70.0478469,8.35741667 61.6847177,0 51.3684211,0 L18.6794258,0 C8.36312919,0 0,8.35741667 0,18.6666667 L0,51.3333333 C0,61.6425833 8.36312919,70 18.6794258,70",fill:"#EC5424"}),r.default.createElement("path",{d:"M49.3806967,15.3375833 L35.0255579,15.3375833 L20.6692517,15.3372917 L16.2334718,29.0535 C13.5345866,37.4759583 16.6820699,46.3411667 23.4098737,51.2499167 L35.023223,59.7280833 L46.6403665,51.2484583 C53.7321273,46.0725417 56.3878163,37.044 53.8334048,29.0957917 C53.8228976,29.05875 49.3806967,15.3375833 49.3806967,15.3375833 Z",fill:"#222228"}),r.default.createElement("polygon",{fill:"#FFFFFF",points:"35.0237775 15.3372333 39.4770694 29.0336083 53.8879545 29.0336083 42.229366 37.4983583 46.6826579 51.1947333 35.0237775 42.7299833 23.3648971 51.1947333 27.818189 37.4983583 16.1596005 29.0336083 30.5704856 29.0336083"}))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"18px",width:"18px",version:"1.1",viewBox:"0 0 18 18"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{fill:"#EB5424",transform:"translate(-2331.000000, -241.000000)"},r.default.createElement("g",{transform:"translate(2297.000000, 116.000000)"},r.default.createElement("g",{transform:"translate(-2.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(35.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(1.000000, 25.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 92.000000)"},r.default.createElement("path",{d:"M0,8 L0,26 L18,26 L18,8 L0,8 Z M9.521136,23.337872 C9.255456,23.877728 8.748288,24.2324 8.160624,24.403616 C7.2576,24.610976 6.393888,24.492752 5.75136,24.10712 C5.321376,23.843312 4.985568,23.437232 4.757616,22.969376 L6.128496,22.129856 C6.140448,22.134896 6.176448,22.199984 6.224544,22.28408 C6.39936,22.576976 6.550128,22.784336 6.84648,22.92992 C7.137648,23.02928 7.776864,23.092784 8.02368,22.580432 C8.174448,22.319792 8.126496,21.482 8.126496,20.555072 C8.126352,19.098512 8.13312,17.648 8.13312,16.208 L9.819216,16.208 C9.819216,17.792 9.827856,19.292192 9.819216,20.837888 C9.822816,21.785408 9.90504,22.630112 9.521136,23.337872 Z M16.515792,22.86152 C15.929712,24.866288 12.662064,24.931376 11.356272,23.606864 C11.080368,23.295104 10.907424,23.13224 10.742832,22.772384 C11.436768,22.373216 11.436768,22.373216 12.111984,21.982544 C12.478752,22.546304 12.817872,22.856336 13.428,22.9832 C14.255712,23.084288 15.088464,22.799888 14.901696,21.920768 C14.709744,21.202784 13.206816,21.028112 12.183984,20.260304 C11.1456,19.562912 10.90224,17.86832 11.755584,16.900064 C12.039984,16.541936 12.524976,16.274672 13.033872,16.146224 L13.564944,16.077536 C14.584608,16.056944 15.221952,16.326224 15.689808,16.848656 C15.819984,16.98056 15.926256,17.122832 16.124976,17.431136 C15.581808,17.777312 15.583536,17.774 14.805504,18.277712 C14.639328,17.919728 14.363568,17.695088 14.072112,17.597456 C13.619664,17.460368 13.049136,17.609408 12.930768,18.087488 C12.889728,18.2348 12.898224,18.371888 12.963456,18.615248 C13.146768,19.03328 13.761936,19.215008 14.313744,19.468592 C15.902208,20.112848 16.438608,20.803616 16.570512,21.625856 C16.69752,22.33376 16.53984,22.792976 16.515792,22.86152 L16.515792,22.86152 Z"})))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"53px",width:"53px",version:"1.1",viewBox:"0 0 53 53"},r.default.createElement("g",{fill:"none",stroke:"none",strokeLinecap:"square",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-195.000000, -258.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(39.000000, 29.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 7.000000)"},r.default.createElement("path",{d:"M52.5091,26.2545 C52.5091,11.7545 40.7551,0.0005 26.2551,0.0005 C11.7551,0.0005 0.0001,11.7545 0.0001,26.2545 C0.0001,40.7545 11.7551,52.5085 26.2551,52.5085 C40.7551,52.5085 52.5091,40.7545 52.5091,26.2545",fill:"#ECECEC"}),r.default.createElement("g",{transform:"translate(16.000000, 11.000000)"},r.default.createElement("polygon",{fill:"#FFFFFF",points:"0.144 26.2871 20.366 26.2871 20.366 8.9541 0.144 8.9541"}),r.default.createElement("polygon",{points:"0.144 26.2871 20.366 26.2871 20.366 8.9541 0.144 8.9541",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M16.0325,8.9533 L16.0325,6.0643 C16.0325,2.8733 13.4455,0.2863 10.2545,0.2863 C7.0635,0.2863 4.4765,2.8733 4.4765,6.0643 L4.4765,8.2313",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M13.1434,16.1759 C13.1434,14.5799 11.8504,13.2869 10.2544,13.2869 C8.6594,13.2869 7.3654,14.5799 7.3654,16.1759 C7.3654,17.2419 7.9504,18.1629 8.8104,18.6639 L8.8104,21.9529 L11.6994,21.9529 L11.6994,18.6639 C12.5594,18.1629 13.1434,17.2419 13.1434,16.1759 Z",stroke:"#EC5424",strokeWidth:"1.5"})))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"54px",width:"53px",version:"1.1",viewBox:"0 0 53 54"},r.default.createElement("g",{fill:"none",stroke:"none",strokeLinecap:"square",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-195.000000, -478.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(39.000000, 29.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 218.853047)"},r.default.createElement("g",{transform:"translate(0.000000, 9.000000)"},r.default.createElement("path",{d:"M52.5091,26.2545 C52.5091,11.7545 40.7551,0.0005 26.2551,0.0005 C11.7551,0.0005 0.0001,11.7545 0.0001,26.2545 C0.0001,40.7545 11.7551,52.5095 26.2551,52.5095 C40.7551,52.5095 52.5091,40.7545 52.5091,26.2545",fill:"#ECECEC"}),r.default.createElement("g",{transform:"translate(17.000000, 12.000000)"},r.default.createElement("path",{d:"M15.7972,28.2545 L2.7122,28.2545 C1.6612,28.2545 0.8012,27.3955 0.8012,26.3445 L0.8012,2.1645 C0.8012,1.1135 1.6612,0.2545 2.7122,0.2545 L15.7972,0.2545 C16.8482,0.2545 17.7072,1.1135 17.7072,2.1645 L17.7072,26.3445 C17.7072,27.3955 16.8482,28.2545 15.7972,28.2545",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M15.7972,28.2545 L2.7122,28.2545 C1.6612,28.2545 0.8012,27.3955 0.8012,26.3445 L0.8012,2.1645 C0.8012,1.1135 1.6612,0.2545 2.7122,0.2545 L15.7972,0.2545 C16.8482,0.2545 17.7072,1.1135 17.7072,2.1645 L17.7072,26.3445 C17.7072,27.3955 16.8482,28.2545 15.7972,28.2545 Z",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M17.7074,20.6343 L0.8014,20.6343",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M0.8016,4.6754 L17.7076,4.6754",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M10.828,24.4674 C10.828,25.3364 10.123,26.0404 9.255,26.0404 C8.386,26.0404 7.682,25.3364 7.682,24.4674 C7.682,23.5984 8.386,22.8944 9.255,22.8944 C10.123,22.8944 10.828,23.5984 10.828,24.4674",fill:"#231F1F"}),r.default.createElement("polyline",{points:"13.4881 9.2833 8.0741 14.6963 5.9671 12.5893",stroke:"#EC5424",strokeWidth:"1.5"}))))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"54px",width:"53px",version:"1.1",viewBox:"0 0 53 54"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-195.000000, -366.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 116.000000)"},r.default.createElement("g",{transform:"translate(-9.000000, 25.000000)"},r.default.createElement("g",{transform:"translate(47.000000, 225.000000)"},r.default.createElement("path",{d:"M52.509,27.1536416 C52.509,12.6536416 40.755,0.899641577 26.255,0.899641577 C11.755,0.899641577 0,12.6536416 0,27.1536416 C0,41.6536416 11.755,53.4086416 26.255,53.4086416 C40.755,53.4086416 52.509,41.6536416 52.509,27.1536416",fill:"#ECECEC"}),r.default.createElement("path",{d:"M26.0930648,35.8676416 C25.7640648,35.8676416 25.4990648,36.1326416 25.4990648,36.4616416 L25.4990648,39.4306416 C25.4990648,39.7586416 25.7640648,40.0236416 26.0930648,40.0236416 C26.4220648,40.0236416 26.6870648,39.7586416 26.6870648,39.4306416 L26.6870648,36.4616416 C26.6870648,36.1326416 26.4220648,35.8676416 26.0930648,35.8676416 M29.2940648,30.8116416 C29.0020648,30.8436416 28.7590648,31.1206416 28.7650648,31.4146416 L28.7650648,38.8366416 C28.7600648,39.1496416 29.0450648,39.4396416 29.3590648,39.4396416 C29.6720648,39.4396416 29.9570648,39.1496416 29.9520648,38.8366416 L29.9520648,31.4146416 C29.9600648,31.0776416 29.6290648,30.7746416 29.2940648,30.8116416 M19.4970648,28.1396416 C19.2050648,28.1716416 18.9620648,28.4496416 18.9680648,28.7426416 L18.9680648,36.4616416 C18.9640648,36.7746416 19.2480648,37.0646416 19.5620648,37.0646416 C19.8760648,37.0646416 20.1600648,36.7746416 20.1560648,36.4616416 L20.1560648,28.7426416 C20.1630648,28.4056416 19.8320648,28.1026416 19.4970648,28.1396416 M26.0930648,17.4616416 C22.2840648,17.4616416 18.9680648,20.3526416 18.9680648,23.9926416 L18.9680648,25.7736416 C18.9640648,26.0876416 19.2480648,26.3766416 19.5620648,26.3766416 C19.8760648,26.3766416 20.1600648,26.0876416 20.1560648,25.7736416 L20.1560648,23.9926416 C20.1560648,21.0836416 22.8850648,18.6496416 26.0930648,18.6496416 C29.3010648,18.6496416 32.0300648,21.0836416 32.0300648,23.9926416 L32.0300648,36.4616416 C32.0260648,36.7746416 32.3100648,37.0646416 32.6240648,37.0646416 C32.9380648,37.0646416 33.2220648,36.7746416 33.2180648,36.4616416 L33.2180648,23.9926416 C33.2180648,20.3526416 29.9020648,17.4616416 26.0930648,17.4616416 M18.3000648,17.4526416 C18.5380648,17.4166416 18.7870648,17.5386416 18.9030648,17.7496416 C19.0190648,17.9596416 18.9950648,18.2436416 18.8380648,18.4266416 C17.7210648,19.8006416 17.1870648,21.4906416 17.1870648,23.3986416 L17.1870648,33.4926416 C17.1920648,33.8056416 16.9070648,34.0956416 16.5930648,34.0956416 C16.2800648,34.0956416 15.9950648,33.8056416 16.0000648,33.4926416 L16.0000648,23.3986416 C16.0000648,21.2666416 16.6070648,19.2776416 17.9100648,17.6756416 C18.0050648,17.5546416 18.1480648,17.4726416 18.3000648,17.4526416 Z M35.5930648,27.5546416 C35.9220648,27.5546416 36.1870648,27.8206416 36.1870648,28.1486416 L36.1870648,33.4926416 C36.1870648,33.8216416 35.9220648,34.0866416 35.5930648,34.0866416 C35.2640648,34.0866416 34.9990648,33.8216416 34.9990648,33.4926416 L34.9990648,28.1486416 C34.9990648,27.8206416 35.2640648,27.5546416 35.5930648,27.5546416 Z M26.0930648,13.8996416 C24.0420648,13.8996416 22.0320648,14.4856416 20.4340648,15.4676416 C20.1690648,15.6326416 20.0740648,16.0276416 20.2390648,16.2926416 C20.4050648,16.5576416 20.8000648,16.6436416 21.0650648,16.4786416 C22.4630648,15.6186416 24.2730648,15.0866416 26.0930648,15.0866416 C31.0550648,15.0866416 34.9990648,18.8286416 34.9990648,23.3986416 L34.9990648,25.1796416 C34.9990648,25.5096416 35.2640648,25.7736416 35.5930648,25.7736416 C35.9220648,25.7736416 36.1870648,25.5096416 36.1870648,25.1796416 L36.1870648,23.3986416 C36.1870648,18.1456416 31.6560648,13.8996416 26.0930648,13.8996416",fill:"#000000"}),r.default.createElement("path",{d:"M26.0280648,24.2806416 C25.7370648,24.3126416 25.4930648,24.5896416 25.4990648,24.8836416 L25.4990648,33.1956416 C25.4950648,33.5096416 25.7800648,33.7986416 26.0930648,33.7986416 C26.4070648,33.7986416 26.6910648,33.5096416 26.6870648,33.1956416 L26.6870648,24.8836416 C26.6940648,24.5466416 26.3630648,24.2436416 26.0280648,24.2806416",fill:"#EB5424"}),r.default.createElement("path",{d:"M26.0930648,21.0246416 C24.0380648,21.0246416 22.2340648,22.5836416 22.2340648,24.5866416 L22.2340648,38.8366416 C22.2290648,39.1496416 22.5140648,39.4396416 22.8270648,39.4396416 C23.1410648,39.4396416 23.4260648,39.1496416 23.4210648,38.8366416 L23.4210648,24.5866416 C23.4210648,23.3146416 24.6390648,22.2116416 26.0930648,22.2116416 C27.5470648,22.2116416 28.7650648,23.3146416 28.7650648,24.5866416 L28.7650648,28.4456416 C28.7600648,28.7596416 29.0450648,29.0486416 29.3590648,29.0486416 C29.6720648,29.0486416 29.9570648,28.7596416 29.9520648,28.4456416 L29.9520648,24.5866416 C29.9520648,22.5836416 28.1480648,21.0246416 26.0930648,21.0246416",fill:"#EB5424"})))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"14px",width:"19px",version:"1.1",viewBox:"0 0 19 14"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{fill:"#EB5424",transform:"translate(-415.000000, -613.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 363.000000)"},r.default.createElement("g",{transform:"translate(259.000000, 18.000000)"},r.default.createElement("path",{d:"M17.4988925,24 L4.6665852,24 C4.02234505,24 3.49972017,23.4773442 3.49972017,22.833066 L3.49972017,21.6667153 L4.6665852,21.6667153 L4.6665852,22.2497448 C4.6665852,22.5720297 4.927606,22.833066 5.24958025,22.833066 L16.9153142,22.833066 C17.2372884,22.833066 17.4988925,22.5720297 17.4988925,22.2497448 L17.4988925,15.2504739 C17.4988925,14.9278973 17.2375801,14.6665694 16.9153142,14.6665694 L16.3320275,14.6665694 L16.3320275,13.5002187 L17.4988925,13.5002187 C18.1431326,13.5002187 18.6651742,14.0225829 18.6651742,14.6665694 L18.6651742,22.833066 C18.6651742,23.4773442 18.1431326,24 17.4988925,24 L17.4988925,24 Z M13.9991723,20.4997813 L1.16657339,20.4997813 C0.522333235,20.4997813 0,19.9771255 0,19.3337222 L0,11.1666424 C0,10.5226558 0.522333235,10 1.16657339,10 L13.9991723,10 C14.6434125,10 15.1657457,10.5226558 15.1657457,11.1666424 L15.1657457,19.3337222 C15.1657457,19.9771255 14.6434125,20.4997813 13.9991723,20.4997813 L13.9991723,20.4997813 Z M13.9991723,11.7505469 C13.9991723,11.4276786 13.7378599,11.1666424 13.415594,11.1666424 L1.74986008,11.1666424 C1.42788583,11.1666424 1.16657339,11.4276786 1.16657339,11.7505469 L1.16657339,18.7498177 C1.16657339,19.072686 1.42788583,19.3337222 1.74986008,19.3337222 L13.415594,19.3337222 C13.7375682,19.3337222 13.9991723,19.072686 13.9991723,18.7498177 L13.9991723,11.7505469 L13.9991723,11.7505469 Z M7.58272703,18.1664965 C5.97227247,18.1664965 4.6665852,16.8601487 4.6665852,15.2504739 C4.6665852,13.6393408 5.97227247,12.3332847 7.58272703,12.3332847 C9.19347324,12.3332847 10.4991605,13.6393408 10.4991605,15.2504739 C10.4991605,16.8604404 9.19347324,18.1664965 7.58272703,18.1664965 L7.58272703,18.1664965 Z M7.58272703,13.5002187 C6.61651262,13.5002187 5.83286695,14.2836191 5.83286695,15.2504739 C5.83286695,16.2164538 6.61651262,16.9998542 7.58272703,16.9998542 C8.54894144,16.9998542 9.33258712,16.2161622 9.33258712,15.2504739 C9.33258712,14.2836191 8.54923309,13.5002187 7.58272703,13.5002187 L7.58272703,13.5002187 Z"}))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"150px",width:"150px",version:"1.1",viewBox:"0 0 150 150"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("path",{d:"M150,150 L0,150 L0,0 L150,0 L150,150 Z",fill:"#5F3237"}),r.default.createElement("path",{d:"M150,150 L30,150 L30,30 L150,30 L150,150 Z",fill:"#E56E62"}),r.default.createElement("path",{d:"M120,120 L30,120 L30,30 L120,30 L120,120 Z",fill:"#ED955B"}),r.default.createElement("path",{d:"M120,120 L60,120 L60,60 L120,60 L120,120 Z",fill:"#F9E862"}),r.default.createElement("path",{d:"M90,90 L60,90 L60,60 L90,60 L90,90 Z",fill:"#FFFFFF"})))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"53px",width:"53px",version:"1.1",viewBox:"0 0 53 53"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-3395.000000, -807.000000)"},r.default.createElement("g",{transform:"translate(3395.000000, 807.000000)"},r.default.createElement("path",{d:"M52.509,26.2544 C52.509,11.7544 40.755,0.0004 26.255,0.0004 C11.755,0.0004 0,11.7544 0,26.2544 C0,40.7544 11.755,52.5094 26.255,52.5094 C40.755,52.5094 52.509,40.7544 52.509,26.2544",fill:"#ECECEC"}),r.default.createElement("g",{transform:"translate(12.000000, 13.000000)"},r.default.createElement("path",{d:"M26.9866,25.3501 L1.5226,25.3501 L1.5226,3.0691 C1.5226,2.0141 2.3776,1.1591 3.4326,1.1591 L25.0766,1.1591 C26.1316,1.1591 26.9866,2.0141 26.9866,3.0691 L26.9866,25.3501 Z",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M26.2366,24.6001 L26.2366,3.0691 C26.2366,2.42831356 25.7173864,1.9091 25.0766,1.9091 L3.4326,1.9091 C2.79181356,1.9091 2.2726,2.42831356 2.2726,3.0691 L2.2726,24.6001 L26.2366,24.6001 Z M0.7726,26.1001 L0.7726,3.0691 C0.7726,1.59988644 1.96338644,0.4091 3.4326,0.4091 L25.0766,0.4091 C26.5458136,0.4091 27.7366,1.59988644 27.7366,3.0691 L27.7366,26.1001 L0.7726,26.1001 Z",fill:"#222228"}),r.default.createElement("polygon",{fill:"#222228",points:"1.5227 5.7286 26.9867 5.7286 26.9867 4.2286 1.5227 4.2286"}),r.default.createElement("path",{d:"M5.229,14.2751 L5.229,8.3191 L23.281,8.3191 L23.281,14.2751 L5.229,14.2751 Z M21.781,12.7751 L21.781,9.8191 L6.729,9.8191 L6.729,12.7751 L21.781,12.7751 Z",fill:"#EC5424"}),r.default.createElement("polygon",{fill:"#222228",points:"23.324 16.5318 5.224 16.5318 5.224 18.0318 23.324 18.0318"}),r.default.createElement("polygon",{fill:"#222228",points:"17.2629 20.0489 5.2239 20.0489 5.2239 21.5489 17.2629 21.5489"}))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l={backgroundColor:"#01B48F",width:46,height:30,display:"inline-block",color:"#F5F7F9",borderRadius:3,textAlign:"center",fontSize:12,fontWeight:500,textTransform:"uppercase",padding:7},o=function(){return r.default.createElement("span",{style:l},"b2b")};t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l={backgroundColor:"#C879B2",width:46,height:30,display:"inline-block",color:"#F5F7F9",borderRadius:3,textAlign:"center",fontSize:12,fontWeight:500,textTransform:"uppercase",padding:7},o=function(){return r.default.createElement("span",{style:l},"b2c")};t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l={backgroundColor:"#4571D0",width:46,height:30,display:"inline-block",color:"#F5F7F9",borderRadius:3,textAlign:"center",fontSize:12,fontWeight:500,textTransform:"uppercase",padding:7},o=function(){return r.default.createElement("span",{style:l},"b2e")};t.default=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"18px",width:"15px",version:"1.1",viewBox:"0 0 15 18"},r.default.createElement("g",{fill:"none",stroke:"none",strokeWidth:"1"},r.default.createElement("g",{fill:"#EB5424",transform:"translate(-2333.000000, -275.000000)"},r.default.createElement("g",{transform:"translate(2297.000000, 116.000000)"},r.default.createElement("g",{transform:"translate(-2.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(35.000000, 0.000000)"},r.default.createElement("g",{transform:"translate(1.000000, 25.000000)"},r.default.createElement("g",{transform:"translate(0.000000, 92.000000)"},r.default.createElement("path",{d:"M14.4263996,51.5628709 C14.4516101,54.2867577 16.8161756,55.1933194 16.8422554,55.2049104 C16.8222609,55.2686609 16.4645334,56.4967281 15.5966567,57.7649293 C14.8464288,58.8614386 14.0676579,59.953891 12.8411845,59.9767833 C11.6360095,59.9988062 11.2484351,59.2619079 9.87040925,59.2619079 C8.49281801,59.2619079 8.06235697,59.953891 6.92136718,59.9988062 C5.73734576,60.0437213 4.83571027,58.8129012 4.07925214,57.7205936 C2.5335913,55.4858474 1.35232275,51.4056679 2.93840724,48.6514996 C3.72630597,47.2837608 5.13461337,46.4177676 6.6630326,46.3954549 C7.82561064,46.3732871 8.92298928,47.1775581 9.63366292,47.1775581 C10.3439019,47.1775581 11.6774473,46.2102886 13.0793797,46.3522784 C13.6663193,46.3767644 15.3136912,46.5893145 16.3715156,48.1378731 C16.2864665,48.1907571 14.4059705,49.2855277 14.4263996,51.5628709 M12.1613719,44.8739903 C12.7898943,44.1131855 13.212966,43.0537675 13.0976355,42 C12.1915085,42.0363668 11.0958685,42.6037466 10.4460477,43.3642616 C9.86359953,44.0375542 9.3535952,45.1155179 9.49109353,46.1484216 C10.5011049,46.2266609 11.5327046,45.6352297 12.1613719,44.8739903"})))))))))};t.default=l},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),r=function(e){return e&&e.__esModule?e:{default:e}}(a),l=function(){return r.default.createElement("svg",{height:"54px",width:"53px",version:"1.1",viewBox:"0 0 53 54"},r.default.createElement("g",{fill:"none",stroke:"none",strokeLinecap:"square",strokeWidth:"1"},r.default.createElement("g",{transform:"translate(-566.000000, -479.000000)"},r.default.createElement("g",{transform:"translate(157.000000, 115.000000)"},r.default.createElement("g",{transform:"translate(-1.000000, 107.000000)"},r.default.createElement("g",{transform:"translate(39.000000, 29.000000)"},r.default.createElement("g",{transform:"translate(371.000000, 218.853047)"},r.default.createElement("g",{transform:"translate(0.000000, 10.000000)"},r.default.createElement("path",{d:"M52.5093,26.2545 C52.5093,11.7545 40.7543,0.0005 26.2543,0.0005 C11.7543,0.0005 0.0003,11.7545 0.0003,26.2545 C0.0003,40.7545 11.7543,52.5095 26.2543,52.5095 C40.7543,52.5095 52.5093,40.7545 52.5093,26.2545",fill:"#ECECEC"}),r.default.createElement("g",{transform:"translate(9.000000, 12.000000)"},r.default.createElement("path",{d:"M22.0679,13.2032 L22.0679,9.2462 L19.1709,9.2462 C18.9839,8.5222 18.6989,7.8392 18.3279,7.2102 L20.3769,5.1622 L17.5779,2.3642 L15.5289,4.4122 C14.9009,4.0412 14.2179,3.7562 13.4939,3.5692 L13.4939,0.6722 L9.5369,0.6722 L9.5369,3.5692 C8.8129,3.7562 8.1299,4.0412 7.5009,4.4122 L5.4529,2.3642 L2.6539,5.1622 L4.7029,7.2102 C4.3319,7.8392 4.0469,8.5222 3.8599,9.2462 L0.9629,9.2462 L0.9629,13.2032 L3.8599,13.2032 C4.0469,13.9282 4.3319,14.6102 4.7029,15.2392 L2.6539,17.2872 L5.4529,20.0852 L7.5009,18.0372 C8.1299,18.4082 8.8129,18.6932 9.5369,18.8802 L9.5369,21.7772 L13.4939,21.7772 L13.4939,18.8802 C14.2179,18.6932 14.9009,18.4082 15.5289,18.0372 L17.5779,20.0852 L20.3769,17.2872 L18.3279,15.2392 C18.6989,14.6102 18.9839,13.9282 19.1709,13.2032 L22.0679,13.2032 Z",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M22.0679,13.2032 L22.0679,9.2462 L19.1709,9.2462 C18.9839,8.5222 18.6989,7.8392 18.3279,7.2102 L20.3769,5.1622 L17.5779,2.3642 L15.5289,4.4122 C14.9009,4.0412 14.2179,3.7562 13.4939,3.5692 L13.4939,0.6722 L9.5369,0.6722 L9.5369,3.5692 C8.8129,3.7562 8.1299,4.0412 7.5009,4.4122 L5.4529,2.3642 L2.6539,5.1622 L4.7029,7.2102 C4.3319,7.8392 4.0469,8.5222 3.8599,9.2462 L0.9629,9.2462 L0.9629,13.2032 L3.8599,13.2032 C4.0469,13.9282 4.3319,14.6102 4.7029,15.2392 L2.6539,17.2872 L5.4529,20.0852 L7.5009,18.0372 C8.1299,18.4082 8.8129,18.6932 9.5369,18.8802 L9.5369,21.7772 L13.4939,21.7772 L13.4939,18.8802 C14.2179,18.6932 14.9009,18.4082 15.5289,18.0372 L17.5779,20.0852 L20.3769,17.2872 L18.3279,15.2392 C18.6989,14.6102 18.9839,13.9282 19.1709,13.2032 L22.0679,13.2032 Z",stroke:"#222228",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M14.813,11.2247 C14.813,13.0457 13.336,14.5227 11.515,14.5227 C9.694,14.5227 8.218,13.0457 8.218,11.2247 C8.218,9.4037 9.694,7.9267 11.515,7.9267 C13.336,7.9267 14.813,9.4037 14.813,11.2247 Z",stroke:"#EC5424",strokeWidth:"1.5"}),r.default.createElement("path",{d:"M31.2583,23.7403 L33.1543,24.0243 L33.5463,21.4113 L31.6623,21.1293 C31.6103,20.8243 31.5313,20.5213 31.4083,20.2233 C31.3003,19.9613 31.1663,19.7163 31.0143,19.4883 L32.1863,17.9923 L30.1053,16.3643 L28.9253,17.8703 C28.3753,17.6713 27.7863,17.5923 27.1883,17.6353 L26.4563,15.8633 L24.0143,16.8713 L24.7463,18.6443 C24.2903,19.0363 23.9273,19.5103 23.6773,20.0413 L21.7703,19.8053 L21.4453,22.4283 L23.3433,22.6623 C23.3973,22.9293 23.4733,23.1953 23.5813,23.4553 C23.7033,23.7513 23.8603,24.0203 24.0363,24.2713 L22.8933,25.8103 L25.0153,27.3853 L26.1633,25.8393 C26.6863,26.0143 27.2393,26.0843 27.8013,26.0433 L28.5423,27.8373 L30.9843,26.8283 L30.2443,25.0353 C30.6703,24.6693 31.0103,24.2303 31.2583,23.7403",fill:"#FFFFFF"}),r.default.createElement("path",{d:"M31.2583,23.7403 L33.1543,24.0243 L33.5463,21.4113 L31.6623,21.1293 C31.6103,20.8243 31.5313,20.5213 31.4083,20.2233 C31.3003,19.9613 31.1663,19.7163 31.0143,19.4883 L32.1863,17.9923 L30.1053,16.3643 L28.9253,17.8703 C28.3753,17.6713 27.7863,17.5923 27.1883,17.6353 L26.4563,15.8633 L24.0143,16.8713 L24.7463,18.6443 C24.2903,19.0363 23.9273,19.5103 23.6773,20.0413 L21.7703,19.8053 L21.4453,22.4283 L23.3433,22.6623 C23.3973,22.9293 23.4733,23.1953 23.5813,23.4553 C23.7033,23.7513 23.8603,24.0203 24.0363,24.2713 L22.8933,25.8103 L25.0153,27.3853 L26.1633,25.8393 C26.6863,26.0143 27.2393,26.0843 27.8013,26.0433 L28.5423,27.8373 L30.9843,26.8283 L30.2443,25.0353 C30.6703,24.6693 31.0103,24.2303 31.2583,23.7403 Z",stroke:"#222228"}),r.default.createElement("path",{d:"M26.8218,20.2091 C25.9208,20.5811 25.4928,21.6121 25.8638,22.5131 C26.2368,23.4141 27.2678,23.8421 28.1688,23.4701 C29.0688,23.0991 29.4978,22.0671 29.1258,21.1661 C28.7538,20.2661 27.7218,19.8371 26.8218,20.2091 Z",stroke:"#EC5424"}))))))))))};t.default=l},function(e,t){e.exports={dropdown:"_1bIk","is-open":"_2Ism",twoBlock:"_3j1_",platformDropdown:"_126L",solutionsDropdown:"_1gCd",whyDropdown:"_10Eu",developersDropdown:"_1xI2","footer-list":"_14MM","footer-highlight":"_1CvT"}},function(e,t){e.exports={baseHighlight:"_2Lw9",content:"_3gp2",title:"_3LEU",text:"_1FRt",link:"_1WsL",highlight:"UAL6 _2Lw9",moreHighlight:"_2rad _2Lw9","section-title":"_3vyR",time:"_1zTu"}},function(e,t){e.exports={dropdownList:"_3qAr",stackedList:"_2d8P",highlight:"_1ds1",twoColList:"__I0",twoColListBig:"mPj3",moreDropdownList:"s_3k","header-title":"_17RU","section-title":"_1jg-",hasArrow:"_3a__","section-description":"fSWW","multi-list":"_3VwG","title-list":"wkWT"}},function(e,t){e.exports={item:"_3v_7",singleItem:"_1ci6",icon:"_3bSm",text:"-gCQ",itemPrefix:"_1Ac8",arrowItem:"_1Z4r _3v_7",moreItem:"_3F2P"}},function(e,t){e.exports={featured:"P2u8","featured-content":"pUyl","featured-more":"_1SDn","featured-description":"_1Z0o","close-notification":"_2DjR",notificationOpen:"_3YWg",dropdownOpen:"y6Uj","featured-title":"tE1s","theme-light":"_1ymv","featured-icon":"m6uH"}},function(e,t){e.exports={"footer-link":"AjX7",icon:"_1l50",text:"fFLa"}},function(e,t){},function(e,t){e.exports={head:"hCiq","theme-dark":"_1gg_",logo:"_3yAY",dropdownOpen:"-S2z",brand:"_2uQu",toggleButton:"_1fl7",closeButton:"_1yKj",iconBar:"_1p6r",bounce:"_12jj"}},function(e,t){e.exports={item:"_2kF_","simple-list":"_22dz",link:"_3BoP",text:"_23zg","item-more":"_3C8p","is-dropdown-open":"_31jh","theme-dark":"g13I","item-caret":"_37hu","dropdown-caret":"_2Oii","item-why-auth0":"_2VGR","item-developers":"_1r7x","item-platform":"_1qTi","item-solutions":"hIvN"}},function(e,t){e.exports={"header-main":"_2qoY","is-notification-open":"_2KWL",header:"_3TAQ","theme-dark":"_3uJX","theme-gray":"_2__8","is-dropdown-open":"_3sHQ",menu:"_2IVQ",collapse:"_3scO","main-navigation":"_3TmG",navigation:"wixE","buttons-group":"_2fCs",focusable:"VXau",overflow:"_1AGc","login-button":"_2Vg9","login-button--dark":"QN_e","menu-mobile":"_1yjk"}},function(e,t){e.exports=[{link:"https://auth0.com/extend",title:"Introducing Auth0 Extend.",description:"Better platform extensibility for your SaaS.",cta:"Read More",iconColor:"#3445DC",probability:.5},{link:"http://auth0.com/jobs#job-openings",title:"We are hiring!",description:"If you care deeply about quality, teamwork, and want to build software that people love.",cta:"Join Us!",iconColor:"#eb5424",probability:.5,include:"auth0.com/blog"}]},function(e,t){e.exports=[{name:"Platform",id:"platform",dropdownClass:"platformDropdown",childrens:[{componentType:"list",title:"Modern Identity Platform",description:'The enterprise-grade platform for modern identity. <a href="https://auth0.com/how-it-works" rel="external">Read more</a>',key:"platform-list",titleHref:"https://auth0.com/how-it-works",twoColLayoutBig:!0,items:[{name:"Lock",description:"The Auth0 Login Box. Secure your websites and mobile apps.",id:"lock",href:"https://auth0.com/lock",icon:"lock"},{name:"Breached Passwords Detection",description:"Protect your users and services from password leaks.",id:"breached-passwords",href:"https://auth0.com/breached-passwords",icon:"breached"},{name:"Passwordless",description:"Allow users to login without the need to remember a password.",id:"passwordless",href:"https://auth0.com/passwordless",icon:"passwordless"},{name:"Multifactor Authentication",description:"The most usable and friction-free multifactor authentication experience.",id:"guardian",href:"https://auth0.com/multifactor-authentication",icon:"multifactor"}]}],footerHighlight:!0,footerLinks:[{id:"read-case-studies",name:"<span>Introducing Auth0 Extend:</span> Better platform extensibility for your SaaS.",href:"https://auth0.com/extend",icon:"extend",external:!0}]},{name:"Solutions",id:"solutions",dropdownClass:"solutionsDropdown",twoBlockLayout:!0,childrens:[{componentType:"list",title:"Use Cases",key:"use-cases-list",stackedList:!0,items:[{name:"For your Customers",customClass:"solutionsItem-b2c",icon:"b2c",id:"b2c",href:"https://auth0.com/b2c-customer-identity-management",alt:"B2C icon"},{name:"For your Business Partners",customClass:"solutionsItem-b2b",icon:"b2b",id:"b2b",href:"https://auth0.com/b2b-enterprise-identity-management",alt:"B2B icon"}]},{componentType:"list",title:"Solutions",key:"solutions-list",highlight:!0,subItems:[{titleList:"INDUSTRIES",items:[{name:"Retail",id:"retail",href:"https://auth0.com/learn/retail/",external:!0},{name:"Healthcare",id:"healthcare",href:"https://auth0.com/learn/why-hipaa-compliance-is-vital-your-business/",external:!0},{name:"Telecommunications",id:"telecommunications",href:"https://auth0.com/learn/telecommunications-industry/",external:!0},{name:"More",id:"more-solutions",href:"https://auth0.com/customers#categories",external:!0}]}]}],footerLinks:[{id:"read-case-studies",name:"Read our Case Studies",href:"https://auth0.com/learn/#case-studies",icon:"blog",external:!0}]},{name:"Why Auth0",id:"why-auth0",dropdownClass:"whyDropdown",twoBlockLayout:!0,childrens:[{componentType:"list",title:"Company",key:"company-list",items:[{name:"Customers",id:"customers",href:"https://auth0.com/customers"},{name:"Security, Privacy & Compliance",id:"security",href:"https://auth0.com/security"},{name:"High Availability",id:"availability",href:"https://auth0.com/availability-trust"}]},{componentType:"list",title:"Resources",key:"resources-list",twoColLayout:!0,highlight:!0,titleHref:"https://auth0.com/resources/",external:!0,items:[{name:"Whitepapers",id:"whitepapers",href:"https://auth0.com/resources/whitepapers",external:!0},{name:"Videos",id:"videos",href:"https://auth0.com/resources/videos",external:!0},{name:"Ebooks",id:"ebooks",href:"https://auth0.com/resources/ebooks",external:!0},{name:"Blog",id:"blog",href:"https://auth0.com/blog/",external:!0},{name:"Webinar",id:"webinar",href:"https://auth0.com/resources/webinars"},{name:"Case Studies",id:"case-studies",href:"https://auth0.com/learn/#case-studies",external:!0}]}]},{name:"Developers",id:"developers",dropdownClass:"developersDropdown",twoBlockLayout:!0,childrens:[{componentType:"list",title:"Documentation",key:"documentation-list",titleHref:"https://auth0.com/docs",external:!0,subItems:[{titleList:"GET STARTED",items:[{name:"Javascript",id:"javascript",href:"https://auth0.com/docs/quickstart/spa/vanillajs",icon:"javascript",external:!0},{name:"iOS",id:"ios",href:"https://auth0.com/docs/quickstart/native/ios-swift",icon:"ios",external:!0},{name:"Android",id:"android",href:"https://auth0.com/docs/quickstart/native/android",icon:"android",external:!0},{name:"All Quickstarts",id:"all-quickstarts",href:"https://auth0.com/docs/quickstart/",icon:"quickstarts",external:!0}]},{titleList:"SECTIONS",items:[{name:"APIs",id:"apis",href:"https://auth0.com/docs/api",external:!0},{name:"Protocols",id:"protocols",href:"https://auth0.com/docs/protocols",external:!0},{name:"Libraries",id:"libraries",href:"https://auth0.com/docs/libraries",external:!0}]}]},{componentType:"list",title:"Resources",key:"resources-list",highlight:!0,items:[{name:"Open Source",id:"open-source",href:"https://auth0.com/opensource"},{name:"Community",id:"community",href:"https://community.auth0.com/"},{name:"Auth0 University",id:"university",href:"https://auth0.com/university/",external:!0},{name:"Knowledge Base",id:"knowledge-base",href:"https://auth0.com/learn"},{name:"Identity Glossary",id:"indentity-glossaryt",href:"https://auth0.com/identity-glossary"}]}],footerLinks:[{id:"latest-blog",name:"<b>Latest from Auth0 Blog:</b> ",icon:"blog",external:!0}]},{name:"Pricing",id:"pricing",href:"https://auth0.com/pricing"}]},function(e,t){e.exports=[{name:"Customers",id:"customers",href:"https://auth0.com/customers"},{name:"Blog",id:"blog",href:"https://auth0.com/blog"},{name:"Case Studies",id:"case-studies",href:"https://auth0.com/learn/#case-studies"},{name:"Press Releases",id:"press-releases",href:"https://auth0.com/press"},{name:"Documentation",id:"documentation",href:"https://auth0.com/docs"},{name:"Resources",id:"resources",href:"https://auth0.com/resources"},{name:"Support",id:"support",href:"https://support.auth0.com/"},{name:"Security",id:"security",href:"https://auth0.com/security"}]},function(e,t){e.exports=__webpack_require__(91)},function(e,t){e.exports=__webpack_require__(42)},function(e,t){e.exports=__webpack_require__(8)},function(e,t,n){e.exports=n(6)}])});
//# sourceMappingURL=web-header.js.map

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);

var objectHelper = __webpack_require__(38);
var assert = __webpack_require__(49);
var responseHandler = __webpack_require__(67);

function DBConnection(request, options) {
  this.baseOptions = options;
  this.request = request;
}

/**
 * @callback signUpCallback
 * @param {Error} [err] error returned by Auth0 with the reason why the signup failed
 * @param {Object} [result] result of the signup request
 * @param {Object} result.email user's email
 * @param {Object} result.emailVerified if the user's email was verified
 */

/**
 * Creates a new user in a Auth0 Database connection
 *
 * @method signup
 * @param {Object} options
 * @param {String} options.email user email address
 * @param {String} options.password user password
 * @param {String} options.connection name of the connection where the user will be created
 * @param {signUpCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#signup}
 */
DBConnection.prototype.signup = function (options, cb) {
  var url;
  var body;

  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    connection: { type: 'string', message: 'connection option is required' },
    email: { type: 'string', message: 'email option is required' },
    password: { type: 'string', message: 'password option is required' }
  });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'dbconnections', 'signup');

  body = objectHelper.merge(this.baseOptions, ['clientID'])
                .with(options);

  body = objectHelper.blacklist(body, ['scope']);

  body = objectHelper.toSnakeCase(body, ['auth0Client']);

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

/**
 * @callback changePasswordCallback
 * @param {Error} [err] error returned by Auth0 with the reason why the request failed
 */

/**
 * Request an email with instruction to change a user's password
 *
 * @method changePassword
 * @param {Object} options
 * @param {String} options.email address where the user will recieve the change password email. It should match the user's email in Auth0
 * @param {String} options.connection name of the connection where the user was created
 * @param {changePasswordCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#change-password}
 */
DBConnection.prototype.changePassword = function (options, cb) {
  var url;
  var body;

  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    connection: { type: 'string', message: 'connection option is required' },
    email: { type: 'string', message: 'email option is required' }
  });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'dbconnections', 'change_password');

  body = objectHelper.merge(this.baseOptions, ['clientID'])
                .with(options, ['email', 'connection']);

  body = objectHelper.toSnakeCase(body, ['auth0Client']);

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

module.exports = DBConnection;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);

var objectHelper = __webpack_require__(38);
var assert = __webpack_require__(49);
var qs = __webpack_require__(83);
var responseHandler = __webpack_require__(67);

function PasswordlessAuthentication(request, options) {
  this.baseOptions = options;
  this.request = request;
}

PasswordlessAuthentication.prototype.buildVerifyUrl = function (options) {
  var params;
  var qString;

  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    connection: { type: 'string', message: 'connection option is required' },
    verificationCode: { type: 'string', message: 'verificationCode option is required' },
    phoneNumber: { optional: false, type: 'string', message: 'phoneNumber option is required',
            condition: function (o) { return !o.email; } },
    email: { optional: false, type: 'string', message: 'email option is required',
            condition: function (o) { return !o.phoneNumber; } }
  });
  /* eslint-enable */

  params = objectHelper.merge(this.baseOptions, [
    'clientID',
    'responseType',
    'responseMode',
    'redirectUri',
    'scope',
    'audience'
  ]).with(options);

  // eslint-disable-next-line
  if (this.baseOptions._sendTelemetry) {
    params.auth0Client = this.request.getTelemetryData();
  }

  params = objectHelper.toSnakeCase(params, ['auth0Client']);

  qString = qs.stringify(params);

  return urljoin(this.baseOptions.rootUrl, 'passwordless', 'verify_redirect', '?' + qString);
};

PasswordlessAuthentication.prototype.start = function (options, cb) {
  var url;
  var body;

  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    connection: { type: 'string', message: 'connection option is required' },
    send: { type: 'string', message: 'send option is required', values: ['link', 'code'],
            value_message: 'send is not valid ([link, code])' },
    phoneNumber: { optional: true, type: 'string', message: 'phoneNumber option is required',
            condition: function (o) { return o.send === 'code' || !o.email; } },
    email: { optional: true, type: 'string', message: 'email option is required',
            condition: function (o) { return o.send === 'link' || !o.phoneNumber; } },
    authParams: { optional: true, type: 'object', message: 'authParams option is required' }
  });
  /* eslint-enable */

  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'passwordless', 'start');

  body = objectHelper.merge(this.baseOptions, [
    'clientID',
    'responseType',
    'redirectUri',
    'scope'
  ]).with(options);

  if (body.scope) {
    body.authParams = body.authParams || {};
    body.authParams.scope = body.scope;
  }

  if (body.redirectUri) {
    body.authParams = body.authParams || {};
    body.authParams.redirect_uri = body.redirectUri;
  }

  if (body.responseType) {
    body.authParams = body.authParams || {};
    body.authParams.response_type = body.responseType;
  }

  delete body.redirectUri;
  delete body.responseType;
  delete body.scope;

  body = objectHelper.toSnakeCase(body, ['auth0Client', 'authParams']);

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

PasswordlessAuthentication.prototype.verify = function (options, cb) {
  var url;
  var cleanOption;

  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    connection: { type: 'string', message: 'connection option is required' },
    verificationCode: { type: 'string', message: 'verificationCode option is required' },
    phoneNumber: { optional: false, type: 'string', message: 'phoneNumber option is required',
            condition: function (o) { return !o.email; } },
    email: { optional: false, type: 'string', message: 'email option is required',
            condition: function (o) { return !o.phoneNumber; } }
  });
  /* eslint-enable */

  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  cleanOption = objectHelper.toSnakeCase(options, ['auth0Client']);

  url = urljoin(this.baseOptions.rootUrl, 'passwordless', 'verify');

  return this.request
    .post(url)
    .send(cleanOption)
    .end(responseHandler(cb));
};

module.exports = PasswordlessAuthentication;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var windowHandler = __webpack_require__(57);
var base64Url = __webpack_require__(219);

function create(name, value, days) {
  var date;
  var expires;

  if (windowHandler.getDocument().cookie === undefined
      || windowHandler.getDocument().cookie === null) {
    throw new Error('cookie storage not available');
  }

  if (days) {
    date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }

  windowHandler.getDocument().cookie = name + '=' + base64Url.encode(value) + expires + '; path=/';
}

function read(name) {
  var i;
  var cookie;
  var cookies;
  var nameEQ = name + '=';

  if (windowHandler.getDocument().cookie === undefined
      || windowHandler.getDocument().cookie === null) {
    throw new Error('cookie storage not available');
  }

  cookies = windowHandler.getDocument().cookie.split(';');

  for (i = 0; i < cookies.length; i++) {
    cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return base64Url.decode(cookie.substring(nameEQ.length, cookie.length));
    }
  }

  return null;
}

function erase(name) {
  create(name, '', -1);
}

module.exports = {
  create: create,
  read: read,
  erase: erase
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var windowHelper = __webpack_require__(57);

function IframeHandler(options) {
  this.auth0 = options.auth0;
  this.url = options.url;
  this.callback = options.callback;
  this.timeout = options.timeout || 60 * 1000;
  this.timeoutCallback = options.timeoutCallback || null;
  this.usePostMessage = options.usePostMessage || false;
  this.iframe = null;
  this.timeoutHandle = null;
  this._destroyTimeout = null;
  this.transientMessageEventListener = null;
  this.transientEventListener = null;
}

IframeHandler.prototype.init = function () {
  var _this = this;
  var _window = windowHelper.getWindow();

  this.iframe = _window.document.createElement('iframe');
  this.iframe.style.display = 'none';
  this.iframe.src = this.url;

  if (this.usePostMessage) {
    // Workaround to avoid using bind that does not work in IE8
    this.transientMessageEventListener = function (e) {
      _this.messageEventListener(e);
    };

    _window.addEventListener('message', this.transientMessageEventListener, false);
  } else {
    // Workaround to avoid using bind that does not work in IE8
    this.transientEventListener = function () {
      _this.loadEventListener();
    };

    this.iframe.addEventListener('load', this.transientEventListener, false);
  }

  _window.document.body.appendChild(this.iframe);

  this.timeoutHandle = setTimeout(function () {
    _this.timeoutHandler();
  }, this.timeout);
};

IframeHandler.prototype.messageEventListener = function (e) {
  this.destroy();
  this.callbackHandler(e.data);
};

IframeHandler.prototype.loadEventListener = function () {
  var _this = this;
  this.auth0.parseHash(
    { hash: this.iframe.contentWindow.location.hash },
    function (error, result) {
      if (error || result) {
        _this.destroy();
        _this.callback(error, result);
      }
    }
  );
};

IframeHandler.prototype.callbackHandler = function (result) {
  var error = null;

  if (result && result.error) {
    error = result;
    result = null;
  }

  this.callback(error, result);
};

IframeHandler.prototype.timeoutHandler = function () {
  this.destroy();
  if (this.timeoutCallback) {
    this.timeoutCallback();
  }
};

IframeHandler.prototype.destroy = function () {
  var _this = this;
  var _window = windowHelper.getWindow();

  clearTimeout(this.timeoutHandle);

  this._destroyTimeout = setTimeout(function () {
    if (_this.usePostMessage) {
      _window.removeEventListener('message', _this.transientMessageEventListener, false);
    } else {
      _this.iframe.removeEventListener('load', _this.transientEventListener, false);
    }

    _window.document.body.removeChild(_this.iframe);
  }, 0);
};

module.exports = IframeHandler;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/* eslint-disable no-continue */

function get() {
  if (!Object.assign) {
    return objectAssignPolyfill;
  }

  return Object.assign;
}

function objectAssignPolyfill(target) {
  'use strict';
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

module.exports = {
  get: get,
  objectAssignPolyfill: objectAssignPolyfill
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var objectHelper = __webpack_require__(38);

var tokenParams = [
// auth0
  'realm',
  'audience',
// oauth2
  'client_id',
  'client_secret',
  'redirect_uri',
  'scope',
  'code',
  'grant_type',
  'username',
  'password',
  'refresh_token',
  'assertion',
  'client_assertion',
  'client_assertion_type',
  'code_verifier'
];

var authorizeParams = [
// auth0
  'connection',
  'connection_scope',
  'auth0Client',
  'owp',
  'device',

  'protocol',
  '_csrf',
  '_intstate',

// oauth2
  'client_id',
  'response_type',
  'response_mode',
  'redirect_uri',
  'audience',
  'scope',
  'state',
  'nonce',
  'display',
  'prompt',
  'max_age',
  'ui_locales',
  'claims_locales',
  'id_token_hint',
  'login_hint',
  'acr_values',
  'claims',
  'registration',
  'request',
  'request_uri',
  'code_challenge',
  'code_challenge_method'
];

function oauthAuthorizeParams(warn, params) {
  var notAllowed = objectHelper.getKeysNotIn(params, authorizeParams);

  if (notAllowed.length > 0) {
    warn.warning('Following parameters are not allowed on the `/authorize` endpoing: [' + notAllowed.join(',') + ']');
  }

  return params;
}

function oauthTokenParams(warn, params) {
  return objectHelper.pick(params, tokenParams);
}

module.exports = {
  oauthTokenParams: oauthTokenParams,
  oauthAuthorizeParams: oauthAuthorizeParams
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var version = __webpack_require__(140);

function PluginHandler(webAuth, plugins) {
  this.plugins = plugins;

  for (var a = 0; a < this.plugins.length; a++) {
    if (this.plugins[a].version !== version.raw) {
      var pluginName = '';

      if (this.plugins[a].constructor && this.plugins[a].constructor.name) {
        pluginName = this.plugins[a].constructor.name;
      }

      throw new Error('Plugin ' + pluginName + ' version (' + this.plugins[a].version + ') ' +
        'is not compatible with the SDK version (' + version.raw + ')');
    }

    this.plugins[a].setWebAuth(webAuth);
  }
}

PluginHandler.prototype.get = function (extensibilityPoint) {
  for (var a = 0; a < this.plugins.length; a++) {
    if (this.plugins[a].supports(extensibilityPoint)) {
      return this.plugins[a].init();
    }
  }

  return null;
};

module.exports = PluginHandler;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
var WinChan = __webpack_require__(368);

var windowHandler = __webpack_require__(57);
var objectHelper = __webpack_require__(38);
var qs = __webpack_require__(83);

function PopupHandler() {
  this._current_popup = null;
}

PopupHandler.prototype.calculatePosition = function (options) {
  var width = options.width || 500;
  var height = options.height || 600;
  var _window = windowHandler.getWindow();

  var screenX = typeof _window.screenX !== 'undefined' ? _window.screenX : _window.screenLeft;
  var screenY = typeof _window.screenY !== 'undefined' ? _window.screenY : _window.screenTop;

  var outerWidth = typeof _window.outerWidth !== 'undefined'
    ? _window.outerWidth
    : _window.document.body.clientWidth;

  var outerHeight = typeof _window.outerHeight !== 'undefined'
    ? _window.outerHeight
    : _window.document.body.clientHeight;

  var left = screenX + ((outerWidth - width) / 2);
  var top = screenY + ((outerHeight - height) / 2);

  return { width: width, height: height, left: left, top: top };
};

PopupHandler.prototype.preload = function (options) {
  var _this = this;
  var _window = windowHandler.getWindow();
  var popupPosition = this.calculatePosition(options.popupOptions || {});
  var popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions);
  var url = options.url || 'about:blank';
  var windowFeatures = qs.stringify(popupOptions, {
    encode: false,
    delimiter: ','
  });

  if (this._current_popup && !this._current_popup.closed) {
    return this._current_popup;
  }

  this._current_popup = _window.open(url, 'auth0_signup_popup', windowFeatures);

  this._current_popup.kill = function () {
    this.close();
    _this._current_popup = null;
  };

  return this._current_popup;
};

PopupHandler.prototype.load = function (url, relayUrl, options, cb) {
  var _this = this;
  var popupPosition = this.calculatePosition(options.popupOptions || {});
  var popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions);

  var winchanOptions = objectHelper.merge({
    url: url,
    relay_url: relayUrl,
    window_features: qs.stringify(popupOptions, {
      delimiter: ',',
      encode: false
    }),
    popup: this._current_popup
  }).with(options);

  var popup = WinChan.open(winchanOptions, function (err, data) {
    _this._current_popup = null;
    return cb(err, data);
  });

  popup.focus();

  return popup;
};

module.exports = PopupHandler;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var windowHelper = __webpack_require__(57);

function randomString(length) {
  // eslint-disable-next-line
  var bytes = new Uint8Array(length);
  var result = [];
  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';

  var cryptoObj = windowHelper.getWindow().crypto || windowHelper.getWindow().msCrypto;
  if (!cryptoObj) {
    return null;
  }

  var random = cryptoObj.getRandomValues(bytes);

  for (var a = 0; a < random.length; a++) {
    result.push(charset[random[a] % charset.length]);
  }

  return result.join('');
}

module.exports = {
  randomString: randomString
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var StorageHandler = __webpack_require__(509);
var storage;

function getStorage(force) {
  if (!storage || force) {
    storage = new StorageHandler();
  }
  return storage;
}

module.exports = {
  getItem: function (key) {
    var value = getStorage().getItem(key);
    return value ? JSON.parse(value) : value;
  },
  removeItem: function (key) {
    return getStorage().removeItem(key);
  },
  setItem: function (key, value) {
    var json = JSON.stringify(value);
    return getStorage().setItem(key, json);
  },
  reload: function () {
    getStorage(true);
  }
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var cookies = __webpack_require__(499);

function CookieStorage() {}

CookieStorage.prototype.getItem = function (key) {
  return cookies.read(key);
};

CookieStorage.prototype.removeItem = function (key) {
  cookies.erase(key);
};

CookieStorage.prototype.setItem = function (key, value) {
  cookies.create(key, value, 1);
};

module.exports = CookieStorage;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

function DummyStorage() {}

DummyStorage.prototype.getItem = function () { return null; };

DummyStorage.prototype.removeItem = function () {};

DummyStorage.prototype.setItem = function () {};

module.exports = DummyStorage;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var windowHandler = __webpack_require__(57);
var DummyStorage = __webpack_require__(508);
var CookieStorage = __webpack_require__(507);
var Warn = __webpack_require__(113);

function StorageHandler() {
  this.warn = new Warn({});
  this.storage = windowHandler.getWindow().localStorage || new CookieStorage();
}

StorageHandler.prototype.failover = function () {
  if (this.storage instanceof DummyStorage) {
    this.warn.warning('DummyStorage: ignore failover');
    return;
  } else if (this.storage instanceof CookieStorage) {
    this.warn.warning('CookieStorage: failing over DummyStorage');
    this.storage = new DummyStorage();
  } else {
    this.warn.warning('LocalStorage: failing over CookieStorage');
    this.storage = new CookieStorage();
  }
};

StorageHandler.prototype.getItem = function (key) {
  try {
    return this.storage.getItem(key);
  } catch (e) {
    this.warn.warning(e);
    this.failover();
    return this.getItem(key);
  }
};

StorageHandler.prototype.removeItem = function (key) {
  try {
    return this.storage.removeItem(key);
  } catch (e) {
    this.warn.warning(e);
    this.failover();
    return this.removeItem(key);
  }
};

StorageHandler.prototype.setItem = function (key, value) {
  try {
    return this.storage.setItem(key, value);
  } catch (e) {
    this.warn.warning(e);
    this.failover();
    return this.setItem(key, value);
  }
};

module.exports = StorageHandler;


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// given a URL, extract the origin. Taken from: https://github.com/firebase/firebase-simple-login/blob/d2cb95b9f812d8488bdbfba51c3a7c153ba1a074/js/src/simple-login/transports/WinChan.js#L25-L30
function extractOrigin(url) {
  if (!/^https?:\/\//.test(url)) url = window.location.href;
  var m = /^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);
  if (m) return m[1];
  return url;
}

module.exports = {
  extractOrigin: extractOrigin
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);

var RequestBuilder = __webpack_require__(139);
var assert = __webpack_require__(49);
var responseHandler = __webpack_require__(67);

/**
 * Auth0 Management API Client (methods allowed to be called from the browser only)
 * @constructor
 * @param {Object} options
 * @param {Object} options.domain your Auth0 acount domain
 * @param {Object} options.token a valid API token
 */
function Management(options) {
  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    domain: { type: 'string', message: 'domain option is required' },
    token: { type: 'string', message: 'token option is required' },
    _sendTelemetry: { optional: true, type: 'boolean', message: '_sendTelemetry option is not valid' },
    _telemetryInfo: { optional: true, type: 'object', message: '_telemetryInfo option is not valid' }
  });
  /* eslint-enable */

  this.baseOptions = options;

  this.baseOptions.headers = { Authorization: 'Bearer ' + this.baseOptions.token };

  this.request = new RequestBuilder(this.baseOptions);
  this.baseOptions.rootUrl = urljoin('https://' + this.baseOptions.domain, 'api', 'v2');
}

/**
 * @callback userCallback
 * @param {Error} [err] failure reason for the failed request to Management API
 * @param {Object} [result] user profile
 */

/**
 * Returns the user profile
 *
 * @method getUser
 * @param {String} userId identifier of the user to retrieve
 * @param {userCallback} cb
 * @see https://auth0.com/docs/api/management/v2#!/Users/get_users_by_id
 */
Management.prototype.getUser = function (userId, cb) {
  var url;

  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'users', userId);

  return this.request
    .get(url)
    .end(responseHandler(cb, { ignoreCasing: true }));
};

/**
 * Updates the user metdata. It will patch the user metdata with the attributes sent.
 *
 *
 * @method patchUserMetadata
 * @param {String} userId
 * @param {Object} userMetadata
 * @param {userCallback} cb
 * @see   {@link https://auth0.com/docs/api/management/v2#!/Users/patch_users_by_id}
 */
Management.prototype.patchUserMetadata = function (userId, userMetadata, cb) {
  var url;

  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
  assert.check(userMetadata, { type: 'object', message: 'userMetadata parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  url = urljoin(this.baseOptions.rootUrl, 'users', userId);

  return this.request
    .patch(url)
    .send({ user_metadata: userMetadata })
    .end(responseHandler(cb, { ignoreCasing: true }));
};

/**
 * Link two users
 *
 * @method linkUser
 * @param {String} userId
 * @param {String} secondaryUserToken
 * @param {userCallback} cb
 * @see   {@link https://auth0.com/docs/api/management/v2#!/Users/post_identities}
 */
Management.prototype.linkUser = function (userId, secondaryUserToken, cb) {
  var url;
  /* eslint-disable */
  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
  assert.check(secondaryUserToken, { type: 'string',
    message: 'secondaryUserToken parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
  /* eslint-enable */

  url = urljoin(this.baseOptions.rootUrl, 'users', userId, 'identities');

  return this.request
    .post(url)
    .send({ link_with: secondaryUserToken })
    .end(responseHandler(cb, { ignoreCasing: true }));
};

module.exports = Management;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var IdTokenVerifier = __webpack_require__(757);

var assert = __webpack_require__(49);
var error = __webpack_require__(220);
var qs = __webpack_require__(83);
var PluginHandler = __webpack_require__(503);
var windowHelper = __webpack_require__(57);
var objectHelper = __webpack_require__(38);
var TransactionManager = __webpack_require__(222);
var Authentication = __webpack_require__(218);
var Redirect = __webpack_require__(514);
var Popup = __webpack_require__(513);
var SilentAuthenticationHandler = __webpack_require__(515);

/**
 * Handles all the browser's AuthN/AuthZ flows
 * @constructor
 * @param {Object} options
 * @param {String} options.domain your Auth0 domain
 * @param {String} options.clientID your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @param {Array} [options.plugins]
 * @see {@link https://auth0.com/docs/api/authentication}
 */
function WebAuth(options) {
  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    domain: { type: 'string', message: 'domain option is required' },
    clientID: { type: 'string', message: 'clientID option is required' },
    responseType: { optional: true, type: 'string', message: 'responseType is not valid' },
    responseMode: { optional: true, type: 'string', message: 'responseMode is not valid' },
    redirectUri: { optional: true, type: 'string', message: 'redirectUri is not valid' },
    scope: { optional: true, type: 'string', message: 'scope is not valid' },
    audience: { optional: true, type: 'string', message: 'audience is not valid' },
    leeway: { optional: true, type: 'number', message: 'leeway is not valid' },
    plugins: { optional: true, type: 'array', message: 'plugins is not valid'},
    _disableDeprecationWarnings: { optional: true, type: 'boolean', message: '_disableDeprecationWarnings option is not valid' },
    _sendTelemetry: { optional: true, type: 'boolean', message: '_sendTelemetry option is not valid' },
    _telemetryInfo: { optional: true, type: 'object', message: '_telemetryInfo option is not valid' }
  });

  if (options.overrides) {
    assert.check(options.overrides, { type: 'object', message: 'overrides option is not valid' }, {
      __tenant: { type: 'string', message: '__tenant option is required' },
      __token_issuer: { type: 'string', message: '__token_issuer option is required' }
    });
  }
  /* eslint-enable */

  this.baseOptions = options;
  this.baseOptions.plugins = new PluginHandler(this, this.baseOptions.plugins || []);

  this.baseOptions._sendTelemetry = this.baseOptions._sendTelemetry === false ?
                                        this.baseOptions._sendTelemetry : true;

  this.baseOptions.tenant = (this.overrides && this.overrides.__tenant)
    || this.baseOptions.domain.split('.')[0];

  this.baseOptions.token_issuer = (this.overrides && this.overrides.__token_issuer)
    || 'https://' + this.baseOptions.domain + '/';

  this.transactionManager = new TransactionManager(this.baseOptions.transaction);

  this.client = new Authentication(this.baseOptions);
  this.redirect = new Redirect(this.client, this.baseOptions);
  this.popup = new Popup(this, this.baseOptions);
}

/**
 * Parse the url hash and extract the Auth response from a Auth flow started with {@link authorize}
 *
 * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
 * by the `/.well-known/jwks.json` endpoint of your account.
 * Tokens signed with other algorithms, e.g. HS256 will not be accepted.
 *
 * @method parseHash
 * @param {Object} options
 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
 * @param {String} [options._idTokenVerification] makes parseHash perform or skip `id_token` verification. We **strongly** recommend validating the `id_token` yourself if you disable the verification.
 * @param {authorizeCallback} cb
 */
WebAuth.prototype.parseHash = function (options, cb) {
  var parsedQs;
  var err;
  var state;
  var transaction;
  var transactionNonce;
  var transactionState;

  if (!cb && typeof options === 'function') {
    cb = options;
    options = {};
  } else {
    options = options || {};
  }

  options._idTokenVerification = !(options._idTokenVerification === false);

  var _window = windowHelper.getWindow();

  var hashStr = options.hash === undefined ? _window.location.hash : options.hash;
  hashStr = hashStr.replace(/^#?\/?/, '');

  parsedQs = qs.parse(hashStr);

  if (parsedQs.hasOwnProperty('error')) {
    err = error.buildResponse(parsedQs.error, parsedQs.error_description);

    if (parsedQs.state) {
      err.state = parsedQs.state;
    }

    return cb(err);
  }

  if (!parsedQs.hasOwnProperty('access_token')
       && !parsedQs.hasOwnProperty('id_token')
       && !parsedQs.hasOwnProperty('refresh_token')) {
    return cb(null, null);
  }

  state = parsedQs.state || options.state;

  transaction = this.transactionManager.getStoredTransaction(state);
  transactionNonce = options.nonce || (transaction && transaction.nonce) || null;
  transactionState = options.state || (transaction && transaction.state) || null;

  var applicationStatus = (transaction && transaction.appStatus) || null;
  if (parsedQs.id_token && options._idTokenVerification) {
    return this.validateToken(
      parsedQs.id_token,
      transactionState,
      transactionNonce,
      function (validationError, payload) {
        if (validationError) {
          return cb(validationError);
        }
        return cb(null, buildParseHashResponse(parsedQs, applicationStatus, payload));
      });
  }

  if (parsedQs.id_token) {
    var verifier = new IdTokenVerifier({
      issuer: this.baseOptions.token_issuer,
      audience: this.baseOptions.clientID,
      leeway: this.baseOptions.leeway || 0,
      __disableExpirationCheck: this.baseOptions.__disableExpirationCheck
    });

    var decodedToken = verifier.decode(parsedQs.id_token);
    cb(null, buildParseHashResponse(parsedQs, applicationStatus, decodedToken.payload));
  } else {
    cb(null, buildParseHashResponse(parsedQs, applicationStatus, null));
  }
};

function buildParseHashResponse(qsParams, appStatus, token) {
  return {
    accessToken: qsParams.access_token || null,
    idToken: qsParams.id_token || null,
    idTokenPayload: token || null,
    appStatus: appStatus || null,
    refreshToken: qsParams.refresh_token || null,
    state: qsParams.state || null,
    expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
    tokenType: qsParams.token_type || null
  };
}

/**
 * @callback validateTokenCallback
 * @param {Error} [err] error returned by while validating the token
 * @param {Object} [payload] claims stored in the token
 */

/**
 * Decodes the a JWT and verifies its nonce value
 *
 * @method validateToken
 * @private
 * @param {String} token
 * @param {String} state
 * @param {String} nonce
 * @param {validateTokenCallback} cb
 */
WebAuth.prototype.validateToken = function (token, state, nonce, cb) {
  var verifier = new IdTokenVerifier({
    issuer: this.baseOptions.token_issuer,
    audience: this.baseOptions.clientID,
    leeway: this.baseOptions.leeway || 0,
    __disableExpirationCheck: this.baseOptions.__disableExpirationCheck
  });

  verifier.verify(token, nonce, function (err, payload) {
    if (err) {
      return cb(error.invalidJwt(err.message));
    }

    cb(null, payload);
  });
};

/**
 * Executes a silent authentication transaction under the hood in order to fetch a new tokens for the current session.
 * This method requires that all Auth is performed with {@link authorize}
 *
 * @method renewAuth
 * @param {Object} options
 * @param {String} [options.domain] your Auth0 domain
 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
 */
WebAuth.prototype.renewAuth = function (options, cb) {
  var handler;
  var usePostMessage = !!options.usePostMessage;
  var _this = this;

  var params = objectHelper.merge(this.baseOptions, [
    'clientID',
    'redirectUri',
    'responseType',
    'scope',
    'audience',
    '_csrf',
    'state',
    '_instate',
    'nonce'
  ]).with(options);

  params.responseType = params.responseType || 'token';
  params.responseMode = params.responseMode || 'fragment';

  params = this.transactionManager.process(params);

  assert.check(params, { type: 'object', message: 'options parameter is not valid' });
  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });

  params.prompt = 'none';

  params = objectHelper.blacklist(params, ['usePostMessage', 'tenant']);

  handler = new SilentAuthenticationHandler(this, this.client.buildAuthorizeUrl(params));

  handler.login(usePostMessage, function (err, data) {
    if (err) {
      return cb(err);
    }

    var transaction = _this.transactionManager.getStoredTransaction(params.state);
    var transactionNonce = options.nonce || (transaction && transaction.nonce) || null;
    var transactionState = options.state || (transaction && transaction.state) || null;

    if (data.id_token) {
      return _this.validateToken(data.id_token, transactionState, transactionNonce, function (validationErr, payload) {
        if (validationErr) {
          return cb(validationErr);
        }

        data.idTokenPayload = payload;

        return cb(null, data);
      });
    }

    return cb(err, data);
  });
};

/**
 * Request an email with instruction to change a user's password
 *
 * @method changePassword
 * @param {Object} options
 * @param {String} options.email address where the user will recieve the change password email. It should match the user's email in Auth0
 * @param {String} options.connection name of the connection where the user was created
 * @param {changePasswordCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#change-password}
 */
WebAuth.prototype.changePassword = function (options, cb) {
  return this.client.dbConnection.changePassword(options, cb);
};

/**
 * Starts a passwordless authentication transaction.
 *
 * @method passwordlessStart
 * @param {Object} options
 * @param {String} options.send what will be sent via email which could be `link` or `code`. For SMS `code` is the only one valud
 * @param {String} [options.phoneNumber] phone number where to send the `code`. This parameter is mutually exclusive with `email`
 * @param {String} [options.email] email where to send the `code` or `link`. This parameter is mutually exclusive with `phoneNumber`
 * @param {String} options.connection name of the passwordless connection
 * @param {Object} [options.authParams] additional Auth parameters when using `link`
 * @param {Function} cb
 * @see   {@link https://auth0.com/docs/api/authentication#passwordless}
 */
WebAuth.prototype.passwordlessStart = function (options, cb) {
  return this.client.passwordless.start(options, cb);
};

/**
 * Creates a new user in a Auth0 Database connection
 *
 * @method signup
 * @param {Object} options
 * @param {String} options.email user email address
 * @param {String} options.password user password
 * @param {String} options.connection name of the connection where the user will be created
 * @param {signUpCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#signup}
 */
WebAuth.prototype.signup = function (options, cb) {
  return this.client.dbConnection.signup(options, cb);
};

/**
 * Redirects to the hosted login page (`/authorize`) in order to start a new authN/authZ transaction
 *
 * @method authorize
 * @param {Object} options
 * @param {String} [options.domain] your Auth0 domain
 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
 */
WebAuth.prototype.authorize = function (options) {
  var params = objectHelper.merge(this.baseOptions, [
    'clientID',
    'responseType',
    'responseMode',
    'redirectUri',
    'scope',
    'audience',
    '_csrf',
    'state',
    '_instate',
    'nonce'
  ]).with(options);

  assert.check(params, { type: 'object', message: 'options parameter is not valid' }, {
    responseType: { type: 'string', message: 'responseType option is required' }
  });

  params = this.transactionManager.process(params);

  windowHelper.redirect(this.client.buildAuthorizeUrl(params));
};

/**
 * Signs up a new user, automatically logs the user in after the signup and returns the user token.
 * The login will be done using /oauth/token with password-realm grant type.
 *
 * @method signupAndAuthorize
 * @param {Object} options
 * @param {String} options.email user email address
 * @param {String} options.password user password
 * @param {String} options.connection name of the connection where the user will be created
 * @param {tokenCallback} cb
 * @see   {@link https://auth0.com/docs/api/authentication#signup}
 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
 */
WebAuth.prototype.signupAndAuthorize = function (options, cb) {
  var _this = this;

  return this.client.dbConnection.signup(objectHelper.blacklist(options, ['popupHandler']),
    function (err) {
      if (err) {
        return cb(err);
      }
      options.realm = options.connection;
      if (!options.username) {
        options.username = options.email;
      }
      _this.client.login(options, cb);
    });
};

/**
 * Redirects to the auth0 logout endpoint
 *
 * If you want to navigate the user to a specific URL after the logout, set that URL at the returnTo parameter. The URL should be included in any the appropriate Allowed Logout URLs list:
 *
 * - If the client_id parameter is included, the returnTo URL must be listed in the Allowed Logout URLs set at the client level (see Setting Allowed Logout URLs at the App Level).
 * - If the client_id parameter is NOT included, the returnTo URL must be listed in the Allowed Logout URLs set at the account level (see Setting Allowed Logout URLs at the Account Level).
 *
 * @method logout
 * @param {Object} options
 * @param {String} [options.clientID] identifier of your client
 * @param {String} [options.returnTo] URL to be redirected after the logout
 * @param {Boolean} [options.federated] tells Auth0 if it should logout the user also from the IdP.
 * @see   {@link https://auth0.com/docs/api/authentication#logout}
 */
WebAuth.prototype.logout = function (options) {
  windowHelper.redirect(this.client.buildLogoutUrl(options));
};

/**
 * Verifies the passwordless TOTP and redirects to finish the passwordless transaction
 *
 * @method passwordlessVerify
 * @param {Object} options
 * @param {String} options.type `sms` or `email`
 * @param {String} options.phoneNumber only if type = sms
 * @param {String} options.email only if type = email
 * @param {String} options.connection the connection name
 * @param {String} options.verificationCode the TOTP code
 * @param {Function} cb
 */
WebAuth.prototype.passwordlessVerify = function (options, cb) {
  var _this = this;
  return this.client.passwordless.verify(options, function (err) {
    if (err) {
      return cb(err);
    }
    return windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(options));
  });
};

module.exports = WebAuth;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);
var WinChan = __webpack_require__(368);

var urlHelper = __webpack_require__(510);
var assert = __webpack_require__(49);
var responseHandler = __webpack_require__(67);
var PopupHandler = __webpack_require__(504);
var objectHelper = __webpack_require__(38);
var Warn = __webpack_require__(113);
var TransactionManager = __webpack_require__(222);

function Popup(webAuth, options) {
  this.baseOptions = options;
  this.client = webAuth.client;
  this.webAuth = webAuth;

  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
  this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  });
}


/**
 * Returns a new instance of the popup handler
 *
 * @method buildPopupHandler
 * @private
 */
Popup.prototype.buildPopupHandler = function () {
  var pluginHandler = this.baseOptions.plugins.get('popup.getPopupHandler');

  if (pluginHandler) {
    return pluginHandler.getPopupHandler();
  }

  return new PopupHandler();
};

/**
 * Initializes the popup window and returns the instance to be used later in order to avoid being blocked by the browser.
 *
 * @method preload
 * @param {Object} options receives the window height and width and any other window feature to be sent to window.open
 */
Popup.prototype.preload = function (options) {
  options = options || {};

  var popup = this.buildPopupHandler();

  popup.preload(options);
  return popup;
};

/**
 * Internal use.
 *
 * @method getPopupHandler
 * @private
 */
Popup.prototype.getPopupHandler = function (options, preload) {
  if (options.popupHandler) {
    return options.popupHandler;
  }

  if (preload) {
    return this.preload(options);
  }

  return this.buildPopupHandler();
};

/**
 * Handles the popup logic for the callback page.
 *
 * @method callback
 * @param {Object} options
 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
 * @param {String} [options._idTokenVerification] makes parseHash perform or skip `id_token` verification. We **strongly** recommend validating the `id_token` yourself if you disable the verification.
 * @see   {@link parseHash}
 */
Popup.prototype.callback = function (options) {
  var _this = this;
  WinChan.onOpen(function (popupOrigin, r, cb) {
    _this.webAuth.parseHash(options || {}, function (err, data) {
      return cb(err || data);
    });
  });
};

/**
 * Shows inside a new window the hosted login page (`/authorize`) in order to start a new authN/authZ transaction and post its result using `postMessage`.
 *
 * @method authorize
 * @param {Object} options
 * @param {String} [options.domain] your Auth0 domain
 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
 * @param {Boolean} [options.owp] determines if Auth0 should render the relay page or not and the caller is responsible of handling the response.
 * @param {authorizeCallback} cb
 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
 */
Popup.prototype.authorize = function (options, cb) {
  var popup;
  var url;
  var relayUrl;
  var popOpts = {};

  var pluginHandler = this.baseOptions.plugins.get('popup.authorize');

  var params = objectHelper.merge(this.baseOptions, [
    'clientID',
    'scope',
    'domain',
    'audience',
    'responseType',
    'redirectUri',
    '_csrf',
    'state',
    '_instate',
    'nonce'
  ]).with(objectHelper.blacklist(options, ['popupHandler']));

  assert.check(params, { type: 'object', message: 'options parameter is not valid' }, {
    responseType: { type: 'string', message: 'responseType option is required' }
  });

  // the relay page should not be necesary as long it happens in the same domain
  // (a redirectUri shoul be provided). It is necesary when using OWP
  relayUrl = urljoin(this.baseOptions.rootUrl, 'relay.html');

  // if a owp is enabled, it should use the owp flag
  if (options.owp) {
    // used by server to render the relay page instead of sending the chunk in the
    // url to the callback
    params.owp = true;
  } else {
    popOpts.origin = urlHelper.extractOrigin(params.redirectUri);
    relayUrl = params.redirectUri;
  }

  if (options.popupOptions) {
    popOpts.popupOptions = objectHelper.pick(options.popupOptions, ['width', 'height']);
  }

  if (pluginHandler) {
    params = pluginHandler.processParams(params);
  }

  params = this.transactionManager.process(params);

  delete params.domain;

  url = this.client.buildAuthorizeUrl(params);

  popup = this.getPopupHandler(options);

  return popup.load(url, relayUrl, popOpts, responseHandler(cb));
};

/**
 * Performs authentication with username/email and password with a database connection inside a new window
 *
 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
 * you should use {@link authorize} or {@link login}.
 *
 * @method loginWithCredentials
 * @param {Object} options
 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} [options.responseType] type of the response used. It can be any of the values `code` and `token`
 * @param {String} [options.responseMode] how the AuthN response is encoded and redirected back to the client. Supported values are `query` and `fragment`
 * @param {String} [options.scope] scopes to be requested during AuthN. e.g. `openid email`
 * @param {credentialsCallback} cb
 */
Popup.prototype.loginWithCredentials = function (options, cb) {
  var params;
  var popup;
  var url;
  var relayUrl;

  /* eslint-disable */
  assert.check(options, { type: 'object', message: 'options parameter is not valid' }, {
    clientID: { optional: true, type: 'string', message: 'clientID option is required' },
    redirectUri: { optional: true, type: 'string', message: 'redirectUri option is required' },
    responseType: { optional: true, type: 'string', message: 'responseType option is required' },
    scope: { optional: true, type: 'string', message: 'scope option is required' },
    audience: { optional: true, type: 'string', message: 'audience option is required' }
  });
  /* eslint-enable */

  popup = this.getPopupHandler(options);

  options = objectHelper.merge(this.baseOptions, [
    'clientID',
    'scope',
    'domain',
    'audience',
    '_csrf',
    'state',
    '_instate',
    'nonce'
  ]).with(objectHelper.blacklist(options, ['popupHandler']));

  params = objectHelper.pick(options, ['clientID', 'domain']);
  params.options = objectHelper.toSnakeCase(
    objectHelper.pick(options, ['password', 'connection', 'state', 'scope', '_csrf', 'device'])
  );
  params.options.username = options.username || options.email;

  url = urljoin(this.baseOptions.rootUrl, 'sso_dbconnection_popup', options.clientID);
  relayUrl = urljoin(this.baseOptions.rootUrl, 'relay.html');

  return popup.load(url, relayUrl, { params: params }, responseHandler(cb));
};

/**
 * Verifies the passwordless TOTP and redirects to finish the passwordless transaction
 *
 * @method passwordlessVerify
 * @param {Object} options
 * @param {String} options.type `sms` or `email`
 * @param {String} options.phoneNumber only if type = sms
 * @param {String} options.email only if type = email
 * @param {String} options.connection the connection name
 * @param {String} options.verificationCode the TOTP code
 * @param {Function} cb
 */
Popup.prototype.passwordlessVerify = function (options, cb) {
  var _this = this;
  return this.client.passwordless.verify(objectHelper.blacklist(options, ['popupHandler']),
    function (err) {
      if (err) {
        return cb(err);
      }

      options.username = options.phoneNumber || options.email;
      options.password = options.verificationCode;

      delete options.email;
      delete options.phoneNumber;
      delete options.verificationCode;
      delete options.type;

      _this.client.loginWithResourceOwner(options, cb);
    });
};

/**
 * Signs up a new user and automatically logs the user in after the signup.
 *
 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
 * you should use {@link authorize} or {@link signupAndAuthorize}.
 *
 * @method signupAndLogin
 * @param {Object} options
 * @param {String} options.email user email address
 * @param {String} options.password user password
 * @param {String} options.connection name of the connection where the user will be created
 * @param {credentialsCallback} cb
 */
Popup.prototype.signupAndLogin = function (options, cb) {
  var _this = this;

  // Preload popup to avoid the browser to block it since the login happens later
  var popupHandler = this.getPopupHandler(options, true);
  options.popupHandler = popupHandler;

  return this.client.dbConnection.signup(objectHelper.blacklist(options, ['popupHandler']),
    function (err) {
      if (err) {
        if (popupHandler._current_popup) {
          popupHandler._current_popup.kill();
        }
        return cb(err);
      }
      _this.loginWithCredentials(options, cb);
    });
};

module.exports = Popup;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var UsernamePassword = __webpack_require__(516);
var objectHelper = __webpack_require__(38);
var Warn = __webpack_require__(113);
var assert = __webpack_require__(49);

function Redirect(client, options) {
  this.baseOptions = options;
  this.client = client;

  this.warn = new Warn({
    disableWarnings: !!options._disableDeprecationWarnings
  });
}

/**
 * @callback credentialsCallback
 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
 * @param {Object} [result] result of the AuthN request
 * @param {String} result.accessToken token that can be used with {@link userinfo}
 * @param {String} [result.idToken] token that identifies the user
 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all clients can request them or the resource server might not allow them.
 */

/**
 * Performs authentication with username/email and password with a database connection
 *
 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
 * you should use {@link authorize} or {@link login}.
 *
 * @method loginWithCredentials
 * @param {Object} options
 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
 * @param {String} [options.responseType] type of the response used. It can be any of the values `code` and `token`
 * @param {String} [options.responseMode] how the AuthN response is encoded and redirected back to the client. Supported values are `query` and `fragment`
 * @param {String} [options.scope] scopes to be requested during AuthN. e.g. `openid email`
 * @param {credentialsCallback} cb
 */
Redirect.prototype.loginWithCredentials = function (options, cb) {
  var usernamePassword;

  var params = objectHelper.merge(this.baseOptions, [
    'clientID',
    'redirectUri',
    'tenant',
    'responseType',
    'responseMode',
    'scope',
    'audience',
    '_csrf',
    'state',
    '_instate',
    'nonce'
  ]).with(options);

  assert.check(params, { type: 'object', message: 'options parameter is not valid' }, {
    responseType: { type: 'string', message: 'responseType option is required' }
  });

  usernamePassword = new UsernamePassword(this.baseOptions);
  return usernamePassword.login(params, function (err, data) {
    if (err) {
      return cb(err);
    }
    return usernamePassword.callback(data);
  });
};

/**
 * Signs up a new user and automatically logs the user in after the signup.
 *
 * @method signupAndLogin
 * @param {Object} options
 * @param {String} options.email user email address
 * @param {String} options.password user password
 * @param {String} options.connection name of the connection where the user will be created
 * @param {credentialsCallback} cb
 */
Redirect.prototype.signupAndLogin = function (options, cb) {
  var _this = this;
  return this.client.dbConnection.signup(options, function (err) {
    if (err) {
      return cb(err);
    }
    return _this.loginWithCredentials(options, cb);
  });
};

module.exports = Redirect;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var IframeHandler = __webpack_require__(500);

function SilentAuthenticationHandler(auth0, authenticationUrl, timeout) {
  this.auth0 = auth0;
  this.authenticationUrl = authenticationUrl;
  this.timeout = timeout || 60 * 1000;
  this.handler = null;
}

SilentAuthenticationHandler.prototype.login = function (usePostMessage, callback) {
  this.handler = new IframeHandler({
    auth0: this.auth0,
    url: this.authenticationUrl,
    callback: callback,
    timeout: this.timeout,
    timeoutCallback: function () {
      callback({
        error: 'timeout',
        description: 'Timeout during authentication renew.'
      });
    },
    usePostMessage: usePostMessage || false
  });

  this.handler.init();
};

module.exports = SilentAuthenticationHandler;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);

var objectHelper = __webpack_require__(38);
var RequestBuilder = __webpack_require__(139);
var responseHandler = __webpack_require__(67);
var windowHelper = __webpack_require__(57);

function UsernamePassword(options) {
  this.baseOptions = options;
  this.request = new RequestBuilder(options);
}

UsernamePassword.prototype.login = function (options, cb) {
  var url;
  var body;

  url = urljoin(this.baseOptions.rootUrl, 'usernamepassword', 'login');

  options.username = options.username || options.email; // eslint-disable-line

  options = objectHelper.blacklist(options, ['email']); // eslint-disable-line

  body = objectHelper.merge(this.baseOptions, [
    'clientID',
    'redirectUri',
    'tenant',
    'responseType',
    'responseMode',
    'scope',
    'audience'
  ]).with(options);

  body = objectHelper.toSnakeCase(body, ['auth0Client']);

  return this.request
    .post(url)
    .send(body)
    .end(responseHandler(cb));
};

UsernamePassword.prototype.callback = function (formHtml) {
  var div;
  var form;
  var _document = windowHelper.getDocument();

  div = _document.createElement('div');
  div.innerHTML = formHtml;
  form = _document.body.appendChild(div).children[0];

  form.submit();
};

module.exports = UsernamePassword;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(68),__webpack_require__(45),__webpack_require__(91),__webpack_require__(42)):"function"==typeof define&&define.amd?define(["react","classnames/bind","prop-types","axios","classnames"],t):"object"==typeof exports?exports.Auth0SubscriptionCenterWidget=t(require("react"),require("classnames/bind"),require("prop-types"),require("axios"),require("classnames")):e.Auth0SubscriptionCenterWidget=t(e.react,e["classnames/bind"],e["prop-types"],e.axios,e.classnames)}(this,function(e,t,n,r,a){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(4);t.default=r.SubscriptionCenterWidget},function(e,t){e.exports=__webpack_require__(1)},function(e,t){e.exports=__webpack_require__(68)},function(e,t){e.exports=__webpack_require__(45)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.SubscriptionCenterWidget=t.Spinner=t.Main=t.Item=t.Alert=void 0;var a=n(6),i=r(a),u=n(8),l=r(u),s=n(10),o=r(s),c=n(12),d=r(c),f=n(14),p=r(f);t.Alert=i.default,t.Item=l.default,t.Main=o.default,t.Spinner=d.default,t.SubscriptionCenterWidget=p.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),i=r(a),u=n(3),l=r(u),s=n(21),o=r(s),c=n(2),d=r(c),f=n(16),p=r(f),m=d.default.bind(p.default),b=function(e){var t=e.type,n=e.message,r="success"===t?"The changes have been saved.":"Can't save the changes.";return i.default.createElement("div",{className:(0,o.default)("alert","animated","fadeIn",{"alert-success":"success"===t,"alert-danger":"error"===t,"alert-info":"info"===t},m("bye-margin")),role:"alert"},n&&n.length?n:r)};b.propTypes={type:l.default.oneOf(["success","error","info"]),message:l.default.string},t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(5),i=r(a);t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),o=n(1),c=r(o),d=n(3),f=r(d),p=n(2),m=r(p),b=n(17),h=r(b),v=m.default.bind(h.default),y=function(e){function t(){return i(this,t),u(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return l(t,e),s(t,[{key:"handleChange",value:function(e,t){this.context.changeSubscribedStateByID(e,t)}},{key:"render",value:function(){var e=this,t=this.props,n=t.className,r=t.id,i=t.title,u=t.description,l=t.subscribed,s=t.disabled;return c.default.createElement("div",{className:v("item",n)},c.default.createElement("div",null,c.default.createElement("label",a({className:v("item-label"),htmlFor:"a0-scw-"+r},"className","control-label"),i),c.default.createElement("p",{className:v("item-description")},u)),c.default.createElement("div",{className:v("item-switch")},c.default.createElement("div",{className:"ui-switch"},c.default.createElement("input",{className:v("switch"),type:"checkbox",id:"a0-scw-"+r,onChange:function(t){return e.handleChange(r,t.target.checked)},checked:l,disabled:s}),c.default.createElement("span",{className:"status","data-label-true":"On","data-label-false":"Off"}))))}}]),t}(o.Component);y.propTypes={className:f.default.string,id:f.default.number,title:f.default.string,description:f.default.string,subscribed:f.default.bool,disabled:f.default.bool},y.contextTypes={changeSubscribedStateByID:f.default.func},t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(7),i=r(a);t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),i=r(a),u=n(3),l=r(u),s=n(2),o=r(s),c=n(4),d=n(18),f=r(d),p=o.default.bind(f.default),m=function(e){var t=e.lastAlert,n=e.emailCampaigns,r=e.email;return i.default.createElement("div",{className:"a0-scw"},i.default.createElement("div",{className:"a0-scw__alerts"},t),i.default.createElement("div",{className:"a0-scw__container"},n.map(function(e){var t=e.id,n=e.title,a=e.description,u=e.subscribed;return i.default.createElement(c.Item,{className:p("item"),id:t,title:n,description:a,subscribed:u,key:t,disabled:0===r.length})})))};m.defaultProps={emailCampaigns:[],email:""},m.propTypes={lastAlert:l.default.node,emailCampaigns:l.default.arrayOf(l.default.shape({id:l.default.number.isRequired,title:l.default.string.isRequired,description:l.default.string.isRequired,subscribed:l.default.bool.isRequired})),email:l.default.string},t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(9),i=r(a);t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(1),i=r(a),u=n(2),l=r(u),s=n(19),o=r(s),c=l.default.bind(o.default),d=function(){return i.default.createElement("div",{className:"spinner spinner-md is-auth0 "+c("custom-spinner")},i.default.createElement("div",{className:"circle"}))};t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(11),i=r(a);t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(1),o=r(s),c=n(3),d=r(c),f=n(4),p=n(15),m=function(e){function t(){var e,n,r,u;a(this,t);for(var l=arguments.length,s=Array(l),c=0;c<l;c++)s[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(s))),r.state={emailCampaigns:[],alerts:[]},r.getAllEmailCampaigns=function(e){var t=r.props.apiUrl;e&&r.validateEmail(e)&&(r.addToAlertState(o.default.createElement(f.Spinner,null)),(0,p.getAll)(t,e).then(function(e){var t=e.data;r.addToAlertState(""),r.setState({emailCampaigns:t})}).catch(function(){return r.addToAlertState(o.default.createElement(f.Alert,{type:"error",message:"Can\\'t get your emails campaigns."}))}))},r.validateEmail=function(e){return/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e)?(r.addToAlertState(""),!0):(r.addToAlertState(o.default.createElement(f.Alert,{type:"error",message:"Invalid email address: "+e+"."})),!1)},r.addToAlertState=function(e){r.setState(function(t){var n=t.alerts;return{alerts:n.concat(e)}})},r.unsubscribeFromAll=function(){return r.changeSubscribedStateAll(!1,!0)},r.changeSubscribedStateAll=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=r.changeSubscribedAll(e);r.setState({emailCampaigns:n},function(){t&&r.changeSubscribedApiAll(e)})},r.changeSubscribedAll=function(e){var t=r.state.emailCampaigns,n=r.cloneCollection(t),a=n.map(function(t){var n=t.id,r=t.title,a=t.description;return{id:n,title:r,description:a,subscribed:e}});return a},r.changeSubscribedApiAll=function(e){var t=r.props,n=t.email,a=t.apiUrl,i=r.state.emailCampaigns,u=r.removeUnnecessaryFields(i);(0,p.setAll)(a,n,u).then(function(){r.addToAlertState(o.default.createElement(f.Alert,{type:"success"}))}).catch(function(){r.addToAlertState(o.default.createElement(f.Alert,{type:"error"})),r.changeSubscribedStateAll(!e,!1)})},r.changeSubscribedStateByID=function(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=r.changeSubscribedByID(e,t);r.setState({emailCampaigns:a},function(){n&&r.changeSubscribedAPIByID(e,a)})},r.changeSubscribedByID=function(e,t){var n=r.state.emailCampaigns,a=r.cloneCollection(n);return a.filter(function(t){var n=t.id;return n===e}).forEach(function(e){return e.subscribed="undefined"==typeof t?!e.subscribed:t}),a},r.changeSubscribedAPIByID=function(e,t){var n=r.props,a=n.email,i=n.apiUrl,u=r.removeUnnecessaryFields(t);(0,p.setAll)(i,a,u).then(function(){r.addToAlertState(o.default.createElement(f.Alert,{type:"success"}))}).catch(function(){r.addToAlertState(o.default.createElement(f.Alert,{type:"error"})),r.changeSubscribedStateByID(e,void 0,!1)})},r.cloneCollection=function(e){return JSON.parse(JSON.stringify(e))},u=n,i(r,u)}return u(t,e),l(t,[{key:"getChildContext",value:function(){return{changeSubscribedStateByID:this.changeSubscribedStateByID}}},{key:"componentWillMount",value:function(){var e=this.props.email;this.getAllEmailCampaigns(e)}},{key:"componentWillReceiveProps",value:function(e){var t=e.email;this.getAllEmailCampaigns(t),t!==this.state.email&&this.setState({emailCampaigns:[]})}},{key:"removeUnnecessaryFields",value:function(e){var t=this.cloneCollection(e),n=t.map(function(e){var t=e.id,n=e.subscribed;return{id:t,subscribed:n}});return n}},{key:"render",value:function(){var e=this.props.email,t=this.state,n=t.emailCampaigns,r=t.alerts,a=r[r.length-1];return o.default.createElement(f.Main,{lastAlert:a,emailCampaigns:n,email:e})}}]),t}(s.Component);m.propTypes={apiUrl:d.default.string.isRequired,email:d.default.string},m.defaultProps={email:""},m.childContextTypes={changeSubscribedStateByID:d.default.func},t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(13),i=r(a);t.default=i.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){return new Promise(function(n,r){return l.default.get(e+"/newsletter?user="+encodeURIComponent(t)).then(n).catch(r)})}function i(e,t,n){return new Promise(function(r,a){return l.default.patch(e+"/newsletter?user="+encodeURIComponent(t),n).then(r).catch(a)})}Object.defineProperty(t,"__esModule",{value:!0}),t.getAll=a,t.setAll=i;var u=n(20),l=r(u)},function(e,t){e.exports={"bye-margin":"_21rn"}},function(e,t){e.exports={"item-image":"_2ZFV","item-label":"_2WFE","item-description":"_3cjo","item-switch":"_3rLE",switch:"_3Z6S"}},function(e,t){e.exports={container:"_2DQu",item:"_26TC"}},function(e,t){e.exports={"custom-spinner":"_6Vnv"}},function(e,t){e.exports=__webpack_require__(91)},function(e,t){e.exports=__webpack_require__(42)}])});
//# sourceMappingURL=subscription-center-widget.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var bind = __webpack_require__(227);
var Axios = __webpack_require__(520);
var defaults = __webpack_require__(141);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(224);
axios.CancelToken = __webpack_require__(519);
axios.isCancel = __webpack_require__(225);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(534);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(224);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(141);
var utils = __webpack_require__(29);
var InterceptorManager = __webpack_require__(521);
var dispatchRequest = __webpack_require__(522);
var isAbsoluteURL = __webpack_require__(530);
var combineURLs = __webpack_require__(528);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);
var transformData = __webpack_require__(525);
var isCancel = __webpack_require__(225);
var defaults = __webpack_require__(141);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(226);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(29);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_function_name__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_raw__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_from_code_point__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_code_point_at__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_repeat__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_starts_with__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_ends_with__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_includes__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_regexp_flags__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_match__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_replace__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_split__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_search__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_array_from__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_of__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_copy_within__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_find__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find_index__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_fill__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_iterator__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_finite__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_integer__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_nan__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_epsilon__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_math_acosh__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_asinh__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_atanh__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_cbrt__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_clz32__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_cosh__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_expm1__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_fround__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_hypot__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_imul__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_log1p__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log10__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log2__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_sign__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sinh__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_tanh__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_trunc__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es7_array_includes__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_object_values__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_entries__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_string_pad_start__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_end__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_web_timers__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_immediate__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_dom_iterable__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_modules_locale_redirection__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_modules_ab_testing__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_modules_npm_component_user_agent__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_modules_triggers__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_pages_ab_variants__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_modules_canonical__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_modules_boot_sso__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_modules_header__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_pages_opensource__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_pages_dashboard__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_pages_why_auth0__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_pages_pricing__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_pages_about__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_pages_customers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_pages_availability_trust__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_pages_terms__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_pages_mcc__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_pages_privacy__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_pages_lock__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_pages_auth_catalog_index__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_pages_auth_catalog__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_pages_changelog__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_pages_wordpress__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_pages_blog__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_pages_docs__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_pages_press__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_pages_events_landing__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_pages_jobs__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_pages_security__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_pages_whitehat__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_pages_partners__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_pages_passwordless__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_pages_enterprise__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_pages_guest_authors__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_pages_breached_passwords__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_pages_guardian__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_pages_identity_glossary__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_pages_b2c__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_pages_b2b__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_pages_subscription_center__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_pages_ambassador_program__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_pages_signup__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_pages_jp__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_pages_resources__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_pages_notfound__ = __webpack_require__(398);
/* eslint-env browser, jquery */
/* global metricsLib */








































































































































var config = window.APP_CONFIG;
// Important note: if you add new components for pages they should list before blog
var pages = [__WEBPACK_IMPORTED_MODULE_97_pages_opensource__["a" /* default */], __WEBPACK_IMPORTED_MODULE_98_pages_dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_99_pages_why_auth0__["a" /* default */], __WEBPACK_IMPORTED_MODULE_100_pages_pricing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_101_pages_about__["a" /* default */], __WEBPACK_IMPORTED_MODULE_102_pages_customers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_103_pages_availability_trust__["a" /* default */], __WEBPACK_IMPORTED_MODULE_104_pages_terms__["a" /* default */], __WEBPACK_IMPORTED_MODULE_105_pages_mcc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_106_pages_privacy__["a" /* default */], __WEBPACK_IMPORTED_MODULE_107_pages_lock__["a" /* default */], __WEBPACK_IMPORTED_MODULE_108_pages_auth_catalog_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_109_pages_auth_catalog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_110_pages_changelog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_111_pages_wordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_112_pages_blog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_113_pages_docs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_114_pages_press__["a" /* default */], __WEBPACK_IMPORTED_MODULE_115_pages_events_landing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_116_pages_jobs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_117_pages_security__["a" /* default */], __WEBPACK_IMPORTED_MODULE_118_pages_whitehat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_119_pages_partners__["a" /* default */], __WEBPACK_IMPORTED_MODULE_120_pages_passwordless__["a" /* default */], __WEBPACK_IMPORTED_MODULE_121_pages_enterprise__["a" /* default */], __WEBPACK_IMPORTED_MODULE_122_pages_guest_authors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_123_pages_breached_passwords__["a" /* default */], __WEBPACK_IMPORTED_MODULE_124_pages_guardian__["a" /* default */], __WEBPACK_IMPORTED_MODULE_125_pages_identity_glossary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_126_pages_b2c__["a" /* default */], __WEBPACK_IMPORTED_MODULE_127_pages_b2b__["a" /* default */], __WEBPACK_IMPORTED_MODULE_128_pages_subscription_center__["a" /* default */], __WEBPACK_IMPORTED_MODULE_129_pages_ambassador_program__["a" /* default */], __WEBPACK_IMPORTED_MODULE_130_pages_signup__["a" /* default */], __WEBPACK_IMPORTED_MODULE_131_pages_jp__["a" /* default */], __WEBPACK_IMPORTED_MODULE_132_pages_resources__["a" /* default */]];

/**
 * Boot components
 * and pages.
 */

__WEBPACK_IMPORTED_MODULE_84_page___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_86_modules_locale_redirection__["a" /* default */])());

if (!config.disable_analytics) {
  __WEBPACK_IMPORTED_MODULE_84_page___default()(__WEBPACK_IMPORTED_MODULE_87_modules_ab_testing__["a" /* default */].computeExperiments());
  // - AB testing variants should go here
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_93_pages_ab_variants__["a" /* default */])();
}

// init pages
pages.forEach(function (pageItem) {
  return pageItem();
});

__WEBPACK_IMPORTED_MODULE_84_page___default()(function (ctx, next) {
  var $ = window.$;
  // FIXME: this should be better handled in future iterations
  if (ctx.notFound) {
    next();
    return;
  }

  ctx.notFound = !!$('.notfound-page').length;
  next();
});

__WEBPACK_IMPORTED_MODULE_84_page___default()(function (ctx, next) {
  var metricsLib = window.metricsLib;
  if (ctx.querystring.indexOf('signup=true') > -1) {
    window.signup();
  }

  // Contact form
  var contactFormOptions = {
    onModalOpen: function onModalOpen() {},
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_85_auth0_contact_form__["handleQueryString"])(contactFormOptions, { includePhoneField: true });

  return next();
});

__WEBPACK_IMPORTED_MODULE_84_page___default()(function (ctx, next) {
  var $ = window.$;
  if (window.location.hostname.toLowerCase() === 'auth0.com') {
    return next();
  }

  $('a[href^="https://auth0.com"]').each(function replaceHref() {
    this.href = this.href.replace('https://auth0.com', '');
  });

  return next();
});

__WEBPACK_IMPORTED_MODULE_84_page___default()(__WEBPACK_IMPORTED_MODULE_87_modules_ab_testing__["a" /* default */].executeExperiments());

// no page.js scripts should be
// added after `notfound`

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_133_pages_notfound__["a" /* default */])();

var scrollExceptionPages = ['/press/news', '/press/announcements', '/pricing', '/jobs', '/customers'];

// Initialize global events binded to page actions
__WEBPACK_IMPORTED_MODULE_90_modules_npm_component_bus__["a" /* default */].on('page:change', function () {
  if (scrollExceptionPages.indexOf(window.location.pathname) !== -1) return;
  var $ = window.$;
  $('body').scrollTop(0);
});

__WEBPACK_IMPORTED_MODULE_90_modules_npm_component_bus__["a" /* default */].on('page:render', function () {
  __WEBPACK_IMPORTED_MODULE_91_modules_triggers__["a" /* default */].triggerNotSignedUp();
  __WEBPACK_IMPORTED_MODULE_88_modules_metrics__["a" /* default */].onPageRenderEvent();
});

/**
 * Boot page.js
 */
var oldMsie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_89_modules_npm_component_user_agent__["a" /* ie */])().lte(9);
__WEBPACK_IMPORTED_MODULE_84_page___default()({
  click: !oldMsie
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(58);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ContactUsForm = function (_Component) {
  _inherits(ContactUsForm, _Component);

  function ContactUsForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactUsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactUsForm.__proto__ || Object.getPrototypeOf(ContactUsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      name: '',
      company: '',
      email: '',
      role: 'Software Developer',
      message: ''
    }, _this.handleInputChange = function (event) {
      var name = event.target.name;
      var value = event.target.value;
      _this.setState(_defineProperty({}, name, value));
    }, _this.submitHandler = function (event) {
      event.preventDefault();
      var _this$state = _this.state,
          name = _this$state.name,
          company = _this$state.company,
          email = _this$state.email,
          role = _this$state.role,
          message = _this$state.message;
      var _this$props = _this.props,
          postContactForm = _this$props.postContactForm,
          postExtraData = _this$props.postExtraData,
          extraDataForPosting = _this$props.extraDataForPosting,
          source = _this$props.source,
          subject = _this$props.subject;


      var formData = {
        email: email,
        name: name,
        company: company,
        role: role,
        message: message,
        source: source,
        subject: subject
      };

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* isValidEmail */])(email)) return alert('Please enter a valid email');

      postContactForm(formData);

      if (extraDataForPosting.url) {
        var extraData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* setExtraFormData */])(_this.state);
        postExtraData(extraData);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactUsForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /* eslint-env browser */
      this.metricsLib = window.metricsLib;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var postExtraDataResponse = nextProps.postExtraDataResponse;

      this.onPostExtraData(postExtraDataResponse);
    }
  }, {
    key: 'onPostExtraData',
    value: function onPostExtraData(response) {
      if (response) {
        var _state = this.state,
            name = _state.name,
            company = _state.company,
            email = _state.email,
            role = _state.role,
            message = _state.message;
        var _props = this.props,
            source = _props.source,
            subject = _props.subject,
            extraDataForPosting = _props.extraDataForPosting;


        var metricsData = {
          email: email,
          name: name,
          company: company,
          role: role,
          message: message,
          source: source,
          subject: subject,
          trackData: email,
          formId: extraDataForPosting.formId,
          lpId: extraDataForPosting.lpId
        };
        if (response.rejected) {
          this.metricsLib.track(extraDataForPosting.trackEventFail, metricsData);
        }
        if (response.fulfilled) {
          this.metricsLib.track(extraDataForPosting.trackEventRegister, metricsData);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          name = _state2.name,
          company = _state2.company,
          email = _state2.email,
          role = _state2.role,
          message = _state2.message;
      var postContactFormResponse = this.props.postContactFormResponse;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'contact-form-section' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.submitHandler, className: 'contact-form' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: 'form-title' },
              'Contact Us'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'name' },
                'Name',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  id: 'name',
                  type: 'text',
                  name: 'name',
                  onChange: this.handleInputChange,
                  value: name,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'company' },
                'Company',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  id: 'company',
                  type: 'text',
                  name: 'company',
                  value: company,
                  onChange: this.handleInputChange,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'email' },
                'Email',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  id: 'email',
                  type: 'email',
                  name: 'email',
                  value: email,
                  onChange: this.handleInputChange,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'role' },
                'Role',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'select',
                  {
                    id: 'role',
                    name: 'role',
                    required: true,
                    onChange: this.handleInputChange,
                    value: role
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Software Developer' },
                    'Software Developer'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Engineering Exec / Management' },
                    'Engineering Exec / Management'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'C-Level' },
                    'C-Level'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'IT operations' },
                    'IT operations'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Product Management' },
                    'Product Management'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Sales' },
                    'Sales'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Marketing' },
                    'Marketing'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Security & Compliance' },
                    'Security & Compliance'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: 'Other' },
                    'Other'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                { htmlFor: 'message', className: 'textarea' },
                'Message',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                  name: 'message',
                  id: 'message',
                  onChange: this.handleInputChange,
                  value: message,
                  required: true
                })
              ),
              postContactFormResponse ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* PromiseStateContainer */], {
                ps: __WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"].race([postContactFormResponse]),
                onPending: function onPending() {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-lg btn-success', type: 'submit', disabled: true },
                    'Sending...'
                  );
                },
                onFulFillment: function onFulFillment() {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-lg btn-success success', type: 'submit', disabled: true },
                    'Thanks for getting in touch!'
                  );
                }
              }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-lg btn-success', type: 'submit' },
                'send'
              )
            )
          )
        )
      );
    }
  }]);

  return ContactUsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ContactUsForm.propTypes = {
  source: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  subject: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  extraDataForPosting: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    url: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    formId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    lpId: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    trackEventRegister: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    trackEventFail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  }),
  postContactForm: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  postExtraData: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  postContactFormResponse: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]),
  postExtraDataResponse: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"])
};
ContactUsForm.defaultProps = {
  extraDataForPosting: {},
  postContactFormResponse: null,
  postExtraDataResponse: null
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__connect__["a" /* default */])(ContactUsForm));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);



/* harmony default export */ __webpack_exports__["a"] = (function (Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function (props) {
    return {
      postContactForm: function postContactForm(data) {
        return {
          postContactFormResponse: {
            url: 'https://auth0-marketing.run.webtask.io/contact-form',
            method: 'POST',
            body: JSON.stringify(data)
          }
        };
      },
      postExtraData: function postExtraData(data) {
        return {
          postExtraDataResponse: {
            url: props.extraDataForPosting.url,
            method: 'POST',
            body: JSON.stringify({
              data: {
                content: data
              }
            })
          }
        };
      }
    };
  })(Component);
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContactUsForm__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ContactUsForm__["a"]; });



/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setExtraFormData;
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidEmail;
function setExtraFormData(data) {
  return Object.keys(data).reduce(function (result, key) {
    return result + (key + ': ' + data[key] + '\n');
  }, '');
}

function isValidEmail(value) {
  var email = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
  return email.test(value);
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  setExtraFormData: setExtraFormData,
  isValidEmail: isValidEmail
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Loader = function Loader(_ref) {
  var size = _ref.size;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'loader-centering spinner ' + (size === 'medium' ? 'spinner-md' : 'spinner-lg') + ' is-auth0'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'circle' })
  );
};

Loader.defaultProps = {
  size: 'medium'
};

Loader.propTypes = {
  size: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });



/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(142);



var settings = {};

var LockHomeDemo = function LockHomeDemo() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* Widget */], settings);
};

/* harmony default export */ __webpack_exports__["a"] = (LockHomeDemo);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_typist__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_typist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_typist__);



var Icon1 = function Icon1() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      className: 'auth0-lock-icon',
      height: '13px',
      version: '1.1',
      viewBox: '0 0 32 26',
      width: '14px',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd', id: 'Page-1', stroke: 'none', strokeWidth: '1' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { fill: '#373A39', id: '32px', transform: 'translate(-2155.000000, -2317.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { id: 'Group-856', transform: 'translate(1.000000, 1.000000)' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
            d: 'M2184,2339 C2184,2339.55 2183.55,2340 2183,2340 L2157,2340 C2156.45,2340 2156,2339.55 2156,2339 L2156,2319 C2156,2318.45 2156.45,2318 2157,2318 L2183,2318 C2183.55,2318 2184,2318.45 2184,2319 L2184,2339 L2184,2339 Z M2184,2316 L2156,2316 C2154.89,2316 2154,2316.89 2154,2318 L2154,2340 C2154,2341.1 2154.89,2342 2156,2342 L2184,2342 C2185.1,2342 2186,2341.1 2186,2340 L2186,2318 C2186,2316.89 2185.1,2316 2184,2316 L2184,2316 Z M2176,2322 L2180,2322 L2180,2326 L2176,2326 L2176,2322 Z M2174,2328 L2182,2328 L2182,2320 L2174,2320 L2174,2328 Z M2158,2332 L2172,2332 L2172,2330 L2158,2330 L2158,2332 Z M2158,2336 L2172,2336 L2172,2334 L2158,2334 L2158,2336 Z',
            id: 'Fill-419'
          })
        )
      )
    )
  );
};

var Icon2 = function Icon2() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      className: 'auth0-lock-icon auth0-lock-icon-box',
      height: '14px',
      version: '1.1',
      viewBox: '0 0 13 16',
      width: '11px',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { fill: '#888888', transform: 'translate(-288.000000, -1508.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M299,1523.998 L290,1523.998 C288.896,1523.998 288,1523.102 288,1521.999 L288,1515.999 C288,1514.895 288.896,1513.998 290,1513.998 L290,1513.998 L290,1512.499 C290,1510.015 292.015,1507.999 294.5,1507.999 C296.985,1507.999 299,1510.015 299,1512.499 L299,1513.999 C300.104,1513.999 301,1514.895 301,1515.999 L301,1521.999 C301,1523.103 300.104,1523.998 299,1523.998 L299,1523.998 Z M298,1512.499 C298,1510.566 296.433,1508.999 294.5,1508.999 C292.567,1508.999 291,1510.566 291,1512.499 L291,1513.998 L298,1513.998 L298,1512.499 L298,1512.499 Z M300,1515.999 C300,1515.446 299.552,1514.998 299,1514.998 L290,1514.998 C289.447,1514.998 289,1515.446 289,1515.999 L289,1521.999 C289,1522.551 289.447,1522.998 290,1522.998 L299,1522.998 C299.552,1522.998 300,1522.551 300,1521.999 L300,1515.999 L300,1515.999 Z M294.5,1520.998 C294.224,1520.998 294,1520.774 294,1520.498 L294,1517.498 C294,1517.223 294.224,1516.999 294.5,1516.999 C294.776,1516.999 295,1517.223 295,1517.498 L295,1520.498 C295,1520.774 294.776,1520.998 294.5,1520.998 L294.5,1520.998 Z' })
      )
    )
  );
};

var Credentials = function Credentials(_ref) {
  var values = _ref.values,
      placeholders = _ref.placeholders,
      typing1 = _ref.typing1,
      typing2 = _ref.typing2,
      onDone1 = _ref.onDone1,
      onDone2 = _ref.onDone2,
      focused = _ref.focused;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'auth0-lock-view-content' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'auth0-lock-body-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'auth0-lock-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'auth0-lock-form' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'auth0-lock-tabs-container' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'auth0-lock-pane-separator' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'auth0-lock-input-block auth0-lock-input-email lolo' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'auth0-lock-input-wrap auth0-lock-input-wrap-with-icon ' + (focused === 1 ? 'auth0-lock-focused' : '')
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon1, null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'auth0-lock-input' },
                  typing1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_typist___default.a,
                    { cursor: { show: false }, onTypingDone: onDone1, avgTypingDelay: 85 },
                    values.user
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'auth0-lock-input-block auth0-lock-input-password' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: 'auth0-lock-input-wrap auth0-lock-input-wrap-with-icon ' + (focused === 2 ? 'auth0-lock-focused' : '')
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon2, null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'auth0-lock-input' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'auth0-lock-input-placeholder' },
                    placeholders.pwd
                  ),
                  typing2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_typist___default.a,
                    { cursor: { show: false }, onTypingDone: onDone2, avgTypingDelay: 85 },
                    values.pwd
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'auth0-lock-alternative' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'auth0-lock-alternative-link', href: '#' },
                'Dont remember your password?'
              )
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Credentials);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(142);



var Dots = function Dots(_ref) {
  var connection = _ref.connection;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'dots' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dot dot-1' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dot dot-2' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'dot-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'dot dot-3' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* Notification */], { connection: connection })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Dots);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_StatusBarSVG__ = __webpack_require__(551);



var Header = function Header(_ref) {
  var text = _ref.text,
      gravatar = _ref.gravatar,
      gravatarUrl = _ref.gravatarUrl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'auth0-lock-header' },
    gravatar && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: gravatarUrl, className: 'auth0-lock-header-avatar', alt: 'Avatar' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__svg_StatusBarSVG__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'auth0-lock-header-bg auth0-lock-blur-support auth0-lock-no-grayscale' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'auth0-lock-header-bg-blur',
        style: { backgroundImage: 'url(' + gravatarUrl + ')' }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'auth0-lock-header-bg-solid', style: { backgroundColor: 'rgb(234, 83, 35)' } })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'auth0-lock-header-welcome' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        className: 'auth0-lock-header-logo ' + (gravatar ? 'auth0-header-logo-disabled' : ''),
        src: 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'auth0-lock-name' },
        text
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DatabaseIcon = function DatabaseIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    {
      width: "12px",
      height: "12px",
      viewBox: "205 16 12 12",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      {
        id: "ic_dns_black_24px",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "translate(205.000000, 16.000000)"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { id: "Group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", { id: "Shape", points: "0 0 12 0 12 12 0 12" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M10,6.5 L2,6.5 C1.725,6.5 1.5,6.725 1.5,7 L1.5,10 C1.5,10.275 1.725,10.5 2,10.5 L10,10.5 C10.275,10.5 10.5,10.275 10.5,10 L10.5,7 C10.5,6.725 10.275,6.5 10,6.5 Z M3.5,9.5 C2.95,9.5 2.5,9.05 2.5,8.5 C2.5,7.95 2.95,7.5 3.5,7.5 C4.05,7.5 4.5,7.95 4.5,8.5 C4.5,9.05 4.05,9.5 3.5,9.5 Z M10,1.5 L2,1.5 C1.725,1.5 1.5,1.725 1.5,2 L1.5,5 C1.5,5.275 1.725,5.5 2,5.5 L10,5.5 C10.275,5.5 10.5,5.275 10.5,5 L10.5,2 C10.5,1.725 10.275,1.5 10,1.5 Z M3.5,4.5 C2.95,4.5 2.5,4.05 2.5,3.5 C2.5,2.95 2.95,2.5 3.5,2.5 C4.05,2.5 4.5,2.95 4.5,3.5 C4.5,4.05 4.05,4.5 3.5,4.5 Z",
          id: "Shape",
          fill: "#000000"
        })
      )
    )
  );
};

var Notifications = function Notifications(_ref) {
  var connection = _ref.connection;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "logged-in-notification" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      "Logged in using ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "bold" },
        connection.name
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DatabaseIcon, null)
  );
};

Notifications.propTypes = {
  connection: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Notifications);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ProfileList = function ProfileList(_ref) {
  var profile = _ref.profile;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "ul",
    { className: "profile-list fadeInRight animated" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-left" },
        "company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-right" },
        profile.company
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-left" },
        "position"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-right" },
        profile.position
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-left" },
        "hobbies"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-right" },
        profile.hobbies
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-left" },
        "location"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-right" },
        profile.location
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-left" },
        "age"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "column-right" },
        profile.age
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ProfileList);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_DeviceSVG__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_persons_json__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_persons_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_persons_json__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ArrowIcon = function ArrowIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      className: 'icon-text',
      height: '10px',
      version: '1.1',
      viewBox: '0 0 8 12',
      width: '7px',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd', id: 'Symbols', stroke: 'none', strokeWidth: '1' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { fill: '#FFFFFF', id: 'Web/Submit/Active', transform: 'translate(-148.000000, -32.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { id: 'Shape', points: '148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38' })
      )
    )
  );
};

var Widget = function (_React$Component) {
  _inherits(Widget, _React$Component);

  function Widget() {
    _classCallCheck(this, Widget);

    var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this));
    /* eslint-env browser */


    _this.state = {
      loggedIn: false,
      welcomeText: 'Auth0',
      gravatar: false,
      gravatarUrl: 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png',
      sampleAppUrl: '',
      typing1: false,
      typing2: false,
      focused: 0,
      values: {
        user: '',
        pwd: ''
      },
      placeholders: {
        user: 'Username',
        pwd: 'Password'
      },
      dots: false,
      profile: false
    };

    _this.getNewPerson = function () {
      var randomPersonIndex = Math.floor(Math.random() * __WEBPACK_IMPORTED_MODULE_3__data_persons_json___default.a.length);
      return __WEBPACK_IMPORTED_MODULE_3__data_persons_json___default.a[randomPersonIndex];
    };

    _this.setStatePromise = function (newState, delay) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          if (_this.stop) {
            return resolve();
          }
          return _this.setState(newState, function () {
            resolve();
          });
        }, delay);
      });
    };

    _this.startLockDemo = function () {
      var newPlaceholderState = {
        placeholders: { user: '', pwd: 'Password' }
      };

      var newValues = {
        user: _this.person.email,
        pwd: '••••••••••'
      };

      _this.setStatePromise({ focused: 1, sampleAppUrl: _this.person.sampleAppUrl }, 500).then(_this.setStatePromise({ typing1: true, values: newValues }, 500)).then(_this.setStatePromise(newPlaceholderState, 200));
    };

    _this.typePassword = function () {
      var exampleAppState = {
        welcomeText: 'Welcome ' + _this.person.name,
        gravatarUrl: _this.person.gravatarUrl,
        gravatar: true,
        typing2: true,
        focused: 2
      };

      var placeholdersState = {
        placeholders: {
          user: '',
          pwd: ''
        }
      };

      _this.setStatePromise(exampleAppState, 300).then(_this.setStatePromise(placeholdersState, 300));
    };

    _this.startAdditionalElements = function () {
      _this.setStatePromise({ focused: 3 }, 100).then(_this.setStatePromise({ loggedIn: true, focus: 0 }, 1000)).then(_this.setStatePromise({ profile: true }, 1000)).then(_this.setStatePromise({ dots: true }, 2000));
    };

    _this.person = _this.getNewPerson();

    var preloadImage = new Image();
    preloadImage.src = _this.person.sampleAppUrl;

    _this.typePassword = _this.typePassword.bind(_this);
    _this.startLockDemo = _this.startLockDemo.bind(_this);
    _this.startAdditionalElements = _this.startAdditionalElements.bind(_this);
    _this.setStatePromise = _this.setStatePromise.bind(_this);
    _this.stop = false;
    return _this;
  }

  _createClass(Widget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startLockDemo();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var lockDevice = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'device' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'auth0-lock-demo-homepage' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'auth0-lock-widget-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'screen1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'auth0-lock-cred-pane auth0-lock-quiet' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["c" /* Header */], {
                  text: this.state.welcomeText,
                  gravatar: this.state.gravatar,
                  gravatarUrl: this.state.gravatarUrl
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* Credentials */], {
                  focused: this.state.focused,
                  values: this.state.values,
                  placeholders: this.state.placeholders,
                  typing1: this.state.typing1,
                  typing2: this.state.typing2,
                  onDone1: this.typePassword,
                  onDone2: this.startAdditionalElements
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    className: 'auth0-lock-submit ' + (this.state.focused === 3 ? 'auth0-lock-submit-focused ' : ''),
                    style: { backgroundColor: '#eb5424' },
                    type: 'submit'
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'auth0-loading-container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'auth0-loading' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'auth0-label-submit' },
                    'Log In',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowIcon, null)
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: (this.state.loggedIn ? ' screen2-active' : '') + ' screen2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: this.state.sampleAppUrl, alt: 'Sample app' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__svg_DeviceSVG__["a" /* default */], null)
        )
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'identity-animation' },
        this.state.profile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["e" /* ProfileList */], { profile: this.person.profile }),
        this.state.dots && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["f" /* Dots */], { connection: this.person.connection }),
        lockDevice
      );
    }
  }]);

  return Widget;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Widget);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LockHomeDemo__ = __webpack_require__(542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LockHomeDemo__["a"]; });



/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DeviceSVG = function DeviceSVG() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    {
      width: "251",
      height: "505",
      viewBox: "-1 -1 251 505",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "defs",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { id: "a", width: "250", height: "504", rx: "32.189" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "filter",
        { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "b" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "3", "in": "SourceAlpha", result: "shadowBlurInner1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feOffset", { dy: "6", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite", {
          "in": "shadowOffsetInner1",
          in2: "SourceAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1",
          result: "shadowInnerInner1"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix", {
          values: "0 0 0 0 0.839340377 0 0 0 0 0.839340377 0 0 0 0 0.888286565 0 0 0 1 0",
          "in": "shadowInnerInner1",
          result: "shadowMatrixInner1"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feMorphology", { radius: "2", "in": "SourceAlpha", result: "shadowSpreadInner2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "4", "in": "shadowSpreadInner2", result: "shadowBlurInner2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feOffset", { dy: "-4", "in": "shadowBlurInner2", result: "shadowOffsetInner2" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite", {
          "in": "shadowOffsetInner2",
          in2: "SourceAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1",
          result: "shadowInnerInner2"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix", {
          values: "0 0 0 0 0.839215686 0 0 0 0 0.839215686 0 0 0 0 0.890196078 0 0 0 1 0",
          "in": "shadowInnerInner2",
          result: "shadowMatrixInner2"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "feMerge",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feMergeNode", { "in": "shadowMatrixInner1" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feMergeNode", { "in": "shadowMatrixInner2" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "linearGradient",
        { x1: "-36.708%", y1: "-156.185%", y2: "227.148%", id: "c" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#ABA3A3", offset: "0%" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { offset: "100%" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { id: "d", x: "105.15", y: "20.224", width: "39.7", height: "4.513", rx: "2.257" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "filter",
        { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "e" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "1", "in": "SourceAlpha", result: "shadowBlurInner1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feOffset", { dy: "2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite", {
          "in": "shadowOffsetInner1",
          in2: "SourceAlpha",
          operator: "arithmetic",
          k2: "-1",
          k3: "1",
          result: "shadowInnerInner1"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feColorMatrix", {
          values: "0 0 0 0 0.0212053571 0 0 0 0 0.0212053571 0 0 0 0 0.0212053571 0 0 0 0.905938632 0",
          "in": "shadowInnerInner1"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "rotate(-180 125 252)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "#FFF", xlinkHref: "#a" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "#000", filter: "url(#b)", xlinkHref: "#a" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { opacity: ".103" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "url(#c)", xlinkHref: "#d" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "#000", filter: "url(#e)", xlinkHref: "#d" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
        stroke: "#DDD",
        strokeWidth: "1.073",
        fill: "#FFF",
        cx: "125",
        cy: "478.191",
        rx: "11.803",
        ry: "11.821"
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DeviceSVG);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var StatusBarSVG = function StatusBarSVG() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      style: { position: 'absolute', top: 0, left: 0, zIndex: 1000 },
      height: '13px',
      width: '231px',
      version: '1.1',
      viewBox: '-1 0 231 13'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      {
        id: 'Status-Bar-/-Black',
        fill: 'none',
        stroke: 'none',
        strokeWidth: '1',
        transform: 'translate(-0.612167, 0.000000)'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { height: '12.4555254', id: 'Background', width: '229.562738', fillOpacity: '0', x: '0', y: '0' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { id: 'Signal', fill: '#000000', transform: 'translate(3.979087, 4.670822)' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', { id: 'Oval-1', cx: '1.68346008', cy: '1.71263474', rx: '1.68346008', ry: '1.71263474' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', { id: 'Oval-1-copy', cx: '5.96863118', cy: '1.71263474', rx: '1.68346008', ry: '1.71263474' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', {
          id: 'Oval-1-copy-2',
          cx: '10.2538023',
          cy: '1.71263474',
          rx: '1.68346008',
          ry: '1.71263474'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          id: 'Shape',
          d: 'M14.5389734,3.11388134 L14.5389734,3.11388134 C15.2996774,3.11388134 15.9163498,2.48652191 15.9163498,1.71263474 C15.9163498,0.93874756 15.2996774,0.311388134 14.5389734,0.311388134 C13.7782693,0.311388134 13.161597,0.93874756 13.161597,1.71263474 C13.161597,2.48652191 13.7782693,3.11388134 14.5389734,3.11388134 L14.5389734,3.11388134 Z M14.5389734,3.42526947 L14.5389734,3.42526947 C13.609224,3.42526947 12.8555133,2.65849683 12.8555133,1.71263474 C12.8555133,0.766772642 13.609224,0 14.5389734,0 C15.4687228,0 16.2224335,0.766772642 16.2224335,1.71263474 C16.2224335,2.65849683 15.4687228,3.42526947 14.5389734,3.42526947 L14.5389734,3.42526947 Z'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          id: 'Shape',
          d: 'M18.8241445,3.11388134 L18.8241445,3.11388134 C19.5848485,3.11388134 20.2015209,2.48652191 20.2015209,1.71263474 C20.2015209,0.93874756 19.5848485,0.311388134 18.8241445,0.311388134 C18.0634404,0.311388134 17.4467681,0.93874756 17.4467681,1.71263474 C17.4467681,2.48652191 18.0634404,3.11388134 18.8241445,3.11388134 L18.8241445,3.11388134 Z M18.8241445,3.42526947 L18.8241445,3.42526947 C17.8943951,3.42526947 17.1406844,2.65849683 17.1406844,1.71263474 C17.1406844,0.766772642 17.8943951,0 18.8241445,0 C19.7538939,0 20.5076046,0.766772642 20.5076046,1.71263474 C20.5076046,2.65849683 19.7538939,3.42526947 18.8241445,3.42526947 L18.8241445,3.42526947 Z'
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        id: 'Facebook',
        d: 'M27.5176667,3.53799402 L27.5176667,8.8683288 L28.2268849,8.8683288 L28.2268849,6.42712506 L30.6755541,6.42712506 L30.6755541,5.82988867 L28.2268849,5.82988867 L28.2268849,4.13523041 L31.018965,4.13523041 L31.018965,3.53799402 L27.5176667,3.53799402 Z M32.5117942,5.82988867 L32.5117942,4.13523041 L33.9302306,4.13523041 C34.0845175,4.13523041 34.2300924,4.14394002 34.3669598,4.1613595 C34.5038271,4.17877898 34.6245174,4.21735011 34.7290343,4.27707405 C34.8335512,4.33679799 34.9156704,4.42140563 34.9753943,4.53089952 C35.0351183,4.6403934 35.0649798,4.78970101 35.0649798,4.97882681 C35.0649798,5.26251551 34.9766395,5.47527885 34.7999561,5.6171232 C34.6232728,5.75896755 34.3333672,5.82988867 33.9302306,5.82988867 L32.5117942,5.82988867 Z M31.802576,3.53799402 L31.802576,8.8683288 L34.3781579,8.8683288 C34.6419387,8.8683288 34.8746097,8.82478075 35.076178,8.73768334 C35.2777463,8.65058593 35.4469615,8.53611677 35.5838289,8.39427242 C35.7206963,8.25242807 35.8239674,8.08943393 35.8936453,7.90528512 C35.9633232,7.72113632 35.9981616,7.53201335 35.9981616,7.33791055 C35.9981616,7.00942889 35.9110655,6.73072137 35.7368707,6.5017796 C35.5626759,6.27283784 35.3113414,6.12353024 34.9828598,6.05385231 L34.9828598,6.0389214 C35.2366865,5.93938151 35.4320306,5.78634121 35.568898,5.57979593 C35.7057653,5.37325064 35.774198,5.12813732 35.774198,4.84444862 C35.774198,4.5756909 35.7132307,4.34924103 35.5912944,4.16509223 C35.469358,3.98094342 35.3212946,3.83661273 35.1470998,3.73209584 C35.0674679,3.6823259 34.9716622,3.64499899 34.8596798,3.62011402 C34.7476974,3.59522905 34.6270071,3.5765656 34.4976052,3.56412311 C34.3682034,3.55168062 34.2375592,3.54421524 34.1056688,3.54172674 C33.9737785,3.53923825 33.8505997,3.53799402 33.7361288,3.53799402 L31.802576,3.53799402 Z M32.5117942,8.27109241 L32.5117942,6.42712506 L34.1317979,6.42712506 C34.2811078,6.42712506 34.4254385,6.44081159 34.5647943,6.46818506 C34.7041502,6.49555853 34.8273289,6.54283927 34.9343343,6.6100287 C35.0413397,6.67721813 35.1271916,6.76804692 35.1918925,6.8825178 C35.2565935,6.99698868 35.2889434,7.14131937 35.2889434,7.31551419 C35.2889434,7.61413388 35.2006031,7.84804912 35.0239198,8.01726695 C34.8472365,8.18648477 34.6021232,8.27109241 34.2885725,8.27109241 L32.5117942,8.27109241 Z',
        fill: '#000000'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        id: 'Wifi',
        d: 'M42.6933698,7.15048347 C42.2307871,7.15048347 41.8070596,7.3488275 41.4778258,7.63488264 L42.6933698,9.04738223 L43.9102933,7.63628602 C43.5808296,7.34952919 43.1568721,7.15048347 42.6933698,7.15048347 Z M42.7414214,4.3565925 C43.8939695,4.3565925 44.9446667,4.8021649 45.749818,5.53309075 L46.3087338,4.88473029 C45.3548295,4.01580564 44.1089371,3.40814312 42.7411915,3.40814312 C41.3757449,3.40814312 40.131462,4.01416836 39.1787072,4.88075405 L39.7367033,5.52958231 C40.5416247,4.80052763 41.5904826,4.3565925 42.7414214,4.3565925 Z M42.7253276,6.22776268 C43.4162127,6.22776268 44.0473207,6.49136377 44.5340441,6.92453967 L45.1258373,6.2385219 C44.4820841,5.65845915 43.6442852,5.2793133 42.7255575,5.2793133 C41.8084391,5.2793133 40.9717898,5.65728967 40.3282665,6.23571515 L40.91914,6.9226685 C41.4054036,6.49019429 42.035592,6.22776268 42.7253276,6.22776268 Z',
        fill: '#000000'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        id: '9:41',
        d: 'M103.468388,8.8683288 L103.468388,3.57532129 L102.983134,3.57532129 C102.948295,3.77440108 102.883595,3.93863945 102.789032,4.06804131 C102.694469,4.19744318 102.578756,4.29947004 102.441888,4.37412496 C102.305021,4.44877989 102.151981,4.49979332 101.982763,4.52716679 C101.813545,4.55454026 101.639353,4.56822679 101.460181,4.56822679 L101.460181,5.07587772 L102.833825,5.07587772 L102.833825,8.8683288 L103.468388,8.8683288 Z M106.409516,5.83735412 L106.409516,5.00868863 L105.58085,5.00868863 L105.58085,5.83735412 L106.409516,5.83735412 Z M105.58085,8.03966331 L105.58085,8.8683288 L106.409516,8.8683288 L106.409516,8.03966331 L105.58085,8.03966331 Z M107.364832,5.44915047 L107.999396,5.44915047 C107.994419,5.28988663 108.010594,5.13186942 108.047921,4.97509408 C108.085249,4.81831874 108.146216,4.67772075 108.230825,4.55329588 C108.315434,4.42887101 108.423682,4.32808838 108.555572,4.25094496 C108.687463,4.17380154 108.84548,4.13523041 109.029629,4.13523041 C109.168984,4.13523041 109.300873,4.15762655 109.425298,4.2024195 C109.549723,4.24721245 109.657971,4.31191242 109.750045,4.39652133 C109.842119,4.48113024 109.915529,4.58191287 109.970276,4.69887225 C110.025023,4.81583163 110.052396,4.94647578 110.052396,5.09080863 C110.052396,5.27495744 110.023779,5.43670734 109.966543,5.5760632 C109.909308,5.71541905 109.8247,5.84481898 109.712718,5.96426685 C109.600735,6.08371473 109.460137,6.20191658 109.290919,6.31887596 C109.121702,6.43583534 108.925113,6.56399103 108.701149,6.70334689 C108.517,6.81284077 108.340319,6.9297984 108.171101,7.05422327 C108.001883,7.17864814 107.850087,7.32297882 107.715708,7.48721965 C107.58133,7.65146048 107.470593,7.84431613 107.383496,8.0657924 C107.296398,8.28726867 107.240408,8.55477813 107.215523,8.8683288 L110.672029,8.8683288 L110.672029,8.30841969 L107.954603,8.30841969 C107.984465,8.14417886 108.047921,7.99860394 108.144972,7.87169058 C108.242024,7.74477721 108.358981,7.62657535 108.495849,7.51708147 C108.632716,7.40758758 108.783268,7.30431649 108.947509,7.20726509 C109.111749,7.11021369 109.275988,7.01191952 109.440229,6.91237962 C109.604469,6.80786273 109.763731,6.69837049 109.918018,6.58389961 C110.072304,6.46942873 110.20917,6.34127303 110.328618,6.19942868 C110.448066,6.05758433 110.543871,5.89707866 110.616038,5.71790684 C110.688204,5.53873503 110.724287,5.33219284 110.724287,5.09827409 C110.724287,4.84942435 110.680739,4.63043986 110.593641,4.44131406 C110.506544,4.25218825 110.388342,4.09417104 110.239032,3.96725767 C110.089722,3.8403443 109.914286,3.74329436 109.712718,3.67610493 C109.511149,3.6089155 109.295898,3.57532129 109.066956,3.57532129 C108.788244,3.57532129 108.539398,3.62260203 108.32041,3.71716493 C108.101423,3.81172784 107.918521,3.94237199 107.771699,4.10910132 C107.624878,4.27583064 107.51663,4.47366322 107.446952,4.70260498 C107.377274,4.93154674 107.349901,5.18039275 107.364832,5.44915047 Z M112.172323,6.26288505 C112.172323,6.13348318 112.173567,5.99039673 112.176056,5.83362139 C112.178544,5.67684606 112.190987,5.52007307 112.213383,5.36329774 C112.23578,5.2065224 112.26813,5.0534821 112.310434,4.90417226 C112.352739,4.75486242 112.41495,4.62421826 112.497071,4.51223588 C112.579191,4.4002535 112.682462,4.3094247 112.806887,4.23974678 C112.931312,4.17006885 113.083108,4.13523041 113.26228,4.13523041 C113.441451,4.13523041 113.593248,4.17006885 113.717672,4.23974678 C113.842097,4.3094247 113.945368,4.4002535 114.027489,4.51223588 C114.109609,4.62421826 114.171821,4.75486242 114.214125,4.90417226 C114.25643,5.0534821 114.28878,5.2065224 114.311176,5.36329774 C114.333573,5.52007307 114.346015,5.67684606 114.348503,5.83362139 C114.350992,5.99039673 114.352236,6.13348318 114.352236,6.26288505 C114.352236,6.46196484 114.346015,6.68468202 114.333572,6.93104326 C114.32113,7.1774045 114.281315,7.40883129 114.214125,7.62533056 C114.146936,7.84182984 114.038688,8.02473165 113.889378,8.1740415 C113.740068,8.32335134 113.531037,8.39800515 113.26228,8.39800515 C112.993522,8.39800515 112.784491,8.32335134 112.635181,8.1740415 C112.485872,8.02473165 112.377624,7.84182984 112.310434,7.62533056 C112.243245,7.40883129 112.203429,7.1774045 112.190987,6.93104326 C112.178544,6.68468202 112.172323,6.46196484 112.172323,6.26288505 Z M111.500432,6.2703505 C111.500432,6.4644533 111.505409,6.66601857 111.515363,6.87505235 C111.525317,7.08408613 111.550202,7.28813986 111.590018,7.48721965 C111.629834,7.68629944 111.687068,7.87417818 111.761723,8.05086149 C111.836378,8.22754481 111.938405,8.38307356 112.067807,8.51745242 C112.197209,8.65183128 112.360203,8.75759084 112.556794,8.83473426 C112.753385,8.91187768 112.988545,8.95044881 113.26228,8.95044881 C113.540991,8.95044881 113.777395,8.91187768 113.971498,8.83473426 C114.165601,8.75759084 114.327351,8.65183128 114.456752,8.51745242 C114.586154,8.38307356 114.688181,8.22754481 114.762836,8.05086149 C114.837491,7.87417818 114.894726,7.68629944 114.934542,7.48721965 C114.974358,7.28813986 114.999242,7.08408613 115.009196,6.87505235 C115.01915,6.66601857 115.024127,6.4644533 115.024127,6.2703505 C115.024127,6.07624771 115.01915,5.87468244 115.009196,5.66564866 C114.999242,5.45661488 114.974358,5.25256115 114.934542,5.05348136 C114.894726,4.85440157 114.837491,4.6652786 114.762836,4.48610679 C114.688181,4.30693497 114.586154,4.15016199 114.456752,4.01578313 C114.327351,3.88140427 114.164356,3.77440049 113.967765,3.69476857 C113.771174,3.61513665 113.536014,3.57532129 113.26228,3.57532129 C112.988545,3.57532129 112.753385,3.61513665 112.556794,3.69476857 C112.360203,3.77440049 112.197209,3.88140427 112.067807,4.01578313 C111.938405,4.15016199 111.836378,4.30693497 111.761723,4.48610679 C111.687068,4.6652786 111.629834,4.85440157 111.590018,5.05348136 C111.550202,5.25256115 111.525317,5.45661488 111.515363,5.66564866 C111.505409,5.87468244 111.500432,6.07624771 111.500432,6.2703505 Z M118.704073,6.09117959 L118.704073,4.13523041 L120.092647,4.13523041 C120.495784,4.13523041 120.790666,4.21859382 120.977304,4.38532315 C121.163941,4.55205247 121.257258,4.79467733 121.257258,5.113205 C121.257258,5.43173266 121.163941,5.67560175 120.977304,5.84481958 C120.790666,6.0140374 120.495784,6.09615658 120.092647,6.09117959 L118.704073,6.09117959 Z M117.994854,3.53799402 L117.994854,8.8683288 L118.704073,8.8683288 L118.704073,6.68841598 L120.331542,6.68841598 C120.869057,6.69339297 121.27592,6.55652767 121.552144,6.27781596 C121.828367,5.99910425 121.966476,5.61090448 121.966476,5.113205 C121.966476,4.61550552 121.828367,4.22854997 121.552144,3.95232676 C121.27592,3.67610355 120.869057,3.53799402 120.331542,3.53799402 L117.994854,3.53799402 Z M122.847138,3.53799402 L122.847138,8.8683288 L123.519029,8.8683288 L123.519029,4.4338486 L123.53396,4.4338486 L125.198757,8.8683288 L125.803458,8.8683288 L127.468255,4.4338486 L127.483186,4.4338486 L127.483186,8.8683288 L128.155077,8.8683288 L128.155077,3.53799402 L127.184568,3.53799402 L125.497375,8.01726695 L123.817647,3.53799402 L122.847138,3.53799402 Z',
        fill: '#000000'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { id: 'Battery-Icon', fill: '#000000', transform: 'translate(211.197719, 3.425269)' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          id: 'Shape',
          d: 'M0.30608365,0.934202413 L0.30608365,0.934202413 L0.30608365,4.98217213 C0.30608365,5.32737525 0.579852964,5.60498641 0.919755871,5.60498641 L12.8540084,5.60498641 C13.1927785,5.60498641 13.4676806,5.32585712 13.4676806,4.98217213 L13.4676806,0.934202413 C13.4676806,0.588999297 13.1939113,0.311388134 12.8540084,0.311388134 L0.919755871,0.311388134 C0.580985766,0.311388134 0.30608365,0.590517417 0.30608365,0.934202413 L0.30608365,0.934202413 Z M0,0.934202413 C0,0.418256667 0.412221405,0 0.919755871,0 L12.8540084,0 C13.3619755,0 13.7737643,0.416027969 13.7737643,0.934202413 L13.7737643,4.98217213 C13.7737643,5.49811788 13.3615429,5.91637454 12.8540084,5.91637454 L0.919755871,5.91637454 C0.41178873,5.91637454 0,5.50034657 0,4.98217213 L0,0.934202413 L0,0.934202413 Z'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          id: 'Shape',
          d: 'M0.917190317,0.622776268 C0.748730757,0.622776268 0.6121673,0.757527622 0.6121673,0.929241945 L0.6121673,4.9871326 C0.6121673,5.15638892 0.746786911,5.29359827 0.917190317,5.29359827 L9.18250951,5.29359827 L9.18250951,0.622776268 L0.917190317,0.622776268 Z M14.0798479,1.8683288 L14.5389734,1.8683288 C14.7925414,1.8683288 14.9980989,2.06948432 14.9980989,2.3305907 L14.9980989,3.58578384 C14.9980989,3.84108404 14.7851256,4.04804574 14.5389734,4.04804574 L14.0798479,4.04804574 L14.0798479,1.8683288 Z'
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        id: '42%',
        d: 'M198.775202,4.20988496 L198.775202,3.66490675 L195.348558,3.66490675 L195.348558,4.26214314 L198.125707,4.26214314 C197.846995,4.55578583 197.586951,4.87679718 197.345567,5.22518682 C197.104183,5.57357646 196.89142,5.94311278 196.707271,6.33380687 C196.523122,6.72450096 196.37257,7.13260841 196.255611,7.55814147 C196.138651,7.98367453 196.065242,8.42039927 196.03538,8.8683288 L196.744598,8.8683288 C196.769483,8.45523823 196.83916,8.02971156 196.953631,7.59173602 C197.068102,7.15376047 197.216165,6.7282338 197.397825,6.31514323 C197.579486,5.90205266 197.787272,5.51385289 198.021191,5.15053227 C198.25511,4.78721165 198.506444,4.47366568 198.775202,4.20988496 Z M202.925733,4.20988496 L202.925733,3.66490675 L199.499089,3.66490675 L199.499089,4.26214314 L202.276238,4.26214314 C201.997527,4.55578583 201.737482,4.87679718 201.496098,5.22518682 C201.254714,5.57357646 201.041951,5.94311278 200.857802,6.33380687 C200.673653,6.72450096 200.523101,7.13260841 200.406142,7.55814147 C200.289182,7.98367453 200.215773,8.42039927 200.185911,8.8683288 L200.895129,8.8683288 C200.920014,8.45523823 200.989691,8.02971156 201.104162,7.59173602 C201.218633,7.15376047 201.366696,6.7282338 201.548356,6.31514323 C201.730017,5.90205266 201.937803,5.51385289 202.171722,5.15053227 C202.405641,4.78721165 202.656975,4.47366568 202.925733,4.20988496 Z M204.523078,5.07587772 C204.523078,4.96140684 204.530544,4.84071653 204.545475,4.71380316 C204.560406,4.58688979 204.591511,4.46993217 204.638793,4.36292678 C204.686074,4.25592139 204.752019,4.16633683 204.836627,4.09417041 C204.921236,4.02200398 205.033217,3.98592131 205.172573,3.98592131 C205.316906,3.98592131 205.430131,4.02200398 205.512251,4.09417041 C205.594372,4.16633683 205.657827,4.25592139 205.70262,4.36292678 C205.747413,4.46993217 205.77603,4.58688979 205.788473,4.71380316 C205.800915,4.84071653 205.807137,4.95891838 205.807137,5.06841227 C205.807137,5.18288315 205.799671,5.30481769 205.78474,5.43421956 C205.769809,5.56362142 205.738704,5.68182328 205.691422,5.78882866 C205.644141,5.89583405 205.578196,5.98417438 205.493588,6.05385231 C205.408979,6.12353024 205.294509,6.15836868 205.150177,6.15836868 C205.010821,6.15836868 204.900084,6.12228601 204.817964,6.05011958 C204.735843,5.97795316 204.672388,5.8883686 204.627595,5.78136321 C204.582802,5.67435782 204.554184,5.5574002 204.541742,5.43048683 C204.5293,5.30357346 204.523078,5.18537161 204.523078,5.07587772 Z M203.963169,5.09080863 C203.963169,5.29486542 203.984321,5.48647685 204.026626,5.66564866 C204.06893,5.84482047 204.137363,6.00159346 204.231926,6.13597232 C204.326489,6.27035118 204.450912,6.37611073 204.605198,6.45325415 C204.759485,6.53039757 204.948608,6.5689687 205.172573,6.5689687 C205.391561,6.5689687 205.575707,6.52666488 205.725017,6.44205597 C205.874326,6.35744705 205.997505,6.24671058 206.094557,6.10984322 C206.191608,5.97297587 206.261285,5.81371442 206.303589,5.63205411 C206.345894,5.4503938 206.367046,5.26251506 206.367046,5.06841227 C206.367046,4.86435548 206.348382,4.67149982 206.311055,4.48983951 C206.273727,4.3081792 206.209027,4.15016199 206.116953,4.01578313 C206.024879,3.88140427 205.902944,3.77440049 205.751146,3.69476857 C205.599347,3.61513665 205.406492,3.57532129 205.172573,3.57532129 C204.943631,3.57532129 204.75202,3.61638088 204.597733,3.6985013 C204.443446,3.78062171 204.319023,3.89135818 204.22446,4.03071404 C204.129897,4.17006989 204.062709,4.33057557 204.022893,4.51223588 C203.983077,4.69389619 203.963169,4.88675185 203.963169,5.09080863 Z M208.211013,7.46482328 C208.211013,7.3503524 208.218478,7.22966209 208.233409,7.10274872 C208.24834,6.97583536 208.279446,6.85887773 208.326728,6.75187234 C208.374009,6.64486696 208.439953,6.55528239 208.524562,6.48311597 C208.609171,6.41094954 208.721152,6.37486687 208.860508,6.37486687 C209.004841,6.37486687 209.118065,6.41094954 209.200186,6.48311597 C209.282306,6.55528239 209.345762,6.64486696 209.390555,6.75187234 C209.435348,6.85887773 209.463965,6.97583536 209.476408,7.10274872 C209.48885,7.22966209 209.495071,7.34786394 209.495071,7.45735783 C209.495071,7.57182871 209.487606,7.69376325 209.472675,7.82316512 C209.457744,7.95256698 209.426638,8.07076884 209.379357,8.17777423 C209.332075,8.28477961 209.266131,8.37311995 209.181522,8.44279787 C209.096913,8.5124758 208.982444,8.54731424 208.838111,8.54731424 C208.698755,8.54731424 208.588019,8.51123157 208.505899,8.43906515 C208.423778,8.36689872 208.360322,8.27731416 208.315529,8.17030877 C208.270736,8.06330338 208.242119,7.94634576 208.229677,7.81943239 C208.217234,7.69251902 208.211013,7.57431717 208.211013,7.46482328 Z M207.651104,7.47975419 C207.651104,7.68381098 207.672256,7.87542241 207.71456,8.05459422 C207.756865,8.23376603 207.825297,8.38929479 207.91986,8.52118515 C208.014423,8.65307551 208.138846,8.75759084 208.293133,8.83473426 C208.44742,8.91187768 208.636543,8.95044881 208.860508,8.95044881 C209.079495,8.95044881 209.263641,8.90938922 209.412951,8.8272688 C209.562261,8.74514839 209.68544,8.63565614 209.782491,8.49878879 C209.879543,8.36192143 209.94922,8.20265998 209.991524,8.02099967 C210.033829,7.83933936 210.05498,7.65146063 210.05498,7.45735783 C210.05498,7.25330104 210.036317,7.06044539 209.99899,6.87878508 C209.961662,6.69712477 209.896962,6.53910755 209.804888,6.40472869 C209.712813,6.27034983 209.590879,6.16334605 209.43908,6.08371413 C209.287282,6.00408221 209.094426,5.96426685 208.860508,5.96426685 C208.631566,5.96426685 208.439954,6.00532644 208.285668,6.08744686 C208.131381,6.16956727 208.006958,6.28030375 207.912395,6.4196596 C207.817832,6.55901546 207.750644,6.71952113 207.710828,6.90118144 C207.671012,7.08284175 207.651104,7.27569741 207.651104,7.47975419 Z M208.696268,3.47827038 L204.679853,9.02510336 L205.321882,9.02510336 L209.330831,3.47827038 L208.696268,3.47827038 Z',
        fill: '#000000'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        id: 'Bluetooth',
        d: 'M190.971484,4.66341953 L188.401228,2.17971694 L188.241445,2.17971694 L188.241445,5.60498641 L186.59558,3.81258484 L186.098859,4.3293743 L188.197719,6.38376806 L186.098859,8.43816182 L186.59558,8.95463997 L188.241445,7.16192708 L188.241445,10.5871965 L188.451266,10.5871965 L190.996198,8.09695625 L189.248826,6.38376806 L190.971484,4.66341953 Z M188.853612,5.60498641 L188.853612,3.73665761 L189.939215,4.67082201 L188.853612,5.60498641 Z M188.853612,7.16192708 L189.951956,8.09609148 L188.853612,9.03025588 L188.853612,7.16192708 Z',
        fill: '#000000',
        opacity: '0.45'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StatusBarSVG);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground__);



var settings = {
  defaultsLogosBaseUrl: 'https://cdn2.auth0.com/website/playground/'
};
var LockPlayground = function LockPlayground() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground___default.a, settings);
};

/* harmony default export */ __webpack_exports__["a"] = (LockPlayground);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LockPlayground__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LockPlayground__["a"]; });



/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground__);



var settings = {
  defaultsLogosBaseUrl: 'https://cdn2.auth0.com/website/playground/'
};
var LockPlaygroundHomepage = function LockPlaygroundHomepage() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_auth0_lock_playground___default.a, settings);
};

/* harmony default export */ __webpack_exports__["a"] = (LockPlaygroundHomepage);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LockPlaygroundHomepage__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LockPlaygroundHomepage__["a"]; });



/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(58);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PromiseStateContainer = function (_Component) {
  _inherits(PromiseStateContainer, _Component);

  function PromiseStateContainer() {
    _classCallCheck(this, PromiseStateContainer);

    return _possibleConstructorReturn(this, (PromiseStateContainer.__proto__ || Object.getPrototypeOf(PromiseStateContainer)).apply(this, arguments));
  }

  _createClass(PromiseStateContainer, [{
    key: 'isEmptyObject',
    value: function isEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ps = _props.ps,
          onPending = _props.onPending,
          onNoResults = _props.onNoResults,
          onRejection = _props.onRejection,
          onFulFillment = _props.onFulFillment;


      if (ps.pending) {
        return onPending(ps.meta);
      }

      if (ps.rejected) {
        return onRejection(ps.reason, ps.meta);
      }

      if (ps.fulfilled && this.isEmptyObject(ps.value)) {
        return onNoResults(ps.value, ps.meta);
      }

      if (ps.fulfilled) {
        return onFulFillment(ps.value, ps.meta);
      }

      return null;
    }
  }]);

  return PromiseStateContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PromiseStateContainer.propTypes = {
  ps: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]).isRequired,
  onPending: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNoResults: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRejection: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onFulFillment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};
PromiseStateContainer.defaultProps = {
  onPending: function onPending() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Loader */], { size: 'large' });
  },
  onNoResults: function onNoResults() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
  },
  onRejection: function onRejection(_ref) {
    var cause = _ref.cause;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { className: 'rejection-message' },
      cause.message
    );
  }
};


/* harmony default export */ __webpack_exports__["a"] = (PromiseStateContainer);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PromiseStateContainer__ = __webpack_require__(556);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PromiseStateContainer__["a"]; });



/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie_dough__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookie_dough___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookie_dough__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var COOKIE_NAME = 'ajs_ab.traits';

var CookieMetrics = function () {
  function CookieMetrics(req) {
    _classCallCheck(this, CookieMetrics);

    // eslint-disable-next-line new-cap
    this.cookie = req ? new __WEBPACK_IMPORTED_MODULE_1_cookie_dough___default.a(req) : __WEBPACK_IMPORTED_MODULE_1_cookie_dough___default()();
    this.variants = {};
    this.server = !!req;
    this.load();
  }

  _createClass(CookieMetrics, [{
    key: 'prepare',
    value: function prepare() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve().then(function () {
        return _this.load();
      });
    }
  }, {
    key: 'getCurrentVariantName',
    value: function getCurrentVariantName(variantName) {
      return this.variants[variantName];
    }
  }, {
    key: 'setCurrentVariantName',
    value: function setCurrentVariantName(variantName, value) {
      this.variants[variantName] = value;
      if (!this.server) {
        this.save();
      }
    }
  }, {
    key: 'load',
    value: function load() {
      if (!this.cookie || this.loaded) {
        return;
      }

      try {
        this.variants = JSON.parse(this.cookie.get(COOKIE_NAME) || '{}');
      } catch (e) {
        this.variants = {};
      }

      this.loaded = true;
    }
  }, {
    key: 'save',
    value: function save() {
      if (!this.cookie) {
        return;
      }

      this.cookie.set(COOKIE_NAME, JSON.stringify(this.variants), {
        maxAge: 31536000000,
        path: '/'
      });
    }
  }]);

  return CookieMetrics;
}();

/* harmony default export */ __webpack_exports__["a"] = (CookieMetrics);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(561);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





// Extends page.exit to support full ab but also maintains compatibility with
// default page.exit behavior:
//   1. page.exit(path, callback[, callback ...])
//      https://visionmedia.github.io/page.js/#pageexitpath-callback-callback-
//   2. page.exit(callback)
//      https://visionmedia.github.io/page.js/#pageexitcallback
/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var pageExitArgs = convertToPageExit(args);
  __WEBPACK_IMPORTED_MODULE_0_page___default.a.exit.apply(__WEBPACK_IMPORTED_MODULE_0_page___default.a, _toConsumableArray(pageExitArgs));
});

function convertToPageExit(args) {
  var getAbExitArgs = isAbExit(args);
  var getNormalExitArgs = isNormalExit(args);
  var getShorthandExitArgs = isShorthandExit(args);

  // page.exit(abVariation, path, callback[, callback ...])
  if (getAbExitArgs) {
    return getAbExitArgs();
  }

  // page.exit(path, callback[, callback ...])
  if (getNormalExitArgs) {
    return getNormalExitArgs();
  }

  // page.exit(callback)
  if (getShorthandExitArgs) {
    return getShorthandExitArgs();
  }

  // It never should arrive to here
  return new Error('page.exit cannot be called without params.');
}

// page.exit(abVariation, path, callback[, callback ...])
function isAbExit(args) {
  var isAb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isString"])(args[0]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isString"])(args[1]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isFunction"])(args[2]);

  if (!isAb) return null;

  return function () {
    var variantName = args[0];
    var path = args[1];
    var callbacks = args.slice(2);
    var newCallbacks = callbacks.map(function (callback) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */])(callback, variantName);
    });
    var pageExitArgs = [path].concat(_toConsumableArray(newCallbacks));

    return pageExitArgs;
  };
}

// page.exit(path, callback[, callback ...])
function isNormalExit(args) {
  var isNormal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isString"])(args[0]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isFunction"])(args[1]);

  if (!isNormal) return null;

  return function () {
    var variantName = 'original';
    var path = args[0];
    var callbacks = args.slice(1);
    var newCallbacks = callbacks.map(function (callback) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */])(callback, variantName);
    });
    var pageExitArgs = [path].concat(_toConsumableArray(newCallbacks));

    return pageExitArgs;
  };
}

// page.exit(callback)
function isShorthandExit(args) {
  var isShorthand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isFunction"])(args[0]);

  if (!isShorthand) return null;

  return function () {
    return args;
  };
}

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);
/* eslint-env browser */



var config = window.APP_CONFIG;

function pageVariant() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var variantName = args.splice(0, 1)[0];
  var pageArgs = args.map(function (arg) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(arg)) {
      return arg;
    }

    return function (ctx, next) {
      if (ctx.winningFullPageVariantName === variantName) {
        return arg.call(arg, ctx, next);
      }

      return next();
    };
  });

  __WEBPACK_IMPORTED_MODULE_1_page___default.a.apply(__WEBPACK_IMPORTED_MODULE_1_page___default.a, pageArgs);
}

function pageVariantStub(_) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_page___default.a.apply(__WEBPACK_IMPORTED_MODULE_1_page___default.a, args);
}

/* harmony default export */ __webpack_exports__["a"] = (config.disable_analytics ? pageVariantStub : pageVariant);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = abPagejsCallback;
function abPagejsCallback(originalCallback, variantName) {
  return function (ctx, next) {
    return callOriginalCallbackOrIgnore(originalCallback, variantName, ctx, next);
  };
}

function callOriginalCallbackOrIgnore(originalCallback, variantName, ctx, next) {
  if (ctx.winningFullPageVariantName === variantName) {
    return originalCallback.call(originalCallback, ctx, next);
  }

  return next();
}

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth0_web_header__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth0_web_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__auth0_web_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_loggedin__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_boot_sso__ = __webpack_require__(216);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      logged: false,
      theme: 'dark',
      showLock: function showLock() {},
      showContactForm: function showContactForm() {}
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      /* eslint-env browser */

      this.createContactForm();

      this.setState({
        login: __WEBPACK_IMPORTED_MODULE_5_modules_boot_sso__["a" /* login */],
        signup: function signup() {
          return window.signup();
        },
        showContactForm: function showContactForm() {
          return _this2.contactForm.show({ includePhoneField: true });
        }
      });

      __WEBPACK_IMPORTED_MODULE_4_modules_loggedin__["a" /* default */].onChange(function (logged) {
        if (document.getElementsByClassName('login-link').length) {
          return;
        }

        _this2.setState({ logged: logged });
      });
    }
  }, {
    key: 'createContactForm',
    value: function createContactForm() {
      /* eslint-env browser */

      var jQuery = window.jQuery;
      var metricsLib = window.metricsLib;
      var extendedOptions = window.APP_STATE.contactFormOptions;

      var contactFormOptions = {
        onModalOpen: function onModalOpen() {
          metricsLib.track('open:talk-to-sales');
        },
        onFormSuccess: function onFormSuccess(metricsData) {
          metricsLib.track('register:lead:talk-to-sales-modal', metricsData);
          metricsLib.track('sent:talk-to-sales', metricsData);
        },
        onFormFail: function onFormFail(metricsData) {
          metricsLib.track('fail:register:lead:talk-to-sales-modal', metricsData);
          metricsLib.track('fail-sent:talk-to-sales', metricsData);
        }
      };
      this.contactForm = new __WEBPACK_IMPORTED_MODULE_3_auth0_contact_form___default.a(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["assign"])({}, contactFormOptions, extendedOptions));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          logged = _state.logged,
          login = _state.login,
          signup = _state.signup,
          showContactForm = _state.showContactForm;
      var _props = this.props,
          featuredLink = _props.featuredLink,
          featuredTitle = _props.featuredTitle,
          featuredDescription = _props.featuredDescription,
          featuredCTA = _props.featuredCTA,
          featuredIconColor = _props.featuredIconColor,
          talkToSalesButtonText = _props.talkToSalesButtonText;

      var theme = this.props.theme || this.state.theme;
      var HeaderProps = {
        logged: logged,
        theme: theme,
        login: login,
        signup: signup,
        showContactForm: showContactForm,
        featuredLink: featuredLink,
        featuredTitle: featuredTitle,
        featuredDescription: featuredDescription,
        featuredCTA: featuredCTA,
        featuredIconColor: featuredIconColor,
        talkToSalesButtonText: talkToSalesButtonText
      };
      var Auth0WebHeaderProps = toAuth0WebHeaderProps(HeaderProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__auth0_web_header___default.a, Auth0WebHeaderProps);
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Header.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  featuredLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  featuredTitle: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  featuredDescription: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  featuredCTA: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  featuredIconColor: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  talkToSalesButtonText: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

Header.checkThemeFromHTMLClass = function () {
  var html = document.documentElement;
  var htmlHasClass = function htmlHasClass(className) {
    return html.classList.contains(className);
  };
  var isDarkTheme = htmlHasClass('header-dark') || htmlHasClass('theme-dark');

  return isDarkTheme ? 'dark' : 'light';
};

function toAuth0WebHeaderProps(props) {
  var Auth0WebHeaderProps = {
    theme: props.theme,
    talkToSalesButtonLink: null,
    talkToSalesButtonOnClick: props.showContactForm,
    className: 'site-header-v2',
    loginButtonOnClick: props.login,
    featuredLink: props.featuredLink,
    featuredTitle: props.featuredTitle,
    featuredDescription: props.featuredDescription,
    featuredCTA: props.featuredCTA,
    featuredIconColor: props.featuredIconColor,
    talkToSalesButtonText: props.talkToSalesButtonText
  };

  if (props.logged) {
    Auth0WebHeaderProps.signupButtonLink = 'https://manage.auth0.com';
  } else {
    Auth0WebHeaderProps.signupButtonOnClick = props.signup;
  }

  return Auth0WebHeaderProps;
}

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spectrum_colorpicker__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spectrum_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_spectrum_colorpicker__);
/* eslint-env jquery, browser */
/* global Auth0LockPasswordless */



/* Export InteractiveWidget */
/* harmony default export */ __webpack_exports__["a"] = (InteractiveWidget);

/*
 * InteractiveWidget
 */

function InteractiveWidget(selector, type, lockContainer) {
  if (!$.fn.spectrum) {
    throw new Error('InteractiveWidget requires `Spectrum` plugin to fully work.');
  }

  var self = this;
  // Get metrics instance
  this.metrics = __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */] : null;
  // Get handle of main selectors
  this.selector = selector;
  this.$selects = $(selector + ' .fake-select-cont');
  this.$selectOptions = this.$selects.find('.select-options');
  this.$iconInput = $(selector + ' .icon-input');
  this.disabledLIs = $(selector + ' [data-enable-criteria]');
  this.$loadOverlay = $(selector + ' .load-overlay') ? $(selector + ' .load-overlay') : undefined;
  // Define type of lock
  this.type = type ? type : 'lock';
  // Set basic state
  this.mainMethod = '';
  this.fieldsReady = false;
  // Init options and starting state depending on lock type
  this.options = {};
  // Set container for the lock instance
  this.options.container = lockContainer ? lockContainer : '';
  // Overriden getImage method with debounced one
  this.getImage = this.debounce(this.getImage, 150);
  // Keep track of total user interactions
  this.userActionsCount = 0;
  // Keep track of last submitted mode (signin or signup)
  this.currMode = '';
  if (this.type !== 'passwordless') throw new Error('Only passwordless type is allowed');
  this.mainLock = new Auth0LockPasswordless('FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3', 'pwdlessdemo.auth0.com');
  this.options.connections = ['google-oauth2', 'github'];
  this.colorSelector = '#passwordless-color';
  this.options.rememberLastLogin = false;
}

InteractiveWidget.prototype.debounce = function (func, wait, immediate) {
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

InteractiveWidget.prototype.init = function () {
  var self = this;
  this.initFields();
  this.getAllFields();
  this.setActiveOptions();
  if (this.type == 'lock') {
    this.mainLock[this.mainMethod](this.options, this.callbackFunc);
    this.onCloseLock();
  } else {
    this.mainLock[this.mainMethod](this.options);
    this.checkMagicLinkSuccess();
  }
  this.showFade();
  this.initColorPicker();
  this.loadFinished();
  this.bindEvents();
};

InteractiveWidget.prototype.checkMagicLinkSuccess = function () {
  var self = this;
  var hash = this.mainLock.parseHash(window.location.hash);
  var pwdLessTab = $('a[data-toggle="tab"][href="#interactive-passwordless-section"]');
  var lockContainer = $('#' + this.options.container);

  function onSuccess(profile) {
    var user = profile || { name: 'John Foo', email: 'foo@auth0.com' };
    pwdLessTab.tab('show');
    lockContainer.find('.auth0-lock').css('opacity', 0);
    self.addSuccessMessage(true, user, "You've finished testing interactive tutorial, nice!");
    setTimeout(function () {
      $('html').animate({
        scrollTop: $(self.selector).parent().offset().top - 100
      }, 750);
    }, 800);
    self.initFields();
    self.noTryLoginTooltip = true; // hide try tooltip
  }

  if (hash && hash.error) {
    console.log('InteractiveWidget: error on login from magiclink');
  } else if (hash && hash.id_token) {
    // use id_token for retrieving profile.
    localStorage.setItem('id_token', hash.id_token);
    // retrieve profile
    self.mainLock.getProfile(hash.id_token, function (err, profile) {
      if (err) {
        // handle err
      } else {
        // use user profile
        // succcess!
        onSuccess(profile);
      }
    });
  }
};

InteractiveWidget.prototype.loadFinished = function () {
  var self = this;
  if (this.$loadOverlay) {
    setTimeout(function () {
      self.$loadOverlay.addClass('ready-hide');
      if (self.type == 'lock' || self.type == 'passwordless') {
        setTimeout(function () {
          self.showTryLogin();
        }, 1200);
      }
    }, 1000);
  }
};

// This assumes we have the spectrum library with its js and css
InteractiveWidget.prototype.initColorPicker = function () {
  var self = this;
  $(this.colorSelector).spectrum({
    preferredFormat: 'hex',
    showInput: true,
    color: '#EA5323',
    replacerClassName: 'spectrum-color-picker',
    move: this.debounce(function (color) {
      self.options.primaryColor = color.toHexString();
      self.getAllFields(true);
    }, 150)
  });
};

InteractiveWidget.prototype.initFields = function () {
  // Calculate fields height to create dropdown behaviour
  this.zeroHeightField = false;
  var self = this;
  this.$selectOptions.each(function (i, el) {
    $(el).css('max-height', 'initial');
    var thisElHeight = $(el).outerHeight(true);
    if (thisElHeight == 0) {
      self.zeroHeightField = true;
    }
    $(el).attr('data-max-height', thisElHeight);
    $(el).css('max-height', 0);
  });
  if (!this.zeroHeightField) this.fieldsReady = true;
};

InteractiveWidget.prototype.dropdownEvent = function () {
  var self = this;
  this.$selects.on('click', function (e) {
    var $tar = $(e.target).closest('.fake-select-cont');
    if ($tar.closest('li').hasClass('lock-li-disabled')) return;
    var $tarOpts = $tar.find('.select-options');

    // If an option was clicked, go to that handler and close the dropdown
    if ($(e.target).hasClass('select-value')) {
      self.selectOptionHandler($(e.target));
      self.closeDropdown($tar, $tarOpts);
      return;
    }

    // General behaviour
    if ($tar.hasClass('open')) {
      // Close
      self.closeDropdown($tar, $tarOpts);
    } else {
      // Open
      self.openDropdown($tar, $tarOpts);
    }
  });
};

InteractiveWidget.prototype.openDropdown = function ($tar, $tarOpts) {
  if ($tar.is('.disabled')) return;

  this.closeAllDropdowns();
  $tar.addClass('open');
  $tarOpts.css('max-height', $tarOpts.data('max-height'));
};

InteractiveWidget.prototype.closeDropdown = function ($tar, $tarOpts) {
  $tar.removeClass('open');
  $tarOpts.css('max-height', 0);
};

InteractiveWidget.prototype.closeAllDropdowns = function () {
  this.$selects.removeClass('open');
  this.$selects.find('.select-options').css('max-height', 0);
};

InteractiveWidget.prototype.selectOptionHandler = function ($tar) {
  var $select = $tar.closest('.fake-select-cont');
  $select.find('.select-value').removeAttr('data-selected');
  $tar.attr('data-selected', '');

  // disable allowLogin select and set it to true if initial screen is
  // login, and enable it otherwise
  var $allowLoginSelect = this.$selects.filter('[data-name="allowLogin"]');
  if ($select.attr('data-name') == 'initialScreen' && $tar.data('value') === 'login') {
    $allowLoginSelect.addClass('disabled');
    $allowLoginSelect.find('[data-value="true"]').attr('data-selected', '');
    $allowLoginSelect.find('[data-value="false"]').removeAttr('data-selected');
  } else {
    $allowLoginSelect.removeClass('disabled');
  }

  this.setActiveOptions();
  if ($select.attr('data-name') == 'icon') {
    this.iconInputUsed = false;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */]) {
    __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('click:interactive:options');
  }

  this.getAllFields(true);
  this.userActionsCount += 1;
  if (this.userActionsCount >= 3 && !this.userDisplayedTryMsg) {
    this.showTryPasswordless();
    this.userDisplayedTryMsg = true;
  }
};

InteractiveWidget.prototype.inputHandler = function () {
  var self = this;
  this.$iconInput.on('input', function () {
    self.iconImgUrl = self.$iconInput.val();
    self.getImage(self.iconImgUrl, function (err, success) {
      if (success) {
        self.iconInputUsed = true;
        self.options.icon = self.iconImgUrl;
        self.getAllFields(true);
      } else {
        console.log('err');
        delete self.options.icon;
        self.getAllFields(true);
      }
    });
  });
};

InteractiveWidget.prototype.getImage = function (url, callback) {
  var img = new Image();
  img.src = url;
  img.onload = function () {
    callback(null, true);
  };
  img.onerror = function (err) {
    callback(err);
  };
};

InteractiveWidget.prototype.closeAllEvent = function () {
  // TO-DO: Optimize this thoroughly by checking first if a dropdown is open.
  var self = this;
  $('body').on('click', function (e) {
    var $tar = $(e.target);
    if (!$tar.closest('.fake-select-cont').length) {
      // If it's not a select close all selects
      self.closeAllDropdowns();
    }
  });
};

InteractiveWidget.prototype.bindEvents = function () {
  this.dropdownEvent();
  this.closeAllEvent();
  this.inputHandler();
  this.autoDissmissTry();
  if (this.type == 'lock') {
    this.tabChangeEvent();
    this.enterpriseReady();
    this.onLoginError();
    this.onLoginSuccess();
    this.switchEvent();
    this.onSignupSubmit();
  }
};

InteractiveWidget.prototype.setActiveOptions = function () {
  this.$selects.each(function (i, el) {
    var currOptVal = $(el).find('[data-selected]').attr('data-value');
    var currOpt = $(el).find('.current-option');
    if ($(el).attr('data-name') == 'dict') {
      currOpt.attr('data-value', currOptVal);
      currOptVal = currOptVal.toUpperCase();
    } else if ($(el).attr('data-name') == 'icon') {
      currOpt.attr('data-value', currOptVal);
    }
    currOpt.text(currOptVal);
  });
};

InteractiveWidget.prototype.toggleDisabled = function () {
  if (this.mainMethod == 'social') {
    this.disabledLIs.filter('[data-enable-criteria="social"]').removeClass('lock-li-disabled');
    this.disabledLIs.filter('[data-enable-criteria="non-social"]').addClass('lock-li-disabled');
  } else {
    this.disabledLIs.filter('[data-enable-criteria="social"]').addClass('lock-li-disabled');
    this.disabledLIs.filter('[data-enable-criteria="non-social"]').removeClass('lock-li-disabled');
  }
};

InteractiveWidget.prototype.showFade = function () {
  var self = this;
  $(this.selector).removeClass('a0-lock-ready');
  setTimeout(function () {
    $(self.selector).addClass('a0-lock-ready');
  }, 80);
};

InteractiveWidget.prototype.onCloseLock = function () {
  var self = this;
  this.mainLock.lock.on('close', function () {
    self.addCloseMessage();
    self.timer = setTimeout(function () {
      self.getAllFields(true);
    }, 3000);
  });
};

InteractiveWidget.prototype.onSignupSubmit = function () {
  var self = this;

  this.mainLock.lock.on('signup submit', function () {
    self.signupMailFieldValue = self.signupMailField.val();
  });
};

InteractiveWidget.prototype.onLoginSuccess = function () {
  var self = this;

  this.mainLock.lock.on('signin success', function () {
    self.currMode = 'signin';

    if (__WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */]) {
      __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('success:interactive:signin');
    }
  });

  this.mainLock.lock.on('signup success', function () {
    self.currMode = 'signup';

    self.callbackFunc();

    if (__WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */]) {
      __WEBPACK_IMPORTED_MODULE_0_modules_metrics__["a" /* default */].lib().track('success:interactive:signup');
    }
  });
};

InteractiveWidget.prototype.onLoginError = function () {
  var self = this;
  this.mainLock.lock.on('signin error', function () {
    // console.log('signin error event');
  });

  this.mainLock.lock.on('signup error', function () {
    // console.log('signup error event');
  });

  this.mainLock.lock.on('error shown', function () {
    // console.log('generic error event');
    setTimeout(function () {
      self.$errorMessage = $(self.selector + ' .a0-error');
      self.$errorMessage.show();
      setTimeout(function () {
        self.$errorMessage.addClass('error-slideUp');
        self.$errorMessage.on('transitionend', function () {
          self.$errorMessage.hide();
          self.$errorMessage.removeClass('error-slideUp');
        });
      }, 2500);
    }, 15);
  });
};

InteractiveWidget.prototype.showTryLogin = function (hide) {
  if (this.type == 'passwordless' && this.noTryLoginTooltip) return;
  var self = this;
  var appendTarget = $(this.selector);
  var msgCont = $('<div class="try-login"></div>');
  var msgString = '<span class="try-login-close">×</span><span>You can signup and login. <a href="#" class="try-login-btn">Try signing up first.</a></span>';

  if (hide && $('.try-login', appendTarget).length) {
    return $('.try-login', appendTarget).removeClass('ready');
  }

  msgCont.html(msgString);
  appendTarget.append(msgCont);
  this.tryLoginMessage = msgCont;
  setTimeout(function () {
    msgCont.addClass('ready');
  }, 100);
  msgCont.find('.try-login-btn').on('click', function (e) {
    e.preventDefault();
    // Here focus the email input
    // var a0switch = $(self.selector + ' .a0-switch span');
    // if (a0switch.length) a0switch.trigger('click');
    var emailInput = $('#a0-signup_easy_email');
    setTimeout(function () {
      if (emailInput.length) $('#a0-signup_easy_email').focus();
    }, 20);
    msgCont.removeClass('ready');
  });
  $('.try-login-close').on('click', function () {
    msgCont.removeClass('ready');
  });
};

InteractiveWidget.prototype.showTryPasswordless = function () {
  var self = this;
  var lockHeader = $(this.selector + ' .a0-header');
  var msgCont = $('<div class="try-passwordless"></div>');
  var msgString = '<span class="try-passwordless-close">×</span><span>Now that you\'ve tested the lock, you can try Passwordless<a href="#" class="try-passwordless-btn">Try it now!</a></span>';
  msgCont.html(msgString);
  lockHeader.append(msgCont);
  this.tryLoginMessage.removeClass('ready');
  this.tryPasswordlessMessage = msgCont;
  msgCont.addClass('ready');
  msgCont.find('.try-passwordless-btn').on('click', function (e) {
    e.preventDefault();
    $('a[data-toggle="tab"][href="#interactive-passwordless-section"]').tab('show');
    msgCont.removeClass('ready');
  });
  $('.try-passwordless-close').on('click', function () {
    msgCont.removeClass('ready');
  });
};

InteractiveWidget.prototype.autoDissmissTry = function () {
  var self = this;
  var btnSelector = self.type === 'lock' ? '.a0-next.a0-primary' : '.auth0-lock-submit';

  $(this.selector).on('click', btnSelector, function () {
    self.showTryLogin(true);
  });
};

InteractiveWidget.prototype.switchEvent = function () {
  var self = this;
  var a0switch = $(self.selector + ' .a0-switch span');
  // Check the switch exists or call again
  if (a0switch.length) {
    var tryLoginMsg = $(self.selector + ' .try-login');
    // Check the login message exists or call again
    if (tryLoginMsg.length) {
      a0switch.on('click', function (e) {
        if (tryLoginMsg.hasClass('ready')) {
          tryLoginMsg.removeClass('ready');
        }
      });
    } else {
      setTimeout(function () {
        self.switchEvent();
      }, 20);
    }
  } else {
    setTimeout(function () {
      self.switchEvent();
    }, 20);
  }
};

InteractiveWidget.prototype.addSuccessMessage = function (signup, profile, customMsg) {
  var self = this;
  var successContainer = $('<div class="success-cont"></div>');
  var userName = profile ? ' ' + profile.name : '';
  var userMail = profile ? ' ' + profile.email : '';
  var successMessage = '';

  if (signup) {
    successMessage = '<p class="success-message">Thanks for registering' + userName + '.</p>';
  } else {
    successMessage = '<p class="success-message">Thanks for logging in' + userName + '.</p><a href="#" class="success-try-passwordless-btn">Try Passwordless</a>';
  }

  if (customMsg) {
    successMessage = '<p class="success-message">' + customMsg + '</p>';
  }

  var checkmarkTemplate = '<svg width="56px" height="56px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="checkmark"><circle cx="26" cy="26" r="25" fill="none" class="checkmark__circle"></circle><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" class="checkmark__check"></path></svg>';

  successContainer.html(checkmarkTemplate + successMessage);

  var insertionPoint = $('#' + this.options.container);
  insertionPoint.css('height', '465px');
  insertionPoint.append(successContainer);
  $('.success-try-passwordless-btn').on('click', function (e) {
    e.preventDefault();
    $('a[data-toggle="tab"][href="#interactive-passwordless-section"]').tab('show');
  });
};

InteractiveWidget.prototype.addCloseMessage = function () {
  var closeContainer = $('<div class="close-cont"></div>');
  var closeMessage = '<p class="close-message">You closed the lock successfully.</p>';
  var checkmarkTemplate = '<svg width="56px" height="56px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="checkmark"><circle cx="26" cy="26" r="25" fill="none" class="checkmark__circle"></circle><path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" class="checkmark__check"></path></svg>';
  closeContainer.html(checkmarkTemplate + closeMessage);
  var insertionPoint = $('#' + this.options.container);
  insertionPoint.append(closeContainer);
};

InteractiveWidget.prototype.tabChangeEvent = function () {
  var self = this;

  this.mainLock.lock.on('signin ready', function () {
    self.signinEmailInput = $('#a0-signin_easy_email');
    self.signinPasswordInput = $('#a0-signin_easy_password');
    if (self.writeEmail) {
      self.signinEmailInput.val(self.signupMailFieldValue);
      self.signinPasswordInput.focus();
      self.writeEmail = !self.writeEmail;
    }
    self.showFade();
    self.centerEverything();
  });

  this.mainLock.lock.on('signup ready', function () {
    self.signupMailField = $('#a0-signup_easy_email');
    self.showFade();
    self.centerEverything();
  });

  this.mainLock.lock.on('reset ready', function () {
    self.showFade();
    self.centerEverything();
  });
};

InteractiveWidget.prototype.enterpriseReady = function () {
  var self = this;

  this.mainLock.lock.on('enterprise ready', function () {
    self.showFade();
    self.centerEverything();
  });
};

InteractiveWidget.prototype.centerEverything = function () {
  var self = this;
  // We need to wrap this in a timeout to allow the DOM to refresh (Better solutions are welcome)
  setTimeout(function () {
    if ($(self.selector + ' .a0-lock form').length || $(self.selector + ' .auth0-lock-content').length) {
      if (self.type == 'lock') {
        self.paddingTarget = $(self.selector + ' .a0-lock form');
        self.lockOuter = $(self.selector + ' .a0-lock');
      } else if (self.type == 'passwordless') {
        // self.paddingTarget = $(`${self.selector} .auth0-lock-content`);
        self.lockOuter = $(self.selector + ' .auth0-lock');
      }

      self.targetHeight = 465;
      self.diffHeight = self.targetHeight - self.lockOuter.height();

      // Leave this for debugging purposes
      // console.log(self.diffHeight + " = " + self.targetHeight + '-' + self.lockOuter.height() );

      // Only check its not 0, this works both for positive and negative values.
      // (in the case of a negative number, nothing can be done, it will just overflow)
      if (self.diffHeight) {
        var currPaddingTop = parseInt(self.paddingTarget.css('padding-top'));
        var currPaddingBottom = parseInt(self.paddingTarget.css('padding-bottom'));
        var totalPadTop = currPaddingTop + self.diffHeight / 2;
        var totalPadBottom = currPaddingBottom + self.diffHeight / 2;
        if (!(self.diffHeight % 2)) {
          // Even
          var totalPadTop = currPaddingTop + self.diffHeight / 2;
          var totalPadBottom = currPaddingBottom + self.diffHeight / 2;
          self.paddingTarget.css('padding-top', totalPadTop).css('padding-bottom', totalPadBottom);
        } else {
          // Odd
          var totalPadTop = currPaddingTop + (self.diffHeight - 1) / 2;
          var totalPadBottom = currPaddingBottom + (self.diffHeight - 1) / 2;
          self.paddingTarget.css('padding-top', totalPadTop).css('padding-bottom', totalPadBottom + 1);
        }
      }
    }
  }, 10);
};

InteractiveWidget.prototype.getAllFields = function (bool) {
  var self = this;
  this.$selects.each(function (i, el) {
    var elName = $(el).attr('data-name');
    var elVal = $(el).find('[data-selected]').attr('data-value');

    try {
      elVal = JSON.parse(elVal);
    } catch (e) {}

    if (elName == 'method') {
      self.mainMethod = elVal;
    } else if (elName == 'initialScreen') {
      self.mainMethod = 'show';
      var initialScreenModeMap = {
        login: 'signin',
        signUp: 'signup',
        forgotPassword: 'reset'
      };
      self.options.mode = initialScreenModeMap[elVal];
    } else if (elName == 'allowLogin') {
      self.options.disableSignupAction = !elVal;
    } else if (elName == 'icon') {
      if (!self.iconInputUsed) {
        self.options[elName] = '/pages/homepage/' + elVal;
      }
    } else {
      self.options[elName] = elVal;
    }
  });
  // Check all disabled and enabled lines according to their criteria
  this.toggleDisabled();

  // Manage exceptions according to lock type
  if (this.type == 'lock') {
    if (this.options.connections.indexOf('auth0') != -1) {
      this.options.connections.push('auth0.com');
    }
  }

  if (this.type == 'passwordless') {
    if (this.mainMethod == 'social') {
      this.options.popup = true;
    }
  }

  // If we get a true argument, then refresh the lock
  if (bool) {
    // Clear timers to avoid refreshing the lock in case the user interacts with it
    if (this.timer) {
      clearTimeout(self.timer);
    }
    if (this.type == 'passwordless') {
      this.mainLock.close();
      this.mainLock[this.mainMethod](this.options);
      this.showFade();
      this.centerEverything();
    } else if (this.type == 'lock') {
      this.mainLock[this.mainMethod](this.options, this.callbackFunc);
      $(this.selector).attr('data-lang', this.options.dict);
      this.showFade();
      this.centerEverything();
    } else {}
  }
  $(this.selector).removeClass('method-showSignin method-show method-showSignup method-showReset method-magiclink method-sms method-emailcode method-social');
  $(this.selector).addClass('method-' + this.mainMethod);
};

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hasLocaleVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = getClientLocale;
/* unused harmony export getServerLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_json__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_json__);


function hasLocaleVersion(path, locale) {
  var supportedLocales = __WEBPACK_IMPORTED_MODULE_0__config_json___default.a[path] || __WEBPACK_IMPORTED_MODULE_0__config_json___default.a[path + '/'];

  if (!supportedLocales || !locale || locale === 'en') {
    return false;
  }

  return supportedLocales.indexOf(locale) !== -1;
}

function getClientLocale() {
  /* eslint-env browser */
  var locale = window.__locale; // eslint-disable-line no-underscore-dangle
  return standardizeLocale(locale);
}

function getServerLocale(locals) {
  var locale = locals.locale;
  return standardizeLocale(locale);
}

function standardizeLocale(locale) {
  switch (locale) {
    case 'ja':
      return 'jp';
    default:
      return locale;
  }
}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locks_js__ = __webpack_require__(566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__locks_js__["a"]; });



/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* eslint-env browser */


var Auth0Lock = window.Auth0Lock;
var auth0IconUrl = 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png';

var AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
var AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;
var AUTH0_CALLBACK_URL = window.APP_CONFIG.AUTH0_CALLBACK_URL;

/**
 * Main Lock
 */
var main = {
  options: {
    auth: { redirectUrl: AUTH0_CALLBACK_URL },
    theme: {
      logo: auth0IconUrl
    },
    rememberLastLogin: true,
    integratedWindowsLogin: false,
    socialButtonStyle: 'big',
    languageDictionary: {
      // eslint-disable-next-line max-len
      signUpTerms: 'By signing up, you agree to our <a href="/terms" target="_new">terms of service</a> and <a href="/privacy" target="_new">privacy policy</a>',
      emailInputPlaceholder: 'Work email',
      passwordInputPlaceholder: 'Your password'
    }
  }
};
main.lock = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, main.options);
main.show = function () {
  main.lock.show({ initialScreen: 'login' });
};
main.signup = function (options) {
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])({}, main.options);

  if (options) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])(opts, options);
  }
  main.lock.show({ initialScreen: 'signUp' });
};

/* harmony default export */ __webpack_exports__["a"] = (main);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  description: 'The new way to solve Identity'
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = metas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_metas_defaults__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* eslint-env browser */




function metas(obj) {
  var _defaults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({}, __WEBPACK_IMPORTED_MODULE_1_modules_metas_defaults__["a" /* default */]);
  var _obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(_defaults, obj);

  for (var prop in _obj) {
    var meta = __WEBPACK_IMPORTED_MODULE_0_component_query___default()('meta[name=' + prop + ']');
    var title = __WEBPACK_IMPORTED_MODULE_0_component_query___default()('title');

    if (!_obj.hasOwnProperty(prop)) continue;
    if (!meta) meta = document.createElement('meta');
    meta.setAttribute('name', prop);
    meta.setAttribute('content', _obj[prop]);

    // asume title exists, and insert after it
    if (!meta.parentNode) {
      after(title, meta);
    }
  }
}

function after(node, meta) {
  if (!node.nextSibling) return node.parentNode.appendChild(meta);
  node.parentNode.insertBefore(meta, node.nextSibling);
}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* npm version only adapted from https://github.com/yields/empty */
/* harmony default export */ __webpack_exports__["a"] = (function (el, node) {
  while (node = el.firstChild) {
    el.removeChild(node);
  }return el;
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_inherit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(92);
/* eslint-env browser */



var ua = navigator.userAgent.toLowerCase();

/**
 * Creates an Chrome instance
 */

function Chrome() {
  if (!(this instanceof Chrome)) {
    return new Chrome();
  }

  this.name = 'Google Chrome';
  this.uaname = 'chrome';
  this.version = ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(this.uaname + '/')[1]) : false;
}

/**
 * Inherits Chrome from Query
 */

__WEBPACK_IMPORTED_MODULE_0_component_inherit___default()(Chrome, __WEBPACK_IMPORTED_MODULE_1__query__["a" /* default */]);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_inherit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(92);
/* eslint-env browser */



var ua = navigator.userAgent.toLowerCase();

/**
 * Creates an FF instance
 */

function FF() {
  if (!(this instanceof FF)) {
    return new FF();
  }

  this.name = 'Mozilla Firefox';
  this.uaname = 'firefox';
  this.version = ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(this.uaname + '/')[1]) : false;
}

/**
 * Inherits FF from Query
 */

__WEBPACK_IMPORTED_MODULE_0_component_inherit___default()(FF, __WEBPACK_IMPORTED_MODULE_1__query__["a" /* default */]);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IE;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_inherit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(92);
/* eslint-env browser */



var ua = navigator.userAgent.toLowerCase();

/**
 * Creates an IE instance
 */

function IE() {
  if (!(this instanceof IE)) {
    return new IE();
  }

  this.name = 'Internet Explorer';
  this.uaname = 'msie';
  this.version = ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(this.uaname)[1]) : false;
}

/**
 * Inherits IE from Query
 */

__WEBPACK_IMPORTED_MODULE_0_component_inherit___default()(IE, __WEBPACK_IMPORTED_MODULE_1__query__["a" /* default */]);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_inherit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(92);
/* eslint-env browser */



var ua = navigator.userAgent;

/**
 * Creates an Mac instance
 */

function MacOS() {
  if (!(this instanceof MacOS)) {
    return new MacOS();
  }

  this.name = 'Mac OS';
  this.uaname = 'mac os';
  var match = ua.match(/mac os ([^)]+)\)/i);
  this.version = match ? 'OS ' + match[1] : false;
}

/**
 * Inherits MacOS from Query
 */

__WEBPACK_IMPORTED_MODULE_0_component_inherit___default()(MacOS, __WEBPACK_IMPORTED_MODULE_1__query__["a" /* default */]);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_inherit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_inherit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__query__ = __webpack_require__(92);
/* eslint-env browser */



var ua = navigator.userAgent.toLowerCase();

/**
 * Creates an Safari instance
 */

function Safari() {
  if (!(this instanceof Safari)) {
    return new Safari();
  }

  this.name = 'Safari';
  this.uaname = 'safari';
  this.version = ua.indexOf('chrome') == -1 && ua.indexOf(this.uaname) != -1 ? parseInt(ua.split(this.uaname + '/')[1]) : false;
}

/**
 * Inherits Safari from Query
 */

__WEBPACK_IMPORTED_MODULE_0_component_inherit___default()(Safari, __WEBPACK_IMPORTED_MODULE_1__query__["a" /* default */]);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = metas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults_json__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__defaults_json__);
/* eslint-env browser */




var slice = Array.prototype.slice;

function metas(tags) {
  var title = __WEBPACK_IMPORTED_MODULE_1_component_query___default()('title');
  var ogs = slice.call(__WEBPACK_IMPORTED_MODULE_1_component_query___default.a.all('meta[property^="og:"],meta[property^="fb:"]'));
  var _defaults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])({}, __WEBPACK_IMPORTED_MODULE_2__defaults_json___default.a);
  var obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])(_defaults, tags);

  ogs.forEach(remove);
  Object.keys(obj).forEach(insertMetasFor(obj));
}

function remove(og) {
  og.parentNode.removeChild(og);
}

function insertMetasFor(obj) {
  return function insertMetaFor(tag) {
    var content = obj[tag];

    if (typeof content === 'string') {
      return insert(tag, content);
    }

    content.forEach(function (sub) {
      Object.keys(sub).forEach(function (prop) {
        insert(tag + ':' + prop, sub[prop]);
      });
    });
  };
}

function insert(prop, content) {
  var meta = document.createElement('meta');
  meta.setAttribute('property', prop);
  meta.setAttribute('content', content);
  after(__WEBPACK_IMPORTED_MODULE_1_component_query___default()('title'), meta);
}

function after(node, meta) {
  if (!node.nextSibling) return node.parentNode.appendChild(meta);
  node.parentNode.insertBefore(meta, node.nextSibling);
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_twittercard__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_opengraph__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_empty__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_title__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_metas__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_component_type__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_component_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_component_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_header__ = __webpack_require__(217);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var Section = function () {
  /**
   * Section constructor, classes are changed on the body
   * but the container is the specified to be rendering
   * the current view
   *
   * @param {Object} options
   * @api public
   */
  function Section(options) {
    _classCallCheck(this, Section);

    this.container = __WEBPACK_IMPORTED_MODULE_8_component_query___default()(options.container || 'body');
    this.classes = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(__WEBPACK_IMPORTED_MODULE_8_component_query___default()('html'));

    this.setMetadata = this.setMetadata.bind(this);
    this.append = this.append.bind(this);
    this.pagechange = this.pagechange.bind(this);
  }

  /**
   * Render section
   *
   * @param {Element|View} view
   * @param {Object} metadata
   * @api public
   */


  _createClass(Section, [{
    key: 'render',
    value: function render(_ref) {
      var view = _ref.view,
          metadata = _ref.metadata,
          append = _ref.append;

      __WEBPACK_IMPORTED_MODULE_7_modules_npm_component_bus__["a" /* default */].emit('page:change');

      this.setMetadata(metadata);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_modules_header__["a" /* default */])({ theme: __WEBPACK_IMPORTED_MODULE_9_modules_header__["b" /* Header */].checkThemeFromHTMLClass() });

      if (view) {
        if (!append) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_empty__["a" /* default */])(this.container);

        var parsedView = __WEBPACK_IMPORTED_MODULE_6_component_type___default()(view) !== 'array' ? [view] : view;
        parsedView.forEach(this.append, this);
      }

      // toggle loading flag by removing html's class
      this.classes.remove('auth0-website-loading');

      __WEBPACK_IMPORTED_MODULE_7_modules_npm_component_bus__["a" /* default */].emit('page:render');
    }
  }, {
    key: 'setMetadata',
    value: function setMetadata(metadata) {
      // set body classes
      (metadata.classes || []).forEach(this.classes.add, this.classes);

      // set page title
      if (__WEBPACK_IMPORTED_MODULE_6_component_type___default()(metadata.title) === 'array') {
        __WEBPACK_IMPORTED_MODULE_4_modules_title__["a" /* default */].apply(__WEBPACK_IMPORTED_MODULE_4_modules_title__["a" /* default */], metadata.title);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_title__["a" /* default */])(metadata.title);
      }

      // set page meta tags
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_metas__["a" /* default */])(metadata.metas || {});
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_opengraph__["a" /* default */])(metadata.opengraph || {});
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_twittercard__["a" /* default */])(metadata.twittercard || {});

      this.pagechange(metadata);
    }

    /**
     * Append `view.el` or `view` element to
     * `Section.container`
     *
     * @param {Element|View} view
     * @api private
     */

  }, {
    key: 'append',
    value: function append(view) {
      this.container.appendChild(view.el || view);
    }

    /**
     * Register a pagechange event, to erease custom
     * page settings when page is left and before
     * the next one renders
     *
     * @param {Object} opts
     * @api private
     */

  }, {
    key: 'pagechange',
    value: function pagechange(metadata) {
      __WEBPACK_IMPORTED_MODULE_7_modules_npm_component_bus__["a" /* default */].once('page:change', onpagechange.bind(this));

      function onpagechange() {
        // unset body classes to defaults
        (metadata.classes || []).forEach(this.classes.remove, this.classes);

        // unset page title to defaults
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_title__["a" /* default */])();

        // unset page metas to defaults
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_metas__["a" /* default */])({});
      }
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(144);
/* eslint-env browser */




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* SignupForm */], props), document.getElementById('signup-app'));
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var AuthButton = function AuthButton(props) {
  var disabled = props.disabled,
      isBig = props.isBig,
      label = props.label,
      onClick = props.onClick,
      strategy = props.strategy;


  var className = 'auth0-lock-social-button';
  if (isBig) className += ' auth0-lock-social-big-button';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    {
      className: 'auth0-lock-social-button',
      'data-provider': strategy,
      disabled: disabled,
      onClick: onClick,
      type: 'button'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'auth0-lock-social-button-icon' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'auth0-lock-social-button-text' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        label
      )
    )
  );
};

AuthButton.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool.isRequired,
  isBig: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func.isRequired,
  strategy: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  primaryColor: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  foregroundColor: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string
};

AuthButton.defaultProps = {
  disabled: false,
  isBig: true
};

/* harmony default export */ __webpack_exports__["a"] = (AuthButton);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Input = function Input(_ref) {
  var onChange = _ref.onChange,
      label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      value = _ref.value,
      type = _ref.type,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      required = _ref.required,
      textError = _ref.textError;

  var hasError = textError.length > 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "required" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { htmlFor: "#" },
        label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "" + (hasError ? 'form-control has-error' : 'form-control'),
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        type: type,
        placeholder: placeholder,
        name: name,
        onChange: onChange,
        value: value,
        required: required
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "text-error-utils" },
      textError
    )
  );
};

Input.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  name: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  type: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  autoComplete: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  autoFocus: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  required: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
  textError: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

Input.defaultProps = {
  textError: ''
};

/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });



/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_auth0_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(144);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SignupForm = function (_Component) {
  _inherits(SignupForm, _Component);

  function SignupForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SignupForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      onClickGithubProvider: function onClickGithubProvider() {},
      onClickGoogleProvider: function onClickGoogleProvider() {},
      onClickMicrosoftProvider: function onClickMicrosoftProvider() {},
      onClickDatabaseProvider: function onClickDatabaseProvider() {}
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SignupForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clientInitialize();
    }
  }, {
    key: 'clientInitialize',
    value: function clientInitialize() {
      var _props = this.props,
          clientID = _props.clientID,
          domain = _props.domain,
          callbackURL = _props.callbackURL,
          dbConnectionName = _props.dbConnectionName;

      var auth0 = new __WEBPACK_IMPORTED_MODULE_1_auth0_js___default.a.WebAuth({
        domain: domain,
        clientID: clientID,
        redirectUri: callbackURL,
        responseType: 'code'
      });

      this.setState({
        onClickGithubProvider: function onClickGithubProvider() {
          return auth0.authorize({ connection: 'github' });
        },
        onClickGoogleProvider: function onClickGoogleProvider() {
          return auth0.authorize({ connection: 'google-oauth2' });
        },
        onClickMicrosoftProvider: function onClickMicrosoftProvider() {
          return auth0.authorize({ connection: 'windowslive' });
        },
        onClickDatabaseProvider: function onClickDatabaseProvider(username, password, onError) {
          return auth0.redirect.signupAndLogin({
            email: username,
            password: password,
            connection: dbConnectionName
          }, onError);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-box' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { className: 'sign-up-form' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* SignupPane */], { onSignup: this.state.onClickDatabaseProvider }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'copy-separate' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'or'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["d" /* SocialButtonsPane */], {
              onClickGithubProvider: this.state.onClickGithubProvider,
              onClickGoogleProvider: this.state.onClickGoogleProvider,
              onClickMicrosoftProvider: this.state.onClickMicrosoftProvider
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'form-box-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'By signing up, you agree to our\xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: '/terms' },
              'terms of service'
            ),
            ' ',
            '\xA0and\xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: '/privacy' },
              'privacy policy'
            )
          )
        )
      );
    }
  }]);

  return SignupForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SignupForm.propTypes = {
  clientID: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  domain: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  callbackURL: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  dbConnectionName: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SignupForm);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignupForm__ = __webpack_require__(581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SignupForm__["a"]; });



/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_email__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_password__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(144);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var responseCode = {
  userExists: 'user_exists',
  invalidPassword: 'invalid_password'
};

var SignupPane = function (_Component) {
  _inherits(SignupPane, _Component);

  function SignupPane() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SignupPane);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignupPane.__proto__ || Object.getPrototypeOf(SignupPane)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      email: '',
      password: '',
      buttonIsDisabled: false,
      error: {
        email: '',
        password: ''
      }
    }, _this.onChange = function (event) {
      var keyName = event.target.name;
      var value = event.target.value;
      var newState = {};
      newState[keyName] = value;
      _this.setState(newState);
    }, _this.onSubmitError = function (details) {
      var error = {};
      if (details.code === responseCode.userExists) {
        error = { email: details.description, password: '' };
      }
      if (details.code === responseCode.invalidPassword) {
        error = details.policy ? // Needs to change how we get the string policy. We will provide 'policy' directly in err obj in auth0.js
        // However we need to better handle the password policy error.
        { email: '', password: details.policy } : { email: '', password: details.description };
      }
      _this.setState({ error: error, buttonIsDisabled: false });
    }, _this.submitHandler = function (event) {
      event.preventDefault();
      var _this$state = _this.state,
          email = _this$state.email,
          password = _this$state.password;

      _this.submit({ email: email, password: password });
      return false;
    }, _this.submit = function (data) {
      var error = { email: '', password: '' };
      _this.setState({ error: error, buttonIsDisabled: true });
      var email = data.email,
          password = data.password;
      var onSignup = _this.props.onSignup;

      var emailIsValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_email__["a" /* validateEmail */])(email);
      if (emailIsValid && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_password__["a" /* passwordIsValid */])(password)) {
        onSignup(email, password, _this.onSubmitError);
        return;
      }
      error.password = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_password__["b" /* getPasswordErrorMessage */])(password);
      error.email = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_email__["b" /* getEmailErrorMessage */])(email);
      _this.setState({ error: error, buttonIsDisabled: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SignupPane, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          email = _state.email,
          password = _state.password,
          error = _state.error;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          'Sign Up'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["b" /* Input */], {
          label: 'Email',
          autoFocus: true,
          type: 'email',
          autoComplete: 'email',
          placeholder: 'yourname@email.com',
          name: 'email',
          onChange: this.onChange,
          value: email,
          required: true,
          textError: error.email
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["b" /* Input */], {
          label: 'Password',
          type: 'password',
          placeholder: '.....',
          name: 'password',
          onChange: this.onChange,
          value: password,
          required: true,
          textError: error.password
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            disabled: this.state.buttonIsDisabled,
            onClick: this.submitHandler,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('btn', 'btn-lg', 'form-control', 'btn-success', {
              'btn-is-disabled-utils': this.state.buttonIsDisabled
            })
          },
          'SIGN UP',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon-budicon-461' })
        )
      );
    }
  }]);

  return SignupPane;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SignupPane.propTypes = {
  onSignup: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SignupPane);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignupPane__ = __webpack_require__(583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SignupPane__["a"]; });



/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthButton__ = __webpack_require__(229);



var SocialButtonsPane = function SocialButtonsPane(_ref) {
  var onClickGithubProvider = _ref.onClickGithubProvider,
      onClickGoogleProvider = _ref.onClickGoogleProvider,
      onClickMicrosoftProvider = _ref.onClickMicrosoftProvider;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'button-wrapper' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AuthButton__["a" /* default */], { strategy: 'github', label: 'Sign up with Github', onClick: onClickGithubProvider }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AuthButton__["a" /* default */], { strategy: 'google', label: 'Sign up with Google', onClick: onClickGoogleProvider }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AuthButton__["a" /* default */], {
      strategy: 'windowslive',
      label: 'Sign up with Microsoft',
      onClick: onClickMicrosoftProvider
    })
  );
};

SocialButtonsPane.propTypes = {
  onClickGithubProvider: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onClickGoogleProvider: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  onClickMicrosoftProvider: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SocialButtonsPane);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SocialButtonsPane__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SocialButtonsPane__["a"]; });



/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateEmail;
/* unused harmony export emailDomain */
/* unused harmony export emailLocalPart */
/* harmony export (immutable) */ __webpack_exports__["b"] = getEmailErrorMessage;
var regExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

function validateEmail(str) {
  var result = regExp.exec(str.toLowerCase().trim());
  return result && result[0];
}

function emailDomain(str) {
  var result = regExp.exec(str.toLowerCase().trim());
  return result ? result.slice(-2)[0] : '';
}

function emailLocalPart(str) {
  var domain = emailDomain(str);
  return domain ? str.slice(0, -1 - domain.length) : str;
}

function getEmailErrorMessage(str) {
  if (str === '') return 'required';
  if (!validateEmail(str)) return 'email is invalid';
  return '';
}

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = passwordIsValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPasswordErrorMessage;
function passwordIsValid(str) {
  return str.length > 0;
}

function getPasswordErrorMessage(str) {
  return str === '' ? 'required' : '';
}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolve;
var orgName = 'Auth0';

/**
 * Expose `title`s resolve function
 */

function resolve(str, append, single) {
  if (!str) return orgName;
  if (single) return str;

  return append ? orgName + ' - ' + str : str + ' - ' + orgName;
}

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = title;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resolve__ = __webpack_require__(589);



/**
 * Change head's title or restore with
 * one from config `organization name`
 *
 * @param {String} str
 * @api public
 */

function title(str, append, single) {
  __WEBPACK_IMPORTED_MODULE_0_component_query___default()('head title').innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__resolve__["a" /* default */])(str, append, single);
}

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = metas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_query__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_component_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_component_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults_json__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__defaults_json__);
/* eslint-env browser */




var slice = Array.prototype.slice;

function metas(tags) {
  var title = __WEBPACK_IMPORTED_MODULE_1_component_query___default()('title');
  var ogs = slice.call(__WEBPACK_IMPORTED_MODULE_1_component_query___default.a.all('meta[name^="twitter:"]'));
  var _defaults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])({}, __WEBPACK_IMPORTED_MODULE_2__defaults_json___default.a);
  var obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])(_defaults, tags);

  ogs.forEach(remove);
  Object.keys(obj).forEach(insertMetasFor(obj));
}

function remove(og) {
  og.parentNode.removeChild(og);
}

function insertMetasFor(obj) {
  return function insertMetaFor(tag) {
    var content = obj[tag];

    if (typeof content === 'string') {
      return insert(tag, content);
    }

    content.forEach(function (sub) {
      Object.keys(sub).forEach(function (prop) {
        insert(tag + ':' + prop, sub[prop]);
      });
    });
  };
}

function insert(prop, content) {
  var meta = document.createElement('meta');
  meta.setAttribute('name', prop);
  meta.setAttribute('content', content);
  after(__WEBPACK_IMPORTED_MODULE_1_component_query___default()('title'), meta);
}

function after(node, meta) {
  if (!node.nextSibling) return node.parentNode.appendChild(meta);
  node.parentNode.insertBefore(meta, node.nextSibling);
}

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highlightjs__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_highlightjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__home_page_pug__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__home_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__home_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_metadata_json__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__data_metadata_json__);
/* eslint-env browser, jquery */














var unmountLockHeroDemo = function unmountLockHeroDemo() {};
var unmountLockPlayground = function unmountLockPlayground() {};

/**
 * Routes
 */
function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/', initial, loadScripts, snippets);
  __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */].exit('/', exit);
  __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */].exit('/signup', exit);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_12__data_metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_11__home_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_4_modules_section_content__["a" /* default */].render(renderOptions);

  return next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_6_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/homepage/vendor/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.end(next);
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  unmountLockHeroDemo = renderLockHeroDemo();
  unmountLockPlayground = renderLockPlayground();

  popoverEmbedWistia();

  var $ = window.$;
  var carouselControls = $('[data-slide="prev"], [data-slide="next"], [data-slide-to]');

  // Load Roboto Mono Font
  loadRobotoFont();

  // Highlightjs

  __WEBPACK_IMPORTED_MODULE_2_highlightjs___default.a.configure({
    classPrefix: ''
  });

  $('pre code').each(function (i, block) {
    __WEBPACK_IMPORTED_MODULE_2_highlightjs___default.a.highlightBlock(block);
  });

  rulesDemoAnimation();

  // Add css animation
  $('.carousel').bind('slide.bs.carousel', function () {
    $('.slides').addClass('animated');
  });

  // Track scroll until the widget is reached, then fire metrics event and unbind scroll
  $(window).on('scroll', trackScrollHomepage);

  // Track when carousel controls are clicked
  carouselControls.on('click', function () {
    __WEBPACK_IMPORTED_MODULE_3_modules_metrics__["a" /* default */].lib().track('click:carousel');
  });

  $('#carousel').swiperight(function swiperight() {
    $(this).carousel('prev');
  });
  $('#carousel').swipeleft(function swipeleft() {
    $(this).carousel('next');
  });

  contactFormModals();

  next();
}

/**
 * Render lock hero demo
 */
function renderLockHeroDemo() {
  return renderReactComponent(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["a" /* LockHomeDemo */], null), document.getElementById('hero-lock-demo'));
}

/**
 * Render playground lock
 */
function renderLockPlayground() {
  return renderReactComponent(__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["b" /* LockPlaygroundHomepage */], null), document.getElementById('playground-next'));
}

function renderReactComponent(instance, element) {
  var rendered = false;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_dom__["render"])(instance, element, setRenderedTrue);

  return unmounReactComponent;

  function setRenderedTrue() {
    rendered = true;
  }

  function unmounReactComponent() {
    if (rendered) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_dom__["unmountComponentAtNode"])(element);
    }
  }
}

/**
 *  load popover embeds wistia Video
 */
function popoverEmbedWistia() {
  var popoverOptions = 'autoPlay=true&controlsVisibleOnLoad=true&popover=true&version=v1&videoHeight=360&videoWidth=640';
  var hrefValue = '//fast.wistia.com/embed/iframe/fu7ww3h1yx?' + popoverOptions;
  var addAttr = function addAttr() {
    $('#wistia-popover').on('click', false);
    return $('.video-btn').attr('href', hrefValue);
  };

  $.when(addAttr()).done(function () {
    $.getScript('//fast.wistia.com/static/popover-v1.js');
  });
}

/**
* Set carousel height
*/
function setCarouselHeight() {
  var $ = window.$;
  var windowHeight = $(window).height();
  var headerHeight = $('.site-header-v2').outerHeight(true);
  var customersHeight = $('.customers').outerHeight();
  $('.carousel').height(windowHeight - headerHeight - customersHeight);
}

/**
 * Load Roboto font
 */
function loadRobotoFont() {
  window.WebFontConfig = {
    google: { families: ['Roboto+Mono:400:latin'] }
  };
  (function webfont() {
    var wf = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    wf.src = (document.location.protocol === 'https:' ? 'https' : 'http') + '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    s.parentNode.insertBefore(wf, s);
  })();
}

/**
 * Track scroll on homepage when widget is reached
 */
function trackScrollHomepage() {
  var $ = window.$;
  var widgetOffsetTop = $('#playground-next').parent().parent().offset().top;
  var rulesOffset = $('.extensibility-example').parent().parent().offset().top;
  var rulesHeight = $('.extensibility-example').outerHeight(true);

  if ($(window).scrollTop() >= widgetOffsetTop) {
    __WEBPACK_IMPORTED_MODULE_3_modules_metrics__["a" /* default */].lib().track('scroll:homepage');
  }

  if ($(window).scrollTop() >= rulesOffset && $(window).scrollTop() <= rulesOffset + rulesHeight) {
    $('.rules-animation').addClass('is-active');
  } else {
    $('.rules-animation').removeClass('is-active');
  }
}

/**
 *  // Contact Sales Form
 */
function contactFormModals() {
  var salesContactFormOptions = {
    onModalOpen: function onModalOpen() {
      window.metricsLib.track('click:contact-sales');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      window.metricsLib.track('register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitSuccess('#contact-form-modal__form');
    },
    onFormFail: function onFormFail(metricsData) {
      window.metricsLib.track('fail:register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitFailure('#contact-form-modal__form');
    },

    source: 'home-page'
  };
  var salesContactForm = new __WEBPACK_IMPORTED_MODULE_5_auth0_contact_form___default.a(salesContactFormOptions);

  $('.open-contact-form-modal').click(function () {
    return salesContactForm.show({ includePhoneField: true });
  });
}

/**
 * Unsubscribe from window events
 */
function exit(ctx, next) {
  var $ = window.$;
  $(window).off('scroll', trackScrollHomepage);
  $(window).off('resize', setCarouselHeight);

  unmountLockHeroDemo();
  unmountLockPlayground();

  next();
}

/**
 * show animation a/b - experiments
 */

window.animationExperiment = function () {
  var $ = window.$;
  var vid = document.getElementById('why-video');

  function playVid() {
    vid.play();
  }

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();

    if (window.wistiaJQuery) playVid();
  });
};

/* Select */

var ruleTemplates = {};

ruleTemplates.option1 = 'function (user, context, callback) {\n  if (context.clientName === \'TheAppToCheckAccessTo\') {\n    var d = new Date().getDay();\n      if (d === 0 || d === 6) {\n        return callback(new UnauthorizedError(\'This app is available during the week\'));\n    }\n  }\n  callback(null, user, context);\n}';

ruleTemplates.option2 = 'function(user, context, callback) {\n  // short-circuit if the user signed up already\n  if (context.stats.loginsCount > 1) return callback(null, user, context);\n\n  // get your slack\'s hook url from: https://slack.com/services/10525858050\n  var SLACK_HOOK = \'YOUR SLACK HOOK URL\';\n\n  var slack = require(\'slack-notify\')(SLACK_HOOK);\n  var message = \'New User: \' + (user.name || user.email) + \' (\' + user.email + \')\';\n  var channel = \'#some_channel\';\n\n  slack.success({\n   text: message,\n   channel: channel\n  });\n\n  // don\u2019t wait for the Slack API call to finish, return right away (the request will continue on the sandbox)\n  callback(null, user, context);\n}';

ruleTemplates.option3 = 'function (user, context, callback) {\n    var whitelist = [\'1.2.3.4\', \'2.3.4.5\']; //authorized IPs\n    var userHasAccess = whitelist.some(\n      function (ip) {\n        return context.request.ip === ip;\n      });\n\n    if (!userHasAccess) {\n      return callback(new UnauthorizedError(\'Access denied from this IP address.\'));\n    }\n\n    return callback(null, user, context);\n}';

function rulesDemoAnimation() {
  $('#ruleOptions').change(function rulesDemoAnimationOnChange() {
    var selected = $(this).val();

    $('.rule-editor pre code').empty();

    $('.rule-editor pre code').append(ruleTemplates[selected]);

    $('pre code').each(function (i, block) {
      __WEBPACK_IMPORTED_MODULE_2_highlightjs___default.a.highlightBlock(block);
    });
  });
}

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PlansMeta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* global FeatureWidget */


function PlansMeta(data) {
  this.plans = data.plans;
}

PlansMeta.prototype.getPlan = function (name) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.plans.models, function (plan) {
    return plan.plan === name;
  });
};

PlansMeta.prototype.getUserLimit = function (plan) {
  return this.getPlan(plan).findPlanFeatureByKey('users_count').getUserLimit();
};

PlansMeta.prototype.getFeatureProp = function (plan, feature, prop) {
  var value = (this.getPlan(plan).findPlanFeatureByKey(feature) || {})[prop];

  if (value === Infinity) {
    value = 'Unlimited';
  }

  return value;
};

PlansMeta.load = function () {
  return new PlansMeta({ plans: new FeatureWidget().plans });
};

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FeaturesPartial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feature_widget_pug__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feature_widget_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__feature_widget_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__features_table_pug__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__features_table_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__features_table_pug__);
/* eslint-env browser, jquery */
/* global FeatureWidget */




function FeaturesPartial(options) {
  options = options || {};

  this.track = options.track;
}

FeaturesPartial.prototype.load = function (batch) {
  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_npm_component_require_global__["a" /* default */])('//cdn.auth0.com/js/feature-widget/feature-widget-1.3.min.js', 'FeatureWidget', done);
  });
};

FeaturesPartial.prototype.activate = function () {
  this.$plans = $('[data-plan]');
  this.setFilterPlans('self_service');
};

FeaturesPartial.prototype.render = function () {
  var _this = this;

  var filterFeaturesThatAreAtLeastInOnePlan = FeatureWidget.filter.filterFeaturesThatAreAtLeastInOnePlan(this.filterPlans.bind(this));
  var filterActiveFeatures = FeatureWidget.filter.filterActiveFeatures();

  this.$plans.each(function (i, planContainer) {
    var $planContainer = $(planContainer);
    var planKey = $planContainer.data('plan');
    var $widgetContainer = $planContainer.find('.js-plan-features-container');

    var widget = new FeatureWidget({
      template: function template(locals) {
        return __WEBPACK_IMPORTED_MODULE_1__feature_widget_pug___default()(Object.assign({}, locals, { planKey: planKey }));
      },
      filterPlans: _this.filterPlans,
      filterFeatures: function filterFeatures(feature) {
        return filterFeaturesThatAreAtLeastInOnePlan(feature) && filterActiveFeatures(feature) && !/users_count|employees_count|social_connections|enterprise_connections/.test(feature.key);
      },

      sortPlans: FeatureWidget.sort.plansByNumberOfFeaturesTheyHave(false),
      sortFeatures: FeatureWidget.sort.featuresByNumberOfPlansTheyAre(true),
      sortTags: _this.sortTags()
    });

    $widgetContainer.html(widget.render());

    // Features table

    var $tableContainer = $('.js-features-table-container');

    var table = new FeatureWidget({
      template: function template(locals) {
        return __WEBPACK_IMPORTED_MODULE_2__features_table_pug___default()(Object.assign({}, locals));
      },
      filterPlans: _this.filterPlans,
      filterFeatures: function filterFeatures(feature) {
        return filterFeaturesThatAreAtLeastInOnePlan(feature) && filterActiveFeatures(feature);
      },

      sortPlans: FeatureWidget.sort.plansByNumberOfFeaturesTheyHave(false),
      sortFeatures: FeatureWidget.sort.featuresByNumberOfPlansTheyAre(true),
      sortTags: _this.sortTags()
    });

    $tableContainer.html(table.render());
  });
};

FeaturesPartial.prototype.sortTags = function () {
  var defaultSorter = FeatureWidget.sort.tagsByNumberOfFeatures(true);

  // we want to place the category 'Support' just after 'Authentication'
  // the rest of the categories will follow the featuresByNumberOfPlansTheyAre
  // sorter
  return function (tag1, tag2) {
    if (tag1.key === 'Authentication' && tag2.key === 'Support') {
      return -1;
    }

    if (tag1.key === 'Support' || tag2.key === 'Support') {
      return 1;
    }

    return defaultSorter(tag1, tag2);
  };
};

FeaturesPartial.prototype.setFilterPlans = function (type) {
  this.currentMode = type;

  this.filterPlans = function (plan) {
    var isNewPlan = ~['free', 'developer', 'developer-pro', 'enterprise'].indexOf(plan.plan);
    return plan.type.toLowerCase() === type && isNewPlan;
  };
};

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PricingPartial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_loggedin__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_bus__ = __webpack_require__(33);
/* eslint-env browser, jquery */
/* global PricingWidget */





function PricingPartial(options) {
  options = options || {};

  this.track = options.track;

  // Expose widgets for AB Testing
  window.pricingWidgets = [];

  this.featuresPartial = options.featuresPartial;

  this.onLoggedinChange = this.onLoggedinChange.bind(this);
}

PricingPartial.prototype.load = function (batch) {
  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn.auth0.com/pricing-widget/pricing-widget-4.3.min.js', 'PricingWidget', done);
  });
};

PricingPartial.prototype.activate = function () {
  var _this = this;

  this.$plans = $('[data-plan]');

  $('.js-see-all-type-features').click(this.onSeeAllTypeFeatures.bind(this));

  this.$plans.each(function (index, el) {
    var $el = $(el);
    $el.on('click', '.js-plan-contact-sales', _this.onContactSales.bind(_this));
  });

  __WEBPACK_IMPORTED_MODULE_2_modules_loggedin__["a" /* default */].onChange(this.onLoggedinChange);

  __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_bus__["a" /* default */].on('page:change', this.onDestroy.bind(this));
};

PricingPartial.prototype.onDestroy = function () {
  __WEBPACK_IMPORTED_MODULE_2_modules_loggedin__["a" /* default */].removeChangeListener(this.onLoggedinChange);
};

PricingPartial.prototype.onLoggedinChange = function (loggedin) {
  this.$plans = $('[data-plan]');
  this.$plans.each(function (index, el) {
    var $el = $(el);
    if (loggedin) {
      $el.find('.js-start-now').addClass('hide');
      $el.find('.js-buy-now').removeClass('hide');
    } else {
      $el.find('.js-start-now').removeClass('hide');
      $el.find('.js-buy-now').addClass('hide');
    }
  });
};

PricingPartial.prototype.render = function () {
  var _this2 = this;

  this.$plans.each(function (i, planContainer) {
    var planKey = planContainer.getAttribute('data-plan');
    var widget = new PricingWidget(planContainer);
    window.pricingWidgets.push(widget);

    widget.on(widget.events.SUBSCRIPTION_COST_CHANGED, _this2.onSubscriptionCostChange.bind(_this2, planContainer));

    widget.on(widget.events.SUBSCRIPTION_CHECKOUT, _this2.onStartNow.bind(_this2));
  });
};

PricingPartial.prototype.onSubscriptionCostChange = function (planContainer, cost, planType, users, recurrence, appliesForCustomDeal) {
  var planKey = planContainer.getAttribute('[data-plan]');
  this.disablePlanCheckout(planContainer, planType !== 'free' && !cost);

  this.track('change:plan-subscription-cost:' + planKey, {
    plan: planKey,
    type: planType,
    users: users,
    recurrence: recurrence,
    appliesForCustomDeal: appliesForCustomDeal
  });
};

PricingPartial.prototype.disablePlanCheckout = function (planContainer, shouldDisable) {
  $(planContainer).find('[data-plan-checkout]').attr('disabled', shouldDisable);
};

PricingPartial.prototype.onSeeAllFeatures = function (event) {
  var planKey = this._getPlanKey(event);

  event.preventDefault();

  this.featuresPartial.setPlanHighlighting(planKey);

  this.track('click:plan-see-all-features:' + planKey, { plan: planKey });
};

PricingPartial.prototype.onSeeAllTypeFeatures = function (event) {
  var planType = $(event.target).data('planType');

  this.featuresPartial.moveTo(planType);

  this.track('click:plan-see-all-features-type:' + planType, { planType: planType });
};

PricingPartial.prototype.onStartNow = function (subscription) {
  var qsPayload = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({
    type: subscription.plan,
    users: subscription.users,
    recurrence: subscription.recurrence
  });

  window.signup(null, { authParams: { state: qsPayload } });

  this.track('click:plan-start-now:' + subscription.plan, { plan: subscription.plan });
};

PricingPartial.prototype.setRecurrence = function (recurrence) {
  window.pricingWidgets.forEach(function (widget) {
    widget.setRecurrence(recurrence);
  }, this);

  this.track('select:pricing-packages-interval', { value: recurrence });
};

PricingPartial.prototype.onContactSales = function (event) {
  var planKey = this._getPlanKey(event);

  this.track('click:plan-contact-sales:' + planKey, { plan: planKey });
};

PricingPartial.prototype._getPlanKey = function (event) {
  return $(event.target).closest('[data-plan]').data('plan');
};

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js_page_variant__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_ab_testing__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_component_tip__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_component_tip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_component_tip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_auth0_contact_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pricing_pug__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pricing_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pricing_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__metadata_json__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_plans_meta__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__partials_features_features_partial__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__partials_pricing_partial__ = __webpack_require__(595);
/* eslint-env browser, jquery */


















var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('auth0:pricing');

var metricsLib = window.metricsLib;
var mouseFlow = window.mouseflow || undefined;

var track = function track(eventName, props) {
  debug('track', eventName, props);
  __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track(eventName, __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.extend({
    category: 'pricing'
  }, props));
};

var featuresPartial = new __WEBPACK_IMPORTED_MODULE_15__partials_features_features_partial__["a" /* default */]({ track: track });

var pricingPartial = new __WEBPACK_IMPORTED_MODULE_16__partials_pricing_partial__["a" /* default */]({ featuresPartial: featuresPartial, track: track });

// routing
function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js_page_variant__["a" /* default */])('newPricingPage', '/pricing', loadScripts, render, renderPricing, renderFeatures, snippets);
}

// route handlers
// page render!
function render(ctx, next) {
  var view = __WEBPACK_IMPORTED_MODULE_5_domify___default()(__WEBPACK_IMPORTED_MODULE_12__pricing_pug___default()({ planMeta: __WEBPACK_IMPORTED_MODULE_14__models_plans_meta__["a" /* default */].load() }));

  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_13__metadata_json___default.a
  }, ctx.init ? {} : { view: view });
  __WEBPACK_IMPORTED_MODULE_3_modules_section_content__["a" /* default */].render(renderOptions);

  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_9_batch___default.a();

  pricingPartial.load(batch);
  featuresPartial.load(batch);

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/pricing/resources/tooltips-a344d1455d.min.js', '$.fn.tooltips', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/pricing/resources/modal-3af0dc2fc3.min.js', '$.fn.modal', done);
  });

  batch.end(next);
}

function renderPricing(ctx, next) {
  pricingPartial.activate();
  pricingPartial.render();
  next();
}

function renderFeatures(ctx, next) {
  featuresPartial.activate();
  $('.js-plan-features-container').each(function () {
    var plan = this.getAttribute('data-plan');
    featuresPartial.render(plan);
  });
  // enable tooltips only in desktop view
  if (!('ontouchstart' in window)) {
    $('[data-toggle="tooltip"]').tooltip({ container: 'body' });
  }
  next();
}

function getModulesOffsets() {
  var modules = $('.pricing-module');
  var offsets = {};
  var count = 0;

  // Get all the plan groups in the page and asign them a data-sticky number
  modules.each(function (i, el) {
    var $el = $(el);

    // Check if composite module
    if (!$el.hasClass('composite-module')) {
      var elName = $el.attr('data-pricing-category');
      $el.attr('data-sticky', count);
      offsets[elName] = $(el).offset().top;
      count += 1;
      return;
    }

    // add composite module
    var plans = $el.find('[data-plan-group]');

    plans.each(function (i, el) {
      var elName = $(el).attr('data-plan-group');
      $(el).attr('data-sticky', count);
      offsets[elName] = $(el).offset().top;
      count += 1;
    });
  });

  return offsets;
}

// route handlers
// page snippets
function snippets(ctx, next) {
  var $featuresSwitch = $('.features-switch-cont');

  $(window).scroll();

  // Switch functionality
  $featuresSwitch.on('click', function (e) {
    $(this).find('.active').removeClass('active');
    $(e.target).addClass('active');
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(function (ev) {
    ev.preventDefault();
    toggleSwitcher($('.switch-plan[data-view="fixed-plans"] .switch-item:not(.active)'));
  });

  $('.switch-plan[data-view="fixed-plans"] .switch-item').click(function (ev) {
    ev.preventDefault();
    if ($(this).hasClass('active')) return;
    toggleSwitcher(this);
  });

  __WEBPACK_IMPORTED_MODULE_7_component_tip___default()('.package-plan-tip');

  $('.js-general-contact-sales').click(function () {
    track('click:contact-sales');
  });

  // Developer Pro Internal-External Switch
  $(".plan-usage-toggle input[type='radio']").change(function () {
    var value = $(this).val();
    $('.developer-pro-external,.developer-pro-internal').toggleClass('hide', true);
    $('.developer-pro-' + value).toggleClass('hide', false);
    $('[name="usage"]').prop('checked', false);
    $('[name="usage"][value="' + value + '"]').prop('checked', function () {
      return $(this).parent().is(':visible');
    });
  });

  contactFormModals();

  next();
}

function toggleSwitcher(el) {
  if ($(el).hasClass('active')) return;

  // toggle buttons
  $('.switch-plan[data-view="fixed-plans"] .switch-item').removeClass('active');
  $(el).addClass('active');

  pricingPartial.setRecurrence($(el).data('interval'));
}

function contactFormModals() {
  // Contact Sales Form
  var salesContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    source: 'pricing-page'
  };
  var salesContactForm = new __WEBPACK_IMPORTED_MODULE_11_auth0_contact_form___default.a(salesContactFormOptions);

  $('.open-contact-form-modal').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_modules_ab_testing__["a" /* default */].executeExperiment('contact-form-show-phone', function (variant) {
      salesContactForm.show({
        includePhoneField: true
      });
    });
  });

  // Contact OSS Form
  var ossContactFormOptions = {
    onModalOpen: function onModalOpen() {
      metricsLib.track('click:contact-oss');
    },
    onFormSuccess: function onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail: function onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form-oss', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },

    modalTitle: 'Contact OSS team',
    source: 'oss'
  };
  var ossContactForm = new __WEBPACK_IMPORTED_MODULE_11_auth0_contact_form___default.a(ossContactFormOptions);

  $('.open-contact-oss').click(function () {
    __WEBPACK_IMPORTED_MODULE_2_modules_ab_testing__["a" /* default */].executeExperiment('contact-form-show-phone', function (variant) {
      ossContactForm.show({
        includePhoneField: true
      });
    });
  });
}

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata_technology_json__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata_technology_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__metadata_technology_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_technologies_json__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata_technologies_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__metadata_technologies_json__);




/**
 * Universal/Isomorphic code
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  getTechnologyTitle: getTechnologyTitle,
  seo: seo
});

function getTechnologyTitle(technologies, technology) {
  if (!technology) {
    return '';
  }

  return technologies.filter(function (item) {
    return item.hash === technology;
  })[0].title;
}

function seo(isTechnology, path, technologyTitle) {
  var metadata = isTechnology ? __WEBPACK_IMPORTED_MODULE_1__metadata_technology_json___default.a : __WEBPACK_IMPORTED_MODULE_2__metadata_technologies_json___default.a;
  metadata = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(metadata);
  metadata.opengraph['og:url'] = 'https://auth0.com' + path;
  if (isTechnology) {
    var title = metadata.title.replace('`${technology}`', technologyTitle);
    var description = metadata.metas.description.replace('`${technology}`', technologyTitle);
    metadata.title = title;
    metadata.opengraph['og:title'] = title;
    metadata.twittercard['twitter:title'] = title;
    metadata.metas.description = description;
    metadata.opengraph['og:description'] = description;
    metadata.twittercard['twitter:description'] = description;
  }

  return metadata;
}

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changelogOldData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changelogApplianceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changelogData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__releases_json__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__releases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__releases_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__changelog_json__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__changelog_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__changelog_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__about_people_json__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__about_people_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__about_people_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generate_releases__ = __webpack_require__(599);






__WEBPACK_IMPORTED_MODULE_0_marked___default.a.setOptions({
  renderer: new __WEBPACK_IMPORTED_MODULE_0_marked___default.a.Renderer()
});

var peopleList = __WEBPACK_IMPORTED_MODULE_3__about_people_json___default.a.reduce(function (acc, person) {
  acc[person.mail] = person;
  return acc;
}, {});

var currentLogs = __WEBPACK_IMPORTED_MODULE_2__changelog_json___default.a.filter(function (log) {
  return !log.old && log.exclusive.toLowerCase() !== 'appliance';
}).sort(function (a, b) {
  return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
});

var changelog = {
  log: currentLogs,
  active: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__generate_releases__["a" /* default */])().filter(function (item) {
    return !item.old;
  }),
  old: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__generate_releases__["a" /* default */])().filter(function (item) {
    return item.old;
  })
};

var changelogOldData = {
  changelog: changelog.old,
  people: peopleList,
  capitalizeFirstLetter: capitalizeFirstLetter,
  renderMarkDown: renderMarkDown
};

var changelogApplianceData = {
  changelog: changelog.active,
  people: peopleList,
  capitalizeFirstLetter: capitalizeFirstLetter,
  renderMarkDown: renderMarkDown
};
var changelogData = {
  people: peopleList,
  capitalizeFirstLetter: capitalizeFirstLetter,
  changelog: changelog.log
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function renderMarkDown(md) {
  var html = __WEBPACK_IMPORTED_MODULE_0_marked___default()(md);
  return html.replace(/\[/g, '<span class="label label-default">').replace(/\]/g, '</span>');
}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateApplianceReleases;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__releases_json__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__releases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__releases_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appliance_json__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appliance_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appliance_json__);




function generateApplianceReleases() {
  var releasesApplianceReleases = __WEBPACK_IMPORTED_MODULE_1__releases_json___default.a.slice(0).map(function (release) {
    var newRelease = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.merge({}, release);
    var releaseLog = __WEBPACK_IMPORTED_MODULE_2__appliance_json___default.a.filter(function (log) {
      return log.release === newRelease.id;
    }).sort(function (a, b) {
      return a.type.localeCompare(b.type);
    }); // Sort by Type

    // Group by Type
    newRelease.changelog = groupBy(releaseLog, function (item) {
      return item.type;
    });

    // Sort by module
    Object.keys(newRelease.changelog).forEach(function (key) {
      newRelease.changelog[key].sort(function (a, b) {
        return a.module.localeCompare(b.module);
      });
    });

    return newRelease;
  });

  return releasesApplianceReleases;
}

/** * HELPER FUNCTIONS ***/

function groupBy(array, f) {
  var groups = {};
  array.forEach(function (o) {
    var group = JSON.stringify(f(o));
    if (group) {
      group = group.replace(/\"([^(\")"]+)\":/g, '$1:');
    }

    groups[group] = groups[group] || [];
    groups[group].push(o);
  });

  return groups;
}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollManager;
/* eslint-env browser, jquery */

function ScrollManager() {
  // Basic state
  this._didScroll = false;
  this.activeCategory = '';
  this.pinnedNav = false;
  // DOM Handles
  this.galleryContainer = $('.container-gallery');
  this.catNav = $('.categories-nav');
  this.catNavHolder = $('.categories-nav-holder');
  this.catNavItems = this.catNav.find('[data-category]');
  this.catContainers = $('[data-scroll-category]');
  this.$window = $(window);
  this.catNavOffsetTop = this.catNavHolder.offset().top;
  // Data lookup
  this.catContainersOffsetsObj = {};
  this.catContainersOffsetsArr = [];
  // Throttle Section Change
  this.navSectionChangeHandler = this.throttle(this.navSectionChangeHandler, 100, true);
}

ScrollManager.prototype.init = function () {
  this.bindEvents();
  if (window.innerWidth > 768) {
    this.pollForScroll();
  }
  this.doMeasurements();
  this.recalculateDelayed();
};

ScrollManager.prototype.bindEvents = function () {
  this.scrollEvent();
  this.navClickEvent();
  this.windowResize();
};

ScrollManager.prototype.throttle = function (func, wait, debounce) {
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    var throttler = function throttler() {
      timeout = null;
      func.apply(context, args);
    };
    if (debounce) clearTimeout(timeout);
    if (debounce || !timeout) timeout = setTimeout(throttler, wait);
  };
};

// Calculations

ScrollManager.prototype.doMeasurements = function () {
  this.catNavOffsetTop = this.catNavHolder.offset().top;
  this.getSectionsOffset();
  this.getNavHeight();
};

// This recalculates some things after a while to get correct measurements
// (we have them defined beforehand to avoid any malfunctioning)
ScrollManager.prototype.recalculateDelayed = function () {
  var self = this;
  var img = new Image();
  img.onload = function () {
    setTimeout(function () {
      self.doMeasurements();
    }, 100);
  };
  img.src = 'https://cdn.auth0.com/website/assets/pages/customers/img/customers-logo-3d621e054c.svg';
};

ScrollManager.prototype.getNavHeight = function () {
  this.catNavHeight = this.catNav.outerHeight(true);
};

ScrollManager.prototype.getSectionsOffset = function () {
  var self = this;
  // Very important: we need to iterate manually instead of using .each,
  // since we need the indexes to keep the order of the content
  for (var i = 0, len = this.catContainers.length; i < len; i += 1) {
    var $el = $(this.catContainers[i]);
    var elName = $el.attr('data-scroll-category');
    var elOffset = $el.offset().top;
    this.catContainersOffsetsObj[elName] = elOffset;
    this.catContainersOffsetsArr[i] = [elName, elOffset];
  }
};

ScrollManager.prototype.windowResize = function () {
  var self = this;
  this.$window.on('resize', function () {
    self.doMeasurements();
    if (window.innerWidth < 768) {
      self.$window.off('scroll');
      self.navPin(false);
    }
  });
};

// Navigation click event

ScrollManager.prototype.navClickEvent = function () {
  var self = this;
  this.catNav.on('click', function (e) {
    if ($(e.target).hasClass('category')) {
      self.navSectionChangeHandler(e.target, true, true);
    }
  });
};

// Navigation and Sections handlers

ScrollManager.prototype.navPin = function (pin) {
  var self = this;
  if (pin) {
    this.catNav.addClass('to-pin');
    this.pinTO = setTimeout(function () {
      self.catNav.addClass('pinned');
    }, 200);
    this.pinnedNav = true;
  } else {
    clearTimeout(this.pinTO);
    this.catNav.removeClass('pinned to-pin');
    this.setActiveCategory(true);
    this.pinnedNav = false;
  }
};

ScrollManager.prototype.navSectionChangeHandler = function (target, set, scroll) {
  this.activeCategory = $(target).attr('data-category');
  if (set) {
    this.setActiveCategory();
  }
  if (scroll) {
    this.scrollToCategory();
  }
};

ScrollManager.prototype.setActiveCategory = function (none) {
  this.catNavItems.filter('.active').removeClass('active');
  if (none) return;
  this.catNavItems.filter('[data-category="' + this.activeCategory + '"]').addClass('active');
};

ScrollManager.prototype.scrollToCategory = function () {
  var self = this;
  var currentCategoryOffsetTop = this.catContainersOffsetsObj[this.activeCategory];
  var scrollDuration = 750;
  currentCategoryOffsetTop -= this.catNavHeight;
  this.galleryContainer.addClass('scrolling');
  $('html, body').stop().animate({
    scrollTop: currentCategoryOffsetTop
  }, scrollDuration);
  setTimeout(function () {
    self.galleryContainer.removeClass('scrolling');
  }, scrollDuration);
};

// Scroll Event

ScrollManager.prototype.scrollEvent = function () {
  var self = this;
  $(window).on('scroll', function () {
    self._didScroll = true;

    if (self.catNav.hasClass('pinned') && $(window).scrollTop() < self.catNavOffsetTop) {
      self.catNav.removeClass('pinned to-pin');
    }
  });
};

ScrollManager.prototype.pollForScroll = function () {
  var self = this;
  function RAFScroll() {
    if (self._didScroll) {
      self._didScroll = false;
      self.scrollHandling();
    }
    requestAnimationFrame(RAFScroll);
  }
  RAFScroll();
};

ScrollManager.prototype.scrollHandling = function () {
  var self = this;
  var currScroll = this.$window.scrollTop();
  // Make sure we are over the navigation
  if (currScroll > this.catNavOffsetTop) {
    if (!this.pinnedNav) {
      this.navPin(true);
    }
    // Make sure we are not scrolling as a result of clicking a nav item to avoid overloading
    if (!this.galleryContainer.hasClass('scrolling')) {
      var currSection = this.catContainersOffsetsArr.filter(function (el, i) {
        return el[1] <= currScroll + self.catNavHeight;
      });
      currSection = currSection[currSection.length - 1];
      if (currSection && currSection !== self.lastActiveSection) {
        this.navSectionChangeHandler(this.catNavItems.filter('[data-category="' + currSection[0] + '"]'), true, false);
      }
      this.lastActiveSection = currSection;
    }
  } else {
    // If we are above the navigation, unpin it and set last section as undefined
    if (this.pinnedNav) {
      this.navPin(false);
    }
    this.lastActiveSection = undefined;
  }
};

ScrollManager.prototype.cancelScrollPoll = function () {
  clearInterval(this._scrollInterval);
};

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jquerysfMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return angularuMeta; });
/* unused harmony export cascadiaData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cascadiaMeta; });
/* unused harmony export osconData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return osconMeta; });
/* unused harmony export forwardData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return forwardMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fec15Meta; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata_json__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__metadata_json__);



var jquerysfData = {
  title: 'Angular 2: The new horizon for jQuerySF',
  description: 'Learn all the basic angular 2 concepts with this talk and small sample'
};
var jquerysfMeta = metadataGenerator(jquerysfData.title, jquerysfData.description);

var angularuData = {
  title: 'Make your angular app a maximum security prison',
  description: 'Learn how to add authentication to an Angular 1 and Angular 2 app very easily!'
};
var angularuMeta = metadataGenerator(angularuData.title, angularuData.description);

var cascadiaData = {
  title: 'Death to cookies: Long live JSON Web Tokens',
  description: 'Learn how to add authentication to a Vanilla JS SPA very easily!'
};
var cascadiaMeta = metadataGenerator(cascadiaData.title, cascadiaData.description);

var osconData = {
  title: 'Reactive Frontend',
  description: 'Learn what Observables, Stream and Reactive Programming are in this amazing talk'
};
var osconMeta = metadataGenerator(osconData.title, osconData.description);

var forwardData = {
  title: 'Reactive Frontend',
  description: 'Learn what Observables, Stream and Reactive Programming are in this amazing talk'
};
var forwardMeta = metadataGenerator(forwardData.title, forwardData.description);

var fec15Data = {
  title: 'Rethinking backend with Webtasks',
  description: 'Learn what Webtasks are and how we can write Backend code in our FrontEnd app.'
};
var fec15Meta = metadataGenerator(fec15Data.title, fec15Data.description);

function metadataGenerator(title, description) {
  var newMetadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["assign"])({}, __WEBPACK_IMPORTED_MODULE_1__metadata_json___default.a, {
    title: title,
    metas: { description: description }
  });
  return newMetadata;
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var GlossaryDetail = function GlossaryDetail(_ref) {
  var search = _ref.search,
      searchTerms = _ref.searchTerms,
      terms = _ref.terms;
  return search.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["g" /* SimpleListItem */], { items: searchTerms }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'col-xs-12' },
    terms.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["h" /* ListItem */], _extends({ key: index }, item));
    })
  );
};

GlossaryDetail.defaultProps = {
  searchTerms: [],
  terms: []
};

var termValidation = {
  term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

GlossaryDetail.propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  searchTerms: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape(termValidation)),
  terms: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape(termValidation))
};

/* harmony default export */ __webpack_exports__["a"] = (GlossaryDetail);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GlossaryDetail__ = __webpack_require__(602);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GlossaryDetail__["a"]; });



/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Hero = function Hero() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "section",
    { className: "herospace" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "container" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-xs-12 col-sm-5 text-container" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            "Identity Glossary"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "We've put together a glossary of terms for newcomers and seasoned developers alike to put any remaining confusion to rest."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: "javascript:signup()", className: "btn btn-success btn-lg" },
            "Use Auth0 for Free"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-xs-12 col-md-7 image-container" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: "https://cdn.auth0.com/website/assets/pages/identity-glossary/img/glossary-e89fa246c0.png", alt: "Identity Glossary" })
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Hero__["a"]; });



/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var Item = function Item(_ref) {
  var term = _ref.term,
      letter = _ref.letter,
      definition = _ref.definition,
      _ref$subitems = _ref.subitems,
      subitems = _ref$subitems === undefined ? {} : _ref$subitems;

  var getMarkup = function getMarkup() {
    return definition;
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    {
      className: 'glossary-term',
      'data-search': term.substring(0, 50).toLowerCase(),
      'data-letter': letter
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { id: term.replace(/\s+/g, '-').toLowerCase(), className: 'term' },
      term
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'definition', dangerouslySetInnerHTML: { __html: getMarkup() } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ol',
      null,
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.values(subitems).map(function (subitem, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: index, className: 'subdefinition' },
          subitem
        );
      })
    )
  );
};

Item.defaultProps = {
  subitems: {}
};

Item.propTypes = {
  term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Item__["a"]; });



/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

var LettersBar = function LettersBar() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'index-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      letters.map(function (letter) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: letter },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '#' + letter },
            letter
          )
        );
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LettersBar);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LettersBar__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LettersBar__["a"]; });



/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var ListItem = function ListItem(_ref) {
  var letter = _ref.letter,
      color = _ref.color,
      items = _ref.items;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ul',
    { className: 'glossary-list' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      { className: 'letter-separator ' + color, id: letter, 'data-letter': letter },
      letter
    ),
    items.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["f" /* Item */], _extends({ key: index }, item));
    })
  );
};

ListItem.defaultProps = {
  items: []
};

ListItem.propTypes = {
  letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  color: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItem__ = __webpack_require__(610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItem__["a"]; });



/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Loader = function Loader() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "press-custom-loader spinner spinner-md is-auth0" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "circle" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });



/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function () {
      _this.modal.classList.remove('in');
      _this.modal.style.display = 'none';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.modal.classList.add('in');
      this.modal.style.display = 'block';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          children = _props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          role: 'dialog',
          className: 'modal',
          ref: function ref(el) {
            _this2.modal = el;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'modal-backdrop custom-modal-backdrop' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal-dialog' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'modal-header has-border' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: this.onClose, type: 'button', 'data-dismiss': 'modal', className: 'close' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  '\xD7'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'sr-only' },
                  'Close'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'modal-title' },
                title
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'modal-body' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'ul',
                  { className: 'glossary-list' },
                  children
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Modal.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(50);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PromiseStateContainer = function (_Component) {
  _inherits(PromiseStateContainer, _Component);

  function PromiseStateContainer() {
    _classCallCheck(this, PromiseStateContainer);

    return _possibleConstructorReturn(this, (PromiseStateContainer.__proto__ || Object.getPrototypeOf(PromiseStateContainer)).apply(this, arguments));
  }

  _createClass(PromiseStateContainer, [{
    key: 'isEmptyObject',
    value: function isEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ps = _props.ps,
          onPending = _props.onPending,
          onNoResults = _props.onNoResults,
          onRejection = _props.onRejection,
          onFulFillment = _props.onFulFillment;


      if (ps.pending) {
        return onPending(ps.meta);
      }

      if (ps.rejected) {
        return onRejection(ps.reason, ps.meta);
      }

      if (ps.fulfilled && this.isEmptyObject(ps.value)) {
        return onNoResults(ps.value, ps.meta);
      }

      if (ps.fulfilled) {
        return onFulFillment(ps.value, ps.meta);
      }

      return null;
    }
  }]);

  return PromiseStateContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PromiseStateContainer.propTypes = {
  ps: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]).isRequired,
  onPending: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNoResults: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRejection: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onFulFillment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};
PromiseStateContainer.defaultProps = {
  onPending: function onPending() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* Loader */], null);
  },
  onNoResults: function onNoResults() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
  },
  onRejection: function onRejection(_ref) {
    var cause = _ref.cause;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { className: 'rejection-message' },
      cause.message
    );
  }
};


/* harmony default export */ __webpack_exports__["a"] = (PromiseStateContainer);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PromiseStateContainer__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PromiseStateContainer__["a"]; });



/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(50);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SearchBar = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.stickyUI = function () {
      var stickySearchTop = _this.glossarySearch.offsetTop + 117;
      var scrollTop = window.scrollY;
      var stickySearchHeight = _this.searchBar.offsetHeight;

      if (scrollTop > stickySearchTop) {
        _this.searchBar.classList.add('sticky');
        _this.glossarySearch.style.height = stickySearchHeight;
      } else {
        _this.searchBar.classList.remove('sticky');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.stickyUI);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.stickyUI);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          searchValue = _props.searchValue,
          onChangeSearch = _props.onChangeSearch;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        {
          ref: function ref(el) {
            _this2.glossarySearch = el;
          },
          className: 'glossary-search'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(el) {
              _this2.searchBar = el;
            },
            className: 'search-bar'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["j" /* SearchField */], {
                  placeholder: 'Search terms',
                  value: searchValue,
                  onChange: onChangeSearch
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["k" /* LettersBar */], null)
              )
            )
          )
        )
      );
    }
  }]);

  return SearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchBar.propTypes = {
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  onChangeSearch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchBar__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchBar__["a"]; });



/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var SearchField = function SearchField(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "search-container" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "form",
      { id: "search", role: "search", autoComplete: "off" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "form-group search-control" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-budicon-489 search-icon" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({ type: "text", id: "search-input", className: "search-input form-control" }, props))
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchField);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchField__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchField__["a"]; });



/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var SimpleListItem = function SimpleListItem(_ref) {
  var items = _ref.items;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'col-xs-12' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { className: 'glossary-list' },
      items.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["f" /* Item */], _extends({ key: index }, item));
      })
    )
  );
};

SimpleListItem.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
  })).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleListItem);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleListItem__ = __webpack_require__(622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SimpleListItem__["a"]; });



/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect__ = __webpack_require__(231);





var TermModal = function TermModal(_ref) {
  var term = _ref.term,
      letter = _ref.letter,
      definition = _ref.definition,
      subitems = _ref.subitems,
      termDetailFetch = _ref.termDetailFetch;
  return term && letter && definition || subitems ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__components__["e" /* Modal */],
    { title: term },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["f" /* Item */], { term: term, letter: letter, definition: definition, subitems: subitems })
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["d" /* PromiseStateContainer */], {
    ps: __WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"].race([termDetailFetch]),
    onFulFillment: function onFulFillment(termItem) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__components__["e" /* Modal */],
        { title: termItem.term },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["f" /* Item */], {
          term: termItem.term,
          letter: termItem.letter,
          definition: termItem.definition,
          subitems: termItem.subitems
        })
      );
    }
  });
};

TermModal.defaultProps = {
  term: null,
  letter: null,
  definition: null,
  subitems: null
};

TermModal.propTypes = {
  term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
  termDetailFetch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__connect__["b" /* termDetailConnect */])(TermModal));

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermModal__ = __webpack_require__(624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TermModal__["a"]; });



/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var App = function App(_ref) {
  var glossaryData = _ref.glossaryData,
      route = _ref.route,
      glossaryItem = _ref.glossaryItem;

  if (route === 'home') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* Glossary */], { glossary: glossaryData, route: route })
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1____["b" /* Glossary */],
      { glossary: glossaryData, route: route },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["l" /* TermModal */], _extends({ route: route }, glossaryItem))
    )
  );
};

App.defaultProps = {
  glossaryItem: {},
  glossaryData: []
};

App.propTypes = {
  glossaryData: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
  })),
  route: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  glossaryItem: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });



/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__connect__ = __webpack_require__(231);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Glossary = function (_Component) {
  _inherits(Glossary, _Component);

  function Glossary() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Glossary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Glossary.__proto__ || Object.getPrototypeOf(Glossary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      search: '',
      searchTerms: []
    }, _this.updateSearch = function (event) {
      _this.setState({ search: event.target.value }, _this.filterGlossaryWithSearch);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Glossary, [{
    key: 'filterGlossaryWithSearch',
    value: function filterGlossaryWithSearch() {
      var options = {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 1000,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['term']
      };
      var fuse = new __WEBPACK_IMPORTED_MODULE_1_fuse_js___default.a(this.props.glossary, options);
      if (this.state.search.length) {
        var fuseSearch = fuse.search(this.state.search);
        this.setState({ searchTerms: fuseSearch });
      } else {
        this.setState({ searchTerms: this.props.glossary });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          glossary = _props.glossary,
          glossaryFetch = _props.glossaryFetch,
          children = _props.children;
      var _state = this.state,
          search = _state.search,
          searchTerms = _state.searchTerms;

      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* setGlossaryList */])(glossary);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* Hero */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["b" /* SearchBar */], { searchValue: search, onChangeSearch: this.updateSearch }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'glossary' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'glossary-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* objectIsEmpty */])(items) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["c" /* GlossaryDetail */], { search: search, searchTerms: searchTerms, terms: items }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["d" /* PromiseStateContainer */], {
                  ps: __WEBPACK_IMPORTED_MODULE_2_react_refetch__["PromiseState"].race([glossaryFetch]),
                  onFulFillment: function onFulFillment(terms) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["c" /* GlossaryDetail */], {
                      search: search,
                      searchTerms: searchTerms,
                      terms: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* setGlossaryList */])(terms)
                    });
                  }
                })
              ),
              children
            )
          )
        )
      );
    }
  }]);

  return Glossary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Glossary.propTypes = {
  glossary: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    term: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    letter: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    definition: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    subitems: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
  })).isRequired,
  glossaryFetch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_2_react_refetch__["PromiseState"]).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].element
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__connect__["a" /* glossaryConnect */])(Glossary));

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Glossary__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Glossary__["a"]; });



/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollToDOMElement;
function scrollToDOMElement(node) {
  var extraHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var headerHieght = 70;
  if (node) node.scrollIntoView();
  var scrolledY = window.scrollY;
  if (scrolledY) {
    window.scroll(0, scrolledY - headerHieght - extraHeight * 1.8);
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  scrollToDOMElement: scrollToDOMElement
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_breached_passwords_resources_flipclock_min__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_breached_passwords_resources_flipclock_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_breached_passwords_resources_flipclock_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breached_passwords_page_pug__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breached_passwords_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__breached_passwords_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__metadata_json__);
/* eslint-env browser, jquery */
/* global WOW */

// import debugT from 'debug';










// const debug = debugT('auth0:breached-passwords');

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_ab_page_js__["a" /* default */])('/jp/breached-passwords', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_9__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_8__breached_passwords_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_5_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var clock = $('.counter').FlipClock(leakedPasswordsCount(), {
    clockFace: 'Counter',
    minimumDigits: ('' + leakedPasswordsCount()).length
  });

  setInterval(function () {
    clock.setTime(leakedPasswordsCount());
  }, 1000);

  window.clock = clock;

  var batch = new __WEBPACK_IMPORTED_MODULE_2_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.end(next);
}

function leakedPasswordsCount() {
  var initialCount = 1135200000;
  var initialDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(1471013548218);
  var diff = Math.round(__WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(initialDate) / 420);

  return initialCount + diff;
}

function snippets(ctx, next) {
  var wow = new WOW();

  wow.init();

  initScrollAnimations();

  playBenefits();

  next();
}

function playBenefits() {
  var $el = $('.js-animate-circles circle');
  var speed = 300;

  function setLoop(counter, duration, backwards) {
    var bounceDuration = duration / 1.2;

    function getCondition() {
      return backwards ? counter >= 0 : counter <= $el.length;
    }

    function removePrev() {
      return backwards ? $el.eq(counter + 1).removeAttr('class') : $el.eq(counter - 1).removeAttr('class');
    }

    return setInterval(function () {
      if (getCondition()) {
        removePrev();

        $el.eq(counter).css({
          '-webkit-transition-duration': bounceDuration + 'ms',
          '-moz-transition-duration': bounceDuration + 'ms',
          'transition-duration': bounceDuration + 'ms'
        });

        $el.eq(counter).attr('class', 'active');

        if (counter === $el.length || counter == 0) {
          var toRemove = counter;

          setTimeout(function () {
            $el.eq(toRemove).removeAttr('class');
          }, duration);
        }

        if (backwards) {
          return counter -= 1;
        }

        return counter += 1;
      }
      if (backwards) {
        return counter = 26;
      }

      return counter = 27;
    }, duration);
  }

  setLoop(26, speed, true);
  setLoop(12, speed, true);

  setLoop(27, speed);
  setLoop(43, speed);
}

function initScrollAnimations() {
  var newsAnimation1 = new WOW({
    boxClass: 'go-down',
    animateClass: 'move'
  });

  var newsAnimation2 = new WOW({
    boxClass: 'go-up',
    animateClass: 'move'
  });

  var switchAnimation = new WOW({
    boxClass: 'switch-container',
    animateClass: 'enabled'
  });

  // video animation

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();
    playVid();
    showRePlay();
  });

  var vid = document.getElementById('breached-video-jp');

  function playVid() {
    vid.play();
  }

  function showRePlay() {
    $('a.play-me-again').hide();
    setTimeout(function () {
      $('a.play-me-again').show();
    }, 9000);
  }

  var lockAnimation = new WOW({
    boxClass: 'example-content',
    mobile: true,
    live: true,
    offset: 200,
    callback: function callback(box) {
      playVid();
      showRePlay();
    }
  });

  // end video animation

  newsAnimation1.init();
  newsAnimation2.init();
  switchAnimation.init();
  lockAnimation.init();
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__guardian_page_pug__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__guardian_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__guardian_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* eslint-env browser, jquery */
/* global WOW */








function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__["a" /* default */])('/jp/multifactor-authentication', render, loadScripts, snippets);
  __WEBPACK_IMPORTED_MODULE_3_modules_ab_page_js__["a" /* default */].redirect('/jp/guardian', '/jp/multifactor-authentication');
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_5__guardian_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_2_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js', 'TweenMax', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  // Hero intro animation
  $('.hero-flex-container .browser').addClass('animate');

  // video animation

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();
    playVid();
    showRePlay();
  });

  var vid = document.getElementById('guardian-video-jp');

  function playVid() {
    vid.play();
  }

  function showRePlay() {
    $('a.play-me-again').hide();
    setTimeout(function () {
      $('a.play-me-again').show();
    }, 27000);
  }

  var wow = new WOW({
    boxClass: 'placeholder-media',
    mobile: true,
    live: true,
    callback: function callback() {
      playVid();
      showRePlay();
    }
  });

  wow.init();

  // end video animation
}

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_interactive_widget__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_main_pug__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_main_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_main_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_metadata_json__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__data_metadata_json__);
/* eslint-env browser, jquery */













/**
 * Routes
 */
function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/jp/', initial, loadScripts, snippets);
  __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */].exit('/jp/', exit);
  __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */].exit('/jp/signup', exit);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_11__data_metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_1_domify___default()(__WEBPACK_IMPORTED_MODULE_10__views_main_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_3_modules_section_content__["a" /* default */].render(renderOptions);

  return next();
}

/**
 * Load required scripts
 */
function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('//cdn2.auth0.com/website/custom/lock-passwordless-2.min.js', 'Auth0LockPasswordless', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/homepage/vendor/tooltips-a344d1455d.min.js', '$.fn.tooltip', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_npm_component_require_global__["a" /* default */])('https://cdn.auth0.com/website/assets/pages/homepage/vendor/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.end(next);
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  renderLockPlayground();

  popoverEmbedWistia();

  var $ = window.$;
  var carouselControls = $('[data-slide="prev"], [data-slide="next"], [data-slide-to]');

  var lockPasswordless = new __WEBPACK_IMPORTED_MODULE_6_modules_interactive_widget__["a" /* default */]('#interactive-passwordless-section', 'passwordless', 'interactive-passwordless');

  setCarouselHeight();
  $(window).on('resize', setCarouselHeight);

  // Load Roboto Mono Font
  loadRobotoFont();

  // Add css animation
  $('.carousel').bind('slide.bs.carousel', function () {
    $('.slide-2 .illustration-aircraft, .slide-2 .illustration-phone, .slide-2 .sdks').addClass('animated');
  });

  // Track scroll until the widget is reached, then fire metrics event and unbind scroll
  $(window).on('scroll', trackScrollHomepage);

  // Track when carousel controls are clicked
  carouselControls.on('click', function () {
    __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:carousel');
  });

  // Init interactive locks
  lockPasswordless.init();

  $('#carousel').swiperight(function swiperight() {
    $(this).carousel('prev');
  });
  $('#carousel').swipeleft(function swipeleft() {
    $(this).carousel('next');
  });

  $('[data-toggle="tooltip"]').tooltip();

  $('a[data-toggle="tab"]').on('shown.bs.tab', function () {
    if (!lockPasswordless.fieldsReady) {
      lockPasswordless.initFields();
    }
  });

  next();
}

/**
 * Render playground lock
 */
function renderLockPlayground() {
  var el = document.getElementById('playground-next');

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["e" /* LockPlayground */], null), el);
}

/**
 *  load popover embeds wistia Video
 */
function popoverEmbedWistia() {
  var popoverOptions = 'autoPlay=true&controlsVisibleOnLoad=true&popover=true&version=v1&videoHeight=360&videoWidth=640';
  var hrefValue = '//fast.wistia.com/embed/iframe/fu7ww3h1yx?' + popoverOptions;
  var addAttr = function addAttr() {
    $('#wistia-popover').on('click', false);
    return $('.video-btn').attr('href', hrefValue);
  };

  $.when(addAttr()).done(function () {
    $.getScript('//fast.wistia.com/static/popover-v1.js');
  });
}

/**
* Set carousel height
*/
function setCarouselHeight() {
  var $ = window.$;
  var windowHeight = $(window).height();
  var headerHeight = $('.site-header-v2').outerHeight(true);
  var customersHeight = $('.customers').outerHeight();
  $('.carousel').height(windowHeight - headerHeight - customersHeight);
}

/**
 * Load Roboto font
 */
function loadRobotoFont() {
  window.WebFontConfig = {
    google: { families: ['Roboto+Mono:400,300,500,700:latin'] }
  };
  (function webfont() {
    var wf = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    wf.src = (document.location.protocol === 'https:' ? 'https' : 'http') + '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    s.parentNode.insertBefore(wf, s);
  })();
}

/**
 * Track scroll on homepage when widget is reached
 */
function trackScrollHomepage() {
  var $ = window.$;
  var widgetOffsetTop = $('#playground-next').parent().parent().offset().top;

  if ($(window).scrollTop() >= widgetOffsetTop) {
    __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('scroll:homepage');
    $(window).off('scroll', trackScrollHomepage);
  }
}

/**
 * Unsubscribe from window events
 */
function exit(ctx, next) {
  var $ = window.$;
  $(window).off('scroll', trackScrollHomepage);
  $(window).off('resize', setCarouselHeight);

  next();
}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__metadata_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug__);
/* eslint-env browser, jquery */
/* global WOW, imagesLoaded, Wistia, Auth0Lock */
// const debug = require('debug')('auth0:how-it-works');









var playVideoIntent = setTimeout(function () {}, 1),
    switchTabIntent = setTimeout(function () {}, 1);

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_modules_ab_page_js__["a" /* default */])('/jp/how-it-works', render, loadscripts, onPageReady);
}

function render(ctx, next) {
  preventScrolling(true);
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_6__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_3_domify___default()(__WEBPACK_IMPORTED_MODULE_7__dashboard_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_0_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadscripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_4_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/jquery.imagesloaded/4.1.0/imagesloaded.pkgd.min.js', 'imagesLoaded', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js', '$.fn.typetype', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//fast.wistia.com/assets/external/E-v1.js', 'Wistia', done);
  });

  batch.end(next);
}

function onPageReady(ctx, next) {
  // global Wistia options
  // for all videos!
  Wistia.options({
    videoQuality: 'hd-only',
    videoFoam: true,
    chromeless: true
  });

  // Tell wistia to initialize videos
  // manually...
  Wistia.embeds.setup();

  imagesLoaded('.jp-dashboard-page .page-hero', function () {
    initCoverPage(0);
  });

  initScrollAnimations();
  attachEvents();
  demoLock();

  next();
}

function demoLock() {
  var auth0IconUrl = 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png';

  var AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
  var AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;
  var AUTH0_CALLBACK_URL = window.APP_CONFIG.AUTH0_CALLBACK_URL;

  var demoOptions = {
    auth: { redirectUrl: AUTH0_CALLBACK_URL },
    theme: {
      logo: auth0IconUrl
    },
    rememberLastLogin: false,
    container: 'iphone',
    integratedWindowsLogin: false,
    socialButtonStyle: 'small',
    languageDictionary: {
      // eslint-disable-next-line max-len
      signUpTerms: 'By signing up, you agree to our <a href="/terms" target="_new">terms of service</a> and <a href="/privacy" target="_new">privacy policy</a>'
    }
  };

  var demo = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, demoOptions);
  demo.show();
}

function preventScrolling(activate) {
  var $body = $('body');

  $body.addClass('no-scroll');
  $body.bind('touchmove', function (e) {
    e.preventDefault();
  });

  if (!activate) {
    $body.removeClass('no-scroll');
    $body.unbind('touchmove');
  }
}

function requestAnimFrame(cb) {
  if (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame) {
    return requestAnimationFrame(cb) || webkitRequestAnimationFrame(cb) || mozRequestAnimationFrame(cb);
  } else {
    return setTimeout(cb, 1000 / 60);
  }
}

function animateEditUsers() {
  var $inputs = $('.js-edit-user-animation input');
  var $modal = $('.js-edit-user-animation .modal-edit-content');
  var $save = $('.js-edit-user-animation .btn');

  var steps = ['Ricardo Rauch', 'ricky@auth0.com', 'RickyRauch', 'Auth0', 'Buenos Aires, Argentina', 'http://auth0.com/'];

  function resetForm() {
    $save.text($save.data('o_val')).removeClass('focused');

    $modal.prepend('<div class="alert alert-success" style="font-size: 14px;">Changes saved</div>');

    setTimeout(function () {
      $modal.find('.alert').remove();
    }, 2000);
  }

  function modifyText(i, value, total) {
    return function () {
      var toCall = parseInt(i) + 1;

      $inputs.eq(i).data('o_val', $inputs.eq(i).val());
      $inputs.eq(i).addClass('focused').val('').delay(700).typetype(value, {
        e: 0.04,
        t: 85,
        callback: function callback() {
          $inputs.eq(i).removeClass('focused');

          if (toCall < total) {
            stack[toCall]();
          } else {
            save();
          }
        }
      });
    };
  }

  function save() {
    setTimeout(function () {
      $save.data('o_val', $save.text());
      $save.text('Saving...').addClass('focused');

      setTimeout(function () {
        resetForm();
      }, 400);
    }, 600);
  }

  var stack = {};

  for (var step in steps) {
    var current = steps[step];

    stack[step] = modifyText(step, current, steps.length);
  }

  stack[0]();
}

function initScrollAnimations() {
  var regularAnimations = new WOW({
    boxClass: 'js-animated',
    animateClass: 'animated',
    offset: 200,
    mobile: false,
    callback: function callback(box) {
      var $after = $(box).siblings().filter('.hide.js-animated-after');

      if ($after.length) {
        setTimeout(function () {
          $after.removeClass('hide').addClass('animated');
        }, 400);
      }

      if ($(box).find('.js-edit-user-animation').length) {
        animateEditUsers();
      }
    }
  });

  var screenshotsAnimation = new WOW({
    boxClass: 'js-contains-videos',
    animateClass: 'animated',
    offset: 0,
    mobile: false,
    callback: function callback(box) {
      var $playOnScroll = $(box).find('.lock-demo'),
          $phoneUp = $('.showcase-area .iphone-lock');

      var whenShowLock = 18;
      var whenChangeLogo = 23;
      var whenChangeSocial = 38;

      if ($playOnScroll.hasClass('wistia_embed')) {
        var video = Wistia.api($playOnScroll.data('source'));
        video && video.bind('secondchange', function (second) {
          if (second === whenShowLock) {
            $phoneUp.removeClass('hide');
          }

          if (second === whenChangeLogo) {
            $phoneUp.find('#iphone .auth0-lock-header-logo').attr('src', 'https://cdn.auth0.com/website/assets/pages/dashboard/img/sharelock-icon-19e529d979.svg');
            $phoneUp.find('.a0-avatar').addClass('a0-hide');
            $phoneUp.find('.a0-image').removeClass('a0-hide');
          }

          if (second === whenChangeSocial) {
            $phoneUp.find('#iphone').removeClass('lock-no-googleplus');
          }
        });

        video.play();
      }
    }
  });

  var profileAutoplay = new WOW({
    boxClass: 'js-switch-profile',
    animateClass: 'triggered',
    offset: -600,
    mobile: false,
    callback: function callback(box) {
      $('.js-switch-profile .profile.right img').trigger('click');

      // autoPlay commented that causes an error

      // setProfileAutoplay(2000);
    }
  });

  regularAnimations.init();
  screenshotsAnimation.init();
  profileAutoplay.init();
}

function profileSwitch(e) {
  var $clicked = $(this),
      $profiles = $('.js-switch-profile .profile'),
      $dots = $('.js-switch-profile .dot');

  if ($clicked.parent().hasClass('right')) {
    goToDirection('right');
  }

  if ($clicked.parent().hasClass('left')) {
    goToDirection('left');
  }

  if ($clicked.hasClass('dot')) {
    goToIndex();
  }

  if (window.profileAutoplay === false) {
    __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:dashboard-profiles');
  }

  function goToIndex() {
    var index = $clicked.index();
    var $target = $profiles.eq(index);

    $clicked = $target.find('img');

    if ($target.hasClass('center')) {
      return;
    }

    if ($target.hasClass('left')) {
      goToDirection('left');
    }

    if ($target.hasClass('right')) {
      goToDirection('right');
    }
  }

  function goToDirection(direction) {
    var inverse = direction === 'left' ? 'right' : 'left';

    $profiles.filter('.back').first().removeClass('back').addClass(direction);
    $profiles.filter('.' + inverse).removeClass(inverse).addClass('back');
    $profiles.filter('.center').removeClass('center').addClass(inverse);

    updateClicked();
  }

  function updateClicked() {
    $dots.removeClass('selected');

    $clicked.parent().removeClass('right left').addClass('center');

    $dots.eq($clicked.parent().index()).addClass('selected');
  }
}

function setProfileAutoplay(time) {
  if (!window.profileAutoplay) {
    window.profileAutoplay = setInterval(play, time);
  }

  $('.js-switch-profile').hover(function () {
    clearInterval(window.profileAutoplay);

    window.profileAutoplay = false;
  }, function () {
    if (!window.profileAutoplay) {
      window.profileAutoplay = setInterval(play, time);
    }
  });

  function play() {
    $('.js-switch-profile .profile.right img').trigger('click');
  }
}

function switchVideos(e) {
  e.preventDefault();
  e.stopPropagation();

  var $clicked = $(this);
  var index = $clicked.index();
  var $videos = $clicked.parents('.js-video-switcher').find('.video-wrapper');
  var $siblings = $videos.eq(index).siblings();

  if ($clicked.hasClass('active')) {
    return false;
  }

  __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:dashboard-tab-switcher', { tab: $clicked[0].className });

  // Set fadeout animation for current slide w/ custom duration
  $siblings.css({
    '-webkit-animation-duration': 400,
    'animation-duration': 400
  });

  $siblings.addClass('fadeOutDownBig');

  clearTimeout(playVideoIntent);
  clearTimeout(switchTabIntent);

  switchTabIntent = setTimeout(function () {
    // Reset animation duration, hide other tabs, remove fadeOut animation
    $siblings.removeAttr('style').addClass('hide').removeClass('fadeOutDownBig');

    $videos.eq(index).removeClass('hide');

    $clicked.siblings().removeClass('active');
    $clicked.addClass('active');

    $videos.eq(index).find('video').get(0).currentTime = 0;
  }, 300);

  // playVideoIntent = setTimeout(function() {
  //     $videos.eq(index).find('video').get(0).play();
  // }, 800);

  playVideoIntent = setTimeout(function () {
    var $videoMarkup = $('.js-video-switcher').find('.dash-demo'),
        $phoneUp = $('.screenshots .iphone-dash');

    if ($videoMarkup.hasClass('wistia_embed')) {
      var videoSource = Wistia.api($videoMarkup.data('source'));
      videoSource.bind('end', function (second) {
        $phoneUp.removeClass('hide');
      });
    }
  }, 300);
}

function attachEvents() {
  $('.jp-dashboard-page').on('click', '.js-switch-profile .profile img', profileSwitch).on('click', '.js-switch-profile .dot', profileSwitch).on('click', '.js-video-switcher .tab-list a', switchVideos);

  $('.mark-red .shape').hover(function () {
    $(this).parent('.mark-red').next('.tooltip').addClass('animated fadeInUp show');
  }, function () {
    $(this).parent('.mark-red').next('.tooltip').removeClass('animated fadeInUp show');
  });

  window.wistiaInit = function (W) {
    var $allVideos = $('.wistia_embed');

    $allVideos.each(function (i, el) {
      var video = W.api($(el).data('source'));

      video && video.bind('play', function () {
        __WEBPACK_IMPORTED_MODULE_2_modules_metrics__["a" /* default */].lib().track('click:dashboard-video', { video: this.name() });
      });
    });
  };
}

function initCoverPage(time) {
  preventScrolling(false);

  var $stack = $('.jp-dashboard-page .banner').find('.js-animation-stack');

  setTimeout(function () {
    $('.js-intro-text').removeClass('invisible').addClass('scaleIn');
    $('.jp-dashboard-page .spinner-container').fadeOut(300);

    setTimeout(function () {
      $('.jp-dashboard-page .banner .mobile-screen').removeClass('invisible');
      $('.jp-dashboard-page .banner .btn').removeClass('invisible').addClass('animated fadeIn');
      $('.jp-dashboard-page .banner .p-dashboard-1').removeClass('invisible').addClass('animated fadeInUp');
    }, 600);

    setTimeout(function () {
      $('.jp-dashboard-page .banner .p-dashboard-2').removeClass('invisible').addClass('animated fadeInUp');

      if ($stack.length) {
        var wait = 250;

        $stack.find('[data-order]').each(function () {
          var elem = $(this);
          var order = parseInt($(this).attr('data-order'));

          var timeout = setTimeout(function () {
            elem.removeClass('hide').addClass('animated');

            clearTimeout(timeout);
          }, wait * order);
        });
      }
    }, 1200);
  }, time || 600);
}

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__ = __webpack_require__(6);
/* eslint-env browser, jquery */


function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_ab_page_js__["a" /* default */])('/jp/learn/(.*)?', replace());
}

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx) {
    window.location.replace(path || ctx.path);
  };
}

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptloader__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scriptloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_metrics__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_batch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_batch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_ab_page_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__metadata_json__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__metadata_json__);
/* eslint-env browser, jquery */
/* global wistiaJQuery, WOW, Swiper, TimelineMax, TweenMax, hljs */












var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('auth0:why-auth0');

function register() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_modules_ab_page_js__["a" /* default */])('/jp/why-auth0', render, loadScripts, snippets);
}

function render(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_10__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_5_domify___default()(__WEBPACK_IMPORTED_MODULE_9__why_auth0_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_1_modules_section_content__["a" /* default */].render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  var batch = new __WEBPACK_IMPORTED_MODULE_7_batch___default.a();

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js', 'TweenMax', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TimelineMax.min.js', 'TimelineMax', done);
  });

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_2_scriptloader___default()('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/plugins/TextPlugin.min.js', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/highlight.js/8.4/highlight.min.js', 'hljs', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//cdnjs.cloudflare.com/ajax/libs/Swiper/3.0.5/js/swiper.min.js', 'Swiper', done);
  });

  batch.push(function (done) {
    __WEBPACK_IMPORTED_MODULE_2_scriptloader___default()('//fast.wistia.com/assets/external/popover-v1.js', done);
  });

  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_npm_component_require_global__["a" /* default */])('//fast.wistia.com/assets/external/iframe-api-v1.js', 'wistiaApi', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('body').addClass('loaded');

  if (window.wistiaJQuery) loadWistia();

  var vid = document.getElementById('why-video');

  function playVid() {
    vid.play();
  }

  $('a.play-me-again').on('click', function (e) {
    e.preventDefault();
    if (window.TimelineMax && window.TweenMax) scene1().resume();
    if (window.wistiaJQuery) playVid();
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('replay:get-started-animation');
  });

  $('.js-play-track').click(function (e) {
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-banner');
  });

  $('[data-toggle="tab"]').on('show.bs.tab', function (ev) {
    var target = $(this).attr('href');
    if ($(target).hasClass('active')) return;
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('viewed:old-new-tab', { value: target.slice(1) });
  });

  // show banner
  $('.banner .container h1, .banner .container p').addClass('animated fadeInDown').css('visibility', 'visible');
  $('.banner .container a').addClass('animated fadeInUp').css('visibility', 'visible');

  if (window.WOW) {
    var wow = new WOW({
      boxClass: 'start-steps',
      mobile: true,
      live: true,
      callback: function callback() {
        if (window.TimelineMax && window.TweenMax) scene1().resume();
        if (window.wistiaJQuery) playVid();
      }
    });
    wow.init();
  }

  if (window.hljs) hljs.initHighlightingOnLoad();

  $('nav.nav-pills.no-mobile a').hover(function (e) {
    e.preventDefault();
    $('nav.nav-pills.no-mobile a').removeClass('active');
    $(this).click().addClass('active');
  });

  if (window.Swiper) {
    var mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 2,
      centeredSlides: true,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 30,
      onSlideChangeEnd: function onSlideChangeEnd() {
        $('a.swiper-slide').removeClass('active');
        $('a.swiper-slide-active').click().addClass('active');
      }
    });
  }

  next();
}

function loadWistia() {
  var transitioned = 0;
  wistiaJQuery(document).bind('wistia-popover-open', function () {
    $('.banner .container h1, .banner .container p').addClass('animated fadeOutUp');
    $('.banner .container a').addClass('animated fadeOutDown');
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('open:video-popup');
  });

  wistiaJQuery(document).bind('wistia-popover', function (ev, iframe) {
    transitioned = 0;
    var api = iframe.wistiaApi;
    api.bind('secondchange', function (s) {
      transitioned = s;
      if (s && !(s % 10)) {
        // every 10 seconds, we trigger a length event
        __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('viewed:video-length', { value: transitioned });
      }
    });
    api.bind('play', function () {
      __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-play', { value: transitioned });
    });
    api.bind('pause', function () {
      __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('click:video-pause', { value: transitioned });
    });
  });

  wistiaJQuery(document).bind('wistia-popover-close', function () {
    $('.banner .container h1, .banner .container p').removeClass('animated fadeOutUp').addClass('animated fadeInDown');
    $('.banner .container a').removeClass('animated fadeOutDown').addClass('animated fadeInUp');
    __WEBPACK_IMPORTED_MODULE_4_modules_metrics__["a" /* default */].lib().track('close:video-popup', { value: transitioned });
    transitioned = 0;
  });
}

function scene1() {
  var timeline = new TimelineMax({
    onComplete: function onComplete() {
      scene2().resume();
    }
  });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s4').removeClass('active');
  }), 0).to('.play-me-again', 0, {
    display: 'none',
    opacity: 1
  }, 0);

  // end reset

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s1').addClass('active');
  }), 0);

  timeline.pause();
  return timeline;
}

function scene2() {
  var timeline = new TimelineMax({
    onComplete: function onComplete() {
      scene3().resume();
    }
  });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s1').removeClass('active');
  }), 4.7).add(TweenMax.delayedCall(0, function () {
    $('.step.s2').addClass('active');
  }), 4.7);

  timeline.pause();
  return timeline;
}

function scene3() {
  var timeline = new TimelineMax({
    onComplete: function onComplete() {
      scene4().resume();
    }
  });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s2').removeClass('active');
  }), 1.5).add(TweenMax.delayedCall(0, function () {
    $('.step.s3').addClass('active');
  }), 1.5);

  timeline.pause();
  return timeline;
}

function scene4() {
  var timeline = new TimelineMax({ onComplete: stepScenesComplete });

  timeline.add(TweenMax.delayedCall(0, function () {
    $('.step.s3').removeClass('active');
  }), 6).add(TweenMax.delayedCall(0, function () {
    $('.step.s4').addClass('active');
  }), 6).to('.play-me-again', 0.5, {
    display: 'block',
    opacity: 1
  }, 15);

  timeline.pause();
  return timeline;
}

function stepScenesComplete() {
  debug('scenes completed succesfully!');
}

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderNotfound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_domify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_domify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_website_404_error_page_build_website_404_error_page_pug__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_website_404_error_page_build_website_404_error_page_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_website_404_error_page_build_website_404_error_page_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_section_content__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_json__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__metadata_json__);





function renderNotfound(ctx, next) {
  var renderOptions = Object.assign({
    metadata: __WEBPACK_IMPORTED_MODULE_3__metadata_json___default.a
  }, ctx.init ? {} : { view: __WEBPACK_IMPORTED_MODULE_0_domify___default()(__WEBPACK_IMPORTED_MODULE_1_website_404_error_page_build_website_404_error_page_pug___default()()) });
  __WEBPACK_IMPORTED_MODULE_2_modules_section_content__["a" /* default */].render(renderOptions);
  next();
}

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(93);



var Card = function Card(_ref) {
  var link = _ref.link,
      title = _ref.title,
      fullDate = _ref.fullDate;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: 'box' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        className: 'box-link-wrapper',
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer',
        title: title
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'box-article' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'box-inner-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'time',
            { className: 'box-date' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* dateCardFormat */])(fullDate)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'box-title' },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'box-link' },
            'Read more ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon icon-budicon-461', 'aria-hidden': 'true' })
          )
        )
      )
    )
  );
};

Card.propTypes = {
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["a"]; });



/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(39);



var CardContainer = function CardContainer(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      title = _ref.title,
      iconUrl = _ref.iconUrl,
      alt = _ref.alt,
      link = _ref.link,
      linkText = _ref.linkText,
      _ref$isNews = _ref.isNews,
      isNews = _ref$isNews === undefined ? false : _ref$isNews;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: 'section-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: iconUrl, alt: alt })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            title
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'box-grid-module' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'box-grid' },
            items.map(function (item, index) {
              if (index === 0 || items.length < 4) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* ImageCard */], {
                  key: index,
                  link: item.link,
                  title: item.title,
                  fullDate: item.fullDate,
                  description: item.description,
                  thumbnail: item.thumbnail,
                  isNews: isNews
                });
              }
              return index < 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["e" /* Card */], { key: index, link: item.link, title: item.title, fullDate: item.fullDate }) : null;
            })
          )
        )
      )
    ),
    items.length > 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'see-all-link', href: link },
            linkText,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon icon-budicon-461', 'aria-hidden': 'true' })
          )
        )
      )
    ) : null
  );
};

CardContainer.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  })),
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  iconUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  linkText: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  alt: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  isNews: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = (CardContainer);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardContainer__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CardContainer__["a"]; });



/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(39);




var CardFetchContainer = function CardFetchContainer(_ref) {
  var fetch = _ref.fetch,
      title = _ref.title,
      iconUrl = _ref.iconUrl,
      alt = _ref.alt,
      linkText = _ref.linkText,
      link = _ref.link,
      isNews = _ref.isNews;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["b" /* PromiseStateContainer */], {
    ps: __WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"].race([fetch]),
    onFulFillment: function onFulFillment(response) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["c" /* CardContainer */], {
        title: title,
        iconUrl: iconUrl,
        alt: alt,
        linkText: linkText,
        link: link,
        items: response,
        isNews: isNews
      });
    }
  });
};

CardFetchContainer.propTypes = {
  fetch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]).isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  iconUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  linkText: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  alt: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  isNews: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = (CardFetchContainer);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardFetchContainer__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CardFetchContainer__["a"]; });



/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DownloadLink = function DownloadLink(_ref) {
  var link = _ref.link;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    { className: "resource-download", href: link, download: true, target: "_blank", rel: "noopener noreferrer" },
    "Download",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon icon-budicon-461", "aria-hidden": "true" })
  );
};

DownloadLink.propTypes = {
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadLink);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DownloadLink__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DownloadLink__["a"]; });



/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Dropdown = function Dropdown(_ref) {
  var onChange = _ref.onChange,
      title = _ref.title,
      values = _ref.values;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "filter" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { htmlFor: "year-dropdow" },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "select-wrapper" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        { onChange: onChange, id: "year-dropdow" },
        values.map(function (value, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "option",
            { key: index, value: value },
            value
          );
        })
      )
    )
  );
};

Dropdown.propTypes = {
  onChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  values: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });



/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(93);



var ImageCard = function ImageCard(_ref) {
  var link = _ref.link,
      title = _ref.title,
      fullDate = _ref.fullDate,
      description = _ref.description,
      thumbnail = _ref.thumbnail,
      _ref$isNews = _ref.isNews,
      isNews = _ref$isNews === undefined ? false : _ref$isNews;

  var getMarkup = function getMarkup() {
    return description;
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: 'box-image-card box' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: 'box-link', href: link, target: '_blank', rel: 'noopener noreferrer', title: title },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'box-article' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'box-image-wrapper',
            style: isNews ? { backgroundImage: 'url(' + thumbnail + ')' } : null
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', className: 'box-image', src: thumbnail })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'box-inner-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'time',
            { className: 'box-date' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* dateCardFormat */])(fullDate)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'box-title' },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'box-description', dangerouslySetInnerHTML: { __html: getMarkup() } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'box-link' },
            'Read more ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon icon-budicon-461', 'aria-hidden': 'true' })
          )
        )
      )
    )
  );
};

ImageCard.propTypes = {
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  isNews: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool
};

/* harmony default export */ __webpack_exports__["a"] = (ImageCard);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageCard__ = __webpack_require__(648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ImageCard__["a"]; });



/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(93);



var renderItem = function renderItem(item, index) {
  var getMarkup = function getMarkup() {
    return item.description;
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      key: index,
      className: 'news',
      href: item.link,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: item.title
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'article',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'time',
        { dateTime: '2016-08-24' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* fullDateFormat */])(item.fullDate)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'articles-details' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          null,
          item.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { dangerouslySetInnerHTML: { __html: getMarkup() } })
      )
    )
  );
};

var List = function List(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'col-sm-12' },
    items.map(function (_ref2, index) {
      var dates = _ref2.dates;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'month-divider' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["g" /* dateFormat */])(dates[0].fullDate)
        ),
        dates.map(renderItem)
      );
    })
  );
};

List.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    textDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    dates: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
      link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
      title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
      date: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
      description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
      thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
      fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
    })).isRequired
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(650);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });



/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Loader = function Loader() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "press-custom-loader spinner spinner-md is-auth0" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "circle" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });



/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(39);



var MainResources = function MainResources(_ref) {
  var assetsDownloadLink = _ref.assetsDownloadLink;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'col-sm-12' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      { className: 'resource-headline' },
      'Auth0 Logos'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'resource-subheadline' },
      'Auth0\u2019s blue logo works best on light backgrounds; the grey one is designed for dark backgrounds.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-blue-2b48b6384e.svg', alt: 'Auth0 Logo Blue' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-grey-eb7ddbce00.svg', alt: 'Auth0 Logo Grey' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["m" /* DownloadLink */], { link: assetsDownloadLink })
  );
};

MainResources.propTypes = {
  assetsDownloadLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MainResources);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainResources__ = __webpack_require__(654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MainResources__["a"]; });



/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PromiseStateContainer = function (_Component) {
  _inherits(PromiseStateContainer, _Component);

  function PromiseStateContainer() {
    _classCallCheck(this, PromiseStateContainer);

    return _possibleConstructorReturn(this, (PromiseStateContainer.__proto__ || Object.getPrototypeOf(PromiseStateContainer)).apply(this, arguments));
  }

  _createClass(PromiseStateContainer, [{
    key: 'isEmptyObject',
    value: function isEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ps = _props.ps,
          onPending = _props.onPending,
          onNoResults = _props.onNoResults,
          onRejection = _props.onRejection,
          onFulFillment = _props.onFulFillment;


      if (ps.pending) {
        return onPending(ps.meta);
      }

      if (ps.rejected) {
        return onRejection(ps.reason, ps.meta);
      }

      if (ps.fulfilled && this.isEmptyObject(ps.value)) {
        return onNoResults(ps.value, ps.meta);
      }

      if (ps.fulfilled) {
        return onFulFillment(ps.value, ps.meta);
      }

      return null;
    }
  }]);

  return PromiseStateContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PromiseStateContainer.propTypes = {
  ps: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]).isRequired,
  onPending: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onNoResults: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onRejection: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,
  onFulFillment: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired
};
PromiseStateContainer.defaultProps = {
  onPending: function onPending() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Loader */], null);
  },
  onNoResults: function onNoResults() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
  },
  onRejection: function onRejection(reason) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      reason
    );
  }
};


/* harmony default export */ __webpack_exports__["a"] = (PromiseStateContainer);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PromiseStateContainer__ = __webpack_require__(656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PromiseStateContainer__["a"]; });



/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Resource = function Resource(_ref) {
  var src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === undefined ? '' : _ref$alt;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'resource' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'asset' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'asset-image-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: src, alt: alt })
      )
    )
  );
};

Resource.propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  alt: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (Resource);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__(658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Resource__["a"]; });



/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(39);



var ResourcesContainer = function ResourcesContainer(_ref) {
  var mainAssetsDownloadLink = _ref.mainAssetsDownloadLink,
      secondaryAssetsDownloadLink = _ref.secondaryAssetsDownloadLink;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'col-sm-12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: 'section-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: 'https://cdn.auth0.com/website/assets/pages/press/img/icon-image-60cc4b34ca.svg', alt: 'Announcements icon' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Media Resources'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'row resources-grid' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["j" /* MainResources */], { assetsDownloadLink: mainAssetsDownloadLink }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["k" /* SecondaryResources */], { assetsDownloadLink: secondaryAssetsDownloadLink })
    )
  );
};

ResourcesContainer.propTypes = {
  mainAssetsDownloadLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  secondaryAssetsDownloadLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ResourcesContainer);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResourcesContainer__ = __webpack_require__(660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ResourcesContainer__["a"]; });



/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(93);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SearchArticles = function (_Component) {
  _inherits(SearchArticles, _Component);

  function SearchArticles() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchArticles);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchArticles.__proto__ || Object.getPrototypeOf(SearchArticles)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      search: '',
      searchArticles: []
    }, _this.updateSearch = function (event) {
      _this.setState({ search: event.target.value }, _this.filterArticlesWithSearch);
    }, _this.filterArticlesByYear = function (event) {
      var year = event.target.value;
      _this.setState({ search: ' ', searchArticles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* filterByYear */])(_this.props.items, year) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchArticles, [{
    key: 'filterArticlesWithSearch',
    value: function filterArticlesWithSearch() {
      var options = {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 1000,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [{
          name: 'title',
          weight: 0.5
        }, {
          name: 'description',
          weight: 0.2
        }, {
          name: 'fullDateFormat1',
          weight: 0.1
        }, {
          name: 'fullDateFormat2',
          weight: 0.1
        }, {
          name: 'fullDateFormat3',
          weight: 0.1
        }]
      };

      var articles = this.props.items.map(function (item) {
        return Object.assign({
          fullDateFormat1: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* fullDateFormat */])(item.fullDate),
          fullDateFormat2: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* fullDateFormat2 */])(item.fullDate),
          fullDateFormat3: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* fullDateFormat3 */])(item.fullDate)
        }, item);
      });

      var fuse = new __WEBPACK_IMPORTED_MODULE_1_fuse_js___default.a(articles, options);

      if (this.state.search.length) {
        var fuseSearch = fuse.search(this.state.search);
        this.setState({ searchArticles: fuseSearch });
      } else {
        this.setState({ searchArticles: this.props.items });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backUrl = _props.backUrl,
          title = _props.title,
          items = _props.items;
      var _state = this.state,
          search = _state.search,
          searchArticles = _state.searchArticles;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'articles-list' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'articles-list-back' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: backUrl },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon icon-budicon-463', 'aria-hidden': 'true' }),
                  ' Back'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-12 col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'articles-list-title' },
                title
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-sm-12 col-md-8' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'search-filter-bar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["f" /* SearchField */], {
                  type: 'text',
                  id: 'search-input',
                  placeholder: 'Search',
                  value: search,
                  onChange: this.updateSearch
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["g" /* Dropdown */], {
                  onChange: this.filterArticlesByYear,
                  title: 'Browse by Year',
                  values: ['2017', '2016', '2015', '2014']
                })
              )
            ),
            search.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["h" /* SimpleList */], { items: searchArticles }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["i" /* List */], { items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* articlesGroupByMonthYear */])(items) })
          )
        )
      );
    }
  }]);

  return SearchArticles;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchArticles.propTypes = {
  backUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    date: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (SearchArticles);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchArticles__ = __webpack_require__(662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchArticles__["a"]; });



/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var SearchField = function SearchField(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "search" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "form",
      { className: "search-form" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "form-group search-control" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "icon-budicon-489" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({}, props, { className: "search-input form-control" }))
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchField);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchField__ = __webpack_require__(664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchField__["a"]; });



/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(39);



var SecondaryResources = function SecondaryResources(_ref) {
  var assetsDownloadLink = _ref.assetsDownloadLink;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'col-sm-12' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      { className: 'resource-headline' },
      'Badge and Product\'s Logos'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'resource-subheadline' },
      'Lock and Passwordless logos work best on dark backgrounds; Guardian and Webtask\u2019s logos are designed for light backgrounds.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'badge-product-grid' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-badge-bac0053249.svg', alt: '' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/lock-logo-7551a9d4a7.svg', alt: '' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/passwordless-logo-e6c31b9edb.svg', alt: '' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/guardian-logo-f355280dcb.svg', alt: '' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["l" /* Resource */], { src: 'https://cdn.auth0.com/website/assets/pages/press/img/resources/webtask-logo-f479cae0f6.svg', alt: '' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["m" /* DownloadLink */], { link: assetsDownloadLink })
  );
};

SecondaryResources.propTypes = {
  assetsDownloadLink: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SecondaryResources);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SecondaryResources__ = __webpack_require__(666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SecondaryResources__["a"]; });



/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(93);



var renderItem = function renderItem(item, index) {
  var getMarkup = function getMarkup() {
    return item.description;
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      key: index,
      className: 'news',
      href: item.link,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: item.title
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'article',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'time',
        { dateTime: '2016-08-24' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* fullDateFormat */])(item.fullDate)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'articles-details' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          null,
          item.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { dangerouslySetInnerHTML: { __html: getMarkup() } })
      )
    )
  );
};

var SimpleList = function SimpleList(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'col-sm-12 simple-list-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      items.map(renderItem)
    )
  );
};

SimpleList.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    date: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleList);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleList__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SimpleList__["a"]; });



/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(39);




var App = function App(_ref) {
  var news = _ref.news,
      announcements = _ref.announcements,
      route = _ref.route;

  if (route === 'press') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers__["b" /* Details */], { news: news, announcements: announcements, route: route });
  }

  if (route === 'news') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers__["c" /* Articles */], { title: 'In the News', items: news, route: route });
  }

  if (route === 'announcements') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers__["c" /* Articles */], { title: 'Announcements', items: announcements, route: route });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* Loader */], null);
};

var itemValidation = {
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  author: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  avatar: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

App.propTypes = {
  announcements: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape(itemValidation)),
  news: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape(itemValidation)),
  route: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });



/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-env browser*/





var Articles = function (_Component) {
  _inherits(Articles, _Component);

  function Articles() {
    _classCallCheck(this, Articles);

    return _possibleConstructorReturn(this, (Articles.__proto__ || Object.getPrototypeOf(Articles)).apply(this, arguments));
  }

  _createClass(Articles, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.scrollTo(0, this.articlesNode.offsetTop);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          items = _props.items,
          articlesFetch = _props.articlesFetch;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { ref: function ref(elem) {
            return _this2.articlesNode = elem;
          } },
        items ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["n" /* SearchArticles */], { title: title, items: items, backUrl: '/press' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["b" /* PromiseStateContainer */], {
          ps: __WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"].race([articlesFetch]),
          onFulFillment: function onFulFillment(response) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["n" /* SearchArticles */], { title: title, items: response, backUrl: '/press' });
          }
        })
      );
    }
  }]);

  return Articles;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Articles.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
  })),
  articlesFetch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_1_react_refetch__["PromiseState"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__connect__["a" /* articlesConnect */])(Articles));

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Articles__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Articles__["a"]; });



/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connect__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(39);




var News = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connect__["b" /* newsConnect */])(function (_ref) {
  var newsFetch = _ref.newsFetch;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["o" /* CardFetchContainer */], {
    fetch: newsFetch,
    title: 'In the News',
    iconUrl: 'https://cdn.auth0.com/website/assets/pages/press/img/icon-news-74f3d405f9.svg',
    alt: 'News icon',
    linkText: 'See all News',
    link: '/press/news',
    isNews: true
  });
});

var Announcements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connect__["c" /* announcementsConnect */])(function (_ref2) {
  var announcementsFetch = _ref2.announcementsFetch;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["o" /* CardFetchContainer */], {
    fetch: announcementsFetch,
    title: 'Announcements',
    iconUrl: 'https://cdn.auth0.com/website/assets/pages/press/img/icon-announ-425ce9b8db.svg',
    alt: 'Announcements icon',
    linkText: 'See all Announcements',
    link: '/press/announcements'
  });
});

var Details = function Details(_ref3) {
  var announcements = _ref3.announcements,
      news = _ref3.news;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'section-announcements' },
      announcements ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["c" /* CardContainer */], {
        title: 'Announcements',
        iconUrl: 'https://cdn.auth0.com/website/assets/pages/press/img/icon-announ-425ce9b8db.svg',
        alt: 'Announcements icon',
        linkText: 'See all Announcements',
        link: '/press/announcements',
        items: announcements
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Announcements, null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'section-news' },
      news ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["c" /* CardContainer */], {
        title: 'In the News',
        iconUrl: 'https://cdn.auth0.com/website/assets/pages/press/img/icon-news-74f3d405f9.svg',
        alt: 'News icon',
        linkText: 'See all News',
        link: '/press/news',
        items: news,
        isNews: true
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(News, null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'section',
      { className: 'section-media' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["p" /* ResourcesContainer */], {
        mainAssetsDownloadLink: 'https://cdn2.auth0.com/website/auth0-assets-logos.zip',
        secondaryAssetsDownloadLink: 'https://cdn2.auth0.com/website/auth0-assets-badge-products-logos.zip'
      })
    )
  );
};

var propsValidation = {
  link: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  thumbnail: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  fullDate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

Details.propTypes = {
  announcements: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape(propsValidation)),
  news: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape(propsValidation))
};

/* harmony default export */ __webpack_exports__["a"] = (Details);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Details__ = __webpack_require__(674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Details__["a"]; });



/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PlansMeta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* global FeatureWidget */


function PlansMeta(data) {
  this.plans = data.plans;
}

PlansMeta.prototype.getPlan = function (name) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.plans.models, function (plan) {
    return plan.plan === name;
  });
};

PlansMeta.prototype.getUserLimit = function (plan) {
  return this.getPlan(plan).findPlanFeatureByKey('users_count').getUserLimit();
};

PlansMeta.prototype.getFeatureProp = function (plan, feature, prop) {
  var value = (this.getPlan(plan).findPlanFeatureByKey(feature) || {})[prop];

  if (value === Infinity) {
    value = 'Unlimited';
  }

  return value;
};

PlansMeta.load = function () {
  return new PlansMeta({ plans: new FeatureWidget().plans });
};

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FeaturesPartial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feature_widget_pug__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feature_widget_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__feature_widget_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__features_table_pug__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__features_table_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__features_table_pug__);
/* eslint-env browser, jquery */
/* global FeatureWidget */




function FeaturesPartial(options) {
  options = options || {};

  this.track = options.track;
}

FeaturesPartial.prototype.load = function (batch) {
  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_modules_npm_component_require_global__["a" /* default */])('//cdn2.auth0.com/js/feature-widget/feature-widget-1.3.min.js', 'FeatureWidget', done);
  });
};

FeaturesPartial.prototype.activate = function () {
  this.$plans = $('[data-plan]');
  this.setFilterPlans('self_service');
};

FeaturesPartial.prototype.render = function () {
  var _this = this;

  var filterFeaturesThatAreAtLeastInOnePlan = FeatureWidget.filter.filterFeaturesThatAreAtLeastInOnePlan(this.filterPlans.bind(this));
  var filterActiveFeatures = FeatureWidget.filter.filterActiveFeatures();

  this.$plans.each(function (i, planContainer) {
    var $planContainer = $(planContainer);
    var planKey = $planContainer.data('plan');
    var $widgetContainer = $planContainer.find('.js-plan-features-container');

    var widget = new FeatureWidget({
      template: function template(locals) {
        return __WEBPACK_IMPORTED_MODULE_1__feature_widget_pug___default()(Object.assign({}, locals, { planKey: planKey }));
      },
      filterPlans: _this.filterPlans,
      filterFeatures: function filterFeatures(feature) {
        return filterFeaturesThatAreAtLeastInOnePlan(feature) && filterActiveFeatures(feature) && !/users_count|employees_count|social_connections|enterprise_connections/.test(feature.key);
      },

      sortPlans: FeatureWidget.sort.plansByNumberOfFeaturesTheyHave(false),
      sortFeatures: FeatureWidget.sort.featuresByNumberOfPlansTheyAre(true),
      sortTags: _this.sortTags()
    });

    $widgetContainer.html(widget.render());

    // Features table

    var $tableContainer = $('.js-features-table-container');

    var table = new FeatureWidget({
      template: function template(locals) {
        return __WEBPACK_IMPORTED_MODULE_2__features_table_pug___default()(Object.assign({}, locals));
      },
      filterPlans: _this.filterPlans,
      filterFeatures: function filterFeatures(feature) {
        return filterFeaturesThatAreAtLeastInOnePlan(feature) && filterActiveFeatures(feature);
      },

      sortPlans: FeatureWidget.sort.plansByNumberOfFeaturesTheyHave(false),
      sortFeatures: FeatureWidget.sort.featuresByNumberOfPlansTheyAre(true),
      sortTags: _this.sortTags()
    });

    $tableContainer.html(table.render());
  });
};

FeaturesPartial.prototype.sortTags = function () {
  var defaultSorter = FeatureWidget.sort.tagsByNumberOfFeatures(true);

  // we want to place the category 'Support' just after 'Authentication'
  // the rest of the categories will follow the featuresByNumberOfPlansTheyAre
  // sorter
  return function (tag1, tag2) {
    if (tag1.key === 'Authentication' && tag2.key === 'Support') {
      return -1;
    }

    if (tag1.key === 'Support' || tag2.key === 'Support') {
      return 1;
    }

    return defaultSorter(tag1, tag2);
  };
};

FeaturesPartial.prototype.setFilterPlans = function (type) {
  this.currentMode = type;

  this.filterPlans = function (plan) {
    var isNewPlan = ~['free', 'developer', 'developer-pro', 'enterprise'].indexOf(plan.plan);
    return plan.type.toLowerCase() === type && isNewPlan;
  };
};

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PricingPartial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_loggedin__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_bus__ = __webpack_require__(33);
/* eslint-env browser, jquery */
/* global PricingWidget */





function PricingPartial(options) {
  options = options || {};

  this.track = options.track;

  // Expose widgets for AB Testing
  window.pricingWidgets = [];

  this.featuresPartial = options.featuresPartial;

  this.onLoggedinChange = this.onLoggedinChange.bind(this);
}

PricingPartial.prototype.load = function (batch) {
  batch.push(function (done) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_npm_component_require_global__["a" /* default */])('//cdn2.auth0.com/pricing-widget/pricing-widget-4.3.min.js', 'PricingWidget', done);
  });
};

PricingPartial.prototype.activate = function () {
  var _this = this;

  this.$plans = $('[data-plan]');

  $('.js-see-all-type-features').click(this.onSeeAllTypeFeatures.bind(this));

  this.$plans.each(function (index, el) {
    var $el = $(el);
    $el.on('click', '.js-plan-contact-sales', _this.onContactSales.bind(_this));
  });

  __WEBPACK_IMPORTED_MODULE_2_modules_loggedin__["a" /* default */].onChange(this.onLoggedinChange);

  __WEBPACK_IMPORTED_MODULE_3_modules_npm_component_bus__["a" /* default */].on('page:change', this.onDestroy.bind(this));
};

PricingPartial.prototype.onDestroy = function () {
  __WEBPACK_IMPORTED_MODULE_2_modules_loggedin__["a" /* default */].removeChangeListener(this.onLoggedinChange);
};

PricingPartial.prototype.onLoggedinChange = function (loggedin) {
  this.$plans = $('[data-plan]');
  this.$plans.each(function (index, el) {
    var $el = $(el);
    if (loggedin) {
      $el.find('.js-start-now').addClass('hide');
      $el.find('.js-buy-now').removeClass('hide');
    } else {
      $el.find('.js-start-now').removeClass('hide');
      $el.find('.js-buy-now').addClass('hide');
    }
  });
};

PricingPartial.prototype.render = function () {
  var _this2 = this;

  this.$plans.each(function (i, planContainer) {
    var planKey = planContainer.getAttribute('data-plan');
    var widget = new PricingWidget(planContainer);
    window.pricingWidgets.push(widget);

    widget.on(widget.events.SUBSCRIPTION_COST_CHANGED, _this2.onSubscriptionCostChange.bind(_this2, planContainer));

    widget.on(widget.events.SUBSCRIPTION_CHECKOUT, _this2.onStartNow.bind(_this2));
  });
};

PricingPartial.prototype.onSubscriptionCostChange = function (planContainer, cost, planType, users, recurrence, appliesForCustomDeal) {
  var planKey = planContainer.getAttribute('[data-plan]');
  this.disablePlanCheckout(planContainer, planType !== 'free' && !cost);

  this.track('change:plan-subscription-cost:' + planKey, {
    plan: planKey,
    type: planType,
    users: users,
    recurrence: recurrence,
    appliesForCustomDeal: appliesForCustomDeal
  });
};

PricingPartial.prototype.disablePlanCheckout = function (planContainer, shouldDisable) {
  $(planContainer).find('[data-plan-checkout]').attr('disabled', shouldDisable);
};

PricingPartial.prototype.onSeeAllFeatures = function (event) {
  var planKey = this._getPlanKey(event);

  event.preventDefault();

  this.featuresPartial.setPlanHighlighting(planKey);

  this.track('click:plan-see-all-features:' + planKey, { plan: planKey });
};

PricingPartial.prototype.onSeeAllTypeFeatures = function (event) {
  var planType = $(event.target).data('planType');

  this.featuresPartial.moveTo(planType);

  this.track('click:plan-see-all-features-type:' + planType, { planType: planType });
};

PricingPartial.prototype.onStartNow = function (subscription) {
  var qsPayload = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({
    type: subscription.plan,
    users: subscription.users,
    recurrence: subscription.recurrence
  });

  window.signup(null, { authParams: { state: qsPayload } });

  this.track('click:plan-start-now:' + subscription.plan, { plan: subscription.plan });
};

PricingPartial.prototype.setRecurrence = function (recurrence) {
  window.pricingWidgets.forEach(function (widget) {
    widget.setRecurrence(recurrence);
  }, this);

  this.track('select:pricing-packages-interval', { value: recurrence });
};

PricingPartial.prototype.onContactSales = function (event) {
  var planKey = this._getPlanKey(event);

  this.track('click:plan-contact-sales:' + planKey, { plan: planKey });
};

PricingPartial.prototype._getPlanKey = function (event) {
  return $(event.target).closest('[data-plan]').data('plan');
};

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(237);



var Card = function Card(_ref) {
  var label = _ref.label,
      className = _ref.className,
      title = _ref.title,
      imageUrl = _ref.imageUrl,
      url = _ref.url;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'resource flex-item ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        style: __WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* isSafariBrowser */] ? { '-webkit-flex': '1 1 29em' } : null,
        className: 'resource-link-wrapper',
        href: url,
        rel: 'noopener noreferrer',
        target: '_blank'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'resource-label' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          label
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'resource-image' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imageUrl, alt: title })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'resource-details' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'resource-title' },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'resource-link' },
          'Learn More '
        )
      )
    )
  );
};

Card.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  imageUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["a"]; });



/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_contact_form__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_auth0_contact_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_auth0_contact_form__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Hero = function (_Component) {
  _inherits(Hero, _Component);

  function Hero() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Hero);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hero.__proto__ || Object.getPrototypeOf(Hero)).call.apply(_ref, [this].concat(args))), _this), _this.contactUsHandler = function () {
      _this.salesContactForm.show();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContactForm();
    }
  }, {
    key: 'createContactForm',
    value: function createContactForm() {
      /* eslint-env browser */
      var metricsLib = window.metricsLib;
      var mouseFlow = window.mouseflow || undefined;
      var salesContactFormOptions = {
        onModalOpen: function onModalOpen() {
          metricsLib.track('click:contact-sales');
        },
        onFormSuccess: function onFormSuccess(metricsData) {
          metricsLib.track('register:lead:resources-contact-form', metricsData);
          mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
        },
        onFormFail: function onFormFail(metricsData) {
          metricsLib.track('fail:register:lead:resources-contact-form', metricsData);
          mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
        },

        source: 'resources-page'
      };
      this.salesContactForm = new __WEBPACK_IMPORTED_MODULE_1_auth0_contact_form___default.a(salesContactFormOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'hero-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row vertical-align ' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12 col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'hero-title' },
                'Resources'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'hero-subtitle' },
                'Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'javascript:signup()', className: 'btn btn-success btn-lg' },
                  'Use auth0 for free'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    onClick: this.contactUsHandler,
                    className: 'btn btn-transparent btn-lg js-general-contact-sales open-contact-form-modal'
                  },
                  'Contact us'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 hidden-xs hidden-sm' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                className: 'hero-image',
                src: 'https://cdn.auth0.com/website/assets/pages/resources/img/hero-illustration-2-23ebe524c6.svg',
                alt: 'resources'
              })
            )
          )
        )
      );
    }
  }]);

  return Hero;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Hero);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hero__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Hero__["a"]; });



/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(145);



var List = function List(_ref) {
  var items = _ref.items;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'row' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'col-xs-12' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'resources flex-wrapper webinar' },
        items && items.length ? items.map(function (_ref2, index) {
          var label = _ref2.label,
              className = _ref2.className,
              title = _ref2.title,
              imageUrl = _ref2.imageUrl,
              url = _ref2.url;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["e" /* Card */], {
            key: index,
            label: label,
            className: label,
            title: title,
            imageUrl: imageUrl,
            url: url
          });
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'There isn\'t any resource yet.'
        )
      )
    )
  );
};

List.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    imageUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  })).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });



/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(237);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-env browser */




var selectHandler = function selectHandler(event) {
  var value = event.target.value;
  __WEBPACK_IMPORTED_MODULE_1_page___default()(value);
};

var getURL = function getURL(route) {
  if (route === 'home') return '/resources';
  if (route === 'whitepapers') return '/resources/whitepapers';
  if (route === 'webinars') return '/resources/webinars';
  if (route === 'videos') return '/resources/videos';
  if (route === 'ebooks') return '/resources/ebooks';
  return '/';
};

var SearchBar = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    _classCallCheck(this, SearchBar);

    return _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).apply(this, arguments));
  }

  _createClass(SearchBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.countHelper = 0;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.countHelper += 1;
      if (this.countHelper > 1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["b" /* scrollToDOMElement */])(this.categoryContainer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          searchValue = _props.searchValue,
          onInputChange = _props.onInputChange,
          route = _props.route,
          firstTabIsSelected = _props.firstTabIsSelected;

      var selectValue = getURL(route);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: function ref(el) {
            _this2.categoryContainer = el;
          },
          className: 'category-bar-wrapper'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-xs-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'category-bar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'categories-nav-holder hidden-xs hidden-sm' },
                  firstTabIsSelected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'nav nav-categories nav-center nav-tabs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'category active link-disabled-utils', 'data-category': 'all' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources' },
                        'All'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'category', 'data-category': 'all' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/whitepapers' },
                        'Whitepapers'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'category', 'data-category': 'all' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/webinars' },
                        'Webinars'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'category', 'data-category': 'all' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/ebooks' },
                        'Ebooks'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      { className: 'category', 'data-category': 'all' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/videos' },
                        'Videos'
                      )
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'nav nav-categories nav-center nav-tabs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      {
                        className: route === 'home' ? 'category active link-disabled-utils' : 'category',
                        'data-category': 'all'
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources' },
                        'All'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      {
                        className: route === 'whitepapers' ? 'category active link-disabled-utils' : 'category',
                        'data-category': 'all'
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/whitepapers' },
                        'Whitepapers'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      {
                        className: route === 'webinars' ? 'category active link-disabled-utils' : 'category',
                        'data-category': 'all'
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/webinars' },
                        'Webinars'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      {
                        className: route === 'ebooks' ? 'category active link-disabled-utils' : 'category',
                        'data-category': 'all'
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/ebooks' },
                        'Ebooks'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'li',
                      {
                        className: route === 'videos' ? 'category active link-disabled-utils' : 'category',
                        'data-category': 'all'
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: '/resources/videos' },
                        'Videos'
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'form',
                  { className: 'category-form form-horizontal hidden-md hidden-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-xs-12 text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'dropdrown-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'select',
                          {
                            onChange: selectHandler,
                            className: 'form-control',
                            defaultValue: selectValue
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: '/resources' },
                            'All Categories'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: '/resources/whitepapers' },
                            'Whitepapers'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: '/resources/webinars' },
                            'Webinars'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: '/resources/videos' },
                            'Videos'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: '/resources/ebooks' },
                            'Ebooks'
                          )
                        )
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'form',
                  { className: 'search-form' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group search-control' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon-budicon-489' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      onChange: onInputChange,
                      type: 'text',
                      placeholder: 'Search for resources',
                      id: 'search-input',
                      className: 'search-input form-control',
                      value: searchValue
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchBar.defaultProps = {
  route: null
};

SearchBar.propTypes = {
  onInputChange: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,
  route: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  firstTabIsSelected: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool.isRequired,
  searchValue: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchBar__ = __webpack_require__(685);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchBar__["a"]; });



/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(145);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SearchResult = function (_Component) {
  _inherits(SearchResult, _Component);

  function SearchResult() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchResult);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchResources: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchResult, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var search = _ref2.search;

      this.filterResourcesWithSearch(search);
    }
  }, {
    key: 'filterResourcesWithSearch',
    value: function filterResourcesWithSearch(search) {
      var options = {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 1000,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [{ name: 'label', weight: 0.3 }, { name: 'title', weight: 0.7 }]
      };
      var fuse = new __WEBPACK_IMPORTED_MODULE_1_fuse_js___default.a(this.props.itemsForSearching, options);
      if (search.length) {
        var fuseSearch = fuse.search(search);
        this.setState({ searchResources: fuseSearch });
      } else {
        this.setState({ searchResources: this.props.items });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          search = _props.search;
      var searchResources = this.state.searchResources;

      return search.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["d" /* List */], { items: searchResources }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["d" /* List */], { items: items });
    }
  }]);

  return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchResult.defaultProps = {
  items: [],
  itemsForSearching: []
};
SearchResult.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    imageUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  })),
  itemsForSearching: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    imageUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  })),
  search: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (SearchResult);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchResult__ = __webpack_require__(687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchResult__["a"]; });



/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers__ = __webpack_require__(236);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clientRoute: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].on('resources-page-route:home', function () {
        return _this2.setState({ clientRoute: 'home' });
      });
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].on('resources-page-route:whitepapers', function () {
        return _this2.setState({ clientRoute: 'whitepapers' });
      });
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].on('resources-page-route:webinars', function () {
        return _this2.setState({ clientRoute: 'webinars' });
      });
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].on('resources-page-route:ebooks', function () {
        return _this2.setState({ clientRoute: 'ebooks' });
      });
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].on('resources-page-route:videos', function () {
        return _this2.setState({ clientRoute: 'videos' });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].off('resources-page-route:home');
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].off('resources-page-route:whitepapers');
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].off('resources-page-route:webinars');
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].off('resources-page-route:ebooks');
      __WEBPACK_IMPORTED_MODULE_1_modules_npm_component_bus__["a" /* default */].off('resources-page-route:videos');
    }
  }, {
    key: 'render',
    value: function render() {
      var clientRoute = this.state.clientRoute;
      var _props = this.props,
          serverRoute = _props.serverRoute,
          items = _props.items;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers__["b" /* Resource */], { items: items, route: clientRoute || serverRoute });
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

App.defaultProps = {
  items: null,
  serverRoute: null
};
App.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    imageUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  })),
  serverRoute: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};


/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });



/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_connect__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_resources__ = __webpack_require__(695);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Resource = function (_Component) {
  _inherits(Resource, _Component);

  function Resource() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Resource);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Resource.__proto__ || Object.getPrototypeOf(Resource)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      search: ''
    }, _this.searchHandler = function (event) {
      var value = event.target.value;

      _this.setState({ search: value });
      if (value.length) {
        __WEBPACK_IMPORTED_MODULE_1_page___default()('/resources');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Resource, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var route = _ref2.route;

      this.initializeState(route);
    }
  }, {
    key: 'initializeState',
    value: function initializeState(route) {
      if (route !== 'home') {
        this.setState({ search: '' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          route = _props.route,
          resourcesFetch = _props.resourcesFetch;
      var search = this.state.search;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'hero' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["a" /* Hero */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["b" /* SearchBar */], {
            onInputChange: this.searchHandler,
            route: route,
            firstTabIsSelected: Boolean(search.length),
            searchValue: search
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'resources-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            items ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["c" /* SearchResult */], {
              items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_resources__["a" /* filterItemsByRoute */])(items, route),
              itemsForSearching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_resources__["b" /* orderByTitle */])(items),
              search: search
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["d" /* PromiseStateContainer */], {
              ps: __WEBPACK_IMPORTED_MODULE_2_react_refetch__["PromiseState"].race([resourcesFetch]),
              onFulFillment: function onFulFillment(resources) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["c" /* SearchResult */], {
                  items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_resources__["a" /* filterItemsByRoute */])(resources, route),
                  itemsForSearching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_resources__["b" /* orderByTitle */])(items),
                  search: search
                });
              }
            })
          )
        )
      );
    }
  }]);

  return Resource;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Resource.defaultProps = {
  items: [],
  route: null
};
Resource.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({
    label: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
    title: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,
    imageUrl: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired
  })),
  route: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,
  resourcesFetch: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].instanceOf(__WEBPACK_IMPORTED_MODULE_2_react_refetch__["PromiseState"]).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_connect__["a" /* appConnect */])(Resource));

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__(691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Resource__["a"]; });



/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return whitepapers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return webinars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return videos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ebooks; });
var whitepapers = 'whitepapers';
var webinars = 'webinars';
var videos = 'videos';
var ebooks = 'ebooks';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  whitepapers: whitepapers,
  webinars: webinars,
  videos: videos,
  ebooks: ebooks
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appConnect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_refetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_refetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);



var appConnect = function appConnect(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_refetch__["connect"])(function () {
    return {
      resourcesFetch: '/resources/api/all'
    };
  })(Component);
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  appConnect: appConnect
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterItemsByLabel */
/* harmony export (immutable) */ __webpack_exports__["a"] = filterItemsByRoute;
/* harmony export (immutable) */ __webpack_exports__["b"] = orderByTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__labels__ = __webpack_require__(693);



function filterItemsByLabel(items, label) {
  return orderByTitle(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(items, function (item) {
    return item.label === label;
  }));
}

function filterItemsByRoute(items, route) {
  var itemsFiltered = orderByTitle(items);
  switch (route) {
    case __WEBPACK_IMPORTED_MODULE_1__labels__["a" /* whitepapers */]:
      itemsFiltered = filterItemsByLabel(items, 'whitepaper');
      break;
    case __WEBPACK_IMPORTED_MODULE_1__labels__["b" /* webinars */]:
      itemsFiltered = filterItemsByLabel(items, 'webinar');
      break;
    case __WEBPACK_IMPORTED_MODULE_1__labels__["c" /* videos */]:
      itemsFiltered = filterItemsByLabel(items, 'videos');
      break;
    case __WEBPACK_IMPORTED_MODULE_1__labels__["d" /* ebooks */]:
      itemsFiltered = filterItemsByLabel(items, 'ebook');
      break;
    case 'home':
      break;
    default:
      break;
  }
  return itemsFiltered;
}

function orderByTitle(items) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(items, function (item) {
    return item.title;
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  filterItemsByLabel: filterItemsByLabel,
  filterItemsByRoute: filterItemsByRoute,
  orderByTitle: orderByTitle
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_website_subscription_center_page__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_website_subscription_center_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_website_subscription_center_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_subscription_center_widget__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_auth0_subscription_center_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_auth0_subscription_center_widget__);




var SubscriptionCenter = function SubscriptionCenter(_ref) {
  var email = _ref.email;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_website_subscription_center_page___default.a,
    { email: email },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_auth0_subscription_center_widget___default.a, { apiUrl: 'https://dwh-tracking.it.auth0.com' })
  );
};

SubscriptionCenter.propTypes = {
  email: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = (SubscriptionCenter);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubscriptionCenter__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SubscriptionCenter__["a"]; });



/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubscriptionCenter__ = __webpack_require__(697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SubscriptionCenter__["a"]; });



/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) { if(true) { !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); } else if(typeof module === "object" && module.exports) { module.exports = factory(); } else { root.bodymovin = factory(); } }(window, function() {var svgNS = "http://www.w3.org/2000/svg";
var subframeEnabled = true;
var expressionsPlugin;
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var cachedColors = {};
var bm_rounder = Math.round;
var bm_rnd;
var bm_pow = Math.pow;
var bm_sqrt = Math.sqrt;
var bm_abs = Math.abs;
var bm_floor = Math.floor;
var bm_max = Math.max;
var bm_min = Math.min;
var blitter = 10;

var BMMath = {};
(function(){
    var propertyNames = Object.getOwnPropertyNames(Math);
    var i, len = propertyNames.length;
    for(i=0;i<len;i+=1){
        BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
}());

function ProjectInterface(){return {}};

BMMath.random = Math.random;
BMMath.abs = function(val){
    var tOfVal = typeof val;
    if(tOfVal === 'object' && val.length){
        var absArr = Array.apply(null,{length:val.length});
        var i, len = val.length;
        for(i=0;i<len;i+=1){
            absArr[i] = Math.abs(val[i]);
        }
        return absArr;
    }
    return Math.abs(val);

}
var defaultCurveSegments = 150;
var degToRads = Math.PI/180;
var roundCorner = 0.5519;

function roundValues(flag){
    if(flag){
        bm_rnd = Math.round;
    }else{
        bm_rnd = function(val){
            return val;
        };
    }
}
roundValues(false);

function roundTo2Decimals(val){
    return Math.round(val*10000)/10000;
}

function roundTo3Decimals(val){
    return Math.round(val*100)/100;
}

function styleDiv(element){
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
}

function styleUnselectableDiv(element){
    element.style.userSelect = 'none';
    element.style.MozUserSelect = 'none';
    element.style.webkitUserSelect = 'none';
    element.style.oUserSelect = 'none';

}

function BMEnterFrameEvent(n,c,t,d){
    this.type = n;
    this.currentTime = c;
    this.totalTime = t;
    this.direction = d < 0 ? -1:1;
}

function BMCompleteEvent(n,d){
    this.type = n;
    this.direction = d < 0 ? -1:1;
}

function BMCompleteLoopEvent(n,c,t,d){
    this.type = n;
    this.currentLoop = c;
    this.totalLoops = t;
    this.direction = d < 0 ? -1:1;
}

function BMSegmentStartEvent(n,f,t){
    this.type = n;
    this.firstFrame = f;
    this.totalFrames = t;
}

function BMDestroyEvent(n,t){
    this.type = n;
    this.target = t;
}

function _addEventListener(eventName, callback){

    if (!this._cbs[eventName]){
        this._cbs[eventName] = [];
    }
    this._cbs[eventName].push(callback);

}

function _removeEventListener(eventName,callback){

    if (!callback){
        this._cbs[eventName] = null;
    }else if(this._cbs[eventName]){
        var i = 0, len = this._cbs[eventName].length;
        while(i<len){
            if(this._cbs[eventName][i] === callback){
                this._cbs[eventName].splice(i,1);
                i -=1;
                len -= 1;
            }
            i += 1;
        }
        if(!this._cbs[eventName].length){
            this._cbs[eventName] = null;
        }
    }

}

function _triggerEvent(eventName, args){
    if (this._cbs[eventName]) {
        var len = this._cbs[eventName].length;
        for (var i = 0; i < len; i++){
            this._cbs[eventName][i](args);
        }
    }
}

function randomString(length, chars){
    if(chars === undefined){
        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
    }
    var i;
    var result = '';
    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
}

function HSVtoRGB(h, s, v) {
    var r, g, b, i, f, p, q, t;
    if (arguments.length === 1) {
        s = h.s, v = h.v, h = h.h;
    }
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v, g = t, b = p; break;
        case 1: r = q, g = v, b = p; break;
        case 2: r = p, g = v, b = t; break;
        case 3: r = p, g = q, b = v; break;
        case 4: r = t, g = p, b = v; break;
        case 5: r = v, g = p, b = q; break;
    }
    return [ r,
        g,
         b ];
}

function RGBtoHSV(r, g, b) {
    if (arguments.length === 1) {
        g = r.g, b = r.b, r = r.r;
    }
    var max = Math.max(r, g, b), min = Math.min(r, g, b),
        d = max - min,
        h,
        s = (max === 0 ? 0 : d / max),
        v = max / 255;

    switch (max) {
        case min: h = 0; break;
        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
        case g: h = (b - r) + d * 2; h /= 6 * d; break;
        case b: h = (r - g) + d * 4; h /= 6 * d; break;
    }

    return [
         h,
         s,
         v
    ];
}

function addSaturationToRGB(color,offset){
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[1] += offset;
    if (hsv[1] > 1) {
        hsv[1] = 1;
    }
    else if (hsv[1] <= 0) {
        hsv[1] = 0;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function addBrightnessToRGB(color,offset){
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[2] += offset;
    if (hsv[2] > 1) {
        hsv[2] = 1;
    }
    else if (hsv[2] < 0) {
        hsv[2] = 0;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function addHueToRGB(color,offset) {
    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
    hsv[0] += offset/360;
    if (hsv[0] > 1) {
        hsv[0] -= 1;
    }
    else if (hsv[0] < 0) {
        hsv[0] += 1;
    }
    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
}

function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}

var rgbToHex = (function(){
    var colorMap = [];
    var i;
    var hex;
    for(i=0;i<256;i+=1){
        hex = i.toString(16);
        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
    }

    return function(r, g, b) {
        if(r<0){
            r = 0;
        }
        if(g<0){
            g = 0;
        }
        if(b<0){
            b = 0;
        }
        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
}());

function fillToRgba(hex,alpha){
    if(!cachedColors[hex]){
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        cachedColors[hex] = parseInt(result[1], 16)+','+parseInt(result[2], 16)+','+parseInt(result[3], 16);
    }
    return 'rgba('+cachedColors[hex]+','+alpha+')';
}

var fillColorToString = (function(){

    var colorMap = [];
    return function(colorArr,alpha){
        if(alpha !== undefined){
            colorArr[3] = alpha;
        }
        if(!colorMap[colorArr[0]]){
            colorMap[colorArr[0]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]]){
            colorMap[colorArr[0]][colorArr[1]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]]){
            colorMap[colorArr[0]][colorArr[1]][colorArr[2]] = {};
        }
        if(!colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]]){
            colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]] = 'rgba(' + colorArr.join(',')+')';
        }
        return colorMap[colorArr[0]][colorArr[1]][colorArr[2]][colorArr[3]];
    };
}());

function RenderedFrame(tr,o) {
    this.tr = tr;
    this.o = o;
}

function LetterProps(o,sw,sc,fc,m,p){
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.props = p;
}

function iterateDynamicProperties(num){
    var i, len = this.dynamicProperties;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue(num);
    }
}

function reversePath(paths){
    var newI = [], newO = [], newV = [];
    var i, len, newPaths = {};
    var init = 0;
    if (paths.c) {
        newI[0] = paths.o[0];
        newO[0] = paths.i[0];
        newV[0] = paths.v[0];
        init = 1;
    }
    len = paths.i.length;
    var cnt = len - 1;

    for (i = init; i < len; i += 1) {
        newI.push(paths.o[cnt]);
        newO.push(paths.i[cnt]);
        newV.push(paths.v[cnt]);
        cnt -= 1;
    }

    newPaths.i = newI;
    newPaths.o = newO;
    newPaths.v = newV;

    return newPaths;
}
/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */

/**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */

var Matrix = (function(){

    function reset(){
        this.props[0] = 1;
        this.props[1] = 0;
        this.props[2] = 0;
        this.props[3] = 0;
        this.props[4] = 0;
        this.props[5] = 1;
        this.props[6] = 0;
        this.props[7] = 0;
        this.props[8] = 0;
        this.props[9] = 0;
        this.props[10] = 1;
        this.props[11] = 0;
        this.props[12] = 0;
        this.props[13] = 0;
        this.props[14] = 0;
        this.props[15] = 1;
        return this;
    }

    function rotate(angle) {
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
    }

    function rotateX(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(1, 0, 0, 0
            , 0, mCos, -mSin, 0
            , 0, mSin,  mCos, 0
            , 0, 0, 0, 1);
    }

    function rotateY(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos,  0,  mSin, 0
            , 0, 1, 0, 0
            , -mSin,  0,  mCos, 0
            , 0, 0, 0, 1);
    }

    function rotateZ(angle){
        if(angle === 0){
            return this;
        }
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
    }

    function shear(sx,sy){
        return this._t(1, sy, sx, 1, 0, 0);
    }

    function skew(ax, ay){
        return this.shear(Math.tan(ax), Math.tan(ay));
    }

    function skewFromAxis(ax, angle){
        var mCos = Math.cos(angle);
        var mSin = Math.sin(angle);
        return this._t(mCos, mSin,  0, 0
            , -mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1)
            ._t(1, 0,  0, 0
            , Math.tan(ax),  1, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1)
            ._t(mCos, -mSin,  0, 0
            , mSin,  mCos, 0, 0
            , 0,  0,  1, 0
            , 0, 0, 0, 1);
        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, Math.tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }

    function scale(sx, sy, sz) {
        sz = isNaN(sz) ? 1 : sz;
        if(sx == 1 && sy == 1 && sz == 1){
            return this;
        }
        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }

    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
        this.props[0] = a;
        this.props[1] = b;
        this.props[2] = c;
        this.props[3] = d;
        this.props[4] = e;
        this.props[5] = f;
        this.props[6] = g;
        this.props[7] = h;
        this.props[8] = i;
        this.props[9] = j;
        this.props[10] = k;
        this.props[11] = l;
        this.props[12] = m;
        this.props[13] = n;
        this.props[14] = o;
        this.props[15] = p;
        return this;
    }

    function translate(tx, ty, tz) {
        tz = tz || 0;
        if(tx !== 0 || ty !== 0 || tz !== 0){
            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
        }
        return this;
    }

    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {

        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
            if(m2 !== 0 || n2 !== 0 || o2 !== 0){

                this.props[12] = this.props[12] * a2 + this.props[13] * e2 + this.props[14] * i2 + this.props[15] * m2 ;
                this.props[13] = this.props[12] * b2 + this.props[13] * f2 + this.props[14] * j2 + this.props[15] * n2 ;
                this.props[14] = this.props[12] * c2 + this.props[13] * g2 + this.props[14] * k2 + this.props[15] * o2 ;
                this.props[15] = this.props[12] * d2 + this.props[13] * h2 + this.props[14] * l2 + this.props[15] * p2 ;
            }
            return this;
        }

        var a1 = this.props[0];
        var b1 = this.props[1];
        var c1 = this.props[2];
        var d1 = this.props[3];
        var e1 = this.props[4];
        var f1 = this.props[5];
        var g1 = this.props[6];
        var h1 = this.props[7];
        var i1 = this.props[8];
        var j1 = this.props[9];
        var k1 = this.props[10];
        var l1 = this.props[11];
        var m1 = this.props[12];
        var n1 = this.props[13];
        var o1 = this.props[14];
        var p1 = this.props[15];

        /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */
        this.props[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
        this.props[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
        this.props[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
        this.props[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;

        this.props[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
        this.props[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
        this.props[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
        this.props[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;

        this.props[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
        this.props[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
        this.props[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
        this.props[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;

        this.props[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
        this.props[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
        this.props[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
        this.props[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;

        return this;
    }

    function clone(matr){
        var i;
        for(i=0;i<16;i+=1){
            matr.props[i] = this.props[i];
        }
    }

    function cloneFromProps(props){
        var i;
        for(i=0;i<16;i+=1){
            this.props[i] = props[i];
        }
    }

    function applyToPoint(x, y, z) {

        return {
            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
        };
        /*return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         };*/
    }
    function applyToX(x, y, z) {
        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }
    function applyToY(x, y, z) {
        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }
    function applyToZ(x, y, z) {
        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }

    function inversePoints(pts){
        //var determinant = this.a * this.d - this.b * this.c;
        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
        var a = this.props[5]/determinant;
        var b = - this.props[1]/determinant;
        var c = - this.props[4]/determinant;
        var d = this.props[0]/determinant;
        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
        var i, len = pts.length, retPts = [];
        for(i=0;i<len;i+=1){
            retPts[i] = [pts[i][0] * a + pts[i][1] * c + e, pts[i][0] * b + pts[i][1] * d + f, 0]
        }
        return retPts;
    }

    function applyToPointArray(x,y,z,dimensions){
        if(dimensions && dimensions === 2) {
            var arr = point_pool.newPoint();
            arr[0] = x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12]; 
            arr[1] = x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13]; 
            return arr;    
        }
        return [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
    }
    function applyToPointStringified(x, y) {
        return (bm_rnd(x * this.props[0] + y * this.props[4] + this.props[12]))+','+(bm_rnd(x * this.props[1] + y * this.props[5] + this.props[13]));
    }

    function toArray() {
        return [this.props[0],this.props[1],this.props[2],this.props[3],this.props[4],this.props[5],this.props[6],this.props[7],this.props[8],this.props[9],this.props[10],this.props[11],this.props[12],this.props[13],this.props[14],this.props[15]];
    }

    function toCSS() {
        if(isSafari){
            return "matrix3d(" + roundTo2Decimals(this.props[0]) + ',' + roundTo2Decimals(this.props[1]) + ',' + roundTo2Decimals(this.props[2]) + ',' + roundTo2Decimals(this.props[3]) + ',' + roundTo2Decimals(this.props[4]) + ',' + roundTo2Decimals(this.props[5]) + ',' + roundTo2Decimals(this.props[6]) + ',' + roundTo2Decimals(this.props[7]) + ',' + roundTo2Decimals(this.props[8]) + ',' + roundTo2Decimals(this.props[9]) + ',' + roundTo2Decimals(this.props[10]) + ',' + roundTo2Decimals(this.props[11]) + ',' + roundTo2Decimals(this.props[12]) + ',' + roundTo2Decimals(this.props[13]) + ',' + roundTo2Decimals(this.props[14]) + ',' + roundTo2Decimals(this.props[15]) + ')';
        } else {
            this.cssParts[1] = this.props.join(',');
            return this.cssParts.join('');
        }
    }

    function to2dCSS() {
        return "matrix(" + this.props[0] + ',' + this.props[1] + ',' + this.props[4] + ',' + this.props[5] + ',' + this.props[12] + ',' + this.props[13] + ")";
    }

    function toString() {
        return "" + this.toArray();
    }

    return function(){
        this.reset = reset;
        this.rotate = rotate;
        this.rotateX = rotateX;
        this.rotateY = rotateY;
        this.rotateZ = rotateZ;
        this.skew = skew;
        this.skewFromAxis = skewFromAxis;
        this.shear = shear;
        this.scale = scale;
        this.setTransform = setTransform;
        this.translate = translate;
        this.transform = transform;
        this.applyToPoint = applyToPoint;
        this.applyToX = applyToX;
        this.applyToY = applyToY;
        this.applyToZ = applyToZ;
        this.applyToPointArray = applyToPointArray;
        this.applyToPointStringified = applyToPointStringified;
        this.toArray = toArray;
        this.toCSS = toCSS;
        this.to2dCSS = to2dCSS;
        this.toString = toString;
        this.clone = clone;
        this.cloneFromProps = cloneFromProps;
        this.inversePoints = inversePoints;
        this._t = this.transform;

        this.props = [1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1];

        this.cssParts = ['matrix3d(','',')'];
    }
}());

function Matrix() {


}

/*
 Copyright 2014 David Bau.

 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//
    var global = this,
        width = 256,        // each RC4 output is 0 <= x < 256
        chunks = 6,         // at least six RC4 outputs for each double
        digits = 52,        // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
    function seedrandom(seed, options, callback) {
        var key = [];
        options = (options == true) ? { entropy: true } : (options || {});

        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(
            options.entropy ? [seed, tostring(pool)] :
                (seed == null) ? autoseed() : seed, 3), key);

        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);

        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
                d = startdenom,                 //   and denominator d = 2 ^ 48.
                x = 0;                          //   and no 'extra last byte'.
            while (n < significance) {          // Fill up all significant digits by
                n = (n + x) * width;              //   shifting numerator and
                d *= width;                       //   denominator and generating a
                x = arc4.g(1);                    //   new least-significant-byte.
            }
            while (n >= overflow) {             // To avoid rounding up, before adding
                n /= 2;                           //   last byte, shift everything
                d /= 2;                           //   right using integer math until
                x >>>= 1;                         //   we have exactly the desired bits.
            }
            return (n + x) / d;                 // Form the number within [0, 1).
        };

        prng.int32 = function() { return arc4.g(4) | 0; }
        prng.quick = function() { return arc4.g(4) / 0x100000000; }
        prng.double = prng;

        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);

        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback ||
        function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) { copy(state, arc4); }
                // Only provide the .state method if requested via options.state.
                prng.state = function() { return copy(arc4, {}); }
            }

            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) { math[rngname] = prng; return seed; }

            // Otherwise, it is a newer calling convention, so return the
            // prng directly.
            else return prng;
        })(
            prng,
            shortseed,
            'global' in options ? options.global : (this == math),
            options.state);
    }
    math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
    function ARC4(key) {
        var t, keylen = key.length,
            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

        // The empty key [] is treated as [0].
        if (!keylen) { key = [keylen++]; }

        // Set up S using the standard key scheduling algorithm.
        while (i < width) {
            s[i] = i++;
        }
        for (i = 0; i < width; i++) {
            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
            s[j] = t;
        }

        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0,
                i = me.i, j = me.j, s = me.S;
            while (count--) {
                t = s[i = mask & (i + 1)];
                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
            }
            me.i = i; me.j = j;
            return r;
            // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    };

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
    function flatten(obj, depth) {
        var result = [], typ = (typeof obj), prop;
        if (depth && typ == 'object') {
            for (prop in obj) {
                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
            }
        }
        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
    }

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while (j < stringseed.length) {
            key[mask & j] =
                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
        }
        return tostring(key);
    }

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
    function autoseed() {
        try {
            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
            var out = new Uint8Array(width);
            (global.crypto || global.msCrypto).getRandomValues(out);
            return tostring(out);
        } catch (e) {
            var browser = global.navigator,
                plugins = browser && browser.plugins;
            return [+new Date, global, plugins, global.screen, tostring(pool)];
        }
    }

//
// tostring()
// Converts an array of charcodes to a string
//
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
    mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//

// End anonymous scope, and pass initial values.
})(
    [],     // pool: entropy pool starts empty
    BMMath    // math: package containing random, pow, and seedrandom
);
var BezierFactory = (function(){
    /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */

        var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};

    function getBezierEasing(a,b,c,d,nm){
        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
        if(beziers[str]){
            return beziers[str];
        }
        var bezEasing = new BezierEasing([a,b,c,d]);
        beziers[str] = bezEasing;
        return bezEasing;
    }

// These values are established by empiricism with tests (tradeoff: performance VS precision)
    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;

    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

    var float32ArraySupported = typeof Float32Array === "function";

    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
    function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier (aT, aA1, aA2) {
        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
    }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope (aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide (aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }

    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }

    /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */
    function BezierEasing (points) {
        this._p = points;
        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        this._precomputed = false;

        this.get = this.get.bind(this);
    }

    BezierEasing.prototype = {

        get: function (x) {
            var mX1 = this._p[0],
                mY1 = this._p[1],
                mX2 = this._p[2],
                mY2 = this._p[3];
            if (!this._precomputed) this._precompute();
            if (mX1 === mY1 && mX2 === mY2) return x; // linear
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) return 0;
            if (x === 1) return 1;
            return calcBezier(this._getTForX(x), mY1, mY2);
        },

        // Private part

        _precompute: function () {
            var mX1 = this._p[0],
                mY1 = this._p[1],
                mX2 = this._p[2],
                mY2 = this._p[3];
            this._precomputed = true;
            if (mX1 !== mY1 || mX2 !== mY2)
                this._calcSampleValues();
        },

        _calcSampleValues: function () {
            var mX1 = this._p[0],
                mX2 = this._p[2];
            for (var i = 0; i < kSplineTableSize; ++i) {
                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }
        },

        /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */
        _getTForX: function (aX) {
            var mX1 = this._p[0],
                mX2 = this._p[2],
                mSampleValues = this._mSampleValues;

            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;

            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
                intervalStart += kSampleStepSize;
            }
            --currentSample;

            // Interpolate to provide an initial guess for t
            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;

            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) {
                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            } else if (initialSlope === 0.0) {
                return guessForT;
            } else {
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        }
    };

    return ob;

}())


function matrixManagerFunction(){

    var mat = new Matrix();

    var returnMatrix2D = function(rX, scaleX, scaleY, tX, tY){
        return mat.reset().translate(tX,tY).rotate(rX).scale(scaleX,scaleY).toCSS();
    };

    var getMatrix = function(animData){
        return returnMatrix2D(animData.tr.r[2],animData.tr.s[0],animData.tr.s[1],animData.tr.p[0],animData.tr.p[1]);
    };

    return {
        getMatrix : getMatrix
    };

}
var MatrixManager = matrixManagerFunction;
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if(!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
                    callback(currTime + timeToCall);
                },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    if(!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());
function createElement(parent,child,params){
    if(child){
        child.prototype = Object.create(parent.prototype);
        child.prototype.constructor = child;
        child.prototype._parent = parent.prototype;
    }else{
        var instance = Object.create(parent.prototype,params);
        var getType = {};
        if(instance && getType.toString.call(instance.init) === '[object Function]'){
            instance.init();
        }
        return instance;
    }
}

function extendPrototype(source,destination){
    for (var attr in source.prototype) {
        if (source.prototype.hasOwnProperty(attr)) destination.prototype[attr] = source.prototype[attr];
    }
}
function bezFunction(){

    var easingFunctions = [];
    var math = Math;

    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
        return det1 > -0.0001 && det1 < 0.0001;
    }

    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
        return pointOnLine2D(x1,y1, x2,y2, x3,y3) && pointOnLine2D(x1,z1, x2,z2, x3,z3);
    }

    /*function getEasingCurve(aa,bb,cc,dd,encodedFuncName) {
        if(!encodedFuncName){
            encodedFuncName = ('bez_' + aa+'_'+bb+'_'+cc+'_'+dd).replace(/\./g, 'p');
        }
        if(easingFunctions[encodedFuncName]){
            return easingFunctions[encodedFuncName];
        }
        var A0, B0, C0;
        var A1, B1, C1;
        easingFunctions[encodedFuncName] = function(tt) {
            var x = tt;
            var i = 0, z;
            while (++i < 20) {
                C0 = 3 * aa;
                B0 = 3 * (cc - aa) - C0;
                A0 = 1 - C0 - B0;
                z = (x * (C0 + x * (B0 + x * A0))) - tt;
                if (bm_abs(z) < 1e-3) break;
                x -= z / (C0 + x * (2 * B0 + 3 * A0 * x));
            }
            C1 = 3 * bb;
            B1 = 3 * (dd - bb) - C1;
            A1 = 1 - C1 - B1;
            var polyB = x * (C1 + x * (B1 + x * A1));
            //return c * polyB + b;
            return polyB;
        };
        return easingFunctions[encodedFuncName];
    }*/
    var getBezierLength = (function(){

        function Segment(l,p){
            this.l = l;
            this.p = p;
        }

        return function(pt1,pt2,pt3,pt4){
            var curveSegments = defaultCurveSegments;
            var k;
            var i, len;
            var ptCoord,perc,addedLength = 0;
            var ptDistance;
            var point = [],lastPoint = [];
            var lengthData = {
                addedLength: 0,
                segments: []
            };
            len = pt3.length;
            for(k=0;k<curveSegments;k+=1){
                perc = k/(curveSegments-1);
                ptDistance = 0;
                for(i=0;i<len;i+=1){
                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
                    point[i] = ptCoord;
                    if(lastPoint[i] !== null){
                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
                    }
                    lastPoint[i] = point[i];
                }
                if(ptDistance){
                    ptDistance = bm_sqrt(ptDistance);
                    addedLength += ptDistance;
                }
                lengthData.segments.push(new Segment(addedLength,perc));
            }
            lengthData.addedLength = addedLength;
            return lengthData;
        };
    }());

    function BezierData(length){
        this.segmentLength = 0;
        this.points = new Array(length);
    }

    function PointData(partial,point){
        this.partialLength = partial;
        this.point = point;
    }

    var buildBezierData = (function(){

        var storedData = {};

        return function (keyData){
            var pt1 = keyData.s;
            var pt2 = keyData.e;
            var pt3 = keyData.to;
            var pt4 = keyData.ti;
            var bezierName = (pt1.join('_')+'_'+pt2.join('_')+'_'+pt3.join('_')+'_'+pt4.join('_')).replace(/\./g, 'p');
            if(storedData[bezierName]){
                keyData.bezierData = storedData[bezierName];
                return;
            }
        var curveSegments = defaultCurveSegments;
        var k, i, len;
            var ptCoord,perc,addedLength = 0;
            var ptDistance;
            var point,lastPoint = null;
            if(pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
                curveSegments = 2;
            }
            var bezierData = new BezierData(curveSegments);
            len = pt3.length;
            for(k=0;k<curveSegments;k+=1){
            point = new Array(len);
                perc = k/(curveSegments-1);
                ptDistance = 0;
                for(i=0;i<len;i+=1){
                ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
                point[i] = ptCoord;
                    if(lastPoint !== null){
                    ptDistance += bm_pow(point[i] - lastPoint[i],2);
                    }
                }
            ptDistance = bm_sqrt(ptDistance);
                addedLength += ptDistance;
                bezierData.points[k] = new PointData(ptDistance,point);
                lastPoint = point;
            }
            bezierData.segmentLength = addedLength;
            keyData.bezierData = bezierData;
            storedData[bezierName] = bezierData;

        }
    }());

    function getDistancePerc(perc,bezierData){
        var segments = bezierData.segments;
        var len = segments.length;
        var initPos = bm_floor((len-1)*perc);
        var lengthPos = perc*bezierData.addedLength;
        var lPerc = 0;
        if(lengthPos == segments[initPos].l){
            return segments[initPos].p;
        }else{
            var dir = segments[initPos].l > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if(segments[initPos].l <= lengthPos && segments[initPos+1].l > lengthPos){
                    lPerc = (lengthPos - segments[initPos].l)/(segments[initPos+1].l-segments[initPos].l);
                    flag = false;
                }else{
                    initPos += dir;
                }
                if(initPos < 0 || initPos >= len - 1){
                    flag = false;
                }
            }
            return segments[initPos].p + (segments[initPos+1].p - segments[initPos].p)*lPerc;
        }
    }

    function SegmentPoints(){
        this.pt1 = new Array(2);
        this.pt2 = new Array(2);
        this.pt3 = new Array(2);
        this.pt4 = new Array(2);
    }

    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){

        var pts = new SegmentPoints();
        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
        var t0 = getDistancePerc(startPerc,bezierData);
        endPerc = endPerc > 1 ? 1 : endPerc;
        var t1 = getDistancePerc(endPerc,bezierData);
        var i, len = pt1.length;
        var u0 = 1 - t0;
        var u1 = 1 - t1;
        //Math.round(num * 100) / 100
        for(i=0;i<len;i+=1){
            pts.pt1[i] =  Math.round((u0*u0*u0* pt1[i] + (t0*u0*u0 + u0*t0*u0 + u0*u0*t0) * pt3[i] + (t0*t0*u0 + u0*t0*t0 + t0*u0*t0)* pt4[i] + t0*t0*t0* pt2[i])* 1000) / 1000;
            pts.pt3[i] = Math.round((u0*u0*u1*pt1[i] + (t0*u0*u1 + u0*t0*u1 + u0*u0*t1)* pt3[i] + (t0*t0*u1 + u0*t0*t1 + t0*u0*t1)* pt4[i] + t0*t0*t1* pt2[i])* 1000) / 1000;
            pts.pt4[i] = Math.round((u0*u1*u1* pt1[i] + (t0*u1*u1 + u0*t1*u1 + u0*u1*t1)* pt3[i] + (t0*t1*u1 + u0*t1*t1 + t0*u1*t1)* pt4[i] + t0*t1*t1* pt2[i])* 1000) / 1000;
            pts.pt2[i] = Math.round((u1*u1*u1* pt1[i] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[i] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[i] + t1*t1*t1* pt2[i])* 1000) / 1000;
        }
        return pts;
    }

    return {
        //getEasingCurve : getEasingCurve,
        getBezierLength : getBezierLength,
        getNewSegment : getNewSegment,
        buildBezierData : buildBezierData,
        pointOnLine2D : pointOnLine2D,
        pointOnLine3D : pointOnLine3D
    };
}

var bez = bezFunction();
function dataFunctionManager(){

    //var tCanvasHelper = document.createElement('canvas').getContext('2d');

    function completeLayers(layers, comps, fontManager){
        var layerData;
        var animArray, lastFrame;
        var i, len = layers.length;
        var j, jLen, k, kLen;
        for(i=0;i<len;i+=1){
            layerData = layers[i];
            if(!('ks' in layerData) || layerData.completed){
                continue;
            }
            layerData.completed = true;
            if(layerData.tt){
                layers[i-1].td = layerData.tt;
            }
            animArray = [];
            lastFrame = -1;
            if(layerData.hasMask){
                var maskProps = layerData.masksProperties;
                jLen = maskProps.length;
                for(j=0;j<jLen;j+=1){
                    if(maskProps[j].pt.k.i){
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                    }else{
                        kLen = maskProps[j].pt.k.length;
                        for(k=0;k<kLen;k+=1){
                            if(maskProps[j].pt.k[k].s){
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                            }
                            if(maskProps[j].pt.k[k].e){
                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                            }
                        }
                    }
                }
            }
            if(layerData.ty===0){
                layerData.layers = findCompLayers(layerData.refId, comps);
                completeLayers(layerData.layers,comps, fontManager);
            }else if(layerData.ty === 4){
                completeShapes(layerData.shapes);
            }else if(layerData.ty == 5){
                completeText(layerData, fontManager);
            }
        }
    }

    function findCompLayers(id,comps){
        var i = 0, len = comps.length;
        while(i<len){
            if(comps[i].id === id){
                return comps[i].layers;
            }
            i += 1;
        }
    }

    function completeShapes(arr){
        var i, len = arr.length;
        var j, jLen;
        var hasPaths = false;
        for(i=len-1;i>=0;i-=1){
            if(arr[i].ty == 'sh'){
                if(arr[i].ks.k.i){
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                }else{
                    jLen = arr[i].ks.k.length;
                    for(j=0;j<jLen;j+=1){
                        if(arr[i].ks.k[j].s){
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                        }
                        if(arr[i].ks.k[j].e){
                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                        }
                    }
                }
                hasPaths = true;
            }else if(arr[i].ty == 'gr'){
                completeShapes(arr[i].it);
            }
        }
        /*if(hasPaths){
            //mx: distance
            //ss: sensitivity
            //dc: decay
            arr.splice(arr.length-1,0,{
                "ty": "ms",
                "mx":20,
                "ss":10,
                 "dc":0.001,
                "maxDist":200
            });
        }*/
    }

    function convertPathsToAbsoluteValues(path){
        var i, len = path.i.length;
        for(i=0;i<len;i+=1){
            path.i[i][0] += path.v[i][0];
            path.i[i][1] += path.v[i][1];
            path.o[i][0] += path.v[i][0];
            path.o[i][1] += path.v[i][1];
        }
    }

    function checkVersion(minimum,animVersionString){
        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
        if(minimum[0]>animVersion[0]){
            return true;
        } else if(animVersion[0] > minimum[0]){
            return false;
        }
        if(minimum[1]>animVersion[1]){
            return true;
        } else if(animVersion[1] > minimum[1]){
            return false;
        }
        if(minimum[2]>animVersion[2]){
            return true;
        } else if(animVersion[2] > minimum[2]){
            return false;
        }
    }

    var checkText = (function(){
        var minimumVersion = [4,4,14];

        function updateTextLayer(textLayer){
            var documentData = textLayer.t.d;
            textLayer.t.d = {
                k: [
                    {
                        s:documentData,
                        t:0
                    }
                ]
            }
        }

        function iterateLayers(layers){
            var i, len = layers.length;
            for(i=0;i<len;i+=1){
                if(layers[i].ty === 5){
                    updateTextLayer(layers[i]);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }())

    var checkColors = (function(){
        var minimumVersion = [4,1,9];

        function iterateShapes(shapes){
            var i, len = shapes.length;
            var j, jLen;
            for(i=0;i<len;i+=1){
                if(shapes[i].ty === 'gr'){
                    iterateShapes(shapes[i].it);
                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
                    if(shapes[i].c.k && shapes[i].c.k[0].i){
                        jLen = shapes[i].c.k.length;
                        for(j=0;j<jLen;j+=1){
                            if(shapes[i].c.k[j].s){
                                shapes[i].c.k[j].s[0] /= 255;
                                shapes[i].c.k[j].s[1] /= 255;
                                shapes[i].c.k[j].s[2] /= 255;
                                shapes[i].c.k[j].s[3] /= 255;
                            }
                            if(shapes[i].c.k[j].e){
                                shapes[i].c.k[j].e[0] /= 255;
                                shapes[i].c.k[j].e[1] /= 255;
                                shapes[i].c.k[j].e[2] /= 255;
                                shapes[i].c.k[j].e[3] /= 255;
                            }
                        }
                    } else {
                        shapes[i].c.k[0] /= 255;
                        shapes[i].c.k[1] /= 255;
                        shapes[i].c.k[2] /= 255;
                        shapes[i].c.k[3] /= 255;
                    }
                }
            }
        }

        function iterateLayers(layers){
            var i, len = layers.length;
            for(i=0;i<len;i+=1){
                if(layers[i].ty === 4){
                    iterateShapes(layers[i].shapes);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }());

    var checkShapes = (function(){
        var minimumVersion = [4,4,18];



        function completeShapes(arr){
            var i, len = arr.length;
            var j, jLen;
            var hasPaths = false;
            for(i=len-1;i>=0;i-=1){
                if(arr[i].ty == 'sh'){
                    if(arr[i].ks.k.i){
                        arr[i].ks.k.c = arr[i].closed;
                    }else{
                        jLen = arr[i].ks.k.length;
                        for(j=0;j<jLen;j+=1){
                            if(arr[i].ks.k[j].s){
                                arr[i].ks.k[j].s[0].c = arr[i].closed;
                            }
                            if(arr[i].ks.k[j].e){
                                arr[i].ks.k[j].e[0].c = arr[i].closed;
                            }
                        }
                    }
                    hasPaths = true;
                }else if(arr[i].ty == 'gr'){
                    completeShapes(arr[i].it);
                }
            }
        }

        function iterateLayers(layers){
            var layerData;
            var i, len = layers.length;
            var j, jLen, k, kLen;
            for(i=0;i<len;i+=1){
                layerData = layers[i];
                if(layerData.hasMask){
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;
                    for(j=0;j<jLen;j+=1){
                        if(maskProps[j].pt.k.i){
                            maskProps[j].pt.k.c = maskProps[j].cl;
                        }else{
                            kLen = maskProps[j].pt.k.length;
                            for(k=0;k<kLen;k+=1){
                                if(maskProps[j].pt.k[k].s){
                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                }
                                if(maskProps[j].pt.k[k].e){
                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                }
                            }
                        }
                    }
                }
                if(layerData.ty === 4){
                    completeShapes(layerData.shapes);
                }
            }
        }

        return function (animationData){
            if(checkVersion(minimumVersion,animationData.v)){
                iterateLayers(animationData.layers);
                if(animationData.assets){
                    var i, len = animationData.assets.length;
                    for(i=0;i<len;i+=1){
                        if(animationData.assets[i].layers){
                            iterateLayers(animationData.assets[i].layers);

                        }
                    }
                }
            }
        }
    }());

    /*function blitPaths(path){
        var i, len = path.i.length;
        for(i=0;i<len;i+=1){
            path.i[i][0] /= blitter;
            path.i[i][1] /= blitter;
            path.o[i][0] /= blitter;
            path.o[i][1] /= blitter;
            path.v[i][0] /= blitter;
            path.v[i][1] /= blitter;
        }
    }

    function blitShapes(arr){
        var i, len = arr.length;
        var j, jLen;
        var hasPaths = false;
        for(i=len-1;i>=0;i-=1){
            if(arr[i].ty == 'sh'){
                if(arr[i].ks.k.i){
                    blitPaths(arr[i].ks.k);
                }else{
                    jLen = arr[i].ks.k.length;
                    for(j=0;j<jLen;j+=1){
                        if(arr[i].ks.k[j].s){
                            blitPaths(arr[i].ks.k[j].s[0]);
                        }
                        if(arr[i].ks.k[j].e){
                            blitPaths(arr[i].ks.k[j].e[0]);
                        }
                    }
                }
                hasPaths = true;
            }else if(arr[i].ty == 'gr'){
                blitShapes(arr[i].it);
            }else if(arr[i].ty == 'rc'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].s);
            }else if(arr[i].ty == 'st'){
                blitProperty(arr[i].w);
            }else if(arr[i].ty == 'tr'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].sk);
                blitProperty(arr[i].a);
            }else if(arr[i].ty == 'el'){
                blitProperty(arr[i].p);
                blitProperty(arr[i].s);
            }else if(arr[i].ty == 'rd'){
                blitProperty(arr[i].r);
            }else{

                //console.log(arr[i].ty );
            }
        }
    }

    function blitText(data, fontManager){

    }

    function blitValue(val){
        if(typeof(val) === 'number'){
            val /= blitter;
        } else {
            var i = val.length-1;
            while(i>=0){
                val[i] /= blitter;
                i-=1;
            }
        }
        return val;
    }

    function blitProperty(data){
        if(!data.k.length){
            data.k = blitValue(data.k);
        }else if(typeof(data.k[0]) === 'number'){
            data.k = blitValue(data.k);
        } else {
            var i, len = data.k.length;
            for(i=0;i<len;i+=1){
                if(data.k[i].s){
                    //console.log('pre S: ', data.k[i].s);
                    data.k[i].s = blitValue(data.k[i].s);
                    //console.log('post S: ', data.k[i].s);
                }
                if(data.k[i].e){
                    //console.log('pre E: ', data.k[i].e);
                    data.k[i].e = blitValue(data.k[i].e);
                    //console.log('post E: ', data.k[i].e);
                }
            }
        }
    }

    function blitLayers(layers,comps, fontManager){
        var layerData;
        var animArray, lastFrame;
        var i, len = layers.length;
        var j, jLen, k, kLen;
        for(i=0;i<len;i+=1){
            layerData = layers[i];
            if(!('ks' in layerData)){
                continue;
            }
            blitProperty(layerData.ks.a);
            blitProperty(layerData.ks.p);
            layerData.completed = true;
            if(layerData.tt){
                layers[i-1].td = layerData.tt;
            }
            animArray = [];
            lastFrame = -1;
            if(layerData.hasMask){
                var maskProps = layerData.masksProperties;
                jLen = maskProps.length;
                for(j=0;j<jLen;j+=1){
                    if(maskProps[j].pt.k.i){
                        blitPaths(maskProps[j].pt.k);
                    }else{
                        kLen = maskProps[j].pt.k.length;
                        for(k=0;k<kLen;k+=1){
                            if(maskProps[j].pt.k[k].s){
                                blitPaths(maskProps[j].pt.k[k].s[0]);
                            }
                            if(maskProps[j].pt.k[k].e){
                                blitPaths(maskProps[j].pt.k[k].e[0]);
                            }
                        }
                    }
                }
            }
            if(layerData.ty===0){
                layerData.w = Math.round(layerData.w/blitter);
                layerData.h = Math.round(layerData.h/blitter);
                blitLayers(layerData.layers,comps, fontManager);
            }else if(layerData.ty === 4){
                blitShapes(layerData.shapes);
            }else if(layerData.ty == 5){
                blitText(layerData, fontManager);
            }else if(layerData.ty == 1){
                layerData.sh /= blitter;
                layerData.sw /= blitter;
            } else {
            }
        }
    }

    function blitAnimation(animationData,comps, fontManager){
        blitLayers(animationData.layers,comps, fontManager);
    }*/

    function completeData(animationData, fontManager){
        if(animationData.__complete){
            return;
        }
        checkColors(animationData);
        checkText(animationData);
        checkShapes(animationData);
        completeLayers(animationData.layers, animationData.assets, fontManager);
        animationData.__complete = true;
        //blitAnimation(animationData, animationData.assets, fontManager);
    }

    function completeText(data, fontManager){
        var letters;
        var keys = data.t.d.k;
        var k, kLen = keys.length;
        for(k=0;k<kLen;k+=1){
            var documentData = data.t.d.k[k].s;
            letters = [];
            var i, len;
            var newLineFlag, index = 0, val;
            var anchorGrouping = data.t.m.g;
            var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
            var lineWidth = 0;
            var maxLineWidth = 0;
            var j, jLen;
            var fontData = fontManager.getFontByName(documentData.f);
            var charData, cLength = 0;
            var styles = fontData.fStyle.split(' ');

            var fWeight = 'normal', fStyle = 'normal';
            len = styles.length;
            for(i=0;i<len;i+=1){
                if (styles[i].toLowerCase() === 'italic') {
                    fStyle = 'italic';
                }else if (styles[i].toLowerCase() === 'bold') {
                    fWeight = '700';
                } else if (styles[i].toLowerCase() === 'black') {
                    fWeight = '900';
                } else if (styles[i].toLowerCase() === 'medium') {
                    fWeight = '500';
                } else if (styles[i].toLowerCase() === 'regular' || styles[i].toLowerCase() === 'normal') {
                    fWeight = '400';
                } else if (styles[i].toLowerCase() === 'light' || styles[i].toLowerCase() === 'thin') {
                    fWeight = '200';
                }
            }
            documentData.fWeight = fWeight;
            documentData.fStyle = fStyle;
            len = documentData.t.length;
            if(documentData.sz){
                var boxWidth = documentData.sz[0];
                var lastSpaceIndex = -1;
                for(i=0;i<len;i+=1){
                    newLineFlag = false;
                    if(documentData.t.charAt(i) === ' '){
                        lastSpaceIndex = i;
                    }else if(documentData.t.charCodeAt(i) === 13){
                        lineWidth = 0;
                        newLineFlag = true;
                    }
                    if(fontManager.chars){
                        charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
                    }else{
                        //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                        cLength = fontManager.measureText(documentData.t.charAt(i), documentData.f, documentData.s);
                    }
                    if(lineWidth + cLength > boxWidth){
                        if(lastSpaceIndex === -1){
                            //i -= 1;
                            documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i);
                            len += 1;
                        } else {
                            i = lastSpaceIndex;
                            documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i+1);
                        }
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    }else {
                        lineWidth += cLength;
                    }
                }
                len = documentData.t.length;
            }
            lineWidth = 0;
            cLength = 0;
            for (i = 0;i < len ;i += 1) {
                newLineFlag = false;
                if(documentData.t.charAt(i) === ' '){
                    val = '\u00A0';
                }else if(documentData.t.charCodeAt(i) === 13){
                    lineWidths.push(lineWidth);
                    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                    lineWidth = 0;
                    val = '';
                    newLineFlag = true;
                    currentLine += 1;
                }else{
                    val = documentData.t.charAt(i);
                }
                if(fontManager.chars){
                    charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                    cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
                }else{
                    //var charWidth = fontManager.measureText(val, documentData.f, documentData.s);
                    //tCanvasHelper.font = documentData.s + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
                    cLength = fontManager.measureText(val, documentData.f, documentData.s);
                }

                //
                lineWidth += cLength;
                letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine});
                if(anchorGrouping == 2){
                    currentSize += cLength;
                    if(val == '' || val == '\u00A0' || i == len - 1){
                        if(val == '' || val == '\u00A0'){
                            currentSize -= cLength;
                        }
                        while(currentPos<=i){
                            letters[currentPos].an = currentSize;
                            letters[currentPos].ind = index;
                            letters[currentPos].extra = cLength;
                            currentPos += 1;
                        }
                        index += 1;
                        currentSize = 0;
                    }
                }else if(anchorGrouping == 3){
                    currentSize += cLength;
                    if(val == '' || i == len - 1){
                        if(val == ''){
                            currentSize -= cLength;
                        }
                        while(currentPos<=i){
                            letters[currentPos].an = currentSize;
                            letters[currentPos].ind = index;
                            letters[currentPos].extra = cLength;
                            currentPos += 1;
                        }
                        currentSize = 0;
                        index += 1;
                    }
                }else{
                    letters[index].ind = index;
                    letters[index].extra = 0;
                    index += 1;
                }
            }
            documentData.l = letters;
            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
            lineWidths.push(lineWidth);
            if(documentData.sz){
                documentData.boxWidth = documentData.sz[0];
                documentData.justifyOffset = 0;
            }else{
                documentData.boxWidth = maxLineWidth;
                switch(documentData.j){
                    case 1:
                        documentData.justifyOffset = - documentData.boxWidth;
                        break;
                    case 2:
                        documentData.justifyOffset = - documentData.boxWidth/2;
                        break;
                    default:
                        documentData.justifyOffset = 0;
                }
            }
            documentData.lineWidths = lineWidths;

            var animators = data.t.a;
            jLen = animators.length;
            var based, ind, indexes = [];
            for(j=0;j<jLen;j+=1){
                if(animators[j].a.sc){
                    documentData.strokeColorAnim = true;
                }
                if(animators[j].a.sw){
                    documentData.strokeWidthAnim = true;
                }
                if(animators[j].a.fc || animators[j].a.fh || animators[j].a.fs || animators[j].a.fb){
                    documentData.fillColorAnim = true;
                }
                ind = 0;
                based = animators[j].s.b;
                for(i=0;i<len;i+=1){
                    letters[i].anIndexes[j] = ind;
                    if((based == 1 && letters[i].val != '') || (based == 2 && letters[i].val != '' && letters[i].val != '\u00A0') || (based == 3 && (letters[i].n || letters[i].val == '\u00A0' || i == len - 1)) || (based == 4 && (letters[i].n || i == len - 1))){
                        if(animators[j].s.rn === 1){
                            indexes.push(ind);
                        }
                        ind += 1;
                    }
                }
                data.t.a[j].s.totalChars = ind;
                var currentInd = -1, newInd;
                if(animators[j].s.rn === 1){
                    for(i = 0; i < len; i += 1){
                        if(currentInd != letters[i].anIndexes[j]){
                            currentInd = letters[i].anIndexes[j];
                            newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
                        }
                        letters[i].anIndexes[j] = newInd;
                    }
                }
            }
            if(jLen === 0 && !('m' in data.t.p)){
                data.singleShape = true;
            }
            documentData.yOffset = documentData.lh || documentData.s*1.2;
            documentData.ls = documentData.ls || 0;
            documentData.ascent = fontData.ascent*documentData.s/100;
        }

    }

    var moduleOb = {};
    moduleOb.completeData = completeData;

    return moduleOb;
}

var dataManager = dataFunctionManager();
var FontManager = (function(){

    var maxWaitingTime = 5000;

    function setUpNode(font, family){
        var parentNode = document.createElement('span');
        parentNode.style.fontFamily    = family;
        var node = document.createElement('span');
        // Characters that vary significantly among different fonts
        node.innerHTML = 'giItT1WQy@!-/#';
        // Visible - so we can measure it - but not on the screen
        parentNode.style.position      = 'absolute';
        parentNode.style.left          = '-10000px';
        parentNode.style.top           = '-10000px';
        // Large font size makes even subtle changes obvious
        parentNode.style.fontSize      = '300px';
        // Reset any font properties
        parentNode.style.fontVariant   = 'normal';
        parentNode.style.fontStyle     = 'normal';
        parentNode.style.fontWeight    = 'normal';
        parentNode.style.letterSpacing = '0';
        parentNode.appendChild(node);
        document.body.appendChild(parentNode);

        // Remember width with no applied web font
        var width = node.offsetWidth;
        node.style.fontFamily = font + ', '+family;
        return {node:node, w:width, parent:parentNode};
    }

    function checkLoadedFonts() {
        var i, len = this.fonts.length;
        var node, w;
        var loadedCount = len;
        for(i=0;i<len; i+= 1){
            if(this.fonts[i].loaded){
                loadedCount -= 1;
                continue;
            }
            if(this.fonts[i].fOrigin === 't'){
                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
                    this.typekitLoaded = 1;
                    try{window.Typekit.load({
                        async: true,
                        active: function() {
                            this.typekitLoaded = 2;
                        }.bind(this)
                    });}catch(e){}
                }
                if(this.typekitLoaded === 2) {
                    this.fonts[i].loaded = true;
                }
            } else if(this.fonts[i].fOrigin === 'n'){
                this.fonts[i].loaded = true;
            } else{
                node = this.fonts[i].monoCase.node;
                w = this.fonts[i].monoCase.w;
                if(node.offsetWidth !== w){
                    loadedCount -= 1;
                    this.fonts[i].loaded = true;
                }else{
                    node = this.fonts[i].sansCase.node;
                    w = this.fonts[i].sansCase.w;
                    if(node.offsetWidth !== w){
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    }
                }
                if(this.fonts[i].loaded){
                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                }
            }
        }

        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
            setTimeout(checkLoadedFonts.bind(this),20);
        }else{
            setTimeout(function(){this.loaded = true;}.bind(this),0);

        }
    };

    function createHelper(def, fontData){
        var tHelper = document.createElementNS(svgNS,'text');
        tHelper.style.fontSize = '100px';
        tHelper.style.fontFamily = fontData.fFamily;
        tHelper.textContent = '1';
        if(fontData.fClass){
            tHelper.style.fontFamily = 'inherit';
            tHelper.className = fontData.fClass;
        } else {
            tHelper.style.fontFamily = fontData.fFamily;
        }
        def.appendChild(tHelper);
        var tCanvasHelper = document.createElement('canvas').getContext('2d');
        tCanvasHelper.font = '100px '+ fontData.fFamily;
        return tCanvasHelper;
        return tHelper;
    }

    function addFonts(fontData, defs){
        if(!fontData){
            this.loaded = true;
            return;
        }
        if(this.chars){
            this.loaded = true;
            this.fonts = fontData.list;
            return;
        }

        var fontArr = fontData.list;
        var i, len = fontArr.length;
        for(i=0; i<len; i+= 1){
            fontArr[i].loaded = false;
            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
            if(!fontArr[i].fPath) {
                fontArr[i].loaded = true;
            }else if(fontArr[i].fOrigin === 'p'){
                var s = document.createElement('style');
                s.type = "text/css";
                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
                defs.appendChild(s);
            } else if(fontArr[i].fOrigin === 'g'){
                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
                var l = document.createElement('link');
                l.type = "text/css";
                l.rel = "stylesheet";
                l.href = fontArr[i].fPath;
                defs.appendChild(l);
            } else if(fontArr[i].fOrigin === 't'){
                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
                var sc = document.createElement('script');
                sc.setAttribute('src',fontArr[i].fPath);
                defs.appendChild(sc);
            }
            fontArr[i].helper = createHelper(defs,fontArr[i]);
            this.fonts.push(fontArr[i]);
        }
        checkLoadedFonts.bind(this)();
    }

    function addChars(chars){
        if(!chars){
            return;
        }
        if(!this.chars){
            this.chars = [];
        }
        var i, len = chars.length;
        var j, jLen = this.chars.length, found;
        for(i=0;i<len;i+=1){
            j = 0;
            found = false;
            while(j<jLen){
                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
                    found = true;
                }
                j += 1;
            }
            if(!found){
                this.chars.push(chars[i]);
                jLen += 1;
            }
        }
    }

    function getCharData(char, style, font){
        var i = 0, len = this.chars.length;
        while( i < len) {
            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
                return this.chars[i];
            }
            i+= 1;
        }
    }

    function measureText(char, fontName, size){
        var fontData = this.getFontByName(fontName);
        var tHelper = fontData.helper;
        //tHelper.textContent = char;
        return tHelper.measureText(char).width*size/100;
        //return tHelper.getComputedTextLength()*size/100;
    }

    function getFontByName(name){
        var i = 0, len = this.fonts.length;
        while(i<len){
            if(this.fonts[i].fName === name) {
                return this.fonts[i];
            }
            i += 1;
        }
        return 'sans-serif';
    }

    var Font = function(){
        this.fonts = [];
        this.chars = null;
        this.typekitLoaded = 0;
        this.loaded = false;
        this.initTime = Date.now();
    };
    Font.prototype.addChars = addChars;
    Font.prototype.addFonts = addFonts;
    Font.prototype.getCharData = getCharData;
    Font.prototype.getFontByName = getFontByName;
    Font.prototype.measureText = measureText;

    return Font;

}());
var PropertyFactory = (function(){

    var initFrame = -999999;

    function getValue(){
        if(this.elem.globalData.frameId === this.frameId){
            return;
        }
        this.mdf = false;
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        if(!(frameNum === this.lastFrame || (this.lastFrame !== initFrame && ((this.lastFrame >= this.keyframes[this.keyframes.length- 1].t-this.offsetTime && frameNum >= this.keyframes[this.keyframes.length- 1].t-this.offsetTime) || (this.lastFrame < this.keyframes[0].t-this.offsetTime && frameNum < this.keyframes[0].t-this.offsetTime))))){
            var i = this.lastFrame < frameNum ? this._lastIndex : 0;
            var len = this.keyframes.length- 1,flag = true;
            var keyData, nextKeyData;

            while(flag){
                keyData = this.keyframes[i];
                nextKeyData = this.keyframes[i+1];
                if(i == len-1 && frameNum >= nextKeyData.t - this.offsetTime){
                    if(keyData.h){
                        keyData = nextKeyData;
                    }
                    break;
                }
                if((nextKeyData.t - this.offsetTime) > frameNum){
                    break;
                }
                if(i < len - 1){
                    i += 1;
                }else{
                    flag = false;
                }
            }

            this._lastIndex = i;

            var k, kLen,perc,jLen, j, fnc;
            if(keyData.to){

                if(!keyData.bezierData){
                    bez.buildBezierData(keyData);
                }
                var bezierData = keyData.bezierData;
                if(frameNum >= nextKeyData.t-this.offsetTime || frameNum < keyData.t-this.offsetTime){
                    var ind = frameNum >= nextKeyData.t-this.offsetTime ? bezierData.points.length - 1 : 0;
                    kLen = bezierData.points[ind].point.length;
                    for(k = 0; k < kLen; k += 1){
                        this.pv[k] = bezierData.points[ind].point[k];
                        this.v[k] = this.mult ? this.pv[k]*this.mult : this.pv[k];
                        if(this.lastPValue[k] !== this.pv[k]) {
                            this.mdf = true;
                            this.lastPValue[k] = this.pv[k];
                        }
                    }
                    this._lastBezierData = null;
                }else{
                    if(keyData.__fnct){
                        fnc = keyData.__fnct;
                    }else{
                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
                        keyData.__fnct = fnc;
                    }
                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                    var distanceInLine = bezierData.segmentLength*perc;

                    var segmentPerc;
                    var addedLength =  (this.lastFrame < frameNum && this._lastBezierData === bezierData) ? this._lastAddedLength : 0;
                    j =  (this.lastFrame < frameNum && this._lastBezierData === bezierData) ? this._lastPoint : 0;
                    flag = true;
                    jLen = bezierData.points.length;
                    while(flag){
                        addedLength +=bezierData.points[j].partialLength;
                        if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
                            kLen = bezierData.points[j].point.length;
                            for(k=0;k<kLen;k+=1){
                                this.pv[k] = bezierData.points[j].point[k];
                                this.v[k] = this.mult ? this.pv[k]*this.mult : this.pv[k];
                                if(this.lastPValue[k] !== this.pv[k]) {
                                    this.mdf = true;
                                    this.lastPValue[k] = this.pv[k];
                                }
                            }
                            break;
                        }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
                            segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
                            kLen = bezierData.points[j].point.length;
                            for(k=0;k<kLen;k+=1){
                                this.pv[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
                                this.v[k] = this.mult ? this.pv[k] * this.mult : this.pv[k];
                                if(this.lastPValue[k] !== this.pv[k]) {
                                    this.mdf = true;
                                    this.lastPValue[k] = this.pv[k];
                                }
                            }
                            break;
                        }
                        if(j < jLen - 1){
                            j += 1;
                        }else{
                            flag = false;
                        }
                    }
                    this._lastPoint = j;
                    this._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                    this._lastBezierData = bezierData;
                }
            }else{
                var outX,outY,inX,inY, keyValue;
                len = keyData.s.length;
                for(i=0;i<len;i+=1){
                    if(keyData.h !== 1){
                        if(frameNum >= nextKeyData.t-this.offsetTime){
                            perc = 1;
                        }else if(frameNum < keyData.t-this.offsetTime){
                            perc = 0;
                        }else{
                            if(keyData.o.x instanceof Array){
                                if(!keyData.__fnct){
                                    keyData.__fnct = [];
                                }
                                if (!keyData.__fnct[i]) {
                                    outX = keyData.o.x[i] || keyData.o.x[0];
                                    outY = keyData.o.y[i] || keyData.o.y[0];
                                    inX = keyData.i.x[i] || keyData.i.x[0];
                                    inY = keyData.i.y[i] || keyData.i.y[0];
                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                                    keyData.__fnct[i] = fnc;
                                } else {
                                    fnc = keyData.__fnct[i];
                                }
                            } else {
                                if (!keyData.__fnct) {
                                    outX = keyData.o.x;
                                    outY = keyData.o.y;
                                    inX = keyData.i.x;
                                    inY = keyData.i.y;
                                    fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                                    keyData.__fnct = fnc;
                                } else{
                                    fnc = keyData.__fnct;
                                }
                            }
                            perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                        }
                    }
                    if(this.sh && keyData.h !== 1){
                        var initP = keyData.s[i];
                        var endP = keyData.e[i];
                        if(initP-endP < -180){
                            initP += 360;
                        } else if(initP-endP > 180){
                            initP -= 360;
                        }
                        keyValue = initP+(endP-initP)*perc;
                    } else {
                        keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
                    }
                    if(len === 1){
                        this.v = this.mult ? keyValue*this.mult : keyValue;
                        this.pv = keyValue;
                        if(this.lastPValue != this.pv){
                            this.mdf = true;
                            this.lastPValue = this.pv;
                        }
                    }else{
                        this.v[i] = this.mult ? keyValue*this.mult : keyValue;
                        this.pv[i] = keyValue;
                        if(this.lastPValue[i] !== this.pv[i]){
                            this.mdf = true;
                            this.lastPValue[i] = this.pv[i];
                        }
                    }
                }
            }
        }
        this.lastFrame = frameNum;
        this.frameId = this.elem.globalData.frameId;
    }

    function getNoValue(){}

    function ValueProperty(elem,data, mult){
        this.mult = mult;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this.mdf = false;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.getValue = getNoValue;
    }

    function MultiDimensionalProperty(elem,data, mult){
        this.mult = mult;
        this.data = data;
        this.mdf = false;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        this.v = Array.apply(null, {length:data.k.length});
        this.pv = Array.apply(null, {length:data.k.length});
        this.lastValue = Array.apply(null, {length:data.k.length});
        var arr = Array.apply(null, {length:data.k.length});
        this.vel = arr.map(function () { return 0 });
        var i, len = data.k.length;
        for(i = 0;i<len;i+=1){
            this.v[i] = mult ? data.k[i] * mult : data.k[i];
            this.pv[i] = data.k[i];
        }
        this.getValue = getNoValue;
    }

    function KeyframedValueProperty(elem, data, mult){
        this.keyframes = data.k;
        this.offsetTime = elem.data.st;
        this.lastValue = -99999;
        this.lastPValue = -99999;
        this.frameId = -1;
        this._lastIndex = 0;
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult;
        this.elem = elem;
        this.comp = elem.comp;
        this.lastFrame = initFrame;
        this.v = mult ? data.k[0].s[0]*mult : data.k[0].s[0];
        this.pv = data.k[0].s[0];
        this.getValue = getValue;
    }

    function KeyframedMultidimensionalProperty(elem, data, mult){
        var i, len = data.k.length;
        var s, e,to,ti;
        for(i=0;i<len-1;i+=1){
            if(data.k[i].to && data.k[i].s && data.k[i].e ){
                s = data.k[i].s;
                e = data.k[i].e;
                to = data.k[i].to;
                ti = data.k[i].ti;
                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.keyframes = data.k;
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this.mult = mult;
        this.elem = elem;
        this.comp = elem.comp;
        this.getValue = getValue;
        this.frameId = -1;
        this._lastIndex = 0;
        this.v = Array.apply(null, {length:data.k[0].s.length});
        this.pv = Array.apply(null, {length:data.k[0].s.length});
        this.lastValue = Array.apply(null, {length:data.k[0].s.length});
        this.lastPValue = Array.apply(null, {length:data.k[0].s.length});
        this.lastFrame = initFrame;
    }

    var TransformProperty = (function() {
        function positionGetter() {
            return ExpressionValue(this.p);
        }
        function xPositionGetter() {
            return ExpressionValue(this.px);
        }
        function yPositionGetter() {
            return ExpressionValue(this.py);
        }
        function zPositionGetter() {
            return ExpressionValue(this.pz);
        }
        function anchorGetter() {
            return ExpressionValue(this.a);
        }
        function orientationGetter() {
            return ExpressionValue(this.or);
        }
        function rotationGetter() {
            return ExpressionValue(this.r, 1/degToRads);
        }
        function scaleGetter() {
            return ExpressionValue(this.s, 100);
        }
        function opacityGetter() {
            return ExpressionValue(this.o, 100);
        }
        function skewGetter() {
            return ExpressionValue(this.sk);
        }
        function skewAxisGetter() {
            return ExpressionValue(this.sa);
        }
        function applyToMatrix(mat) {
            var i, len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1) {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i].mdf) {
                    this.mdf = true;
                }
            }
            if (this.a) {
                mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            }
            if (this.s) {
                mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            }
            if (this.r) {
                mat.rotate(-this.r.v);
            } else {
                mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            }
            if (this.data.p.s) {
                if (this.data.p.z) {
                    mat.translate(this.px.v, this.py.v, -this.pz.v);
                } else {
                    mat.translate(this.px.v, this.py.v, 0);
                }
            } else {
                mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
        }
        function processKeys(){
            if (this.elem.globalData.frameId === this.frameId) {
                return;
            }

            this.mdf = false;
            var i, len = this.dynamicProperties.length;

            for(i = 0; i < len; i += 1) {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i].mdf) {
                    this.mdf = true;
                }
            }
            if (this.mdf) {
                this.v.reset();
                if (this.a) {
                    this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                }
                if(this.s) {
                    this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                }
                if (this.sk) {
                    this.v.skewFromAxis(-this.sk.v, this.sa.v);
                }
                if (this.r) {
                    this.v.rotate(-this.r.v);
                } else {
                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                }
                if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
                    var v1,v2;
                    if (this.p.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
                    } else if(this.p.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
                    } else {
                        v1 = this.p.pv;
                        v2 = this.p.getValueAtTime((this.p.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if(this.data.p.s){
                    if(this.data.p.z) {
                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    } else {
                        this.v.translate(this.px.v, this.py.v, 0);
                    }
                }else{
                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
            }
            //console.log(this.v.to2dCSS())
            this.frameId = this.elem.globalData.frameId;
        }

        function setInverted(){
            this.inverted = true;
            this.iv = new Matrix();
            if(!this.k){
                if(this.data.p.s){
                    this.iv.translate(this.px.v,this.py.v,-this.pz.v);
                }else{
                    this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
                if(this.r){
                    this.iv.rotate(-this.r.v);
                }else{
                    this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
                }
                if(this.s){
                    this.iv.scale(this.s.v[0],this.s.v[1],1);
                }
                if(this.a){
                    this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
                }
            }
        }

        function autoOrient(){
            //
            //var prevP = this.getValueAtTime();
        }

        return function TransformProperty(elem,data,arr){
            this.elem = elem;
            this.frameId = -1;
            this.type = 'transform';
            this.dynamicProperties = [];
            this.mdf = false;
            this.data = data;
            this.getValue = processKeys;
            this.applyToMatrix = applyToMatrix;
            this.setInverted = setInverted;
            this.autoOrient = autoOrient;
            this.v = new Matrix();
            if(data.p.s){
                this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this.dynamicProperties);
                this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this.dynamicProperties);
                if(data.p.z){
                    this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this.dynamicProperties);
                }
            }else{
                this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            }
            if(data.r) {
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this.dynamicProperties);
            } else if(data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this.dynamicProperties);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this.dynamicProperties);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this.dynamicProperties);
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this.dynamicProperties);
            }
            if(data.sk){
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this.dynamicProperties);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this.dynamicProperties);
            }
            if(data.a) {
                this.a = PropertyFactory.getProp(elem,data.a,1,0,this.dynamicProperties);
            }
            if(data.s) {
                this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this.dynamicProperties);
            }
            if(data.o){
                this.o = PropertyFactory.getProp(elem,data.o,0,0.01,arr);
            } else {
                this.o = {mdf:false,v:1};
            }
            if(this.dynamicProperties.length){
                arr.push(this);
            }else{
                if(this.a){
                    this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
                }
                if(this.s){
                    this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);
                }
                if(this.sk){
                    this.v.skewFromAxis(-this.sk.v,this.sa.v);
                }
                if(this.r){
                    this.v.rotate(-this.r.v);
                }else{
                    this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                }
                if(this.data.p.s){
                    if(data.p.z) {
                        this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    } else {
                        this.v.translate(this.px.v, this.py.v, 0);
                    }
                }else{
                    this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
                }
            }
            Object.defineProperty(this, "position", { get: positionGetter});
            Object.defineProperty(this, "xPosition", { get: xPositionGetter});
            Object.defineProperty(this, "yPosition", { get: yPositionGetter});
            Object.defineProperty(this, "orientation", { get: orientationGetter});
            Object.defineProperty(this, "anchorPoint", { get: anchorGetter});
            Object.defineProperty(this, "rotation", { get: rotationGetter});
            Object.defineProperty(this, "scale", { get: scaleGetter});
            Object.defineProperty(this, "opacity", { get: opacityGetter});
            Object.defineProperty(this, "skew", { get: skewGetter});
            Object.defineProperty(this, "skewAxis", { get: skewAxisGetter});
        }
    }());

    function getProp(elem,data,type, mult, arr) {
        var p;
        if(type === 2){
            p = new TransformProperty(elem, data, arr);
        } else if(data.a === 0){
            if(type === 0) {
                p = new ValueProperty(elem,data,mult);
            } else {
                p = new MultiDimensionalProperty(elem,data, mult);
            }
        } else if(data.a === 1){
            if(type === 0) {
                p = new KeyframedValueProperty(elem,data,mult);
            } else {
                p = new KeyframedMultidimensionalProperty(elem,data, mult);
            }
        } else if(!data.k.length){
            p = new ValueProperty(elem,data, mult);
        }else if(typeof(data.k[0]) === 'number'){
            p = new MultiDimensionalProperty(elem,data, mult);
        }else{
            switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem,data,mult);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem,data,mult);
                    break;
            }
        }
        if(p.k){
            arr.push(p);
        }
        return p;
    }

    var getGradientProp = (function(){

        function getValue(forceRender){
            this.prop.getValue();
            this.cmdf = false;
            this.omdf = false;
            if(this.prop.mdf || forceRender){
                var i, len = this.data.p*4;
                var mult, val;
                for(i=0;i<len;i+=1){
                    mult = i%4 === 0 ? 100 : 255;
                    val = Math.round(this.prop.v[i]*mult);
                    if(this.c[i] !== val){
                        this.c[i] = val;
                        this.cmdf = true;
                    }
                }
                if(this.o.length){
                    len = this.prop.v.length;
                    for(i=this.data.p*4;i<len;i+=1){
                        mult = i%2 === 0 ? 100 : 1;
                        val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
                        if(this.o[i-this.data.p*4] !== val){
                            this.o[i-this.data.p*4] = val;
                            this.omdf = true;
                        }
                    }
                }
            }

        }

        function gradientProp(elem,data,arr){
            this.prop = getProp(elem,data.k,1,null,[]);
            this.data = data;
            this.k = this.prop.k;
            this.c = Array.apply(null,{length:data.p*4});
            var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
            this.o = Array.apply(null,{length:cLength});
            this.cmdf = false;
            this.omdf = false;
            this.getValue = getValue;
            if(this.prop.k){
                arr.push(this);
            }
            this.getValue(true);
        }

        return function getGradientProp(elem,data,arr){
            return new gradientProp(elem,data,arr);
        }
    }());




    var DashProperty = (function(){

        function processKeys(forceRender){
            var i = 0, len = this.dataProps.length;

            if(this.elem.globalData.frameId === this.frameId && !forceRender){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            while(i<len){
                if(this.dataProps[i].p.mdf){
                    this.mdf = true;
                    break;
                }
                i+=1;
            }
            if(this.mdf || forceRender){
                if(this.renderer === 'svg') {
                    this.dasharray = '';
                }
                for(i=0;i<len;i+=1){
                    if(this.dataProps[i].n != 'o'){
                        if(this.renderer === 'svg') {
                            this.dasharray += ' ' + this.dataProps[i].p.v;
                        }else{
                            this.dasharray[i] = this.dataProps[i].p.v;
                        }
                    }else{
                        this.dashoffset = this.dataProps[i].p.v;
                    }
                }
            }
        }

        return function(elem, data,renderer, dynamicProperties){
            this.elem = elem;
            this.frameId = -1;
            this.dataProps = new Array(data.length);
            this.renderer = renderer;
            this.mdf = false;
            this.k = false;
            if(this.renderer === 'svg'){
                this.dasharray = '';
            }else{

                this.dasharray = new Array(data.length - 1);
            }
            this.dashoffset = 0;
            var i, len = data.length, prop;
            for(i=0;i<len;i+=1){
                prop = PropertyFactory.getProp(elem,data[i].v,0, 0, dynamicProperties);
                this.k = prop.k ? true : this.k;
                this.dataProps[i] = {n:data[i].n,p:prop};
            }
            this.getValue = processKeys;
            if(this.k){
                dynamicProperties.push(this);
            }else{
                this.getValue(true);
            }

        }
    }());

    function getDashProp(elem, data,renderer, dynamicProperties) {
        return new DashProperty(elem, data,renderer, dynamicProperties);
    };

    var TextSelectorProp = (function(){
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function updateRange(){
            if(this.dynamicProperties.length){
                var i, len = this.dynamicProperties.length;
                for(i=0;i<len;i+=1){
                    this.dynamicProperties[i].getValue();
                    if(this.dynamicProperties[i].mdf){
                        this.mdf = true;
                    }
                }
            }
            var totalChars = this.data.totalChars;
            var divisor = this.data.r === 2 ? 1 : 100/totalChars;
            var o = this.o.v/divisor;
            var s = this.s.v/divisor + o;
            var e = (this.e.v/divisor) + o;
            if(s>e){
                var _s = s;
                s = e;
                e = _s;
            }
            this.finalS = s;
            this.finalE = e;
        }

        function getMult(ind){
            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
            var mult = 0;
            var s = this.finalS;
            var e = this.finalE;
            var type = this.data.sh;
            if(type == 2){
                if(e === s){
                    mult = ind >= e ? 1 : 0;
                }else{
                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                }
                mult = easer(mult);
            }else if(type == 3){
                if(e === s){
                    mult = ind >= e ? 0 : 1;
                }else{
                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                }

                mult = easer(mult);
            }else if(type == 4){
                if(e === s){
                    mult = 0;
                }else{
                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
                    if(mult<.5){
                        mult *= 2;
                    }else{
                        mult = 1 - 2*(mult-0.5);
                    }
                }
                mult = easer(mult);
            }else if(type == 5){
                if(e === s){
                    mult = 0;
                }else{
                    var tot = e - s;
                    /*ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
                    ind = min(max(0,ind+0.5-s),e-s);
                    var x = -tot/2+ind;
                    var a = tot/2;
                    mult = Math.sqrt(1 - (x*x)/(a*a));
                }
                mult = easer(mult);
            }else if(type == 6){
                if(e === s){
                    mult = 0;
                }else{
                    ind = min(max(0,ind+0.5-s),e-s);
                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
                    /*
                     ind = Math.min(Math.max(s,ind),e-1);
                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
                }
                mult = easer(mult);
            }else {
                if(ind >= floor(s)){
                    if(ind-s < 0){
                        mult = 1 - (s - ind);
                    }else{
                        mult = max(0,min(e-ind,1));
                    }
                }
                mult = easer(mult);
            }
            return mult*this.a.v;
        }

        return function TextSelectorProp(elem,data, arr){
            this.mdf = false;
            this.k = false;
            this.data = data;
            this.dynamicProperties = [];
            this.getValue = updateRange;
            this.getMult = getMult;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this.dynamicProperties);
            if('e' in data){
                this.e = PropertyFactory.getProp(elem,data.e,0,0,this.dynamicProperties);
            }else{
                this.e = {v:data.r === 2 ? data.totalChars : 100};
            }
            this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this.dynamicProperties);
            this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this.dynamicProperties);
            this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this.dynamicProperties);
            this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this.dynamicProperties);
            if(this.dynamicProperties.length){
                arr.push(this);
            }else{
                this.getValue();
            }
        }
    }());

    function getTextSelectorProp(elem, data,arr) {
        return new TextSelectorProp(elem, data, arr);
    };

    var ob = {};
    ob.getProp = getProp;
    ob.getDashProp = getDashProp;
    ob.getTextSelectorProp = getTextSelectorProp;
    ob.getGradientProp = getGradientProp;
    return ob;
}());
function ShapePath(){
	this.c = false;
	this._length = 0;
	this._maxLength = 8;
	this.v = Array.apply(null,{length:this._maxLength});
	this.o = Array.apply(null,{length:this._maxLength});
	this.i = Array.apply(null,{length:this._maxLength});
};

ShapePath.prototype.setPathData = function(closed, len) {
	this.c = closed;
	while(len > this._maxLength){
		this.doubleArrayLength();
	}
	var i = 0;
	while(i < len){
		this.v[i] = point_pool.newPoint();
		this.o[i] = point_pool.newPoint();
		this.i[i] = point_pool.newPoint();
		i += 1;
	}
	this._length = len;
};

ShapePath.prototype.doubleArrayLength = function() {
	this.v = this.v.concat(Array.apply(null,{length:this._maxLength}))
	this.i = this.i.concat(Array.apply(null,{length:this._maxLength}))
	this.o = this.o.concat(Array.apply(null,{length:this._maxLength}))
	this._maxLength *= 2;
};

ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
	var arr;
	this._length = Math.max(this._length, pos + 1);
	if(this._length >= this._maxLength) {
		this.doubleArrayLength();
	}
	switch(type){
		case 'v':
			arr = this.v;
			break;
		case 'i':
			arr = this.i;
			break;
		case 'o':
			arr = this.o;
			break;
	}
	if(!arr[pos] || (arr[pos] && !replace)){
		arr[pos] = point_pool.newPoint();
	}
	arr[pos][0] = x;
	arr[pos][1] = y;
};

ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
	this.setXYAt(vX,vY,'v',pos, replace);
	this.setXYAt(oX,oY,'o',pos, replace);
	this.setXYAt(iX,iY,'i',pos, replace);
};
var ShapePropertyFactory = (function(){

    var initFrame = -999999;

    function interpolateShape() {
        if(this.elem.globalData.frameId === this.frameId){
            return;
        }
        this.mdf = false;
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        if(!((this.lastFrame !== initFrame && ((this.lastFrame < this.keyframes[0].t-this.offsetTime && frameNum < this.keyframes[0].t-this.offsetTime) || (this.lastFrame > this.keyframes[this.keyframes.length - 1].t-this.offsetTime && frameNum > this.keyframes[this.keyframes.length - 1].t-this.offsetTime))))){
            var keyPropS,keyPropE,isHold;
            if(frameNum < this.keyframes[0].t-this.offsetTime){
                keyPropS = this.keyframes[0].s[0];
                isHold = true;
                this._lastIndex = 0;
            }else if(frameNum >= this.keyframes[this.keyframes.length - 1].t-this.offsetTime){
                if(this.keyframes[this.keyframes.length - 2].h === 1){
                    keyPropS = this.keyframes[this.keyframes.length - 1].s[0];
                }else{
                    keyPropS = this.keyframes[this.keyframes.length - 2].e[0];
                }
                isHold = true;
            }else{
                var i = this.lastFrame < initFrame ? this._lastIndex : 0;
                var len = this.keyframes.length- 1,flag = true,keyData,nextKeyData, j, jLen, k, kLen;
                while(flag){
                    keyData = this.keyframes[i];
                    nextKeyData = this.keyframes[i+1];
                    if((nextKeyData.t - this.offsetTime) > frameNum){
                        break;
                    }
                    if(i < len - 1){
                        i += 1;
                    }else{
                        flag = false;
                    }
                }
                isHold = keyData.h === 1;
                this._lastIndex = i;

                var perc;
                if(!isHold){
                    if(frameNum >= nextKeyData.t-this.offsetTime){
                        perc = 1;
                    }else if(frameNum < keyData.t-this.offsetTime){
                        perc = 0;
                    }else{
                        var fnc;
                        if(keyData.__fnct){
                            fnc = keyData.__fnct;
                        }else{
                            fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
                            keyData.__fnct = fnc;
                        }
                        perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
                    }
                    keyPropE = keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = this.v._length;
            kLen = keyPropS.i[0].length;
            var hasModified = false;
            var vertexValue;
            for(j=0;j<jLen;j+=1){
                for(k=0;k<kLen;k+=1){
                    if(isHold){
                        vertexValue = keyPropS.i[j][k];
                        if(this.v.i[j][k] !== vertexValue){
                            this.v.i[j][k] = vertexValue;
                            this.pv.i[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.o[j][k];
                        if(this.v.o[j][k] !== vertexValue){
                            this.v.o[j][k] = vertexValue;
                            this.pv.o[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.v[j][k];
                        if(this.v.v[j][k] !== vertexValue){
                            this.v.v[j][k] = vertexValue;
                            this.pv.v[j][k] = vertexValue;
                            hasModified = true;
                        }
                    }else{
                        vertexValue = keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
                        if(this.v.i[j][k] !== vertexValue){
                            this.v.i[j][k] = vertexValue;
                            this.pv.i[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
                        if(this.v.o[j][k] !== vertexValue){
                            this.v.o[j][k] = vertexValue;
                            this.pv.o[j][k] = vertexValue;
                            hasModified = true;
                        }
                        vertexValue = keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
                        if(this.v.v[j][k] !== vertexValue){
                            this.v.v[j][k] = vertexValue;
                            this.pv.v[j][k] = vertexValue;
                            hasModified = true;
                        }
                    }
                }
            }
            this.mdf = hasModified;
            this.v.c = keyPropS.c;
            this.paths = this.localShapeCollection;
        }

        this.lastFrame = frameNum;
        this.frameId = this.elem.globalData.frameId;
    }

    function getShapeValue(){
        return this.v;
    }

    function resetShape(){
        this.paths = this.localShapeCollection;
        if(!this.k){
            this.mdf = false;
        }
    }

    function ShapeProperty(elem, data, type){
        this.comp = elem.comp;
        this.k = false;
        this.mdf = false;
        this.v = shape_pool.newShape();
        var pathData = type === 3 ? data.pt.k : data.ks.k;
        this.v.v = pathData.v;
        this.v.i = pathData.i;
        this.v.o = pathData.o;
        this.v.c = pathData.c;
        this.v._length = this.v.v.length;
        this.getValue = getShapeValue;
        this.pv = shape_pool.clone(this.v);
        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.reset = resetShape;
    }

    function KeyframedShapeProperty(elem,data,type){
        this.comp = elem.comp;
        this.elem = elem;
        this.offsetTime = elem.data.st;
        this._lastIndex = 0;
        this.getValue = interpolateShape;
        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
        this.k = true;
        this.kf = true;
        var i, len = this.keyframes[0].s[0].i.length;
        var jLen = this.keyframes[0].s[0].i[0].length;
        this.v = shape_pool.newShape();
        this.v.setPathData(this.keyframes[0].s[0].c, len);
        this.pv = shape_pool.clone(this.v);
        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.lastFrame = initFrame;
        this.reset = resetShape;
    }

    var EllShapeProperty = (function(){

        var cPoint = roundCorner;

        function convertEllToPath(){
            var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
            if(this.d !== 3){
                this.v.v[0][0] = p0;
                this.v.v[0][1] = p1-s1;
                this.v.v[1][0] = p0 + s0;
                this.v.v[1][1] = p1;
                this.v.v[2][0] = p0;
                this.v.v[2][1] = p1+s1;
                this.v.v[3][0] = p0 - s0;
                this.v.v[3][1] = p1;
                this.v.i[0][0] = p0 - s0*cPoint;
                this.v.i[0][1] = p1 - s1;
                this.v.i[1][0] = p0 + s0;
                this.v.i[1][1] = p1 - s1*cPoint;
                this.v.i[2][0] = p0 + s0*cPoint;
                this.v.i[2][1] = p1 + s1;
                this.v.i[3][0] = p0 - s0;
                this.v.i[3][1] = p1 + s1*cPoint;
                this.v.o[0][0] = p0 + s0*cPoint;
                this.v.o[0][1] = p1 - s1;
                this.v.o[1][0] = p0 + s0;
                this.v.o[1][1] = p1 + s1*cPoint;
                this.v.o[2][0] = p0 - s0*cPoint;
                this.v.o[2][1] = p1 + s1;
                this.v.o[3][0] = p0 - s0;
                this.v.o[3][1] = p1 - s1*cPoint;
            }else{
                this.v.v[0][0] = p0;
                this.v.v[0][1] = p1-s1;
                this.v.v[1][0] = p0 - s0;
                this.v.v[1][1] = p1;
                this.v.v[2][0] = p0;
                this.v.v[2][1] = p1+s1;
                this.v.v[3][0] = p0 + s0;
                this.v.v[3][1] = p1;
                this.v.i[0][0] = p0 + s0*cPoint;
                this.v.i[0][1] = p1 - s1;
                this.v.i[1][0] = p0 - s0;
                this.v.i[1][1] = p1 - s1*cPoint;
                this.v.i[2][0] = p0 - s0*cPoint;
                this.v.i[2][1] = p1 + s1;
                this.v.i[3][0] = p0 + s0;
                this.v.i[3][1] = p1 + s1*cPoint;
                this.v.o[0][0] = p0 - s0*cPoint;
                this.v.o[0][1] = p1 - s1;
                this.v.o[1][0] = p0 - s0;
                this.v.o[1][1] = p1 + s1*cPoint;
                this.v.o[2][0] = p0 + s0*cPoint;
                this.v.o[2][1] = p1 + s1;
                this.v.o[3][0] = p0 + s0;
                this.v.o[3][1] = p1 - s1*cPoint;
            }
        }

        function processKeys(frameNum){
            var i, len = this.dynamicProperties.length;
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue(frameNum);
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertEllToPath();
            }
        }

        return function EllShapeProperty(elem,data) {
            /*this.v = {
                v: Array.apply(null,{length:4}),
                i: Array.apply(null,{length:4}),
                o: Array.apply(null,{length:4}),
                c: true
            };*/
            this.v = shape_pool.newShape();
            this.v.setPathData(true, 4);
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.localShapeCollection.addShape(this.v);
            this.d = data.d;
            this.dynamicProperties = [];
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.mdf = false;
            this.getValue = processKeys;
            this.convertEllToPath = convertEllToPath;
            this.reset = resetShape;
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertEllToPath();
            }
        }
    }());

    var StarShapeProperty = (function() {

        function convertPolygonToPath(){
            var numPts = Math.floor(this.pt.v);
            var angle = Math.PI*2/numPts;
            /*this.v.v.length = numPts;
            this.v.i.length = numPts;
            this.v.o.length = numPts;*/
            var rad = this.or.v;
            var roundness = this.os.v;
            var perimSegment = 2*Math.PI*rad/(numPts*4);
            var i, currentAng = -Math.PI/ 2;
            var dir = this.data.d === 3 ? -1 : 1;
            currentAng += this.r.v;
            this.v._length = 0;
            for(i=0;i<numPts;i+=1){
                var x = rad * Math.cos(currentAng);
                var y = rad * Math.sin(currentAng);
                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
                x +=  + this.p.v[0];
                y +=  + this.p.v[1];
                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
                /*this.v.v[i] = [x,y];
                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];*/
                currentAng += angle*dir;
            }
            this.paths.length = 0;
            this.paths[0] = this.v;
        }

        function convertStarToPath() {
            var numPts = Math.floor(this.pt.v)*2;
            var angle = Math.PI*2/numPts;
            /*this.v.v.length = numPts;
            this.v.i.length = numPts;
            this.v.o.length = numPts;*/
            var longFlag = true;
            var longRad = this.or.v;
            var shortRad = this.ir.v;
            var longRound = this.os.v;
            var shortRound = this.is.v;
            var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
            var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
            var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
            currentAng += this.r.v;
            var dir = this.data.d === 3 ? -1 : 1;
            this.v._length = 0;
            for(i=0;i<numPts;i+=1){
                rad = longFlag ? longRad : shortRad;
                roundness = longFlag ? longRound : shortRound;
                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                var x = rad * Math.cos(currentAng);
                var y = rad * Math.sin(currentAng);
                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
                x +=  + this.p.v[0];
                y +=  + this.p.v[1];
                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);

                /*this.v.v[i] = [x,y];
                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                this.v._length = numPts;*/
                longFlag = !longFlag;
                currentAng += angle*dir;
            }
        }

        function processKeys() {
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            var i, len = this.dynamicProperties.length;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue();
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertToPath();
            }
        }

        return function StarShapeProperty(elem,data) {
            /*this.v = {
                v: [],
                i: [],
                o: [],
                c: true
            };*/
            this.v = shape_pool.newShape();
            this.v.setPathData(true, 0);
            this.elem = elem;
            this.comp = elem.comp;
            this.data = data;
            this.frameId = -1;
            this.d = data.d;
            this.dynamicProperties = [];
            this.mdf = false;
            this.getValue = processKeys;
            this.reset = resetShape;
            if(data.sy === 1){
                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this.dynamicProperties);
                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this.dynamicProperties);
                this.convertToPath = convertStarToPath;
            } else {
                this.convertToPath = convertPolygonToPath;
            }
            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this.dynamicProperties);
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this.dynamicProperties);
            this.or = PropertyFactory.getProp(elem,data.or,0,0,this.dynamicProperties);
            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this.dynamicProperties);
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertToPath();
            }
        }
    }());

    var RectShapeProperty = (function() {
        function processKeys(frameNum){
            if(this.elem.globalData.frameId === this.frameId){
                return;
            }
            this.mdf = false;
            this.frameId = this.elem.globalData.frameId;
            var i, len = this.dynamicProperties.length;

            for(i=0;i<len;i+=1){
                this.dynamicProperties[i].getValue(frameNum);
                if(this.dynamicProperties[i].mdf){
                    this.mdf = true;
                }
            }
            if(this.mdf){
                this.convertRectToPath();
            }

        }

        function convertRectToPath(){
            var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
            var round = bm_min(v0,v1,this.r.v);
            var cPoint = round*(1-roundCorner);
            this.v._length = 0;

            if(this.d === 2 || this.d === 1) {
                this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
                this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
                if(round!== 0){
                    this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
                } else {
                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
                }
            }else{
                this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
                if(round!== 0){
                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
                    this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
                    this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
                } else {
                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
                    this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);

                }
            }
        }

        return function RectShapeProperty(elem,data) {
            this.v = shape_pool.newShape();
            this.v.c = true;
            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.d = data.d;
            this.dynamicProperties = [];
            this.mdf = false;
            this.getValue = processKeys;
            this.convertRectToPath = convertRectToPath;
            this.reset = resetShape;
            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
            this.r = PropertyFactory.getProp(elem,data.r,0,0,this.dynamicProperties);
            if(this.dynamicProperties.length){
                this.k = true;
            }else{
                this.convertRectToPath();
            }
        }
    }());

    function getShapeProp(elem,data,type, arr){
        var prop;
        if(type === 3 || type === 4){
            var dataProp = type === 3 ? data.pt : data.ks;
            var keys = dataProp.k;
            if(dataProp.a === 1 || keys.length){
                prop = new KeyframedShapeProperty(elem, data, type);
            }else{
                prop = new ShapeProperty(elem, data, type);
            }
        }else if(type === 5){
            prop = new RectShapeProperty(elem, data);
        }else if(type === 6){
            prop = new EllShapeProperty(elem, data);
        }else if(type === 7){
            prop = new StarShapeProperty(elem, data);
        }
        if(prop.k){
            arr.push(prop);
        }
        return prop;
    }

    var ob = {};
    ob.getShapeProp = getShapeProp;
    return ob;
}());
var ShapeModifiers = (function(){
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;

    function registerModifier(nm,factory){
        if(!modifiers[nm]){
            modifiers[nm] = factory;
        }
    }

    function getModifier(nm,elem, data, dynamicProperties){
        return new modifiers[nm](elem, data, dynamicProperties);
    }

    return ob;
}());

function ShapeModifier(){}
ShapeModifier.prototype.initModifierProperties = function(){};
ShapeModifier.prototype.addShapeToModifier = function(){};
ShapeModifier.prototype.addShape = function(data){
    if(!this.closed){
        this.shapes.push({shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()});
        this.addShapeToModifier(data.sh);
    }
}
ShapeModifier.prototype.init = function(elem,data,dynamicProperties){
    this.elem = elem;
    this.frameId = -1;
    this.shapes = [];
    this.dynamicProperties = [];
    this.mdf = false;
    this.closed = false;
    this.k = false;
    this.isTrimming = false;
    this.comp = elem.comp;
    this.initModifierProperties(elem,data);
    if(this.dynamicProperties.length){
        this.k = true;
        dynamicProperties.push(this);
    }else{
        this.getValue(true);
    }
}
function TrimModifier(){};
extendPrototype(ShapeModifier,TrimModifier);
TrimModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
    if(this.mdf || forceRender){
        var o = (this.o.v%360)/360;
        if(o < 0){
            o += 1;
        }
        var s = this.s.v + o;
        var e = this.e.v + o;
        if(s == e){

        }
        if(s>e){
            var _s = s;
            s = e;
            e = _s;
        }
        this.sValue = s;
        this.eValue = e;
        this.oValue = o;
    }
}
TrimModifier.prototype.initModifierProperties = function(elem,data){
    this.sValue = 0;
    this.eValue = 0;
    this.oValue = 0;
    this.getValue = this.processKeys;
    this.s = PropertyFactory.getProp(elem,data.s,0,0.01,this.dynamicProperties);
    this.e = PropertyFactory.getProp(elem,data.e,0,0.01,this.dynamicProperties);
    this.o = PropertyFactory.getProp(elem,data.o,0,0,this.dynamicProperties);
    this.m = data.m;
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
};

TrimModifier.prototype.getSegmentsLength = function(shapeData){
    var closed = shapeData.c;
    var pathV = shapeData.v;
    var pathO = shapeData.o;
    var pathI = shapeData.i;
    var i, len = shapeData._length;
    var lengths = [];
    var totalLength = 0;
    for(i=0;i<len-1;i+=1){
        lengths[i] = bez.getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
        totalLength += lengths[i].addedLength;
    }
    if(closed){
        lengths[i] = bez.getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
        totalLength += lengths[i].addedLength;
    }
    return {lengths:lengths,totalLength:totalLength};
}

TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = []
    if(e <= 1){
        segments.push({
            s: s,
            e: e
        })
    }else if(s >= 1){
        segments.push({
            s: s - 1,
            e: e - 1
        })
    }else{
        segments.push({
            s: s,
            e: 1
        })
        segments.push({
            s: 0,
            e: e - 1
        })
    }
    var shapeSegments = [];
    var i, len = segments.length, segmentOb;
    for(i = 0; i < len; i += 1) {
        segmentOb = segments[i];
        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
            
        } else {
            var shapeS, shapeE;
            if(segmentOb.s * totalModifierLength <= addedLength) {
                shapeS = 0;
            } else {
                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
            }
            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
                shapeE = 1;
            } else {
                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
            }
            shapeSegments.push([shapeS, shapeE]);
        }
    }
    if(!shapeSegments.length){
        shapeSegments.push([0,0]);
    }
    return shapeSegments;
}

TrimModifier.prototype.processShapes = function(firstFrame){
    var shapePaths;
    var i, len = this.shapes.length;
    var j, jLen;
    var s = this.sValue;
    var e = this.eValue;
    var pathsData,pathData, totalShapeLength, totalModifierLength = 0;

    if(e === s){
        for(i=0;i<len;i+=1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape.mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
        }
    } else if(!((e === 1 && s === 0) || (e===0 && s === 1))){
        var segments = [], shapeData, localShapeCollection;
        for(i=0;i<len;i+=1){
            shapeData = this.shapes[i];
            if(!shapeData.shape.mdf && !this.mdf && !firstFrame && this.m !== 2){
                shapeData.shape.paths = shapeData.localShapeCollection;
            } else {
                shapePaths = shapeData.shape.paths;
                jLen = shapePaths._length;
                totalShapeLength = 0;
                if(!shapeData.shape.mdf && shapeData.pathsData){
                    totalShapeLength = shapeData.totalShapeLength;
                } else {
                    pathsData = [];
                    for(j=0;j<jLen;j+=1){
                        pathData = this.getSegmentsLength(shapePaths.shapes[j]);
                        pathsData.push(pathData);
                        totalShapeLength += pathData.totalLength;
                    }
                    shapeData.totalShapeLength = totalShapeLength;
                    shapeData.pathsData = pathsData;
                }

                totalModifierLength += totalShapeLength;
                shapeData.shape.mdf = true;
            }
        }
        var shapeS = s, shapeE = e, addedLength = 0;
        var j, jLen;
        for(i = len - 1; i >= 0; i -= 1){
            shapeData = this.shapes[i];
            if (shapeData.shape.mdf) {
                localShapeCollection = shapeData.localShapeCollection;
                localShapeCollection.releaseShapes();
                if(this.m === 2 && len > 1) {
                    var edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                    addedLength += shapeData.totalShapeLength;
                } else {
                    edges = [[shapeS, shapeE]]
                }
                jLen = edges.length;
                for (j = 0; j < jLen; j += 1) {
                    shapeS = edges[j][0];
                    shapeE = edges[j][1];
                    segments.length = 0;
                    if(shapeE <= 1){
                        segments.push({
                            s:shapeData.totalShapeLength * shapeS,
                            e:shapeData.totalShapeLength * shapeE
                        })
                    }else if(shapeS >= 1){
                        segments.push({
                            s:shapeData.totalShapeLength * (shapeS - 1),
                            e:shapeData.totalShapeLength * (shapeE - 1)
                        })
                    }else{
                        segments.push({
                            s:shapeData.totalShapeLength * shapeS,
                            e:shapeData.totalShapeLength
                        })
                        segments.push({
                            s:0,
                            e:shapeData.totalShapeLength*(shapeE - 1)
                        })
                    }
                    var newShapesData = this.addShapes(shapeData,segments[0]);
                    if (segments[0].s !== segments[0].e) {
                        var lastPos;
                        if(segments.length > 1){
                            if(shapeData.shape.v.c){
                                var lastShape = newShapesData.pop();
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData,segments[1], lastShape);
                            } else {
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData,segments[1]);
                            }
                        } 
                        this.addPaths(newShapesData, localShapeCollection);
                    }
                    
                }
                shapeData.shape.paths = localShapeCollection;
            }
        }
    } else if(this.mdf){
        for(i=0;i<len;i+=1){
            this.shapes[i].shape.mdf = true;
        }
    }
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
}

TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
    var i, len = newPaths.length;
    for(i = 0; i < len; i += 1) {
        localShapeCollection.addShape(newPaths[i])
    }
}

TrimModifier.prototype.addSegment = function(pt1,pt2,pt3,pt4,shapePath,pos, newShape) {
    /*console.log(pt1, 'vertex: v, at: ', pos);
    console.log(pt2, 'vertex: o, at: ', pos);
    console.log(pt3, 'vertex: i, at: ', pos + 1);
    console.log(pt4, 'vertex: v, at: ', pos + 1);
    console.log('newShape: ', newShape);*/
    shapePath.setXYAt(pt2[0],pt2[1],'o',pos);
    shapePath.setXYAt(pt3[0],pt3[1],'i',pos + 1);
    if(newShape){
        shapePath.setXYAt(pt1[0],pt1[1],'v',pos);
    }
    shapePath.setXYAt(pt4[0],pt4[1],'v',pos + 1);
}

TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath){
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i, len = shapeData.shape.paths._length, j, jLen;
    var addedLength = 0;
    var currentLengthData,segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;
    if(!shapePath){
        shapePath = shape_pool.newShape();
        segmentCount = 0;
        initPos = 0;
    } else {
        segmentCount = shapePath._length;
        initPos = shapePath._length;
    }
    shapes.push(shapePath);
    for(i=0;i<len;i+=1){
        lengths = pathsData[i].lengths;
        shapePath.c = shapePaths[i].c;
        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
        for(j=1;j<jLen;j+=1){
            currentLengthData = lengths[j-1];
            if(addedLength + currentLengthData.addedLength < shapeSegment.s){
                addedLength += currentLengthData.addedLength;
                shapePath.c = false;
            } else if(addedLength > shapeSegment.e){
                shapePath.c = false;
                break;
            } else {
                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength){
                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);
                    newShape = false;
                } else {
                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
                    newShape = false;
                    shapePath.c = false;
                }
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
        }
        if(shapePaths[i].c){
            currentLengthData = lengths[j-1];
            if(addedLength <= shapeSegment.e){
                var segmentLength = lengths[j-1].addedLength;
                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength){
                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);
                    newShape = false;
                }else{
                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0], (shapeSegment.s - addedLength)/segmentLength,(shapeSegment.e - addedLength)/segmentLength, lengths[j-1]);
                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
                    newShape = false;
                    shapePath.c = false;
                }
            } else {
                shapePath.c = false;
            }
            addedLength += currentLengthData.addedLength;
            segmentCount += 1;
        }
        if(shapePath._length){
            shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);
            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0],shapePath.v[shapePath._length - 1][1],'o',shapePath._length - 1);
        }
        if(addedLength > shapeSegment.e){
            break;
        }
        if(i<len-1){
            shapePath = shape_pool.newShape();
            newShape = true;
            shapes.push(shapePath);
            segmentCount = 0;
        }
    }
    return shapes;

}


ShapeModifiers.registerModifier('tm',TrimModifier);
function RoundCornersModifier(){};
extendPrototype(ShapeModifier,RoundCornersModifier);
RoundCornersModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
}
RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this.dynamicProperties);
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
};

RoundCornersModifier.prototype.processPath = function(path, round){
    var cloned_path = shape_pool.newShape();
    cloned_path.c = path.c;
    var i, len = path._length;
    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
    var vX,vY,oX,oY,iX,iY;
    for(i=0;i<len;i+=1){
        currentV = path.v[i];
        currentO = path.o[i];
        currentI = path.i[i];
        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
            if((i===0 || i === len - 1) && !path.c){
                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
                /*cloned_path.v[index] = currentV;
                cloned_path.o[index] = currentO;
                cloned_path.i[index] = currentI;*/
                index += 1;
            } else {
                if(i===0){
                    closerV = path.v[len-1];
                } else {
                    closerV = path.v[i-1];
                }
                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
                oX = vX-(vX-currentV[0])*roundCorner;
                oY = vY-(vY-currentV[1])*roundCorner;
                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
                /*newV = [currentV[0]+(closerV[0]-currentV[0])*newPosPerc,currentV[1]-(currentV[1]-closerV[1])*newPosPerc];
                newI = newV;
                newO = [newV[0]-(newV[0]-currentV[0])*roundCorner,newV[1]-(newV[1]-currentV[1])*roundCorner];
                cloned_path.v[index] = newV;
                cloned_path.i[index] = newI;
                cloned_path.o[index] = newO;*/
                index += 1;

                if(i === len - 1){
                    closerV = path.v[0];
                } else {
                    closerV = path.v[i+1];
                }
                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
                iX = vX-(vX-currentV[0])*roundCorner;
                iY = vY-(vY-currentV[1])*roundCorner;
                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);

                /*newV = [currentV[0]+(closerV[0]-currentV[0])*newPosPerc,currentV[1]+(closerV[1]-currentV[1])*newPosPerc];
                newI = [newV[0]-(newV[0]-currentV[0])*roundCorner,newV[1]-(newV[1]-currentV[1])*roundCorner];
                newO = newV;
                cloned_path.v[index] = newV;
                cloned_path.i[index] = newI;
                cloned_path.o[index] = newO;*/
                index += 1;
            }
        } else {
            /*cloned_path.v[index] = path.v[i];
            cloned_path.o[index] = path.o[i];
            cloned_path.i[index] = path.i[i];*/
            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
            index += 1;
        }
    }
    return cloned_path;
}

RoundCornersModifier.prototype.processShapes = function(firstFrame){
    var shapePaths;
    var i, len = this.shapes.length;
    var j, jLen;
    var rd = this.rd.v;

    if(rd !== 0){
        var shapeData, newPaths, localShapeCollection;
        for(i=0;i<len;i+=1){
            shapeData = this.shapes[i];
            newPaths = shapeData.shape.paths;
            localShapeCollection = shapeData.localShapeCollection;
            if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
                localShapeCollection.releaseShapes();
                shapeData.shape.mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j=0;j<jLen;j+=1){
                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
                }
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }

    }
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
}


ShapeModifiers.registerModifier('rd',RoundCornersModifier);
function RepeaterModifier(){};
extendPrototype(ShapeModifier,RepeaterModifier);
RepeaterModifier.prototype.processKeys = function(forceRender){
    if(this.elem.globalData.frameId === this.frameId && !forceRender){
        return;
    }
    this.mdf = forceRender ? true : false;
    this.frameId = this.elem.globalData.frameId;
    var i, len = this.dynamicProperties.length;

    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        if(this.dynamicProperties[i].mdf){
            this.mdf = true;
        }
    }
};
RepeaterModifier.prototype.initModifierProperties = function(elem,data){
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem,data.c,0,null,this.dynamicProperties);
    this.o = PropertyFactory.getProp(elem,data.o,0,null,this.dynamicProperties);
    this.tr = PropertyFactory.getProp(elem,data.tr,2,null,this.dynamicProperties);
    if(!this.dynamicProperties.length){
        this.getValue(true);
    }
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
};

RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
}

RepeaterModifier.prototype.processShapes = function(firstFrame){
    if(!this.dynamicProperties.length){
        this.mdf = false;
    }
    var i, len = this.shapes.length;
    var j, jLen;
    var shapeData, localShapeCollection, currentPath;
    var copies = Math.ceil(this.c.v);
    var offset = this.o.v;
    var offsetModulo = offset%1;
    var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
    var k, pathData, shapeCollection, shapeCollectionList;
    var tMat = this.tr.v.props;
    var pProps = this.pMatrix.props;
    var rProps = this.rMatrix.props;
    var sProps = this.sMatrix.props;
    var iteration = 0;
    var l, lLen, tProps,transformers, maxLvl;
    for(i=0;i<len;i+=1){
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;
        if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
            localShapeCollection.releaseShapes();
            shapeData.shape.mdf = true;
            shapeCollection = shapeData.shape.paths;
            shapeCollectionList = shapeCollection.shapes;
            jLen = shapeCollection._length;
            iteration = 0;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();

            if(offset > 0) {
                while(iteration<roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if(offsetModulo){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if(roundOffset < 0) {
                while(iteration>roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if(offsetModulo){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            for(j=0;j<jLen;j+=1){
                currentPath = shapeCollectionList[j];
                for(k=0;k<copies;k+=1) {
                    if(k !== 0) {
                        this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    }
                    if(shapeData.data.transformers) {
                        shapeData.data.lvl = 0;
                        maxLvl = 0;
                        lLen = shapeData.data.elements.length;
                        for(l = 0; l < lLen; l += 1) {
                            maxLvl = Math.max(maxLvl, shapeData.data.elements[l].st.lvl);
                        } 
                        transformers = shapeData.data.transformers;
                        lLen = transformers.length;
                        for(l = lLen - 1; l >= maxLvl; l -= 1) {
                            tProps = transformers[l].mProps.v.props;
                            this.matrix.transform(tProps[0],tProps[1],tProps[2],tProps[3],tProps[4],tProps[5],tProps[6],tProps[7],tProps[8],tProps[9],tProps[10],tProps[11],tProps[12],tProps[13],tProps[14],tProps[15]);
                        }
                    }
                    if(iteration !== 0){
                        this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
                        this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
                        this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
                    }
                    localShapeCollection.addShape(this.processPath(currentPath, this.matrix));
                    this.matrix.reset();
                    iteration += 1;
                }
            }
        }
        shapeData.shape.paths = localShapeCollection;
    }
};

RepeaterModifier.prototype.processPath = function(path, transform) {
    var clonedPath = shape_pool.clone(path, transform);
    return clonedPath;
};


ShapeModifiers.registerModifier('rp',RepeaterModifier);
function ShapeCollection(){
	this._length = 0;
	this._maxLength = 4;
	this.shapes = Array.apply(null,{length:this._maxLength});
};

ShapeCollection.prototype.addShape = function(shapeData){
	if(this._length === this._maxLength){
		this.shapes = this.shapes.concat(Array.apply(null,{length:this._maxLength}));
		this._maxLength *= 2;
	}
	this.shapes[this._length] = shapeData;
	this._length += 1;
};

ShapeCollection.prototype.releaseShapes = function(){
	var i;
	for(i = 0; i < this._length; i += 1) {
		shape_pool.release(this.shapes[i]);
	}
	this._length = 0;
};
var ImagePreloader = (function(){

    function imageLoaded(){
        this.loadedAssets += 1;
        if(this.loadedAssets === this.totalImages){
        }
    }

    function getAssetsPath(assetData){
        var path = '';
        if(this.assetsPath){
            var imagePath = assetData.p;
            if(imagePath.indexOf('images/') !== -1){
                imagePath = imagePath.split('/')[1];
            }
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    }

    function loadImage(path){
        var img = document.createElement('img');
        img.addEventListener('load', imageLoaded.bind(this), false);
        img.addEventListener('error', imageLoaded.bind(this), false);
        img.src = path;
    }
    function loadAssets(assets){
        this.totalAssets = assets.length;
        var i;
        for(i=0;i<this.totalAssets;i+=1){
            if(!assets[i].layers){
                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
                this.totalImages += 1;
            }
        }
    }

    function setPath(path){
        this.path = path || '';
    }

    function setAssetsPath(path){
        this.assetsPath = path || '';
    }

    return function ImagePreloader(){
        this.loadAssets = loadAssets;
        this.setAssetsPath = setAssetsPath;
        this.setPath = setPath;
        this.assetsPath = '';
        this.path = '';
        this.totalAssets = 0;
        this.totalImages = 0;
        this.loadedAssets = 0;
    }
}());
var featureSupport = (function(){
	var ob = {
		maskType: true
	}
	if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	   ob.maskType = false;
	}
	return ob;
}());
var filtersFactory = (function(){
	var ob = {};
	ob.createFilter = createFilter;
	ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

	function createFilter(filId){
        	var fil = document.createElementNS(svgNS,'filter');
        	fil.setAttribute('id',filId);
                fil.setAttribute('filterUnits','objectBoundingBox');
                fil.setAttribute('x','0%');
                fil.setAttribute('y','0%');
                fil.setAttribute('width','100%');
                fil.setAttribute('height','100%');
                return fil;
	}

	function createAlphaToLuminanceFilter(){
                var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
                feColorMatrix.setAttribute('type','matrix');
                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 0 1');
                return feColorMatrix;
	}

	return ob;
}())
var pooling = (function(){

	function double(arr){
		return arr.concat(Array.apply(null,{length:arr.length}))
	}

	return {
		double: double
	}
}());
var point_pool = (function(){
	var ob = {
		newPoint: newPoint,
		release: release
		/*,getLength:function(){return _length}
		,getCont:function(){return cont}*/
	}

	var _length = 0;
	var _maxLength = 8;
	var pool = Array.apply(null,{length:_maxLength});

	//var cont = 0;

	function newPoint(){
		//window.bm_newPoint = window.bm_newPoint ? window.bm_newPoint + 1 : 1;
		var point;
		if(_length){
			_length -= 1;
			point = pool[_length];
			//window.bm_reuse = window.bm_reuse ? window.bm_reuse + 1 : 1;
		} else {
			point = [0.1,0.1];
			//cont++;
			//console.log('new');
			//window.bm_new = window.bm_new ? window.bm_new + 1 : 1;
			//point._tst = cont++;
		}
		return point;
	}

	function release(point) {
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = point;
		_length += 1;
		//window.bm_release = window.bm_release ? window.bm_release + 1 : 1;
		//console.log('release');
	}


	return ob;
}());
var shape_pool = (function(){
	var ob = {
		clone: clone,
		newShape: newShape,
		release: release,
		releaseArray: releaseArray
	}

	var _length = 0;
	var _maxLength = 4;
	var pool = Array.apply(null,{length:_maxLength});

	function newShape(){
		var shapePath;
		if(_length){
			_length -= 1;
			shapePath = pool[_length];
		} else {
			shapePath = new ShapePath();
		}
		return shapePath;
	}

	function release(shapePath) {
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		var len = shapePath._length, i;
		for(i = 0; i < len; i += 1) {
			point_pool.release(shapePath.v[i]);
			point_pool.release(shapePath.i[i]);
			point_pool.release(shapePath.o[i]);
			shapePath.v[i] = null;
			shapePath.i[i] = null;
			shapePath.o[i] = null;
		}
		shapePath._length = 0;
		shapePath.c = false;
		pool[_length] = shapePath;
		_length += 1;
	}

	function releaseArray(shapePathsCollection, length) {
		while(length--) {
			release(shapePathsCollection[length]);
		}
	}

	function clone(shape, transform) {
		var i, len = shape._length;
		var cloned = newShape();
		cloned._length = shape._length;
		cloned.c = shape.c;

		var pt;
		
		for(i = 0; i < len; i += 1) {
			if(transform){
				pt = transform.applyToPointArray(shape.v[i][0],shape.v[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'v',i);
				point_pool.release(pt);
				pt = transform.applyToPointArray(shape.o[i][0],shape.o[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'o',i);
				point_pool.release(pt);
				pt = transform.applyToPointArray(shape.i[i][0],shape.i[i][1],0,2);
				cloned.setXYAt(pt[0],pt[1],'i',i);
				point_pool.release(pt);
			}else{
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
		}
		return cloned
	}


	return ob;
}());
var shapeCollection_pool = (function(){
	var ob = {
		newShapeCollection: newShapeCollection,
		release: release,
		clone: clone
	}

	var _length = 0;
	var _maxLength = 4;
	var pool = Array.apply(null,{length:_maxLength});

	var cont = 0;

	function newShapeCollection(){
		var shapeCollection;
		if(_length){
			_length -= 1;
			shapeCollection = pool[_length];
		} else {
			shapeCollection = new ShapeCollection();
		}
		return shapeCollection;
	}

	function release(shapeCollection) {
		var i, len = shapeCollection._length;
		for(i = 0; i < len; i += 1) {
			shape_pool.release(shapeCollection.shapes[i]);
		}
		shapeCollection._length = 0;

		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = shapeCollection;
		_length += 1;
	}

	function clone(shapeCollection, originCollection) {
		release(shapeCollection);
		if(_length === _maxLength) {
			pool = pooling.double(pool);
			_maxLength = _maxLength*2;
		}
		pool[_length] = shapeCollection;
		_length += 1;
	}


	return ob;
}());
function BaseRenderer(){}
BaseRenderer.prototype.checkLayers = function(num){
    var i, len = this.layers.length, data;
    this.completeLayers = true;
    for (i = len - 1; i >= 0; i--) {
        if (!this.elements[i]) {
            data = this.layers[i];
            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
            {
                this.buildItem(i);
            }
        }
        this.completeLayers = this.elements[i] ? this.completeLayers:false;
    }
    this.checkPendingElements();
};

BaseRenderer.prototype.createItem = function(layer){
    switch(layer.ty){
        case 2:
            return this.createImage(layer);
        case 0:
            return this.createComp(layer);
        case 1:
            return this.createSolid(layer);
        case 4:
            return this.createShape(layer);
        case 5:
            return this.createText(layer);
        case 99:
            return null;
    }
    return this.createBase(layer);
};
BaseRenderer.prototype.buildAllItems = function(){
    var i, len = this.layers.length;
    for(i=0;i<len;i+=1){
        this.buildItem(i);
    }
    this.checkPendingElements();
};

BaseRenderer.prototype.includeLayers = function(newLayers){
    this.completeLayers = false;
    var i, len = newLayers.length;
    var j, jLen = this.layers.length;
    for(i=0;i<len;i+=1){
        j = 0;
        while(j<jLen){
            if(this.layers[j].id == newLayers[i].id){
                this.layers[j] = newLayers[i];
                break;
            }
            j += 1;
        }
    }
};

BaseRenderer.prototype.setProjectInterface = function(pInterface){
    this.globalData.projectInterface = pInterface;
};

BaseRenderer.prototype.initItems = function(){
    if(!this.globalData.progressiveLoad){
        this.buildAllItems();
    }
};
BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy){
    hierarchy = hierarchy || [];
    var elements = this.elements;
    var layers = this.layers;
    var i=0, len = layers.length;
    while(i<len){
        if(layers[i].ind == parentName){
            if(!elements[i] || elements[i] === true){
                this.buildItem(i);
                this.addPendingElement(element);
            } else if(layers[i].parent !== undefined){
                hierarchy.push(elements[i]);
                elements[i]._isParent = true;
                this.buildElementParenting(element,layers[i].parent, hierarchy);
            } else {
                hierarchy.push(elements[i]);
                elements[i]._isParent = true;
                element.setHierarchy(hierarchy);
            }


        }
        i += 1;
    }
};

BaseRenderer.prototype.addPendingElement = function(element){
    this.pendingElements.push(element);
};
function SVGRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.renderConfig = {
        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
        progressiveLoad: (config && config.progressiveLoad) || false
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;

}

extendPrototype(BaseRenderer,SVGRenderer);

SVGRenderer.prototype.createBase = function (data) {
    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createShape = function (data) {
    return new IShapeElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createText = function (data) {
    return new SVGTextElement(data, this.layerElement,this.globalData,this);

};

SVGRenderer.prototype.createImage = function (data) {
    return new IImageElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.createComp = function (data) {
    return new ICompElement(data, this.layerElement,this.globalData,this);

};

SVGRenderer.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.layerElement,this.globalData,this);
};

SVGRenderer.prototype.configAnimation = function(animData){
    this.layerElement = document.createElementNS(svgNS,'svg');
    this.layerElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
    this.layerElement.setAttribute('width',animData.w);
    this.layerElement.setAttribute('height',animData.h);
    this.layerElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
    this.layerElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
    this.layerElement.style.width = '100%';
    this.layerElement.style.height = '100%';
    //this.layerElement.style.transform = 'translate3d(0,0,0)';
    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
    this.animationItem.wrapper.appendChild(this.layerElement);
    //Mask animation
    var defs = document.createElementNS(svgNS, 'defs');
    this.globalData.defs = defs;
    this.layerElement.appendChild(defs);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.globalData.frameId = 0;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.data = animData;
    this.globalData.frameRate = animData.fr;
    var maskElement = document.createElementNS(svgNS, 'clipPath');
    var rect = document.createElementNS(svgNS,'rect');
    rect.setAttribute('width',animData.w);
    rect.setAttribute('height',animData.h);
    rect.setAttribute('x',0);
    rect.setAttribute('y',0);
    var maskId = 'animationMask_'+randomString(10);
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    var maskedElement = document.createElementNS(svgNS,'g');
    maskedElement.setAttribute("clip-path", "url(#"+maskId+")");
    this.layerElement.appendChild(maskedElement);
    defs.appendChild(maskElement);
    this.layerElement = maskedElement;
    this.layers = animData.layers;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,defs);
    this.elements = Array.apply(null,{length:animData.layers.length});
};


SVGRenderer.prototype.destroy = function () {
    this.animationItem.wrapper.innerHTML = '';
    this.layerElement = null;
    this.globalData.defs = null;
    var i, len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i++) {
        if(this.elements[i]){
            this.elements[i].destroy();
        }
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};

SVGRenderer.prototype.updateContainerSize = function () {
};

SVGRenderer.prototype.buildItem  = function(pos){
    var elements = this.elements;
    if(elements[pos] || this.layers[pos].ty == 99){
        return;
    }
    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);

    elements[pos] = element;
    if(expressionsPlugin){
        if(this.layers[pos].ty === 0){
            this.globalData.projectInterface.registerComposition(element);
        }
        element.initExpressions();
    }
    this.appendElementInPos(element,pos);
    if(this.layers[pos].tt){
        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
            this.buildItem(pos - 1);
            this.addPendingElement(element);
        } else {
            element.setMatte(elements[pos - 1].layerId);
        }
    }
};

SVGRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
        if(element.data.tt){
            var i = 0, len = this.elements.length;
            while(i<len){
                if(this.elements[i] === element){
                    element.setMatte(this.elements[i - 1].layerId);
                    break;
                }
                i += 1;
            }
        }
    }
};

SVGRenderer.prototype.renderFrame = function(num){
    if(this.renderedFrame == num || this.destroyed){
        return;
    }
    if(num === null){
        num = this.renderedFrame;
    }else{
        this.renderedFrame = num;
    }
    //clearPoints();
    /*console.log('-------');
    console.log('FRAME ',num);*/
    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    var i, len = this.layers.length;
    if(!this.completeLayers){
        this.checkLayers(num);
    }
    for (i = len - 1; i >= 0; i--) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(num - this.layers[i].st);
        }
    }
    for (i = len - 1; i >= 0; i--) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
};

SVGRenderer.prototype.appendElementInPos = function(element, pos){
    var newElement = element.getBaseElement();
    if(!newElement){
        return;
    }
    var i = 0;
    var nextElement;
    while(i<pos){
        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
            nextElement = this.elements[i].getBaseElement();
        }
        i += 1;
    }
    if(nextElement){
        this.layerElement.insertBefore(newElement, nextElement);
    } else {
        this.layerElement.appendChild(newElement);
    }
};

SVGRenderer.prototype.hide = function(){
    this.layerElement.style.display = 'none';
};

SVGRenderer.prototype.show = function(){
    this.layerElement.style.display = 'block';
};

SVGRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElementNS(svgNS,'g');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
            comp.initExpressions();
            //comp.compInterface = CompExpressionInterface(comp);
            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};

function MaskElement(data,element,globalData) {
    this.dynamicProperties = [];
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.paths = [];
    this.storedData = [];
    this.masksProperties = this.data.masksProperties;
    this.viewData = new Array(this.masksProperties.length);
    this.maskElement = null;
    this.firstFrame = true;
    var defs = this.globalData.defs;
    var i, len = this.masksProperties.length;


    var path, properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j, jLen;
    var layerId = randomString(10);
    var rect, expansor, feMorph,x;
    var maskType = 'clipPath', maskRef = 'clip-path';
    for (i = 0; i < len; i++) {

        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
            maskType = 'mask';
            maskRef = 'mask';
        }

        if((properties[i].mode == 's' || properties[i].mode == 'i') && count == 0){
            rect = document.createElementNS(svgNS, 'rect');
            rect.setAttribute('fill', '#ffffff');
            rect.setAttribute('width', this.element.comp.data.w);
            rect.setAttribute('height', this.element.comp.data.h);
            currentMasks.push(rect);
        } else {
            rect = null;
        }

        path = document.createElementNS(svgNS, 'path');
        if(properties[i].mode == 'n') {
            this.viewData[i] = {
                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null),
                elem: path
            };
            defs.appendChild(path);
            continue;
        }
        count += 1;

        if(properties[i].mode == 's'){
            path.setAttribute('fill', '#000000');
        }else{
            path.setAttribute('fill', '#ffffff');
        }
        path.setAttribute('clip-rule','nonzero');

        if(properties[i].x.k !== 0){
            maskType = 'mask';
            maskRef = 'mask';
            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.dynamicProperties);
            var filterID = 'fi_'+randomString(10);
            expansor = document.createElementNS(svgNS,'filter');
            expansor.setAttribute('id',filterID);
            feMorph = document.createElementNS(svgNS,'feMorphology');
            feMorph.setAttribute('operator','dilate');
            feMorph.setAttribute('in','SourceGraphic');
            feMorph.setAttribute('radius','0');
            expansor.appendChild(feMorph);
            defs.appendChild(expansor);
            if(properties[i].mode == 's'){
                path.setAttribute('stroke', '#000000');
            }else{
                path.setAttribute('stroke', '#ffffff');
            }
        }else{
            feMorph = null;
            x = null;
        }


        this.storedData[i] = {
             elem: path,
             x: x,
             expan: feMorph,
            lastPath: '',
            lastOperator:'',
            filterId:filterID,
            lastRadius:0
        };
        if(properties[i].mode == 'i'){
            jLen = currentMasks.length;
            var g = document.createElementNS(svgNS,'g');
            for(j=0;j<jLen;j+=1){
                g.appendChild(currentMasks[j]);
            }
            var mask = document.createElementNS(svgNS,'mask');
            mask.setAttribute('mask-type','alpha');
            mask.setAttribute('id',layerId+'_'+count);
            mask.appendChild(path);
            defs.appendChild(mask);
            g.setAttribute('mask','url(#'+layerId+'_'+count+')');

            currentMasks.length = 0;
            currentMasks.push(g);
        }else{
            currentMasks.push(path);
        }
        if(properties[i].inv && !this.solidPath){
            this.solidPath = this.createLayerSolidPath();
        }
        this.viewData[i] = {
            elem: path,
            lastPath: '',
            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null)
        };
        if(rect){
            this.viewData[i].invRect = rect;
        }
        if(!this.viewData[i].prop.k){
            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
        }
    }

    this.maskElement = document.createElementNS(svgNS, maskType);

    len = currentMasks.length;
    for(i=0;i<len;i+=1){
        this.maskElement.appendChild(currentMasks[i]);
    }

    this.maskElement.setAttribute('id', layerId);
    if(count > 0){
        this.element.maskedElement.setAttribute(maskRef, "url(#" + layerId + ")");
    }

    defs.appendChild(this.maskElement);
};

MaskElement.prototype.getMaskProperty = function(pos){
    return this.viewData[pos].prop;
};

MaskElement.prototype.prepareFrame = function(){
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();

    }
};

MaskElement.prototype.renderFrame = function (finalMat) {
    var i, len = this.masksProperties.length;
    for (i = 0; i < len; i++) {
        if(this.viewData[i].prop.mdf || this.firstFrame){
            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
        }
        if(this.viewData[i].op.mdf || this.firstFrame){
            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
        }
        if(this.masksProperties[i].mode !== 'n'){
            if(this.viewData[i].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame)){
                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
            }
            if(this.storedData[i].x && (this.storedData[i].x.mdf || this.firstFrame)){
                var feMorph = this.storedData[i].expan;
                if(this.storedData[i].x.v < 0){
                    if(this.storedData[i].lastOperator !== 'erode'){
                        this.storedData[i].lastOperator = 'erode';
                        this.storedData[i].elem.setAttribute('filter','url(#'+this.storedData[i].filterId+')');
                    }
                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
                }else{
                    if(this.storedData[i].lastOperator !== 'dilate'){
                        this.storedData[i].lastOperator = 'dilate';
                        this.storedData[i].elem.setAttribute('filter',null);
                    }
                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);

                }
            }
        }
    }
    this.firstFrame = false;
};

MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
};

MaskElement.prototype.createLayerSolidPath = function(){
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w ;
    path += ' v' + this.globalData.compSize.h ;
    path += ' h-' + this.globalData.compSize.w ;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
};

MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    var i, len;
    len = pathNodes._length;
    for(i=1;i<len;i+=1){
        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[i][0])+','+bm_rnd(pathNodes.i[i][1]) + " "+bm_rnd(pathNodes.v[i][0])+','+bm_rnd(pathNodes.v[i][1]);
    }
        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    if(pathNodes.c && len > 1){
        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[0][0])+','+bm_rnd(pathNodes.i[0][1]) + " "+bm_rnd(pathNodes.v[0][0])+','+bm_rnd(pathNodes.v[0][1]);
    }
    //pathNodes.__renderedString = pathString;


    if(viewData.lastPath !== pathString){
        if(viewData.elem){
            if(!pathNodes.c){
                viewData.elem.setAttribute('d','');
            }else if(pathData.inv){
                viewData.elem.setAttribute('d',this.solidPath + pathString);
            }else{
                viewData.elem.setAttribute('d',pathString);
            }
        }
        viewData.lastPath = pathString;
    }
};

MaskElement.prototype.getMask = function(nm){
    var i = 0, len = this.masksProperties.length;
    while(i<len){
        if(this.masksProperties[i].nm === nm){
            return {
                maskPath: this.viewData[i].prop.pv
            }
        }
        i += 1;
    }
};

MaskElement.prototype.destroy = function(){
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.paths = null;
    this.masksProperties = null;
};
function BaseElement(){
};
BaseElement.prototype.checkMasks = function(){
    if(!this.data.hasMask){
        return false;
    }
    var i = 0, len = this.data.masksProperties.length;
    while(i<len) {
        if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
            return true;
        }
        i += 1;
    }
    return false;
}

BaseElement.prototype.checkParenting = function(){
    if(this.data.parent !== undefined){
        this.comp.buildElementParenting(this, this.data.parent);
    }
}

BaseElement.prototype.prepareFrame = function(num){
    if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
    {
        if(this.isVisible !== true){
            this.elemMdf = true;
            this.globalData.mdf = true;
            this.isVisible = true;
            this.firstFrame = true;
            if(this.data.hasMask){
                this.maskManager.firstFrame = true;
            }
        }
    }else{
        if(this.isVisible !== false){
            this.elemMdf = true;
            this.globalData.mdf = true;
            this.isVisible = false;
        }
    }
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        if(this.isVisible || (this._isParent && this.dynamicProperties[i].type === 'transform')){
            this.dynamicProperties[i].getValue();
            if(this.dynamicProperties[i].mdf){
                this.elemMdf = true;
                this.globalData.mdf = true;
            }
        }
    }
    if(this.data.hasMask && this.isVisible){
        this.maskManager.prepareFrame(num*this.data.sr);
    }
    
    /* TODO check this
    if(this.data.sy){
        if(this.data.sy[0].renderedData[num]){
            if(this.data.sy[0].renderedData[num].c){
                this.feFlood.setAttribute('flood-color','rgb('+Math.round(this.data.sy[0].renderedData[num].c[0])+','+Math.round(this.data.sy[0].renderedData[num].c[1])+','+Math.round(this.data.sy[0].renderedData[num].c[2])+')');
            }
            if(this.data.sy[0].renderedData[num].s){
                this.feMorph.setAttribute('radius',this.data.sy[0].renderedData[num].s);
            }
        }
    }
    */


    this.currentFrameNum = num*this.data.sr;
    return this.isVisible;
};

BaseElement.prototype.globalToLocal = function(pt){
    var transforms = [];
    transforms.push(this.finalTransform);
    var flag = true;
    var comp = this.comp;
    while(flag){
        if(comp.finalTransform){
            if(comp.data.hasMask){
                transforms.splice(0,0,comp.finalTransform);
            }
            comp = comp.comp;
        } else {
            flag = false;
        }
    }
    var i, len = transforms.length,ptNew;
    for(i=0;i<len;i+=1){
        ptNew = transforms[i].mat.applyToPointArray(0,0,0);
        //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
        pt = [pt[0] - ptNew[0],pt[1] - ptNew[1],0];
    }
    return pt;
};

BaseElement.prototype.initExpressions = function(){
    this.layerInterface = LayerExpressionInterface(this);
    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
    //layers[i].layerInterface = LayerExpressionInterface(layers[i]);
    if(this.data.hasMask){
        this.layerInterface.registerMaskInterface(this.maskManager);
    }
    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
    this.layerInterface.registerEffectsInterface(effectsInterface);

    if(this.data.ty === 0 || this.data.xt){
        this.compInterface = CompExpressionInterface(this);
    } else if(this.data.ty === 4){
        this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData,this.viewData,this.layerInterface);
    } else if(this.data.ty === 5){
        this.layerInterface.textInterface = TextExpressionInterface(this);
    }
}

BaseElement.prototype.setBlendMode = function(){
    var blendModeValue = '';
    switch(this.data.bm){
        case 1:
            blendModeValue = 'multiply';
            break;
        case 2:
            blendModeValue = 'screen';
            break;
        case 3:
            blendModeValue = 'overlay';
            break;
        case 4:
            blendModeValue = 'darken';
            break;
        case 5:
            blendModeValue = 'lighten';
            break;
        case 6:
            blendModeValue = 'color-dodge';
            break;
        case 7:
            blendModeValue = 'color-burn';
            break;
        case 8:
            blendModeValue = 'hard-light';
            break;
        case 9:
            blendModeValue = 'soft-light';
            break;
        case 10:
            blendModeValue = 'difference';
            break;
        case 11:
            blendModeValue = 'exclusion';
            break;
        case 12:
            blendModeValue = 'hue';
            break;
        case 13:
            blendModeValue = 'saturation';
            break;
        case 14:
            blendModeValue = 'color';
            break;
        case 15:
            blendModeValue = 'luminosity';
            break;
    }
    var elem = this.baseElement || this.layerElement;

    elem.style['mix-blend-mode'] = blendModeValue;
}

BaseElement.prototype.init = function(){
    if(!this.data.sr){
        this.data.sr = 1;
    }
    this.dynamicProperties = [];
    if(this.data.ef){
        this.effects = new EffectsManager(this.data,this,this.dynamicProperties);
        //this.effect = this.effectsManager.bind(this.effectsManager);
    }
    //this.elemInterface = buildLayerExpressionInterface(this);
    this.hidden = false;
    this.firstFrame = true;
    this.isVisible = false;
    this._isParent = false;
    this.currentFrameNum = -99999;
    this.lastNum = -99999;
    if(this.data.ks){
        this.finalTransform = {
            mProp: PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),
            matMdf: false,
            opMdf: false,
            mat: new Matrix(),
            opacity: 1
        };
        if(this.data.ao){
            this.finalTransform.mProp.autoOriented = true;
        }
        this.finalTransform.op = this.finalTransform.mProp.o;
        this.transform = this.finalTransform.mProp;
        if(this.data.ty !== 11){
            this.createElements();
        }
        if(this.data.hasMask){
            this.addMasks(this.data);
        }
    }
    this.elemMdf = false;
};
BaseElement.prototype.getType = function(){
    return this.type;
};

BaseElement.prototype.resetHierarchy = function(){
    if(!this.hierarchy){
        this.hierarchy = [];
    }else{
        this.hierarchy.length = 0;
    }
};

BaseElement.prototype.getHierarchy = function(){
    if(!this.hierarchy){
        this.hierarchy = [];
    }
    return this.hierarchy;
};

BaseElement.prototype.setHierarchy = function(hierarchy){
    this.hierarchy = hierarchy;
};

BaseElement.prototype.getLayerSize = function(){
    if(this.data.ty === 5){
        return {w:this.data.textData.width,h:this.data.textData.height};
    }else{
        return {w:this.data.width,h:this.data.height};
    }
};

BaseElement.prototype.hide = function(){

};

BaseElement.prototype.mHelper = new Matrix();
function SVGBaseElement(data,parentContainer,globalData,comp, placeholder){
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.matteElement = null;
    this.transformedElement = null;
    this.parentContainer = parentContainer;
    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
    this.placeholder = placeholder;
    this.init();
};

createElement(BaseElement, SVGBaseElement);

SVGBaseElement.prototype.createElements = function(){
    this.layerElement = document.createElementNS(svgNS,'g');
    this.transformedElement = this.layerElement;
    if(this.data.hasMask){
        this.maskedElement = this.layerElement;
    }
    var layerElementParent = null;
    if(this.data.td){
        if(this.data.td == 3 || this.data.td == 1){
            var masker = document.createElementNS(svgNS,'mask');
            masker.setAttribute('id',this.layerId);
            masker.setAttribute('mask-type',this.data.td == 3 ? 'luminance':'alpha');
            masker.appendChild(this.layerElement);
            layerElementParent = masker;
            this.globalData.defs.appendChild(masker);
            ////// This is only for IE and Edge when mask if of type alpha
            if(!featureSupport.maskType && this.data.td == 1){
                masker.setAttribute('mask-type','luminance');
                var filId = randomString(10);
                var fil = filtersFactory.createFilter(filId);
                this.globalData.defs.appendChild(fil);
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                var gg = document.createElementNS(svgNS,'g');
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                masker.appendChild(gg);
                gg.setAttribute('filter','url(#'+filId+')');
            }
        }else if(this.data.td == 2){
            var maskGroup = document.createElementNS(svgNS,'mask');
            maskGroup.setAttribute('id',this.layerId);
            maskGroup.setAttribute('mask-type','alpha');
            var maskGrouper = document.createElementNS(svgNS,'g');
            maskGroup.appendChild(maskGrouper);
            var filId = randomString(10);
            var fil = filtersFactory.createFilter(filId);
            ////

            var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
            feColorMatrix.setAttribute('type','matrix');
            feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
            feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
            fil.appendChild(feColorMatrix);

            ////
            /*var feCTr = document.createElementNS(svgNS,'feComponentTransfer');
            feCTr.setAttribute('in','SourceGraphic');
            fil.appendChild(feCTr);
            var feFunc = document.createElementNS(svgNS,'feFuncA');
            feFunc.setAttribute('type','table');
            feFunc.setAttribute('tableValues','1.0 0.0');
            feCTr.appendChild(feFunc);*/
            this.globalData.defs.appendChild(fil);
            var alphaRect = document.createElementNS(svgNS,'rect');
            alphaRect.setAttribute('width',this.comp.data.w);
            alphaRect.setAttribute('height',this.comp.data.h);
            alphaRect.setAttribute('x','0');
            alphaRect.setAttribute('y','0');
            alphaRect.setAttribute('fill','#ffffff');
            alphaRect.setAttribute('opacity','0');
            maskGrouper.setAttribute('filter','url(#'+filId+')');
            maskGrouper.appendChild(alphaRect);
            maskGrouper.appendChild(this.layerElement);
            layerElementParent = maskGrouper;
            if(!featureSupport.maskType){
                maskGroup.setAttribute('mask-type','luminance');
                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                var gg = document.createElementNS(svgNS,'g');
                maskGrouper.appendChild(alphaRect);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                maskGrouper.appendChild(gg);
            }
            this.globalData.defs.appendChild(maskGroup);
        }
    }else if(this.data.hasMask || this.data.tt){
        if(this.data.tt){
            this.matteElement = document.createElementNS(svgNS,'g');
            this.matteElement.appendChild(this.layerElement);
            layerElementParent = this.matteElement;
            this.baseElement = this.matteElement;
        }else{
            this.baseElement = this.layerElement;
        }
    }else{
        this.baseElement = this.layerElement;
    }
    if((this.data.ln || this.data.cl) && (this.data.ty === 4 || this.data.ty === 0)){
        if(this.data.ln){
            this.layerElement.setAttribute('id',this.data.ln);
        }
        if(this.data.cl){
            this.layerElement.setAttribute('class',this.data.cl);
        }
    }
    if(this.data.ty === 0){
            var cp = document.createElementNS(svgNS, 'clipPath');
            var pt = document.createElementNS(svgNS,'path');
            pt.setAttribute('d','M0,0 L'+this.data.w+',0'+' L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');
            var clipId = 'cp_'+randomString(8);
            cp.setAttribute('id',clipId);
            cp.appendChild(pt);
            this.globalData.defs.appendChild(cp);
        if(this.checkMasks()){
            var cpGroup = document.createElementNS(svgNS,'g');
            cpGroup.setAttribute('clip-path','url(#'+clipId+')');
            cpGroup.appendChild(this.layerElement);
            this.transformedElement = cpGroup;
            if(layerElementParent){
                layerElementParent.appendChild(this.transformedElement);
            } else {
                this.baseElement = this.transformedElement;
            }
        } else {
            this.layerElement.setAttribute('clip-path','url(#'+clipId+')');
        }
        
    }
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    if(this.layerElement !== this.parentContainer){
        this.placeholder = null;
    }
    /* Todo performance killer
    if(this.data.sy){
        var filterID = 'st_'+randomString(10);
        var c = this.data.sy[0].c.k;
        var r = this.data.sy[0].s.k;
        var expansor = document.createElementNS(svgNS,'filter');
        expansor.setAttribute('id',filterID);
        var feFlood = document.createElementNS(svgNS,'feFlood');
        this.feFlood = feFlood;
        if(!c[0].e){
            feFlood.setAttribute('flood-color','rgb('+c[0]+','+c[1]+','+c[2]+')');
        }
        feFlood.setAttribute('result','base');
        expansor.appendChild(feFlood);
        var feMorph = document.createElementNS(svgNS,'feMorphology');
        feMorph.setAttribute('operator','dilate');
        feMorph.setAttribute('in','SourceGraphic');
        feMorph.setAttribute('result','bigger');
        this.feMorph = feMorph;
        if(!r.length){
            feMorph.setAttribute('radius',this.data.sy[0].s.k);
        }
        expansor.appendChild(feMorph);
        var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
        feColorMatrix.setAttribute('result','mask');
        feColorMatrix.setAttribute('in','bigger');
        feColorMatrix.setAttribute('type','matrix');
        feColorMatrix.setAttribute('values','0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0');
        expansor.appendChild(feColorMatrix);
        var feComposite = document.createElementNS(svgNS,'feComposite');
        feComposite.setAttribute('result','drop');
        feComposite.setAttribute('in','base');
        feComposite.setAttribute('in2','mask');
        feComposite.setAttribute('operator','in');
        expansor.appendChild(feComposite);
        var feBlend = document.createElementNS(svgNS,'feBlend');
        feBlend.setAttribute('in','SourceGraphic');
        feBlend.setAttribute('in2','drop');
        feBlend.setAttribute('mode','normal');
        expansor.appendChild(feBlend);
        this.globalData.defs.appendChild(expansor);
        var cont = document.createElementNS(svgNS,'g');
        if(this.layerElement === this.parentContainer){
            this.layerElement = cont;
        }else{
            cont.appendChild(this.layerElement);
        }
        cont.setAttribute('filter','url(#'+filterID+')');
        if(this.data.td){
            cont.setAttribute('data-td',this.data.td);
        }
        if(this.data.td == 3){
            this.globalData.defs.appendChild(cont);
        }else if(this.data.td == 2){
            maskGrouper.appendChild(cont);
        }else if(this.data.td == 1){
            masker.appendChild(cont);
        }else{
            if(this.data.hasMask && this.data.tt){
                this.matteElement.appendChild(cont);
            }else{
                this.appendNodeToParent(cont);
            }
        }
    }*/
    if(this.data.ef){
        this.effectsManager = new SVGEffects(this);
    }
    this.checkParenting();
};


SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;

SVGBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3 || this.data.hd || !this.isVisible){
        return false;
    }

    this.lastNum = this.currentFrameNum;
    this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i = 0, len = this.hierarchy.length;
        if(!this.finalTransform.matMdf) {
            while(i < len) {
                if(this.hierarchy[i].finalTransform.mProp.mdf) {
                    this.finalTransform.matMdf = true;
                    break;
                }
                i += 1;
            }
        }
        
        if(this.finalTransform.matMdf) {
            mat = this.finalTransform.mProp.v.props;
            finalMat.cloneFromProps(mat);
            for(i=0;i<len;i+=1){
                mat = this.hierarchy[i].finalTransform.mProp.v.props;
                finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
            }
        }
        
    }else if(this.isVisible){
        finalMat = this.finalTransform.mProp.v;
    }
    if(this.finalTransform.matMdf && this.layerElement){
        this.transformedElement.setAttribute('transform',finalMat.to2dCSS());
    }
    if(this.finalTransform.opMdf && this.layerElement){
        this.transformedElement.setAttribute('opacity',this.finalTransform.op.v);
    }

    if(this.data.hasMask){
        this.maskManager.renderFrame(finalMat);
    }
    if(this.effectsManager){
        this.effectsManager.renderFrame(this.firstFrame);
    }
    return this.isVisible;
};

SVGBaseElement.prototype.destroy = function(){
    this.layerElement = null;
    this.parentContainer = null;
    if(this.matteElement) {
        this.matteElement = null;
    }
    if(this.maskManager) {
        this.maskManager.destroy();
    }
};

SVGBaseElement.prototype.getBaseElement = function(){
    return this.baseElement;
};
SVGBaseElement.prototype.addMasks = function(data){
    this.maskManager = new MaskElement(data,this,this.globalData);
};

SVGBaseElement.prototype.setMatte = function(id){
    if(!this.matteElement){
        return;
    }
    this.matteElement.setAttribute("mask", "url(#" + id + ")");
};

SVGBaseElement.prototype.setMatte = function(id){
    if(!this.matteElement){
        return;
    }
    this.matteElement.setAttribute("mask", "url(#" + id + ")");
};

SVGBaseElement.prototype.hide = function(){

};

function ITextElement(data, animationItem,parentContainer,globalData){
}
ITextElement.prototype.init = function(){
    this._parent.init.call(this);

    this.lettersChangedFlag = false;
    this.currentTextDocumentData = {};
    var data = this.data;
    this.viewData = {
        m:{
            a: PropertyFactory.getProp(this,data.t.m.a,1,0,this.dynamicProperties)
        }
    };
    var textData = this.data.t;
    if(textData.a.length){
        this.viewData.a = Array.apply(null,{length:textData.a.length});
        var i, len = textData.a.length, animatorData, animatorProps;
        for(i=0;i<len;i+=1){
            animatorProps = textData.a[i];
            animatorData = {
                a: {},
                s: {}
            };
            if('r' in animatorProps.a) {
                animatorData.a.r = PropertyFactory.getProp(this,animatorProps.a.r,0,degToRads,this.dynamicProperties);
            }
            if('rx' in animatorProps.a) {
                animatorData.a.rx = PropertyFactory.getProp(this,animatorProps.a.rx,0,degToRads,this.dynamicProperties);
            }
            if('ry' in animatorProps.a) {
                animatorData.a.ry = PropertyFactory.getProp(this,animatorProps.a.ry,0,degToRads,this.dynamicProperties);
            }
            if('sk' in animatorProps.a) {
                animatorData.a.sk = PropertyFactory.getProp(this,animatorProps.a.sk,0,degToRads,this.dynamicProperties);
            }
            if('sa' in animatorProps.a) {
                animatorData.a.sa = PropertyFactory.getProp(this,animatorProps.a.sa,0,degToRads,this.dynamicProperties);
            }
            if('s' in animatorProps.a) {
                animatorData.a.s = PropertyFactory.getProp(this,animatorProps.a.s,1,0.01,this.dynamicProperties);
            }
            if('a' in animatorProps.a) {
                animatorData.a.a = PropertyFactory.getProp(this,animatorProps.a.a,1,0,this.dynamicProperties);
            }
            if('o' in animatorProps.a) {
                animatorData.a.o = PropertyFactory.getProp(this,animatorProps.a.o,0,0.01,this.dynamicProperties);
            }
            if('p' in animatorProps.a) {
                animatorData.a.p = PropertyFactory.getProp(this,animatorProps.a.p,1,0,this.dynamicProperties);
            }
            if('sw' in animatorProps.a) {
                animatorData.a.sw = PropertyFactory.getProp(this,animatorProps.a.sw,0,0,this.dynamicProperties);
            }
            if('sc' in animatorProps.a) {
                animatorData.a.sc = PropertyFactory.getProp(this,animatorProps.a.sc,1,0,this.dynamicProperties);
            }
            if('fc' in animatorProps.a) {
                animatorData.a.fc = PropertyFactory.getProp(this,animatorProps.a.fc,1,0,this.dynamicProperties);
            }
            if('fh' in animatorProps.a) {
                animatorData.a.fh = PropertyFactory.getProp(this,animatorProps.a.fh,0,0,this.dynamicProperties);
            }
            if('fs' in animatorProps.a) {
                animatorData.a.fs = PropertyFactory.getProp(this,animatorProps.a.fs,0,0.01,this.dynamicProperties);
            }
            if('fb' in animatorProps.a) {
                animatorData.a.fb = PropertyFactory.getProp(this,animatorProps.a.fb,0,0.01,this.dynamicProperties);
            }
            if('t' in animatorProps.a) {
                animatorData.a.t = PropertyFactory.getProp(this,animatorProps.a.t,0,0,this.dynamicProperties);
            }
            animatorData.s = PropertyFactory.getTextSelectorProp(this,animatorProps.s,this.dynamicProperties);
            animatorData.s.t = animatorProps.s.t;
            this.viewData.a[i] = animatorData;
        }
    }else{
        this.viewData.a = [];
    }
    if(textData.p && 'm' in textData.p){
        this.viewData.p = {
            f: PropertyFactory.getProp(this,textData.p.f,0,0,this.dynamicProperties),
            l: PropertyFactory.getProp(this,textData.p.l,0,0,this.dynamicProperties),
            r: textData.p.r,
            m: this.maskManager.getMaskProperty(textData.p.m)
        };
        this.maskPath = true;
    } else {
        this.maskPath = false;
    }
};
ITextElement.prototype.prepareFrame = function(num) {
    var i = 0, len = this.data.t.d.k.length;
    var textDocumentData = this.data.t.d.k[i].s;
    i += 1;
    while(i<len){
        if(this.data.t.d.k[i].t > num){
            break;
        }
        textDocumentData = this.data.t.d.k[i].s;
        i += 1;
    }
    this.lettersChangedFlag = false;
    if(textDocumentData !== this.currentTextDocumentData){
        this.currentTextDocumentData = textDocumentData;
        this.lettersChangedFlag = true;
        this.buildNewText();
    }
    this._parent.prepareFrame.call(this, num);
}

ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
    var j,jLen = shapes.length;
    var k, kLen, pathNodes;
    var shapeStr = '';
    for(j=0;j<jLen;j+=1){
        kLen = shapes[j].ks.k.i.length;
        pathNodes = shapes[j].ks.k;
        for(k=1;k<kLen;k+=1){
            if(k==1){
                shapeStr += " M"+matrixHelper.applyToPointStringified(pathNodes.v[0][0],pathNodes.v[0][1]);
            }
            shapeStr += " C"+matrixHelper.applyToPointStringified(pathNodes.o[k-1][0],pathNodes.o[k-1][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.i[k][0],pathNodes.i[k][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.v[k][0],pathNodes.v[k][1]);
        }
        shapeStr += " C"+matrixHelper.applyToPointStringified(pathNodes.o[k-1][0],pathNodes.o[k-1][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.i[0][0],pathNodes.i[0][1]) + " "+matrixHelper.applyToPointStringified(pathNodes.v[0][0],pathNodes.v[0][1]);
        shapeStr += 'z';
    }
    return shapeStr;
};

ITextElement.prototype.getMeasures = function(){

    var matrixHelper = this.mHelper;
    var renderType = this.renderType;
    var data = this.data;
    var xPos,yPos;
    var i, len;
    var documentData = this.currentTextDocumentData;
    var letters = documentData.l;
    if(this.maskPath) {
        var mask = this.viewData.p.m;
        if(!this.viewData.p.n || this.viewData.p.mdf){
            var paths = mask.v;
            if(this.viewData.p.r){
                paths = reversePath(paths);
            }
            var pathInfo = {
                tLength: 0,
                segments: []
            };
            len = paths.v.length - 1;
            var pathData;
            var totalLength = 0;
            for (i = 0; i < len; i += 1) {
                pathData = {
                    s: paths.v[i],
                    e: paths.v[i + 1],
                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
                };
                bez.buildBezierData(pathData);
                pathInfo.tLength += pathData.bezierData.segmentLength;
                pathInfo.segments.push(pathData);
                totalLength += pathData.bezierData.segmentLength;
            }
            i = len;
            if (mask.v.c) {
                pathData = {
                    s: paths.v[i],
                    e: paths.v[0],
                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
                };
                bez.buildBezierData(pathData);
                pathInfo.tLength += pathData.bezierData.segmentLength;
                pathInfo.segments.push(pathData);
                totalLength += pathData.bezierData.segmentLength;
            }
            this.viewData.p.pi = pathInfo;
        }
        var pathInfo = this.viewData.p.pi;

        var currentLength = this.viewData.p.f.v, segmentInd = 0, pointInd = 1, currentPoint, prevPoint, points;
        var segmentLength = 0, flag = true;
        var segments = pathInfo.segments;
        if (currentLength < 0 && mask.v.c) {
            if (pathInfo.tLength < Math.abs(currentLength)) {
                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
            }
            segmentInd = segments.length - 1;
            points = segments[segmentInd].bezierData.points;
            pointInd = points.length - 1;
            while (currentLength < 0) {
                currentLength += points[pointInd].partialLength;
                pointInd -= 1;
                if (pointInd < 0) {
                    segmentInd -= 1;
                    points = segments[segmentInd].bezierData.points;
                    pointInd = points.length - 1;
                }
            }

        }
        points = segments[segmentInd].bezierData.points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        var partialLength = currentPoint.partialLength;
        var perc, tanAngle;
    }


    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.s*1.2*.714;
    var firstLine = true;
    var renderedData = this.viewData, animatorProps, animatorSelector;
    var j, jLen;
    var lettersValue = Array.apply(null,{length:len}), letterValue;

    jLen = renderedData.a.length;
    var lastLetter;

    var mult, ind = -1, offf, xPathPos, yPathPos;
    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
    var elemOpacity;
    var sc,sw,fc,k;
    var lineLength = 0;
    var letterSw,letterSc,letterFc,letterM,letterP,letterO;
    for( i = 0; i < len; i += 1) {
        matrixHelper.reset();
        elemOpacity = 1;
        if(letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            currentLength = initPathPos ;
            firstLine = false;
            lineLength = 0;
            if(this.maskPath) {
                segmentInd = initSegmentInd;
                pointInd = initPointInd;
                points = segments[segmentInd].bezierData.points;
                prevPoint = points[pointInd - 1];
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
                segmentLength = 0;
            }
            lettersValue[i] = this.emptyProp;
        }else{
            if(this.maskPath) {
                if(currentLine !== letters[i].line){
                    switch(documentData.j){
                        case 1:
                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
                            break;
                        case 2:
                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
                            break;
                    }
                    currentLine = letters[i].line;
                }
                if (ind !== letters[i].ind) {
                    if (letters[ind]) {
                        currentLength += letters[ind].extra;
                    }
                    currentLength += letters[i].an / 2;
                    ind = letters[i].ind;
                }
                currentLength += renderedData.m.a.v[0] * letters[i].an / 200;
                var animatorOffset = 0;
                for (j = 0; j < jLen; j += 1) {
                    animatorProps = renderedData.a[j].a;
                    if ('p' in animatorProps) {
                        animatorSelector = renderedData.a[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                        if(mult.length){
                            animatorOffset += animatorProps.p.v[0] * mult[0];
                        } else{
                            animatorOffset += animatorProps.p.v[0] * mult;
                        }

                    }
                    if ('a' in animatorProps) {
                        animatorSelector = renderedData.a[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                        if(mult.length){
                            animatorOffset += animatorProps.a.v[0] * mult[0];
                        } else{
                            animatorOffset += animatorProps.a.v[0] * mult;
                        }

                    }
                }
                flag = true;
                while (flag) {
                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                        matrixHelper.translate(-renderedData.m.a.v[0]*letters[i].an/200, -(renderedData.m.a.v[1] * yOff / 100));
                        flag = false;
                    } else if (points) {
                        segmentLength += currentPoint.partialLength;
                        pointInd += 1;
                        if (pointInd >= points.length) {
                            pointInd = 0;
                            segmentInd += 1;
                            if (!segments[segmentInd]) {
                                if (mask.v.c) {
                                    pointInd = 0;
                                    segmentInd = 0;
                                    points = segments[segmentInd].bezierData.points;
                                } else {
                                    segmentLength -= currentPoint.partialLength;
                                    points = null;
                                }
                            } else {
                                points = segments[segmentInd].bezierData.points;
                            }
                        }
                        if (points) {
                            prevPoint = currentPoint;
                            currentPoint = points[pointInd];
                            partialLength = currentPoint.partialLength;
                        }
                    }
                }
                offf = letters[i].an / 2 - letters[i].add;
                matrixHelper.translate(-offf, 0, 0);
            } else {
                offf = letters[i].an/2 - letters[i].add;
                matrixHelper.translate(-offf,0,0);

                // Grouping alignment
                matrixHelper.translate(-renderedData.m.a.v[0]*letters[i].an/200, -renderedData.m.a.v[1]*yOff/100, 0);
            }

            lineLength += letters[i].l/2;
            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;
                if ('t' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                    if(this.maskPath) {
                        if(mult.length) {
                            currentLength += animatorProps.t*mult[0];
                        } else {
                            currentLength += animatorProps.t*mult;
                        }
                    }else{
                        if(mult.length) {
                            xPos += animatorProps.t.v*mult[0];
                        } else {
                            xPos += animatorProps.t.v*mult;
                        }
                    }
                }
            }
            lineLength += letters[i].l/2;
            if(documentData.strokeWidthAnim) {
                sw = documentData.sw || 0;
            }
            if(documentData.strokeColorAnim) {
                if(documentData.sc){
                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
                }else{
                    sc = [0,0,0];
                }
            }
            if(documentData.fillColorAnim) {
                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
            }
            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;
                if ('a' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);

                    if(mult.length){
                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
                    } else {
                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
                    }
                }
            }
            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;
                if ('s' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                    if(mult.length){
                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
                    } else {
                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
                    }
                }
            }
            for(j=0;j<jLen;j+=1) {
                animatorProps = renderedData.a[j].a;
                animatorSelector = renderedData.a[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                if ('sk' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                    } else {
                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                }
                if ('r' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                    } else {
                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                }
                if ('ry' in animatorProps) {

                    if(mult.length) {
                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
                    }else{
                        matrixHelper.rotateY(animatorProps.ry.v*mult);
                    }
                }
                if ('rx' in animatorProps) {
                    if(mult.length) {
                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
                    } else {
                        matrixHelper.rotateX(animatorProps.rx.v*mult);
                    }
                }
                if ('o' in animatorProps) {
                    if(mult.length) {
                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
                    } else {
                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
                    }
                }
                if (documentData.strokeWidthAnim && 'sw' in animatorProps) {
                    if(mult.length) {
                        sw += animatorProps.sw.v*mult[0];
                    } else {
                        sw += animatorProps.sw.v*mult;
                    }
                }
                if (documentData.strokeColorAnim && 'sc' in animatorProps) {
                    for(k=0;k<3;k+=1){
                        if(mult.length) {
                            sc[k] = Math.round(255*(sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0]));
                        } else {
                            sc[k] = Math.round(255*(sc[k] + (animatorProps.sc.v[k] - sc[k])*mult));
                        }
                    }
                }
                if (documentData.fillColorAnim) {
                    if('fc' in animatorProps){
                        for(k=0;k<3;k+=1){
                            if(mult.length) {
                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
                            } else {
                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
                                //console.log('mult',mult);
                                //console.log(Math.round(fc[k] + (animatorProps.fc.v[k] - fc[k])*mult));
                            }
                        }
                    }
                    if('fh' in animatorProps){
                        if(mult.length) {
                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
                        } else {
                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
                        }
                    }
                    if('fs' in animatorProps){
                        if(mult.length) {
                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
                        } else {
                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
                        }
                    }
                    if('fb' in animatorProps){
                        if(mult.length) {
                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
                        } else {
                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
                        }
                    }
                }
            }

            for(j=0;j<jLen;j+=1){
                animatorProps = renderedData.a[j].a;

                if ('p' in animatorProps) {
                    animatorSelector = renderedData.a[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j],data.t.a[j].s.totalChars);
                    if(this.maskPath) {
                        if(mult.length) {
                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                        } else {
                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        }
                    }else{
                        if(mult.length) {
                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        } else {
                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        }
                    }
                }
            }
            if(documentData.strokeWidthAnim){
                letterSw = sw < 0 ? 0 : sw;
            }
            if(documentData.strokeColorAnim){
                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
            }
            if(documentData.fillColorAnim){
                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
            }

            if(this.maskPath) {
                matrixHelper.translate(0,-documentData.ls);

                matrixHelper.translate(0, renderedData.m.a.v[1]*yOff/100 + yPos,0);
                if (data.t.p.p) {
                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
                    if (currentPoint.point[0] < prevPoint.point[0]) {
                        rot += 180;
                    }
                    matrixHelper.rotate(-rot * Math.PI / 180);
                }
                matrixHelper.translate(xPathPos, yPathPos, 0);
                currentLength -= renderedData.m.a.v[0]*letters[i].an/200;
                if(letters[i+1] && ind !== letters[i+1].ind){
                    currentLength += letters[i].an / 2;
                    currentLength += documentData.tr/1000*documentData.s;
                }
            }else{

                matrixHelper.translate(xPos,yPos,0);

                if(documentData.ps){
                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
                }
                switch(documentData.j){
                    case 1:
                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
                        break;
                    case 2:
                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
                        break;
                }
                matrixHelper.translate(0,-documentData.ls);
                matrixHelper.translate(offf,0,0);
                matrixHelper.translate(renderedData.m.a.v[0]*letters[i].an/200,renderedData.m.a.v[1]*yOff/100,0);
                xPos += letters[i].l + documentData.tr/1000*documentData.s;
            }
            if(renderType === 'html'){
                letterM = matrixHelper.toCSS();
            }else if(renderType === 'svg'){
                letterM = matrixHelper.to2dCSS();
            }else{
                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
            }
            letterO = elemOpacity;

            lastLetter = this.renderedLetters[i];
            if(lastLetter && (lastLetter.o !== letterO || lastLetter.sw !== letterSw || lastLetter.sc !== letterSc || lastLetter.fc !== letterFc)){
                this.lettersChangedFlag = true;
                letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
            }else{
                if((renderType === 'svg' || renderType === 'html') && (!lastLetter || lastLetter.m !== letterM)){
                    this.lettersChangedFlag = true;
                    letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM);
                }else if(renderType === 'canvas' && (!lastLetter || (lastLetter.props[0] !== letterP[0] || lastLetter.props[1] !== letterP[1] || lastLetter.props[4] !== letterP[4] || lastLetter.props[5] !== letterP[5] || lastLetter.props[12] !== letterP[12] || lastLetter.props[13] !== letterP[13]))){
                    this.lettersChangedFlag = true;
                    letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,null,letterP);
                } else {
                    letterValue = lastLetter;
                }
            }
            this.renderedLetters[i] = letterValue;
        }
    }
};

ITextElement.prototype.emptyProp = new LetterProps();

function SVGTextElement(data,parentContainer,globalData,comp, placeholder){
    this.textSpans = [];
    this.renderType = 'svg';
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, SVGTextElement);

SVGTextElement.prototype.init = ITextElement.prototype.init;
SVGTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape;
SVGTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
SVGTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;

SVGTextElement.prototype.createElements = function(){

    this._parent.createElements.call(this);


    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }
};

SVGTextElement.prototype.buildNewText = function(){
    var i, len;

    var documentData = this.currentTextDocumentData;
    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
    if(documentData.fc) {
        this.layerElement.setAttribute('fill', 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')');
    }else{
        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }
    if(documentData.sc){
        this.layerElement.setAttribute('stroke', 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')');
        this.layerElement.setAttribute('stroke-width', documentData.sw);
    }
    this.layerElement.setAttribute('font-size', documentData.s);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if(fontData.fClass){
        this.layerElement.setAttribute('class',fontData.fClass);
    } else {
        this.layerElement.setAttribute('font-family', fontData.fFamily);
        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
        this.layerElement.setAttribute('font-style', fStyle);
        this.layerElement.setAttribute('font-weight', fWeight);
    }



    var letters = documentData.l || [];
    len = letters.length;
    if(!len){
        return;
    }
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapes, shapeStr = '', singleShape = this.data.singleShape;
    if (singleShape) {
        var xPos = 0, yPos = 0, lineWidths = documentData.lineWidths, boxWidth = documentData.boxWidth, firstLine = true;
    }
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        if(this.globalData.fontManager.chars){
            if(!singleShape || i === 0){
                tSpan = this.textSpans[cnt] ? this.textSpans[cnt] : document.createElementNS(svgNS,'path');
            }
        }else{
            tSpan = this.textSpans[cnt] ? this.textSpans[cnt] : document.createElementNS(svgNS,'text');
        }
        tSpan.style.display = 'inherit';
        tSpan.setAttribute('stroke-linecap', 'butt');
        tSpan.setAttribute('stroke-linejoin','round');
        tSpan.setAttribute('stroke-miterlimit','4');
        //tSpan.setAttribute('visibility', 'hidden');
        if(singleShape && letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
        }
        matrixHelper.reset();
        if(this.globalData.fontManager.chars) {
            matrixHelper.scale(documentData.s / 100, documentData.s / 100);
        }
        if (singleShape) {
            if(documentData.ps){
                matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
            }
            matrixHelper.translate(0,-documentData.ls,0);
            switch(documentData.j){
                case 1:
                    matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line]),0,0);
                    break;
                case 2:
                    matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line])/2,0,0);
                    break;
            }
            matrixHelper.translate(xPos, yPos, 0);
        }
        if(this.globalData.fontManager.chars){
            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            var shapeData;
            if(charData){
                shapeData = charData.data;
            } else {
                shapeData = null;
            }
            if(shapeData && shapeData.shapes){
                shapes = shapeData.shapes[0].it;
                if(!singleShape){
                    shapeStr = '';
                }
                shapeStr += this.createPathShape(matrixHelper,shapes);
                if(!singleShape){

                    tSpan.setAttribute('d',shapeStr);
                }
            }
            if(!singleShape){
                this.layerElement.appendChild(tSpan);
            }
        }else{
            tSpan.textContent = letters[i].val;
            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
            this.layerElement.appendChild(tSpan);
            if(singleShape){
                tSpan.setAttribute('transform',matrixHelper.to2dCSS());
            }
        }
        if(singleShape) {
            xPos += letters[i].l;
            xPos += documentData.tr/1000*documentData.s;
        }
        //
        this.textSpans[cnt] = tSpan;
        cnt += 1;
    }
    if(!singleShape){
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    }
    if(singleShape && this.globalData.fontManager.chars){
        tSpan.setAttribute('d',shapeStr);
        this.layerElement.appendChild(tSpan);
    }
}

SVGTextElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        this.hidden = true;
    }
};

SVGTextElement.prototype.renderFrame = function(parentMatrix){

    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.layerElement.style.display = 'block';
    }

    if(this.data.singleShape){
        return;
    }
    this.getMeasures();
    if(!this.lettersChangedFlag){
        return;
    }
    var  i,len;
    var renderedLetters = this.renderedLetters;

    var letters = this.currentTextDocumentData.l;

    len = letters.length;
    var renderedLetter;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        this.textSpans[i].setAttribute('transform',renderedLetter.m);
        this.textSpans[i].setAttribute('opacity',renderedLetter.o);
        if(renderedLetter.sw){
            this.textSpans[i].setAttribute('stroke-width',renderedLetter.sw);
        }
        if(renderedLetter.sc){
            this.textSpans[i].setAttribute('stroke',renderedLetter.sc);
        }
        if(renderedLetter.fc){
            this.textSpans[i].setAttribute('fill',renderedLetter.fc);
        }
    }
    if(this.firstFrame) {
        this.firstFrame = false;
    }
}


SVGTextElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
};
function SVGTintFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f1');
    filter.appendChild(feColorMatrix);
    feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f2');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
        var feMerge = document.createElementNS(svgNS,'feMerge');
        filter.appendChild(feMerge);
        var feMergeNode;
        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
        feMergeNode.setAttribute('in','SourceGraphic');
        feMerge.appendChild(feMergeNode);
        feMergeNode = document.createElementNS(svgNS,'feMergeNode');
        feMergeNode.setAttribute('in','f2');
        feMerge.appendChild(feMergeNode);
    }
}

SVGTintFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var colorBlack = this.filterManager.effectElements[0].p.v;
        var colorWhite = this.filterManager.effectElements[1].p.v;
        var opacity = this.filterManager.effectElements[2].p.v/100;
        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
    }
};
function SVGFillFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
}
SVGFillFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var color = this.filterManager.effectElements[2].p.v;
        var opacity = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
    }
};
function SVGStrokeEffect(elem, filterManager){
    this.initialized = false;
    this.filterManager = filterManager;
    this.elem = elem;
    this.paths = [];
}

SVGStrokeEffect.prototype.initialize = function(){

    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
    var path,groupPath, i, len;
    if(this.filterManager.effectElements[1].p.v === 1){
        len = this.elem.maskManager.masksProperties.length;
        i = 0;
    } else {
        i = this.filterManager.effectElements[0].p.v - 1;
        len = i + 1;
    }
    groupPath = document.createElementNS(svgNS,'g'); 
    groupPath.setAttribute('fill','none');
    groupPath.setAttribute('stroke-linecap','round');
    groupPath.setAttribute('stroke-dashoffset',1);
    for(i;i<len;i+=1){
        path = document.createElementNS(svgNS,'path');
        groupPath.appendChild(path);
        this.paths.push({p:path,m:i});
    }
    if(this.filterManager.effectElements[10].p.v === 3){
        var mask = document.createElementNS(svgNS,'mask');
        var id = 'stms_' + randomString(10);
        mask.setAttribute('id',id);
        mask.setAttribute('mask-type','alpha');
        mask.appendChild(groupPath);
        this.elem.globalData.defs.appendChild(mask);
        var g = document.createElementNS(svgNS,'g');
        g.setAttribute('mask','url(#'+id+')');
        if(elemChildren[0]){
            g.appendChild(elemChildren[0]);
        }
        this.elem.layerElement.appendChild(g);
        this.masker = mask;
        groupPath.setAttribute('stroke','#fff');
    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
        if(this.filterManager.effectElements[10].p.v === 2){
            var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            while(elemChildren.length){
                this.elem.layerElement.removeChild(elemChildren[0]);
            }
        }
        this.elem.layerElement.appendChild(groupPath);
        this.elem.layerElement.removeAttribute('mask');
        groupPath.setAttribute('stroke','#fff');
    }
    this.initialized = true;
    this.pathMasker = groupPath;
}

SVGStrokeEffect.prototype.renderFrame = function(forceRender){
    if(!this.initialized){
        this.initialize();
    }
    var i, len = this.paths.length;
    var mask, path;
    for(i=0;i<len;i+=1){
        mask = this.elem.maskManager.viewData[this.paths[i].m];
        path = this.paths[i].p;
        if(forceRender || this.filterManager.mdf || mask.prop.mdf){
            path.setAttribute('d',mask.lastPath);
        }
        if(forceRender || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || mask.prop.mdf){
            var dasharrayValue;
            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
                var l = path.getTotalLength();
                dasharrayValue = '0 0 0 ' + l*s + ' ';
                var lineLength = l*(e-s);
                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
                var units = Math.floor(lineLength/segment);
                var j;
                for(j=0;j<units;j+=1){
                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
                }
                dasharrayValue += '0 ' + l*10 + ' 0 0';
            } else {
                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
            }
            path.setAttribute('stroke-dasharray',dasharrayValue);
        }
    }
    if(forceRender || this.filterManager.effectElements[4].p.mdf){
        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
    }
    
    if(forceRender || this.filterManager.effectElements[6].p.mdf){
        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
    }
    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
        if(forceRender || this.filterManager.effectElements[3].p.mdf){
            var color = this.filterManager.effectElements[3].p.v;
            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
        }
    }
};
function SVGTritoneFilter(filter, filterManager){
    this.filterManager = filterManager;
    var feColorMatrix = document.createElementNS(svgNS,'feColorMatrix');
    feColorMatrix.setAttribute('type','matrix');
    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result','f1');
    filter.appendChild(feColorMatrix);
    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
    filter.appendChild(feComponentTransfer);
    this.matrixFilter = feComponentTransfer;
    var feFuncR = document.createElementNS(svgNS,'feFuncR');
    feFuncR.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncR);
    this.feFuncR = feFuncR;
    var feFuncG = document.createElementNS(svgNS,'feFuncG');
    feFuncG.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncG);
    this.feFuncG = feFuncG;
    var feFuncB = document.createElementNS(svgNS,'feFuncB');
    feFuncB.setAttribute('type','table');
    feComponentTransfer.appendChild(feFuncB);
    this.feFuncB = feFuncB;
}

SVGTritoneFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var color1 = this.filterManager.effectElements[0].p.v;
        var color2 = this.filterManager.effectElements[1].p.v;
        var color3 = this.filterManager.effectElements[2].p.v;
        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0]
        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1]
        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2]
        this.feFuncR.setAttribute('tableValues', tableR);
        this.feFuncG.setAttribute('tableValues', tableG);
        this.feFuncB.setAttribute('tableValues', tableB);
        //var opacity = this.filterManager.effectElements[2].p.v/100;
        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
    }
};
function SVGProLevelsFilter(filter, filterManager){
    this.filterManager = filterManager;
    var effectElements = this.filterManager.effectElements;
    var feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    var feFuncR, feFuncG, feFuncB;
    
    if(effectElements[9].p.k || effectElements[9].p.v !== 0 || effectElements[10].p.k || effectElements[10].p.v !== 1 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 0 || effectElements[13].p.k || effectElements[13].p.v !== 1){
        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
    }
    if(effectElements[16].p.k || effectElements[16].p.v !== 0 || effectElements[17].p.k || effectElements[17].p.v !== 1 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 0 || effectElements[20].p.k || effectElements[20].p.v !== 1){
        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
    }
    if(effectElements[23].p.k || effectElements[23].p.v !== 0 || effectElements[24].p.k || effectElements[24].p.v !== 1 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 0 || effectElements[27].p.k || effectElements[27].p.v !== 1){
        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
    }
    if(effectElements[30].p.k || effectElements[30].p.v !== 0 || effectElements[31].p.k || effectElements[31].p.v !== 1 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 0 || effectElements[34].p.k || effectElements[34].p.v !== 1){
        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
    }
    
    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
        filter.appendChild(feComponentTransfer);
        feComponentTransfer = document.createElementNS(svgNS,'feComponentTransfer');
    }

    if(effectElements[2].p.k || effectElements[2].p.v !== 0 || effectElements[3].p.k || effectElements[3].p.v !== 1 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 0 || effectElements[6].p.k || effectElements[6].p.v !== 1){

        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
        filter.appendChild(feComponentTransfer);
        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
    }
}

SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
    var feFunc = document.createElementNS(svgNS,type);
    feFunc.setAttribute('type','table');
    feComponentTransfer.appendChild(feFunc);
    return feFunc;
};

SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
    var cnt = 0;
    var segments = 256;
    var perc;
    var min = Math.min(inputBlack, inputWhite);
    var max = Math.max(inputBlack, inputWhite);
    var table = Array.call(null,{length:segments});
    var colorValue;
    var pos = 0;
    var outputDelta = outputWhite - outputBlack; 
    var inputDelta = inputWhite - inputBlack; 
    while(cnt <= 256) {
        perc = cnt/256;
        if(perc <= min){
            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
        } else if(perc >= max){
            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
        } else {
            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
        }
        table[pos++] = colorValue;
        cnt += 256/(segments-1);
    }
    return table.join(' ');
};

SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        var val, cnt, perc, bezier;
        var effectElements = this.filterManager.effectElements;
        if(this.feFuncRComposed && (forceRender || effectElements[2].p.mdf || effectElements[3].p.mdf || effectElements[4].p.mdf || effectElements[5].p.mdf || effectElements[6].p.mdf)){
            val = this.getTableValue(effectElements[2].p.v,effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v);
            this.feFuncRComposed.setAttribute('tableValues',val);
            this.feFuncGComposed.setAttribute('tableValues',val);
            this.feFuncBComposed.setAttribute('tableValues',val);
        }

        if(this.feFuncR && (forceRender || effectElements[9].p.mdf || effectElements[10].p.mdf || effectElements[11].p.mdf || effectElements[12].p.mdf || effectElements[13].p.mdf)){
            val = this.getTableValue(effectElements[9].p.v,effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v);
            this.feFuncR.setAttribute('tableValues',val);
        }

        if(this.feFuncG && (forceRender || effectElements[16].p.mdf || effectElements[17].p.mdf || effectElements[18].p.mdf || effectElements[19].p.mdf || effectElements[20].p.mdf)){
            val = this.getTableValue(effectElements[16].p.v,effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v);
            this.feFuncG.setAttribute('tableValues',val);
        }

        if(this.feFuncB && (forceRender || effectElements[23].p.mdf || effectElements[24].p.mdf || effectElements[25].p.mdf || effectElements[26].p.mdf || effectElements[27].p.mdf)){
            val = this.getTableValue(effectElements[23].p.v,effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v);
            this.feFuncB.setAttribute('tableValues',val);
        }

        if(this.feFuncA && (forceRender || effectElements[30].p.mdf || effectElements[31].p.mdf || effectElements[32].p.mdf || effectElements[33].p.mdf || effectElements[34].p.mdf)){
            val = this.getTableValue(effectElements[30].p.v,effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v);
            this.feFuncA.setAttribute('tableValues',val);
        }
        
    }
};
function SVGDropShadowEffect(filter, filterManager){
    /*<feGaussianBlur in="SourceAlpha" stdDeviation="3"/> <!-- stdDeviation is how much to blur -->
  <feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
  <feMerge> 
    <feMergeNode/> <!-- this contains the offset blurred image -->
    <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
  </feMerge>*/
  /*<feFlood flood-color="#3D4574" flood-opacity="0.5" result="offsetColor"/>*/
    filter.setAttribute('x','-100%');
    filter.setAttribute('y','-100%');
    filter.setAttribute('width','400%');
    filter.setAttribute('height','400%');
    this.filterManager = filterManager;

    var feGaussianBlur = document.createElementNS(svgNS,'feGaussianBlur');
    feGaussianBlur.setAttribute('in','SourceAlpha');
    feGaussianBlur.setAttribute('result','drop_shadow_1');
    feGaussianBlur.setAttribute('stdDeviation','0');
    this.feGaussianBlur = feGaussianBlur;
    filter.appendChild(feGaussianBlur);

    var feOffset = document.createElementNS(svgNS,'feOffset');
    feOffset.setAttribute('dx','25');
    feOffset.setAttribute('dy','0');
    feOffset.setAttribute('in','drop_shadow_1');
    feOffset.setAttribute('result','drop_shadow_2');
    this.feOffset = feOffset;
    filter.appendChild(feOffset);
    var feFlood = document.createElementNS(svgNS,'feFlood');
    feFlood.setAttribute('flood-color','#00ff00');
    feFlood.setAttribute('flood-opacity','1');
    feFlood.setAttribute('result','drop_shadow_3');
    this.feFlood = feFlood;
    filter.appendChild(feFlood);

    var feComposite = document.createElementNS(svgNS,'feComposite');
    feComposite.setAttribute('in','drop_shadow_3');
    feComposite.setAttribute('in2','drop_shadow_2');
    feComposite.setAttribute('operator','in');
    feComposite.setAttribute('result','drop_shadow_4');
    filter.appendChild(feComposite);


    var feMerge = document.createElementNS(svgNS,'feMerge');
    filter.appendChild(feMerge);
    var feMergeNode;
    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
    feMerge.appendChild(feMergeNode);
    feMergeNode = document.createElementNS(svgNS,'feMergeNode');
    feMergeNode.setAttribute('in','SourceGraphic');
    this.feMergeNode = feMergeNode;
    this.feMerge = feMerge;
    this.originalNodeAdded = false;
    feMerge.appendChild(feMergeNode);
}

SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
    if(forceRender || this.filterManager.mdf){
        if(forceRender || this.filterManager.effectElements[4].p.mdf){
            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
        }
        if(forceRender || this.filterManager.effectElements[0].p.mdf){
            var col = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
        }
        if(forceRender || this.filterManager.effectElements[1].p.mdf){
            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
        }
        if(forceRender || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf){
            var distance = this.filterManager.effectElements[3].p.v
            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads
            var x = distance * Math.cos(angle)
            var y = distance * Math.sin(angle)
            this.feOffset.setAttribute('dx', x);
            this.feOffset.setAttribute('dy', y);
        }
        /*if(forceRender || this.filterManager.effectElements[5].p.mdf){
            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
                this.feMerge.removeChild(this.feMergeNode);
                this.originalNodeAdded = false;
            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
                this.feMerge.appendChild(this.feMergeNode);
                this.originalNodeAdded = true;
            }
        }*/
    }
};
function SVGEffects(elem){
    var i, len = elem.data.ef.length;
    var filId = randomString(10);
    var fil = filtersFactory.createFilter(filId);
    var count = 0;
    this.filters = [];
    var filterManager;
    for(i=0;i<len;i+=1){
        if(elem.data.ef[i].ty === 20){
            count += 1;
            filterManager = new SVGTintFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 21){
            count += 1;
            filterManager = new SVGFillFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 22){
            filterManager = new SVGStrokeEffect(elem, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 23){
            count += 1;
            filterManager = new SVGTritoneFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 24){
            count += 1;
            filterManager = new SVGProLevelsFilter(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }else if(elem.data.ef[i].ty === 25){
            count += 1;
            filterManager = new SVGDropShadowEffect(fil, elem.effects.effectElements[i]);
            this.filters.push(filterManager);
        }
    }
    if(count){
        elem.globalData.defs.appendChild(fil);
        elem.layerElement.setAttribute('filter','url(#'+filId+')');
    }
}

SVGEffects.prototype.renderFrame = function(firstFrame){
    var i, len = this.filters.length;
    for(i=0;i<len;i+=1){
        this.filters[i].renderFrame(firstFrame);
    }
};
function ICompElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? Array.apply(null,{length:this.layers.length}) : [];
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.xt){
        this.layerElement = document.createElementNS(svgNS,'g');
        this.buildAllItems();
    } else if(!globalData.progressiveLoad){
        this.buildAllItems();
    }
}
createElement(SVGBaseElement, ICompElement);

ICompElement.prototype.hide = function(){
    if(!this.hidden){
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
        this.hidden = true;
    }
};

ICompElement.prototype.prepareFrame = function(num){
    this._parent.prepareFrame.call(this,num);
    if(this.isVisible===false && !this.data.xt){
        return;
    }

    if(this.tm){
        var timeRemapped = this.tm.v;
        if(timeRemapped === this.data.op){
            timeRemapped = this.data.op - 1;
        }
        this.renderedFrame = timeRemapped;
    } else {
        this.renderedFrame = num/this.data.sr;
    }
    var i,len = this.elements.length;
    if(!this.completeLayers){
        this.checkLayers(this.renderedFrame);
    }
    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
        }
    }
};

ICompElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    var i,len = this.layers.length;
    if(renderParent===false){
        this.hide();
        return;
    }

    this.hidden = false;
    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

ICompElement.prototype.setElements = function(elems){
    this.elements = elems;
};

ICompElement.prototype.getElements = function(){
    return this.elements;
};

ICompElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    var i,len = this.layers.length;
    for( i = 0; i < len; i+=1 ){
        if(this.elements[i]){
            this.elements[i].destroy();
        }
    }
};

ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers;
ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem;
ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems;
ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting;
ICompElement.prototype.createItem = SVGRenderer.prototype.createItem;
ICompElement.prototype.createImage = SVGRenderer.prototype.createImage;
ICompElement.prototype.createComp = SVGRenderer.prototype.createComp;
ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid;
ICompElement.prototype.createShape = SVGRenderer.prototype.createShape;
ICompElement.prototype.createText = SVGRenderer.prototype.createText;
ICompElement.prototype.createBase = SVGRenderer.prototype.createBase;
ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos;
ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements;
ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement;
function IImageElement(data,parentContainer,globalData,comp,placeholder){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data,parentContainer,globalData,comp,placeholder);
}
createElement(SVGBaseElement, IImageElement);

IImageElement.prototype.createElements = function(){

    var assetPath = this.globalData.getAssetsPath(this.assetData);

    this._parent.createElements.call(this);

    this.innerElem = document.createElementNS(svgNS,'image');
    this.innerElem.setAttribute('width',this.assetData.w+"px");
    this.innerElem.setAttribute('height',this.assetData.h+"px");
    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
    this.maskedElement = this.innerElem;
    this.layerElement.appendChild(this.innerElem);
    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }

};

IImageElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        this.hidden = true;
    }
};

IImageElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.layerElement.style.display = 'block';
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

IImageElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    this.innerElem =  null;
};
function IShapeElement(data,parentContainer,globalData,comp, placeholder){
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.viewData = [];
    this.shapeModifiers = [];
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, IShapeElement);

IShapeElement.prototype.lcEnum = {
    '1': 'butt',
    '2': 'round',
    '3': 'butt'
}

IShapeElement.prototype.ljEnum = {
    '1': 'miter',
    '2': 'round',
    '3': 'butt'
}

IShapeElement.prototype.buildExpressionInterface = function(){};

IShapeElement.prototype.createElements = function(){
    //TODO check if I can use symbol so i can set its viewBox
    this._parent.createElements.call(this);
    this.searchShapes(this.shapesData,this.viewData,this.layerElement,this.dynamicProperties, 0);
    if(!this.data.hd || this.data.td){
        styleUnselectableDiv(this.layerElement);
    }
    //this.elemInterface.registerShapeExpressionInterface(ShapeExpressionInterface.createShapeInterface(this.shapesData,this.viewData,this.elemInterface));
};

IShapeElement.prototype.setGradientData = function(pathElement,arr,data){

    var gradientId = 'gr_'+randomString(10);
    var gfill;
    if(arr.t === 1){
        gfill = document.createElementNS(svgNS,'linearGradient');
    } else {
        gfill = document.createElementNS(svgNS,'radialGradient');
    }
    gfill.setAttribute('id',gradientId);
    gfill.setAttribute('spreadMethod','pad');
    gfill.setAttribute('gradientUnits','userSpaceOnUse');
    var stops = [];
    var stop, j, jLen;
    jLen = arr.g.p*4;
    for(j=0;j<jLen;j+=4){
        stop = document.createElementNS(svgNS,'stop');
        gfill.appendChild(stop);
        stops.push(stop);
    }
    pathElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
    this.globalData.defs.appendChild(gfill);
    data.gf = gfill;
    data.cst = stops;
}

IShapeElement.prototype.setGradientOpacity = function(arr, data, styleOb){
    if((arr.g.k.k[0].s && arr.g.k.k[0].s.length > arr.g.p*4) || arr.g.k.k.length > arr.g.p*4){
        var opFill;
        var stop, j, jLen;
        var mask = document.createElementNS(svgNS,"mask");
        var maskElement = document.createElementNS(svgNS, 'path');
        mask.appendChild(maskElement);
        var opacityId = 'op_'+randomString(10);
        var maskId = 'mk_'+randomString(10);
        mask.setAttribute('id',maskId);
        if(arr.t === 1){
            opFill = document.createElementNS(svgNS,'linearGradient');
        } else {
            opFill = document.createElementNS(svgNS,'radialGradient');
        }
        opFill.setAttribute('id',opacityId);
        opFill.setAttribute('spreadMethod','pad');
        opFill.setAttribute('gradientUnits','userSpaceOnUse');
        jLen = arr.g.k.k[0].s ? arr.g.k.k[0].s.length : arr.g.k.k.length;
        var stops = [];
        for(j=arr.g.p*4;j<jLen;j+=2){
            stop = document.createElementNS(svgNS,'stop');
            stop.setAttribute('stop-color','rgb(255,255,255)');
            //stop.setAttribute('offset',Math.round(arr.y[j][0]*100)+'%');
            //stop.setAttribute('style','stop-color:rgb(255,255,255);stop-opacity:'+arr.y[j][1]);
            opFill.appendChild(stop);
            stops.push(stop);
        }
        maskElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
        this.globalData.defs.appendChild(opFill);
        this.globalData.defs.appendChild(mask);
        data.of = opFill;
        data.ost = stops;
        styleOb.msElem = maskElement;
        return maskId;
    }
};

IShapeElement.prototype.searchShapes = function(arr,data,container,dynamicProperties, level, transformers){
    transformers = transformers || [];
    var ownTransformers = [].concat(transformers);
    var i, len = arr.length - 1;
    var j, jLen;
    var ownArrays = [], ownModifiers = [], styleOb, currentTransform;
    for(i=len;i>=0;i-=1){
        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
            data[i] = {};
            styleOb = {
                type: arr[i].ty,
                d: '',
                ld: '',
                lvl: level,
                mdf: false
            };
            var pathElement = document.createElementNS(svgNS, "path");
            data[i].o = PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties);
            if(arr[i].ty == 'st' || arr[i].ty == 'gs') {
                pathElement.setAttribute('stroke-linecap', this.lcEnum[arr[i].lc] || 'round');
                ////pathElement.style.strokeLinecap = this.lcEnum[arr[i].lc] || 'round';
                pathElement.setAttribute('stroke-linejoin',this.ljEnum[arr[i].lj] || 'round');
                ////pathElement.style.strokeLinejoin = this.ljEnum[arr[i].lj] || 'round';
                pathElement.setAttribute('fill-opacity','0');
                ////pathElement.style.fillOpacity = 0;
                if(arr[i].lj == 1) {
                    pathElement.setAttribute('stroke-miterlimit',arr[i].ml);
                    ////pathElement.style.strokeMiterlimit = arr[i].ml;
                }

                data[i].w = PropertyFactory.getProp(this,arr[i].w,0,null,dynamicProperties);
                if(arr[i].d){
                    var d = PropertyFactory.getDashProp(this,arr[i].d,'svg',dynamicProperties);
                    if(!d.k){
                        pathElement.setAttribute('stroke-dasharray', d.dasharray);
                        ////pathElement.style.strokeDasharray = d.dasharray;
                        pathElement.setAttribute('stroke-dashoffset', d.dashoffset);
                        ////pathElement.style.strokeDashoffset = d.dashoffset;
                    }
                    data[i].d = d;
                }

            }
            if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
                data[i].c = PropertyFactory.getProp(this,arr[i].c,1,255,dynamicProperties);
                container.appendChild(pathElement);
            } else {
                data[i].g = PropertyFactory.getGradientProp(this,arr[i].g,dynamicProperties);
                if(arr[i].t == 2){
                    data[i].h = PropertyFactory.getProp(this,arr[i].h,1,0.01,dynamicProperties);
                    data[i].a = PropertyFactory.getProp(this,arr[i].a,1,degToRads,dynamicProperties);
                }
                data[i].s = PropertyFactory.getProp(this,arr[i].s,1,null,dynamicProperties);
                data[i].e = PropertyFactory.getProp(this,arr[i].e,1,null,dynamicProperties);
                this.setGradientData(pathElement,arr[i],data[i], styleOb);
                var maskId = this.setGradientOpacity(arr[i],data[i], styleOb);
                if(maskId){
                    pathElement.setAttribute('mask','url(#'+maskId+')');
                }
                data[i].elem = pathElement;
                container.appendChild(pathElement);
            }
            if(arr[i].r === 2) {
                pathElement.setAttribute('fill-rule', 'evenodd');
            }

            if(arr[i].ln){
                pathElement.setAttribute('id',arr[i].ln);
            }
            if(arr[i].cl){
                pathElement.setAttribute('class',arr[i].cl);
            }
            styleOb.pElem = pathElement;
            this.stylesList.push(styleOb);
            data[i].style = styleOb;
            ownArrays.push(styleOb);
        }else if(arr[i].ty == 'gr'){
            data[i] = {
                it: []
            };
            var g = document.createElementNS(svgNS,'g');
            container.appendChild(g);
            data[i].gr = g;
            this.searchShapes(arr[i].it,data[i].it,g,dynamicProperties, level + 1, ownTransformers);
        }else if(arr[i].ty == 'tr'){
            data[i] = {
                transform : {
                    op: PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties),
                    mProps: PropertyFactory.getProp(this,arr[i],2,null,dynamicProperties)
                },
                elements: []
            };
            currentTransform = data[i].transform;
            ownTransformers.push(currentTransform);
        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
            data[i] = {
                elements : [],
                caches:[],
                styles : [],
                transformers: ownTransformers,
                lStr: ''
            };
            var ty = 4;
            if(arr[i].ty == 'rc'){
                ty = 5;
            }else if(arr[i].ty == 'el'){
                ty = 6;
            }else if(arr[i].ty == 'sr'){
                ty = 7;
            }
            data[i].sh = ShapePropertyFactory.getShapeProp(this,arr[i],ty,dynamicProperties);
            data[i].lvl = level;
            this.shapes.push(data[i].sh);
            this.addShapeToModifiers(data[i]);
            jLen = this.stylesList.length;
            for(j=0;j<jLen;j+=1){
                if(!this.stylesList[j].closed){
                    data[i].elements.push({
                        ty:this.stylesList[j].type,
                        st: this.stylesList[j]
                    });
                }
            }
        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms' || arr[i].ty == 'rp'){
            var modifier = ShapeModifiers.getModifier(arr[i].ty);
            modifier.init(this,arr[i],dynamicProperties);
            this.shapeModifiers.push(modifier);
            ownModifiers.push(modifier);
            data[i] = modifier;
        }
    }
    len = ownArrays.length;
    for(i=0;i<len;i+=1){
        ownArrays[i].closed = true;
    }
    len = ownModifiers.length;
    for(i=0;i<len;i+=1){
        ownModifiers[i].closed = true;
    }
};

IShapeElement.prototype.addShapeToModifiers = function(data) {
    var i, len = this.shapeModifiers.length;
    for(i=0;i<len;i+=1){
        this.shapeModifiers[i].addShape(data);
    }
};

IShapeElement.prototype.renderModifiers = function() {
    if(!this.shapeModifiers.length){
        return;
    }
    var i, len = this.shapes.length;
    for(i=0;i<len;i+=1){
        this.shapes[i].reset();
    }


    len = this.shapeModifiers.length;

    for(i=len-1;i>=0;i-=1){
        this.shapeModifiers[i].processShapes(this.firstFrame);
    }
};

IShapeElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    this.globalToLocal([0,0,0]);
    if(this.hidden){
        this.layerElement.style.display = 'block';
        this.hidden = false;
    }
    this.renderModifiers();
    this.renderShape(null,null,true, null);
};

IShapeElement.prototype.hide = function(){
    if(!this.hidden){
        this.layerElement.style.display = 'none';
        var i, len = this.stylesList.length;
        for(i=len-1;i>=0;i-=1){
            if(this.stylesList[i].ld !== '0'){
                this.stylesList[i].ld = '0';
                this.stylesList[i].pElem.style.display = 'none';
                if(this.stylesList[i].pElem.parentNode){
                    this.stylesList[i].parent = this.stylesList[i].pElem.parentNode;
                    //this.stylesList[i].pElem.parentNode.removeChild(this.stylesList[i].pElem);
                }
            }
        }
        this.hidden = true;
    }
};

IShapeElement.prototype.renderShape = function(items,data,isMain, container){
    var i, len;
    if(!items){
        items = this.shapesData;
        len = this.stylesList.length;
        for(i=0;i<len;i+=1){
            this.stylesList[i].d = '';
            this.stylesList[i].mdf = false;
        }
    }
    if(!data){
        data = this.viewData;
    }
    ///
    ///
    len = items.length - 1;
    var ty;
    for(i=len;i>=0;i-=1){
        ty = items[i].ty;
        if(ty == 'tr'){
            if(this.firstFrame || data[i].transform.op.mdf && container){
                container.setAttribute('opacity',data[i].transform.op.v);
            }
            if(this.firstFrame || data[i].transform.mProps.mdf && container){
                container.setAttribute('transform',data[i].transform.mProps.v.to2dCSS());
            }
        }else if(ty == 'sh' || ty == 'el' || ty == 'rc' || ty == 'sr'){
            this.renderPath(items[i],data[i]);
        }else if(ty == 'fl'){
            this.renderFill(items[i],data[i]);
        }else if(ty == 'gf'){
            this.renderGradient(items[i],data[i]);
        }else if(ty == 'gs'){
            this.renderGradient(items[i],data[i]);
            this.renderStroke(items[i],data[i]);
        }else if(ty == 'st'){
            this.renderStroke(items[i],data[i]);
        }else if(ty == 'gr'){
            this.renderShape(items[i].it,data[i].it,false, data[i].gr);
        }else if(ty == 'tm'){
            //
        }
    }
    if(isMain) {
        len = this.stylesList.length;
        for (i = 0; i < len; i += 1) {
            if (this.stylesList[i].ld === '0') {
                this.stylesList[i].ld = '1';
                this.stylesList[i].pElem.style.display = 'block';
                //this.stylesList[i].parent.appendChild(this.stylesList[i].pElem);
            }
            if (this.stylesList[i].mdf || this.firstFrame) {
                this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d);
                if(this.stylesList[i].msElem){
                    this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
                }
            }
        }
        if (this.firstFrame) {
            this.firstFrame = false;
        }
    }

};

IShapeElement.prototype.renderPath = function(pathData,viewData){
    var len, i, j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = viewData.elements.length;
    var lvl = viewData.lvl;
    for(l=0;l<lLen;l+=1){
        redraw = viewData.sh.mdf || this.firstFrame;
        pathStringTransformed = 'M0 0';
        var paths = viewData.sh.paths;
        jLen = paths._length;
        if(viewData.elements[l].st.lvl < lvl){
            var mat = this.mHelper.reset(), props;
            var iterations = lvl - viewData.elements[l].st.lvl;
            var k = viewData.transformers.length-1;
            while(iterations > 0) {
                redraw = viewData.transformers[k].mProps.mdf || redraw;
                props = viewData.transformers[k].mProps.v.props;
                mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
                iterations --;
                k --;
            }
            if(redraw){
                for(j=0;j<jLen;j+=1){
                    pathNodes = paths.shapes[j];
                    if(pathNodes && pathNodes._length){
                        len = pathNodes._length;
                        for (i = 1; i < len; i += 1) {
                            if (i == 1) {
                                pathStringTransformed += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            }
                            pathStringTransformed += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
                        }
                        if (len == 1) {
                            pathStringTransformed += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                        }
                        if (pathNodes.c) {
                            pathStringTransformed += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            pathStringTransformed += 'z';
                        }
                    }
                }
                viewData.caches[l] = pathStringTransformed;
            } else {
                pathStringTransformed = viewData.caches[l];
            }
        } else {
            if(redraw){
                for(j=0;j<jLen;j+=1){
                    pathNodes = paths.shapes[j];
                    if(pathNodes && pathNodes._length){
                        len = pathNodes._length;
                        for (i = 1; i < len; i += 1) {
                            if (i == 1) {
                                //pathStringTransformed += " M" + groupTransform.mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                                pathStringTransformed += " M" + pathNodes.v[0].join(',');
                            }
                            //pathStringTransformed += " C" + groupTransform.mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
                            pathStringTransformed += " C" + pathNodes.o[i - 1].join(',') + " " + pathNodes.i[i].join(',') + " " + pathNodes.v[i].join(',');
                        }
                        if (len == 1) {
                            //pathStringTransformed += " M" + groupTransform.mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            pathStringTransformed += " M" + pathNodes.v[0].join(',');
                        }
                        if (pathNodes.c && len) {
                            //pathStringTransformed += " C" + groupTransform.mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + groupTransform.mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
                            pathStringTransformed += " C" + pathNodes.o[i - 1].join(',') + " " + pathNodes.i[0].join(',') + " " + pathNodes.v[0].join(',');
                            pathStringTransformed += 'z';
                        }
                    }
                }
                viewData.caches[l] = pathStringTransformed;
            } else {
                pathStringTransformed = viewData.caches[l];
            }
        }
        viewData.elements[l].st.d += pathStringTransformed;
        viewData.elements[l].st.mdf = redraw || viewData.elements[l].st.mdf;
    }

};

IShapeElement.prototype.renderFill = function(styleData,viewData){
    var styleElem = viewData.style;

    if(viewData.c.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')');
        ////styleElem.pElem.style.fill = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('fill-opacity',viewData.o.v);
    }
};

IShapeElement.prototype.renderGradient = function(styleData,viewData){
    var gfill = viewData.gf;
    var opFill = viewData.of;
    var pt1 = viewData.s.v,pt2 = viewData.e.v;

    if(viewData.o.mdf || this.firstFrame){
        var attr = styleData.ty === 'gf' ? 'fill-opacity':'stroke-opacity';
        viewData.elem.setAttribute(attr,viewData.o.v);
    }
    //clippedElement.setAttribute('transform','matrix(1,0,0,1,-100,0)');
    if(viewData.s.mdf || this.firstFrame){
        var attr1 = styleData.t === 1 ? 'x1':'cx';
        var attr2 = attr1 === 'x1' ? 'y1':'cy';
        gfill.setAttribute(attr1,pt1[0]);
        gfill.setAttribute(attr2,pt1[1]);
        if(opFill){
            opFill.setAttribute(attr1,pt1[0]);
            opFill.setAttribute(attr2,pt1[1]);
        }
    }
    var stops, i, len, stop;
    if(viewData.g.cmdf || this.firstFrame){
        stops = viewData.cst;
        var cValues = viewData.g.c;
        len = stops.length;
        for(i=0;i<len;i+=1){
            stop = stops[i];
            stop.setAttribute('offset',cValues[i*4]+'%');
            stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');
        }
    }
    if(opFill && (viewData.g.omdf || this.firstFrame)){
        stops = viewData.ost;
        var oValues = viewData.g.o;
        len = stops.length;
        for(i=0;i<len;i+=1){
            stop = stops[i];
            stop.setAttribute('offset',oValues[i*2]+'%');
            stop.setAttribute('stop-opacity',oValues[i*2+1]);
        }
    }
    if(styleData.t === 1){
        if(viewData.e.mdf  || this.firstFrame){
            gfill.setAttribute('x2',pt2[0]);
            gfill.setAttribute('y2',pt2[1]);
            if(opFill){
                opFill.setAttribute('x2',pt2[0]);
                opFill.setAttribute('y2',pt2[1]);
            }
        }
    } else {
        var rad;
        if(viewData.s.mdf || viewData.e.mdf || this.firstFrame){
            rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
            gfill.setAttribute('r',rad);
            if(opFill){
                opFill.setAttribute('r',rad);
            }
        }
        if(viewData.e.mdf || viewData.h.mdf || viewData.a.mdf || this.firstFrame){
            if(!rad){
                rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
            }
            var ang = Math.atan2(pt2[1]-pt1[1], pt2[0]-pt1[0]);

            var percent = viewData.h.v >= 1 ? 0.99 : viewData.h.v <= -1 ? -0.99:viewData.h.v;
            var dist = rad*percent;
            var x = Math.cos(ang + viewData.a.v)*dist + pt1[0];
            var y = Math.sin(ang + viewData.a.v)*dist + pt1[1];
            gfill.setAttribute('fx',x);
            gfill.setAttribute('fy',y);
            if(opFill){
                opFill.setAttribute('fx',x);
                opFill.setAttribute('fy',y);
            }
        }
        //gfill.setAttribute('fy','200');
    }
};

IShapeElement.prototype.renderStroke = function(styleData,viewData){
    var styleElem = viewData.style;
    //TODO fix dashes
    var d = viewData.d;
    var dasharray,dashoffset;
    if(d && d.k && (d.mdf || this.firstFrame)){
        styleElem.pElem.setAttribute('stroke-dasharray', d.dasharray);
        ////styleElem.pElem.style.strokeDasharray = d.dasharray;
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset);
        ////styleElem.pElem.style.strokeDashoffset = d.dashoffset;
    }
    if(viewData.c && (viewData.c.mdf || this.firstFrame)){
        styleElem.pElem.setAttribute('stroke','rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')');
        ////styleElem.pElem.style.stroke = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('stroke-opacity',viewData.o.v);
    }
    if(viewData.w.mdf || this.firstFrame){
        styleElem.pElem.setAttribute('stroke-width',viewData.w.v);
        if(styleElem.msElem){
            styleElem.msElem.setAttribute('stroke-width',viewData.w.v);
        }
        ////styleElem.pElem.style.strokeWidth = viewData.w.v;
    }
};

IShapeElement.prototype.destroy = function(){
    this._parent.destroy.call(this._parent);
    this.shapeData = null;
    this.viewData = null;
    this.parentContainer = null;
    this.placeholder = null;
};

function ISolidElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(SVGBaseElement, ISolidElement);

ISolidElement.prototype.createElements = function(){
    this._parent.createElements.call(this);

    var rect = document.createElementNS(svgNS,'rect');
    ////rect.style.width = this.data.sw;
    ////rect.style.height = this.data.sh;
    ////rect.style.fill = this.data.sc;
    rect.setAttribute('width',this.data.sw);
    rect.setAttribute('height',this.data.sh);
    rect.setAttribute('fill',this.data.sc);
    this.layerElement.appendChild(rect);
    this.innerElem = rect;
    if(this.data.ln){
        this.layerElement.setAttribute('id',this.data.ln);
    }
    if(this.data.cl){
        this.layerElement.setAttribute('class',this.data.cl);
    }
};

ISolidElement.prototype.hide = IImageElement.prototype.hide;
ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
ISolidElement.prototype.destroy = IImageElement.prototype.destroy;

var animationManager = (function(){
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var idled = true;
    var playingAnimationsNum = 0;

    function removeElement(ev){
        var i = 0;
        var animItem = ev.target;
        while(i<len) {
            if (registeredAnimations[i].animation === animItem) {
                registeredAnimations.splice(i, 1);
                i -= 1;
                len -= 1;
                if(!animItem.isPaused){
                    subtractPlayingCount();   
                }
            }
            i += 1;
        }
    }

    function registerAnimation(element, animationData){
        if(!element){
            return null;
        }
        var i=0;
        while(i<len){
            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
                return registeredAnimations[i].animation;
            }
            i+=1;
        }
        var animItem = new AnimationItem();
        setupAnimation(animItem, element);
        animItem.setData(element, animationData);
        return animItem;
    }

    function addPlayingCount(){
        playingAnimationsNum += 1;
        activate();
    }

    function subtractPlayingCount(){
        playingAnimationsNum -= 1;
        if(playingAnimationsNum === 0){
            idled = true;
        }
    }

    function setupAnimation(animItem, element){
        animItem.addEventListener('destroy',removeElement);
        animItem.addEventListener('_active',addPlayingCount);
        animItem.addEventListener('_idle',subtractPlayingCount);
        registeredAnimations.push({elem: element,animation:animItem});
        len += 1;
    }

    function loadAnimation(params){
        var animItem = new AnimationItem();
        setupAnimation(animItem, null);
        animItem.setParams(params);
        return animItem;
    }


    function setSpeed(val,animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.setSpeed(val, animation);
        }
    }

    function setDirection(val, animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.setDirection(val, animation);
        }
    }

    function play(animation){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.play(animation);
        }
    }

    function moveFrame (value, animation) {
        initTime = Date.now();
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.moveFrame(value,animation);
        }
    }

    function resume(nowTime) {

        var elapsedTime = nowTime - initTime;
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.advanceTime(elapsedTime);
        }
        initTime = nowTime;
        if(!idled) {
            requestAnimationFrame(resume);
        }
    }

    function first(nowTime){
        initTime = nowTime;
        requestAnimationFrame(resume);
    }

    function pause(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.pause(animation);
        }
    }

    function goToAndStop(value,isFrame,animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
        }
    }

    function stop(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.stop(animation);
        }
    }

    function togglePause(animation) {
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.togglePause(animation);
        }
    }

    function destroy(animation) {
        var i;
        for(i=(len-1);i>=0;i-=1){
            registeredAnimations[i].animation.destroy(animation);
        }
    }

    function searchAnimations(animationData, standalone, renderer){
        var animElements = document.getElementsByClassName('bodymovin');
        var i, len = animElements.length;
        for(i=0;i<len;i+=1){
            if(renderer){
                animElements[i].setAttribute('data-bm-type',renderer);
            }
            registerAnimation(animElements[i], animationData);
        }
        if(standalone && len === 0){
            if(!renderer){
                renderer = 'svg';
            }
            var body = document.getElementsByTagName('body')[0];
            body.innerHTML = '';
            var div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.setAttribute('data-bm-type',renderer);
            body.appendChild(div);
            registerAnimation(div, animationData);
        }
    }

    function resize(){
        var i;
        for(i=0;i<len;i+=1){
            registeredAnimations[i].animation.resize();
        }
    }

    function start(){
        requestAnimationFrame(first);
    }

    function activate(){
        if(idled){
            idled = false;
            requestAnimationFrame(first);
        }
    }

    //start();

    setTimeout(start,0);

    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.moveFrame = moveFrame;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize;
    moduleOb.start = start;
    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    return moduleOb;
}());
var AnimationItem = function () {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.pendingElements = 0;
    this.playCount = 0;
    this.prerenderFramesFlag = true;
    this.animationData = {};
    this.layers = [];
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = randomString(10);
    this.scaleMode = 'fit';
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.subframeEnabled = subframeEnabled;
    this.segments = [];
    this.pendingSegment = false;
    this._idle = true;
    this.projectInterface = ProjectInterface();
};

AnimationItem.prototype.setParams = function(params) {
    var self = this;
    if(params.context){
        this.context = params.context;
    }
    if(params.wrapper || params.container){
        this.wrapper = params.wrapper || params.container;
    }
    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
    switch(animType){
        case 'canvas':
            this.renderer = new CanvasRenderer(this, params.rendererSettings);
            break;
        case 'svg':
            this.renderer = new SVGRenderer(this, params.rendererSettings);
            break;
        case 'hybrid':
        case 'html':
        default:
            this.renderer = new HybridRenderer(this, params.rendererSettings);
            break;
    }
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;

    if(params.loop === '' || params.loop === null){
    }else if(params.loop === false){
        this.loop = false;
    }else if(params.loop === true){
        this.loop = true;
    }else{
        this.loop = parseInt(params.loop);
    }
    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name :  '';
    this.prerenderFramesFlag = 'prerender' in params ? params.prerender : true;
    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
    if(params.animationData){
        self.configAnimation(params.animationData);
    }else if(params.path){
        if(params.path.substr(-4) != 'json'){
            if (params.path.substr(-1, 1) != '/') {
                params.path += '/';
            }
            params.path += 'data.json';
        }

        var xhr = new XMLHttpRequest();
        if(params.path.lastIndexOf('\\') != -1){
            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
        }else{
            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
        }
        this.assetsPath = params.assetsPath;
        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
        xhr.open('GET', params.path, true);
        xhr.send();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                if(xhr.status == 200){
                    self.configAnimation(JSON.parse(xhr.responseText));
                }else{
                    try{
                        var response = JSON.parse(xhr.responseText);
                        self.configAnimation(response);
                    }catch(err){
                    }
                }
            }
        };
    }
};

AnimationItem.prototype.setData = function (wrapper, animationData) {
    var params = {
        wrapper: wrapper,
        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
    };
    var wrapperAttributes = wrapper.attributes;

    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';

    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
    if(loop === ''){
    }else if(loop === 'false'){
        params.loop = false;
    }else if(loop === 'true'){
        params.loop = true;
    }else{
        params.loop = parseInt(loop);
    }
    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== "false";

    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

    if(prerender === 'false'){
        params.prerender = false;
    }
    this.setParams(params);
};

AnimationItem.prototype.includeLayers = function(data) {
    if(data.op > this.animationData.op){
        this.animationData.op = data.op;
        this.totalFrames = Math.floor(data.op - this.animationData.ip);
        this.animationData.tf = this.totalFrames;
    }
    var layers = this.animationData.layers;
    var i, len = layers.length;
    var newLayers = data.layers;
    var j, jLen = newLayers.length;
    for(j=0;j<jLen;j+=1){
        i = 0;
        while(i<len){
            if(layers[i].id == newLayers[j].id){
                layers[i] = newLayers[j];
                break;
            }
            i += 1;
        }
    }
    if(data.chars || data.fonts){
        this.renderer.globalData.fontManager.addChars(data.chars);
        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }
    if(data.assets){
        len = data.assets.length;
        for(i = 0; i < len; i += 1){
            this.animationData.assets.push(data.assets[i]);
        }
    }
    //this.totalFrames = 50;
    //this.animationData.tf = 50;
    this.animationData.__complete = false;
    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
    this.renderer.includeLayers(data.layers);
    if(expressionsPlugin){
        expressionsPlugin.initExpressions(this);
    }
    this.renderer.renderFrame(null);
    this.loadNextSegment();
};

AnimationItem.prototype.loadNextSegment = function() {
    var segments = this.animationData.segments;
    if(!segments || segments.length === 0 || !this.autoloadSegments){
        this.trigger('data_ready');
        this.timeCompleted = this.animationData.tf;
        return;
    }
    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var xhr = new XMLHttpRequest();
    var self = this;
    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    xhr.open('GET', segmentPath, true);
    xhr.send();
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if(xhr.status == 200){
                self.includeLayers(JSON.parse(xhr.responseText));
            }else{
                try{
                    var response = JSON.parse(xhr.responseText);
                    self.includeLayers(response);
                }catch(err){
                }
            }
        }
    };
};

AnimationItem.prototype.loadSegments = function() {
    var segments = this.animationData.segments;
    if(!segments) {
        this.timeCompleted = this.animationData.tf;
    }
    this.loadNextSegment();
};

AnimationItem.prototype.configAnimation = function (animData) {
    if(this.renderer && this.renderer.destroyed){
        return;
    }
    //console.log(JSON.parse(JSON.stringify(animData)));
    //animData.w = Math.round(animData.w/blitter);
    //animData.h = Math.round(animData.h/blitter);
    this.animationData = animData;
    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
    this.animationData.tf = this.totalFrames;
    this.renderer.configAnimation(animData);
    if(!animData.assets){
        animData.assets = [];
    }
    if(animData.comps) {
        animData.assets = animData.assets.concat(animData.comps);
        animData.comps = null;
    }
    this.renderer.searchExtraCompositions(animData.assets);

    this.layers = this.animationData.layers;
    this.assets = this.animationData.assets;
    this.frameRate = this.animationData.fr;
    this.firstFrame = Math.round(this.animationData.ip);
    this.frameMult = this.animationData.fr / 1000;
    this.trigger('config_ready');
    this.imagePreloader = new ImagePreloader();
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(animData.assets);
    this.loadSegments();
    this.updaFrameModifier();
    if(this.renderer.globalData.fontManager){
        this.waitForFontsLoaded();
    }else{
        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
        this.checkLoaded();
    }
};

AnimationItem.prototype.waitForFontsLoaded = (function(){
    function checkFontsLoaded(){
        if(this.renderer.globalData.fontManager.loaded){
            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
            //this.renderer.buildItems(this.animationData.layers);
            this.checkLoaded();
        }else{
            setTimeout(checkFontsLoaded.bind(this),20);
        }
    }

    return function(){
        checkFontsLoaded.bind(this)();
    }
}());

AnimationItem.prototype.addPendingElement = function () {
    this.pendingElements += 1;
}

AnimationItem.prototype.elementLoaded = function () {
    this.pendingElements--;
    this.checkLoaded();
};

AnimationItem.prototype.checkLoaded = function () {
    if (this.pendingElements === 0) {
        if(expressionsPlugin){
            expressionsPlugin.initExpressions(this);
        }
        this.renderer.initItems();
        setTimeout(function(){
            this.trigger('DOMLoaded');
        }.bind(this),0);
        this.isLoaded = true;
        this.gotoFrame();
        if(this.autoplay){
            this.play();
        }
    }
};

AnimationItem.prototype.resize = function () {
    this.renderer.updateContainerSize();
};

AnimationItem.prototype.setSubframe = function(flag){
    this.subframeEnabled = flag ? true : false;
}

AnimationItem.prototype.gotoFrame = function () {
    if(this.subframeEnabled){
        this.currentFrame = this.currentRawFrame;
    }else{
        this.currentFrame = Math.floor(this.currentRawFrame);
    }

    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
        this.currentFrame = this.timeCompleted;
    }
    this.trigger('enterFrame');
    this.renderFrame();
};

AnimationItem.prototype.renderFrame = function () {
    if(this.isLoaded === false){
        return;
    }
    //console.log('this.currentFrame:',this.currentFrame + this.firstFrame);
    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
};

AnimationItem.prototype.play = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === true){
        this.isPaused = false;
        if(this._idle){
            this._idle = false;
            this.trigger('_active');
        }
    }
};

AnimationItem.prototype.pause = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === false){
        this.isPaused = true;
        if(!this.pendingSegment){
            this._idle = true;
            this.trigger('_idle');
        }
    }
};

AnimationItem.prototype.togglePause = function (name) {
    if(name && this.name != name){
        return;
    }
    if(this.isPaused === true){
        this.play();
    }else{
        this.pause();
    }
};

AnimationItem.prototype.stop = function (name) {
    if(name && this.name != name){
        return;
    }
    this.pause();
    this.currentFrame = this.currentRawFrame = 0;
    this.playCount = 0;
    this.gotoFrame();
};

AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if(name && this.name != name){
        return;
    }
    if(isFrame){
        this.setCurrentRawFrameValue(value);
    }else{
        this.setCurrentRawFrameValue(value * this.frameModifier);
    }
    this.pause();
};

AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    this.goToAndStop(value, isFrame, name);
    this.play();
};

AnimationItem.prototype.advanceTime = function (value) {
    if(this.pendingSegment){
        this.pendingSegment = false;
        this.adjustSegment(this.segments.shift());
        if(this.isPaused){
            this.play();
        }
        return;
    }
    if (this.isPaused === true || this.isLoaded === false) {
        return;
    }
    this.setCurrentRawFrameValue(this.currentRawFrame + value * this.frameModifier);
};

AnimationItem.prototype.updateAnimation = function (perc) {
    this.setCurrentRawFrameValue(this.totalFrames * perc);
};

AnimationItem.prototype.moveFrame = function (value, name) {
    if(name && this.name != name){
        return;
    }
    this.setCurrentRawFrameValue(this.currentRawFrame+value);
};

AnimationItem.prototype.adjustSegment = function(arr){
    this.playCount = 0;
    if(arr[1] < arr[0]){
        if(this.frameModifier > 0){
            if(this.playSpeed < 0){
                this.setSpeed(-this.playSpeed);
            } else {
                this.setDirection(-1);
            }
        }
        this.totalFrames = arr[0] - arr[1];
        this.firstFrame = arr[1];
        this.setCurrentRawFrameValue(this.totalFrames - 0.01);
    } else if(arr[1] > arr[0]){
        if(this.frameModifier < 0){
            if(this.playSpeed < 0){
                this.setSpeed(-this.playSpeed);
            } else {
                this.setDirection(1);
            }
        }
        this.totalFrames = arr[1] - arr[0];
        this.firstFrame = arr[0];
        this.setCurrentRawFrameValue(0);
    }
    this.trigger('segmentStart');
};
AnimationItem.prototype.setSegment = function (init,end) {
    var pendingFrame = -1;
    if(this.isPaused) {
        if (this.currentRawFrame + this.firstFrame < init) {
            pendingFrame = init;
        } else if (this.currentRawFrame + this.firstFrame > end) {
            pendingFrame = end - init - 0.01;
        }
    }

    this.firstFrame = init;
    this.totalFrames = end - init;
    if(pendingFrame !== -1) {
        this.goToAndStop(pendingFrame,true);
    }
}

AnimationItem.prototype.playSegments = function (arr,forceFlag) {
    if(typeof arr[0] === 'object'){
        var i, len = arr.length;
        for(i=0;i<len;i+=1){
            this.segments.push(arr[i]);
        }
    }else{
        this.segments.push(arr);
    }
    if(forceFlag){
        this.adjustSegment(this.segments.shift());
    }
    if(this.isPaused){
        this.play();
    }
};

AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
    if(forceFlag){
        this.adjustSegment(this.segments.shift());
    }
};
AnimationItem.prototype.checkSegments = function(){
    if(this.segments.length){
        this.pendingSegment = true;
    }
}

AnimationItem.prototype.remove = function (name) {
    if(name && this.name != name){
        return;
    }
    this.renderer.destroy();
};

AnimationItem.prototype.destroy = function (name) {
    if((name && this.name != name) || (this.renderer && this.renderer.destroyed)){
        return;
    }
    this.renderer.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
};

AnimationItem.prototype.setCurrentRawFrameValue = function(value){
    this.currentRawFrame = value;
    //console.log(this.totalFrames);
    if (this.currentRawFrame >= this.totalFrames) {
        this.checkSegments();
        if(this.loop === false){
            this.currentRawFrame = this.totalFrames - 0.01;
            this.gotoFrame();
            this.pause();
            this.trigger('complete');
            return;
        }else{
            this.trigger('loopComplete');
            this.playCount += 1;
            if((this.loop !== true && this.playCount == this.loop) || this.pendingSegment){
                this.currentRawFrame = this.totalFrames - 0.01;
                this.gotoFrame();
                this.pause();
                this.trigger('complete');
                return;
            } else {
                this.currentRawFrame = this.currentRawFrame % this.totalFrames;
            }
        }
    } else if (this.currentRawFrame < 0) {
        this.checkSegments();
        this.playCount -= 1;
        if(this.playCount < 0){
            this.playCount = 0;
        }
        if(this.loop === false  || this.pendingSegment){
            this.currentRawFrame = 0;
            this.gotoFrame();
            this.pause();
            this.trigger('complete');
            return;
        }else{
            this.trigger('loopComplete');
            this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames;
            this.gotoFrame();
            return;
        }
    }

    this.gotoFrame();
};

AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
};

AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
};

AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
};

AnimationItem.prototype.getPath = function () {
    return this.path;
};

AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';
    if(this.assetsPath){
        var imagePath = assetData.p;
        if(imagePath.indexOf('images/') !== -1){
            imagePath = imagePath.split('/')[1];
        }
        path = this.assetsPath + imagePath;
    } else {
        path = this.path;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
    }
    return path;
};

AnimationItem.prototype.getAssetData = function (id) {
    var i = 0, len = this.assets.length;
    while (i < len) {
        if(id == this.assets[i].id){
            return this.assets[i];
        }
        i += 1;
    }
};

AnimationItem.prototype.hide = function () {
    this.renderer.hide();
};

AnimationItem.prototype.show = function () {
    this.renderer.show();
};

AnimationItem.prototype.getAssets = function () {
    return this.assets;
};

AnimationItem.prototype.trigger = function(name){
    if(this._cbs && this._cbs[name]){
        switch(name){
            case 'enterFrame':
                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
                break;
            case 'loopComplete':
                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name,new BMDestroyEvent(name,this));
                break;
            default:
                this.triggerEvent(name);
        }
    }
    if(name === 'enterFrame' && this.onEnterFrame){
        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
    }
    if(name === 'loopComplete' && this.onLoopComplete){
        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
    }
    if(name === 'complete' && this.onComplete){
        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
    }
    if(name === 'segmentStart' && this.onSegmentStart){
        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
    }
    if(name === 'destroy' && this.onDestroy){
        this.onDestroy.call(this,new BMDestroyEvent(name,this));
    }
};

AnimationItem.prototype.addEventListener = _addEventListener;
AnimationItem.prototype.removeEventListener = _removeEventListener;
AnimationItem.prototype.triggerEvent = _triggerEvent;

function CanvasRenderer(animationItem, config){
    this.animationItem = animationItem;
    this.renderConfig = {
        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
        context: (config && config.context) || null,
        progressiveLoad: (config && config.progressiveLoad) || false,
        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet'
    };
    this.renderConfig.dpr = (config && config.dpr) || 1;
    if (this.animationItem.wrapper) {
        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
    }
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.contextData = {
        saved : Array.apply(null,{length:15}),
        savedOp: Array.apply(null,{length:15}),
        cArrPos : 0,
        cTr : new Matrix(),
        cO : 1
    };
    var i, len = 15;
    for(i=0;i<len;i+=1){
        this.contextData.saved[i] = Array.apply(null,{length:16});
    }
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
}
extendPrototype(BaseRenderer,CanvasRenderer);

CanvasRenderer.prototype.createBase = function (data) {
    return new CVBaseElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createShape = function (data) {
    return new CVShapeElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createText = function (data) {
    return new CVTextElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createImage = function (data) {
    return new CVImageElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createComp = function (data) {
    return new CVCompElement(data, this, this.globalData);
};

CanvasRenderer.prototype.createSolid = function (data) {
    return new CVSolidElement(data, this, this.globalData);
};

CanvasRenderer.prototype.ctxTransform = function(props){
    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
        return;
    }
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
        return;
    }
    this.transformMat.cloneFromProps(props);
    this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15])
    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
    this.contextData.cTr.cloneFromProps(this.transformMat.props);
    var trProps = this.contextData.cTr.props;
    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
};

CanvasRenderer.prototype.ctxOpacity = function(op){
    if(op === 1){
        return;
    }
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
        return;
    }
    this.contextData.cO *= op < 0 ? 0 : op;
    this.canvasContext.globalAlpha = this.contextData.cO;
};

CanvasRenderer.prototype.reset = function(){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.restore();
        return;
    }
    this.contextData.cArrPos = 0;
    this.contextData.cTr.reset();
    this.contextData.cO = 1;
};

CanvasRenderer.prototype.save = function(actionFlag){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.save();
        return;
    }
    if(actionFlag){
        this.canvasContext.save();
    }
    var props = this.contextData.cTr.props;
    if(this.contextData.saved[this.contextData.cArrPos] === null || this.contextData.saved[this.contextData.cArrPos] === undefined){
        this.contextData.saved[this.contextData.cArrPos] = new Array(16);
    }
    var i,arr = this.contextData.saved[this.contextData.cArrPos];
    for(i=0;i<16;i+=1){
        arr[i] = props[i];
    }
    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
    this.contextData.cArrPos += 1;
};

CanvasRenderer.prototype.restore = function(actionFlag){
    if(!this.renderConfig.clearCanvas){
        this.canvasContext.restore();
        return;
    }
    if(actionFlag){
        this.canvasContext.restore();
    }
    this.contextData.cArrPos -= 1;
    var popped = this.contextData.saved[this.contextData.cArrPos];
    var i,arr = this.contextData.cTr.props;
    for(i=0;i<16;i+=1){
        arr[i] = popped[i];
    }
    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
    popped = this.contextData.savedOp[this.contextData.cArrPos];
    this.contextData.cO = popped;
    this.canvasContext.globalAlpha = popped;
};

CanvasRenderer.prototype.configAnimation = function(animData){
    if(this.animationItem.wrapper){
        this.animationItem.container = document.createElement('canvas');
        this.animationItem.container.style.width = '100%';
        this.animationItem.container.style.height = '100%';
        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.animationItem.container);
        this.canvasContext = this.animationItem.container.getContext('2d');
    }else{
        this.canvasContext = this.renderConfig.context;
    }
    this.data = animData;
    this.globalData.canvasContext = this.canvasContext;
    this.globalData.renderer = this;
    this.globalData.isDashed = false;
    this.globalData.totalFrames = Math.floor(animData.tf);
    this.globalData.compWidth = animData.w;
    this.globalData.compHeight = animData.h;
    this.globalData.frameRate = animData.fr;
    this.globalData.frameId = 0;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.layers = animData.layers;
    this.transformCanvas = {};
    this.transformCanvas.w = animData.w;
    this.transformCanvas.h = animData.h;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,document.body);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
    this.globalData.transformCanvas = this.transformCanvas;
    this.elements = Array.apply(null,{length:animData.layers.length});

    this.updateContainerSize();
};

CanvasRenderer.prototype.updateContainerSize = function () {
    var elementWidth,elementHeight;
    if(this.animationItem.wrapper && this.animationItem.container){
        elementWidth = this.animationItem.wrapper.offsetWidth;
        elementHeight = this.animationItem.wrapper.offsetHeight;
        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
    }else{
        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
    }
    var elementRel,animationRel;
    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
        var par = this.renderConfig.preserveAspectRatio.split(' ');
        var fillType = par[1] || 'meet';
        var pos = par[0] || 'xMidYMid';
        var xPos = pos.substr(0,4);
        var yPos = pos.substr(4);
        elementRel = elementWidth/elementHeight;
        animationRel = this.transformCanvas.w/this.transformCanvas.h;
        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
        }else{
            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
        }

        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
        } else {
            this.transformCanvas.tx = 0;
        }
        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
        } else {
            this.transformCanvas.ty = 0;
        }

    }else if(this.renderConfig.preserveAspectRatio == 'none'){
        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
        this.transformCanvas.tx = 0;
        this.transformCanvas.ty = 0;
    }else{
        this.transformCanvas.sx = this.renderConfig.dpr;
        this.transformCanvas.sy = this.renderConfig.dpr;
        this.transformCanvas.tx = 0;
        this.transformCanvas.ty = 0;
    }
    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
    var i, len = this.elements.length;
    for(i=0;i<len;i+=1){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(this.globalData.transformCanvas);
        }
    }
};

CanvasRenderer.prototype.destroy = function () {
    if(this.renderConfig.clearCanvas) {
        this.animationItem.wrapper.innerHTML = '';
    }
    var i, len = this.layers ? this.layers.length : 0;
    for (i = len - 1; i >= 0; i-=1) {
        this.elements[i].destroy();
    }
    this.elements.length = 0;
    this.globalData.canvasContext = null;
    this.animationItem.container = null;
    this.destroyed = true;
};

CanvasRenderer.prototype.renderFrame = function(num){
    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === null){
        return;
    }
    this.renderedFrame = num;
    this.globalData.frameNum = num - this.animationItem.firstFrame;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    if(this.renderConfig.clearCanvas === true){
        this.reset();
        this.canvasContext.save();
        //this.canvasContext.canvas.width = this.canvasContext.canvas.width;
        this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w*this.transformCanvas.sx, this.transformCanvas.h*this.transformCanvas.sy);
    }else{
        this.save();
    }
    this.ctxTransform(this.transformCanvas.props);
    this.canvasContext.beginPath();
    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
    this.canvasContext.closePath();
    this.canvasContext.clip();

    //console.log('--------');
    //console.log('NEW: ',num);
    var i, len = this.layers.length;
    if(!this.completeLayers){
        this.checkLayers(num);
    }

    for (i = 0; i < len; i++) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(num - this.layers[i].st);
        }
    }
    for (i = len - 1; i >= 0; i-=1) {
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.renderConfig.clearCanvas !== true){
        this.restore();
    } else {
        this.canvasContext.restore();
    }
};

CanvasRenderer.prototype.buildItem = function(pos){
    var elements = this.elements;
    if(elements[pos] || this.layers[pos].ty == 99){
        return;
    }
    var element = this.createItem(this.layers[pos], this,this.globalData);
    elements[pos] = element;
    element.initExpressions();
    if(this.layers[pos].ty === 0){
        element.resize(this.globalData.transformCanvas);
    }
};

CanvasRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
    }
};

CanvasRenderer.prototype.hide = function(){
    this.animationItem.container.style.display = 'none';
};

CanvasRenderer.prototype.show = function(){
    this.animationItem.container.style.display = 'block';
};

CanvasRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElementNS(svgNS,'g');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],this.globalData.comp,this.globalData);
            comp.initExpressions();
            //comp.compInterface = CompExpressionInterface(comp);
            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};
function HybridRenderer(animationItem){
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.globalData = {
        frameNum: -1
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;

}

extendPrototype(BaseRenderer,HybridRenderer);

HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;

HybridRenderer.prototype.checkPendingElements  = function(){
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
    }
};

HybridRenderer.prototype.appendElementInPos = function(element, pos){
    var newElement = element.getBaseElement();
    if(!newElement){
        return;
    }
    var layer = this.layers[pos];
    if(!layer.ddd || !this.supports3d){
        var i = 0;
        var nextElement;
        while(i<pos){
            if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
                nextElement = this.elements[i].getBaseElement();
            }
            i += 1;
        }
        if(nextElement){
            if(!layer.ddd || !this.supports3d){
                this.layerElement.insertBefore(newElement, nextElement);
            }
        } else {
            if(!layer.ddd || !this.supports3d){
                this.layerElement.appendChild(newElement);
            }
        }
    } else {
        this.addTo3dContainer(newElement,pos);
    }
};


HybridRenderer.prototype.createBase = function (data) {
    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createShape = function (data) {
    if(!this.supports3d){
        return new IShapeElement(data, this.layerElement,this.globalData,this);
    }
    return new HShapeElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createText = function (data) {
    if(!this.supports3d){
        return new SVGTextElement(data, this.layerElement,this.globalData,this);
    }
    return new HTextElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createCamera = function (data) {
    this.camera = new HCameraElement(data, this.layerElement,this.globalData,this);
    return this.camera;
};

HybridRenderer.prototype.createImage = function (data) {
    if(!this.supports3d){
        return new IImageElement(data, this.layerElement,this.globalData,this);
    }
    return new HImageElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.createComp = function (data) {
    if(!this.supports3d){
        return new ICompElement(data, this.layerElement,this.globalData,this);
    }
    return new HCompElement(data, this.layerElement,this.globalData,this);

};

HybridRenderer.prototype.createSolid = function (data) {
    if(!this.supports3d){
        return new ISolidElement(data, this.layerElement,this.globalData,this);
    }
    return new HSolidElement(data, this.layerElement,this.globalData,this);
};

HybridRenderer.prototype.getThreeDContainer = function(pos){
    var perspectiveElem = document.createElement('div');
    styleDiv(perspectiveElem);
    perspectiveElem.style.width = this.globalData.compSize.w+'px';
    perspectiveElem.style.height = this.globalData.compSize.h+'px';
    perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
    var container = document.createElement('div');
    styleDiv(container);
    container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    perspectiveElem.appendChild(container);
    this.resizerElem.appendChild(perspectiveElem);
    var threeDContainerData = {
        container:container,
        perspectiveElem:perspectiveElem,
        startPos: pos,
        endPos: pos
    };
    this.threeDElements.push(threeDContainerData);
    return threeDContainerData;
};

HybridRenderer.prototype.build3dContainers = function(){
    var i, len = this.layers.length;
    var lastThreeDContainerData;
    for(i=0;i<len;i+=1){
        if(this.layers[i].ddd){
            if(!lastThreeDContainerData){
                lastThreeDContainerData = this.getThreeDContainer(i);
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
        } else {
            lastThreeDContainerData = null;
        }
    }
};

HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
    var i = 0, len = this.threeDElements.length;
    while(i<len){
        if(pos <= this.threeDElements[i].endPos){
            var j = this.threeDElements[i].startPos;
            var nextElement;
            while(j<pos){
                if(this.elements[j] && this.elements[j].getBaseElement){
                    nextElement = this.elements[j].getBaseElement();
                }
                j += 1;
            }
            if(nextElement){
                this.threeDElements[i].container.insertBefore(elem, nextElement);
            } else {
                this.threeDElements[i].container.appendChild(elem);
            }
            break;
        }
        i += 1;
    }
};

HybridRenderer.prototype.configAnimation = function(animData){
    var resizerElem = document.createElement('div');
    var wrapper = this.animationItem.wrapper;
    resizerElem.style.width = animData.w+'px';
    resizerElem.style.height = animData.h+'px';
    this.resizerElem = resizerElem;
    styleDiv(resizerElem);
    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
    wrapper.appendChild(resizerElem);

    resizerElem.style.overflow = 'hidden';
    var svg = document.createElementNS(svgNS,'svg');
    svg.setAttribute('width','1');
    svg.setAttribute('height','1');
    styleDiv(svg);
    this.resizerElem.appendChild(svg);
    var defs = document.createElementNS(svgNS,'defs');
    svg.appendChild(defs);
    this.globalData.defs = defs;
    this.data = animData;
    //Mask animation
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
    this.globalData.frameId = 0;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
    this.globalData.frameRate = animData.fr;
    this.layers = animData.layers;
    this.globalData.fontManager = new FontManager();
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts,svg);
    this.layerElement = this.resizerElem;
    this.build3dContainers();
    this.updateContainerSize();
};

HybridRenderer.prototype.destroy = function () {
    this.animationItem.wrapper.innerHTML = '';
    this.animationItem.container = null;
    this.globalData.defs = null;
    var i, len = this.layers ? this.layers.length : 0;
    for (i = 0; i < len; i++) {
        this.elements[i].destroy();
    }
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};

HybridRenderer.prototype.updateContainerSize = function () {
    var elementWidth = this.animationItem.wrapper.offsetWidth;
    var elementHeight = this.animationItem.wrapper.offsetHeight;
    var elementRel = elementWidth/elementHeight;
    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
    var sx,sy,tx,ty;
    if(animationRel>elementRel){
        sx = elementWidth/(this.globalData.compSize.w);
        sy = elementWidth/(this.globalData.compSize.w);
        tx = 0;
        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
    }else{
        sx = elementHeight/(this.globalData.compSize.h);
        sy = elementHeight/(this.globalData.compSize.h);
        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
        ty = 0;
    }
    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
};

HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

HybridRenderer.prototype.hide = function(){
    this.resizerElem.style.display = 'none';
};

HybridRenderer.prototype.show = function(){
    this.resizerElem.style.display = 'block';
};

HybridRenderer.prototype.initItems = function(){
    this.buildAllItems();
    if(this.camera){
        this.camera.setup();
    } else {
        var cWidth = this.globalData.compSize.w;
        var cHeight = this.globalData.compSize.h;
        var i, len = this.threeDElements.length;
        for(i=0;i<len;i+=1){
            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
        }
    }
};

HybridRenderer.prototype.searchExtraCompositions = function(assets){
    var i, len = assets.length;
    var floatingContainer = document.createElement('div');
    for(i=0;i<len;i+=1){
        if(assets[i].xt){
            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    }
};
function CVBaseElement(data, comp,globalData){
    this.globalData = globalData;
    this.data = data;
    this.comp = comp;
    this.canvasContext = globalData.canvasContext;
    this.init();
}

createElement(BaseElement, CVBaseElement);

CVBaseElement.prototype.createElements = function(){
    this.checkParenting();
};

CVBaseElement.prototype.checkBlendMode = function(globalData){
    if(globalData.blendMode !== this.data.bm) {
        globalData.blendMode = this.data.bm;

        var blendModeValue = '';
        switch (this.data.bm) {
            case 0:
                blendModeValue = 'normal';
                break;
            case 1:
                blendModeValue = 'multiply';
                break;
            case 2:
                blendModeValue = 'screen';
                break;
            case 3:
                blendModeValue = 'overlay';
                break;
            case 4:
                blendModeValue = 'darken';
                break;
            case 5:
                blendModeValue = 'lighten';
                break;
            case 6:
                blendModeValue = 'color-dodge';
                break;
            case 7:
                blendModeValue = 'color-burn';
                break;
            case 8:
                blendModeValue = 'hard-light';
                break;
            case 9:
                blendModeValue = 'soft-light';
                break;
            case 10:
                blendModeValue = 'difference';
                break;
            case 11:
                blendModeValue = 'exclusion';
                break;
            case 12:
                blendModeValue = 'hue';
                break;
            case 13:
                blendModeValue = 'saturation';
                break;
            case 14:
                blendModeValue = 'color';
                break;
            case 15:
                blendModeValue = 'luminosity';
                break;
        }
        globalData.canvasContext.globalCompositeOperation = blendModeValue;
    }
};


CVBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3){
        return false;
    }
        this.checkBlendMode(this.data.ty === 0?this.parentGlobalData:this.globalData);

    if(!this.isVisible){
        return this.isVisible;
    }
    this.finalTransform.opMdf = this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i, len = this.hierarchy.length;
        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for(i=0;i<len;i+=1){
            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        }
    }else{
        if(!parentTransform){
            finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
        }else{
            mat = this.finalTransform.mProp.v.props;
            finalMat.cloneFromProps(mat);
        }
    }

    if(parentTransform){
        mat = parentTransform.mat.props;
        finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        this.finalTransform.opacity *= parentTransform.opacity;
        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
    }

    if(this.data.hasMask){
        this.globalData.renderer.save(true);
        this.maskManager.renderFrame(this.data.ty === 0?null:finalMat);
    }
    if(this.data.hd){
        this.isVisible = false;
    }
    return this.isVisible;

};

CVBaseElement.prototype.addMasks = function(data){
    this.maskManager = new CVMaskElement(data,this,this.globalData);
};


CVBaseElement.prototype.destroy = function(){
    this.canvasContext = null;
    this.data = null;
    this.globalData = null;
    if(this.maskManager) {
        this.maskManager.destroy();
    }
};

CVBaseElement.prototype.mHelper = new Matrix();

function CVCompElement(data, comp,globalData){
    this._parent.constructor.call(this,data, comp,globalData);
    var compGlobalData = {};
    for(var s in globalData){
        if(globalData.hasOwnProperty(s)){
            compGlobalData[s] = globalData[s];
        }
    }
    compGlobalData.renderer = this;
    compGlobalData.compHeight = this.data.h;
    compGlobalData.compWidth = this.data.w;
    this.renderConfig = {
        clearCanvas: true
    };
    this.contextData = {
        saved : Array.apply(null,{length:15}),
        savedOp: Array.apply(null,{length:15}),
        cArrPos : 0,
        cTr : new Matrix(),
        cO : 1
    };
    this.completeLayers = false;
    var i, len = 15;
    for(i=0;i<len;i+=1){
        this.contextData.saved[i] = Array.apply(null,{length:16});
    }
    this.transformMat = new Matrix();
    this.parentGlobalData = this.globalData;
    var cv = document.createElement('canvas');
    //document.body.appendChild(cv);
    compGlobalData.canvasContext = cv.getContext('2d');
    this.canvasContext = compGlobalData.canvasContext;
    cv.width = this.data.w;
    cv.height = this.data.h;
    this.canvas = cv;
    this.globalData = compGlobalData;
    this.layers = data.layers;
    this.pendingElements = [];
    this.elements = Array.apply(null,{length:this.layers.length});
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.xt || !globalData.progressiveLoad){
        this.buildAllItems();
    }
}
createElement(CVBaseElement, CVCompElement);

CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform;
CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity;
CVCompElement.prototype.save = CanvasRenderer.prototype.save;
CVCompElement.prototype.restore = CanvasRenderer.prototype.restore;
CVCompElement.prototype.reset =  function(){
    this.contextData.cArrPos = 0;
    this.contextData.cTr.reset();
    this.contextData.cO = 1;
};
CVCompElement.prototype.resize = function(transformCanvas){
    var maxScale = Math.max(transformCanvas.sx,transformCanvas.sy);
    this.canvas.width = this.data.w*maxScale;
    this.canvas.height = this.data.h*maxScale;
    this.transformCanvas = {
        sc:maxScale,
        w:this.data.w*maxScale,
        h:this.data.h*maxScale,
        props:[maxScale,0,0,0,0,maxScale,0,0,0,0,1,0,0,0,0,1]
    }
    var i,len = this.elements.length;
    for( i = 0; i < len; i+=1 ){
        if(this.elements[i] && this.elements[i].data.ty === 0){
            this.elements[i].resize(transformCanvas);
        }
    }
};

CVCompElement.prototype.prepareFrame = function(num){
    this.globalData.frameId = this.parentGlobalData.frameId;
    this.globalData.mdf = false;
    this._parent.prepareFrame.call(this,num);
    if(this.isVisible===false && !this.data.xt){
        return;
    }
    var timeRemapped = num;
    if(this.tm){
        timeRemapped = this.tm.v;
        if(timeRemapped === this.data.op){
            timeRemapped = this.data.op - 1;
        }
    }
    this.renderedFrame = timeRemapped/this.data.sr;
    var i,len = this.elements.length;

    if(!this.completeLayers){
        this.checkLayers(num);
    }

    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].prepareFrame(timeRemapped/this.data.sr - this.layers[i].st);
            if(this.elements[i].data.ty === 0 && this.elements[i].globalData.mdf){
                this.globalData.mdf = true;
            }
        }
    }
    if(this.globalData.mdf && !this.data.xt){
        this.canvasContext.clearRect(0, 0, this.data.w, this.data.h);
        this.ctxTransform(this.transformCanvas.props);
    }
};

CVCompElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this,parentMatrix)===false){
        return;
    }
    if(this.globalData.mdf){
        var i,len = this.layers.length;
        for( i = len - 1; i >= 0; i -= 1 ){
            if(this.completeLayers || this.elements[i]){
                this.elements[i].renderFrame();
            }
        }
    }
    if(this.data.hasMask){
        this.globalData.renderer.restore(true);
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
    this.parentGlobalData.renderer.save();
    this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity);
    this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h);
    this.parentGlobalData.renderer.restore();

    if(this.globalData.mdf){
        this.reset();
    }
};

CVCompElement.prototype.setElements = function(elems){
    this.elements = elems;
};

CVCompElement.prototype.getElements = function(){
    return this.elements;
};

CVCompElement.prototype.destroy = function(){
    var i,len = this.layers.length;
    for( i = len - 1; i >= 0; i -= 1 ){
        this.elements[i].destroy();
    }
    this.layers = null;
    this.elements = null;
    this._parent.destroy.call(this._parent);
};
CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers;
CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem;
CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements;
CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement;
CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems;
CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem;
CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage;
CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp;
CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid;
CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape;
CVCompElement.prototype.createText = CanvasRenderer.prototype.createText;
CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase;
CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting;
function CVImageElement(data, comp,globalData){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data, comp,globalData);
    this.globalData.addPendingElement();
}
createElement(CVBaseElement, CVImageElement);

CVImageElement.prototype.createElements = function(){
    var imageLoaded = function(){
        this.globalData.elementLoaded();
        if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
            var canvas = document.createElement('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');

            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w/this.assetData.h;
            var widthCrop, heightCrop;
            if(imgRel>canvasRel){
                heightCrop = imgH;
                widthCrop = heightCrop*canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop/canvasRel;
            }
            ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
            this.img = canvas;
        }
    }.bind(this);
    var imageFailed = function(){
        this.failed = true;
        this.globalData.elementLoaded();
    }.bind(this);

    this.img = new Image();
    this.img.addEventListener('load', imageLoaded, false);
    this.img.addEventListener('error', imageFailed, false);
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.img.src = assetPath;

    this._parent.createElements.call(this);

};

CVImageElement.prototype.renderFrame = function(parentMatrix){
    if(this.failed){
        return;
    }
    if(this._parent.renderFrame.call(this,parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    this.globalData.renderer.save();
    var finalMat = this.finalTransform.mat.props;
    this.globalData.renderer.ctxTransform(finalMat);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.drawImage(this.img,0,0);
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

CVImageElement.prototype.destroy = function(){
    this.img = null;
    this._parent.destroy.call(this._parent);
};

function CVMaskElement(data,element){
    this.data = data;
    this.element = element;
    this.dynamicProperties = [];
    this.masksProperties = this.data.masksProperties;
    this.viewData = new Array(this.masksProperties.length);
    var i, len = this.masksProperties.length;
    for (i = 0; i < len; i++) {
        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3,this.dynamicProperties,null);
    }
}

CVMaskElement.prototype.getMaskProperty = function(pos){
    return this.viewData[pos];
};

CVMaskElement.prototype.prepareFrame = function(num){
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue(num);
        if(this.dynamicProperties[i].mdf){
            this.element.globalData.mdf = true;
        }
    }
};

CVMaskElement.prototype.renderFrame = function (transform) {
    var ctx = this.element.canvasContext;
    var i, len = this.data.masksProperties.length;
    var pt,pt2,pt3,data, hasMasks = false;
    for (i = 0; i < len; i++) {
        if(this.masksProperties[i].mode === 'n'){
            continue;
        }
        if(hasMasks === false){
            ctx.beginPath();
            hasMasks = true;
        }
        if (this.masksProperties[i].inv) {
            ctx.moveTo(0, 0);
            ctx.lineTo(this.element.globalData.compWidth, 0);
            ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
            ctx.lineTo(0, this.element.globalData.compHeight);
            ctx.lineTo(0, 0);
        }
        data = this.viewData[i].v;
        pt = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0):data.v[0];
        ctx.moveTo(pt[0], pt[1]);
        var j, jLen = data._length;
        for (j = 1; j < jLen; j++) {
            pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
            pt2 = transform ? transform.applyToPointArray(data.i[j][0],data.i[j][1],0) : data.i[j];
            pt3 = transform ? transform.applyToPointArray(data.v[j][0],data.v[j][1],0) : data.v[j];
            ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
        }
        pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
        pt2 = transform ? transform.applyToPointArray(data.i[0][0],data.i[0][1],0) : data.i[0];
        pt3 = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0) : data.v[0];
        ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
    }
    if(hasMasks){
        ctx.clip();
    }
};

CVMaskElement.prototype.getMask = function(nm){
    var i = 0, len = this.masksProperties.length;
    while(i<len){
        if(this.masksProperties[i].nm === nm){
            return {
                maskPath: this.viewData[i].pv
            }
        }
        i += 1;
    }
};

CVMaskElement.prototype.destroy = function(){
    this.element = null;
};
function CVShapeElement(data, comp,globalData){
    this.shapes = [];
    this.stylesList = [];
    this.viewData = [];
    this.shapeModifiers = [];
    this.shapesData = data.shapes;
    this.firstFrame = true;
    this._parent.constructor.call(this,data, comp,globalData);
}
createElement(CVBaseElement, CVShapeElement);

CVShapeElement.prototype.lcEnum = {
    '1': 'butt',
    '2': 'round',
    '3': 'butt'
}

CVShapeElement.prototype.ljEnum = {
    '1': 'miter',
    '2': 'round',
    '3': 'butt'
};
CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),matMdf:false,opMdf:false};

CVShapeElement.prototype.dashResetter = [];

CVShapeElement.prototype.createElements = function(){

    this._parent.createElements.call(this);
    this.searchShapes(this.shapesData,this.viewData,this.dynamicProperties);
};
CVShapeElement.prototype.searchShapes = function(arr,data,dynamicProperties){
    var i, len = arr.length - 1;
    var j, jLen;
    var ownArrays = [], ownModifiers = [], styleElem;
    for(i=len;i>=0;i-=1){
        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
            styleElem = {
                type: arr[i].ty,
                elements: []
            };
            data[i] = {};
            if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
                data[i].c = PropertyFactory.getProp(this,arr[i].c,1,255,dynamicProperties);
                if(!data[i].c.k){
                    styleElem.co = 'rgb('+bm_floor(data[i].c.v[0])+','+bm_floor(data[i].c.v[1])+','+bm_floor(data[i].c.v[2])+')';
                }
            }
            data[i].o = PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties);
            if(arr[i].ty == 'st') {
                styleElem.lc = this.lcEnum[arr[i].lc] || 'round';
                styleElem.lj = this.ljEnum[arr[i].lj] || 'round';
                if(arr[i].lj == 1) {
                    styleElem.ml = arr[i].ml;
                }
                data[i].w = PropertyFactory.getProp(this,arr[i].w,0,null,dynamicProperties);
                if(!data[i].w.k){
                    styleElem.wi = data[i].w.v;
                }
                if(arr[i].d){
                    var d = PropertyFactory.getDashProp(this,arr[i].d,'canvas',dynamicProperties);
                    data[i].d = d;
                    if(!data[i].d.k){
                        styleElem.da = data[i].d.dasharray;
                        styleElem.do = data[i].d.dashoffset;
                    }
                }

            } else {

                styleElem.r = arr[i].r === 2 ? 'evenodd' : 'nonzero';
            }
            this.stylesList.push(styleElem);
            data[i].style = styleElem;
            ownArrays.push(data[i].style);
        }else if(arr[i].ty == 'gr'){
            data[i] = {
                it: []
            };
            this.searchShapes(arr[i].it,data[i].it,dynamicProperties);
        }else if(arr[i].ty == 'tr'){
            data[i] = {
                transform : {
                    mat: new Matrix(),
                    opacity: 1,
                    matMdf:false,
                    opMdf:false,
                    op: PropertyFactory.getProp(this,arr[i].o,0,0.01,dynamicProperties),
                    mProps: PropertyFactory.getProp(this,arr[i],2,null,dynamicProperties)
                },
                elements: []
            };
        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
            data[i] = {
                nodes:[],
                trNodes:[],
                tr:[0,0,0,0,0,0]
            };
            var ty = 4;
            if(arr[i].ty == 'rc'){
                ty = 5;
            }else if(arr[i].ty == 'el'){
                ty = 6;
            }else if(arr[i].ty == 'sr'){
                ty = 7;
            }
            data[i].sh = ShapePropertyFactory.getShapeProp(this,arr[i],ty,dynamicProperties);
            this.shapes.push(data[i].sh);
            this.addShapeToModifiers(data[i]);
            jLen = this.stylesList.length;
            var hasStrokes = false, hasFills = false;
            for(j=0;j<jLen;j+=1){
                if(!this.stylesList[j].closed){
                    this.stylesList[j].elements.push(data[i]);
                    if(this.stylesList[j].type === 'st'){
                        hasStrokes = true;
                    }else{
                        hasFills = true;
                    }
                }
            }
            data[i].st = hasStrokes;
            data[i].fl = hasFills;
        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'rp'){
            var modifier = ShapeModifiers.getModifier(arr[i].ty);
            modifier.init(this,arr[i],dynamicProperties);
            this.shapeModifiers.push(modifier);
            ownModifiers.push(modifier);
            data[i] = modifier;
        }
    }
    len = ownArrays.length;
    for(i=0;i<len;i+=1){
        ownArrays[i].closed = true;
    }
    len = ownModifiers.length;
    for(i=0;i<len;i+=1){
        ownModifiers[i].closed = true;
    }
};

CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers;
CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers;

CVShapeElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    this.transformHelper.mat.reset();
    this.transformHelper.opacity = this.finalTransform.opacity;
    this.transformHelper.matMdf = false;
    this.transformHelper.opMdf = this.finalTransform.opMdf;
    this.renderModifiers();
    this.renderShape(this.transformHelper,null,null,true);
    if(this.data.hasMask){
        this.globalData.renderer.restore(true);
    }
};

CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
    var i, len;
    if(!items){
        items = this.shapesData;
        len = this.stylesList.length;
        for(i=0;i<len;i+=1){
            this.stylesList[i].d = '';
            this.stylesList[i].mdf = false;
        }
    }
    if(!data){
        data = this.viewData;
    }
    ///
    ///
    len = items.length - 1;
    var groupTransform,groupMatrix;
    groupTransform = parentTransform;
    for(i=len;i>=0;i-=1){
        if(items[i].ty == 'tr'){
            groupTransform = data[i].transform;
            var mtArr = data[i].transform.mProps.v.props;
            groupTransform.matMdf = groupTransform.mProps.mdf;
            groupTransform.opMdf = groupTransform.op.mdf;
            groupMatrix = groupTransform.mat;
            groupMatrix.cloneFromProps(mtArr);
            if(parentTransform){
                var props = parentTransform.mat.props;
                groupTransform.opacity = parentTransform.opacity;
                groupTransform.opacity *= data[i].transform.op.v;
                groupTransform.matMdf = parentTransform.matMdf ? true : groupTransform.matMdf;
                groupTransform.opMdf = parentTransform.opMdf ? true : groupTransform.opMdf;
                groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
            }else{
                groupTransform.opacity = groupTransform.op.o;
            }
        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
            this.renderPath(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'fl'){
            this.renderFill(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'st'){
            this.renderStroke(items[i],data[i],groupTransform);
        }else if(items[i].ty == 'gr'){
            this.renderShape(groupTransform,items[i].it,data[i].it);
        }else if(items[i].ty == 'tm'){
            //
        }
    }
    if(!isMain){
        return;
    }
    len = this.stylesList.length;
    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type;
    renderer.save();
    renderer.ctxTransform(this.finalTransform.mat.props);
    for(i=0;i<len;i+=1){
        type = this.stylesList[i].type;
        if(type === 'st' && this.stylesList[i].wi === 0){
            continue;
        }
        renderer.save();
        elems = this.stylesList[i].elements;
        if(type === 'st'){
            ctx.strokeStyle = this.stylesList[i].co;
            ctx.lineWidth = this.stylesList[i].wi;
            ctx.lineCap = this.stylesList[i].lc;
            ctx.lineJoin = this.stylesList[i].lj;
            ctx.miterLimit = this.stylesList[i].ml || 0;
        }else{
            ctx.fillStyle = this.stylesList[i].co;
        }
        renderer.ctxOpacity(this.stylesList[i].coOp);
        if(type !== 'st'){
            ctx.beginPath();
        }
        jLen = elems.length;
        for(j=0;j<jLen;j+=1){
            if(type === 'st'){
                ctx.beginPath();
                if(this.stylesList[i].da){
                    ctx.setLineDash(this.stylesList[i].da);
                    ctx.lineDashOffset = this.stylesList[i].do;
                    this.globalData.isDashed = true;
                }else if(this.globalData.isDashed){
                    ctx.setLineDash(this.dashResetter);
                    this.globalData.isDashed = false;
                }
            }
            nodes = elems[j].trNodes;
            kLen = nodes.length;

            for(k=0;k<kLen;k+=1){
                if(nodes[k].t == 'm'){
                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
                }else if(nodes[k].t == 'c'){
                    ctx.bezierCurveTo(nodes[k].p1[0],nodes[k].p1[1],nodes[k].p2[0],nodes[k].p2[1],nodes[k].p3[0],nodes[k].p3[1]);
                }else{
                    ctx.closePath();
                }
            }
            if(type === 'st'){
                ctx.stroke();
            }
        }
        if(type !== 'st'){
            ctx.fill(this.stylesList[i].r);
        }
        renderer.restore();
    }
    renderer.restore();
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
CVShapeElement.prototype.renderPath = function(pathData,viewData,groupTransform){
    var len, i, j,jLen;
    var redraw = groupTransform.matMdf || viewData.sh.mdf || this.firstFrame;
    if(redraw) {
        var paths = viewData.sh.paths;
        jLen = paths._length;
        var pathStringTransformed = viewData.trNodes;
        pathStringTransformed.length = 0;
        for(j=0;j<jLen;j+=1){
            var pathNodes = paths.shapes[j];
            if(pathNodes && pathNodes.v){
                len = pathNodes._length;
                for (i = 1; i < len; i += 1) {
                    if (i == 1) {
                        pathStringTransformed.push({
                            t: 'm',
                            p: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                    }
                    pathStringTransformed.push({
                        t: 'c',
                        p1: groupTransform.mat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
                        p2: groupTransform.mat.applyToPointArray(pathNodes.i[i][0], pathNodes.i[i][1], 0),
                        p3: groupTransform.mat.applyToPointArray(pathNodes.v[i][0], pathNodes.v[i][1], 0)
                    });
                }
                if (len == 1) {
                    pathStringTransformed.push({
                        t: 'm',
                        p: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                }
                if (pathNodes.c && len) {
                    pathStringTransformed.push({
                        t: 'c',
                        p1: groupTransform.mat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
                        p2: groupTransform.mat.applyToPointArray(pathNodes.i[0][0], pathNodes.i[0][1], 0),
                        p3: groupTransform.mat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    pathStringTransformed.push({
                        t: 'z'
                    });
                }
                viewData.lStr = pathStringTransformed;
            }

        }

        if (viewData.st) {
            for (i = 0; i < 16; i += 1) {
                viewData.tr[i] = groupTransform.mat.props[i];
            }
        }
        viewData.trNodes = pathStringTransformed;

    }
};



CVShapeElement.prototype.renderFill = function(styleData,viewData, groupTransform){
    var styleElem = viewData.style;

    if(viewData.c.mdf || this.firstFrame){
        styleElem.co = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || groupTransform.opMdf || this.firstFrame){
        styleElem.coOp = viewData.o.v*groupTransform.opacity;
    }
};

CVShapeElement.prototype.renderStroke = function(styleData,viewData, groupTransform){
    var styleElem = viewData.style;
    //TODO fix dashes
    var d = viewData.d;
    var dasharray,dashoffset;
    if(d && (d.mdf  || this.firstFrame)){
        styleElem.da = d.dasharray;
        styleElem.do = d.dashoffset;
    }
    if(viewData.c.mdf || this.firstFrame){
        styleElem.co = 'rgb('+bm_floor(viewData.c.v[0])+','+bm_floor(viewData.c.v[1])+','+bm_floor(viewData.c.v[2])+')';
    }
    if(viewData.o.mdf || groupTransform.opMdf || this.firstFrame){
        styleElem.coOp = viewData.o.v*groupTransform.opacity;
    }
    if(viewData.w.mdf || this.firstFrame){
        styleElem.wi = viewData.w.v;
    }
};


CVShapeElement.prototype.destroy = function(){
    this.shapesData = null;
    this.globalData = null;
    this.canvasContext = null;
    this.stylesList.length = 0;
    this.viewData.length = 0;
    this._parent.destroy.call(this._parent);
};


function CVSolidElement(data, comp,globalData){
    this._parent.constructor.call(this,data, comp,globalData);
}
createElement(CVBaseElement, CVSolidElement);

CVSolidElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    this.globalData.renderer.save();
    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.fillStyle=this.data.sc;
    ctx.fillRect(0,0,this.data.sw,this.data.sh);
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
function CVTextElement(data, comp, globalData){
    this.textSpans = [];
    this.yOffset = 0;
    this.fillColorAnim = false;
    this.strokeColorAnim = false;
    this.strokeWidthAnim = false;
    this.stroke = false;
    this.fill = false;
    this.justifyOffset = 0;
    this.currentRender = null;
    this.renderType = 'canvas';
    this.values = {
        fill: 'rgba(0,0,0,0)',
        stroke: 'rgba(0,0,0,0)',
        sWidth: 0,
        fValue: ''
    }
    this._parent.constructor.call(this,data,comp, globalData);
}
createElement(CVBaseElement, CVTextElement);

CVTextElement.prototype.init = ITextElement.prototype.init;
CVTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
CVTextElement.prototype.getMult = ITextElement.prototype.getMult;
CVTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;

CVTextElement.prototype.tHelper = document.createElement('canvas').getContext('2d');

CVTextElement.prototype.createElements = function(){

    this._parent.createElements.call(this);
    //console.log('this.data: ',this.data);

};

CVTextElement.prototype.buildNewText = function(){
    var documentData = this.currentTextDocumentData;
    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});

    var hasFill = false;
    if(documentData.fc) {
        hasFill = true;
        this.values.fill = 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')';
    }else{
        this.values.fill = 'rgba(0,0,0,0)';
    }
    this.fill = hasFill;
    var hasStroke = false;
    if(documentData.sc){
        hasStroke = true;
        this.values.stroke = 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')';
        this.values.sWidth = documentData.sw;
    }
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    var i, len;
    var letters = documentData.l;
    var matrixHelper = this.mHelper;
    this.stroke = hasStroke;
    this.values.fValue = documentData.s + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
    len = documentData.t.length;
    this.tHelper.font = this.values.fValue;
    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
    if (singleShape) {
        var xPos = 0, yPos = 0, lineWidths = documentData.lineWidths, boxWidth = documentData.boxWidth, firstLine = true;
    }
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        var shapeData;
        if(charData){
            shapeData = charData.data;
        } else {
            shapeData = null;
        }
        matrixHelper.reset();
        if(singleShape && letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
        }

        if(shapeData && shapeData.shapes){
            shapes = shapeData.shapes[0].it;
            jLen = shapes.length;
            matrixHelper.scale(documentData.s/100,documentData.s/100);
            if(singleShape){
                if(documentData.ps){
                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
                }
                matrixHelper.translate(0,-documentData.ls,0);
                switch(documentData.j){
                    case 1:
                        matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line]),0,0);
                        break;
                    case 2:
                        matrixHelper.translate(documentData.justifyOffset + (boxWidth - lineWidths[letters[i].line])/2,0,0);
                        break;
                }
                matrixHelper.translate(xPos,yPos,0);
            }
            commands = new Array(jLen);
            for(j=0;j<jLen;j+=1){
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k=1;k<kLen;k+=1){
                    if(k==1){
                        pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
                    }
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
                commands[j] = pathArr;
            }
        }else{
            commands = [];
        }
        if(singleShape){
            xPos += letters[i].l;
        }
        if(this.textSpans[cnt]){
            this.textSpans[cnt].elem = commands;
        } else {
            this.textSpans[cnt] = {elem: commands};
        }
        cnt +=1;
    }
}

CVTextElement.prototype.renderFrame = function(parentMatrix){
    if(this._parent.renderFrame.call(this, parentMatrix)===false){
        return;
    }
    var ctx = this.canvasContext;
    var finalMat = this.finalTransform.mat.props;
    this.globalData.renderer.save();
    this.globalData.renderer.ctxTransform(finalMat);
    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
    ctx.font = this.values.fValue;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 4;

    if(!this.data.singleShape){
        this.getMeasures();
    }

    var  i,len, j, jLen, k, kLen;
    var renderedLetters = this.renderedLetters;

    var letters = this.currentTextDocumentData.l;

    len = letters.length;
    var renderedLetter;
    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        if(renderedLetter){
            this.globalData.renderer.save();
            this.globalData.renderer.ctxTransform(renderedLetter.props);
            this.globalData.renderer.ctxOpacity(renderedLetter.o);
        }
        if(this.fill){
            if(renderedLetter && renderedLetter.fc){
                if(lastFill !== renderedLetter.fc){
                    lastFill = renderedLetter.fc;
                    ctx.fillStyle = renderedLetter.fc;
                }
            }else if(lastFill !== this.values.fill){
                lastFill = this.values.fill;
                ctx.fillStyle = this.values.fill;
            }
            commands = this.textSpans[i].elem;
            jLen = commands.length;
            this.globalData.canvasContext.beginPath();
            for(j=0;j<jLen;j+=1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k = 2; k < kLen; k += 6) {
                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
            }
            this.globalData.canvasContext.closePath();
            this.globalData.canvasContext.fill();
            ///ctx.fillText(this.textSpans[i].val,0,0);
        }
        if(this.stroke){
            if(renderedLetter && renderedLetter.sw){
                if(lastStrokeW !== renderedLetter.sw){
                    lastStrokeW = renderedLetter.sw;
                    ctx.lineWidth = renderedLetter.sw;
                }
            }else if(lastStrokeW !== this.values.sWidth){
                lastStrokeW = this.values.sWidth;
                ctx.lineWidth = this.values.sWidth;
            }
            if(renderedLetter && renderedLetter.sc){
                if(lastStroke !== renderedLetter.sc){
                    lastStroke = renderedLetter.sc;
                    ctx.strokeStyle = renderedLetter.sc;
                }
            }else if(lastStroke !== this.values.stroke){
                lastStroke = this.values.stroke;
                ctx.strokeStyle = this.values.stroke;
            }
            commands = this.textSpans[i].elem;
            jLen = commands.length;
            this.globalData.canvasContext.beginPath();
            for(j=0;j<jLen;j+=1) {
                pathArr = commands[j];
                kLen = pathArr.length;
                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                for (k = 2; k < kLen; k += 6) {
                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
            }
            this.globalData.canvasContext.closePath();
            this.globalData.canvasContext.stroke();
            ///ctx.strokeText(letters[i].val,0,0);
        }
        if(renderedLetter) {
            this.globalData.renderer.restore();
        }
    }
    /*if(this.data.hasMask){
     this.globalData.renderer.restore(true);
     }*/
    this.globalData.renderer.restore(this.data.hasMask);
    if(this.firstFrame){
        this.firstFrame = false;
    }
};
function HBaseElement(data,parentContainer,globalData,comp, placeholder){
    this.globalData = globalData;
    this.comp = comp;
    this.data = data;
    this.matteElement = null;
    this.parentContainer = parentContainer;
    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
    this.placeholder = placeholder;
    this.init();
};

createElement(BaseElement, HBaseElement);
HBaseElement.prototype.checkBlendMode = function(){

};
HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;

/*HBaseElement.prototype.appendNodeToParent = function(node) {
    if(this.data.hd){
        return;
    }
    if(this.placeholder){
        var g = this.placeholder.phElement;
        g.parentNode.insertBefore(node, g);
        //g.parentNode.removeChild(g);
    }else{
        this.parentContainer.appendChild(node);
    }
};*/


HBaseElement.prototype.getBaseElement = function(){
    return this.baseElement;
};

HBaseElement.prototype.createElements = function(){
    if(this.data.hasMask){
        this.layerElement = document.createElementNS(svgNS,'svg');
        styleDiv(this.layerElement);
        //this.appendNodeToParent(this.layerElement);
        this.baseElement = this.layerElement;
        this.maskedElement = this.layerElement;
    }else{
        this.layerElement = this.parentContainer;
    }
    this.transformedElement = this.layerElement;
    if(this.data.ln && (this.data.ty === 4 || this.data.ty === 0)){
        if(this.layerElement === this.parentContainer){
            this.layerElement = document.createElementNS(svgNS,'g');
            //this.appendNodeToParent(this.layerElement);
            this.baseElement = this.layerElement;
        }
        this.layerElement.setAttribute('id',this.data.ln);
    }
    this.setBlendMode();
    if(this.layerElement !== this.parentContainer){
        this.placeholder = null;
    }
    this.checkParenting();
};

HBaseElement.prototype.renderFrame = function(parentTransform){
    if(this.data.ty === 3){
        return false;
    }

    if(this.currentFrameNum === this.lastNum || !this.isVisible){
        return this.isVisible;
    }
    this.lastNum = this.currentFrameNum;

    this.finalTransform.opMdf = this.finalTransform.op.mdf;
    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
    this.finalTransform.opacity = this.finalTransform.op.v;
    if(this.firstFrame){
        this.finalTransform.opMdf = true;
        this.finalTransform.matMdf = true;
    }

    var mat;
    var finalMat = this.finalTransform.mat;

    if(this.hierarchy){
        var i, len = this.hierarchy.length;

        mat = this.finalTransform.mProp.v.props;
        finalMat.cloneFromProps(mat);
        for(i=0;i<len;i+=1){
            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
            mat = this.hierarchy[i].finalTransform.mProp.v.props;
            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
        }
    }else{
        if(this.isVisible && this.finalTransform.matMdf){
            if(!parentTransform){
                finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
            }else{
                mat = this.finalTransform.mProp.v.props;
                finalMat.cloneFromProps(mat);
            }
        }
    }
    if(this.data.hasMask){
        this.maskManager.renderFrame(finalMat);
    }

    if(parentTransform){
        mat = parentTransform.mat.props;
        finalMat.cloneFromProps(mat);
        this.finalTransform.opacity *= parentTransform.opacity;
        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
    }

    if(this.finalTransform.matMdf){
        this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = finalMat.toCSS();
        this.finalMat = finalMat;
    }
    if(this.finalTransform.opMdf){
        this.transformedElement.style.opacity = this.finalTransform.opacity;
    }
    return this.isVisible;
};

HBaseElement.prototype.destroy = function(){
    this.layerElement = null;
    this.transformedElement = null;
    this.parentContainer = null;
    if(this.matteElement) {
        this.matteElement = null;
    }
    if(this.maskManager) {
        this.maskManager.destroy();
        this.maskManager = null;
    }
};

HBaseElement.prototype.getDomElement = function(){
    return this.layerElement;
};
HBaseElement.prototype.addMasks = function(data){
    this.maskManager = new MaskElement(data,this,this.globalData);
};

HBaseElement.prototype.hide = function(){
};

HBaseElement.prototype.setMatte = function(){

}

HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
function HSolidElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(HBaseElement, HSolidElement);

HSolidElement.prototype.createElements = function(){
    var parent = document.createElement('div');
    styleDiv(parent);
    var cont = document.createElementNS(svgNS,'svg');
    styleDiv(cont);
    cont.setAttribute('width',this.data.sw);
    cont.setAttribute('height',this.data.sh);
    parent.appendChild(cont);
    this.layerElement = parent;
    this.transformedElement = parent;
    //this.appendNodeToParent(parent);
    this.baseElement = parent;
    this.innerElem = parent;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    var rect = document.createElementNS(svgNS,'rect');
    rect.setAttribute('width',this.data.sw);
    rect.setAttribute('height',this.data.sh);
    rect.setAttribute('fill',this.data.sc);
    cont.appendChild(rect);
    if(this.data.hasMask){
        this.maskedElement = rect;
    }
    this.checkParenting();
};



HSolidElement.prototype.hide = IImageElement.prototype.hide;
HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
HSolidElement.prototype.destroy = IImageElement.prototype.destroy;
function HCompElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = Array.apply(null,{length:this.layers.length});
    if(this.data.tm){
        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
    }
    if(this.data.hasMask) {
        this.supports3d = false;
    }
    if(this.data.xt){
        this.layerElement = document.createElement('div');
    }
    this.buildAllItems();

}
createElement(HBaseElement, HCompElement);

HCompElement.prototype.createElements = function(){
    var divElement = document.createElement('div');
    styleDiv(divElement);
    if(this.data.ln){
        divElement.setAttribute('id',this.data.ln);
    }
    divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
    if(this.data.hasMask){
        var compSvg = document.createElementNS(svgNS,'svg');
        styleDiv(compSvg);
        compSvg.setAttribute('width',this.data.w);
        compSvg.setAttribute('height',this.data.h);
        var g = document.createElementNS(svgNS,'g');
        compSvg.appendChild(g);
        divElement.appendChild(compSvg);
        this.maskedElement = g;
        this.baseElement = divElement;
        this.layerElement = g;
        this.transformedElement = divElement;
    }else{
        this.layerElement = divElement;
        this.baseElement = this.layerElement;
        this.transformedElement = divElement;
    }
    //this.appendNodeToParent(this.layerElement);
    this.checkParenting();
};

HCompElement.prototype.hide = ICompElement.prototype.hide;
HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame;
HCompElement.prototype.setElements = ICompElement.prototype.setElements;
HCompElement.prototype.getElements = ICompElement.prototype.getElements;
HCompElement.prototype.destroy = ICompElement.prototype.destroy;

HCompElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    var i,len = this.layers.length;
    if(renderParent===false){
        this.hide();
        return;
    }

    this.hidden = false;

    for( i = 0; i < len; i+=1 ){
        if(this.completeLayers || this.elements[i]){
            this.elements[i].renderFrame();
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
};

HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers;
HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem;
HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements;
HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement;
HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems;
HCompElement.prototype.createItem = HybridRenderer.prototype.createItem;
HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
HCompElement.prototype.createImage = HybridRenderer.prototype.createImage;
HCompElement.prototype.createComp = HybridRenderer.prototype.createComp;
HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid;
HCompElement.prototype.createShape = HybridRenderer.prototype.createShape;
HCompElement.prototype.createText = HybridRenderer.prototype.createText;
HCompElement.prototype.createBase = HybridRenderer.prototype.createBase;
HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos;
function HShapeElement(data,parentContainer,globalData,comp, placeholder){
    this.shapes = [];
    this.shapeModifiers = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.viewData = [];
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.addedTransforms = {
        mdf: false,
        mats: [this.finalTransform.mat]
    };
    this.currentBBox = {
        x:999999,
        y: -999999,
        h: 0,
        w: 0
    };
}
createElement(HBaseElement, HShapeElement);
var parent = HShapeElement.prototype._parent;
extendPrototype(IShapeElement, HShapeElement);
HShapeElement.prototype._parent = parent;

HShapeElement.prototype.createElements = function(){
    var parent = document.createElement('div');
    styleDiv(parent);
    var cont = document.createElementNS(svgNS,'svg');
    styleDiv(cont);
    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
    cont.setAttribute('width',size.w);
    cont.setAttribute('height',size.h);
    if(this.data.hasMask){
        var g = document.createElementNS(svgNS,'g');
        parent.appendChild(cont);
        cont.appendChild(g);
        this.maskedElement = g;
        this.layerElement = g;
        this.shapesContainer = g;
    }else{
        parent.appendChild(cont);
        this.layerElement = cont;
        this.shapesContainer = document.createElementNS(svgNS,'g');
        this.layerElement.appendChild(this.shapesContainer);
    }
    if(!this.data.hd){
        //this.parentContainer.appendChild(parent);
        this.baseElement = parent;
    }
    this.innerElem = parent;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    this.searchShapes(this.shapesData,this.viewData,this.layerElement,this.dynamicProperties,0);
    this.buildExpressionInterface();
    this.layerElement = parent;
    this.transformedElement = parent;
    this.shapeCont = cont;
    if(this.data.bm !== 0){
        this.setBlendMode();
    }
    this.checkParenting();
};

HShapeElement.prototype.renderFrame = function(parentMatrix){
    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.layerElement.style.display = 'block';
        this.hidden = false;
    }
    this.renderModifiers();
    this.addedTransforms.mdf = this.finalTransform.matMdf;
    this.addedTransforms.mats.length = 1;
    this.addedTransforms.mats[0] = this.finalTransform.mat;
    this.renderShape(null,null,true, null);

    if(this.isVisible && (this.elemMdf || this.firstFrame)){
        var boundingBox = this.shapeCont.getBBox();
        var changed = false;
        if(this.currentBBox.w !== boundingBox.width){
            this.currentBBox.w = boundingBox.width;
            this.shapeCont.setAttribute('width',boundingBox.width);
            changed = true;
        }
        if(this.currentBBox.h !== boundingBox.height){
            this.currentBBox.h = boundingBox.height;
            this.shapeCont.setAttribute('height',boundingBox.height);
            changed = true;
        }
        if(changed  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
            this.currentBBox.w = boundingBox.width;
            this.currentBBox.h = boundingBox.height;
            this.currentBBox.x = boundingBox.x;
            this.currentBBox.y = boundingBox.y;

            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        }
    }

};
function HTextElement(data,parentContainer,globalData,comp, placeholder){
    this.textSpans = [];
    this.textPaths = [];
    this.currentBBox = {
        x:999999,
        y: -999999,
        h: 0,
        w: 0
    }
    this.renderType = 'svg';
    this.isMasked = false;
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);

}
createElement(HBaseElement, HTextElement);

HTextElement.prototype.init = ITextElement.prototype.init;
HTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures;
HTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape;
HTextElement.prototype.prepareFrame = ITextElement.prototype.prepareFrame;

HTextElement.prototype.createElements = function(){
    this.isMasked = this.checkMasks();
    var parent = document.createElement('div');
    styleDiv(parent);
    this.layerElement = parent;
    this.transformedElement = parent;
    if(this.isMasked){
        this.renderType = 'svg';
        var cont = document.createElementNS(svgNS,'svg');
        styleDiv(cont);
        this.cont = cont;
        this.compW = this.comp.data.w;
        this.compH = this.comp.data.h;
        cont.setAttribute('width',this.compW);
        cont.setAttribute('height',this.compH);
        var g = document.createElementNS(svgNS,'g');
        cont.appendChild(g);
        parent.appendChild(cont);
        this.maskedElement = g;
        this.innerElem = g;
    } else {
        this.renderType = 'html';
        this.innerElem = parent;
    }
    this.baseElement = parent;

    this.checkParenting();

};

HTextElement.prototype.buildNewText = function(){
    var documentData = this.currentTextDocumentData;
    this.renderedLetters = Array.apply(null,{length:this.currentTextDocumentData.l ? this.currentTextDocumentData.l.length : 0});
    if(documentData.fc) {
        this.innerElem.style.color = this.innerElem.style.fill = 'rgb(' + Math.round(documentData.fc[0]*255) + ',' + Math.round(documentData.fc[1]*255) + ',' + Math.round(documentData.fc[2]*255) + ')';
        ////this.innerElem.setAttribute('fill', 'rgb(' + documentData.fc[0] + ',' + documentData.fc[1] + ',' + documentData.fc[2] + ')');
    }else{
        this.innerElem.style.color = this.innerElem.style.fill = 'rgba(0,0,0,0)';
        ////this.innerElem.setAttribute('fill', 'rgba(0,0,0,0)');
    }
    if(documentData.sc){
        ////this.innerElem.setAttribute('stroke', 'rgb(' + documentData.sc[0] + ',' + documentData.sc[1] + ',' + documentData.sc[2] + ')');
        this.innerElem.style.stroke = 'rgb(' + Math.round(documentData.sc[0]*255) + ',' + Math.round(documentData.sc[1]*255) + ',' + Math.round(documentData.sc[2]*255) + ')';
        ////this.innerElem.setAttribute('stroke-width', documentData.sw);
        this.innerElem.style.strokeWidth = documentData.sw+'px';
    }
    ////this.innerElem.setAttribute('font-size', documentData.s);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if(!this.globalData.fontManager.chars){
        this.innerElem.style.fontSize = documentData.s+'px';
        this.innerElem.style.lineHeight = documentData.s+'px';
        if(fontData.fClass){
            this.innerElem.className = fontData.fClass;
        } else {
            ////this.innerElem.setAttribute('font-family', fontData.fFamily);
            this.innerElem.style.fontFamily = fontData.fFamily;
            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
            ////this.innerElem.setAttribute('font-style', fStyle);
            this.innerElem.style.fontStyle = fStyle;
            ////this.innerElem.setAttribute('font-weight', fWeight);
            this.innerElem.style.fontWeight = fWeight;
        }
    }
    var i, len;

    var letters = documentData.l;
    len = letters.length;
    var tSpan,tParent,tCont;
    var matrixHelper = this.mHelper;
    var shapes, shapeStr = '';
    var cnt = 0;
    for (i = 0;i < len ;i += 1) {
        if(this.globalData.fontManager.chars){
            if(!this.textPaths[cnt]){
                tSpan = document.createElementNS(svgNS,'path');
                tSpan.setAttribute('stroke-linecap', 'butt');
                tSpan.setAttribute('stroke-linejoin','round');
                tSpan.setAttribute('stroke-miterlimit','4');
            } else {
                tSpan = this.textPaths[cnt];
            }
            if(!this.isMasked){
                if(this.textSpans[cnt]){
                    tParent = this.textSpans[cnt];
                    tCont = tParent.children[0];
                } else {

                    tParent = document.createElement('div');
                    tCont = document.createElementNS(svgNS,'svg');
                    tCont.appendChild(tSpan);
                    styleDiv(tParent);
                }
            }
        }else{
            if(!this.isMasked){
                if(this.textSpans[cnt]){
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = document.createElement('span');
                    styleDiv(tParent);
                    tSpan = document.createElement('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else {
                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : document.createElementNS(svgNS,'text');
            }
        }
        //tSpan.setAttribute('visibility', 'hidden');
        if(this.globalData.fontManager.chars){
            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            var shapeData;
            if(charData){
                shapeData = charData.data;
            } else {
                shapeData = null;
            }
            matrixHelper.reset();
            if(shapeData && shapeData.shapes){
                shapes = shapeData.shapes[0].it;
                matrixHelper.scale(documentData.s/100,documentData.s/100);
                shapeStr = this.createPathShape(matrixHelper,shapes);
                tSpan.setAttribute('d',shapeStr);
            }
            if(!this.isMasked){
                this.innerElem.appendChild(tParent);
                if(shapeData && shapeData.shapes){
                    document.body.appendChild(tCont);

                    var boundingBox = tCont.getBBox();
                    tCont.setAttribute('width',boundingBox.width);
                    tCont.setAttribute('height',boundingBox.height);
                    tCont.setAttribute('viewBox',boundingBox.x+' '+ boundingBox.y+' '+ boundingBox.width+' '+ boundingBox.height);
                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + boundingBox.x + 'px,' + boundingBox.y + 'px)';

                    letters[i].yOffset = boundingBox.y;
                    tParent.appendChild(tCont);

                } else{
                    tCont.setAttribute('width',1);
                    tCont.setAttribute('height',1);
                }
            }else{
                this.innerElem.appendChild(tSpan);
            }
        }else{
            tSpan.textContent = letters[i].val;
            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
            if(!this.isMasked){
                this.innerElem.appendChild(tParent);
                //
                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.s/1.2+'px,0)';
            } else {
                this.innerElem.appendChild(tSpan);
            }
        }
        //
        if(!this.isMasked){
            this.textSpans[cnt] = tParent;
        }else{
            this.textSpans[cnt] = tSpan;
        }
        this.textSpans[cnt].style.display = 'block';
        this.textPaths[cnt] = tSpan;
        cnt += 1;
    }
    while(cnt < this.textSpans.length){
        this.textSpans[cnt].style.display = 'none';
        cnt += 1;
    }
}

HTextElement.prototype.hide = SVGTextElement.prototype.hide;

HTextElement.prototype.renderFrame = function(parentMatrix){

    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
    if(renderParent===false){
        this.hide();
        return;
    }
    if(this.hidden){
        this.hidden = false;
        this.innerElem.style.display = 'block';
        this.layerElement.style.display = 'block';
    }

    if(this.data.singleShape){
        if(!this.firstFrame && !this.lettersChangedFlag){
            return;
        } else {
            // Todo Benchmark if using this is better than getBBox
             if(this.isMasked && this.finalTransform.matMdf){
                 this.cont.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
             }
        }
    }

    this.getMeasures();
    if(!this.lettersChangedFlag){
        return;
    }
    var  i,len;
    var renderedLetters = this.renderedLetters;

    var letters = this.currentTextDocumentData.l;

    len = letters.length;
    var renderedLetter;
    for(i=0;i<len;i+=1){
        if(letters[i].n){
            continue;
        }
        renderedLetter = renderedLetters[i];
        if(!this.isMasked){
            this.textSpans[i].style.transform = this.textSpans[i].style.webkitTransform = renderedLetter.m;
        }else{
            this.textSpans[i].setAttribute('transform',renderedLetter.m);
        }
        ////this.textSpans[i].setAttribute('opacity',renderedLetter.o);
        this.textSpans[i].style.opacity = renderedLetter.o;
        if(renderedLetter.sw){
            this.textPaths[i].setAttribute('stroke-width',renderedLetter.sw);
        }
        if(renderedLetter.sc){
            this.textPaths[i].setAttribute('stroke',renderedLetter.sc);
        }
        if(renderedLetter.fc){
            this.textPaths[i].setAttribute('fill',renderedLetter.fc);
            this.textPaths[i].style.color = renderedLetter.fc;
        }
    }
    if(this.isVisible && (this.elemMdf || this.firstFrame)){
        if(this.innerElem.getBBox){
            var boundingBox = this.innerElem.getBBox();

            if(this.currentBBox.w !== boundingBox.width){
                this.currentBBox.w = boundingBox.width;
                this.cont.setAttribute('width',boundingBox.width);
            }
            if(this.currentBBox.h !== boundingBox.height){
                this.currentBBox.h = boundingBox.height;
                this.cont.setAttribute('height',boundingBox.height);
            }
            if(this.currentBBox.w !== boundingBox.width || this.currentBBox.h !== boundingBox.height  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
                this.currentBBox.w = boundingBox.width;
                this.currentBBox.h = boundingBox.height;
                this.currentBBox.x = boundingBox.x;
                this.currentBBox.y = boundingBox.y;

                this.cont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
            }
        }
    }
    if(this.firstFrame){
        this.firstFrame = false;
    }
}


HTextElement.prototype.destroy = SVGTextElement.prototype.destroy;
function HImageElement(data,parentContainer,globalData,comp, placeholder){
    this.assetData = globalData.getAssetData(data.refId);
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
}
createElement(HBaseElement, HImageElement);

HImageElement.prototype.createElements = function(){

    var assetPath = this.globalData.getAssetsPath(this.assetData);
    var img = new Image();

    if(this.data.hasMask){
        var parent = document.createElement('div');
        styleDiv(parent);
        var cont = document.createElementNS(svgNS,'svg');
        styleDiv(cont);
        cont.setAttribute('width',this.assetData.w);
        cont.setAttribute('height',this.assetData.h);
        parent.appendChild(cont);
        this.imageElem = document.createElementNS(svgNS,'image');
        this.imageElem.setAttribute('width',this.assetData.w+"px");
        this.imageElem.setAttribute('height',this.assetData.h+"px");
        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
        cont.appendChild(this.imageElem);
        this.layerElement = parent;
        this.transformedElement = parent;
        this.baseElement = parent;
        this.innerElem = parent;
        this.maskedElement = this.imageElem;
    } else {
        styleDiv(img);
        this.layerElement = img;
        this.baseElement = img;
        this.innerElem = img;
        this.transformedElement = img;
    }
    img.src = assetPath;
    if(this.data.ln){
        this.innerElem.setAttribute('id',this.data.ln);
    }
    this.checkParenting();
};

HImageElement.prototype.hide = HSolidElement.prototype.hide;
HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame;
HImageElement.prototype.destroy = HSolidElement.prototype.destroy;
function HCameraElement(data,parentContainer,globalData,comp, placeholder){
    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
    this.pe = PropertyFactory.getProp(this,data.pe,0,0,this.dynamicProperties);
    if(data.ks.p.s){
        this.px = PropertyFactory.getProp(this,data.ks.p.x,1,0,this.dynamicProperties);
        this.py = PropertyFactory.getProp(this,data.ks.p.y,1,0,this.dynamicProperties);
        this.pz = PropertyFactory.getProp(this,data.ks.p.z,1,0,this.dynamicProperties);
    }else{
        this.p = PropertyFactory.getProp(this,data.ks.p,1,0,this.dynamicProperties);
    }
    if(data.ks.a){
        this.a = PropertyFactory.getProp(this,data.ks.a,1,0,this.dynamicProperties);
    }
    if(data.ks.or.k.length){
        var i,len = data.ks.or.k.length;
        for(i=0;i<len;i+=1){
            data.ks.or.k[i].to = null;
            data.ks.or.k[i].ti = null;
        }
    }
    this.or = PropertyFactory.getProp(this,data.ks.or,1,degToRads,this.dynamicProperties);
    this.or.sh = true;
    this.rx = PropertyFactory.getProp(this,data.ks.rx,0,degToRads,this.dynamicProperties);
    this.ry = PropertyFactory.getProp(this,data.ks.ry,0,degToRads,this.dynamicProperties);
    this.rz = PropertyFactory.getProp(this,data.ks.rz,0,degToRads,this.dynamicProperties);
    this.mat = new Matrix();
}
createElement(HBaseElement, HCameraElement);

HCameraElement.prototype.setup = function() {
    var i, len = this.comp.threeDElements.length, comp;
    for(i=0;i<len;i+=1){
        //[perspectiveElem,container]
        comp = this.comp.threeDElements[i];
        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
        comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
        comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
    }
};

HCameraElement.prototype.createElements = function(){
};

HCameraElement.prototype.hide = function(){
};

HCameraElement.prototype.renderFrame = function(){
    var mdf = this.firstFrame;
    var i, len;
    if(this.hierarchy){
        len = this.hierarchy.length;
        for(i=0;i<len;i+=1){
            mdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : mdf;
        }
    }
    if(mdf || (this.p && this.p.mdf) || (this.px && (this.px.mdf || this.py.mdf || this.pz.mdf)) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || (this.a && this.a.mdf)) {
        this.mat.reset();

        if(this.p){
            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
        }else{
            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
        }
        if(this.a){
            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);

        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
        this.mat.translate(0,0,this.pe.v);
        if(this.hierarchy){
            var mat;
            len = this.hierarchy.length;
            for(i=0;i<len;i+=1){
                mat = this.hierarchy[i].finalTransform.mProp.iv.props;
                this.mat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],-mat[12],-mat[13],mat[14],mat[15]);
            }
        }
        len = this.comp.threeDElements.length;
        var comp;
        for(i=0;i<len;i+=1){
            comp = this.comp.threeDElements[i];
            comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
        }
    }
    this.firstFrame = false;
};

HCameraElement.prototype.destroy = function(){
};
var Expressions = (function(){
    var ob = {};
    ob.initExpressions = initExpressions;


    function initExpressions(animation){
        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
    }
   return ob;
}());

expressionsPlugin = Expressions;

(function addPropertyDecorator() {

    function getStaticValueAtTime() {
        return this.pv;
    }

    function getValueAtTime(frameNum, offsetTime) {
        frameNum *= this.elem.globalData.frameRate;
        var i = 0,len = this.keyframes.length- 1,dir= 1,flag = true;
        var keyData, nextKeyData;
        offsetTime = offsetTime === undefined ? this.offsetTime : 0;
        //console.log(this.offsetTime);
        var retVal = typeof this.pv === 'object' ? [this.pv.length] : 0;

        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i+1];
            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
                if(keyData.h){
                    keyData = nextKeyData;
                }
                break;
            }
            if((nextKeyData.t - offsetTime) > frameNum){
                break;
            }
            if(i < len - 1){
                i += dir;
            }else{
                flag = false;
            }
        }

        var k, kLen,perc,jLen, j = 0, fnc;
        if (keyData.to) {

            if (!keyData.bezierData) {
                bez.buildBezierData(keyData);
            }
            var bezierData = keyData.bezierData;
            if (frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime) {
                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1){
                    retVal[k] = bezierData.points[ind].point[k];
                }
            } else {
                if (keyData.__fnct) {
                    fnc = keyData.__fnct;
                } else {
                    //fnc = bez.getEasingCurve(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n);
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyData.__fnct = fnc;
                }
                perc = fnc((frameNum - (keyData.t - offsetTime)) / ((nextKeyData.t - offsetTime) - (keyData.t - offsetTime)));
                var distanceInLine = bezierData.segmentLength * perc;

                var segmentPerc;
                var addedLength = 0;
                dir = 1;
                flag = true;
                jLen = bezierData.points.length;
                while(flag) {
                    addedLength += bezierData.points[j].partialLength*dir;
                    if (distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for (k = 0; k < kLen; k += 1) {
                            retVal[k] = bezierData.points[j].point[k];
                        }
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
                        segmentPerc = (distanceInLine - addedLength) / (bezierData.points[j + 1].partialLength);
                        kLen = bezierData.points[j].point.length;
                        for (k = 0; k < kLen; k += 1) {
                            retVal[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        }
                        break;
                    }
                    if (j < jLen - 1 && dir == 1 || j > 0 && dir == -1) {
                        j += dir;
                    } else {
                        flag = false;
                    }
                }
            }
        } else {
            var outX,outY,inX,inY, isArray = false, keyValue;
            len = keyData.s.length;
            for(i=0;i<len;i+=1){
                if(keyData.h !== 1){
                    if(keyData.o.x instanceof Array){
                        isArray = true;
                        if(!keyData.__fnct){
                            keyData.__fnct = [];
                        }
                        if(!keyData.__fnct[i]){
                            outX = keyData.o.x[i] || keyData.o.x[0];
                            outY = keyData.o.y[i] || keyData.o.y[0];
                            inX = keyData.i.x[i] || keyData.i.x[0];
                            inY = keyData.i.y[i] || keyData.i.y[0];
                        }
                    }else{
                        isArray = false;
                        if(!keyData.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                        }
                    }
                    if(isArray){
                        if(keyData.__fnct[i]){
                            fnc = keyData.__fnct[i];
                        }else{
                            //fnc = bez.getEasingCurve(outX,outY,inX,inY);
                            fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                            keyData.__fnct[i] = fnc;
                        }
                    }else{
                        if(keyData.__fnct){
                            fnc = keyData.__fnct;
                        }else{
                            //fnc = bez.getEasingCurve(outX,outY,inX,inY);
                            fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
                            keyData.__fnct = fnc;
                        }
                    }
                    if(frameNum >= nextKeyData.t-offsetTime){
                        perc = 1;
                    }else if(frameNum < keyData.t-offsetTime){
                        perc = 0;
                    }else{
                        perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
                    }
                }
                if(this.sh && keyData.h !== 1){
                    var initP = keyData.s[i];
                    var endP = keyData.e[i];
                    if(initP-endP < -180){
                        initP += 360;
                    } else if(initP-endP > 180){
                        initP -= 360;
                    }
                    keyValue = initP+(endP-initP)*perc;
                } else {
                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
                }
                if(len === 1){
                    retVal = keyValue;
                }else{
                    retVal[i] = keyValue;
                }
            }
        }
        return retVal;
    }

    function getVelocityAtTime(frameNum) {
        if(this.vel !== undefined){
            return this.vel;
        }
        var delta = -0.01;
        //frameNum += this.elem.data.st;
        var v1 = this.getValueAtTime(frameNum, 0);
        var v2 = this.getValueAtTime(frameNum + delta, 0);
        var velocity;
        if(v1.length){
            velocity = Array.apply(null,{length:v1.length});
            var i;
            for(i=0;i<v1.length;i+=1){
                //removing frameRate
                //if needed, don't add it here
                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i])/delta;
            }
        } else {
            velocity = (v2 - v1)/delta;
        }
        return velocity;
    };

    function setGroupProperty(propertyGroup){
        this.propertyGroup = propertyGroup;
    }

    function searchExpressions(elem,data,prop){
        if(data.x){
            prop.k = true;
            prop.x = true;
            if(prop.getValue) {
                prop.getPreValue = prop.getValue;
            }
            prop.getValue = ExpressionManager.initiateExpression.bind(prop)(elem,data,prop);
        }
    }

    var TextExpressionSelectorProp = (function(){

        function getValueProxy(index,total){
            this.textIndex = index+1;
            this.textTotal = total;
            this.getValue();
            return this.v;
        }

        return function TextExpressionSelectorProp(elem,data){
            this.pv = 1;
            this.comp = elem.comp;
            this.elem = elem;
            this.mult = .01;
            this.type = 'textSelector';
            this.textTotal = data.totalChars;
            this.selectorValue = 100;
            this.lastValue = [1,1,1];
            searchExpressions.bind(this)(elem,data,this);
            this.getMult = getValueProxy;
            this.getVelocityAtTime = getVelocityAtTime;
            if(this.kf){
                this.getValueAtTime = getValueAtTime.bind(this);
            } else {
                this.getValueAtTime = getStaticValueAtTime.bind(this);
            }
            this.setGroupProperty = setGroupProperty;
        }
    }());


    var propertyGetProp = PropertyFactory.getProp;
    PropertyFactory.getProp = function(elem,data,type, mult, arr){
        var prop = propertyGetProp(elem,data,type, mult, arr);
        prop.getVelocityAtTime = getVelocityAtTime;
        if(prop.kf){
            prop.getValueAtTime = getValueAtTime.bind(prop);
        } else {
            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
        }
        prop.setGroupProperty = setGroupProperty;
        var isAdded = prop.k;
        if(data.ix !== undefined){
            Object.defineProperty(prop,'propertyIndex',{
                get: function(){
                    return data.ix;
                }
            })
        }
        searchExpressions(elem,data,prop);
        if(!isAdded && prop.x){
            arr.push(prop);
        }

        return prop;
    }

    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
        prop.setGroupProperty = setGroupProperty;
        if(prop.kf){
            prop.getValueAtTime = getValueAtTime;
        } else {
            prop.getValueAtTime = getStaticValueAtTime;
        }
        var isAdded = prop.k;
        if(data.ix !== undefined){
            Object.defineProperty(prop,'propertyIndex',{
                get: function(){
                    return data.ix;
                }
            })
        }
        if(type === 3){
            searchExpressions(elem,data.pt,prop);
        } else if(type === 4){
            searchExpressions(elem,data.ks,prop);
        }
        if(!isAdded && prop.x){
            arr.push(prop);
        }
        return prop;
    }

    var propertyGetTextProp = PropertyFactory.getTextSelectorProp;
    PropertyFactory.getTextSelectorProp = function(elem, data,arr){
        if(data.t === 1){
            return new TextExpressionSelectorProp(elem, data,arr);
        } else {
            return propertyGetTextProp(elem,data,arr);
        }
    }
}());
var ExpressionManager = (function(){
    var ob = {};
    var Math = BMMath;

    function duplicatePropertyValue(value, mult){
        mult = mult || 1;

        if(typeof value === 'number'  || value instanceof Number){
            return value*mult;
        }else if(value.i){
            return JSON.parse(JSON.stringify(value));
        }else{
            var arr = Array.apply(null,{length:value.length});
            var i, len = value.length;
            for(i=0;i<len;i+=1){
                arr[i]=value[i]*mult;
            }
            return arr;
        }
    }

    function shapesEqual(shape1, shape2) {
        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
            return false;
        }
        var i, len = shape1._length;
        for(i = 0; i < len; i += 1) {
            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1]
                || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1]
                || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
                return false;
            }
        }
        return true;
    }

    function $bm_neg(a){
        var tOfA = typeof a;
        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
            return -a;
        }
        if(a.constructor === Array){
            var i, lenA = a.length;
            var retArr = [];
            for(i=0;i<lenA;i+=1){
                retArr[i] = -a[i];
            }
            return retArr;
        }
    }

    function sum(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        if(tOfA === 'string' || tOfB === 'string'){
            return a + b;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string'  || b instanceof Number)) {
            return a + b;
        }
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            a[0] = a[0] + b;
            return a;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b .constructor === Array){
            b[0] = a + b[0];
            return b;
        }
        if(a.constructor === Array && b.constructor === Array){
            var i = 0, lenA = a.length, lenB = b.length;
            var retArr = [];
            while(i<lenA || i < lenB){
                if(typeof a[i] === 'number' && typeof b[i] === 'number'){
                    retArr[i] = a[i] + b[i];
                }else{
                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
                }
                i += 1;
            }
            return retArr;
        }
        return 0;
    }
    var add = sum;

    function sub(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a - b;
        }
        if( a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            a[0] = a[0] - b;
            return a;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) &&  b.constructor === Array){
            b[0] = a - b[0];
            return b;
        }
        if(a.constructor === Array && b.constructor === Array){
            var i = 0, lenA = a.length, lenB = b.length;
            var retArr = [];
            while(i<lenA || i < lenB){
                if(typeof a[i] === 'number' && typeof b[i] === 'number'){
                    retArr[i] = a[i] - b[i];
                }else{
                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
                }
                i += 1;
            }
            return retArr;
        }
        return 0;
    }

    function mul(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        var arr;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a * b;
        }

        var i, len;
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
            len = a.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a[i] * b;
            }
            return arr;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            len = b.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a * b[i];
            }
            return arr;
        }
        return 0;
    }

    function div(a,b) {
        var tOfA = typeof a;
        var tOfB = typeof b;
        var arr;
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
            return a / b;
        }
        var i, len;
        if(a.constructor === Array && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number  )){
            len = a.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a[i] / b;
            }
            return arr;
        }
        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && b.constructor === Array){
            len = b.length;
            arr = Array.apply(null,{length:len});
            for(i=0;i<len;i+=1){
                arr[i] = a / b[i];
            }
            return arr;
        }
        return 0;
    }

    function clamp(num, min, max) {
        if(min > max){
            var mm = max;
            max = min;
            min = mm;
        }
        return Math.min(Math.max(num, min), max);
    }

    function radiansToDegrees(val) {
        return val/degToRads;
    }
    var radians_to_degrees = radiansToDegrees;

    function degreesToRadians(val) {
        return val*degToRads;
    }
    var degrees_to_radians = radiansToDegrees;

    var helperLengthArray = [0,0,0,0,0,0];

    function length(arr1,arr2){
        if(typeof arr1 === "number"){
            arr2 = arr2 || 0;
            return Math.abs(arr1 - arr2);
        }
        if(!arr2){
            arr2 = helperLengthArray;
        }
        var i,len = Math.min(arr1.length,arr2.length);
        var addedLength = 0;
        for(i=0;i<len;i+=1){
            addedLength += Math.pow(arr2[i]-arr1[i],2);
        }
        return Math.sqrt(addedLength);
    }

    function normalize(vec){
        return div(vec, length(vec));
    }

    function rgbToHsl(val){
        var r = val[0]; var g = val[1]; var b = val[2];
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min){
            h = s = 0; // achromatic
        }else{
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        return [h, s, l,val[3]];
    }
    function hslToRgb(val){
        var h = val[0];
        var s = val[1];
        var l = val[2];

        var r, g, b;

        if(s == 0){
            r = g = b = l; // achromatic
        }else{
            function hue2rgb(p, q, t){
                if(t < 0) t += 1;
                if(t > 1) t -= 1;
                if(t < 1/6) return p + (q - p) * 6 * t;
                if(t < 1/2) return q;
                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                return p;
            }

            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return [r, g , b, val[3]];
    }

    function linear(t, tMin, tMax, value1, value2){
        if(value1 === undefined || value2 === undefined){
            return linear(t,0,1,tMin,tMax);
        }
        if(t <= tMin) {
            return value1;
        }else if(t >= tMax){
            return value2;
        }
        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
        if(!value1.length){
            return value1 + (value2-value1)*perc;
        }
        var i, len = value1.length;
        var arr = Array.apply( null, { length: len } );
        for(i=0;i<len;i+=1){
            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
        }
        return arr;
    }
    function random(min,max){
        if(max === undefined){
            if(min === undefined){
                min = 0;
                max = 1;
            } else {
                max = min;
                min = undefined;
            }
        }
        if(max.length){
            var i, len = max.length;
            if(!min){
                min = Array.apply(null,{length:len});
            }
            var arr = Array.apply(null,{length:len});
            var rnd = BMMath.random();
            for(i=0;i<len;i+=1){
                arr[i] = min[i] + rnd*(max[i]-min[i])
            }
            return arr;
        }
        if(min === undefined){
            min = 0;
        }
        var rndm = BMMath.random();
        return min + rndm*(max-min);
    }

    function initiateExpression(elem,data,property){
        var val = data.x;
        var needsVelocity = /velocity(?![\w\d])/.test(val);
        var _needsRandom = val.indexOf('random') !== -1;
        var elemType = elem.data.ty;
        var transform,content,effect;
        var thisComp = elem.comp;
        var thisProperty = property;
        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
        var thisLayer,thisComp;
        var fn = new Function();
        //var fnStr = 'var fn = function(){'+val+';this.v = $bm_rt;}';
        //eval(fnStr);
        var fn = eval('[function(){' + val+';this.v = $bm_rt;}' + ']')[0];
        var bindedFn = fn.bind(this);
        var numKeys = property.kf ? data.k.length : 0;

        var wiggle = function wiggle(freq,amp){
            var i,j, len = this.pv.length ? this.pv.length : 1;
            var addedAmps = Array.apply(null,{len:len});
            for(j=0;j<len;j+=1){
                addedAmps[j] = 0;
            }
            freq = 5;
            var iterations = Math.floor(time*freq);
            i = 0;
            j = 0;
            while(i<iterations){
                //var rnd = BMMath.random();
                for(j=0;j<len;j+=1){
                    addedAmps[j] += -amp + amp*2*BMMath.random();
                    //addedAmps[j] += -amp + amp*2*rnd;
                }
                i += 1;
            }
            //var rnd2 = BMMath.random();
            var periods = time*freq;
            var perc = periods - Math.floor(periods);
            var arr = Array.apply({length:len});
            for(j=0;j<len;j+=1){
                arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
                //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
            }
            return arr;
        }.bind(this);

        var loopIn = function loopIn(type,duration, durationFlag) {
            if(!this.k){
                return this.pv;
            }
            var currentFrame = time*elem.comp.globalData.frameRate;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if(currentFrame>=firstKeyFrame){
                return this.pv;
            }else{
                var cycleDuration, lastKeyFrame;
                if(!durationFlag){
                    if(!duration || duration > keyframes.length - 1){
                        duration = keyframes.length - 1;
                    }
                    lastKeyFrame = keyframes[duration].t;
                    cycleDuration = lastKeyFrame - firstKeyFrame;
                } else {
                    if(!duration){
                        cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
                    } else {
                        cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
                    }
                    lastKeyFrame = firstKeyFrame + cycleDuration;
                }
                var i, len, ret;
                if(type === 'pingpong') {
                    var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
                    if(iterations % 2 === 0){
                        return this.getValueAtTime(((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    }
                } else if(type === 'offset'){
                    var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                    var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                    var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
                    if(this.pv.length){
                        ret = new Array(initV.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = current[i]-(endV[i]-initV[i])*repeats;
                        }
                        return ret;
                    }
                    return current-(endV-initV)*repeats;
                } else if(type === 'continue'){
                    var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                    var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                    if(this.pv.length){
                        ret = new Array(firstValue.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
                        }
                        return ret;
                    }
                    return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
                }
                return this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
            }
        }.bind(this);

        var loopInDuration = function loopInDuration(type,duration){
            return loopIn(type,duration,true);
        }.bind(this);

        var loopOut = function loopOut(type,duration,durationFlag){
            if(!this.k || !this.keyframes){
                return this.pv;
            }
            var currentFrame = time*elem.comp.globalData.frameRate;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if(currentFrame<=lastKeyFrame){
                return this.pv;
            }else{
                var cycleDuration, firstKeyFrame;
                if(!durationFlag){
                    if(!duration || duration > keyframes.length - 1){
                        duration = keyframes.length - 1;
                    }
                    firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                    cycleDuration = lastKeyFrame - firstKeyFrame;
                } else {
                    if(!duration){
                        cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
                    } else {
                        cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
                    }
                    firstKeyFrame = lastKeyFrame - cycleDuration;
                }
                var i, len, ret;
                if(type === 'pingpong') {
                    var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
                    if(iterations % 2 !== 0){
                        return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    }
                } else if(type === 'offset'){
                    var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                    var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                    var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
                    var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
                    if(this.pv.length){
                        ret = new Array(initV.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = (endV[i]-initV[i])*repeats + current[i];
                        }
                        return ret;
                    }
                    return (endV-initV)*repeats + current;
                } else if(type === 'continue'){
                    var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                    var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                    if(this.pv.length){
                        ret = new Array(lastValue.length);
                        len = ret.length;
                        for(i=0;i<len;i+=1){
                            ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
                        }
                        return ret;
                    }
                    return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
                }
                return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
            }
        }.bind(this);
        var loop_out = loopOut;

        var loopOutDuration = function loopOutDuration(type,duration){
            return loopOut(type,duration,true);
        }.bind(this);

        var valueAtTime = function valueAtTime(t) {
            return this.getValueAtTime(t, 0);
        }.bind(this);

        var velocityAtTime = function velocityAtTime(t) {
            return this.getVelocityAtTime(t);
        }.bind(this);

        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

        function lookAt(elem1,elem2){
            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
            return [yaw,pitch,0];
        }

        function easeOut(t, val1, val2){
            return -(val2-val1) * t*(t-2) + val1;
        }

        function nearestKey(time){
            var i, len = data.k.length,index,keyTime;
            if(!data.k.length || typeof(data.k[0]) === 'number'){
                index = 0;
                keyTime = 0;
            } else {
                index = -1;
                time *= elem.comp.globalData.frameRate;
                for(i=0;i<len-1;i+=1){
                    if(time === data.k[i].t){
                        index = i + 1;
                        keyTime = data.k[i].t;
                        break;
                    }else if(time>data.k[i].t && time<data.k[i+1].t){
                        if(time-data.k[i].t > data.k[i+1].t - time){
                            index = i + 2;
                            keyTime = data.k[i+1].t;
                        } else {
                            index = i + 1;
                            keyTime = data.k[i].t;
                        }
                        break;
                    }
                }
                if(index === -1){
                    index = i + 1;
                    keyTime = data.k[i].t;
                }
            }
            var ob = {};
            ob.index = index;
            ob.time = keyTime/elem.comp.globalData.frameRate;
            return ob;
        }

        function key(ind){
            if(!data.k.length || typeof(data.k[0]) === 'number'){
                return {time:0};
            }
            ind -= 1;
            var ob = {
                time: data.k[ind].t/elem.comp.globalData.frameRate
            };
            var arr;
            if(ind === data.k.length - 1 && !data.k[ind].h){
                arr = data.k[ind-1].e;
            }else{
                arr = data.k[ind].s;
            }
            var i, len = arr.length;
            for(i=0;i<len;i+=1){
                ob[i] = arr[i];
            }
            return ob;
        }

        function framesToTime(frames,fps){
            if(!fps){
                fps = elem.comp.globalData.frameRate;
            }
            return frames/fps;
        }

        function timeToFrames(t,fps){
            if(!t){
                t = time;
            }
            if(!fps){
                fps = elem.comp.globalData.frameRate;
            }
            return t*fps;
        }

        var toworldMatrix = new Matrix();
        function toWorld(arr){
            toworldMatrix.reset();
            elem.finalTransform.mProp.applyToMatrix(toworldMatrix);
            if(elem.hierarchy && elem.hierarchy.length){
                var i, len = elem.hierarchy.length;
                for(i=0;i<len;i+=1){
                    elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toworldMatrix);
                }
                return toworldMatrix.applyToPointArray(arr[0],arr[1],arr[2]||0);
            }
            return toworldMatrix.applyToPointArray(arr[0],arr[1],arr[2]||0);
        }

        var fromworldMatrix = new Matrix();
        function fromWorld(arr){
            fromworldMatrix.reset();
            var pts = [];
            pts.push(arr);
            elem.finalTransform.mProp.applyToMatrix(fromworldMatrix);
            if(elem.hierarchy && elem.hierarchy.length){
                var i, len = elem.hierarchy.length;
                for(i=0;i<len;i+=1){
                    elem.hierarchy[i].finalTransform.mProp.applyToMatrix(fromworldMatrix);
                }
                return fromworldMatrix.inversePoints(pts)[0];
            }
            return fromworldMatrix.inversePoints(pts)[0];
        }

        function seedRandom(seed){
            BMMath.seedrandom(randSeed + seed);
        };

        var time,velocity, value,textIndex,textTotal,selectorValue;
        var index = elem.data.ind;
        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
        var parent;
        var randSeed = Math.floor(Math.random()*1000000);
        function execute(){
            if(_needsRandom){
                seedRandom(randSeed);
            }
            if(this.frameExpressionId === elem.globalData.frameId && this.type !== 'textSelector'){
                return;
            }
            if(this.lock){
                this.v = duplicatePropertyValue(this.pv,this.mult);
                return true;
            }
            if(this.type === 'textSelector'){
                textIndex = this.textIndex;
                textTotal = this.textTotal;
                selectorValue = this.selectorValue;
            }
            if(!thisLayer){
                thisLayer = elem.layerInterface;
                thisComp = elem.comp.compInterface;
            }
            if(!transform){
                transform = elem.layerInterface("ADBE Transform Group");
            }
            if(elemType === 4 && !content){
                content = thisLayer("ADBE Root Vectors Group");
            }
            if(!effect){
                effect = thisLayer(4);
            }
            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            if(hasParent && !parent){
                parent = elem.hierarchy[elem.hierarchy.length - 1].layerInterface;
            }
            this.lock = true;
            if(this.getPreValue){
                this.getPreValue();
            }
            value = this.pv;
            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
            if(needsVelocity){
                velocity = velocityAtTime(time);
            }
            bindedFn();
            this.frameExpressionId = elem.globalData.frameId;
            var i,len;
            if(this.mult){
                if(typeof this.v === 'number' || this.v instanceof Number || typeof this.v === 'string'){
                    this.v *= this.mult;
                }else if(this.v.length === 1){
                    this.v = this.v[0] * this.mult;
                }else{
                    len = this.v.length;
                    if(value === this.v){
                        this.v = len === 2 ? [value[0],value[1]] : [value[0],value[1],value[2]];
                    }
                    for(i = 0; i < len; i += 1){
                        this.v[i] *= this.mult;
                    }
                }
            }

            if(this.v.length === 1){
                this.v = this.v[0];
            }
            if(typeof this.v === 'number' || this.v instanceof Number || typeof this.v === 'string'){
                if(this.lastValue !== this.v){
                    this.lastValue = this.v;
                    this.mdf = true;
                }
            }else if(this.v._length){
                if(!shapesEqual(this.v,this.localShapeCollection.shapes[0])){
                    this.mdf = true;
                    this.localShapeCollection.releaseShapes();
                    this.localShapeCollection.addShape(shape_pool.clone(this.v));
                }
            }else{
                len = this.v.length;
                for(i = 0; i < len; i += 1){
                    if(this.v[i] !== this.lastValue[i]){
                        this.lastValue[i] = this.v[i];
                        this.mdf = true;
                    }
                }
            }
            this.lock = false;
        }
        return execute;
    }

    ob.initiateExpression = initiateExpression;
    return ob;
}());
var ShapeExpressionInterface = (function(){
    var ob = {
        createShapeInterface:createShapeInterface,
        createGroupInterface:createGroupInterface,
        createTrimInterface:createTrimInterface,
        createStrokeInterface:createStrokeInterface,
        createTransformInterface:createTransformInterface,
        createEllipseInterface:createEllipseInterface,
        createStarInterface:createStarInterface,
        createRectInterface:createRectInterface,
        createRoundedInterface:createRoundedInterface,
        createRepatearInterface:createRepatearInterface,
        createPathInterface:createPathInterface,
        createFillInterface:createFillInterface
    };
    function createShapeInterface(shapes,view,propertyGroup){
        return shapeInterfaceFactory(shapes,view,propertyGroup);
    }
    function createGroupInterface(shapes,view,propertyGroup){
        return groupInterfaceFactory(shapes,view,propertyGroup);
    }
    function createFillInterface(shape,view,propertyGroup){
        return fillInterfaceFactory(shape,view,propertyGroup);
    }
    function createStrokeInterface(shape,view,propertyGroup){
        return strokeInterfaceFactory(shape,view,propertyGroup);
    }
    function createTrimInterface(shape,view,propertyGroup){
        return trimInterfaceFactory(shape,view,propertyGroup);
    }
    function createTransformInterface(shape,view,propertyGroup){
        return transformInterfaceFactory(shape,view,propertyGroup);
    }
    function createEllipseInterface(shape,view,propertyGroup){
        return ellipseInterfaceFactory(shape,view,propertyGroup);
    }
    function createStarInterface(shape,view,propertyGroup){
        return starInterfaceFactory(shape,view,propertyGroup);
    }
    function createRectInterface(shape,view,propertyGroup){
        return rectInterfaceFactory(shape,view,propertyGroup);
    }
    function createRoundedInterface(shape,view,propertyGroup){
        return roundedInterfaceFactory(shape,view,propertyGroup);
    }
    function createRepatearInterface(shape,view,propertyGroup){
        return repeaterInterfaceFactory(shape,view,propertyGroup);
    }
    function createPathInterface(shape,view,propertyGroup){
        return pathInterfaceFactory(shape,view,propertyGroup);
    }

    function iterateElements(shapes,view, propertyGroup){
        var arr = [];
        var i, len = shapes ? shapes.length : 0;
        for(i=0;i<len;i+=1){
            if(shapes[i].ty == 'gr'){
                arr.push(ShapeExpressionInterface.createGroupInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'fl'){
                arr.push(ShapeExpressionInterface.createFillInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'st'){
                arr.push(ShapeExpressionInterface.createStrokeInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'tm'){
                arr.push(ShapeExpressionInterface.createTrimInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'tr'){
                //arr.push(ShapeExpressionInterface.createTransformInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'el'){
                arr.push(ShapeExpressionInterface.createEllipseInterface(shapes[i],view[i],propertyGroup));
            }else if(shapes[i].ty == 'sr'){
                arr.push(ShapeExpressionInterface.createStarInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'sh'){
                arr.push(ShapeExpressionInterface.createPathInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rc'){
                arr.push(ShapeExpressionInterface.createRectInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rd'){
                arr.push(ShapeExpressionInterface.createRoundedInterface(shapes[i],view[i],propertyGroup));
            } else if(shapes[i].ty == 'rp'){
                arr.push(ShapeExpressionInterface.createRepatearInterface(shapes[i],view[i],propertyGroup));
            } else{
                //console.log(shapes[i].ty);
            }
        }
        return arr;
    }

    var shapeInterfaceFactory = (function(){
        return function(shapes,view,propertyGroup){
            var interfaces;
            function _interfaceFunction(value){
                if(typeof value === 'number'){
                    return interfaces[value-1];
                } else {
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i]._name === value){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                }
            }
            _interfaceFunction.propertyGroup = propertyGroup;
            interfaces = iterateElements(shapes, view, _interfaceFunction);
            return _interfaceFunction;
        }
    }());

    var contentsInterfaceFactory = (function(){
       return function(shape,view, propertyGroup){
           var interfaces;
           var interfaceFunction = function _interfaceFunction(value){
               var i = 0, len = interfaces.length;
                while(i<len){
                    if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
                       return interfaces[i];
                    }
                    i+=1;
                }
                if(typeof value === 'number'){
                   return interfaces[value-1];
                }
           };
           interfaceFunction.propertyGroup = function(val){
               if(val === 1){
                   return interfaceFunction;
               } else{
                   return propertyGroup(val-1);
               }
           };
           interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
           interfaceFunction.numProperties = interfaces.length;
           interfaceFunction.propertyIndex = shape.cix;

           return interfaceFunction;
       }
    }());

    var groupInterfaceFactory = (function(){
        return function(shape,view, propertyGroup){
            var interfaceFunction = function _interfaceFunction(value){
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    case 'ADBE Vector Transform Group':
                    case 3:
                    default:
                        return interfaceFunction.transform;
                }
                /*if(value === 'ADBE Vector Transform Group'){
                    return interfaceFunction.transform;
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i].ty === 'tr'){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                    return null;
                }
                if(typeof value === 'number'){
                    return interfaces[value-1];
                } else {
                    var i = 0, len = interfaces.length;
                    while(i<len){
                        if(interfaces[i]._name === value){
                            return interfaces[i];
                        }
                        i+=1;
                    }
                }*/
            }
            interfaceFunction.propertyGroup = function(val){
                if(val === 1){
                    return interfaceFunction;
                } else{
                    return propertyGroup(val-1);
                }
            };
            var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
            var transformInterface = ShapeExpressionInterface.createTransformInterface(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            //interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var fillInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){

            function interfaceFunction(val){
                if(val === 'Color' || val === 'color'){
                    return interfaceFunction.color;
                } else if(val === 'Opacity' || val === 'opacity'){
                    return interfaceFunction.opacity;
                }
            }
            Object.defineProperty(interfaceFunction, 'color', {
                get: function(){
                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
                }
            });
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.o, 100);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });

            view.c.setGroupProperty(propertyGroup);
            view.o.setGroupProperty(propertyGroup);
            return interfaceFunction;
        }
    }());

    var strokeInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val === 1){
                    return ob;
                } else{
                    return propertyGroup(val-1);
                }
            };
            function _dashPropertyGroup(val){
                if(val === 1){
                    return dashOb;
                } else{
                    return _propertyGroup(val-1);
                }
            };
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: function(){
                        return ExpressionValue(view.d.dataProps[i].p)
                    }
                });
            }
            var i, len = shape.d ? shape.d.length : 0;
            var dashOb = {}
            for (i = 0; i < len; i += 1) {
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }

            function interfaceFunction(val){
                if(val === 'Color' || val === 'color'){
                    return interfaceFunction.color;
                } else if(val === 'Opacity' || val === 'opacity'){
                    return interfaceFunction.opacity;
                } else if(val === 'Stroke Width' || val === 'stroke width'){
                    return interfaceFunction.strokeWidth;
                }
            }
            Object.defineProperty(interfaceFunction, 'color', {
                get: function(){
                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
                }
            });
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.o, 100);
                }
            });
            Object.defineProperty(interfaceFunction, 'strokeWidth', {
                get: function(){
                    return ExpressionValue(view.w);
                }
            });
            Object.defineProperty(interfaceFunction, 'dash', {
                get: function(){
                    return dashOb;
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });

            view.c.setGroupProperty(_propertyGroup);
            view.o.setGroupProperty(_propertyGroup);
            view.w.setGroupProperty(_propertyGroup);
            return interfaceFunction;
        }
    }());

    var trimInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            interfaceFunction.propertyIndex = shape.ix;

            view.s.setGroupProperty(_propertyGroup);
            view.e.setGroupProperty(_propertyGroup);
            view.o.setGroupProperty(_propertyGroup);

            function interfaceFunction(val){
                if(val === shape.e.ix || val === 'End' || val === 'end'){
                    return interfaceFunction.end;
                }
                if(val === shape.s.ix){
                    return interfaceFunction.start;
                }
                if(val === shape.o.ix){
                    return interfaceFunction.offset;
                }
            }
            interfaceFunction.propertyIndex = shape.ix;
            Object.defineProperty(interfaceFunction, 'start', {
                get: function(){
                    return ExpressionValue(view.s, 1 / view.s.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'end', {
                get: function(){
                    return ExpressionValue(view.e, 1 / view.e.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'offset', {
                get: function(){
                    return ExpressionValue(view.o);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var transformInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            view.transform.mProps.o.setGroupProperty(_propertyGroup);
            view.transform.mProps.p.setGroupProperty(_propertyGroup);
            view.transform.mProps.a.setGroupProperty(_propertyGroup);
            view.transform.mProps.s.setGroupProperty(_propertyGroup);
            view.transform.mProps.r.setGroupProperty(_propertyGroup);
            if(view.transform.mProps.sk){
                view.transform.mProps.sk.setGroupProperty(_propertyGroup);
                view.transform.mProps.sa.setGroupProperty(_propertyGroup);
            }
            view.transform.op.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.a.ix === value){
                    return interfaceFunction.anchorPoint;
                }
                if(shape.o.ix === value){
                    return interfaceFunction.opacity;
                }
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.s.ix === value){
                    return interfaceFunction.scale;
                }
                if(shape.sk && shape.sk.ix === value){
                    return interfaceFunction.skew;
                }
                if(shape.sa && shape.sa.ix === value){
                    return interfaceFunction.skewAxis;
                }
                if(value === 'Opacity') {
                    return interfaceFunction.opacity;
                }
                if(value === 'Position') {
                    return interfaceFunction.position;
                }
                if(value === 'Anchor Point') {
                    return interfaceFunction.anchorPoint;
                }
                if(value === 'Scale') {
                    return interfaceFunction.scale;
                }
                if(value === 'Rotation' || value === 'ADBE Vector Rotation') {
                    return interfaceFunction.rotation;
                }
                if(value === 'Skew') {
                    return interfaceFunction.skew;
                }
                if(value === 'Skew Axis') {
                    return interfaceFunction.skewAxis;
                }

            }
            Object.defineProperty(interfaceFunction, 'opacity', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'anchorPoint', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.a);
                }
            });
            var scaleArray = [];
            Object.defineProperty(interfaceFunction, 'scale', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'rotation', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'skew', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.sk);
                }
            });
            Object.defineProperty(interfaceFunction, 'skewAxis', {
                get: function(){
                    return ExpressionValue(view.transform.mProps.sa);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var ellipseInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(_propertyGroup);
            prop.p.setGroupProperty(_propertyGroup);
            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.s.ix === value){
                    return interfaceFunction.size;
                }
            }
            Object.defineProperty(interfaceFunction, 'size', {
                get: function(){
                    return ExpressionValue(prop.s);
                }
            });
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var starInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(_propertyGroup);
            prop.os.setGroupProperty(_propertyGroup);
            prop.pt.setGroupProperty(_propertyGroup);
            prop.p.setGroupProperty(_propertyGroup);
            prop.r.setGroupProperty(_propertyGroup);
            if(shape.ir){
                prop.ir.setGroupProperty(_propertyGroup);
                prop.is.setGroupProperty(_propertyGroup);
            }

            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.pt.ix === value){
                    return interfaceFunction.points;
                }
                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
                    return interfaceFunction.outerRadius;
                }
                if(shape.os.ix === value){
                    return interfaceFunction.outerRoundness;
                }
                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
                    return interfaceFunction.innerRadius;
                }
                if(shape.is && shape.is.ix === value){
                    return interfaceFunction.innerRoundness;
                }

            }
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'rotation', {
                get: function(){
                    return ExpressionValue(prop.r, 1 / prop.r.mult);
                }
            });
            Object.defineProperty(interfaceFunction, 'points', {
                get: function(){
                    return ExpressionValue(prop.pt);
                }
            });
            Object.defineProperty(interfaceFunction, 'outerRadius', {
                get: function(){
                    return ExpressionValue(prop.or);
                }
            });
            Object.defineProperty(interfaceFunction, 'outerRoundness', {
                get: function(){
                    return ExpressionValue(prop.os);
                }
            });
            Object.defineProperty(interfaceFunction, 'innerRadius', {
                get: function(){
                    if(!prop.ir){
                        return 0;
                    }
                    return ExpressionValue(prop.ir);
                }
            });
            Object.defineProperty(interfaceFunction, 'innerRoundness', {
                get: function(){
                    if(!prop.is){
                        return 0;
                    }
                    return ExpressionValue(prop.is, 1 / prop.is.mult);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var rectInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(_propertyGroup);
            prop.s.setGroupProperty(_propertyGroup);
            prop.r.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.p.ix === value){
                    return interfaceFunction.position;
                }
                if(shape.r.ix === value){
                    return interfaceFunction.rotation;
                }
                if(shape.pt.ix === value){
                    return interfaceFunction.points;
                }
                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
                    return interfaceFunction.outerRadius;
                }
                if(shape.os.ix === value){
                    return interfaceFunction.outerRoundness;
                }
                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
                    return interfaceFunction.innerRadius;
                }
                if(shape.is && shape.is.ix === value){
                    return interfaceFunction.innerRoundness;
                }

            }
            Object.defineProperty(interfaceFunction, 'position', {
                get: function(){
                    return ExpressionValue(prop.p);
                }
            });
            Object.defineProperty(interfaceFunction, 'roundness', {
                get: function(){
                    return ExpressionValue(prop.r);
                }
            });
            Object.defineProperty(interfaceFunction, 'size', {
                get: function(){
                    return ExpressionValue(prop.s);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var roundedInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.r.ix === value || 'Round Corners 1' === value){
                    return interfaceFunction.radius;
                }

            }
            Object.defineProperty(interfaceFunction, 'radius', {
                get: function(){
                    return ExpressionValue(prop.rd);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var repeaterInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(_propertyGroup);
            prop.o.setGroupProperty(_propertyGroup);

            function interfaceFunction(value){
                if(shape.c.ix === value || 'Copies' === value){
                    return interfaceFunction.copies;
                } else if(shape.o.ix === value || 'Offset' === value){
                    return interfaceFunction.offset;
                }

            }
            Object.defineProperty(interfaceFunction, 'copies', {
                get: function(){
                    return ExpressionValue(prop.c);
                }
            });

            Object.defineProperty(interfaceFunction, 'offset', {
                get: function(){
                    return ExpressionValue(prop.o);
                }
            });

            Object.defineProperty(interfaceFunction, '_name', {
                get: function(){
                    return shape.nm;
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
    }());

    var pathInterfaceFactory = (function(){
        return function(shape,view,propertyGroup){
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            function _propertyGroup(val){
                if(val == 1){
                    return interfaceFunction;
                } else {
                    return propertyGroup(--val);
                }
            }
            prop.setGroupProperty(_propertyGroup);

            function interfaceFunction(val){
                if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path'){
                    return interfaceFunction.path;
                }
            }
            Object.defineProperty(interfaceFunction, 'path', {
                get: function(){
                    if(prop.k){
                        prop.getValue();
                    }
                    return prop.v;
                    //return shape_pool.clone(prop.v);
                }
            });
            Object.defineProperty(interfaceFunction, 'shape', {
                get: function(){
                    if(prop.k){
                        prop.getValue();
                    }
                    return prop.v;
                    //return shape_pool.clone(prop.v);
                }
            });
            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
            Object.defineProperty(interfaceFunction, 'ix', { value: shape.ix });
            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
            return interfaceFunction;
        }
    }());


    return ob;
}())

var TextExpressionInterface = (function(){
	return function(elem){
        function _thisLayerFunction(){
        }
        Object.defineProperty(_thisLayerFunction, "sourceText", {
            get: function(){
            	if(!elem.currentTextDocumentData.t) {
            		return ''
            	}
                return elem.currentTextDocumentData.t;
            }
        });
        return _thisLayerFunction;
    }
}())
var LayerExpressionInterface = (function (){
    function toWorld(arr){
        var toWorldMat = new Matrix();
        toWorldMat.reset();
        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
        if(this._elem.hierarchy && this._elem.hierarchy.length){
            var i, len = this._elem.hierarchy.length;
            for(i=0;i<len;i+=1){
                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
            }
            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
        }
        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
    }


    return function(elem){

        var transformInterface = TransformExpressionInterface(elem.transform);

        function _registerMaskInterface(maskManager){
            _thisLayerFunction.mask = maskManager.getMask.bind(maskManager);
        }
        function _registerEffectsInterface(effects){
            _thisLayerFunction.effect = effects;
        }

        function _thisLayerFunction(name){
            switch(name){
                case "ADBE Root Vectors Group":
                case "Contents":
                case 2:
                    return _thisLayerFunction.shapeInterface;
                case 1:
                case "Transform":
                case "transform":
                case "ADBE Transform Group":
                    return transformInterface;
                case 4:
                case "ADBE Effect Parade":
                    return _thisLayerFunction.effect;
            }
        }
        _thisLayerFunction.toWorld = toWorld;
        _thisLayerFunction.toComp = toWorld;
        _thisLayerFunction._elem = elem;
        Object.defineProperty(_thisLayerFunction, 'hasParent', {
            get: function(){
                return !!elem.hierarchy;
            }
        });
        Object.defineProperty(_thisLayerFunction, 'parent', {
            get: function(){
                return elem.hierarchy[0].layerInterface;
            }
        });
        Object.defineProperty(_thisLayerFunction, "rotation", {
            get: function(){
                return transformInterface.rotation;
            }
        });
        Object.defineProperty(_thisLayerFunction, "scale", {
            get: function () {
                return transformInterface.scale;
            }
        });

        Object.defineProperty(_thisLayerFunction, "position", {
            get: function () {
                return transformInterface.position;
            }
        });

        Object.defineProperty(_thisLayerFunction, "anchorPoint", {
            get: function () {
                return transformInterface.anchorPoint;
            }
        });

        Object.defineProperty(_thisLayerFunction, "transform", {
            get: function () {
                return transformInterface;
            }
        });

        Object.defineProperty(_thisLayerFunction, "width", {
            get: function () {
                if(elem.data.ty === 0) {
                    return elem.data.w
                }
                return 100;
            }
        });

        Object.defineProperty(_thisLayerFunction, "height", {
            get: function () {
                if(elem.data.ty === 0) {
                    return elem.data.h
                }
                return 100;
            }
        });

        Object.defineProperty(_thisLayerFunction, "source", {
            get: function () {
                return elem.data.refId;
            }
        });

        Object.defineProperty(_thisLayerFunction, "_name", { value:elem.data.nm });
        Object.defineProperty(_thisLayerFunction, "content", {
            get: function(){
                return _thisLayerFunction.shapeInterface;
            }
        });

        Object.defineProperty(_thisLayerFunction, "active", {
            get: function(){
                return elem.isVisible;
            }
        });

        Object.defineProperty(_thisLayerFunction, "text", {
            get: function(){
                return _thisLayerFunction.textInterface;
            }
        });

        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
        return _thisLayerFunction;
    }
}());

var CompExpressionInterface = (function (){
    return function(comp){
        function _thisLayerFunction(name){
            var i=0, len = comp.layers.length;
            while(i<len){
                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
                    return comp.elements[i].layerInterface;
                }
                i += 1;
            }
            return {active:false}
        }
        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
        _thisLayerFunction.layer = _thisLayerFunction;
        _thisLayerFunction.pixelAspect = 1;
        _thisLayerFunction.height = comp.globalData.compSize.h;
        _thisLayerFunction.width = comp.globalData.compSize.w;
        _thisLayerFunction.pixelAspect = 1;
        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
        return _thisLayerFunction;
    }
}());
var TransformExpressionInterface = (function (){
    return function(transform){
        function _thisFunction(name){
            switch(name){
                case "scale":
                case "Scale":
                case "ADBE Scale":
                    return _thisFunction.scale;
                case "rotation":
                case "Rotation":
                case "ADBE Rotation":
                case "ADBE Rotate Z":
                    return _thisFunction.rotation;
                case "position":
                case "Position":
                case "ADBE Position":
                    return transform.position;
                case "anchorPoint":
                case "AnchorPoint":
                case "Anchor Point":
                case "ADBE AnchorPoint":
                    return _thisFunction.anchorPoint;
                case "opacity":
                case "Opacity":
                    return _thisFunction.opacity;
            }
        }

        Object.defineProperty(_thisFunction, "rotation", {
            get: function(){
                return transform.rotation;
            }
        });
        Object.defineProperty(_thisFunction, "scale", {
            get: function () {
                return transform.scale;
            }
        });

        Object.defineProperty(_thisFunction, "position", {
            get: function () {
                return transform.position;
            }
        });

        Object.defineProperty(_thisFunction, "xPosition", {
            get: function () {
                return transform.xPosition;
            }
        });

        Object.defineProperty(_thisFunction, "yPosition", {
            get: function () {
                return transform.yPosition;
            }
        });

        Object.defineProperty(_thisFunction, "anchorPoint", {
            get: function () {
                return transform.anchorPoint;
            }
        });

        Object.defineProperty(_thisFunction, "opacity", {
            get: function () {
                return transform.opacity;
            }
        });

        Object.defineProperty(_thisFunction, "skew", {
            get: function () {
                return transform.skew;
            }
        });

        Object.defineProperty(_thisFunction, "skewAxis", {
            get: function () {
                return transform.skewAxis;
            }
        });

        return _thisFunction;
    }
}());
var ProjectInterface = (function (){

    function registerComposition(comp){
        this.compositions.push(comp);
    }

    return function(){
        function _thisProjectFunction(name){
            var i = 0, len = this.compositions.length;
            while(i<len){
                if(this.compositions[i].data && this.compositions[i].data.nm === name){
                    this.compositions[i].prepareFrame(this.currentFrame);
                    return this.compositions[i].compInterface;
                }
                i+=1;
            }
        }

        _thisProjectFunction.compositions = [];
        _thisProjectFunction.currentFrame = 0;

        _thisProjectFunction.registerComposition = registerComposition;



        return _thisProjectFunction;
    }
}());
var EffectsExpressionInterface = (function (){
    var ob = {
        createEffectsInterface: createEffectsInterface
    };

    function createEffectsInterface(elem, propertyGroup){
        if(elem.effects){

            var effectElements = [];
            var effectsData = elem.data.ef;
            var i, len = elem.effects.effectElements.length;
            for(i=0;i<len;i+=1){
                effectElements.push(createGroupInterface(effectsData[i],elem.effects.effectElements[i],propertyGroup,elem));
            }

            return function(name){
                var effects = elem.data.ef, i = 0, len = effects.length;
                while(i<len) {
                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
                        return effectElements[i];
                    }
                    i += 1;
                }
            }
        }
    }

    function createGroupInterface(data,elements, propertyGroup, elem){
        var effectElements = [];
        var i, len = data.ef.length;
        for(i=0;i<len;i+=1){
            if(data.ef[i].ty === 5){
                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],propertyGroup, elem));
            } else {
                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem));
            }
        }
        var groupInterface = function(name){
            var effects = data.ef, i = 0, len = effects.length;
            while(i<len) {
                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
                    if(effects[i].ty === 5){
                        return effectElements[i];
                    } else {
                        return effectElements[i]();
                    }
                }
                i += 1;
            }
            return effectElements[0]();
        }
        if(data.mn === 'ADBE Color Control'){
            Object.defineProperty(groupInterface, 'color', {
                get: function(){
                    return effectElements[0]();
                }
            });
        }
        groupInterface.active = data.en !== 0;
        return groupInterface
    }

    function createValueInterface(element, type, elem){
        return function(){
            if(type === 10){
                return elem.comp.compInterface(element.p.v);
            }
            return ExpressionValue(element.p);
        }
    }

    return ob;

}());
var ExpressionValue = (function() {
	return function(elementProp, mult, type) {
        var expressionValue, arrayValue;
		if (elementProp.k) {
            elementProp.getValue();
        }
        var i, len, arrValue;
        if (type) {
        	if(type === 'color') {
        		len = 4;
		        expressionValue = Array.apply(null, {length: len});
		        arrValue = Array.apply(null, {length: len});
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = (mult && i < 3) ? elementProp.v[i] * mult : 1;
		        }
	        	expressionValue.value = arrValue;
        	}
        } else if (typeof elementProp.v === 'number' || elementProp.v instanceof Number){
            expressionValue = mult ? new Number(elementProp.v * mult) : new Number(elementProp.v);
            expressionValue.value = mult ? elementProp.v * mult : elementProp.v;
        } else {
        	len = elementProp.v.length;
	        expressionValue = Array.apply(null, {length: len});
	        arrValue = Array.apply(null, {length: len});
	        for (i = 0; i < len; i += 1) {
	            expressionValue[i] = arrValue[i] = mult ? elementProp.v[i] * mult : elementProp.v[i];
	        }
	        expressionValue.value = arrValue;
        }
        
        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
        expressionValue.key = function(pos) {
            if (!expressionValue.numKeys) {
                return 0;
            } else {
                return elementProp.keyframes[pos-1].t;
            }
        };
        expressionValue.valueAtTime = elementProp.getValueAtTime;
        expressionValue.propertyGroup = elementProp.propertyGroup;
        return expressionValue;
	}
}())
function SliderEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function AngleEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function ColorEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
}
function PointEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
}
function LayerIndexEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function MaskIndexEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function CheckboxEffect(data,elem, dynamicProperties){
    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
}
function NoValueEffect(){
    this.p = {};
}
function EffectsManager(data,element,dynamicProperties){
    var effects = data.ef;
    this.effectElements = [];
    var i,len = effects.length;
    var effectItem;
    for(i=0;i<len;i++) {
        effectItem = new GroupEffect(effects[i],element,dynamicProperties);
        this.effectElements.push(effectItem);
    }
}

function GroupEffect(data,element,dynamicProperties){
    this.dynamicProperties = [];
    this.init(data,element,this.dynamicProperties);
    if(this.dynamicProperties.length){
        dynamicProperties.push(this);
    }
}

GroupEffect.prototype.getValue = function(){
    this.mdf = false;
    var i, len = this.dynamicProperties.length;
    for(i=0;i<len;i+=1){
        this.dynamicProperties[i].getValue();
        this.mdf = this.dynamicProperties[i].mdf ? true : this.mdf;
    }
};

GroupEffect.prototype.init = function(data,element,dynamicProperties){
    this.data = data;
    this.mdf = false;
    this.effectElements = [];
    var i, len = this.data.ef.length;
    var eff, effects = this.data.ef;
    for(i=0;i<len;i+=1){
        switch(effects[i].ty){
            case 0:
                eff = new SliderEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 1:
                eff = new AngleEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 2:
                eff = new ColorEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 3:
                eff = new PointEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 4:
            case 7:
                eff = new CheckboxEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 10:
                eff = new LayerIndexEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 11:
                eff = new MaskIndexEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 5:
                eff = new EffectsManager(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
            case 6:
                eff = new NoValueEffect(effects[i],element,dynamicProperties);
                this.effectElements.push(eff);
                break;
        }
    }
};var bodymovinjs = {}; function play(animation){ animationManager.play(animation); } function pause(animation){ animationManager.pause(animation); } function togglePause(animation){ animationManager.togglePause(animation); } function setSpeed(value,animation){ animationManager.setSpeed(value, animation); } function setDirection(value,animation){ animationManager.setDirection(value, animation); } function stop(animation){ animationManager.stop(animation); } function moveFrame(value){ animationManager.moveFrame(value); } function searchAnimations(){ if(standalone === true){ animationManager.searchAnimations(animationData,standalone, renderer); }else{ animationManager.searchAnimations(); } } function registerAnimation(elem){ return animationManager.registerAnimation(elem); } function resize(){ animationManager.resize(); } function start(){ animationManager.start(); } function goToAndStop(val,isFrame, animation){ animationManager.goToAndStop(val,isFrame, animation); } function setSubframeRendering(flag){ subframeEnabled = flag; } function loadAnimation(params){ if(standalone === true){ params.animationData = JSON.parse(animationData); } return animationManager.loadAnimation(params); } function destroy(animation){ return animationManager.destroy(animation); } function setQuality(value){ if(typeof value === 'string'){ switch(value){ case 'high': defaultCurveSegments = 200; break; case 'medium': defaultCurveSegments = 50; break; case 'low': defaultCurveSegments = 10; break; } }else if(!isNaN(value) && value > 1){ defaultCurveSegments = value; } if(defaultCurveSegments >= 50){ roundValues(false); }else{ roundValues(true); } } function installPlugin(type,plugin){ if(type==='expressions'){ expressionsPlugin = plugin; } } function getFactory(name){ switch(name){ case "propertyFactory": return PropertyFactory;case "shapePropertyFactory": return ShapePropertyFactory; case "matrix": return Matrix; } } bodymovinjs.play = play; bodymovinjs.pause = pause; bodymovinjs.togglePause = togglePause; bodymovinjs.setSpeed = setSpeed; bodymovinjs.setDirection = setDirection; bodymovinjs.stop = stop; bodymovinjs.moveFrame = moveFrame; bodymovinjs.searchAnimations = searchAnimations; bodymovinjs.registerAnimation = registerAnimation; bodymovinjs.loadAnimation = loadAnimation; bodymovinjs.setSubframeRendering = setSubframeRendering; bodymovinjs.resize = resize; bodymovinjs.start = start; bodymovinjs.goToAndStop = goToAndStop; bodymovinjs.destroy = destroy; bodymovinjs.setQuality = setQuality; bodymovinjs.installPlugin = installPlugin; bodymovinjs.__getFactory = getFactory; bodymovinjs.version = '4.6.7'; function checkReady(){ if (document.readyState === "complete") { clearInterval(readyStateCheckInterval); searchAnimations(); } } function getQueryVariable(variable) { var vars = queryString.split('&'); for (var i = 0; i < vars.length; i++) { var pair = vars[i].split('='); if (decodeURIComponent(pair[0]) == variable) { return decodeURIComponent(pair[1]); } } } var standalone = '__[STANDALONE]__'; var animationData = '__[ANIMATIONDATA]__'; var renderer = ''; if(standalone) { var scripts = document.getElementsByTagName('script'); var index = scripts.length - 1; var myScript = scripts[index]; var queryString = myScript.src.replace(/^[^\?]+\??/,''); renderer = getQueryVariable('renderer'); } var readyStateCheckInterval = setInterval(checkReady, 100); return bodymovinjs; }));  

/***/ }),
/* 700 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);


/***/ }),
/* 701 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);


/***/ }),
/* 705 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);


/***/ }),
/* 706 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);


/***/ }),
/* 707 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


/***/ }),
/* 708 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);


/***/ }),
/* 710 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);


/***/ }),
/* 711 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var getDocument = __webpack_require__(749);

/**
 * Module exports.
 */

module.exports = getBoundingClientRect;

/**
 * Returns the "bounding client rectangle" of the given `TextNode`,
 * `HTMLElement`, or `Range`.
 *
 * @param {Node} node
 * @return {TextRectangle}
 * @public
 */

function getBoundingClientRect (node) {
  var rect = null;
  var doc = getDocument(node);

  if (node.nodeType === 3 /* TEXT_NODE */) {
    // see: http://stackoverflow.com/a/6966613/376773
    var range = doc.createRange();
    range.selectNodeContents(node);
    node = range;
  }

  if ('function' === typeof node.getBoundingClientRect) {
    rect = node.getBoundingClientRect();

    if (node.startContainer && rect.left === 0 && rect.top === 0) {
      // Range instances sometimes report all `0`s
      // see: http://stackoverflow.com/a/6847328/376773
      var span = doc.createElement('span');

      // Ensure span has dimensions and position by
      // adding a zero-width space character
      span.appendChild(doc.createTextNode('\u200b'));
      node.insertNode(span);
      rect = span.getBoundingClientRect();

      // Remove temp SPAN and glue any broken text nodes back together
      var spanParent = span.parentNode;
      spanParent.removeChild(span);
      spanParent.normalize();
    }

  }

  return rect;
}


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(146)
var ieee754 = __webpack_require__(758)
var isArray = __webpack_require__(286)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 714 */
/***/ (function(module, exports) {

/**
 * Export `swap`
 */

module.exports = swap;

/**
 * Initialize `swap`
 *
 * @param {Element} el
 * @param {Object} options
 * @param {Function} fn
 * @param {Array} args
 * @return {Mixed}
 */

function swap(el, options, fn, args) {
  // Remember the old values, and insert the new ones
  for (var key in options) {
    old[key] = el.style[key];
    el.style[key] = options[key];
  }

  ret = fn.apply(el, args || []);

  // Revert the old values
  for (key in options) {
    el.style[key] = old[key];
  }

  return ret;
}


/***/ }),
/* 715 */
/***/ (function(module, exports) {

/**
 * Module Dependencies
 */

var prefixes = ['Webkit', 'O', 'Moz', 'ms'];

/**
 * Expose `vendor`
 */

module.exports = vendor;

/**
 * Get the vendor prefix for a given property
 *
 * @param {String} prop
 * @param {Object} style
 * @return {String}
 */

function vendor(prop, style) {
  // shortcut for names that are not vendor prefixed
  if (style[prop]) return prop;

  // check for vendor prefixed names
  var capName = prop[0].toUpperCase() + prop.slice(1);
  var original = prop;
  var i = prefixes.length;

  while (i--) {
    prop = prefixes[i] + capName;
    if (prop in style) return prop;
  }

  return original;
}


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16)
  , isArray  = __webpack_require__(263)
  , SPECIES  = __webpack_require__(17)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(717);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction  = __webpack_require__(59)
  , isObject   = __webpack_require__(16)
  , invoke     = __webpack_require__(119)
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(74)
  , gOPS    = __webpack_require__(121)
  , pIE     = __webpack_require__(102);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(14);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var isObject       = __webpack_require__(16)
  , setPrototypeOf = __webpack_require__(275).set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(99)
  , descriptor     = __webpack_require__(53)
  , setToStringTag = __webpack_require__(76)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(35)(IteratorPrototype, __webpack_require__(17)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(74)
  , toIObject = __webpack_require__(40);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(12)
  , macrotask = __webpack_require__(163).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(71)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(20)
  , anObject = __webpack_require__(14)
  , getKeys  = __webpack_require__(74);

module.exports = __webpack_require__(30) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(40)
  , gOPN      = __webpack_require__(100).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path      = __webpack_require__(729)
  , invoke    = __webpack_require__(119)
  , aFunction = __webpack_require__(59);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(78)
  , defined   = __webpack_require__(51);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(12)
  , core           = __webpack_require__(97)
  , LIBRARY        = __webpack_require__(73)
  , wksExt         = __webpack_require__(279)
  , defineProperty = __webpack_require__(20).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var emptyObject = __webpack_require__(79);
var _invariant = __webpack_require__(5);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context',
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */


  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {

    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @nosideeffects
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'

  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function (Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function (Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function (Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
    },
    contextTypes: function (Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function (Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function (Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function (Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function () {} };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
      }

      return;
    }

    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isInherited = name in Constructor;
      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
        } else if (!args.length) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedMixin = {
    componentDidMount: function () {
      this.__isMounted = true;
    },
    componentWillUnmount: function () {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {

    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function (newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function () {
      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function () {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedMixin);
    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(732);

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(734));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(887);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(737);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(747);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(5);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(22);

var createArrayFromMixed = __webpack_require__(740);
var getMarkupWrap = __webpack_require__(742);
var invariant = __webpack_require__(5);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(22);

var invariant = __webpack_require__(5);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(744);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(746);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 749 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = getDocument;

// defined by w3c
var DOCUMENT_NODE = 9;

/**
 * Returns `true` if `w` is a Document object, or `false` otherwise.
 *
 * @param {?} d - Document object, maybe
 * @return {Boolean}
 * @private
 */

function isDocument (d) {
  return d && d.nodeType === DOCUMENT_NODE;
}

/**
 * Returns the `document` object associated with the given `node`, which may be
 * a DOM element, the Window object, a Selection, a Range. Basically any DOM
 * object that references the Document in some way, this function will find it.
 *
 * @param {Mixed} node - DOM node, selection, or range in which to find the `document` object
 * @return {Document} the `document` object associated with `node`
 * @public
 */

function getDocument(node) {
  if (isDocument(node)) {
    return node;

  } else if (isDocument(node.ownerDocument)) {
    return node.ownerDocument;

  } else if (isDocument(node.document)) {
    return node.document;

  } else if (node.parentNode) {
    return getDocument(node.parentNode);

  // Range support
  } else if (node.commonAncestorContainer) {
    return getDocument(node.commonAncestorContainer);

  } else if (node.startContainer) {
    return getDocument(node.startContainer);

  // Selection support
  } else if (node.anchorNode) {
    return getDocument(node.anchorNode);
  }
}


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

/*! highlight.js v9.10.0 | BSD3 License | git.io/hljslicense */
(function(factory) {

  // Find the global object for export to both the browser and web workers.
  var globalObject = typeof window === 'object' && window ||
                     typeof self === 'object' && self;

  // Setup highlight.js for different environments. First is Node.js or
  // CommonJS.
  if(true) {
    factory(exports);
  } else if(globalObject) {
    // Export hljs globally even when using AMD for cases when this script
    // is loaded with others that may still expect a global hljs.
    globalObject.hljs = factory({});

    // Finally register the global hljs with AMD.
    if(typeof define === 'function' && define.amd) {
      define([], function() {
        return globalObject.hljs;
      });
    }
  }

}(function(hljs) {
  // Convenience variables for build-in objects
  var ArrayProto = [],
      objectKeys = Object.keys;

  // Global internal variables used within the highlight.js library.
  var languages = {},
      aliases   = {};

  // Regular expressions used throughout the highlight.js library.
  var noHighlightRe    = /^(no-?highlight|plain|text)$/i,
      languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i,
      fixMarkupRe      = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;

  var spanEndTag = '</span>';

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  var options = {
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: undefined
  };

  // Object map that is used to escape some common HTML characters.
  var escapeRegexMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;'
  };

  /* Utility functions */

  function escape(value) {
    return value.replace(/[&<>]/gm, function(character) {
      return escapeRegexMap[character];
    });
  }

  function tag(node) {
    return node.nodeName.toLowerCase();
  }

  function testRe(re, lexeme) {
    var match = re && re.exec(lexeme);
    return match && match.index === 0;
  }

  function isNotHighlighted(language) {
    return noHighlightRe.test(language);
  }

  function blockLanguage(block) {
    var i, match, length, _class;
    var classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    match = languagePrefixRe.exec(classes);
    if (match) {
      return getLanguage(match[1]) ? match[1] : 'no-highlight';
    }

    classes = classes.split(/\s+/);

    for (i = 0, length = classes.length; i < length; i++) {
      _class = classes[i]

      if (isNotHighlighted(_class) || getLanguage(_class)) {
        return _class;
      }
    }
  }

  function inherit(parent) {  // inherit(parent, override_obj, override_obj, ...)
    var key;
    var result = {};
    var objects = Array.prototype.slice.call(arguments, 1);

    for (key in parent)
      result[key] = parent[key];
    objects.forEach(function(obj) {
      for (key in obj)
        result[key] = obj[key];
    });
    return result;
  }

  /* Stream merging */

  function nodeStream(node) {
    var result = [];
    (function _nodeStream(node, offset) {
      for (var child = node.firstChild; child; child = child.nextSibling) {
        if (child.nodeType === 3)
          offset += child.nodeValue.length;
        else if (child.nodeType === 1) {
          result.push({
            event: 'start',
            offset: offset,
            node: child
          });
          offset = _nodeStream(child, offset);
          // Prevent void elements from having an end tag that would actually
          // double them in the output. There are more void elements in HTML
          // but we list only those realistically expected in code display.
          if (!tag(child).match(/br|hr|img|input/)) {
            result.push({
              event: 'stop',
              offset: offset,
              node: child
            });
          }
        }
      }
      return offset;
    })(node, 0);
    return result;
  }

  function mergeStreams(original, highlighted, value) {
    var processed = 0;
    var result = '';
    var nodeStack = [];

    function selectStream() {
      if (!original.length || !highlighted.length) {
        return original.length ? original : highlighted;
      }
      if (original[0].offset !== highlighted[0].offset) {
        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
      }

      /*
      To avoid starting the stream just before it should stop the order is
      ensured that original always starts first and closes last:

      if (event1 == 'start' && event2 == 'start')
        return original;
      if (event1 == 'start' && event2 == 'stop')
        return highlighted;
      if (event1 == 'stop' && event2 == 'start')
        return original;
      if (event1 == 'stop' && event2 == 'stop')
        return highlighted;

      ... which is collapsed to:
      */
      return highlighted[0].event === 'start' ? original : highlighted;
    }

    function open(node) {
      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value) + '"';}
      result += '<' + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join('') + '>';
    }

    function close(node) {
      result += '</' + tag(node) + '>';
    }

    function render(event) {
      (event.event === 'start' ? open : close)(event.node);
    }

    while (original.length || highlighted.length) {
      var stream = selectStream();
      result += escape(value.substring(processed, stream[0].offset));
      processed = stream[0].offset;
      if (stream === original) {
        /*
        On any opening or closing tag of the original markup we first close
        the entire highlighted node stack, then render the original tag along
        with all the following original tags at the same offset and then
        reopen all the tags on the highlighted stack.
        */
        nodeStack.reverse().forEach(close);
        do {
          render(stream.splice(0, 1)[0]);
          stream = selectStream();
        } while (stream === original && stream.length && stream[0].offset === processed);
        nodeStack.reverse().forEach(open);
      } else {
        if (stream[0].event === 'start') {
          nodeStack.push(stream[0].node);
        } else {
          nodeStack.pop();
        }
        render(stream.splice(0, 1)[0]);
      }
    }
    return result + escape(value.substr(processed));
  }

  /* Initialization */

  function expand_mode(mode) {
    if (mode.variants && !mode.cached_variants) {
      mode.cached_variants = mode.variants.map(function(variant) {
        return inherit(mode, {variants: null}, variant);
      });
    }
    return mode.cached_variants || (mode.endsWithParent && [inherit(mode)]) || [mode];
  }

  function compileLanguage(language) {

    function reStr(re) {
        return (re && re.source) || re;
    }

    function langRe(value, global) {
      return new RegExp(
        reStr(value),
        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
      );
    }

    function compileMode(mode, parent) {
      if (mode.compiled)
        return;
      mode.compiled = true;

      mode.keywords = mode.keywords || mode.beginKeywords;
      if (mode.keywords) {
        var compiled_keywords = {};

        var flatten = function(className, str) {
          if (language.case_insensitive) {
            str = str.toLowerCase();
          }
          str.split(' ').forEach(function(kw) {
            var pair = kw.split('|');
            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
          });
        };

        if (typeof mode.keywords === 'string') { // string
          flatten('keyword', mode.keywords);
        } else {
          objectKeys(mode.keywords).forEach(function (className) {
            flatten(className, mode.keywords[className]);
          });
        }
        mode.keywords = compiled_keywords;
      }
      mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);

      if (parent) {
        if (mode.beginKeywords) {
          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
        }
        if (!mode.begin)
          mode.begin = /\B|\b/;
        mode.beginRe = langRe(mode.begin);
        if (!mode.end && !mode.endsWithParent)
          mode.end = /\B|\b/;
        if (mode.end)
          mode.endRe = langRe(mode.end);
        mode.terminator_end = reStr(mode.end) || '';
        if (mode.endsWithParent && parent.terminator_end)
          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
      }
      if (mode.illegal)
        mode.illegalRe = langRe(mode.illegal);
      if (mode.relevance == null)
        mode.relevance = 1;
      if (!mode.contains) {
        mode.contains = [];
      }
      mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
        return expand_mode(c === 'self' ? mode : c)
      }));
      mode.contains.forEach(function(c) {compileMode(c, mode);});

      if (mode.starts) {
        compileMode(mode.starts, parent);
      }

      var terminators =
        mode.contains.map(function(c) {
          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
        })
        .concat([mode.terminator_end, mode.illegal])
        .map(reStr)
        .filter(Boolean);
      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
    }

    compileMode(language);
  }

  /*
  Core highlighting function. Accepts a language name, or an alias, and a
  string with the code to highlight. Returns an object with the following
  properties:

  - relevance (int)
  - value (an HTML string with highlighting markup)

  */
  function highlight(name, value, ignore_illegals, continuation) {

    function subMode(lexeme, mode) {
      var i, length;

      for (i = 0, length = mode.contains.length; i < length; i++) {
        if (testRe(mode.contains[i].beginRe, lexeme)) {
          return mode.contains[i];
        }
      }
    }

    function endOfMode(mode, lexeme) {
      if (testRe(mode.endRe, lexeme)) {
        while (mode.endsParent && mode.parent) {
          mode = mode.parent;
        }
        return mode;
      }
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, lexeme);
      }
    }

    function isIllegal(lexeme, mode) {
      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
    }

    function keywordMatch(mode, match) {
      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
    }

    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
      var classPrefix = noPrefix ? '' : options.classPrefix,
          openSpan    = '<span class="' + classPrefix,
          closeSpan   = leaveOpen ? '' : spanEndTag

      openSpan += classname + '">';

      return openSpan + insideSpan + closeSpan;
    }

    function processKeywords() {
      var keyword_match, last_index, match, result;

      if (!top.keywords)
        return escape(mode_buffer);

      result = '';
      last_index = 0;
      top.lexemesRe.lastIndex = 0;
      match = top.lexemesRe.exec(mode_buffer);

      while (match) {
        result += escape(mode_buffer.substring(last_index, match.index));
        keyword_match = keywordMatch(top, match);
        if (keyword_match) {
          relevance += keyword_match[1];
          result += buildSpan(keyword_match[0], escape(match[0]));
        } else {
          result += escape(match[0]);
        }
        last_index = top.lexemesRe.lastIndex;
        match = top.lexemesRe.exec(mode_buffer);
      }
      return result + escape(mode_buffer.substr(last_index));
    }

    function processSubLanguage() {
      var explicit = typeof top.subLanguage === 'string';
      if (explicit && !languages[top.subLanguage]) {
        return escape(mode_buffer);
      }

      var result = explicit ?
                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Usecase in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      if (explicit) {
        continuations[top.subLanguage] = result.top;
      }
      return buildSpan(result.language, result.value, false, true);
    }

    function processBuffer() {
      result += (top.subLanguage != null ? processSubLanguage() : processKeywords());
      mode_buffer = '';
    }

    function startNewMode(mode) {
      result += mode.className? buildSpan(mode.className, '', true): '';
      top = Object.create(mode, {parent: {value: top}});
    }

    function processLexeme(buffer, lexeme) {

      mode_buffer += buffer;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      var new_mode = subMode(lexeme, top);
      if (new_mode) {
        if (new_mode.skip) {
          mode_buffer += lexeme;
        } else {
          if (new_mode.excludeBegin) {
            mode_buffer += lexeme;
          }
          processBuffer();
          if (!new_mode.returnBegin && !new_mode.excludeBegin) {
            mode_buffer = lexeme;
          }
        }
        startNewMode(new_mode, lexeme);
        return new_mode.returnBegin ? 0 : lexeme.length;
      }

      var end_mode = endOfMode(top, lexeme);
      if (end_mode) {
        var origin = top;
        if (origin.skip) {
          mode_buffer += lexeme;
        } else {
          if (!(origin.returnEnd || origin.excludeEnd)) {
            mode_buffer += lexeme;
          }
          processBuffer();
          if (origin.excludeEnd) {
            mode_buffer = lexeme;
          }
        }
        do {
          if (top.className) {
            result += spanEndTag;
          }
          if (!top.skip) {
            relevance += top.relevance;
          }
          top = top.parent;
        } while (top !== end_mode.parent);
        if (end_mode.starts) {
          startNewMode(end_mode.starts, '');
        }
        return origin.returnEnd ? 0 : lexeme.length;
      }

      if (isIllegal(lexeme, top))
        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');

      /*
      Parser should not reach this point as all types of lexemes should be caught
      earlier, but if it does due to some bug make sure it advances at least one
      character forward to prevent infinite looping.
      */
      mode_buffer += lexeme;
      return lexeme.length || 1;
    }

    var language = getLanguage(name);
    if (!language) {
      throw new Error('Unknown language: "' + name + '"');
    }

    compileLanguage(language);
    var top = continuation || language;
    var continuations = {}; // keep continuations for sub-languages
    var result = '', current;
    for(current = top; current !== language; current = current.parent) {
      if (current.className) {
        result = buildSpan(current.className, '', true) + result;
      }
    }
    var mode_buffer = '';
    var relevance = 0;
    try {
      var match, count, index = 0;
      while (true) {
        top.terminators.lastIndex = index;
        match = top.terminators.exec(value);
        if (!match)
          break;
        count = processLexeme(value.substring(index, match.index), match[0]);
        index = match.index + count;
      }
      processLexeme(value.substr(index));
      for(current = top; current.parent; current = current.parent) { // close dangling modes
        if (current.className) {
          result += spanEndTag;
        }
      }
      return {
        relevance: relevance,
        value: result,
        language: name,
        top: top
      };
    } catch (e) {
      if (e.message && e.message.indexOf('Illegal') !== -1) {
        return {
          relevance: 0,
          value: escape(value)
        };
      } else {
        throw e;
      }
    }
  }

  /*
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

  */
  function highlightAuto(text, languageSubset) {
    languageSubset = languageSubset || options.languages || objectKeys(languages);
    var result = {
      relevance: 0,
      value: escape(text)
    };
    var second_best = result;
    languageSubset.filter(getLanguage).forEach(function(name) {
      var current = highlight(name, text, false);
      current.language = name;
      if (current.relevance > second_best.relevance) {
        second_best = current;
      }
      if (current.relevance > result.relevance) {
        second_best = result;
        result = current;
      }
    });
    if (second_best.language) {
      result.second_best = second_best;
    }
    return result;
  }

  /*
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

  */
  function fixMarkup(value) {
    return !(options.tabReplace || options.useBR)
      ? value
      : value.replace(fixMarkupRe, function(match, p1) {
          if (options.useBR && match === '\n') {
            return '<br>';
          } else if (options.tabReplace) {
            return p1.replace(/\t/g, options.tabReplace);
          }
          return '';
      });
  }

  function buildClassName(prevClassName, currentLang, resultLang) {
    var language = currentLang ? aliases[currentLang] : resultLang,
        result   = [prevClassName.trim()];

    if (!prevClassName.match(/\bhljs\b/)) {
      result.push('hljs');
    }

    if (prevClassName.indexOf(language) === -1) {
      result.push(language);
    }

    return result.join(' ').trim();
  }

  /*
  Applies highlighting to a DOM node containing code. Accepts a DOM node and
  two optional parameters for fixMarkup.
  */
  function highlightBlock(block) {
    var node, originalStream, result, resultNode, text;
    var language = blockLanguage(block);

    if (isNotHighlighted(language))
        return;

    if (options.useBR) {
      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
    } else {
      node = block;
    }
    text = node.textContent;
    result = language ? highlight(language, text, true) : highlightAuto(text);

    originalStream = nodeStream(node);
    if (originalStream.length) {
      resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      resultNode.innerHTML = result.value;
      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
    }
    result.value = fixMarkup(result.value);

    block.innerHTML = result.value;
    block.className = buildClassName(block.className, language, result.language);
    block.result = {
      language: result.language,
      re: result.relevance
    };
    if (result.second_best) {
      block.second_best = {
        language: result.second_best.language,
        re: result.second_best.relevance
      };
    }
  }

  /*
  Updates highlight.js global options with values passed in the form of an object.
  */
  function configure(user_options) {
    options = inherit(options, user_options);
  }

  /*
  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
  */
  function initHighlighting() {
    if (initHighlighting.called)
      return;
    initHighlighting.called = true;

    var blocks = document.querySelectorAll('pre code');
    ArrayProto.forEach.call(blocks, highlightBlock);
  }

  /*
  Attaches highlighting to the page load event.
  */
  function initHighlightingOnLoad() {
    addEventListener('DOMContentLoaded', initHighlighting, false);
    addEventListener('load', initHighlighting, false);
  }

  function registerLanguage(name, language) {
    var lang = languages[name] = language(hljs);
    if (lang.aliases) {
      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
    }
  }

  function listLanguages() {
    return objectKeys(languages);
  }

  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /* Interface definition */

  hljs.highlight = highlight;
  hljs.highlightAuto = highlightAuto;
  hljs.fixMarkup = fixMarkup;
  hljs.highlightBlock = highlightBlock;
  hljs.configure = configure;
  hljs.initHighlighting = initHighlighting;
  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
  hljs.registerLanguage = registerLanguage;
  hljs.listLanguages = listLanguages;
  hljs.getLanguage = getLanguage;
  hljs.inherit = inherit;

  // Common regexps
  hljs.IDENT_RE = '[a-zA-Z]\\w*';
  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

  // Common modes
  hljs.BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]', relevance: 0
  };
  hljs.APOS_STRING_MODE = {
    className: 'string',
    begin: '\'', end: '\'',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"', end: '"',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|like)\b/
  };
  hljs.COMMENT = function (begin, end, inherits) {
    var mode = hljs.inherit(
      {
        className: 'comment',
        begin: begin, end: end,
        contains: []
      },
      inherits || {}
    );
    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
    mode.contains.push({
      className: 'doctag',
      begin: '(?:TODO|FIXME|NOTE|BUG|XXX):',
      relevance: 0
    });
    return mode;
  };
  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
  hljs.NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE,
    relevance: 0
  };
  hljs.C_NUMBER_MODE = {
    className: 'number',
    begin: hljs.C_NUMBER_RE,
    relevance: 0
  };
  hljs.BINARY_NUMBER_MODE = {
    className: 'number',
    begin: hljs.BINARY_NUMBER_RE,
    relevance: 0
  };
  hljs.CSS_NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE + '(' +
      '%|em|ex|ch|rem'  +
      '|vw|vh|vmin|vmax' +
      '|cm|mm|in|pt|pc|px' +
      '|deg|grad|rad|turn' +
      '|s|ms' +
      '|Hz|kHz' +
      '|dpi|dpcm|dppx' +
      ')?',
    relevance: 0
  };
  hljs.REGEXP_MODE = {
    className: 'regexp',
    begin: /\//, end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      {
        begin: /\[/, end: /\]/,
        relevance: 0,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  hljs.TITLE_MODE = {
    className: 'title',
    begin: hljs.IDENT_RE,
    relevance: 0
  };
  hljs.UNDERSCORE_TITLE_MODE = {
    className: 'title',
    begin: hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  hljs.METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };

hljs.registerLanguage('1c', function(hljs){
  var IDENT_RE_RU = '[a-zA-Zа-яА-Я][a-zA-Z0-9_а-яА-Я]*';
  var OneS_KEYWORDS = 'возврат дата для если и или иначе иначеесли исключение конецесли ' +
    'конецпопытки конецпроцедуры конецфункции конеццикла константа не перейти перем ' +
    'перечисление по пока попытка прервать продолжить процедура строка тогда фс функция цикл ' +
    'число экспорт';
  var OneS_BUILT_IN = 'ansitooem oemtoansi ввестивидсубконто ввестидату ввестизначение ' +
    'ввестиперечисление ввестипериод ввестиплансчетов ввестистроку ввестичисло вопрос ' +
    'восстановитьзначение врег выбранныйплансчетов вызватьисключение датагод датамесяц ' +
    'датачисло добавитьмесяц завершитьработусистемы заголовоксистемы записьжурналарегистрации ' +
    'запуститьприложение зафиксироватьтранзакцию значениевстроку значениевстрокувнутр ' +
    'значениевфайл значениеизстроки значениеизстрокивнутр значениеизфайла имякомпьютера ' +
    'имяпользователя каталогвременныхфайлов каталогиб каталогпользователя каталогпрограммы ' +
    'кодсимв командасистемы конгода конецпериодаби конецрассчитанногопериодаби ' +
    'конецстандартногоинтервала конквартала конмесяца коннедели лев лог лог10 макс ' +
    'максимальноеколичествосубконто мин монопольныйрежим названиеинтерфейса названиенабораправ ' +
    'назначитьвид назначитьсчет найти найтипомеченныенаудаление найтиссылки началопериодаби ' +
    'началостандартногоинтервала начатьтранзакцию начгода начквартала начмесяца начнедели ' +
    'номерднягода номерднянедели номернеделигода нрег обработкаожидания окр описаниеошибки ' +
    'основнойжурналрасчетов основнойплансчетов основнойязык открытьформу открытьформумодально ' +
    'отменитьтранзакцию очиститьокносообщений периодстр полноеимяпользователя получитьвремята ' +
    'получитьдатута получитьдокументта получитьзначенияотбора получитьпозициюта ' +
    'получитьпустоезначение получитьта прав праводоступа предупреждение префиксавтонумерации ' +
    'пустаястрока пустоезначение рабочаядаттьпустоезначение рабочаядата разделительстраниц ' +
    'разделительстрок разм разобратьпозициюдокумента рассчитатьрегистрына ' +
    'рассчитатьрегистрыпо сигнал симв символтабуляции создатьобъект сокрл сокрлп сокрп ' +
    'сообщить состояние сохранитьзначение сред статусвозврата стрдлина стрзаменить ' +
    'стрколичествострок стрполучитьстроку  стрчисловхождений сформироватьпозициюдокумента ' +
    'счетпокоду текущаядата текущеевремя типзначения типзначениястр удалитьобъекты ' +
    'установитьтана установитьтапо фиксшаблон формат цел шаблон';
  var DQUOTE =  {begin: '""'};
  var STR_START = {
      className: 'string',
      begin: '"', end: '"|$',
      contains: [DQUOTE]
    };
  var STR_CONT = {
    className: 'string',
    begin: '\\|', end: '"|$',
    contains: [DQUOTE]
  };

  return {
    case_insensitive: true,
    lexemes: IDENT_RE_RU,
    keywords: {keyword: OneS_KEYWORDS, built_in: OneS_BUILT_IN},
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.NUMBER_MODE,
      STR_START, STR_CONT,
      {
        className: 'function',
        begin: '(процедура|функция)', end: '$',
        lexemes: IDENT_RE_RU,
        keywords: 'процедура функция',
        contains: [
          {
            begin: 'экспорт', endsWithParent: true,
            lexemes: IDENT_RE_RU,
            keywords: 'экспорт',
            contains: [hljs.C_LINE_COMMENT_MODE]
          },
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            lexemes: IDENT_RE_RU,
            keywords: 'знач',
            contains: [STR_START, STR_CONT]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE_RU})
        ]
      },
      {className: 'meta', begin: '#', end: '$'},
      {className: 'number', begin: '\'\\d{2}\\.\\d{2}\\.(\\d{2}|\\d{4})\''} // date
    ]
  };
});

hljs.registerLanguage('abnf', function(hljs) {
    var regexes = {
        ruleDeclaration: "^[a-zA-Z][a-zA-Z0-9-]*",
        unexpectedChars: "[!@#$^&',?+~`|:]"
    };

    var keywords = [
        "ALPHA",
        "BIT",
        "CHAR",
        "CR",
        "CRLF",
        "CTL",
        "DIGIT",
        "DQUOTE",
        "HEXDIG",
        "HTAB",
        "LF",
        "LWSP",
        "OCTET",
        "SP",
        "VCHAR",
        "WSP"
    ];

    var commentMode = hljs.COMMENT(";", "$");

    var terminalBinaryMode = {
        className: "symbol",
        begin: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+){0,1}/
    };

    var terminalDecimalMode = {
        className: "symbol",
        begin: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+){0,1}/
    };

    var terminalHexadecimalMode = {
        className: "symbol",
        begin: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+){0,1}/,
    };

    var caseSensitivityIndicatorMode = {
        className: "symbol",
        begin: /%[si]/
    };

    var ruleDeclarationMode = {
        begin: regexes.ruleDeclaration + '\\s*=',
        returnBegin: true,
        end: /=/,
        relevance: 0,
        contains: [{className: "attribute", begin: regexes.ruleDeclaration}]
    };

    return {
      illegal: regexes.unexpectedChars,
      keywords: keywords.join(" "),
      contains: [
          ruleDeclarationMode,
          commentMode,
          terminalBinaryMode,
          terminalDecimalMode,
          terminalHexadecimalMode,
          caseSensitivityIndicatorMode,
          hljs.QUOTE_STRING_MODE,
          hljs.NUMBER_MODE
      ]
    };
});

hljs.registerLanguage('accesslog', function(hljs) {
  return {
    contains: [
      // IP
      {
        className: 'number',
        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
      },
      // Other numbers
      {
        className: 'number',
        begin: '\\b\\d+\\b',
        relevance: 0
      },
      // Requests
      {
        className: 'string',
        begin: '"(GET|POST|HEAD|PUT|DELETE|CONNECT|OPTIONS|PATCH|TRACE)', end: '"',
        keywords: 'GET POST HEAD PUT DELETE CONNECT OPTIONS PATCH TRACE',
        illegal: '\\n',
        relevance: 10
      },
      // Dates
      {
        className: 'string',
        begin: /\[/, end: /\]/,
        illegal: '\\n'
      },
      // Strings
      {
        className: 'string',
        begin: '"', end: '"',
        illegal: '\\n'
      }
    ]
  };
});

hljs.registerLanguage('actionscript', function(hljs) {
  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';

  var AS3_REST_ARG_MODE = {
    className: 'rest_arg',
    begin: '[.]{3}', end: IDENT_RE,
    relevance: 10
  };

  return {
    aliases: ['as'],
    keywords: {
      keyword: 'as break case catch class const continue default delete do dynamic each ' +
        'else extends final finally for function get if implements import in include ' +
        'instanceof interface internal is namespace native new override package private ' +
        'protected public return set static super switch this throw try typeof use var void ' +
        'while with',
      literal: 'true false null undefined'
    },
    contains: [
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'class',
        beginKeywords: 'package', end: '{',
        contains: [hljs.TITLE_MODE]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.TITLE_MODE
        ]
      },
      {
        className: 'meta',
        beginKeywords: 'import include', end: ';',
        keywords: {'meta-keyword': 'import include'}
      },
      {
        className: 'function',
        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
        illegal: '\\S',
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              AS3_REST_ARG_MODE
            ]
          },
          {
            begin: ':\\s*' + IDENT_FUNC_RETURN_TYPE_RE
          }
        ]
      },
      hljs.METHOD_GUARD
    ],
    illegal: /#/
  };
});

hljs.registerLanguage('ada', // We try to support full Ada2012
//
// We highlight all appearances of types, keywords, literals (string, char, number, bool)
// and titles (user defined function/procedure/package)
// CSS classes are set accordingly
//
// Languages causing problems for language detection:
// xml (broken by Foo : Bar type), elm (broken by Foo : Bar type), vbscript-html (broken by body keyword)
// sql (ada default.txt has a lot of sql keywords)

function(hljs) {
    // Regular expression for Ada numeric literals.
    // stolen form the VHDL highlighter

    // Decimal literal:
    var INTEGER_RE = '\\d(_|\\d)*';
    var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
    var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';

    // Based literal:
    var BASED_INTEGER_RE = '\\w+';
    var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';

    var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';

    // Identifier regex
    var ID_REGEX = '[A-Za-z](_?[A-Za-z0-9.])*';

    // bad chars, only allowed in literals
    var BAD_CHARS = '[]{}%#\'\"'

    // Ada doesn't have block comments, only line comments
    var COMMENTS = hljs.COMMENT('--', '$');

    // variable declarations of the form
    // Foo : Bar := Baz;
    // where only Bar will be highlighted
    var VAR_DECLS = {
        // TODO: These spaces are not required by the Ada syntax
        // however, I have yet to see handwritten Ada code where
        // someone does not put spaces around :
        begin: '\\s+:\\s+', end: '\\s*(:=|;|\\)|=>|$)',
        // endsWithParent: true,
        // returnBegin: true,
        illegal: BAD_CHARS,
        contains: [
            {
                // workaround to avoid highlighting
                // named loops and declare blocks
                beginKeywords: 'loop for declare others',
                endsParent: true,
            },
            {
                // properly highlight all modifiers
                className: 'keyword',
                beginKeywords: 'not null constant access function procedure in out aliased exception'
            },
            {
                className: 'type',
                begin: ID_REGEX,
                endsParent: true,
                relevance: 0,
            }
        ]
    };

    return {
        case_insensitive: true,
        keywords: {
            keyword:
                'abort else new return abs elsif not reverse abstract end ' +
                'accept entry select access exception of separate aliased exit or some ' +
                'all others subtype and for out synchronized array function overriding ' +
                'at tagged generic package task begin goto pragma terminate ' +
                'body private then if procedure type case in protected constant interface ' +
                'is raise use declare range delay limited record when delta loop rem while ' +
                'digits renames with do mod requeue xor',
            literal:
                'True False',
        },
        contains: [
            COMMENTS,
            // strings "foobar"
            {
                className: 'string',
                begin: /"/, end: /"/,
                contains: [{begin: /""/, relevance: 0}]
            },
            // characters ''
            {
                // character literals always contain one char
                className: 'string',
                begin: /'.'/
            },
            {
                // number literals
                className: 'number',
                begin: NUMBER_RE,
                relevance: 0
            },
            {
                // Attributes
                className: 'symbol',
                begin: "'" + ID_REGEX,
            },
            {
                // package definition, maybe inside generic
                className: 'title',
                begin: '(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?', end: '(is|$)',
                keywords: 'package body',
                excludeBegin: true,
                excludeEnd: true,
                illegal: BAD_CHARS
            },
            {
                // function/procedure declaration/definition
                // maybe inside generic
                begin: '(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+', end: '(\\bis|\\bwith|\\brenames|\\)\\s*;)',
                keywords: 'overriding function procedure with is renames return',
                // we need to re-match the 'function' keyword, so that
                // the title mode below matches only exactly once
                returnBegin: true,
                contains:
                [
                    COMMENTS,
                    {
                        // name of the function/procedure
                        className: 'title',
                        begin: '(\\bwith\\s+)?\\b(function|procedure)\\s+',
                        end: '(\\(|\\s+|$)',
                        excludeBegin: true,
                        excludeEnd: true,
                        illegal: BAD_CHARS
                    },
                    // 'self'
                    // // parameter types
                    VAR_DECLS,
                    {
                        // return type
                        className: 'type',
                        begin: '\\breturn\\s+', end: '(\\s+|;|$)',
                        keywords: 'return',
                        excludeBegin: true,
                        excludeEnd: true,
                        // we are done with functions
                        endsParent: true,
                        illegal: BAD_CHARS

                    },
                ]
            },
            {
                // new type declarations
                // maybe inside generic
                className: 'type',
                begin: '\\b(sub)?type\\s+', end: '\\s+',
                keywords: 'type',
                excludeBegin: true,
                illegal: BAD_CHARS
            },

            // see comment above the definition
            VAR_DECLS,

            // no markup
            // relevance boosters for small snippets
            // {begin: '\\s*=>\\s*'},
            // {begin: '\\s*:=\\s*'},
            // {begin: '\\s+:=\\s+'},
        ]
    };
});

hljs.registerLanguage('apache', function(hljs) {
  var NUMBER = {className: 'number', begin: '[\\$%]\\d+'};
  return {
    aliases: ['apacheconf'],
    case_insensitive: true,
    contains: [
      hljs.HASH_COMMENT_MODE,
      {className: 'section', begin: '</?', end: '>'},
      {
        className: 'attribute',
        begin: /\w+/,
        relevance: 0,
        // keywords aren’t needed for highlighting per se, they only boost relevance
        // for a very generally defined mode (starts with a word, ends with line-end
        keywords: {
          nomarkup:
            'order deny allow setenv rewriterule rewriteengine rewritecond documentroot ' +
            'sethandler errordocument loadmodule options header listen serverroot ' +
            'servername'
        },
        starts: {
          end: /$/,
          relevance: 0,
          keywords: {
            literal: 'on off all'
          },
          contains: [
            {
              className: 'meta',
              begin: '\\s\\[', end: '\\]$'
            },
            {
              className: 'variable',
              begin: '[\\$%]\\{', end: '\\}',
              contains: ['self', NUMBER]
            },
            NUMBER,
            hljs.QUOTE_STRING_MODE
          ]
        }
      }
    ],
    illegal: /\S/
  };
});

hljs.registerLanguage('applescript', function(hljs) {
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: ''});
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)',
    contains: ['self', hljs.C_NUMBER_MODE, STRING]
  };
  var COMMENT_MODE_1 = hljs.COMMENT('--', '$');
  var COMMENT_MODE_2 = hljs.COMMENT(
    '\\(\\*',
    '\\*\\)',
    {
      contains: ['self', COMMENT_MODE_1] //allow nesting
    }
  );
  var COMMENTS = [
    COMMENT_MODE_1,
    COMMENT_MODE_2,
    hljs.HASH_COMMENT_MODE
  ];

  return {
    aliases: ['osascript'],
    keywords: {
      keyword:
        'about above after against and around as at back before beginning ' +
        'behind below beneath beside between but by considering ' +
        'contain contains continue copy div does eighth else end equal ' +
        'equals error every exit fifth first for fourth from front ' +
        'get given global if ignoring in into is it its last local me ' +
        'middle mod my ninth not of on onto or over prop property put ref ' +
        'reference repeat returning script second set seventh since ' +
        'sixth some tell tenth that the|0 then third through thru ' +
        'timeout times to transaction try until where while whose with ' +
        'without',
      literal:
        'AppleScript false linefeed return pi quote result space tab true',
      built_in:
        'alias application boolean class constant date file integer list ' +
        'number real record string text ' +
        'activate beep count delay launch log offset read round ' +
        'run say summarize write ' +
        'character characters contents day frontmost id item length ' +
        'month name paragraph paragraphs rest reverse running time version ' +
        'weekday word words year'
    },
    contains: [
      STRING,
      hljs.C_NUMBER_MODE,
      {
        className: 'built_in',
        begin:
          '\\b(clipboard info|the clipboard|info for|list (disks|folder)|' +
          'mount volume|path to|(close|open for) access|(get|set) eof|' +
          'current date|do shell script|get volume settings|random number|' +
          'set volume|system attribute|system info|time to GMT|' +
          '(load|run|store) script|scripting components|' +
          'ASCII (character|number)|localized string|' +
          'choose (application|color|file|file name|' +
          'folder|from list|remote application|URL)|' +
          'display (alert|dialog))\\b|^\\s*return\\b'
      },
      {
        className: 'literal',
        begin:
          '\\b(text item delimiters|current application|missing value)\\b'
      },
      {
        className: 'keyword',
        begin:
          '\\b(apart from|aside from|instead of|out of|greater than|' +
          "isn't|(doesn't|does not) (equal|come before|come after|contain)|" +
          '(greater|less) than( or equal)?|(starts?|ends|begins?) with|' +
          'contained by|comes (before|after)|a (ref|reference)|POSIX file|' +
          'POSIX path|(date|time) string|quoted form)\\b'
      },
      {
        beginKeywords: 'on',
        illegal: '[${=;\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      }
    ].concat(COMMENTS),
    illegal: '//|->|=>|\\[\\['
  };
});

hljs.registerLanguage('cpp', function(hljs) {
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '(u8?|U)?L?"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '(u8?|U)?R"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '\'\\\\?.', end: '\'',
        illegal: '.'
      }
    ]
  };

  var NUMBERS = {
    className: 'number',
    variants: [
      { begin: '\\b(0b[01\']+)' },
      { begin: '\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)' },
      { begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)' }
    ],
    relevance: 0
  };

  var PREPROCESSOR =       {
    className: 'meta',
    begin: /#\s*[a-z]+\b/, end: /$/,
    keywords: {
      'meta-keyword':
        'if else elif endif define undef warning error line ' +
        'pragma ifdef ifndef include'
    },
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      hljs.inherit(STRINGS, {className: 'meta-string'}),
      {
        className: 'meta-string',
        begin: /<[^\n>]*>/, end: /$/,
        illegal: '\\n',
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var FUNCTION_TITLE = hljs.IDENT_RE + '\\s*\\(';

  var CPP_KEYWORDS = {
    keyword: 'int float while private char catch import module export virtual operator sizeof ' +
      'dynamic_cast|10 typedef const_cast|10 const struct for static_cast|10 union namespace ' +
      'unsigned long volatile static protected bool template mutable if public friend ' +
      'do goto auto void enum else break extern using class asm case typeid ' +
      'short reinterpret_cast|10 default double register explicit signed typename try this ' +
      'switch continue inline delete alignof constexpr decltype ' +
      'noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary ' +
      'atomic_bool atomic_char atomic_schar ' +
      'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' +
      'atomic_ullong new throw return',
    built_in: 'std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' +
      'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' +
      'unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos ' +
      'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' +
      'fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' +
      'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' +
      'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' +
      'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' +
      'vfprintf vprintf vsprintf endl initializer_list unique_ptr',
    literal: 'true false nullptr NULL'
  };

  var EXPRESSION_CONTAINS = [
    CPP_PRIMITIVE_TYPES,
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    NUMBERS,
    STRINGS
  ];

  return {
    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp'],
    keywords: CPP_KEYWORDS,
    illegal: '</',
    contains: EXPRESSION_CONTAINS.concat([
      PREPROCESSOR,
      {
        begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<', end: '>',
        keywords: CPP_KEYWORDS,
        contains: ['self', CPP_PRIMITIVE_TYPES]
      },
      {
        begin: hljs.IDENT_RE + '::',
        keywords: CPP_KEYWORDS
      },
      {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
          {begin: /=/, end: /;/},
          {begin: /\(/, end: /\)/},
          {beginKeywords: 'new throw return else', end: /;/}
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
          {
            begin: /\(/, end: /\)/,
            keywords: CPP_KEYWORDS,
            contains: EXPRESSION_CONTAINS.concat(['self']),
            relevance: 0
          }
        ]),
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + hljs.IDENT_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
        returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&]/,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.TITLE_MODE],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: CPP_KEYWORDS,
            relevance: 0,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              STRINGS,
              NUMBERS,
              CPP_PRIMITIVE_TYPES
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          PREPROCESSOR
        ]
      }
    ]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
});

hljs.registerLanguage('arduino', function(hljs) {
  var CPP = hljs.getLanguage('cpp').exports;
	return {
    keywords: {
      keyword:
        'boolean byte word string String array ' + CPP.keywords.keyword,
      built_in:
        'setup loop while catch for if do goto try switch case else ' +
        'default break continue return ' +
        'KeyboardController MouseController SoftwareSerial ' +
        'EthernetServer EthernetClient LiquidCrystal ' +
        'RobotControl GSMVoiceCall EthernetUDP EsploraTFT ' +
        'HttpClient RobotMotor WiFiClient GSMScanner ' +
        'FileSystem Scheduler GSMServer YunClient YunServer ' +
        'IPAddress GSMClient GSMModem Keyboard Ethernet ' +
        'Console GSMBand Esplora Stepper Process ' +
        'WiFiUDP GSM_SMS Mailbox USBHost Firmata PImage ' +
        'Client Server GSMPIN FileIO Bridge Serial ' +
        'EEPROM Stream Mouse Audio Servo File Task ' +
        'GPRS WiFi Wire TFT GSM SPI SD ' +
        'runShellCommandAsynchronously analogWriteResolution ' +
        'retrieveCallingNumber printFirmwareVersion ' +
        'analogReadResolution sendDigitalPortPair ' +
        'noListenOnLocalhost readJoystickButton setFirmwareVersion ' +
        'readJoystickSwitch scrollDisplayRight getVoiceCallStatus ' +
        'scrollDisplayLeft writeMicroseconds delayMicroseconds ' +
        'beginTransmission getSignalStrength runAsynchronously ' +
        'getAsynchronously listenOnLocalhost getCurrentCarrier ' +
        'readAccelerometer messageAvailable sendDigitalPorts ' +
        'lineFollowConfig countryNameWrite runShellCommand ' +
        'readStringUntil rewindDirectory readTemperature ' +
        'setClockDivider readLightSensor endTransmission ' +
        'analogReference detachInterrupt countryNameRead ' +
        'attachInterrupt encryptionType readBytesUntil ' +
        'robotNameWrite readMicrophone robotNameRead cityNameWrite ' +
        'userNameWrite readJoystickY readJoystickX mouseReleased ' +
        'openNextFile scanNetworks noInterrupts digitalWrite ' +
        'beginSpeaker mousePressed isActionDone mouseDragged ' +
        'displayLogos noAutoscroll addParameter remoteNumber ' +
        'getModifiers keyboardRead userNameRead waitContinue ' +
        'processInput parseCommand printVersion readNetworks ' +
        'writeMessage blinkVersion cityNameRead readMessage ' +
        'setDataMode parsePacket isListening setBitOrder ' +
        'beginPacket isDirectory motorsWrite drawCompass ' +
        'digitalRead clearScreen serialEvent rightToLeft ' +
        'setTextSize leftToRight requestFrom keyReleased ' +
        'compassRead analogWrite interrupts WiFiServer ' +
        'disconnect playMelody parseFloat autoscroll ' +
        'getPINUsed setPINUsed setTimeout sendAnalog ' +
        'readSlider analogRead beginWrite createChar ' +
        'motorsStop keyPressed tempoWrite readButton ' +
        'subnetMask debugPrint macAddress writeGreen ' +
        'randomSeed attachGPRS readString sendString ' +
        'remotePort releaseAll mouseMoved background ' +
        'getXChange getYChange answerCall getResult ' +
        'voiceCall endPacket constrain getSocket writeJSON ' +
        'getButton available connected findUntil readBytes ' +
        'exitValue readGreen writeBlue startLoop IPAddress ' +
        'isPressed sendSysex pauseMode gatewayIP setCursor ' +
        'getOemKey tuneWrite noDisplay loadImage switchPIN ' +
        'onRequest onReceive changePIN playFile noBuffer ' +
        'parseInt overflow checkPIN knobRead beginTFT ' +
        'bitClear updateIR bitWrite position writeRGB ' +
        'highByte writeRed setSpeed readBlue noStroke ' +
        'remoteIP transfer shutdown hangCall beginSMS ' +
        'endWrite attached maintain noCursor checkReg ' +
        'checkPUK shiftOut isValid shiftIn pulseIn ' +
        'connect println localIP pinMode getIMEI ' +
        'display noBlink process getBand running beginSD ' +
        'drawBMP lowByte setBand release bitRead prepare ' +
        'pointTo readRed setMode noFill remove listen ' +
        'stroke detach attach noTone exists buffer ' +
        'height bitSet circle config cursor random ' +
        'IRread setDNS endSMS getKey micros ' +
        'millis begin print write ready flush width ' +
        'isPIN blink clear press mkdir rmdir close ' +
        'point yield image BSSID click delay ' +
        'read text move peek beep rect line open ' +
        'seek fill size turn stop home find ' +
        'step tone sqrt RSSI SSID ' +
        'end bit tan cos sin pow map abs max ' +
        'min get run put',
      literal:
        'DIGITAL_MESSAGE FIRMATA_STRING ANALOG_MESSAGE ' +
        'REPORT_DIGITAL REPORT_ANALOG INPUT_PULLUP ' +
        'SET_PIN_MODE INTERNAL2V56 SYSTEM_RESET LED_BUILTIN ' +
        'INTERNAL1V1 SYSEX_START INTERNAL EXTERNAL ' +
        'DEFAULT OUTPUT INPUT HIGH LOW'
    },
    contains: [
      CPP.preprocessor,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('armasm', function(hljs) {
    //local labels: %?[FB]?[AT]?\d{1,2}\w+
  return {
    case_insensitive: true,
    aliases: ['arm'],
    lexemes: '\\.?' + hljs.IDENT_RE,
    keywords: {
      meta:
        //GNU preprocs
        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg '+
        //ARM directives
        'ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ',
      built_in:
        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 '+ //standard registers
        'pc lr sp ip sl sb fp '+ //typical regs plus backward compatibility
        'a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 '+ //more regs and fp
        'p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 '+ //coprocessor regs
        'c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 '+ //more coproc
        'q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 '+ //advanced SIMD NEON regs

        //program status registers
        'cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf '+
        'spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf '+

        //NEON and VFP registers
        's0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 '+
        's16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 '+
        'd0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 '+
        'd16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 ' +

        '{PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @'
    },
    contains: [
      {
        className: 'keyword',
        begin: '\\b('+     //mnemonics
            'adc|'+
            '(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|'+
            'and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|'+
            'bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|'+
            'setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|'+
            'ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|'+
            'mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|'+
            'mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|'+
            'mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|'+
            'rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|'+
            'stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|'+
            '[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|'+
            'wfe|wfi|yield'+
        ')'+
        '(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?'+ //condition codes
        '[sptrx]?' ,                                             //legal postfixes
        end: '\\s'
      },
      hljs.COMMENT('[;@]', '$', {relevance: 0}),
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'',
        end: '[^\\\\]\'',
        relevance: 0
      },
      {
        className: 'title',
        begin: '\\|', end: '\\|',
        illegal: '\\n',
        relevance: 0
      },
      {
        className: 'number',
        variants: [
            {begin: '[#$=]?0x[0-9a-f]+'}, //hex
            {begin: '[#$=]?0b[01]+'},     //bin
            {begin: '[#$=]\\d+'},        //literal
            {begin: '\\b\\d+'}           //bare number
        ],
        relevance: 0
      },
      {
        className: 'symbol',
        variants: [
            {begin: '^[a-z_\\.\\$][a-z0-9_\\.\\$]+'}, //ARM syntax
            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU ARM syntax
            {begin: '[=#]\\w+' }  //label reference
        ],
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('xml', function(hljs) {
  var XML_IDENT_RE = '[A-Za-z0-9\\._:-]+';
  var TAG_INTERNALS = {
    endsWithParent: true,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: 'attr',
        begin: XML_IDENT_RE,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: 'string',
            endsParent: true,
            variants: [
              {begin: /"/, end: /"/},
              {begin: /'/, end: /'/},
              {begin: /[^\s"'=<>`]+/}
            ]
          }
        ]
      }
    ]
  };
  return {
    aliases: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist'],
    case_insensitive: true,
    contains: [
      {
        className: 'meta',
        begin: '<!DOCTYPE', end: '>',
        relevance: 10,
        contains: [{begin: '\\[', end: '\\]'}]
      },
      hljs.COMMENT(
        '<!--',
        '-->',
        {
          relevance: 10
        }
      ),
      {
        begin: '<\\!\\[CDATA\\[', end: '\\]\\]>',
        relevance: 10
      },
      {
        begin: /<\?(php)?/, end: /\?>/,
        subLanguage: 'php',
        contains: [{begin: '/\\*', end: '\\*/', skip: true}]
      },
      {
        className: 'tag',
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending braket. The '$' is needed for the lexeme to be recognized
        by hljs.subMode() that tests lexemes outside the stream.
        */
        begin: '<style(?=\\s|>|$)', end: '>',
        keywords: {name: 'style'},
        contains: [TAG_INTERNALS],
        starts: {
          end: '</style>', returnEnd: true,
          subLanguage: ['css', 'xml']
        }
      },
      {
        className: 'tag',
        // See the comment in the <style tag about the lookahead pattern
        begin: '<script(?=\\s|>|$)', end: '>',
        keywords: {name: 'script'},
        contains: [TAG_INTERNALS],
        starts: {
          end: '\<\/script\>', returnEnd: true,
          subLanguage: ['actionscript', 'javascript', 'handlebars', 'xml']
        }
      },
      {
        className: 'meta',
        variants: [
          {begin: /<\?xml/, end: /\?>/, relevance: 10},
          {begin: /<\?\w+/, end: /\?>/}
        ]
      },
      {
        className: 'tag',
        begin: '</?', end: '/?>',
        contains: [
          {
            className: 'name', begin: /[^\/><\s]+/, relevance: 0
          },
          TAG_INTERNALS
        ]
      }
    ]
  };
});

hljs.registerLanguage('asciidoc', function(hljs) {
  return {
    aliases: ['adoc'],
    contains: [
      // block comment
      hljs.COMMENT(
        '^/{4,}\\n',
        '\\n/{4,}$',
        // can also be done as...
        //'^/{4,}$',
        //'^/{4,}$',
        {
          relevance: 10
        }
      ),
      // line comment
      hljs.COMMENT(
        '^//',
        '$',
        {
          relevance: 0
        }
      ),
      // title
      {
        className: 'title',
        begin: '^\\.\\w.*$'
      },
      // example, admonition & sidebar blocks
      {
        begin: '^[=\\*]{4,}\\n',
        end: '\\n^[=\\*]{4,}$',
        relevance: 10
      },
      // headings
      {
        className: 'section',
        relevance: 10,
        variants: [
          {begin: '^(={1,5}) .+?( \\1)?$'},
          {begin: '^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$'},
        ]
      },
      // document attributes
      {
        className: 'meta',
        begin: '^:.+?:',
        end: '\\s',
        excludeEnd: true,
        relevance: 10
      },
      // block attributes
      {
        className: 'meta',
        begin: '^\\[.+?\\]$',
        relevance: 0
      },
      // quoteblocks
      {
        className: 'quote',
        begin: '^_{4,}\\n',
        end: '\\n_{4,}$',
        relevance: 10
      },
      // listing and literal blocks
      {
        className: 'code',
        begin: '^[\\-\\.]{4,}\\n',
        end: '\\n[\\-\\.]{4,}$',
        relevance: 10
      },
      // passthrough blocks
      {
        begin: '^\\+{4,}\\n',
        end: '\\n\\+{4,}$',
        contains: [
          {
            begin: '<', end: '>',
            subLanguage: 'xml',
            relevance: 0
          }
        ],
        relevance: 10
      },
      // lists (can only capture indicators)
      {
        className: 'bullet',
        begin: '^(\\*+|\\-+|\\.+|[^\\n]+?::)\\s+'
      },
      // admonition
      {
        className: 'symbol',
        begin: '^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+',
        relevance: 10
      },
      // inline strong
      {
        className: 'strong',
        // must not follow a word character or be followed by an asterisk or space
        begin: '\\B\\*(?![\\*\\s])',
        end: '(\\n{2}|\\*)',
        // allow escaped asterisk followed by word char
        contains: [
          {
            begin: '\\\\*\\w',
            relevance: 0
          }
        ]
      },
      // inline emphasis
      {
        className: 'emphasis',
        // must not follow a word character or be followed by a single quote or space
        begin: '\\B\'(?![\'\\s])',
        end: '(\\n{2}|\')',
        // allow escaped single quote followed by word char
        contains: [
          {
            begin: '\\\\\'\\w',
            relevance: 0
          }
        ],
        relevance: 0
      },
      // inline emphasis (alt)
      {
        className: 'emphasis',
        // must not follow a word character or be followed by an underline or space
        begin: '_(?![_\\s])',
        end: '(\\n{2}|_)',
        relevance: 0
      },
      // inline smart quotes
      {
        className: 'string',
        variants: [
          {begin: "``.+?''"},
          {begin: "`.+?'"}
        ]
      },
      // inline code snippets (TODO should get same treatment as strong and emphasis)
      {
        className: 'code',
        begin: '(`.+?`|\\+.+?\\+)',
        relevance: 0
      },
      // indented literal block
      {
        className: 'code',
        begin: '^[ \\t]',
        end: '$',
        relevance: 0
      },
      // horizontal rules
      {
        begin: '^\'{3,}[ \\t]*$',
        relevance: 10
      },
      // images and links
      {
        begin: '(link:)?(http|https|ftp|file|irc|image:?):\\S+\\[.*?\\]',
        returnBegin: true,
        contains: [
          {
            begin: '(link|image:?):',
            relevance: 0
          },
          {
            className: 'link',
            begin: '\\w',
            end: '[^\\[]+',
            relevance: 0
          },
          {
            className: 'string',
            begin: '\\[',
            end: '\\]',
            excludeBegin: true,
            excludeEnd: true,
            relevance: 0
          }
        ],
        relevance: 10
      }
    ]
  };
});

hljs.registerLanguage('aspectj', function (hljs) {
  var KEYWORDS =
    'false synchronized int abstract float private char boolean static null if const ' +
    'for true while long throw strictfp finally protected import native final return void ' +
    'enum else extends implements break transient new catch instanceof byte super volatile case ' +
    'assert short package default double public try this switch continue throws privileged ' +
    'aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization ' +
    'staticinitialization withincode target within execution getWithinTypeName handler ' +
    'thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents '+
    'warning error soft precedence thisAspectInstance';
  var SHORTKEYS = 'get set args call';
  return {
    keywords : KEYWORDS,
    illegal : /<\/|#/,
    contains : [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/, relevance: 0
            },
            {
              className : 'doctag',
              begin : '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className : 'class',
        beginKeywords : 'aspect',
        end : /[{;=]/,
        excludeEnd : true,
        illegal : /[:;"\[\]]/,
        contains : [
          {
            beginKeywords : 'extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton'
          },
          hljs.UNDERSCORE_TITLE_MODE,
          {
            begin : /\([^\)]*/,
            end : /[)]+/,
            keywords : KEYWORDS + ' ' + SHORTKEYS,
            excludeEnd : false
          }
        ]
      },
      {
        className : 'class',
        beginKeywords : 'class interface',
        end : /[{;=]/,
        excludeEnd : true,
        relevance: 0,
        keywords : 'class interface',
        illegal : /[:"\[\]]/,
        contains : [
          {beginKeywords : 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // AspectJ Constructs
        beginKeywords : 'pointcut after before around throwing returning',
        end : /[)]/,
        excludeEnd : false,
        illegal : /["\[\]]/,
        contains : [
          {
            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            returnBegin : true,
            contains : [hljs.UNDERSCORE_TITLE_MODE]
          }
        ]
      },
      {
        begin : /[:]/,
        returnBegin : true,
        end : /[{;]/,
        relevance: 0,
        excludeEnd : false,
        keywords : KEYWORDS,
        illegal : /["\[\]]/,
        contains : [
          {
            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            keywords : KEYWORDS + ' ' + SHORTKEYS
          },
          hljs.QUOTE_STRING_MODE
        ]
      },
      {
        // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
        beginKeywords : 'new throw',
        relevance : 0
      },
      {
        // the function class is a bit different for AspectJ compared to the Java language
        className : 'function',
        begin : /\w+ +\w+(\.)?\w+\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
        returnBegin : true,
        end : /[{;=]/,
        keywords : KEYWORDS,
        excludeEnd : true,
        contains : [
          {
            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            returnBegin : true,
            relevance: 0,
            contains : [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className : 'params',
            begin : /\(/, end : /\)/,
            relevance: 0,
            keywords : KEYWORDS,
            contains : [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      hljs.C_NUMBER_MODE,
      {
        // annotation is also used in this language
        className : 'meta',
        begin : '@[A-Za-z]+'
      }
    ]
  };
});

hljs.registerLanguage('autohotkey', function(hljs) {
  var BACKTICK_ESCAPE = {
    begin: /`[\s\S]/
  };

  return {
    case_insensitive: true,
    keywords: {
      keyword: 'Break Continue Else Gosub If Loop Return While',
      literal: 'A|0 true false NOT AND OR',
      built_in: 'ComSpec Clipboard ClipboardAll ErrorLevel',
    },
    contains: [
      {
        className: 'built_in',
        begin: 'A_[a-zA-Z0-9]+'
      },
      BACKTICK_ESCAPE,
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [BACKTICK_ESCAPE]}),
      hljs.COMMENT(';', '$', {relevance: 0}),
      {
        className: 'number',
        begin: hljs.NUMBER_RE,
        relevance: 0
      },
      {
        className: 'variable', // FIXME
        begin: '%', end: '%',
        illegal: '\\n',
        contains: [BACKTICK_ESCAPE]
      },
      {
        className: 'symbol',
        contains: [BACKTICK_ESCAPE],
        variants: [
          {begin: '^[^\\n";]+::(?!=)'},
          {begin: '^[^\\n";]+:(?!=)', relevance: 0} // zero relevance as it catches a lot of things
                                                    // followed by a single ':' in many languages
        ]
      },
      {
        // consecutive commas, not for highlighting but just for relevance
        begin: ',\\s*,'
      }
    ]
  }
});

hljs.registerLanguage('autoit', function(hljs) {
    var KEYWORDS = 'ByRef Case Const ContinueCase ContinueLoop ' +
        'Default Dim Do Else ElseIf EndFunc EndIf EndSelect ' +
        'EndSwitch EndWith Enum Exit ExitLoop For Func ' +
        'Global If In Local Next ReDim Return Select Static ' +
        'Step Switch Then To Until Volatile WEnd While With',

        LITERAL = 'True False And Null Not Or',

        BUILT_IN =
          'Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait',

        COMMENT = {
            variants: [
              hljs.COMMENT(';', '$', {relevance: 0}),
              hljs.COMMENT('#cs', '#ce'),
              hljs.COMMENT('#comments-start', '#comments-end')
            ]
        },

        VARIABLE = {
            begin: '\\$[A-z0-9_]+'
        },

        STRING = {
            className: 'string',
            variants: [{
                begin: /"/,
                end: /"/,
                contains: [{
                    begin: /""/,
                    relevance: 0
                }]
            }, {
                begin: /'/,
                end: /'/,
                contains: [{
                    begin: /''/,
                    relevance: 0
                }]
            }]
        },

        NUMBER = {
            variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
        },

        PREPROCESSOR = {
            className: 'meta',
            begin: '#',
            end: '$',
            keywords: {'meta-keyword': 'comments include include-once NoTrayIcon OnAutoItStartRegister pragma compile RequireAdmin'},
            contains: [{
                    begin: /\\\n/,
                    relevance: 0
                }, {
                    beginKeywords: 'include',
                    keywords: {'meta-keyword': 'include'},
                    end: '$',
                    contains: [
                        STRING, {
                            className: 'meta-string',
                            variants: [{
                                begin: '<',
                                end: '>'
                            }, {
                                begin: /"/,
                                end: /"/,
                                contains: [{
                                    begin: /""/,
                                    relevance: 0
                                }]
                            }, {
                                begin: /'/,
                                end: /'/,
                                contains: [{
                                    begin: /''/,
                                    relevance: 0
                                }]
                            }]
                        }
                    ]
                },
                STRING,
                COMMENT
            ]
        },

        CONSTANT = {
            className: 'symbol',
            // begin: '@',
            // end: '$',
            // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
            // relevance: 5
            begin: '@[A-z0-9_]+'
        },

        FUNCTION = {
            className: 'function',
            beginKeywords: 'Func',
            end: '$',
            illegal: '\\$|\\[|%',
            contains: [
                hljs.UNDERSCORE_TITLE_MODE, {
                    className: 'params',
                    begin: '\\(',
                    end: '\\)',
                    contains: [
                        VARIABLE,
                        STRING,
                        NUMBER
                    ]
                }
            ]
        };

    return {
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: KEYWORDS,
            built_in: BUILT_IN,
            literal: LITERAL
        },
        contains: [
            COMMENT,
            VARIABLE,
            STRING,
            NUMBER,
            PREPROCESSOR,
            CONSTANT,
            FUNCTION
        ]
    }
});

hljs.registerLanguage('avrasm', function(hljs) {
  return {
    case_insensitive: true,
    lexemes: '\\.?' + hljs.IDENT_RE,
    keywords: {
      keyword:
        /* mnemonic */
        'adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs ' +
        'brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr ' +
        'clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor ' +
        'fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul ' +
        'muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs ' +
        'sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub ' +
        'subi swap tst wdr',
      built_in:
        /* general purpose registers */
        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 ' +
        'r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ' +
        /* IO Registers (ATMega128) */
        'ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h ' +
        'tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ' +
        'ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ' +
        'ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk ' +
        'tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ' +
        'ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr ' +
        'porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ' +
        'ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf',
      meta:
        '.byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list ' +
        '.listmac .macro .nolist .org .set'
    },
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT(
        ';',
        '$',
        {
          relevance: 0
        }
      ),
      hljs.C_NUMBER_MODE, // 0x..., decimal, float
      hljs.BINARY_NUMBER_MODE, // 0b...
      {
        className: 'number',
        begin: '\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)' // $..., 0o...
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'', end: '[^\\\\]\'',
        illegal: '[^\\\\][^\']'
      },
      {className: 'symbol',  begin: '^[A-Za-z0-9_.$]+:'},
      {className: 'meta', begin: '#', end: '$'},
      {  // подстановка в «.macro»
        className: 'subst',
        begin: '@[0-9]+'
      }
    ]
  };
});

hljs.registerLanguage('awk', function(hljs) {
  var VARIABLE = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d#@][\w\d_]*/},
      {begin: /\$\{(.*?)}/}
    ]
  };
  var KEYWORDS = 'BEGIN END if else while do for in break continue delete next nextfile function func exit|10';
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /(u|b)?r?'''/, end: /'''/,
        relevance: 10
      },
      {
        begin: /(u|b)?r?"""/, end: /"""/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)'/, end: /'/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)"/, end: /"/,
        relevance: 10
      },
      {
        begin: /(b|br)'/, end: /'/
      },
      {
        begin: /(b|br)"/, end: /"/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
  return {
	 keywords: {
	   keyword: KEYWORDS
    },
    contains: [
      VARIABLE,
      STRING,
      hljs.REGEXP_MODE,
      hljs.HASH_COMMENT_MODE,
      hljs.NUMBER_MODE
    ]
  }
});

hljs.registerLanguage('axapta', function(hljs) {
  return {
    keywords: 'false int abstract private char boolean static null if for true ' +
      'while long throw finally protected final return void enum else ' +
      'break new catch byte super case short default double public try this switch ' +
      'continue reverse firstfast firstonly forupdate nofetch sum avg minof maxof count ' +
      'order group by asc desc index hint like dispaly edit client server ttsbegin ' +
      'ttscommit str real date container anytype common div mod',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$'
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: ':',
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      }
    ]
  };
});

hljs.registerLanguage('bash', function(hljs) {
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d#@][\w\d_]*/},
      {begin: /\$\{(.*?)}/}
    ]
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$\(/, end: /\)/,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  var APOS_STRING = {
    className: 'string',
    begin: /'/, end: /'/
  };

  return {
    aliases: ['sh', 'zsh'],
    lexemes: /-?[a-z\._]+/,
    keywords: {
      keyword:
        'if then else elif fi for while in do done case esac function',
      literal:
        'true false',
      built_in:
        // Shell built-ins
        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' +
        'trap umask unset ' +
        // Bash built-ins
        'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' +
        'read readarray source type typeset ulimit unalias ' +
        // Shell modifiers
        'set shopt ' +
        // Zsh built-ins
        'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' +
        'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' +
        'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' +
        'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' +
        'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' +
        'zpty zregexparse zsocket zstyle ztcp',
      _:
        '-ne -eq -lt -gt -f -d -e -s -l -a' // relevance booster
    },
    contains: [
      {
        className: 'meta',
        begin: /^#![^\n]+sh\s*$/,
        relevance: 10
      },
      {
        className: 'function',
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [hljs.inherit(hljs.TITLE_MODE, {begin: /\w[\w\d_]*/})],
        relevance: 0
      },
      hljs.HASH_COMMENT_MODE,
      QUOTE_STRING,
      APOS_STRING,
      VAR
    ]
  };
});

hljs.registerLanguage('basic', function(hljs) {
  return {
    case_insensitive: true,
    illegal: '^\.',
    // Support explicitely typed variables that end with $%! or #.
    lexemes: '[a-zA-Z][a-zA-Z0-9_\$\%\!\#]*',
    keywords: {
        keyword:
          'ABS ASC AND ATN AUTO|0 BEEP BLOAD|10 BSAVE|10 CALL CALLS CDBL CHAIN CHDIR CHR$|10 CINT CIRCLE ' +
          'CLEAR CLOSE CLS COLOR COM COMMON CONT COS CSNG CSRLIN CVD CVI CVS DATA DATE$ ' +
          'DEFDBL DEFINT DEFSNG DEFSTR DEF|0 SEG USR DELETE DIM DRAW EDIT END ENVIRON ENVIRON$ ' +
          'EOF EQV ERASE ERDEV ERDEV$ ERL ERR ERROR EXP FIELD FILES FIX FOR|0 FRE GET GOSUB|10 GOTO ' +
          'HEX$ IF|0 THEN ELSE|0 INKEY$ INP INPUT INPUT# INPUT$ INSTR IMP INT IOCTL IOCTL$ KEY ON ' +
          'OFF LIST KILL LEFT$ LEN LET LINE LLIST LOAD LOC LOCATE LOF LOG LPRINT USING LSET ' +
          'MERGE MID$ MKDIR MKD$ MKI$ MKS$ MOD NAME NEW NEXT NOISE NOT OCT$ ON OR PEN PLAY STRIG OPEN OPTION ' +
          'BASE OUT PAINT PALETTE PCOPY PEEK PMAP POINT POKE POS PRINT PRINT] PSET PRESET ' +
          'PUT RANDOMIZE READ REM RENUM RESET|0 RESTORE RESUME RETURN|0 RIGHT$ RMDIR RND RSET ' +
          'RUN SAVE SCREEN SGN SHELL SIN SOUND SPACE$ SPC SQR STEP STICK STOP STR$ STRING$ SWAP ' +
          'SYSTEM TAB TAN TIME$ TIMER TROFF TRON TO USR VAL VARPTR VARPTR$ VIEW WAIT WHILE ' +
          'WEND WIDTH WINDOW WRITE XOR'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.COMMENT('REM', '$', {relevance: 10}),
      hljs.COMMENT('\'', '$', {relevance: 0}),
      {
        // Match line numbers
        className: 'symbol',
        begin: '^[0-9]+\ ',
        relevance: 10
      },
      {
        // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
        className: 'number',
        begin: '\\b([0-9]+[0-9edED\.]*[#\!]?)',
        relevance: 0
      },
      {
        // Match hexadecimal numbers (&Hxxxx)
        className: 'number',
        begin: '(\&[hH][0-9a-fA-F]{1,4})'
      },
      {
        // Match octal numbers (&Oxxxxxx)
        className: 'number',
        begin: '(\&[oO][0-7]{1,6})'
      }
    ]
  };
});

hljs.registerLanguage('bnf', function(hljs){
  return {
    contains: [
      // Attribute
      {
        className: 'attribute',
        begin: /</, end: />/
      },
      // Specific
      {
        begin: /::=/,
        starts: {
          end: /$/,
          contains: [
            {
              begin: /</, end: />/
            },
            // Common
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
          ]
        }
      }
    ]
  };
});

hljs.registerLanguage('brainfuck', function(hljs){
  var LITERAL = {
    className: 'literal',
    begin: '[\\+\\-]',
    relevance: 0
  };
  return {
    aliases: ['bf'],
    contains: [
      hljs.COMMENT(
        '[^\\[\\]\\.,\\+\\-<> \r\n]',
        '[\\[\\]\\.,\\+\\-<> \r\n]',
        {
          returnEnd: true,
          relevance: 0
        }
      ),
      {
        className: 'title',
        begin: '[\\[\\]]',
        relevance: 0
      },
      {
        className: 'string',
        begin: '[\\.,]',
        relevance: 0
      },
      {
        // this mode works as the only relevance counter
        begin: /\+\+|\-\-/, returnBegin: true,
        contains: [LITERAL]
      },
      LITERAL
    ]
  };
});

hljs.registerLanguage('cal', function(hljs) {
  var KEYWORDS =
    'div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to ' +
    'until while with var';
  var LITERALS = 'false true';
  var COMMENT_MODES = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.COMMENT(
      /\{/,
      /\}/,
      {
        relevance: 0
      }
    ),
    hljs.COMMENT(
      /\(\*/,
      /\*\)/,
      {
        relevance: 10
      }
    )
  ];
  var STRING = {
    className: 'string',
    begin: /'/, end: /'/,
    contains: [{begin: /''/}]
  };
  var CHAR_STRING = {
    className: 'string', begin: /(#\d+)+/
  };
  var DATE = {
      className: 'number',
      begin: '\\b\\d+(\\.\\d+)?(DT|D|T)',
      relevance: 0
  };
  var DBL_QUOTED_VARIABLE = {
      className: 'string', // not a string technically but makes sense to be highlighted in the same style
      begin: '"',
      end: '"'
  };

  var PROCEDURE = {
    className: 'function',
    beginKeywords: 'procedure', end: /[:;]/,
    keywords: 'procedure|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: [STRING, CHAR_STRING]
      }
    ].concat(COMMENT_MODES)
  };

  var OBJECT = {
    className: 'class',
    begin: 'OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)',
    returnBegin: true,
    contains: [
      hljs.TITLE_MODE,
        PROCEDURE
    ]
  };

  return {
    case_insensitive: true,
    keywords: { keyword: KEYWORDS, literal: LITERALS },
    illegal: /\/\*/,
    contains: [
      STRING, CHAR_STRING,
      DATE, DBL_QUOTED_VARIABLE,
      hljs.NUMBER_MODE,
      OBJECT,
      PROCEDURE
    ]
  };
});

hljs.registerLanguage('capnproto', function(hljs) {
  return {
    aliases: ['capnp'],
    keywords: {
      keyword:
        'struct enum interface union group import using const annotation extends in of on as with from fixed',
      built_in:
        'Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 ' +
        'Text Data AnyPointer AnyStruct Capability List',
      literal:
        'true false'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.HASH_COMMENT_MODE,
      {
        className: 'meta',
        begin: /@0x[\w\d]{16};/,
        illegal: /\n/
      },
      {
        className: 'symbol',
        begin: /@\d+\b/
      },
      {
        className: 'class',
        beginKeywords: 'struct enum', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      },
      {
        className: 'class',
        beginKeywords: 'interface', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      }
    ]
  };
});

hljs.registerLanguage('ceylon', function(hljs) {
  // 2.3. Identifiers and keywords
  var KEYWORDS =
    'assembly module package import alias class interface object given value ' +
    'assign void function new of extends satisfies abstracts in out return ' +
    'break continue throw assert dynamic if else switch case for while try ' +
    'catch finally then let this outer super is exists nonempty';
  // 7.4.1 Declaration Modifiers
  var DECLARATION_MODIFIERS =
    'shared abstract formal default actual variable late native deprecated' +
    'final sealed annotation suppressWarnings small';
  // 7.4.2 Documentation
  var DOCUMENTATION =
    'doc by license see throws tagged';
  var SUBST = {
    className: 'subst', excludeBegin: true, excludeEnd: true,
    begin: /``/, end: /``/,
    keywords: KEYWORDS,
    relevance: 10
  };
  var EXPRESSIONS = [
    {
      // verbatim string
      className: 'string',
      begin: '"""',
      end: '"""',
      relevance: 10
    },
    {
      // string literal or template
      className: 'string',
      begin: '"', end: '"',
      contains: [SUBST]
    },
    {
      // character literal
      className: 'string',
      begin: "'",
      end: "'"
    },
    {
      // numeric literal
      className: 'number',
      begin: '#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?',
      relevance: 0
    }
  ];
  SUBST.contains = EXPRESSIONS;

  return {
    keywords: {
      keyword: KEYWORDS + ' ' + DECLARATION_MODIFIERS,
      meta: DOCUMENTATION
    },
    illegal: '\\$[^01]|#[^0-9a-fA-F]',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
      {
        // compiler annotation
        className: 'meta',
        begin: '@[a-z]\\w*(?:\\:\"[^\"]*\")?'
      }
    ].concat(EXPRESSIONS)
  };
});

hljs.registerLanguage('clean', function(hljs) {
  return {
    aliases: ['clean','icl','dcl'],
    keywords: {
      keyword:
        'if let in with where case of class instance otherwise ' +
        'implementation definition system module from import qualified as ' +
        'special code inline foreign export ccall stdcall generic derive ' +
        'infix infixl infixr',
      literal:
        'True False'
    },
    contains: [

      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,

      {begin: '->|<-[|:]?|::|#!?|>>=|\\{\\||\\|\\}|:==|=:|\\.\\.|<>|`'} // relevance booster
    ]
  };
});

hljs.registerLanguage('clojure', function(hljs) {
  var keywords = {
    'builtin-name':
      // Clojure keywords
      'def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem '+
      'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? '+
      'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? '+
      'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? '+
      'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . '+
      'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last '+
      'drop-while while intern condp case reduced cycle split-at split-with repeat replicate '+
      'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext '+
      'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends '+
      'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler '+
      'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter '+
      'monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or '+
      'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert '+
      'peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast '+
      'sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import '+
      'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! '+
      'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger '+
      'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline '+
      'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking '+
      'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! '+
      'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! '+
      'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty '+
      'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list '+
      'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer '+
      'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate '+
      'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta '+
      'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
   };

  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';

  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number', begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';',
    '$',
    {
      relevance: 0
    }
  );
  var LITERAL = {
    className: 'literal',
    begin: /\b(true|false|nil)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]', end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    keywords: keywords,
    lexemes: SYMBOL_RE,
    className: 'name', begin: SYMBOL_RE,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];

  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;

  return {
    aliases: ['clj'],
    illegal: /\S/,
    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  }
});

hljs.registerLanguage('clojure-repl', function(hljs) {
  return {
    contains: [
      {
        className: 'meta',
        begin: /^([\w.-]+|\s*#_)=>/,
        starts: {
          end: /$/,
          subLanguage: 'clojure'
        }
      }
    ]
  }
});

hljs.registerLanguage('cmake', function(hljs) {
  return {
    aliases: ['cmake.in'],
    case_insensitive: true,
    keywords: {
      keyword:
        'add_custom_command add_custom_target add_definitions add_dependencies ' +
        'add_executable add_library add_subdirectory add_test aux_source_directory ' +
        'break build_command cmake_minimum_required cmake_policy configure_file ' +
        'create_test_sourcelist define_property else elseif enable_language enable_testing ' +
        'endforeach endfunction endif endmacro endwhile execute_process export find_file ' +
        'find_library find_package find_path find_program fltk_wrap_ui foreach function ' +
        'get_cmake_property get_directory_property get_filename_component get_property ' +
        'get_source_file_property get_target_property get_test_property if include ' +
        'include_directories include_external_msproject include_regular_expression install ' +
        'link_directories load_cache load_command macro mark_as_advanced message option ' +
        'output_required_files project qt_wrap_cpp qt_wrap_ui remove_definitions return ' +
        'separate_arguments set set_directory_properties set_property ' +
        'set_source_files_properties set_target_properties set_tests_properties site_name ' +
        'source_group string target_link_libraries try_compile try_run unset variable_watch ' +
        'while build_name exec_program export_library_dependencies install_files ' +
        'install_programs install_targets link_libraries make_directory remove subdir_depends ' +
        'subdirs use_mangled_mesa utility_source variable_requires write_file ' +
        'qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or ' +
        'equal less greater strless strgreater strequal matches'
    },
    contains: [
      {
        className: 'variable',
        begin: '\\${', end: '}'
      },
      hljs.HASH_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('coffeescript', function(hljs) {
  var KEYWORDS = {
    keyword:
      // JS keywords
      'in if for while finally new do return else break catch instanceof throw try this ' +
      'switch continue typeof delete debugger super yield import export from as default await ' +
      // Coffee keywords
      'then unless until loop of by when and or is isnt not',
    literal:
      // JS literals
      'true false null undefined ' +
      // Coffee literals
      'yes no on off',
    built_in:
      'npm require console print module global window document'
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.BINARY_NUMBER_MODE,
    hljs.inherit(hljs.C_NUMBER_MODE, {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: 'string',
      variants: [
        {
          begin: /'''/, end: /'''/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/, end: /"""/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        }
      ]
    },
    {
      className: 'regexp',
      variants: [
        {
          begin: '///', end: '///',
          contains: [SUBST, hljs.HASH_COMMENT_MODE]
        },
        {
          begin: '//[gim]*',
          relevance: 0
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
        }
      ]
    },
    {
      begin: '@' + JS_IDENT_RE // relevance booster
    },
    {
      subLanguage: 'javascript',
      excludeBegin: true, excludeEnd: true,
      variants: [
        {
          begin: '```', end: '```',
        },
        {
          begin: '`', end: '`',
        }
      ]
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };

  return {
    aliases: ['coffee', 'cson', 'iced'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('###', '###'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'function',
        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
        returnBegin: true,
        contains: [TITLE, PARAMS]
      },
      {
        // anonymous function start
        begin: /[:\(,=]\s*/,
        relevance: 0,
        contains: [
          {
            className: 'function',
            begin: PARAMS_RE, end: '[-=]>',
            returnBegin: true,
            contains: [PARAMS]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
});

hljs.registerLanguage('coq', function(hljs) {
  return {
    keywords: {
      keyword:
        '_ as at cofix else end exists exists2 fix for forall fun if IF in let ' +
        'match mod Prop return Set then Type using where with ' +
        'Abort About Add Admit Admitted All Arguments Assumptions Axiom Back BackTo ' +
        'Backtrack Bind Blacklist Canonical Cd Check Class Classes Close Coercion ' +
        'Coercions CoFixpoint CoInductive Collection Combined Compute Conjecture ' +
        'Conjectures Constant constr Constraint Constructors Context Corollary ' +
        'CreateHintDb Cut Declare Defined Definition Delimit Dependencies Dependent' +
        'Derive Drop eauto End Equality Eval Example Existential Existentials ' +
        'Existing Export exporting Extern Extract Extraction Fact Field Fields File ' +
        'Fixpoint Focus for From Function Functional Generalizable Global Goal Grab ' +
        'Grammar Graph Guarded Heap Hint HintDb Hints Hypotheses Hypothesis ident ' +
        'Identity If Immediate Implicit Import Include Inductive Infix Info Initial ' +
        'Inline Inspect Instance Instances Intro Intros Inversion Inversion_clear ' +
        'Language Left Lemma Let Libraries Library Load LoadPath Local Locate Ltac ML ' +
        'Mode Module Modules Monomorphic Morphism Next NoInline Notation Obligation ' +
        'Obligations Opaque Open Optimize Options Parameter Parameters Parametric ' +
        'Path Paths pattern Polymorphic Preterm Print Printing Program Projections ' +
        'Proof Proposition Pwd Qed Quit Rec Record Recursive Redirect Relation Remark ' +
        'Remove Require Reserved Reset Resolve Restart Rewrite Right Ring Rings Save ' +
        'Scheme Scope Scopes Script Search SearchAbout SearchHead SearchPattern ' +
        'SearchRewrite Section Separate Set Setoid Show Solve Sorted Step Strategies ' +
        'Strategy Structure SubClass Table Tables Tactic Term Test Theorem Time ' +
        'Timeout Transparent Type Typeclasses Types Undelimit Undo Unfocus Unfocused ' +
        'Unfold Universe Universes Unset Unshelve using Variable Variables Variant ' +
        'Verbose Visibility where with',
      built_in:
        'abstract absurd admit after apply as assert assumption at auto autorewrite ' +
        'autounfold before bottom btauto by case case_eq cbn cbv change ' +
        'classical_left classical_right clear clearbody cofix compare compute ' +
        'congruence constr_eq constructor contradict contradiction cut cutrewrite ' +
        'cycle decide decompose dependent destruct destruction dintuition ' +
        'discriminate discrR do double dtauto eapply eassumption eauto ecase ' +
        'econstructor edestruct ediscriminate eelim eexact eexists einduction ' +
        'einjection eleft elim elimtype enough equality erewrite eright ' +
        'esimplify_eq esplit evar exact exactly_once exfalso exists f_equal fail ' +
        'field field_simplify field_simplify_eq first firstorder fix fold fourier ' +
        'functional generalize generalizing gfail give_up has_evar hnf idtac in ' +
        'induction injection instantiate intro intro_pattern intros intuition ' +
        'inversion inversion_clear is_evar is_var lapply lazy left lia lra move ' +
        'native_compute nia nsatz omega once pattern pose progress proof psatz quote ' +
        'record red refine reflexivity remember rename repeat replace revert ' +
        'revgoals rewrite rewrite_strat right ring ring_simplify rtauto set ' +
        'setoid_reflexivity setoid_replace setoid_rewrite setoid_symmetry ' +
        'setoid_transitivity shelve shelve_unifiable simpl simple simplify_eq solve ' +
        'specialize split split_Rabs split_Rmult stepl stepr subst sum swap ' +
        'symmetry tactic tauto time timeout top transitivity trivial try tryif ' +
        'unfold unify until using vm_compute with'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.COMMENT('\\(\\*', '\\*\\)'),
      hljs.C_NUMBER_MODE,
      {
        className: 'type',
        excludeBegin: true,
        begin: '\\|\\s*',
        end: '\\w+'
      },
      {begin: /[-=]>/} // relevance booster
    ]
  };
});

hljs.registerLanguage('cos', function cos (hljs) {

  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '"',
        end: '"',
        contains: [{ // escaped
          begin: "\"\"",
          relevance: 0
        }]
      }
    ]
  };

  var NUMBERS = {
    className: "number",
    begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
    relevance: 0
  };

  var COS_KEYWORDS =
    'property parameter class classmethod clientmethod extends as break ' +
    'catch close continue do d|0 else elseif for goto halt hang h|0 if job ' +
    'j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 ' +
    'tcommit throw trollback try tstart use view while write w|0 xecute x|0 ' +
    'zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert ' +
    'zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit ' +
    'zsync ascii';

    // registered function - no need in them due to all functions are highlighted,
    // but I'll just leave this here.

    //"$bit", "$bitcount",
    //"$bitfind", "$bitlogic", "$case", "$char", "$classmethod", "$classname",
    //"$compile", "$data", "$decimal", "$double", "$extract", "$factor",
    //"$find", "$fnumber", "$get", "$increment", "$inumber", "$isobject",
    //"$isvaliddouble", "$isvalidnum", "$justify", "$length", "$list",
    //"$listbuild", "$listdata", "$listfind", "$listfromstring", "$listget",
    //"$listlength", "$listnext", "$listsame", "$listtostring", "$listvalid",
    //"$locate", "$match", "$method", "$name", "$nconvert", "$next",
    //"$normalize", "$now", "$number", "$order", "$parameter", "$piece",
    //"$prefetchoff", "$prefetchon", "$property", "$qlength", "$qsubscript",
    //"$query", "$random", "$replace", "$reverse", "$sconvert", "$select",
    //"$sortbegin", "$sortend", "$stack", "$text", "$translate", "$view",
    //"$wascii", "$wchar", "$wextract", "$wfind", "$wiswide", "$wlength",
    //"$wreverse", "$xecute", "$zabs", "$zarccos", "$zarcsin", "$zarctan",
    //"$zcos", "$zcot", "$zcsc", "$zdate", "$zdateh", "$zdatetime",
    //"$zdatetimeh", "$zexp", "$zhex", "$zln", "$zlog", "$zpower", "$zsec",
    //"$zsin", "$zsqr", "$ztan", "$ztime", "$ztimeh", "$zboolean",
    //"$zconvert", "$zcrc", "$zcyc", "$zdascii", "$zdchar", "$zf",
    //"$ziswide", "$zlascii", "$zlchar", "$zname", "$zposition", "$zqascii",
    //"$zqchar", "$zsearch", "$zseek", "$zstrip", "$zwascii", "$zwchar",
    //"$zwidth", "$zwpack", "$zwbpack", "$zwunpack", "$zwbunpack", "$zzenkaku",
    //"$change", "$mv", "$mvat", "$mvfmt", "$mvfmts", "$mviconv",
    //"$mviconvs", "$mvinmat", "$mvlover", "$mvoconv", "$mvoconvs", "$mvraise",
    //"$mvtrans", "$mvv", "$mvname", "$zbitand", "$zbitcount", "$zbitfind",
    //"$zbitget", "$zbitlen", "$zbitnot", "$zbitor", "$zbitset", "$zbitstr",
    //"$zbitxor", "$zincrement", "$znext", "$zorder", "$zprevious", "$zsort",
    //"device", "$ecode", "$estack", "$etrap", "$halt", "$horolog",
    //"$io", "$job", "$key", "$namespace", "$principal", "$quit", "$roles",
    //"$storage", "$system", "$test", "$this", "$tlevel", "$username",
    //"$x", "$y", "$za", "$zb", "$zchild", "$zeof", "$zeos", "$zerror",
    //"$zhorolog", "$zio", "$zjob", "$zmode", "$znspace", "$zparent", "$zpi",
    //"$zpos", "$zreference", "$zstorage", "$ztimestamp", "$ztimezone",
    //"$ztrap", "$zversion"

  return {
    case_insensitive: true,
    aliases: ["cos", "cls"],
    keywords: COS_KEYWORDS,
    contains: [
      NUMBERS,
      STRINGS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: "comment",
        begin: /;/, end: "$",
        relevance: 0
      },
      { // Functions and user-defined functions: write $ztime(60*60*3), $$myFunc(10), $$^Val(1)
        className: "built_in",
        begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
      },
      { // Macro command: quit $$$OK
        className: "built_in",
        begin: /\$\$\$[a-zA-Z]+/
      },
      { // Special (global) variables: write %request.Content; Built-in classes: %Library.Integer
        className: "built_in",
        begin: /%[a-z]+(?:\.[a-z]+)*/
      },
      { // Global variable: set ^globalName = 12 write ^globalName
        className: "symbol",
        begin: /\^%?[a-zA-Z][\w]*/
      },
      { // Some control constructions: do ##class(Package.ClassName).Method(), ##super()
        className: "keyword",
        begin: /##class|##super|#define|#dim/
      },

      // sub-languages: are not fully supported by hljs by 11/15/2015
      // left for the future implementation.
      {
        begin: /&sql\(/,    end: /\)/,
        excludeBegin: true, excludeEnd: true,
        subLanguage: "sql"
      },
      {
        begin: /&(js|jscript|javascript)</, end: />/,
        excludeBegin: true, excludeEnd: true,
        subLanguage: "javascript"
      },
      {
        // this brakes first and last tag, but this is the only way to embed a valid html
        begin: /&html<\s*</, end: />\s*>/,
        subLanguage: "xml"
      }
    ]
  };
});

hljs.registerLanguage('crmsh', function(hljs) {
  var RESOURCES = 'primitive rsc_template';

  var COMMANDS = 'group clone ms master location colocation order fencing_topology ' +
      'rsc_ticket acl_target acl_group user role ' +
      'tag xml';

  var PROPERTY_SETS = 'property rsc_defaults op_defaults';

  var KEYWORDS = 'params meta operations op rule attributes utilization';

  var OPERATORS = 'read write deny defined not_defined in_range date spec in ' +
      'ref reference attribute type xpath version and or lt gt tag ' +
      'lte gte eq ne \\';

  var TYPES = 'number string';

  var LITERALS = 'Master Started Slave Stopped start promote demote stop monitor true false';

  return {
    aliases: ['crm', 'pcmk'],
    case_insensitive: true,
    keywords: {
      keyword: KEYWORDS + ' ' + OPERATORS + ' ' + TYPES,
      literal: LITERALS
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        beginKeywords: 'node',
        starts: {
          end: '\\s*([\\w_-]+:)?',
          starts: {
            className: 'title',
            end: '\\s*[\\$\\w_][\\w_-]*'
          }
        }
      },
      {
        beginKeywords: RESOURCES,
        starts: {
          className: 'title',
          end: '\\s*[\\$\\w_][\\w_-]*',
          starts: {
            end: '\\s*@?[\\w_][\\w_\\.:-]*'
          }
        }
      },
      {
        begin: '\\b(' + COMMANDS.split(' ').join('|') + ')\\s+',
        keywords: COMMANDS,
        starts: {
          className: 'title',
          end: '[\\$\\w_][\\w_-]*'
        }
      },
      {
        beginKeywords: PROPERTY_SETS,
        starts: {
          className: 'title',
          end: '\\s*([\\w_-]+:)?'
        }
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'meta',
        begin: '(ocf|systemd|service|lsb):[\\w_:-]+',
        relevance: 0
      },
      {
        className: 'number',
        begin: '\\b\\d+(\\.\\d+)?(ms|s|h|m)?',
        relevance: 0
      },
      {
        className: 'literal',
        begin: '[-]?(infinity|inf)',
        relevance: 0
      },
      {
        className: 'attr',
        begin: /([A-Za-z\$_\#][\w_-]+)=/,
        relevance: 0
      },
      {
        className: 'tag',
        begin: '</?',
        end: '/?>',
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('crystal', function(hljs) {
  var NUM_SUFFIX = '(_[uif](8|16|32|64))?';
  var CRYSTAL_IDENT_RE = '[a-zA-Z_]\\w*[!?=]?';
  var RE_STARTER = '!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|' +
    '>>|>|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
  var CRYSTAL_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\][=?]?';
  var CRYSTAL_KEYWORDS = {
    keyword:
      'abstract alias as asm begin break case class def do else elsif end ensure enum extend for fun if ifdef ' +
      'include instance_sizeof is_a? lib macro module next of out pointerof private protected rescue responds_to? ' +
      'return require self sizeof struct super then type typeof union unless until when while with yield ' +
      '__DIR__ __FILE__ __LINE__',
    literal: 'false nil true'
  };
  var SUBST = {
    className: 'subst',
    begin: '#{', end: '}',
    keywords: CRYSTAL_KEYWORDS
  };
  var EXPANSION = {
    className: 'template-variable',
    variants: [
      {begin: '\\{\\{', end: '\\}\\}'},
      {begin: '\\{%', end: '%\\}'}
    ],
    keywords: CRYSTAL_KEYWORDS
  };

  function recursiveParen(begin, end) {
    var
    contains = [{begin: begin, end: end}];
    contains[0].contains = contains;
    return contains;
  }
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /`/, end: /`/},
      {begin: '%w?\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
      {begin: '%w?\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
      {begin: '%w?{', end: '}', contains: recursiveParen('{', '}')},
      {begin: '%w?<', end: '>', contains: recursiveParen('<', '>')},
      {begin: '%w?/', end: '/'},
      {begin: '%w?%', end: '%'},
      {begin: '%w?-', end: '-'},
      {begin: '%w?\\|', end: '\\|'},
    ],
    relevance: 0,
  };
  var REGEXP = {
    begin: '(' + RE_STARTER + ')\\s*',
    contains: [
      {
        className: 'regexp',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST],
        variants: [
          {begin: '//[a-z]*', relevance: 0},
          {begin: '/', end: '/[a-z]*'},
          {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
          {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
          {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
          {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
          {begin: '%r/', end: '/'},
          {begin: '%r%', end: '%'},
          {begin: '%r-', end: '-'},
          {begin: '%r\\|', end: '\\|'},
        ]
      }
    ],
    relevance: 0
  };
  var REGEXP2 = {
    className: 'regexp',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
      {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
      {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
      {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
      {begin: '%r/', end: '/'},
      {begin: '%r%', end: '%'},
      {begin: '%r-', end: '-'},
      {begin: '%r\\|', end: '\\|'},
    ],
    relevance: 0
  };
  var ATTRIBUTE = {
    className: 'meta',
    begin: '@\\[', end: '\\]',
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'meta-string'})
    ]
  };
  var CRYSTAL_DEFAULT_CONTAINS = [
    EXPANSION,
    STRING,
    REGEXP,
    REGEXP2,
    ATTRIBUTE,
    hljs.HASH_COMMENT_MODE,
    {
      className: 'class',
      beginKeywords: 'class module struct', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.HASH_COMMENT_MODE,
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
        {begin: '<'} // relevance booster for inheritance
      ]
    },
    {
      className: 'class',
      beginKeywords: 'lib enum union', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.HASH_COMMENT_MODE,
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
      ],
      relevance: 10
    },
    {
      className: 'function',
      beginKeywords: 'def', end: /\B\b/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {
          begin: CRYSTAL_METHOD_RE,
          endsParent: true
        })
      ]
    },
    {
      className: 'function',
      beginKeywords: 'fun macro', end: /\B\b/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {
          begin: CRYSTAL_METHOD_RE,
          endsParent: true
        })
      ],
      relevance: 5
    },
    {
      className: 'symbol',
      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ':',
      contains: [STRING, {begin: CRYSTAL_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'number',
      variants: [
        { begin: '\\b0b([01_]*[01])' + NUM_SUFFIX },
        { begin: '\\b0o([0-7_]*[0-7])' + NUM_SUFFIX },
        { begin: '\\b0x([A-Fa-f0-9_]*[A-Fa-f0-9])' + NUM_SUFFIX },
        { begin: '\\b(([0-9][0-9_]*[0-9]|[0-9])(\\.[0-9_]*[0-9])?([eE][+-]?[0-9_]*[0-9])?)' + NUM_SUFFIX}
      ],
      relevance: 0
    }
  ];
  SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
  EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION

  return {
    aliases: ['cr'],
    lexemes: CRYSTAL_IDENT_RE,
    keywords: CRYSTAL_KEYWORDS,
    contains: CRYSTAL_DEFAULT_CONTAINS
  };
});

hljs.registerLanguage('cs', function(hljs) {
  var KEYWORDS = {
    keyword:
      // Normal keywords.
      'abstract as base bool break byte case catch char checked const continue decimal ' +
      'default delegate do double else enum event explicit extern finally fixed float ' +
      'for foreach goto if implicit in int interface internal is lock long ' +
      'object operator out override params private protected public readonly ref sbyte ' +
      'sealed short sizeof stackalloc static string struct switch this try typeof ' +
      'uint ulong unchecked unsafe ushort using virtual void volatile while ' +
      'nameof ' +
      // Contextual keywords.
      'add alias ascending async await by descending dynamic equals from get global group into join ' +
      'let on orderby partial remove select set value var where yield',
    literal:
      'null false true'
  };

  var VERBATIM_STRING = {
    className: 'string',
    begin: '@"', end: '"',
    contains: [{begin: '""'}]
  };
  var VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {illegal: /\n/});
  var SUBST = {
    className: 'subst',
    begin: '{', end: '}',
    keywords: KEYWORDS
  };
  var SUBST_NO_LF = hljs.inherit(SUBST, {illegal: /\n/});
  var INTERPOLATED_STRING = {
    className: 'string',
    begin: /\$"/, end: '"',
    illegal: /\n/,
    contains: [{begin: '{{'}, {begin: '}}'}, hljs.BACKSLASH_ESCAPE, SUBST_NO_LF]
  };
  var INTERPOLATED_VERBATIM_STRING = {
    className: 'string',
    begin: /\$@"/, end: '"',
    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST]
  };
  var INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
    illegal: /\n/,
    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST_NO_LF]
  });
  SUBST.contains = [
    INTERPOLATED_VERBATIM_STRING,
    INTERPOLATED_STRING,
    VERBATIM_STRING,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE,
    hljs.C_BLOCK_COMMENT_MODE
  ];
  SUBST_NO_LF.contains = [
    INTERPOLATED_VERBATIM_STRING_NO_LF,
    INTERPOLATED_STRING,
    VERBATIM_STRING_NO_LF,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE,
    hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {illegal: /\n/})
  ];
  var STRING = {
    variants: [
      INTERPOLATED_VERBATIM_STRING,
      INTERPOLATED_STRING,
      VERBATIM_STRING,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };

  var TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';
  return {
    aliases: ['csharp'],
    keywords: KEYWORDS,
    illegal: /::/,
    contains: [
      hljs.COMMENT(
        '///',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              variants: [
                {
                  begin: '///', relevance: 0
                },
                {
                  begin: '<!--|-->'
                },
                {
                  begin: '</?', end: '>'
                }
              ]
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'meta',
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'}
      },
      STRING,
      hljs.C_NUMBER_MODE,
      {
        beginKeywords: 'class interface', end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          hljs.TITLE_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '[a-zA-Z](\\.?\\w)*'}),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new return throw await',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
            contains: [hljs.TITLE_MODE],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      }
    ]
  };
});

hljs.registerLanguage('csp', function(hljs) {
  return {
    case_insensitive: false,
    lexemes: '[a-zA-Z][a-zA-Z0-9_-]*',
    keywords: {
      keyword: 'base-uri child-src connect-src default-src font-src form-action' +
        ' frame-ancestors frame-src img-src media-src object-src plugin-types' +
        ' report-uri sandbox script-src style-src', 
    },
    contains: [
    {
      className: 'string',
      begin: "'", end: "'"
    },
    {
      className: 'attribute',
      begin: '^Content', end: ':', excludeEnd: true,
    },
    ]
  };
});

hljs.registerLanguage('css', function(hljs) {
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var RULE = {
    begin: /[A-Z\_\.\-]+\s*:/, returnBegin: true, end: ';', endsWithParent: true,
    contains: [
      {
        className: 'attribute',
        begin: /\S/, end: ':', excludeEnd: true,
        starts: {
          endsWithParent: true, excludeEnd: true,
          contains: [
            {
              begin: /[\w-]+\(/, returnBegin: true,
              contains: [
                {
                  className: 'built_in',
                  begin: /[\w-]+/
                },
                {
                  begin: /\(/, end: /\)/,
                  contains: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                  ]
                }
              ]
            },
            hljs.CSS_NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
              className: 'number', begin: '#[0-9A-Fa-f]+'
            },
            {
              className: 'meta', begin: '!important'
            }
          ]
        }
      }
    ]
  };

  return {
    case_insensitive: true,
    illegal: /[=\/|'\$]/,
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'selector-id', begin: /#[A-Za-z0-9_-]+/
      },
      {
        className: 'selector-class', begin: /\.[A-Za-z0-9_-]+/
      },
      {
        className: 'selector-attr',
        begin: /\[/, end: /\]/,
        illegal: '$'
      },
      {
        className: 'selector-pseudo',
        begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
      },
      {
        begin: '@(font-face|page)',
        lexemes: '[a-z-]+',
        keywords: 'font-face page'
      },
      {
        begin: '@', end: '[{;]', // at_rule eating first "{" is a good thing
                                 // because it doesn’t let it to be parsed as
                                 // a rule set but instead drops parser into
                                 // the default mode which is how it should be.
        illegal: /:/, // break on Less variables @var: ...
        contains: [
          {
            className: 'keyword',
            begin: /\w+/
          },
          {
            begin: /\s/, endsWithParent: true, excludeEnd: true,
            relevance: 0,
            contains: [
              hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE,
              hljs.CSS_NUMBER_MODE
            ]
          }
        ]
      },
      {
        className: 'selector-tag', begin: IDENT_RE,
        relevance: 0
      },
      {
        begin: '{', end: '}',
        illegal: /\S/,
        contains: [
          hljs.C_BLOCK_COMMENT_MODE,
          RULE,
        ]
      }
    ]
  };
});

hljs.registerLanguage('d', /**
 * Known issues:
 *
 * - invalid hex string literals will be recognized as a double quoted strings
 *   but 'x' at the beginning of string will not be matched
 *
 * - delimited string literals are not checked for matching end delimiter
 *   (not possible to do with js regexp)
 *
 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
 *   also, content of token string is not validated to contain only valid D tokens
 *
 * - special token sequence rule is not strictly following D grammar (anything following #line
 *   up to the end of line is matched as special token sequence)
 */

function(hljs) {
  /**
   * Language keywords
   *
   * @type {Object}
   */
  var D_KEYWORDS = {
    keyword:
      'abstract alias align asm assert auto body break byte case cast catch class ' +
      'const continue debug default delete deprecated do else enum export extern final ' +
      'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' +
      'interface invariant is lazy macro mixin module new nothrow out override package ' +
      'pragma private protected public pure ref return scope shared static struct ' +
      'super switch synchronized template this throw try typedef typeid typeof union ' +
      'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' +
      '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
    built_in:
      'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' +
      'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' +
      'wstring',
    literal:
      'false null true'
  };

  /**
   * Number literal regexps
   *
   * @type {String}
   */
  var decimal_integer_re = '(0|[1-9][\\d_]*)',
    decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)',
    binary_integer_re = '0[bB][01_]+',
    hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)',
    hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re,

    decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')',
    decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' +
                '\\d+\\.' + decimal_integer_nosus_re + decimal_integer_nosus_re + '|' +
                '\\.' + decimal_integer_re + decimal_exponent_re + '?' +
              ')',
    hexadecimal_float_re = '(0[xX](' +
                  hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|'+
                  '\\.?' + hexadecimal_digits_re +
                 ')[pP][+-]?' + decimal_integer_nosus_re + ')',

    integer_re = '(' +
      decimal_integer_re + '|' +
      binary_integer_re  + '|' +
       hexadecimal_integer_re   +
    ')',

    float_re = '(' +
      hexadecimal_float_re + '|' +
      decimal_float_re  +
    ')';

  /**
   * Escape sequence supported in D string and character literals
   *
   * @type {String}
   */
  var escape_sequence_re = '\\\\(' +
              '[\'"\\?\\\\abfnrtv]|' +  // common escapes
              'u[\\dA-Fa-f]{4}|' +     // four hex digit unicode codepoint
              '[0-7]{1,3}|' +       // one to three octal digit ascii char code
              'x[\\dA-Fa-f]{2}|' +    // two hex digit ascii char code
              'U[\\dA-Fa-f]{8}' +      // eight hex digit unicode codepoint
              ')|' +
              '&[a-zA-Z\\d]{2,};';      // named character entity

  /**
   * D integer number literals
   *
   * @type {Object}
   */
  var D_INTEGER_MODE = {
    className: 'number',
      begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
      relevance: 0
  };

  /**
   * [D_FLOAT_MODE description]
   * @type {Object}
   */
  var D_FLOAT_MODE = {
    className: 'number',
    begin: '\\b(' +
        float_re + '([fF]|L|i|[fF]i|Li)?|' +
        integer_re + '(i|[fF]i|Li)' +
      ')',
    relevance: 0
  };

  /**
   * D character literal
   *
   * @type {Object}
   */
  var D_CHARACTER_MODE = {
    className: 'string',
    begin: '\'(' + escape_sequence_re + '|.)', end: '\'',
    illegal: '.'
  };

  /**
   * D string escape sequence
   *
   * @type {Object}
   */
  var D_ESCAPE_SEQUENCE = {
    begin: escape_sequence_re,
    relevance: 0
  };

  /**
   * D double quoted string literal
   *
   * @type {Object}
   */
  var D_STRING_MODE = {
    className: 'string',
    begin: '"',
    contains: [D_ESCAPE_SEQUENCE],
    end: '"[cwd]?'
  };

  /**
   * D wysiwyg and delimited string literals
   *
   * @type {Object}
   */
  var D_WYSIWYG_DELIMITED_STRING_MODE = {
    className: 'string',
    begin: '[rq]"',
    end: '"[cwd]?',
    relevance: 5
  };

  /**
   * D alternate wysiwyg string literal
   *
   * @type {Object}
   */
  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
    className: 'string',
    begin: '`',
    end: '`[cwd]?'
  };

  /**
   * D hexadecimal string literal
   *
   * @type {Object}
   */
  var D_HEX_STRING_MODE = {
    className: 'string',
    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
    relevance: 10
  };

  /**
   * D delimited string literal
   *
   * @type {Object}
   */
  var D_TOKEN_STRING_MODE = {
    className: 'string',
    begin: 'q"\\{',
    end: '\\}"'
  };

  /**
   * Hashbang support
   *
   * @type {Object}
   */
  var D_HASHBANG_MODE = {
    className: 'meta',
    begin: '^#!',
    end: '$',
    relevance: 5
  };

  /**
   * D special token sequence
   *
   * @type {Object}
   */
  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
    className: 'meta',
    begin: '#(line)',
    end: '$',
    relevance: 5
  };

  /**
   * D attributes
   *
   * @type {Object}
   */
  var D_ATTRIBUTE_MODE = {
    className: 'keyword',
    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
  };

  /**
   * D nesting comment
   *
   * @type {Object}
   */
  var D_NESTING_COMMENT_MODE = hljs.COMMENT(
    '\\/\\+',
    '\\+\\/',
    {
      contains: ['self'],
      relevance: 10
    }
  );

  return {
    lexemes: hljs.UNDERSCORE_IDENT_RE,
    keywords: D_KEYWORDS,
    contains: [
      hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        D_NESTING_COMMENT_MODE,
        D_HEX_STRING_MODE,
        D_STRING_MODE,
        D_WYSIWYG_DELIMITED_STRING_MODE,
        D_ALTERNATE_WYSIWYG_STRING_MODE,
        D_TOKEN_STRING_MODE,
        D_FLOAT_MODE,
        D_INTEGER_MODE,
        D_CHARACTER_MODE,
        D_HASHBANG_MODE,
        D_SPECIAL_TOKEN_SEQUENCE_MODE,
        D_ATTRIBUTE_MODE
    ]
  };
});

hljs.registerLanguage('markdown', function(hljs) {
  return {
    aliases: ['md', 'mkdown', 'mkd'],
    contains: [
      // highlight headers
      {
        className: 'section',
        variants: [
          { begin: '^#{1,6}', end: '$' },
          { begin: '^.+?\\n[=-]{2,}$' }
        ]
      },
      // inline html
      {
        begin: '<', end: '>',
        subLanguage: 'xml',
        relevance: 0
      },
      // lists (indicators only)
      {
        className: 'bullet',
        begin: '^([*+-]|(\\d+\\.))\\s+'
      },
      // strong segments
      {
        className: 'strong',
        begin: '[*_]{2}.+?[*_]{2}'
      },
      // emphasis segments
      {
        className: 'emphasis',
        variants: [
          { begin: '\\*.+?\\*' },
          { begin: '_.+?_'
          , relevance: 0
          }
        ]
      },
      // blockquotes
      {
        className: 'quote',
        begin: '^>\\s+', end: '$'
      },
      // code snippets
      {
        className: 'code',
        variants: [
          {
            begin: '^```\w*\s*$', end: '^```\s*$'
          },
          {
            begin: '`.+?`'
          },
          {
            begin: '^( {4}|\t)', end: '$',
            relevance: 0
          }
        ]
      },
      // horizontal rules
      {
        begin: '^[-\\*]{3,}', end: '$'
      },
      // using links - title and link
      {
        begin: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
        returnBegin: true,
        contains: [
          {
            className: 'string',
            begin: '\\[', end: '\\]',
            excludeBegin: true,
            returnEnd: true,
            relevance: 0
          },
          {
            className: 'link',
            begin: '\\]\\(', end: '\\)',
            excludeBegin: true, excludeEnd: true
          },
          {
            className: 'symbol',
            begin: '\\]\\[', end: '\\]',
            excludeBegin: true, excludeEnd: true
          }
        ],
        relevance: 10
      },
      {
        begin: /^\[[^\n]+\]:/,
        returnBegin: true,
        contains: [
          {
            className: 'symbol',
            begin: /\[/, end: /\]/,
            excludeBegin: true, excludeEnd: true
          },
          {
            className: 'link',
            begin: /:\s*/, end: /$/,
            excludeBegin: true
          }
        ]
      }
    ]
  };
});

hljs.registerLanguage('dart', function (hljs) {
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{', end: '}',
    keywords: 'true false null this is new super'
  };

  var STRING = {
    className: 'string',
    variants: [
      {
        begin: 'r\'\'\'', end: '\'\'\''
      },
      {
        begin: 'r"""', end: '"""'
      },
      {
        begin: 'r\'', end: '\'',
        illegal: '\\n'
      },
      {
        begin: 'r"', end: '"',
        illegal: '\\n'
      },
      {
        begin: '\'\'\'', end: '\'\'\'',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '"""', end: '"""',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '\'', end: '\'',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      }
    ]
  };
  SUBST.contains = [
    hljs.C_NUMBER_MODE, STRING
  ];

  var KEYWORDS = {
    keyword: 'assert async await break case catch class const continue default do else enum extends false final ' +
      'finally for if in is new null rethrow return super switch sync this throw true try var void while with yield ' +
      'abstract as dynamic export external factory get implements import library operator part set static typedef',
    built_in:
      // dart:core
      'print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set ' +
      'Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num ' +
      // dart:html
      'document window querySelector querySelectorAll Element ElementList'
  };

  return {
    keywords: KEYWORDS,
    contains: [
      STRING,
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          subLanguage: 'markdown'
        }
      ),
      hljs.COMMENT(
        '///',
        '$',
        {
          subLanguage: 'markdown'
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      hljs.C_NUMBER_MODE,
      {
        className: 'meta', begin: '@[A-Za-z]+'
      },
      {
        begin: '=>' // No markup, just a relevance booster
      }
    ]
  }
});

hljs.registerLanguage('delphi', function(hljs) {
  var KEYWORDS =
    'exports register file shl array record property for mod while set ally label uses raise not ' +
    'stored class safecall var interface or private static exit index inherited to else stdcall ' +
    'override shr asm far resourcestring finalization packed virtual out and protected library do ' +
    'xorwrite goto near function end div overload object unit begin string on inline repeat until ' +
    'destructor write message program with read initialization except default nil if case cdecl in ' +
    'downto threadvar of try pascal const external constructor type public then implementation ' +
    'finally published procedure absolute reintroduce operator as is abstract alias assembler ' +
    'bitpacked break continue cppdecl cvar enumerator experimental platform deprecated ' +
    'unimplemented dynamic export far16 forward generic helper implements interrupt iochecks ' +
    'local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat ' +
    'specialize strict unaligned varargs ';
  var COMMENT_MODES = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.COMMENT(/\{/, /\}/, {relevance: 0}),
    hljs.COMMENT(/\(\*/, /\*\)/, {relevance: 10})
  ];
  var DIRECTIVE = {
    className: 'meta',
    variants: [
      {begin: /\{\$/, end: /\}/},
      {begin: /\(\*\$/, end: /\*\)/}
    ]
  };
  var STRING = {
    className: 'string',
    begin: /'/, end: /'/,
    contains: [{begin: /''/}]
  };
  var CHAR_STRING = {
    className: 'string', begin: /(#\d+)+/
  };
  var CLASS = {
    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(', returnBegin: true,
    contains: [
      hljs.TITLE_MODE
    ]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure', end: /[:;]/,
    keywords: 'function constructor|10 destructor|10 procedure|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: [STRING, CHAR_STRING, DIRECTIVE].concat(COMMENT_MODES)
      },
      DIRECTIVE
    ].concat(COMMENT_MODES)
  };
  return {
    aliases: ['dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'],
    case_insensitive: true,
    keywords: KEYWORDS,
    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
    contains: [
      STRING, CHAR_STRING,
      hljs.NUMBER_MODE,
      CLASS,
      FUNCTION,
      DIRECTIVE
    ].concat(COMMENT_MODES)
  };
});

hljs.registerLanguage('diff', function(hljs) {
  return {
    aliases: ['patch'],
    contains: [
      {
        className: 'meta',
        relevance: 10,
        variants: [
          {begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},
          {begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/},
          {begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/}
        ]
      },
      {
        className: 'comment',
        variants: [
          {begin: /Index: /, end: /$/},
          {begin: /={3,}/, end: /$/},
          {begin: /^\-{3}/, end: /$/},
          {begin: /^\*{3} /, end: /$/},
          {begin: /^\+{3}/, end: /$/},
          {begin: /\*{5}/, end: /\*{5}$/}
        ]
      },
      {
        className: 'addition',
        begin: '^\\+', end: '$'
      },
      {
        className: 'deletion',
        begin: '^\\-', end: '$'
      },
      {
        className: 'addition',
        begin: '^\\!', end: '$'
      }
    ]
  };
});

hljs.registerLanguage('django', function(hljs) {
  var FILTER = {
    begin: /\|[A-Za-z]+:?/,
    keywords: {
      name:
        'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' +
        'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' +
        'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' +
        'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' +
        'dictsortreversed default_if_none pluralize lower join center default ' +
        'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' +
        'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' +
        'localtime utc timezone'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE
    ]
  };

  return {
    aliases: ['jinja'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
      hljs.COMMENT(/\{#/, /#}/),
      {
        className: 'template-tag',
        begin: /\{%/, end: /%}/,
        contains: [
          {
            className: 'name',
            begin: /\w+/,
            keywords: {
              name:
                'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' +
                'endfor ifnotequal endifnotequal widthratio extends include spaceless ' +
                'endspaceless regroup ifequal endifequal ssi now with cycle url filter ' +
                'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' +
                'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' +
                'plural get_current_language language get_available_languages ' +
                'get_current_language_bidi get_language_info get_language_info_list localize ' +
                'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' +
                'verbatim'
            },
            starts: {
              endsWithParent: true,
              keywords: 'in by as',
              contains: [FILTER],
              relevance: 0
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /}}/,
        contains: [FILTER]
      }
    ]
  };
});

hljs.registerLanguage('dns', function(hljs) {
  return {
    aliases: ['bind', 'zone'],
    keywords: {
      keyword:
        'IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX ' +
        'LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT'
    },
    contains: [
      hljs.COMMENT(';', '$', {relevance: 0}),
      {
        className: 'meta',
        begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
      },
      // IPv6
      {
        className: 'number',
        begin: '((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b'
      },
      // IPv4
      {
        className: 'number',
        begin: '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b'
      },
      hljs.inherit(hljs.NUMBER_MODE, {begin: /\b\d+[dhwm]?/})
    ]
  };
});

hljs.registerLanguage('dockerfile', function(hljs) {
  return {
    aliases: ['docker'],
    case_insensitive: true,
    keywords: 'from maintainer expose env user onbuild',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      {
        beginKeywords: 'run cmd entrypoint volume add copy workdir label healthcheck',
        starts: {
          end: /[^\\]\n/,
          subLanguage: 'bash'
        }
      }
    ],
    illegal: '</'
  }
});

hljs.registerLanguage('dos', function(hljs) {
  var COMMENT = hljs.COMMENT(
    /^\s*@?rem\b/, /$/,
    {
      relevance: 10
    }
  );
  var LABEL = {
    className: 'symbol',
    begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)',
    relevance: 0
  };
  return {
    aliases: ['bat', 'cmd'],
    case_insensitive: true,
    illegal: /\/\*/,
    keywords: {
      keyword:
        'if else goto for in do call exit not exist errorlevel defined ' +
        'equ neq lss leq gtr geq',
      built_in:
        'prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux ' +
        'shift cd dir echo setlocal endlocal set pause copy ' +
        'append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color ' +
        'comp compact convert date dir diskcomp diskcopy doskey erase fs ' +
        'find findstr format ftype graftabl help keyb label md mkdir mode more move path ' +
        'pause print popd pushd promt rd recover rem rename replace restore rmdir shift' +
        'sort start subst time title tree type ver verify vol ' +
        // winutils
        'ping net ipconfig taskkill xcopy ren del'
    },
    contains: [
      {
        className: 'variable', begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
      },
      {
        className: 'function',
        begin: LABEL.begin, end: 'goto:eof',
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
          COMMENT
        ]
      },
      {
        className: 'number', begin: '\\b\\d+',
        relevance: 0
      },
      COMMENT
    ]
  };
});

hljs.registerLanguage('dsconfig', function(hljs) {
  var QUOTED_PROPERTY = {
    className: 'string',
    begin: /"/, end: /"/
  };
  var APOS_PROPERTY = {
    className: 'string',
    begin: /'/, end: /'/
  };
  var UNQUOTED_PROPERTY = {
    className: 'string',
    begin: '[\\w-?]+:\\w+', end: '\\W',
    relevance: 0
  };
  var VALUELESS_PROPERTY = {
    className: 'string',
    begin: '\\w+-?\\w+', end: '\\W',
    relevance: 0
  };

  return {
    keywords: 'dsconfig',
    contains: [
      {
        className: 'keyword',
        begin: '^dsconfig', end: '\\s', excludeEnd: true,
        relevance: 10
      },
      {
        className: 'built_in',
        begin: '(list|create|get|set|delete)-(\\w+)', end: '\\s', excludeEnd: true,
        illegal: '!@#$%^&*()',
        relevance: 10
      },
      {
        className: 'built_in',
        begin: '--(\\w+)', end: '\\s', excludeEnd: true
      },
      QUOTED_PROPERTY,
      APOS_PROPERTY,
      UNQUOTED_PROPERTY,
      VALUELESS_PROPERTY,
      hljs.HASH_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('dts', function(hljs) {
  var STRINGS = {
    className: 'string',
    variants: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
      {
        begin: '(u8?|U)?R"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '\'\\\\?.', end: '\'',
        illegal: '.'
      }
    ]
  };

  var NUMBERS = {
    className: 'number',
    variants: [
      { begin: '\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)' },
      { begin: hljs.C_NUMBER_RE }
    ],
    relevance: 0
  };

  var PREPROCESSOR = {
    className: 'meta',
    begin: '#', end: '$',
    keywords: {'meta-keyword': 'if else elif endif define undef ifdef ifndef'},
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      {
        beginKeywords: 'include', end: '$',
        keywords: {'meta-keyword': 'include'},
        contains: [
          hljs.inherit(STRINGS, {className: 'meta-string'}),
          {
            className: 'meta-string',
            begin: '<', end: '>',
            illegal: '\\n'
          }
        ]
      },
      STRINGS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var DTS_REFERENCE = {
    className: 'variable',
    begin: '\\&[a-z\\d_]*\\b'
  };

  var DTS_KEYWORD = {
    className: 'meta-keyword',
    begin: '/[a-z][a-z\\d-]*/'
  };

  var DTS_LABEL = {
    className: 'symbol',
    begin: '^\\s*[a-zA-Z_][a-zA-Z\\d_]*:'
  };

  var DTS_CELL_PROPERTY = {
    className: 'params',
    begin: '<',
    end: '>',
    contains: [
      NUMBERS,
      DTS_REFERENCE
    ]
  };

  var DTS_NODE = {
    className: 'class',
    begin: /[a-zA-Z_][a-zA-Z\d_@]*\s{/,
    end: /[{;=]/,
    returnBegin: true,
    excludeEnd: true
  };

  var DTS_ROOT_NODE = {
    className: 'class',
    begin: '/\\s*{',
    end: '};',
    relevance: 10,
    contains: [
      DTS_REFERENCE,
      DTS_KEYWORD,
      DTS_LABEL,
      DTS_NODE,
      DTS_CELL_PROPERTY,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBERS,
      STRINGS
    ]
  };

  return {
    keywords: "",
    contains: [
      DTS_ROOT_NODE,
      DTS_REFERENCE,
      DTS_KEYWORD,
      DTS_LABEL,
      DTS_NODE,
      DTS_CELL_PROPERTY,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBERS,
      STRINGS,
      PREPROCESSOR,
      {
        begin: hljs.IDENT_RE + '::',
        keywords: ""
      }
    ]
  };
});

hljs.registerLanguage('dust', function(hljs) {
  var EXPRESSION_KEYWORDS = 'if eq ne lt lte gt gte select default math sep';
  return {
    aliases: ['dst'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      {
        className: 'template-tag',
        begin: /\{[#\/]/, end: /\}/, illegal: /;/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.-]+/,
            starts: {
              endsWithParent: true, relevance: 0,
              contains: [
                hljs.QUOTE_STRING_MODE
              ]
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{/, end: /\}/, illegal: /;/,
        keywords: EXPRESSION_KEYWORDS
      }
    ]
  };
});

hljs.registerLanguage('ebnf', function(hljs) {
    var commentMode = hljs.COMMENT(/\(\*/, /\*\)/);

    var nonTerminalMode = {
        className: "attribute",
        begin: /^[ ]*[a-zA-Z][a-zA-Z-]*([\s-]+[a-zA-Z][a-zA-Z]*)*/
    };

    var specialSequenceMode = {
        className: "meta",
        begin: /\?.*\?/
    };

    var ruleBodyMode = {
        begin: /=/, end: /;/,
        contains: [
            commentMode,
            specialSequenceMode,
            // terminals
            hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE
        ]
    };

    return {
        illegal: /\S/,
        contains: [
            commentMode,
            nonTerminalMode,
            ruleBodyMode
        ]
    };
});

hljs.registerLanguage('elixir', function(hljs) {
  var ELIXIR_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_]*(\\!|\\?)?';
  var ELIXIR_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var ELIXIR_KEYWORDS =
    'and false then defined module in return redo retry end for true self when ' +
    'next until do begin unless nil break not case cond alias while ensure or ' +
    'include use alias fn quote';
  var SUBST = {
    className: 'subst',
    begin: '#\\{', end: '}',
    lexemes: ELIXIR_IDENT_RE,
    keywords: ELIXIR_KEYWORDS
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {
        begin: /'/, end: /'/
      },
      {
        begin: /"/, end: /"/
      }
    ]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'def defp defmacro', end: /\B\b/, // the mode is ended by the title
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {
        begin: ELIXIR_IDENT_RE,
        endsParent: true
      })
    ]
  };
  var CLASS = hljs.inherit(FUNCTION, {
    className: 'class',
    beginKeywords: 'defimpl defmodule defprotocol defrecord', end: /\bdo\b|$|;/
  });
  var ELIXIR_DEFAULT_CONTAINS = [
    STRING,
    hljs.HASH_COMMENT_MODE,
    CLASS,
    FUNCTION,
    {
      className: 'symbol',
      begin: ':(?!\\s)',
      contains: [STRING, {begin: ELIXIR_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ELIXIR_IDENT_RE + ':',
      relevance: 0
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    {
      className: 'variable',
      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))'
    },
    {
      begin: '->'
    },
    { // regexp container
      begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
      contains: [
        hljs.HASH_COMMENT_MODE,
        {
          className: 'regexp',
          illegal: '\\n',
          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
          variants: [
            {
              begin: '/', end: '/[a-z]*'
            },
            {
              begin: '%r\\[', end: '\\][a-z]*'
            }
          ]
        }
      ],
      relevance: 0
    }
  ];
  SUBST.contains = ELIXIR_DEFAULT_CONTAINS;

  return {
    lexemes: ELIXIR_IDENT_RE,
    keywords: ELIXIR_KEYWORDS,
    contains: ELIXIR_DEFAULT_CONTAINS
  };
});

hljs.registerLanguage('elm', function(hljs) {
  var COMMENT = {
    variants: [
      hljs.COMMENT('--', '$'),
      hljs.COMMENT(
        '{-',
        '-}',
        {
          contains: ['self']
        }
      )
    ]
  };

  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (built-in, infix).
    relevance: 0
  };

  var LIST = {
    begin: '\\(', end: '\\)',
    illegal: '"',
    contains: [
      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
      COMMENT
    ]
  };

  var RECORD = {
    begin: '{', end: '}',
    contains: LIST.contains
  };

  return {
    keywords:
      'let in if then else case of where module import exposing ' +
      'type alias as infix infixl infixr port effect command subscription',
    contains: [

      // Top-level constructions.

      {
        beginKeywords: 'port effect module', end: 'exposing',
        keywords: 'port effect module where command subscription exposing',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: 'import', end: '$',
        keywords: 'import as exposing',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: 'type', end: '$',
        keywords: 'type alias',
        contains: [CONSTRUCTOR, LIST, RECORD, COMMENT]
      },
      {
        beginKeywords: 'infix infixl infixr', end: '$',
        contains: [hljs.C_NUMBER_MODE, COMMENT]
      },
      {
        begin: 'port', end: '$',
        keywords: 'port',
        contains: [COMMENT]
      },

      // Literals and names.

      // TODO: characters.
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      CONSTRUCTOR,
      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
      COMMENT,

      {begin: '->|<-'} // No markup, relevance booster
    ]
  };
});

hljs.registerLanguage('ruby', function(hljs) {
  var RUBY_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var RUBY_KEYWORDS = {
    keyword:
      'and then defined module in return redo if BEGIN retry end for self when ' +
      'next until do begin unless END rescue else break undef not super class case ' +
      'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor',
    literal:
      'true false nil'
  };
  var YARDOCTAG = {
    className: 'doctag',
    begin: '@[A-Za-z]+'
  };
  var IRB_OBJECT = {
    begin: '#<', end: '>'
  };
  var COMMENT_MODES = [
    hljs.COMMENT(
      '#',
      '$',
      {
        contains: [YARDOCTAG]
      }
    ),
    hljs.COMMENT(
      '^\\=begin',
      '^\\=end',
      {
        contains: [YARDOCTAG],
        relevance: 10
      }
    ),
    hljs.COMMENT('^__END__', '\\n$')
  ];
  var SUBST = {
    className: 'subst',
    begin: '#\\{', end: '}',
    keywords: RUBY_KEYWORDS
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /`/, end: /`/},
      {begin: '%[qQwWx]?\\(', end: '\\)'},
      {begin: '%[qQwWx]?\\[', end: '\\]'},
      {begin: '%[qQwWx]?{', end: '}'},
      {begin: '%[qQwWx]?<', end: '>'},
      {begin: '%[qQwWx]?/', end: '/'},
      {begin: '%[qQwWx]?%', end: '%'},
      {begin: '%[qQwWx]?-', end: '-'},
      {begin: '%[qQwWx]?\\|', end: '\\|'},
      {
        // \B in the beginning suppresses recognition of ?-sequences where ?
        // is the last character of a preceding identifier, as in: `func?4`
        begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
      },
      {
        begin: /<<(-?)\w+$/, end: /^\s*\w+$/,
      }
    ]
  };
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)', endsParent: true,
    keywords: RUBY_KEYWORDS
  };

  var RUBY_DEFAULT_CONTAINS = [
    STRING,
    IRB_OBJECT,
    {
      className: 'class',
      beginKeywords: 'class module', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
        {
          begin: '<\\s*',
          contains: [{
            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
          }]
        }
      ].concat(COMMENT_MODES)
    },
    {
      className: 'function',
      beginKeywords: 'def', end: '$|;',
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: RUBY_METHOD_RE}),
        PARAMS
      ].concat(COMMENT_MODES)
    },
    {
      // swallow namespace qualifiers before symbols
      begin: hljs.IDENT_RE + '::'
    },
    {
      className: 'symbol',
      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ':(?!\\s)',
      contains: [STRING, {begin: RUBY_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    {
      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))' // variables
    },
    {
      className: 'params',
      begin: /\|/, end: /\|/,
      keywords: RUBY_KEYWORDS
    },
    { // regexp container
      begin: '(' + hljs.RE_STARTERS_RE + '|unless)\\s*',
      contains: [
        IRB_OBJECT,
        {
          className: 'regexp',
          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
          illegal: /\n/,
          variants: [
            {begin: '/', end: '/[a-z]*'},
            {begin: '%r{', end: '}[a-z]*'},
            {begin: '%r\\(', end: '\\)[a-z]*'},
            {begin: '%r!', end: '![a-z]*'},
            {begin: '%r\\[', end: '\\][a-z]*'}
          ]
        }
      ].concat(COMMENT_MODES),
      relevance: 0
    }
  ].concat(COMMENT_MODES);

  SUBST.contains = RUBY_DEFAULT_CONTAINS;
  PARAMS.contains = RUBY_DEFAULT_CONTAINS;

  var SIMPLE_PROMPT = "[>?]>";
  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";

  var IRB_DEFAULT = [
    {
      begin: /^\s*=>/,
      starts: {
        end: '$', contains: RUBY_DEFAULT_CONTAINS
      }
    },
    {
      className: 'meta',
      begin: '^('+SIMPLE_PROMPT+"|"+DEFAULT_PROMPT+'|'+RVM_PROMPT+')',
      starts: {
        end: '$', contains: RUBY_DEFAULT_CONTAINS
      }
    }
  ];

  return {
    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
    keywords: RUBY_KEYWORDS,
    illegal: /\/\*/,
    contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
  };
});

hljs.registerLanguage('erb', function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT('<%#', '%>'),
      {
        begin: '<%[%=-]?', end: '[%-]?%>',
        subLanguage: 'ruby',
        excludeBegin: true,
        excludeEnd: true
      }
    ]
  };
});

hljs.registerLanguage('erlang-repl', function(hljs) {
  return {
    keywords: {
      built_in:
        'spawn spawn_link self',
      keyword:
        'after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if ' +
        'let not of or orelse|10 query receive rem try when xor'
    },
    contains: [
      {
        className: 'meta', begin: '^[0-9]+> ',
        relevance: 10
      },
      hljs.COMMENT('%', '$'),
      {
        className: 'number',
        begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
        relevance: 0
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        begin: '\\?(::)?([A-Z]\\w*(::)?)+'
      },
      {
        begin: '->'
      },
      {
        begin: 'ok'
      },
      {
        begin: '!'
      },
      {
        begin: '(\\b[a-z\'][a-zA-Z0-9_\']*:[a-z\'][a-zA-Z0-9_\']*)|(\\b[a-z\'][a-zA-Z0-9_\']*)',
        relevance: 0
      },
      {
        begin: '[A-Z][a-zA-Z0-9_\']*',
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('erlang', function(hljs) {
  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
  var ERLANG_RESERVED = {
    keyword:
      'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' +
      'let not of orelse|10 query receive rem try when xor',
    literal:
      'false true'
  };

  var COMMENT = hljs.COMMENT('%', '$');
  var NUMBER = {
    className: 'number',
    begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
    relevance: 0
  };
  var NAMED_FUN = {
    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
  };
  var FUNCTION_CALL = {
    begin: FUNCTION_NAME_RE + '\\(', end: '\\)',
    returnBegin: true,
    relevance: 0,
    contains: [
      {
        begin: FUNCTION_NAME_RE, relevance: 0
      },
      {
        begin: '\\(', end: '\\)', endsWithParent: true,
        returnEnd: true,
        relevance: 0
        // "contains" defined later
      }
    ]
  };
  var TUPLE = {
    begin: '{', end: '}',
    relevance: 0
    // "contains" defined later
  };
  var VAR1 = {
    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
    relevance: 0
  };
  var VAR2 = {
    begin: '[A-Z][a-zA-Z0-9_]*',
    relevance: 0
  };
  var RECORD_ACCESS = {
    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0,
    returnBegin: true,
    contains: [
      {
        begin: '#' + hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
      },
      {
        begin: '{', end: '}',
        relevance: 0
        // "contains" defined later
      }
    ]
  };

  var BLOCK_STATEMENTS = {
    beginKeywords: 'fun receive if try case', end: 'end',
    keywords: ERLANG_RESERVED
  };
  BLOCK_STATEMENTS.contains = [
    COMMENT,
    NAMED_FUN,
    hljs.inherit(hljs.APOS_STRING_MODE, {className: ''}),
    BLOCK_STATEMENTS,
    FUNCTION_CALL,
    hljs.QUOTE_STRING_MODE,
    NUMBER,
    TUPLE,
    VAR1, VAR2,
    RECORD_ACCESS
  ];

  var BASIC_MODES = [
    COMMENT,
    NAMED_FUN,
    BLOCK_STATEMENTS,
    FUNCTION_CALL,
    hljs.QUOTE_STRING_MODE,
    NUMBER,
    TUPLE,
    VAR1, VAR2,
    RECORD_ACCESS
  ];
  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
  TUPLE.contains = BASIC_MODES;
  RECORD_ACCESS.contains[1].contains = BASIC_MODES;

  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)',
    contains: BASIC_MODES
  };
  return {
    aliases: ['erl'],
    keywords: ERLANG_RESERVED,
    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
    contains: [
      {
        className: 'function',
        begin: '^' + BASIC_ATOM_RE + '\\s*\\(', end: '->',
        returnBegin: true,
        illegal: '\\(|#|//|/\\*|\\\\|:|;',
        contains: [
          PARAMS,
          hljs.inherit(hljs.TITLE_MODE, {begin: BASIC_ATOM_RE})
        ],
        starts: {
          end: ';|\\.',
          keywords: ERLANG_RESERVED,
          contains: BASIC_MODES
        }
      },
      COMMENT,
      {
        begin: '^-', end: '\\.',
        relevance: 0,
        excludeEnd: true,
        returnBegin: true,
        lexemes: '-' + hljs.IDENT_RE,
        keywords:
          '-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn ' +
          '-import -include -include_lib -compile -define -else -endif -file -behaviour ' +
          '-behavior -spec',
        contains: [PARAMS]
      },
      NUMBER,
      hljs.QUOTE_STRING_MODE,
      RECORD_ACCESS,
      VAR1, VAR2,
      TUPLE,
      {begin: /\.$/} // relevance booster
    ]
  };
});

hljs.registerLanguage('excel', function(hljs) {
  return {
    aliases: ['xlsx', 'xls'],
    case_insensitive: true,
    lexemes: /[a-zA-Z][\w\.]*/,
    // built-in functions imported from https://web.archive.org/web/20160513042710/https://support.office.com/en-us/article/Excel-functions-alphabetical-b3944572-255d-4efb-bb96-c6d90033e188
    keywords: {
        built_in: 'ABS ACCRINT ACCRINTM ACOS ACOSH ACOT ACOTH AGGREGATE ADDRESS AMORDEGRC AMORLINC AND ARABIC AREAS ASC ASIN ASINH ATAN ATAN2 ATANH AVEDEV AVERAGE AVERAGEA AVERAGEIF AVERAGEIFS BAHTTEXT BASE BESSELI BESSELJ BESSELK BESSELY BETADIST BETA.DIST BETAINV BETA.INV BIN2DEC BIN2HEX BIN2OCT BINOMDIST BINOM.DIST BINOM.DIST.RANGE BINOM.INV BITAND BITLSHIFT BITOR BITRSHIFT BITXOR CALL CEILING CEILING.MATH CEILING.PRECISE CELL CHAR CHIDIST CHIINV CHITEST CHISQ.DIST CHISQ.DIST.RT CHISQ.INV CHISQ.INV.RT CHISQ.TEST CHOOSE CLEAN CODE COLUMN COLUMNS COMBIN COMBINA COMPLEX CONCAT CONCATENATE CONFIDENCE CONFIDENCE.NORM CONFIDENCE.T CONVERT CORREL COS COSH COT COTH COUNT COUNTA COUNTBLANK COUNTIF COUNTIFS COUPDAYBS COUPDAYS COUPDAYSNC COUPNCD COUPNUM COUPPCD COVAR COVARIANCE.P COVARIANCE.S CRITBINOM CSC CSCH CUBEKPIMEMBER CUBEMEMBER CUBEMEMBERPROPERTY CUBERANKEDMEMBER CUBESET CUBESETCOUNT CUBEVALUE CUMIPMT CUMPRINC DATE DATEDIF DATEVALUE DAVERAGE DAY DAYS DAYS360 DB DBCS DCOUNT DCOUNTA DDB DEC2BIN DEC2HEX DEC2OCT DECIMAL DEGREES DELTA DEVSQ DGET DISC DMAX DMIN DOLLAR DOLLARDE DOLLARFR DPRODUCT DSTDEV DSTDEVP DSUM DURATION DVAR DVARP EDATE EFFECT ENCODEURL EOMONTH ERF ERF.PRECISE ERFC ERFC.PRECISE ERROR.TYPE EUROCONVERT EVEN EXACT EXP EXPON.DIST EXPONDIST FACT FACTDOUBLE FALSE|0 F.DIST FDIST F.DIST.RT FILTERXML FIND FINDB F.INV F.INV.RT FINV FISHER FISHERINV FIXED FLOOR FLOOR.MATH FLOOR.PRECISE FORECAST FORECAST.ETS FORECAST.ETS.CONFINT FORECAST.ETS.SEASONALITY FORECAST.ETS.STAT FORECAST.LINEAR FORMULATEXT FREQUENCY F.TEST FTEST FV FVSCHEDULE GAMMA GAMMA.DIST GAMMADIST GAMMA.INV GAMMAINV GAMMALN GAMMALN.PRECISE GAUSS GCD GEOMEAN GESTEP GETPIVOTDATA GROWTH HARMEAN HEX2BIN HEX2DEC HEX2OCT HLOOKUP HOUR HYPERLINK HYPGEOM.DIST HYPGEOMDIST IF|0 IFERROR IFNA IFS IMABS IMAGINARY IMARGUMENT IMCONJUGATE IMCOS IMCOSH IMCOT IMCSC IMCSCH IMDIV IMEXP IMLN IMLOG10 IMLOG2 IMPOWER IMPRODUCT IMREAL IMSEC IMSECH IMSIN IMSINH IMSQRT IMSUB IMSUM IMTAN INDEX INDIRECT INFO INT INTERCEPT INTRATE IPMT IRR ISBLANK ISERR ISERROR ISEVEN ISFORMULA ISLOGICAL ISNA ISNONTEXT ISNUMBER ISODD ISREF ISTEXT ISO.CEILING ISOWEEKNUM ISPMT JIS KURT LARGE LCM LEFT LEFTB LEN LENB LINEST LN LOG LOG10 LOGEST LOGINV LOGNORM.DIST LOGNORMDIST LOGNORM.INV LOOKUP LOWER MATCH MAX MAXA MAXIFS MDETERM MDURATION MEDIAN MID MIDBs MIN MINIFS MINA MINUTE MINVERSE MIRR MMULT MOD MODE MODE.MULT MODE.SNGL MONTH MROUND MULTINOMIAL MUNIT N NA NEGBINOM.DIST NEGBINOMDIST NETWORKDAYS NETWORKDAYS.INTL NOMINAL NORM.DIST NORMDIST NORMINV NORM.INV NORM.S.DIST NORMSDIST NORM.S.INV NORMSINV NOT NOW NPER NPV NUMBERVALUE OCT2BIN OCT2DEC OCT2HEX ODD ODDFPRICE ODDFYIELD ODDLPRICE ODDLYIELD OFFSET OR PDURATION PEARSON PERCENTILE.EXC PERCENTILE.INC PERCENTILE PERCENTRANK.EXC PERCENTRANK.INC PERCENTRANK PERMUT PERMUTATIONA PHI PHONETIC PI PMT POISSON.DIST POISSON POWER PPMT PRICE PRICEDISC PRICEMAT PROB PRODUCT PROPER PV QUARTILE QUARTILE.EXC QUARTILE.INC QUOTIENT RADIANS RAND RANDBETWEEN RANK.AVG RANK.EQ RANK RATE RECEIVED REGISTER.ID REPLACE REPLACEB REPT RIGHT RIGHTB ROMAN ROUND ROUNDDOWN ROUNDUP ROW ROWS RRI RSQ RTD SEARCH SEARCHB SEC SECH SECOND SERIESSUM SHEET SHEETS SIGN SIN SINH SKEW SKEW.P SLN SLOPE SMALL SQL.REQUEST SQRT SQRTPI STANDARDIZE STDEV STDEV.P STDEV.S STDEVA STDEVP STDEVPA STEYX SUBSTITUTE SUBTOTAL SUM SUMIF SUMIFS SUMPRODUCT SUMSQ SUMX2MY2 SUMX2PY2 SUMXMY2 SWITCH SYD T TAN TANH TBILLEQ TBILLPRICE TBILLYIELD T.DIST T.DIST.2T T.DIST.RT TDIST TEXT TEXTJOIN TIME TIMEVALUE T.INV T.INV.2T TINV TODAY TRANSPOSE TREND TRIM TRIMMEAN TRUE|0 TRUNC T.TEST TTEST TYPE UNICHAR UNICODE UPPER VALUE VAR VAR.P VAR.S VARA VARP VARPA VDB VLOOKUP WEBSERVICE WEEKDAY WEEKNUM WEIBULL WEIBULL.DIST WORKDAY WORKDAY.INTL XIRR XNPV XOR YEAR YEARFRAC YIELD YIELDDISC YIELDMAT Z.TEST ZTEST'
    },
    contains: [
      {
        /* matches a beginning equal sign found in Excel formula examples */ 
        begin: /^=/,
        end: /[^=]/, returnEnd: true, illegal: /=/, /* only allow single equal sign at front of line */
        relevance: 10
      },
      /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */
      {
        /* matches a reference to a single cell */
        className: 'symbol',
        begin: /\b[A-Z]{1,2}\d+\b/,
        end: /[^\d]/, excludeEnd: true,
        relevance: 0
      },
      {
        /* matches a reference to a range of cells */
        className: 'symbol',
        begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
        relevance: 0
      },
      hljs.BACKSLASH_ESCAPE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        begin: hljs.NUMBER_RE + '(%)?',
        relevance: 0
      },
      /* Excel formula comments are done by putting the comment in a function call to N() */
      hljs.COMMENT(/\bN\(/,/\)/,
      {
        excludeBegin: true,
        excludeEnd: true,
        illegal: /\n/
      })
    ]
  };
});

hljs.registerLanguage('fix', function(hljs) {
  return {
    contains: [
    {
      begin: /[^\u2401\u0001]+/,
      end: /[\u2401\u0001]/,
      excludeEnd: true,
      returnBegin: true,
      returnEnd: false,
      contains: [
      {
        begin: /([^\u2401\u0001=]+)/,
        end: /=([^\u2401\u0001=]+)/,
        returnEnd: true,
        returnBegin: false,
        className: 'attr'
      },
      {
        begin: /=/,
        end: /([\u2401\u0001])/,
        excludeEnd: true,
        excludeBegin: true,
        className: 'string'
      }]
    }],
    case_insensitive: true
  };
});

hljs.registerLanguage('flix', function (hljs) {

    var CHAR = {
        className: 'string',
        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    };

    var STRING = {
        className: 'string',
        variants: [
            {
                begin: '"', end: '"'
            }
        ]
    };

    var NAME = {
        className: 'title',
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
    };

    var METHOD = {
        className: 'function',
        beginKeywords: 'def',
        end: /[:={\[(\n;]/,
        excludeEnd: true,
        contains: [NAME]
    };

    return {
        keywords: {
            literal: 'true false',
            keyword: 'case class def else enum if impl import in lat rel index let match namespace switch type yield with'
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            CHAR,
            STRING,
            METHOD,
            hljs.C_NUMBER_MODE
        ]
    };
});

hljs.registerLanguage('fortran', function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var F_KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do while private call intrinsic where elsewhere ' +
      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
      'goto save else use module select case ' +
      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
      'continue format pause cycle exit ' +
      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
      'integer real character complex logical dimension allocatable|10 parameter ' +
      'external implicit|10 none double precision assign intent optional pointer ' +
      'target in out common equivalence data',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
      'num_images parity popcnt poppar shifta shiftl shiftr this_image'
  };
  return {
    case_insensitive: true,
    aliases: ['f90', 'f95'],
    keywords: F_KEYWORDS,
    illegal: /\/\*/,
    contains: [
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
      {
        className: 'function',
        beginKeywords: 'subroutine function program',
        illegal: '[${=\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      },
      hljs.COMMENT('!', '$', {relevance: 0}),
      {
        className: 'number',
        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('fsharp', function(hljs) {
  var TYPEPARAM = {
    begin: '<', end: '>',
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {begin: /'[a-zA-Z0-9_]+/})
    ]
  };

  return {
    aliases: ['fs'],
    keywords:
      'abstract and as assert base begin class default delegate do done ' +
      'downcast downto elif else end exception extern false finally for ' +
      'fun function global if in inherit inline interface internal lazy let ' +
      'match member module mutable namespace new null of open or ' +
      'override private public rec return sig static struct then to ' +
      'true try type upcast use val void when while with yield',
    illegal: /\/\*/,
    contains: [
      {
        // monad builder keywords (matches before non-bang kws)
        className: 'keyword',
        begin: /\b(yield|return|let|do)!/
      },
      {
        className: 'string',
        begin: '@"', end: '"',
        contains: [{begin: '""'}]
      },
      {
        className: 'string',
        begin: '"""', end: '"""'
      },
      hljs.COMMENT('\\(\\*', '\\*\\)'),
      {
        className: 'class',
        beginKeywords: 'type', end: '\\(|=|$', excludeEnd: true,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          TYPEPARAM
        ]
      },
      {
        className: 'meta',
        begin: '\\[<', end: '>\\]',
        relevance: 10
      },
      {
        className: 'symbol',
        begin: '\\B(\'[A-Za-z])\\b',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('gams', function (hljs) {
  var KEYWORDS = {
    'keyword':
      'abort acronym acronyms alias all and assign binary card diag display ' +
      'else eq file files for free ge gt if integer le loop lt maximizing ' +
      'minimizing model models ne negative no not option options or ord ' +
      'positive prod put putpage puttl repeat sameas semicont semiint smax ' +
      'smin solve sos1 sos2 sum system table then until using while xor yes',
    'literal': 'eps inf na',
    'built-in':
      'abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy ' +
      'cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact ' +
      'floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max ' +
      'min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power ' +
      'randBinomial randLinear randTriangle round rPower sigmoid sign ' +
      'signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt ' +
      'tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp ' +
      'bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt ' +
      'rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear ' +
      'jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion ' +
      'handleCollect handleDelete handleStatus handleSubmit heapFree ' +
      'heapLimit heapSize jobHandle jobKill jobStatus jobTerminate ' +
      'licenseLevel licenseStatus maxExecError sleep timeClose timeComp ' +
      'timeElapsed timeExec timeStart'
  };
  var PARAMS = {
    className: 'params',
    begin: /\(/, end: /\)/,
    excludeBegin: true,
    excludeEnd: true,
  };
  var SYMBOLS = {
    className: 'symbol',
    variants: [
      {begin: /\=[lgenxc]=/},
      {begin: /\$/},
    ]
  };
  var QSTR = { // One-line quoted comment string
    className: 'comment',
    variants: [
      {begin: '\'', end: '\''},
      {begin: '"', end: '"'},
    ],
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var ASSIGNMENT = {
    begin: '/',
    end: '/',
    keywords: KEYWORDS,
    contains: [
      QSTR,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      hljs.C_NUMBER_MODE,
    ],
  };
  var DESCTEXT = { // Parameter/set/variable description text
    begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
    excludeBegin: true,
    end: '$',
    endsWithParent: true,
    contains: [
      QSTR,
      ASSIGNMENT,
      {
        className: 'comment',
        begin: /([ ]*[a-z0-9&#*=?@>\\<:\-,()$\[\]_.{}!+%^]+)+/,
        relevance: 0
      },
    ],
  };

  return {
    aliases: ['gms'],
    case_insensitive: true,
    keywords: KEYWORDS,
    contains: [
      hljs.COMMENT(/^\$ontext/, /^\$offtext/),
      {
        className: 'meta',
        begin: '^\\$[a-z0-9]+',
        end: '$',
        returnBegin: true,
        contains: [
          {
            className: 'meta-keyword',
            begin: '^\\$[a-z0-9]+',
          }
        ]
      },
      hljs.COMMENT('^\\*', '$'),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      // Declarations
      {
        beginKeywords:
          'set sets parameter parameters variable variables ' +
          'scalar scalars equation equations',
        end: ';',
        contains: [
          hljs.COMMENT('^\\*', '$'),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          ASSIGNMENT,
          DESCTEXT,
        ]
      },
      { // table environment
        beginKeywords: 'table',
        end: ';',
        returnBegin: true,
        contains: [
          { // table header row
            beginKeywords: 'table',
            end: '$',
            contains: [DESCTEXT],
          },
          hljs.COMMENT('^\\*', '$'),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          hljs.C_NUMBER_MODE,
          // Table does not contain DESCTEXT or ASSIGNMENT
        ]
      },
      // Function definitions
      {
        className: 'function',
        begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
        returnBegin: true,
        contains: [
              { // Function title
                className: 'title',
                begin: /^[a-z][a-z0-9_]+/,
              },
              PARAMS,
              SYMBOLS,
            ],
      },
      hljs.C_NUMBER_MODE,
      SYMBOLS,
    ]
  };
});

hljs.registerLanguage('gauss', function(hljs) {
  var KEYWORDS = {
    keyword: 'and bool break call callexe checkinterrupt clear clearg closeall cls comlog compile ' +
              'continue create debug declare delete disable dlibrary dllcall do dos ed edit else ' +
              'elseif enable end endfor endif endp endo errorlog errorlogat expr external fn ' +
              'for format goto gosub graph if keyword let lib library line load loadarray loadexe ' +
              'loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow ' +
              'matrix msym ndpclex new not open or output outwidth plot plotsym pop prcsn print ' +
              'printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen ' +
              'scroll setarray show sparse stop string struct system trace trap threadfor ' +
              'threadendfor threadbegin threadjoin threadstat threadend until use while winprint',
    built_in: 'abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol ' +
              'AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks ' +
              'AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults ' +
              'annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness ' +
              'annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd ' +
              'astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar ' +
              'base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 ' +
              'cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv ' +
              'cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn ' +
              'cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi ' +
              'cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ' +
              'ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated ' +
              'complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs ' +
              'cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos ' +
              'datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd ' +
              'dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName ' +
              'dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy ' +
              'dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen ' +
              'dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA ' +
              'dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField ' +
              'dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition ' +
              'dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows ' +
              'dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly ' +
              'dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy ' +
              'dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl ' +
              'dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt ' +
              'dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday ' +
              'dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays ' +
              'endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error ' +
              'etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut ' +
              'EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol ' +
              'EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq ' +
              'feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt ' +
              'floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC ' +
              'gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders ' +
              'gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse ' +
              'gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray ' +
              'getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders ' +
              'getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT ' +
              'gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm ' +
              'hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 ' +
              'indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 ' +
              'inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf ' +
              'isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv ' +
              'lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn ' +
              'lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind ' +
              'loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars ' +
              'makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli ' +
              'mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave ' +
              'movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate ' +
              'olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto ' +
              'pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox ' +
              'plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea ' +
              'plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout ' +
              'plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill ' +
              'plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol ' +
              'plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange ' +
              'plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel ' +
              'plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot ' +
              'pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames ' +
              'pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector ' +
              'pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate ' +
              'qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr ' +
              'real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn ' +
              'rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel ' +
              'rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn ' +
              'rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh ' +
              'rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind ' +
              'scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa ' +
              'setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind ' +
              'sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL ' +
              'spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense ' +
              'spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet ' +
              'sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt ' +
              'strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr ' +
              'surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname threadBegin threadEnd threadEndFor threadFor ' +
              'threadJoin threadStat time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk ' +
              'trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt ' +
              'utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs ' +
              'vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window ' +
              'writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM ' +
              'xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute ' +
              'h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels ' +
              'plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin strtrim sylvester',
    literal: 'DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS ' +
             'DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 ' +
             'DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS ' +
             'DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES ' +
             'DB_TRANSACTIONS DB_UNICODE DB_VIEWS'
  };

  var PREPROCESSOR =
  {
    className: 'meta',
    begin: '#', end: '$',
    keywords: {'meta-keyword': 'define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline'},
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      {
        beginKeywords: 'include', end: '$',
        keywords: {'meta-keyword': 'include'},
        contains: [
          {
            className: 'meta-string',
            begin: '"', end: '"',
            illegal: '\\n'
          }
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var FUNCTION_TITLE = hljs.UNDERSCORE_IDENT_RE + '\\s*\\(?';
  var PARSE_PARAMS = [
    {
      className: 'params',
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      relevance: 0,
      contains: [
        hljs.C_NUMBER_MODE,
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE
      ]
    }
  ];

  return {
    aliases: ['gss'],
    case_insensitive: true, // language is case-insensitive
    keywords: KEYWORDS,
    illegal: '(\\{[%#]|[%#]\\})',
    contains: [
      hljs.C_NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT('@', '@'),
      PREPROCESSOR,
      {
        className: 'string',
        begin: '"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        className: 'function',
        beginKeywords: 'proc keyword',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.UNDERSCORE_TITLE_MODE],
            relevance: 0
          },
          hljs.C_NUMBER_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          PREPROCESSOR
        ].concat(PARSE_PARAMS)
      },
      {
        className: 'function',
        beginKeywords: 'fn',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: FUNCTION_TITLE + hljs.IDENT_RE + '\\)?\\s*\\=\\s*', returnBegin: true,
            contains: [hljs.UNDERSCORE_TITLE_MODE],
            relevance: 0
          },
          hljs.C_NUMBER_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ].concat(PARSE_PARAMS)
      },
      {
        className: 'function',
        begin: '\\bexternal (proc|keyword|fn)\\s+',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.UNDERSCORE_TITLE_MODE],
            relevance: 0
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: 'function',
        begin: '\\bexternal (matrix|string|array|sparse matrix|struct ' + hljs.IDENT_RE + ')\\s+',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      }
    ]
  };
});

hljs.registerLanguage('gcode', function(hljs) {
    var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
    var GCODE_CLOSE_RE = '\\%';
    var GCODE_KEYWORDS =
      'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' +
      'EQ LT GT NE GE LE OR XOR';
    var GCODE_START = {
        className: 'meta',
        begin: '([O])([0-9]+)'
    };
    var GCODE_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT(/\(/, /\)/),
        hljs.inherit(hljs.C_NUMBER_MODE, {begin: '([-+]?([0-9]*\\.?[0-9]+\\.?))|' + hljs.C_NUMBER_RE}),
        hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
        {
            className: 'name',
            begin: '([G])([0-9]+\\.?[0-9]?)'
        },
        {
            className: 'name',
            begin: '([M])([0-9]+\\.?[0-9]?)'
        },
        {
            className: 'attr',
            begin: '(VC|VS|#)',
            end: '(\\d+)'
        },
        {
            className: 'attr',
            begin: '(VZOFX|VZOFY|VZOFZ)'
        },
        {
            className: 'built_in',
            begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
            end: '([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])'
        },
        {
            className: 'symbol',
            variants: [
                {
                    begin: 'N', end: '\\d+',
                    illegal: '\\W'
                }
            ]
        }
    ];

    return {
        aliases: ['nc'],
        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
        // However, most prefer all uppercase and uppercase is customary.
        case_insensitive: true,
        lexemes: GCODE_IDENT_RE,
        keywords: GCODE_KEYWORDS,
        contains: [
            {
                className: 'meta',
                begin: GCODE_CLOSE_RE
            },
            GCODE_START
        ].concat(GCODE_CODE)
    };
});

hljs.registerLanguage('gherkin', function (hljs) {
  return {
    aliases: ['feature'],
    keywords: 'Feature Background Ability Business\ Need Scenario Scenarios Scenario\ Outline Scenario\ Template Examples Given And Then But When',
    contains: [
      {
        className: 'symbol',
        begin: '\\*',
        relevance: 0
      },
      {
        className: 'meta',
        begin: '@[^@\\s]+'
      },
      {
        begin: '\\|', end: '\\|\\w*$',
        contains: [
          {
            className: 'string',
            begin: '[^|]+'
          }
        ]
      },
      {
        className: 'variable',
        begin: '<', end: '>'
      },
      hljs.HASH_COMMENT_MODE,
      {
        className: 'string',
        begin: '"""', end: '"""'
      },
      hljs.QUOTE_STRING_MODE
    ]
  };
});

hljs.registerLanguage('glsl', function(hljs) {
  return {
    keywords: {
      keyword:
        // Statements
        'break continue discard do else for if return while switch case default ' +
        // Qualifiers
        'attribute binding buffer ccw centroid centroid varying coherent column_major const cw ' +
        'depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing ' +
        'flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant ' +
        'invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y ' +
        'local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left ' +
        'out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f '+
        'r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict ' +
        'rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 ' +
        'rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 ' +
        'rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip ' +
        'triangles triangles_adjacency uniform varying vertices volatile writeonly',
      type:
        'atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 ' +
        'dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray ' +
        'iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer' +
        'iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray ' +
        'image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray ' +
        'isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D ' +
        'isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 ' +
        'mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray ' +
        'sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow ' +
        'sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D ' +
        'samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow ' +
        'image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect ' +
        'uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray ' +
        'usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D ' +
        'samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void',
      built_in:
        // Constants
        'gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes ' +
        'gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms ' +
        'gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers ' +
        'gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits ' +
        'gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize ' +
        'gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters ' +
        'gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors ' +
        'gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers ' +
        'gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents ' +
        'gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits ' +
        'gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents ' +
        'gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset ' +
        'gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms ' +
        'gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits ' +
        'gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents ' +
        'gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters ' +
        'gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents ' +
        'gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents ' +
        'gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits ' +
        'gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors ' +
        'gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms ' +
        'gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits ' +
        'gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset ' +
        // Variables
        'gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial ' +
        'gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color ' +
        'gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord ' +
        'gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor ' +
        'gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial ' +
        'gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel ' +
        'gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix ' +
        'gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose ' +
        'gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose ' +
        'gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 ' +
        'gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 ' +
        'gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ ' +
        'gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord ' +
        'gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse ' +
        'gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask ' +
        'gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter ' +
        'gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose ' +
        'gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out ' +
        // Functions
        'EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin ' +
        'asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement ' +
        'atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier ' +
        'bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross ' +
        'dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB ' +
        'floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan ' +
        'greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap ' +
        'imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad ' +
        'imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset ' +
        'interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log ' +
        'log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer ' +
        'memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 ' +
        'normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 ' +
        'packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod ' +
        'shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh ' +
        'smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod ' +
        'texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod ' +
        'texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod ' +
        'textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset ' +
        'textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset ' +
        'textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod ' +
        'textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 ' +
        'unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow',
      literal: 'true false'
    },
    illegal: '"',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$'
      }
    ]
  };
});

hljs.registerLanguage('go', function(hljs) {
  var GO_KEYWORDS = {
    keyword:
      'break default func interface select case map struct chan else goto package switch ' +
      'const fallthrough if range type continue for import return var go defer ' +
      'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' +
      'uint16 uint32 uint64 int uint uintptr rune',
    literal:
       'true false iota nil',
    built_in:
      'append cap close complex copy imag len make new panic print println real recover delete'
  };
  return {
    aliases: ['golang'],
    keywords: GO_KEYWORDS,
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'string',
        variants: [
          hljs.QUOTE_STRING_MODE,
          {begin: '\'', end: '[^\\\\]\''},
          {begin: '`', end: '`'},
        ]
      },
      {
        className: 'number',
        variants: [
          {begin: hljs.C_NUMBER_RE + '[dflsi]', relevance: 1},
          hljs.C_NUMBER_MODE
        ]
      },
      {
        begin: /:=/ // relevance booster
      },
      {
        className: 'function',
        beginKeywords: 'func', end: /\s*\{/, excludeEnd: true,
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: GO_KEYWORDS,
            illegal: /["']/
          }
        ]
      }
    ]
  };
});

hljs.registerLanguage('golo', function(hljs) {
    return {
      keywords: {
        keyword:
          'println readln print import module function local return let var ' +
          'while for foreach times in case when match with break continue ' +
          'augment augmentation each find filter reduce ' +
          'if then else otherwise try catch finally raise throw orIfNull ' +
          'DynamicObject|10 DynamicVariable struct Observable map set vector list array',
        literal:
          'true false null'
      },
      contains: [
        hljs.HASH_COMMENT_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.C_NUMBER_MODE,
        {
          className: 'meta', begin: '@[A-Za-z]+'
        }
      ]
    }
});

hljs.registerLanguage('gradle', function(hljs) {
  return {
    case_insensitive: true,
    keywords: {
      keyword:
        'task project allprojects subprojects artifacts buildscript configurations ' +
        'dependencies repositories sourceSets description delete from into include ' +
        'exclude source classpath destinationDir includes options sourceCompatibility ' +
        'targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant ' +
        'def abstract break case catch continue default do else extends final finally ' +
        'for if implements instanceof native new private protected public return static ' +
        'switch synchronized throw throws transient try volatile while strictfp package ' +
        'import false null super this true antlrtask checkstyle codenarc copy boolean ' +
        'byte char class double float int interface long short void compile runTime ' +
        'file fileTree abs any append asList asWritable call collect compareTo count ' +
        'div dump each eachByte eachFile eachLine every find findAll flatten getAt ' +
        'getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods ' +
        'isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter ' +
        'newReader newWriter next plus pop power previous print println push putAt read ' +
        'readBytes readLines reverse reverseEach round size sort splitEachLine step subMap ' +
        'times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader ' +
        'withStream withWriter withWriterAppend write writeLine'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.REGEXP_MODE

    ]
  }
});

hljs.registerLanguage('groovy', function(hljs) {
    return {
        keywords: {
            literal : 'true false null',
            keyword:
            'byte short char int long boolean float double void ' +
            // groovy specific keywords
            'def as in assert trait ' +
            // common keywords with Java
            'super this abstract static volatile transient public private protected synchronized final ' +
            'class interface enum if else for while switch case break default continue ' +
            'throw throws try catch finally implements extends new import package return instanceof'
        },

        contains: [
            hljs.COMMENT(
                '/\\*\\*',
                '\\*/',
                {
                    relevance : 0,
                    contains : [
                      {
                          // eat up @'s in emails to prevent them to be recognized as doctags
                          begin: /\w+@/, relevance: 0
                      },
                      {
                          className : 'doctag',
                          begin : '@[A-Za-z]+'
                      }
                    ]
                }
            ),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: 'string',
                begin: '"""', end: '"""'
            },
            {
                className: 'string',
                begin: "'''", end: "'''"
            },
            {
                className: 'string',
                begin: "\\$/", end: "/\\$",
                relevance: 10
            },
            hljs.APOS_STRING_MODE,
            {
                className: 'regexp',
                begin: /~?\/[^\/\n]+\//,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: 'meta',
                begin: "^#!/usr/bin/env", end: '$',
                illegal: '\n'
            },
            hljs.BINARY_NUMBER_MODE,
            {
                className: 'class',
                beginKeywords: 'class interface trait enum', end: '{',
                illegal: ':',
                contains: [
                    {beginKeywords: 'extends implements'},
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                className: 'meta', begin: '@[A-Za-z]+'
            },
            {
                // highlight map keys and named parameters as strings
                className: 'string', begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
            },
            {
                // catch middle element of the ternary operator
                // to avoid highlight it as a label, named parameter, or map key
                begin: /\?/, end: /\:/
            },
            {
                // highlight labeled statements
                className: 'symbol', begin: '^\\s*[A-Za-z0-9_$]+:',
                relevance: 0
            }
        ],
        illegal: /#|<\//
    }
});

hljs.registerLanguage('haml', // TODO support filter tags like :javascript, support inline HTML
function(hljs) {
  return {
    case_insensitive: true,
    contains: [
      {
        className: 'meta',
        begin: '^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$',
        relevance: 10
      },
      // FIXME these comments should be allowed to span indented lines
      hljs.COMMENT(
        '^\\s*(!=#|=#|-#|/).*$',
        false,
        {
          relevance: 0
        }
      ),
      {
        begin: '^\\s*(-|=|!=)(?!#)',
        starts: {
          end: '\\n',
          subLanguage: 'ruby'
        }
      },
      {
        className: 'tag',
        begin: '^\\s*%',
        contains: [
          {
            className: 'selector-tag',
            begin: '\\w+'
          },
          {
            className: 'selector-id',
            begin: '#[\\w-]+'
          },
          {
            className: 'selector-class',
            begin: '\\.[\\w-]+'
          },
          {
            begin: '{\\s*',
            end: '\\s*}',
            contains: [
              {
                begin: ':\\w+\\s*=>',
                end: ',\\s+',
                returnBegin: true,
                endsWithParent: true,
                contains: [
                  {
                    className: 'attr',
                    begin: ':\\w+'
                  },
                  hljs.APOS_STRING_MODE,
                  hljs.QUOTE_STRING_MODE,
                  {
                    begin: '\\w+',
                    relevance: 0
                  }
                ]
              }
            ]
          },
          {
            begin: '\\(\\s*',
            end: '\\s*\\)',
            excludeEnd: true,
            contains: [
              {
                begin: '\\w+\\s*=',
                end: '\\s+',
                returnBegin: true,
                endsWithParent: true,
                contains: [
                  {
                    className: 'attr',
                    begin: '\\w+',
                    relevance: 0
                  },
                  hljs.APOS_STRING_MODE,
                  hljs.QUOTE_STRING_MODE,
                  {
                    begin: '\\w+',
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        begin: '^\\s*[=~]\\s*'
      },
      {
        begin: '#{',
        starts: {
          end: '}',
          subLanguage: 'ruby'
        }
      }
    ]
  };
});

hljs.registerLanguage('handlebars', function(hljs) {
  var BUILT_INS = {'builtin-name': 'each in with if else unless bindattr action collection debugger log outlet template unbound view yield'};
  return {
    aliases: ['hbs', 'html.hbs', 'html.handlebars'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
    hljs.COMMENT('{{!(--)?', '(--)?}}'),
      {
        className: 'template-tag',
        begin: /\{\{[#\/]/, end: /\}\}/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.-]+/,
            keywords: BUILT_INS,
            starts: {
              endsWithParent: true, relevance: 0,
              contains: [
                hljs.QUOTE_STRING_MODE
              ]
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /\}\}/,
        keywords: BUILT_INS
      }
    ]
  };
});

hljs.registerLanguage('haskell', function(hljs) {
  var COMMENT = {
    variants: [
      hljs.COMMENT('--', '$'),
      hljs.COMMENT(
        '{-',
        '-}',
        {
          contains: ['self']
        }
      )
    ]
  };

  var PRAGMA = {
    className: 'meta',
    begin: '{-#', end: '#-}'
  };

  var PREPROCESSOR = {
    className: 'meta',
    begin: '^#', end: '$'
  };

  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
    relevance: 0
  };

  var LIST = {
    begin: '\\(', end: '\\)',
    illegal: '"',
    contains: [
      PRAGMA,
      PREPROCESSOR,
      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
      hljs.inherit(hljs.TITLE_MODE, {begin: '[_a-z][\\w\']*'}),
      COMMENT
    ]
  };

  var RECORD = {
    begin: '{', end: '}',
    contains: LIST.contains
  };

  return {
    aliases: ['hs'],
    keywords:
      'let in if then else case of where do module import hiding ' +
      'qualified type data newtype deriving class instance as default ' +
      'infix infixl infixr foreign export ccall stdcall cplusplus ' +
      'jvm dotnet safe unsafe family forall mdo proc rec',
    contains: [

      // Top-level constructions.

      {
        beginKeywords: 'module', end: 'where',
        keywords: 'module where',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: '\\bimport\\b', end: '$',
        keywords: 'import qualified as hiding',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },

      {
        className: 'class',
        begin: '^(\\s*)?(class|instance)\\b', end: 'where',
        keywords: 'class family instance where',
        contains: [CONSTRUCTOR, LIST, COMMENT]
      },
      {
        className: 'class',
        begin: '\\b(data|(new)?type)\\b', end: '$',
        keywords: 'data family type newtype deriving',
        contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD, COMMENT]
      },
      {
        beginKeywords: 'default', end: '$',
        contains: [CONSTRUCTOR, LIST, COMMENT]
      },
      {
        beginKeywords: 'infix infixl infixr', end: '$',
        contains: [hljs.C_NUMBER_MODE, COMMENT]
      },
      {
        begin: '\\bforeign\\b', end: '$',
        keywords: 'foreign import export ccall stdcall cplusplus jvm ' +
                  'dotnet safe unsafe',
        contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE, COMMENT]
      },
      {
        className: 'meta',
        begin: '#!\\/usr\\/bin\\/env\ runhaskell', end: '$'
      },

      // "Whitespaces".

      PRAGMA,
      PREPROCESSOR,

      // Literals and names.

      // TODO: characters.
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      CONSTRUCTOR,
      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),

      COMMENT,

      {begin: '->|<-'} // No markup, relevance booster
    ]
  };
});

hljs.registerLanguage('haxe', function(hljs) {
  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';

  var HAXE_BASIC_TYPES = 'Int Float String Bool Dynamic Void Array ';

  return {
    aliases: ['hx'],
    keywords: {
      keyword: 'break callback case cast catch continue default do dynamic else enum extern ' +
               'for function here if import in inline never new override package private get set ' +
               'public return static super switch this throw trace try typedef untyped using var while ' +
               HAXE_BASIC_TYPES,
      built_in:
        'trace this',
      literal:
        'true false null _'
    },
    contains: [
      { className: 'string', // interpolate-able strings
        begin: '\'', end: '\'',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          { className: 'subst', // interpolation
            begin: '\\$\\{', end: '\\}'
          },
          { className: 'subst', // interpolation
            begin: '\\$', end: '\\W}'
          }
        ]
      },
      hljs.QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      { className: 'meta', // compiler meta
        begin: '@:', end: '$'
      },
      { className: 'meta', // compiler conditionals
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elseif end error'}
      },
      { className: 'type', // function types
        begin: ':[ \t]*', end: '[^A-Za-z0-9_ \t\\->]',
        excludeBegin: true, excludeEnd: true,
        relevance: 0
      },
      { className: 'type', // types
        begin: ':[ \t]*', end: '\\W',
        excludeBegin: true, excludeEnd: true
      },
      { className: 'type', // instantiation
        begin: 'new *', end: '\\W',
        excludeBegin: true, excludeEnd: true
      },
      { className: 'class', // enums
        beginKeywords: 'enum', end: '\\{',
        contains: [
          hljs.TITLE_MODE
        ]
      },
      { className: 'class', // abstracts
        beginKeywords: 'abstract', end: '[\\{$]',
        contains: [
          { className: 'type',
            begin: '\\(', end: '\\)',
            excludeBegin: true, excludeEnd: true
          },
          { className: 'type',
            begin: 'from +', end: '\\W',
            excludeBegin: true, excludeEnd: true
          },
          { className: 'type',
            begin: 'to +', end: '\\W',
            excludeBegin: true, excludeEnd: true
          },
          hljs.TITLE_MODE
        ],
        keywords: {
          keyword: 'abstract from to'
        }
      },
      { className: 'class', // classes
        begin: '\\b(class|interface) +', end: '[\\{$]',  excludeEnd: true,
        keywords: 'class interface',
        contains: [
          { className: 'keyword',
            begin: '\\b(extends|implements) +',
            keywords: 'extends implements',
            contains: [
              {
                className: 'type',
                begin: hljs.IDENT_RE,
                relevance: 0
              }
            ]
          },
          hljs.TITLE_MODE
        ]
      },
      { className: 'function',
        beginKeywords: 'function', end: '\\(', excludeEnd: true,
        illegal: '\\S',
        contains: [
          hljs.TITLE_MODE
        ]
      }
    ],
    illegal: /<\//
  };
});

hljs.registerLanguage('hsp', function(hljs) {
  return {
    case_insensitive: true,
    lexemes: /[\w\._]+/,
    keywords: 'goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,

      {
        // multi-line string
        className: 'string',
        begin: '{"', end: '"}',
        contains: [hljs.BACKSLASH_ESCAPE]
      },

      hljs.COMMENT(';', '$', {relevance: 0}),

      {
        // pre-processor
        className: 'meta',
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib'},
        contains: [
          hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'meta-string'}),
          hljs.NUMBER_MODE,
          hljs.C_NUMBER_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },

      {
        // label
        className: 'symbol',
        begin: '^\\*(\\w+|@)'
      },

      hljs.NUMBER_MODE,
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('htmlbars', function(hljs) {
  var BUILT_INS = 'action collection component concat debugger each each-in else get hash if input link-to loc log mut outlet partial query-params render textarea unbound unless with yield view';

  var ATTR_ASSIGNMENT = {
    illegal: /\}\}/,
    begin: /[a-zA-Z0-9_]+=/,
    returnBegin: true,
    relevance: 0,
    contains: [
      {
        className: 'attr', begin: /[a-zA-Z0-9_]+/
      }
    ]
  };

  var SUB_EXPR = {
    illegal: /\}\}/,
    begin: /\)/, end: /\)/,
    contains: [
      {
        begin: /[a-zA-Z\.\-]+/,
        keywords: {built_in: BUILT_INS},
        starts: {
          endsWithParent: true, relevance: 0,
          contains: [
            hljs.QUOTE_STRING_MODE,
          ]
        }
      }
    ]
  };

  var TAG_INNARDS = {
    endsWithParent: true, relevance: 0,
    keywords: {keyword: 'as', built_in: BUILT_INS},
    contains: [
      hljs.QUOTE_STRING_MODE,
      ATTR_ASSIGNMENT,
      hljs.NUMBER_MODE
    ]
  };

  return {
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT('{{!(--)?', '(--)?}}'),
      {
        className: 'template-tag',
        begin: /\{\{[#\/]/, end: /\}\}/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.\-]+/,
            keywords: {'builtin-name': BUILT_INS},
            starts: TAG_INNARDS
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{[a-zA-Z][a-zA-Z\-]+/, end: /\}\}/,
        keywords: {keyword: 'as', built_in: BUILT_INS},
        contains: [
          hljs.QUOTE_STRING_MODE
        ]
      }
    ]
  };
});

hljs.registerLanguage('http', function(hljs) {
  var VERSION = 'HTTP/[0-9\\.]+';
  return {
    aliases: ['https'],
    illegal: '\\S',
    contains: [
      {
        begin: '^' + VERSION, end: '$',
        contains: [{className: 'number', begin: '\\b\\d{3}\\b'}]
      },
      {
        begin: '^[A-Z]+ (.*?) ' + VERSION + '$', returnBegin: true, end: '$',
        contains: [
          {
            className: 'string',
            begin: ' ', end: ' ',
            excludeBegin: true, excludeEnd: true
          },
          {
            begin: VERSION
          },
          {
            className: 'keyword',
            begin: '[A-Z]+'
          }
        ]
      },
      {
        className: 'attribute',
        begin: '^\\w', end: ': ', excludeEnd: true,
        illegal: '\\n|\\s|=',
        starts: {end: '$', relevance: 0}
      },
      {
        begin: '\\n\\n',
        starts: {subLanguage: [], endsWithParent: true}
      }
    ]
  };
});

hljs.registerLanguage('hy', function(hljs) {
  var keywords = {
    'builtin-name':
      // keywords
      '!= % %= & &= * ** **= *= *map ' +
      '+ += , --build-class-- --import-- -= . / // //= ' +
      '/= < << <<= <= = > >= >> >>= ' +
      '@ @= ^ ^= abs accumulate all and any ap-compose ' +
      'ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ' +
      'ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast ' +
      'callable calling-module-name car case cdr chain chr coll? combinations compile ' +
      'compress cond cons cons? continue count curry cut cycle dec ' +
      'def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn ' +
      'defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir ' +
      'disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? ' +
      'end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first ' +
      'flatten float? fn fnc fnr for for* format fraction genexpr ' +
      'gensym get getattr global globals group-by hasattr hash hex id ' +
      'identity if if* if-not if-python2 import in inc input instance? ' +
      'integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even ' +
      'is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none ' +
      'is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass ' +
      'iter iterable? iterate iterator? keyword keyword? lambda last len let ' +
      'lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all ' +
      'map max merge-with method-decorator min multi-decorator multicombinations name neg? next ' +
      'none? nonlocal not not-in not? nth numeric? oct odd? open ' +
      'or ord partition permutations pos? post-route postwalk pow prewalk print ' +
      'product profile/calls profile/cpu put-route quasiquote quote raise range read read-str ' +
      'recursive-replace reduce remove repeat repeatedly repr require rest round route ' +
      'route-with-methods rwm second seq set-comp setattr setv some sorted string ' +
      'string? sum switch symbol? take take-nth take-while tee try unless ' +
      'unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms ' +
      'xi xor yield yield-from zero? zip zip-longest | |= ~'
   };

  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';

  var SHEBANG = {
    className: 'meta',
    begin: '^#!', end: '$'
  };

  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number', begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';',
    '$',
    {
      relevance: 0
    }
  );
  var LITERAL = {
    className: 'literal',
    begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]', end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    keywords: keywords,
    lexemes: SYMBOL_RE,
    className: 'name', begin: SYMBOL_RE,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];

  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;

  return {
    aliases: ['hylang'],
    illegal: /\S/,
    contains: [SHEBANG, LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  }
});

hljs.registerLanguage('inform7', function(hljs) {
  var START_BRACKET = '\\[';
  var END_BRACKET = '\\]';
  return {
    aliases: ['i7'],
    case_insensitive: true,
    keywords: {
      // Some keywords more or less unique to I7, for relevance.
      keyword:
        // kind:
        'thing room person man woman animal container ' +
        'supporter backdrop door ' +
        // characteristic:
        'scenery open closed locked inside gender ' +
        // verb:
        'is are say understand ' +
        // misc keyword:
        'kind of rule'
    },
    contains: [
      {
        className: 'string',
        begin: '"', end: '"',
        relevance: 0,
        contains: [
          {
            className: 'subst',
            begin: START_BRACKET, end: END_BRACKET
          }
        ]
      },
      {
        className: 'section',
        begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
        end: '$'
      },
      {
        // Rule definition
        // This is here for relevance.
        begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
        end: ':',
        contains: [
          {
            //Rule name
            begin: '\\(This', end: '\\)'
          }
        ]
      },
      {
        className: 'comment',
        begin: START_BRACKET, end: END_BRACKET,
        contains: ['self']
      }
    ]
  };
});

hljs.registerLanguage('ini', function(hljs) {
  var STRING = {
    className: "string",
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: "'''", end: "'''",
        relevance: 10
      }, {
        begin: '"""', end: '"""',
        relevance: 10
      }, {
        begin: '"', end: '"'
      }, {
        begin: "'", end: "'"
      }
    ]
  };
  return {
    aliases: ['toml'],
    case_insensitive: true,
    illegal: /\S/,
    contains: [
      hljs.COMMENT(';', '$'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'section',
        begin: /^\s*\[+/, end: /\]+/
      },
      {
        begin: /^[a-z0-9\[\]_-]+\s*=\s*/, end: '$',
        returnBegin: true,
        contains: [
          {
            className: 'attr',
            begin: /[a-z0-9\[\]_-]+/
          },
          {
            begin: /=/, endsWithParent: true,
            relevance: 0,
            contains: [
              {
                className: 'literal',
                begin: /\bon|off|true|false|yes|no\b/
              },
              {
                className: 'variable',
                variants: [
                  {begin: /\$[\w\d"][\w\d_]*/},
                  {begin: /\$\{(.*?)}/}
                ]
              },
              STRING,
              {
                className: 'number',
                begin: /([\+\-]+)?[\d]+_[\d_]+/
              },
              hljs.NUMBER_MODE
            ]
          }
        ]
      }
    ]
  };
});

hljs.registerLanguage('irpf90', function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var F_KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do while private call intrinsic where elsewhere ' +
      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
      'goto save else use module select case ' +
      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
      'continue format pause cycle exit ' +
      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
      'integer real character complex logical dimension allocatable|10 parameter ' +
      'external implicit|10 none double precision assign intent optional pointer ' +
      'target in out common equivalence data ' +
      // IRPF90 special keywords
      'begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch ' +
      'soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
      'num_images parity popcnt poppar shifta shiftl shiftr this_image ' +
      // IRPF90 special built_ins
      'IRP_ALIGN irp_here'
  };
  return {
    case_insensitive: true,
    keywords: F_KEYWORDS,
    illegal: /\/\*/,
    contains: [
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
      {
        className: 'function',
        beginKeywords: 'subroutine function program',
        illegal: '[${=\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      },
      hljs.COMMENT('!', '$', {relevance: 0}),
      hljs.COMMENT('begin_doc', 'end_doc', {relevance: 10}),
      {
        className: 'number',
        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('java', function(hljs) {
  var JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
  var GENERIC_IDENT_RE = JAVA_IDENT_RE + '(<' + JAVA_IDENT_RE + '(\\s*,\\s*' + JAVA_IDENT_RE + ')*>)?';
  var KEYWORDS =
    'false synchronized int abstract float private char boolean static null if const ' +
    'for true while long strictfp finally protected import native final void ' +
    'enum else break transient catch instanceof byte super volatile case assert short ' +
    'package default double public try this switch continue throws protected public private ' +
    'module requires exports do';

  // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
  var JAVA_NUMBER_RE = '\\b' +
    '(' +
      '0[bB]([01]+[01_]+[01]+|[01]+)' + // 0b...
      '|' +
      '0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)' + // 0x...
      '|' +
      '(' +
        '([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?' +
        '|' +
        '\\.([\\d]+[\\d_]+[\\d]+|[\\d]+)' +
      ')' +
      '([eE][-+]?\\d+)?' + // octal, decimal, float
    ')' +
    '[lLfF]?';
  var JAVA_NUMBER_MODE = {
    className: 'number',
    begin: JAVA_NUMBER_RE,
    relevance: 0
  };

  return {
    aliases: ['jsp'],
    keywords: KEYWORDS,
    illegal: /<\/|#/,
    contains: [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/, relevance: 0
            },
            {
              className : 'doctag',
              begin : '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface', end: /[{;=]/, excludeEnd: true,
        keywords: 'class interface',
        illegal: /[:"\[\]]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new throw return else',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      JAVA_NUMBER_MODE,
      {
        className: 'meta', begin: '@[A-Za-z]+'
      }
    ]
  };
});

hljs.registerLanguage('javascript', function(hljs) {
  var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var KEYWORDS = {
    keyword:
      'in of if for while finally var new function do return void else break catch ' +
      'instanceof with throw case default try this switch continue typeof delete ' +
      'let yield const export super debugger as async await static ' +
      // ECMAScript 6 modules import
      'import from as'
    ,
    literal:
      'true false null undefined NaN Infinity',
    built_in:
      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
      'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
      'Promise'
  };
  var EXPRESSIONS;
  var NUMBER = {
    className: 'number',
    variants: [
      { begin: '\\b(0[bB][01]+)' },
      { begin: '\\b(0[oO][0-7]+)' },
      { begin: hljs.C_NUMBER_RE }
    ],
    relevance: 0
  };
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{', end: '\\}',
    keywords: KEYWORDS,
    contains: []  // defined later
  };
  var TEMPLATE_STRING = {
    className: 'string',
    begin: '`', end: '`',
    contains: [
      hljs.BACKSLASH_ESCAPE,
      SUBST
    ]
  };
  SUBST.contains = [
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    TEMPLATE_STRING,
    NUMBER,
    hljs.REGEXP_MODE
  ]
  var PARAMS_CONTAINS = SUBST.contains.concat([
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.C_LINE_COMMENT_MODE
  ]);

  return {
    aliases: ['js', 'jsx'],
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      {
        className: 'meta',
        begin: /^#!/, end: /$/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      TEMPLATE_STRING,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBER,
      { // object attr container
        begin: /[{,]\s*/, relevance: 0,
        contains: [
          {
            begin: IDENT_RE + '\\s*:', returnBegin: true,
            relevance: 0,
            contains: [{className: 'attr', begin: IDENT_RE, relevance: 0}]
          }
        ]
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          {
            className: 'function',
            begin: '(\\(.*?\\)|' + IDENT_RE + ')\\s*=>', returnBegin: true,
            end: '\\s*=>',
            contains: [
              {
                className: 'params',
                variants: [
                  {
                    begin: IDENT_RE
                  },
                  {
                    begin: /\(\s*\)/,
                  },
                  {
                    begin: /\(/, end: /\)/,
                    excludeBegin: true, excludeEnd: true,
                    keywords: KEYWORDS,
                    contains: PARAMS_CONTAINS
                  }
                ]
              }
            ]
          },
          { // E4X / JSX
            begin: /</, end: /(\/\w+|\w+\/)>/,
            subLanguage: 'xml',
            contains: [
              {begin: /<\w+\s*\/>/, skip: true},
              {
                begin: /<\w+/, end: /(\/\w+|\w+\/)>/, skip: true,
                contains: [
                  {begin: /<\w+\s*\/>/, skip: true},
                  'self'
                ]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /\{/, excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            contains: PARAMS_CONTAINS
          }
        ],
        illegal: /\[|%/
      },
      {
        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      },
      hljs.METHOD_GUARD,
      { // ES6 class
        className: 'class',
        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
        illegal: /[:"\[\]]/,
        contains: [
          {beginKeywords: 'extends'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'constructor', end: /\{/, excludeEnd: true
      }
    ],
    illegal: /#(?!!)/
  };
});

hljs.registerLanguage('json', function(hljs) {
  var LITERALS = {literal: 'true false null'};
  var TYPES = [
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE
  ];
  var VALUE_CONTAINER = {
    end: ',', endsWithParent: true, excludeEnd: true,
    contains: TYPES,
    keywords: LITERALS
  };
  var OBJECT = {
    begin: '{', end: '}',
    contains: [
      {
        className: 'attr',
        begin: /"/, end: /"/,
        contains: [hljs.BACKSLASH_ESCAPE],
        illegal: '\\n',
      },
      hljs.inherit(VALUE_CONTAINER, {begin: /:/})
    ],
    illegal: '\\S'
  };
  var ARRAY = {
    begin: '\\[', end: '\\]',
    contains: [hljs.inherit(VALUE_CONTAINER)], // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
    illegal: '\\S'
  };
  TYPES.splice(TYPES.length, 0, OBJECT, ARRAY);
  return {
    contains: TYPES,
    keywords: LITERALS,
    illegal: '\\S'
  };
});

hljs.registerLanguage('julia', function(hljs) {
  // Since there are numerous special names in Julia, it is too much trouble
  // to maintain them by hand. Hence these names (i.e. keywords, literals and
  // built-ins) are automatically generated from Julia (v0.3.0 and v0.4.1)
  // itself through following scripts for each.

  var KEYWORDS = {
    // # keyword generator
    // println("in")
    // for kw in Base.REPLCompletions.complete_keyword("")
    //     println(kw)
    // end
    keyword:
      'in abstract baremodule begin bitstype break catch ccall const continue do else elseif end export ' +
      'finally for function global if immutable import importall let local macro module quote return try type ' +
      'typealias using while',

    // # literal generator
    // println("true")
    // println("false")
    // for name in Base.REPLCompletions.completions("", 0)[1]
    //     try
    //         s = symbol(name)
    //         v = eval(s)
    //         if !isa(v, Function) &&
    //            !isa(v, DataType) &&
    //            !isa(v, IntrinsicFunction) &&
    //            !issubtype(typeof(v), Tuple) &&
    //            !isa(v, Union) &&
    //            !isa(v, Module) &&
    //            !isa(v, TypeConstructor) &&
    //            !isa(v, TypeVar) &&
    //            !isa(v, Colon)
    //             println(name)
    //         end
    //     end
    // end
    literal:
      // v0.3
      'true false ARGS CPU_CORES C_NULL DL_LOAD_PATH DevNull ENDIAN_BOM ENV I|0 Inf Inf16 Inf32 ' +
      'InsertionSort JULIA_HOME LOAD_PATH MS_ASYNC MS_INVALIDATE MS_SYNC MergeSort NaN NaN16 NaN32 OS_NAME QuickSort ' +
      'RTLD_DEEPBIND RTLD_FIRST RTLD_GLOBAL RTLD_LAZY RTLD_LOCAL RTLD_NODELETE RTLD_NOLOAD RTLD_NOW RoundDown ' +
      'RoundFromZero RoundNearest RoundToZero RoundUp STDERR STDIN STDOUT VERSION WORD_SIZE catalan cglobal e|0 eu|0 ' +
      'eulergamma golden im nothing pi γ π φ ' +
      // v0.4 (diff)
      'Inf64 NaN64 RoundNearestTiesAway RoundNearestTiesUp ',

    // # built_in generator:
    // for name in Base.REPLCompletions.completions("", 0)[1]
    //     try
    //         v = eval(symbol(name))
    //         if isa(v, DataType) || isa(v, TypeConstructor) || isa(v, TypeVar)
    //             println(name)
    //         end
    //     end
    // end
    built_in:
      // v0.3
      'ANY ASCIIString AbstractArray AbstractRNG AbstractSparseArray Any ArgumentError Array Associative Base64Pipe ' +
      'Bidiagonal BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError Box CFILE Cchar Cdouble Cfloat Char ' +
      'CharString Cint Clong Clonglong ClusterManager Cmd Coff_t Colon Complex Complex128 Complex32 Complex64 ' +
      'Condition Cptrdiff_t Cshort Csize_t Cssize_t Cuchar Cuint Culong Culonglong Cushort Cwchar_t DArray DataType ' +
      'DenseArray Diagonal Dict DimensionMismatch DirectIndexString Display DivideError DomainError EOFError ' +
      'EachLine Enumerate ErrorException Exception Expr Factorization FileMonitor FileOffset Filter Float16 Float32 ' +
      'Float64 FloatRange FloatingPoint Function GetfieldNode GotoNode Hermitian IO IOBuffer IOStream IPv4 IPv6 ' +
      'InexactError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException IntrinsicFunction KeyError ' +
      'LabelNode LambdaStaticData LineNumberNode LoadError LocalProcess MIME MathConst MemoryError MersenneTwister ' +
      'Method MethodError MethodTable Module NTuple NewvarNode Nothing Number ObjectIdDict OrdinalRange ' +
      'OverflowError ParseError PollingFileWatcher ProcessExitedException ProcessGroup Ptr QuoteNode Range Range1 ' +
      'Ranges Rational RawFD Real Regex RegexMatch RemoteRef RepString RevString RopeString RoundingMode Set ' +
      'SharedArray Signed SparseMatrixCSC StackOverflowError Stat StatStruct StepRange String SubArray SubString ' +
      'SymTridiagonal Symbol SymbolNode Symmetric SystemError Task TextDisplay Timer TmStruct TopNode Triangular ' +
      'Tridiagonal Type TypeConstructor TypeError TypeName TypeVar UTF16String UTF32String UTF8String UdpSocket ' +
      'Uint Uint128 Uint16 Uint32 Uint64 Uint8 UndefRefError UndefVarError UniformScaling UnionType UnitRange ' +
      'Unsigned Vararg VersionNumber WString WeakKeyDict WeakRef Woodbury Zip ' +
      // v0.4 (diff)
      'AbstractChannel AbstractFloat AbstractString AssertionError Base64DecodePipe Base64EncodePipe BufferStream ' +
      'CapturedException CartesianIndex CartesianRange Channel Cintmax_t CompositeException Cstring Cuintmax_t ' +
      'Cwstring Date DateTime Dims Enum GenSym GlobalRef HTML InitError InvalidStateException Irrational LinSpace ' +
      'LowerTriangular NullException Nullable OutOfMemoryError Pair PartialQuickSort Pipe RandomDevice ' +
      'ReadOnlyMemoryError ReentrantLock Ref RemoteException SegmentationFault SerializationState SimpleVector ' +
      'TCPSocket Text Tuple UDPSocket UInt UInt128 UInt16 UInt32 UInt64 UInt8 UnicodeError Union UpperTriangular ' +
      'Val Void WorkerConfig AbstractMatrix AbstractSparseMatrix AbstractSparseVector AbstractVecOrMat AbstractVector ' +
      'DenseMatrix DenseVecOrMat DenseVector Matrix SharedMatrix SharedVector StridedArray StridedMatrix ' +
      'StridedVecOrMat StridedVector VecOrMat Vector '
  };

  // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
  var VARIABLE_NAME_RE = '[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*';

  // placeholder for recursive self-reference
  var DEFAULT = { lexemes: VARIABLE_NAME_RE, keywords: KEYWORDS, illegal: /<\// };

  var TYPE_ANNOTATION = {
    className: 'type',
    begin: /::/
  };

  var SUBTYPE = {
    className: 'type',
    begin: /<:/
  };

  // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
  var NUMBER = {
    className: 'number',
    // supported numeric literals:
    //  * binary literal (e.g. 0x10)
    //  * octal literal (e.g. 0o76543210)
    //  * hexadecimal literal (e.g. 0xfedcba876543210)
    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
    //  * decimal literal (e.g. 9876543210, 100_000_000)
    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
    relevance: 0
  };

  var CHAR = {
    className: 'string',
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  };

  var INTERPOLATION = {
    className: 'subst',
    begin: /\$\(/, end: /\)/,
    keywords: KEYWORDS
  };

  var INTERPOLATED_VARIABLE = {
    className: 'variable',
    begin: '\\$' + VARIABLE_NAME_RE
  };

  // TODO: neatly escape normal code in string literal
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    variants: [
      { begin: /\w*"""/, end: /"""\w*/, relevance: 10 },
      { begin: /\w*"/, end: /"\w*/ }
    ]
  };

  var COMMAND = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    begin: '`', end: '`'
  };

  var MACROCALL = {
    className: 'meta',
    begin: '@' + VARIABLE_NAME_RE
  };

  var COMMENT = {
    className: 'comment',
    variants: [
      { begin: '#=', end: '=#', relevance: 10 },
      { begin: '#', end: '$' }
    ]
  };

  DEFAULT.contains = [
    NUMBER,
    CHAR,
    TYPE_ANNOTATION,
    SUBTYPE,
    STRING,
    COMMAND,
    MACROCALL,
    COMMENT,
    hljs.HASH_COMMENT_MODE
  ];
  INTERPOLATION.contains = DEFAULT.contains;

  return DEFAULT;
});

hljs.registerLanguage('kotlin', function(hljs) {
  var KEYWORDS = {
    keyword:
      'abstract as val var vararg get set class object open private protected public noinline ' +
      'crossinline dynamic final enum if else do while for when throw try catch finally ' +
      'import package is in fun override companion reified inline lateinit init' +
      'interface annotation data sealed internal infix operator out by constructor super ' +
      // to be deleted soon
      'trait volatile transient native default',
    built_in:
      'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
    literal:
      'true false null'
  };
  var KEYWORDS_WITH_LABEL = {
    className: 'keyword',
    begin: /\b(break|continue|return|this)\b/,
    starts: {
      contains: [
        {
          className: 'symbol',
          begin: /@\w+/
        }
      ]
    }
  };
  var LABEL = {
    className: 'symbol', begin: hljs.UNDERSCORE_IDENT_RE + '@'
  };

  // for string templates
  var SUBST = {
    className: 'subst',
    variants: [
      {begin: '\\$' + hljs.UNDERSCORE_IDENT_RE},
      {begin: '\\${', end: '}', contains: [hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE]}
    ]
  };
  var STRING = {
    className: 'string',
    variants: [
      {
        begin: '"""', end: '"""',
        contains: [SUBST]
      },
      // Can't use built-in modes easily, as we want to use STRING in the meta
      // context as 'meta-string' and there's no syntax to remove explicitly set
      // classNames in built-in modes.
      {
        begin: '\'', end: '\'',
        illegal: /\n/,
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '"', end: '"',
        illegal: /\n/,
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      }
    ]
  };

  var ANNOTATION_USE_SITE = {
    className: 'meta', begin: '@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*' + hljs.UNDERSCORE_IDENT_RE + ')?'
  };
  var ANNOTATION = {
    className: 'meta', begin: '@' + hljs.UNDERSCORE_IDENT_RE,
    contains: [
      {
        begin: /\(/, end: /\)/,
        contains: [
          hljs.inherit(STRING, {className: 'meta-string'})
        ]
      }
    ]
  };

  return {
    keywords: KEYWORDS,
    contains : [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [{
            className : 'doctag',
            begin : '@[A-Za-z]+'
          }]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      KEYWORDS_WITH_LABEL,
      LABEL,
      ANNOTATION_USE_SITE,
      ANNOTATION,
      {
        className: 'function',
        beginKeywords: 'fun', end: '[(]|$',
        returnBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS,
        illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
        relevance: 5,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'type',
            begin: /</, end: />/, keywords: 'reified',
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            endsParent: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              {
                begin: /:/, end: /[=,\/]/, endsWithParent: true,
                contains: [
                  {className: 'type', begin: hljs.UNDERSCORE_IDENT_RE},
                  hljs.C_LINE_COMMENT_MODE,
                  hljs.C_BLOCK_COMMENT_MODE
                ],
                relevance: 0
              },
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              ANNOTATION_USE_SITE,
              ANNOTATION,
              STRING,
              hljs.C_NUMBER_MODE
            ]
          },
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface trait', end: /[:\{(]|$/, // remove 'trait' when removed from KEYWORDS
        excludeEnd: true,
        illegal: 'extends implements',
        contains: [
          {beginKeywords: 'public protected internal private constructor'},
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'type',
            begin: /</, end: />/, excludeBegin: true, excludeEnd: true,
            relevance: 0
          },
          {
            className: 'type',
            begin: /[,:]\s*/, end: /[<\(,]|$/, excludeBegin: true, returnEnd: true
          },
          ANNOTATION_USE_SITE,
          ANNOTATION
        ]
      },
      STRING,
      {
        className: 'meta',
        begin: "^#!/usr/bin/env", end: '$',
        illegal: '\n'
      },
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('lasso', function(hljs) {
  var LASSO_IDENT_RE = '[a-zA-Z_][\\w.]*';
  var LASSO_ANGLE_RE = '<\\?(lasso(script)?|=)';
  var LASSO_CLOSE_RE = '\\]|\\?>';
  var LASSO_KEYWORDS = {
    literal:
      'true false none minimal full all void and or not ' +
      'bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft',
    built_in:
      'array date decimal duration integer map pair string tag xml null ' +
      'boolean bytes keyword list locale queue set stack staticarray ' +
      'local var variable global data self inherited currentcapture givenblock',
    keyword:
      'cache database_names database_schemanames database_tablenames ' +
      'define_tag define_type email_batch encode_set html_comment handle ' +
      'handle_error header if inline iterate ljax_target link ' +
      'link_currentaction link_currentgroup link_currentrecord link_detail ' +
      'link_firstgroup link_firstrecord link_lastgroup link_lastrecord ' +
      'link_nextgroup link_nextrecord link_prevgroup link_prevrecord log ' +
      'loop namespace_using output_none portal private protect records ' +
      'referer referrer repeating resultset rows search_args ' +
      'search_arguments select sort_args sort_arguments thread_atomic ' +
      'value_list while abort case else fail_if fail_ifnot fail if_empty ' +
      'if_false if_null if_true loop_abort loop_continue loop_count params ' +
      'params_up return return_value run_children soap_definetag ' +
      'soap_lastrequest soap_lastresponse tag_name ascending average by ' +
      'define descending do equals frozen group handle_failure import in ' +
      'into join let match max min on order parent protected provide public ' +
      'require returnhome skip split_thread sum take thread to trait type ' +
      'where with yield yieldhome'
  };
  var HTML_COMMENT = hljs.COMMENT(
    '<!--',
    '-->',
    {
      relevance: 0
    }
  );
  var LASSO_NOPROCESS = {
    className: 'meta',
    begin: '\\[noprocess\\]',
    starts: {
      end: '\\[/noprocess\\]',
      returnEnd: true,
      contains: [HTML_COMMENT]
    }
  };
  var LASSO_START = {
    className: 'meta',
    begin: '\\[/noprocess|' + LASSO_ANGLE_RE
  };
  var LASSO_DATAMEMBER = {
    className: 'symbol',
    begin: '\'' + LASSO_IDENT_RE + '\''
  };
  var LASSO_CODE = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.inherit(hljs.C_NUMBER_MODE, {begin: hljs.C_NUMBER_RE + '|(-?infinity|NaN)\\b'}),
    hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
    hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
    {
      className: 'string',
      begin: '`', end: '`'
    },
    { // variables
      variants: [
        {
          begin: '[#$]' + LASSO_IDENT_RE
        },
        {
          begin: '#', end: '\\d+',
          illegal: '\\W'
        }
      ]
    },
    {
      className: 'type',
      begin: '::\\s*', end: LASSO_IDENT_RE,
      illegal: '\\W'
    },
    {
      className: 'params',
      variants: [
        {
          begin: '-(?!infinity)' + LASSO_IDENT_RE,
          relevance: 0
        },
        {
          begin: '(\\.\\.\\.)'
        }
      ]
    },
    {
      begin: /(->|\.)\s*/,
      relevance: 0,
      contains: [LASSO_DATAMEMBER]
    },
    {
      className: 'class',
      beginKeywords: 'define',
      returnEnd: true, end: '\\(|=>',
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: LASSO_IDENT_RE + '(=(?!>))?|[-+*/%](?!>)'})
      ]
    }
  ];
  return {
    aliases: ['ls', 'lassoscript'],
    case_insensitive: true,
    lexemes: LASSO_IDENT_RE + '|&[lg]t;',
    keywords: LASSO_KEYWORDS,
    contains: [
      {
        className: 'meta',
        begin: LASSO_CLOSE_RE,
        relevance: 0,
        starts: { // markup
          end: '\\[|' + LASSO_ANGLE_RE,
          returnEnd: true,
          relevance: 0,
          contains: [HTML_COMMENT]
        }
      },
      LASSO_NOPROCESS,
      LASSO_START,
      {
        className: 'meta',
        begin: '\\[no_square_brackets',
        starts: {
          end: '\\[/no_square_brackets\\]', // not implemented in the language
          lexemes: LASSO_IDENT_RE + '|&[lg]t;',
          keywords: LASSO_KEYWORDS,
          contains: [
            {
              className: 'meta',
              begin: LASSO_CLOSE_RE,
              relevance: 0,
              starts: {
                end: '\\[noprocess\\]|' + LASSO_ANGLE_RE,
                returnEnd: true,
                contains: [HTML_COMMENT]
              }
            },
            LASSO_NOPROCESS,
            LASSO_START
          ].concat(LASSO_CODE)
        }
      },
      {
        className: 'meta',
        begin: '\\[',
        relevance: 0
      },
      {
        className: 'meta',
        begin: '^#!', end:'lasso9$',
        relevance: 10
      }
    ].concat(LASSO_CODE)
  };
});

hljs.registerLanguage('ldif', function(hljs) {
  return {
    contains: [
      {
        className: 'attribute',
        begin: '^dn', end: ': ', excludeEnd: true,
        starts: {end: '$', relevance: 0},
        relevance: 10
      },
      {
        className: 'attribute',
        begin: '^\\w', end: ': ', excludeEnd: true,
        starts: {end: '$', relevance: 0}
      },
      {
        className: 'literal',
        begin: '^-', end: '$'
      },
      hljs.HASH_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('leaf', function (hljs) {
  return {
    contains: [
      {
        className: 'function',
        begin: '#+' + '[A-Za-z_0-9]*' + '\\(',
        end:' {',
        returnBegin: true,
        excludeEnd: true,
        contains : [
          {
            className: 'keyword',
            begin: '#+'
          },
          {
            className: 'title',
            begin: '[A-Za-z_][A-Za-z_0-9]*'
          },
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            endsParent: true,
            contains: [
              {
                className: 'string',
                begin: '"',
                end: '"'
              },
              {
                className: 'variable',
                begin: '[A-Za-z_][A-Za-z_0-9]*'
              }
            ]
          }
        ]
      }
    ]
  };
});

hljs.registerLanguage('less', function(hljs) {
  var IDENT_RE        = '[\\w-]+'; // yes, Less identifiers may begin with a digit
  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@{' + IDENT_RE + '})';

  /* Generic Modes */

  var RULES = [], VALUE = []; // forward def. for recursive modes

  var STRING_MODE = function(c) { return {
    // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
    className: 'string', begin: '~?' + c + '.*?' + c
  };};

  var IDENT_MODE = function(name, begin, relevance) { return {
    className: name, begin: begin, relevance: relevance
  };};

  var PARENS_MODE = {
    // used only to properly balance nested parens inside mixin call, def. arg list
    begin: '\\(', end: '\\)', contains: VALUE, relevance: 0
  };

  // generic Less highlighter (used almost everywhere except selectors):
  VALUE.push(
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    STRING_MODE("'"),
    STRING_MODE('"'),
    hljs.CSS_NUMBER_MODE, // fixme: it does not include dot for numbers like .5em :(
    {
      begin: '(url|data-uri)\\(',
      starts: {className: 'string', end: '[\\)\\n]', excludeEnd: true}
    },
    IDENT_MODE('number', '#[0-9A-Fa-f]+\\b'),
    PARENS_MODE,
    IDENT_MODE('variable', '@@?' + IDENT_RE, 10),
    IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),
    IDENT_MODE('built_in', '~?`[^`]*?`'), // inline javascript (or whatever host language) *multiline* string
    { // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
      className: 'attribute', begin: IDENT_RE + '\\s*:', end: ':', returnBegin: true, excludeEnd: true
    },
    {
      className: 'meta',
      begin: '!important'
    }
  );

  var VALUE_WITH_RULESETS = VALUE.concat({
    begin: '{', end: '}', contains: RULES
  });

  var MIXIN_GUARD_MODE = {
    beginKeywords: 'when', endsWithParent: true,
    contains: [{beginKeywords: 'and not'}].concat(VALUE) // using this form to override VALUE’s 'function' match
  };

  /* Rule-Level Modes */

  var RULE_MODE = {
    begin: INTERP_IDENT_RE + '\\s*:', returnBegin: true, end: '[;}]',
    relevance: 0,
    contains: [
      {
        className: 'attribute',
        begin: INTERP_IDENT_RE, end: ':', excludeEnd: true,
        starts: {
          endsWithParent: true, illegal: '[<=$]',
          relevance: 0,
          contains: VALUE
        }
      }
    ]
  };

  var AT_RULE_MODE = {
    className: 'keyword',
    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
    starts: {end: '[;{}]', returnEnd: true, contains: VALUE, relevance: 0}
  };

  // variable definitions and calls
  var VAR_RULE_MODE = {
    className: 'variable',
    variants: [
      // using more strict pattern for higher relevance to increase chances of Less detection.
      // this is *the only* Less specific statement used in most of the sources, so...
      // (we’ll still often loose to the css-parser unless there's '//' comment,
      // simply because 1 variable just can't beat 99 properties :)
      {begin: '@' + IDENT_RE + '\\s*:', relevance: 15},
      {begin: '@' + IDENT_RE}
    ],
    starts: {end: '[;}]', returnEnd: true, contains: VALUE_WITH_RULESETS}
  };

  var SELECTOR_MODE = {
    // first parse unambiguous selectors (i.e. those not starting with tag)
    // then fall into the scary lookahead-discriminator variant.
    // this mode also handles mixin definitions and calls
    variants: [{
      begin: '[\\.#:&\\[>]', end: '[;{}]'  // mixin calls end with ';'
      }, {
      begin: INTERP_IDENT_RE, end: '{'
    }],
    returnBegin: true,
    returnEnd:   true,
    illegal: '[<=\'$"]',
    relevance: 0,
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      MIXIN_GUARD_MODE,
      IDENT_MODE('keyword',  'all\\b'),
      IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),     // otherwise it’s identified as tag
      IDENT_MODE('selector-tag',  INTERP_IDENT_RE + '%?', 0), // '%' for more consistent coloring of @keyframes "tags"
      IDENT_MODE('selector-id', '#' + INTERP_IDENT_RE),
      IDENT_MODE('selector-class', '\\.' + INTERP_IDENT_RE, 0),
      IDENT_MODE('selector-tag',  '&', 0),
      {className: 'selector-attr', begin: '\\[', end: '\\]'},
      {className: 'selector-pseudo', begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},
      {begin: '\\(', end: '\\)', contains: VALUE_WITH_RULESETS}, // argument list of parametric mixins
      {begin: '!important'} // eat !important after mixin call or it will be colored as tag
    ]
  };

  RULES.push(
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    AT_RULE_MODE,
    VAR_RULE_MODE,
    RULE_MODE,
    SELECTOR_MODE
  );

  return {
    case_insensitive: true,
    illegal: '[=>\'/<($"]',
    contains: RULES
  };
});

hljs.registerLanguage('lisp', function(hljs) {
  var LISP_IDENT_RE = '[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*';
  var MEC_RE = '\\|[^]*?\\|';
  var LISP_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?';
  var SHEBANG = {
    className: 'meta',
    begin: '^#!', end: '$'
  };
  var LITERAL = {
    className: 'literal',
    begin: '\\b(t{1}|nil)\\b'
  };
  var NUMBER = {
    className: 'number',
    variants: [
      {begin: LISP_SIMPLE_NUMBER_RE, relevance: 0},
      {begin: '#(b|B)[0-1]+(/[0-1]+)?'},
      {begin: '#(o|O)[0-7]+(/[0-7]+)?'},
      {begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'},
      {begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE, end: '\\)'}
    ]
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';', '$',
    {
      relevance: 0
    }
  );
  var VARIABLE = {
    begin: '\\*', end: '\\*'
  };
  var KEYWORD = {
    className: 'symbol',
    begin: '[:&]' + LISP_IDENT_RE
  };
  var IDENT = {
    begin: LISP_IDENT_RE,
    relevance: 0
  };
  var MEC = {
    begin: MEC_RE
  };
  var QUOTED_LIST = {
    begin: '\\(', end: '\\)',
    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
  };
  var QUOTED = {
    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
    variants: [
      {
        begin: '[\'`]\\(', end: '\\)'
      },
      {
        begin: '\\(quote ', end: '\\)',
        keywords: {name: 'quote'}
      },
      {
        begin: '\'' + MEC_RE
      }
    ]
  };
  var QUOTED_ATOM = {
    variants: [
      {begin: '\'' + LISP_IDENT_RE},
      {begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'}
    ]
  };
  var LIST = {
    begin: '\\(\\s*', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  LIST.contains = [
    {
      className: 'name',
      variants: [
        {begin: LISP_IDENT_RE},
        {begin: MEC_RE}
      ]
    },
    BODY
  ];
  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];

  return {
    illegal: /\S/,
    contains: [
      NUMBER,
      SHEBANG,
      LITERAL,
      STRING,
      COMMENT,
      QUOTED,
      QUOTED_ATOM,
      LIST,
      IDENT
    ]
  };
});

hljs.registerLanguage('livecodeserver', function(hljs) {
  var VARIABLE = {
    begin: '\\b[gtps][A-Z]+[A-Za-z0-9_\\-]*\\b|\\$_[A-Z]+',
    relevance: 0
  };
  var COMMENT_MODES = [
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.HASH_COMMENT_MODE,
    hljs.COMMENT('--', '$'),
    hljs.COMMENT('[^:]//', '$')
  ];
  var TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
    variants: [
      {begin: '\\b_*rig[A-Z]+[A-Za-z0-9_\\-]*'},
      {begin: '\\b_[a-z0-9\\-]+'}
    ]
  });
  var TITLE2 = hljs.inherit(hljs.TITLE_MODE, {begin: '\\b([A-Za-z0-9_\\-]+)\\b'});
  return {
    case_insensitive: false,
    keywords: {
      keyword:
        '$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER ' +
        'codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph ' +
        'after byte bytes english the until http forever descending using line real8 with seventh ' +
        'for stdout finally element word words fourth before black ninth sixth characters chars stderr ' +
        'uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid ' +
        'at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 ' +
        'int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat ' +
        'end repeat URL in try into switch to words https token binfile each tenth as ticks tick ' +
        'system real4 by dateItems without char character ascending eighth whole dateTime numeric short ' +
        'first ftp integer abbreviated abbr abbrev private case while if ' +
        'div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within ' +
        'contains ends with begins the keys of keys',
      literal:
        'SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE ' +
        'QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO ' +
        'six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five ' +
        'quote empty one true return cr linefeed right backslash null seven tab three two ' +
        'RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK ' +
        'FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK',
      built_in:
        'put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode ' +
        'base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum ' +
        'cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress ' +
        'constantNames cos date dateFormat decompress directories ' +
        'diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global ' +
        'globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset ' +
        'keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders ' +
        'libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 ' +
        'longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge millisec ' +
        'millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar ' +
        'numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets ' +
        'paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation ' +
        'populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile ' +
        'revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull ' +
        'revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered ' +
        'revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames ' +
        'revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull ' +
        'revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections ' +
        'revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype ' +
        'revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext ' +
        'revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames ' +
        'revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase ' +
        'revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute ' +
        'revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces ' +
        'revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode ' +
        'revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling ' +
        'revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error ' +
        'revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute ' +
        'revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort ' +
        'revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree ' +
        'revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance ' +
        'sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound ' +
        'stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper ' +
        'transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames ' +
        'variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet ' +
        'xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process ' +
        'combine constant convert create new alias folder directory decrypt delete variable word line folder ' +
        'directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile ' +
        'libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback ' +
        'libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime ' +
        'libURLSetStatusCallback load multiply socket prepare process post seek rel relative read from process rename ' +
        'replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase ' +
        'revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees ' +
        'revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord ' +
        'revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase ' +
        'revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD ' +
        'revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost ' +
        'revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData ' +
        'revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel ' +
        'revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback ' +
        'revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop ' +
        'subtract union unload wait write'
    },
    contains: [
      VARIABLE,
      {
        className: 'keyword',
        begin: '\\bend\\sif\\b'
      },
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          VARIABLE,
          TITLE2,
          hljs.APOS_STRING_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.BINARY_NUMBER_MODE,
          hljs.C_NUMBER_MODE,
          TITLE1
        ]
      },
      {
        className: 'function',
        begin: '\\bend\\s+', end: '$',
        keywords: 'end',
        contains: [
          TITLE2,
          TITLE1
        ],
        relevance: 0
      },
      {
        beginKeywords: 'command on', end: '$',
        contains: [
          VARIABLE,
          TITLE2,
          hljs.APOS_STRING_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.BINARY_NUMBER_MODE,
          hljs.C_NUMBER_MODE,
          TITLE1
        ]
      },
      {
        className: 'meta',
        variants: [
          {
            begin: '<\\?(rev|lc|livecode)',
            relevance: 10
          },
          { begin: '<\\?' },
          { begin: '\\?>' }
        ]
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.BINARY_NUMBER_MODE,
      hljs.C_NUMBER_MODE,
      TITLE1
    ].concat(COMMENT_MODES),
    illegal: ';$|^\\[|^=|&|{'
  };
});

hljs.registerLanguage('livescript', function(hljs) {
  var KEYWORDS = {
    keyword:
      // JS keywords
      'in if for while finally new do return else break catch instanceof throw try this ' +
      'switch continue typeof delete debugger case default function var with ' +
      // LiveScript keywords
      'then unless until loop of by when and or is isnt not it that otherwise from to til fallthrough super ' +
      'case default function var void const let enum export import native ' +
      '__hasProp __extends __slice __bind __indexOf',
    literal:
      // JS literals
      'true false null undefined ' +
      // LiveScript literals
      'yes no on off it that void',
    built_in:
      'npm require console print module global window document'
  };
  var JS_IDENT_RE = '[A-Za-z$_](?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*';
  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var SUBST_SIMPLE = {
    className: 'subst',
    begin: /#[A-Za-z$_]/, end: /(?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.BINARY_NUMBER_MODE,
    {
      className: 'number',
      begin: '(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)',
      relevance: 0,
      starts: {end: '(\\s*/)?', relevance: 0} // a number tries to eat the following slash to prevent treating it as a regexp
    },
    {
      className: 'string',
      variants: [
        {
          begin: /'''/, end: /'''/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/, end: /"""/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
        },
        {
          begin: /\\/, end: /(\s|$)/,
          excludeEnd: true
        }
      ]
    },
    {
      className: 'regexp',
      variants: [
        {
          begin: '//', end: '//[gim]*',
          contains: [SUBST, hljs.HASH_COMMENT_MODE]
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
        }
      ]
    },
    {
      begin: '@' + JS_IDENT_RE
    },
    {
      begin: '``', end: '``',
      excludeBegin: true, excludeEnd: true,
      subLanguage: 'javascript'
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var PARAMS = {
    className: 'params',
    begin: '\\(', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [
      {
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: ['self'].concat(EXPRESSIONS)
      }
    ]
  };

  return {
    aliases: ['ls'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('\\/\\*', '\\*\\/'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'function',
        contains: [TITLE, PARAMS],
        returnBegin: true,
        variants: [
          {
            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B\\->\\*?', end: '\\->\\*?'
          },
          {
            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?!?(\\(.*\\))?\\s*\\B[-~]{1,2}>\\*?', end: '[-~]{1,2}>\\*?'
          },
          {
            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B!?[-~]{1,2}>\\*?', end: '!?[-~]{1,2}>\\*?'
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
});

hljs.registerLanguage('llvm', function(hljs) {
  var identifier = '([-a-zA-Z$._][\\w\\-$.]*)';
  return {
    //lexemes: '[.%]?' + hljs.IDENT_RE,
    keywords:
      'begin end true false declare define global ' +
      'constant private linker_private internal ' +
      'available_externally linkonce linkonce_odr weak ' +
      'weak_odr appending dllimport dllexport common ' +
      'default hidden protected extern_weak external ' +
      'thread_local zeroinitializer undef null to tail ' +
      'target triple datalayout volatile nuw nsw nnan ' +
      'ninf nsz arcp fast exact inbounds align ' +
      'addrspace section alias module asm sideeffect ' +
      'gc dbg linker_private_weak attributes blockaddress ' +
      'initialexec localdynamic localexec prefix unnamed_addr ' +
      'ccc fastcc coldcc x86_stdcallcc x86_fastcallcc ' +
      'arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ' +
      'ptx_kernel intel_ocl_bicc msp430_intrcc spir_func ' +
      'spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc ' +
      'cc c signext zeroext inreg sret nounwind ' +
      'noreturn noalias nocapture byval nest readnone ' +
      'readonly inlinehint noinline alwaysinline optsize ssp ' +
      'sspreq noredzone noimplicitfloat naked builtin cold ' +
      'nobuiltin noduplicate nonlazybind optnone returns_twice ' +
      'sanitize_address sanitize_memory sanitize_thread sspstrong ' +
      'uwtable returned type opaque eq ne slt sgt ' +
      'sle sge ult ugt ule uge oeq one olt ogt ' +
      'ole oge ord uno ueq une x acq_rel acquire ' +
      'alignstack atomic catch cleanup filter inteldialect ' +
      'max min monotonic nand personality release seq_cst ' +
      'singlethread umax umin unordered xchg add fadd ' +
      'sub fsub mul fmul udiv sdiv fdiv urem srem ' +
      'frem shl lshr ashr and or xor icmp fcmp ' +
      'phi call trunc zext sext fptrunc fpext uitofp ' +
      'sitofp fptoui fptosi inttoptr ptrtoint bitcast ' +
      'addrspacecast select va_arg ret br switch invoke ' +
      'unwind unreachable indirectbr landingpad resume ' +
      'malloc alloca free load store getelementptr ' +
      'extractelement insertelement shufflevector getresult ' +
      'extractvalue insertvalue atomicrmw cmpxchg fence ' +
      'argmemonly double',
    contains: [
      {
        className: 'keyword',
        begin: 'i\\d+'
      },
      hljs.COMMENT(
        ';', '\\n', {relevance: 0}
      ),
      // Double quote string
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          // Double-quoted string
          { begin: '"', end: '[^\\\\]"' },
        ],
        relevance: 0
      },
      {
        className: 'title',
        variants: [
          { begin: '@' + identifier },
          { begin: '@\\d+' },
          { begin: '!' + identifier },
          { begin: '!\\d+' + identifier }
        ]
      },
      {
        className: 'symbol',
        variants: [
          { begin: '%' + identifier },
          { begin: '%\\d+' },
          { begin: '#\\d+' },
        ]
      },
      {
        className: 'number',
        variants: [
            { begin: '0[xX][a-fA-F0-9]+' },
            { begin: '-?\\d+(?:[.]\\d+)?(?:[eE][-+]?\\d+(?:[.]\\d+)?)?' }
        ],
        relevance: 0
      },
    ]
  };
});

hljs.registerLanguage('lsl', function(hljs) {

    var LSL_STRING_ESCAPE_CHARS = {
        className: 'subst',
        begin: /\\[tn"\\]/
    };

    var LSL_STRINGS = {
        className: 'string',
        begin: '"',
        end: '"',
        contains: [
            LSL_STRING_ESCAPE_CHARS
        ]
    };

    var LSL_NUMBERS = {
        className: 'number',
        begin: hljs.C_NUMBER_RE
    };

    var LSL_CONSTANTS = {
        className: 'literal',
        variants: [
            {
                begin: '\\b(?:PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b'
            },
            {
                begin: '\\b(?:XP_ERROR_(?:EXPERIENCES_DISABLED|EXPERIENCE_(?:DISABLED|SUSPENDED)|INVALID_(?:EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(?:FOUND|PERMITTED(?:_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(?:PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(?:_OBJECT)?|(?:DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(?:FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(?:_(?:BY_(?:LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(?:PARCEL(?:_OWNER)?|REGION)))?|CAMERA_(?:PITCH|DISTANCE|BEHINDNESS_(?:ANGLE|LAG)|(?:FOCUS|POSITION)(?:_(?:THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(?:ROOT|SET|ALL_(?:OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(?:IVE|_(?:ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(?:FWD|BACK|(?:ROT_)?(?:LEFT|RIGHT)|UP|DOWN|(?:ML_)?LBUTTON)|PERMISSION_(?:RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(?:CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(?:TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(?:INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(?:_START)?|TELEPORT|MEDIA)|OBJECT_(?:CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(?:PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_ON_REZ|NAME|DESC|POS|PRIM_(?:COUNT|EQUIVALENCE)|RETURN_(?:PARCEL(?:_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP|CREATOR|ATTACHED_POINT|RENDER_WEIGHT|(?:BODY_SHAPE|PATHFINDING)_TYPE|(?:RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(?:MEMORY|TIME))|TYPE_(?:INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(?:DEBUG|PUBLIC)_CHANNEL|ATTACH_(?:AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](?:SHOULDER|HAND|FOOT|EAR|EYE|[UL](?:ARM|LEG)|HIP)|(?:LEFT|RIGHT)_PEC|HUD_(?:CENTER_[12]|TOP_(?:RIGHT|CENTER|LEFT)|BOTTOM(?:_(?:RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(?:BASE|TIP)|[LR]WING|FACE_(?:JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(?:LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(?:ONLINE|NAME|BORN|SIM_(?:POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(?:ON_FILE|USED)|REMOTE_DATA_(?:CHANNEL|REQUEST|REPLY)|PSYS_(?:PART_(?:BF_(?:ZERO|ONE(?:_MINUS_(?:DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(?:START|END)_(?:COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(?:RIBBON|WIND|INTERP_(?:COLOR|SCALE)|BOUNCE|FOLLOW_(?:SRC|VELOCITY)|TARGET_(?:POS|LINEAR)|EMISSIVE)_MASK)|SRC_(?:MAX_AGE|PATTERN|ANGLE_(?:BEGIN|END)|BURST_(?:RATE|PART_COUNT|RADIUS|SPEED_(?:MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(?:DROP|EXPLODE|ANGLE(?:_CONE(?:_EMPTY)?)?)))|VEHICLE_(?:REFERENCE_FRAME|TYPE_(?:NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(?:LINEAR|ANGULAR)_(?:FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(?:HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(?:LINEAR|ANGULAR)_(?:DEFLECTION_(?:EFFICIENCY|TIMESCALE)|MOTOR_(?:DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(?:EFFICIENCY|TIMESCALE)|BANKING_(?:EFFICIENCY|MIX|TIMESCALE)|FLAG_(?:NO_DEFLECTION_UP|LIMIT_(?:ROLL_ONLY|MOTOR_UP)|HOVER_(?:(?:WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(?:STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(?:ALPHA_MODE(?:_(?:BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(?:_(?:BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(?:DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(?:_(?:STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(?:NONE|LOW|MEDIUM|HIGH)|BUMP_(?:NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(?:DEFAULT|PLANAR)|SCULPT_(?:TYPE_(?:SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(?:MIRROR|INVERT))|PHYSICS(?:_(?:SHAPE_(?:CONVEX|NONE|PRIM|TYPE)))?|(?:POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(?:ALT_IMAGE_ENABLE|CONTROLS|(?:CURRENT|HOME)_URL|AUTO_(?:LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(?:WIDTH|HEIGHT)_PIXELS|WHITELIST(?:_ENABLE)?|PERMS_(?:INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(?:STANDARD|MINI)|PERM_(?:NONE|OWNER|GROUP|ANYONE)|MAX_(?:URL_LENGTH|WHITELIST_(?:SIZE|COUNT)|(?:WIDTH|HEIGHT)_PIXELS)))|MASK_(?:BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(?:TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(?:MEDIA_COMMAND_(?:STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(?:ALLOW_(?:FLY|(?:GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(?:GROUP_)?OBJECTS)|USE_(?:ACCESS_(?:GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(?:GROUP|ALL)_OBJECT_ENTRY)|COUNT_(?:TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(?:NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(?:MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(?:_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(?:HIDE|DEFAULT)|REGION_FLAG_(?:ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(?:COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(?:METHOD|MIMETYPE|BODY_(?:MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|STRING_(?:TRIM(?:_(?:HEAD|TAIL))?)|CLICK_ACTION_(?:NONE|TOUCH|SIT|BUY|PAY|OPEN(?:_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(?:NONE|SCRIPT_MEMORY)|RC_(?:DATA_FLAGS|DETECT_PHANTOM|GET_(?:LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(?:TYPES|AGENTS|(?:NON)?PHYSICAL|LAND))|RCERR_(?:CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(?:ALLOWED_(?:AGENT|GROUP)_(?:ADD|REMOVE)|BANNED_AGENT_(?:ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(?:COMMAND|CMD_(?:PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(?:GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(?:CMD_(?:(?:SMOOTH_)?STOP|JUMP)|DESIRED_(?:TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(?:_(?:[ABCD]|NONE))?|MAX_(?:DECEL|TURN_RADIUS|(?:ACCEL|SPEED)))|PURSUIT_(?:OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(?:CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(?:EVADE_(?:HIDDEN|SPOTTED)|FAILURE_(?:DYNAMIC_PATHFINDING_DISABLED|INVALID_(?:GOAL|START)|NO_(?:NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(?:PARCEL_)?UNREACHABLE)|(?:GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(?:_(?:FAST|NONE|SLOW))?|CONTENT_TYPE_(?:ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(?:RADIUS|STATIC)|(?:PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(?:AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b'
            },
            {
                begin: '\\b(?:FALSE|TRUE)\\b'
            },
            {
                begin: '\\b(?:ZERO_ROTATION)\\b'
            },
            {
                begin: '\\b(?:EOF|JSON_(?:ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(?:BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(?:GRANTED|DENIED))\\b'
            },
            {
                begin: '\\b(?:ZERO_VECTOR|TOUCH_INVALID_(?:TEXCOORD|VECTOR))\\b'
            }
        ]
    };

    var LSL_FUNCTIONS = {
        className: 'built_in',
        begin: '\\b(?:ll(?:AgentInExperience|(?:Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(?:Details|ErrorMessage)|ReturnObjectsBy(?:ID|Owner)|Json(?:2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(?:Mag|Norm|Dist)|Rot(?:Between|2(?:Euler|Fwd|Left|Up))|(?:Euler|Axes)2Rot|Whisper|(?:Region|Owner)?Say|Shout|Listen(?:Control|Remove)?|Sensor(?:Repeat|Remove)?|Detected(?:Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|(?:[GS]et)(?:AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(?:Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(?:Scale|Offset|Rotate)Texture|(?:Rot)?Target(?:Remove)?|(?:Stop)?MoveToTarget|Apply(?:Rotational)?Impulse|Set(?:KeyframedMotion|ContentType|RegionPos|(?:Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(?:Queueing|Radius)|Vehicle(?:Type|(?:Float|Vector|Rotation)Param)|(?:Touch|Sit)?Text|Camera(?:Eye|At)Offset|PrimitiveParams|ClickAction|Link(?:Alpha|Color|PrimitiveParams(?:Fast)?|Texture(?:Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get(?:(?:Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(?:PrimitiveParams|Number(?:OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(?:Details|PermMask|PrimCount)|Parcel(?:MaxPrims|Details|Prim(?:Count|Owners))|Attached(?:List)?|(?:SPMax|Free|Used)Memory|Region(?:Name|TimeDilation|FPS|Corner|AgentCount)|Root(?:Position|Rotation)|UnixTime|(?:Parcel|Region)Flags|(?:Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(?:Prims|NotecardLines|Sides)|Animation(?:List)?|(?:Camera|Local)(?:Pos|Rot)|Vel|Accel|Omega|Time(?:stamp|OfDay)|(?:Object|CenterOf)?Mass|MassMKS|Energy|Owner|(?:Owner)?Key|SunDirection|Texture(?:Offset|Scale|Rot)|Inventory(?:Number|Name|Key|Type|Creator|PermMask)|Permissions(?:Key)?|StartParameter|List(?:Length|EntryType)|Date|Agent(?:Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(?:Name|State))|(?:Get|Reset|GetAndReset)Time|PlaySound(?:Slave)?|LoopSound(?:Master|Slave)?|(?:Trigger|Stop|Preload)Sound|(?:(?:Get|Delete)Sub|Insert)String|To(?:Upper|Lower)|Give(?:InventoryList|Money)|RezObject|(?:Stop)?LookAt|Sleep|CollisionFilter|(?:Take|Release)Controls|DetachFromAvatar|AttachToAvatar(?:Temp)?|InstantMessage|(?:GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(?:Length|Trim)|(?:Start|Stop)Animation|TargetOmega|Request(?:Experience)?Permissions|(?:Create|Break)Link|BreakAllLinks|(?:Give|Remove)Inventory|Water|PassTouches|Request(?:Agent|Inventory)Data|TeleportAgent(?:Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(?:Axis|Angle)|A(?:cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(?:CSV|Integer|Json|Float|String|Key|Vector|Rot|List(?:Strided)?)|DeleteSubList|List(?:Statistics|Sort|Randomize|(?:Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(?:CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(?:Slope|Normal|Contour)|GroundRepel|(?:Set|Remove)VehicleFlags|(?:AvatarOn)?(?:Link)?SitTarget|Script(?:Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(?:Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(?:Integer|String)ToBase64|XorBase64|Log(?:10)?|Base64To(?:String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(?:Load|Release|(?:E|Une)scape)URL|ParcelMedia(?:CommandList|Query)|ModPow|MapDestination|(?:RemoveFrom|AddTo|Reset)Land(?:Pass|Ban)List|(?:Set|Clear)CameraParams|HTTP(?:Request|Response)|TextBox|DetectedTouch(?:UV|Face|Pos|(?:N|Bin)ormal|ST)|(?:MD5|SHA1|DumpList2)String|Request(?:Secure)?URL|Clear(?:Prim|Link)Media|(?:Link)?ParticleSystem|(?:Get|Request)(?:Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(?:Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b'
    };

    return {
        illegal: ':',
        contains: [
            LSL_STRINGS,
            {
                className: 'comment',
                variants: [
                    hljs.COMMENT('//', '$'),
                    hljs.COMMENT('/\\*', '\\*/')
                ]
            },
            LSL_NUMBERS,
            {
                className: 'section',
                variants: [
                    {
                        begin: '\\b(?:state|default)\\b'
                    },
                    {
                        begin: '\\b(?:state_(?:entry|exit)|touch(?:_(?:start|end))?|(?:land_)?collision(?:_(?:start|end))?|timer|listen|(?:no_)?sensor|control|(?:not_)?at_(?:rot_)?target|money|email|experience_permissions(?:_denied)?|run_time_permissions|changed|attach|dataserver|moving_(?:start|end)|link_message|(?:on|object)_rez|remote_data|http_re(?:sponse|quest)|path_update|transaction_result)\\b'
                    }
                ]
            },
            LSL_FUNCTIONS,
            LSL_CONSTANTS,
            {
                className: 'type',
                begin: '\\b(?:integer|float|string|key|vector|quaternion|rotation|list)\\b'
            }
        ]
    };
});

hljs.registerLanguage('lua', function(hljs) {
  var OPENING_LONG_BRACKET = '\\[=*\\[';
  var CLOSING_LONG_BRACKET = '\\]=*\\]';
  var LONG_BRACKETS = {
    begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
    contains: ['self']
  };
  var COMMENTS = [
    hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'),
    hljs.COMMENT(
      '--' + OPENING_LONG_BRACKET,
      CLOSING_LONG_BRACKET,
      {
        contains: [LONG_BRACKETS],
        relevance: 10
      }
    )
  ];
  return {
    lexemes: hljs.UNDERSCORE_IDENT_RE,
    keywords: {
      literal: "true false nil",
      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
      built_in:
        //Metatags and globals:
        '_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len ' +
        '__gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert ' +
        //Standard methods and properties:
        'collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring' +
        'module next pairs pcall print rawequal rawget rawset require select setfenv' +
        'setmetatable tonumber tostring type unpack xpcall arg self' +
        //Library methods and properties (one line per library):
        'coroutine resume yield status wrap create running debug getupvalue' +
        'debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv' +
        'io lines write close flush open output type read stderr stdin input stdout popen tmpfile' +
        'math, log, max, acos, huge, ldexp, pi, cos, tanh, pow, deg, tan, cosh, sinh, random, randomseed, frexp, ceil, floor, rad, abs, sqrt, modf, asin, min, mod, fmod, log10, atan2, exp, sin, atan' +
        'os, exit, setlocale, date, getenv, difftime, remove, time, clock, tmpname, rename, execute, package, preload, loadlib, loaded, loaders, cpath, config path, seeall' +
        'string, sub, upper, len, gfind, rep, find, match, char, dump, gmatch, reverse, byte, format, gsub, lower' +
        'table, setn, insert, getn, foreachi, maxn, foreach, concat, sort, remove'
    },
    contains: COMMENTS.concat([
      {
        className: 'function',
        beginKeywords: 'function', end: '\\)',
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
          {
            className: 'params',
            begin: '\\(', endsWithParent: true,
            contains: COMMENTS
          }
        ].concat(COMMENTS)
      },
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
        contains: [LONG_BRACKETS],
        relevance: 5
      }
    ])
  };
});

hljs.registerLanguage('makefile', function(hljs) {
  var VARIABLE = {
    className: 'variable',
    begin: /\$\(/, end: /\)/,
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  return {
    aliases: ['mk', 'mak'],
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        begin: /^\w+\s*\W*=/, returnBegin: true,
        relevance: 0,
        starts: {
          end: /\s*\W*=/, excludeEnd: true,
          starts: {
            end: /$/,
            relevance: 0,
            contains: [
              VARIABLE
            ]
          }
        }
      },
      {
        className: 'section',
        begin: /^[\w]+:\s*$/
      },
      {
        className: 'meta',
        begin: /^\.PHONY:/, end: /$/,
        keywords: {'meta-keyword': '.PHONY'}, lexemes: /[\.\w]+/
      },
      {
        begin: /^\t+/, end: /$/,
        relevance: 0,
        contains: [
          hljs.QUOTE_STRING_MODE,
          VARIABLE
        ]
      }
    ]
  };
});

hljs.registerLanguage('mathematica', function(hljs) {
  return {
    aliases: ['mma'],
    lexemes: '(\\$|\\b)' + hljs.IDENT_RE + '\\b',
    keywords: 'AbelianGroup Abort AbortKernels AbortProtect Above Abs Absolute AbsoluteCorrelation AbsoluteCorrelationFunction AbsoluteCurrentValue AbsoluteDashing AbsoluteFileName AbsoluteOptions AbsolutePointSize AbsoluteThickness AbsoluteTime AbsoluteTiming AccountingForm Accumulate Accuracy AccuracyGoal ActionDelay ActionMenu ActionMenuBox ActionMenuBoxOptions Active ActiveItem ActiveStyle AcyclicGraphQ AddOnHelpPath AddTo AdjacencyGraph AdjacencyList AdjacencyMatrix AdjustmentBox AdjustmentBoxOptions AdjustTimeSeriesForecast AffineTransform After AiryAi AiryAiPrime AiryAiZero AiryBi AiryBiPrime AiryBiZero AlgebraicIntegerQ AlgebraicNumber AlgebraicNumberDenominator AlgebraicNumberNorm AlgebraicNumberPolynomial AlgebraicNumberTrace AlgebraicRules AlgebraicRulesData Algebraics AlgebraicUnitQ Alignment AlignmentMarker AlignmentPoint All AllowedDimensions AllowGroupClose AllowInlineCells AllowKernelInitialization AllowReverseGroupClose AllowScriptLevelChange AlphaChannel AlternatingGroup AlternativeHypothesis Alternatives AmbientLight Analytic AnchoredSearch And AndersonDarlingTest AngerJ AngleBracket AngularGauge Animate AnimationCycleOffset AnimationCycleRepetitions AnimationDirection AnimationDisplayTime AnimationRate AnimationRepetitions AnimationRunning Animator AnimatorBox AnimatorBoxOptions AnimatorElements Annotation Annuity AnnuityDue Antialiasing Antisymmetric Apart ApartSquareFree Appearance AppearanceElements AppellF1 Append AppendTo Apply ArcCos ArcCosh ArcCot ArcCoth ArcCsc ArcCsch ArcSec ArcSech ArcSin ArcSinDistribution ArcSinh ArcTan ArcTanh Arg ArgMax ArgMin ArgumentCountQ ARIMAProcess ArithmeticGeometricMean ARMAProcess ARProcess Array ArrayComponents ArrayDepth ArrayFlatten ArrayPad ArrayPlot ArrayQ ArrayReshape ArrayRules Arrays Arrow Arrow3DBox ArrowBox Arrowheads AspectRatio AspectRatioFixed Assert Assuming Assumptions AstronomicalData Asynchronous AsynchronousTaskObject AsynchronousTasks AtomQ Attributes AugmentedSymmetricPolynomial AutoAction AutoDelete AutoEvaluateEvents AutoGeneratedPackage AutoIndent AutoIndentSpacings AutoItalicWords AutoloadPath AutoMatch Automatic AutomaticImageSize AutoMultiplicationSymbol AutoNumberFormatting AutoOpenNotebooks AutoOpenPalettes AutorunSequencing AutoScaling AutoScroll AutoSpacing AutoStyleOptions AutoStyleWords Axes AxesEdge AxesLabel AxesOrigin AxesStyle Axis ' +
      'BabyMonsterGroupB Back Background BackgroundTasksSettings Backslash Backsubstitution Backward Band BandpassFilter BandstopFilter BarabasiAlbertGraphDistribution BarChart BarChart3D BarLegend BarlowProschanImportance BarnesG BarOrigin BarSpacing BartlettHannWindow BartlettWindow BaseForm Baseline BaselinePosition BaseStyle BatesDistribution BattleLemarieWavelet Because BeckmannDistribution Beep Before Begin BeginDialogPacket BeginFrontEndInteractionPacket BeginPackage BellB BellY Below BenfordDistribution BeniniDistribution BenktanderGibratDistribution BenktanderWeibullDistribution BernoulliB BernoulliDistribution BernoulliGraphDistribution BernoulliProcess BernsteinBasis BesselFilterModel BesselI BesselJ BesselJZero BesselK BesselY BesselYZero Beta BetaBinomialDistribution BetaDistribution BetaNegativeBinomialDistribution BetaPrimeDistribution BetaRegularized BetweennessCentrality BezierCurve BezierCurve3DBox BezierCurve3DBoxOptions BezierCurveBox BezierCurveBoxOptions BezierFunction BilateralFilter Binarize BinaryFormat BinaryImageQ BinaryRead BinaryReadList BinaryWrite BinCounts BinLists Binomial BinomialDistribution BinomialProcess BinormalDistribution BiorthogonalSplineWavelet BipartiteGraphQ BirnbaumImportance BirnbaumSaundersDistribution BitAnd BitClear BitGet BitLength BitNot BitOr BitSet BitShiftLeft BitShiftRight BitXor Black BlackmanHarrisWindow BlackmanNuttallWindow BlackmanWindow Blank BlankForm BlankNullSequence BlankSequence Blend Block BlockRandom BlomqvistBeta BlomqvistBetaTest Blue Blur BodePlot BohmanWindow Bold Bookmarks Boole BooleanConsecutiveFunction BooleanConvert BooleanCountingFunction BooleanFunction BooleanGraph BooleanMaxterms BooleanMinimize BooleanMinterms Booleans BooleanTable BooleanVariables BorderDimensions BorelTannerDistribution Bottom BottomHatTransform BoundaryStyle Bounds Box BoxBaselineShift BoxData BoxDimensions Boxed Boxes BoxForm BoxFormFormatTypes BoxFrame BoxID BoxMargins BoxMatrix BoxRatios BoxRotation BoxRotationPoint BoxStyle BoxWhiskerChart Bra BracketingBar BraKet BrayCurtisDistance BreadthFirstScan Break Brown BrownForsytheTest BrownianBridgeProcess BrowserCategory BSplineBasis BSplineCurve BSplineCurve3DBox BSplineCurveBox BSplineCurveBoxOptions BSplineFunction BSplineSurface BSplineSurface3DBox BubbleChart BubbleChart3D BubbleScale BubbleSizes BulletGauge BusinessDayQ ButterflyGraph ButterworthFilterModel Button ButtonBar ButtonBox ButtonBoxOptions ButtonCell ButtonContents ButtonData ButtonEvaluator ButtonExpandable ButtonFrame ButtonFunction ButtonMargins ButtonMinHeight ButtonNote ButtonNotebook ButtonSource ButtonStyle ButtonStyleMenuListing Byte ByteCount ByteOrdering ' +
      'C CachedValue CacheGraphics CalendarData CalendarType CallPacket CanberraDistance Cancel CancelButton CandlestickChart Cap CapForm CapitalDifferentialD CardinalBSplineBasis CarmichaelLambda Cases Cashflow Casoratian Catalan CatalanNumber Catch CauchyDistribution CauchyWindow CayleyGraph CDF CDFDeploy CDFInformation CDFWavelet Ceiling Cell CellAutoOverwrite CellBaseline CellBoundingBox CellBracketOptions CellChangeTimes CellContents CellContext CellDingbat CellDynamicExpression CellEditDuplicate CellElementsBoundingBox CellElementSpacings CellEpilog CellEvaluationDuplicate CellEvaluationFunction CellEventActions CellFrame CellFrameColor CellFrameLabelMargins CellFrameLabels CellFrameMargins CellGroup CellGroupData CellGrouping CellGroupingRules CellHorizontalScrolling CellID CellLabel CellLabelAutoDelete CellLabelMargins CellLabelPositioning CellMargins CellObject CellOpen CellPrint CellProlog Cells CellSize CellStyle CellTags CellularAutomaton CensoredDistribution Censoring Center CenterDot CentralMoment CentralMomentGeneratingFunction CForm ChampernowneNumber ChanVeseBinarize Character CharacterEncoding CharacterEncodingsPath CharacteristicFunction CharacteristicPolynomial CharacterRange Characters ChartBaseStyle ChartElementData ChartElementDataFunction ChartElementFunction ChartElements ChartLabels ChartLayout ChartLegends ChartStyle Chebyshev1FilterModel Chebyshev2FilterModel ChebyshevDistance ChebyshevT ChebyshevU Check CheckAbort CheckAll Checkbox CheckboxBar CheckboxBox CheckboxBoxOptions ChemicalData ChessboardDistance ChiDistribution ChineseRemainder ChiSquareDistribution ChoiceButtons ChoiceDialog CholeskyDecomposition Chop Circle CircleBox CircleDot CircleMinus CirclePlus CircleTimes CirculantGraph CityData Clear ClearAll ClearAttributes ClearSystemCache ClebschGordan ClickPane Clip ClipboardNotebook ClipFill ClippingStyle ClipPlanes ClipRange Clock ClockGauge ClockwiseContourIntegral Close Closed CloseKernels ClosenessCentrality Closing ClosingAutoSave ClosingEvent ClusteringComponents CMYKColor Coarse Coefficient CoefficientArrays CoefficientDomain CoefficientList CoefficientRules CoifletWavelet Collect Colon ColonForm ColorCombine ColorConvert ColorData ColorDataFunction ColorFunction ColorFunctionScaling Colorize ColorNegate ColorOutput ColorProfileData ColorQuantize ColorReplace ColorRules ColorSelectorSettings ColorSeparate ColorSetter ColorSetterBox ColorSetterBoxOptions ColorSlider ColorSpace Column ColumnAlignments ColumnBackgrounds ColumnForm ColumnLines ColumnsEqual ColumnSpacings ColumnWidths CommonDefaultFormatTypes Commonest CommonestFilter CommonUnits CommunityBoundaryStyle CommunityGraphPlot CommunityLabels CommunityRegionStyle CompatibleUnitQ CompilationOptions CompilationTarget Compile Compiled CompiledFunction Complement CompleteGraph CompleteGraphQ CompleteKaryTree CompletionsListPacket Complex Complexes ComplexExpand ComplexInfinity ComplexityFunction ComponentMeasurements ' +
      'ComponentwiseContextMenu Compose ComposeList ComposeSeries Composition CompoundExpression CompoundPoissonDistribution CompoundPoissonProcess CompoundRenewalProcess Compress CompressedData Condition ConditionalExpression Conditioned Cone ConeBox ConfidenceLevel ConfidenceRange ConfidenceTransform ConfigurationPath Congruent Conjugate ConjugateTranspose Conjunction Connect ConnectedComponents ConnectedGraphQ ConnesWindow ConoverTest ConsoleMessage ConsoleMessagePacket ConsolePrint Constant ConstantArray Constants ConstrainedMax ConstrainedMin ContentPadding ContentsBoundingBox ContentSelectable ContentSize Context ContextMenu Contexts ContextToFilename ContextToFileName Continuation Continue ContinuedFraction ContinuedFractionK ContinuousAction ContinuousMarkovProcess ContinuousTimeModelQ ContinuousWaveletData ContinuousWaveletTransform ContourDetect ContourGraphics ContourIntegral ContourLabels ContourLines ContourPlot ContourPlot3D Contours ContourShading ContourSmoothing ContourStyle ContraharmonicMean Control ControlActive ControlAlignment ControllabilityGramian ControllabilityMatrix ControllableDecomposition ControllableModelQ ControllerDuration ControllerInformation ControllerInformationData ControllerLinking ControllerManipulate ControllerMethod ControllerPath ControllerState ControlPlacement ControlsRendering ControlType Convergents ConversionOptions ConversionRules ConvertToBitmapPacket ConvertToPostScript ConvertToPostScriptPacket Convolve ConwayGroupCo1 ConwayGroupCo2 ConwayGroupCo3 CoordinateChartData CoordinatesToolOptions CoordinateTransform CoordinateTransformData CoprimeQ Coproduct CopulaDistribution Copyable CopyDirectory CopyFile CopyTag CopyToClipboard CornerFilter CornerNeighbors Correlation CorrelationDistance CorrelationFunction CorrelationTest Cos Cosh CoshIntegral CosineDistance CosineWindow CosIntegral Cot Coth Count CounterAssignments CounterBox CounterBoxOptions CounterClockwiseContourIntegral CounterEvaluator CounterFunction CounterIncrements CounterStyle CounterStyleMenuListing CountRoots CountryData Covariance CovarianceEstimatorFunction CovarianceFunction CoxianDistribution CoxIngersollRossProcess CoxModel CoxModelFit CramerVonMisesTest CreateArchive CreateDialog CreateDirectory CreateDocument CreateIntermediateDirectories CreatePalette CreatePalettePacket CreateScheduledTask CreateTemporary CreateWindow CriticalityFailureImportance CriticalitySuccessImportance CriticalSection Cross CrossingDetect CrossMatrix Csc Csch CubeRoot Cubics Cuboid CuboidBox Cumulant CumulantGeneratingFunction Cup CupCap Curl CurlyDoubleQuote CurlyQuote CurrentImage CurrentlySpeakingPacket CurrentValue CurvatureFlowFilter CurveClosed Cyan CycleGraph CycleIndexPolynomial Cycles CyclicGroup Cyclotomic Cylinder CylinderBox CylindricalDecomposition ' +
      'D DagumDistribution DamerauLevenshteinDistance DampingFactor Darker Dashed Dashing DataCompression DataDistribution DataRange DataReversed Date DateDelimiters DateDifference DateFunction DateList DateListLogPlot DateListPlot DatePattern DatePlus DateRange DateString DateTicksFormat DaubechiesWavelet DavisDistribution DawsonF DayCount DayCountConvention DayMatchQ DayName DayPlus DayRange DayRound DeBruijnGraph Debug DebugTag Decimal DeclareKnownSymbols DeclarePackage Decompose Decrement DedekindEta Default DefaultAxesStyle DefaultBaseStyle DefaultBoxStyle DefaultButton DefaultColor DefaultControlPlacement DefaultDuplicateCellStyle DefaultDuration DefaultElement DefaultFaceGridsStyle DefaultFieldHintStyle DefaultFont DefaultFontProperties DefaultFormatType DefaultFormatTypeForStyle DefaultFrameStyle DefaultFrameTicksStyle DefaultGridLinesStyle DefaultInlineFormatType DefaultInputFormatType DefaultLabelStyle DefaultMenuStyle DefaultNaturalLanguage DefaultNewCellStyle DefaultNewInlineCellStyle DefaultNotebook DefaultOptions DefaultOutputFormatType DefaultStyle DefaultStyleDefinitions DefaultTextFormatType DefaultTextInlineFormatType DefaultTicksStyle DefaultTooltipStyle DefaultValues Defer DefineExternal DefineInputStreamMethod DefineOutputStreamMethod Definition Degree DegreeCentrality DegreeGraphDistribution DegreeLexicographic DegreeReverseLexicographic Deinitialization Del Deletable Delete DeleteBorderComponents DeleteCases DeleteContents DeleteDirectory DeleteDuplicates DeleteFile DeleteSmallComponents DeleteWithContents DeletionWarning Delimiter DelimiterFlashTime DelimiterMatching Delimiters Denominator DensityGraphics DensityHistogram DensityPlot DependentVariables Deploy Deployed Depth DepthFirstScan Derivative DerivativeFilter DescriptorStateSpace DesignMatrix Det DGaussianWavelet DiacriticalPositioning Diagonal DiagonalMatrix Dialog DialogIndent DialogInput DialogLevel DialogNotebook DialogProlog DialogReturn DialogSymbols Diamond DiamondMatrix DiceDissimilarity DictionaryLookup DifferenceDelta DifferenceOrder DifferenceRoot DifferenceRootReduce Differences DifferentialD DifferentialRoot DifferentialRootReduce DifferentiatorFilter DigitBlock DigitBlockMinimum DigitCharacter DigitCount DigitQ DihedralGroup Dilation Dimensions DiracComb DiracDelta DirectedEdge DirectedEdges DirectedGraph DirectedGraphQ DirectedInfinity Direction Directive Directory DirectoryName DirectoryQ DirectoryStack DirichletCharacter DirichletConvolve DirichletDistribution DirichletL DirichletTransform DirichletWindow DisableConsolePrintPacket DiscreteChirpZTransform DiscreteConvolve DiscreteDelta DiscreteHadamardTransform DiscreteIndicator DiscreteLQEstimatorGains DiscreteLQRegulatorGains DiscreteLyapunovSolve DiscreteMarkovProcess DiscretePlot DiscretePlot3D DiscreteRatio DiscreteRiccatiSolve DiscreteShift DiscreteTimeModelQ DiscreteUniformDistribution DiscreteVariables DiscreteWaveletData DiscreteWaveletPacketTransform ' +
      'DiscreteWaveletTransform Discriminant Disjunction Disk DiskBox DiskMatrix Dispatch DispersionEstimatorFunction Display DisplayAllSteps DisplayEndPacket DisplayFlushImagePacket DisplayForm DisplayFunction DisplayPacket DisplayRules DisplaySetSizePacket DisplayString DisplayTemporary DisplayWith DisplayWithRef DisplayWithVariable DistanceFunction DistanceTransform Distribute Distributed DistributedContexts DistributeDefinitions DistributionChart DistributionDomain DistributionFitTest DistributionParameterAssumptions DistributionParameterQ Dithering Div Divergence Divide DivideBy Dividers Divisible Divisors DivisorSigma DivisorSum DMSList DMSString Do DockedCells DocumentNotebook DominantColors DOSTextFormat Dot DotDashed DotEqual Dotted DoubleBracketingBar DoubleContourIntegral DoubleDownArrow DoubleLeftArrow DoubleLeftRightArrow DoubleLeftTee DoubleLongLeftArrow DoubleLongLeftRightArrow DoubleLongRightArrow DoubleRightArrow DoubleRightTee DoubleUpArrow DoubleUpDownArrow DoubleVerticalBar DoublyInfinite Down DownArrow DownArrowBar DownArrowUpArrow DownLeftRightVector DownLeftTeeVector DownLeftVector DownLeftVectorBar DownRightTeeVector DownRightVector DownRightVectorBar Downsample DownTee DownTeeArrow DownValues DragAndDrop DrawEdges DrawFrontFaces DrawHighlighted Drop DSolve Dt DualLinearProgramming DualSystemsModel DumpGet DumpSave DuplicateFreeQ Dynamic DynamicBox DynamicBoxOptions DynamicEvaluationTimeout DynamicLocation DynamicModule DynamicModuleBox DynamicModuleBoxOptions DynamicModuleParent DynamicModuleValues DynamicName DynamicNamespace DynamicReference DynamicSetting DynamicUpdating DynamicWrapper DynamicWrapperBox DynamicWrapperBoxOptions ' +
      'E EccentricityCentrality EdgeAdd EdgeBetweennessCentrality EdgeCapacity EdgeCapForm EdgeColor EdgeConnectivity EdgeCost EdgeCount EdgeCoverQ EdgeDashing EdgeDelete EdgeDetect EdgeForm EdgeIndex EdgeJoinForm EdgeLabeling EdgeLabels EdgeLabelStyle EdgeList EdgeOpacity EdgeQ EdgeRenderingFunction EdgeRules EdgeShapeFunction EdgeStyle EdgeThickness EdgeWeight Editable EditButtonSettings EditCellTagsSettings EditDistance EffectiveInterest Eigensystem Eigenvalues EigenvectorCentrality Eigenvectors Element ElementData Eliminate EliminationOrder EllipticE EllipticExp EllipticExpPrime EllipticF EllipticFilterModel EllipticK EllipticLog EllipticNomeQ EllipticPi EllipticReducedHalfPeriods EllipticTheta EllipticThetaPrime EmitSound EmphasizeSyntaxErrors EmpiricalDistribution Empty EmptyGraphQ EnableConsolePrintPacket Enabled Encode End EndAdd EndDialogPacket EndFrontEndInteractionPacket EndOfFile EndOfLine EndOfString EndPackage EngineeringForm Enter EnterExpressionPacket EnterTextPacket Entropy EntropyFilter Environment Epilog Equal EqualColumns EqualRows EqualTilde EquatedTo Equilibrium EquirippleFilterKernel Equivalent Erf Erfc Erfi ErlangB ErlangC ErlangDistribution Erosion ErrorBox ErrorBoxOptions ErrorNorm ErrorPacket ErrorsDialogSettings EstimatedDistribution EstimatedProcess EstimatorGains EstimatorRegulator EuclideanDistance EulerE EulerGamma EulerianGraphQ EulerPhi Evaluatable Evaluate Evaluated EvaluatePacket EvaluationCell EvaluationCompletionAction EvaluationElements EvaluationMode EvaluationMonitor EvaluationNotebook EvaluationObject EvaluationOrder Evaluator EvaluatorNames EvenQ EventData EventEvaluator EventHandler EventHandlerTag EventLabels ExactBlackmanWindow ExactNumberQ ExactRootIsolation ExampleData Except ExcludedForms ExcludePods Exclusions ExclusionsStyle Exists Exit ExitDialog Exp Expand ExpandAll ExpandDenominator ExpandFileName ExpandNumerator Expectation ExpectationE ExpectedValue ExpGammaDistribution ExpIntegralE ExpIntegralEi Exponent ExponentFunction ExponentialDistribution ExponentialFamily ExponentialGeneratingFunction ExponentialMovingAverage ExponentialPowerDistribution ExponentPosition ExponentStep Export ExportAutoReplacements ExportPacket ExportString Expression ExpressionCell ExpressionPacket ExpToTrig ExtendedGCD Extension ExtentElementFunction ExtentMarkers ExtentSize ExternalCall ExternalDataCharacterEncoding Extract ExtractArchive ExtremeValueDistribution ' +
      'FaceForm FaceGrids FaceGridsStyle Factor FactorComplete Factorial Factorial2 FactorialMoment FactorialMomentGeneratingFunction FactorialPower FactorInteger FactorList FactorSquareFree FactorSquareFreeList FactorTerms FactorTermsList Fail FailureDistribution False FARIMAProcess FEDisableConsolePrintPacket FeedbackSector FeedbackSectorStyle FeedbackType FEEnableConsolePrintPacket Fibonacci FieldHint FieldHintStyle FieldMasked FieldSize File FileBaseName FileByteCount FileDate FileExistsQ FileExtension FileFormat FileHash FileInformation FileName FileNameDepth FileNameDialogSettings FileNameDrop FileNameJoin FileNames FileNameSetter FileNameSplit FileNameTake FilePrint FileType FilledCurve FilledCurveBox Filling FillingStyle FillingTransform FilterRules FinancialBond FinancialData FinancialDerivative FinancialIndicator Find FindArgMax FindArgMin FindClique FindClusters FindCurvePath FindDistributionParameters FindDivisions FindEdgeCover FindEdgeCut FindEulerianCycle FindFaces FindFile FindFit FindGeneratingFunction FindGeoLocation FindGeometricTransform FindGraphCommunities FindGraphIsomorphism FindGraphPartition FindHamiltonianCycle FindIndependentEdgeSet FindIndependentVertexSet FindInstance FindIntegerNullVector FindKClan FindKClique FindKClub FindKPlex FindLibrary FindLinearRecurrence FindList FindMaximum FindMaximumFlow FindMaxValue FindMinimum FindMinimumCostFlow FindMinimumCut FindMinValue FindPermutation FindPostmanTour FindProcessParameters FindRoot FindSequenceFunction FindSettings FindShortestPath FindShortestTour FindThreshold FindVertexCover FindVertexCut Fine FinishDynamic FiniteAbelianGroupCount FiniteGroupCount FiniteGroupData First FirstPassageTimeDistribution FischerGroupFi22 FischerGroupFi23 FischerGroupFi24Prime FisherHypergeometricDistribution FisherRatioTest FisherZDistribution Fit FitAll FittedModel FixedPoint FixedPointList FlashSelection Flat Flatten FlattenAt FlatTopWindow FlipView Floor FlushPrintOutputPacket Fold FoldList Font FontColor FontFamily FontForm FontName FontOpacity FontPostScriptName FontProperties FontReencoding FontSize FontSlant FontSubstitutions FontTracking FontVariations FontWeight For ForAll Format FormatRules FormatType FormatTypeAutoConvert FormatValues FormBox FormBoxOptions FortranForm Forward ForwardBackward Fourier FourierCoefficient FourierCosCoefficient FourierCosSeries FourierCosTransform FourierDCT FourierDCTFilter FourierDCTMatrix FourierDST FourierDSTMatrix FourierMatrix FourierParameters FourierSequenceTransform FourierSeries FourierSinCoefficient FourierSinSeries FourierSinTransform FourierTransform FourierTrigSeries FractionalBrownianMotionProcess FractionalPart FractionBox FractionBoxOptions FractionLine Frame FrameBox FrameBoxOptions Framed FrameInset FrameLabel Frameless FrameMargins FrameStyle FrameTicks FrameTicksStyle FRatioDistribution FrechetDistribution FreeQ FrequencySamplingFilterKernel FresnelC FresnelS Friday FrobeniusNumber FrobeniusSolve ' +
      'FromCharacterCode FromCoefficientRules FromContinuedFraction FromDate FromDigits FromDMS Front FrontEndDynamicExpression FrontEndEventActions FrontEndExecute FrontEndObject FrontEndResource FrontEndResourceString FrontEndStackSize FrontEndToken FrontEndTokenExecute FrontEndValueCache FrontEndVersion FrontFaceColor FrontFaceOpacity Full FullAxes FullDefinition FullForm FullGraphics FullOptions FullSimplify Function FunctionExpand FunctionInterpolation FunctionSpace FussellVeselyImportance ' +
      'GaborFilter GaborMatrix GaborWavelet GainMargins GainPhaseMargins Gamma GammaDistribution GammaRegularized GapPenalty Gather GatherBy GaugeFaceElementFunction GaugeFaceStyle GaugeFrameElementFunction GaugeFrameSize GaugeFrameStyle GaugeLabels GaugeMarkers GaugeStyle GaussianFilter GaussianIntegers GaussianMatrix GaussianWindow GCD GegenbauerC General GeneralizedLinearModelFit GenerateConditions GeneratedCell GeneratedParameters GeneratingFunction Generic GenericCylindricalDecomposition GenomeData GenomeLookup GeodesicClosing GeodesicDilation GeodesicErosion GeodesicOpening GeoDestination GeodesyData GeoDirection GeoDistance GeoGridPosition GeometricBrownianMotionProcess GeometricDistribution GeometricMean GeometricMeanFilter GeometricTransformation GeometricTransformation3DBox GeometricTransformation3DBoxOptions GeometricTransformationBox GeometricTransformationBoxOptions GeoPosition GeoPositionENU GeoPositionXYZ GeoProjectionData GestureHandler GestureHandlerTag Get GetBoundingBoxSizePacket GetContext GetEnvironment GetFileName GetFrontEndOptionsDataPacket GetLinebreakInformationPacket GetMenusPacket GetPageBreakInformationPacket Glaisher GlobalClusteringCoefficient GlobalPreferences GlobalSession Glow GoldenRatio GompertzMakehamDistribution GoodmanKruskalGamma GoodmanKruskalGammaTest Goto Grad Gradient GradientFilter GradientOrientationFilter Graph GraphAssortativity GraphCenter GraphComplement GraphData GraphDensity GraphDiameter GraphDifference GraphDisjointUnion ' +
      'GraphDistance GraphDistanceMatrix GraphElementData GraphEmbedding GraphHighlight GraphHighlightStyle GraphHub Graphics Graphics3D Graphics3DBox Graphics3DBoxOptions GraphicsArray GraphicsBaseline GraphicsBox GraphicsBoxOptions GraphicsColor GraphicsColumn GraphicsComplex GraphicsComplex3DBox GraphicsComplex3DBoxOptions GraphicsComplexBox GraphicsComplexBoxOptions GraphicsContents GraphicsData GraphicsGrid GraphicsGridBox GraphicsGroup GraphicsGroup3DBox GraphicsGroup3DBoxOptions GraphicsGroupBox GraphicsGroupBoxOptions GraphicsGrouping GraphicsHighlightColor GraphicsRow GraphicsSpacing GraphicsStyle GraphIntersection GraphLayout GraphLinkEfficiency GraphPeriphery GraphPlot GraphPlot3D GraphPower GraphPropertyDistribution GraphQ GraphRadius GraphReciprocity GraphRoot GraphStyle GraphUnion Gray GrayLevel GreatCircleDistance Greater GreaterEqual GreaterEqualLess GreaterFullEqual GreaterGreater GreaterLess GreaterSlantEqual GreaterTilde Green Grid GridBaseline GridBox GridBoxAlignment GridBoxBackground GridBoxDividers GridBoxFrame GridBoxItemSize GridBoxItemStyle GridBoxOptions GridBoxSpacings GridCreationSettings GridDefaultElement GridElementStyleOptions GridFrame GridFrameMargins GridGraph GridLines GridLinesStyle GroebnerBasis GroupActionBase GroupCentralizer GroupElementFromWord GroupElementPosition GroupElementQ GroupElements GroupElementToWord GroupGenerators GroupMultiplicationTable GroupOrbits GroupOrder GroupPageBreakWithin GroupSetwiseStabilizer GroupStabilizer GroupStabilizerChain Gudermannian GumbelDistribution ' +
      'HaarWavelet HadamardMatrix HalfNormalDistribution HamiltonianGraphQ HammingDistance HammingWindow HankelH1 HankelH2 HankelMatrix HannPoissonWindow HannWindow HaradaNortonGroupHN HararyGraph HarmonicMean HarmonicMeanFilter HarmonicNumber Hash HashTable Haversine HazardFunction Head HeadCompose Heads HeavisideLambda HeavisidePi HeavisideTheta HeldGroupHe HeldPart HelpBrowserLookup HelpBrowserNotebook HelpBrowserSettings HermiteDecomposition HermiteH HermitianMatrixQ HessenbergDecomposition Hessian HexadecimalCharacter Hexahedron HexahedronBox HexahedronBoxOptions HiddenSurface HighlightGraph HighlightImage HighpassFilter HigmanSimsGroupHS HilbertFilter HilbertMatrix Histogram Histogram3D HistogramDistribution HistogramList HistogramTransform HistogramTransformInterpolation HitMissTransform HITSCentrality HodgeDual HoeffdingD HoeffdingDTest Hold HoldAll HoldAllComplete HoldComplete HoldFirst HoldForm HoldPattern HoldRest HolidayCalendar HomeDirectory HomePage Horizontal HorizontalForm HorizontalGauge HorizontalScrollPosition HornerForm HotellingTSquareDistribution HoytDistribution HTMLSave Hue HumpDownHump HumpEqual HurwitzLerchPhi HurwitzZeta HyperbolicDistribution HypercubeGraph HyperexponentialDistribution Hyperfactorial Hypergeometric0F1 Hypergeometric0F1Regularized Hypergeometric1F1 Hypergeometric1F1Regularized Hypergeometric2F1 Hypergeometric2F1Regularized HypergeometricDistribution HypergeometricPFQ HypergeometricPFQRegularized HypergeometricU Hyperlink HyperlinkCreationSettings Hyphenation HyphenationOptions HypoexponentialDistribution HypothesisTestData ' +
      'I Identity IdentityMatrix If IgnoreCase Im Image Image3D Image3DSlices ImageAccumulate ImageAdd ImageAdjust ImageAlign ImageApply ImageAspectRatio ImageAssemble ImageCache ImageCacheValid ImageCapture ImageChannels ImageClip ImageColorSpace ImageCompose ImageConvolve ImageCooccurrence ImageCorners ImageCorrelate ImageCorrespondingPoints ImageCrop ImageData ImageDataPacket ImageDeconvolve ImageDemosaic ImageDifference ImageDimensions ImageDistance ImageEffect ImageFeatureTrack ImageFileApply ImageFileFilter ImageFileScan ImageFilter ImageForestingComponents ImageForwardTransformation ImageHistogram ImageKeypoints ImageLevels ImageLines ImageMargins ImageMarkers ImageMeasurements ImageMultiply ImageOffset ImagePad ImagePadding ImagePartition ImagePeriodogram ImagePerspectiveTransformation ImageQ ImageRangeCache ImageReflect ImageRegion ImageResize ImageResolution ImageRotate ImageRotated ImageScaled ImageScan ImageSize ImageSizeAction ImageSizeCache ImageSizeMultipliers ImageSizeRaw ImageSubtract ImageTake ImageTransformation ImageTrim ImageType ImageValue ImageValuePositions Implies Import ImportAutoReplacements ImportString ImprovementImportance In IncidenceGraph IncidenceList IncidenceMatrix IncludeConstantBasis IncludeFileExtension IncludePods IncludeSingularTerm Increment Indent IndentingNewlineSpacings IndentMaxFraction IndependenceTest IndependentEdgeSetQ IndependentUnit IndependentVertexSetQ Indeterminate IndexCreationOptions Indexed IndexGraph IndexTag Inequality InexactNumberQ InexactNumbers Infinity Infix Information Inherited InheritScope Initialization InitializationCell InitializationCellEvaluation InitializationCellWarning InlineCounterAssignments InlineCounterIncrements InlineRules Inner Inpaint Input InputAliases InputAssumptions InputAutoReplacements InputField InputFieldBox InputFieldBoxOptions InputForm InputGrouping InputNamePacket InputNotebook InputPacket InputSettings InputStream InputString InputStringPacket InputToBoxFormPacket Insert InsertionPointObject InsertResults Inset Inset3DBox Inset3DBoxOptions InsetBox InsetBoxOptions Install InstallService InString Integer IntegerDigits IntegerExponent IntegerLength IntegerPart IntegerPartitions IntegerQ Integers IntegerString Integral Integrate Interactive InteractiveTradingChart Interlaced Interleaving InternallyBalancedDecomposition InterpolatingFunction InterpolatingPolynomial Interpolation InterpolationOrder InterpolationPoints InterpolationPrecision Interpretation InterpretationBox InterpretationBoxOptions InterpretationFunction ' +
      'InterpretTemplate InterquartileRange Interrupt InterruptSettings Intersection Interval IntervalIntersection IntervalMemberQ IntervalUnion Inverse InverseBetaRegularized InverseCDF InverseChiSquareDistribution InverseContinuousWaveletTransform InverseDistanceTransform InverseEllipticNomeQ InverseErf InverseErfc InverseFourier InverseFourierCosTransform InverseFourierSequenceTransform InverseFourierSinTransform InverseFourierTransform InverseFunction InverseFunctions InverseGammaDistribution InverseGammaRegularized InverseGaussianDistribution InverseGudermannian InverseHaversine InverseJacobiCD InverseJacobiCN InverseJacobiCS InverseJacobiDC InverseJacobiDN InverseJacobiDS InverseJacobiNC InverseJacobiND InverseJacobiNS InverseJacobiSC InverseJacobiSD InverseJacobiSN InverseLaplaceTransform InversePermutation InverseRadon InverseSeries InverseSurvivalFunction InverseWaveletTransform InverseWeierstrassP InverseZTransform Invisible InvisibleApplication InvisibleTimes IrreduciblePolynomialQ IsolatingInterval IsomorphicGraphQ IsotopeData Italic Item ItemBox ItemBoxOptions ItemSize ItemStyle ItoProcess ' +
      'JaccardDissimilarity JacobiAmplitude Jacobian JacobiCD JacobiCN JacobiCS JacobiDC JacobiDN JacobiDS JacobiNC JacobiND JacobiNS JacobiP JacobiSC JacobiSD JacobiSN JacobiSymbol JacobiZeta JankoGroupJ1 JankoGroupJ2 JankoGroupJ3 JankoGroupJ4 JarqueBeraALMTest JohnsonDistribution Join Joined JoinedCurve JoinedCurveBox JoinForm JordanDecomposition JordanModelDecomposition ' +
      'K KagiChart KaiserBesselWindow KaiserWindow KalmanEstimator KalmanFilter KarhunenLoeveDecomposition KaryTree KatzCentrality KCoreComponents KDistribution KelvinBei KelvinBer KelvinKei KelvinKer KendallTau KendallTauTest KernelExecute KernelMixtureDistribution KernelObject Kernels Ket Khinchin KirchhoffGraph KirchhoffMatrix KleinInvariantJ KnightTourGraph KnotData KnownUnitQ KolmogorovSmirnovTest KroneckerDelta KroneckerModelDecomposition KroneckerProduct KroneckerSymbol KuiperTest KumaraswamyDistribution Kurtosis KuwaharaFilter ' +
      'Label Labeled LabeledSlider LabelingFunction LabelStyle LaguerreL LambdaComponents LambertW LanczosWindow LandauDistribution Language LanguageCategory LaplaceDistribution LaplaceTransform Laplacian LaplacianFilter LaplacianGaussianFilter Large Larger Last Latitude LatitudeLongitude LatticeData LatticeReduce Launch LaunchKernels LayeredGraphPlot LayerSizeFunction LayoutInformation LCM LeafCount LeapYearQ LeastSquares LeastSquaresFilterKernel Left LeftArrow LeftArrowBar LeftArrowRightArrow LeftDownTeeVector LeftDownVector LeftDownVectorBar LeftRightArrow LeftRightVector LeftTee LeftTeeArrow LeftTeeVector LeftTriangle LeftTriangleBar LeftTriangleEqual LeftUpDownVector LeftUpTeeVector LeftUpVector LeftUpVectorBar LeftVector LeftVectorBar LegendAppearance Legended LegendFunction LegendLabel LegendLayout LegendMargins LegendMarkers LegendMarkerSize LegendreP LegendreQ LegendreType Length LengthWhile LerchPhi Less LessEqual LessEqualGreater LessFullEqual LessGreater LessLess LessSlantEqual LessTilde LetterCharacter LetterQ Level LeveneTest LeviCivitaTensor LevyDistribution Lexicographic LibraryFunction LibraryFunctionError LibraryFunctionInformation LibraryFunctionLoad LibraryFunctionUnload LibraryLoad LibraryUnload LicenseID LiftingFilterData LiftingWaveletTransform LightBlue LightBrown LightCyan Lighter LightGray LightGreen Lighting LightingAngle LightMagenta LightOrange LightPink LightPurple LightRed LightSources LightYellow Likelihood Limit LimitsPositioning LimitsPositioningTokens LindleyDistribution Line Line3DBox LinearFilter LinearFractionalTransform LinearModelFit LinearOffsetFunction LinearProgramming LinearRecurrence LinearSolve LinearSolveFunction LineBox LineBreak LinebreakAdjustments LineBreakChart LineBreakWithin LineColor LineForm LineGraph LineIndent LineIndentMaxFraction LineIntegralConvolutionPlot LineIntegralConvolutionScale LineLegend LineOpacity LineSpacing LineWrapParts LinkActivate LinkClose LinkConnect LinkConnectedQ LinkCreate LinkError LinkFlush LinkFunction LinkHost LinkInterrupt LinkLaunch LinkMode LinkObject LinkOpen LinkOptions LinkPatterns LinkProtocol LinkRead LinkReadHeld LinkReadyQ Links LinkWrite LinkWriteHeld LiouvilleLambda List Listable ListAnimate ListContourPlot ListContourPlot3D ListConvolve ListCorrelate ListCurvePathPlot ListDeconvolve ListDensityPlot Listen ListFourierSequenceTransform ListInterpolation ListLineIntegralConvolutionPlot ListLinePlot ListLogLinearPlot ListLogLogPlot ListLogPlot ListPicker ListPickerBox ListPickerBoxBackground ListPickerBoxOptions ListPlay ListPlot ListPlot3D ListPointPlot3D ListPolarPlot ListQ ListStreamDensityPlot ListStreamPlot ListSurfacePlot3D ListVectorDensityPlot ListVectorPlot ListVectorPlot3D ListZTransform Literal LiteralSearch LocalClusteringCoefficient LocalizeVariables LocationEquivalenceTest LocationTest Locator LocatorAutoCreate LocatorBox LocatorBoxOptions LocatorCentering LocatorPane LocatorPaneBox LocatorPaneBoxOptions ' +
      'LocatorRegion Locked Log Log10 Log2 LogBarnesG LogGamma LogGammaDistribution LogicalExpand LogIntegral LogisticDistribution LogitModelFit LogLikelihood LogLinearPlot LogLogisticDistribution LogLogPlot LogMultinormalDistribution LogNormalDistribution LogPlot LogRankTest LogSeriesDistribution LongEqual Longest LongestAscendingSequence LongestCommonSequence LongestCommonSequencePositions LongestCommonSubsequence LongestCommonSubsequencePositions LongestMatch LongForm Longitude LongLeftArrow LongLeftRightArrow LongRightArrow Loopback LoopFreeGraphQ LowerCaseQ LowerLeftArrow LowerRightArrow LowerTriangularize LowpassFilter LQEstimatorGains LQGRegulator LQOutputRegulatorGains LQRegulatorGains LUBackSubstitution LucasL LuccioSamiComponents LUDecomposition LyapunovSolve LyonsGroupLy ' +
      'MachineID MachineName MachineNumberQ MachinePrecision MacintoshSystemPageSetup Magenta Magnification Magnify MainSolve MaintainDynamicCaches Majority MakeBoxes MakeExpression MakeRules MangoldtLambda ManhattanDistance Manipulate Manipulator MannWhitneyTest MantissaExponent Manual Map MapAll MapAt MapIndexed MAProcess MapThread MarcumQ MardiaCombinedTest MardiaKurtosisTest MardiaSkewnessTest MarginalDistribution MarkovProcessProperties Masking MatchingDissimilarity MatchLocalNameQ MatchLocalNames MatchQ Material MathematicaNotation MathieuC MathieuCharacteristicA MathieuCharacteristicB MathieuCharacteristicExponent MathieuCPrime MathieuGroupM11 MathieuGroupM12 MathieuGroupM22 MathieuGroupM23 MathieuGroupM24 MathieuS MathieuSPrime MathMLForm MathMLText Matrices MatrixExp MatrixForm MatrixFunction MatrixLog MatrixPlot MatrixPower MatrixQ MatrixRank Max MaxBend MaxDetect MaxExtraBandwidths MaxExtraConditions MaxFeatures MaxFilter Maximize MaxIterations MaxMemoryUsed MaxMixtureKernels MaxPlotPoints MaxPoints MaxRecursion MaxStableDistribution MaxStepFraction MaxSteps MaxStepSize MaxValue MaxwellDistribution McLaughlinGroupMcL Mean MeanClusteringCoefficient MeanDegreeConnectivity MeanDeviation MeanFilter MeanGraphDistance MeanNeighborDegree MeanShift MeanShiftFilter Median MedianDeviation MedianFilter Medium MeijerG MeixnerDistribution MemberQ MemoryConstrained MemoryInUse Menu MenuAppearance MenuCommandKey MenuEvaluator MenuItem MenuPacket MenuSortingValue MenuStyle MenuView MergeDifferences Mesh MeshFunctions MeshRange MeshShading MeshStyle Message MessageDialog MessageList MessageName MessageOptions MessagePacket Messages MessagesNotebook MetaCharacters MetaInformation Method MethodOptions MexicanHatWavelet MeyerWavelet Min MinDetect MinFilter MinimalPolynomial MinimalStateSpaceModel Minimize Minors MinRecursion MinSize MinStableDistribution Minus MinusPlus MinValue Missing MissingDataMethod MittagLefflerE MixedRadix MixedRadixQuantity MixtureDistribution Mod Modal Mode Modular ModularLambda Module Modulus MoebiusMu Moment Momentary MomentConvert MomentEvaluate MomentGeneratingFunction Monday Monitor MonomialList MonomialOrder MonsterGroupM MorletWavelet MorphologicalBinarize MorphologicalBranchPoints MorphologicalComponents MorphologicalEulerNumber MorphologicalGraph MorphologicalPerimeter MorphologicalTransform Most MouseAnnotation MouseAppearance MouseAppearanceTag MouseButtons Mouseover MousePointerNote MousePosition MovingAverage MovingMedian MoyalDistribution MultiedgeStyle MultilaunchWarning MultiLetterItalics MultiLetterStyle MultilineFunction Multinomial MultinomialDistribution MultinormalDistribution MultiplicativeOrder Multiplicity Multiselection MultivariateHypergeometricDistribution MultivariatePoissonDistribution MultivariateTDistribution ' +
      'N NakagamiDistribution NameQ Names NamespaceBox Nand NArgMax NArgMin NBernoulliB NCache NDSolve NDSolveValue Nearest NearestFunction NeedCurrentFrontEndPackagePacket NeedCurrentFrontEndSymbolsPacket NeedlemanWunschSimilarity Needs Negative NegativeBinomialDistribution NegativeMultinomialDistribution NeighborhoodGraph Nest NestedGreaterGreater NestedLessLess NestedScriptRules NestList NestWhile NestWhileList NevilleThetaC NevilleThetaD NevilleThetaN NevilleThetaS NewPrimitiveStyle NExpectation Next NextPrime NHoldAll NHoldFirst NHoldRest NicholsGridLines NicholsPlot NIntegrate NMaximize NMaxValue NMinimize NMinValue NominalVariables NonAssociative NoncentralBetaDistribution NoncentralChiSquareDistribution NoncentralFRatioDistribution NoncentralStudentTDistribution NonCommutativeMultiply NonConstants None NonlinearModelFit NonlocalMeansFilter NonNegative NonPositive Nor NorlundB Norm Normal NormalDistribution NormalGrouping Normalize NormalizedSquaredEuclideanDistance NormalsFunction NormFunction Not NotCongruent NotCupCap NotDoubleVerticalBar Notebook NotebookApply NotebookAutoSave NotebookClose NotebookConvertSettings NotebookCreate NotebookCreateReturnObject NotebookDefault NotebookDelete NotebookDirectory NotebookDynamicExpression NotebookEvaluate NotebookEventActions NotebookFileName NotebookFind NotebookFindReturnObject NotebookGet NotebookGetLayoutInformationPacket NotebookGetMisspellingsPacket NotebookInformation NotebookInterfaceObject NotebookLocate NotebookObject NotebookOpen NotebookOpenReturnObject NotebookPath NotebookPrint NotebookPut NotebookPutReturnObject NotebookRead NotebookResetGeneratedCells Notebooks NotebookSave NotebookSaveAs NotebookSelection NotebookSetupLayoutInformationPacket NotebooksMenu NotebookWrite NotElement NotEqualTilde NotExists NotGreater NotGreaterEqual NotGreaterFullEqual NotGreaterGreater NotGreaterLess NotGreaterSlantEqual NotGreaterTilde NotHumpDownHump NotHumpEqual NotLeftTriangle NotLeftTriangleBar NotLeftTriangleEqual NotLess NotLessEqual NotLessFullEqual NotLessGreater NotLessLess NotLessSlantEqual NotLessTilde NotNestedGreaterGreater NotNestedLessLess NotPrecedes NotPrecedesEqual NotPrecedesSlantEqual NotPrecedesTilde NotReverseElement NotRightTriangle NotRightTriangleBar NotRightTriangleEqual NotSquareSubset NotSquareSubsetEqual NotSquareSuperset NotSquareSupersetEqual NotSubset NotSubsetEqual NotSucceeds NotSucceedsEqual NotSucceedsSlantEqual NotSucceedsTilde NotSuperset NotSupersetEqual NotTilde NotTildeEqual NotTildeFullEqual NotTildeTilde NotVerticalBar NProbability NProduct NProductFactors NRoots NSolve NSum NSumTerms Null NullRecords NullSpace NullWords Number NumberFieldClassNumber NumberFieldDiscriminant NumberFieldFundamentalUnits NumberFieldIntegralBasis NumberFieldNormRepresentatives NumberFieldRegulator NumberFieldRootsOfUnity NumberFieldSignature NumberForm NumberFormat NumberMarks NumberMultiplier NumberPadding NumberPoint NumberQ NumberSeparator ' +
      'NumberSigns NumberString Numerator NumericFunction NumericQ NuttallWindow NValues NyquistGridLines NyquistPlot ' +
      'O ObservabilityGramian ObservabilityMatrix ObservableDecomposition ObservableModelQ OddQ Off Offset OLEData On ONanGroupON OneIdentity Opacity Open OpenAppend Opener OpenerBox OpenerBoxOptions OpenerView OpenFunctionInspectorPacket Opening OpenRead OpenSpecialOptions OpenTemporary OpenWrite Operate OperatingSystem OptimumFlowData Optional OptionInspectorSettings OptionQ Options OptionsPacket OptionsPattern OptionValue OptionValueBox OptionValueBoxOptions Or Orange Order OrderDistribution OrderedQ Ordering Orderless OrnsteinUhlenbeckProcess Orthogonalize Out Outer OutputAutoOverwrite OutputControllabilityMatrix OutputControllableModelQ OutputForm OutputFormData OutputGrouping OutputMathEditExpression OutputNamePacket OutputResponse OutputSizeLimit OutputStream Over OverBar OverDot Overflow OverHat Overlaps Overlay OverlayBox OverlayBoxOptions Overscript OverscriptBox OverscriptBoxOptions OverTilde OverVector OwenT OwnValues ' +
      'PackingMethod PaddedForm Padding PadeApproximant PadLeft PadRight PageBreakAbove PageBreakBelow PageBreakWithin PageFooterLines PageFooters PageHeaderLines PageHeaders PageHeight PageRankCentrality PageWidth PairedBarChart PairedHistogram PairedSmoothHistogram PairedTTest PairedZTest PaletteNotebook PalettePath Pane PaneBox PaneBoxOptions Panel PanelBox PanelBoxOptions Paneled PaneSelector PaneSelectorBox PaneSelectorBoxOptions PaperWidth ParabolicCylinderD ParagraphIndent ParagraphSpacing ParallelArray ParallelCombine ParallelDo ParallelEvaluate Parallelization Parallelize ParallelMap ParallelNeeds ParallelProduct ParallelSubmit ParallelSum ParallelTable ParallelTry Parameter ParameterEstimator ParameterMixtureDistribution ParameterVariables ParametricFunction ParametricNDSolve ParametricNDSolveValue ParametricPlot ParametricPlot3D ParentConnect ParentDirectory ParentForm Parenthesize ParentList ParetoDistribution Part PartialCorrelationFunction PartialD ParticleData Partition PartitionsP PartitionsQ ParzenWindow PascalDistribution PassEventsDown PassEventsUp Paste PasteBoxFormInlineCells PasteButton Path PathGraph PathGraphQ Pattern PatternSequence PatternTest PauliMatrix PaulWavelet Pause PausedTime PDF PearsonChiSquareTest PearsonCorrelationTest PearsonDistribution PerformanceGoal PeriodicInterpolation Periodogram PeriodogramArray PermutationCycles PermutationCyclesQ PermutationGroup PermutationLength PermutationList PermutationListQ PermutationMax PermutationMin PermutationOrder PermutationPower PermutationProduct PermutationReplace Permutations PermutationSupport Permute PeronaMalikFilter Perpendicular PERTDistribution PetersenGraph PhaseMargins Pi Pick PIDData PIDDerivativeFilter PIDFeedforward PIDTune Piecewise PiecewiseExpand PieChart PieChart3D PillaiTrace PillaiTraceTest Pink Pivoting PixelConstrained PixelValue PixelValuePositions Placed Placeholder PlaceholderReplace Plain PlanarGraphQ Play PlayRange Plot Plot3D Plot3Matrix PlotDivision PlotJoined PlotLabel PlotLayout PlotLegends PlotMarkers PlotPoints PlotRange PlotRangeClipping PlotRangePadding PlotRegion PlotStyle Plus PlusMinus Pochhammer PodStates PodWidth Point Point3DBox PointBox PointFigureChart PointForm PointLegend PointSize PoissonConsulDistribution PoissonDistribution PoissonProcess PoissonWindow PolarAxes PolarAxesOrigin PolarGridLines PolarPlot PolarTicks PoleZeroMarkers PolyaAeppliDistribution PolyGamma Polygon Polygon3DBox Polygon3DBoxOptions PolygonBox PolygonBoxOptions PolygonHoleScale PolygonIntersections PolygonScale PolyhedronData PolyLog PolynomialExtendedGCD PolynomialForm PolynomialGCD PolynomialLCM PolynomialMod PolynomialQ PolynomialQuotient PolynomialQuotientRemainder PolynomialReduce PolynomialRemainder Polynomials PopupMenu PopupMenuBox PopupMenuBoxOptions PopupView PopupWindow Position Positive PositiveDefiniteMatrixQ PossibleZeroQ Postfix PostScript Power PowerDistribution PowerExpand PowerMod PowerModList ' +
      'PowerSpectralDensity PowersRepresentations PowerSymmetricPolynomial Precedence PrecedenceForm Precedes PrecedesEqual PrecedesSlantEqual PrecedesTilde Precision PrecisionGoal PreDecrement PredictionRoot PreemptProtect PreferencesPath Prefix PreIncrement Prepend PrependTo PreserveImageOptions Previous PriceGraphDistribution PrimaryPlaceholder Prime PrimeNu PrimeOmega PrimePi PrimePowerQ PrimeQ Primes PrimeZetaP PrimitiveRoot PrincipalComponents PrincipalValue Print PrintAction PrintForm PrintingCopies PrintingOptions PrintingPageRange PrintingStartingPageNumber PrintingStyleEnvironment PrintPrecision PrintTemporary Prism PrismBox PrismBoxOptions PrivateCellOptions PrivateEvaluationOptions PrivateFontOptions PrivateFrontEndOptions PrivateNotebookOptions PrivatePaths Probability ProbabilityDistribution ProbabilityPlot ProbabilityPr ProbabilityScalePlot ProbitModelFit ProcessEstimator ProcessParameterAssumptions ProcessParameterQ ProcessStateDomain ProcessTimeDomain Product ProductDistribution ProductLog ProgressIndicator ProgressIndicatorBox ProgressIndicatorBoxOptions Projection Prolog PromptForm Properties Property PropertyList PropertyValue Proportion Proportional Protect Protected ProteinData Pruning PseudoInverse Purple Put PutAppend Pyramid PyramidBox PyramidBoxOptions ' +
      'QBinomial QFactorial QGamma QHypergeometricPFQ QPochhammer QPolyGamma QRDecomposition QuadraticIrrationalQ Quantile QuantilePlot Quantity QuantityForm QuantityMagnitude QuantityQ QuantityUnit Quartics QuartileDeviation Quartiles QuartileSkewness QueueingNetworkProcess QueueingProcess QueueProperties Quiet Quit Quotient QuotientRemainder ' +
      'RadialityCentrality RadicalBox RadicalBoxOptions RadioButton RadioButtonBar RadioButtonBox RadioButtonBoxOptions Radon RamanujanTau RamanujanTauL RamanujanTauTheta RamanujanTauZ Random RandomChoice RandomComplex RandomFunction RandomGraph RandomImage RandomInteger RandomPermutation RandomPrime RandomReal RandomSample RandomSeed RandomVariate RandomWalkProcess Range RangeFilter RangeSpecification RankedMax RankedMin Raster Raster3D Raster3DBox Raster3DBoxOptions RasterArray RasterBox RasterBoxOptions Rasterize RasterSize Rational RationalFunctions Rationalize Rationals Ratios Raw RawArray RawBoxes RawData RawMedium RayleighDistribution Re Read ReadList ReadProtected Real RealBlockDiagonalForm RealDigits RealExponent Reals Reap Record RecordLists RecordSeparators Rectangle RectangleBox RectangleBoxOptions RectangleChart RectangleChart3D RecurrenceFilter RecurrenceTable RecurringDigitsForm Red Reduce RefBox ReferenceLineStyle ReferenceMarkers ReferenceMarkerStyle Refine ReflectionMatrix ReflectionTransform Refresh RefreshRate RegionBinarize RegionFunction RegionPlot RegionPlot3D RegularExpression Regularization Reinstall Release ReleaseHold ReliabilityDistribution ReliefImage ReliefPlot Remove RemoveAlphaChannel RemoveAsynchronousTask Removed RemoveInputStreamMethod RemoveOutputStreamMethod RemoveProperty RemoveScheduledTask RenameDirectory RenameFile RenderAll RenderingOptions RenewalProcess RenkoChart Repeated RepeatedNull RepeatedString Replace ReplaceAll ReplaceHeldPart ReplaceImageValue ReplaceList ReplacePart ReplacePixelValue ReplaceRepeated Resampling Rescale RescalingTransform ResetDirectory ResetMenusPacket ResetScheduledTask Residue Resolve Rest Resultant ResumePacket Return ReturnExpressionPacket ReturnInputFormPacket ReturnPacket ReturnTextPacket Reverse ReverseBiorthogonalSplineWavelet ReverseElement ReverseEquilibrium ReverseGraph ReverseUpEquilibrium RevolutionAxis RevolutionPlot3D RGBColor RiccatiSolve RiceDistribution RidgeFilter RiemannR RiemannSiegelTheta RiemannSiegelZ Riffle Right RightArrow RightArrowBar RightArrowLeftArrow RightCosetRepresentative RightDownTeeVector RightDownVector RightDownVectorBar RightTee RightTeeArrow RightTeeVector RightTriangle RightTriangleBar RightTriangleEqual RightUpDownVector RightUpTeeVector RightUpVector RightUpVectorBar RightVector RightVectorBar RiskAchievementImportance RiskReductionImportance RogersTanimotoDissimilarity Root RootApproximant RootIntervals RootLocusPlot RootMeanSquare RootOfUnityQ RootReduce Roots RootSum Rotate RotateLabel RotateLeft RotateRight RotationAction RotationBox RotationBoxOptions RotationMatrix RotationTransform Round RoundImplies RoundingRadius Row RowAlignments RowBackgrounds RowBox RowHeights RowLines RowMinHeight RowReduce RowsEqual RowSpacings RSolve RudvalisGroupRu Rule RuleCondition RuleDelayed RuleForm RulerUnits Run RunScheduledTask RunThrough RuntimeAttributes RuntimeOptions RussellRaoDissimilarity ' +
      'SameQ SameTest SampleDepth SampledSoundFunction SampledSoundList SampleRate SamplingPeriod SARIMAProcess SARMAProcess SatisfiabilityCount SatisfiabilityInstances SatisfiableQ Saturday Save Saveable SaveAutoDelete SaveDefinitions SawtoothWave Scale Scaled ScaleDivisions ScaledMousePosition ScaleOrigin ScalePadding ScaleRanges ScaleRangeStyle ScalingFunctions ScalingMatrix ScalingTransform Scan ScheduledTaskActiveQ ScheduledTaskData ScheduledTaskObject ScheduledTasks SchurDecomposition ScientificForm ScreenRectangle ScreenStyleEnvironment ScriptBaselineShifts ScriptLevel ScriptMinSize ScriptRules ScriptSizeMultipliers Scrollbars ScrollingOptions ScrollPosition Sec Sech SechDistribution SectionGrouping SectorChart SectorChart3D SectorOrigin SectorSpacing SeedRandom Select Selectable SelectComponents SelectedCells SelectedNotebook Selection SelectionAnimate SelectionCell SelectionCellCreateCell SelectionCellDefaultStyle SelectionCellParentStyle SelectionCreateCell SelectionDebuggerTag SelectionDuplicateCell SelectionEvaluate SelectionEvaluateCreateCell SelectionMove SelectionPlaceholder SelectionSetStyle SelectWithContents SelfLoops SelfLoopStyle SemialgebraicComponentInstances SendMail Sequence SequenceAlignment SequenceForm SequenceHold SequenceLimit Series SeriesCoefficient SeriesData SessionTime Set SetAccuracy SetAlphaChannel SetAttributes Setbacks SetBoxFormNamesPacket SetDelayed SetDirectory SetEnvironment SetEvaluationNotebook SetFileDate SetFileLoadingContext SetNotebookStatusLine SetOptions SetOptionsPacket SetPrecision SetProperty SetSelectedNotebook SetSharedFunction SetSharedVariable SetSpeechParametersPacket SetStreamPosition SetSystemOptions Setter SetterBar SetterBox SetterBoxOptions Setting SetValue Shading Shallow ShannonWavelet ShapiroWilkTest Share Sharpen ShearingMatrix ShearingTransform ShenCastanMatrix Short ShortDownArrow Shortest ShortestMatch ShortestPathFunction ShortLeftArrow ShortRightArrow ShortUpArrow Show ShowAutoStyles ShowCellBracket ShowCellLabel ShowCellTags ShowClosedCellArea ShowContents ShowControls ShowCursorTracker ShowGroupOpenCloseIcon ShowGroupOpener ShowInvisibleCharacters ShowPageBreaks ShowPredictiveInterface ShowSelection ShowShortBoxForm ShowSpecialCharacters ShowStringCharacters ShowSyntaxStyles ShrinkingDelay ShrinkWrapBoundingBox SiegelTheta SiegelTukeyTest Sign Signature SignedRankTest SignificanceLevel SignPadding SignTest SimilarityRules SimpleGraph SimpleGraphQ Simplify Sin Sinc SinghMaddalaDistribution SingleEvaluation SingleLetterItalics SingleLetterStyle SingularValueDecomposition SingularValueList SingularValuePlot SingularValues Sinh SinhIntegral SinIntegral SixJSymbol Skeleton SkeletonTransform SkellamDistribution Skewness SkewNormalDistribution Skip SliceDistribution Slider Slider2D Slider2DBox Slider2DBoxOptions SliderBox SliderBoxOptions SlideView Slot SlotSequence Small SmallCircle Smaller SmithDelayCompensator SmithWatermanSimilarity ' +
      'SmoothDensityHistogram SmoothHistogram SmoothHistogram3D SmoothKernelDistribution SocialMediaData Socket SokalSneathDissimilarity Solve SolveAlways SolveDelayed Sort SortBy Sound SoundAndGraphics SoundNote SoundVolume Sow Space SpaceForm Spacer Spacings Span SpanAdjustments SpanCharacterRounding SpanFromAbove SpanFromBoth SpanFromLeft SpanLineThickness SpanMaxSize SpanMinSize SpanningCharacters SpanSymmetric SparseArray SpatialGraphDistribution Speak SpeakTextPacket SpearmanRankTest SpearmanRho Spectrogram SpectrogramArray Specularity SpellingCorrection SpellingDictionaries SpellingDictionariesPath SpellingOptions SpellingSuggestionsPacket Sphere SphereBox SphericalBesselJ SphericalBesselY SphericalHankelH1 SphericalHankelH2 SphericalHarmonicY SphericalPlot3D SphericalRegion SpheroidalEigenvalue SpheroidalJoiningFactor SpheroidalPS SpheroidalPSPrime SpheroidalQS SpheroidalQSPrime SpheroidalRadialFactor SpheroidalS1 SpheroidalS1Prime SpheroidalS2 SpheroidalS2Prime Splice SplicedDistribution SplineClosed SplineDegree SplineKnots SplineWeights Split SplitBy SpokenString Sqrt SqrtBox SqrtBoxOptions Square SquaredEuclideanDistance SquareFreeQ SquareIntersection SquaresR SquareSubset SquareSubsetEqual SquareSuperset SquareSupersetEqual SquareUnion SquareWave StabilityMargins StabilityMarginsStyle StableDistribution Stack StackBegin StackComplete StackInhibit StandardDeviation StandardDeviationFilter StandardForm Standardize StandbyDistribution Star StarGraph StartAsynchronousTask StartingStepSize StartOfLine StartOfString StartScheduledTask StartupSound StateDimensions StateFeedbackGains StateOutputEstimator StateResponse StateSpaceModel StateSpaceRealization StateSpaceTransform StationaryDistribution StationaryWaveletPacketTransform StationaryWaveletTransform StatusArea StatusCentrality StepMonitor StieltjesGamma StirlingS1 StirlingS2 StopAsynchronousTask StopScheduledTask StrataVariables StratonovichProcess StreamColorFunction StreamColorFunctionScaling StreamDensityPlot StreamPlot StreamPoints StreamPosition Streams StreamScale StreamStyle String StringBreak StringByteCount StringCases StringCount StringDrop StringExpression StringForm StringFormat StringFreeQ StringInsert StringJoin StringLength StringMatchQ StringPosition StringQ StringReplace StringReplaceList StringReplacePart StringReverse StringRotateLeft StringRotateRight StringSkeleton StringSplit StringTake StringToStream StringTrim StripBoxes StripOnInput StripWrapperBoxes StrokeForm StructuralImportance StructuredArray StructuredSelection StruveH StruveL Stub StudentTDistribution Style StyleBox StyleBoxAutoDelete StyleBoxOptions StyleData StyleDefinitions StyleForm StyleKeyMapping StyleMenuListing StyleNameDialogSettings StyleNames StylePrint StyleSheetPath Subfactorial Subgraph SubMinus SubPlus SubresultantPolynomialRemainders ' +
      'SubresultantPolynomials Subresultants Subscript SubscriptBox SubscriptBoxOptions Subscripted Subset SubsetEqual Subsets SubStar Subsuperscript SubsuperscriptBox SubsuperscriptBoxOptions Subtract SubtractFrom SubValues Succeeds SucceedsEqual SucceedsSlantEqual SucceedsTilde SuchThat Sum SumConvergence Sunday SuperDagger SuperMinus SuperPlus Superscript SuperscriptBox SuperscriptBoxOptions Superset SupersetEqual SuperStar Surd SurdForm SurfaceColor SurfaceGraphics SurvivalDistribution SurvivalFunction SurvivalModel SurvivalModelFit SuspendPacket SuzukiDistribution SuzukiGroupSuz SwatchLegend Switch Symbol SymbolName SymletWavelet Symmetric SymmetricGroup SymmetricMatrixQ SymmetricPolynomial SymmetricReduction Symmetrize SymmetrizedArray SymmetrizedArrayRules SymmetrizedDependentComponents SymmetrizedIndependentComponents SymmetrizedReplacePart SynchronousInitialization SynchronousUpdating Syntax SyntaxForm SyntaxInformation SyntaxLength SyntaxPacket SyntaxQ SystemDialogInput SystemException SystemHelpPath SystemInformation SystemInformationData SystemOpen SystemOptions SystemsModelDelay SystemsModelDelayApproximate SystemsModelDelete SystemsModelDimensions SystemsModelExtract SystemsModelFeedbackConnect SystemsModelLabels SystemsModelOrder SystemsModelParallelConnect SystemsModelSeriesConnect SystemsModelStateFeedbackConnect SystemStub ' +
      'Tab TabFilling Table TableAlignments TableDepth TableDirections TableForm TableHeadings TableSpacing TableView TableViewBox TabSpacings TabView TabViewBox TabViewBoxOptions TagBox TagBoxNote TagBoxOptions TaggingRules TagSet TagSetDelayed TagStyle TagUnset Take TakeWhile Tally Tan Tanh TargetFunctions TargetUnits TautologyQ TelegraphProcess TemplateBox TemplateBoxOptions TemplateSlotSequence TemporalData Temporary TemporaryVariable TensorContract TensorDimensions TensorExpand TensorProduct TensorQ TensorRank TensorReduce TensorSymmetry TensorTranspose TensorWedge Tetrahedron TetrahedronBox TetrahedronBoxOptions TeXForm TeXSave Text Text3DBox Text3DBoxOptions TextAlignment TextBand TextBoundingBox TextBox TextCell TextClipboardType TextData TextForm TextJustification TextLine TextPacket TextParagraph TextRecognize TextRendering TextStyle Texture TextureCoordinateFunction TextureCoordinateScaling Therefore ThermometerGauge Thick Thickness Thin Thinning ThisLink ThompsonGroupTh Thread ThreeJSymbol Threshold Through Throw Thumbnail Thursday Ticks TicksStyle Tilde TildeEqual TildeFullEqual TildeTilde TimeConstrained TimeConstraint Times TimesBy TimeSeriesForecast TimeSeriesInvertibility TimeUsed TimeValue TimeZone Timing Tiny TitleGrouping TitsGroupT ToBoxes ToCharacterCode ToColor ToContinuousTimeModel ToDate ToDiscreteTimeModel ToeplitzMatrix ToExpression ToFileName Together Toggle ToggleFalse Toggler TogglerBar TogglerBox TogglerBoxOptions ToHeldExpression ToInvertibleTimeSeries TokenWords Tolerance ToLowerCase ToNumberField TooBig Tooltip TooltipBox TooltipBoxOptions TooltipDelay TooltipStyle Top TopHatTransform TopologicalSort ToRadicals ToRules ToString Total TotalHeight TotalVariationFilter TotalWidth TouchscreenAutoZoom TouchscreenControlPlacement ToUpperCase Tr Trace TraceAbove TraceAction TraceBackward TraceDepth TraceDialog TraceForward TraceInternal TraceLevel TraceOff TraceOn TraceOriginal TracePrint TraceScan TrackedSymbols TradingChart TraditionalForm TraditionalFunctionNotation TraditionalNotation TraditionalOrder TransferFunctionCancel TransferFunctionExpand TransferFunctionFactor TransferFunctionModel TransferFunctionPoles TransferFunctionTransform TransferFunctionZeros TransformationFunction TransformationFunctions TransformationMatrix TransformedDistribution TransformedField Translate TranslationTransform TransparentColor Transpose TreeForm TreeGraph TreeGraphQ TreePlot TrendStyle TriangleWave TriangularDistribution Trig TrigExpand TrigFactor TrigFactorList Trigger TrigReduce TrigToExp TrimmedMean True TrueQ TruncatedDistribution TsallisQExponentialDistribution TsallisQGaussianDistribution TTest Tube TubeBezierCurveBox TubeBezierCurveBoxOptions TubeBox TubeBSplineCurveBox TubeBSplineCurveBoxOptions Tuesday TukeyLambdaDistribution TukeyWindow Tuples TuranGraph TuringMachine ' +
      'Transparent ' +
      'UnateQ Uncompress Undefined UnderBar Underflow Underlined Underoverscript UnderoverscriptBox UnderoverscriptBoxOptions Underscript UnderscriptBox UnderscriptBoxOptions UndirectedEdge UndirectedGraph UndirectedGraphQ UndocumentedTestFEParserPacket UndocumentedTestGetSelectionPacket Unequal Unevaluated UniformDistribution UniformGraphDistribution UniformSumDistribution Uninstall Union UnionPlus Unique UnitBox UnitConvert UnitDimensions Unitize UnitRootTest UnitSimplify UnitStep UnitTriangle UnitVector Unprotect UnsameQ UnsavedVariables Unset UnsetShared UntrackedVariables Up UpArrow UpArrowBar UpArrowDownArrow Update UpdateDynamicObjects UpdateDynamicObjectsSynchronous UpdateInterval UpDownArrow UpEquilibrium UpperCaseQ UpperLeftArrow UpperRightArrow UpperTriangularize Upsample UpSet UpSetDelayed UpTee UpTeeArrow UpValues URL URLFetch URLFetchAsynchronous URLSave URLSaveAsynchronous UseGraphicsRange Using UsingFrontEnd ' +
      'V2Get ValidationLength Value ValueBox ValueBoxOptions ValueForm ValueQ ValuesData Variables Variance VarianceEquivalenceTest VarianceEstimatorFunction VarianceGammaDistribution VarianceTest VectorAngle VectorColorFunction VectorColorFunctionScaling VectorDensityPlot VectorGlyphData VectorPlot VectorPlot3D VectorPoints VectorQ Vectors VectorScale VectorStyle Vee Verbatim Verbose VerboseConvertToPostScriptPacket VerifyConvergence VerifySolutions VerifyTestAssumptions Version VersionNumber VertexAdd VertexCapacity VertexColors VertexComponent VertexConnectivity VertexCoordinateRules VertexCoordinates VertexCorrelationSimilarity VertexCosineSimilarity VertexCount VertexCoverQ VertexDataCoordinates VertexDegree VertexDelete VertexDiceSimilarity VertexEccentricity VertexInComponent VertexInDegree VertexIndex VertexJaccardSimilarity VertexLabeling VertexLabels VertexLabelStyle VertexList VertexNormals VertexOutComponent VertexOutDegree VertexQ VertexRenderingFunction VertexReplace VertexShape VertexShapeFunction VertexSize VertexStyle VertexTextureCoordinates VertexWeight Vertical VerticalBar VerticalForm VerticalGauge VerticalSeparator VerticalSlider VerticalTilde ViewAngle ViewCenter ViewMatrix ViewPoint ViewPointSelectorSettings ViewPort ViewRange ViewVector ViewVertical VirtualGroupData Visible VisibleCell VoigtDistribution VonMisesDistribution ' +
      'WaitAll WaitAsynchronousTask WaitNext WaitUntil WakebyDistribution WalleniusHypergeometricDistribution WaringYuleDistribution WatershedComponents WatsonUSquareTest WattsStrogatzGraphDistribution WaveletBestBasis WaveletFilterCoefficients WaveletImagePlot WaveletListPlot WaveletMapIndexed WaveletMatrixPlot WaveletPhi WaveletPsi WaveletScale WaveletScalogram WaveletThreshold WeaklyConnectedComponents WeaklyConnectedGraphQ WeakStationarity WeatherData WeberE Wedge Wednesday WeibullDistribution WeierstrassHalfPeriods WeierstrassInvariants WeierstrassP WeierstrassPPrime WeierstrassSigma WeierstrassZeta WeightedAdjacencyGraph WeightedAdjacencyMatrix WeightedData WeightedGraphQ Weights WelchWindow WheelGraph WhenEvent Which While White Whitespace WhitespaceCharacter WhittakerM WhittakerW WienerFilter WienerProcess WignerD WignerSemicircleDistribution WilksW WilksWTest WindowClickSelect WindowElements WindowFloating WindowFrame WindowFrameElements WindowMargins WindowMovable WindowOpacity WindowSelected WindowSize WindowStatusArea WindowTitle WindowToolbars WindowWidth With WolframAlpha WolframAlphaDate WolframAlphaQuantity WolframAlphaResult Word WordBoundary WordCharacter WordData WordSearch WordSeparators WorkingPrecision Write WriteString Wronskian ' +
      'XMLElement XMLObject Xnor Xor ' +
      'Yellow YuleDissimilarity ' +
      'ZernikeR ZeroSymmetric ZeroTest ZeroWidthTimes Zeta ZetaZero ZipfDistribution ZTest ZTransform ' +
      '$Aborted $ActivationGroupID $ActivationKey $ActivationUserRegistered $AddOnsDirectory $AssertFunction $Assumptions $AsynchronousTask $BaseDirectory $BatchInput $BatchOutput $BoxForms $ByteOrdering $Canceled $CharacterEncoding $CharacterEncodings $CommandLine $CompilationTarget $ConditionHold $ConfiguredKernels $Context $ContextPath $ControlActiveSetting $CreationDate $CurrentLink $DateStringFormat $DefaultFont $DefaultFrontEnd $DefaultImagingDevice $DefaultPath $Display $DisplayFunction $DistributedContexts $DynamicEvaluation $Echo $Epilog $ExportFormats $Failed $FinancialDataSource $FormatType $FrontEnd $FrontEndSession $GeoLocation $HistoryLength $HomeDirectory $HTTPCookies $IgnoreEOF $ImagingDevices $ImportFormats $InitialDirectory $Input $InputFileName $InputStreamMethods $Inspector $InstallationDate $InstallationDirectory $InterfaceEnvironment $IterationLimit $KernelCount $KernelID $Language $LaunchDirectory $LibraryPath $LicenseExpirationDate $LicenseID $LicenseProcesses $LicenseServer $LicenseSubprocesses $LicenseType $Line $Linked $LinkSupported $LoadedFiles $MachineAddresses $MachineDomain $MachineDomains $MachineEpsilon $MachineID $MachineName $MachinePrecision $MachineType $MaxExtraPrecision $MaxLicenseProcesses $MaxLicenseSubprocesses $MaxMachineNumber $MaxNumber $MaxPiecewiseCases $MaxPrecision $MaxRootDegree $MessageGroups $MessageList $MessagePrePrint $Messages $MinMachineNumber $MinNumber $MinorReleaseNumber $MinPrecision $ModuleNumber $NetworkLicense $NewMessage $NewSymbol $Notebooks $NumberMarks $Off $OperatingSystem $Output $OutputForms $OutputSizeLimit $OutputStreamMethods $Packages $ParentLink $ParentProcessID $PasswordFile $PatchLevelID $Path $PathnameSeparator $PerformanceGoal $PipeSupported $Post $Pre $PreferencesDirectory $PrePrint $PreRead $PrintForms $PrintLiteral $ProcessID $ProcessorCount $ProcessorType $ProductInformation $ProgramName $RandomState $RecursionLimit $ReleaseNumber $RootDirectory $ScheduledTask $ScriptCommandLine $SessionID $SetParentLink $SharedFunctions $SharedVariables $SoundDisplay $SoundDisplayFunction $SuppressInputFormHeads $SynchronousEvaluation $SyntaxHandler $System $SystemCharacterEncoding $SystemID $SystemWordLength $TemporaryDirectory $TemporaryPrefix $TextStyle $TimedOut $TimeUnit $TimeZone $TopDirectory $TraceOff $TraceOn $TracePattern $TracePostAction $TracePreAction $Urgent $UserAddOnsDirectory $UserBaseDirectory $UserDocumentsDirectory $UserName $Version $VersionNumber',
    contains: [
      {
        className: 'comment',
        begin: /\(\*/, end: /\*\)/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        begin: /\{/, end: /\}/,
        illegal: /:/
      }
    ]
  };
});

hljs.registerLanguage('matlab', function(hljs) {
  var COMMON_CONTAINS = [
    hljs.C_NUMBER_MODE,
    {
      className: 'string',
      begin: '\'', end: '\'',
      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
    }
  ];
  var TRANSPOSE = {
    relevance: 0,
    contains: [
      {
        begin: /'['\.]*/
      }
    ]
  };

  return {
    keywords: {
      keyword:
        'break case catch classdef continue else elseif end enumerated events for function ' +
        'global if methods otherwise parfor persistent properties return spmd switch try while',
      built_in:
        'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' +
        'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' +
        'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' +
        'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' +
        'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' +
        'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' +
        'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' +
        'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' +
        'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' +
        'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' +
        'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' +
        'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan ' +
        'isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal ' +
        'rosser toeplitz vander wilkinson'
    },
    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            variants: [
              {begin: '\\(', end: '\\)'},
              {begin: '\\[', end: '\\]'}
            ]
          }
        ]
      },
      {
        begin: /[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,
        returnBegin: true,
        relevance: 0,
        contains: [
          {begin: /[a-zA-Z_][a-zA-Z_0-9]*/, relevance: 0},
          TRANSPOSE.contains[0]
        ]
      },
      {
        begin: '\\[', end: '\\]',
        contains: COMMON_CONTAINS,
        relevance: 0,
        starts: TRANSPOSE
      },
      {
        begin: '\\{', end: /}/,
        contains: COMMON_CONTAINS,
        relevance: 0,
        starts: TRANSPOSE
      },
      {
        // transpose operators at the end of a function call
        begin: /\)/,
        relevance: 0,
        starts: TRANSPOSE
      },
      hljs.COMMENT('^\\s*\\%\\{\\s*$', '^\\s*\\%\\}\\s*$'),
      hljs.COMMENT('\\%', '$')
    ].concat(COMMON_CONTAINS)
  };
});

hljs.registerLanguage('maxima', function(hljs) {
  var KEYWORDS = 'if then else elseif for thru do while unless step in and or not';
  var LITERALS = 'true false unknown inf minf ind und %e %i %pi %phi %gamma';
  var BUILTIN_FUNCTIONS =
        ' abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate'
      + ' addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix'
      + ' adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type'
      + ' alias allroots alphacharp alphanumericp amortization %and annuity_fv'
      + ' annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2'
      + ' applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply'
      + ' arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger'
      + ' asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order'
      + ' asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method'
      + ' av average_degree backtrace bars barsplot barsplot_description base64 base64_decode'
      + ' bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx'
      + ' bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify'
      + ' bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized'
      + ' bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp'
      + ' bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition'
      + ' block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description'
      + ' break bug_report build_info|10 buildq build_sample burn cabs canform canten'
      + ' cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli'
      + ' cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform'
      + ' cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel'
      + ' cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial'
      + ' cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson'
      + ' cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay'
      + ' ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic'
      + ' cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2'
      + ' charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps'
      + ' chinese cholesky christof chromatic_index chromatic_number cint circulant_graph'
      + ' clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph'
      + ' clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse'
      + ' collectterms columnop columnspace columnswap columnvector combination combine'
      + ' comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph'
      + ' complete_graph complex_number_p components compose_functions concan concat'
      + ' conjugate conmetderiv connected_components connect_vertices cons constant'
      + ' constantp constituent constvalue cont2part content continuous_freq contortion'
      + ' contour_plot contract contract_edge contragrad contrib_ode convert coord'
      + ' copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1'
      + ' covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline'
      + ' ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph'
      + ' cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate'
      + ' declare declare_constvalue declare_dimensions declare_fundamental_dimensions'
      + ' declare_fundamental_units declare_qty declare_translated declare_unit_conversion'
      + ' declare_units declare_weights decsym defcon define define_alt_display define_variable'
      + ' defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten'
      + ' delta demo demoivre denom depends derivdegree derivlist describe desolve'
      + ' determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag'
      + ' diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export'
      + ' dimacs_import dimension dimensionless dimensions dimensions_as_list direct'
      + ' directory discrete_freq disjoin disjointp disolate disp dispcon dispform'
      + ' dispfun dispJordan display disprule dispterms distrib divide divisors divsum'
      + ' dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart'
      + ' draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring'
      + ' edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth'
      + ' einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome'
      + ' ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using'
      + ' ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi'
      + ' ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp'
      + ' equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors'
      + ' euler ev eval_string evenp every evolution evolution2d evundiff example exp'
      + ' expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci'
      + ' expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li'
      + ' expintegral_shi expintegral_si explicit explose exponentialize express expt'
      + ' exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum'
      + ' factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements'
      + ' fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge'
      + ' file_search file_type fillarray findde find_root find_root_abs find_root_error'
      + ' find_root_rel first fix flatten flength float floatnump floor flower_snark'
      + ' flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran'
      + ' fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp'
      + ' foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s'
      + ' from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp'
      + ' fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units'
      + ' fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized'
      + ' gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide'
      + ' gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym'
      + ' geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean'
      + ' geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string'
      + ' get_pixel get_plot_option get_tex_environment get_tex_environment_default'
      + ' get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close'
      + ' gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum'
      + ' gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import'
      + ' graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery'
      + ' graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph'
      + ' grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path'
      + ' hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite'
      + ' hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description'
      + ' hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph'
      + ' icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy'
      + ' ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart'
      + ' imetric implicit implicit_derivative implicit_plot indexed_tensor indices'
      + ' induced_subgraph inferencep inference_result infix info_display init_atensor'
      + ' init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions'
      + ' integrate intersect intersection intervalp intopois intosum invariant1 invariant2'
      + ' inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc'
      + ' inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns'
      + ' inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint'
      + ' invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph'
      + ' is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate'
      + ' isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph'
      + ' items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc'
      + ' jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd'
      + ' jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill'
      + ' killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis'
      + ' kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform'
      + ' kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete'
      + ' kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace'
      + ' kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2'
      + ' kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson'
      + ' kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange'
      + ' laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp'
      + ' lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length'
      + ' let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit'
      + ' Lindstedt linear linearinterpol linear_program linear_regression line_graph'
      + ' linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials'
      + ' listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry'
      + ' log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst'
      + ' lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact'
      + ' lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub'
      + ' lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma'
      + ' make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country'
      + ' make_polygon make_random_state make_rgb_picture makeset make_string_input_stream'
      + ' make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom'
      + ' maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display'
      + ' mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker'
      + ' max max_clique max_degree max_flow maximize_lp max_independent_set max_matching'
      + ' maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform'
      + ' mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete'
      + ' mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic'
      + ' mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t'
      + ' mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull'
      + ' median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree'
      + ' min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor'
      + ' minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton'
      + ' mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions'
      + ' multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff'
      + ' multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary'
      + ' natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext'
      + ' newdet new_graph newline newton new_variable next_prime nicedummies niceindices'
      + ' ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp'
      + ' nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst'
      + ' nthroot nullity nullspace num numbered_boundaries numberp number_to_octets'
      + ' num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai'
      + ' nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin'
      + ' oid_to_octets op opena opena_binary openr openr_binary openw openw_binary'
      + ' operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless'
      + ' orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap'
      + ' out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface'
      + ' parg parGosper parse_string parse_timedate part part2cont partfrac partition'
      + ' partition_set partpol path_digraph path_graph pathname_directory pathname_name'
      + ' pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform'
      + ' pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete'
      + ' pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal'
      + ' pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal'
      + ' pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t'
      + ' pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph'
      + ' petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding'
      + ' playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff'
      + ' poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar'
      + ' polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion'
      + ' poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal'
      + ' poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal'
      + ' poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation'
      + ' poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm'
      + ' poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form'
      + ' poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part'
      + ' poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension'
      + ' poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod'
      + ' powerseries powerset prefix prev_prime primep primes principal_components'
      + ' print printf printfile print_graph printpois printprops prodrac product properties'
      + ' propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct'
      + ' puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp'
      + ' quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile'
      + ' quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2'
      + ' quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f'
      + ' quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel'
      + ' quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal'
      + ' quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t'
      + ' quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t'
      + ' quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan'
      + ' radius random random_bernoulli random_beta random_binomial random_bipartite_graph'
      + ' random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform'
      + ' random_exp random_f random_gamma random_general_finite_discrete random_geometric'
      + ' random_graph random_graph1 random_gumbel random_hypergeometric random_laplace'
      + ' random_logistic random_lognormal random_negative_binomial random_network'
      + ' random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto'
      + ' random_permutation random_poisson random_rayleigh random_regular_graph random_student_t'
      + ' random_tournament random_tree random_weibull range rank rat ratcoef ratdenom'
      + ' ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump'
      + ' ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array'
      + ' read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline'
      + ' read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate'
      + ' realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar'
      + ' rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus'
      + ' rem remainder remarray rembox remcomps remcon remcoord remfun remfunction'
      + ' remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions'
      + ' remove_fundamental_units remove_plot_option remove_vertex rempart remrule'
      + ' remsym remvalue rename rename_file reset reset_displays residue resolvante'
      + ' resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein'
      + ' resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer'
      + ' rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann'
      + ' rinvariant risch rk rmdir rncombine romberg room rootscontract round row'
      + ' rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i'
      + ' scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description'
      + ' scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second'
      + ' sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight'
      + ' setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state'
      + ' set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications'
      + ' set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path'
      + ' show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform'
      + ' simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert'
      + ' sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial'
      + ' skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp'
      + ' skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric'
      + ' skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic'
      + ' skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t'
      + ' skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t'
      + ' skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph'
      + ' smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve'
      + ' solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export'
      + ' sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1'
      + ' spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition'
      + ' sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus'
      + ' ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot'
      + ' starplot_description status std std1 std_bernoulli std_beta std_binomial'
      + ' std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma'
      + ' std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace'
      + ' std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t'
      + ' std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull'
      + ' stemplot stirling stirling1 stirling2 strim striml strimr string stringout'
      + ' stringp strong_components struve_h struve_l sublis sublist sublist_indices'
      + ' submatrix subsample subset subsetp subst substinpart subst_parallel substpart'
      + ' substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext'
      + ' symbolp symmdifference symmetricp system take_channel take_inference tan'
      + ' tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract'
      + ' tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference'
      + ' test_normality test_proportion test_proportions_difference test_rank_sum'
      + ' test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display'
      + ' texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter'
      + ' toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep'
      + ' totalfourier totient tpartpol trace tracematrix trace_options transform_sample'
      + ' translate translate_file transpose treefale tree_reduce treillis treinat'
      + ' triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate'
      + ' truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph'
      + ' truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget'
      + ' ultraspherical underlying_graph undiff union unique uniteigenvectors unitp'
      + ' units unit_step unitvector unorder unsum untellrat untimer'
      + ' untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli'
      + ' var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform'
      + ' var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel'
      + ' var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial'
      + ' var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson'
      + ' var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp'
      + ' verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance'
      + ' vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle'
      + ' vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j'
      + ' wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian'
      + ' xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta'
      + ' zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors'
      + ' zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table'
      + ' absboxchar activecontexts adapt_depth additive adim aform algebraic'
      + ' algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic'
      + ' animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar'
      + ' asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top'
      + ' azimuth background background_color backsubst berlefact bernstein_explicit'
      + ' besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest'
      + ' border boundaries_array box boxchar breakup %c capping cauchysum cbrange'
      + ' cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics'
      + ' colorbox columns commutative complex cone context contexts contour contour_levels'
      + ' cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp'
      + ' cube current_let_rule_package cylinder data_file_name debugmode decreasing'
      + ' default_let_rule_package delay dependencies derivabbrev derivsubst detout'
      + ' diagmetric diff dim dimensions dispflag display2d|10 display_format_internal'
      + ' distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor'
      + ' doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules'
      + ' dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart'
      + ' edge_color edge_coloring edge_partition edge_type edge_width %edispflag'
      + ' elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer'
      + ' epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type'
      + ' %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand'
      + ' expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine'
      + ' factlim factorflag factorial_expand factors_only fb feature features'
      + ' file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10'
      + ' file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color'
      + ' fill_density filled_func fixed_vertices flipflag float2bf font font_size'
      + ' fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim'
      + ' gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command'
      + ' gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command'
      + ' gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command'
      + ' gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble'
      + ' gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args'
      + ' Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both'
      + ' head_length head_type height hypergeometric_representation %iargs ibase'
      + ' icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form'
      + ' ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval'
      + ' infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued'
      + ' integrate_use_rootsof integration_constant integration_constant_counter interpolate_color'
      + ' intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr'
      + ' julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment'
      + ' label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max'
      + ' leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear'
      + ' linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params'
      + ' linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname'
      + ' loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx'
      + ' logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros'
      + ' mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult'
      + ' matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10'
      + ' maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint'
      + ' maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp'
      + ' mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver'
      + ' modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag'
      + ' newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc'
      + ' noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np'
      + ' npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties'
      + ' opsubst optimprefix optionset orientation origin orthopoly_returns_intervals'
      + ' outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution'
      + ' %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart'
      + ' png_file pochhammer_max_index points pointsize point_size points_joined point_type'
      + ' poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm'
      + ' poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list'
      + ' poly_secondary_elimination_order poly_top_reduction_only posfun position'
      + ' powerdisp pred prederror primep_number_of_tests product_use_gamma program'
      + ' programmode promote_float_to_bigfloat prompt proportional_axes props psexpand'
      + ' ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof'
      + ' ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann'
      + ' ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw'
      + ' refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs'
      + ' rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy'
      + ' same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck'
      + ' setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width'
      + ' show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type'
      + ' show_vertices show_weight simp simplified_output simplify_products simpproduct'
      + ' simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn'
      + ' solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag'
      + ' stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda'
      + ' subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric'
      + ' tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials'
      + ' tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch'
      + ' tr track transcompile transform transform_xy translate_fast_arrays transparent'
      + ' transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex'
      + ' tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign'
      + ' trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars'
      + ' tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode'
      + ' tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes'
      + ' ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble'
      + ' usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition'
      + ' vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface'
      + ' wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel'
      + ' xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate'
      + ' xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel'
      + ' xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width'
      + ' ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis'
      + ' ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis'
      + ' yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob'
      + ' zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest';
  var SYMBOLS = '_ __ %|0 %%|0';

  return {
    lexemes: '[A-Za-z_%][0-9A-Za-z_%]*',
    keywords: {
      keyword: KEYWORDS,
      literal: LITERALS,
      built_in: BUILTIN_FUNCTIONS,
      symbol: SYMBOLS,
    },
    contains: [
      {
        className: 'comment',
        begin: '/\\*',
        end: '\\*/',
        contains: ['self']
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        relevance: 0,
        variants: [
          {
            // float number w/ exponent
            // hmm, I wonder if we ought to include other exponent markers?
            begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b',
          },
          {
            // bigfloat number
            begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b',
            relevance: 10
          },
          {
            // float number w/out exponent
            // Doesn't seem to recognize floats which start with '.'
            begin: '\\b(\\.\\d+|\\d+\\.\\d+)\\b',
          },
          {
            // integer in base up to 36
            // Doesn't seem to recognize integers which end with '.'
            begin: '\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b',
          }
        ]
      }
    ],
    illegal: /@/
  }
});

hljs.registerLanguage('mel', function(hljs) {
  return {
    keywords:
      'int float string vector matrix if else switch case default while do for in break ' +
      'continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic ' +
      'addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey ' +
      'affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve ' +
      'alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor ' +
      'animDisplay animView annotate appendStringArray applicationName applyAttrPreset ' +
      'applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx ' +
      'artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu ' +
      'artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand ' +
      'assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface ' +
      'attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu ' +
      'attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp ' +
      'attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery ' +
      'autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults ' +
      'bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership ' +
      'bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType ' +
      'boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu ' +
      'buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge ' +
      'cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch ' +
      'catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox ' +
      'character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp ' +
      'checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip ' +
      'clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore ' +
      'closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter ' +
      'cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color ' +
      'colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp ' +
      'colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem ' +
      'componentEditor compositingInterop computePolysetVolume condition cone confirmDialog ' +
      'connectAttr connectControl connectDynamic connectJoint connectionInfo constrain ' +
      'constrainValue constructionHistory container containsMultibyte contextInfo control ' +
      'convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation ' +
      'convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache ' +
      'cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel ' +
      'cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver ' +
      'cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor ' +
      'createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer ' +
      'createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse ' +
      'currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx ' +
      'curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface ' +
      'curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox ' +
      'defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete ' +
      'deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes ' +
      'delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo ' +
      'dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable ' +
      'disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected ' +
      'displayColor displayCull displayLevelOfDetail displayPref displayRGBColor ' +
      'displaySmoothness displayStats displayString displaySurface distanceDimContext ' +
      'distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct ' +
      'doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator ' +
      'duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression ' +
      'dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor ' +
      'dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers ' +
      'editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor ' +
      'editorTemplate effector emit emitter enableDevice encodeString endString endsWith env ' +
      'equivalent equivalentTol erf error eval evalDeferred evalEcho event ' +
      'exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp ' +
      'expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof ' +
      'fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo ' +
      'filetest filletCurve filter filterCurve filterExpand filterStudioImport ' +
      'findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster ' +
      'finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar ' +
      'floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo ' +
      'fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint ' +
      'frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss ' +
      'geometryConstraint getApplicationVersionAsFloat getAttr getClassification ' +
      'getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes ' +
      'getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender ' +
      'glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl ' +
      'gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid ' +
      'gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap ' +
      'HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor ' +
      'HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached ' +
      'HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel ' +
      'headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey ' +
      'hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender ' +
      'hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox ' +
      'iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ' +
      'ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ' +
      'ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform ' +
      'insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance ' +
      'instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp ' +
      'interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf ' +
      'isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect ' +
      'itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx ' +
      'jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner ' +
      'keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx ' +
      'keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx ' +
      'keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx ' +
      'keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor ' +
      'layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList ' +
      'lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep ' +
      'listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory ' +
      'listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation ' +
      'listNodeTypes listPanelCategories listRelatives listSets listTransforms ' +
      'listUnselected listerEditor loadFluid loadNewShelf loadPlugin ' +
      'loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log ' +
      'longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive ' +
      'makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext ' +
      'manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx ' +
      'manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout ' +
      'menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp ' +
      'mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move ' +
      'moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute ' +
      'nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast ' +
      'nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint ' +
      'normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect ' +
      'nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref ' +
      'nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType ' +
      'objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface ' +
      'offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit ' +
      'orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier ' +
      'paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration ' +
      'panelHistory paramDimContext paramDimension paramLocator parent parentConstraint ' +
      'particle particleExists particleInstancer particleRenderInfo partition pasteKey ' +
      'pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture ' +
      'pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo ' +
      'pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult ' +
      'pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend ' +
      'polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal ' +
      'polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge ' +
      'polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge ' +
      'polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet ' +
      'polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet ' +
      'polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection ' +
      'polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge ' +
      'polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet ' +
      'polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix ' +
      'polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut ' +
      'polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet ' +
      'polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge ' +
      'polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex ' +
      'polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection ' +
      'polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection ' +
      'polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint ' +
      'polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate ' +
      'polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge ' +
      'polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing ' +
      'polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet ' +
      'polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace ' +
      'popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer ' +
      'projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx ' +
      'propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd ' +
      'python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection ' +
      'radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl ' +
      'readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference ' +
      'referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE ' +
      'registerPluginResource rehash reloadImage removeJoint removeMultiInstance ' +
      'removePanelCategory rename renameAttr renameSelectionList renameUI render ' +
      'renderGlobalsNode renderInfo renderLayerButton renderLayerParent ' +
      'renderLayerPostProcess renderLayerUnparent renderManip renderPartition ' +
      'renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor ' +
      'renderWindowSelectContext renderer reorder reorderDeformers requires reroot ' +
      'resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget ' +
      'reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx ' +
      'rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout ' +
      'runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage ' +
      'saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale ' +
      'scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor ' +
      'sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable ' +
      'scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt ' +
      'searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey ' +
      'selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType ' +
      'selectedNodes selectionConnection separator setAttr setAttrEnumResource ' +
      'setAttrMapping setAttrNiceNameResource setConstraintRestPosition ' +
      'setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr ' +
      'setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe ' +
      'setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag ' +
      'setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject ' +
      'setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets ' +
      'shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare ' +
      'shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField ' +
      'shortNameOf showHelp showHidden showManipCtx showSelectionInTitle ' +
      'showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface ' +
      'size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep ' +
      'snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound ' +
      'soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort ' +
      'spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString ' +
      'startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp ' +
      'stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex ' +
      'stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex ' +
      'stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString ' +
      'stringToStringArray strip stripPrefixFromName stroke subdAutoProjection ' +
      'subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV ' +
      'subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror ' +
      'subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease ' +
      'subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring ' +
      'surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton ' +
      'symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext ' +
      'texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext ' +
      'texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text ' +
      'textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList ' +
      'textToShelf textureDisplacePlane textureHairColor texturePlacementContext ' +
      'textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath ' +
      'toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower ' +
      'toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper ' +
      'trace track trackCtx transferAttributes transformCompare transformLimits translator ' +
      'trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence ' +
      'twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit ' +
      'unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink ' +
      'uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane ' +
      'viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex ' +
      'waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire ' +
      'wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform',
    illegal: '</',
    contains: [
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '`', end: '`',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      { // eats variables
        begin: '[\\$\\%\\@](\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)'
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('mercury', function(hljs) {
  var KEYWORDS = {
    keyword:
      'module use_module import_module include_module end_module initialise ' +
      'mutable initialize finalize finalise interface implementation pred ' +
      'mode func type inst solver any_pred any_func is semidet det nondet ' +
      'multi erroneous failure cc_nondet cc_multi typeclass instance where ' +
      'pragma promise external trace atomic or_else require_complete_switch ' +
      'require_det require_semidet require_multi require_nondet ' +
      'require_cc_multi require_cc_nondet require_erroneous require_failure',
    meta:
      // pragma
      'inline no_inline type_spec source_file fact_table obsolete memo ' +
      'loop_check minimal_model terminates does_not_terminate ' +
      'check_termination promise_equivalent_clauses ' +
      // preprocessor
      'foreign_proc foreign_decl foreign_code foreign_type ' +
      'foreign_import_module foreign_export_enum foreign_export ' +
      'foreign_enum may_call_mercury will_not_call_mercury thread_safe ' +
      'not_thread_safe maybe_thread_safe promise_pure promise_semipure ' +
      'tabled_for_io local untrailed trailed attach_to_io_state ' +
      'can_pass_as_mercury_type stable will_not_throw_exception ' +
      'may_modify_trail will_not_modify_trail may_duplicate ' +
      'may_not_duplicate affects_liveness does_not_affect_liveness ' +
      'doesnt_affect_liveness no_sharing unknown_sharing sharing',
    built_in:
      'some all not if then else true fail false try catch catch_any ' +
      'semidet_true semidet_false semidet_fail impure_true impure semipure'
  };

  var COMMENT = hljs.COMMENT('%', '$');

  var NUMCODE = {
    className: 'number',
    begin: "0'.\\|0[box][0-9a-fA-F]*"
  };

  var ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {relevance: 0});
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {relevance: 0});
  var STRING_FMT = {
    className: 'subst',
    begin: '\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]',
    relevance: 0
  };
  STRING.contains.push(STRING_FMT);

  var IMPLICATION = {
    className: 'built_in',
    variants: [
      {begin: '<=>'},
      {begin: '<=', relevance: 0},
      {begin: '=>', relevance: 0},
      {begin: '/\\\\'},
      {begin: '\\\\/'}
    ]
  };

  var HEAD_BODY_CONJUNCTION = {
    className: 'built_in',
    variants: [
      {begin: ':-\\|-->'},
      {begin: '=', relevance: 0}
    ]
  };

  return {
    aliases: ['m', 'moo'],
    keywords: KEYWORDS,
    contains: [
      IMPLICATION,
      HEAD_BODY_CONJUNCTION,
      COMMENT,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMCODE,
      hljs.NUMBER_MODE,
      ATOM,
      STRING,
      {begin: /:-/} // relevance booster
    ]
  };
});

hljs.registerLanguage('mipsasm', function(hljs) {
    //local labels: %?[FB]?[AT]?\d{1,2}\w+
  return {
    case_insensitive: true,
    aliases: ['mips'],
    lexemes: '\\.?' + hljs.IDENT_RE,
    keywords: {
      meta:
        //GNU preprocs
        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ',
      built_in:
        '$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 ' + // integer registers
        '$16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 ' + // integer registers
        'zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 ' + // integer register aliases
        't0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 ' + // integer register aliases
        'k0 k1 gp sp fp ra ' + // integer register aliases
        '$f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 ' + // floating-point registers
        '$f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 ' + // floating-point registers
        'Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi ' + // Coprocessor 0 registers
        'HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId ' + // Coprocessor 0 registers
        'EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ' + // Coprocessor 0 registers
        'ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt ' // Coprocessor 0 registers
    },
    contains: [
      {
        className: 'keyword',
        begin: '\\b('+     //mnemonics
            // 32-bit integer instructions
            'addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|' +
            'bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\.hb)?|jr(\.hb)?|lbu?|lhu?|' +
            'll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|' +
            'multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|' +
            'srlv?|subu?|sw[lr]?|xori?|wsbh|' +
            // floating-point instructions
            'abs\.[sd]|add\.[sd]|alnv.ps|bc1[ft]l?|' +
            'c\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\.[sd]|' +
            '(ceil|floor|round|trunc)\.[lw]\.[sd]|cfc1|cvt\.d\.[lsw]|' +
            'cvt\.l\.[dsw]|cvt\.ps\.s|cvt\.s\.[dlw]|cvt\.s\.p[lu]|cvt\.w\.[dls]|' +
            'div\.[ds]|ldx?c1|luxc1|lwx?c1|madd\.[sd]|mfc1|mov[fntz]?\.[ds]|' +
            'msub\.[sd]|mth?c1|mul\.[ds]|neg\.[ds]|nmadd\.[ds]|nmsub\.[ds]|' +
            'p[lu][lu]\.ps|recip\.fmt|r?sqrt\.[ds]|sdx?c1|sub\.[ds]|suxc1|' +
            'swx?c1|' +
            // system control instructions
            'break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|' +
            'rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|' +
            'tlti?u?|tnei?|wait|wrpgpr'+
        ')',
        end: '\\s'
      },
      hljs.COMMENT('[;#]', '$'),
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'',
        end: '[^\\\\]\'',
        relevance: 0
      },
      {
        className: 'title',
        begin: '\\|', end: '\\|',
        illegal: '\\n',
        relevance: 0
      },
      {
        className: 'number',
        variants: [
            {begin: '0x[0-9a-f]+'}, //hex
            {begin: '\\b-?\\d+'}           //bare number
        ],
        relevance: 0
      },
      {
        className: 'symbol',
        variants: [
            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU MIPS syntax
            {begin: '^\\s*[0-9]+:'}, // numbered local labels
            {begin: '[0-9]+[bf]' }  // number local label reference (backwards, forwards)
        ],
        relevance: 0
      }
    ],
    illegal: '\/'
  };
});

hljs.registerLanguage('mizar', function(hljs) {
  return {
    keywords:
      'environ vocabularies notations constructors definitions ' +
      'registrations theorems schemes requirements begin end definition ' +
      'registration cluster existence pred func defpred deffunc theorem ' +
      'proof let take assume then thus hence ex for st holds consider ' +
      'reconsider such that and in provided of as from be being by means ' +
      'equals implies iff redefine define now not or attr is mode ' +
      'suppose per cases set thesis contradiction scheme reserve struct ' +
      'correctness compatibility coherence symmetry assymetry ' +
      'reflexivity irreflexivity connectedness uniqueness commutativity ' +
      'idempotence involutiveness projectivity',
    contains: [
      hljs.COMMENT('::', '$')
    ]
  };
});

hljs.registerLanguage('perl', function(hljs) {
  var PERL_KEYWORDS = 'getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ' +
    'ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime ' +
    'readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qq' +
    'fileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent ' +
    'shutdown dump chomp connect getsockname die socketpair close flock exists index shmget' +
    'sub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr ' +
    'unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 ' +
    'getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline ' +
    'endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand ' +
    'mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink ' +
    'getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr ' +
    'untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link ' +
    'getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller ' +
    'lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and ' +
    'sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 ' +
    'chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach ' +
    'tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedir' +
    'ioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe ' +
    'atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when';
  var SUBST = {
    className: 'subst',
    begin: '[$@]\\{', end: '\\}',
    keywords: PERL_KEYWORDS
  };
  var METHOD = {
    begin: '->{', end: '}'
    // contains defined later
  };
  var VAR = {
    variants: [
      {begin: /\$\d/},
      {begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},
      {begin: /[\$%@][^\s\w{]/, relevance: 0}
    ]
  };
  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
  var PERL_DEFAULT_CONTAINS = [
    VAR,
    hljs.HASH_COMMENT_MODE,
    hljs.COMMENT(
      '^\\=\\w',
      '\\=cut',
      {
        endsWithParent: true
      }
    ),
    METHOD,
    {
      className: 'string',
      contains: STRING_CONTAINS,
      variants: [
        {
          begin: 'q[qwxr]?\\s*\\(', end: '\\)',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\[', end: '\\]',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\{', end: '\\}',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\|', end: '\\|',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\<', end: '\\>',
          relevance: 5
        },
        {
          begin: 'qw\\s+q', end: 'q',
          relevance: 5
        },
        {
          begin: '\'', end: '\'',
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: '"', end: '"'
        },
        {
          begin: '`', end: '`',
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: '{\\w+}',
          contains: [],
          relevance: 0
        },
        {
          begin: '\-?\\w+\\s*\\=\\>',
          contains: [],
          relevance: 0
        }
      ]
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    { // regexp container
      begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
      keywords: 'split return print reverse grep',
      relevance: 0,
      contains: [
        hljs.HASH_COMMENT_MODE,
        {
          className: 'regexp',
          begin: '(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*',
          relevance: 10
        },
        {
          className: 'regexp',
          begin: '(m|qr)?/', end: '/[a-z]*',
          contains: [hljs.BACKSLASH_ESCAPE],
          relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
        }
      ]
    },
    {
      className: 'function',
      beginKeywords: 'sub', end: '(\\s*\\(.*?\\))?[;{]', excludeEnd: true,
      relevance: 5,
      contains: [hljs.TITLE_MODE]
    },
    {
      begin: '-\\w\\b',
      relevance: 0
    },
    {
      begin: "^__DATA__$",
      end: "^__END__$",
      subLanguage: 'mojolicious',
      contains: [
        {
            begin: "^@@.*",
            end: "$",
            className: "comment"
        }
      ]
    }
  ];
  SUBST.contains = PERL_DEFAULT_CONTAINS;
  METHOD.contains = PERL_DEFAULT_CONTAINS;

  return {
    aliases: ['pl', 'pm'],
    lexemes: /[\w\.]+/,
    keywords: PERL_KEYWORDS,
    contains: PERL_DEFAULT_CONTAINS
  };
});

hljs.registerLanguage('mojolicious', function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      {
        className: 'meta',
        begin: '^__(END|DATA)__$'
      },
    // mojolicious line
      {
        begin: "^\\s*%{1,2}={0,2}", end: '$',
        subLanguage: 'perl'
      },
    // mojolicious block
      {
        begin: "<%{1,2}={0,2}",
        end: "={0,1}%>",
        subLanguage: 'perl',
        excludeBegin: true,
        excludeEnd: true
      }
    ]
  };
});

hljs.registerLanguage('monkey', function(hljs) {
  var NUMBER = {
    className: 'number', relevance: 0,
    variants: [
      {
        begin: '[$][a-fA-F0-9]+'
      },
      hljs.NUMBER_MODE
    ]
  };

  return {
    case_insensitive: true,
    keywords: {
      keyword: 'public private property continue exit extern new try catch ' +
        'eachin not abstract final select case default const local global field ' +
        'end if then else elseif endif while wend repeat until forever for ' +
        'to step next return module inline throw import',

      built_in: 'DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil ' +
        'Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI',

      literal: 'true false null and or shl shr mod'
    },
    illegal: /\/\*/,
    contains: [
      hljs.COMMENT('#rem', '#end'),
      hljs.COMMENT(
        "'",
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'function',
        beginKeywords: 'function method', end: '[(=:]|$',
        illegal: /\n/,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '$',
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        className: 'built_in',
        begin: '\\b(self|super)\\b'
      },
      {
        className: 'meta',
        begin: '\\s*#', end: '$',
        keywords: {'meta-keyword': 'if else elseif endif end then'}
      },
      {
        className: 'meta',
        begin: '^\\s*strict\\b'
      },
      {
        beginKeywords: 'alias', end: '=',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      hljs.QUOTE_STRING_MODE,
      NUMBER
    ]
  }
});

hljs.registerLanguage('moonscript', function(hljs) {
  var KEYWORDS = {
    keyword:
      // Moonscript keywords
      'if then not for in while do return else elseif break continue switch and or ' +
      'unless when class extends super local import export from using',
    literal:
      'true false nil',
    built_in:
      '_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load ' +
      'loadfile loadstring module next pairs pcall print rawequal rawget rawset require ' +
      'select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug ' +
      'io math os package string table'
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.inherit(hljs.C_NUMBER_MODE,
      {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: 'string',
      variants: [
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        }
      ]
    },
    {
      className: 'built_in',
      begin: '@__' + hljs.IDENT_RE
    },
    {
      begin: '@' + hljs.IDENT_RE // relevance booster on par with CoffeeScript
    },
    {
      begin: hljs.IDENT_RE + '\\\\' + hljs.IDENT_RE // inst\method
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };

  return {
    aliases: ['moon'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('--', '$'),
      {
        className: 'function',  // function: -> =>
        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
        returnBegin: true,
        contains: [TITLE, PARAMS]
      },
      {
        begin: /[\(,:=]\s*/, // anonymous function start
        relevance: 0,
        contains: [
          {
            className: 'function',
            begin: PARAMS_RE, end: '[-=]>',
            returnBegin: true,
            contains: [PARAMS]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        className: 'name',    // table
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
});

hljs.registerLanguage('n1ql', function(hljs) {
  return {
    case_insensitive: true,
    contains: [
      {
        beginKeywords:
          'build create index delete drop explain infer|10 insert merge prepare select update upsert|10',
        end: /;/, endsWithParent: true,
        keywords: {
          // Taken from http://developer.couchbase.com/documentation/server/current/n1ql/n1ql-language-reference/reservedwords.html
          keyword:
            'all alter analyze and any array as asc begin between binary boolean break bucket build by call ' +
            'case cast cluster collate collection commit connect continue correlate cover create database ' +
            'dataset datastore declare decrement delete derived desc describe distinct do drop each element ' +
            'else end every except exclude execute exists explain fetch first flatten for force from ' +
            'function grant group gsi having if ignore ilike in include increment index infer inline inner ' +
            'insert intersect into is join key keys keyspace known last left let letting like limit lsm map ' +
            'mapping matched materialized merge minus namespace nest not number object offset on ' +
            'option or order outer over parse partition password path pool prepare primary private privilege ' +
            'procedure public raw realm reduce rename return returning revoke right role rollback satisfies ' +
            'schema select self semi set show some start statistics string system then to transaction trigger ' +
            'truncate under union unique unknown unnest unset update upsert use user using validate value ' +
            'valued values via view when where while with within work xor',
          // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/literals.html
          literal:
            'true false null missing|5',
          // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/functions.html
          built_in:
            'array_agg array_append array_concat array_contains array_count array_distinct array_ifnull array_length ' +
            'array_max array_min array_position array_prepend array_put array_range array_remove array_repeat array_replace ' +
            'array_reverse array_sort array_sum avg count max min sum greatest least ifmissing ifmissingornull ifnull ' +
            'missingif nullif ifinf ifnan ifnanorinf naninf neginfif posinfif clock_millis clock_str date_add_millis ' +
            'date_add_str date_diff_millis date_diff_str date_part_millis date_part_str date_trunc_millis date_trunc_str ' +
            'duration_to_str millis str_to_millis millis_to_str millis_to_utc millis_to_zone_name now_millis now_str ' +
            'str_to_duration str_to_utc str_to_zone_name decode_json encode_json encoded_size poly_length base64 base64_encode ' +
            'base64_decode meta uuid abs acos asin atan atan2 ceil cos degrees e exp ln log floor pi power radians random ' +
            'round sign sin sqrt tan trunc object_length object_names object_pairs object_inner_pairs object_values ' +
            'object_inner_values object_add object_put object_remove object_unwrap regexp_contains regexp_like regexp_position ' +
            'regexp_replace contains initcap length lower ltrim position repeat replace rtrim split substr title trim upper ' +
            'isarray isatom isboolean isnumber isobject isstring type toarray toatom toboolean tonumber toobject tostring'
        },
        contains: [
          {
            className: 'string',
            begin: '\'', end: '\'',
            contains: [hljs.BACKSLASH_ESCAPE],
            relevance: 0
          },
          {
            className: 'string',
            begin: '"', end: '"',
            contains: [hljs.BACKSLASH_ESCAPE],
            relevance: 0
          },
          {
            className: 'symbol',
            begin: '`', end: '`',
            contains: [hljs.BACKSLASH_ESCAPE],
            relevance: 2
          },
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('nginx', function(hljs) {
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$\d+/},
      {begin: /\$\{/, end: /}/},
      {begin: '[\\$\\@]' + hljs.UNDERSCORE_IDENT_RE}
    ]
  };
  var DEFAULT = {
    endsWithParent: true,
    lexemes: '[a-z/_]+',
    keywords: {
      literal:
        'on off yes no true false none blocked debug info notice warn error crit ' +
        'select break last permanent redirect kqueue rtsig epoll poll /dev/poll'
    },
    relevance: 0,
    illegal: '=>',
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE, VAR],
        variants: [
          {begin: /"/, end: /"/},
          {begin: /'/, end: /'/}
        ]
      },
      // this swallows entire URLs to avoid detecting numbers within
      {
        begin: '([a-z]+):/', end: '\\s', endsWithParent: true, excludeEnd: true,
        contains: [VAR]
      },
      {
        className: 'regexp',
        contains: [hljs.BACKSLASH_ESCAPE, VAR],
        variants: [
          {begin: "\\s\\^", end: "\\s|{|;", returnEnd: true},
          // regexp locations (~, ~*)
          {begin: "~\\*?\\s+", end: "\\s|{|;", returnEnd: true},
          // *.example.com
          {begin: "\\*(\\.[a-z\\-]+)+"},
          // sub.example.*
          {begin: "([a-z\\-]+\\.)+\\*"}
        ]
      },
      // IP
      {
        className: 'number',
        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
      },
      // units
      {
        className: 'number',
        begin: '\\b\\d+[kKmMgGdshdwy]*\\b',
        relevance: 0
      },
      VAR
    ]
  };

  return {
    aliases: ['nginxconf'],
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s+{', returnBegin: true,
        end: '{',
        contains: [
          {
            className: 'section',
            begin: hljs.UNDERSCORE_IDENT_RE
          }
        ],
        relevance: 0
      },
      {
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s', end: ';|{', returnBegin: true,
        contains: [
          {
            className: 'attribute',
            begin: hljs.UNDERSCORE_IDENT_RE,
            starts: DEFAULT
          }
        ],
        relevance: 0
      }
    ],
    illegal: '[^\\s\\}]'
  };
});

hljs.registerLanguage('nimrod', function(hljs) {
  return {
    aliases: ['nim'],
    keywords: {
      keyword:
        'addr and as asm bind block break case cast const continue converter ' +
        'discard distinct div do elif else end enum except export finally ' +
        'for from generic if import in include interface is isnot iterator ' +
        'let macro method mixin mod nil not notin object of or out proc ptr ' +
        'raise ref return shl shr static template try tuple type using var ' +
        'when while with without xor yield',
      literal:
        'shared guarded stdin stdout stderr result true false',
      built_in:
        'int int8 int16 int32 int64 uint uint8 uint16 uint32 uint64 float ' +
        'float32 float64 bool char string cstring pointer expr stmt void ' +
        'auto any range array openarray varargs seq set clong culong cchar ' +
        'cschar cshort cint csize clonglong cfloat cdouble clongdouble ' +
        'cuchar cushort cuint culonglong cstringarray semistatic'
    },
    contains: [ {
        className: 'meta', // Actually pragma
        begin: /{\./,
        end: /\.}/,
        relevance: 10
      }, {
        className: 'string',
        begin: /[a-zA-Z]\w*"/,
        end: /"/,
        contains: [{begin: /""/}]
      }, {
        className: 'string',
        begin: /([a-zA-Z]\w*)?"""/,
        end: /"""/
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'type',
        begin: /\b[A-Z]\w+\b/,
        relevance: 0
      }, {
        className: 'number',
        relevance: 0,
        variants: [
          {begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/},
          {begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/},
          {begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/},
          {begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/}
        ]
      },
      hljs.HASH_COMMENT_MODE
    ]
  }
});

hljs.registerLanguage('nix', function(hljs) {
  var NIX_KEYWORDS = {
    keyword:
      'rec with let in inherit assert if else then',
    literal:
      'true false or and null',
    built_in:
      'import abort baseNameOf dirOf isNull builtins map removeAttrs throw ' +
      'toString derivation'
  };
  var ANTIQUOTE = {
    className: 'subst',
    begin: /\$\{/,
    end: /}/,
    keywords: NIX_KEYWORDS
  };
  var ATTRS = {
    begin: /[a-zA-Z0-9-_]+(\s*=)/, returnBegin: true,
    relevance: 0,
    contains: [
      {
        className: 'attr',
        begin: /\S+/
      }
    ]
  };
  var STRING = {
    className: 'string',
    contains: [ANTIQUOTE],
    variants: [
      {begin: "''", end: "''"},
      {begin: '"', end: '"'}
    ]
  };
  var EXPRESSIONS = [
    hljs.NUMBER_MODE,
    hljs.HASH_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    STRING,
    ATTRS
  ];
  ANTIQUOTE.contains = EXPRESSIONS;
  return {
    aliases: ["nixos"],
    keywords: NIX_KEYWORDS,
    contains: EXPRESSIONS
  };
});

hljs.registerLanguage('nsis', function(hljs) {
  var CONSTANTS = {
    className: 'variable',
    begin: /\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)/
  };

  var DEFINES = {
    // ${defines}
    className: 'variable',
    begin: /\$+{[\w\.:-]+}/
  };

  var VARIABLES = {
    // $variables
    className: 'variable',
    begin: /\$+\w+/,
    illegal: /\(\){}/
  };

  var LANGUAGES = {
    // $(language_strings)
    className: 'variable',
    begin: /\$+\([\w\^\.:-]+\)/
  };

  var PARAMETERS = {
    // command parameters
    className: 'params',
    begin: '(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)'
  };

  var COMPILER = {
    // !compiler_flags
    className: 'keyword',
    begin: /\!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversionsystem|ifdef|ifmacrodef|ifmacrondef|ifndef|if|include|insertmacro|macroend|macro|makensis|packhdr|searchparse|searchreplace|tempfile|undef|verbose|warning)/
  };

  var METACHARS = {
    // $\n, $\r, $\t, $$
    className: 'subst',
    begin: /\$(\\[nrt]|\$)/
  };

  var PLUGINS = {
    // plug::ins
    className: 'class',
    begin: /\w+\:\:\w+/
  };

    var STRING = {
      className: 'string',
      variants: [
        {
          begin: '"', end: '"'
        },
        {
          begin: '\'', end: '\''
        },
        {
          begin: '`', end: '`'
        }
      ],
      illegal: /\n/,
      contains: [
        METACHARS,
        CONSTANTS,
        DEFINES,
        VARIABLES,
        LANGUAGES
      ]
  };

  return {
    case_insensitive: false,
    keywords: {
      keyword:
      'Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileSeek FileWrite FileWriteByte FileWriteUTF16LE FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI FunctionEnd GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText IntCmp IntCmpU IntFmt IntOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PageExEnd Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionEnd SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionGroupEnd SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegStr WriteUninstaller XPStyle',
      literal:
      'admin all auto both bottom bzip2 colored components current custom directory false force hide highest ifdiff ifnewer instfiles lastused leave left license listonly lzma nevershow none normal notset off on open print right show silent silentlog smooth textonly top true try un.components un.custom un.directory un.instfiles un.license uninstConfirm user Win10 Win7 Win8 WinVista zlib'
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT(
        ';',
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'function',
        beginKeywords: 'Function PageEx Section SectionGroup', end: '$'
      },
      STRING,
      COMPILER,
      DEFINES,
      VARIABLES,
      LANGUAGES,
      PARAMETERS,
      PLUGINS,
      hljs.NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('objectivec', function(hljs) {
  var API_CLASS = {
    className: 'built_in',
    begin: '\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+',
  };
  var OBJC_KEYWORDS = {
    keyword:
      'int float while char export sizeof typedef const struct for union ' +
      'unsigned long volatile static bool mutable if do return goto void ' +
      'enum else break extern asm case short default double register explicit ' +
      'signed typename this switch continue wchar_t inline readonly assign ' +
      'readwrite self @synchronized id typeof ' +
      'nonatomic super unichar IBOutlet IBAction strong weak copy ' +
      'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' +
      '@private @protected @public @try @property @end @throw @catch @finally ' +
      '@autoreleasepool @synthesize @dynamic @selector @optional @required ' +
      '@encode @package @import @defs @compatibility_alias ' +
      '__bridge __bridge_transfer __bridge_retained __bridge_retain ' +
      '__covariant __contravariant __kindof ' +
      '_Nonnull _Nullable _Null_unspecified ' +
      '__FUNCTION__ __PRETTY_FUNCTION__ __attribute__ ' +
      'getter setter retain unsafe_unretained ' +
      'nonnull nullable null_unspecified null_resettable class instancetype ' +
      'NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER ' +
      'NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED ' +
      'NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE ' +
      'NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END ' +
      'NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW ' +
      'NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN',
    literal:
      'false true FALSE TRUE nil YES NO NULL',
    built_in:
      'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
  };
  var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
  var CLASS_KEYWORDS = '@interface @class @protocol @implementation';
  return {
    aliases: ['mm', 'objc', 'obj-c'],
    keywords: OBJC_KEYWORDS,
    lexemes: LEXEMES,
    illegal: '</',
    contains: [
      API_CLASS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          {
            begin: '@"', end: '"',
            illegal: '\\n',
            contains: [hljs.BACKSLASH_ESCAPE]
          },
          {
            begin: '\'', end: '[^\\\\]\'',
            illegal: '[^\\\\][^\']'
          }
        ]
      },
      {
        className: 'meta',
        begin: '#',
        end: '$',
        contains: [
          {
            className: 'meta-string',
            variants: [
              { begin: '\"', end: '\"' },
              { begin: '<', end: '>' }
            ]
          }
        ]
      },
      {
        className: 'class',
        begin: '(' + CLASS_KEYWORDS.split(' ').join('|') + ')\\b', end: '({|$)', excludeEnd: true,
        keywords: CLASS_KEYWORDS, lexemes: LEXEMES,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        begin: '\\.'+hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('ocaml', function(hljs) {
  /* missing support for heredoc-like string (OCaml 4.0.2+) */
  return {
    aliases: ['ml'],
    keywords: {
      keyword:
        'and as assert asr begin class constraint do done downto else end ' +
        'exception external for fun function functor if in include ' +
        'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' +
        'mod module mutable new object of open! open or private rec sig struct ' +
        'then to try type val! val virtual when while with ' +
        /* camlp4 */
        'parser value',
      built_in:
        /* built-in types */
        'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' +
        /* (some) types in Pervasives */
        'in_channel out_channel ref',
      literal:
        'true false'
    },
    illegal: /\/\/|>>/,
    lexemes: '[a-z_]\\w*!?',
    contains: [
      {
        className: 'literal',
        begin: '\\[(\\|\\|)?\\]|\\(\\)',
        relevance: 0
      },
      hljs.COMMENT(
        '\\(\\*',
        '\\*\\)',
        {
          contains: ['self']
        }
      ),
      { /* type variable */
        className: 'symbol',
        begin: '\'[A-Za-z_](?!\')[\\w\']*'
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      { /* polymorphic variant */
        className: 'type',
        begin: '`[A-Z][\\w\']*'
      },
      { /* module or constructor */
        className: 'type',
        begin: '\\b[A-Z][\\w\']*',
        relevance: 0
      },
      { /* don't color identifiers, but safely catch all identifiers with '*/
        begin: '[a-z_]\\w*\'[\\w\']*', relevance: 0
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'number',
        begin:
          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
          '0[oO][0-7_]+[Lln]?|' +
          '0[bB][01_]+[Lln]?|' +
          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
        relevance: 0
      },
      {
        begin: /[-=]>/ // relevance booster
      }
    ]
  }
});

hljs.registerLanguage('openscad', function(hljs) {
	var SPECIAL_VARS = {
		className: 'keyword',
		begin: '\\$(f[asn]|t|vp[rtd]|children)'
	},
	LITERALS = {
		className: 'literal',
		begin: 'false|true|PI|undef'
	},
	NUMBERS = {
		className: 'number',
		begin: '\\b\\d+(\\.\\d+)?(e-?\\d+)?', //adds 1e5, 1e-10
		relevance: 0
	},
	STRING = hljs.inherit(hljs.QUOTE_STRING_MODE,{illegal: null}),
	PREPRO = {
		className: 'meta',
		keywords: {'meta-keyword': 'include use'},
		begin: 'include|use <',
		end: '>'
	},
	PARAMS = {
		className: 'params',
		begin: '\\(', end: '\\)',
		contains: ['self', NUMBERS, STRING, SPECIAL_VARS, LITERALS]
	},
	MODIFIERS = {
		begin: '[*!#%]',
		relevance: 0
	},
	FUNCTIONS = {
		className: 'function',
		beginKeywords: 'module function',
		end: '\\=|\\{',
		contains: [PARAMS, hljs.UNDERSCORE_TITLE_MODE]
	};

	return {
		aliases: ['scad'],
		keywords: {
			keyword: 'function module include use for intersection_for if else \\%',
			literal: 'false true PI undef',
			built_in: 'circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign'
		},
		contains: [
			hljs.C_LINE_COMMENT_MODE,
			hljs.C_BLOCK_COMMENT_MODE,
			NUMBERS,
			PREPRO,
			STRING,
			SPECIAL_VARS,
			MODIFIERS,
			FUNCTIONS
		]
	}
});

hljs.registerLanguage('oxygene', function(hljs) {
  var OXYGENE_KEYWORDS = 'abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue '+
    'create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false '+
    'final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited '+
    'inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of '+
    'old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly '+
    'record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple '+
    'type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal '+
    'register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained';
  var CURLY_COMMENT =  hljs.COMMENT(
    '{',
    '}',
    {
      relevance: 0
    }
  );
  var PAREN_COMMENT = hljs.COMMENT(
    '\\(\\*',
    '\\*\\)',
    {
      relevance: 10
    }
  );
  var STRING = {
    className: 'string',
    begin: '\'', end: '\'',
    contains: [{begin: '\'\''}]
  };
  var CHAR_STRING = {
    className: 'string', begin: '(#\\d+)+'
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure method', end: '[:;]',
    keywords: 'function constructor|10 destructor|10 procedure|10 method|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: '\\(', end: '\\)',
        keywords: OXYGENE_KEYWORDS,
        contains: [STRING, CHAR_STRING]
      },
      CURLY_COMMENT, PAREN_COMMENT
    ]
  };
  return {
    case_insensitive: true,
    lexemes: /\.?\w+/,
    keywords: OXYGENE_KEYWORDS,
    illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
    contains: [
      CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
      STRING, CHAR_STRING,
      hljs.NUMBER_MODE,
      FUNCTION,
      {
        className: 'class',
        begin: '=\\bclass\\b', end: 'end;',
        keywords: OXYGENE_KEYWORDS,
        contains: [
          STRING, CHAR_STRING,
          CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
          FUNCTION
        ]
      }
    ]
  };
});

hljs.registerLanguage('parser3', function(hljs) {
  var CURLY_SUBCOMMENT = hljs.COMMENT(
    '{',
    '}',
    {
      contains: ['self']
    }
  );
  return {
    subLanguage: 'xml', relevance: 0,
    contains: [
      hljs.COMMENT('^#', '$'),
      hljs.COMMENT(
        '\\^rem{',
        '}',
        {
          relevance: 10,
          contains: [
            CURLY_SUBCOMMENT
          ]
        }
      ),
      {
        className: 'meta',
        begin: '^@(?:BASE|USE|CLASS|OPTIONS)$',
        relevance: 10
      },
      {
        className: 'title',
        begin: '@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$'
      },
      {
        className: 'variable',
        begin: '\\$\\{?[\\w\\-\\.\\:]+\\}?'
      },
      {
        className: 'keyword',
        begin: '\\^[\\w\\-\\.\\:]+'
      },
      {
        className: 'number',
        begin: '\\^#[0-9a-fA-F]+'
      },
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('pf', function(hljs) {
  var MACRO = {
    className: 'variable',
    begin: /\$[\w\d#@][\w\d_]*/
  };
  var TABLE = {
    className: 'variable',
    begin: /<(?!\/)/, end: />/
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/
  };

  return {
    aliases: ['pf.conf'],
    lexemes: /[a-z0-9_<>-]+/,
    keywords: {
      built_in: /* block match pass are "actions" in pf.conf(5), the rest are
                 * lexically similar top-level commands.
                 */
        'block match pass load anchor|5 antispoof|10 set table',
      keyword:
        'in out log quick on rdomain inet inet6 proto from port os to route' +
        'allow-opts divert-packet divert-reply divert-to flags group icmp-type' +
        'icmp6-type label once probability recieved-on rtable prio queue' +
        'tos tag tagged user keep fragment for os drop' +
        'af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin' +
        'source-hash static-port' +
        'dup-to reply-to route-to' +
        'parent bandwidth default min max qlimit' +
        'block-policy debug fingerprints hostid limit loginterface optimization' +
        'reassemble ruleset-optimization basic none profile skip state-defaults' +
        'state-policy timeout' +
        'const counters persist' +
        'no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy' +
        'source-track global rule max-src-nodes max-src-states max-src-conn' +
        'max-src-conn-rate overload flush' +
        'scrub|5 max-mss min-ttl no-df|10 random-id',
      literal:
        'all any no-route self urpf-failed egress|5 unknown'
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.NUMBER_MODE,
      hljs.QUOTE_STRING_MODE,
      MACRO,
      TABLE
    ]
  };
});

hljs.registerLanguage('php', function(hljs) {
  var VARIABLE = {
    begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*'
  };
  var PREPROCESSOR = {
    className: 'meta', begin: /<\?(php)?|\?>/
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
    variants: [
      {
        begin: 'b"', end: '"'
      },
      {
        begin: 'b\'', end: '\''
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
    ]
  };
  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
  return {
    aliases: ['php3', 'php4', 'php5', 'php6'],
    case_insensitive: true,
    keywords:
      'and include_once list abstract global private echo interface as static endswitch ' +
      'array null if endwhile or const for endforeach self var while isset public ' +
      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
      'enddeclare final try switch continue endfor endif declare unset true false ' +
      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
      'yield finally',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.COMMENT('//', '$', {contains: [PREPROCESSOR]}),
      hljs.COMMENT(
        '/\\*',
        '\\*/',
        {
          contains: [
            {
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.COMMENT(
        '__halt_compiler.+?;',
        false,
        {
          endsWithParent: true,
          keywords: '__halt_compiler',
          lexemes: hljs.UNDERSCORE_IDENT_RE
        }
      ),
      {
        className: 'string',
        begin: /<<<['"]?\w+['"]?$/, end: /^\w+;?$/,
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            variants: [
              {begin: /\$\w+/},
              {begin: /\{\$/, end: /\}/}
            ]
          }
        ]
      },
      PREPROCESSOR,
      {
        className: 'keyword', begin: /\$this\b/
      },
      VARIABLE,
      {
        // swallow composed identifiers to avoid parsing them as keywords
        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
        illegal: '\\$|\\[|%',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              'self',
              VARIABLE,
              hljs.C_BLOCK_COMMENT_MODE,
              STRING,
              NUMBER
            ]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: /[:\(\$"]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: ';',
        illegal: /[\.']/,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        beginKeywords: 'use', end: ';',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: '=>' // No markup, just a relevance booster
      },
      STRING,
      NUMBER
    ]
  };
});

hljs.registerLanguage('pony', function(hljs) {
  var KEYWORDS = {
    keyword:
      'actor addressof and as be break class compile_error compile_intrinsic' +
      'consume continue delegate digestof do else elseif embed end error' +
      'for fun if ifdef in interface is isnt lambda let match new not object' +
      'or primitive recover repeat return struct then trait try type until ' +
      'use var where while with xor',
    meta:
      'iso val tag trn box ref',
    literal:
      'this false true'
  };

  var TRIPLE_QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"""', end: '"""',
    relevance: 10
  };

  var QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"', end: '"',
    contains: [hljs.BACKSLASH_ESCAPE]
  };

  var SINGLE_QUOTE_CHAR_MODE = {
    className: 'string',
    begin: '\'', end: '\'',
    contains: [hljs.BACKSLASH_ESCAPE],
    relevance: 0
  };

  var TYPE_NAME = {
    className: 'type',
    begin: '\\b_?[A-Z][\\w]*',
    relevance: 0
  };

  var PRIMED_NAME = {
    begin: hljs.IDENT_RE + '\'', relevance: 0
  };

  var CLASS = {
    className: 'class',
    beginKeywords: 'class actor', end: '$',
    contains: [
      hljs.TITLE_MODE,
      hljs.C_LINE_COMMENT_MODE
    ]
  }

  var FUNCTION = {
    className: 'function',
    beginKeywords: 'new fun', end: '=>',
    contains: [
      hljs.TITLE_MODE,
      {
        begin: /\(/, end: /\)/,
        contains: [
          TYPE_NAME,
          PRIMED_NAME,
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        begin: /:/, endsWithParent: true,
        contains: [TYPE_NAME]
      },
      hljs.C_LINE_COMMENT_MODE
    ]
  }

  return {
    keywords: KEYWORDS,
    contains: [
      CLASS,
      FUNCTION,
      TYPE_NAME,
      TRIPLE_QUOTE_STRING_MODE,
      QUOTE_STRING_MODE,
      SINGLE_QUOTE_CHAR_MODE,
      PRIMED_NAME,
      hljs.C_NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('powershell', function(hljs) {
  var BACKTICK_ESCAPE = {
    begin: '`[\\s\\S]',
    relevance: 0
  };
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d][\w\d_:]*/}
    ]
  };
  var LITERAL = {
    className: 'literal',
    begin: /\$(null|true|false)\b/
  };
  var QUOTE_STRING = {
    className: 'string',
    variants: [
      { begin: /"/, end: /"/ },
      { begin: /@"/, end: /^"@/ }
    ],
    contains: [
      BACKTICK_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$[A-z]/, end: /[^A-z]/
      }
    ]
  };
  var APOS_STRING = {
    className: 'string',
    variants: [
      { begin: /'/, end: /'/ },
      { begin: /@'/, end: /^'@/ }
    ]
  };

  var PS_HELPTAGS = {
    className: 'doctag',
    variants: [
      /* no paramater help tags */ 
      { begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/ },
      /* one parameter help tags */
      { begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/ }
    ]
  };
  var PS_COMMENT = hljs.inherit(
    hljs.COMMENT(null, null),
    {
      variants: [
        /* single-line comment */
        { begin: /#/, end: /$/ },
        /* multi-line comment */
        { begin: /<#/, end: /#>/ }
      ],
      contains: [PS_HELPTAGS]
    }
  );

  return {
    aliases: ['ps'],
    lexemes: /-?[A-z\.\-]+/,
    case_insensitive: true,
    keywords: {
      keyword: 'if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch',
      built_in: 'Add-Computer Add-Content Add-History Add-JobTrigger Add-Member Add-PSSnapin Add-Type Checkpoint-Computer Clear-Content Clear-EventLog Clear-History Clear-Host Clear-Item Clear-ItemProperty Clear-Variable Compare-Object Complete-Transaction Connect-PSSession Connect-WSMan Convert-Path ConvertFrom-Csv ConvertFrom-Json ConvertFrom-SecureString ConvertFrom-StringData ConvertTo-Csv ConvertTo-Html ConvertTo-Json ConvertTo-SecureString ConvertTo-Xml Copy-Item Copy-ItemProperty Debug-Process Disable-ComputerRestore Disable-JobTrigger Disable-PSBreakpoint Disable-PSRemoting Disable-PSSessionConfiguration Disable-WSManCredSSP Disconnect-PSSession Disconnect-WSMan Disable-ScheduledJob Enable-ComputerRestore Enable-JobTrigger Enable-PSBreakpoint Enable-PSRemoting Enable-PSSessionConfiguration Enable-ScheduledJob Enable-WSManCredSSP Enter-PSSession Exit-PSSession Export-Alias Export-Clixml Export-Console Export-Counter Export-Csv Export-FormatData Export-ModuleMember Export-PSSession ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-ComputerRestorePoint Get-Content Get-ControlPanelItem Get-Counter Get-Credential Get-Culture Get-Date Get-Event Get-EventLog Get-EventSubscriber Get-ExecutionPolicy Get-FormatData Get-Host Get-HotFix Get-Help Get-History Get-IseSnippet Get-Item Get-ItemProperty Get-Job Get-JobTrigger Get-Location Get-Member Get-Module Get-PfxCertificate Get-Process Get-PSBreakpoint Get-PSCallStack Get-PSDrive Get-PSProvider Get-PSSession Get-PSSessionConfiguration Get-PSSnapin Get-Random Get-ScheduledJob Get-ScheduledJobOption Get-Service Get-TraceSource Get-Transaction Get-TypeData Get-UICulture Get-Unique Get-Variable Get-Verb Get-WinEvent Get-WmiObject Get-WSManCredSSP Get-WSManInstance Group-Object Import-Alias Import-Clixml Import-Counter Import-Csv Import-IseSnippet Import-LocalizedData Import-PSSession Import-Module Invoke-AsWorkflow Invoke-Command Invoke-Expression Invoke-History Invoke-Item Invoke-RestMethod Invoke-WebRequest Invoke-WmiMethod Invoke-WSManAction Join-Path Limit-EventLog Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Event New-EventLog New-IseSnippet New-Item New-ItemProperty New-JobTrigger New-Object New-Module New-ModuleManifest New-PSDrive New-PSSession New-PSSessionConfigurationFile New-PSSessionOption New-PSTransportOption New-PSWorkflowExecutionOption New-PSWorkflowSession New-ScheduledJobOption New-Service New-TimeSpan New-Variable New-WebServiceProxy New-WinEvent New-WSManInstance New-WSManSessionOption Out-Default Out-File Out-GridView Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Receive-Job Register-EngineEvent Register-ObjectEvent Register-PSSessionConfiguration Register-ScheduledJob Register-WmiEvent Remove-Computer Remove-Event Remove-EventLog Remove-Item Remove-ItemProperty Remove-Job Remove-JobTrigger Remove-Module Remove-PSBreakpoint Remove-PSDrive Remove-PSSession Remove-PSSnapin Remove-TypeData Remove-Variable Remove-WmiObject Remove-WSManInstance Rename-Computer Rename-Item Rename-ItemProperty Reset-ComputerMachinePassword Resolve-Path Restart-Computer Restart-Service Restore-Computer Resume-Job Resume-Service Save-Help Select-Object Select-String Select-Xml Send-MailMessage Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-JobTrigger Set-Location Set-PSBreakpoint Set-PSDebug Set-PSSessionConfiguration Set-ScheduledJob Set-ScheduledJobOption Set-Service Set-StrictMode Set-TraceSource Set-Variable Set-WmiInstance Set-WSManInstance Set-WSManQuickConfig Show-Command Show-ControlPanelItem Show-EventLog Sort-Object Split-Path Start-Job Start-Process Start-Service Start-Sleep Start-Transaction Start-Transcript Stop-Computer Stop-Job Stop-Process Stop-Service Stop-Transcript Suspend-Job Suspend-Service Tee-Object Test-ComputerSecureChannel Test-Connection Test-ModuleManifest Test-Path Test-PSSessionConfigurationFile Trace-Command Unblock-File Undo-Transaction Unregister-Event Unregister-PSSessionConfiguration Unregister-ScheduledJob Update-FormatData Update-Help Update-List Update-TypeData Use-Transaction Wait-Event Wait-Job Wait-Process Where-Object Write-Debug Write-Error Write-EventLog Write-Host Write-Output Write-Progress Write-Verbose Write-Warning Add-MDTPersistentDrive Disable-MDTMonitorService Enable-MDTMonitorService Get-MDTDeploymentShareStatistics Get-MDTMonitorData Get-MDTOperatingSystemCatalog Get-MDTPersistentDrive Import-MDTApplication Import-MDTDriver Import-MDTOperatingSystem Import-MDTPackage Import-MDTTaskSequence New-MDTDatabase Remove-MDTMonitorData Remove-MDTPersistentDrive Restore-MDTPersistentDrive Set-MDTMonitorData Test-MDTDeploymentShare Test-MDTMonitorData Update-MDTDatabaseSchema Update-MDTDeploymentShare Update-MDTLinkedDS Update-MDTMedia Update-MDTMedia Add-VamtProductKey Export-VamtData Find-VamtManagedMachine Get-VamtConfirmationId Get-VamtProduct Get-VamtProductKey Import-VamtData Initialize-VamtData Install-VamtConfirmationId Install-VamtProductActivation Install-VamtProductKey Update-VamtProduct',
      nomarkup: '-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace'
    },
    contains: [
      BACKTICK_ESCAPE,
      hljs.NUMBER_MODE,
      QUOTE_STRING,
      APOS_STRING,
      LITERAL,
      VAR,
      PS_COMMENT
    ]
  };
});

hljs.registerLanguage('processing', function(hljs) {
  return {
    keywords: {
      keyword: 'BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color ' +
        'double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject ' +
        'Object StringDict StringList Table TableRow XML ' +
        // Java keywords
        'false synchronized int abstract float private char boolean static null if const ' +
        'for true while long throw strictfp finally protected import native final return void ' +
        'enum else break transient new catch instanceof byte super volatile case assert short ' +
        'package default double public try this switch continue throws protected public private',
      literal: 'P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI',
      title: 'setup draw',
      built_in: 'displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key ' +
        'keyCode pixels focused frameCount frameRate height width ' +
        'size createGraphics beginDraw createShape loadShape PShape arc ellipse line point ' +
        'quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint ' +
        'curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex ' +
        'endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap ' +
        'strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased ' +
        'mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour ' +
        'millis minute month second year background clear colorMode fill noFill noStroke stroke alpha ' +
        'blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY ' +
        'screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ' +
        'ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle ' +
        'pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf ' +
        'nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset ' +
        'box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings ' +
        'loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput ' +
        'createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings ' +
        'saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale ' +
        'shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal ' +
        'pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap ' +
        'blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont ' +
        'loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil ' +
        'constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees ' +
        'radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('profile', function(hljs) {
  return {
    contains: [
      hljs.C_NUMBER_MODE,
      {
        begin: '[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}', end: ':',
        excludeEnd: true
      },
      {
        begin: '(ncalls|tottime|cumtime)', end: '$',
        keywords: 'ncalls tottime|10 cumtime|10 filename',
        relevance: 10
      },
      {
        begin: 'function calls', end: '$',
        contains: [hljs.C_NUMBER_MODE],
        relevance: 10
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\\(', end: '\\)$',
        excludeBegin: true, excludeEnd: true,
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('prolog', function(hljs) {

  var ATOM = {

    begin: /[a-z][A-Za-z0-9_]*/,
    relevance: 0
  };

  var VAR = {

    className: 'symbol',
    variants: [
      {begin: /[A-Z][a-zA-Z0-9_]*/},
      {begin: /_[A-Za-z0-9_]*/},
    ],
    relevance: 0
  };

  var PARENTED = {

    begin: /\(/,
    end: /\)/,
    relevance: 0
  };

  var LIST = {

    begin: /\[/,
    end: /\]/
  };

  var LINE_COMMENT = {

    className: 'comment',
    begin: /%/, end: /$/,
    contains: [hljs.PHRASAL_WORDS_MODE]
  };

  var BACKTICK_STRING = {

    className: 'string',
    begin: /`/, end: /`/,
    contains: [hljs.BACKSLASH_ESCAPE]
  };

  var CHAR_CODE = {

    className: 'string', // 0'a etc.
    begin: /0\'(\\\'|.)/
  };

  var SPACE_CODE = {

    className: 'string',
    begin: /0\'\\s/ // 0'\s
  };

  var PRED_OP = { // relevance booster
    begin: /:-/
  };

  var inner = [

    ATOM,
    VAR,
    PARENTED,
    PRED_OP,
    LIST,
    LINE_COMMENT,
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.APOS_STRING_MODE,
    BACKTICK_STRING,
    CHAR_CODE,
    SPACE_CODE,
    hljs.C_NUMBER_MODE
  ];

  PARENTED.contains = inner;
  LIST.contains = inner;

  return {
    contains: inner.concat([
      {begin: /\.$/} // relevance booster
    ])
  };
});

hljs.registerLanguage('protobuf', function(hljs) {
  return {
    keywords: {
      keyword: 'package import option optional required repeated group',
      built_in: 'double float int32 int64 uint32 uint64 sint32 sint64 ' +
        'fixed32 fixed64 sfixed32 sfixed64 bool string bytes',
      literal: 'true false'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'message enum service', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      },
      {
        className: 'function',
        beginKeywords: 'rpc',
        end: /;/, excludeEnd: true,
        keywords: 'rpc returns'
      },
      {
        begin: /^\s*[A-Z_]+/,
        end: /\s*=/, excludeEnd: true
      }
    ]
  };
});

hljs.registerLanguage('puppet', function(hljs) {

  var PUPPET_KEYWORDS = {
    keyword:
    /* language keywords */
      'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
    literal:
    /* metaparameters */
      'alias audit before loglevel noop require subscribe tag ' +
    /* normal attributes */
      'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' +
      'en_address ip_address realname command environment hour monute month monthday special target weekday '+
      'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' +
      'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' +
      'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid '+
      'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' +
      'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' +
      'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' +
      'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' +
      'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' +
      'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' +
      'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' +
      'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' +
      'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' +
      'sslverify mounted',
    built_in:
    /* core facts */
      'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' +
      'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces '+
      'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' +
      'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' +
      'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' +
      'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease '+
      'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion '+
      'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced '+
      'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime '+
      'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
  };

  var COMMENT = hljs.COMMENT('#', '$');

  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE});

  var VARIABLE = {className: 'variable', begin: '\\$' + IDENT_RE};

  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/}
    ]
  };

  return {
    aliases: ['pp'],
    contains: [
      COMMENT,
      VARIABLE,
      STRING,
      {
        beginKeywords: 'class', end: '\\{|;',
        illegal: /=/,
        contains: [TITLE, COMMENT]
      },
      {
        beginKeywords: 'define', end: /\{/,
        contains: [
          {
            className: 'section', begin: hljs.IDENT_RE, endsParent: true
          }
        ]
      },
      {
        begin: hljs.IDENT_RE + '\\s+\\{', returnBegin: true,
        end: /\S/,
        contains: [
          {
            className: 'keyword',
            begin: hljs.IDENT_RE
          },
          {
            begin: /\{/, end: /\}/,
            keywords: PUPPET_KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              COMMENT,
              {
                begin:'[a-zA-Z_]+\\s*=>',
                returnBegin: true, end: '=>',
                contains: [
                  {
                    className: 'attr',
                    begin: hljs.IDENT_RE,
                  }
                ]
              },
              {
                className: 'number',
                begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
                relevance: 0
              },
              VARIABLE
            ]
          }
        ],
        relevance: 0
      }
    ]
  }
});

hljs.registerLanguage('purebasic', // Base deafult colors in PB IDE: background: #FFFFDF; foreground: #000000;

function(hljs) {
  var STRINGS = { // PB IDE color: #0080FF (Azure Radiance)
    className: 'string',
    begin: '(~)?"', end: '"',
    illegal: '\\n'
  };
  var CONSTANTS = { // PB IDE color: #924B72 (Cannon Pink)
    //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
    className: 'symbol',
    begin: '#[a-zA-Z_]\\w*\\$?'
  };

  return {
    aliases: ['pb', 'pbi'],
    keywords: // PB IDE color: #006666 (Blue Stone) + Bold
      // The following keywords list was taken and adapted from GuShH's PureBasic language file for GeSHi...
      'And As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerEndIf CompilerEndSelect ' +
      'CompilerError CompilerIf CompilerSelect Continue Data DataSection EndDataSection Debug DebugLevel ' +
      'Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM ' +
      'EnableDebugger EnableExplicit End EndEnumeration EndIf EndImport EndInterface EndMacro EndProcedure ' +
      'EndSelect EndStructure EndStructureUnion EndWith Enumeration Extends FakeReturn For Next ForEach ' +
      'ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface Macro ' +
      'NewList Not Or ProcedureReturn Protected Prototype ' +
      'PrototypeC Read ReDim Repeat Until Restore Return Select Shared Static Step Structure StructureUnion ' +
      'Swap To Wend While With XIncludeFile XOr ' +
      'Procedure ProcedureC ProcedureCDLL ProcedureDLL Declare DeclareC DeclareCDLL DeclareDLL',
    contains: [
      // COMMENTS | PB IDE color: #00AAAA (Persian Green)
      hljs.COMMENT(';', '$', {relevance: 0}),

      { // PROCEDURES DEFINITIONS
        className: 'function',
        begin: '\\b(Procedure|Declare)(C|CDLL|DLL)?\\b',
        end: '\\(',
        excludeEnd: true,
        returnBegin: true,
        contains: [
          { // PROCEDURE KEYWORDS | PB IDE color: #006666 (Blue Stone) + Bold
            className: 'keyword',
            begin: '(Procedure|Declare)(C|CDLL|DLL)?',
            excludeEnd: true
          },
          { // PROCEDURE RETURN TYPE SETTING | PB IDE color: #000000 (Black)
            className: 'type',
            begin: '\\.\\w*'
            // end: ' ',
          },
          hljs.UNDERSCORE_TITLE_MODE // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
        ]
      },
      STRINGS,
      CONSTANTS
    ]
  };
});

hljs.registerLanguage('python', function(hljs) {
  var KEYWORDS = {
    keyword:
      'and elif is global as in if from raise for except finally print import pass return ' +
      'exec else break not with class assert yield try while continue del or def lambda ' +
      'async await nonlocal|10 None True False',
    built_in:
      'Ellipsis NotImplemented'
  };
  var PROMPT = {
    className: 'meta',  begin: /^(>>>|\.\.\.) /
  };
  var SUBST = {
    className: 'subst',
    begin: /\{/, end: /\}/,
    keywords: KEYWORDS,
    illegal: /#/
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /(u|b)?r?'''/, end: /'''/,
        contains: [PROMPT],
        relevance: 10
      },
      {
        begin: /(u|b)?r?"""/, end: /"""/,
        contains: [PROMPT],
        relevance: 10
      },
      {
        begin: /(fr|rf|f)'''/, end: /'''/,
        contains: [PROMPT, SUBST]
      },
      {
        begin: /(fr|rf|f)"""/, end: /"""/,
        contains: [PROMPT, SUBST]
      },
      {
        begin: /(u|r|ur)'/, end: /'/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)"/, end: /"/,
        relevance: 10
      },
      {
        begin: /(b|br)'/, end: /'/
      },
      {
        begin: /(b|br)"/, end: /"/
      },
      {
        begin: /(fr|rf|f)'/, end: /'/,
        contains: [SUBST]
      },
      {
        begin: /(fr|rf|f)"/, end: /"/,
        contains: [SUBST]
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
  var NUMBER = {
    className: 'number', relevance: 0,
    variants: [
      {begin: hljs.BINARY_NUMBER_RE + '[lLjJ]?'},
      {begin: '\\b(0o[0-7]+)[lLjJ]?'},
      {begin: hljs.C_NUMBER_RE + '[lLjJ]?'}
    ]
  };
  var PARAMS = {
    className: 'params',
    begin: /\(/, end: /\)/,
    contains: ['self', PROMPT, NUMBER, STRING]
  };
  SUBST.contains = [STRING, NUMBER, PROMPT];
  return {
    aliases: ['py', 'gyp'],
    keywords: KEYWORDS,
    illegal: /(<\/|->|\?)|=>/,
    contains: [
      PROMPT,
      NUMBER,
      STRING,
      hljs.HASH_COMMENT_MODE,
      {
        variants: [
          {className: 'function', beginKeywords: 'def'},
          {className: 'class', beginKeywords: 'class'}
        ],
        end: /:/,
        illegal: /[${=;\n,]/,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          PARAMS,
          {
            begin: /->/, endsWithParent: true,
            keywords: 'None'
          }
        ]
      },
      {
        className: 'meta',
        begin: /^[\t ]*@/, end: /$/
      },
      {
        begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
      }
    ]
  };
});

hljs.registerLanguage('q', function(hljs) {
  var Q_KEYWORDS = {
  keyword:
    'do while select delete by update from',
  literal:
    '0b 1b',
  built_in:
    'neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum',
  type:
    '`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid'
  };
  return {
  aliases:['k', 'kdb'],
  keywords: Q_KEYWORDS,
  lexemes: /(`?)[A-Za-z0-9_]+\b/,
  contains: [
  hljs.C_LINE_COMMENT_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE
     ]
  };
});

hljs.registerLanguage('qml', function(hljs) {
  var KEYWORDS = {
      keyword:
        'in of on if for while finally var new function do return void else break catch ' +
        'instanceof with throw case default try this switch continue typeof delete ' +
        'let yield const export super debugger as async await import',
      literal:
        'true false null undefined NaN Infinity',
      built_in:
        'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
        'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
        'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
        'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
        'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
        'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
        'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
        'Behavior bool color coordinate date double enumeration font geocircle georectangle ' +
        'geoshape int list matrix4x4 parent point quaternion real rect ' +
        'size string url var variant vector2d vector3d vector4d' +
        'Promise'
    };

  var QML_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9\\._]*';

  // Isolate property statements. Ends at a :, =, ;, ,, a comment or end of line.
  // Use property class.
  var PROPERTY = {
      className: 'keyword',
      begin: '\\bproperty\\b',
      starts: {
        className: 'string',
        end: '(:|=|;|,|//|/\\*|$)',
        returnEnd: true
      }
  };

  // Isolate signal statements. Ends at a ) a comment or end of line.
  // Use property class.
  var SIGNAL = {
      className: 'keyword',
      begin: '\\bsignal\\b',
      starts: {
        className: 'string',
        end: '(\\(|:|=|;|,|//|/\\*|$)',
        returnEnd: true
      }
  };

  // id: is special in QML. When we see id: we want to mark the id: as attribute and
  // emphasize the token following.
  var ID_ID = {
      className: 'attribute',
      begin: '\\bid\\s*:',
      starts: {
        className: 'string',
        end: QML_IDENT_RE,
        returnEnd: false
      }
  };

  // Find QML object attribute. An attribute is a QML identifier followed by :.
  // Unfortunately it's hard to know where it ends, as it may contain scalars,
  // objects, object definitions, or javascript. The true end is either when the parent
  // ends or the next attribute is detected.
  var QML_ATTRIBUTE = {
    begin: QML_IDENT_RE + '\\s*:',
    returnBegin: true,
    contains: [
      {
        className: 'attribute',
        begin: QML_IDENT_RE,
        end: '\\s*:',
        excludeEnd: true,
        relevance: 0
      }
    ],
    relevance: 0
  };

  // Find QML object. A QML object is a QML identifier followed by { and ends at the matching }.
  // All we really care about is finding IDENT followed by { and just mark up the IDENT and ignore the {.
  var QML_OBJECT = {
    begin: QML_IDENT_RE + '\\s*{', end: '{',
    returnBegin: true,
    relevance: 0,
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {begin: QML_IDENT_RE})
    ]
  };

  return {
    aliases: ['qt'],
    case_insensitive: false,
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      { // template string
        className: 'string',
        begin: '`', end: '`',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            begin: '\\$\\{', end: '\\}'
          }
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'number',
        variants: [
          { begin: '\\b(0[bB][01]+)' },
          { begin: '\\b(0[oO][0-7]+)' },
          { begin: hljs.C_NUMBER_RE }
        ],
        relevance: 0
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          { // E4X / JSX
            begin: /</, end: />\s*[);\]]/,
            relevance: 0,
            subLanguage: 'xml'
          }
        ],
        relevance: 0
      },
      SIGNAL,
      PROPERTY,
      {
        className: 'function',
        beginKeywords: 'function', end: /\{/, excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          }
        ],
        illegal: /\[|%/
      },
      {
        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
      },
      ID_ID,
      QML_ATTRIBUTE,
      QML_OBJECT
    ],
    illegal: /#/
  };
});

hljs.registerLanguage('r', function(hljs) {
  var IDENT_RE = '([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*';

  return {
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        begin: IDENT_RE,
        lexemes: IDENT_RE,
        keywords: {
          keyword:
            'function if in break next repeat else for return switch while try tryCatch ' +
            'stop warning require library attach detach source setMethod setGeneric ' +
            'setGroupGeneric setClass ...',
          literal:
            'NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 ' +
            'NA_complex_|10'
        },
        relevance: 0
      },
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // explicit integer
        className: 'number',
        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
        relevance: 0
      },
      {
        // number with trailing decimal
        className: 'number',
        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
        relevance: 0
      },
      {
        // number
        className: 'number',
        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },
      {
        // number with leading decimal
        className: 'number',
        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },

      {
        // escaped identifier
        begin: '`',
        end: '`',
        relevance: 0
      },

      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          {begin: '"', end: '"'},
          {begin: "'", end: "'"}
        ]
      }
    ]
  };
});

hljs.registerLanguage('rib', function(hljs) {
  return {
    keywords:
      'ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis ' +
      'Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone ' +
      'CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail ' +
      'DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format ' +
      'FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry ' +
      'Hider Hyperboloid Identity Illuminate Imager Interior LightSource ' +
      'MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte ' +
      'MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option ' +
      'Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples ' +
      'PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection ' +
      'Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ' +
      'ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere ' +
      'SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd ' +
      'TransformPoints Translate TrimCurve WorldBegin WorldEnd',
    illegal: '</',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
});

hljs.registerLanguage('roboconf', function(hljs) {
  var IDENTIFIER = '[a-zA-Z-_][^\\n{]+\\{';

  var PROPERTY = {
    className: 'attribute',
    begin: /[a-zA-Z-_]+/, end: /\s*:/, excludeEnd: true,
    starts: {
      end: ';',
      relevance: 0,
      contains: [
        {
          className: 'variable',
          begin: /\.[a-zA-Z-_]+/
        },
        {
          className: 'keyword',
          begin: /\(optional\)/
        }
      ]
    }
  };

  return {
    aliases: ['graph', 'instances'],
    case_insensitive: true,
    keywords: 'import',
    contains: [
      // Facet sections
      {
        begin: '^facet ' + IDENTIFIER,
        end: '}',
        keywords: 'facet',
        contains: [
          PROPERTY,
          hljs.HASH_COMMENT_MODE
        ]
      },

      // Instance sections
      {
        begin: '^\\s*instance of ' + IDENTIFIER,
        end: '}',
        keywords: 'name count channels instance-data instance-state instance of',
        illegal: /\S/,
        contains: [
          'self',
          PROPERTY,
          hljs.HASH_COMMENT_MODE
        ]
      },

      // Component sections
      {
        begin: '^' + IDENTIFIER,
        end: '}',
        contains: [
          PROPERTY,
          hljs.HASH_COMMENT_MODE
        ]
      },

      // Comments
      hljs.HASH_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('rsl', function(hljs) {
  return {
    keywords: {
      keyword:
        'float color point normal vector matrix while for if do return else break extern continue',
      built_in:
        'abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise ' +
        'clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp ' +
        'faceforward filterstep floor format fresnel incident length lightsource log match ' +
        'max min mod noise normalize ntransform opposite option phong pnoise pow printf ' +
        'ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp ' +
        'setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan ' +
        'texture textureinfo trace transform vtransform xcomp ycomp zcomp'
    },
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$'
      },
      {
        className: 'class',
        beginKeywords: 'surface displacement light volume imager', end: '\\('
      },
      {
        beginKeywords: 'illuminate illuminance gather', end: '\\('
      }
    ]
  };
});

hljs.registerLanguage('ruleslanguage', function(hljs) {
  return {
    keywords: {
       keyword: 'BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE ' +
         'INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 ' +
         'INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 ' +
         'INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 ' +
         'INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 ' +
         'INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 ' +
         'INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 ' +
         'INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 ' +
         'INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 ' +
         'INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 ' +
         'INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 ' +
         'INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 ' +
         'INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 ' +
         'INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 ' +
         'INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 ' +
         'MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER ' +
         'OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE ' +
         'NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH ' +
         'IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND ' +
         'UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ' +
         'ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE ' +
         'GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE ' +
         'SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING ' +
         'DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF ' +
         'MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY ' +
         'YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE ' +
         'COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR ' +
         'READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ' +
         'ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE ' +
         'EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE ' +
         'SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL ' +
         'COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN ' +
         'MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING ' +
         'FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM ' +
         'NUMDAYS READ_DATE STAGING',
       built_in: 'IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML ' +
         'DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT ' +
         'DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE ' +
         'DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT ' +
         'DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'literal',
        variants: [
          {begin: '#\\s+[a-zA-Z\\ \\.]*', relevance: 0}, // looks like #-comment
          {begin: '#[a-zA-Z\\ \\.]+'}
        ]
      }
    ]
  };
});

hljs.registerLanguage('rust', function(hljs) {
  var NUM_SUFFIX = '([ui](8|16|32|64|128|size)|f(32|64))\?';
  var KEYWORDS =
    'alignof as be box break const continue crate do else enum extern ' +
    'false fn for if impl in let loop match mod mut offsetof once priv ' +
    'proc pub pure ref return self Self sizeof static struct super trait true ' +
    'type typeof unsafe unsized use virtual while where yield move default';
  var BUILTINS =
    // functions
    'drop ' +
    // types
    'i8 i16 i32 i64 i128 isize ' +
    'u8 u16 u32 u64 u128 usize ' +
    'f32 f64 ' +
    'str char bool ' +
    'Box Option Result String Vec ' +
    // traits
    'Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug ' +
    'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' +
    'Extend IntoIterator DoubleEndedIterator ExactSizeIterator ' +
    'SliceConcatExt ToString ' +
    // macros
    'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' +
    'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' +
    'include_bin! include_str! line! local_data_key! module_path! ' +
    'option_env! print! println! select! stringify! try! unimplemented! ' +
    'unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!';
  return {
    aliases: ['rs'],
    keywords: {
      keyword:
        KEYWORDS,
      literal:
        'true false Some None Ok Err',
      built_in:
        BUILTINS
    },
    lexemes: hljs.IDENT_RE + '!?',
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {begin: /b?"/, illegal: null}),
      {
        className: 'string',
        variants: [
           { begin: /r(#*)".*?"\1(?!#)/ },
           { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
        ]
      },
      {
        className: 'symbol',
        begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
      },
      {
        className: 'number',
        variants: [
          { begin: '\\b0b([01_]+)' + NUM_SUFFIX },
          { begin: '\\b0o([0-7_]+)' + NUM_SUFFIX },
          { begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX },
          { begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' +
                   NUM_SUFFIX
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'fn', end: '(\\(|<)', excludeEnd: true,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        className: 'meta',
        begin: '#\\!?\\[', end: '\\]',
        contains: [
          {
            className: 'meta-string',
            begin: /"/, end: /"/
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'type', end: ';',
        contains: [
          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
        ],
        illegal: '\\S'
      },
      {
        className: 'class',
        beginKeywords: 'trait enum struct union', end: '{',
        contains: [
          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
        ],
        illegal: '[\\w\\d]'
      },
      {
        begin: hljs.IDENT_RE + '::',
        keywords: {built_in: BUILTINS}
      },
      {
        begin: '->'
      }
    ]
  };
});

hljs.registerLanguage('scala', function(hljs) {

  var ANNOTATION = { className: 'meta', begin: '@[A-Za-z]+' };

  // used in strings for escaping/interpolation/substitution
  var SUBST = {
    className: 'subst',
    variants: [
      {begin: '\\$[A-Za-z0-9_]+'},
      {begin: '\\${', end: '}'}
    ]
  };

  var STRING = {
    className: 'string',
    variants: [
      {
        begin: '"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '"""', end: '"""',
        relevance: 10
      },
      {
        begin: '[a-z]+"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        className: 'string',
        begin: '[a-z]+"""', end: '"""',
        contains: [SUBST],
        relevance: 10
      }
    ]

  };

  var SYMBOL = {
    className: 'symbol',
    begin: '\'\\w[\\w\\d_]*(?!\')'
  };

  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][A-Za-z0-9_]*',
    relevance: 0
  };

  var NAME = {
    className: 'title',
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
    relevance: 0
  };

  var CLASS = {
    className: 'class',
    beginKeywords: 'class object trait type',
    end: /[:={\[\n;]/,
    excludeEnd: true,
    contains: [
      {
        beginKeywords: 'extends with',
        relevance: 10
      },
      {
        begin: /\[/,
        end: /\]/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [TYPE]
      },
      {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [TYPE]
      },
      NAME
    ]
  };

  var METHOD = {
    className: 'function',
    beginKeywords: 'def',
    end: /[:={\[(\n;]/,
    excludeEnd: true,
    contains: [NAME]
  };

  return {
    keywords: {
      literal: 'true false null',
      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      STRING,
      SYMBOL,
      TYPE,
      METHOD,
      CLASS,
      hljs.C_NUMBER_MODE,
      ANNOTATION
    ]
  };
});

hljs.registerLanguage('scheme', function(hljs) {
  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
  var SCHEME_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+([./]\\d+)?';
  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
  var BUILTINS = {
    'builtin-name':
      'case-lambda call/cc class define-class exit-handler field import ' +
      'inherit init-field interface let*-values let-values let/ec mixin ' +
      'opt-lambda override protect provide public rename require ' +
      'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' +
      'when with-syntax and begin call-with-current-continuation ' +
      'call-with-input-file call-with-output-file case cond define ' +
      'define-syntax delay do dynamic-wind else for-each if lambda let let* ' +
      'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' +
      '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' +
      'boolean? caar cadr call-with-input-file call-with-output-file ' +
      'call-with-values car cdddar cddddr cdr ceiling char->integer ' +
      'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' +
      'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' +
      'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' +
      'char? close-input-port close-output-port complex? cons cos ' +
      'current-input-port current-output-port denominator display eof-object? ' +
      'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' +
      'force gcd imag-part inexact->exact inexact? input-port? integer->char ' +
      'integer? interaction-environment lcm length list list->string ' +
      'list->vector list-ref list-tail list? load log magnitude make-polar ' +
      'make-rectangular make-string make-vector max member memq memv min ' +
      'modulo negative? newline not null-environment null? number->string ' +
      'number? numerator odd? open-input-file open-output-file output-port? ' +
      'pair? peek-char port? positive? procedure? quasiquote quote quotient ' +
      'rational? rationalize read read-char real-part real? remainder reverse ' +
      'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' +
      'string->list string->number string->symbol string-append string-ci<=? ' +
      'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' +
      'string-fill! string-length string-ref string-set! string<=? string<? ' +
      'string=? string>=? string>? string? substring symbol->string symbol? ' +
      'tan transcript-off transcript-on truncate values vector ' +
      'vector->list vector-fill! vector-length vector-ref vector-set! ' +
      'with-input-from-file with-output-to-file write write-char zero?'
  };

  var SHEBANG = {
    className: 'meta',
    begin: '^#!',
    end: '$'
  };

  var LITERAL = {
    className: 'literal',
    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
  };

  var NUMBER = {
    className: 'number',
    variants: [
      { begin: SCHEME_SIMPLE_NUMBER_RE, relevance: 0 },
      { begin: SCHEME_COMPLEX_NUMBER_RE, relevance: 0 },
      { begin: '#b[0-1]+(/[0-1]+)?' },
      { begin: '#o[0-7]+(/[0-7]+)?' },
      { begin: '#x[0-9a-f]+(/[0-9a-f]+)?' }
    ]
  };

  var STRING = hljs.QUOTE_STRING_MODE;

  var REGULAR_EXPRESSION = {
    className: 'regexp',
    begin: '#[pr]x"',
    end: '[^\\\\]"'
  };

  var COMMENT_MODES = [
    hljs.COMMENT(
      ';',
      '$',
      {
        relevance: 0
      }
    ),
    hljs.COMMENT('#\\|', '\\|#')
  ];

  var IDENT = {
    begin: SCHEME_IDENT_RE,
    relevance: 0
  };

  var QUOTED_IDENT = {
    className: 'symbol',
    begin: '\'' + SCHEME_IDENT_RE
  };

  var BODY = {
    endsWithParent: true,
    relevance: 0
  };

  var QUOTED_LIST = {
    variants: [
      { begin: /'/ },
      { begin: '`' }
    ],
    contains: [
      {
        begin: '\\(', end: '\\)',
        contains: ['self', LITERAL, STRING, NUMBER, IDENT, QUOTED_IDENT]
      }
    ]
  };

  var NAME = {
    className: 'name',
    begin: SCHEME_IDENT_RE,
    lexemes: SCHEME_IDENT_RE,
    keywords: BUILTINS
  };

  var LAMBDA = {
    begin: /lambda/, endsWithParent: true, returnBegin: true,
    contains: [
      NAME,
      {
        begin: /\(/, end: /\)/, endsParent: true,
        contains: [IDENT],
      }
    ]
  };

  var LIST = {
    variants: [
      { begin: '\\(', end: '\\)' },
      { begin: '\\[', end: '\\]' }
    ],
    contains: [LAMBDA, NAME, BODY]
  };

  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES);

  return {
    illegal: /\S/,
    contains: [SHEBANG, NUMBER, STRING, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES)
  };
});

hljs.registerLanguage('scilab', function(hljs) {

  var COMMON_CONTAINS = [
    hljs.C_NUMBER_MODE,
    {
      className: 'string',
      begin: '\'|\"', end: '\'|\"',
      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
    }
  ];

  return {
    aliases: ['sci'],
    lexemes: /%?\w+/,
    keywords: {
      keyword: 'abort break case clear catch continue do elseif else endfunction end for function '+
        'global if pause return resume select try then while',
      literal:
        '%f %F %t %T %pi %eps %inf %nan %e %i %z %s',
      built_in: // Scilab has more than 2000 functions. Just list the most commons
       'abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error '+
       'exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty '+
       'isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log '+
       'max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real '+
       'round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan '+
       'type typename warning zeros matrix'
    },
    illegal: '("|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)'
          }
        ]
      },
      {
        begin: '[a-zA-Z_][a-zA-Z_0-9]*(\'+[\\.\']*|[\\.\']+)', end: '',
        relevance: 0
      },
      {
        begin: '\\[', end: '\\]\'*[\\.\']*',
        relevance: 0,
        contains: COMMON_CONTAINS
      },
      hljs.COMMENT('//', '$')
    ].concat(COMMON_CONTAINS)
  };
});

hljs.registerLanguage('scss', function(hljs) {
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var VARIABLE = {
    className: 'variable',
    begin: '(\\$' + IDENT_RE + ')\\b'
  };
  var HEXCOLOR = {
    className: 'number', begin: '#[0-9A-Fa-f]+'
  };
  var DEF_INTERNALS = {
    className: 'attribute',
    begin: '[A-Z\\_\\.\\-]+', end: ':',
    excludeEnd: true,
    illegal: '[^\\s]',
    starts: {
      endsWithParent: true, excludeEnd: true,
      contains: [
        HEXCOLOR,
        hljs.CSS_NUMBER_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.APOS_STRING_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        {
          className: 'meta', begin: '!important'
        }
      ]
    }
  };
  return {
    case_insensitive: true,
    illegal: '[=/|\']',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'selector-id', begin: '\\#[A-Za-z0-9_-]+',
        relevance: 0
      },
      {
        className: 'selector-class', begin: '\\.[A-Za-z0-9_-]+',
        relevance: 0
      },
      {
        className: 'selector-attr', begin: '\\[', end: '\\]',
        illegal: '$'
      },
      {
        className: 'selector-tag', // begin: IDENT_RE, end: '[,|\\s]'
        begin: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
        relevance: 0
      },
      {
        begin: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
      },
      {
        begin: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
      },
      VARIABLE,
      {
        className: 'attribute',
        begin: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
        illegal: '[^\\s]'
      },
      {
        begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
      },
      {
        begin: ':', end: ';',
        contains: [
          VARIABLE,
          HEXCOLOR,
          hljs.CSS_NUMBER_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          {
            className: 'meta', begin: '!important'
          }
        ]
      },
      {
        begin: '@', end: '[{;]',
        keywords: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
        contains: [
          VARIABLE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          HEXCOLOR,
          hljs.CSS_NUMBER_MODE,
          {
            begin: '\\s[A-Za-z0-9_.-]+',
            relevance: 0
          }
        ]
      }
    ]
  };
});

hljs.registerLanguage('smali', function(hljs) {
  var smali_instr_low_prio = ['add', 'and', 'cmp', 'cmpg', 'cmpl', 'const', 'div', 'double', 'float', 'goto', 'if', 'int', 'long', 'move', 'mul', 'neg', 'new', 'nop', 'not', 'or', 'rem', 'return', 'shl', 'shr', 'sput', 'sub', 'throw', 'ushr', 'xor'];
  var smali_instr_high_prio = ['aget', 'aput', 'array', 'check', 'execute', 'fill', 'filled', 'goto/16', 'goto/32', 'iget', 'instance', 'invoke', 'iput', 'monitor', 'packed', 'sget', 'sparse'];
  var smali_keywords = ['transient', 'constructor', 'abstract', 'final', 'synthetic', 'public', 'private', 'protected', 'static', 'bridge', 'system'];
  return {
    aliases: ['smali'],
    contains: [
      {
        className: 'string',
        begin: '"', end: '"',
        relevance: 0
      },
      hljs.COMMENT(
        '#',
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'keyword',
        variants: [
          {begin: '\\s*\\.end\\s[a-zA-Z0-9]*'},
          {begin: '^[ ]*\\.[a-zA-Z]*', relevance: 0},
          {begin: '\\s:[a-zA-Z_0-9]*', relevance: 0},
          {begin: '\\s(' + smali_keywords.join('|') + ')'}
        ]
      },
      {
        className: 'built_in',
        variants : [
          {
            begin: '\\s('+smali_instr_low_prio.join('|')+')\\s'
          },
          {
            begin: '\\s('+smali_instr_low_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)+\\s',
            relevance: 10
          },
          {
            begin: '\\s('+smali_instr_high_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)*\\s',
            relevance: 10
          },
        ]
      },
      {
        className: 'class',
        begin: 'L[^\(;:\n]*;',
        relevance: 0
      },
      {
        begin: '[vp][0-9]+',
      }
    ]
  };
});

hljs.registerLanguage('smalltalk', function(hljs) {
  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
  var CHAR = {
    className: 'string',
    begin: '\\$.{1}'
  };
  var SYMBOL = {
    className: 'symbol',
    begin: '#' + hljs.UNDERSCORE_IDENT_RE
  };
  return {
    aliases: ['st'],
    keywords: 'self super nil true false thisContext', // only 6
    contains: [
      hljs.COMMENT('"', '"'),
      hljs.APOS_STRING_MODE,
      {
        className: 'type',
        begin: '\\b[A-Z][A-Za-z0-9_]*',
        relevance: 0
      },
      {
        begin: VAR_IDENT_RE + ':',
        relevance: 0
      },
      hljs.C_NUMBER_MODE,
      SYMBOL,
      CHAR,
      {
        // This looks more complicated than needed to avoid combinatorial
        // explosion under V8. It effectively means `| var1 var2 ... |` with
        // whitespace adjacent to `|` being optional.
        begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
        returnBegin: true, end: /\|/,
        illegal: /\S/,
        contains: [{begin: '(\\|[ ]*)?' + VAR_IDENT_RE}]
      },
      {
        begin: '\\#\\(', end: '\\)',
        contains: [
          hljs.APOS_STRING_MODE,
          CHAR,
          hljs.C_NUMBER_MODE,
          SYMBOL
        ]
      }
    ]
  };
});

hljs.registerLanguage('sml', function(hljs) {
  return {
    aliases: ['ml'],
    keywords: {
      keyword:
        /* according to Definition of Standard ML 97  */
        'abstype and andalso as case datatype do else end eqtype ' +
        'exception fn fun functor handle if in include infix infixr ' +
        'let local nonfix of op open orelse raise rec sharing sig ' +
        'signature struct structure then type val with withtype where while',
      built_in:
        /* built-in types according to basis library */
        'array bool char exn int list option order real ref string substring vector unit word',
      literal:
        'true false NONE SOME LESS EQUAL GREATER nil'
    },
    illegal: /\/\/|>>/,
    lexemes: '[a-z_]\\w*!?',
    contains: [
      {
        className: 'literal',
        begin: /\[(\|\|)?\]|\(\)/,
        relevance: 0
      },
      hljs.COMMENT(
        '\\(\\*',
        '\\*\\)',
        {
          contains: ['self']
        }
      ),
      { /* type variable */
        className: 'symbol',
        begin: '\'[A-Za-z_](?!\')[\\w\']*'
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      { /* polymorphic variant */
        className: 'type',
        begin: '`[A-Z][\\w\']*'
      },
      { /* module or constructor */
        className: 'type',
        begin: '\\b[A-Z][\\w\']*',
        relevance: 0
      },
      { /* don't color identifiers, but safely catch all identifiers with '*/
        begin: '[a-z_]\\w*\'[\\w\']*'
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'number',
        begin:
          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
          '0[oO][0-7_]+[Lln]?|' +
          '0[bB][01_]+[Lln]?|' +
          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
        relevance: 0
      },
      {
        begin: /[-=]>/ // relevance booster
      }
    ]
  };
});

hljs.registerLanguage('sqf', function(hljs) {
  var CPP = hljs.getLanguage('cpp').exports;

  // In SQF, a variable start with _
  var VARIABLE = {
    className: 'variable',
    begin: /\b_+[a-zA-Z_]\w*/
  };

  // In SQF, a function should fit myTag_fnc_myFunction pattern
  // https://community.bistudio.com/wiki/Functions_Library_(Arma_3)#Adding_a_Function
  var FUNCTION = {
    className: 'title',
    begin: /[a-zA-Z][a-zA-Z0-9]+_fnc_\w*/
  };

  // In SQF strings, quotes matching the start are escaped by adding a consecutive.
  // Example of single escaped quotes: " "" " and  ' '' '.
  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '"',
        end: '"',
        contains: [{begin: '""', relevance: 0}]
      },
      {
        begin: '\'',
        end: '\'',
        contains: [{begin: '\'\'', relevance: 0}]
      }
    ]
  };

  return {
    aliases: ['sqf'],
    case_insensitive: true,
    keywords: {
      keyword:
        'case catch default do else exit exitWith for forEach from if ' +
        'switch then throw to try waitUntil while with',
      built_in:
        'abs accTime acos action actionIDs actionKeys actionKeysImages actionKeysNames ' +
        'actionKeysNamesArray actionName actionParams activateAddons activatedAddons activateKey ' +
        'add3DENConnection add3DENEventHandler add3DENLayer addAction addBackpack addBackpackCargo ' +
        'addBackpackCargoGlobal addBackpackGlobal addCamShake addCuratorAddons addCuratorCameraArea ' +
        'addCuratorEditableObjects addCuratorEditingArea addCuratorPoints addEditorObject addEventHandler ' +
        'addGoggles addGroupIcon addHandgunItem addHeadgear addItem addItemCargo addItemCargoGlobal ' +
        'addItemPool addItemToBackpack addItemToUniform addItemToVest addLiveStats addMagazine ' +
        'addMagazineAmmoCargo addMagazineCargo addMagazineCargoGlobal addMagazineGlobal addMagazinePool ' +
        'addMagazines addMagazineTurret addMenu addMenuItem addMissionEventHandler addMPEventHandler ' +
        'addMusicEventHandler addOwnedMine addPlayerScores addPrimaryWeaponItem ' +
        'addPublicVariableEventHandler addRating addResources addScore addScoreSide addSecondaryWeaponItem ' +
        'addSwitchableUnit addTeamMember addToRemainsCollector addUniform addVehicle addVest addWaypoint ' +
        'addWeapon addWeaponCargo addWeaponCargoGlobal addWeaponGlobal addWeaponItem addWeaponPool ' +
        'addWeaponTurret agent agents AGLToASL aimedAtTarget aimPos airDensityRTD airportSide ' +
        'AISFinishHeal alive all3DENEntities allControls allCurators allCutLayers allDead allDeadMen ' +
        'allDisplays allGroups allMapMarkers allMines allMissionObjects allow3DMode allowCrewInImmobile ' +
        'allowCuratorLogicIgnoreAreas allowDamage allowDammage allowFileOperations allowFleeing allowGetIn ' +
        'allowSprint allPlayers allSites allTurrets allUnits allUnitsUAV allVariables ammo and animate ' +
        'animateDoor animateSource animationNames animationPhase animationSourcePhase animationState ' +
        'append apply armoryPoints arrayIntersect asin ASLToAGL ASLToATL assert assignAsCargo ' +
        'assignAsCargoIndex assignAsCommander assignAsDriver assignAsGunner assignAsTurret assignCurator ' +
        'assignedCargo assignedCommander assignedDriver assignedGunner assignedItems assignedTarget ' +
        'assignedTeam assignedVehicle assignedVehicleRole assignItem assignTeam assignToAirport atan atan2 ' +
        'atg ATLToASL attachedObject attachedObjects attachedTo attachObject attachTo attackEnabled ' +
        'backpack backpackCargo backpackContainer backpackItems backpackMagazines backpackSpaceFor ' +
        'behaviour benchmark binocular blufor boundingBox boundingBoxReal boundingCenter breakOut breakTo ' +
        'briefingName buildingExit buildingPos buttonAction buttonSetAction cadetMode call callExtension ' +
        'camCommand camCommit camCommitPrepared camCommitted camConstuctionSetParams camCreate camDestroy ' +
        'cameraEffect cameraEffectEnableHUD cameraInterest cameraOn cameraView campaignConfigFile ' +
        'camPreload camPreloaded camPrepareBank camPrepareDir camPrepareDive camPrepareFocus camPrepareFov ' +
        'camPrepareFovRange camPreparePos camPrepareRelPos camPrepareTarget camSetBank camSetDir ' +
        'camSetDive camSetFocus camSetFov camSetFovRange camSetPos camSetRelPos camSetTarget camTarget ' +
        'camUseNVG canAdd canAddItemToBackpack canAddItemToUniform canAddItemToVest ' +
        'cancelSimpleTaskDestination canFire canMove canSlingLoad canStand canSuspend canUnloadInCombat ' +
        'canVehicleCargo captive captiveNum cbChecked cbSetChecked ceil channelEnabled cheatsEnabled ' +
        'checkAIFeature checkVisibility civilian className clearAllItemsFromBackpack clearBackpackCargo ' +
        'clearBackpackCargoGlobal clearGroupIcons clearItemCargo clearItemCargoGlobal clearItemPool ' +
        'clearMagazineCargo clearMagazineCargoGlobal clearMagazinePool clearOverlay clearRadio ' +
        'clearWeaponCargo clearWeaponCargoGlobal clearWeaponPool clientOwner closeDialog closeDisplay ' +
        'closeOverlay collapseObjectTree collect3DENHistory combatMode commandArtilleryFire commandChat ' +
        'commander commandFire commandFollow commandFSM commandGetOut commandingMenu commandMove ' +
        'commandRadio commandStop commandSuppressiveFire commandTarget commandWatch comment commitOverlay ' +
        'compile compileFinal completedFSM composeText configClasses configFile configHierarchy configName ' +
        'configNull configProperties configSourceAddonList configSourceMod configSourceModList ' +
        'connectTerminalToUAV controlNull controlsGroupCtrl copyFromClipboard copyToClipboard ' +
        'copyWaypoints cos count countEnemy countFriendly countSide countType countUnknown ' +
        'create3DENComposition create3DENEntity createAgent createCenter createDialog createDiaryLink ' +
        'createDiaryRecord createDiarySubject createDisplay createGearDialog createGroup ' +
        'createGuardedPoint createLocation createMarker createMarkerLocal createMenu createMine ' +
        'createMissionDisplay createMPCampaignDisplay createSimpleObject createSimpleTask createSite ' +
        'createSoundSource createTask createTeam createTrigger createUnit createVehicle createVehicleCrew ' +
        'createVehicleLocal crew ctrlActivate ctrlAddEventHandler ctrlAngle ctrlAutoScrollDelay ' +
        'ctrlAutoScrollRewind ctrlAutoScrollSpeed ctrlChecked ctrlClassName ctrlCommit ctrlCommitted ' +
        'ctrlCreate ctrlDelete ctrlEnable ctrlEnabled ctrlFade ctrlHTMLLoaded ctrlIDC ctrlIDD ' +
        'ctrlMapAnimAdd ctrlMapAnimClear ctrlMapAnimCommit ctrlMapAnimDone ctrlMapCursor ctrlMapMouseOver ' +
        'ctrlMapScale ctrlMapScreenToWorld ctrlMapWorldToScreen ctrlModel ctrlModelDirAndUp ctrlModelScale ' +
        'ctrlParent ctrlParentControlsGroup ctrlPosition ctrlRemoveAllEventHandlers ctrlRemoveEventHandler ' +
        'ctrlScale ctrlSetActiveColor ctrlSetAngle ctrlSetAutoScrollDelay ctrlSetAutoScrollRewind ' +
        'ctrlSetAutoScrollSpeed ctrlSetBackgroundColor ctrlSetChecked ctrlSetEventHandler ctrlSetFade ' +
        'ctrlSetFocus ctrlSetFont ctrlSetFontH1 ctrlSetFontH1B ctrlSetFontH2 ctrlSetFontH2B ctrlSetFontH3 ' +
        'ctrlSetFontH3B ctrlSetFontH4 ctrlSetFontH4B ctrlSetFontH5 ctrlSetFontH5B ctrlSetFontH6 ' +
        'ctrlSetFontH6B ctrlSetFontHeight ctrlSetFontHeightH1 ctrlSetFontHeightH2 ctrlSetFontHeightH3 ' +
        'ctrlSetFontHeightH4 ctrlSetFontHeightH5 ctrlSetFontHeightH6 ctrlSetFontHeightSecondary ' +
        'ctrlSetFontP ctrlSetFontPB ctrlSetFontSecondary ctrlSetForegroundColor ctrlSetModel ' +
        'ctrlSetModelDirAndUp ctrlSetModelScale ctrlSetPosition ctrlSetScale ctrlSetStructuredText ' +
        'ctrlSetText ctrlSetTextColor ctrlSetTooltip ctrlSetTooltipColorBox ctrlSetTooltipColorShade ' +
        'ctrlSetTooltipColorText ctrlShow ctrlShown ctrlText ctrlTextHeight ctrlType ctrlVisible ' +
        'curatorAddons curatorCamera curatorCameraArea curatorCameraAreaCeiling curatorCoef ' +
        'curatorEditableObjects curatorEditingArea curatorEditingAreaType curatorMouseOver curatorPoints ' +
        'curatorRegisteredObjects curatorSelected curatorWaypointCost current3DENOperation currentChannel ' +
        'currentCommand currentMagazine currentMagazineDetail currentMagazineDetailTurret ' +
        'currentMagazineTurret currentMuzzle currentNamespace currentTask currentTasks currentThrowable ' +
        'currentVisionMode currentWaypoint currentWeapon currentWeaponMode currentWeaponTurret ' +
        'currentZeroing cursorObject cursorTarget customChat customRadio cutFadeOut cutObj cutRsc cutText ' +
        'damage date dateToNumber daytime deActivateKey debriefingText debugFSM debugLog deg ' +
        'delete3DENEntities deleteAt deleteCenter deleteCollection deleteEditorObject deleteGroup ' +
        'deleteIdentity deleteLocation deleteMarker deleteMarkerLocal deleteRange deleteResources ' +
        'deleteSite deleteStatus deleteTeam deleteVehicle deleteVehicleCrew deleteWaypoint detach ' +
        'detectedMines diag_activeMissionFSMs diag_activeScripts diag_activeSQFScripts ' +
        'diag_activeSQSScripts diag_captureFrame diag_captureSlowFrame diag_codePerformance diag_drawMode ' +
        'diag_enable diag_enabled diag_fps diag_fpsMin diag_frameNo diag_list diag_log diag_logSlowFrame ' +
        'diag_mergeConfigFile diag_recordTurretLimits diag_tickTime diag_toggle dialog diarySubjectExists ' +
        'didJIP didJIPOwner difficulty difficultyEnabled difficultyEnabledRTD difficultyOption direction ' +
        'directSay disableAI disableCollisionWith disableConversation disableDebriefingStats ' +
        'disableNVGEquipment disableRemoteSensors disableSerialization disableTIEquipment ' +
        'disableUAVConnectability disableUserInput displayAddEventHandler displayCtrl displayNull ' +
        'displayParent displayRemoveAllEventHandlers displayRemoveEventHandler displaySetEventHandler ' +
        'dissolveTeam distance distance2D distanceSqr distributionRegion do3DENAction doArtilleryFire ' +
        'doFire doFollow doFSM doGetOut doMove doorPhase doStop doSuppressiveFire doTarget doWatch ' +
        'drawArrow drawEllipse drawIcon drawIcon3D drawLine drawLine3D drawLink drawLocation drawPolygon ' +
        'drawRectangle driver drop east echo edit3DENMissionAttributes editObject editorSetEventHandler ' +
        'effectiveCommander emptyPositions enableAI enableAIFeature enableAimPrecision enableAttack ' +
        'enableAudioFeature enableCamShake enableCaustics enableChannel enableCollisionWith enableCopilot ' +
        'enableDebriefingStats enableDiagLegend enableEndDialog enableEngineArtillery enableEnvironment ' +
        'enableFatigue enableGunLights enableIRLasers enableMimics enablePersonTurret enableRadio ' +
        'enableReload enableRopeAttach enableSatNormalOnDetail enableSaving enableSentences ' +
        'enableSimulation enableSimulationGlobal enableStamina enableTeamSwitch enableUAVConnectability ' +
        'enableUAVWaypoints enableVehicleCargo endLoadingScreen endMission engineOn enginesIsOnRTD ' +
        'enginesRpmRTD enginesTorqueRTD entities estimatedEndServerTime estimatedTimeLeft ' +
        'evalObjectArgument everyBackpack everyContainer exec execEditorScript execFSM execVM exp ' +
        'expectedDestination exportJIPMessages eyeDirection eyePos face faction fadeMusic fadeRadio ' +
        'fadeSound fadeSpeech failMission fillWeaponsFromPool find findCover findDisplay findEditorObject ' +
        'findEmptyPosition findEmptyPositionReady findNearestEnemy finishMissionInit finite fire ' +
        'fireAtTarget firstBackpack flag flagOwner flagSide flagTexture fleeing floor flyInHeight ' +
        'flyInHeightASL fog fogForecast fogParams forceAddUniform forcedMap forceEnd forceMap forceRespawn ' +
        'forceSpeed forceWalk forceWeaponFire forceWeatherChange forEachMember forEachMemberAgent ' +
        'forEachMemberTeam format formation formationDirection formationLeader formationMembers ' +
        'formationPosition formationTask formatText formLeader freeLook fromEditor fuel fullCrew ' +
        'gearIDCAmmoCount gearSlotAmmoCount gearSlotData get3DENActionState get3DENAttribute get3DENCamera ' +
        'get3DENConnections get3DENEntity get3DENEntityID get3DENGrid get3DENIconsVisible ' +
        'get3DENLayerEntities get3DENLinesVisible get3DENMissionAttribute get3DENMouseOver get3DENSelected ' +
        'getAimingCoef getAllHitPointsDamage getAllOwnedMines getAmmoCargo getAnimAimPrecision ' +
        'getAnimSpeedCoef getArray getArtilleryAmmo getArtilleryComputerSettings getArtilleryETA ' +
        'getAssignedCuratorLogic getAssignedCuratorUnit getBackpackCargo getBleedingRemaining ' +
        'getBurningValue getCameraViewDirection getCargoIndex getCenterOfMass getClientState ' +
        'getClientStateNumber getConnectedUAV getCustomAimingCoef getDammage getDescription getDir ' +
        'getDirVisual getDLCs getEditorCamera getEditorMode getEditorObjectScope getElevationOffset ' +
        'getFatigue getFriend getFSMVariable getFuelCargo getGroupIcon getGroupIconParams getGroupIcons ' +
        'getHideFrom getHit getHitIndex getHitPointDamage getItemCargo getMagazineCargo getMarkerColor ' +
        'getMarkerPos getMarkerSize getMarkerType getMass getMissionConfig getMissionConfigValue ' +
        'getMissionDLCs getMissionLayerEntities getModelInfo getMousePosition getNumber getObjectArgument ' +
        'getObjectChildren getObjectDLC getObjectMaterials getObjectProxy getObjectTextures getObjectType ' +
        'getObjectViewDistance getOxygenRemaining getPersonUsedDLCs getPilotCameraDirection ' +
        'getPilotCameraPosition getPilotCameraRotation getPilotCameraTarget getPlayerChannel ' +
        'getPlayerScores getPlayerUID getPos getPosASL getPosASLVisual getPosASLW getPosATL ' +
        'getPosATLVisual getPosVisual getPosWorld getRelDir getRelPos getRemoteSensorsDisabled ' +
        'getRepairCargo getResolution getShadowDistance getShotParents getSlingLoad getSpeed getStamina ' +
        'getStatValue getSuppression getTerrainHeightASL getText getUnitLoadout getUnitTrait getVariable ' +
        'getVehicleCargo getWeaponCargo getWeaponSway getWPPos glanceAt globalChat globalRadio goggles ' +
        'goto group groupChat groupFromNetId groupIconSelectable groupIconsVisible groupId groupOwner ' +
        'groupRadio groupSelectedUnits groupSelectUnit grpNull gunner gusts halt handgunItems ' +
        'handgunMagazine handgunWeapon handsHit hasInterface hasPilotCamera hasWeapon hcAllGroups ' +
        'hcGroupParams hcLeader hcRemoveAllGroups hcRemoveGroup hcSelected hcSelectGroup hcSetGroup ' +
        'hcShowBar hcShownBar headgear hideBody hideObject hideObjectGlobal hideSelection hint hintC ' +
        'hintCadet hintSilent hmd hostMission htmlLoad HUDMovementLevels humidity image importAllGroups ' +
        'importance in inArea inAreaArray incapacitatedState independent inflame inflamed ' +
        'inGameUISetEventHandler inheritsFrom initAmbientLife inPolygon inputAction inRangeOfArtillery ' +
        'insertEditorObject intersect is3DEN is3DENMultiplayer isAbleToBreathe isAgent isArray ' +
        'isAutoHoverOn isAutonomous isAutotest isBleeding isBurning isClass isCollisionLightOn ' +
        'isCopilotEnabled isDedicated isDLCAvailable isEngineOn isEqualTo isEqualType isEqualTypeAll ' +
        'isEqualTypeAny isEqualTypeArray isEqualTypeParams isFilePatchingEnabled isFlashlightOn ' +
        'isFlatEmpty isForcedWalk isFormationLeader isHidden isInRemainsCollector ' +
        'isInstructorFigureEnabled isIRLaserOn isKeyActive isKindOf isLightOn isLocalized isManualFire ' +
        'isMarkedForCollection isMultiplayer isMultiplayerSolo isNil isNull isNumber isObjectHidden ' +
        'isObjectRTD isOnRoad isPipEnabled isPlayer isRealTime isRemoteExecuted isRemoteExecutedJIP ' +
        'isServer isShowing3DIcons isSprintAllowed isStaminaEnabled isSteamMission ' +
        'isStreamFriendlyUIEnabled isText isTouchingGround isTurnedOut isTutHintsEnabled isUAVConnectable ' +
        'isUAVConnected isUniformAllowed isVehicleCargo isWalking isWeaponDeployed isWeaponRested ' +
        'itemCargo items itemsWithMagazines join joinAs joinAsSilent joinSilent joinString kbAddDatabase ' +
        'kbAddDatabaseTargets kbAddTopic kbHasTopic kbReact kbRemoveTopic kbTell kbWasSaid keyImage ' +
        'keyName knowsAbout land landAt landResult language laserTarget lbAdd lbClear lbColor lbCurSel ' +
        'lbData lbDelete lbIsSelected lbPicture lbSelection lbSetColor lbSetCurSel lbSetData lbSetPicture ' +
        'lbSetPictureColor lbSetPictureColorDisabled lbSetPictureColorSelected lbSetSelectColor ' +
        'lbSetSelectColorRight lbSetSelected lbSetTooltip lbSetValue lbSize lbSort lbSortByValue lbText ' +
        'lbValue leader leaderboardDeInit leaderboardGetRows leaderboardInit leaveVehicle libraryCredits ' +
        'libraryDisclaimers lifeState lightAttachObject lightDetachObject lightIsOn lightnings limitSpeed ' +
        'linearConversion lineBreak lineIntersects lineIntersectsObjs lineIntersectsSurfaces ' +
        'lineIntersectsWith linkItem list listObjects ln lnbAddArray lnbAddColumn lnbAddRow lnbClear ' +
        'lnbColor lnbCurSelRow lnbData lnbDeleteColumn lnbDeleteRow lnbGetColumnsPosition lnbPicture ' +
        'lnbSetColor lnbSetColumnsPos lnbSetCurSelRow lnbSetData lnbSetPicture lnbSetText lnbSetValue ' +
        'lnbSize lnbText lnbValue load loadAbs loadBackpack loadFile loadGame loadIdentity loadMagazine ' +
        'loadOverlay loadStatus loadUniform loadVest local localize locationNull locationPosition lock ' +
        'lockCameraTo lockCargo lockDriver locked lockedCargo lockedDriver lockedTurret lockIdentity ' +
        'lockTurret lockWP log logEntities logNetwork logNetworkTerminate lookAt lookAtPos magazineCargo ' +
        'magazines magazinesAllTurrets magazinesAmmo magazinesAmmoCargo magazinesAmmoFull magazinesDetail ' +
        'magazinesDetailBackpack magazinesDetailUniform magazinesDetailVest magazinesTurret ' +
        'magazineTurretAmmo mapAnimAdd mapAnimClear mapAnimCommit mapAnimDone mapCenterOnCamera ' +
        'mapGridPosition markAsFinishedOnSteam markerAlpha markerBrush markerColor markerDir markerPos ' +
        'markerShape markerSize markerText markerType max members menuAction menuAdd menuChecked menuClear ' +
        'menuCollapse menuData menuDelete menuEnable menuEnabled menuExpand menuHover menuPicture ' +
        'menuSetAction menuSetCheck menuSetData menuSetPicture menuSetValue menuShortcut menuShortcutText ' +
        'menuSize menuSort menuText menuURL menuValue min mineActive mineDetectedBy missionConfigFile ' +
        'missionDifficulty missionName missionNamespace missionStart missionVersion mod modelToWorld ' +
        'modelToWorldVisual modParams moonIntensity moonPhase morale move move3DENCamera moveInAny ' +
        'moveInCargo moveInCommander moveInDriver moveInGunner moveInTurret moveObjectToEnd moveOut ' +
        'moveTime moveTo moveToCompleted moveToFailed musicVolume name nameSound nearEntities ' +
        'nearestBuilding nearestLocation nearestLocations nearestLocationWithDubbing nearestObject ' +
        'nearestObjects nearestTerrainObjects nearObjects nearObjectsReady nearRoads nearSupplies ' +
        'nearTargets needReload netId netObjNull newOverlay nextMenuItemIndex nextWeatherChange nMenuItems ' +
        'not numberToDate objectCurators objectFromNetId objectParent objNull objStatus onBriefingGroup ' +
        'onBriefingNotes onBriefingPlan onBriefingTeamSwitch onCommandModeChanged onDoubleClick ' +
        'onEachFrame onGroupIconClick onGroupIconOverEnter onGroupIconOverLeave onHCGroupSelectionChanged ' +
        'onMapSingleClick onPlayerConnected onPlayerDisconnected onPreloadFinished onPreloadStarted ' +
        'onShowNewObject onTeamSwitch openCuratorInterface openDLCPage openMap openYoutubeVideo opfor or ' +
        'orderGetIn overcast overcastForecast owner param params parseNumber parseText parsingNamespace ' +
        'particlesQuality pi pickWeaponPool pitch pixelGrid pixelGridBase pixelGridNoUIScale pixelH pixelW ' +
        'playableSlotsNumber playableUnits playAction playActionNow player playerRespawnTime playerSide ' +
        'playersNumber playGesture playMission playMove playMoveNow playMusic playScriptedMission ' +
        'playSound playSound3D position positionCameraToWorld posScreenToWorld posWorldToScreen ' +
        'ppEffectAdjust ppEffectCommit ppEffectCommitted ppEffectCreate ppEffectDestroy ppEffectEnable ' +
        'ppEffectEnabled ppEffectForceInNVG precision preloadCamera preloadObject preloadSound ' +
        'preloadTitleObj preloadTitleRsc preprocessFile preprocessFileLineNumbers primaryWeapon ' +
        'primaryWeaponItems primaryWeaponMagazine priority private processDiaryLink productVersion ' +
        'profileName profileNamespace profileNameSteam progressLoadingScreen progressPosition ' +
        'progressSetPosition publicVariable publicVariableClient publicVariableServer pushBack ' +
        'pushBackUnique putWeaponPool queryItemsPool queryMagazinePool queryWeaponPool rad radioChannelAdd ' +
        'radioChannelCreate radioChannelRemove radioChannelSetCallSign radioChannelSetLabel radioVolume ' +
        'rain rainbow random rank rankId rating rectangular registeredTasks registerTask reload ' +
        'reloadEnabled remoteControl remoteExec remoteExecCall remove3DENConnection remove3DENEventHandler ' +
        'remove3DENLayer removeAction removeAll3DENEventHandlers removeAllActions removeAllAssignedItems ' +
        'removeAllContainers removeAllCuratorAddons removeAllCuratorCameraAreas ' +
        'removeAllCuratorEditingAreas removeAllEventHandlers removeAllHandgunItems removeAllItems ' +
        'removeAllItemsWithMagazines removeAllMissionEventHandlers removeAllMPEventHandlers ' +
        'removeAllMusicEventHandlers removeAllOwnedMines removeAllPrimaryWeaponItems removeAllWeapons ' +
        'removeBackpack removeBackpackGlobal removeCuratorAddons removeCuratorCameraArea ' +
        'removeCuratorEditableObjects removeCuratorEditingArea removeDrawIcon removeDrawLinks ' +
        'removeEventHandler removeFromRemainsCollector removeGoggles removeGroupIcon removeHandgunItem ' +
        'removeHeadgear removeItem removeItemFromBackpack removeItemFromUniform removeItemFromVest ' +
        'removeItems removeMagazine removeMagazineGlobal removeMagazines removeMagazinesTurret ' +
        'removeMagazineTurret removeMenuItem removeMissionEventHandler removeMPEventHandler ' +
        'removeMusicEventHandler removeOwnedMine removePrimaryWeaponItem removeSecondaryWeaponItem ' +
        'removeSimpleTask removeSwitchableUnit removeTeamMember removeUniform removeVest removeWeapon ' +
        'removeWeaponGlobal removeWeaponTurret requiredVersion resetCamShake resetSubgroupDirection ' +
        'resistance resize resources respawnVehicle restartEditorCamera reveal revealMine reverse ' +
        'reversedMouseY roadAt roadsConnectedTo roleDescription ropeAttachedObjects ropeAttachedTo ' +
        'ropeAttachEnabled ropeAttachTo ropeCreate ropeCut ropeDestroy ropeDetach ropeEndPosition ' +
        'ropeLength ropes ropeUnwind ropeUnwound rotorsForcesRTD rotorsRpmRTD round runInitScript ' +
        'safeZoneH safeZoneW safeZoneWAbs safeZoneX safeZoneXAbs safeZoneY save3DENInventory saveGame ' +
        'saveIdentity saveJoysticks saveOverlay saveProfileNamespace saveStatus saveVar savingEnabled say ' +
        'say2D say3D scopeName score scoreSide screenshot screenToWorld scriptDone scriptName scriptNull ' +
        'scudState secondaryWeapon secondaryWeaponItems secondaryWeaponMagazine select selectBestPlaces ' +
        'selectDiarySubject selectedEditorObjects selectEditorObject selectionNames selectionPosition ' +
        'selectLeader selectMax selectMin selectNoPlayer selectPlayer selectRandom selectWeapon ' +
        'selectWeaponTurret sendAUMessage sendSimpleCommand sendTask sendTaskResult sendUDPMessage ' +
        'serverCommand serverCommandAvailable serverCommandExecutable serverName serverTime set ' +
        'set3DENAttribute set3DENAttributes set3DENGrid set3DENIconsVisible set3DENLayer ' +
        'set3DENLinesVisible set3DENMissionAttributes set3DENModelsVisible set3DENObjectType ' +
        'set3DENSelected setAccTime setAirportSide setAmmo setAmmoCargo setAnimSpeedCoef setAperture ' +
        'setApertureNew setArmoryPoints setAttributes setAutonomous setBehaviour setBleedingRemaining ' +
        'setCameraInterest setCamShakeDefParams setCamShakeParams setCamUseTi setCaptive setCenterOfMass ' +
        'setCollisionLight setCombatMode setCompassOscillation setCuratorCameraAreaCeiling setCuratorCoef ' +
        'setCuratorEditingAreaType setCuratorWaypointCost setCurrentChannel setCurrentTask ' +
        'setCurrentWaypoint setCustomAimCoef setDamage setDammage setDate setDebriefingText ' +
        'setDefaultCamera setDestination setDetailMapBlendPars setDir setDirection setDrawIcon ' +
        'setDropInterval setEditorMode setEditorObjectScope setEffectCondition setFace setFaceAnimation ' +
        'setFatigue setFlagOwner setFlagSide setFlagTexture setFog setFormation setFormationTask ' +
        'setFormDir setFriend setFromEditor setFSMVariable setFuel setFuelCargo setGroupIcon ' +
        'setGroupIconParams setGroupIconsSelectable setGroupIconsVisible setGroupId setGroupIdGlobal ' +
        'setGroupOwner setGusts setHideBehind setHit setHitIndex setHitPointDamage setHorizonParallaxCoef ' +
        'setHUDMovementLevels setIdentity setImportance setLeader setLightAmbient setLightAttenuation ' +
        'setLightBrightness setLightColor setLightDayLight setLightFlareMaxDistance setLightFlareSize ' +
        'setLightIntensity setLightnings setLightUseFlare setLocalWindParams setMagazineTurretAmmo ' +
        'setMarkerAlpha setMarkerAlphaLocal setMarkerBrush setMarkerBrushLocal setMarkerColor ' +
        'setMarkerColorLocal setMarkerDir setMarkerDirLocal setMarkerPos setMarkerPosLocal setMarkerShape ' +
        'setMarkerShapeLocal setMarkerSize setMarkerSizeLocal setMarkerText setMarkerTextLocal ' +
        'setMarkerType setMarkerTypeLocal setMass setMimic setMousePosition setMusicEffect ' +
        'setMusicEventHandler setName setNameSound setObjectArguments setObjectMaterial ' +
        'setObjectMaterialGlobal setObjectProxy setObjectTexture setObjectTextureGlobal ' +
        'setObjectViewDistance setOvercast setOwner setOxygenRemaining setParticleCircle setParticleClass ' +
        'setParticleFire setParticleParams setParticleRandom setPilotCameraDirection ' +
        'setPilotCameraRotation setPilotCameraTarget setPilotLight setPiPEffect setPitch setPlayable ' +
        'setPlayerRespawnTime setPos setPosASL setPosASL2 setPosASLW setPosATL setPosition setPosWorld ' +
        'setRadioMsg setRain setRainbow setRandomLip setRank setRectangular setRepairCargo ' +
        'setShadowDistance setShotParents setSide setSimpleTaskAlwaysVisible setSimpleTaskCustomData ' +
        'setSimpleTaskDescription setSimpleTaskDestination setSimpleTaskTarget setSimpleTaskType ' +
        'setSimulWeatherLayers setSize setSkill setSlingLoad setSoundEffect setSpeaker setSpeech ' +
        'setSpeedMode setStamina setStaminaScheme setStatValue setSuppression setSystemOfUnits ' +
        'setTargetAge setTaskResult setTaskState setTerrainGrid setText setTimeMultiplier setTitleEffect ' +
        'setTriggerActivation setTriggerArea setTriggerStatements setTriggerText setTriggerTimeout ' +
        'setTriggerType setType setUnconscious setUnitAbility setUnitLoadout setUnitPos setUnitPosWeak ' +
        'setUnitRank setUnitRecoilCoefficient setUnitTrait setUnloadInCombat setUserActionText setVariable ' +
        'setVectorDir setVectorDirAndUp setVectorUp setVehicleAmmo setVehicleAmmoDef setVehicleArmor ' +
        'setVehicleCargo setVehicleId setVehicleLock setVehiclePosition setVehicleTiPars setVehicleVarName ' +
        'setVelocity setVelocityTransformation setViewDistance setVisibleIfTreeCollapsed setWaves ' +
        'setWaypointBehaviour setWaypointCombatMode setWaypointCompletionRadius setWaypointDescription ' +
        'setWaypointForceBehaviour setWaypointFormation setWaypointHousePosition setWaypointLoiterRadius ' +
        'setWaypointLoiterType setWaypointName setWaypointPosition setWaypointScript setWaypointSpeed ' +
        'setWaypointStatements setWaypointTimeout setWaypointType setWaypointVisible ' +
        'setWeaponReloadingTime setWind setWindDir setWindForce setWindStr setWPPos show3DIcons showChat ' +
        'showCinemaBorder showCommandingMenu showCompass showCuratorCompass showGPS showHUD showLegend ' +
        'showMap shownArtilleryComputer shownChat shownCompass shownCuratorCompass showNewEditorObject ' +
        'shownGPS shownHUD shownMap shownPad shownRadio shownScoretable shownUAVFeed shownWarrant ' +
        'shownWatch showPad showRadio showScoretable showSubtitles showUAVFeed showWarrant showWatch ' +
        'showWaypoint showWaypoints side sideAmbientLife sideChat sideEmpty sideEnemy sideFriendly ' +
        'sideLogic sideRadio sideUnknown simpleTasks simulationEnabled simulCloudDensity ' +
        'simulCloudOcclusion simulInClouds simulWeatherSync sin size sizeOf skill skillFinal skipTime ' +
        'sleep sliderPosition sliderRange sliderSetPosition sliderSetRange sliderSetSpeed sliderSpeed ' +
        'slingLoadAssistantShown soldierMagazines someAmmo sort soundVolume spawn speaker speed speedMode ' +
        'splitString sqrt squadParams stance startLoadingScreen step stop stopEngineRTD stopped str ' +
        'sunOrMoon supportInfo suppressFor surfaceIsWater surfaceNormal surfaceType swimInDepth ' +
        'switchableUnits switchAction switchCamera switchGesture switchLight switchMove ' +
        'synchronizedObjects synchronizedTriggers synchronizedWaypoints synchronizeObjectsAdd ' +
        'synchronizeObjectsRemove synchronizeTrigger synchronizeWaypoint systemChat systemOfUnits tan ' +
        'targetKnowledge targetsAggregate targetsQuery taskAlwaysVisible taskChildren taskCompleted ' +
        'taskCustomData taskDescription taskDestination taskHint taskMarkerOffset taskNull taskParent ' +
        'taskResult taskState taskType teamMember teamMemberNull teamName teams teamSwitch ' +
        'teamSwitchEnabled teamType terminate terrainIntersect terrainIntersectASL text textLog ' +
        'textLogFormat tg time timeMultiplier titleCut titleFadeOut titleObj titleRsc titleText toArray ' +
        'toFixed toLower toString toUpper triggerActivated triggerActivation triggerArea ' +
        'triggerAttachedVehicle triggerAttachObject triggerAttachVehicle triggerStatements triggerText ' +
        'triggerTimeout triggerTimeoutCurrent triggerType turretLocal turretOwner turretUnit tvAdd tvClear ' +
        'tvCollapse tvCount tvCurSel tvData tvDelete tvExpand tvPicture tvSetCurSel tvSetData tvSetPicture ' +
        'tvSetPictureColor tvSetPictureColorDisabled tvSetPictureColorSelected tvSetPictureRight ' +
        'tvSetPictureRightColor tvSetPictureRightColorDisabled tvSetPictureRightColorSelected tvSetText ' +
        'tvSetTooltip tvSetValue tvSort tvSortByValue tvText tvTooltip tvValue type typeName typeOf ' +
        'UAVControl uiNamespace uiSleep unassignCurator unassignItem unassignTeam unassignVehicle ' +
        'underwater uniform uniformContainer uniformItems uniformMagazines unitAddons unitAimPosition ' +
        'unitAimPositionVisual unitBackpack unitIsUAV unitPos unitReady unitRecoilCoefficient units ' +
        'unitsBelowHeight unlinkItem unlockAchievement unregisterTask updateDrawIcon updateMenuItem ' +
        'updateObjectTree useAISteeringComponent useAudioTimeForMoves vectorAdd vectorCos ' +
        'vectorCrossProduct vectorDiff vectorDir vectorDirVisual vectorDistance vectorDistanceSqr ' +
        'vectorDotProduct vectorFromTo vectorMagnitude vectorMagnitudeSqr vectorMultiply vectorNormalized ' +
        'vectorUp vectorUpVisual vehicle vehicleCargoEnabled vehicleChat vehicleRadio vehicles ' +
        'vehicleVarName velocity velocityModelSpace verifySignature vest vestContainer vestItems ' +
        'vestMagazines viewDistance visibleCompass visibleGPS visibleMap visiblePosition ' +
        'visiblePositionASL visibleScoretable visibleWatch waves waypointAttachedObject ' +
        'waypointAttachedVehicle waypointAttachObject waypointAttachVehicle waypointBehaviour ' +
        'waypointCombatMode waypointCompletionRadius waypointDescription waypointForceBehaviour ' +
        'waypointFormation waypointHousePosition waypointLoiterRadius waypointLoiterType waypointName ' +
        'waypointPosition waypoints waypointScript waypointsEnabledUAV waypointShow waypointSpeed ' +
        'waypointStatements waypointTimeout waypointTimeoutCurrent waypointType waypointVisible ' +
        'weaponAccessories weaponAccessoriesCargo weaponCargo weaponDirection weaponInertia weaponLowered ' +
        'weapons weaponsItems weaponsItemsCargo weaponState weaponsTurret weightRTD west WFSideText wind',
      literal:
        'true false nil'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.NUMBER_MODE,
      VARIABLE,
      FUNCTION,
      STRINGS,
      CPP.preprocessor
    ],
    illegal: /#/
  };
});

hljs.registerLanguage('sql', function(hljs) {
  var COMMENT_MODE = hljs.COMMENT('--', '$');
  return {
    case_insensitive: true,
    illegal: /[<>{}*#]/,
    contains: [
      {
        beginKeywords:
          'begin end start commit rollback savepoint lock alter create drop rename call ' +
          'delete do handler insert load replace select truncate update set show pragma grant ' +
          'merge describe use explain help declare prepare execute deallocate release ' +
          'unlock purge reset change stop analyze cache flush optimize repair kill ' +
          'install uninstall checksum restore check backup revoke comment',
        end: /;/, endsWithParent: true,
        lexemes: /[\w\.]+/,
        keywords: {
          keyword:
            'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' +
            'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' +
            'allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply ' +
            'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' +
            'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' +
            'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' +
            'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' +
            'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' +
            'buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel ' +
            'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' +
            'char_length character_length characters characterset charindex charset charsetform charsetid check ' +
            'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' +
            'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' +
            'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' +
            'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' +
            'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' +
            'consider consistent constant constraint constraints constructor container content contents context ' +
            'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' +
            'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' +
            'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' +
            'cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add ' +
            'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' +
            'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' +
            'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' +
            'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' +
            'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' +
            'deterministic diagnostics difference dimension direct_load directory disable disable_all ' +
            'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' +
            'do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable ' +
            'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' +
            'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' +
            'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' +
            'execu execut execute exempt exists exit exp expire explain export export_set extended extent external ' +
            'external_1 external_2 externally extract failed failed_login_attempts failover failure far fast ' +
            'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' +
            'finish first first_value fixed flash_cache flashback floor flush following follows for forall force ' +
            'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' +
            'ftp full function general generated get get_format get_lock getdate getutcdate global global_name ' +
            'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' +
            'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' +
            'hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified ' +
            'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' +
            'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' +
            'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' +
            'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' +
            'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' +
            'keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase ' +
            'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' +
            'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' +
            'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' +
            'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime ' +
            'managed management manual map mapping mask master master_pos_wait match matched materialized max ' +
            'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' +
            'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' +
            'minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month ' +
            'months mount move movement multiset mutex name name_const names nan national native natural nav nchar ' +
            'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' +
            'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' +
            'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' +
            'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' +
            'noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe ' +
            'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' +
            'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' +
            'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' +
            'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' +
            'out outer outfile outline output over overflow overriding package pad parallel parallel_enable ' +
            'parameters parent parse partial partition partitions pascal passing password password_grace_time ' +
            'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' +
            'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' +
            'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' +
            'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' +
            'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' +
            'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' +
            'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' +
            'quotename radians raise rand range rank raw read reads readsize rebuild record records ' +
            'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' +
            'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' +
            'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' +
            'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' +
            'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' +
            'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' +
            'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' +
            'sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select ' +
            'self sequence sequential serializable server servererror session session_user sessions_per_user set ' +
            'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' +
            'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' +
            'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' +
            'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' +
            'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' +
            'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' +
            'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' +
            'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' +
            'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' +
            'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' +
            'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' +
            'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo ' +
            'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' +
            'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' +
            'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' +
            'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' +
            'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' +
            'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot ' +
            'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' +
            'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' +
            'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' +
            'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' +
            'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' +
            'wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped ' +
            'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' +
            'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
          literal:
            'true false null',
          built_in:
            'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number ' +
            'numeric real record serial serial8 smallint text varchar varying void'
        },
        contains: [
          {
            className: 'string',
            begin: '\'', end: '\'',
            contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
          },
          {
            className: 'string',
            begin: '"', end: '"',
            contains: [hljs.BACKSLASH_ESCAPE, {begin: '""'}]
          },
          {
            className: 'string',
            begin: '`', end: '`',
            contains: [hljs.BACKSLASH_ESCAPE]
          },
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          COMMENT_MODE
        ]
      },
      hljs.C_BLOCK_COMMENT_MODE,
      COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('stan', function(hljs) {
  return {
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        begin: hljs.UNDERSCORE_IDENT_RE,
        lexemes: hljs.UNDERSCORE_IDENT_RE,
        keywords: {
          // Stan's keywords
          name:
            'for in while repeat until if then else',
          // Stan's probablity distributions (less beta and gamma, as commonly
          // used for parameter names). So far, _log and _rng variants are not
          // included
          symbol:
            'bernoulli bernoulli_logit binomial binomial_logit '               +
            'beta_binomial hypergeometric categorical categorical_logit '      +
            'ordered_logistic neg_binomial neg_binomial_2 '                    +
            'neg_binomial_2_log poisson poisson_log multinomial normal '       +
            'exp_mod_normal skew_normal student_t cauchy double_exponential '  +
            'logistic gumbel lognormal chi_square inv_chi_square '             +
            'scaled_inv_chi_square exponential inv_gamma weibull frechet '     +
            'rayleigh wiener pareto pareto_type_2 von_mises uniform '          +
            'multi_normal multi_normal_prec multi_normal_cholesky multi_gp '   +
            'multi_gp_cholesky multi_student_t gaussian_dlm_obs dirichlet '    +
            'lkj_corr lkj_corr_cholesky wishart inv_wishart',
          // Stan's data types
          'selector-tag':
            'int real vector simplex unit_vector ordered positive_ordered '    +
            'row_vector matrix cholesky_factor_corr cholesky_factor_cov '      +
            'corr_matrix cov_matrix',
          // Stan's model blocks
          title:
            'functions model data parameters quantities transformed '          +
            'generated',
          literal:
            'true false'
        },
        relevance: 0
      },
      // The below is all taken from the R language definition
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // explicit integer
        className: 'number',
        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
        relevance: 0
      },
      {
        // number with trailing decimal
        className: 'number',
        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
        relevance: 0
      },
      {
        // number
        className: 'number',
        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },
      {
        // number with leading decimal
        className: 'number',
        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      }
    ]
  };
});

hljs.registerLanguage('stata', function(hljs) {
  return {
    aliases: ['do', 'ado'],
    case_insensitive: true,
    keywords: 'if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize meqparse mer merg merge mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5',
        contains: [
      {
        className: 'symbol',
        begin: /`[a-zA-Z0-9_]+'/
      },
      {
        className: 'variable',
        begin: /\$\{?[a-zA-Z0-9_]+\}?/
      },
      {
        className: 'string',
        variants: [
          {begin: '`"[^\r\n]*?"\''},
          {begin: '"[^\r\n"]*"'}
        ]
      },

      {
        className: 'built_in',
        variants: [
          {
            begin: '\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\(|$)'
          }
        ]
      },

      hljs.COMMENT('^[ \t]*\\*.*$', false),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
});

hljs.registerLanguage('step21', function(hljs) {
  var STEP21_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
  var STEP21_KEYWORDS = {
    keyword: 'HEADER ENDSEC DATA'
  };
  var STEP21_START = {
    className: 'meta',
    begin: 'ISO-10303-21;',
    relevance: 10
  };
  var STEP21_CLOSE = {
    className: 'meta',
    begin: 'END-ISO-10303-21;',
    relevance: 10
  };

  return {
    aliases: ['p21', 'step', 'stp'],
    case_insensitive: true, // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
    lexemes: STEP21_IDENT_RE,
    keywords: STEP21_KEYWORDS,
    contains: [
      STEP21_START,
      STEP21_CLOSE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT('/\\*\\*!', '\\*/'),
      hljs.C_NUMBER_MODE,
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'string',
        begin: "'", end: "'"
      },
      {
        className: 'symbol',
        variants: [
          {
            begin: '#', end: '\\d+',
            illegal: '\\W'
          }
        ]
      }
    ]
  };
});

hljs.registerLanguage('stylus', function(hljs) {

  var VARIABLE = {
    className: 'variable',
    begin: '\\$' + hljs.IDENT_RE
  };

  var HEX_COLOR = {
    className: 'number',
    begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
  };

  var AT_KEYWORDS = [
    'charset',
    'css',
    'debug',
    'extend',
    'font-face',
    'for',
    'import',
    'include',
    'media',
    'mixin',
    'page',
    'warn',
    'while'
  ];

  var PSEUDO_SELECTORS = [
    'after',
    'before',
    'first-letter',
    'first-line',
    'active',
    'first-child',
    'focus',
    'hover',
    'lang',
    'link',
    'visited'
  ];

  var TAGS = [
    'a',
    'abbr',
    'address',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'dd',
    'del',
    'details',
    'dfn',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'mark',
    'menu',
    'nav',
    'object',
    'ol',
    'p',
    'q',
    'quote',
    'samp',
    'section',
    'span',
    'strong',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'ul',
    'var',
    'video'
  ];

  var TAG_END = '[\\.\\s\\n\\[\\:,]';

  var ATTRIBUTES = [
    'align-content',
    'align-items',
    'align-self',
    'animation',
    'animation-delay',
    'animation-direction',
    'animation-duration',
    'animation-fill-mode',
    'animation-iteration-count',
    'animation-name',
    'animation-play-state',
    'animation-timing-function',
    'auto',
    'backface-visibility',
    'background',
    'background-attachment',
    'background-clip',
    'background-color',
    'background-image',
    'background-origin',
    'background-position',
    'background-repeat',
    'background-size',
    'border',
    'border-bottom',
    'border-bottom-color',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-bottom-style',
    'border-bottom-width',
    'border-collapse',
    'border-color',
    'border-image',
    'border-image-outset',
    'border-image-repeat',
    'border-image-slice',
    'border-image-source',
    'border-image-width',
    'border-left',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-spacing',
    'border-style',
    'border-top',
    'border-top-color',
    'border-top-left-radius',
    'border-top-right-radius',
    'border-top-style',
    'border-top-width',
    'border-width',
    'bottom',
    'box-decoration-break',
    'box-shadow',
    'box-sizing',
    'break-after',
    'break-before',
    'break-inside',
    'caption-side',
    'clear',
    'clip',
    'clip-path',
    'color',
    'column-count',
    'column-fill',
    'column-gap',
    'column-rule',
    'column-rule-color',
    'column-rule-style',
    'column-rule-width',
    'column-span',
    'column-width',
    'columns',
    'content',
    'counter-increment',
    'counter-reset',
    'cursor',
    'direction',
    'display',
    'empty-cells',
    'filter',
    'flex',
    'flex-basis',
    'flex-direction',
    'flex-flow',
    'flex-grow',
    'flex-shrink',
    'flex-wrap',
    'float',
    'font',
    'font-family',
    'font-feature-settings',
    'font-kerning',
    'font-language-override',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-variant-ligatures',
    'font-weight',
    'height',
    'hyphens',
    'icon',
    'image-orientation',
    'image-rendering',
    'image-resolution',
    'ime-mode',
    'inherit',
    'initial',
    'justify-content',
    'left',
    'letter-spacing',
    'line-height',
    'list-style',
    'list-style-image',
    'list-style-position',
    'list-style-type',
    'margin',
    'margin-bottom',
    'margin-left',
    'margin-right',
    'margin-top',
    'marks',
    'mask',
    'max-height',
    'max-width',
    'min-height',
    'min-width',
    'nav-down',
    'nav-index',
    'nav-left',
    'nav-right',
    'nav-up',
    'none',
    'normal',
    'object-fit',
    'object-position',
    'opacity',
    'order',
    'orphans',
    'outline',
    'outline-color',
    'outline-offset',
    'outline-style',
    'outline-width',
    'overflow',
    'overflow-wrap',
    'overflow-x',
    'overflow-y',
    'padding',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'padding-top',
    'page-break-after',
    'page-break-before',
    'page-break-inside',
    'perspective',
    'perspective-origin',
    'pointer-events',
    'position',
    'quotes',
    'resize',
    'right',
    'tab-size',
    'table-layout',
    'text-align',
    'text-align-last',
    'text-decoration',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-style',
    'text-indent',
    'text-overflow',
    'text-rendering',
    'text-shadow',
    'text-transform',
    'text-underline-position',
    'top',
    'transform',
    'transform-origin',
    'transform-style',
    'transition',
    'transition-delay',
    'transition-duration',
    'transition-property',
    'transition-timing-function',
    'unicode-bidi',
    'vertical-align',
    'visibility',
    'white-space',
    'widows',
    'width',
    'word-break',
    'word-spacing',
    'word-wrap',
    'z-index'
  ];

  // illegals
  var ILLEGAL = [
    '\\?',
    '(\\bReturn\\b)', // monkey
    '(\\bEnd\\b)', // monkey
    '(\\bend\\b)', // vbscript
    '(\\bdef\\b)', // gradle
    ';', // a whole lot of languages
    '#\\s', // markdown
    '\\*\\s', // markdown
    '===\\s', // markdown
    '\\|',
    '%', // prolog
  ];

  return {
    aliases: ['styl'],
    case_insensitive: false,
    keywords: 'if else for in',
    illegal: '(' + ILLEGAL.join('|') + ')',
    contains: [

      // strings
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,

      // comments
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,

      // hex colors
      HEX_COLOR,

      // class tag
      {
        begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-class', begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // id tag
      {
        begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-id', begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // tags
      {
        begin: '\\b(' + TAGS.join('|') + ')' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-tag', begin: '\\b[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // psuedo selectors
      {
        begin: '&?:?:\\b(' + PSEUDO_SELECTORS.join('|') + ')' + TAG_END
      },

      // @ keywords
      {
        begin: '\@(' + AT_KEYWORDS.join('|') + ')\\b'
      },

      // variables
      VARIABLE,

      // dimension
      hljs.CSS_NUMBER_MODE,

      // number
      hljs.NUMBER_MODE,

      // functions
      //  - only from beginning of line + whitespace
      {
        className: 'function',
        begin: '^[a-zA-Z][a-zA-Z0-9_\-]*\\(.*\\)',
        illegal: '[\\n]',
        returnBegin: true,
        contains: [
          {className: 'title', begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*'},
          {
            className: 'params',
            begin: /\(/,
            end: /\)/,
            contains: [
              HEX_COLOR,
              VARIABLE,
              hljs.APOS_STRING_MODE,
              hljs.CSS_NUMBER_MODE,
              hljs.NUMBER_MODE,
              hljs.QUOTE_STRING_MODE
            ]
          }
        ]
      },

      // attributes
      //  - only from beginning of line + whitespace
      //  - must have whitespace after it
      {
        className: 'attribute',
        begin: '\\b(' + ATTRIBUTES.reverse().join('|') + ')\\b',
        starts: {
          // value container
          end: /;|$/,
          contains: [
            HEX_COLOR,
            VARIABLE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.CSS_NUMBER_MODE,
            hljs.NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE
          ],
          illegal: /\./,
          relevance: 0
        }
      }
    ]
  };
});

hljs.registerLanguage('subunit', function(hljs) {
  var DETAILS = {
    className: 'string',
    begin: '\\[\n(multipart)?', end: '\\]\n'
  };
  var TIME = {
    className: 'string',
    begin: '\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}\.\\d+Z'
  };
  var PROGRESSVALUE = {
    className: 'string',
    begin: '(\\+|-)\\d+'
  };
  var KEYWORDS = {
    className: 'keyword',
    relevance: 10,
    variants: [
      { begin: '^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?' },
      { begin: '^progress(:?)(\\s+)?(pop|push)?' },
      { begin: '^tags:' },
      { begin: '^time:' }
    ],
  };
  return {
    case_insensitive: true,
    contains: [
      DETAILS,
      TIME,
      PROGRESSVALUE,
      KEYWORDS
    ]
  };
});

hljs.registerLanguage('swift', function(hljs) {
  var SWIFT_KEYWORDS = {
      keyword: '__COLUMN__ __FILE__ __FUNCTION__ __LINE__ as as! as? associativity ' +
        'break case catch class continue convenience default defer deinit didSet do ' +
        'dynamic dynamicType else enum extension fallthrough false final for func ' +
        'get guard if import in indirect infix init inout internal is lazy left let ' +
        'mutating nil none nonmutating operator optional override postfix precedence ' +
        'prefix private protocol Protocol public repeat required rethrows return ' +
        'right self Self set static struct subscript super switch throw throws true ' +
        'try try! try? Type typealias unowned var weak where while willSet',
      literal: 'true false nil',
      built_in: 'abs advance alignof alignofValue anyGenerator assert assertionFailure ' +
        'bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC ' +
        'bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros ' +
        'debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords ' +
        'enumerate equal fatalError filter find getBridgedObjectiveCType getVaList ' +
        'indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC ' +
        'isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare ' +
        'map max maxElement min minElement numericCast overlaps partition posix ' +
        'precondition preconditionFailure print println quickSort readLine reduce reflect ' +
        'reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split ' +
        'startsWith stride strideof strideofValue swap toString transcode ' +
        'underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap ' +
        'unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer ' +
        'withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers ' +
        'withUnsafePointer withUnsafePointers withVaList zip'
    };

  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][\\w\u00C0-\u02B8\']*',
    relevance: 0
  };
  var BLOCK_COMMENT = hljs.COMMENT(
    '/\\*',
    '\\*/',
    {
      contains: ['self']
    }
  );
  var SUBST = {
    className: 'subst',
    begin: /\\\(/, end: '\\)',
    keywords: SWIFT_KEYWORDS,
    contains: [] // assigned later
  };
  var NUMBERS = {
      className: 'number',
      begin: '\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b',
      relevance: 0
  };
  var QUOTE_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    contains: [SUBST, hljs.BACKSLASH_ESCAPE]
  });
  SUBST.contains = [NUMBERS];

  return {
    keywords: SWIFT_KEYWORDS,
    contains: [
      QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      BLOCK_COMMENT,
      TYPE,
      NUMBERS,
      {
        className: 'function',
        beginKeywords: 'func', end: '{', excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            begin: /[A-Za-z$_][0-9A-Za-z$_]*/
          }),
          {
            begin: /</, end: />/
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/, endsParent: true,
            keywords: SWIFT_KEYWORDS,
            contains: [
              'self',
              NUMBERS,
              QUOTE_STRING_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              {begin: ':'} // relevance booster
            ],
            illegal: /["']/
          }
        ],
        illegal: /\[|%/
      },
      {
        className: 'class',
        beginKeywords: 'struct protocol class extension enum',
        keywords: SWIFT_KEYWORDS,
        end: '\\{',
        excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/})
        ]
      },
      {
        className: 'meta', // @attributes
        begin: '(@warn_unused_result|@exported|@lazy|@noescape|' +
                  '@NSCopying|@NSManaged|@objc|@convention|@required|' +
                  '@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|' +
                  '@infix|@prefix|@postfix|@autoclosure|@testable|@available|' +
                  '@nonobjc|@NSApplicationMain|@UIApplicationMain)'

      },
      {
        beginKeywords: 'import', end: /$/,
        contains: [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT]
      }
    ]
  };
});

hljs.registerLanguage('taggerscript', function(hljs) {

  var COMMENT = {
    className: 'comment',
    begin: /\$noop\(/,
    end: /\)/,
    contains: [{
      begin: /\(/,
      end: /\)/,
      contains: ['self', {
        begin: /\\./
      }]
    }],
    relevance: 10
  };

  var FUNCTION = {
    className: 'keyword',
    begin: /\$(?!noop)[a-zA-Z][_a-zA-Z0-9]*/,
    end: /\(/,
    excludeEnd: true
  };

  var VARIABLE = {
    className: 'variable',
    begin: /%[_a-zA-Z0-9:]*/,
    end: '%'
  };

  var ESCAPE_SEQUENCE = {
    className: 'symbol',
    begin: /\\./
  };

  return {
    contains: [
      COMMENT,
      FUNCTION,
      VARIABLE,
      ESCAPE_SEQUENCE
    ]
  };
});

hljs.registerLanguage('yaml', function(hljs) {
  var LITERALS = 'true false yes no null';

  var keyPrefix = '^[ \\-]*';
  var keyName =  '[a-zA-Z_][\\w\\-]*';
  var KEY = {
    className: 'attr',
    variants: [
      { begin: keyPrefix + keyName + ":"},
      { begin: keyPrefix + '"' + keyName + '"' + ":"},
      { begin: keyPrefix + "'" + keyName + "'" + ":"}
    ]
  };

  var TEMPLATE_VARIABLES = {
    className: 'template-variable',
    variants: [
      { begin: '\{\{', end: '\}\}' }, // jinja templates Ansible
      { begin: '%\{', end: '\}' } // Ruby i18n
    ]
  };
  var STRING = {
    className: 'string',
    relevance: 0,
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /\S+/}
    ],
    contains: [
      hljs.BACKSLASH_ESCAPE,
      TEMPLATE_VARIABLES
    ]
  };

  return {
    case_insensitive: true,
    aliases: ['yml', 'YAML', 'yaml'],
    contains: [
      KEY,
      {
        className: 'meta',
        begin: '^---\s*$',
        relevance: 10
      },
      { // multi line string
        className: 'string',
        begin: '[\\|>] *$',
        returnEnd: true,
        contains: STRING.contains,
        // very simple termination: next hash key
        end: KEY.variants[0].begin
      },
      { // Ruby/Rails erb
        begin: '<%[%=-]?', end: '[%-]?%>',
        subLanguage: 'ruby',
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0
      },
      { // data type
        className: 'type',
        begin: '!!' + hljs.UNDERSCORE_IDENT_RE,
      },
      { // fragment id &ref
        className: 'meta',
        begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$',
      },
      { // fragment reference *ref
        className: 'meta',
        begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
      },
      { // array listing
        className: 'bullet',
        begin: '^ *-',
        relevance: 0
      },
      hljs.HASH_COMMENT_MODE,
      {
        beginKeywords: LITERALS,
        keywords: {literal: LITERALS}
      },
      hljs.C_NUMBER_MODE,
      STRING
    ]
  };
});

hljs.registerLanguage('tap', function(hljs) {
  return {
    case_insensitive: true,
    contains: [
      hljs.HASH_COMMENT_MODE,
      // version of format and total amount of testcases
      {
        className: 'meta',
        variants: [
          { begin: '^TAP version (\\d+)$' },
          { begin: '^1\\.\\.(\\d+)$' }
        ],
      },
      // YAML block
      {
        begin: '(\s+)?---$', end: '\\.\\.\\.$',
        subLanguage: 'yaml',
        relevance: 0
      },
	  // testcase number
      {
        className: 'number',
        begin: ' (\\d+) '
      },
	  // testcase status and description
      {
        className: 'symbol',
        variants: [
          { begin: '^ok' },
          { begin: '^not ok' }
        ],
      },
    ]
  };
});

hljs.registerLanguage('tcl', function(hljs) {
  return {
    aliases: ['tk'],
    keywords: 'after append apply array auto_execok auto_import auto_load auto_mkindex ' +
      'auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock ' +
      'close concat continue dde dict encoding eof error eval exec exit expr fblocked ' +
      'fconfigure fcopy file fileevent filename flush for foreach format gets glob global ' +
      'history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list ' +
      'llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 '+
      'mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex '+
      'platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename '+
      'return safe scan seek set socket source split string subst switch tcl_endOfWord '+
      'tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter '+
      'tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update '+
      'uplevel upvar variable vwait while',
    contains: [
      hljs.COMMENT(';[ \\t]*#', '$'),
      hljs.COMMENT('^[ \\t]*#', '$'),
      {
        beginKeywords: 'proc',
        end: '[\\{]',
        excludeEnd: true,
        contains: [
          {
            className: 'title',
            begin: '[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
            end: '[ \\t\\n\\r]',
            endsWithParent: true,
            excludeEnd: true
          }
        ]
      },
      {
        excludeEnd: true,
        variants: [
          {
            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*\\(([a-zA-Z0-9_])*\\)',
            end: '[^a-zA-Z0-9_\\}\\$]'
          },
          {
            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
            end: '(\\))?[^a-zA-Z0-9_\\}\\$]'
          }
        ]
      },
      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
          hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
        ]
      },
      {
        className: 'number',
        variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
      }
    ]
  }
});

hljs.registerLanguage('tex', function(hljs) {
  var COMMAND = {
    className: 'tag',
    begin: /\\/,
    relevance: 0,
    contains: [
      {
        className: 'name',
        variants: [
          {begin: /[a-zA-Zа-яА-я]+[*]?/},
          {begin: /[^a-zA-Zа-яА-я0-9]/}
        ],
        starts: {
          endsWithParent: true,
          relevance: 0,
          contains: [
            {
              className: 'string', // because it looks like attributes in HTML tags
              variants: [
                {begin: /\[/, end: /\]/},
                {begin: /\{/, end: /\}/}
              ]
            },
            {
              begin: /\s*=\s*/, endsWithParent: true,
              relevance: 0,
              contains: [
                {
                  className: 'number',
                  begin: /-?\d*\.?\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?/
                }
              ]
            }
          ]
        }
      }
    ]
  };

  return {
    contains: [
      COMMAND,
      {
        className: 'formula',
        contains: [COMMAND],
        relevance: 0,
        variants: [
          {begin: /\$\$/, end: /\$\$/},
          {begin: /\$/, end: /\$/}
        ]
      },
      hljs.COMMENT(
        '%',
        '$',
        {
          relevance: 0
        }
      )
    ]
  };
});

hljs.registerLanguage('thrift', function(hljs) {
  var BUILT_IN_TYPES = 'bool byte i16 i32 i64 double string binary';
  return {
    keywords: {
      keyword:
        'namespace const typedef struct enum service exception void oneway set list map required optional',
      built_in:
        BUILT_IN_TYPES,
      literal:
        'true false'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'struct enum service exception', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      },
      {
        begin: '\\b(set|list|map)\\s*<', end: '>',
        keywords: BUILT_IN_TYPES,
        contains: ['self']
      }
    ]
  };
});

hljs.registerLanguage('tp', function(hljs) {
  var TPID = {
    className: 'number',
    begin: '[1-9][0-9]*', /* no leading zeros */
    relevance: 0
  };
  var TPLABEL = {
    className: 'symbol',
    begin: ':[^\\]]+'
  };
  var TPDATA = {
    className: 'built_in',
    begin: '(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|\
    TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[', end: '\\]',
    contains: [
      'self',
      TPID,
      TPLABEL
    ]
  };
  var TPIO = {
    className: 'built_in',
    begin: '(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[', end: '\\]',
    contains: [
      'self',
      TPID,
      hljs.QUOTE_STRING_MODE, /* for pos section at bottom */
      TPLABEL
    ]
  };

  return {
    keywords: {
      keyword:
        'ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB ' +
        'DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC ' +
        'IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE ' +
        'PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET ' +
        'Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN ' +
        'SUBSTR FINDSTR VOFFSET PROG ATTR MN POS',
      literal:
        'ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET'
    },
    contains: [
      TPDATA,
      TPIO,
      {
        className: 'keyword',
        begin: '/(PROG|ATTR|MN|POS|END)\\b'
      },
      {
        /* this is for cases like ,CALL */
        className: 'keyword',
        begin: '(CALL|RUN|POINT_LOGIC|LBL)\\b'
      },
      {
        /* this is for cases like CNT100 where the default lexemes do not
         * separate the keyword and the number */
        className: 'keyword',
        begin: '\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)'
      },
      {
        /* to catch numbers that do not have a word boundary on the left */
        className: 'number',
        begin: '\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b',
        relevance: 0
      },
      hljs.COMMENT('//', '[;$]'),
      hljs.COMMENT('!', '[;$]'),
      hljs.COMMENT('--eg:', '$'),
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'', end: '\''
      },
      hljs.C_NUMBER_MODE,
      {
        className: 'variable',
        begin: '\\$[A-Za-z0-9_]+'
      }
    ]
  };
});

hljs.registerLanguage('twig', function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var FUNCTION_NAMES = 'attribute block constant cycle date dump include ' +
                  'max min parent random range source template_from_string';

  var FUNCTIONS = {
    beginKeywords: FUNCTION_NAMES,
    keywords: {name: FUNCTION_NAMES},
    relevance: 0,
    contains: [
      PARAMS
    ]
  };

  var FILTER = {
    begin: /\|[A-Za-z_]+:?/,
    keywords:
      'abs batch capitalize convert_encoding date date_modify default ' +
      'escape first format join json_encode keys last length lower ' +
      'merge nl2br number_format raw replace reverse round slice sort split ' +
      'striptags title trim upper url_encode',
    contains: [
      FUNCTIONS
    ]
  };

  var TAGS = 'autoescape block do embed extends filter flush for ' +
    'if import include macro sandbox set spaceless use verbatim';

  TAGS = TAGS + ' ' + TAGS.split(' ').map(function(t){return 'end' + t}).join(' ');

  return {
    aliases: ['craftcms'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT(/\{#/, /#}/),
      {
        className: 'template-tag',
        begin: /\{%/, end: /%}/,
        contains: [
          {
            className: 'name',
            begin: /\w+/,
            keywords: TAGS,
            starts: {
              endsWithParent: true,
              contains: [FILTER, FUNCTIONS],
              relevance: 0
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /}}/,
        contains: ['self', FILTER, FUNCTIONS]
      }
    ]
  };
});

hljs.registerLanguage('typescript', function(hljs) {
  var KEYWORDS = {
    keyword:
      'in if for while finally var new function do return void else break catch ' +
      'instanceof with throw case default try this switch continue typeof delete ' +
      'let yield const class public private protected get set super ' +
      'static implements enum export import declare type namespace abstract ' +
      'as from extends async await',
    literal:
      'true false null undefined NaN Infinity',
    built_in:
      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
      'module console window document any number boolean string void Promise'
  };

  return {
    aliases: ['ts'],
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        begin: /^\s*['"]use strict['"]/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      { // template string
        className: 'string',
        begin: '`', end: '`',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            begin: '\\$\\{', end: '\\}'
          }
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'number',
        variants: [
          { begin: '\\b(0[bB][01]+)' },
          { begin: '\\b(0[oO][0-7]+)' },
          { begin: hljs.C_NUMBER_RE }
        ],
        relevance: 0
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          {
            className: 'function',
            begin: '(\\(.*?\\)|' + hljs.IDENT_RE + ')\\s*=>', returnBegin: true,
            end: '\\s*=>',
            contains: [
              {
                className: 'params',
                variants: [
                  {
                    begin: hljs.IDENT_RE
                  },
                  {
                    begin: /\(\s*\)/,
                  },
                  {
                    begin: /\(/, end: /\)/,
                    excludeBegin: true, excludeEnd: true,
                    keywords: KEYWORDS,
                    contains: [
                      'self',
                      hljs.C_LINE_COMMENT_MODE,
                      hljs.C_BLOCK_COMMENT_MODE
                    ]
                  }
                ]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        begin: 'function', end: /[\{;]/, excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          'self',
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ],
            illegal: /["'\(]/
          }
        ],
        illegal: /%/,
        relevance: 0 // () => {} is more typical in TypeScript
      },
      {
        beginKeywords: 'constructor', end: /\{/, excludeEnd: true,
        contains: [
          'self',
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ],
            illegal: /["'\(]/
          }
        ]
      },
      { // prevent references like module.id from being higlighted as module definitions
        begin: /module\./,
        keywords: {built_in: 'module'},
        relevance: 0
      },
      {
        beginKeywords: 'module', end: /\{/, excludeEnd: true
      },
      {
        beginKeywords: 'interface', end: /\{/, excludeEnd: true,
        keywords: 'interface extends'
      },
      {
        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      },
      {
        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
      },
      {
        className: 'meta', begin: '@[A-Za-z]+'
      }
    ]
  };
});

hljs.registerLanguage('vala', function(hljs) {
  return {
    keywords: {
      keyword:
        // Value types
        'char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 ' +
        'uint16 uint32 uint64 float double bool struct enum string void ' +
        // Reference types
        'weak unowned owned ' +
        // Modifiers
        'async signal static abstract interface override virtual delegate ' +
        // Control Structures
        'if while do for foreach else switch case break default return try catch ' +
        // Visibility
        'public private protected internal ' +
        // Other
        'using new this get set const stdout stdin stderr var',
      built_in:
        'DBus GLib CCode Gee Object Gtk Posix',
      literal:
        'false true null'
    },
    contains: [
      {
        className: 'class',
        beginKeywords: 'class interface namespace', end: '{', excludeEnd: true,
        illegal: '[^,:\\n\\s\\.]',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'string',
        begin: '"""', end: '"""',
        relevance: 5
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '^#', end: '$',
        relevance: 2
      }
    ]
  };
});

hljs.registerLanguage('vbnet', function(hljs) {
  return {
    aliases: ['vb'],
    case_insensitive: true,
    keywords: {
      keyword:
        'addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval ' + /* a-b */
        'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
        'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
        'get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue ' + /* g-i */
        'join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass ' + /* j-m */
        'namespace narrowing new next not notinheritable notoverridable ' + /* n */
        'of off on operator option optional or order orelse overloads overridable overrides ' + /* o */
        'paramarray partial preserve private property protected public ' + /* p */
        'raiseevent readonly redim rem removehandler resume return ' + /* r */
        'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
        'take text then throw to try unicode until using when where while widening with withevents writeonly xor', /* t-x */
      built_in:
        'boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype ' +  /* b-c */
        'date decimal directcast double gettype getxmlnamespace iif integer long object ' + /* d-o */
        'sbyte short single string trycast typeof uinteger ulong ushort', /* s-u */
      literal:
        'true false nothing'
    },
    illegal: '//|{|}|endif|gosub|variant|wend', /* reserved deprecated keywords */
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
      hljs.COMMENT(
        '\'',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              begin: '\'\'\'|<!--|-->',
              contains: [hljs.PHRASAL_WORDS_MODE]
            },
            {
              className: 'doctag',
              begin: '</?', end: '>',
              contains: [hljs.PHRASAL_WORDS_MODE]
            }
          ]
        }
      ),
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elseif end region externalsource'}
      }
    ]
  };
});

hljs.registerLanguage('vbscript', function(hljs) {
  return {
    aliases: ['vbs'],
    case_insensitive: true,
    keywords: {
      keyword:
        'call class const dim do loop erase execute executeglobal exit for each next function ' +
        'if then else on error option explicit new private property let get public randomize ' +
        'redim rem select case set stop sub while wend with end to elseif is or xor and not ' +
        'class_initialize class_terminate default preserve in me byval byref step resume goto',
      built_in:
        'lcase month vartype instrrev ubound setlocale getobject rgb getref string ' +
        'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' +
        'conversions csng timevalue second year space abs clng timeserial fixs len asc ' +
        'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' +
        'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' +
        'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' +
        'strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion ' +
        'scriptengine split scriptengineminorversion cint sin datepart ltrim sqr ' +
        'scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw ' +
        'chrw regexp server response request cstr err',
      literal:
        'true false null nothing empty'
    },
    illegal: '//',
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
      hljs.COMMENT(
        /'/,
        /$/,
        {
          relevance: 0
        }
      ),
      hljs.C_NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('vbscript-html', function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      {
        begin: '<%', end: '%>',
        subLanguage: 'vbscript'
      }
    ]
  };
});

hljs.registerLanguage('verilog', function(hljs) {
  var SV_KEYWORDS = {
    keyword:
      'accept_on alias always always_comb always_ff always_latch and assert assign ' +
      'assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 ' +
      'byte case casex casez cell chandle checker class clocking cmos config const ' +
      'constraint context continue cover covergroup coverpoint cross deassign default ' +
      'defparam design disable dist do edge else end endcase endchecker endclass ' +
      'endclocking endconfig endfunction endgenerate endgroup endinterface endmodule ' +
      'endpackage endprimitive endprogram endproperty endspecify endsequence endtable ' +
      'endtask enum event eventually expect export extends extern final first_match for ' +
      'force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 ' +
      'if iff ifnone ignore_bins illegal_bins implements implies import incdir include ' +
      'initial inout input inside instance int integer interconnect interface intersect ' +
      'join join_any join_none large let liblist library local localparam logic longint ' +
      'macromodule matches medium modport module nand negedge nettype new nexttime nmos ' +
      'nor noshowcancelled not notif0 notif1 or output package packed parameter pmos ' +
      'posedge primitive priority program property protected pull0 pull1 pulldown pullup ' +
      'pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos ' +
      'real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran ' +
      'rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared ' +
      'sequence shortint shortreal showcancelled signed small soft solve specify specparam ' +
      'static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on ' +
      'sync_reject_on table tagged task this throughout time timeprecision timeunit tran ' +
      'tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 ' +
      'unsigned until until_with untyped use uwire var vectored virtual void wait wait_order ' +
      'wand weak weak0 weak1 while wildcard wire with within wor xnor xor',
    literal:
      'null',
    built_in:
      '$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale ' +
      '$bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat ' +
      '$realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson ' +
      '$assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff ' +
      '$assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk ' +
      '$fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control ' +
      '$coverage_get $coverage_save $set_coverage_db_name $rose $stable $past ' +
      '$rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display ' +
      '$coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename ' +
      '$unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow ' +
      '$floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning ' +
      '$dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh ' +
      '$tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random ' +
      '$dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson ' +
      '$dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array ' +
      '$async$nand$array $async$or$array $async$nor$array $sync$and$array ' +
      '$sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf ' +
      '$async$and$plane $async$nand$plane $async$or$plane $async$nor$plane ' +
      '$sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system ' +
      '$display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo ' +
      '$write $readmemb $readmemh $writememh $value$plusargs ' +
      '$dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit ' +
      '$writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb ' +
      '$dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall ' +
      '$dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo ' +
      '$fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh ' +
      '$swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb ' +
      '$fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat ' +
      '$sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror'
    };
  return {
    aliases: ['v', 'sv', 'svh'],
    case_insensitive: false,
    keywords: SV_KEYWORDS, lexemes: /[\w\$]+/,
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          {begin: '\\b((\\d+\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
          {begin: '\\B((\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
          {begin: '\\b([0-9_])+', relevance: 0}
        ]
      },
      /* parameters to instances */
      {
        className: 'variable',
        variants: [
          {begin: '#\\((?!parameter).+\\)'},
          {begin: '\\.\\w+', relevance: 0},
        ]
      },
      {
        className: 'meta',
        begin: '`', end: '$',
        keywords: {'meta-keyword': 'define __FILE__ ' +
          '__LINE__ begin_keywords celldefine default_nettype define ' +
          'else elsif end_keywords endcelldefine endif ifdef ifndef ' +
          'include line nounconnected_drive pragma resetall timescale ' +
          'unconnected_drive undef undefineall'},
        relevance: 0
      }
    ]
  }; // return
});

hljs.registerLanguage('vhdl', function(hljs) {
  // Regular expression for VHDL numeric literals.

  // Decimal literal:
  var INTEGER_RE = '\\d(_|\\d)*';
  var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
  var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';
  // Based literal:
  var BASED_INTEGER_RE = '\\w+';
  var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';

  var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';

  return {
    case_insensitive: true,
    keywords: {
      keyword:
        'abs access after alias all and architecture array assert assume assume_guarantee attribute ' +
        'begin block body buffer bus case component configuration constant context cover disconnect ' +
        'downto default else elsif end entity exit fairness file for force function generate ' +
        'generic group guarded if impure in inertial inout is label library linkage literal ' +
        'loop map mod nand new next nor not null of on open or others out package port ' +
        'postponed procedure process property protected pure range record register reject ' +
        'release rem report restrict restrict_guarantee return rol ror select sequence ' +
        'severity shared signal sla sll sra srl strong subtype then to transport type ' +
        'unaffected units until use variable vmode vprop vunit wait when while with xnor xor',
      built_in:
        'boolean bit character ' +
        'integer time delay_length natural positive ' +
        'string bit_vector file_open_kind file_open_status ' +
        'std_logic std_logic_vector unsigned signed boolean_vector integer_vector ' +
        'std_ulogic std_ulogic_vector unresolved_unsigned u_unsigned unresolved_signed u_signed' +
        'real_vector time_vector',
      literal:
        'false true note warning error failure ' +  // severity_level
        'line text side width'                      // textio
    },
    illegal: '{',
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,      // VHDL-2008 block commenting.
      hljs.COMMENT('--', '$'),
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        begin: NUMBER_RE,
        relevance: 0
      },
      {
        className: 'string',
        begin: '\'(U|X|0|1|Z|W|L|H|-)\'',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        className: 'symbol',
        begin: '\'[A-Za-z](_?[A-Za-z0-9])*',
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
});

hljs.registerLanguage('vim', function(hljs) {
  return {
    lexemes: /[!#@\w]+/,
    keywords: {
      keyword:
        // express version except: ! & * < = > !! # @ @@
        'N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope '+
        'cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc '+
        'ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 '+
        'profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor '+
        'so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew '+
        'tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ '+
        // full version
        'Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload '+
        'bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap '+
        'cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor '+
        'endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap '+
        'imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview '+
        'lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap '+
        'nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext '+
        'ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding '+
        'scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace '+
        'startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious '+'trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew '+
        'vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank',
      built_in: //built in func
        'synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv ' +
        'complete_check add getwinposx getqflist getwinposy screencol ' +
        'clearmatches empty extend getcmdpos mzeval garbagecollect setreg ' +
        'ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable ' +
        'shiftwidth max sinh isdirectory synID system inputrestore winline ' +
        'atan visualmode inputlist tabpagewinnr round getregtype mapcheck ' +
        'hasmapto histdel argidx findfile sha256 exists toupper getcmdline ' +
        'taglist string getmatches bufnr strftime winwidth bufexists ' +
        'strtrans tabpagebuflist setcmdpos remote_read printf setloclist ' +
        'getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval ' +
        'resolve libcallnr foldclosedend reverse filter has_key bufname ' +
        'str2float strlen setline getcharmod setbufvar index searchpos ' +
        'shellescape undofile foldclosed setqflist buflisted strchars str2nr ' +
        'virtcol floor remove undotree remote_expr winheight gettabwinvar ' +
        'reltime cursor tabpagenr finddir localtime acos getloclist search ' +
        'tanh matchend rename gettabvar strdisplaywidth type abs py3eval ' +
        'setwinvar tolower wildmenumode log10 spellsuggest bufloaded ' +
        'synconcealed nextnonblank server2client complete settabwinvar ' +
        'executable input wincol setmatches getftype hlID inputsave ' +
        'searchpair or screenrow line settabvar histadd deepcopy strpart ' +
        'remote_peek and eval getftime submatch screenchar winsaveview ' +
        'matchadd mkdir screenattr getfontname libcall reltimestr getfsize ' +
        'winnr invert pow getbufline byte2line soundfold repeat fnameescape ' +
        'tagfiles sin strwidth spellbadword trunc maparg log lispindent ' +
        'hostname setpos globpath remote_foreground getchar synIDattr ' +
        'fnamemodify cscope_connection stridx winbufnr indent min ' +
        'complete_add nr2char searchpairpos inputdialog values matchlist ' +
        'items hlexists strridx browsedir expand fmod pathshorten line2byte ' +
        'argc count getwinvar glob foldtextresult getreg foreground cosh ' +
        'matchdelete has char2nr simplify histget searchdecl iconv ' +
        'winrestcmd pumvisible writefile foldlevel haslocaldir keys cos ' +
        'matchstr foldtext histnr tan tempname getcwd byteidx getbufvar ' +
        'islocked escape eventhandler remote_send serverlist winrestview ' +
        'synstack pyeval prevnonblank readfile cindent filereadable changenr ' +
        'exp'
    },
    illegal: /;/,
    contains: [
      hljs.NUMBER_MODE,
      hljs.APOS_STRING_MODE,

      /*
      A double quote can start either a string or a line comment. Strings are
      ended before the end of a line by another double quote and can contain
      escaped double-quotes and post-escaped line breaks.

      Also, any double quote at the beginning of a line is a comment but we
      don't handle that properly at the moment: any double quote inside will
      turn them into a string. Handling it properly will require a smarter
      parser.
      */
      {
        className: 'string',
        begin: /"(\\"|\n\\|[^"\n])*"/
      },
      hljs.COMMENT('"', '$'),

      {
        className: 'variable',
        begin: /[bwtglsav]:[\w\d_]*/
      },
      {
        className: 'function',
        beginKeywords: 'function function!', end: '$',
        relevance: 0,
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)'
          }
        ]
      },
      {
        className: 'symbol',
        begin: /<[\w-]+>/
      }
    ]
  };
});

hljs.registerLanguage('x86asm', function(hljs) {
  return {
    case_insensitive: true,
    lexemes: '[.%]?' + hljs.IDENT_RE,
    keywords: {
      keyword:
        'lock rep repe repz repne repnz xaquire xrelease bnd nobnd ' +
        'aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63',
      built_in:
        // Instruction pointer
        'ip eip rip ' +
        // 8-bit registers
        'al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ' +
        // 16-bit registers
        'ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w ' +
        // 32-bit registers
        'eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d ' +
        // 64-bit registers
        'rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 ' +
        // Segment registers
        'cs ds es fs gs ss ' +
        // Floating point stack registers
        'st st0 st1 st2 st3 st4 st5 st6 st7 ' +
        // MMX Registers
        'mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 ' +
        // SSE registers
        'xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 ' +
        'xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ' +
        // AVX registers
        'ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ' +
        'ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 ' +
        // AVX-512F registers
        'zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 ' +
        'zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 ' +
        // AVX-512F mask registers
        'k0 k1 k2 k3 k4 k5 k6 k7 ' +
        // Bound (MPX) register
        'bnd0 bnd1 bnd2 bnd3 ' +
        // Special register
        'cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 ' +
        // NASM altreg package
        'r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b ' +
        'r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d ' +
        'r0h r1h r2h r3h ' +
        'r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l ' +

        'db dw dd dq dt ddq do dy dz ' +
        'resb resw resd resq rest resdq reso resy resz ' +
        'incbin equ times ' +
        'byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr',

      meta:
        '%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif ' +
        '%if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep ' +
        '%endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment ' +
        '.nolist ' +
        '__FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ ' +
        '__UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend ' +
        'align alignb sectalign daz nodaz up down zero default option assume public ' +

        'bits use16 use32 use64 default section segment absolute extern global common cpu float ' +
        '__utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ ' +
        '__float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ ' +
        '__Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e ' +
        'float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__'
    },
    contains: [
      hljs.COMMENT(
        ';',
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'number',
        variants: [
          // Float number and x87 BCD
          {
            begin: '\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|' +
                   '(0[Xx])?[0-9][0-9_]*\\.?[0-9_]*(?:[pP](?:[+-]?[0-9_]+)?)?)\\b',
            relevance: 0
          },

          // Hex number in $
          { begin: '\\$[0-9][0-9A-Fa-f]*', relevance: 0 },

          // Number in H,D,T,Q,O,B,Y suffix
          { begin: '\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b' },

          // Number in X,D,T,Q,O,B,Y prefix
          { begin: '\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b'}
        ]
      },
      // Double quote string
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          // Single-quoted string
          { begin: '\'', end: '[^\\\\]\'' },
          // Backquoted string
          { begin: '`', end: '[^\\\\]`' }
        ],
        relevance: 0
      },
      {
        className: 'symbol',
        variants: [
          // Global label and local label
          { begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)' },
          // Macro-local label
          { begin: '^\\s*%%[A-Za-z0-9_$#@~.?]*:' }
        ],
        relevance: 0
      },
      // Macro parameter
      {
        className: 'subst',
        begin: '%[0-9]+',
        relevance: 0
      },
      // Macro parameter
      {
        className: 'subst',
        begin: '%!\S+',
        relevance: 0
      },
      {
        className: 'meta',
        begin: /^\s*\.[\w_-]+/
      }
    ]
  };
});

hljs.registerLanguage('xl', function(hljs) {
  var BUILTIN_MODULES =
    'ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo ' +
    'StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts';

  var XL_KEYWORDS = {
    keyword:
      'if then else do while until for loop import with is as where when by data constant ' +
      'integer real text name boolean symbol infix prefix postfix block tree',
    literal:
      'true false nil',
    built_in:
      'in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin ' +
      'acos atan exp expm1 log log2 log10 log1p pi at text_length text_range ' +
      'text_find text_replace contains page slide basic_slide title_slide ' +
      'title subtitle fade_in fade_out fade_at clear_color color line_color ' +
      'line_width texture_wrap texture_transform texture scale_?x scale_?y ' +
      'scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y ' +
      'rotate_?z? rectangle circle ellipse sphere path line_to move_to ' +
      'quad_to curve_to theme background contents locally time mouse_?x ' +
      'mouse_?y mouse_buttons ' +
      BUILTIN_MODULES
  };

  var DOUBLE_QUOTE_TEXT = {
    className: 'string',
    begin: '"', end: '"', illegal: '\\n'
  };
  var SINGLE_QUOTE_TEXT = {
    className: 'string',
    begin: '\'', end: '\'', illegal: '\\n'
  };
  var LONG_TEXT = {
    className: 'string',
    begin: '<<', end: '>>'
  };
  var BASED_NUMBER = {
    className: 'number',
    begin: '[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?'
  };
  var IMPORT = {
    beginKeywords: 'import', end: '$',
    keywords: XL_KEYWORDS,
    contains: [DOUBLE_QUOTE_TEXT]
  };
  var FUNCTION_DEFINITION = {
    className: 'function',
    begin: /[a-z][^\n]*->/, returnBegin: true, end: /->/,
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {starts: {
        endsWithParent: true,
        keywords: XL_KEYWORDS
      }})
    ]
  };
  return {
    aliases: ['tao'],
    lexemes: /[a-zA-Z][a-zA-Z0-9_?]*/,
    keywords: XL_KEYWORDS,
    contains: [
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    DOUBLE_QUOTE_TEXT,
    SINGLE_QUOTE_TEXT,
    LONG_TEXT,
    FUNCTION_DEFINITION,
    IMPORT,
    BASED_NUMBER,
    hljs.NUMBER_MODE
    ]
  };
});

hljs.registerLanguage('xquery', function(hljs) {
  var KEYWORDS = 'for let if while then else return where group by xquery encoding version' +
    'module namespace boundary-space preserve strip default collation base-uri ordering' +
    'copy-namespaces order declare import schema namespace function option in allowing empty' +
    'at tumbling window sliding window start when only end when previous next stable ascending' +
    'descending empty greatest least some every satisfies switch case typeswitch try catch and' +
    'or to union intersect instance of treat as castable cast map array delete insert into' +
    'replace value rename copy modify update';
  var LITERAL = 'false true xs:string xs:integer element item xs:date xs:datetime xs:float xs:double xs:decimal QName xs:anyURI xs:long xs:int xs:short xs:byte attribute';
  var VAR = {
    begin: /\$[a-zA-Z0-9\-]+/
  };

  var NUMBER = {
    className: 'number',
    begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
    relevance: 0
  };

  var STRING = {
    className: 'string',
    variants: [
      {begin: /"/, end: /"/, contains: [{begin: /""/, relevance: 0}]},
      {begin: /'/, end: /'/, contains: [{begin: /''/, relevance: 0}]}
    ]
  };

  var ANNOTATION = {
    className: 'meta',
    begin: '%\\w+'
  };

  var COMMENT = {
    className: 'comment',
    begin: '\\(:', end: ':\\)',
    relevance: 10,
    contains: [
      {
        className: 'doctag', begin: '@\\w+'
      }
    ]
  };

  var METHOD = {
    begin: '{', end: '}'
  };

  var CONTAINS = [
    VAR,
    STRING,
    NUMBER,
    COMMENT,
    ANNOTATION,
    METHOD
  ];
  METHOD.contains = CONTAINS;


  return {
    aliases: ['xpath', 'xq'],
    case_insensitive: false,
    lexemes: /[a-zA-Z\$][a-zA-Z0-9_:\-]*/,
    illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
    keywords: {
      keyword: KEYWORDS,
      literal: LITERAL
    },
    contains: CONTAINS
  };
});

hljs.registerLanguage('zephir', function(hljs) {
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: 'b"', end: '"'
      },
      {
        begin: 'b\'', end: '\''
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
    ]
  };
  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
  return {
    aliases: ['zep'],
    case_insensitive: true,
    keywords:
      'and include_once list abstract global private echo interface as static endswitch ' +
      'array null if endwhile or const for endforeach self var let while isset public ' +
      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
      'enddeclare final try switch continue endfor endif declare unset true false ' +
      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
      'yield finally int uint long ulong char uchar double float bool boolean string' +
      'likely unlikely',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.HASH_COMMENT_MODE,
      hljs.COMMENT(
        '/\\*',
        '\\*/',
        {
          contains: [
            {
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.COMMENT(
        '__halt_compiler.+?;',
        false,
        {
          endsWithParent: true,
          keywords: '__halt_compiler',
          lexemes: hljs.UNDERSCORE_IDENT_RE
        }
      ),
      {
        className: 'string',
        begin: '<<<[\'"]?\\w+[\'"]?$', end: '^\\w+;',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        // swallow composed identifiers to avoid parsing them as keywords
        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
        illegal: '\\$|\\[|%',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              'self',
              hljs.C_BLOCK_COMMENT_MODE,
              STRING,
              NUMBER
            ]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: /[:\(\$"]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: ';',
        illegal: /[\.']/,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        beginKeywords: 'use', end: ';',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: '=>' // No markup, just a relevance booster
      },
      STRING,
      NUMBER
    ]
  };
});

  return hljs;
}));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tip tip-hide\">\n  <div class=\"tip-arrow\"></div>\n  <div class=\"tip-inner\"></div>\n</div>";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

function DummyCache() {}

DummyCache.prototype.get = function (key) {
  return null;
};

DummyCache.prototype.has = function (key) {
  return false;
};

DummyCache.prototype.set = function (key, value) {
};

module.exports = DummyCache;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

function ConfigurationError(message) {
    this.name = 'ConfigurationError';
    this.message = (message || '');
}
ConfigurationError.prototype = Error.prototype;

function TokenValidationError(message) {
    this.name = 'TokenValidationError';
    this.message = (message || '');
}
TokenValidationError.prototype = Error.prototype;

module.exports = {
  ConfigurationError: ConfigurationError,
  TokenValidationError: TokenValidationError
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var urljoin = __webpack_require__(66);
var base64 = __webpack_require__(284);
var request = __webpack_require__(90);

function process(jwks) {
  var modulus = base64.decodeToHEX(jwks.n);
  var exp = base64.decodeToHEX(jwks.e);

  return {
    modulus: modulus,
    exp: exp
  };
}

function getJWKS(options, cb) {
  var url = urljoin(options.iss, '.well-known', 'jwks.json');

  return request
    .get(url)
    .end(function (err, data) {
      if (err) {
        cb(err);
      }

      var matchingKey = null;

      for (var a = 0; a < data.body.keys.length && matchingKey === null; a ++) {
        var key = data.body.keys[a];
        if (key.kid === options.kid) {
          matchingKey = key;
        }
      }

      cb(null, process(matchingKey));
    });
}

module.exports = {
  process: process,
  getJWKS: getJWKS
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

/*
Based on the work of Tom Wu
http://www-cs-students.stanford.edu/~tjw/jsbn/
http://www-cs-students.stanford.edu/~tjw/jsbn/LICENSE
*/

var BigInteger = __webpack_require__(760).BigInteger;
var SHA256 = __webpack_require__(735);

var DigestInfoHead = {
  sha1: '3021300906052b0e03021a05000414',
  sha224: '302d300d06096086480165030402040500041c',
  sha256: '3031300d060960864801650304020105000420',
  sha384: '3041300d060960864801650304020205000430',
  sha512: '3051300d060960864801650304020305000440',
  md2: '3020300c06082a864886f70d020205000410',
  md5: '3020300c06082a864886f70d020505000410',
  ripemd160: '3021300906052b2403020105000414'
};

var DigestAlgs = {
  sha256: SHA256
};

function RSAVerifier(modulus, exp) {
  this.n = null;
  this.e = 0;

  if (modulus != null && exp != null && modulus.length > 0 && exp.length > 0) {
    this.n = new BigInteger(modulus, 16);
    this.e = parseInt(exp, 16);
  } else {
    throw new Error('Invalid key data');
  }
}

function getAlgorithmFromDigest(hDigestInfo) {
  for (var algName in DigestInfoHead) {
    var head = DigestInfoHead[algName];
    var len = head.length;

    if (hDigestInfo.substring(0, len) === head) {
      return {
        alg: algName,
        hash: hDigestInfo.substring(len)
      };
    }
  }
  return [];
}


RSAVerifier.prototype.verify = function (msg, encsig) {
  encsig = encsig.replace(/[^0-9a-f]|[\s\n]]/ig, '');

  var sig = new BigInteger(encsig, 16);
  if (sig.bitLength() > this.n.bitLength()) {
    throw new Error('Signature does not match with the key modulus.');
  }

  var decryptedSig = sig.modPowInt(this.e, this.n);
  var digest = decryptedSig.toString(16).replace(/^1f+00/, '');

  var digestInfo = getAlgorithmFromDigest(digest);
  if (digestInfo.length === 0) {
    return false;
  }

  if (!DigestAlgs.hasOwnProperty(digestInfo.alg)) {
    throw new Error('Hashing algorithm is not supported.');
  }

  var msgHash = DigestAlgs[digestInfo.alg](msg).toString();
  return (digestInfo.hash === msgHash);
};

module.exports = RSAVerifier;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var RSAVerifier = __webpack_require__(756);
var base64 = __webpack_require__(284);
var jwks = __webpack_require__(755);
var error = __webpack_require__(754);
var DummyCache = __webpack_require__(753);
var supportedAlgs = ['RS256'];

function IdTokenVerifier(options) {
  options = options || {};

  this.jwksCache = options.jwksCache || new DummyCache();
  this.expectedAlg = options.expectedAlg || 'RS256';
  this.issuer = options.issuer;
  this.audience = options.audience;
  this.leeway = options.leeway || 0;
  this.__disableExpirationCheck = options.__disableExpirationCheck || false;

  if (this.leeway < 0 || this.leeway > 60) {
    throw new error.ConfigurationError('The leeway should be positive and lower than a minute.');
  }

  if (supportedAlgs.indexOf(this.expectedAlg) === -1) {
    throw new error.ConfigurationError('Algorithm ' + this.expectedAlg +
      ' is not supported. (Expected algs: [' + supportedAlgs.join(',') + '])');
  }
}

IdTokenVerifier.prototype.verify = function (token, nonce, cb) {
  var jwt = this.decode(token);

  if (jwt instanceof Error) {
    return cb(jwt, false);
  }

  var headAndPayload = jwt.encoded.header + '.' + jwt.encoded.payload;
  var signature = base64.decodeToHEX(jwt.encoded.signature);

  var alg = jwt.header.alg;
  var kid = jwt.header.kid;

  var aud = jwt.payload.aud;
  var iss = jwt.payload.iss;
  var exp = jwt.payload.exp;
  var iat = jwt.payload.iat;
  var tnonce = jwt.payload.nonce || null;

  if (this.issuer !== iss) {
    return cb(new error.TokenValidationError('Issuer ' + iss + ' is not valid.'), false);
  }

  if (this.audience !== aud) {
    return cb(new error.TokenValidationError('Audience ' + aud + ' is not valid.'), false);
  }

  if (this.expectedAlg !== alg) {
    return cb(new error.TokenValidationError('Algorithm ' + alg +
      ' is not supported. (Expected algs: [' + supportedAlgs.join(',') + '])'), false);
  }

  if (tnonce !== nonce) {
    return cb(new error.TokenValidationError('Nonce does not match.'), false);
  }

  var expirationError = this.verifyExpAndIat(exp, iat);

  if (expirationError) {
    return cb(expirationError, false);
  }

  this.getRsaVerifier(iss, kid, function (err, rsaVerifier) {
    if (err) {
      return cb(err);
    }
    if (rsaVerifier.verify(headAndPayload, signature)) {
      cb(null, jwt.payload);
    } else {
      cb(new error.TokenValidationError('Invalid signature.'));
    }
  });
};

IdTokenVerifier.prototype.verifyExpAndIat = function (exp, iat) {
  if (this.__disableExpirationCheck) {
    return null;
  }

  var now = new Date();

  var expDate = new Date(0);
  expDate.setUTCSeconds(exp + this.leeway);

  if (now > expDate) {
    return new error.TokenValidationError('Expired token.');
  }

  var iatDate = new Date(0);
  iatDate.setUTCSeconds(iat - this.leeway);

  if (now < iatDate) {
    return new error.TokenValidationError('The token was issued in the future. ' +
      'Please check your computed clock.');
  }

  return null;
};

IdTokenVerifier.prototype.getRsaVerifier = function (iss, kid, cb) {
  var _this = this;
  var cachekey = iss + kid;

  if (!this.jwksCache.has(cachekey)) {
    jwks.getJWKS({
      iss: iss,
      kid: kid
    }, function (err, keyInfo) {
      if (err) {
        cb(err);
      }
      _this.jwksCache.set(cachekey, keyInfo);
      cb(null, new RSAVerifier(keyInfo.modulus, keyInfo.exp));
    });
  } else {
    var keyInfo = this.jwksCache.get(cachekey);
    cb(null, new RSAVerifier(keyInfo.modulus, keyInfo.exp));
  }
};

IdTokenVerifier.prototype.decode = function (token) {
  var parts = token.split('.');
  var header;
  var payload;

  if (parts.length !== 3) {
    return new error.TokenValidationError('Cannot decode a malformed JWT');
  }

  try {
    header = JSON.parse(base64.decodeToString(parts[0]));
    payload = JSON.parse(base64.decodeToString(parts[1]));
  } catch (e) {
    return new error.TokenValidationError('Token header or payload is not valid JSON');
  }

  return {
    header: header,
    payload: payload,
    encoded: {
      header: parts[0],
      payload: parts[1],
      signature: parts[2]
    }
  };
};

module.exports = IdTokenVerifier;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.inView=e():t.inView=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

(function(){

    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.

    // Basic JavaScript BN library - subset useful for RSA encryption.

    // Bits per digit
    var dbits;

    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = ((canary&0xffffff)==0xefcafe);

    // (public) Constructor
    function BigInteger(a,b,c) {
      if(a != null)
        if("number" == typeof a) this.fromNumber(a,b,c);
        else if(b == null && "string" != typeof a) this.fromString(a,256);
        else this.fromString(a,b);
    }

    // return new, unset BigInteger
    function nbi() { return new BigInteger(null); }

    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.

    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i,x,w,j,c,n) {
      while(--n >= 0) {
        var v = x*this[i++]+w[j]+c;
        c = Math.floor(v/0x4000000);
        w[j++] = v&0x3ffffff;
      }
      return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i,x,w,j,c,n) {
      var xl = x&0x7fff, xh = x>>15;
      while(--n >= 0) {
        var l = this[i]&0x7fff;
        var h = this[i++]>>15;
        var m = xh*l+h*xl;
        l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);
        c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);
        w[j++] = l&0x3fffffff;
      }
      return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i,x,w,j,c,n) {
      var xl = x&0x3fff, xh = x>>14;
      while(--n >= 0) {
        var l = this[i]&0x3fff;
        var h = this[i++]>>14;
        var m = xh*l+h*xl;
        l = xl*l+((m&0x3fff)<<14)+w[j]+c;
        c = (l>>28)+(m>>14)+xh*h;
        w[j++] = l&0xfffffff;
      }
      return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if(inBrowser && j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
      BigInteger.prototype.am = am2;
      dbits = 30;
    }
    else if(inBrowser && j_lm && (navigator.appName != "Netscape")) {
      BigInteger.prototype.am = am1;
      dbits = 26;
    }
    else { // Mozilla/Netscape seems to prefer am3
      BigInteger.prototype.am = am3;
      dbits = 28;
    }

    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = ((1<<dbits)-1);
    BigInteger.prototype.DV = (1<<dbits);

    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2,BI_FP);
    BigInteger.prototype.F1 = BI_FP-dbits;
    BigInteger.prototype.F2 = 2*dbits-BI_FP;

    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr,vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

    function int2char(n) { return BI_RM.charAt(n); }
    function intAt(s,i) {
      var c = BI_RC[s.charCodeAt(i)];
      return (c==null)?-1:c;
    }

    // (protected) copy this to r
    function bnpCopyTo(r) {
      for(var i = this.t-1; i >= 0; --i) r[i] = this[i];
      r.t = this.t;
      r.s = this.s;
    }

    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
      this.t = 1;
      this.s = (x<0)?-1:0;
      if(x > 0) this[0] = x;
      else if(x < -1) this[0] = x+this.DV;
      else this.t = 0;
    }

    // return bigint initialized to value
    function nbv(i) { var r = nbi(); r.fromInt(i); return r; }

    // (protected) set from string and radix
    function bnpFromString(s,b) {
      var k;
      if(b == 16) k = 4;
      else if(b == 8) k = 3;
      else if(b == 256) k = 8; // byte array
      else if(b == 2) k = 1;
      else if(b == 32) k = 5;
      else if(b == 4) k = 2;
      else { this.fromRadix(s,b); return; }
      this.t = 0;
      this.s = 0;
      var i = s.length, mi = false, sh = 0;
      while(--i >= 0) {
        var x = (k==8)?s[i]&0xff:intAt(s,i);
        if(x < 0) {
          if(s.charAt(i) == "-") mi = true;
          continue;
        }
        mi = false;
        if(sh == 0)
          this[this.t++] = x;
        else if(sh+k > this.DB) {
          this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;
          this[this.t++] = (x>>(this.DB-sh));
        }
        else
          this[this.t-1] |= x<<sh;
        sh += k;
        if(sh >= this.DB) sh -= this.DB;
      }
      if(k == 8 && (s[0]&0x80) != 0) {
        this.s = -1;
        if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;
      }
      this.clamp();
      if(mi) BigInteger.ZERO.subTo(this,this);
    }

    // (protected) clamp off excess high words
    function bnpClamp() {
      var c = this.s&this.DM;
      while(this.t > 0 && this[this.t-1] == c) --this.t;
    }

    // (public) return string representation in given radix
    function bnToString(b) {
      if(this.s < 0) return "-"+this.negate().toString(b);
      var k;
      if(b == 16) k = 4;
      else if(b == 8) k = 3;
      else if(b == 2) k = 1;
      else if(b == 32) k = 5;
      else if(b == 4) k = 2;
      else return this.toRadix(b);
      var km = (1<<k)-1, d, m = false, r = "", i = this.t;
      var p = this.DB-(i*this.DB)%k;
      if(i-- > 0) {
        if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }
        while(i >= 0) {
          if(p < k) {
            d = (this[i]&((1<<p)-1))<<(k-p);
            d |= this[--i]>>(p+=this.DB-k);
          }
          else {
            d = (this[i]>>(p-=k))&km;
            if(p <= 0) { p += this.DB; --i; }
          }
          if(d > 0) m = true;
          if(m) r += int2char(d);
        }
      }
      return m?r:"0";
    }

    // (public) -this
    function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }

    // (public) |this|
    function bnAbs() { return (this.s<0)?this.negate():this; }

    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
      var r = this.s-a.s;
      if(r != 0) return r;
      var i = this.t;
      r = i-a.t;
      if(r != 0) return (this.s<0)?-r:r;
      while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;
      return 0;
    }

    // returns bit length of the integer x
    function nbits(x) {
      var r = 1, t;
      if((t=x>>>16) != 0) { x = t; r += 16; }
      if((t=x>>8) != 0) { x = t; r += 8; }
      if((t=x>>4) != 0) { x = t; r += 4; }
      if((t=x>>2) != 0) { x = t; r += 2; }
      if((t=x>>1) != 0) { x = t; r += 1; }
      return r;
    }

    // (public) return the number of bits in "this"
    function bnBitLength() {
      if(this.t <= 0) return 0;
      return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));
    }

    // (protected) r = this << n*DB
    function bnpDLShiftTo(n,r) {
      var i;
      for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];
      for(i = n-1; i >= 0; --i) r[i] = 0;
      r.t = this.t+n;
      r.s = this.s;
    }

    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n,r) {
      for(var i = n; i < this.t; ++i) r[i-n] = this[i];
      r.t = Math.max(this.t-n,0);
      r.s = this.s;
    }

    // (protected) r = this << n
    function bnpLShiftTo(n,r) {
      var bs = n%this.DB;
      var cbs = this.DB-bs;
      var bm = (1<<cbs)-1;
      var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;
      for(i = this.t-1; i >= 0; --i) {
        r[i+ds+1] = (this[i]>>cbs)|c;
        c = (this[i]&bm)<<bs;
      }
      for(i = ds-1; i >= 0; --i) r[i] = 0;
      r[ds] = c;
      r.t = this.t+ds+1;
      r.s = this.s;
      r.clamp();
    }

    // (protected) r = this >> n
    function bnpRShiftTo(n,r) {
      r.s = this.s;
      var ds = Math.floor(n/this.DB);
      if(ds >= this.t) { r.t = 0; return; }
      var bs = n%this.DB;
      var cbs = this.DB-bs;
      var bm = (1<<bs)-1;
      r[0] = this[ds]>>bs;
      for(var i = ds+1; i < this.t; ++i) {
        r[i-ds-1] |= (this[i]&bm)<<cbs;
        r[i-ds] = this[i]>>bs;
      }
      if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;
      r.t = this.t-ds;
      r.clamp();
    }

    // (protected) r = this - a
    function bnpSubTo(a,r) {
      var i = 0, c = 0, m = Math.min(a.t,this.t);
      while(i < m) {
        c += this[i]-a[i];
        r[i++] = c&this.DM;
        c >>= this.DB;
      }
      if(a.t < this.t) {
        c -= a.s;
        while(i < this.t) {
          c += this[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c += this.s;
      }
      else {
        c += this.s;
        while(i < a.t) {
          c -= a[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c -= a.s;
      }
      r.s = (c<0)?-1:0;
      if(c < -1) r[i++] = this.DV+c;
      else if(c > 0) r[i++] = c;
      r.t = i;
      r.clamp();
    }

    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a,r) {
      var x = this.abs(), y = a.abs();
      var i = x.t;
      r.t = i+y.t;
      while(--i >= 0) r[i] = 0;
      for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);
      r.s = 0;
      r.clamp();
      if(this.s != a.s) BigInteger.ZERO.subTo(r,r);
    }

    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
      var x = this.abs();
      var i = r.t = 2*x.t;
      while(--i >= 0) r[i] = 0;
      for(i = 0; i < x.t-1; ++i) {
        var c = x.am(i,x[i],r,2*i,0,1);
        if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {
          r[i+x.t] -= x.DV;
          r[i+x.t+1] = 1;
        }
      }
      if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);
      r.s = 0;
      r.clamp();
    }

    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m,q,r) {
      var pm = m.abs();
      if(pm.t <= 0) return;
      var pt = this.abs();
      if(pt.t < pm.t) {
        if(q != null) q.fromInt(0);
        if(r != null) this.copyTo(r);
        return;
      }
      if(r == null) r = nbi();
      var y = nbi(), ts = this.s, ms = m.s;
      var nsh = this.DB-nbits(pm[pm.t-1]);   // normalize modulus
      if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }
      else { pm.copyTo(y); pt.copyTo(r); }
      var ys = y.t;
      var y0 = y[ys-1];
      if(y0 == 0) return;
      var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);
      var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;
      var i = r.t, j = i-ys, t = (q==null)?nbi():q;
      y.dlShiftTo(j,t);
      if(r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t,r);
      }
      BigInteger.ONE.dlShiftTo(ys,t);
      t.subTo(y,y);  // "negative" y so we can replace sub with am later
      while(y.t < ys) y[y.t++] = 0;
      while(--j >= 0) {
        // Estimate quotient digit
        var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);
        if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {   // Try it out
          y.dlShiftTo(j,t);
          r.subTo(t,r);
          while(r[i] < --qd) r.subTo(t,r);
        }
      }
      if(q != null) {
        r.drShiftTo(ys,q);
        if(ts != ms) BigInteger.ZERO.subTo(q,q);
      }
      r.t = ys;
      r.clamp();
      if(nsh > 0) r.rShiftTo(nsh,r); // Denormalize remainder
      if(ts < 0) BigInteger.ZERO.subTo(r,r);
    }

    // (public) this mod a
    function bnMod(a) {
      var r = nbi();
      this.abs().divRemTo(a,null,r);
      if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);
      return r;
    }

    // Modular reduction using "classic" algorithm
    function Classic(m) { this.m = m; }
    function cConvert(x) {
      if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
      else return x;
    }
    function cRevert(x) { return x; }
    function cReduce(x) { x.divRemTo(this.m,null,x); }
    function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
    function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;

    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
      if(this.t < 1) return 0;
      var x = this[0];
      if((x&1) == 0) return 0;
      var y = x&3;       // y == 1/x mod 2^2
      y = (y*(2-(x&0xf)*y))&0xf; // y == 1/x mod 2^4
      y = (y*(2-(x&0xff)*y))&0xff;   // y == 1/x mod 2^8
      y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;    // y == 1/x mod 2^16
      // last step - calculate inverse mod DV directly;
      // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
      y = (y*(2-x*y%this.DV))%this.DV;       // y == 1/x mod 2^dbits
      // we really want the negative inverse, and -DV < y < DV
      return (y>0)?this.DV-y:-y;
    }

    // Montgomery reduction
    function Montgomery(m) {
      this.m = m;
      this.mp = m.invDigit();
      this.mpl = this.mp&0x7fff;
      this.mph = this.mp>>15;
      this.um = (1<<(m.DB-15))-1;
      this.mt2 = 2*m.t;
    }

    // xR mod m
    function montConvert(x) {
      var r = nbi();
      x.abs().dlShiftTo(this.m.t,r);
      r.divRemTo(this.m,null,r);
      if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);
      return r;
    }

    // x/R mod m
    function montRevert(x) {
      var r = nbi();
      x.copyTo(r);
      this.reduce(r);
      return r;
    }

    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
      while(x.t <= this.mt2) // pad x so am has enough room later
        x[x.t++] = 0;
      for(var i = 0; i < this.m.t; ++i) {
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i]&0x7fff;
        var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i+this.m.t;
        x[j] += this.m.am(0,u0,x,i,0,this.m.t);
        // propagate carry
        while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }
      }
      x.clamp();
      x.drShiftTo(this.m.t,x);
      if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
    }

    // r = "x^2/R mod m"; x != r
    function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

    // r = "xy/R mod m"; x,y != r
    function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;

    // (protected) true iff this is even
    function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }

    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e,z) {
      if(e > 0xffffffff || e < 1) return BigInteger.ONE;
      var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;
      g.copyTo(r);
      while(--i >= 0) {
        z.sqrTo(r,r2);
        if((e&(1<<i)) > 0) z.mulTo(r2,g,r);
        else { var t = r; r = r2; r2 = t; }
      }
      return z.revert(r);
    }

    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e,m) {
      var z;
      if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);
      return this.exp(e,z);
    }

    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;

    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;

    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);

    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.

    // Extended JavaScript BN functions, required for RSA private ops.

    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix

    // (public)
    function bnClone() { var r = nbi(); this.copyTo(r); return r; }

    // (public) return value as integer
    function bnIntValue() {
      if(this.s < 0) {
        if(this.t == 1) return this[0]-this.DV;
        else if(this.t == 0) return -1;
      }
      else if(this.t == 1) return this[0];
      else if(this.t == 0) return 0;
      // assumes 16 < DB < 32
      return ((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];
    }

    // (public) return value as byte
    function bnByteValue() { return (this.t==0)?this.s:(this[0]<<24)>>24; }

    // (public) return value as short (assumes DB>=16)
    function bnShortValue() { return (this.t==0)?this.s:(this[0]<<16)>>16; }

    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) { return Math.floor(Math.LN2*this.DB/Math.log(r)); }

    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
      if(this.s < 0) return -1;
      else if(this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;
      else return 1;
    }

    // (protected) convert to radix string
    function bnpToRadix(b) {
      if(b == null) b = 10;
      if(this.signum() == 0 || b < 2 || b > 36) return "0";
      var cs = this.chunkSize(b);
      var a = Math.pow(b,cs);
      var d = nbv(a), y = nbi(), z = nbi(), r = "";
      this.divRemTo(d,y,z);
      while(y.signum() > 0) {
        r = (a+z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d,y,z);
      }
      return z.intValue().toString(b) + r;
    }

    // (protected) convert from radix string
    function bnpFromRadix(s,b) {
      this.fromInt(0);
      if(b == null) b = 10;
      var cs = this.chunkSize(b);
      var d = Math.pow(b,cs), mi = false, j = 0, w = 0;
      for(var i = 0; i < s.length; ++i) {
        var x = intAt(s,i);
        if(x < 0) {
          if(s.charAt(i) == "-" && this.signum() == 0) mi = true;
          continue;
        }
        w = b*w+x;
        if(++j >= cs) {
          this.dMultiply(d);
          this.dAddOffset(w,0);
          j = 0;
          w = 0;
        }
      }
      if(j > 0) {
        this.dMultiply(Math.pow(b,j));
        this.dAddOffset(w,0);
      }
      if(mi) BigInteger.ZERO.subTo(this,this);
    }

    // (protected) alternate constructor
    function bnpFromNumber(a,b,c) {
      if("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if(a < 2) this.fromInt(1);
        else {
          this.fromNumber(a,c);
          if(!this.testBit(a-1))	// force MSB set
            this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);
          if(this.isEven()) this.dAddOffset(1,0); // force odd
          while(!this.isProbablePrime(b)) {
            this.dAddOffset(2,0);
            if(this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a-1),this);
          }
        }
      }
      else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a&7;
        x.length = (a>>3)+1;
        b.nextBytes(x);
        if(t > 0) x[0] &= ((1<<t)-1); else x[0] = 0;
        this.fromString(x,256);
      }
    }

    // (public) convert to bigendian byte array
    function bnToByteArray() {
      var i = this.t, r = new Array();
      r[0] = this.s;
      var p = this.DB-(i*this.DB)%8, d, k = 0;
      if(i-- > 0) {
        if(p < this.DB && (d = this[i]>>p) != (this.s&this.DM)>>p)
          r[k++] = d|(this.s<<(this.DB-p));
        while(i >= 0) {
          if(p < 8) {
            d = (this[i]&((1<<p)-1))<<(8-p);
            d |= this[--i]>>(p+=this.DB-8);
          }
          else {
            d = (this[i]>>(p-=8))&0xff;
            if(p <= 0) { p += this.DB; --i; }
          }
          if((d&0x80) != 0) d |= -256;
          if(k == 0 && (this.s&0x80) != (d&0x80)) ++k;
          if(k > 0 || d != this.s) r[k++] = d;
        }
      }
      return r;
    }

    function bnEquals(a) { return(this.compareTo(a)==0); }
    function bnMin(a) { return(this.compareTo(a)<0)?this:a; }
    function bnMax(a) { return(this.compareTo(a)>0)?this:a; }

    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a,op,r) {
      var i, f, m = Math.min(a.t,this.t);
      for(i = 0; i < m; ++i) r[i] = op(this[i],a[i]);
      if(a.t < this.t) {
        f = a.s&this.DM;
        for(i = m; i < this.t; ++i) r[i] = op(this[i],f);
        r.t = this.t;
      }
      else {
        f = this.s&this.DM;
        for(i = m; i < a.t; ++i) r[i] = op(f,a[i]);
        r.t = a.t;
      }
      r.s = op(this.s,a.s);
      r.clamp();
    }

    // (public) this & a
    function op_and(x,y) { return x&y; }
    function bnAnd(a) { var r = nbi(); this.bitwiseTo(a,op_and,r); return r; }

    // (public) this | a
    function op_or(x,y) { return x|y; }
    function bnOr(a) { var r = nbi(); this.bitwiseTo(a,op_or,r); return r; }

    // (public) this ^ a
    function op_xor(x,y) { return x^y; }
    function bnXor(a) { var r = nbi(); this.bitwiseTo(a,op_xor,r); return r; }

    // (public) this & ~a
    function op_andnot(x,y) { return x&~y; }
    function bnAndNot(a) { var r = nbi(); this.bitwiseTo(a,op_andnot,r); return r; }

    // (public) ~this
    function bnNot() {
      var r = nbi();
      for(var i = 0; i < this.t; ++i) r[i] = this.DM&~this[i];
      r.t = this.t;
      r.s = ~this.s;
      return r;
    }

    // (public) this << n
    function bnShiftLeft(n) {
      var r = nbi();
      if(n < 0) this.rShiftTo(-n,r); else this.lShiftTo(n,r);
      return r;
    }

    // (public) this >> n
    function bnShiftRight(n) {
      var r = nbi();
      if(n < 0) this.lShiftTo(-n,r); else this.rShiftTo(n,r);
      return r;
    }

    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
      if(x == 0) return -1;
      var r = 0;
      if((x&0xffff) == 0) { x >>= 16; r += 16; }
      if((x&0xff) == 0) { x >>= 8; r += 8; }
      if((x&0xf) == 0) { x >>= 4; r += 4; }
      if((x&3) == 0) { x >>= 2; r += 2; }
      if((x&1) == 0) ++r;
      return r;
    }

    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
      for(var i = 0; i < this.t; ++i)
        if(this[i] != 0) return i*this.DB+lbit(this[i]);
      if(this.s < 0) return this.t*this.DB;
      return -1;
    }

    // return number of 1 bits in x
    function cbit(x) {
      var r = 0;
      while(x != 0) { x &= x-1; ++r; }
      return r;
    }

    // (public) return number of set bits
    function bnBitCount() {
      var r = 0, x = this.s&this.DM;
      for(var i = 0; i < this.t; ++i) r += cbit(this[i]^x);
      return r;
    }

    // (public) true iff nth bit is set
    function bnTestBit(n) {
      var j = Math.floor(n/this.DB);
      if(j >= this.t) return(this.s!=0);
      return((this[j]&(1<<(n%this.DB)))!=0);
    }

    // (protected) this op (1<<n)
    function bnpChangeBit(n,op) {
      var r = BigInteger.ONE.shiftLeft(n);
      this.bitwiseTo(r,op,r);
      return r;
    }

    // (public) this | (1<<n)
    function bnSetBit(n) { return this.changeBit(n,op_or); }

    // (public) this & ~(1<<n)
    function bnClearBit(n) { return this.changeBit(n,op_andnot); }

    // (public) this ^ (1<<n)
    function bnFlipBit(n) { return this.changeBit(n,op_xor); }

    // (protected) r = this + a
    function bnpAddTo(a,r) {
      var i = 0, c = 0, m = Math.min(a.t,this.t);
      while(i < m) {
        c += this[i]+a[i];
        r[i++] = c&this.DM;
        c >>= this.DB;
      }
      if(a.t < this.t) {
        c += a.s;
        while(i < this.t) {
          c += this[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c += this.s;
      }
      else {
        c += this.s;
        while(i < a.t) {
          c += a[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c += a.s;
      }
      r.s = (c<0)?-1:0;
      if(c > 0) r[i++] = c;
      else if(c < -1) r[i++] = this.DV+c;
      r.t = i;
      r.clamp();
    }

    // (public) this + a
    function bnAdd(a) { var r = nbi(); this.addTo(a,r); return r; }

    // (public) this - a
    function bnSubtract(a) { var r = nbi(); this.subTo(a,r); return r; }

    // (public) this * a
    function bnMultiply(a) { var r = nbi(); this.multiplyTo(a,r); return r; }

    // (public) this^2
    function bnSquare() { var r = nbi(); this.squareTo(r); return r; }

    // (public) this / a
    function bnDivide(a) { var r = nbi(); this.divRemTo(a,r,null); return r; }

    // (public) this % a
    function bnRemainder(a) { var r = nbi(); this.divRemTo(a,null,r); return r; }

    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
      var q = nbi(), r = nbi();
      this.divRemTo(a,q,r);
      return new Array(q,r);
    }

    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
      this[this.t] = this.am(0,n-1,this,0,0,this.t);
      ++this.t;
      this.clamp();
    }

    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n,w) {
      if(n == 0) return;
      while(this.t <= w) this[this.t++] = 0;
      this[w] += n;
      while(this[w] >= this.DV) {
        this[w] -= this.DV;
        if(++w >= this.t) this[this.t++] = 0;
        ++this[w];
      }
    }

    // A "null" reducer
    function NullExp() {}
    function nNop(x) { return x; }
    function nMulTo(x,y,r) { x.multiplyTo(y,r); }
    function nSqrTo(x,r) { x.squareTo(r); }

    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;

    // (public) this^e
    function bnPow(e) { return this.exp(e,new NullExp()); }

    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a,n,r) {
      var i = Math.min(this.t+a.t,n);
      r.s = 0; // assumes a,this >= 0
      r.t = i;
      while(i > 0) r[--i] = 0;
      var j;
      for(j = r.t-this.t; i < j; ++i) r[i+this.t] = this.am(0,a[i],r,i,0,this.t);
      for(j = Math.min(a.t,n); i < j; ++i) this.am(0,a[i],r,i,0,n-i);
      r.clamp();
    }

    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a,n,r) {
      --n;
      var i = r.t = this.t+a.t-n;
      r.s = 0; // assumes a,this >= 0
      while(--i >= 0) r[i] = 0;
      for(i = Math.max(n-this.t,0); i < a.t; ++i)
        r[this.t+i-n] = this.am(n-i,a[i],r,0,0,this.t+i-n);
      r.clamp();
      r.drShiftTo(1,r);
    }

    // Barrett modular reduction
    function Barrett(m) {
      // setup Barrett
      this.r2 = nbi();
      this.q3 = nbi();
      BigInteger.ONE.dlShiftTo(2*m.t,this.r2);
      this.mu = this.r2.divide(m);
      this.m = m;
    }

    function barrettConvert(x) {
      if(x.s < 0 || x.t > 2*this.m.t) return x.mod(this.m);
      else if(x.compareTo(this.m) < 0) return x;
      else { var r = nbi(); x.copyTo(r); this.reduce(r); return r; }
    }

    function barrettRevert(x) { return x; }

    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
      x.drShiftTo(this.m.t-1,this.r2);
      if(x.t > this.m.t+1) { x.t = this.m.t+1; x.clamp(); }
      this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);
      this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);
      while(x.compareTo(this.r2) < 0) x.dAddOffset(1,this.m.t+1);
      x.subTo(this.r2,x);
      while(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
    }

    // r = x^2 mod m; x != r
    function barrettSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

    // r = x*y mod m; x,y != r
    function barrettMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;

    // (public) this^e % m (HAC 14.85)
    function bnModPow(e,m) {
      var i = e.bitLength(), k, r = nbv(1), z;
      if(i <= 0) return r;
      else if(i < 18) k = 1;
      else if(i < 48) k = 3;
      else if(i < 144) k = 4;
      else if(i < 768) k = 5;
      else k = 6;
      if(i < 8)
        z = new Classic(m);
      else if(m.isEven())
        z = new Barrett(m);
      else
        z = new Montgomery(m);

      // precomputation
      var g = new Array(), n = 3, k1 = k-1, km = (1<<k)-1;
      g[1] = z.convert(this);
      if(k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1],g2);
        while(n <= km) {
          g[n] = nbi();
          z.mulTo(g2,g[n-2],g[n]);
          n += 2;
        }
      }

      var j = e.t-1, w, is1 = true, r2 = nbi(), t;
      i = nbits(e[j])-1;
      while(j >= 0) {
        if(i >= k1) w = (e[j]>>(i-k1))&km;
        else {
          w = (e[j]&((1<<(i+1))-1))<<(k1-i);
          if(j > 0) w |= e[j-1]>>(this.DB+i-k1);
        }

        n = k;
        while((w&1) == 0) { w >>= 1; --n; }
        if((i -= n) < 0) { i += this.DB; --j; }
        if(is1) {	// ret == 1, don't bother squaring or multiplying it
          g[w].copyTo(r);
          is1 = false;
        }
        else {
          while(n > 1) { z.sqrTo(r,r2); z.sqrTo(r2,r); n -= 2; }
          if(n > 0) z.sqrTo(r,r2); else { t = r; r = r2; r2 = t; }
          z.mulTo(r2,g[w],r);
        }

        while(j >= 0 && (e[j]&(1<<i)) == 0) {
          z.sqrTo(r,r2); t = r; r = r2; r2 = t;
          if(--i < 0) { i = this.DB-1; --j; }
        }
      }
      return z.revert(r);
    }

    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
      var x = (this.s<0)?this.negate():this.clone();
      var y = (a.s<0)?a.negate():a.clone();
      if(x.compareTo(y) < 0) { var t = x; x = y; y = t; }
      var i = x.getLowestSetBit(), g = y.getLowestSetBit();
      if(g < 0) return x;
      if(i < g) g = i;
      if(g > 0) {
        x.rShiftTo(g,x);
        y.rShiftTo(g,y);
      }
      while(x.signum() > 0) {
        if((i = x.getLowestSetBit()) > 0) x.rShiftTo(i,x);
        if((i = y.getLowestSetBit()) > 0) y.rShiftTo(i,y);
        if(x.compareTo(y) >= 0) {
          x.subTo(y,x);
          x.rShiftTo(1,x);
        }
        else {
          y.subTo(x,y);
          y.rShiftTo(1,y);
        }
      }
      if(g > 0) y.lShiftTo(g,y);
      return y;
    }

    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
      if(n <= 0) return 0;
      var d = this.DV%n, r = (this.s<0)?n-1:0;
      if(this.t > 0)
        if(d == 0) r = this[0]%n;
        else for(var i = this.t-1; i >= 0; --i) r = (d*r+this[i])%n;
      return r;
    }

    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
      var ac = m.isEven();
      if((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;
      var u = m.clone(), v = this.clone();
      var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
      while(u.signum() != 0) {
        while(u.isEven()) {
          u.rShiftTo(1,u);
          if(ac) {
            if(!a.isEven() || !b.isEven()) { a.addTo(this,a); b.subTo(m,b); }
            a.rShiftTo(1,a);
          }
          else if(!b.isEven()) b.subTo(m,b);
          b.rShiftTo(1,b);
        }
        while(v.isEven()) {
          v.rShiftTo(1,v);
          if(ac) {
            if(!c.isEven() || !d.isEven()) { c.addTo(this,c); d.subTo(m,d); }
            c.rShiftTo(1,c);
          }
          else if(!d.isEven()) d.subTo(m,d);
          d.rShiftTo(1,d);
        }
        if(u.compareTo(v) >= 0) {
          u.subTo(v,u);
          if(ac) a.subTo(c,a);
          b.subTo(d,b);
        }
        else {
          v.subTo(u,v);
          if(ac) c.subTo(a,c);
          d.subTo(b,d);
        }
      }
      if(v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
      if(d.compareTo(m) >= 0) return d.subtract(m);
      if(d.signum() < 0) d.addTo(m,d); else return d;
      if(d.signum() < 0) return d.add(m); else return d;
    }

    var lowprimes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];
    var lplim = (1<<26)/lowprimes[lowprimes.length-1];

    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
      var i, x = this.abs();
      if(x.t == 1 && x[0] <= lowprimes[lowprimes.length-1]) {
        for(i = 0; i < lowprimes.length; ++i)
          if(x[0] == lowprimes[i]) return true;
        return false;
      }
      if(x.isEven()) return false;
      i = 1;
      while(i < lowprimes.length) {
        var m = lowprimes[i], j = i+1;
        while(j < lowprimes.length && m < lplim) m *= lowprimes[j++];
        m = x.modInt(m);
        while(i < j) if(m%lowprimes[i++] == 0) return false;
      }
      return x.millerRabin(t);
    }

    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
      var n1 = this.subtract(BigInteger.ONE);
      var k = n1.getLowestSetBit();
      if(k <= 0) return false;
      var r = n1.shiftRight(k);
      t = (t+1)>>1;
      if(t > lowprimes.length) t = lowprimes.length;
      var a = nbi();
      for(var i = 0; i < t; ++i) {
        //Pick bases at random, instead of starting at 2
        a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);
        var y = a.modPow(r,this);
        if(y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
          var j = 1;
          while(j++ < k && y.compareTo(n1) != 0) {
            y = y.modPowInt(2,this);
            if(y.compareTo(BigInteger.ONE) == 0) return false;
          }
          if(y.compareTo(n1) != 0) return false;
        }
      }
      return true;
    }

    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;

    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;

    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;

    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett

    // BigInteger interfaces not implemented in jsbn:

    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)

	// Random number generator - requires a PRNG backend, e.g. prng4.js

	// For best results, put code like
	// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
	// in your main HTML document.

	var rng_state;
	var rng_pool;
	var rng_pptr;

	// Mix in a 32-bit integer into the pool
	function rng_seed_int(x) {
	  rng_pool[rng_pptr++] ^= x & 255;
	  rng_pool[rng_pptr++] ^= (x >> 8) & 255;
	  rng_pool[rng_pptr++] ^= (x >> 16) & 255;
	  rng_pool[rng_pptr++] ^= (x >> 24) & 255;
	  if(rng_pptr >= rng_psize) rng_pptr -= rng_psize;
	}

	// Mix in the current time (w/milliseconds) into the pool
	function rng_seed_time() {
	  rng_seed_int(new Date().getTime());
	}

	// Initialize the pool with junk if needed.
	if(rng_pool == null) {
	  rng_pool = new Array();
	  rng_pptr = 0;
	  var t;
	  if(typeof window !== "undefined" && window.crypto) {
		if (window.crypto.getRandomValues) {
		  // Use webcrypto if available
		  var ua = new Uint8Array(32);
		  window.crypto.getRandomValues(ua);
		  for(t = 0; t < 32; ++t)
			rng_pool[rng_pptr++] = ua[t];
		}
		else if(navigator.appName == "Netscape" && navigator.appVersion < "5") {
		  // Extract entropy (256 bits) from NS4 RNG if available
		  var z = window.crypto.random(32);
		  for(t = 0; t < z.length; ++t)
			rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
		}
	  }
	  while(rng_pptr < rng_psize) {  // extract some randomness from Math.random()
		t = Math.floor(65536 * Math.random());
		rng_pool[rng_pptr++] = t >>> 8;
		rng_pool[rng_pptr++] = t & 255;
	  }
	  rng_pptr = 0;
	  rng_seed_time();
	  //rng_seed_int(window.screenX);
	  //rng_seed_int(window.screenY);
	}

	function rng_get_byte() {
	  if(rng_state == null) {
		rng_seed_time();
		rng_state = prng_newstate();
		rng_state.init(rng_pool);
		for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
		  rng_pool[rng_pptr] = 0;
		rng_pptr = 0;
		//rng_pool = null;
	  }
	  // TODO: allow reseeding after first request
	  return rng_state.next();
	}

	function rng_get_bytes(ba) {
	  var i;
	  for(i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();
	}

	function SecureRandom() {}

	SecureRandom.prototype.nextBytes = rng_get_bytes;

	// prng4.js - uses Arcfour as a PRNG

	function Arcfour() {
	  this.i = 0;
	  this.j = 0;
	  this.S = new Array();
	}

	// Initialize arcfour context from key, an array of ints, each from [0..255]
	function ARC4init(key) {
	  var i, j, t;
	  for(i = 0; i < 256; ++i)
		this.S[i] = i;
	  j = 0;
	  for(i = 0; i < 256; ++i) {
		j = (j + this.S[i] + key[i % key.length]) & 255;
		t = this.S[i];
		this.S[i] = this.S[j];
		this.S[j] = t;
	  }
	  this.i = 0;
	  this.j = 0;
	}

	function ARC4next() {
	  var t;
	  this.i = (this.i + 1) & 255;
	  this.j = (this.j + this.S[this.i]) & 255;
	  t = this.S[this.i];
	  this.S[this.i] = this.S[this.j];
	  this.S[this.j] = t;
	  return this.S[(t + this.S[this.i]) & 255];
	}

	Arcfour.prototype.init = ARC4init;
	Arcfour.prototype.next = ARC4next;

	// Plug in your RNG constructor here
	function prng_newstate() {
	  return new Arcfour();
	}

	// Pool size must be a multiple of 4 and greater than 32.
	// An array of bytes the size of the pool will be passed to init()
	var rng_psize = 256;

  BigInteger.SecureRandom = SecureRandom;
  BigInteger.BigInteger = BigInteger;
  if (true) {
    exports = module.exports = BigInteger;
  } else {
    this.BigInteger = BigInteger;
    this.SecureRandom = SecureRandom;
  }

}).call(this);


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(818),
    hashDelete = __webpack_require__(819),
    hashGet = __webpack_require__(820),
    hashHas = __webpack_require__(821),
    hashSet = __webpack_require__(822);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(62),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(170),
    setCacheAdd = __webpack_require__(851),
    setCacheHas = __webpack_require__(852);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 767 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(775);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(104),
    keysIn = __webpack_require__(328);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(175),
    isFlattenable = __webpack_require__(827);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(772),
    baseIsNaN = __webpack_require__(779),
    strictIndexOf = __webpack_require__(858);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isObjectLike = __webpack_require__(63);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(171),
    equalArrays = __webpack_require__(304),
    equalByTag = __webpack_require__(810),
    equalObjects = __webpack_require__(811),
    getTag = __webpack_require__(312),
    isArray = __webpack_require__(26),
    isBuffer = __webpack_require__(190),
    isTypedArray = __webpack_require__(327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(171),
    baseIsEqual = __webpack_require__(296);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 779 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(191),
    isMasked = __webpack_require__(830),
    isObject = __webpack_require__(55),
    toSource = __webpack_require__(324);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    isLength = __webpack_require__(192),
    isObjectLike = __webpack_require__(63);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(784),
    baseMatchesProperty = __webpack_require__(785),
    identity = __webpack_require__(188),
    isArray = __webpack_require__(26),
    property = __webpack_require__(879);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55),
    isPrototype = __webpack_require__(185),
    nativeKeysIn = __webpack_require__(844);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(778),
    getMatchData = __webpack_require__(813),
    matchesStrictComparable = __webpack_require__(315);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(296),
    get = __webpack_require__(871),
    hasIn = __webpack_require__(872),
    isKey = __webpack_require__(184),
    isStrictComparable = __webpack_require__(313),
    matchesStrictComparable = __webpack_require__(315),
    toKey = __webpack_require__(82);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(177);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(863),
    defineProperty = __webpack_require__(303),
    identity = __webpack_require__(188);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    arrayMap = __webpack_require__(174),
    isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(105);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    last = __webpack_require__(875),
    parent = __webpack_require__(848),
    toKey = __webpack_require__(82);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(179);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(766),
    arrayReduce = __webpack_require__(291),
    mapToArray = __webpack_require__(314);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(767),
    arrayReduce = __webpack_require__(291),
    setToArray = __webpack_require__(319);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(179);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(104),
    getSymbols = __webpack_require__(182);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(104),
    getSymbolsIn = __webpack_require__(311);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 805 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(129),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(172),
    createCtor = __webpack_require__(129),
    createHybrid = __webpack_require__(301),
    createRecurry = __webpack_require__(302),
    getHolder = __webpack_require__(310),
    replaceHolders = __webpack_require__(186),
    root = __webpack_require__(23);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(172),
    createCtor = __webpack_require__(129),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(873);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    Uint8Array = __webpack_require__(288),
    eq = __webpack_require__(187),
    equalArrays = __webpack_require__(304),
    mapToArray = __webpack_require__(314),
    setToArray = __webpack_require__(319);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(307);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(849);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(313),
    keys = __webpack_require__(132);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 815 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 816 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    isArguments = __webpack_require__(189),
    isArray = __webpack_require__(26),
    isIndex = __webpack_require__(183),
    isLength = __webpack_require__(192),
    toKey = __webpack_require__(82);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(131);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 819 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(131);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(131);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(131);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 823 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(179),
    cloneDataView = __webpack_require__(796),
    cloneMap = __webpack_require__(797),
    cloneRegExp = __webpack_require__(798),
    cloneSet = __webpack_require__(799),
    cloneSymbol = __webpack_require__(800),
    cloneTypedArray = __webpack_require__(801);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(126),
    getPrototype = __webpack_require__(181),
    isPrototype = __webpack_require__(185);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    isArguments = __webpack_require__(189),
    isArray = __webpack_require__(26);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 828 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(168),
    getData = __webpack_require__(309),
    getFuncName = __webpack_require__(812),
    lodash = __webpack_require__(885);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(804);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 831 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(125);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(125);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(125);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(125);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(762),
    ListCache = __webpack_require__(124),
    Map = __webpack_require__(169);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(130);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(130);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(130);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(130);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(876);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(299),
    composeArgsRight = __webpack_require__(300),
    replaceHolders = __webpack_require__(186);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(317);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 844 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(306);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),
/* 846 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(172);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(177),
    baseSlice = __webpack_require__(789);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 849 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(128),
    isIndex = __webpack_require__(183);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 851 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 852 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(124);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 855 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 856 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(124),
    Map = __webpack_require__(169),
    MapCache = __webpack_require__(170);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 858 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(173),
    arrayIncludes = __webpack_require__(769);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(168),
    LodashWrapper = __webpack_require__(287),
    copyArray = __webpack_require__(128);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(180);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(176);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 863 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(180);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(773);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(867),
    fallbackHolder = __webpack_require__(325);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isFunction': util.isFunction,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isFunction = helpers.isFunction,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null) {
        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 867 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(861),
  'assign': __webpack_require__(293),
  'clone': __webpack_require__(862),
  'curry': __webpack_require__(864),
  'forEach': __webpack_require__(173),
  'isArray': __webpack_require__(26),
  'isFunction': __webpack_require__(191),
  'iteratee': __webpack_require__(874),
  'keys': __webpack_require__(297),
  'rearg': __webpack_require__(880),
  'toInteger': __webpack_require__(330),
  'toPath': __webpack_require__(884)
};


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(866),
    util = __webpack_require__(868);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(869),
    func = convert('omit', __webpack_require__(878));

func.placeholder = __webpack_require__(325);
module.exports = func;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(177);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(774),
    hasPath = __webpack_require__(817);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(81),
    getPrototype = __webpack_require__(181),
    isObjectLike = __webpack_require__(63);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(176),
    baseIteratee = __webpack_require__(782);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 875 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(170);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 877 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(174),
    baseClone = __webpack_require__(176),
    baseUnset = __webpack_require__(793),
    castPath = __webpack_require__(127),
    copyObject = __webpack_require__(104),
    customOmitClone = __webpack_require__(809),
    flatRest = __webpack_require__(305),
    getAllKeysIn = __webpack_require__(308);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(786),
    basePropertyDeep = __webpack_require__(787),
    isKey = __webpack_require__(184),
    toKey = __webpack_require__(82);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(180),
    flatRest = __webpack_require__(305);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 881 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(883);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55),
    isSymbol = __webpack_require__(105);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(174),
    copyArray = __webpack_require__(128),
    isArray = __webpack_require__(26),
    isSymbol = __webpack_require__(105),
    stringToPath = __webpack_require__(323),
    toKey = __webpack_require__(82),
    toString = __webpack_require__(331);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(168),
    LodashWrapper = __webpack_require__(287),
    baseLodash = __webpack_require__(178),
    isArray = __webpack_require__(26),
    isObjectLike = __webpack_require__(63),
    wrapperClone = __webpack_require__(860);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */

;(function() {

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
  nptable: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
  table: noop,
  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
  text: /^[^\n]+/
};

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = replace(block.item, 'gm')
  (/bull/g, block.bullet)
  ();

block.list = replace(block.list)
  (/bull/g, block.bullet)
  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
  ('def', '\\n+(?=' + block.def.source + ')')
  ();

block.blockquote = replace(block.blockquote)
  ('def', block.def)
  ();

block._tag = '(?!(?:'
  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';

block.html = replace(block.html)
  ('comment', /<!--[\s\S]*?-->/)
  ('closed', /<(tag)[\s\S]+?<\/\1>/)
  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
  (/tag/g, block._tag)
  ();

block.paragraph = replace(block.paragraph)
  ('hr', block.hr)
  ('heading', block.heading)
  ('lheading', block.lheading)
  ('blockquote', block.blockquote)
  ('tag', '<' + block._tag)
  ('def', block.def)
  ();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = replace(block.paragraph)
  ('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  ();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = {};
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top, bq) {
  var src = src.replace(/^ +$/gm, '')
    , next
    , loose
    , cap
    , bull
    , b
    , item
    , space
    , i
    , l;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? cap.replace(/\n+$/, '')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i].split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top, true);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];

      this.tokens.push({
        type: 'list_start',
        ordered: bull.length > 1
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        this.tokens.push({
          type: loose
            ? 'loose_item_start'
            : 'list_item_start'
        });

        // Recurse.
        this.token(item, false, bq);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.links[cap[1].toLowerCase()] = {
        href: cap[2],
        title: cap[3]
      };
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i]
          .replace(/^ *\| *| *\| *$/g, '')
          .split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
  autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
  url: noop,
  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
  link: /^!?\[(inside)\]\(href\)/,
  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
};

inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;

inline.link = replace(inline.link)
  ('inside', inline._inside)
  ('href', inline._href)
  ();

inline.reflink = replace(inline.reflink)
  ('inside', inline._inside)
  ();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: replace(inline.escape)('])', '~|])')(),
  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: replace(inline.text)
    (']|', '~]|')
    ('|', '|https?://|')
    ()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: replace(inline.br)('{2,}', '*')(),
  text: replace(inline.gfm.text)('{2,}', '*')()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer;
  this.renderer.options = this.options;

  if (!this.links) {
    throw new
      Error('Tokens array requires a `links` property.');
  }

  if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  } else if (this.options.pedantic) {
    this.rules = inline.pedantic;
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = ''
    , link
    , text
    , href
    , cap;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = cap[1].charAt(6) === ':'
          ? this.mangle(cap[1].substring(7))
          : this.mangle(cap[1]);
        href = this.mangle('mailto:') + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      src = src.substring(cap[0].length);
      text = escape(cap[1]);
      href = text;
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0]
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      out += this.outputLink(cap, {
        href: cap[2],
        title: cap[3]
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2], true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.text(escape(this.smartypants(cap[0])));
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = escape(link.href)
    , title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = ''
    , l = text.length
    , i = 0
    , ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || {};
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '\n</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '\n</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  return '<h'
    + level
    + ' id="'
    + this.options.headerPrefix
    + raw.toLowerCase().replace(/[^\w]+/g, '-')
    + '">'
    + text
    + '</h'
    + level
    + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered) {
  var type = ordered ? 'ol' : 'ul';
  return '<' + type + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + '<tbody>\n'
    + body
    + '</tbody>\n'
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' style="text-align:' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
      return '';
    }
  }
  var out = '<a href="' + href + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer;
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options, renderer) {
  var parser = new Parser(options, renderer);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options, this.renderer);
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        this.token.text);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = ''
        , body = ''
        , i
        , row
        , cell
        , flags
        , j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        flags = { header: true, align: this.token.align[i] };
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      var body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      var body = ''
        , ordered = this.token.ordered;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered);
    }
    case 'list_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'loose_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      var html = !this.token.pre && !this.options.pedantic
        ? this.inline.output(this.token.text)
        : this.token.text;
      return this.renderer.html(html);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
	// explicitly match decimal, hex, and named HTML entities 
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function replace(regex, opt) {
  regex = regex.source;
  opt = opt || '';
  return function self(name, val) {
    if (!name) return new RegExp(regex, opt);
    val = val.source || val;
    val = val.replace(/(^|[^\[])\^/g, '$1');
    regex = regex.replace(name, val);
    return self;
  };
}

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1
    , target
    , key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}


/**
 * Marked
 */

function marked(src, opt, callback) {
  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight
      , tokens
      , pending
      , i = 0;

    try {
      tokens = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/chjj/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occured:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.defaults = {
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  sanitizer: null,
  mangle: true,
  smartLists: false,
  silent: false,
  highlight: null,
  langPrefix: 'lang-',
  smartypants: false,
  headerPrefix: '',
  renderer: new Renderer,
  xhtml: false
};

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (true) {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  this.marked = marked;
}

}).call(function() {
  return this || (typeof window !== 'undefined' ? window : global);
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 887 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(286)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^()])+)\\))?|\\(((?:\\\\.|[^()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {String} str
 * @return {Array}
 */
function parse (str) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var suffix = res[6]
    var asterisk = res[7]

    var repeat = suffix === '+' || suffix === '*'
    var optional = suffix === '?' || suffix === '*'
    var delimiter = prefix || '/'
    var pattern = capture || group || (asterisk ? '.*' : '[^' + delimiter + ']+?')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      pattern: escapeGroup(pattern)
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {String}   str
 * @return {Function}
 */
function compile (str) {
  return tokensToFunction(parse(str))
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^' + tokens[i].pattern + '$')
    }
  }

  return function (obj) {
    var path = ''
    var data = obj || {}

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received "' + value + '"')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encodeURIComponent(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = encodeURIComponent(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {String} str
 * @return {String}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {String} group
 * @return {String}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {RegExp} re
 * @param  {Array}  keys
 * @return {RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {String}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {RegExp} path
 * @param  {Array}  keys
 * @return {RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {Array}  path
 * @param  {Array}  keys
 * @param  {Object} options
 * @return {RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {String} path
 * @param  {Array}  keys
 * @param  {Object} options
 * @return {RegExp}
 */
function stringToRegexp (path, keys, options) {
  var tokens = parse(path)
  var re = tokensToRegExp(tokens, options)

  // Attach keys back to the regexp.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] !== 'string') {
      keys.push(tokens[i])
    }
  }

  return attachKeys(re, keys)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {Array}  tokens
 * @param  {Array}  keys
 * @param  {Object} options
 * @return {RegExp}
 */
function tokensToRegExp (tokens, options) {
  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''
  var lastToken = tokens[tokens.length - 1]
  var endsWithSlash = typeof lastToken === 'string' && /\/$/.test(lastToken)

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = token.pattern

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (prefix) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithSlash ? route.slice(0, -2) : route) + '(?:\\/(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithSlash ? '' : '(?=\\/|$)'
  }

  return new RegExp('^' + route, flags(options))
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(String|RegExp|Array)} path
 * @param  {Array}                 [keys]
 * @param  {Object}                [options]
 * @return {RegExp}
 */
function pathToRegexp (path, keys, options) {
  keys = keys || []

  if (!isarray(keys)) {
    options = keys
    keys = []
  } else if (!options) {
    options = {}
  }

  if (path instanceof RegExp) {
    return regexpToRegexp(path, keys, options)
  }

  if (isarray(path)) {
    return arrayToRegexp(path, keys, options)
  }

  return stringToRegexp(path, keys, options)
}


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(32);
var invariant = __webpack_require__(5);
var ReactPropTypesSecret = __webpack_require__(333);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(32);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

var ReactPropTypesSecret = __webpack_require__(333);
var checkPropTypes = __webpack_require__(889);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"notfound-container\"\u003E\u003Cdiv class=\"notfound-orbits\"\u003E\u003Cdiv class=\"orbit1\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"orbit2\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"orbit3\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"orbit4\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"notfound-content\"\u003E\u003Ch1 class=\"title\"\u003E404\u003C\u002Fh1\u003E\u003Cp class=\"description\"\u003ESorry, the page you were looking for doesn't exist.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"notfound-particles\"\u003E";
for(var x = 0;x <= 11;x++)
{
pug_html = pug_html + "\u003Cdiv class=\"notfound-particle\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math) {var rand  = Math.random();
var lockSlideActive = rand > 0.3 ? 'active' : '';
var auth0SlideActive = rand <= 0.3 ? 'active' : '';
pug_mixins["slide_right"] = pug_interp = function(feature_article, subtitle_article, description_article, learn_more_url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"slide-right\"\u003E\u003Cdiv class=\"article-content\"\u003E\u003Ch3 class=\"article-type\"\u003E" + (pug.escape(null == (pug_interp = feature_article) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Ch4 class=\"article-title\"\u003E" + (pug.escape(null == (pug_interp = subtitle_article) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E\u003Cp class=\"article-description\"\u003E" + (pug.escape(null == (pug_interp = description_article) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"article-footer\"\u003E\u003Ca" + (" class=\"article-more\""+pug.attr("href", learn_more_url, true, true)) + "\u003ERead More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + (null == (pug_interp = __webpack_require__(897).call(this, locals)) ? "" : pug_interp) + "\u003Csection class=\"carousel hero-carousel\" id=\"carousel\" data-ride=\"carousel\" data-interval=\"15000\" data-pause=\"true\" role=\"region\" aria-label=\"Carousel content with 3 slides.\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"carousel-head\"\u003E\u003Cimg class=\"carousel-head-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fperson-icon-dd29bfd2e7.svg\" alt=\"\" role=\"presentation\"\u003E\u003Ch2 class=\"carousel-head-text\"\u003ETransform your business with better engagement,\u003Cbr\u003Eimproved conversion and increased revenue.\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"carousel-inner\"\u003E\u003Ca class=\"left carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"prev\" aria-label=\"Previous slide\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"right carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"next\" aria-label=\"Next slide\"\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"slide-1 row item active b2c-card\" role=\"tabpanel\"\u003E\u003Cdiv class=\"slide-left animated fadeIn\"\u003E\u003Cdiv class=\"illustration\"\u003E\u003Cimg class=\"avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fhero\u002Fpersons\u002Fperson-1-0b0477ce8b.png\" alt=\"\" role=\"presentation\"\u003E\u003Cimg class=\"main\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fb2c-illustration-e899cd7407.svg\" alt=\"\" role=\"presentation\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["slide_right"](
          "B2C",
          "Modern identity for your Customers",
          "Smartly engage with your users with actionable intelligence based on their profiles, trends and analytics.",
          "https://auth0.com/b2c-customer-identity-management"
        );
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-2 row item b2b-card\" role=\"tabpanel\"\u003E\u003Cdiv class=\"slide-left animated fadeIn\"\u003E\u003Cdiv class=\"illustration\"\u003E\u003Cimg class=\"main\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fb2b-illustration-056a51cc22.svg\" alt=\"\" role=\"presentation\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["slide_right"](
          "B2B",
          "Modern identity for your Business Partners",
          "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch.",
          "https://auth0.com/b2b-enterprise-identity-management"
        );
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-3 row item b2e-card\" role=\"tabpanel\"\u003E\u003Cdiv class=\"slide-left animated fadeIn\"\u003E\u003Cdiv class=\"illustration\"\u003E\u003Cimg class=\"avatars-1\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fb2e-avatars-1-cc49b862b0.png\" alt=\"\" role=\"presentation\"\u003E\u003Cimg class=\"avatars-2\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fb2e-avatars-2-3e6ab6254e.png\" alt=\"\" role=\"presentation\"\u003E\u003Cimg class=\"main\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fb2e-illustration-0420cbf293.svg\" alt=\"\" role=\"presentation\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["slide_right"](
          "B2E",
          "Modern identity for your Enterprise",
          "Improve team collaboration by using identity standards, increase user efficiency and reduce costs thanks to adaptive security and complete identity management.",
          "https://auth0.com/enterprise"
        );
pug_html = pug_html + ("\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Col class=\"carousel-indicators\" role=\"tablist\"\u003E\u003Cli class=\"active\" data-target=\"#carousel\" data-slide-to=\"0\" aria-controls=\"tabpanel-0-0\" tabindex=\"-1\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"1\" aria-controls=\"tabpanel-0-1\" tabindex=\"-1\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"2\" aria-controls=\"tabpanel-0-2\" tabindex=\"-1\"\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fsection\u003E" + (null == (pug_interp = __webpack_require__(895).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(898).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(899).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(894).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(900).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(901).call(this, locals)) ? "" : pug_interp));}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"customers theme-light\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12\"\u003E\u003Cdiv class=\"customers-header\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Fcustomers-icon-e6580a660a.svg\" alt=\"\" role=\"presentation\"\u003E\u003Ch2\u003EJoin thousands of companies that trust Auth0 everyday\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-12 customers-list clearfix\"\u003E\u003Ca class=\"customers-list-item atlassian\" target=\"_blank\" href=\"\u002Fcustomers#atlassian\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-atlassian-7830cc62b0.svg\" alt=\"Atlassian logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item optimizely\" target=\"_blank\" href=\"\u002Fcustomers#optimizely\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-optimizely-fb12dff7e6.svg\" alt=\"Optimizely logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item polaris\" target=\"_blank\" href=\"\u002Fcustomers#polaris\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-polaris-industries-5ee70ef168.svg\" alt=\"Polaris logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item nvidia\" target=\"_blank\" href=\"\u002Fcustomers#nvidia\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-nvidia-6b3d90dfc2.svg\" alt=\"NVIDIA logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item amd\" target=\"_blank\" href=\"\u002Fcustomers#amd\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-amd-1d53131816.svg\" alt=\"AMD logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item newscorp\" target=\"_blank\" href=\"\u002Fcustomers#newscorp\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-newscorp-0dab593d7b.svg\" alt=\"News Corp logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item jet\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fjetprivilege-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-jet-26aa6f780e.svg\" alt=\"Jet Privilege logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item mozilla\" target=\"_blank\" href=\"\u002Fcustomers#mozilla\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-mozilla-2538e7d3d8.svg\" alt=\"Mozilla logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item harper\" target=\"_blank\" href=\"\u002Fcustomers#harper\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-harper-485f833932.svg\" alt=\"Harper Collins logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item bluetooth-sig\" target=\"_blank\" href=\"\u002Fcustomers#bluetooth-sig\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-bluetooth-632a4ebcf4.svg\" alt=\"Bluetooth Special Interest Group logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item pbs\" target=\"_blank\" href=\"\u002Fcustomers#PBS\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-pbs-f8e4a8a436.svg\" alt=\"PBS logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item ms\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fmarks-spencer-auth0-authentication-scalability-in-action\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-marks-spencer-44f43eadfb.svg\" alt=\"Marks Spencer logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item aeromexico\" target=\"_blank\" href=\"\u002Fcustomers#aeromexico\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-aeromexico-8fafadbb79.svg\" alt=\"Aeromexico logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"customers-list-item schneider\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fschneider-electric-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Flogo-schneider-electric-e453b18686.png\" alt=\"Schneider Electric logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-12\"\u003E\u003Cdiv class=\"customers-description\"\u003E\u003Cp\u003EJoin the club with thousands of Auth0 happy customers who trust us with their identity needs.\u003C\u002Fp\u003E\u003Ca class=\"more-link\" href=\"https:\u002F\u002Fauth0.com\u002Fcustomers\"\u003ESee All Customers\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customers-articles\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6 separate\"\u003E\u003Cdiv class=\"article article-left\"\u003E\u003Cdiv class=\"article-content\"\u003E\u003Ca href=\"https:\u002F\u002Fdiscourse.mozilla-community.org\u002Ft\u002Fmozilla-s-identity-and-access-management-iam-initiatives\u002F11845\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E\u003Ch5 class=\"article-title\"\u003EMozilla’s identity and access management (IAM) initiatives\u003C\u002Fh5\u003E\u003C\u002Fa\u003E\u003Cp class=\"article-description\"\u003ERead why Mozilla chose Auth0 to carry out their initiative of a broader identity and access management\u003C\u002Fp\u003E\u003Ca class=\"article-link\" href=\"https:\u002F\u002Fauth0.com\u002Fpress\u002Fnews\" target=\"_blank\"\u003E\u003Cimg class=\"article-link-icon\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Fnews-icon-8c02f16c91.svg\" role=\"presentation\" alt=\"\"\u003EMore news about Auth0\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"article-main-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Fmozilla-3388399f31.png\" role=\"presentation\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"article article-right\"\u003E\u003Cdiv class=\"article-content\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002Fauth0-named-in-seattle-10-hottest-ventures-2016\u002F\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E\u003Ch5 class=\"article-title\"\u003EFeatured on Geekwire’s Seattle \u003Cbr\u003E10 Hottest Startups\u003C\u002Fh5\u003E\u003C\u002Fa\u003E\u003Cp class=\"article-description\"\u003EThis year’s list showcases 10 of the most promising startups in the region, from education to virtual reality and robotics.\u003C\u002Fp\u003E\u003Ca class=\"article-link\" href=\"https:\u002F\u002Fauth0.com\u002Fpress\u002Fannouncements\" target=\"_blank\"\u003E\u003Cimg class=\"article-link-icon\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Fpress-releases-icon-e3ab7f7ec3.svg\" role=\"presentation\" alt=\"\"\u003ERead our Press Releases\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"article-main-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcustomers\u002Fgw-fa130fcaa7.png\" role=\"presentation\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"features-articles\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6 article-container touch-id-bg\"\u003E\u003Cdiv class=\"article\"\u003E\u003Cimg class=\"article-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Ffeatures\u002Fshield-black-icon-368f6db6dc.svg\" role=\"presentation\" alt=\"\"\u003E\u003Ch2 class=\"article-title short-title\"\u003ERisk-based and prioritized security.\u003C\u002Fh2\u003E\u003Cp class=\"article-description\"\u003EWe offer adaptive multi-layer security designed by world-class experts. \nAll of our products were carefully crafted with security in mind.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"statistics clearfix\"\u003E\u003Cdiv class=\"statistic separate\"\u003E\u003Cdiv class=\"number\"\u003E\u003Cspan class=\"highlight\"\u003E+\u003C\u002Fspan\u003E1.1B\u003C\u002Fdiv\u003E\u003Cdiv class=\"description\"\u003ELogins Securely\u003Cbr\u003E Authenticated\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"statistic\"\u003E\u003Cdiv class=\"number\"\u003E\u003Cspan class=\"highlight\"\u003E+\u003C\u002Fspan\u003E1.3M\u003C\u002Fdiv\u003E\u003Cdiv class=\"description\"\u003EMalicious Logins\u003Cbr\u003E Prevented\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"more-link\" href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 article-container map-bg\"\u003E\u003Cdiv class=\"article\"\u003E\u003Cimg class=\"article-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Ffeatures\u002Fglobal-black-icon-0ae5e5bd67.svg\" role=\"presentation\" alt=\"\"\u003E\u003Ch2 class=\"article-title\"\u003EEnterprise-class availability.\u003Cbr\u003EAlways ready, wherever you are.\u003C\u002Fh2\u003E\u003Cp class=\"article-description\"\u003EWe ensure high availability and resiliency thanks to our advanced infrastructure, \ndisaster recovery systems, and fully capable on-premise solutions.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"statistics clearfix\"\u003E\u003Cdiv class=\"statistic separate\"\u003E\u003Cdiv class=\"number\"\u003E3\u003Cdiv class=\"flags\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Ffeatures\u002Fau-flag-2d3e6d7786.png\" alt=\"Australia flag\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Ffeatures\u002Fus-flag-a0123709ef.png\" alt=\"US flag\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Ffeatures\u002Feu-flag-cde2197497.png\" alt=\"Europe flag\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"description\"\u003EPublic Cloud Environments\u003C\u002Fdiv\u003E\u003Cdiv class=\"sub-description\"\u003EUS, EU, AU\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"statistic\"\u003E\u003Cdiv class=\"number\"\u003E99.95\u003Cspan class=\"highlight\"\u003E%\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"description\"\u003EGuaranteed SLA\u003C\u002Fdiv\u003E\u003Cdiv class=\"sub-description\"\u003EFor Prod. Environments\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"more-link\" href=\"https:\u002F\u002Fauth0.com\u002Favailability-trust\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"identity-animation\"\u003E\u003Cdiv class=\"device\"\u003E\u003Cform class=\"auth0-lock-demo-homepage\"\u003E\u003Cdiv class=\"auth0-lock-widget-container\"\u003E\u003Cdiv class=\"screen1\"\u003E\u003Cdiv class=\"auth0-lock-cred-pane auth0-lock-quiet\"\u003E\u003Cdiv class=\"auth0-lock-header\"\u003E\u003Csvg height=\"13px\" width=\"231px\" version=\"1.1\" viewbox=\"-1 0 231 13\" style=\"position: absolute; top: 0px; left: 0px; z-index: 1000;\"\u003E\u003Cg id=\"Status-Bar-\u002F-Black\" fill=\"none\" stroke=\"none\" stroke-width=\"1\" transform=\"translate(-0.612167, 0.000000)\"\u003E\u003Crect id=\"Background\" height=\"12.4555254\" width=\"229.562738\" fill-opacity=\"0\" x=\"0\" y=\"0\"\u003E\u003C\u002Frect\u003E\u003Cg id=\"Signal\" fill=\"#000000\" transform=\"translate(3.979087, 4.670822)\"\u003E\u003Cellipse id=\"Oval-1\" cx=\"1.68346008\" cy=\"1.71263474\" rx=\"1.68346008\" ry=\"1.71263474\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse id=\"Oval-1-copy\" cx=\"5.96863118\" cy=\"1.71263474\" rx=\"1.68346008\" ry=\"1.71263474\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse id=\"Oval-1-copy-2\" cx=\"10.2538023\" cy=\"1.71263474\" rx=\"1.68346008\" ry=\"1.71263474\"\u003E\u003C\u002Fellipse\u003E\u003Cpath id=\"Shape\" d=\"M14.5389734 3.11388134 14.5389734 3.11388134C15.2996774 3.11388134 15.9163498 2.48652191 15.9163498 1.71263474 15.9163498.93874756 15.2996774.311388134 14.5389734.311388134 13.7782693.311388134 13.161597.93874756 13.161597 1.71263474 13.161597 2.48652191 13.7782693 3.11388134 14.5389734 3.11388134L14.5389734 3.11388134ZM14.5389734 3.42526947 14.5389734 3.42526947C13.609224 3.42526947 12.8555133 2.65849683 12.8555133 1.71263474 12.8555133.766772642 13.609224 0 14.5389734 0 15.4687228 0 16.2224335.766772642 16.2224335 1.71263474 16.2224335 2.65849683 15.4687228 3.42526947 14.5389734 3.42526947L14.5389734 3.42526947Z\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Shape\" d=\"M18.8241445 3.11388134 18.8241445 3.11388134C19.5848485 3.11388134 20.2015209 2.48652191 20.2015209 1.71263474 20.2015209.93874756 19.5848485.311388134 18.8241445.311388134 18.0634404.311388134 17.4467681.93874756 17.4467681 1.71263474 17.4467681 2.48652191 18.0634404 3.11388134 18.8241445 3.11388134L18.8241445 3.11388134ZM18.8241445 3.42526947 18.8241445 3.42526947C17.8943951 3.42526947 17.1406844 2.65849683 17.1406844 1.71263474 17.1406844.766772642 17.8943951 0 18.8241445 0 19.7538939 0 20.5076046.766772642 20.5076046 1.71263474 20.5076046 2.65849683 19.7538939 3.42526947 18.8241445 3.42526947L18.8241445 3.42526947Z\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003Cpath id=\"Facebook\" d=\"M27.5176667 3.53799402 27.5176667 8.8683288 28.2268849 8.8683288 28.2268849 6.42712506 30.6755541 6.42712506 30.6755541 5.82988867 28.2268849 5.82988867 28.2268849 4.13523041 31.018965 4.13523041 31.018965 3.53799402 27.5176667 3.53799402ZM32.5117942 5.82988867 32.5117942 4.13523041 33.9302306 4.13523041C34.0845175 4.13523041 34.2300924 4.14394002 34.3669598 4.1613595 34.5038271 4.17877898 34.6245174 4.21735011 34.7290343 4.27707405 34.8335512 4.33679799 34.9156704 4.42140563 34.9753943 4.53089952 35.0351183 4.6403934 35.0649798 4.78970101 35.0649798 4.97882681 35.0649798 5.26251551 34.9766395 5.47527885 34.7999561 5.6171232 34.6232728 5.75896755 34.3333672 5.82988867 33.9302306 5.82988867L32.5117942 5.82988867ZM31.802576 3.53799402 31.802576 8.8683288 34.3781579 8.8683288C34.6419387 8.8683288 34.8746097 8.82478075 35.076178 8.73768334 35.2777463 8.65058593 35.4469615 8.53611677 35.5838289 8.39427242 35.7206963 8.25242807 35.8239674 8.08943393 35.8936453 7.90528512 35.9633232 7.72113632 35.9981616 7.53201335 35.9981616 7.33791055 35.9981616 7.00942889 35.9110655 6.73072137 35.7368707 6.5017796 35.5626759 6.27283784 35.3113414 6.12353024 34.9828598 6.05385231L34.9828598 6.0389214C35.2366865 5.93938151 35.4320306 5.78634121 35.568898 5.57979593 35.7057653 5.37325064 35.774198 5.12813732 35.774198 4.84444862 35.774198 4.5756909 35.7132307 4.34924103 35.5912944 4.16509223 35.469358 3.98094342 35.3212946 3.83661273 35.1470998 3.73209584 35.0674679 3.6823259 34.9716622 3.64499899 34.8596798 3.62011402 34.7476974 3.59522905 34.6270071 3.5765656 34.4976052 3.56412311 34.3682034 3.55168062 34.2375592 3.54421524 34.1056688 3.54172674 33.9737785 3.53923825 33.8505997 3.53799402 33.7361288 3.53799402L31.802576 3.53799402ZM32.5117942 8.27109241 32.5117942 6.42712506 34.1317979 6.42712506C34.2811078 6.42712506 34.4254385 6.44081159 34.5647943 6.46818506 34.7041502 6.49555853 34.8273289 6.54283927 34.9343343 6.6100287 35.0413397 6.67721813 35.1271916 6.76804692 35.1918925 6.8825178 35.2565935 6.99698868 35.2889434 7.14131937 35.2889434 7.31551419 35.2889434 7.61413388 35.2006031 7.84804912 35.0239198 8.01726695 34.8472365 8.18648477 34.6021232 8.27109241 34.2885725 8.27109241L32.5117942 8.27109241Z\" fill=\"#000000\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Wifi\" d=\"M42.6933698 7.15048347C42.2307871 7.15048347 41.8070596 7.3488275 41.4778258 7.63488264L42.6933698 9.04738223 43.9102933 7.63628602C43.5808296 7.34952919 43.1568721 7.15048347 42.6933698 7.15048347ZM42.7414214 4.3565925C43.8939695 4.3565925 44.9446667 4.8021649 45.749818 5.53309075L46.3087338 4.88473029C45.3548295 4.01580564 44.1089371 3.40814312 42.7411915 3.40814312 41.3757449 3.40814312 40.131462 4.01416836 39.1787072 4.88075405L39.7367033 5.52958231C40.5416247 4.80052763 41.5904826 4.3565925 42.7414214 4.3565925ZM42.7253276 6.22776268C43.4162127 6.22776268 44.0473207 6.49136377 44.5340441 6.92453967L45.1258373 6.2385219C44.4820841 5.65845915 43.6442852 5.2793133 42.7255575 5.2793133 41.8084391 5.2793133 40.9717898 5.65728967 40.3282665 6.23571515L40.91914 6.9226685C41.4054036 6.49019429 42.035592 6.22776268 42.7253276 6.22776268Z\" fill=\"#000000\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"9:41\" d=\"M103.468388 8.8683288 103.468388 3.57532129 102.983134 3.57532129C102.948295 3.77440108 102.883595 3.93863945 102.789032 4.06804131 102.694469 4.19744318 102.578756 4.29947004 102.441888 4.37412496 102.305021 4.44877989 102.151981 4.49979332 101.982763 4.52716679 101.813545 4.55454026 101.639353 4.56822679 101.460181 4.56822679L101.460181 5.07587772 102.833825 5.07587772 102.833825 8.8683288 103.468388 8.8683288ZM106.409516 5.83735412 106.409516 5.00868863 105.58085 5.00868863 105.58085 5.83735412 106.409516 5.83735412ZM105.58085 8.03966331 105.58085 8.8683288 106.409516 8.8683288 106.409516 8.03966331 105.58085 8.03966331ZM107.364832 5.44915047 107.999396 5.44915047C107.994419 5.28988663 108.010594 5.13186942 108.047921 4.97509408 108.085249 4.81831874 108.146216 4.67772075 108.230825 4.55329588 108.315434 4.42887101 108.423682 4.32808838 108.555572 4.25094496 108.687463 4.17380154 108.84548 4.13523041 109.029629 4.13523041 109.168984 4.13523041 109.300873 4.15762655 109.425298 4.2024195 109.549723 4.24721245 109.657971 4.31191242 109.750045 4.39652133 109.842119 4.48113024 109.915529 4.58191287 109.970276 4.69887225 110.025023 4.81583163 110.052396 4.94647578 110.052396 5.09080863 110.052396 5.27495744 110.023779 5.43670734 109.966543 5.5760632 109.909308 5.71541905 109.8247 5.84481898 109.712718 5.96426685 109.600735 6.08371473 109.460137 6.20191658 109.290919 6.31887596 109.121702 6.43583534 108.925113 6.56399103 108.701149 6.70334689 108.517 6.81284077 108.340319 6.9297984 108.171101 7.05422327 108.001883 7.17864814 107.850087 7.32297882 107.715708 7.48721965 107.58133 7.65146048 107.470593 7.84431613 107.383496 8.0657924 107.296398 8.28726867 107.240408 8.55477813 107.215523 8.8683288L110.672029 8.8683288 110.672029 8.30841969 107.954603 8.30841969C107.984465 8.14417886 108.047921 7.99860394 108.144972 7.87169058 108.242024 7.74477721 108.358981 7.62657535 108.495849 7.51708147 108.632716 7.40758758 108.783268 7.30431649 108.947509 7.20726509 109.111749 7.11021369 109.275988 7.01191952 109.440229 6.91237962 109.604469 6.80786273 109.763731 6.69837049 109.918018 6.58389961 110.072304 6.46942873 110.20917 6.34127303 110.328618 6.19942868 110.448066 6.05758433 110.543871 5.89707866 110.616038 5.71790684 110.688204 5.53873503 110.724287 5.33219284 110.724287 5.09827409 110.724287 4.84942435 110.680739 4.63043986 110.593641 4.44131406 110.506544 4.25218825 110.388342 4.09417104 110.239032 3.96725767 110.089722 3.8403443 109.914286 3.74329436 109.712718 3.67610493 109.511149 3.6089155 109.295898 3.57532129 109.066956 3.57532129 108.788244 3.57532129 108.539398 3.62260203 108.32041 3.71716493 108.101423 3.81172784 107.918521 3.94237199 107.771699 4.10910132 107.624878 4.27583064 107.51663 4.47366322 107.446952 4.70260498 107.377274 4.93154674 107.349901 5.18039275 107.364832 5.44915047ZM112.172323 6.26288505C112.172323 6.13348318 112.173567 5.99039673 112.176056 5.83362139 112.178544 5.67684606 112.190987 5.52007307 112.213383 5.36329774 112.23578 5.2065224 112.26813 5.0534821 112.310434 4.90417226 112.352739 4.75486242 112.41495 4.62421826 112.497071 4.51223588 112.579191 4.4002535 112.682462 4.3094247 112.806887 4.23974678 112.931312 4.17006885 113.083108 4.13523041 113.26228 4.13523041 113.441451 4.13523041 113.593248 4.17006885 113.717672 4.23974678 113.842097 4.3094247 113.945368 4.4002535 114.027489 4.51223588 114.109609 4.62421826 114.171821 4.75486242 114.214125 4.90417226 114.25643 5.0534821 114.28878 5.2065224 114.311176 5.36329774 114.333573 5.52007307 114.346015 5.67684606 114.348503 5.83362139 114.350992 5.99039673 114.352236 6.13348318 114.352236 6.26288505 114.352236 6.46196484 114.346015 6.68468202 114.333572 6.93104326 114.32113 7.1774045 114.281315 7.40883129 114.214125 7.62533056 114.146936 7.84182984 114.038688 8.02473165 113.889378 8.1740415 113.740068 8.32335134 113.531037 8.39800515 113.26228 8.39800515 112.993522 8.39800515 112.784491 8.32335134 112.635181 8.1740415 112.485872 8.02473165 112.377624 7.84182984 112.310434 7.62533056 112.243245 7.40883129 112.203429 7.1774045 112.190987 6.93104326 112.178544 6.68468202 112.172323 6.46196484 112.172323 6.26288505ZM111.500432 6.2703505C111.500432 6.4644533 111.505409 6.66601857 111.515363 6.87505235 111.525317 7.08408613 111.550202 7.28813986 111.590018 7.48721965 111.629834 7.68629944 111.687068 7.87417818 111.761723 8.05086149 111.836378 8.22754481 111.938405 8.38307356 112.067807 8.51745242 112.197209 8.65183128 112.360203 8.75759084 112.556794 8.83473426 112.753385 8.91187768 112.988545 8.95044881 113.26228 8.95044881 113.540991 8.95044881 113.777395 8.91187768 113.971498 8.83473426 114.165601 8.75759084 114.327351 8.65183128 114.456752 8.51745242 114.586154 8.38307356 114.688181 8.22754481 114.762836 8.05086149 114.837491 7.87417818 114.894726 7.68629944 114.934542 7.48721965 114.974358 7.28813986 114.999242 7.08408613 115.009196 6.87505235 115.01915 6.66601857 115.024127 6.4644533 115.024127 6.2703505 115.024127 6.07624771 115.01915 5.87468244 115.009196 5.66564866 114.999242 5.45661488 114.974358 5.25256115 114.934542 5.05348136 114.894726 4.85440157 114.837491 4.6652786 114.762836 4.48610679 114.688181 4.30693497 114.586154 4.15016199 114.456752 4.01578313 114.327351 3.88140427 114.164356 3.77440049 113.967765 3.69476857 113.771174 3.61513665 113.536014 3.57532129 113.26228 3.57532129 112.988545 3.57532129 112.753385 3.61513665 112.556794 3.69476857 112.360203 3.77440049 112.197209 3.88140427 112.067807 4.01578313 111.938405 4.15016199 111.836378 4.30693497 111.761723 4.48610679 111.687068 4.6652786 111.629834 4.85440157 111.590018 5.05348136 111.550202 5.25256115 111.525317 5.45661488 111.515363 5.66564866 111.505409 5.87468244 111.500432 6.07624771 111.500432 6.2703505ZM118.704073 6.09117959 118.704073 4.13523041 120.092647 4.13523041C120.495784 4.13523041 120.790666 4.21859382 120.977304 4.38532315 121.163941 4.55205247 121.257258 4.79467733 121.257258 5.113205 121.257258 5.43173266 121.163941 5.67560175 120.977304 5.84481958 120.790666 6.0140374 120.495784 6.09615658 120.092647 6.09117959L118.704073 6.09117959ZM117.994854 3.53799402 117.994854 8.8683288 118.704073 8.8683288 118.704073 6.68841598 120.331542 6.68841598C120.869057 6.69339297 121.27592 6.55652767 121.552144 6.27781596 121.828367 5.99910425 121.966476 5.61090448 121.966476 5.113205 121.966476 4.61550552 121.828367 4.22854997 121.552144 3.95232676 121.27592 3.67610355 120.869057 3.53799402 120.331542 3.53799402L117.994854 3.53799402ZM122.847138 3.53799402 122.847138 8.8683288 123.519029 8.8683288 123.519029 4.4338486 123.53396 4.4338486 125.198757 8.8683288 125.803458 8.8683288 127.468255 4.4338486 127.483186 4.4338486 127.483186 8.8683288 128.155077 8.8683288 128.155077 3.53799402 127.184568 3.53799402 125.497375 8.01726695 123.817647 3.53799402 122.847138 3.53799402Z\" fill=\"#000000\"\u003E\u003C\u002Fpath\u003E\u003Cg id=\"Battery-Icon\" fill=\"#000000\" transform=\"translate(211.197719, 3.425269)\"\u003E\u003Cpath id=\"Shape\" d=\"M.30608365.934202413.30608365.934202413.30608365 4.98217213C.30608365 5.32737525.579852964 5.60498641.919755871 5.60498641L12.8540084 5.60498641C13.1927785 5.60498641 13.4676806 5.32585712 13.4676806 4.98217213L13.4676806.934202413C13.4676806.588999297 13.1939113.311388134 12.8540084.311388134L.919755871.311388134C.580985766.311388134.30608365.590517417.30608365.934202413L.30608365.934202413ZM0 .934202413C0 .418256667.412221405 0 .919755871 0L12.8540084 0C13.3619755 0 13.7737643.416027969 13.7737643.934202413L13.7737643 4.98217213C13.7737643 5.49811788 13.3615429 5.91637454 12.8540084 5.91637454L.919755871 5.91637454C.41178873 5.91637454 0 5.50034657 0 4.98217213L0 .934202413 0 .934202413Z\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Shape\" d=\"M.917190317.622776268C.748730757.622776268.6121673.757527622.6121673.929241945L.6121673 4.9871326C.6121673 5.15638892.746786911 5.29359827.917190317 5.29359827L9.18250951 5.29359827 9.18250951.622776268.917190317.622776268ZM14.0798479 1.8683288 14.5389734 1.8683288C14.7925414 1.8683288 14.9980989 2.06948432 14.9980989 2.3305907L14.9980989 3.58578384C14.9980989 3.84108404 14.7851256 4.04804574 14.5389734 4.04804574L14.0798479 4.04804574 14.0798479 1.8683288Z\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003Cpath id=\"42%\" d=\"M198.775202 4.20988496 198.775202 3.66490675 195.348558 3.66490675 195.348558 4.26214314 198.125707 4.26214314C197.846995 4.55578583 197.586951 4.87679718 197.345567 5.22518682 197.104183 5.57357646 196.89142 5.94311278 196.707271 6.33380687 196.523122 6.72450096 196.37257 7.13260841 196.255611 7.55814147 196.138651 7.98367453 196.065242 8.42039927 196.03538 8.8683288L196.744598 8.8683288C196.769483 8.45523823 196.83916 8.02971156 196.953631 7.59173602 197.068102 7.15376047 197.216165 6.7282338 197.397825 6.31514323 197.579486 5.90205266 197.787272 5.51385289 198.021191 5.15053227 198.25511 4.78721165 198.506444 4.47366568 198.775202 4.20988496ZM202.925733 4.20988496 202.925733 3.66490675 199.499089 3.66490675 199.499089 4.26214314 202.276238 4.26214314C201.997527 4.55578583 201.737482 4.87679718 201.496098 5.22518682 201.254714 5.57357646 201.041951 5.94311278 200.857802 6.33380687 200.673653 6.72450096 200.523101 7.13260841 200.406142 7.55814147 200.289182 7.98367453 200.215773 8.42039927 200.185911 8.8683288L200.895129 8.8683288C200.920014 8.45523823 200.989691 8.02971156 201.104162 7.59173602 201.218633 7.15376047 201.366696 6.7282338 201.548356 6.31514323 201.730017 5.90205266 201.937803 5.51385289 202.171722 5.15053227 202.405641 4.78721165 202.656975 4.47366568 202.925733 4.20988496ZM204.523078 5.07587772C204.523078 4.96140684 204.530544 4.84071653 204.545475 4.71380316 204.560406 4.58688979 204.591511 4.46993217 204.638793 4.36292678 204.686074 4.25592139 204.752019 4.16633683 204.836627 4.09417041 204.921236 4.02200398 205.033217 3.98592131 205.172573 3.98592131 205.316906 3.98592131 205.430131 4.02200398 205.512251 4.09417041 205.594372 4.16633683 205.657827 4.25592139 205.70262 4.36292678 205.747413 4.46993217 205.77603 4.58688979 205.788473 4.71380316 205.800915 4.84071653 205.807137 4.95891838 205.807137 5.06841227 205.807137 5.18288315 205.799671 5.30481769 205.78474 5.43421956 205.769809 5.56362142 205.738704 5.68182328 205.691422 5.78882866 205.644141 5.89583405 205.578196 5.98417438 205.493588 6.05385231 205.408979 6.12353024 205.294509 6.15836868 205.150177 6.15836868 205.010821 6.15836868 204.900084 6.12228601 204.817964 6.05011958 204.735843 5.97795316 204.672388 5.8883686 204.627595 5.78136321 204.582802 5.67435782 204.554184 5.5574002 204.541742 5.43048683 204.5293 5.30357346 204.523078 5.18537161 204.523078 5.07587772ZM203.963169 5.09080863C203.963169 5.29486542 203.984321 5.48647685 204.026626 5.66564866 204.06893 5.84482047 204.137363 6.00159346 204.231926 6.13597232 204.326489 6.27035118 204.450912 6.37611073 204.605198 6.45325415 204.759485 6.53039757 204.948608 6.5689687 205.172573 6.5689687 205.391561 6.5689687 205.575707 6.52666488 205.725017 6.44205597 205.874326 6.35744705 205.997505 6.24671058 206.094557 6.10984322 206.191608 5.97297587 206.261285 5.81371442 206.303589 5.63205411 206.345894 5.4503938 206.367046 5.26251506 206.367046 5.06841227 206.367046 4.86435548 206.348382 4.67149982 206.311055 4.48983951 206.273727 4.3081792 206.209027 4.15016199 206.116953 4.01578313 206.024879 3.88140427 205.902944 3.77440049 205.751146 3.69476857 205.599347 3.61513665 205.406492 3.57532129 205.172573 3.57532129 204.943631 3.57532129 204.75202 3.61638088 204.597733 3.6985013 204.443446 3.78062171 204.319023 3.89135818 204.22446 4.03071404 204.129897 4.17006989 204.062709 4.33057557 204.022893 4.51223588 203.983077 4.69389619 203.963169 4.88675185 203.963169 5.09080863ZM208.211013 7.46482328C208.211013 7.3503524 208.218478 7.22966209 208.233409 7.10274872 208.24834 6.97583536 208.279446 6.85887773 208.326728 6.75187234 208.374009 6.64486696 208.439953 6.55528239 208.524562 6.48311597 208.609171 6.41094954 208.721152 6.37486687 208.860508 6.37486687 209.004841 6.37486687 209.118065 6.41094954 209.200186 6.48311597 209.282306 6.55528239 209.345762 6.64486696 209.390555 6.75187234 209.435348 6.85887773 209.463965 6.97583536 209.476408 7.10274872 209.48885 7.22966209 209.495071 7.34786394 209.495071 7.45735783 209.495071 7.57182871 209.487606 7.69376325 209.472675 7.82316512 209.457744 7.95256698 209.426638 8.07076884 209.379357 8.17777423 209.332075 8.28477961 209.266131 8.37311995 209.181522 8.44279787 209.096913 8.5124758 208.982444 8.54731424 208.838111 8.54731424 208.698755 8.54731424 208.588019 8.51123157 208.505899 8.43906515 208.423778 8.36689872 208.360322 8.27731416 208.315529 8.17030877 208.270736 8.06330338 208.242119 7.94634576 208.229677 7.81943239 208.217234 7.69251902 208.211013 7.57431717 208.211013 7.46482328ZM207.651104 7.47975419C207.651104 7.68381098 207.672256 7.87542241 207.71456 8.05459422 207.756865 8.23376603 207.825297 8.38929479 207.91986 8.52118515 208.014423 8.65307551 208.138846 8.75759084 208.293133 8.83473426 208.44742 8.91187768 208.636543 8.95044881 208.860508 8.95044881 209.079495 8.95044881 209.263641 8.90938922 209.412951 8.8272688 209.562261 8.74514839 209.68544 8.63565614 209.782491 8.49878879 209.879543 8.36192143 209.94922 8.20265998 209.991524 8.02099967 210.033829 7.83933936 210.05498 7.65146063 210.05498 7.45735783 210.05498 7.25330104 210.036317 7.06044539 209.99899 6.87878508 209.961662 6.69712477 209.896962 6.53910755 209.804888 6.40472869 209.712813 6.27034983 209.590879 6.16334605 209.43908 6.08371413 209.287282 6.00408221 209.094426 5.96426685 208.860508 5.96426685 208.631566 5.96426685 208.439954 6.00532644 208.285668 6.08744686 208.131381 6.16956727 208.006958 6.28030375 207.912395 6.4196596 207.817832 6.55901546 207.750644 6.71952113 207.710828 6.90118144 207.671012 7.08284175 207.651104 7.27569741 207.651104 7.47975419ZM208.696268 3.47827038 204.679853 9.02510336 205.321882 9.02510336 209.330831 3.47827038 208.696268 3.47827038Z\" fill=\"#000000\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Bluetooth\" d=\"M190.971484 4.66341953 188.401228 2.17971694 188.241445 2.17971694 188.241445 5.60498641 186.59558 3.81258484 186.098859 4.3293743 188.197719 6.38376806 186.098859 8.43816182 186.59558 8.95463997 188.241445 7.16192708 188.241445 10.5871965 188.451266 10.5871965 190.996198 8.09695625 189.248826 6.38376806 190.971484 4.66341953ZM188.853612 5.60498641 188.853612 3.73665761 189.939215 4.67082201 188.853612 5.60498641ZM188.853612 7.16192708 189.951956 8.09609148 188.853612 9.03025588 188.853612 7.16192708Z\" fill=\"#000000\" opacity=\"0.45\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003Cdiv class=\"auth0-lock-header-bg auth0-lock-blur-support auth0-lock-no-grayscale\"\u003E\u003Cdiv class=\"auth0-lock-header-bg-blur\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-lock-header-bg-solid\" style=\"background-color: rgb(234, 83, 35);\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-lock-header-welcome\"\u003E\u003Cimg class=\"auth0-lock-header-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fstyleguide\u002Fcomponents\u002F1.0.8\u002Fmedia\u002Flogos\u002Fimg\u002Fbadge.png\" alt=\"Auth0 logo\"\u003E\u003Cdiv class=\"auth0-lock-name\"\u003EAuth0\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-lock-view-content\"\u003E\u003Cdiv class=\"auth0-lock-body-content\"\u003E\u003Cdiv class=\"auth0-lock-content\"\u003E\u003Cdiv class=\"auth0-lock-form\"\u003E\u003Cdiv class=\"auth0-lock-tabs-container\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-lock-pane-separator\"\u003E\u003Cdiv class=\"auth0-lock-input-block auth0-lock-input-email lolo\"\u003E\u003Cdiv class=\"auth0-lock-input-wrap auth0-lock-input-wrap-with-icon\"\u003E\u003Cspan\u003E\u003Csvg class=\"auth0-lock-icon\" height=\"13px\" version=\"1.1\" viewbox=\"0 0 32 26\" width=\"14px\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg id=\"Page-1\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"\u003E\u003Cg id=\"32px\" fill=\"#373A39\" transform=\"translate(-2155.000000, -2317.000000)\"\u003E\u003Cg id=\"Group-856\" transform=\"translate(1.000000, 1.000000)\"\u003E\u003Cpath id=\"Fill-419\" d=\"M2184 2339C2184 2339.55 2183.55 2340 2183 2340L2157 2340C2156.45 2340 2156 2339.55 2156 2339L2156 2319C2156 2318.45 2156.45 2318 2157 2318L2183 2318C2183.55 2318 2184 2318.45 2184 2319L2184 2339 2184 2339ZM2184 2316 2156 2316C2154.89 2316 2154 2316.89 2154 2318L2154 2340C2154 2341.1 2154.89 2342 2156 2342L2184 2342C2185.1 2342 2186 2341.1 2186 2340L2186 2318C2186 2316.89 2185.1 2316 2184 2316L2184 2316ZM2176 2322 2180 2322 2180 2326 2176 2326 2176 2322ZM2174 2328 2182 2328 2182 2320 2174 2320 2174 2328ZM2158 2332 2172 2332 2172 2330 2158 2330 2158 2332ZM2158 2336 2172 2336 2172 2334 2158 2334 2158 2336Z\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"auth0-lock-input\"\u003E\u003Cdiv class=\"auth0-lock-input-placeholder\"\u003EEmail\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-lock-input-block auth0-lock-input-password\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-lock-input-wrap auth0-lock-input-wrap-with-icon\"\u003E\u003Cspan\u003E\u003Csvg class=\"auth0-lock-icon auth0-lock-icon-box\" height=\"14px\" version=\"1.1\" viewbox=\"0 0 13 16\" width=\"11px\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"\u003E\u003Cg fill=\"#888888\" transform=\"translate(-288.000000, -1508.000000)\"\u003E\u003Cpath d=\"M299 1523.998 290 1523.998C288.896 1523.998 288 1523.102 288 1521.999L288 1515.999C288 1514.895 288.896 1513.998 290 1513.998L290 1513.998 290 1512.499C290 1510.015 292.015 1507.999 294.5 1507.999 296.985 1507.999 299 1510.015 299 1512.499L299 1513.999C300.104 1513.999 301 1514.895 301 1515.999L301 1521.999C301 1523.103 300.104 1523.998 299 1523.998L299 1523.998ZM298 1512.499C298 1510.566 296.433 1508.999 294.5 1508.999 292.567 1508.999 291 1510.566 291 1512.499L291 1513.998 298 1513.998 298 1512.499 298 1512.499ZM300 1515.999C300 1515.446 299.552 1514.998 299 1514.998L290 1514.998C289.447 1514.998 289 1515.446 289 1515.999L289 1521.999C289 1522.551 289.447 1522.998 290 1522.998L299 1522.998C299.552 1522.998 300 1522.551 300 1521.999L300 1515.999 300 1515.999ZM294.5 1520.998C294.224 1520.998 294 1520.774 294 1520.498L294 1517.498C294 1517.223 294.224 1516.999 294.5 1516.999 294.776 1516.999 295 1517.223 295 1517.498L295 1520.498C295 1520.774 294.776 1520.998 294.5 1520.998L294.5 1520.998Z\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"auth0-lock-input\"\u003E\u003Cdiv class=\"auth0-lock-input-placeholder\"\u003EPassword\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"auth0-lock-alternative\"\u003E\u003Ca class=\"auth0-lock-alternative-link\" href=\"#\"\u003EDont remember your password?\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"auth0-lock-submit\" type=\"submit\" style=\"background-color: #eb5424;\"\u003E\u003Cdiv class=\"auth0-loading-container\"\u003E\u003Cdiv class=\"auth0-loading\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"auth0-label-submit\"\u003ELog In\u003Csvg class=\"icon-text\" height=\"10px\" version=\"1.1\" viewbox=\"0 0 8 12\" width=\"7px\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg id=\"Symbols\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"\u003E\u003Cg fill=\"#FFFFFF\" id=\"Web\u002FSubmit\u002FActive\" transform=\"translate(-148.000000, -32.000000)\"\u003E\u003Cpolygon id=\"Shape\" points=\"148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38\"\u003E\u003C\u002Fpolygon\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fhero\u002Fanimation-phone-mockup-2dbd020009.svg\" alt=\"Phone mockup\"\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"banner theme-dark\"\u003E\u003Cdiv class=\"background-container\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"copy\"\u003E\u003Ch1 class=\"hero-title\"\u003EThe new way to solve Identity\u003C\u002Fh1\u003E\u003Cp class=\"hero-description\"\u003EWe solve the most complex identity use cases with an extensible and easy to \nintegrate platform that secures billions of logins every year\u003C\u002Fp\u003E\u003Cdiv class=\"cta-action\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003Ca class=\"video-btn btn btn-lg btn-default wistia-popover[height=360,width=640]\" id=\"wistia-popover\" href=\"#\"\u003E\u003Cspan class=\"btn-icon btn-icon-custom\"\u003E\u003Csvg width=\"7\" height=\"12\" viewBox=\"212 11 7 12\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cpath fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M218.133 16.5L213 22V11z\"\u002F\u003E\u003C\u002Fsvg\u003E\u003C\u002Fspan\u003EWatch Video\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6 graphic\"\u003E\u003Cdiv id=\"hero-lock-demo\"\u003E" + (null == (pug_interp = __webpack_require__(896).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"background-container\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"lock-playground-section theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"section-head\"\u003E\u003Cimg class=\"section-head-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fcarousel\u002Fperson-icon-dd29bfd2e7.svg\" role=\"presentation\" alt=\"\"\u003E\u003Ch2 class=\"section-head-title\"\u003EA Powerful Platform for Developers\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row lock-info-container\"\u003E\u003Cdiv class=\"col-xs-12 col-md-7\"\u003E\u003Ch3 class=\"lock-title\"\u003ELock and Auth0.js\u003C\u002Fh3\u003E\u003Cp class=\"lock-description\"\u003EDeploy quickly by integrating instantly on any platform with our Lock library,\nor build your own implementation choosing from more than 50 integrations.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-5 hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"integration-list\"\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fnative\u002Fios-swift\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Fswift-f0ecbddea6.svg\" alt=\"Swift logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fnodejs\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Fnodejs-ee73cbac4a.svg\" alt=\"Node.js logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fjava\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Fjava-47b77418dc.svg\" alt=\"Java logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fspa\u002Freact\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Freact-aa8ab29ec0.svg\" alt=\"React logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fruby\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Fruby-266b27f3e5.svg\" alt=\"Ruby logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fphp\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Fphp-529573cd84.svg\" alt=\"PHP logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fpython\"\u003E\u003Cimg class=\"integration-item\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Flock-playground\u002Fpython-48fcd4f963.svg\" alt=\"Python logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"integration-item-container\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002F\"\u003E\u003Cspan class=\"more-integrations\"\u003E50+\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(334).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Array) {pug_html = pug_html + "\u003Csection class=\"extensibility theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-8 extensibility-description\"\u003E\u003Cdiv class=\"title-container\"\u003E\u003Ch3 class=\"title\"\u003EExtensibility\u003C\u002Fh3\u003E\u003Cp class=\"description\"\u003ECustomize, configure and extend Auth0 platform capabilities with Rules and Extensions. Tweak  platform capabilities to better serve your goals.\u003C\u002Fp\u003E\u003Ca class=\"more-link more-link-negative\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Ftopics\u002Fextensibility\"\u003EMore about Extensibilty\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-8 extensibility-example clearfix\"\u003E\u003Cdiv class=\"rules-animation\"\u003E\u003Cdiv class=\"flow-container\"\u003E\u003Cspan\u003ELogin\u003C\u002Fspan\u003E\u003Cdiv class=\"pointed-line-to-rules\"\u003E\u003Cdiv class=\"line-x\"\u003E";
// iterate Array(8)
;(function(){
  var $$obj = Array(8);
  if ('number' == typeof $$obj.length) {
      for (var n = 0, $$l = $$obj.length; n < $$l; n++) {
        var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+(n+5)], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var n in $$obj) {
      $$l++;
      var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+(n+5)], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"line-y\"\u003E";
// iterate Array(5)
;(function(){
  var $$obj = Array(5);
  if ('number' == typeof $$obj.length) {
      for (var n = 0, $$l = $$obj.length; n < $$l; n++) {
        var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+n], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var n in $$obj) {
      $$l++;
      var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+n], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"your-app-container\"\u003E\u003Cimg class=\"pulse-31\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Frules\u002Fyour-app-icon-5b1574a6c4.svg\" role=\"presentation\" alt=\"\"\u003E\u003Cspan\u003EYour App\u002FAPI\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pointed-line-from-rules\"\u003E\u003Cdiv class=\"line-y\"\u003E";
// iterate Array(5)
;(function(){
  var $$obj = Array(5);
  if ('number' == typeof $$obj.length) {
      for (var n = 0, $$l = $$obj.length; n < $$l; n++) {
        var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+(n+26)], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var n in $$obj) {
      $$l++;
      var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+(n+26)], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"line-x bottom\"\u003E";
// iterate Array(8)
;(function(){
  var $$obj = Array(8);
  if ('number' == typeof $$obj.length) {
      for (var n = 0, $$l = $$obj.length; n < $$l; n++) {
        var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+(n+18)], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
      }
  } else {
    var $$l = 0;
    for (var n in $$obj) {
      $$l++;
      var _ = $$obj[n];
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(['point animated-dot-'+(n+18)], [true]), false, true)) + "\u003E\u003C\u002Fspan\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cspan\u003EToken\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth0-server-container\"\u003E\u003Cimg class=\"pulse-13\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Frules\u002Fauth0-server-icon-9bf5c93306.svg\" role=\"presentation\" alt=\"\"\u003E\u003Cspan\u003EAuth0 server\u003C\u002Fspan\u003E\u003Cdiv class=\"pointed-line\"\u003E\u003Cspan class=\"point animated-dot-14\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"point animated-dot-15\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"point animated-dot-16\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"rules-container\"\u003E\u003Cdiv class=\"title\"\u003E\u003Csvg class=\"title-image\" width=\"14px\" height=\"14px\" viewBox=\"166 99 14 14\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\"\u003E\u003Cpath class=\"animated-text-17\" d=\"M166,101.699341 C166,100.208536 167.217917,99 168.699341,99 L177.300659,99 C178.791464,99 180,100.217917 180,101.699341 L180,110.300659 C180,111.791464 178.782083,113 177.300659,113 L168.699341,113 C167.208536,113 166,111.782083 166,110.300659 L166,101.699341 Z M174.545535,101 L170,106.748264 L172.590323,106.748264 L171.589441,110.625 L176.125,104.876736 L173.524701,104.876736 L174.545535,101 Z\" id=\"Combined-Shape\" stroke=\"none\" fill=\"#FFFFFF\" fill-rule=\"evenodd\" opacity=\"0.3\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fsvg\u003E\u003Cspan class=\"animated-text-17\"\u003ERules Engine\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"select rule-selector\"\u003E\u003Cselect id=\"ruleOptions\"\u003E\u003Coption value=\"option1\"\u003EOnly allow logins during weekdays\u003C\u002Foption\u003E\u003Coption value=\"option2\"\u003ESlack Notification on User Signup\u003C\u002Foption\u003E\u003Coption value=\"option3\"\u003EIP Address whitelist\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"rule-editor\"\u003E\u003Cpre\u003E\u003Ccode\u003Efunction (user, context, callback) {\n  if (context.clientName === 'TheAppToCheckAccessTo') {\n    var d = new Date().getDay();\n      if (d === 0 || d === 6) {\n        return callback(new UnauthorizedError('This app is available during the week'));\n    }\n  }\n  callback(null, user, context);\n}\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"std-cert\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-4 col-md-offset-1 pull-right\"\u003E\u003Ch2 class=\"title\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fstd_cert\u002Fstar-18e8030ca0.svg\" role=\"presentation\" alt=\"\"\u003Estandards & certifications\u003C\u002Fh2\u003E\u003Cp\u003EWe strive to make it simple for our clients to comply with the most strict industry standards & regulations. To do this, we make use of the best technologies and practices available to us.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-7 std-cert-logos\"\u003E\u003Ca class=\"std-cert-logo-link\" href=\"https:\u002F\u002Foauth.net\u002F\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fstd_cert\u002Foauth2-360e300bd3.svg\" alt=\"OAuth2 logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"std-cert-logo-link\" href=\"http:\u002F\u002Fopenid.net\u002F\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E\u003Cimg class=\"openid\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fstd_cert\u002Fopenid-ab6c47dd68.svg\" alt=\"OpenID logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"std-cert-logo-link\" href=\"https:\u002F\u002Fwww.hhs.gov\u002Fhipaa\u002F\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fstd_cert\u002Fhipaa-2ec0cfe308.svg\" alt=\"HIPAA logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"std-cert-logo-link\" href=\"https:\u002F\u002Fwww.aicpa.org\u002FInterestAreas\u002FFRC\u002FAssuranceAdvisoryServices\u002FPages\u002FAICPASOC2Report.aspx\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fab-variants\u002Fnew-homepage\u002Fimg\u002Fstd_cert\u002Faicpa-e6fa275170.svg\" alt=\"AICPA logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"try-auth0 theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-5\"\u003E\u003Ch2\u003EMake the internet safer \u003Cbr\u003E\u003Cspan class=\"lowlight\"\u003EImplement Auth0 today\u003C\u002Fspan\u003E\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-7\"\u003E\u003Cdiv class=\"try-buttons\"\u003E\u003Cdiv class=\"success\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003EUse Auth0 for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default\"\u003E\u003Ca class=\"btn btn-lg btn-default open-contact-form-modal\"\u003ETalk to sales\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (_, features, filterPlans, planKey, plans) {var plan = plans.findByPlanKey(planKey)
var index = _.findIndex(plans.models, { plan: planKey })
var prevPlan = index && _.at(plans.models, index - 1)[0];
var prevPlanIndex = index && index - 1;
var currentFeatures = features.filter(function (feature) {
  var featureAvailableForPlans = feature.plans.filter(filterPlans).length;
  var isNotInPreviousPlans = (plans.length - index) === featureAvailableForPlans;
  var isNotFiltered = plan.hasFeature(feature);
  return isNotInPreviousPlans && isNotFiltered;
});
var prevPlanFeatures = prevPlan && features.filter(function (feature) {
  var featureAvailableForPlans = feature.plans.filter(filterPlans).length;
  var isNotInPreviousPlans = (plans.length - prevPlanIndex) === featureAvailableForPlans;
  var isNotFiltered = prevPlan.hasFeature(feature);
  return isNotInPreviousPlans && isNotFiltered;
});
var prevPlanFeaturesArray = prevPlan && _.map(prevPlanFeatures.models).map(function (f) {
  return f.friendlyName
})
var freeFeatures = [
  'Passwordless & TouchID Login',
  'Lock for Web, iOS & Android',
  'Up to 2 social identity providers',
  'Rules & Webtask.io subscription'
];

pug_mixins["check-icon"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg class=\"check-icon-white\" width=\"12px\" height=\"9px\" viewBox=\"423 363 12 9\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\"\u003E\n\u003Cpolygon id=\"Path-2\" stroke=\"none\" fill=\"#FFFFFF\" fill-rule=\"evenodd\" points=\"426.355216 371.158394 427.068452 371.87163 427.775506 371.152265 434.41029 364.401955 432.983923 363 426.349139 369.750309 427.769429 369.74418 424.414214 366.388964 423 367.803178\"\u003E\u003C\u002Fpolygon\u003E\n\u003C\u002Fsvg\u003E";
};
pug_mixins["prev-plan-mixin"] = pug_interp = function(plan, features){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E" + (pug.escape(null == (pug_interp = 'also includes:') ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
if ('free' === plan.plan) {
// iterate freeFeatures
;(function(){
  var $$obj = freeFeatures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var feature = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
else {
// iterate features
;(function(){
  var $$obj = features;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var feature = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
};
pug_mixins["feature-item"] = pug_interp = function(title, feature){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cp" + (" class=\"only-tooltip\""+" data-toggle=\"tooltip\" data-placement=\"bottom\" data-container=\"body\" data-trigger=\"hover\""+pug.attr("data-original-title", feature.description, true, true)) + "\u003E";
if (feature.link) {
pug_html = pug_html + "\u003Ca" + (" class=\"feature-link\""+pug.attr("href", feature.link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fp\u003E";
};
































}.call(this,"_" in locals_for_with?locals_for_with._:typeof _!=="undefined"?_:undefined,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"filterPlans" in locals_for_with?locals_for_with.filterPlans:typeof filterPlans!=="undefined"?filterPlans:undefined,"planKey" in locals_for_with?locals_for_with.planKey:typeof planKey!=="undefined"?planKey:undefined,"plans" in locals_for_with?locals_for_with.plans:typeof plans!=="undefined"?plans:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (features, featuresByTag, planHighlighting, plans, sortTags) {pug_html = pug_html + "\u003Cdiv class=\"features-table-cont\"\u003E\u003Cdiv class=\"features-divisions-outer\"\u003E\u003Cdiv class=\"features-divisions\" id=\"features-divisions\"\u003E\u003Cdiv class=\"division dummy-div\"\u003E\u003C\u002Fdiv\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var plan = $$obj[pug_index0];
var activePlan = plan.isSomeByKey(planHighlighting) ? 'active' : '';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["division","js-plan-name","plan-name",[plan.custom ? 'custom' : '', plan.plan.toLowerCase(), activePlan ]], [false,false,false,true]), false, true)+pug.attr("data-plan", plan.plan.toLowerCase(), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = plan.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index0];
var activePlan = plan.isSomeByKey(planHighlighting) ? 'active' : '';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["division","js-plan-name","plan-name",[plan.custom ? 'custom' : '', plan.plan.toLowerCase(), activePlan ]], [false,false,false,true]), false, true)+pug.attr("data-plan", plan.plan.toLowerCase(), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = plan.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"features-table\"\u003E";
// iterate features.groupByTags().sort(sortTags).groups
;(function(){
  var $$obj = features.groupByTags().sort(sortTags).groups;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var group = $$obj[pug_index1];
featuresByTag = group.features
if ((group.key)) {
pug_html = pug_html + "\u003Ctr class=\"feature-row header-row js-tag\"\u003E\u003Ctd" + (pug.attr("colspan", plans.length + 1, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = group.key) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
// iterate featuresByTag.models
;(function(){
  var $$obj = featuresByTag.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var plan = $$obj[pug_index3];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index3];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var plan = $$obj[pug_index4];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index4];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var group = $$obj[pug_index1];
featuresByTag = group.features
if ((group.key)) {
pug_html = pug_html + "\u003Ctr class=\"feature-row header-row js-tag\"\u003E\u003Ctd" + (pug.attr("colspan", plans.length + 1, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = group.key) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
// iterate featuresByTag.models
;(function(){
  var $$obj = featuresByTag.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var feature = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var plan = $$obj[pug_index6];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index6];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var plan = $$obj[pug_index7];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index7];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E";}.call(this,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"featuresByTag" in locals_for_with?locals_for_with.featuresByTag:typeof featuresByTag!=="undefined"?featuresByTag:undefined,"planHighlighting" in locals_for_with?locals_for_with.planHighlighting:typeof planHighlighting!=="undefined"?planHighlighting:undefined,"plans" in locals_for_with?locals_for_with.plans:typeof plans!=="undefined"?plans:undefined,"sortTags" in locals_for_with?locals_for_with.sortTags:typeof sortTags!=="undefined"?sortTags:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (tooltip) {var fixedPlan = {id: 'fixed', title: 'Packages', cssClass: 'fixed active', iconClass: 'icon-budicon-647' };
var customPlan = {id: 'custom', title: 'Build a Custom Plan', cssClass: 'custom', iconClass: 'icon-budicon-327' };
var tabs = [fixedPlan, customPlan];
var free = ['Passwordless & TouchID Login', 'Lock for Web, iOS & Android', 'Up to 2 social identity providers', 'Rules & Webtask.io subscription'];
var dev = ['All Free Features', 'Social Connections', 'Email Notifications', 'Custom Email Provider', 'Impersonation'];
var devPro = ['All Developer Features', 'Delegation', 'AD Connector', 'Account Linking', 'Custom Emails', 'Password Complexity', 'MFA Consumer'];
var enterprise = ['All Developer Pro Features', 'SOC2 & HIPAA/BAA Compliance', 'On Premise Deployment', 'Database Migration', 'MFA Consumer & Enterprise', 'Enterprise Add-On Delegation', 'Password Complexity', 'SLA', 'Enterprise Support', 'Consolidation of user stores'];
pug_html = pug_html + "\u003Clink rel=\"stylesheet\" type=\"text\u002Fcss\" href=\"\u002F\u002Fcdn.auth0.com\u002Fpricing-widget\u002Fpricing-widget-4.3.min.css\"\u003E";
pug_mixins["plan-sliders"] = pug_interp = function(sliders){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (sliders['social'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-slider\" data-user-slider=\"social\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-data\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"A user that has authenticated with username\u002Fpassword, passwordless connections or any social provider in the last 30 days, counted per application.\"\u003E\u003Cspan data-user-count=\"social\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"slider-detail\"\u003ERegular Active Users\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
if (sliders['free'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-data\"\u003E\u003Cspan\u003ESee all free features\u003C\u002Fspan\u003E\u003Ca href=\"#features-divisions\"\u003E\u003Cspan class=\"slider-detail\"\u003Ebelow\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
if (sliders['developer'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-data\"\u003E\u003Cspan\u003ESee all developer features\u003C\u002Fspan\u003E\u003Ca href=\"#features-divisions\"\u003E\u003Cspan class=\"slider-detail\"\u003Ebelow\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
if (sliders['enterprise'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-slider\" data-user-slider=\"enterprise\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-data\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"A user that has authenticated using an enterprise connection like SAML, Active Directory or LDAP among others in the last 30 days, counted per application.\"\u003E\u003Cspan data-user-count=\"enterprise\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"slider-detail\"\u003EEnterprise Active Users\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
if (sliders['employee'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-slider\" data-user-slider=\"employee\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-data\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"An internal employee of your company that authenticated with any connection or identity provider.\"\u003E\u003Cspan data-user-count=\"employee\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"slider-detail\"\u003EEmployees\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["plan-price"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan class=\"money-sign\"\u003E$\u003C\u002Fspan\u003E\u003Cspan class=\"price-amount\" data-price-tag=\"\"\u003E0\u003C\u002Fspan\u003E\u003Cspan class=\"price-time\" data-time-period=\"\"\u003E\u002Fmo\u003C\u002Fspan\u003E";
};
pug_mixins["plan-usage-switch"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"plan-usage-toggle\"\u003E\u003Cform class=\"plan-usage-form\"\u003E\u003Cdiv class=\"switch-group\" data-toggle=\"tooltip\" data-placement=\"top\" data-container=\"body\" title=\"You should choose this option if it will be external people the ones who will authenticate against the applications and APIs you've created or acquired.\"\u003E\u003Cinput id=\"external\" type=\"radio\" name=\"usage\" value=\"external\" checked\u003E\u003Clabel for=\"external\"\u003E\u003Cspan class=\"only-tooltip\"\u003EExternal\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-group\" data-toggle=\"tooltip\" data-placement=\"top\" data-container=\"body\" title=\"You should choose this option if it will be your company employees the ones who will authenticate against the applications and APIs you've created or acquired.\"\u003E\u003Cinput id=\"internal\" type=\"radio\" name=\"usage\" value=\"internal\"\u003E\u003Clabel for=\"internal\"\u003E\u003Cspan class=\"only-tooltip\"\u003EInternal\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["plan-actions"] = pug_interp = function(button){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cbutton class=\"plan-cta btn btn-lg btn-success js-start-now\" data-plan-checkout\u003E" + (pug.escape(null == (pug_interp = button.text) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Ca class=\"plan-cta btn btn-lg btn-success js-buy-now hide\" href=\"\u002F\u002Fmanage.auth0.com\u002F#\u002Faccount\u002Fbilling\u002Fsubscription\"\u003E" + (pug.escape(null == (pug_interp = button.text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (button.customText) {
pug_html = pug_html + "\u003Cbutton class=\"plan-cta btn btn-lg btn-success js-plan-contact-sales custom-deal open-contact-form-modal\"\u003E" + (pug.escape(null == (pug_interp = button.customText) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
}
};
pug_mixins["plan-box"] = pug_interp = function(plan, name, planClass, description, button, sliders, showPrice, subtitle, onlyTooltip){
var block = (this && this.block), attributes = (this && this.attributes) || {};
showPrice = typeof showPrice === 'undefined' ? true : false
subtitle  = typeof subtitle === 'undefined' ? '' : 'has-subtitle'
tooltip = typeof onlyTooltip === 'undefined' ? false : true
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["plan-box",planClass], [false,true]), false, true)+pug.attr("data-plan", plan, true, true)) + "\u003E\u003Cdiv class=\"plan-box-inner\"\u003E\u003Cdiv class=\"plan-header\"\u003E\u003Cdiv class=\"plan-image\"\u003E\u003Cimg" + (pug.attr("src", '/pages/ab-variants/new-pricing/img/illustration-' + plan + '.svg', true, true)+pug.attr("alt", plan, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Ch3" + (pug.attr("class", pug.classes(["plan-title",subtitle], [false,true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = name) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-body\"\u003E";
if ((plan!=='enterprise')) {
pug_html = pug_html + "\u003Cdiv class=\"plan-price\"\u003E";
pug_mixins["plan-price"]();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cspan class=\"price-alt-text\"\u003EGet in touch\u003C\u002Fspan\u003E";
}
if ((plan=='enterprise')) {
pug_html = pug_html + "\u003Ch2 class=\"ent-alt-text\"\u003EContact Us\u003C\u002Fh2\u003E";
}
if ((plan!=='enterprise')) {
pug_html = pug_html + "\u003Cdiv class=\"plan-details\"\u003E";
if ((plan=='developer-pro')) {
pug_mixins["plan-usage-switch"]();
}
pug_mixins["plan-sliders"](sliders);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if ((plan=='enterprise')) {
pug_html = pug_html + "\u003Cp class=\"plan-description\"\u003E" + (pug.escape(null == (pug_interp = description) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"plan-ctas-cont\"\u003E";
pug_mixins["plan-actions"](button);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"js-plan-features-container\""+pug.attr("data-plan", plan, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"fixed-plans\" id=\"pricing-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cnoscript\u003E\u003Cimg height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https:\u002F\u002Fanalytics.twitter.com\u002Fi\u002Fadsct?txn_id=l4ru9&p_id=Twitter\" \u002F\u003E\n\u003Cimg height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"\u002F\u002Ft.co\u002Fi\u002Fadsct?txn_id=l4ru9&p_id=Twitter\" \u002F\u003E\u003C\u002Fnoscript\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1\u003EFlexible pricing,\u003Cbr class=\"rm-break\"\u003E for developers and companies\u003C\u002Fh1\u003E\u003Cp\u003EEverything you need to start using Auth0\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"plans-switch\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"switch-container\"\u003E\u003Cdiv class=\"switch-cont\"\u003E\u003Cdiv class=\"switch-plan\" data-view=\"fixed-plans\"\u003E\u003Ca class=\"switch-item active\" href=\"#\" data-interval=\"month\"\u003EMonthly Billing\u003C\u002Fa\u003E\u003Ca class=\"switch-item\" href=\"#\" data-interval=\"year\"\u003EYearly Billing\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-text\"\u003ESubscribe for a year and get a month free\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"pricing-module\" data-pricing-category=\"developers\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"module-plans-outer\"\u003E";
pug_mixins["plan-box"]('free', 'free', 'free' ,'See all free features below', { text: 'START NOW', customText: 'START NOWS' }, { free: true }, undefined, true);
pug_mixins["plan-box"]('developer', 'Developer', 'developer' ,'Use any social identity providers to authenticate, manage users with a powerful dashboard, and customize and extend authentication processes programatically.', { text: 'TRY IT FOR FREE', customText: 'CONTACT US' }, { social: true, developer: true });
pug_mixins["plan-box"]('developer-pro', 'Developer Pro', 'developer-pro-external' ,'Enterprise identity providers support, impersonation and additional security features including password complexity rules and multi-factor authentication among others.', { text: 'TRY IT FOR FREE', customText: 'CONTACT US' }, { social: true, enterprise: true }, undefined, true);
pug_mixins["plan-box"]('developer-pro', 'Developer Pro', 'developer-pro-internal hide' ,'Enterprise identity providers support, impersonation and additional security features including password complexity rules and multi-factor authentication among others.', { text: 'TRY IT FOR FREE', customText: 'CONTACT US' }, { employee: true}, undefined, true);
pug_mixins["plan-box"]('enterprise', 'Enterprise', 'enterprise', 'High SLA environment with enterprise-grade support, SOC 2, HIPAA/BAA, Privacy Shield certifications and audit reports as well as private cloud or on-premise deployments.', { text: 'TALK TO SALES', customText: 'TALK TO SALES' }, {}, undefined, true);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"pricing-full-features\" id=\"full-features\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"features-header\"\u003E\u003Ch2 class=\"section-title\"\u003ECompare our features, side by side\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"features-table-outer-cont\"\u003E\u003Cdiv class=\"js-features-table-container\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"enterprise-addons theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"enterprise-addon-container\"\u003E\u003Cdiv class=\"enterprise-addons-header\"\u003E\u003Cimg class=\"section-heading-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-addons-1b23d1097d.svg\" alt=\"features\"\u003E\u003Ch2 class=\"section-title\"\u003EEnterprise Addons\u003C\u002Fh2\u003E\u003Cp class=\"enterprise-addons-description\"\u003EGet the most out of your Auth0 subscription by adding our enterprise-grade, web-scale add-ons. Try them for free!\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-lg btn-success js-general-contact-sales open-contact-form-modal\"\u003ETALK TO SALES\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"addons-list\"\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Fbreached-passwords-logo-ddbcd43a85.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003EBreached Password Detection\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EKeep your users and services safe from password leaks and intruders. Protects and notifies your users when their credentials are leaked by a data breach of a third party or when somebody is trying to force their way into their account.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"button btn btn-lg btn-success\" href=\"javascript:signup()\"\u003ETry it for free\u003C\u002Fa\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fbreached-passwords\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Fguardian-logo-510772a3a5.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003EMultifactor Auth with Guardian\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EThe most usable and friction-free multifactor authentication experience available. Use the Guardian iOS or Android app to receive push notifications, get one-time codes delivered via SMS or connect with a third party token generation app such as Google Authenticator.\u003C\u002Fp\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"button btn btn-lg btn-success\" href=\"javascript:signup()\"\u003ETry it for free\u003C\u002Fa\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fguardian\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-premium-support-dcd8155364.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003EPreferred Support\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EPreferred level of support agreement that includes extended support hours including an available 24\u002F7 option with 1 hour response time and a dedicated customer success manager to help you with your on boarding and on going experience with Auth0.\u003C\u002Fp\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fsupport#ticket-response-times\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-sla-9995-a6257c73dc.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003ESLA 99.95%\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EAuth0 commits to deliver 99.95% level of end-user availability of service, with financial incentives to perform.\u003C\u002Fp\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fsupport\u002Fsla\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fsection\u003E\u003Csection class=\"faq theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"faq-header\"\u003E\u003Cimg class=\"section-heading-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-faq-86386d9b51.svg\" alt=\"Frecuently Asked Questions\"\u003E\u003Ch2 class=\"section-title\"\u003EFrequently Asked Questions\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"faq-outer-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cul class=\"question-list\"\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhy should I trust Auth0 with my users?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003ESecurity is our utmost priority. For starters, we follow security best practices for storing user credentials: they are never stored in plain text, and all passwords are hashed and salted using the \u003Ca href=\"https:\u002F\u002Fen.wikipedia.org\u002Fwiki\u002FBcrypt\"\u003Ebcrypt\u003C\u002Fa\u003E algorithm, a state-of-the-art algorithm designed to prevent brute-force attacks even in case of a breach. Furthermore, our implementation of TLS has received an “A+” score in \u003Ca href=\"https:\u002F\u002Fwww.ssllabs.com\u002Fssltest\u002Fanalyze.html?d=manage.auth0.com\"\u003EQualsys’ SSL Labs SSL Server test\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EWe also implement proactive security measures for your projects such as password breach detection, using a huge database of leaked passwords, and brute-force attack detection. Automated rate-limiting checks and denial of service mitigation procedures are also in place.\u003C\u002Fp\u003E\u003Cp\u003EYou can learn more about security at Auth0 at our \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\u002F\"\u003Esecurity page\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat happens if I stop using Auth0? How do I know my user's data is safe?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EYour data is safe as long as it’s stored in our servers. If you choose to stop using Auth0, exporting your data is a simple matter. Head over to the Auth0 Dashboard and go to the extensions page. Select “User Import\u002FExport” and proceed to enable the extension. If you need help using the extension, check our \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fextensions\u002Fuser-import-export\"\u003Edocs\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EIf you feel the export extension does not fill your needs, the \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fapi\u002Fmanagement\u002Fv2#!\"\u003EAuth0 management API\u003C\u002Fa\u003E lets you fully inspect all the data from your account. With it, you can export all data to any format.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat's the difference between regular users and enterprise users? How is the user count computed?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EUsers are differentiated according to what type of connection is required for them. Regular users are connected through a standard database connection (username + password), a passwordless scheme (SMS, E-mail, TouchID) or a \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\"\u003Esocial connection\u003C\u002Fa\u003E (of which there are more than 30 providers). Enterprise users, on the other hand, are connected through an enterprise connection such as Active Directory, WS-Federation or LDAP. You can find all about the different types of connections in the \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\"\u003Edocs\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EBoth the regular users and the enterprise users are counted as active if they logged in at least once in the last 30 days. Employee users are always counted, regardless of their activity.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EIf I surpass the 7000 users Free Plan do I need to select the Developer Plan with up to 10,000 users?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EYes, if you pass the 7,000 users mark, you need to select the Developer Plan (or any of the other plans that fit your needs) and select the right amount of users for your use case. Paid plans let you pick a custom number of users, from 1,000 up to 100,000 or more. Up to 7,000 users, a special, lower, per-user price is computed, to recoup for the users of the free plan. Regardless of the number of users you pick, you always get all the added benefits of the paid plans, such as 2 days log retention and unlimited social providers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat are the different deployment models and the difference of private cloud vs appliance?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EAuth0 can run as a third-party service on the Auth0 cloud, or it can be installed to your own internal systems or cloud. In particular, Auth0 supports \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Foverview\u002Fdeployment-models\"\u003Efour different types of deployment modes\u003C\u002Fa\u003E:\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003EAuth0 cloud, multi-tenant\u003C\u002Fli\u003E\u003Cli\u003EAuth0 cloud, single-tenant (dedicated)\u003C\u002Fli\u003E\u003Cli\u003ECustomer’s cloud (private cloud)\u003C\u002Fli\u003E\u003Cli\u003ECustomer’s data centre (appliance)\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat's Auth0's uptime and status?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EAuth0 systems have over 99.9% monthly uptime figures. You can check the current and past status and uptime figures at the \u003Ca href=\"https:\u002F\u002Fstatus.auth0.com\u002F\"\u003Estatus\u003C\u002Fa\u003E and \u003Ca href=\"http:\u002F\u002Fuptime.auth0.com\u002F\"\u003Euptime\u003C\u002Fa\u003E pages.\u003C\u002Fp\u003E\u003Cp\u003EEnterprise users can optionally request a Service Level Agreement (SLA) with 99.95% availability for an added cost.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EHow long does my trial last?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EThe trial period lasts 22 days. After that, the free plan gets activated automatically. If you wish to continue using some of the features from our Developer, Developer Pro or Enterprise plans, please choose one from above.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"tooltip" in locals_for_with?locals_for_with.tooltip:typeof tooltip!=="undefined"?tooltip:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Object, people) {pug_html = pug_html + "\u003Cdiv class=\"about-page\"\u003E\u003Cdiv class=\"banner-diagonal\"\u003E\u003Cdiv class=\"banner-content\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Foffsite-2016\u002Foffsite-16-d87d0e94a6.jpg\" alt=\"Auth0 team\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info-post-slider\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1\u003EAbout Us\u003C\u002Fh1\u003E\u003Cp\u003EWe're a team of developers that got tired of the friction caused by complex identity environments. So we built a zero-friction, infinitely extensible, enterprise-class web-scale cloud solution that makes identity easy.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"#meet-the-team\" data=\"scroll-to\"\u003EMEET THE TEAM\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"missions\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EOur Mission\u003C\u002Fh2\u003E\u003Cp\u003EZero-friction authentication and authorization for developers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team team-random\" id=\"meet-the-team\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EThe Team\u003C\u002Fh2\u003E\u003Csection\u003E";
// iterate people.filter(function(person) { return person.active})
;(function(){
  var $$obj = people.filter(function(person) { return person.active});
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var person = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle\u003E\u003Cdiv class=\"profile\"\u003E\u003Cimg" + (pug.attr("src", person.avatarUrl, true, true)+pug.attr("alt", person.name, true, true)) + "\u003E\u003Ch4\u003E" + (pug.escape(null == (pug_interp = person.name) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = person.title) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = person.quote) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
if (person.social) {
pug_html = pug_html + "\u003Cul class=\"social\"\u003E";
// iterate Object.keys(person.social).sort()
;(function(){
  var $$obj = Object.keys(person.social).sort();
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var key = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([key], [true]), false, true)) + "\u003E\u003Ca" + (pug.attr("href", person.social[key], true, true)+" target=\"_blank\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var key = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([key], [true]), false, true)) + "\u003E\u003Ca" + (pug.attr("href", person.social[key], true, true)+" target=\"_blank\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var person = $$obj[pug_index0];
pug_html = pug_html + "\u003Carticle\u003E\u003Cdiv class=\"profile\"\u003E\u003Cimg" + (pug.attr("src", person.avatarUrl, true, true)+pug.attr("alt", person.name, true, true)) + "\u003E\u003Ch4\u003E" + (pug.escape(null == (pug_interp = person.name) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = person.title) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hover\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = person.quote) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
if (person.social) {
pug_html = pug_html + "\u003Cul class=\"social\"\u003E";
// iterate Object.keys(person.social).sort()
;(function(){
  var $$obj = Object.keys(person.social).sort();
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var key = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([key], [true]), false, true)) + "\u003E\u003Ca" + (pug.attr("href", person.social[key], true, true)+" target=\"_blank\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var key = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli" + (pug.attr("class", pug.classes([key], [true]), false, true)) + "\u003E\u003Ca" + (pug.attr("href", person.social[key], true, true)+" target=\"_blank\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"investors\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EInvestors\u003C\u002Fh2\u003E\u003Csection\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fbvp.com\u002F\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fbvp-a89e92a609.png\" alt=\"Bessemer Venture Partners\"\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fwww.trinityventures.com\u002F\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Ftrinity-a4621f5692.png\" alt=\"Trinity Ventures\"\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fk9ventures.com\u002F\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fk9-7b7fdf33a9.png\" alt=\"K9 Ventures\"\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fportlandseedfund.com\u002F\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fseedfund-8aa378e8c4.png\" alt=\"Portland Seed Fund\"\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fnxtplabs.com\u002F\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fnxtplabs-26f53a421a.png\" alt=\"Nxtp Labs\"\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"advisors\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EAdvisors\u003C\u002Fh2\u003E\u003Csection\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Ftwitter.com\u002Frauchg\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fguillermo-dca664fd8a.png\" alt=\"Guillermo Rauch\"\u003E\u003C\u002Fa\u003E\u003Ch4\u003E\u003Ca href=\"https:\u002F\u002Ftwitter.com\u002Frauchg\" target=\"_blank\"\u003EGuillermo Rauch\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003Cp\u003ECreator of Socket.IO. Founder of Cloudup.\u003C\u002Fp\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Ftwitter.com\u002Fdscape\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fnuno-d8fe7b6a05.png\" alt=\"Nuno Job\"\u003E\u003C\u002Fa\u003E\u003Ch4\u003E\u003Ca href=\"https:\u002F\u002Ftwitter.com\u002Fdscape\" target=\"_blank\"\u003ENuno Job\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003Cp\u003EDirector at YLD, ex Nodejitsu.\u003C\u002Fp\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fen.wikipedia.org\u002Fwiki\u002FSteve_Coast\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Fsteve-77e739ebca.png\" alt=\"Steve Coast\"\u003E\u003C\u002Fa\u003E\u003Ch4\u003E\u003Ca href=\"http:\u002F\u002Fen.wikipedia.org\u002Fwiki\u002FSteve_Coast\" target=\"_blank\"\u003ESteve Coast\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003Cp\u003EFounder of OpenStreetMap.\u003C\u002Fp\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fen.wikipedia.org\u002Fwiki\u002FTim_Bray\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fabout\u002Fimg\u002Ftim-4233003c9b.png\" alt=\"Tim Bray\"\u003E\u003C\u002Fa\u003E\u003Ch4\u003E\u003Ca href=\"http:\u002F\u002Fen.wikipedia.org\u002Fwiki\u002FTim_Bray\" target=\"_blank\"\u003ETim Bray\u003C\u002Fa\u003E\u003C\u002Fh4\u003E\u003Cp class=\"width\"\u003EFounder of two companies. Maker of internet standards. Veteran of sun Microsystems and Google.\u003C\u002Fp\u003E\u003C\u002Farticle\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"where-we-are\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EWhere we are\u003C\u002Fh2\u003E\u003Cp\u003EWe believe talent is everywhere\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"map\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fmap-5f9892722c.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip tooltip-1 hq wow bounceIn\"\u003E\u003Cdiv class=\"glow wow blip\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESeattle HQ\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E72 authzeros\u003C\u002Fp\u003E\u003Cp class=\"grey\"\u003E10900 NE 8th St #700, Bellevue, WA\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgoo.gl\u002Fmaps\u002F1gLQGBsgugE2\" target=\"_blank\"\u003EView on Google Maps\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-2 hq wow bounceIn\"\u003E\u003Cdiv class=\"glow wow blip\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EBuenos Aires HQ\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E53 authzeros\u003C\u002Fp\u003E\u003Cp class=\"grey\"\u003EEl Salvador 5718, CABA\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgoo.gl\u002Fmaps\u002FekAb93KPqtQ2\" target=\"_blank\"\u003EView on Google Maps\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-3 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EBelgium\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E2 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-4 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003EAustralia\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E4 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-5 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EPhiladelphia\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-6 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EMountain View\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-7 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ECordoba\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-8 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EDetroit\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-9 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EBrazil\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E3 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-10 hq wow bounceIn\"\u003E\u003Cdiv class=\"glow wow blip\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EUnited Kingdom HQ\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E10 authzeros\u003C\u002Fp\u003E\u003Cp class=\"grey\"\u003ESiena Court, The Broadway, Maidenhead SL6 1NJ\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgoo.gl\u002Fmaps\u002FDkmdr2AioyA2\" target=\"_blank\"\u003EView on Google Maps\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-11 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESouth Africa\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-12 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ECanada\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E4 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-13 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003EJapan\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E2 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-14 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003ETaiwan\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-15 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EPoland\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-16 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EChile\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E3 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-17 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESpain\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E3 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-18 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003ENew Zealand\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-19 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EGreece\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-20 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESri Lanka\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-21 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ENigeria\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-22 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EBolivia\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-23 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EColombia\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E2 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-24 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EIndia\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E2 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-25 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESweden\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-26 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ENetherlands\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E2 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-27 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EPortugal\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-28 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EPuerto Rico\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-29 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ETrinidad and Tobago\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-30 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ETurkey\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E1 authzero\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-31 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EMinneapolis\u003C\u002Fp\u003E\u003Cp class=\"orange\"\u003E3 authzeros\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contacts\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EJoin Us\u003C\u002Fh2\u003E\u003Cp\u003E\u003Ca href=\"mailto:jobs@auth0.com\"\u003Ejobs@auth0.com\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"social\"\u003E\u003Cli class=\"twitter\"\u003E\u003Ca href=\"http:\u002F\u002Ftwitter.com\u002Fauth0\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"git\"\u003E\u003Ca href=\"http:\u002F\u002Fgithub.com\u002Fauth0\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"dribble\"\u003E\u003Ca href=\"http:\u002F\u002Fdribbble.com\u002Fauth0\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"talk\"\u003E\u003Ca href=\"mailto:info@auth0.com\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team-slider\"\u003E\u003Cdiv class=\"overlay\"\u003E\u003Cdiv class=\"close-slider\"\u003E\u003Ci class=\"icon-budicon-471\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slider\"\u003E\u003Csection\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"Object" in locals_for_with?locals_for_with.Object:typeof Object!=="undefined"?Object:undefined,"people" in locals_for_with?locals_for_with.people:typeof people!=="undefined"?people:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"ambassador-program page-content\"\u003E\u003Cdiv class=\"jumbo-ambasador\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-7 vertical-align\"\u003E\u003Ch1\u003EAuth0 Ambassador Program\u003C\u002Fh1\u003E\u003Cp\u003EDo you want to serve the developer community, make the internet safer, and build your brand while you’re at it?\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success form-apply\"\u003EAPPLY TO BE AN AMBASSADOR\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003Cimg class=\"jumbo-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fambassador-program\u002Fassets\u002Fambassador-spaceman-stand-up-2x-bccef18705.gif\" alt=\"Ambassador Program\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"our-goal\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-4 vertical-align\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fambassador-program\u002Fassets\u002Four-goal-cd01870d2b.svg\" alt=\"Ambassador Program Goal\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8 vertical-align\"\u003E\u003Ch2\u003EOur Goal\u003C\u002Fh2\u003E\u003Cp\u003EHere at Auth0 we love developers. Serving and giving back to their community is one of the most rewarding things we do. That’s why we're looking to expand on these outreach efforts by launching the Ambassador program!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"can-i\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-4 vertical-align image\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fambassador-program\u002Fassets\u002Fambassador-b3bf911893.svg\" alt=\"Can I be an Ambassador?\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8 vertical-align description\"\u003E\u003Ch2\u003ECan I be an Ambassador?\u003C\u002Fh2\u003E\u003Cp\u003EIf you feel that the criteria below sounds similar to you, then you should apply to be an Auth0 Ambassador!\u003C\u002Fp\u003E\u003Cul class=\"can-i-list list\"\u003E\u003Cli\u003E\u003Cspan\u003EPassionate about mentoring and teaching developers\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EActive participant and\u002For leader in a tech community\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EA love of software development\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EDream job is to become a Developer Evangelist\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EA demonstrated interest in at least two of the following (creating technical blog posts, public speaking, developer events, web or mobile development)\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EOver the Age of 18\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"two-sections-container clearfix\"\u003E\u003Cdiv class=\"paid-position\"\u003E\u003Cdiv class=\"image-left\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fambassador-program\u002Fassets\u002Fpaid-image-l-5becaec417.svg\" alt=\"Ambassador Program Paid Position\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2 class=\"text-center\"\u003EIs This a Paid Position?\u003C\u002Fh2\u003E\u003Cp class=\"text-center\"\u003EThis is not a paid position. However you get access to some great rewards and perks\u003Cbr\u003Efor being an Auth0 Ambassador.\u003C\u002Fp\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cul class=\"list\"\u003E\u003Cli\u003E\u003Cspan\u003EExclusive Auth0 gear that identifies you as part of the Ambassador Program\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003ERecognition on Auth0’s Facebook, Twitter & Blog\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EEnrolled in our guest Author program\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EWe’ll pay for travel and lodging to any of your accepted talks that cover Auth0 or Identity \u002F Security\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cul class=\"list\"\u003E\u003Cli\u003E\u003Cspan\u003EExclusive access to new Auth0 features (more details will be given once you’re in the program)\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EA stash of Auth0 swag that you can hand out at events\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EHave Auth0 sponsor local developer meetups of your choice\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EOther experiences such as tickets to participate in StartupBus or similar events\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"image-right\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fambassador-program\u002Fassets\u002Fpaid-image-r-da118121e5.svg\" alt=\"Ambassador Program Perks\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"what-does-ambassador\"\u003E\u003Cdiv class=\"image-traveler\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fambassador-program\u002Fassets\u002Fambassador-spaceman-2x-6975e8a2d6.gif\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-8 pull-right\"\u003E\u003Ch2\u003E\tWhat Does the Ambassador Program Entail?\u003C\u002Fh2\u003E\u003Cp\u003EOur evangelism team will help you build up your brand and local developer community by:\u003C\u002Fp\u003E\u003Cul class=\"list\"\u003E\u003Cli\u003E\u003Cspan\u003EHelping you organize local meetups\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EBuilding up your technical speaking & writing skills\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EWe will help you find and create open source projects that you can get involved in\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EGive you opportunities to mentor developers at startup accelerators, hackathons & conferences\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EShowcase the awesome hacks you build on top of our API’s\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EMuch, much more!\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp\u003EAll of these tasks will be on a voluntary basis. This means you can do as much or as little as your schedule permits. However, the more you do, the more rewards and perks you get!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"question\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-8 text-center\"\u003E\u003Ch2 class=\"text-center\"\u003EWhat if I Have Additional Questions?\u003C\u002Fh2\u003E\u003Cp class=\"text-center\"\u003EPlease email\u003Ca href=\"mailto:community@auth0.com\"\u003E community@auth0.com\u003C\u002Fa\u003E for any additional questions. You shouldhear back from us within 48hrs.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"apply text-center\" id=\"form-apply\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-10 center-block\"\u003E\u003Ch2\u003E\tApply to be an Ambassador\u003C\u002Fh2\u003E\u003Cp\u003EWe’ll follow up with an email that includes an assignment that will help us gauge your experiences in the developer community.\u003C\u002Fp\u003E\u003Cspan class=\"icon-budicon-389\" style=\"display:none;\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-rotating icon-budicon-330\" style=\"display:none;\"\u003E\u003C\u002Fspan\u003E\u003Cform class=\"apply-form\" id=\"ambassador-program-form\"\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"form-group required\"\u003E\u003Cinput class=\"form-control\" type=\"text\" placeholder=\"Name\" name=\"name\" required\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group required\"\u003E\u003Cinput class=\"form-control\" type=\"text\" placeholder=\"Email\" name=\"email\" required\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group required\"\u003E\u003Cinput class=\"form-control\" type=\"text\" placeholder=\"Country\" name=\"country\" required\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group required\"\u003E\u003Cinput class=\"form-control\" type=\"text\" placeholder=\"City \u002F Province\" name=\"city-province\" required\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group required\"\u003E\u003Cinput class=\"form-control\" type=\"text\" placeholder=\"Link to a tech blog post, talk or oss project\" name=\"link\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cdiv class=\"form-group required\"\u003E\u003Ctextarea class=\"form-control message-area\" placeholder=\"Tell us why you’re proud of it\" name=\"message\" required\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003Cbutton class=\"btn btn-lg btn-success animated\" type=\"submit\"\u003EAPPLY\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (JSON, alias, connections, metadata, technologies, technology, technologyTitle) {var catalog_title = technology ? technologyTitle + ' Authentication' : 'How to authenticate'
var catalog_description = technology ? 'Log in to your ' + technologyTitle + ' App with any Identity Provider' : 'Authenticate your users with any Identity Provider'
var catalog_subtitle = technology ? 'Log in to your ' + technologyTitle + ' app with any enterprise or social credentials store. Includes user management, single sign on, reporting and analytics, multifactor authentication and more.' : 'With any of these technologies'
var catalog_placeholder = technology ? 'Search connections' : 'Search technologies'
pug_mixins["technologyItem"] = pug_interp = function(url, button_text, type){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"technology-list__item\"\u003E\u003Cdiv class=\"hover-content\"\u003E\u003Ca" + (pug.attr("href", url, true, true)) + "\u003E";
if (type.image) {
pug_html = pug_html + "\u003Cdiv class=\"technology__img\"\u003E\u003Cimg" + (" class=\"technology-logo__image\""+pug.attr("src", type.image, true, true)+pug.attr("alt", technology ? technologyTitle + ' Authentication with ' + type.title : type.title + ' Authentication', true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"technology__img\"\u003E\u003Ci class=\"icon icon-budicon-649 technology-logo__default\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"technology__title\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"technology__footer text-center\"\u003E\u003Ca" + (" class=\"btn btn-lg btn-success\""+pug.attr("href", url, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = button_text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"auth-catalog-index-page\"\u003E\u003Cdiv class=\"banner auth-catalog-index-page__banner\"\u003E\u003Cdiv class=\"banner__container container banner-container\"\u003E\u003Ch1 class=\"banner__title\"\u003E" + (pug.escape(null == (pug_interp = catalog_title) ? "" : pug_interp)) + "\u003C\u002Fh1\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = catalog_description) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003Cdiv class=\"banner__form\"\u003E\u003Cform class=\"technologies-search\"\u003E\u003Cinput" + (" class=\"technologies-search__input\""+" type=\"text\""+pug.attr("placeholder", catalog_placeholder, true, true)+" autofocus") + "\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth-catalog-index-page__content\"\u003E\u003Cdiv class=\"container\"\u003E";
if (technology) {
pug_html = pug_html + "\u003Ch2\u003EChoose your Connection\u003C\u002Fh2\u003E";
}
else
if (!technology) {
pug_html = pug_html + "\u003Ch2\u003EChoose your Platform\u003C\u002Fh2\u003E";
}
pug_html = pug_html + "\u003Cul class=\"technology-list list-unstyled\"\u003E";
// iterate technologies
;(function(){
  var $$obj = technologies;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var _technology = $$obj[pug_index0];
if (technology && technology === _technology.hash) {
// iterate _technology.connections
;(function(){
  var $$obj = _technology.connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var technology_connection = $$obj[pug_index1];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var connection = $$obj[pug_index2];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index2];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var technology_connection = $$obj[pug_index1];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var connection = $$obj[pug_index3];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index3];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

    }
  }
}).call(this);

}
else
if (!technology) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = _technology.title) ? "" : pug_interp)) + "\u003Cspan\u003E app\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash, 'Show connections', _technology);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var _technology = $$obj[pug_index0];
if (technology && technology === _technology.hash) {
// iterate _technology.connections
;(function(){
  var $$obj = _technology.connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var technology_connection = $$obj[pug_index4];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var connection = $$obj[pug_index5];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index5];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var technology_connection = $$obj[pug_index4];
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var connection = $$obj[pug_index6];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index6];
if (technology_connection === connection.hash) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your " + (pug.escape(null == (pug_interp = technologyTitle) ? "" : pug_interp)) + " app with&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash + '/' + connection.hash, 'Quick tutorial', connection);
}
    }
  }
}).call(this);

    }
  }
}).call(this);

}
else
if (!technology) {
pug_mixins["technologyItem"].call({
block: function(){
pug_html = pug_html + "\u003Cspan class=\"technology__plus-title\"\u003EAuthenticate your&nbsp;\u003C\u002Fspan\u003E\u003Cspan class=\"technology__the-title\"\u003E" + (pug.escape(null == (pug_interp = _technology.title) ? "" : pug_interp)) + "\u003Cspan\u003E app\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
}, '/' + alias + '/' + _technology.hash, 'Show connections', _technology);
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003Cdiv class=\"message message--notfound\"\u003ENo matches were found.\u003C\u002Fdiv\u003E\u003Cdiv class=\"message message--tryagain\"\u003EUnable to connect with the server,\u003Ca class=\"message__link\" href=\"#\"\u003Eplease try again\u003C\u002Fa\u003E.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"create-account\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EStart your free trial today\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"auth-catalog-index-bottom\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Cscript\u003Evar authCatalogIndex = {\n  metadata: " + (null == (pug_interp = JSON.stringify(metadata)) ? "" : pug_interp) + "\n};\u003C\u002Fscript\u003E";}.call(this,"JSON" in locals_for_with?locals_for_with.JSON:typeof JSON!=="undefined"?JSON:undefined,"alias" in locals_for_with?locals_for_with.alias:typeof alias!=="undefined"?alias:undefined,"connections" in locals_for_with?locals_for_with.connections:typeof connections!=="undefined"?connections:undefined,"metadata" in locals_for_with?locals_for_with.metadata:typeof metadata!=="undefined"?metadata:undefined,"technologies" in locals_for_with?locals_for_with.technologies:typeof technologies!=="undefined"?technologies:undefined,"technology" in locals_for_with?locals_for_with.technology:typeof technology!=="undefined"?technology:undefined,"technologyTitle" in locals_for_with?locals_for_with.technologyTitle:typeof technologyTitle!=="undefined"?technologyTitle:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (aliaspath, app, applications, connections, idp) {pug_html = pug_html + "\u003Cdiv class=\"see-also\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EYou might also be interested\u003C\u002Fh3\u003E\u003Cdiv class=\"col-sm-6 block-left\"\u003E\u003Cul class=\"block-list\"\u003E\u003Cli\u003E\u003Ch5\u003EPlatforms\u003C\u002Fh5\u003E\u003C\u002Fli\u003E";
// iterate connections
;(function(){
  var $$obj = connections;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var connection = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"interest-integration\""+pug.attr("href", '/' + aliaspath + '/' + app.hash + '/' + connection.hash, true, true)) + "\u003E\u003Cfigure\u003E";
if (connection.image) {
pug_html = pug_html + "\u003Cimg" + (" class=\"platform-img\""+pug.attr("src", (connection.image || '').replace('https:', ''), true, true)+pug.attr("alt", "Authenticate " + app.title + "with " + connection.title, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Ci class=\"icon icon-budicon-649\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E\u003Cp\u003EAuthenticate" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = app.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "with" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var connection = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"interest-integration\""+pug.attr("href", '/' + aliaspath + '/' + app.hash + '/' + connection.hash, true, true)) + "\u003E\u003Cfigure\u003E";
if (connection.image) {
pug_html = pug_html + "\u003Cimg" + (" class=\"platform-img\""+pug.attr("src", (connection.image || '').replace('https:', ''), true, true)+pug.attr("alt", "Authenticate " + app.title + "with " + connection.title, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Ci class=\"icon icon-budicon-649\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E\u003Cp\u003EAuthenticate" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = app.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "with" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = connection.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 block-right\"\u003E\u003Cul class=\"block-list\"\u003E\u003Cli\u003E\u003Ch5\u003EConnections\u003C\u002Fh5\u003E\u003C\u002Fli\u003E";
// iterate applications
;(function(){
  var $$obj = applications;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var application = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"interest-integration\""+pug.attr("href", '/' + aliaspath + '/' + application.hash + '/' + idp.hash, true, true)) + "\u003E\u003Cfigure\u003E";
if (idp.image) {
pug_html = pug_html + "\u003Cimg" + (" class=\"platform-img\""+pug.attr("src", (idp.image || '').replace('https:', ''), true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Ci class=\"icon icon-budicon-649\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E\u003Cp\u003EAuthenticate" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = application.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "with" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var application = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"interest-integration\""+pug.attr("href", '/' + aliaspath + '/' + application.hash + '/' + idp.hash, true, true)) + "\u003E\u003Cfigure\u003E";
if (idp.image) {
pug_html = pug_html + "\u003Cimg" + (" class=\"platform-img\""+pug.attr("src", (idp.image || '').replace('https:', ''), true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Ci class=\"icon icon-budicon-649\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Ffigure\u003E\u003Cp\u003EAuthenticate" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = application.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "with" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"aliaspath" in locals_for_with?locals_for_with.aliaspath:typeof aliaspath!=="undefined"?aliaspath:undefined,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"applications" in locals_for_with?locals_for_with.applications:typeof applications!=="undefined"?applications:undefined,"connections" in locals_for_with?locals_for_with.connections:typeof connections!=="undefined"?connections:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, context, first_type, idp, second_type) {var hasSnippets = app.snippets && (app.snippets.dependencies || app.snippets.setup || app.snippets.use)
pug_html = pug_html + "\u003Cdiv class=\"auth-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"auth-logos\"\u003E\u003Cdiv class=\"idp-circle\"\u003E";
if ((app.image)) {
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", app.image, true, true)+pug.attr("alt", app.title, true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Ci class=\"icon icon-budicon-649 technology-logo__default logo-default\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cspan\u003E+\u003C\u002Fspan\u003E\u003Cdiv class=\"idp-circle\"\u003E\u003Cimg" + (pug.attr("src", idp.image, true, true)+pug.attr("alt", idp.title, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch2\u003EAuthenticate \u003Cstrong\u003E" + (pug.escape(null == (pug_interp = app.title) ? "" : pug_interp)) + " \u003C\u002Fstrong\u003Ewith \u003Cstrong\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + " \u003C\u002Fstrong\u003Eusing Auth0\u003C\u002Fh2\u003E";
var shareUrl = context.origin + "/authenticate/" + app.hash + "/" + idp.hash;
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth-benefits\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cul class=\"benefit-list\"\u003E\u003Cli\u003EAuthentication as a Service\u003C\u002Fli\u003E\u003Cli\u003EEASY TO INTEGRATE\u003C\u002Fli\u003E\u003Cli\u003ECUSTOMIZABLE\u003C\u002Fli\u003E\u003Cli\u003Esecure token auth\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tutorial\"\u003E\u003Cdiv class=\"spinner spinner-lg is-auth0\"\u003E\u003Cdiv class=\"circle\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tutorial-nav-steps\"\u003E\u003Cdiv class=\"auth-logos\"\u003E\u003Cimg" + (pug.attr("src", app.image, true, true)+pug.attr("alt", app.title, true, true)) + "\u003E\u003Cspan\u003E+ \u003C\u002Fspan\u003E\u003Cimg" + (pug.attr("src", idp.image, true, true)+pug.attr("alt", idp.title, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tutorial-steps\"\u003E";
if (('platforms' === first_type || 'addons' === first_type ) && 'connections' === second_type && 'grean' === idp.type) {
pug_html = pug_html + (null == (pug_interp = __webpack_require__(912).call(this, locals)) ? "" : pug_interp);
}
else
if ('platforms' === first_type && 'connections' === second_type && 'custom' !== idp.type) {
pug_html = pug_html + (null == (pug_interp = __webpack_require__(913).call(this, locals)) ? "" : pug_interp);
}
else
if ('platforms' === first_type && 'connections' === second_type && 'custom' === idp.type) {
pug_html = pug_html + (null == (pug_interp = __webpack_require__(911).call(this, locals)) ? "" : pug_interp);
}
else
if ('platforms' === first_type && 'third party apps' === second_type) {
pug_html = pug_html + (null == (pug_interp = __webpack_require__(914).call(this, locals)) ? "" : pug_interp);
}
else {
pug_html = pug_html + (null == (pug_interp = __webpack_require__(910).call(this, locals)) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"get-started\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-6 get-started-copy\"\u003EGET STARTED IN MINUTES\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 get-started-btn\"\u003E\u003Ca class=\"signup-button btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" data-track=\"auth-catalog-bottom\"\u003EUSE AUTH0 FOR FREE\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"authenticate-secure\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"description\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Fauth0-circle-logo-93c907fb88.svg\" alt=\"Authentication Security and Availability\"\u003E\u003Ch4\u003EAuthentication Built for Security & High Availability\u003C\u002Fh4\u003E\u003Cp\u003EAuth0 is the easiest way for developers to integrate enterprise-grade authentication and identity management to any app. \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container-boxes clearfix\"\u003E\u003Cdiv class=\"step-line\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 boxes-left\"\u003E\u003Cdiv class=\"box\"\u003E\u003Ch5\u003EIndustry Standard Compliance\u003C\u002Fh5\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Ficon-soc2-c9115d8645.svg\" alt=\"Authentication Certifications and Compliance\"\u003E\u003Cp\u003ESOC 2, HIPAA\u002FBAA, EU\u002FUS Privacy Shield Framework, Open ID Certified.\u003C\u002Fp\u003E\u003Ca class=\"learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\" target=\"_blank\"\u003ELearn More\u003Ci class=\"icon-budicon-461\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box\"\u003E\u003Ch5\u003EBuilt by Security Experts\u003C\u002Fh5\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Fexpert-cc8443a80f.svg\" alt=\"uthentication Experts\"\u003E\u003Cp\u003EContinuously reviewed and tested by external security experts. Strong password encryption and hashing algorithms, at rest and in transit.\u003C\u002Fp\u003E\u003Ca class=\"learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\" target=\"_blank\"\u003ELearn More\u003Ci class=\"icon-budicon-461\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box\"\u003E\u003Ch5\u003E What Our Customers Say\u003C\u002Fh5\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Ficon-schneider-5285434107.png\" alt=\"Authentication Case Studies\"\u003E\u003Cp\u003EContinuously reviewed and tested by external security experts. Strong password encryption and hashing algorithms, at rest and in transit.\u003C\u002Fp\u003E\u003Ca class=\"learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Fcustomers\" target=\"_blank\"\u003ELearn More\u003Ci class=\"icon-budicon-461\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 boxes-right\"\u003E\u003Cdiv class=\"box abailability\"\u003E\u003Ch5\u003EAvailability & trust\u003C\u002Fh5\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Ficon-availability-85c05f10f3.svg\" alt=\"Authentication Availability\"\u003E\u003Cp\u003EUptime time in 3 different regions.\u003C\u002Fp\u003E\u003Ca class=\"learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Favailability-trust\" target=\"_blank\"\u003ELearn More\u003Ci class=\"icon-budicon-461\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box\"\u003E\u003Ch5\u003EHost Anywhere\u003C\u002Fh5\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Ficon-anywhere-9bf56bc76d.svg\" alt=\"Auth0 Appliance\"\u003E\u003Cp\u003EDeploy On-Premises or on Cloud on your data center or Auth0’s one.\u003C\u002Fp\u003E\u003Ca class=\"learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fappliance\" target=\"_blank\"\u003ELearn More\u003Ci class=\"icon-budicon-461\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"auth0-for-free clearfix\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Ficon-active-user-97e4b42ee7.svg\" alt=\"Auth0 Active Users\"\u003E\u003Ch3\u003EGet Auth0 free for 7,000 \u003Cspan class=\"power\"\u003Eactive users \u003C\u002Fspan\u003Eper month with unlimited logins\u003C\u002Fh3\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cul class=\"text-left\"\u003E\u003Cli\u003E\u003Cspan\u003ESingle Sign On\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EPasswordless Login\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EUp to 2 Social Identity Providers\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cul class=\"text-left\"\u003E\u003Cli\u003E\u003Cspan\u003EMultifactor Authentication\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EUser Management\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EExtensibility (Run custom code on Auth)\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"signup-button btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" data-track=\"auth-catalog-bottom\"\u003ESign Up Free \u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customers\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch3\u003ESome of the companies that trust us every day\u003C\u002Fh3\u003E\u003Cdiv class=\"clearfix\"\u003E\u003Ca class=\"atlassian\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-atlassian-color-7830cc62b0.svg\" alt=\"Atlassian - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"pbs\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-pbs-f8e4a8a436.svg\" alt=\"PBS - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"nvidia\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-nvidia-color-6b3d90dfc2.svg\" alt=\"NVIDIA - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"mozilla\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-mozilla-color-641b413898.svg\" alt=\"Mozilla - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"bluetooth-sig\" target=\"_blank\" href=\"\u002Fcustomers#bluetooth-sig\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-bluetooth-color-632a4ebcf4.svg\" alt=\"Bluetooth - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"financialtimes\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-financialtimes-color-2cb7e44652.svg\" alt=\"Financial Times - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"jet\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fjetprivilege-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-jet-color-bbd05033a3.svg\" alt=\"Jet - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"houghton\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-hmh-color-ab0a4583c1.svg\" alt=\"HMH - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"optimizely\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-optimizely-color-4d45421a3e.svg\" alt=\"Optimizely - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"polaris\" target=\"_blank\" href=\"\u002Fcustomers#polaris\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-polaris-industries-color-0bc2488a05.svg\" alt=\"Polaris - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"harper\" target=\"_blank\" href=\"\u002Fcustomers#harper\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-harper-color-eb07400b01.svg\" alt=\"Harper - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"newscorp\" target=\"_blank\" href=\"\u002Fcustomers#newscorp\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-news-corp-color-0953d795df.svg\" alt=\"News Corp - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ca target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(908).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"context" in locals_for_with?locals_for_with.context:typeof context!=="undefined"?context:undefined,"first_type" in locals_for_with?locals_for_with.first_type:typeof first_type!=="undefined"?first_type:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined,"second_type" in locals_for_with?locals_for_with.second_type:typeof second_type!=="undefined"?second_type:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, hasSnippets, idp) {var index = 1;
if (hasSnippets)
{
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ESetup your application's code\u003C\u002Fh3\u003E";
if (app.snippets.dependencies)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.dependencies) ? "" : pug_interp);
}
if (app.snippets.setup)
{
pug_html = pug_html + ("\u003Cp\u003EAdd the following lines to your base code\u003C\u002Fp\u003E" + (null == (pug_interp = app.snippets.setup) ? "" : pug_interp));
}
if (!app.snippets.dependencies && !app.snippets.setup && app.snippets.use)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.use) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate an " + (pug.escape(null == (pug_interp = app.thirdParty ? "API" : "Application") ? "" : pug_interp)) + " in&nbsp;\u003Ca href=\"https:\u002F\u002Fapp.auth0.com\" target=\"_blank\"\u003EAuth0 dashboard&nbsp;\u003C\u002Fa\u003E. Select" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = app.short_title || app.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "under" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\n " + (pug.escape(null == (pug_interp = app.thirdParty ? "SSO Integrations" : "Addons") ? "" : pug_interp)) + "\u003C\u002Fh3\u003E";
if (app.thirdParty) {
pug_html = pug_html + "\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fintegrations\u002Fthird-party-apps\u002Fcreate.png\" alt=\"Integrate with SSO providers\"\u003E";
}
else {
pug_html = pug_html + "\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Fauth0-catalog\u002Fapplication-addon.png\" alt=\"Activate Addons in your Auth0 dashboard\"\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate&nbsp;";
if('database' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fdatabase\" target=\"_blank\"\u003Ea Database&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Database section";
}
if('social' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fsocial\" target=\"_blank\"\u003Ea Social&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Social section";
}
if('enterprise' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fenterprise\" target=\"_blank\"\u003Ean Enterprise&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Enterprise section";
}
if('passwordless' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fenterprise\" target=\"_blank\"\u003Ean Passwordless&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Passwordless section";
}
var connection_alt = 'Database';
if ('enterprise' === idp.type) connection_alt = 'Enterprise';
if ('social' === idp.type) connection_alt = 'Social'
if ('passwordless' === idp.type) connection_alt = 'Passwordless'
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", 'https://cdn2.auth0.com/docs/media/auth0-catalog/connection-' + idp.type + '.png', true, true)+pug.attr("alt", 'Create a ' + connection_alt + ' Connection for authentication', true, true)) + "\u003E\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"hasSnippets" in locals_for_with?locals_for_with.hasSnippets:typeof hasSnippets!=="undefined"?hasSnippets:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, hasSnippets, idp) {var index = 1;
if (hasSnippets)
{
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ESetup your application's code\u003C\u002Fh3\u003E";
if (app.snippets.dependencies)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.dependencies) ? "" : pug_interp);
}
if (app.snippets.use)
{
pug_html = pug_html + ("\u003Cp\u003EAdd the following lines to your base code\u003C\u002Fp\u003E" + (null == (pug_interp = app.snippets.use) ? "" : pug_interp));
}
if (!app.snippets.dependencies && !app.snippets.use && app.snippets.setup)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.setup) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate an " + (pug.escape(null == (pug_interp = app.thirdParty ? "API" : "Application") ? "" : pug_interp)) + " in&nbsp;\u003Ca href=\"https:\u002F\u002Fapp.auth0.com\" target=\"_blank\"\u003EAuth0 dashboard&nbsp;\u003C\u002Fa\u003E\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Fauth0-catalog\u002Fapplication-create.png\" alt=\"Create an Application in Auth0 dashboard\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EInstall the Custom Social Connection extension under&nbsp;\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fextensions\" target=\"_blank\"\u003EExtensions&nbsp;\u003C\u002Fa\u003E\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fextensions\u002Finstalling-custom-social-connections.png\" alt=\"installing-custom-social-connections\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EList the app under the Installed&nbsp;\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fextensions\" target=\"_blank\"\u003EExtensions tab.&nbsp;\u003C\u002Fa\u003EClick on the Custom Social Connections\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fextensions\u002Finstalled-custom-social-extension.png\" alt=\"Installed Extensions tab\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate a&nbsp;\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fextensions\" target=\"_blank\"\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;connection under Custom Social Connections\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fextensions\u002Fcustom-social-connections.png\" alt=\"Authorize the Custom Social Connections app\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EConfigure your connection settings and enable your application under the Apps tab\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fextensions\u002Fnew-custom-social-connection.png\" alt=\"Configure Social Connection Settings\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"hasSnippets" in locals_for_with?locals_for_with.hasSnippets:typeof hasSnippets!=="undefined"?hasSnippets:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, idp) {var isBankIdNO = (idp.hash === 'bankid-no');
var bankType = isBankIdNO ? "Norwegian " : "Swedish";
var bankCode = isBankIdNO ? "NO" : "SE";
if ((app.typeTitle === 'Addon')) {
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003ECreate an Application in&nbsp;\u003Ca href=\"https:\u002F\u002Fapp.auth0.com\" target=\"_blank\"\u003EAuth0 dashboard&nbsp;\u003C\u002Fa\u003E. Select" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = app.short_title || app.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "under" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\n Addons\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-image\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Fauth0-catalog\u002Fapplication-addon.png\" alt=\"Activate Addons in your Auth0 dashboard\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003ECreate an account with Grean easyID\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E \u003Cp\u003EGo to \u003Ca href=\"https:\u002F\u002Fgrean.com\u002Feasyid\u002F\" target=\"_blank\"\u003Egrean.com\u002Feasyid \u003C\u002Fa\u003Eand click the sign-up button. \u003Cbr \u002F\u003E \nOnce registered you will be asked to create your tenant.\u003C\u002Fp\u003E\u003Cdiv class=\"grean-image\"\u003E \u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fconnections\u002Fgrean\u002Feasyid-signup.png\" alt=\"Create new tenant\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003ECreate an Application to point to Auth0\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E\u003Cp\u003EIn easyID go to the \u003Cstrong\u003EAPPLICATIONS \u003C\u002Fstrong\u003Etab and create a new application, a client, by clikcing the \u003Cstrong\u003Ewith Auth0 \u003C\u002Fstrong\u003Ebutton. Give it a meaningful name, select the domain and remember to select the \u003Cstrong\u003E" + (pug.escape(null == (pug_interp = bankCode) ? "" : pug_interp)) + " \u003C\u002Fstrong\u003EBankID.\u003C\u002Fp\u003E";
var secondStepImageName = isBankIdNO ? "auth0-app-no.png" : "auth0-app-se.png";
pug_html = pug_html + "\u003Cdiv class=\"grean-image\"\u003E\u003Cimg" + (pug.attr("src", "https://cdn2.auth0.com/docs/media/articles/connections/grean/" + secondStepImageName, true, true)+" alt=\"Create application with Auth0\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EClick \u003Cstrong\u003ESave \u003C\u002Fstrong\u003Eto open the next dialog\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003EName the connection (prefix) as it will appear in Auth0&nbsp;\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E\u003Cp\u003EIf you do not run off the public Auth0 service, enter the DNS name of the login tenant. Otherwise just leave the \u003Cstrong\u003EAuth0 tenant \u003C\u002Fstrong\u003Efield as is.\u003C\u002Fp\u003E\u003Cp\u003ESecondly enter a name to be used as the prefix for the connections created in Auth0.\u003C\u002Fp\u003E\u003Cdiv class=\"grean-image\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fconnections\u002Fgrean\u002Fauth0-details.png\" alt=\"Auth0 connections details\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EClick \u003Cstrong\u003EProceed.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003ECreate new connections in Auth0\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E\u003Cp\u003EIf you are not already logged in to Auth0 in this session, you will be prompted to do so in the popup window.\u003C\u002Fp\u003E\u003Cp\u003EOnce logged in you must grant Grean easyID consent to create connections and read the clients.\u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003ENote: \u003C\u002Fstrong\u003EIf you have more than one Auth0 tenant, remember to select the right one. in the dialog.\u003C\u002Fp\u003E\u003Cdiv class=\"grean-image\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Farticles\u002Fconnections\u002Fgrean\u002Fauth0-consent.png\" alt=\"Auth0 connections details\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EClick the check mark in the green area at the bottom to allow Grean easyID to set up the connections.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003EVerify the connections\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E\u003Cp\u003EGo to the \u003Cstrong\u003EConnections \u003E Enterprise \u003C\u002Fstrong\u003Esection and open the ADFS connections to see the connections for " + (pug.escape(null == (pug_interp = bankType) ? "" : pug_interp)) + " BankID created from the previous steps.\u003C\u002Fp\u003E";
var verifyConnectionNO = 'Norwegian BankID: Browser based and mobile. The mobile method requires a special SIM card issued by a Norwegian provider.';
var verifyConnectionSE = 'Swedish BankID: Native BankID application or mobile app. Both applications must be installed prior to BankID authentication.';
var fifthStepImageName = isBankIdNO ? "adfs-connections-no.png" : "adfs-connections-se.png";
pug_html = pug_html + "\u003Cp\u003E\u003Cstrong\u003ENote: \u003C\u002Fstrong\u003EOne connection has been created for each kind of authentication supported by " + (pug.escape(null == (pug_interp = isBankIdNO ? verifyConnectionNO: verifyConnectionSE) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"grean-image\"\u003E\u003Cimg" + (pug.attr("src", "https://cdn2.auth0.com/docs/media/articles/connections/grean/" + fifthStepImageName, true, true)+" alt=\"ADFS connections created\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ERemember to enable at least one client before clicking the Try button! For more on test users see documentation on easyID.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003ECreate your test users\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E";
if ((isBankIdNO)) {
pug_html = pug_html + "\u003Cp\u003EWith the above setup you will be ready to start testing. You will find a test user's credentials in your easyID tenant to start testing the web based flow. To get your own test users and to get the special SIM cards need to test the mobile flow, work with Grean to sign up for production use of Norwegian BankID.  \u003C\u002Fp\u003E";
}
else {
pug_html = pug_html + "\u003Cp\u003EWith the above setup you will be ready to start testing. But first you must create one or more test users here: \u003Ca href=\"https:\u002F\u002Fdemo.bankid.com\u002F\" target=\"_blank\"\u003Edemo.bankid.com\u002F. \u003C\u002Fa\u003EIf you don't already have a test or real BankID, go to the section namd \u003Cstrong\u003ELog in with a personal code.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content grean\"\u003E\u003Ch3\u003EEnable production use\u003C\u002Fh3\u003E\u003Cdiv class=\"grean-steps\"\u003E\u003Cp\u003ETo start accepting real BankID logins from real legal persons, you must first enter into a formal agreement with a " + (pug.escape(null == (pug_interp = bankType) ? "" : pug_interp)) + " Bank, possibly through Grean, or directly with you bank.\u003C\u002Fp\u003E\u003Cp\u003EOnce this agreement is in place you will receive a certificate to upload to Grean easyID. Go to the \u003Cstrong\u003EIDENTITY SERVICES \u003C\u002Fstrong\u003Etab and open the \u003Cstrong\u003E" + (pug.escape(null == (pug_interp = bankCode) ? "" : pug_interp)) + " BankID \u003C\u002Fstrong\u003Esection. This is where you will upload your organization's BankID certificate.\u003C\u002Fp\u003E";
var seventhStepImageName = isBankIdNO ? "no-bankid-prod.png" : "se-bankid-prod.png";
pug_html = pug_html + "\u003Cdiv class=\"grean-image\"\u003E\u003Cimg" + (pug.attr("src", "https://cdn2.auth0.com/docs/media/articles/connections/grean/" + seventhStepImageName, true, true)+" alt=\"Identity Service production\"") + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, hasSnippets, idp) {var index = 1;
if (hasSnippets)
{
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ESetup your application's code\u003C\u002Fh3\u003E";
if (app.snippets.dependencies)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.dependencies) ? "" : pug_interp);
}
if (app.snippets.use)
{
pug_html = pug_html + ("\u003Cp\u003EAdd the following lines to your base code\u003C\u002Fp\u003E" + (null == (pug_interp = app.snippets.use) ? "" : pug_interp));
}
if (!app.snippets.dependencies && !app.snippets.use && app.snippets.setup)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.setup) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate an " + (pug.escape(null == (pug_interp = app.thirdParty ? "API" : "Application") ? "" : pug_interp)) + " in&nbsp;\u003Ca href=\"https:\u002F\u002Fapp.auth0.com\" target=\"_blank\"\u003EAuth0 dashboard&nbsp;\u003C\u002Fa\u003E\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Fauth0-catalog\u002Fapplication-create.png\" alt=\"Create an Application in Auth0 dashboard\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECreate&nbsp;";
if('database' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fdatabase\" target=\"_blank\"\u003Ea Database&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Database section";
}
if('social' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fsocial\" target=\"_blank\"\u003Ea Social&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Social section";
}
if('enterprise' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fenterprise\" target=\"_blank\"\u003Ean Enterprise&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Enterprise section";
}
if('passwordless' === idp.type)
{
pug_html = pug_html + "\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fconnections\u002Fenterprise\" target=\"_blank\"\u003Ean Passwordless&nbsp;\u003Cspan\u003E" + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E Connection\u003C\u002Fspan\u003E\u003C\u002Fa\u003E&nbsp;under Connections \u002F Passwordless section";
}
pug_html = pug_html + "\u003C\u002Fh3\u003E";
var connection_alt = 'Database';
if ('enterprise' === idp.type) connection_alt = 'Enterprise';
if ('social' === idp.type) connection_alt = 'Social'
if ('passwordless' === idp.type) connection_alt = 'Passwordless'
{
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", "https://cdn2.auth0.com/docs/media/auth0-catalog/connection-" + idp.type + ".png", true, true)+pug.attr("alt", "Create a " + connection_alt + " Connection for authentication", true, true)) + "\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"hasSnippets" in locals_for_with?locals_for_with.hasSnippets:typeof hasSnippets!=="undefined"?hasSnippets:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app, hasSnippets, idp) {var index = 1;
if (hasSnippets)
{
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EAdd the needed dependencies to your client application\u003C\u002Fh3\u003E";
if (app.snippets.dependencies)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.dependencies) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EShow Lock, the login box, to the user\u003C\u002Fh3\u003E";
if (app.snippets.use)
{
pug_html = pug_html + (null == (pug_interp = app.snippets.use) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EActivate the " + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + " addon in your&nbsp;\u003Ca href=\"https:\u002F\u002Fmanage.auth0.com\" target=\"_blank\"\u003EAuth0 dashboard\u003C\u002Fa\u003E\u003C\u002Fh3\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fdocs\u002Fmedia\u002Fauth0-catalog\u002Fapplication-addon.png\" alt=\"Activate Addons in your Auth0 dashboard\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003ECall the Delegation endpoint from Auth0 to get a token for " + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cpre\u003E\u003Ccode\u003Ecurl --data \\\n \"client_id=YOUR_CLIENT_ID&\\\n &grant_type=urn:ietf:params:oauth:grant-type:jwt-bearer\\\n &refresh_token=\\\n &scope=open_id\\\n &api_type=" + (pug.escape(null == (pug_interp = idp.name) ? "" : pug_interp)) + "\"\\\n https:\u002F\u002FYOUR_ACCOUNT.auth0.com\u002Fdelegation\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"item\"\u003E\u003Cdiv class=\"item-content\"\u003E\u003Ch3\u003EUse the newly got token to call the " + (pug.escape(null == (pug_interp = idp.title) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cdiv class=\"banner jwt-api-call\"\u003E\u003Cdiv class=\"logos\"\u003E\u003Cdiv class=\"ac-item ac-item-left\"\u003E\u003Cimg" + (pug.attr("src", (app.image || '').replace('https:', ''), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"icon-budicon-519 jwt-arrow\"\u003E\u003C\u002Fspan\u003E\u003Ca href=\"https:\u002F\u002Fjwt.io\"\u003E\u003Csvg class=\"jwt-icon\" width=\"50px\" height=\"101px\" viewbox=\"0 0 101 101\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cdefs\u003E\u003C\u002Fdefs\u003E\u003Cg stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg sketch:type=\"MSLayerGroup\" transform=\"translate(-150.000000, -538.000000)\"\u003E\u003Cg transform=\"translate(0.000000, 413.000000)\" sketch:type=\"MSShapeGroup\"\u003E\u003Cg transform=\"translate(150.000000, 125.000000)\"\u003E\u003Cg id=\"group\"\u003E\u003Cpath d=\"M57.8,27.2 L57.7,0.3 L42.7,0.3 L42.8,27.2 L50.3,37.5 L57.8,27.2 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M69.9,36 L85.7,14.2 L73.6,5.4 L57.8,27.2 L57.8,39.9 L69.9,36 Z\" fill=\"#FB015B\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M74.5,50.3 L100.1,41.9 L95.5,27.7 L69.9,36 L62.4,46.3 L74.5,50.3 Z\" fill=\"#D63AFF\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M62.4,54.2 L69.9,64.5 L95.5,72.8 L100.1,58.6 L74.5,50.3 L62.4,54.2 Z\" fill=\"#00B9F1\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M57.8,73.3 L73.6,95.1 L85.7,86.3 L69.9,64.5 L57.8,60.6 L57.8,73.3 Z\" fill=\"#00F2E6\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M42.8,73.3 L42.8,100.3 L57.8,100.3 L57.8,73.3 L50.3,63 L42.8,73.3 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M30.6,64.5 L14.8,86.3 L26.9,95.1 L42.8,73.3 L42.8,60.6 L30.6,64.5 Z\" fill=\"#FB015B\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M26,50.3 L0.4,58.6 L5,72.8 L30.6,64.5 L38.1,54.2 L26,50.3 Z\" fill=\"#D63AFF\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M30.6,36 L5,27.7 L0.4,41.9 L26,50.3 L38.1,46.3 L30.6,36 Z\" fill=\"#00B9F1\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M42.8,27.2 L26.9,5.4 L14.8,14.2 L30.6,36 L42.8,39.9 L42.8,27.2 Z\" fill=\"#00F2E6\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fa\u003E\u003Cspan class=\"icon-budicon-519 jwt-arrow\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"ac-item ac-item-right\"\u003E\u003Cimg" + (pug.attr("src", (idp.image || '').replace('https:', ''), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"try-banner\"\u003E\u003Ca href=\"javascript:void(0);\" onclick=\"signup(this)\" data-track=\"auth-catalog-bottom\" class=\"signup-button btn btn-success btn-lg\"\u003ETry this on your application now\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined,"hasSnippets" in locals_for_with?locals_for_with.hasSnippets:typeof hasSnippets!=="undefined"?hasSnippets:undefined,"idp" in locals_for_with?locals_for_with.idp:typeof idp!=="undefined"?idp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Favailability-trust\u002Fimg\u002Favialability-logo-e14e191f1c.svg\" alt=\"\" data-no-retina=\"\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EAvailability &amp; Trust\u003C\u002Fh1\u003E\u003Cp\u003EWe know that if you can't log in to your app, nothing else works. At web scale in the cloud, failures and outages occur. That's why we have architected Auth0 to be highly resilient to the failure of any of its components, with the goal that your users never experience any downtime.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" data-track=\"auth-availability-banner\"\u003EUSE AUTH0 FOR FREE\u003C\u002Fbutton\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"avialability__content\"\u003E\u003Csection\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"media-item\"\u003E\u003Cdiv class=\"media-item__text pr\"\u003E\u003Ch3\u003EHow it Works?\u003C\u002Fh3\u003E\u003Cp\u003EAt a high level, our availability strategy is rather simple, and yet very effective: we ensure that critical dependencies are redundant, we rapidly detect failures, and our failover is very quick. The Auth0 architecture implements redundant components at all levels. These are:\u003C\u002Fp\u003E\u003Cul class=\"avialability__list avialability__list--inline\"\u003E\u003Cli\u003EDNS\u003C\u002Fli\u003E\u003Cli\u003EDatacenter\u003C\u002Fli\u003E\u003Cli\u003EApplication layer\u003C\u002Fli\u003E\u003Cli\u003EStorage\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EOur High-Availability Strategy\u003C\u002Fh3\u003E\u003Cp\u003EWe've done many things to ensure extra availability. An important aspect is how the application is architected: That is, how we manage user sessions, how we partition functionality, how we prioritize the availability of modules, and how we handle transient conditions\u003C\u002Fp\u003E\u003Cp\u003EAuth0 is designed and built as a scalable, highly available, multi-tenant cloud service.\u003C\u002Fp\u003E\u003Cp\u003EThis highly reliable architecture is combined with solid operational processes and a culture of continuous improvement that constantly refines and improves Auth0 operations.\u003C\u002Fp\u003E\u003Ca class=\"img--standalone\" href=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Favailability-trust\u002Fimg\u002FDiagram-7c8f25d0ef.svg\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Favailability-trust\u002Fimg\u002FDiagram-7c8f25d0ef.svg\" alt=\"Auth0 Availability Diagram\"\u003E\u003C\u002Fa\u003E\u003Cp\u003EConsider the following scenarios:\u003C\u002Fp\u003E\u003Cul class=\"avialability__list avialability__list--dots\"\u003E\u003Cli\u003EIf one of the VMs is taken down, the load balancer will take it off rotation until it's up again.\u003C\u002Fli\u003E\u003Cli\u003EIf one of the database VMs is taken down, the secondary VM is elected as primary.\u003C\u002Fli\u003E\u003Cli\u003EIf there is an outage on the primary datacenter, the DNS will detect that and start redirecting requests to the second datacenter (in a different location).\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"bottom-flat\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EAppliance Gives More Control to our Customers\u003C\u002Fh3\u003E\u003Cp\u003EWe know there are scenarios where a public cloud-based solution is not acceptable---for example, due to compliance or legal requirements. For these cases, Auth0 is available as an appliance to be deployed in a private environment. The Auth0 architecture makes this possible: scaling down a  cloud service to become a server. With traditional monolithic identity infrastructure implementations, the opposite is a very hard - or even impossible - task.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section__inner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-part media-item\"\u003E\u003Cimg class=\"media-item__img\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Favailability-trust\u002Fimg\u002Fdeployment-1172092b11.svg\" alt=\"Continuous Deployment\"\u003E\u003Cp class=\"media-item__text\"\u003E\u003Cspan class=\"media-item__header\"\u003EContinuous Deployment with No Downtime\u003C\u002Fspan\u003EWe continuously improve Auth0. Whether we have to update a tutorial, optimize the performance of a module, or launch a whole new feature, on a typical day we might deploy three or four times. We designed our deployment infrastructure to do this with no planned downtime.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"inner-part media-item\"\u003E\u003Cimg class=\"media-item__img\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Favailability-trust\u002Fimg\u002Fstatus-8f62687a96.svg\" alt=\"Auth0 Service Status\"\u003E\u003Cp class=\"media-item__text\"\u003E\u003Cspan class=\"media-item__header\"\u003EAuth0 Status\u003C\u002Fspan\u003EWe monitor our infrastructure from over 50 locations all over the world. Our availability is published instantly on&nbsp;\u003Ca href=\"http:\u002F\u002Fstatus.auth0.com\"\u003Estatus.auth0.com\u003C\u002Fa\u003E, and if there ever is an incident, we'll let you know immediately through Twitter. You can also check our uptime reports by clicking&nbsp;\u003Ca href=\"http:\u002F\u002Fuptime.auth0.com\u002F\"\u003Ehere.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection\u003E\u003Cdiv class=\"container\"\u003E\u003Cp class=\"text--standalone\"\u003EFor questions, please contact us at&nbsp;\u003Ca href=\"mailto:trust@auth0.com\"\u003Etrust@auth0.com\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (app) {pug_html = pug_html + "\u003Cdiv class=\"b2b-app\"\u003E" + (null == (pug_interp = app) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"b2b-page\"\u003E\u003Cdiv class=\"top-bg-pattern\"\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(921).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(922).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(924).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(923).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(920).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(919).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(917).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(918).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"app" in locals_for_with?locals_for_with.app:typeof app!=="undefined"?app:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"features-module cloud\"\u003E\u003Cdiv class=\"top-features-block\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 description text-center\"\u003E\u003Cimg class=\"feature-icon\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-blocks-fca44e9b01.svg\" alt=\"Secure, Scalable, Ready to Serve\"\u003E\u003Ch2 class=\"feature-title\"\u003ESecure, Scalable, Ready to Serve\u003C\u002Fh2\u003E\u003Cp class=\"feature-description\"\u003EOur highly-available multi-tenant cloud service can handle over 1 billion transactions daily and is backed by security best practices across the board.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 animation\"\u003E\u003Cimg class=\"feature-main-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Flogos-gray-e21f09198c.svg\" alt=\"B2B Identity Management Customers\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-features-block\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-container\"\u003E\u003Cdiv class=\"row options\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cul class=\"feature-list\"\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-cloud-g-d3044d35cc.svg\" alt=\"Cloud Identity Management\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EOn Premise, In Cloud\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003EHost in our cloud, your cloud, or your private data center.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fappliance\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-building-g-e4ad59114e.svg\" alt=\"Enterprise Federation\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EEnterprise Federation at Scale\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003ESet up as many Active Directory, PingFederate, LDAP, or even a custom SAML-P providers for as many customers as needed.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Ftutorials\u002Fusing-auth0-with-multi-tenant-apps\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-key-lock-g-9768103f13.svg\" alt=\"Industry Standard Authentication\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EIndustry Standard Authentication\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003ELearn how open protocols like OAuth and OpenID Connect promote better security.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fhow-auth0-uses-identity-industry-standards\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-code-g-c8ed705768.svg\" alt=\"Any Language, Any Framework\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EAny Language, Any Framework\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003EImplement modern identity management in any technology stack.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstarts\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (contactUsForm) {pug_html = pug_html + "\u003Cdiv class=\"contact-us-app\"\u003E" + (null == (pug_interp = contactUsForm) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"contactUsForm" in locals_for_with?locals_for_with.contactUsForm:typeof contactUsForm!=="undefined"?contactUsForm:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"customer-banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"banner-wrapper\"\u003E\u003Cdiv class=\"customer-info\"\u003E\u003Cimg class=\"customer-banner-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Flogo-atlassian-c0e84af9a1.svg\" alt=\"Atlassian Identity Management\"\u003E\u003Cp class=\"customer-banner-copy\"\u003EAtlassian is using Auth0 for all their B2B applications\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"https:\u002F\u002Fauth0.com\u002Fcustomers#atlassian\" target=\"_blank\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"customer-pdf-module\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch2 class=\"customer-pdf-image\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-join-5fc805ba43.svg\" alt=\"Enterprise Satisfaction\"\u003E\u003C\u002Fh2\u003E\u003Cp class=\"customer-pdf-title\"\u003EJoin thousands of customers like Atlassian that trust Auth0 everyday\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"flex-container\"\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"pdf-box\"\u003E\u003Cimg class=\"pdf-box-bg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Fbg-img-phone-0a1f558ec4.svg\" alt=\"Authentication Costs\"\u003E\u003Ch2 class=\"pdf-box-title\"\u003EIs Authentication Costing You Revenue?\u003C\u002Fh2\u003E\u003Cp class=\"pdf-box-description\"\u003EKeeping up with evolving standards, best practices and patching security bugs takes time and money away from your core business.\u003C\u002Fp\u003E\u003Ca class=\"pdf-box-link\" href=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Fis_authentication_costing_you_revenue.pdf\" target=\"_blank\" rel=\"external\"\u003E\u003Cspan class=\"inner-link\"\u003EDownload PDF\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"pdf-box\"\u003E\u003Cimg class=\"pdf-box-bg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Fbg-img-userbox-cc9cade929.svg\" alt=\"Modern Authentication\"\u003E\u003Ch2 class=\"pdf-box-title\"\u003EMoving Beyond Username and Password\u003C\u002Fh2\u003E\u003Cp class=\"pdf-box-description\"\u003EBuilding modern authentication goes beyond usernames and passwords and provides a framework for managing identity.\u003C\u002Fp\u003E\u003Ca class=\"pdf-box-link\" href=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Fauthentication_is_not_enough.pdf\" target=\"_blank\" rel=\"external\"\u003E\u003Cspan class=\"inner-link\"\u003EDownload PDF\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"pdf-box\"\u003E\u003Cimg class=\"pdf-box-bg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Fbg-img-key-f3e2e25fb6.svg\" alt=\"Risks Posed by Legacy Authentication\"\u003E\u003Ch2 class=\"pdf-box-title\"\u003ERisks Posed by Legacy Authentication\u003C\u002Fh2\u003E\u003Cp class=\"pdf-box-description\"\u003ELegacy authentication leaves your organization exposed by violating the “defense in depth” security best practice.\u003C\u002Fp\u003E\u003Ca class=\"pdf-box-link\" href=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Frisks_posed_by_legacy_auth.pdf\" target=\"_blank\" rel=\"external\"\u003E\u003Cspan class=\"inner-link\"\u003EDownload PDF\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cimg class=\"hero-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Flogo-b2b-f0a89387cb.svg\" alt=\"B2B Companies\"\u003E\u003Ch1 class=\"hero-title\"\u003EEasier Identity Management for your Business Partners\u003C\u002Fh1\u003E\u003Cp class=\"hero-copy\"\u003EGive your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch.\u003C\u002Fp\u003E\u003Cdiv class=\"btn-container\"\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:signup()\"\u003EUse auth0 for free\u003C\u002Fa\u003E\u003Cbutton class=\"btn btn-transparent btn-lg js-general-contact-sales open-contact-form-modal\"\u003EContact us\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"features-module revenue\"\u003E\u003Cdiv class=\"top-features-block\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-container\"\u003E\u003Cdiv class=\"row description-container v-align\"\u003E\u003Cdiv class=\"col-xs-12 col-lg-6 description\"\u003E\u003Cdiv\u003E\u003Cimg class=\"feature-icon\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-bills-647980dff9.svg\" alt=\"B2B Increase Revenue\"\u003E\u003Ch2 class=\"feature-title\"\u003EIncrease Your Revenue\u003C\u002Fh2\u003E\u003Cp class=\"feature-description\"\u003EBuilding identity management is complex, expensive, and difficult. So don’t. Increase revenue, minimize risk, and reduce the sales cycle with Auth0 for both new and existing apps.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-lg-6 animation\"\u003E\u003Cdiv id=\"animation-funnel\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-features-block\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-container\"\u003E\u003Cdiv class=\"row options\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cul class=\"feature-list\"\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-gear-g-85c8f9b908.svg\" alt=\"Turn-Key Identity Management\"\u003E\u003Ch3 class=\"feature-item-title\"\u003ETurn-Key Identity Management\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003ESave time by writing your code once, then simply configure enterprise federation, multifactor authentication, or other use case.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fbuild-or-buy-20-identity-management-questions\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-auth0-badge-g-7a40a25218.svg\" alt=\"Auth Lock\"\u003E\u003Ch3 class=\"feature-item-title\"\u003ELock - The Login Box Done Right\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003EEmbed our easy to use login form in any web or mobile application with just a few lines of code.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Flock\" target=\"_blank\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-graph-g-6ab5a820e0.svg\" alt=\"Single Identity Management API\"\u003E\u003Ch3 class=\"feature-item-title\"\u003ESingle Identity Management API\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003EReduce ongoing maintenance and support by implementing a single API for all of your identity providers.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-check-g-cf02d1a395.svg\" alt=\"Compliance and Certifications\"\u003E\u003Ch3 class=\"feature-item-title\"\u003ECompliance and Certifications\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003ECompliance with leading organizations including SOC2, HIPAA\u002FBAA, OpenID Connect, and others.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"quote-module\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"customer-quote\"\u003E\u003Cp class=\"customer-text\"\u003EAuth0 allowed us to ship Enteprise Single Sign On faster and cheaper and their support helped us with edge case SAML providers, saving our devs a lot of time.\u003C\u002Fp\u003E\u003Cdiv class=\"customer-signature\"\u003E\u003Cimg class=\"customer-avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fquotes-03-concepcion-b2f10ddde2.png\" alt=\"Cris Concepcion\"\u003E\u003Cspan class=\"customer-name\"\u003ECris Concepcion, Safari Books Online.\u003C\u002Fspan\u003E\u003Cimg class=\"customer-brand\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Flogo-safari-white-36c3b8de45.svg\" alt=\"Safari Books\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"features-module security\"\u003E\u003Cdiv class=\"top-features-block\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-container\"\u003E\u003Cdiv class=\"row description-container v-align\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 col-md-push-6 description\"\u003E\u003Cdiv\u003E\u003Cimg class=\"feature-icon\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-secure-383d259a4c.svg\" alt=\"Modern Enterprise Identity Management\"\u003E\u003Ch2 class=\"feature-title\"\u003EModern Identity Management\u003C\u002Fh2\u003E\u003Cp class=\"feature-description\"\u003EDemand for enterprise federation, single sign-on, and multifactor auth is skyrocketing. These features offer enhanced security and upsell opportunities that customers will pay for.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"animation\" id=\"animation-phone\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-features-block\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"inner-container\"\u003E\u003Cdiv class=\"row options\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cul class=\"feature-list\"\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-switch-g-299a252670.svg\" alt=\"Enterprise Federation Made Easy\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EEnterprise Federation Made Easy\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003EConnect with AD, SAML, Ping, Office 365, and more with the flip of a switch.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders#enterprise\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-touch-g-0cdc86f517.svg\" alt=\"Single Sign-On\"\u003E\u003Ch3 class=\"feature-item-title\"\u003ESingle Sign-On (SSO)\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003ELog in once, access everything.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fhow-to-implement-single-sign-on\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-user-g-32931e0884.svg\" alt=\"User Management Simplified\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EUser Management Simplified\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003ECentralized provisioning and deprovisioning of users and services.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fcloud-identity-access-management\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"feature-list-item\"\u003E\u003Cdiv class=\"feature-item-wrapper\"\u003E\u003Cimg class=\"feature-item-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2b\u002Fimg\u002Ficon-square-shield-g-ca59ee97ba.svg\" alt=\"Enhanced Security\"\u003E\u003Ch3 class=\"feature-item-title\"\u003EEnhanced Security\u003C\u002Fh3\u003E\u003Cp class=\"feature-item-description\"\u003EEnable multifactor authentication, anomaly detection, and more with the flip of a switch.\u003C\u002Fp\u003E\u003Ca class=\"feature-item-link\" href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002Fmodern-authentication-for-your-clients-made-easy\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"b2c-page\"\u003E\u003Cdiv class=\"top-bg-pattern\"\u003E\u003Cdiv class=\"left-circle\"\u003E" + (null == (pug_interp = __webpack_require__(335).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"right-circle\"\u003E" + (null == (pug_interp = __webpack_require__(335).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch1 class=\"hero-title\"\u003EBetter, Easier Identity Management for B2C Companies\u003C\u002Fh1\u003E\u003Cp class=\"hero-copy\"\u003EDrive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"btn-container\"\u003E\u003Ca class=\"btn btn-success btn-md\" href=\"javascript:signup()\"\u003EUse auth0 for free\u003C\u002Fa\u003E\u003Cbutton class=\"btn btn-transparent btn-md js-general-contact-sales open-contact-form-modal\"\u003EContact us\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"conv\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 conv-details-wrapper\"\u003E\u003Ch1 class=\"section-title conv-title\"\u003EIncrease Your\u003Cbr class=\"rm-break\"\u003E Conversion Rate\u003C\u002Fh1\u003E\u003Cp class=\"section-description conv-description\"\u003EGive customers an easy, secure way to log in, and please them from their very first contact.\u003Cbr\u003ETurn visitors into prospects with Auth0’s\u003Cb\u003EA\u002FB tested and proven login box.\u003C\u002Fb\u003E\u003C\u002Fp\u003E\u003Cul class=\"custom-list conv-list\"\u003E\u003Cli class=\"conv-item\"\u003E\u003Ca class=\"list-link conv-link\" href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002Fauth0-lock-is-here-for-b2b-and-b2c\u002F\" target=\"_blank\" rel=\"external\"\u003EAuth0 Lock for B2C\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EAn easy to use UX on any device.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"conv-item\"\u003E\u003Ca class=\"list-link conv-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fsocial-login\u002F\" target=\"_blank\" rel=\"external\"\u003ESocial Connection SSO\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EOne click logs them in.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"conv-item\"\u003E\u003Ca class=\"conv-link\" href=\"https:\u002F\u002Fauth0.com\u002Fpasswordless\" target=\"_blank\"\u003EAuth0 Passwordless\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EEliminate hated passwords, simple and secure.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 conv-lock-wrapper\"\u003E\u003Cimg class=\"mobile-lock mobile-lock-01\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Fmobile-lock-01-0660914009.svg\" alt=\"Auth0 Lock\"\u003E\u003Cimg class=\"mobile-lock mobile-lock-02\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Fmobile-lock-02-1bef50d4c7.svg\" alt=\"Auth0 Lock\"\u003E\u003Cimg class=\"desktop-lock\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Fb2c-lock-example-5c0b10a0ad.png\" alt=\"Customer Identity Management Login\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"case-study\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 bottom-customer\"\u003E\u003Cdiv class=\"case-study-headline\"\u003E\u003Ch2\u003ECustomer Identity Management Case Study\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Flogo-jet-privilege-b2549964bb.svg\" alt=\"Jet-Privilige\"\u003E\u003Cp class=\"customer-copy\"\u003EJetPrivilege entrusts Auth0 to help drive more engagement and customer loyalty - learn how the companies worked together to deploy in mere months, propelling JetPrivilege to new heights.\u003Cbr\u003E\u003Ca class=\"case-study-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fjetprivilege-case-study\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"customers-rel\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-5\"\u003E\u003Cdiv class=\"customer-card-container\"\u003E\u003Cdiv class=\"customer-video\"\u003E\u003Cvideo src=\"https:\u002F\u002Fembed-ssl.wistia.com\u002Fdeliveries\u002Ffb1dc91b7fcfc87d181b66f4a952715b6def494d\u002Fb2c-video.mp4\" width=\"350\" height=\"622\" poster=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Fb2c-videoposter-3d05c8c3ac.png\" autoplay loop\u003E\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-7\"\u003E\u003Cdiv class=\"rel-details\"\u003E\u003Ch2 class=\"section-title rel-title\"\u003EKnow Your Customers: Relationships Powered By Data\u003C\u002Fh2\u003E\u003Cp class=\"section-description rel-description\"\u003ELearn about your customers in real-time. Gather information from your users to engage with them in a personalized way.\u003C\u002Fp\u003E\u003Cul class=\"custom-list rel-list\"\u003E\u003Cli class=\"rel-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fb2c-delight-your-customers-with-auth0\u002F\" target=\"_blank\" rel=\"external\"\u003ESocial Data\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003ELearn about your users’ interests, likes and friends.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"rel-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Ftutorials\u002Ftrack-signups-enrich-user-profile-generate-leads\" target=\"_blank\" rel=\"external\"\u003EProfile Enhancement\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EEnhance user profiles by calling external APIs using Auth0 rules.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"rel-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002Fprogressive-profiling\u002F\" target=\"_blank\" rel=\"external\"\u003EProgressive Profiling\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EGradually collect data from your users.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"rel-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Frules\u002Fmetadata-in-rules\" target=\"_blank\" rel=\"external\"\u003EBehavioral Profiling\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EUnderstand your users’ behaviour by recording their actions in their user profile.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"rel-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flink-accounts\" target=\"_blank\" rel=\"external\"\u003EAccount Linking\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EConnect multiple social profiles of your users to get the full picture.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"drive-rev\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Cdiv class=\"drive-rev-details\"\u003E\u003Ch2 class=\"section-title drive-rev-title\"\u003EThe Science of Yes: Drive Revenue and Upsells With Analytics\u003C\u002Fh2\u003E\u003Cp class=\"section-description drive-rev-description\"\u003ETurn the data you’ve gathered into insights and actions you can take to encourage conversions and upsells.\u003C\u002Fp\u003E\u003Cul class=\"custom-list drive-rev-list\"\u003E\u003Cli class=\"drive-rev-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fapi\u002Fmanagement\u002Fv2\u002Fuser-search\" target=\"_blank\" rel=\"external\"\u003EPowerful Search\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EQuery your user base to find qualified leads.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"drive-rev-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fpowering-user-analytics-identity\u002F\" target=\"_blank\" rel=\"external\"\u003EDashboard Visualizations\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EAssess your audience as a whole to create new messaging for each persona.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"drive-rev-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F5-killer-email-strategies-for-lifecycle-marketing\u002F\" target=\"_blank\" rel=\"external\"\u003EMarketing Automation Integration\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EDrive personalized marketing campaigns using user data.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"drive-rev-item\"\u003E\u003Ca class=\"list-link\" href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002Finsight-execution-why-analytics-matter\u002F\" target=\"_blank\" rel=\"external\"\u003EAnalytics Platform Feeds\u003C\u002Fa\u003E\u003Cspan class=\"list-text\"\u003EUse data to evaluate the success or failure of marketing experiments.\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 dr-image-wrapper-small\"\u003E\u003Cimg class=\"hidden-md hidden-lg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Fdrive-rev-image-926560a414.svg\" alt=\"Revenue for B2C Companies\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dr-image-wrapper-large hidden-xs hidden-sm\"\u003E" + (null == (pug_interp = __webpack_require__(926).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"web-scale\"\u003E\u003Cdiv class=\"ws-image-wrapper-large hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-01-462467c633.png\" alt=\"Customer Avatar\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-02-ccae853469.png\" alt=\"Customer Avatar 2\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-03-62c2776f95.png\" alt=\"Customer Avatar 3\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-04-7a690700b9.png\" alt=\"Customer Avatar 4\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-05-38e18a514d.png\" alt=\"Customer Avatar 5\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-06-e1c0401a2c.png\" alt=\"Customer Avatar 6\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-07-2c44999be3.png\" alt=\"Customer Avatar 7\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-08-c0eda856bd.png\" alt=\"Customer Avatar 8\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"avatar\"\u003E\u003Cimg class=\"wow zoomIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Favatar-09-20d0c4da30.png\" alt=\"Customer Avatar 9\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-7 ws-image-wrapper-small\"\u003E\u003Cimg class=\"hidden-md hidden-lg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Fweb-scale-mobile-90b03a336e.png\" alt=\"Web Scale Graphic\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-5\"\u003E\u003Ch2 class=\"section-title web-scale-title\"\u003EWeb Scale, Secure: Customer Identity Management\u003C\u002Fh2\u003E\u003Cp class=\"section-description web-scale-description\"\u003EMillions of potential users trust you with their privacy. Given the increasing amount of breaches, it’s your job to safeguard their private information. For that, you need an identity management partner you can rely on.\u003C\u002Fp\u003E\u003Cul class=\"custom-list web-scale-list\"\u003E\u003Cli\u003EConfidently scale your customer base. Auth0 can handle over\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Favailability-trust\" target=\"_blank\"\u003E1B identity transactions per day.\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003EAuth0 is always on:\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Favailability-trust\" target=\"_blank\"\u003EResilient availability backed by an optional SLA.\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003EWe follow security\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\" target=\"_blank\"\u003Ebest practices, and we’re continuously audited to comply with sought-after certifications such as SOC2 and HIPAA\u002FBAA, among others.\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"case-study\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 bottom-customer\"\u003E\u003Cdiv class=\"case-study-headline\"\u003E\u003Ch2\u003ECustomer Identity Management Case Study\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fb2c\u002Fimg\u002Flogo-m&amp;s-65e8ad7f27.svg\" alt=\"Marks &amp; Spencer\"\u003E\u003Cp class=\"customer-copy\"\u003EHow did Marks & Spencer engage over 1.5 million people in a viral, wildly popular holiday game? Auth0 authentication scalability, of course!\u003Cbr\u003E\u003Ca class=\"case-study-link\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fmarks-spencer-auth0-authentication-scalability-in-action\u002F\" target=\"_blank\" rel=\"external\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"custom-try-banner\"\u003E\u003Cdiv class=\"banner-wrapper\"\u003E\u003Ca class=\"banner-logo\" href=\"https:\u002F\u002Fauth0.com\u002F\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003Cp class=\"banner-text\"\u003EStart acquiring and retaining customers.\u003Cbr\u003EIntegrate in minutes.\u003C\u002Fp\u003E\u003Ca class=\"signup-button btn btn-success btn-md\" href=\"javascript:signup()\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003Cbutton class=\"signup-button btn btn-default btn-md js-general-contact-sales open-contact-form-modal\"\u003EContact us\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csvg width=\"600px\" height=\"585px\" viewBox=\"495 32 600 585\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\"\u003E\n\u003C!-- Generator: Sketch 40 (33762) - http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch --\u003E\n\u003Cdesc\u003ECreated with Sketch.\u003C\u002Fdesc\u003E\n\u003Cdefs\u003E\u003C\u002Fdefs\u003E\n\u003Cg id=\"b2c\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(496.000000, 32.000000)\"\u003E\n\u003Cg id=\"Group\"\u003E\n\u003Cpath d=\"M242,182.5 C239.8,182.5 238,180.8 238,178.6 C238,176.4 239.8,174.4 242,174.4 C243.9,174.4 245.4,176.2 245.9,177.2 L253.5,177.2 C247.9,169.2 238.6,164 228.1,163.7 L228.1,194.2 L259.1,194.2 C258.9,189.2 257.4,184.2 254.8,179.2 L246,179.2 C245.4,181.3 243.9,182.5 242,182.5 L242,182.5 Z\" id=\"Shape\"\u003E\u003C\u002Fpath\u003E\n\u003Cpolygon id=\"Shape\" points=\"347 153.2 347 182.3 375.6 182.3\"\u003E\u003C\u002Fpolygon\u003E\n\u003Cpath d=\"M249,217.5 C246.8,217.5 245,215.8 245,213.6 C245,211.4 246.8,209.4 249,209.4 C250.9,209.4 252.4,211.2 252.9,212.2 L256.3,212.2 C257.5,209.2 258.4,206.2 258.9,202.2 L229.5,202.2 L250.4,223.1 C252.5,220.5 254.2,218.2 255.6,214.2 L253,214.2 C252.4,216.3 250.9,217.5 249,217.5 L249,217.5 Z\" id=\"Shape\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M346,184.3 L345,183.8 L345,151.3 L164,151.3 L164,407.3 L247.4,407.3 C240.6,392.3 237,377 237,360.8 C237,333.5 247.2,307.3 265.8,287.3 L188,287.3 L188,285.3 L267.7,285.3 C267.9,285.3 268.1,284.9 268.3,284.6 C272.5,280.4 277,277.3 281.7,273.3 L188,273.3 L188,271.3 L284.6,271.3 C292.2,266.3 300.3,262.3 308.7,259.3 L205,259.3 L205,257.3 L313,257.3 L313,258.4 C333.9,252.1 356.3,252.3 377,259 L377,184.3 L346,184.3 L346,184.3 Z M351,221.3 L351,223.3 L319,223.3 L319,221.3 L351,221.3 L351,221.3 Z M278,171.3 L323,171.3 L323,173.3 L278,173.3 L278,171.3 L278,171.3 Z M226,162.7 L227,161.5 C239.1,161.5 249.8,168.3 255.8,177.3 L328,177.3 L328,175.3 L330,175.3 L330,181.3 L328,181.3 L328,179.3 L257,179.3 C259.6,184.3 261,189.5 261,195.3 L260,196.3 L227,196.3 L226,195.8 L226,162.7 L226,162.7 Z M257.7,214.3 C256,219.3 253.8,222.4 251.1,225.5 L249.6,225.7 L226.3,202.2 L227,200.3 L260,200.3 L261,201.4 C260.5,205.2 259.6,209.3 258.4,212.3 L300,212.3 L300,210.3 L302,210.3 L302,216.3 L300,216.3 L300,214.3 L257.7,214.3 L257.7,214.3 Z M276,208.3 L276,206.3 L295,206.3 L295,208.3 L276,208.3 L276,208.3 Z M190,307.3 L190,367.3 L237,367.3 L237,369.3 L189,369.3 L188,368.8 L188,307.3 L190,307.3 L190,307.3 Z M356,231.3 L356,229.3 L244,229.3 C237.7,235.3 229.6,238.5 221,238.5 C202.3,238.5 187,223.4 187,204.6 C187,195.5 190.5,186.8 197,180.4 C203.4,174 212,170.3 221,170.3 L222,170.3 L222,204.4 L245.4,227.3 L356,227.3 L356,225.3 L358,225.3 L358,231.3 L356,231.3 L356,231.3 Z\" id=\"Shape\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M220,172.8 C211.8,173 204.2,176.3 198.4,182.2 C192.4,188.2 189,196.3 189,204.8 C189,222.4 203.4,236.6 221,236.6 C228.3,236.6 235.3,234.4 241,229.4 L222.9,229.4 C222.5,231.4 220.9,232.6 219,232.6 C216.8,232.6 215,230.9 215,228.7 C215,226.5 216.8,224.5 219,224.5 C220.9,224.5 222.4,226.3 222.9,227.3 L242.6,227.3 L220,205.2 L220,172.8 L220,172.8 Z\" id=\"Shape\"\u003E\u003C\u002Fpath\u003E\n\u003Cg id=\"salesforce-logo\" transform=\"translate(0.000000, 208.000000)\"\u003E\n\u003Cg id=\"layer1\" transform=\"translate(-0.000001, 0.060074)\"\u003E\n\u003Cg id=\"g3003\" transform=\"translate(39.523666, 28.713713) scale(1, -1) translate(-39.523666, -28.713713) translate(0.023666, 0.713713)\" fill=\"#B5B5B5\"\u003E\n\u003Cpath d=\"M32.7683341,49.2994488 C35.3066528,51.9552961 38.8405664,53.6023942 42.7489493,53.6023942 C47.9444302,53.6023942 52.4773023,50.6932338 54.8911716,46.3745267 C56.9888722,47.3157256 59.3108059,47.8392394 61.7538256,47.8392394 C71.1245267,47.8392394 78.7215441,40.1441498 78.7215441,30.6522259 C78.7215441,21.1591761 71.1245267,13.4640866 61.7538256,13.4640866 C60.6102368,13.4640866 59.4924348,13.5789219 58.4116312,13.7984599 C56.2859015,9.9908823 52.2351305,7.41834687 47.5856572,7.41834687 C45.6393139,7.41834687 43.7983602,7.86980714 42.1592163,8.67252826 C40.0043362,3.58262338 34.9837571,0.013723025 29.1323944,0.013723025 C23.03886,0.013723025 17.8456214,3.88547328 15.8521892,9.31538066 C14.9810436,9.1296177 14.0785054,9.0327958 13.1524227,9.0327958 C5.89736077,9.0327958 0.0157266046,14.999727 0.0157266046,22.3615691 C0.0157266046,27.2949827 2.65831367,31.6024316 6.58463522,33.907018 C5.7762749,35.77478 5.32668754,37.8361859 5.32668754,40.0034203 C5.32668754,48.4697076 12.1714029,55.3328043 20.613779,55.3328043 C25.5704516,55.3328043 29.9755109,52.9662969 32.7683341,49.2994488\" id=\"path3005\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3007\" transform=\"translate(14.318013, 27.193836) scale(1, -1) translate(-14.318013, -27.193836) translate(11.318013, 23.193836)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M0.121165491,1.12583607 C0.0718342098,0.996364924 0.139104139,0.969344859 0.154800456,0.946828137 C0.302794301,0.838747874 0.453030477,0.761065185 0.604387818,0.674375807 C1.40714231,0.2465581 2.16505018,0.121590296 2.95771418,0.121590296 C4.57219249,0.121590296 5.57451444,0.983980727 5.57451444,2.3721366 L5.57451444,2.39915667 C5.57451444,3.68260979 4.44325846,4.14870593 3.38151474,4.48533091 L3.24361138,4.53036436 C2.44309922,4.79155833 1.75246128,5.01672554 1.75246128,5.54586849 L1.75246128,5.5740144 C1.75246128,6.0266005 2.15608086,6.35984797 2.7816912,6.35984797 C3.47681381,6.35984797 4.30199161,6.12792574 4.83342405,5.83295669 C4.83342405,5.83295669 4.98926605,5.73163145 5.0464455,5.88361932 C5.07783813,5.96467951 5.34691785,6.69196962 5.37494698,6.77077814 C5.40521845,6.85634168 5.35140251,6.9193885 5.2964654,6.95316358 C4.68991487,7.32356365 3.85128308,7.57687677 2.98350099,7.57687677 L2.82205316,7.57575093 C1.34435704,7.57575093 0.31288479,6.67958542 0.31288479,5.39500646 L0.31288479,5.36798639 C0.31288479,4.0136056 1.45086776,3.57452953 2.51709615,3.26830212 L2.68863447,3.21538782 C3.46560215,2.97558474 4.13493795,2.76955674 4.13493795,2.22014874 L4.13493795,2.19312867 C4.13493795,1.69100578 3.69992574,1.3172282 2.99807614,1.3172282 C2.72563293,1.3172282 1.85672967,1.32285739 0.918314156,1.91842467 C0.805076441,1.984849 0.738927677,2.03325995 0.651476769,2.08617424 C0.605508984,2.11544598 0.490028938,2.1661086 0.439576491,2.0129949 L0.121165491,1.12583607 L0.121165491,1.12583607 Z\" id=\"path3009\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3011\" transform=\"translate(37.953303, 27.193836) scale(1, -1) translate(-37.953303, -27.193836) translate(34.953303, 23.193836)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M0.121165491,1.12583607 C0.0718342098,0.996364924 0.139104139,0.969344859 0.154800456,0.946828137 C0.302794301,0.838747874 0.453030477,0.761065185 0.604387818,0.674375807 C1.40714231,0.2465581 2.16505018,0.121590296 2.95771418,0.121590296 C4.57219249,0.121590296 5.57451444,0.983980727 5.57451444,2.3721366 L5.57451444,2.39915667 C5.57451444,3.68260979 4.44325846,4.14870593 3.38151474,4.48533091 L3.24361138,4.53036436 C2.44309922,4.79155833 1.75246128,5.01672554 1.75246128,5.54586849 L1.75246128,5.5740144 C1.75246128,6.0266005 2.15608086,6.35984797 2.7816912,6.35984797 C3.47681381,6.35984797 4.30199161,6.12792574 4.83342405,5.83295669 C4.83342405,5.83295669 4.98926605,5.73163145 5.0464455,5.88361932 C5.07783813,5.96467951 5.34691785,6.69196962 5.37494698,6.77077814 C5.40521845,6.85634168 5.35140251,6.9193885 5.2964654,6.95316358 C4.68991487,7.32356365 3.85128308,7.57687677 2.98350099,7.57687677 L2.82205316,7.57575093 C1.34435704,7.57575093 0.31288479,6.67958542 0.31288479,5.39500646 L0.31288479,5.36798639 C0.31288479,4.0136056 1.45086776,3.57452953 2.51709615,3.26830212 L2.68863447,3.21538782 C3.46560215,2.97558474 4.13605912,2.76955674 4.13605912,2.22014874 L4.13605912,2.19312867 C4.13605912,1.69100578 3.69992574,1.3172282 2.99807614,1.3172282 C2.72563293,1.3172282 1.85672967,1.32285739 0.918314156,1.91842467 C0.805076441,1.984849 0.737806512,2.03100827 0.652597934,2.08617424 C0.623447632,2.10531346 0.486665442,2.15822775 0.439576491,2.0129949 L0.121165491,1.12583607 L0.121165491,1.12583607 Z\" id=\"path3013\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3015\" transform=\"translate(49.603787, 27.352226) scale(1, -1) translate(-49.603787, -27.352226) translate(45.603787, 22.852226)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M5.60582746,4.50334429 C5.60582746,3.71863655 5.46007594,3.10055254 5.17305758,2.66372815 C4.88940271,2.2314071 4.45999632,2.02087575 3.86129395,2.02087575 C3.26147041,2.02087575 2.83430636,2.23028126 2.55513615,2.66372815 C2.27260245,3.09942671 2.12909327,3.71863655 2.12909327,4.50334429 C2.12909327,5.2869262 2.27260245,5.90388436 2.55513615,6.33620542 C2.83430636,6.76402312 3.26147041,6.9723028 3.86129395,6.9723028 C4.45999632,6.9723028 4.88940271,6.76402312 5.17417874,6.33620542 C5.46007594,5.90388436 5.60582746,5.2869262 5.60582746,4.50334429 M6.95346838,5.9579245 C6.82117085,6.40713309 6.6148764,6.80342739 6.34019085,7.13329736 C6.06550531,7.46429316 5.71794401,7.72999047 5.30535511,7.92363428 C4.89388737,8.11615225 4.40730155,8.21409999 3.86129395,8.21409999 C3.31416519,8.21409999 2.82757937,8.11615225 2.41611163,7.92363428 C2.00352273,7.72999047 1.65596143,7.46429316 1.38015472,7.13329736 C1.10659034,6.80230155 0.90029589,6.40600725 0.766877196,5.9579245 C0.635700834,5.51096758 0.56955207,5.02235472 0.56955207,4.50334429 C0.56955207,3.98433386 0.635700834,3.49459517 0.766877196,3.04876408 C0.90029589,2.60068133 1.10546917,2.20438703 1.38127589,1.87339122 C1.65596143,1.54239542 2.0046439,1.27782394 2.41611163,1.08980932 C2.82870053,0.901794694 3.31416519,0.806098628 3.86129395,0.806098628 C4.40730155,0.806098628 4.8927662,0.901794694 5.30535511,1.08980932 C5.71682284,1.27782394 6.06550531,1.54239542 6.34019085,1.87339122 C6.6148764,2.20326119 6.82117085,2.59955549 6.95346838,3.04876408 C7.08576591,3.49572101 7.15191467,3.9854597 7.15191467,4.50334429 C7.15191467,5.02122888 7.08576591,5.51096758 6.95346838,5.9579245\" id=\"path3017\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3019\" transform=\"translate(61.018121, 27.373502) scale(1, -1) translate(-61.018121, -27.373502) translate(58.018121, 22.873502)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M5.60582746,2.25167215 C5.56098084,2.38339497 5.43428914,2.33385818 5.43428914,2.33385818 C5.23808518,2.25842716 5.02954839,2.18862533 4.80755763,2.15372441 C4.58220336,2.11882349 4.33442579,2.10081011 4.06870957,2.10081011 C3.41619125,2.10081011 2.8982128,2.29557975 2.52710702,2.68061569 C2.15488007,3.06565163 1.94634329,3.68823897 1.94858562,4.53036436 C1.95082796,5.29705872 2.1346991,5.87348679 2.46544292,6.31256286 C2.7939444,6.74938726 3.29398421,6.97342863 3.96107768,6.97342863 C4.51717576,6.97342863 4.94097632,6.90925598 5.38495786,6.76852647 C5.38495786,6.76852647 5.49146858,6.72236719 5.54192102,6.86197086 C5.6596434,7.190715 5.74709431,7.42601473 5.87266484,7.78740811 C5.90854214,7.8898592 5.82109123,7.9337668 5.7896986,7.946151 C5.61479678,8.014827 5.20220788,8.12628477 4.89052387,8.17356989 C4.59902085,8.21860333 4.25818654,8.24224589 3.8792326,8.24224589 C3.31304403,8.24224589 2.80851956,8.14542399 2.37687084,7.95178018 C1.94634329,7.75926221 1.58084334,7.4935649 1.29158265,7.16256909 C1.00232195,6.83157329 0.782573513,6.43527899 0.635700834,5.98719623 C0.48994932,5.54023931 0.415952397,5.04937479 0.415952397,4.53036436 C0.415952397,3.40790579 0.717545914,2.50048192 1.31288479,1.83623863 C1.90934483,1.16974368 2.80515606,0.830867022 3.9734105,0.830867022 C4.66404844,0.830867022 5.37262503,0.971596531 5.88163417,1.17312119 C5.88163417,1.17312119 5.97917557,1.2204063 5.93657128,1.33411575 L5.60582746,2.25167215 L5.60582746,2.25167215 Z\" id=\"path3021\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3023\" transform=\"translate(67.329580, 26.858081) scale(1, -1) translate(-67.329580, -26.858081) translate(63.739530, 22.615657)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M2.24233098,4.50334429 C2.30623742,4.93904285 2.42620212,5.30156207 2.61119443,5.58414692 C2.89036464,6.01309046 3.31640752,6.2483902 3.9151099,6.2483902 C4.51381227,6.2483902 4.90958369,6.01196463 5.19323856,5.58414692 C5.38159436,5.30156207 5.46343944,4.92328115 5.49595324,4.50334429 L2.24233098,4.50334429 L2.24233098,4.50334429 Z M6.77968773,5.46143079 C6.66532885,5.89487768 6.38167398,6.33282791 6.19556051,6.53322673 C5.90181515,6.8507125 5.61479678,7.07250221 5.33002075,7.19634418 C4.9577938,7.3562129 4.51156994,7.46204149 4.02274178,7.46204149 C3.45318971,7.46204149 2.93633242,7.36634542 2.51701653,7.16819827 C2.09657947,6.97005113 1.74341234,6.69985047 1.46648446,6.36322548 C1.18955659,6.02772633 0.981019805,5.62805453 0.848722277,5.17434259 C0.715303584,4.72288232 0.648033654,4.23089196 0.648033654,3.71188153 C0.648033654,3.18386441 0.717545914,2.69187405 0.85544927,2.24942047 C0.994473791,1.80358939 1.21646456,1.4106726 1.51693691,1.08530597 C1.8162881,0.757687677 2.20196903,0.500997052 2.66388921,0.321989117 C3.12244589,0.144107017 3.67966514,0.0517884593 4.31985064,0.0529142954 C5.63722009,0.0574176397 6.33122153,0.352386691 6.61711873,0.511129577 C6.66757118,0.539275479 6.71578129,0.588812266 6.65523836,0.730667611 L6.35700834,1.56941549 C6.31216172,1.69438329 6.18547002,1.64822401 6.18547002,1.64822401 C5.85921086,1.52663371 5.39504834,1.30822152 4.31312365,1.31047319 C3.60566822,1.31159902 3.08096277,1.52100453 2.75246128,1.84862283 C2.41499047,2.18412198 2.25017914,2.67723818 2.22102884,3.37300487 L6.78305122,3.36850153 C6.78305122,3.36850153 6.90301593,3.3707532 6.91534875,3.48784015 C6.91983341,3.53737694 7.07231192,4.42903911 6.77968773,5.46143079 L6.77968773,5.46143079 Z\" id=\"path3025\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3027\" transform=\"translate(30.704336, 27.100505) scale(1, -1) translate(-30.704336, -27.100505) translate(27.204336, 23.100505)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M2.24233098,4.50334429 C2.30735858,4.93904285 2.42620212,5.30156207 2.61119443,5.58414692 C2.89036464,6.01309046 3.31640752,6.2483902 3.9151099,6.2483902 C4.51381227,6.2483902 4.90958369,6.01196463 5.19435972,5.58414692 C5.38159436,5.30156207 5.46343944,4.92328115 5.49595324,4.50334429 L2.24233098,4.50334429 L2.24233098,4.50334429 Z M6.77856656,5.46143079 C6.66420768,5.89487768 6.38167398,6.33282791 6.19556051,6.53322673 C5.90181515,6.8507125 5.61479678,7.07250221 5.33002075,7.19634418 C4.9577938,7.3562129 4.51156994,7.46204149 4.02274178,7.46204149 C3.45431088,7.46204149 2.93633242,7.36634542 2.51701653,7.16819827 C2.09657947,6.97005113 1.74341234,6.69985047 1.46648446,6.36322548 C1.18955659,6.02772633 0.981019805,5.62805453 0.848722277,5.17434259 C0.716424749,4.72288232 0.648033654,4.23089196 0.648033654,3.71188153 C0.648033654,3.18386441 0.717545914,2.69187405 0.85544927,2.24942047 C0.994473791,1.80358939 1.21646456,1.4106726 1.51693691,1.08530597 C1.8162881,0.757687677 2.20196903,0.500997052 2.66388921,0.321989117 C3.12244589,0.144107017 3.67966514,0.0517884593 4.31985064,0.0529142954 C5.63722009,0.0574176397 6.33122153,0.352386691 6.61711873,0.511129577 C6.66757118,0.539275479 6.71578129,0.588812266 6.65523836,0.730667611 L6.3581295,1.56941549 C6.31216172,1.69438329 6.18547002,1.64822401 6.18547002,1.64822401 C5.85921086,1.52663371 5.39616951,1.30822152 4.31200248,1.31047319 C3.60566822,1.31159902 3.08096277,1.52100453 2.75246128,1.84862283 C2.41499047,2.18412198 2.25017914,2.67723818 2.22102884,3.37300487 L6.78305122,3.36850153 C6.78305122,3.36850153 6.90301593,3.3707532 6.91534875,3.48784015 C6.91983341,3.53737694 7.07231192,4.42903911 6.77856656,5.46143079 L6.77856656,5.46143079 Z\" id=\"path3029\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3031\" transform=\"translate(20.843573, 27.348397) scale(1, -1) translate(-20.843573, -27.348397) translate(17.343573, 22.848397)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M2.24233098,2.25167215 C2.06406567,2.39465333 2.03940003,2.43068008 1.97885709,2.52299864 C1.88916385,2.66372815 1.84319607,2.86412697 1.84319607,3.11856592 C1.84319607,3.52161524 1.9754936,3.81095511 2.25017914,4.00572475 C2.24681564,4.00459891 2.64258706,4.34910475 3.57315442,4.33672055 C4.2267939,4.32771386 4.81092112,4.23089196 4.81092112,4.23089196 L4.81092112,2.14809523 L4.81204229,2.14809523 C4.81204229,2.14809523 4.23239973,2.02312742 3.57988141,1.98372316 C2.65155639,1.92743136 2.23896749,2.25279798 2.24233098,2.25167215 M4.05749791,5.47043748 C3.87250561,5.48394751 3.63257619,5.49182836 3.34555783,5.49182836 C2.95427107,5.49182836 2.5764383,5.44229158 2.22215,5.34659551 C1.86561938,5.25089944 1.54496605,5.10116325 1.26915934,4.9030161 C0.99223146,4.70374311 0.769119527,4.44930416 0.607671696,4.14758009 C0.446223866,3.84585602 0.364378785,3.49009183 0.364378785,3.09154586 C0.364378785,2.68624487 0.433891045,2.33385818 0.572915566,2.04564414 C0.711940087,1.75630427 0.91262871,1.51537535 1.16825444,1.3296124 C1.42163784,1.14384945 1.73444302,1.00762328 2.09770063,0.925437252 C2.45535243,0.843251218 2.86121433,0.801595284 3.30519587,0.801595284 C3.77272188,0.801595284 4.23912672,0.83987371 4.69095642,0.917556399 C5.13830145,0.994113252 5.68767254,1.10557102 5.84015104,1.14047194 C5.99150839,1.1764987 6.15968321,1.22265797 6.15968321,1.22265797 C6.27292092,1.25080388 6.2639516,1.37239417 6.2639516,1.37239417 L6.26170927,5.5616302 C6.26170927,6.48031243 6.01729519,7.16144326 5.5363152,7.58363179 C5.05757753,8.00469448 4.35236444,8.21747749 3.44085689,8.21747749 C3.09890142,8.21747749 2.54840916,8.17019238 2.21878651,8.10376805 C2.21878651,8.10376805 1.22207039,7.91012425 0.811723816,7.58813513 C0.811723816,7.58813513 0.722030576,7.53184333 0.771361858,7.40574969 L1.09425752,6.53435257 C1.13461948,6.42176896 1.24337253,6.46004738 1.24337253,6.46004738 C1.24337253,6.46004738 1.27812866,6.47355742 1.31849062,6.49719998 C2.1963632,6.97680614 3.30631703,6.96217027 3.30631703,6.96217027 C3.79962985,6.96217027 4.17858379,6.8630967 4.43420952,6.66607539 C4.68310826,6.47468325 4.80979996,6.18534338 4.80979996,5.57514023 L4.80979996,5.38149643 C4.41739204,5.43778823 4.05749791,5.47043748 4.05749791,5.47043748\" id=\"path3033\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3035\" transform=\"translate(56.211043, 26.898383) scale(1, -1) translate(-56.211043, -26.898383) translate(53.711043, 22.898383)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M4.48466197,6.88085251 C4.5194181,6.98442943 4.44654234,7.03396621 4.41627087,7.04522457 C4.33891045,7.07562215 3.95098719,7.15780818 3.65163601,7.1769474 C3.07872044,7.21184831 2.76030944,7.11502641 2.4755334,6.9866811 C2.1929997,6.85833579 1.87907336,6.65118195 1.70417155,6.41588221 L1.70417155,6.97317107 C1.70417155,7.05085376 1.64923444,7.11277474 1.57299518,7.11277474 L0.403619577,7.11277474 C0.327380323,7.11277474 0.272443214,7.05085376 0.272443214,6.97317107 L0.272443214,0.140471942 C0.272443214,0.0639150886 0.335228482,0.000868268554 0.411467735,0.000868268554 L1.60999365,0.000868268554 C1.6862329,0.000868268554 1.747897,0.0639150886 1.747897,0.140471942 L1.747897,3.55400691 C1.747897,4.0122222 1.79834945,4.46931164 1.89925434,4.75639984 C1.99791691,5.04011053 2.13245676,5.26752942 2.29838926,5.43077565 C2.46544292,5.59289604 2.65491988,5.70660548 2.8623355,5.77077814 C3.07423578,5.83607663 3.30855937,5.85746752 3.47449186,5.85746752 C3.71330011,5.85746752 3.97565283,5.79554653 3.97565283,5.79554653 C4.06310374,5.78541401 4.11243502,5.83945414 4.14158533,5.9193885 C4.22006691,6.12879401 4.44205768,6.7558847 4.48466197,6.88085251\" id=\"path3037\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3039\" transform=\"translate(43.476381, 27.360816) scale(1, -1) translate(-43.476381, -27.360816) translate(38.976381, 20.360816)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M7.96932393,13.5100329 C7.82357242,13.5550663 7.69127489,13.5854639 7.5186154,13.6181131 C7.34371359,13.6496365 7.13517681,13.6653982 6.89861089,13.6653982 C6.07343309,13.6653982 5.4231571,13.4312243 4.96684275,12.9696316 C4.51277072,12.5102904 4.20445021,11.8111462 4.04972937,10.8913382 L3.9936711,10.5817332 L2.95771418,10.5817332 C2.95771418,10.5817332 2.83214365,10.5862366 2.80523568,10.4488846 L2.63593969,9.49530144 C2.62360687,9.40523455 2.66284766,9.34781691 2.78393353,9.34781691 L3.79186131,9.34781691 L2.76935838,3.61505963 C2.68975563,3.15346684 2.59782006,2.77406008 2.495794,2.48584605 C2.39601027,2.20213536 2.29846888,1.98935234 2.177383,1.83398696 C2.06078179,1.6853766 1.95090757,1.57504467 1.76030944,1.51087201 C1.60334627,1.45795771 1.42171746,1.43318932 1.22327117,1.43318932 C1.11339695,1.43318932 0.966524272,1.4512027 0.857771219,1.47371942 C0.750139332,1.4951103 0.692959892,1.51875286 0.611114811,1.55365378 C0.611114811,1.55365378 0.493392435,1.59868722 0.446303484,1.48047444 C0.409305023,1.3825267 0.140225305,0.640600725 0.107711505,0.549408003 C0.0763188717,0.458215282 0.121165491,0.387287609 0.178344931,0.365896724 C0.31288479,0.318611609 0.412668519,0.287088199 0.595418494,0.243180592 C0.848801895,0.18351128 1.0629445,0.180133772 1.26363313,0.180133772 C1.68294902,0.180133772 2.06638762,0.239803083 2.38367745,0.354638363 C2.70208845,0.470599478 2.98013749,0.672124135 3.2267939,0.944576465 C3.49251012,1.23954552 3.65956378,1.5480246 3.81876928,1.97021313 C3.97685362,2.38677247 4.11251464,2.90465707 4.22014653,3.5081052 L5.24825528,9.34781691 L6.75061704,9.34781691 C6.75061704,9.34781691 6.87730874,9.34331357 6.90309555,9.4817914 L7.0735127,10.4342487 C7.08472436,10.5254414 7.04660473,10.5817332 6.92439769,10.5817332 L5.46576139,10.5817332 C5.47360955,10.6143825 5.53975831,11.1300154 5.70681197,11.6152508 C5.77856656,11.8212788 5.91310642,11.9890283 6.02634413,12.1038636 C6.13846068,12.2164472 6.26739472,12.2963816 6.40866157,12.3425409 C6.55329192,12.389826 6.71810324,12.4123427 6.89861089,12.4123427 C7.03539308,12.4123427 7.1710541,12.396581 7.27308016,12.3751901 C7.41434701,12.3447925 7.46928412,12.3290308 7.50628258,12.3177725 C7.65539759,12.272739 7.67557857,12.3166466 7.70472888,12.3887001 L8.05341134,13.3501641 C8.08928864,13.4537411 8.00071656,13.4976487 7.96932393,13.5100329\" id=\"path3041\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"g3043\" transform=\"translate(25.823389, 25.884086) scale(1, -1) translate(-25.823389, -25.884086) translate(24.323389, 19.884086)\" fill=\"#FFFFFF\"\u003E\n\u003Cpath d=\"M2.24233098,1.12583607 C2.24233098,1.04927922 2.18739387,0.987358236 2.11115462,0.987358236 L0.901417055,0.987358236 C0.825177802,0.987358236 0.771361858,1.04927922 0.771361858,1.12583607 L0.771361858,10.9025965 C0.771361858,10.9791534 0.825177802,11.0410744 0.901417055,11.0410744 L2.11115462,11.0410744 C2.18739387,11.0410744 2.24233098,10.9791534 2.24233098,10.9025965 L2.24233098,1.12583607 L2.24233098,1.12583607 Z\" id=\"path3045\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fg\u003E\n\u003Cpath d=\"M78,545.2 C78,561.7 91.5,575.2 108,575.2 C124.5,575.2 138,561.7 138,545.2 C138,528.7 124.5,515.2 108,515.2 C91.5,515.2 78,528.7 78,545.2 L78,545.2 Z\" id=\"Shape\"\u003E\u003C\u002Fpath\u003E\n\u003Cg id=\"marketo-logo\" transform=\"translate(79.000000, 525.000000)\"\u003E\n\u003Cpath d=\"M26.5870445,0.427868852 C33.1748988,-0.33442623 40.005668,1.16557377 45.6607287,4.68196721 C50.8906883,7.90819672 55.0955466,12.8139344 57.4712551,18.5336066 C59.8761134,24.1967213 60.3838057,30.6393443 59.0234818,36.6393443 C57.5659919,43.0745902 53.8906883,48.9639344 48.7967611,53.0803279 C43.4356275,57.4745902 36.5295547,59.8721311 29.6356275,59.7565574 C24.2574899,59.7122951 18.9303644,58.1360656 14.3271255,55.3303279 C8.57732794,51.752459 4.04453441,46.1557377 1.8534413,39.6811475 C-1.61781377,29.8868852 0.59757085,18.2901639 7.48663968,10.5540984 C12.2793522,4.89098361 19.2825911,1.26147541 26.5870445,0.427868852 L26.5870445,0.427868852 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M26.3271255,4.54918033 C31.9263158,3.75491803 37.7902834,4.81229508 42.7093117,7.65737705 C47.4437247,10.3352459 51.291498,14.5819672 53.5165992,19.5909836 C55.7902834,24.6934426 56.2955466,30.5655738 55.005668,36.002459 C53.7376518,41.2377049 50.8080972,46.047541 46.7198381,49.5098361 C42.5101215,53.1491803 37.1052632,55.3598361 31.5716599,55.647541 C25.4526316,56.0754098 19.2242915,54.157377 14.3562753,50.3901639 C10.0955466,47.1467213 6.90121457,42.5188525 5.35870445,37.354918 C3.5659919,31.3770492 4.05425101,24.7352459 6.71417004,19.0967213 C10.2947368,11.3213115 17.9489879,5.70983607 26.3271255,4.54918033 L26.3271255,4.54918033 Z\" id=\"Shape\" fill=\"#FFFFFE\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M40.2315789,19.8516393 C40.3991903,18.7672131 41.3805668,17.85 42.4906883,17.9262295 C43.9287449,17.9483607 45.3862348,17.8106557 46.8121457,18.0344262 C47.5530364,18.2336066 47.6259109,19.1631148 47.4631579,19.795082 C45.6558704,27.5655738 43.8072874,35.3286885 42.0121457,43.1040984 C39.8477733,42.157377 37.6615385,41.2745902 35.4121457,40.5590164 C36.9473684,33.6393443 38.642915,26.7565574 40.2315789,19.8516393 L40.2315789,19.8516393 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M29.8834008,26.3016393 C30.0850202,25.2762295 31.005668,24.4672131 32.0526316,24.4942623 C33.4299595,24.4795082 34.8121457,24.4278689 36.1846154,24.5434426 C36.9813765,24.6196721 37.3408907,25.5418033 37.102834,26.242623 C36.0388664,30.8606557 34.9311741,35.4713115 33.8842105,40.0967213 C31.6008097,39.5409836 29.2955466,39.0959016 26.9927126,38.6360656 C27.9376518,34.5196721 28.9190283,30.4131148 29.8834008,26.3016393 L29.8834008,26.3016393 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M20.3538462,30.1868852 C20.5214575,29.2991803 21.1554656,28.3868852 22.1101215,28.3008197 C23.3222672,28.1704918 24.5441296,28.2393443 25.7611336,28.2221311 C26.3538462,28.2393443 27.0874494,28.202459 27.4663968,28.7631148 C27.9157895,29.5008197 27.5004049,30.3688525 27.3595142,31.1360656 C26.7230769,33.5729508 26.2955466,36.0713115 25.557085,38.4762295 C23.2591093,38.1221311 20.9392713,37.957377 18.6242915,37.7852459 C19.1295547,35.2377049 19.7781377,32.7196721 20.3538462,30.1868852 L20.3538462,30.1868852 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M10.4793522,34.197541 C10.7295547,33.2532787 11.6502024,32.554918 12.6194332,32.6016393 C13.9214575,32.5918033 15.2283401,32.55 16.5279352,32.6286885 C17.2834008,32.5991803 17.8348178,33.4081967 17.6817814,34.1213115 C17.4534413,35.3286885 17.1497976,36.5213115 16.8218623,37.7040984 C14.4364372,37.6155738 12.048583,37.5909836 9.66315789,37.7065574 C9.88906883,36.5262295 10.1489879,35.3508197 10.4793522,34.197541 L10.4793522,34.197541 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"first-logo\"\u003E\n\u003Cpath d=\"M195.000026,43.0121001 C195.000026,41.9075999 194.104529,41.0120999 193.000032,41.0120999 C191.895536,41.0120999 191.000039,41.9075999 191.000039,43.0121001 L191.000039,61 C191.000039,62.1044999 191.895536,62.9999999 193.000032,62.9999999 C194.104529,62.9999999 195.000026,62.1044999 195.000026,61 L195.000026,43.0121001 L195.000026,43.0121001 Z M194.302028,30.49355 C193.993029,30.2289 186.584053,24.0119 173.000098,24.0119 C159.416142,24.0119 152.007416,30.2291 151.698417,30.49375 C150.85992,31.2125 150.76287,32.4752 151.481618,33.31405 C152.198815,34.151 153.457961,34.25 154.297059,33.53475 C154.414608,33.4365 161.030387,28.0123 173.000098,28.0121 C185.120158,28.0121 191.633837,33.4756 191.698287,33.53065 C192.535184,34.2494 193.80003,34.15275 194.518527,33.31385 C195.237525,32.4752 195.140525,31.2123 194.302028,30.49355 L194.302028,30.49355 L194.302028,30.49355 Z M150.999969,61 C150.999969,62.1044999 151.895466,62.9999999 152.999963,62.9999999 C154.104659,62.9999999 154.999956,62.1044999 154.999956,61 L154.999956,43.0121001 C154.999956,41.9078001 154.104659,41.0123001 152.999963,41.0123001 C151.895466,41.0123001 150.999969,41.9078001 150.999969,43.0123 L150.999969,61 L150.999969,61 Z M161.000137,65.0000001 C161.000137,66.1045 161.895634,67 163.00013,67 C164.104627,67 165.000124,66.1045 165.000124,65.0000001 L165.000124,38.28105 C165.000124,37.17655 164.104627,36.28105 163.00013,36.28105 C161.895634,36.28105 161.000137,37.17655 161.000137,38.28105 L161.000137,65.0000001 L161.000137,65.0000001 Z M171.000104,66.0119999 C171.000104,67.117 171.895601,68.0120001 173.000098,68.0120001 C174.104594,68.0120001 175.000091,67.117 175.000091,66.0119999 L175.000091,37.0121 C175.000091,35.9076 174.104594,35.0121 173.000098,35.0121 C171.895601,35.0121 171.000104,35.9076 171.000104,37.0121 L171.000104,66.0119999 L171.000104,66.0119999 Z M181.000072,65.0000001 C181.000072,66.1045 181.895569,67 183.000065,67 C184.104561,67 185.000059,66.1045 185.000059,65.0000001 L185.000059,38.28105 C185.000059,37.17655 184.104561,36.28105 183.000065,36.28105 C181.895569,36.28105 181.000072,37.17655 181.000072,38.28105 L181.000072,65.0000001 L181.000072,65.0000001 Z M195.500024,76 L150.499971,76 C146.357994,76 143,72.6419999 143,68.5 L143.000195,23.5 C143.000195,19.35801 146.357994,16 150.499971,16 L195.500024,16 C199.642011,16 203,19.35801 203,23.5 L203,68.5 C203,72.6419999 199.642011,76 195.500024,76 L195.500024,76 L195.500024,76 Z\" id=\"Shape\" fill=\"#B5B5B5\" transform=\"translate(173.000000, 46.000000) scale(1, -1) translate(-173.000000, -46.000000) \"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"domo-logo\" transform=\"translate(300.000000, 0.000000)\"\u003E\n\u003Cpath d=\"M7.0161,0.128333333 C8.94855,0.138518519 10.8732,0.719074074 12.50535,1.7987037 C14.859,3.32444444 16.536,5.8687037 17.16195,8.67777778 C17.472,7.4962963 17.86395,6.32703704 18.49965,5.29018519 C20.163,2.44851852 23.1348,0.499074074 26.31135,0.183333333 C29.22855,-0.14462963 32.24325,0.906481481 34.4058,2.97407407 C35.9658,4.43462963 37.0071,6.41462963 37.5531,8.51481481 C37.58235,5.71388889 37.54725,2.91296296 37.5687,0.112037037 C41.04945,3.72981481 44.5107,7.37 47.99145,10.9898148 C51.49755,7.38833333 54.94125,3.7237037 58.4454,0.120185185 C58.4883,2.84981481 58.3908,5.58148148 58.49415,8.30907407 C58.77495,7.54111111 59.0148,6.75481481 59.3814,6.02555556 C60.68595,3.36925926 63.0786,1.32407407 65.83395,0.52962963 C68.42745,-0.234259259 71.29785,0.103888889 73.65735,1.46462963 C75.5157,2.48518519 76.9236,4.17796296 78,6.02962963 C78,6.02962963 78.7520821,8.46592593 78.7520821,10.9898148 C78.7520821,13.5137037 78,15.842037 78,15.842037 C76.6857,18.6898148 74.1078,20.8511111 71.1672,21.5966667 C68.133,22.4033333 64.76535,21.6781481 62.29665,19.6635185 C60.41295,18.1948148 59.15325,16.0151852 58.47855,13.6868519 C58.4142,16.4287037 58.4727,19.1746296 58.45125,21.9164815 C57.27735,21.9246296 56.1015,21.9205556 54.9276,21.9225926 C54.9003,17.5898148 54.9315,13.257037 54.912,8.9262963 C52.60905,11.3442593 50.3178,13.7744444 47.9934,16.17 C45.67875,13.7540741 43.36995,11.332037 41.0514,8.92018519 C41.03385,13.252963 41.0514,17.5857407 41.0436,21.9164815 C39.8814,21.9225926 38.72115,21.9307407 37.5609,21.9103704 C37.557,19.1114815 37.57845,16.3105556 37.5531,13.5137037 C37.01685,15.6138889 35.9814,17.5918519 34.4214,19.0524074 C32.175,21.2361111 28.9731,22.2709259 25.93695,21.8146296 C22.8462,21.392963 20.0031,19.412963 18.4158,16.612037 C17.823,15.6118519 17.45835,14.4935185 17.16195,13.365 C16.5399,16.1659259 14.8746,18.7 12.5346,20.2277778 C10.73085,21.4377778 8.5722,21.997963 6.43695,21.9225926 C4.29195,21.8675926 2.1372,22.0244444 0,21.8451852 L0,0.128333333 C2.33805,0.13037037 4.67805,0.126296296 7.0161,0.128333333 Z\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M3.49245,3.79907407 C5.6862,3.88462963 8.0457,3.40796296 10.0659,4.5487037 C12.82125,5.93796296 14.43,9.38055556 13.7475,12.5012963 C13.299,14.8316667 11.67075,16.8625926 9.5589,17.7385185 C7.644,18.5859259 5.5263,18.1540741 3.51195,18.2559259 C3.4749,13.4383333 3.48855,8.6187037 3.49245,3.79907407 L3.49245,3.79907407 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M25.80045,3.96 C28.7157,3.19814815 31.97415,4.7137037 33.4113,7.46166667 C34.7178,9.81851852 34.5813,12.9535185 33.05835,15.1677778 C31.35795,17.8118519 27.88305,18.977037 25.02825,17.8464815 C22.06035,16.7892593 20.05575,13.4383333 20.47695,10.1851852 C20.7753,7.21314815 23.0061,4.60166667 25.80045,3.96 L25.80045,3.96 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M67.1346,3.94777778 C70.4067,3.09833333 74.03175,5.18222222 75.15105,8.49037037 C76.3308,11.5907407 75.08475,15.4 72.3723,17.1396296 C70.6563,18.2966667 68.43915,18.59 66.50085,17.9177778 C64.4124,17.2211111 62.7042,15.4162963 62.0412,13.2346296 C61.50105,11.5011111 61.6239,9.55574074 62.38635,7.91592593 C63.2775,5.92777778 65.08125,4.41833333 67.1346,3.94777778 L67.1346,3.94777778 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003Cpath d=\"M205,257.3 L205,259.3 L308.7,259.3 C310.1,259.3 311.6,258.8 313,258.4 L313,257.3 L205,257.3 L205,257.3 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M188,273.3 L281.7,273.3 C282.7,273.3 283.6,272.3 284.6,271.3 L188,271.3 L188,273.3 L188,273.3 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M188,287.3 L265.8,287.3 C266.4,287.3 267.1,286.3 267.7,285.3 L188,285.3 L188,287.3 L188,287.3 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M164,407.3 L164,151.3 L345,151.3 L345,183.8 L346,184.3 L377,184.3 L377,259 C377.7,259.2 378.3,259.4 379,259.7 L379,183.8 L378.7,183.1 L346.7,149.9 L346,149.4 L163,149.4 L162,150.9 L162,408 L163,409.5 L248.3,409.5 C248,408.5 247.6,407.5 247.3,407.5 L164,407.5 L164,407.3 Z M347,153.2 L375.6,182.3 L347,182.3 L347,153.2 L347,153.2 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M428.1,436.4 L423.7,432 C422.4,433.5 421,434.9 419.6,436.4 C418.2,437.8 416.7,439.2 415.2,440.5 L419.6,444.9 L428.1,436.4 L428.1,436.4 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M475.1,508.8 L492.1,491.8 L438.8,438.5 L438.1,439.2 L422.5,454.8 L422.5,454.8 L421.8,455.5 L475.1,508.8 L475.1,508.8 Z M488.5,488.8 L472.1,505.2 L470.7,503.8 L487.1,487.4 L488.5,488.8 L488.5,488.8 Z M483.5,483.8 L467.1,500.2 L465.7,498.8 L482.1,482.4 L483.5,483.8 L483.5,483.8 Z M478.5,478.8 L462.1,495.2 L460.7,493.8 L477.1,477.4 L478.5,478.8 L478.5,478.8 Z M473.5,473.8 L457.1,490.2 L455.7,488.8 L472.1,472.4 L473.5,473.8 L473.5,473.8 Z M468.5,468.8 L452.1,485.2 L450.7,483.8 L467.1,467.4 L468.5,468.8 L468.5,468.8 Z M463.5,463.8 L447.1,480.2 L445.7,478.8 L462.1,462.4 L463.5,463.8 L463.5,463.8 Z M458.5,458.8 L442.1,475.2 L440.7,473.8 L457.1,457.4 L458.5,458.8 L458.5,458.8 Z M453.5,453.8 L437.1,470.2 L435.7,468.8 L452.1,452.4 L453.5,453.8 L453.5,453.8 Z M448.5,448.8 L432.1,465.2 L430.7,463.8 L447.1,447.4 L448.5,448.8 L448.5,448.8 Z M442,442.4 L443.4,443.8 L427,460.2 L425.6,458.8 L442,442.4 L442,442.4 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpolygon id=\"Shape\" fill=\"#FFFFFF\" points=\"501.2 501 493.4 493.2 476.5 510.2 484.2 518 485 517.3 500.5 501.7\"\u003E\u003C\u002Fpolygon\u003E\n\u003Cpath d=\"M504,501 L493.4,490.4 L493.4,490.4 L438.7,435.7 L436.6,437.8 L431.7,432.8 L429.6,434.9 L425.1,430.4 C461.3,388.4 459.5,324.8 419.7,284.9 C407.9,273.1 393.9,264.6 379,259.5 C378.3,259.3 377.7,259 377,258.8 C356.3,252.1 333.9,251.9 313,258.2 C311.6,258.6 310.1,259.1 308.7,259.6 C300.3,262.5 292.2,266.5 284.6,271.6 C283.6,272.2 282.7,272.9 281.7,273.6 C277,277 272.5,280.7 268.3,284.9 C268.1,285.1 267.9,285.3 267.7,285.6 C267.1,286.3 266.4,286.9 265.8,287.6 C247.2,307.5 237,333.3 237,360.6 C237,376.8 240.6,392.5 247.4,406.7 C247.7,407.4 248,408 248.4,408.7 C253.5,418.8 260.2,428.1 268.4,436.3 C289.3,457.2 316.7,467.6 344.1,467.6 C369,467.6 393.9,459 413.9,441.8 L418.4,446.3 L416.3,448.4 L421.2,453.3 L419.1,455.4 L484.4,520.7 L486.5,518.6 L491.5,523.6 L507.1,508 L502.2,503 L504,501 L504,501 Z M491.3,520.8 L487.8,517.3 L500.5,504.6 L504,508.1 L491.3,520.8 L491.3,520.8 Z M344,255.8 C370.9,255.8 397.8,266 418.2,286.5 C459.1,327.4 459.1,394.1 418.2,435 C377.3,475.9 310.6,475.9 269.7,435 C249.9,415.2 238.9,388.8 238.9,360.8 C238.9,332.8 249.8,306.4 269.7,286.6 C290.2,266 317.1,255.8 344,255.8 L344,255.8 Z M419.7,436.4 C421.1,435 422.5,433.5 423.8,432 L428.2,436.4 L419.7,444.9 L415.3,440.5 C416.8,439.2 418.2,437.8 419.7,436.4 L419.7,436.4 Z M431.7,435.7 L435.2,439.2 L422.5,452 L419,448.5 L431.7,435.7 L431.7,435.7 Z M422.5,454.8 L438.1,439.2 L438.8,438.5 L492.1,491.8 L475.1,508.8 L421.8,455.5 L422.5,454.8 L422.5,454.8 L422.5,454.8 Z M484.2,518 L476.4,510.2 L493.4,493.2 L501.2,501 L500.5,501.7 L485,517.3 L484.2,518 L484.2,518 Z\" id=\"Shape\" fill=\"#222228\"\u003E\u003C\u002Fpath\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#FFFFFF\" transform=\"translate(427.062990, 443.801670) rotate(-45.000000) translate(-427.062990, -443.801670) \" x=\"418.063076\" y=\"441.301694\" width=\"17.9998274\" height=\"4.99995205\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#FFFFFF\" transform=\"translate(495.919560, 512.704380) rotate(-45.000000) translate(-495.919560, -512.704380) \" x=\"486.919646\" y=\"510.204404\" width=\"17.9998274\" height=\"4.99995205\"\u003E\u003C\u002Frect\u003E\n\u003Cpath d=\"M239,360.7 C239,388.7 249.9,415.1 269.8,434.9 C310.7,475.8 377.4,475.8 418.3,434.9 C459.2,394 459.2,327.3 418.3,286.4 C397.8,265.9 370.9,255.7 344.1,255.7 C317.3,255.7 290.3,265.9 269.9,286.4 C249.9,306.3 239,332.7 239,360.7 L239,360.7 Z M411.4,293.3 C429.4,311.3 439.3,335.2 439.3,360.7 C439.3,386.2 429.4,410.1 411.4,428.1 C392.8,446.7 368.4,456 344,456 C319.6,456 295.2,446.7 276.6,428.1 C239.4,390.9 239.4,330.5 276.6,293.3 C313.8,256.2 374.2,256.2 411.4,293.3 L411.4,293.3 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M437.3,360.7 C437.3,335.8 427.6,312.3 410,294.7 C405.6,290.3 400.9,286.5 396,283.2 L396,426.2 L277.1,426.2 C277.4,426.2 277.7,426.6 278,426.9 C314.4,463.3 373.6,463.2 410,426.8 C427.6,409.2 437.3,385.7 437.3,360.7 L437.3,360.7 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M306.7,314.4 L276.7,344.4 C276.9,344.8 277,345.2 277,345.7 C277,347 276.2,348.1 275,348.5 L275,381.2 L307,381.2 L307,314.5 C306.9,314.5 306.8,314.5 306.7,314.4 L306.7,314.4 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M326,326.7 C326,326.4 326.1,326.1 326.1,325.9 L309.7,314.2 C309.5,314.4 309.2,314.5 309,314.6 L309,381.3 L328,381.3 L328,329.6 C326.8,329.2 326,328.1 326,326.7 L326,326.7 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M271,345.7 C271,345.5 271,345.2 271.1,345 L254.5,334 C250,349.4 249.5,366.2 253.1,381.2 L273,381.2 L273,348.5 C271.8,348.2 271,347.1 271,345.7 L271,345.7 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M331.7,325.5 C331.9,325.9 332,326.3 332,326.8 C332,328.1 331.2,329.2 330,329.6 L330,381.3 L355,381.3 L355,302.2 L331.7,325.5 L331.7,325.5 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M344,267.5 C320.1,267.5 296.2,276.6 278,294.8 C267.1,305.7 259.5,318.6 255.1,332.3 L272.1,343.4 C272.6,343 273.2,342.8 273.9,342.8 C274.4,342.8 274.8,342.9 275.2,343.1 L305.2,313.1 C305,312.7 304.9,312.3 304.9,311.8 C304.9,310.1 306.2,308.8 307.9,308.8 C309.6,308.8 310.9,310.1 310.9,311.8 C310.9,312.1 310.8,312.4 310.8,312.6 L327.2,324.3 C327.7,324 328.3,323.8 328.9,323.8 C329.4,323.8 329.8,323.7 330.2,323.9 L362.5,291.4 L355,291.4 L355,289.4 L366,289.4 L366,300.4 L364,300.4 L364,293.3 L356.4,300.4 L357,300.4 L357,381.4 L369,381.4 L369,383.4 L253.6,383.4 C257.3,398.4 264.5,412.4 275.2,424.4 L394,424.4 L394,282 C378.8,272.3 361.4,267.5 344,267.5 L344,267.5 Z\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M274,348.7 C273.6,348.7 273.3,348.6 273,348.5 L273,381.2 L275,381.2 L275,348.5 C274.7,348.7 274.4,348.7 274,348.7 L274,348.7 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M308,314.7 C307.6,314.7 307.3,314.6 307,314.5 L307,381.2 L309,381.2 L309,314.5 C308.7,314.7 308.4,314.7 308,314.7 L308,314.7 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M329,329.7 C328.6,329.7 328.3,329.6 328,329.5 L328,381.2 L330,381.2 L330,329.5 C329.7,329.7 329.4,329.7 329,329.7 L329,329.7 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpolygon id=\"Shape\" fill=\"#D8D8D8\" points=\"356.4 300.3 355 302.2 355 381.3 357 381.3 357 300.3\"\u003E\u003C\u002Fpolygon\u003E\n\u003Cpath d=\"M276.6,293.3 C239.4,330.5 239.4,390.9 276.6,428.1 C295.2,446.7 319.6,456 344,456 C368.4,456 392.8,446.7 411.4,428.1 C429.4,410.1 439.3,386.2 439.3,360.7 C439.3,335.2 429.4,311.3 411.4,293.3 C374.2,256.2 313.8,256.2 276.6,293.3 L276.6,293.3 Z M278,427 C277.7,426.7 277.4,426.3 277.1,426.3 L396,426.3 L396,283.3 C400.9,286.6 405.6,290.4 410,294.8 C427.6,312.4 437.3,335.9 437.3,360.8 C437.3,385.7 427.6,409.3 410,426.9 C373.6,463.2 314.4,463.4 278,427 L278,427 Z M394,424.3 L275.2,424.3 C264.4,412.3 257.2,398.3 253.6,383.3 L369,383.3 L369,381.3 L357,381.3 L355,381.3 L330,381.3 L328,381.3 L309,381.3 L307,381.3 L275,381.3 L273,381.3 L253.1,381.3 C249.5,366.3 250,349.5 254.5,334.1 C254.7,333.4 254.9,332.9 255.1,332.2 C259.5,318.5 267.1,305.6 278,294.7 C296.2,276.5 320.1,267.4 344,267.4 C361.4,267.4 378.8,272.3 394,281.9 L394,424.3 L394,424.3 Z\" id=\"Shape\" fill=\"#222228\"\u003E\u003C\u002Fpath\u003E\n\u003Cpolygon id=\"Shape\" fill=\"#B5B5B5\" points=\"188 368.7 189 369.3 237 369.3 237 367.3 190 367.3 190 307.3 188 307.3\"\u003E\u003C\u002Fpolygon\u003E\n\u003Cpath d=\"M221,236.5 C203.4,236.5 189,222.3 189,204.6 C189,196.1 192.3,188.1 198.4,182 C204.2,176.2 211.9,173 220,172.7 L220,205.1 L242.6,227.2 L245.4,227.2 L222,204.3 L222,170.2 L221,170.2 C211.9,170.2 203.4,174 197,180.4 C190.6,186.8 187,195.5 187,204.6 C187,223.3 202.3,238.4 221,238.4 C229.6,238.4 237.7,235.2 244,229.2 L241,229.2 C235.3,234.3 228.3,236.5 221,236.5 L221,236.5 Z\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M260,196.3 L261,195.3 C261,189.5 259.5,184.3 257,179.3 L254.7,179.3 C257.3,184.3 258.8,189.3 259,194.3 L228,194.3 L228,163.8 C238.6,164.1 247.9,169.3 253.4,177.3 L255.8,177.3 C249.8,168.3 239.1,161.5 227,161.5 L226,162.7 L226,195.7 L227,196.2 L260,196.2 L260,196.3 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M302,216.3 L302,210.3 L300,210.3 L300,212.3 L258.4,212.3 C259.6,209.3 260.5,205.2 261,201.4 L260,200.3 L227,200.3 L226.3,202.2 L249.6,225.7 L251.1,225.5 C253.8,222.4 256,219.3 257.7,214.3 L300,214.3 L300,216.3 L302,216.3 L302,216.3 Z M250.3,223.1 L229.4,202.2 L258.8,202.2 C258.3,206.2 257.4,209.2 256.2,212.2 L252.8,212.2 C252.4,211.2 250.8,209.4 248.9,209.4 C246.7,209.4 244.9,211.3 244.9,213.5 C244.9,215.7 246.7,217.3 248.9,217.3 C250.8,217.3 252.3,216.1 252.8,214.1 L255.4,214.1 C254.1,218.3 252.3,220.6 250.3,223.1 L250.3,223.1 Z M251,213.7 C251,214.8 250.1,215.7 249,215.7 C247.9,215.7 247,214.8 247,213.7 C247,212.6 247.9,211.7 249,211.7 C250.1,211.7 251,212.6 251,213.7 L251,213.7 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M356,225.3 L356,227.3 L245.4,227.3 L242.6,227.3 L222.9,227.3 C222.5,226.3 220.9,224.5 219,224.5 C216.8,224.5 215,226.4 215,228.6 C215,230.8 216.8,232.4 219,232.4 C220.9,232.4 222.4,231.2 222.9,229.2 L241,229.2 L244.1,229.2 L356.1,229.2 L356.1,231.2 L358.1,231.2 L358.1,225.2 L356,225.2 L356,225.3 Z M221,228.7 C221,229.8 220.1,230.7 219,230.7 C217.9,230.7 217,229.8 217,228.7 C217,227.6 217.9,226.7 219,226.7 C220.1,226.7 221,227.6 221,228.7 L221,228.7 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M245.9,177.3 C245.5,176.3 243.9,174.5 242,174.5 C239.8,174.5 238,176.4 238,178.6 C238,180.8 239.8,182.4 242,182.4 C243.9,182.4 245.4,181.2 245.9,179.2 L254.7,179.2 L257,179.2 L328,179.2 L328,181.2 L330,181.2 L330,175.2 L328,175.2 L328,177.2 L255.8,177.2 L253.4,177.2 L245.9,177.2 L245.9,177.3 Z M244,178.7 C244,179.8 243.1,180.7 242,180.7 C240.9,180.7 240,179.8 240,178.7 C240,177.6 240.9,176.7 242,176.7 C243.1,176.7 244,177.6 244,178.7 L244,178.7 Z\" id=\"Shape\" fill=\"#D8D8D8\"\u003E\u003C\u002Fpath\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(434.572990, 451.276270) rotate(-45.000000) translate(-434.572990, -451.276270) \" x=\"422.973101\" y=\"450.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(439.572990, 456.276270) rotate(-45.000000) translate(-439.572990, -456.276270) \" x=\"427.973101\" y=\"455.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(444.572890, 461.276270) rotate(-45.000000) translate(-444.572890, -461.276270) \" x=\"432.973001\" y=\"460.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(449.572790, 466.276270) rotate(-45.000000) translate(-449.572790, -466.276270) \" x=\"437.972901\" y=\"465.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(454.572790, 471.276270) rotate(-45.000000) translate(-454.572790, -471.276270) \" x=\"442.972901\" y=\"470.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(459.572690, 476.276270) rotate(-45.000000) translate(-459.572690, -476.276270) \" x=\"447.972801\" y=\"475.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(464.572590, 481.276270) rotate(-45.000000) translate(-464.572590, -481.276270) \" x=\"452.972701\" y=\"480.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(469.572590, 486.276270) rotate(-45.000000) translate(-469.572590, -486.276270) \" x=\"457.972701\" y=\"485.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(474.572490, 491.276270) rotate(-45.000000) translate(-474.572490, -491.276270) \" x=\"462.972601\" y=\"490.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#E3E5E7\" transform=\"translate(479.572390, 496.276270) rotate(-45.000000) translate(-479.572390, -496.276270) \" x=\"467.972501\" y=\"495.27628\" width=\"23.1997775\" height=\"1.99998082\"\u003E\u003C\u002Frect\u003E\n\u003Cpath d=\"M271,345.7 C271,347 271.8,348.1 273,348.5 C273.3,348.6 273.6,348.7 274,348.7 C274.4,348.7 274.7,348.6 275,348.5 C276.2,348.1 277,347 277,345.7 C277,345.2 276.9,344.8 276.7,344.4 L306.7,314.4 C306.8,314.4 306.9,314.5 307,314.5 C307.3,314.6 307.6,314.7 308,314.7 C308.4,314.7 308.7,314.6 309,314.5 C309.3,314.4 309.5,314.3 309.7,314.1 L326.1,325.8 C326,326.1 326,326.3 326,326.6 C326,327.9 326.8,329 328,329.4 C328.3,329.5 328.6,329.6 329,329.6 C329.4,329.6 329.7,329.5 330,329.4 C331.2,329 332,327.9 332,326.6 C332,326.1 331.9,325.7 331.7,325.3 L355,302 L356.4,300.6 L364,293 L364,300.1 L366,300.1 L366,289.1 L355,289.1 L355,291.1 L362.6,291.1 L330.3,323.6 C329.9,323.4 329.5,323.4 329,323.4 C328.4,323.4 327.8,323.7 327.3,324 L310.9,312.3 C311,312 311,311.8 311,311.5 C311,309.8 309.7,308.5 308,308.5 C306.3,308.5 305,309.8 305,311.5 C305,312 305.1,312.4 305.3,312.8 L275.3,342.8 C274.9,342.6 274.5,342.5 274,342.5 C273.3,342.5 272.7,342.7 272.2,343.1 L255.2,332 C255,332.7 254.8,333.3 254.6,334 L271.2,344.8 C271,345.3 271,345.5 271,345.7 L271,345.7 Z\" id=\"Shape\" fill=\"#EB5424\"\u003E\u003C\u002Fpath\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#B5B5B5\" x=\"278\" y=\"171.3\" width=\"45\" height=\"2\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#B5B5B5\" x=\"319\" y=\"221.3\" width=\"32\" height=\"2\"\u003E\u003C\u002Frect\u003E\n\u003Crect id=\"Rectangle-path\" fill=\"#B5B5B5\" x=\"276\" y=\"206.3\" width=\"19\" height=\"2\"\u003E\u003C\u002Frect\u003E\n\u003Ccircle id=\"Oval\" fill=\"#FFFFFF\" cx=\"249\" cy=\"213.7\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\n\u003Ccircle id=\"Oval\" fill=\"#FFFFFF\" cx=\"242\" cy=\"178.7\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\n\u003Ccircle id=\"Oval\" fill=\"#FFFFFF\" cx=\"219\" cy=\"228.7\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\n\u003Cpath d=\"M176.08325,412.742999 L176.08325,459.567608 C176.08325,470.616704 167.127495,479.573767 156.077972,479.573767 L124.712452,479.573767 C115.323991,479.573767 107.71314,487.180786 107.71314,496.583308 L107.71314,513.005214\" id=\"line-connect-6\" stroke=\"#44C7F4\" stroke-width=\"2\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M222.037646,415.324611 L222.037646,552.087592 C222.037646,566.442252 233.674464,578.079003 246.720716,578.079003 L246.720716,578.079003 L246.762961,578.079003 C261.122015,578.079003 272.762329,566.447823 272.762329,552.074709 L272.762329,541.819397 C272.762329,533.536142 279.475861,526.821237 287.761837,526.821237 L297.331126,526.821237\" id=\"line-connect-5\" stroke=\"#44C7F4\" stroke-width=\"2\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M385.349068,243.492113 L429.435614,243.492113 C441.031102,243.492113 450.431103,234.092514 450.431103,222.483617 L450.431103,199.55107 C450.431103,190.711475 457.600572,183.545567 466.436768,183.545567 L473.02311,183.545567 C481.862795,183.545567 489.028776,190.712223 489.028776,199.548182 L489.028776,293.094303 L489.028776,321.441797 C489.028776,331.937289 497.544845,340.445567 508.030726,340.445567 L525.846354,340.445567\" id=\"line-connect-4\" stroke=\"#44C7F4\" stroke-width=\"2\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M156,235 L90,235\" id=\"line-connect-3\" stroke=\"#44C7F4\" stroke-width=\"2\" stroke-linecap=\"square\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M218.975684,142.030594 L218.975684,142.030594 C218.975684,129.733565 229.281654,119.764854 241.972789,119.764854 L451.318233,119.764854 C464.019184,119.764854 474.315339,109.461589 474.315339,96.773072 L474.315339,89.3192518 C474.315339,76.6212412 464.017707,66.3274697 451.322599,66.3274697 L363.777337,66.3274697 C351.078798,66.3274697 340.784597,56.0305162 340.784597,43.3325527 L340.784597,32.2775049\" id=\"line-connect-2\" stroke=\"#44C7F4\" stroke-width=\"2\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M156.795219,196.745374 L128.036617,196.380759 C115.330592,196.219667 105.061936,185.800587 105.101021,173.080321 L105.278565,115.299067 C105.322697,100.936541 93.7162607,89.1880479 79.353486,89.0580607 L60.9656879,88.8916458 C49.9205593,88.7916841 40.9667135,79.7494607 40.9667135,68.7122453 L40.9667135,68.2908854 C40.9667135,55.0390166 51.7207905,44.2962543 64.9697999,44.2962543 L131.422802,44.2962543\" id=\"line-connect-1\" stroke=\"#44C7F4\" stroke-width=\"2\"\u003E\u003C\u002Fpath\u003E          \n\u003C\u002Fg\u003E\n\u003Cg id=\"mixpanel-logo\" transform=\"translate(306.000000, 509.000000)\" fill=\"#B5B5B5\"\u003E\n\u003Cg transform=\"translate(0.179798, 21.551789)\" id=\"Oval\"\u003E\n\u003Cellipse cx=\"3.89568283\" cy=\"3.8983383\" rx=\"3.86565656\" ry=\"3.89381061\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse cx=\"17.849804\" cy=\"3.94089856\" rx=\"2.73418788\" ry=\"2.7541013\"\u003E\u003C\u002Fellipse\u003E\n\u003Cellipse cx=\"29.3523797\" cy=\"3.94089856\" rx=\"1.24132525\" ry=\"1.25036598\"\u003E\u003C\u002Fellipse\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"Shape\"\u003E\n\u003Cpath d=\"M17.2931495,17.2919602 C16.6135131,17.2919602 16.1100788,16.7596853 16.1100788,16.100273 L16.1100788,11.0292639 C16.1100788,9.27976568 15.2794121,7.93594825 13.416705,7.93594825 C11.553998,7.93594825 10.4212707,9.38118588 10.4212707,11.0548 L10.4212707,16.100273 C10.4212707,16.7596853 9.96817979,17.2919602 9.2382,17.2919602 C8.53339191,17.2919602 8.05512929,16.7596853 8.05512929,16.100273 L8.05512929,11.0292639 C8.05512929,9.27976568 7.14894748,7.93594825 5.2862404,7.93594825 C3.3731899,7.93594825 2.36632121,9.38118588 2.36632121,11.0548 L2.36632121,16.100273 C2.36632121,16.7596853 1.88805859,17.2919602 1.1832505,17.2919602 C0.503434344,17.2919602 0,16.7596853 0,16.100273 L0,7.09923174 C0,6.38929045 0.453090908,5.88218954 1.18307071,5.88218954 C1.98856566,5.88218954 2.36614141,6.44000055 2.36614141,7.09923174 L2.36614141,7.91059321 C3.04577778,6.56677578 4.43022222,5.78076936 5.91535354,5.78076936 C7.72771717,5.78076936 9.0869899,6.69355101 9.76662627,8.03736844 C10.7483232,6.51606568 12.1831111,5.78076936 13.970303,5.78076936 C17.0160808,5.78076936 18.4760403,7.88523817 18.4760403,10.8517785 L18.4760403,16.1000919 C18.4758606,16.7596853 17.9979576,17.2919602 17.2931495,17.2919602 L17.2931495,17.2919602 L17.2931495,17.2919602 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M21.7988868,1.36899137 C22.5540384,1.36899137 23.1833314,2.00286751 23.1833314,2.7635189 C23.1833314,3.52417027 22.5540384,4.15804642 21.7988868,4.15804642 C21.0437354,4.15804642 20.4144424,3.52417027 20.4144424,2.7635189 C20.4144424,2.00286751 21.0437354,1.36899137 21.7988868,1.36899137 L21.7988868,1.36899137 L21.7988868,1.36899137 Z M21.7988868,17.2919602 C21.0940788,17.2919602 20.6158162,16.7596853 20.6158162,16.100273 L20.6158162,7.07387669 C20.6158162,6.4146455 21.1192505,5.88218954 21.7988868,5.88218954 C22.4785233,5.88218954 22.9819576,6.4146455 22.9819576,7.07387669 L22.9819576,16.100273 C22.9815979,16.7596853 22.503695,17.2919602 21.7988868,17.2919602 L21.7988868,17.2919602 L21.7988868,17.2919602 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M29.6519233,9.98970697 L32.6473576,6.23716017 C32.8487314,6.00896477 33.1004486,5.88218954 33.4276809,5.88218954 C34.0821455,5.88218954 34.5100646,6.31322532 34.5100646,6.92174642 C34.5100646,7.14994182 34.4345495,7.37813725 34.2331757,7.60633266 L30.9356809,11.5617198 L34.2835191,15.5422809 C34.4597212,15.7451213 34.560408,15.9479616 34.560408,16.2522222 C34.560408,16.8357505 34.0569738,17.2917791 33.503196,17.2917791 C33.150792,17.2917791 32.8739031,17.1650038 32.6725293,16.9110912 L29.6519233,13.1335516 L26.6313172,16.9110912 C26.4299434,17.1644605 26.1530545,17.2917791 25.8006505,17.2917791 C25.2468727,17.2917791 24.7434384,16.8352071 24.7434384,16.2522222 C24.7434384,15.9479616 24.8441252,15.7451213 25.0203273,15.5422809 L28.3681656,11.5617198 L25.0706707,7.60651376 C24.8692969,7.37795613 24.7937818,7.14994182 24.7937818,6.92192753 C24.7937818,6.31340642 25.221701,5.88237064 25.8761656,5.88237064 C26.2033979,5.88237064 26.4551151,6.00914588 26.6564889,6.23734129 L29.6519233,9.98970697 L29.6519233,9.98970697 L29.6519233,9.98970697 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M42.5650141,17.3935615 C40.8785092,17.3935615 39.4940646,16.5064971 38.6885698,15.2132086 L38.6885698,20.8420289 C38.6885698,21.5014411 38.2103071,22.0333538 37.505499,22.0333538 C36.8006908,22.0333538 36.3224283,21.50126 36.3224283,20.8420289 L36.3224283,7.07387669 C36.3224283,6.4146455 36.7251757,5.88218954 37.4551556,5.88218954 C38.1851354,5.88218954 38.6130545,6.44000055 38.6130545,7.09923174 L38.6130545,7.96166551 C39.3682061,6.64320313 40.8785092,5.78113158 42.5650141,5.78113158 C45.4597616,5.78113158 47.8259031,8.21485375 47.8259031,11.5874371 C47.8259031,15.0860712 45.4597616,17.3935615 42.5650141,17.3935615 L42.5650141,17.3935615 L42.5650141,17.3935615 Z M42.0869314,7.75864404 C40.0480222,7.75864404 38.6887495,9.55849009 38.6887495,11.587256 C38.6887495,13.6160219 40.0480222,15.4158679 42.0869314,15.4158679 C44.1258403,15.4158679 45.4597616,13.8693912 45.4597616,11.587256 C45.4597616,9.30530185 44.1256606,7.75864404 42.0869314,7.75864404 L42.0869314,7.75864404 L42.0869314,7.75864404 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M60.3110748,16.100273 C60.3110748,16.7596853 59.8579838,17.2919602 59.128004,17.2919602 C58.423196,17.2919602 57.9704646,16.7596853 57.9704646,16.100273 L57.9704646,15.542462 C57.2656566,16.607374 55.9315556,17.3935615 54.2957535,17.3935615 C50.7709939,17.3935615 48.7326243,14.8075279 48.7326243,11.5870749 C48.7326243,8.41769413 50.9984384,5.78076936 54.5472908,5.78076936 C58.1720182,5.78076936 60.3117939,8.16414367 60.3117939,11.5870749 L60.3117939,16.100273 L60.3110748,16.100273 L60.3110748,16.100273 L60.3110748,16.100273 Z M54.5215797,7.80917302 C52.5076627,7.80917302 51.0980465,9.50832331 51.0980465,11.5870749 C51.0980465,13.7676088 52.2811172,15.3649767 54.5215797,15.3649767 C56.6106526,15.3649767 57.9447535,13.5647684 57.9447535,11.5870749 C57.9447535,9.25441065 56.5353172,7.80917302 54.5215797,7.80917302 L54.5215797,7.80917302 L54.5215797,7.80917302 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M67.4348505,5.78113158 C70.4804486,5.78113158 72.7205514,8.11379579 72.7205514,11.0803362 L72.7205514,16.1004541 C72.7205514,16.7600475 72.1921252,17.2921413 71.5374809,17.2921413 C70.883196,17.2921413 70.3544101,16.7600475 70.3544101,16.1004541 L70.3544101,10.8012495 C70.3544101,9.20388165 69.0958243,7.96148441 67.4348505,7.96148441 C65.7735172,7.96148441 64.5397434,9.20351943 64.5397434,10.8012495 L64.5397434,16.1004541 C64.5397434,16.7600475 64.0113172,17.2921413 63.3566727,17.2921413 C62.7023879,17.2921413 62.1736021,16.7600475 62.1736021,16.1004541 L62.1736021,11.0801551 C62.1736021,8.11361469 64.3887132,5.78113158 67.4348505,5.78113158 L67.4348505,5.78113158 L67.4348505,5.78113158 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M85.0293415,11.6124299 C85.0293415,12.0181106 84.802796,12.4237914 84.1233394,12.4237914 L76.5971757,12.4237914 C76.7228545,14.1732895 77.9059252,15.4915708 79.9949979,15.4915708 C81.3041071,15.4915708 82.0844302,15.0349989 82.9149172,14.2491736 C83.1164707,14.0463332 83.3931797,13.8684857 83.6952403,13.8684857 C84.2236667,13.8684857 84.6771172,14.2491736 84.6771172,14.8575136 C84.6771172,15.1107018 84.5510788,15.3388972 84.3750566,15.5417376 C83.4185314,16.6573596 81.706495,17.3930182 79.8944908,17.3930182 C76.1437252,17.3930182 74.1549797,14.7557312 74.1549797,11.5863504 C74.1549797,8.26483942 76.5464727,5.78004492 79.7932646,5.78004492 C82.9656203,5.78113158 85.0293415,8.36698403 85.0293415,11.6124299 L85.0293415,11.6124299 L85.0293415,11.6124299 Z M79.793804,7.68276001 C78.0569556,7.68276001 76.8738849,8.92479504 76.6473394,10.4971701 L82.8394021,10.4971701 C82.638208,8.97550514 81.505301,7.68276001 79.793804,7.68276001 L79.793804,7.68276001 L79.793804,7.68276001 Z\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M87.7982302,17.2919602 C87.0930627,17.2919602 86.6151597,16.7596853 86.6151597,16.100273 L86.6151597,1.19186826 C86.6151597,0.532274856 87.0934222,0.00018110747 87.7982302,0.00018110747 C88.5030384,0.00018110747 88.9809415,0.532274856 88.9809415,1.19186826 L88.9809415,16.100273 C88.981301,16.7596853 88.5030384,17.2919602 87.7982302,17.2919602 L87.7982302,17.2919602 L87.7982302,17.2919602 Z\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fg\u003E\n\u003Cg id=\"elephant-logo\" transform=\"translate(529.000000, 318.000000)\"\u003E\n\u003Cpolyline fill=\"#F8F8F8\" points=\"25.9544747 11.4254319 21.3184047 12.1713723 17.0884436 14.0083009 13.4955642 16.2466615 10.0764591 20.379144 8.14505836 22.4054579 6.27712061 23.0874604 5.78330739 21.8915279 6.64700389 20.6567471 6.84093386 18.9153204 7.41945526 18.9385214 8.05163425 19.5096446 7.88112842 17.7355746 7.18031128 17.2699352 7.20182879 16.5938677 5.54198444 17.5240674 4.03902723 19.2806018 3.72525292 20.8504488 4.36832684 22.1076213 4.967821 24.2431958 6.18696498 24.8148586 7.46957198 24.7525396 8.68571985 24.0527315 7.87431906 28.1280206 8.68571985 32.6622051 7.79260699 34.7559637 4.86758754 37.8773127 5.38754863 39.7422984 6.77338523 41.903232 9.38599222 43.7242439 10.7718288 43.9122802 12.3126459 43.9640779 11.3511673 47.8726433 14.8863035 49.3073309 19.2903113 49.8814214 20.7968093 48.9058987 20.9128405 46.265297 22.5936576 43.5103086 22.7094164 41.3291415 26.7658755 41.6161869 30.5325292 41.2719483 26.7658755 43.5103086 27.4035018 46.2081038 29.7791441 49.8814214 32.0973152 50.8572139 33.9516343 50.1110039 34.7047471 48.6188536 38.5874319 45.6914759 39.340817 46.32276 45.425642 46.5523424 46.6423346 45.5768197 46.7580933 43.8545472 46.3528015 43.1088767 46.0627237 38.4594968 44.0346304 34.4416705 44.3824514 32.6622051 45.5991441 33.2937589 49.0182489 36.4504487 50.6987939 36.5653749 52.5531128 35.8191646 54.4077043 34.4416705 55.3345915 31.4568302 60.7820623 31.8013386 64.0851362 30.5387704 66.7508559 28.0705577 68.6631906 24.5118962 69.1264982 20.3219507 68.7209338 15.4429883 67.6780155 11.0811933 66.6348249 9.70369909 65.1863425 9.2442646 62.6363814 11.9992529 60.3184824 12.8029261 58.2901167 9.47384696 56.2620234 7.63718805 55.160817 6.94844099 50.7565371 3.33231646 47.2219456 1.43819455 43.6868094 1.15141894 39.572607 1.84016602 35.9797277 3.15992736 33.4877821 5.16897536 31.5177043 7.52226199 29.4896109 8.09635279 25.9544747 11.4254319\"\u003E\u003C\u002Fpolyline\u003E\n\u003Cpath d=\"M12.5090272,21.7844254 C8.53809338,26.3720259 9.42031128,31.9356887 10.5207004,37.3871233 C9.93346304,35.9170947 9.34595331,34.4470661 8.75871596,32.977847 C8.542179,31.6302984 8.32564204,30.2827498 8.10937745,28.9352009 C8.17120623,27.5571674 8.23276264,26.1794034 8.2948638,24.8016394 C8.85132295,23.4851154 9.4077821,22.1683217 9.96424125,20.8515279 C10.7987938,19.6267289 11.6336187,18.4019299 12.4684436,17.1768612 C13.7668482,16.105297 15.0655253,15.033463 16.36393,13.9618988 C17.7857198,13.3799844 19.2080545,12.7983398 20.6301167,12.2164254 C22.2994942,12.0022205 23.9688716,11.7880156 25.6385214,11.5735408 C24.0925292,13.3187445 22.5468093,15.0642179 21.0010895,16.8094215 C17.2774708,18.0056239 15.0818677,18.8114552 12.5090272,21.7844254\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M31.2031128,7.80687938 C28.442607,10.4747289 26.9344747,12.4867445 25.1776654,15.6102516 C23.9212062,17.8448353 22.5114008,19.9968664 21.1901167,22.2001556 C20.5219844,23.3154241 20.4587938,24.2504799 20.2588716,25.5365188 C19.6098054,24.7711543 18.9607393,24.0055201 18.3114008,23.2401556 C18.6208171,22.3212866 18.9296887,21.4026874 19.2388327,20.4840882 C20.2899222,18.6161349 21.341284,16.7481816 22.3923735,14.880498 C24.6182101,12.706345 26.8443191,10.5324617 29.0701556,8.3583087 C29.7810505,8.17431907 30.4922179,7.99086901 31.2031128,7.80687938\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M44.8370429,1.19296498 C42.625642,2.01390402 38.9537745,2.28449287 38.6991052,4.79802854 C38.5177043,6.58315954 38.8350195,7.48017638 39.921245,9.36890273 C37.2380933,6.61850066 36.5745915,7.04421272 31.3885991,7.89887418 C32.130817,6.85779507 32.8727626,5.81671596 33.6144359,4.77563683 C34.9128404,3.97924773 36.2115176,3.18312841 37.5099222,2.38700908 C39.1792997,2.01956939 40.8489495,1.6521297 42.5183268,1.28469001 C43.2910505,1.25420493 44.0640468,1.22371984 44.8370429,1.19296498\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M50.93821,35.1935461 C51.6741635,35.6435384 51.6583657,35.9697016 51.5352529,36.2780597 C52.1159532,36.0479378 52.6966538,35.8178159 53.2770818,35.5882334 C53.6535018,35.0877925 54.0293775,34.5876212 54.4057976,34.0871803 C54.6849805,33.374153 54.9641635,32.6616653 55.2433462,31.948638 C54.8865371,31.6829053 54.53,31.4171726 54.1729182,31.1514396 C52.6135796,31.3483787 51.0542413,31.5455877 49.4946304,31.7430661 C49.3788717,32.0549312 49.2625681,32.3673358 49.1462647,32.6797407 C49.1794942,33.1232582 49.2129961,33.5670454 49.2459532,34.0105629 C49.395214,34.2735979 49.5447471,34.5363631 49.6940079,34.7993983 C49.9263425,34.9143242 50.1584046,35.0295202 50.3907392,35.1444462 C50.5735018,35.1606328 50.7557198,35.1773592 50.93821,35.1935461\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M50.5026848,27.2690427 C48.1575486,27.9394448 48.1757976,28.1242439 47.483424,30.4287005 C48.3975097,28.9759378 49.074358,28.2426771 50.5026848,27.2690427\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M66.0952529,10.0250065 C65.6785213,10.2157406 65.2724125,10.3074656 65.0120234,10.685157 C64.4509337,11.4982724 63.9701945,12.1821634 63.0424903,12.7527471 C62.5750973,13.040332 62.0919067,13.2264799 61.5964593,13.3797146 C61.1854474,13.5062412 60.9384046,13.3929339 60.5886769,13.6422101 C60.7962255,13.677821 61.0037745,13.7139715 61.2113231,13.7498521 L62.5840857,13.7498521 C63.1481711,13.4048042 63.7122568,13.0597562 64.2763425,12.714978 C64.6083657,12.3696602 64.9401167,12.0246122 65.2718678,11.6795642 C65.5461477,11.1281349 65.8207003,10.576166 66.0952529,10.0250065\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M28.7405836,15.1794137 C27.8180544,17.68 27.0118288,19.8233982 25.6145525,22.087118 C27.4051362,20.176 28.490817,18.5516576 29.516576,16.3909935 C29.9150584,15.5517095 29.9902334,14.5667445 31.1001556,14.9328353 C31.15,15.77131 31.3289495,16.6089754 31.3785213,17.4469105 C31.9782879,13.1897899 33.669183,11.4092451 37.5998055,9.75684566 C36.4882489,9.88849805 35.3766927,10.0198807 34.2654085,10.1512633 C33.2200389,10.3813852 32.1749416,10.6115071 31.129572,10.8413593 C30.6153307,11.5808249 30.100817,12.3205603 29.5868483,13.0597562 C29.3046693,13.7663087 29.0227626,14.4728612 28.7405836,15.1794137\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M36.3553307,15.0809442 C37.2032295,19.0324047 38.4237353,22.824965 38.9537745,26.839284 C39.2980544,29.447782 39.335642,30.7009078 38.010817,32.9514085 C36.562607,32.8586045 35.6635018,33.0202023 34.2626848,33.4750506 C28.6866538,35.2855409 25.4884436,37.947725 21.7310506,32.5836991 C22.9305836,33.1434916 24.1301167,33.7032841 25.3296498,34.2633463 C26.1846304,34.0968924 27.0396109,33.9307082 27.8945915,33.7637146 C29.404358,32.8931362 30.9141246,32.0220182 32.4238912,31.1514396 C33.6016343,30.9213176 34.7796498,30.691196 35.957393,30.461074 C36.3389884,28.883943 36.7205836,27.3062725 37.102179,25.7288716 C36.82,23.6418573 36.537821,21.5551128 36.2559143,19.4680986 C36.2229571,18.4823242 36.1897277,17.4965499 36.1564982,16.5105058 C36.2229571,16.0338054 36.2894164,15.5573748 36.3553307,15.0809442\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M45.9611283,39.5316006 C45.4926459,42.7419766 47.0397277,44.4677561 46.3991052,45.3545213 C46.2177043,45.6054165 45.9720234,46.0435384 45.6977432,46.1638599 C44.7174708,46.5925395 43.3697666,46.0834657 43.2736186,46.3343606 L40.038638,46.3343606 C39.6071985,46.1536083 39.176031,45.972856 38.7445915,45.7921038 C39.4080933,45.019725 40.0715954,44.2473463 40.7353696,43.4752373 C41.3822568,42.0788585 42.0294164,40.6819403 42.6763036,39.285022 C43.0911283,37.8719169 43.5059532,36.458812 43.9205058,35.0457069 L44.5676654,35.0457069 C45.0320623,36.5410947 45.4967316,38.0362128 45.9611283,39.5316006\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M40.5237353,30.1985786 C40.786576,31.6561971 41.2430739,32.002594 41.9351751,33.4135409 C41.4743191,35.7155695 40.7342802,38.453022 39.8433462,40.4841919 C39.4677432,41.3407418 39.1645915,41.8131258 38.5019067,42.4751646 C37.3838134,43.5936705 36.2534629,44.5675745 34.9852918,45.5371621 C34.0722957,46.2340025 33.435214,45.884638 32.3089495,45.7265472 C31.8298444,46.5866045 31.6977432,47.064384 30.8160699,47.5011569 C29.4601945,48.1723683 28.2470429,46.7258106 27.182607,45.8743865 C27.9509727,47.063035 28.7193386,48.2514137 29.4871596,49.4400622 C30.0182879,49.9332191 30.5491441,50.4255668 31.08,50.9187236 C31.5277821,50.9842802 31.9758365,51.050376 32.4238912,51.1162023 C33.0209337,50.7546978 33.6182489,50.3929235 34.2152918,50.0314189 C34.5307003,49.4400622 34.8458365,48.8484357 35.1609727,48.257079 C35.8247471,47.7639221 36.4885213,47.271035 37.1517511,46.7778781 C37.964786,46.0880518 38.777821,45.3976862 39.5905836,44.7075901 C40.1050973,43.9845811 40.6190662,43.2618417 41.1335796,42.5385629 C41.5979766,41.6841712 42.0623736,40.8297795 42.5267705,39.9753878 C43.124358,38.2007781 43.7214009,36.4258987 44.3189884,34.651559 C44.3685602,33.9776499 44.4181322,33.3040105 44.4679766,32.6301013 C43.7214009,32.3017795 42.9750973,31.9726485 42.2282489,31.644057 C41.6807781,31.1349832 41.0712061,30.7079221 40.5237353,30.1985786\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M22.6688327,40.468275 C25.1806615,40.468275 27.8335796,40.3301478 30.1343191,39.285022 C30.7852918,38.3178626 31.4280933,37.5276782 32.2245137,36.672747 C31.4997277,38.0289287 31.2722957,38.7956419 31.08,40.3204357 C30.8310505,40.6819403 30.5823736,41.0431751 30.333424,41.4049494 C28.4420623,41.4540493 26.5509728,41.5034189 24.6596109,41.5527886 C24.0456809,41.4866925 23.4320233,41.4211362 22.8180934,41.3555797 C22.7516343,41.2894839 22.6854475,41.2239273 22.6189883,41.158371 C22.6358755,40.9282491 22.6524903,40.6981272 22.6688327,40.468275\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M22.3204669,38.743035 C22.255642,38.1597718 22.1905447,37.5762386 22.1254475,36.9924357 C21.6964591,39.5510248 21.7994164,41.2660129 20.6105058,43.5580597 C19.7225681,44.5770168 18.6289883,45.5042491 17.3766148,46.0006433 C17.4825681,46.6289598 17.5141634,47.0220286 17.452607,47.4825422 C17.2319844,49.1397977 13.8850584,48.407616 12.5082101,48.3415202 C14.7174319,48.9050895 16.9261089,49.4681195 19.1350584,50.0314189 C19.6329572,49.83421 20.1303113,49.6372711 20.6282101,49.4400622 C20.794358,48.4872009 20.9602335,47.5338002 21.1261089,46.5809392 C21.5905058,45.7265472 22.0551751,44.871616 22.519572,44.0177638 C22.6023735,43.4914242 22.6854475,42.9661635 22.7685214,42.4400933 C22.6189883,41.2077407 22.47,39.9753878 22.3204669,38.743035\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M18.5875875,24.29931 C18.5184047,25.5435331 18.4372374,26.0620493 18.9909728,27.1608613 C19.6950584,28.55724 20.5598443,29.8697173 21.3249416,31.2499092 C21.4080156,30.3294214 21.4908171,29.4094734 21.5738911,28.4892554 C20.5786381,27.0923372 19.5831128,25.6959585 18.5875875,24.29931\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M8.37112842,33.697349 C8.15540857,34.1513878 7.94023346,34.6056964 7.72451362,35.0600052 C8.31747082,37.0382984 8.84478599,38.2914242 9.97377432,40.0196317 C9.77712061,40.7197093 9.63003891,41.0261789 9.17762647,41.5967627 C8.18400778,41.4456862 7.30151751,41.4017121 6.29455252,41.4049494 C7.40610894,42.2590713 8.51766538,43.1140025 9.62922179,43.9683942 C10.1764202,43.8693851 10.7241634,43.7709158 11.2716343,43.6724462 C11.8188327,43.1301894 12.3665759,42.5879326 12.9140467,42.0456758 C12.1342412,40.8459661 11.3544358,39.6467963 10.5749027,38.447087 C9.84003891,36.8640206 9.10544748,35.2804151 8.37112842,33.697349\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M66.1023346,9.37052139 C66.7794553,12.3869261 67.6526848,15.1707808 67.5715176,18.2602957 C67.4721012,22.0506978 66.7263425,26.8387445 63.1805836,29.1243165 C59.2096498,31.6842543 54.5482489,30.4734839 50.191362,29.3765604 C51.9666927,30.0998393 53.7420234,30.8225786 55.5168094,31.5455877 C57.1758365,31.6278704 58.8348638,31.710153 60.4938912,31.7918962 C61.6220623,31.4635745 62.7502334,31.1349832 63.8781322,30.8063917 C64.7573541,30.0831129 65.6368483,29.3603735 66.5160699,28.6370947 C67.179572,27.2569028 67.8430739,25.8767108 68.5068483,24.4965188 C68.7557976,22.9023917 69.0044748,21.3085344 69.2531517,19.714677 C69.0543191,18.153463 68.8549416,16.5925188 68.6561088,15.0315746 C68.2911283,13.4870869 67.9258754,11.9423295 67.5611672,10.3978418 C67.0749805,10.0552218 66.5887939,9.71287159 66.1023346,9.37052139\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M6.8436576,18.3611933 C5.04108948,19.5234034 4.3329183,20.0335564 4.53066149,22.187476 C4.71015565,22.8325188 4.88992219,23.4775616 5.06941635,24.1226044 C5.32408559,24.2933748 5.57848249,24.4638755 5.83287939,24.6343761 C6.14747082,24.7382412 6.46178988,24.8418366 6.77638134,24.9457017 C7.34536964,24.8124306 7.91435796,24.6788898 8.48307392,24.5453489 C8.77533073,23.6480623 9.06731517,22.7510454 9.35902723,21.8537588 C8.55062255,22.2468275 7.74194553,22.6398962 6.93354085,23.032965 L6.372179,23.032965 C6.16272374,22.7140856 5.95299611,22.3952062 5.74326848,22.0763268 C5.99793775,21.70538 6.25233462,21.3349727 6.50700389,20.9640259 C6.64182879,20.2596317 6.77638134,19.5552374 6.91120623,18.850843 C7.08334629,18.9026407 7.25548638,18.9547082 7.42762647,19.0062361 C7.63735407,19.1697224 7.84680933,19.332939 8.05653696,19.4956161 C8.02657587,19.1252088 7.99661477,18.754262 7.96665371,18.3835849 C7.82447471,18.1464488 7.68202334,17.9090428 7.53984435,17.6719066 C7.39766538,17.5529339 7.25548638,17.4345007 7.11330739,17.3157977 C7.02342413,17.6643528 6.93354085,18.0129079 6.8436576,18.3611933\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M47.2878599,1.38936446 C48.8877821,2.86101167 50.8513231,4.14003631 52.1312061,5.93838651 C52.6263814,6.63441764 53.176576,6.99052659 52.1227626,7.97387289 C53.2362255,7.65877044 53.6499611,7.69303242 54.5414398,7.7998651 C56.1628793,7.99437614 57.6827237,10.2775201 57.7794164,11.913463 C57.7603502,12.066428 57.329183,12.413904 56.0754474,12.7567938 C56.0506614,12.8045448 55.367821,12.6642594 55.3847082,12.7101219 C55.5151751,13.0629935 55.6892219,13.1172192 55.9550584,13.2823242 C56.0128015,13.6751232 56.0498444,14.2807782 56.3200389,14.7102672 C57.1088328,14.6962386 57.8799222,14.781489 58.6523736,14.9328353 C58.9122179,15.360166 58.8732684,15.787227 58.8514787,16.2145577 C59.15,16.1654579 59.4485213,16.1160882 59.7473152,16.0669883 C59.6645137,15.3930791 59.5814398,14.7194397 59.498638,14.0458002 C59.7639301,13.602013 60.0292219,13.1582257 60.294786,12.714978 C59.9131906,11.8600467 59.5315954,11.0059248 59.15,10.1512633 C58.4203113,9.46116733 57.6903502,8.77107135 56.9601167,8.08097536 C56.8901167,8.07746824 56.8192997,8.07396108 56.749572,8.07045395 C55.9283657,7.57136188 55.1077043,7.07253955 54.2867705,6.57344748 C52.9477821,5.4883943 51.6090663,4.4036109 50.2700778,3.31855772 C49.2759143,2.67540337 48.2820234,2.03251881 47.2878599,1.38936446\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M49.9829961,13.5353774 C49.8985602,13.6815979 49.7710894,13.915227 49.6079377,14.0770947 C50.2741635,14.7013645 50.6029182,15.1195227 50.8407003,16.002511 C50.0873152,16.3729183 49.3339301,16.7435953 48.580817,17.1137328 C47.9431906,17.719118 47.3055641,18.3245032 46.6684824,18.9296187 C45.8292997,18.4823242 45.6203891,18.1388949 45.2142802,17.2858521 C44.7414398,17.4099507 44.2936575,17.5291933 43.9030739,17.3872892 C44.1509337,17.3891777 44.3029182,17.3279377 44.5505058,17.1763217 C44.9560699,16.7589727 45.3619067,16.3416239 45.7674708,15.924275 C46.4838134,15.3868742 47.200428,14.8492036 47.9167705,14.3118029 C48.3857976,14.1604565 48.8545526,14.0091102 49.3235796,13.8577639 C49.5025292,13.7849235 49.8037745,13.6084877 49.9829961,13.5353774\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M52.0622957,15.7621375 C49.6656809,17.0403528 47.3701167,18.3258521 46.1447082,20.7533282 C46.1447082,17.6721764 49.2682879,16.315725 52.0622957,15.7621375\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M45.6688717,9.70073152 C43.889183,10.9025992 42.630817,13.3281868 42.7887939,15.6919948 C42.209183,13.6451777 42.4145526,11.7111284 44.1945137,10.2974838 C44.4949416,10.152882 44.7950973,10.0080104 45.0955252,9.86367834 C45.2867316,9.80945266 45.4776654,9.75522697 45.6688717,9.70073152\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M69.6186769,15.2813904 C69.295642,13.2655979 68.7607003,11.3088872 68.01821,9.90198704 C67.9277821,9.72986771 67.7905058,9.55559015 67.6205447,9.3891362 C67.2517511,9.02898054 66.705642,8.68797925 66.1415565,8.49589623 C65.5436964,8.29221272 64.913424,8.25066667 64.4130739,8.509655 C64.2831517,8.57709986 64.1624903,8.66396887 64.0549027,8.77215045 C63.7307781,9.09750454 63.4575875,9.49246174 63.1838523,9.88849805 C62.8793386,10.3293178 62.5731906,10.7722957 62.2068483,11.0820026 C61.7822179,11.4416187 61.250817,11.6598703 60.7496498,11.8592374 C60.5298444,11.3328975 60.2770818,10.8513411 59.991362,10.3991907 C59.6487158,9.85801296 59.2586769,9.35136705 58.8294164,8.84445136 C58.4785991,8.43087938 58.1373152,8.12009339 57.7679766,7.84168092 C57.397821,7.5619196 57.0189495,7.32640206 56.5774319,7.05284566 C55.3942413,6.31877561 54.3867316,5.4436109 53.3590663,4.55037093 C52.8922179,4.14462257 52.4204669,3.73509727 51.9590663,3.3582153 C49.5120623,1.35968872 47.2292997,0.390370947 44.7880155,0.238215305 C42.3633462,0.0871387809 39.803035,0.747019455 36.7802334,2.00742931 C35.3214009,2.61551232 34.2378988,3.33420493 33.2941246,4.1983087 C32.3925681,5.02464332 31.6271985,5.97561607 30.7858365,7.08629832 C30.2961088,7.12083009 29.8627626,7.19259144 29.4198833,7.36821789 C28.9320623,7.56138002 28.4409727,7.87432425 27.8526459,8.38879378 C27.4350973,8.7532659 27.0355253,9.12043581 26.6492996,9.4903035 C26.2875875,9.83670039 25.9364981,10.1893022 25.5903113,10.5456809 C22.838249,10.9835331 20.59607,11.466978 18.5881323,12.2374682 C16.5347082,13.0252244 14.7245136,14.1091984 12.8652918,15.7421738 C12.105642,16.4090687 11.4481323,17.1140026 10.872607,17.8607523 C10.3071595,18.5942827 9.82315176,19.3655824 9.3985214,20.1789676 C9.02645915,20.5866044 8.6541245,20.9980182 8.2507393,21.357904 C7.85743191,21.7086174 7.43824903,22.0040259 6.96867705,22.1831595 L6.96894942,22.1834293 C6.69575875,22.2875642 6.58272374,22.3485344 6.57046693,22.3444877 C6.55684824,22.3369339 6.54922179,22.2964669 6.52988328,22.221738 C7.20455252,21.5839792 7.31050584,20.6473048 7.37287939,19.7171051 C7.45377432,19.8131466 7.53167316,19.93131 7.61229571,20.0545992 C7.70136186,20.1908379 7.79260699,20.331393 7.90210116,20.4681712 L8.35996109,21.0403735 L8.52093386,20.326537 C8.65603113,19.7284358 8.7570817,18.9317769 8.59964982,18.2411414 C8.4977821,17.7930376 8.2877821,17.3934942 7.92198444,17.1104955 C7.95712061,17.0198495 7.99007781,16.9364877 8.02276264,16.8542049 C8.13770429,16.5631128 8.25591441,16.2644669 8.35642024,15.9822776 L8.55470818,15.4227549 L7.96420234,15.524192 C7.17840468,15.6593515 5.48941635,16.5787601 4.30023346,17.801131 C3.85844359,18.2551699 3.47875486,18.7569598 3.22953307,19.2835694 C2.97023346,19.8314916 2.85420234,20.404773 2.95470818,20.978594 C3.04241246,21.4801141 3.29571985,21.972192 3.75603113,22.4367523 C3.83992219,22.7715486 3.91727626,23.0621012 4.00007781,23.3243268 C4.0948638,23.622703 4.19700389,23.8895149 4.32474708,24.1520104 C4.67093386,24.8650376 5.22276264,25.3004617 5.86120623,25.5036057 C6.37463036,25.6668223 6.94225681,25.6749157 7.49898833,25.5543242 C7.39031128,26.1775149 7.32167316,26.8290324 7.29498055,27.5407107 C7.25984435,28.4711803 7.29416343,29.4990402 7.39766538,30.6917355 C7.42027237,30.9534214 7.45431906,31.2415461 7.49844359,31.5544902 C7.53657587,31.821572 7.58206225,32.0837977 7.63108948,32.3441349 C7.5270428,32.6252452 7.42245137,32.9068949 7.31813231,33.1880052 C7.15607003,33.6245084 6.99400778,34.0615513 6.8322179,34.4980545 C6.47568094,34.8479584 6.11914398,35.1978626 5.76287939,35.5474968 C5.43031128,35.8731206 5.09747082,36.1998236 4.76490273,36.5262568 C4.73739301,36.5535045 4.62517511,36.6600674 4.52357976,36.757188 C3.84945526,37.3995332 3.71599222,37.5271387 3.90747082,38.6577847 C4.02431906,39.3505786 4.25447471,40.0525447 4.61373541,40.7294214 C4.94466927,41.3536914 5.38863814,41.9615045 5.95844359,42.5275021 C6.66961088,43.233515 7.83482489,44.1102984 9.05478599,44.569463 C9.75206225,44.8319584 10.470856,44.9601038 11.1452529,44.8530014 C11.1109339,44.9557872 11.0774319,45.0583036 11.039572,45.1618987 C10.9333463,45.4524514 10.8148638,45.7432736 10.6838521,46.027891 C9.85638134,47.8248924 10.7059144,48.7631855 12.0282879,49.3604773 C12.6885214,49.6585835 13.4735019,49.8609182 14.2029183,50.0494941 C14.352179,50.0875332 14.5014397,50.1263812 14.6893774,50.1765604 C15.5538911,50.4080311 17.0470428,50.8329339 18.4108171,50.9181841 C19.8993385,51.0115279 21.2418677,50.7072166 21.6016732,49.3836782 C21.7441245,48.8592271 21.8269261,48.4572554 21.860428,48.0639169 C21.8914786,47.6989053 21.8794942,47.329847 21.8364591,46.8733801 C22.2608171,45.9418313 22.440856,45.6798756 22.7510895,45.2304228 C22.8118288,45.1416653 22.8853696,45.0353721 22.9074319,45.0019196 C23.2402724,44.5136188 23.39607,44.1669521 23.4527237,43.7765811 C23.5071984,43.3999689 23.4611673,43.0247055 23.3922568,42.4508847 C23.3857198,42.3963892 23.375642,42.316804 23.3614786,42.2115901 C24.2328016,42.3221998 25.0918677,42.3815513 25.9460311,42.3869469 C26.3796498,42.3896446 26.8129961,42.376965 27.2463424,42.3543036 C27.1357588,42.4106873 27.0270817,42.466262 26.9083268,42.5266925 C26.8557588,42.5534008 26.8015564,42.581188 26.7470817,42.6089752 C25.5976654,43.1943969 25.5497276,44.3034605 25.9095331,45.4443581 C26.23393,46.473297 26.9015175,47.5238183 27.320428,48.162926 C28.2010116,49.5069675 29.0412842,50.6446279 30.0599611,51.2629623 C31.1279377,51.9112425 32.3478988,51.9875901 33.9227626,51.14345 C34.7238134,50.7136914 34.976576,50.2758392 35.3167705,49.6855615 C35.420817,49.505349 35.5357587,49.3089494 35.6635018,49.1152477 C35.9947082,48.8980751 36.8183657,48.2252452 37.6270429,47.5629364 C37.9021401,47.3376705 38.1772374,47.1132139 38.4877432,46.8628585 C38.7015565,47.0185213 38.9597666,47.126703 39.2716343,47.2003529 C39.6769261,47.2963942 40.159572,47.3398288 40.737821,47.3808354 C41.1706225,47.4123994 42.5820623,47.4113204 43.493969,47.4110506 C43.775603,47.4110506 44.009572,47.4110506 44.1498444,47.4118599 C45.0911672,47.4175252 45.8510894,47.3684255 46.4252529,47.0463086 C47.0372763,46.7026097 47.4000778,46.0939871 47.4793386,45.0024591 C47.5139301,44.5176653 47.5201945,44.2187498 47.4523736,43.9133592 C47.3889106,43.6273931 47.2649805,43.3684046 47.0522568,42.9890947 C47.0394553,42.5175202 47.0266538,42.0456757 47.0141246,41.5741013 C47.0007781,41.0736601 46.9868872,40.5729494 46.9735407,40.0727781 C46.9574708,39.4827704 46.8918289,39.0036419 46.7708948,38.5320674 C46.6510505,38.0637302 46.48,37.6131985 46.2509338,37.0728302 C46.0956809,36.7072788 45.9698444,36.3714032 45.8467316,36.0420025 L45.5163425,36.1617847 L45.5672763,36.1431698 L45.8467316,36.0420025 L45.8467316,36.0406537 C45.6498055,35.5145835 45.455603,35.0025422 45.1837745,34.4546199 C45.2014787,34.3488665 45.219183,34.2352893 45.2363425,34.1138885 C45.4112061,34.2811517 45.5863425,34.4481453 45.7612061,34.614869 L46.5350195,35.3535252 C47.1252529,35.9165552 47.6648249,36.4285967 48.298638,36.7987341 C48.953969,37.1818211 49.6910116,37.4041195 50.6454085,37.3593358 C51.6444748,37.3126642 52.7135407,36.8958547 53.5938523,36.2527005 C54.4452918,35.6300493 55.1286769,34.7904955 55.4138523,33.8613749 C55.4963814,33.5926744 55.5789106,33.3237044 55.6608948,33.0552736 C55.7265371,32.8410688 55.7924514,32.6263242 55.8583657,32.4118494 C57.2594553,32.6470972 58.7632295,32.7229053 60.2157976,32.5723683 C61.6174319,32.4264176 62.9716732,32.0730066 64.1393386,31.4560206 C65.8561088,30.5487523 67.1430739,29.2122645 68.0680544,27.6254214 L68.0685991,27.6256914 C69.1022568,25.8521608 69.6810505,23.7624488 69.9011283,21.6120363 C70.0773541,19.8873359 69.9812061,17.5426822 69.6186769,15.2813904 L69.6186769,15.2813904 L69.6186769,15.2813904 Z M51.4657976,29.775834 C50.6584824,29.5068638 50.0971207,29.114065 49.3875875,28.6713567 C49.5807003,29.5333022 49.6686769,30.4448871 49.4115565,31.3054839 C49.0035407,32.6708379 48.3446693,34.9046122 50.2161477,35.3168354 C50.9286769,35.4735772 51.2517121,35.4509158 52.2573152,34.9369857 C51.4434629,35.1196265 51.0329961,35.0748431 50.4735407,34.972057 C49.9666538,34.8797925 49.697821,34.560913 49.5561866,34.1848404 C49.7332295,34.3113672 50.0222179,34.3801608 50.5157587,34.4980545 C51.9032295,34.8293438 53.2253307,34.1675745 53.4840857,33.2147135 C53.6347082,32.6578885 53.6091052,32.3654476 53.9285991,31.6065577 C54.2156809,31.6945059 54.5125681,31.7743606 54.8170818,31.8474707 C54.645214,32.4024074 54.4733462,32.9578833 54.3014787,33.5128197 C53.855603,34.9537121 52.1181322,36.1153826 50.5841246,36.0889441 C49.1658754,36.0641244 48.2667705,35.1843735 47.2875875,34.3216188 C46.6131906,33.7267548 45.9641246,33.1583295 45.3207781,32.5950297 C43.5557976,32.0433309 42.1410894,31.3988274 40.503035,30.1977691 C41.6687939,31.5544902 42.4594942,32.3058263 44.0852918,32.9810842 C43.8488717,35.3699818 43.0107781,37.1116782 42.2960699,39.39779 C41.9724903,40.4313152 39.4192608,44.5737795 38.7116343,44.9776394 C38.2071985,45.2654941 35.0468483,47.9017795 34.4525292,48.2497949 C34.0096498,48.8322491 33.6209727,49.6370014 32.9552918,49.9852865 C30.9269261,51.0476782 29.6233462,49.0135409 28.5319456,47.2955849 C28.0348638,46.5126848 26.6547471,44.2584074 27.857821,43.6268536 C28.9955252,43.030371 29.632607,42.6038494 30.7931906,41.8490066 C30.9636964,42.1568249 31.2562255,42.4541219 31.4468872,42.7616705 C31.4049416,42.4252554 31.3627237,42.0891104 31.3202334,41.7524255 C31.243969,41.1429934 31.246965,40.648218 31.2959921,40.0350091 C31.3433851,39.4414941 31.3902334,38.8477093 31.4373541,38.2539249 C31.2627626,38.8574214 30.9138523,39.4609183 30.7395331,40.0641453 C30.6698055,40.3055979 30.6120623,40.5006485 30.5788328,40.6814008 C27.9746693,41.20855 25.3892996,41.241463 22.7843191,40.7812191 C22.6181712,39.8259301 22.4157977,38.8307135 22.2461089,38.1171464 C22.1946304,38.9162334 22.2278599,41.1254578 22.2235019,42.3626667 C22.2202335,43.3209235 22.1796498,43.6489752 21.6806615,44.4645189 C21.2135409,45.2274553 21.0157977,45.4009235 20.3615564,46.6904696 C20.4160311,47.5043942 20.4171206,48.042065 20.1989494,48.8144437 C19.8358755,50.098594 16.1738132,49.1036471 15.2079767,48.8416914 C14.018249,48.519035 11.5589883,48.0399067 12.1775486,46.4692502 C12.721751,45.0866303 13.0668482,43.6290116 13.3326848,41.6946925 C11.1531518,38.5849441 9.12642024,34.3232373 8.73747082,30.5471335 C8.43540857,27.6154396 8.61653696,25.8108846 9.25715954,24.0173904 C10.2720233,21.1758029 11.692179,18.7162231 13.9705836,16.735502 C17.0437743,14.0644151 19.9167704,12.9917717 24.4150195,12.3135461 C23.3331518,13.5129857 22.2629961,14.7812192 21.0964202,16.1411777 C19.9156809,17.5178625 19.2140467,18.9083061 18.4642023,20.4142153 C17.4283657,22.4939455 17.4507004,23.2854786 18.8237354,25.1113463 C20.0069261,26.6849702 20.645642,27.3931415 21.1623346,28.9330427 C20.7357977,29.803891 20.5805447,30.5401195 20.4372763,31.7295772 C21.8860311,33.2983449 22.9627237,34.3731464 24.3695331,34.704166 C25.7493774,35.0289805 26.9015175,34.9661219 28.1361866,34.3413127 C30.8778988,32.9527575 33.414786,31.1598029 36.5078599,31.0858833 C37.938638,27.601681 37.7940079,24.6902205 37.1070818,21.3190558 C36.6377821,19.0167574 36.449572,16.836939 36.3038523,14.4898573 C35.7236964,16.9070817 35.6147471,19.0326745 36.0450973,21.4404565 C36.563969,24.3419352 36.9673541,27.5479948 35.5240468,30.0979507 C32.7273152,30.3099975 30.330428,31.9953099 27.8098833,33.2883631 C26.7966537,33.8082282 25.741751,33.8589469 24.6203891,33.5540961 C23.5793774,33.2708274 22.8769261,32.5885552 21.7555642,31.3076419 C21.7378599,30.0213333 22.0309339,29.4278183 22.6271595,28.2629105 C23.5853696,26.3922594 24.6427237,24.6511025 25.8033074,22.8106667 C24.3823346,24.5094682 23.0359922,25.9287782 21.9176265,27.6367523 C21.49,26.4305681 20.8787938,25.8178988 19.8661089,24.459559 C18.8771206,23.1327834 18.7736187,22.5519481 19.5131128,21.0163632 C20.2566926,19.4734942 20.8872374,18.1173126 22.1529572,16.7638288 C24.3398443,14.4245707 26.3431518,11.8214682 28.7345915,9.51755123 C30.0332684,8.26685343 30.5605836,8.31001817 32.2828015,8.05156939 C33.8396888,7.81767055 35.3595331,7.52280157 36.9471985,7.15752009 C35.4118289,7.29915434 33.9276654,7.3512218 32.432607,7.38791181 C32.4170818,7.38845136 32.4018289,7.38899092 32.3863036,7.38926069 C33.8571207,5.52886122 34.7107392,4.49209857 37.099183,3.46396887 C42.9802723,0.934246433 46.716965,0.660690014 51.3366927,4.50693644 C52.5340468,5.50404151 53.5796888,6.4717406 54.7936575,7.33179766 C54.3535018,7.36902725 53.9740857,7.44726328 53.4723736,7.64231387 C54.083035,7.52711803 54.78821,7.64123476 55.4220234,7.75616083 C55.5998833,7.87054734 55.7826459,7.98196628 55.9697666,8.09122698 C56.8269261,8.59139818 57.3133851,8.86765241 57.8929961,9.66754864 C58.5055641,10.5127678 59.0162647,11.3574475 59.4662255,12.2884565 C59.171245,12.1840519 58.9239301,12.095834 58.7035796,12.0310869 C58.541245,11.9571673 58.3647471,11.9088768 58.1776264,11.8908016 C57.8069261,11.8554604 57.4522957,11.9458366 57.1567705,12.1260493 C57.144786,12.1314449 57.1330739,12.1368405 57.1210894,12.1425058 C56.6468872,12.3710091 55.9125681,12.6316161 55.4212061,12.7106615 C55.67179,12.7964514 56.2263425,12.8285551 56.487821,12.7260389 C56.5226848,12.7122802 56.5583657,12.7017588 56.5948638,12.6931258 C56.4769261,12.8919533 56.4001167,13.117489 56.3761477,13.3616394 C56.3448249,13.6851051 56.4112842,13.9953515 56.5515565,14.2648612 C56.5521012,14.2656705 56.5523736,14.2664799 56.5529182,14.2678288 C56.5973152,14.3711543 56.6588717,14.4663865 56.7266927,14.5351803 C56.5022568,14.6171933 56.2729182,14.7108067 56.0364982,14.8125136 C57.1325292,14.6471388 58.1207003,14.6188119 59.1903113,14.7582879 C59.2608559,15.092275 59.3319456,15.4462257 59.3978599,15.8061115 C59.265214,15.8163632 59.1331128,15.826345 59.0004669,15.8368664 C58.9901167,15.8376758 58.9789495,15.8387549 58.9683268,15.839834 C58.4622568,15.4392114 57.8984435,15.5063865 57.1281711,15.6806641 C54.7854863,16.2097017 55.3359532,17.5116576 54.2584435,19.4734942 C55.3773541,18.1186615 55.2942802,16.7012399 57.117821,16.2733696 C57.5427237,16.173821 57.8319845,16.0489131 58.1196109,16.091808 C57.6021012,16.3497173 57.1543191,16.7773178 56.9767316,17.2737121 C56.4761088,18.6735979 56.7868872,19.8530739 56.236965,21.1606952 C56.9181711,19.9917406 56.9592997,18.8511128 57.5683268,17.6211881 C57.7870429,17.179559 58.5987158,16.4724669 59.0971596,16.4616758 C59.2341635,16.4584384 59.3703502,16.4557406 59.5073541,16.452773 C59.6274708,17.2308171 59.7004669,18.0034656 59.6538912,18.644192 C59.5689106,19.8136861 59.2622179,21.5494475 59.078638,22.2136446 C59.6955641,21.4280467 59.9766538,19.7643165 60.2476654,18.5929339 C60.5298444,17.3735305 60.4584824,15.9099767 60.2114398,14.5999274 C59.872607,12.8023865 61.7416343,13.0948275 62.8267705,12.2477198 C63.6242802,11.624799 64.1736575,10.6303917 64.9049805,9.92572764 C65.6303113,9.22726848 66.7721012,10.2537795 67.0575486,10.9365914 C68.2946693,13.9011984 68.85821,18.5654164 68.5316343,21.5540337 C68.1647471,24.907393 66.5294164,28.5683009 63.5433851,30.2193515 C59.7364204,32.3239015 55.2479766,31.0381324 51.4657976,29.775834 L51.4657976,29.775834 L51.4657976,29.775834 Z M46.0567316,44.6700908 C45.9325292,46.05379 45.4670429,46.1452452 44.2402723,46.1239326 C43.6829961,46.1142205 41.4636964,46.1042386 40.900428,46.056218 C40.1048249,45.9882334 39.6581322,45.9178211 39.4149027,45.7381478 C40.6650973,44.8292607 42.7893386,41.0763581 43.2033462,39.784384 C43.6413231,38.4195695 44.1207003,37.228223 44.4772374,35.9667341 C44.6412061,36.4938833 44.7708559,37.0164462 45.0094553,37.5765084 C45.4079377,38.5123735 45.6026848,39.0907809 45.6312842,40.0946303 C45.661245,41.1537847 45.6914787,42.2132089 45.7217121,43.2723631 C46.0640857,43.8661478 46.1174708,43.9929441 46.0567316,44.6700908 L46.0567316,44.6700908 L46.0567316,44.6700908 Z M8.43350195,34.1883476 C9.22747082,36.9082645 10.5798054,39.58124 12.0792218,41.8282334 C12.0792218,41.8411828 12.0789494,41.8541324 12.0789494,41.8676212 C11.9847082,42.2539455 11.8763035,42.6300182 11.6483268,42.9321712 C10.5768093,44.3522907 7.85089495,42.2677044 7.06182879,41.4702362 C6.19949416,40.5977691 5.62206225,39.5650531 5.48451362,38.5960052 C5.38455252,37.8894528 5.48178988,37.8721869 5.97941635,37.3722854 C6.65027237,36.6994553 7.32194553,36.0263554 7.99252918,35.3537949 C8.13933851,34.9653127 8.28642024,34.5765604 8.43350195,34.1883476 L8.43350195,34.1883476 L8.43350195,34.1883476 Z M6.91747082,17.0824384 C6.71400778,17.5151647 6.56964982,17.8429468 6.47132295,18.180441 C6.04396887,19.6423761 6.66470818,20.9472996 5.32463036,22.0069935 C5.95435796,23.2655149 5.92548638,23.7673048 7.39031128,23.1859299 C7.95521401,22.9614734 8.42124514,22.6469105 8.83715954,22.2748846 C8.63887158,22.7826096 8.45501945,23.3065214 8.28178988,23.8474293 C8.2529183,23.9369961 8.22540857,24.0271025 8.19871596,24.1163995 C7.15116732,24.5566796 5.77350195,24.836441 5.24618678,23.7459922 C4.99015565,23.2166848 4.84552529,22.6970895 4.65894942,22.0283061 C2.93373541,20.258013 5.51256809,17.9206433 6.91747082,17.0824384 L6.91747082,17.0824384 L6.91747082,17.0824384 Z M7.76536964,18.9576758 C7.55237353,18.7467082 7.38186769,18.603725 7.10677043,18.6347497 C7.12992219,18.4558859 7.16070039,18.2834968 7.20428015,18.1213593 C7.2263424,18.0379974 7.24976654,17.9562542 7.27482489,17.8742412 C7.63190663,18.0803528 7.72614787,18.4537276 7.76536964,18.9576758 L7.76536964,18.9576758 L7.76536964,18.9576758 Z M59.4937353,12.3456498 C59.5588328,12.4816187 59.6228404,12.6200156 59.6857587,12.7600311 C59.6337353,12.7978002 59.5841635,12.8377276 59.5378599,12.8798132 C59.4528793,12.6828742 59.3294942,12.5042802 59.1766927,12.3548223 C59.2796498,12.3510454 59.3850584,12.347808 59.4937353,12.3456498 L59.4937353,12.3456498 L59.4937353,12.3456498 Z M9.68859921,20.3810324 L9.68832684,20.3807626 L9.68859921,20.3810324 L9.68859921,20.3810324 L9.68859921,20.3810324 Z M4.07334629,22.2603165 L4.07361866,22.2603165 L4.07334629,22.2603165 L4.07334629,22.2603165 L4.07334629,22.2603165 Z M22.9501946,41.8061115 L22.9507393,41.8061115 L22.9501946,41.8061115 L22.9501946,41.8061115 L22.9501946,41.8061115 Z M38.498638,46.4036939 L38.498638,46.4036939 L38.4983657,46.4036939 L38.498638,46.4036939 L38.498638,46.4036939 L38.498638,46.4036939 Z M44.8179766,34.5069573 L44.8182489,34.5069573 L44.8179766,34.5072271 L44.8179766,34.5069573 L44.8179766,34.5069573 L44.8179766,34.5069573 Z M7.09533073,22.5090532 L7.09533073,22.5087834 L7.09505836,22.5090532 L7.08361866,22.4788379 L7.09533073,22.5090532 L7.09533073,22.5090532 L7.09533073,22.5090532 Z M67.758638,27.4484462 L67.758638,27.4484462 L67.7668094,27.4533022 L67.758638,27.4484462 L67.758638,27.4484462 L67.758638,27.4484462 Z\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M1.00832685,22.0833411 C1.28287938,19.0046174 1.88727626,17.6754137 4.09568094,15.3582776 C1.32564202,17.2917873 0.634357976,18.1704592 1.00832685,22.0833411\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M0.293891052,19.5684565 C0.598949416,18.182869 0.883307392,17.6600363 1.74564202,16.5226459 C0.346459143,17.4908846 0.163968872,17.8885396 0.293891052,19.5684565\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M32.7918678,0.253053178 C31.1325681,0.649089494 30.8160699,0.953130999 30.3184435,2.56425421 C31.1124125,1.38450843 31.5697277,1.00061219 32.7918678,0.253053178\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M35.4088328,0.0183450065 C32.1174708,0.817431907 31.1502723,1.38558755 30.056965,5.16384955 C31.4466149,2.39672114 32.4990662,1.37776394 35.4088328,0.0183450065\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M42.4973541,13.7919377 C42.8481711,12.2525759 43.4716343,10.7690584 45.8854085,9.62141635 C42.6858365,10.4151077 42.0860699,11.7459299 42.4973541,13.7919377\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M62.8542802,13.8982309 C64.7489106,13.2291777 65.662179,11.7205707 66.1159532,9.94542152 C65.3742802,11.4332555 64.2300389,12.6774786 62.6753307,13.4396057 C61.8410505,13.8483217 61.3082879,13.7058781 60.3767705,13.6184695 C61.3240857,13.8877095 61.9241246,14.2265525 62.8542802,13.8982309\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M49.9475875,15.4068379 C49.6950973,14.8826563 49.2527626,14.5071232 48.7407003,14.3212451 C49.2053696,14.075476 49.6618678,13.817297 50.0181322,13.4965292 C48.9749416,13.9748483 47.760428,13.8580337 46.8654085,14.4569442 C46.0768872,14.9843632 44.988755,16.655917 44.1874319,17.3646277 C44.7678599,17.1415201 45.3270429,16.7557354 45.8415565,16.3489079 C45.8437353,16.6513307 45.9107392,16.9575305 46.0504669,17.2478132 C46.2591052,17.6805396 46.596576,18.011559 46.9961477,18.2184799 C46.7077043,18.5948223 46.4682879,19.0162179 46.296965,19.483476 C47.8225292,17.6926796 50.0344748,16.340275 52.1140468,15.7618677 C51.5328015,15.7537743 50.8445137,15.8614163 50.143424,16.0896498 C50.117821,15.8587186 50.0540857,15.6280571 49.9475875,15.4068379\" id=\"Shape\" fill=\"#B5B5B5\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M47.7525292,28.9381687 C47.6784435,29.4019196 47.5768483,29.9781687 47.5027626,30.4421894 C47.7007781,29.9171985 47.9393775,29.3072271 48.1698055,28.8067861 C48.414397,28.2772089 48.5519456,28.2272995 49.0705447,27.9478081 C49.4382489,27.7495202 50.1061088,27.4770427 50.4738134,27.2787548 C50.0954863,27.3418833 49.4172763,27.4797407 49.0389495,27.542869 C48.0281711,27.7120206 47.9091441,27.9523942 47.7525292,28.9381687\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M30.4881322,11.0353307 C29.3150195,12.1837821 28.1759532,16.1244514 27.81179,17.7010428 C28.3854085,16.3912633 29.8202723,12.7276576 30.9212061,11.7955694 C31.2251751,11.5379299 31.4376264,11.3798392 31.6658754,11.2649131 C30.8778988,12.5736135 30.935642,12.8992374 31.2123736,14.6528042 C31.4471596,12.8701012 32.0695331,12.1813541 33.0909338,10.8513411 C34.2103891,10.5729287 35.25821,10.239751 36.4065371,9.79596369 C35.1114009,9.94110506 33.8181711,10.0738366 32.5224903,10.1952374 C31.4346304,10.2974838 31.2594942,10.2799481 30.4881322,11.0353307\" id=\"Shape\" fill=\"#E3E5E7\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M46.4677432,17.7433982 C46.2539301,17.3004202 46.4451362,16.7667964 46.8934629,16.555559 C47.34179,16.3440519 47.8816343,16.5328975 48.0954474,16.9761453 C48.1158754,17.0182309 48.1319456,17.0613956 48.1452918,17.1045603 C47.7171207,17.419393 47.3246304,17.7900701 46.9953307,18.219559 C46.7738912,18.1313411 46.5775097,17.9708223 46.4677432,17.7433982\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003Cpath d=\"M56.4848249,13.9052451 C56.5207781,13.5380752 56.8367316,13.2674864 57.2071596,13.3030973 C57.5773152,13.3387082 57.8510505,13.6664903 57.8153696,14.0333904 C57.8074708,14.1116265 57.7862255,14.1847367 57.754358,14.2521816 C57.4152529,14.3096446 57.0761477,14.4078444 56.7266927,14.5351803 C56.5807003,14.3870713 56.464397,14.1167523 56.4848249,13.9052451\" id=\"Shape\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fg\u003E\n\u003C\u002Fsvg\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csvg height=\"228\" viewbox=\"0 0 671 228\" width=\"671\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(1)\"\u003E\u003Cg class=\"js-animate-circles\" fill=\"#E3E5E7\" transform=\"translate(59 20)\"\u003E\u003Ccircle cx=\"2\" cy=\"75\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"63\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"51\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"39\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"27\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"15\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"13\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"25\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"37\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"49\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"61\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"73\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"84\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"97\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"109\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"121\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"133\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"145\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"157\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"168\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"180\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"193\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"205\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"217\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"229\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"240\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"314\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"326\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"338\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"350\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"361\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"374\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"386\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"398\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"410\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"421\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"434\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"446\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"458\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"470\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"481\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"492\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"505\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"517\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"529\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"540\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"13\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"24\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"36\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"47\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"58\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"70\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003C\u002Fg\u003E\u003Cg stroke-width=\"1.5\" transform=\"translate(585 127)\"\u003E\u003Cpath d=\"M45.75 80H2.25C.975 80 0 78.943 0 77.736V2.264C0 1.057.975 0 2.25 0h43.5C47.025 0 48 1.057 48 2.264v75.472C48 78.943 47.025 80 45.75 80z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M5.25 7.547h37.5v61.887H5.25z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"24\" cy=\"74.717\" rx=\"2.25\" ry=\"2.264\" stroke=\"#222228\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M20.25 3.774h7.5M22.05 28.755l-9.225 16.15c-.9 1.51.225 3.397 1.95 3.397H33.3c1.725 0 2.85-1.887 1.95-3.396l-9.225-16.15c-.975-1.51-3.075-1.51-3.975 0l-9.225 16.15c-.9 1.51.225 3.396 1.95 3.396H33.3c1.725 0 2.85-1.887 1.95-3.396l-9.225-16.15c-.975-1.51-3.075-1.51-3.975 0z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M24 33.208v8.3M24 43.02v2.263\" stroke=\"#EB5424\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M45.75 80H2.25C.975 80 0 78.943 0 77.736V2.264C0 1.057.975 0 2.25 0h43.5C47.025 0 48 1.057 48 2.264v75.472C48 78.943 47.025 80 45.75 80z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003Cg transform=\"translate(28 133)\"\u003E\u003Cpath d=\"M0 0h58.276v19.644H0zM0 24.178h58.276v19.644H0zM50.805 48.356H0V68h48.563\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"13.448\" cy=\"12.089\" fill=\"#EB5424\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse cx=\"7.471\" cy=\"12.089\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M52.3 6.044V13.6M47.816 6.044V13.6M43.333 6.044V13.6\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"7.471\" cy=\"36.267\" fill=\"#EB5424\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse cx=\"13.448\" cy=\"36.267\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M52.3 30.222v7.556M47.816 30.222v7.556M43.333 30.222v7.556\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"13.448\" cy=\"60.444\" fill=\"#EB5424\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse cx=\"7.471\" cy=\"60.444\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M51.552 56.667H65V68H51.552zM63.506 56.667v-3.023c0-2.946-2.316-5.288-5.23-5.288-2.914 0-5.23 2.342-5.23 5.288v3.023\" stroke=\"#EB5424\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M58.276 60.444v5.29\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"58.276\" cy=\"61.2\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003C\u002Fg\u003E\u003Cpath d=\"M345.757 36.404l-4.49-13.905 11.752-8.592h-14.527L334.003.004 334 0h14.53l4.49 13.907.004-.003c2.608 8.068-.078 17.244-7.267 22.5zm-23.508 0l-.005.003L334 45l11.757-8.596-11.754-8.593-11.754 8.594zm-7.267-22.5c-2.745 8.505.442 17.516 7.263 22.502V36.4l4.49-13.903-11.748-8.59h14.523L334 .005l.002-.004h-14.53l-4.49 13.905z\" fill=\"#EB5424\"\u003E\u003C\u002Fpath\u003E\u003Ccircle cx=\"60\" cy=\"167\" r=\"60\" stroke=\"#E3E5E7\" stroke-width=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"609\" cy=\"167\" r=\"60\" stroke=\"#E3E5E7\" stroke-width=\"2\"\u003E\u003C\u002Fcircle\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;





pug_html = pug_html + "\u003Cdiv class=\"breached-passwords-page page-content\"\u003E\u003Csection class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"hero-text-content col-xs-12 col-md-6\"\u003E\u003Ch1 class=\"hero-header\"\u003EProtect your users and services \u003Cbr class=\"rd-break\"\u003Efrom password leaks\u003C\u002Fh1\u003E\u003Cp class=\"hero-description\"\u003EBreached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success enable-now\" href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fanomaly\" rel=\"external\"\u003EENABLE NOW\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-transparent join-us\" href=\"javascript:signup()\"\u003EUSE AUTH0 FOR FREE\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-news-content col-xs-12 col-md-6\"\u003E\u003Cdiv class=\"news-1 go-down\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"news-2 go-down\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"news-3 go-up\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"news-4 go-up\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"how-it-works\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fhiw-icon-2bfd9905d1.svg\" alt=\"How it works\"\u003E\u003Ch2 class=\"h2\"\u003EHow It Works\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003EAuth0 maintains a continuously-updated collection of breached credentials, with hundreds of millions of entries. All password-based login or signup attempts are checked against this database, and any matches are blocked in real-time.\u003C\u002Fp\u003E\u003Cdiv class=\"example-content\"\u003E\u003Cvideo id=\"breached-video\" width=\"100%\"\u003E\u003Csource src=\"https:\u002F\u002Fembed-ssl.wistia.com\u002Fdeliveries\u002F2c40154d519f5fb3713c1f64f80f20625c89ba3e\u002Fbreached-video.mp4\"\u003E\u003C\u002Fvideo\u003E\u003Ca class=\"play-me-again\" href=\"#\"\u003E\u003Ci class=\"icon-budicon-257\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"benefits\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fbenefits-icon-eeeb4ead7a.svg\" alt=\"Benefits\"\u003E\u003Ch2 class=\"h2\"\u003EBenefits\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003EIn many instances, users are not aware that their password has been leaked. Enabling breached password detection in your app will notify users when they are at risk and enhance your brand perception.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"benefits-details\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center visible-md visible-lg\"\u003E" + (null == (pug_interp = __webpack_require__(927).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12 col-md-6 benefit-left\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fservice-providers-icon-2183fd545f.svg\" alt=\"Service providers\"\u003E\u003Ch2 class=\"h2\"\u003EFor Service Providers\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column text-benefit\"\u003EBlock hackers from impersonating users with compromised credentials from data breaches.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center col-xs-12 col-md-6 benefit-right\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fend-users-icon-a033ef8c1d.svg\" alt=\"End Users\"\u003E\u003Ch2 class=\"h2\"\u003EFor End Users\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column text-benefit\"\u003EReceive data breach notifications if your credentials are compromised and keep your accounts safe.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"flip-counter\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Ch2 class=\"h2\"\u003EThe world is leaking passwords\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003EAs you read this, more and more passwords are being stolen and leaked in data breaches.\u003C\u002Fp\u003E\u003Cdiv class=\"counter\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"enable text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fenable-icon-3a9e5829ec.svg\" alt=\"Enable Breached Password\"\u003E\u003Ch2 class=\"h2\"\u003EEnable Breached Password Detection Today\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003EBreached password detection is available now in preview.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success enable-now\" href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fanomaly\" rel=\"external\"\u003EENABLE NOW\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-transparent enable-learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fanomaly-detection\" rel=\"external\"\u003ELEARN MORE\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-container\"\u003E\u003Cdiv class=\"switcher\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EBreached Password Detection\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Object, capitalizeFirstLetter, changelog, renderMarkDown) {pug_mixins["changelog-item"] = pug_interp = function(release){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate Object.keys(release.changelog)
;(function(){
  var $$obj = Object.keys(release.changelog);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var key = $$obj[pug_index0];
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(key.replace(/"/g, ''))) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cul class=\"changelog\"\u003E";
// iterate release.changelog[key]
;(function(){
  var $$obj = release.changelog[key];
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var log = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var log = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var key = $$obj[pug_index0];
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(key.replace(/"/g, ''))) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cul class=\"changelog\"\u003E";
// iterate release.changelog[key]
;(function(){
  var $$obj = release.changelog[key];
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var log = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var log = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cdiv class=\"changelog-page\"\u003E\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fchangelog\u002Fimg\u002Fchangelog-c894862bd1.svg\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EAuth0 Appliance Release Notes\u003C\u002Fh1\u003E\u003Cp\u003EGet the latest updates in Auth0\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003Csection class=\"categories\"\u003E\u003Cdiv class=\"container\" id=\"changelog\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 center left-side\"\u003E\u003Cdiv class=\"category\" id=\"appliance\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-3\"\u003E\u003Cdiv class=\"sidebar-box\"\u003E\u003Cstrong\u003EReleases\u003C\u002Fstrong\u003E\u003Cul\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var release = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '#' + release.id, true, true)+" data-control=\"release\"") + "\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var release = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '#' + release.id, true, true)+" data-control=\"release\"") + "\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-9 text-content\"\u003E\u003Ca href=\"\u002Fchangelog\u002Fappliance\u002Fold\"\u003ESee old releases\u003C\u002Fa\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var release = $$obj[pug_index4];
pug_html = pug_html + "\u003Ca" + (pug.attr("name", release.id, true, true)) + "\u003E\u003C\u002Fa\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
pug_mixins["changelog-item"](release);
pug_html = pug_html + "\u003Chr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var release = $$obj[pug_index4];
pug_html = pug_html + "\u003Ca" + (pug.attr("name", release.id, true, true)) + "\u003E\u003C\u002Fa\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
pug_mixins["changelog-item"](release);
pug_html = pug_html + "\u003Chr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"Object" in locals_for_with?locals_for_with.Object:typeof Object!=="undefined"?Object:undefined,"capitalizeFirstLetter" in locals_for_with?locals_for_with.capitalizeFirstLetter:typeof capitalizeFirstLetter!=="undefined"?capitalizeFirstLetter:undefined,"changelog" in locals_for_with?locals_for_with.changelog:typeof changelog!=="undefined"?changelog:undefined,"renderMarkDown" in locals_for_with?locals_for_with.renderMarkDown:typeof renderMarkDown!=="undefined"?renderMarkDown:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (capitalizeFirstLetter, changelog, people) {pug_html = pug_html + "\u003Cdiv class=\"changelog-page boxes\"\u003E\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fchangelog\u002Fimg\u002Fchangelog-c894862bd1.svg\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EAuth0 Changelog\u003C\u002Fh1\u003E\u003Cp\u003EGet the latest updates in Auth0\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003Csection class=\"categories\"\u003E\u003Cdiv class=\"container\" id=\"changelog\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 center left-side\"\u003E\u003Cdiv class=\"category\" id=\"cloud\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12\"\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var log = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"logbox clearfix\"\u003E\u003Cdiv class=\"log-header row\"\u003E\u003Cp class=\"col-xs-7\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.type) + ': ' + capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"col-xs-5 text-right\"\u003E" + (pug.escape(null == (pug_interp = log.publishedAt) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"log-content\"\u003E\u003Cdiv class=\"description\"\u003E" + (null == (pug_interp = log.description) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
if (log.team) {
}
pug_html = pug_html + "\u003Cdiv class=\"team-members clearfix\"\u003E";
// iterate log.team
;(function(){
  var $$obj = log.team;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var key = $$obj[pug_index1];
if (people[key]) {
pug_html = pug_html + "\u003Cdiv class=\"profile-box\"\u003E\u003Cdiv class=\"profile\"\u003E\u003Cspan\u003E\u003Cimg" + (pug.attr("src", people[key].avatarUrl, true, true)+pug.attr("alt", people[key].name, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"text\"\u003E\u003Cp class=\"profile-name\"\u003E" + (pug.escape(null == (pug_interp = people[key].name) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"profile-title\"\u003E" + (pug.escape(null == (pug_interp = people[key].title) ? "" : pug_interp)) + " \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var key = $$obj[pug_index1];
if (people[key]) {
pug_html = pug_html + "\u003Cdiv class=\"profile-box\"\u003E\u003Cdiv class=\"profile\"\u003E\u003Cspan\u003E\u003Cimg" + (pug.attr("src", people[key].avatarUrl, true, true)+pug.attr("alt", people[key].name, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"text\"\u003E\u003Cp class=\"profile-name\"\u003E" + (pug.escape(null == (pug_interp = people[key].name) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"profile-title\"\u003E" + (pug.escape(null == (pug_interp = people[key].title) ? "" : pug_interp)) + " \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var log = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"logbox clearfix\"\u003E\u003Cdiv class=\"log-header row\"\u003E\u003Cp class=\"col-xs-7\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.type) + ': ' + capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"col-xs-5 text-right\"\u003E" + (pug.escape(null == (pug_interp = log.publishedAt) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"log-content\"\u003E\u003Cdiv class=\"description\"\u003E" + (null == (pug_interp = log.description) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
if (log.team) {
}
pug_html = pug_html + "\u003Cdiv class=\"team-members clearfix\"\u003E";
// iterate log.team
;(function(){
  var $$obj = log.team;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var key = $$obj[pug_index2];
if (people[key]) {
pug_html = pug_html + "\u003Cdiv class=\"profile-box\"\u003E\u003Cdiv class=\"profile\"\u003E\u003Cspan\u003E\u003Cimg" + (pug.attr("src", people[key].avatarUrl, true, true)+pug.attr("alt", people[key].name, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"text\"\u003E\u003Cp class=\"profile-name\"\u003E" + (pug.escape(null == (pug_interp = people[key].name) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"profile-title\"\u003E" + (pug.escape(null == (pug_interp = people[key].title) ? "" : pug_interp)) + " \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var key = $$obj[pug_index2];
if (people[key]) {
pug_html = pug_html + "\u003Cdiv class=\"profile-box\"\u003E\u003Cdiv class=\"profile\"\u003E\u003Cspan\u003E\u003Cimg" + (pug.attr("src", people[key].avatarUrl, true, true)+pug.attr("alt", people[key].name, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"text\"\u003E\u003Cp class=\"profile-name\"\u003E" + (pug.escape(null == (pug_interp = people[key].name) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cp class=\"profile-title\"\u003E" + (pug.escape(null == (pug_interp = people[key].title) ? "" : pug_interp)) + " \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"capitalizeFirstLetter" in locals_for_with?locals_for_with.capitalizeFirstLetter:typeof capitalizeFirstLetter!=="undefined"?capitalizeFirstLetter:undefined,"changelog" in locals_for_with?locals_for_with.changelog:typeof changelog!=="undefined"?changelog:undefined,"people" in locals_for_with?locals_for_with.people:typeof people!=="undefined"?people:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Object, capitalizeFirstLetter, changelog, renderMarkDown) {pug_mixins["changelog-item"] = pug_interp = function(release){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate Object.keys(release.changelog)
;(function(){
  var $$obj = Object.keys(release.changelog);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var key = $$obj[pug_index0];
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(key.replace(/"/g, ''))) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cul class=\"changelog\"\u003E";
// iterate release.changelog[key]
;(function(){
  var $$obj = release.changelog[key];
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var log = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var log = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var key = $$obj[pug_index0];
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(key.replace(/"/g, ''))) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003Cul class=\"changelog\"\u003E";
// iterate release.changelog[key]
;(function(){
  var $$obj = release.changelog[key];
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var log = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var log = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Cspan class=\"label label-default\"\u003E" + (pug.escape(null == (pug_interp = capitalizeFirstLetter(log.module)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"log-description\"\u003E " + (null == (pug_interp = renderMarkDown(log.description)) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cdiv class=\"changelog-page\"\u003E\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fchangelog\u002Fimg\u002Fchangelog-c894862bd1.svg\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EAuth0 Appliance - Old Releases\u003C\u002Fh1\u003E\u003Cp\u003EGet the latest updates in Auth0\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003Csection class=\"categories\"\u003E\u003Cdiv class=\"container\" id=\"changelog\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-12 center left-side\"\u003E\u003Cdiv class=\"category\" id=\"old-releases\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-md-3\"\u003E\u003Cdiv class=\"sidebar-box\"\u003E\u003Cstrong\u003EReleases\u003C\u002Fstrong\u003E\u003Cul\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var release = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '#' + release.id, true, true)+" data-control=\"release\"") + "\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var release = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '#' + release.id, true, true)+" data-control=\"release\"") + "\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-9 text-content\"\u003E\u003Ca href=\"\u002Fchangelog\u002Fappliance\"\u003EBack to active releases\u003C\u002Fa\u003E";
// iterate changelog
;(function(){
  var $$obj = changelog;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var release = $$obj[pug_index4];
pug_html = pug_html + "\u003Ca" + (pug.attr("name", release.id, true, true)) + "\u003E\u003C\u002Fa\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
pug_mixins["changelog-item"](release);
pug_html = pug_html + "\u003Chr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var release = $$obj[pug_index4];
pug_html = pug_html + "\u003Ca" + (pug.attr("name", release.id, true, true)) + "\u003E\u003C\u002Fa\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = release.title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E";
pug_mixins["changelog-item"](release);
pug_html = pug_html + "\u003Chr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"Object" in locals_for_with?locals_for_with.Object:typeof Object!=="undefined"?Object:undefined,"capitalizeFirstLetter" in locals_for_with?locals_for_with.capitalizeFirstLetter:typeof capitalizeFirstLetter!=="undefined"?capitalizeFirstLetter:undefined,"changelog" in locals_for_with?locals_for_with.changelog:typeof changelog!=="undefined"?changelog:undefined,"renderMarkDown" in locals_for_with?locals_for_with.renderMarkDown:typeof renderMarkDown!=="undefined"?renderMarkDown:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (customers) {pug_html = pug_html + "\u003Csection class=\"jumbotron\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-5\"\u003E\u003Ch1\u003ECustomers\u003C\u002Fh1\u003E\u003Cp\u003EThese are some of the companies that trust Auth0 every day.\u003Cbr class=\"rm-break\"\u003E Your company can be the next.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:signup()\"\u003EUse auth0 for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-5 hero-image-container\"\u003E\u003Cimg class=\"hero-image animated fadeIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fcustomers-hero-5f3e6ab970.png\" alt=\"Auth0's Customers\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circles-container-medium hidden-xs hidden-lg\"\u003E\u003Cimg class=\"animated fadeIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fcustomers-hero-tablet-cb0a1929e0.svg\" alt=\"Auth0's Customers\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circles-container-large hidden-xs hidden-sm\"\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-atlassian-d64d2ca93a.svg\" alt=\"Telkomsel\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-mozilla-c391653364.svg\" alt=\"Safari Books Online\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-houghton-4b87092568.svg\" alt=\"Houghton Mifflin Harcourt\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-marks-spencer-44f43eadfb.svg\" alt=\"Marks &amp; Spencer\" style=\"max-width:40%;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-bluetooth-sig-167197fc93.svg\" alt=\"Jet Privilege\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-nvidia-1431159d4a.svg\" alt=\"Schneider Electric\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-financial-times-974fd8fe13.svg\" alt=\"NewsCorp\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-dowjones-82f152280f.svg\" alt=\"Dow Jones\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-optimizely-1452715a9c.svg\" alt=\"Optimizely\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-pldt-2c6fca8008.png\" alt=\"PLDT Home\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle animated fadeIn\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-pbs-f8e4a8a436.svg\" alt=\"PBS\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"featured-customers\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3 class=\"section-title\"\u003EFeatured Customer Stories\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"featured-customers-container\"\u003E";
// iterate customers
;(function(){
  var $$obj = customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var category = $$obj[pug_index0];
if (category.data == "featured")
{
// iterate category.customers
;(function(){
  var $$obj = category.customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var customer = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv" + (" class=\"featured-customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv" + (" class=\"customer-image-container\""+pug.attr("style", pug.style("background-color:" + customer.color), false, true)) + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)+pug.attr("alt", customer.text, true, true)) + "\u003E";
if ((customer.videoURL)) {
pug_html = pug_html + "\u003Ca" + (" class=\"wistia-popover[height=720,playerColor=7b796a,width=1280] play-button\""+pug.attr("href", customer.videoURL, true, true)) + "\u003E\u003Cspan class=\"play-icon\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"play-text\"\u003EWatch Video\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cp class=\"customer-text\"\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-links row\"\u003E\u003Cdiv class=\"website-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" target=\"_blank\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var customer = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv" + (" class=\"featured-customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv" + (" class=\"customer-image-container\""+pug.attr("style", pug.style("background-color:" + customer.color), false, true)) + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)+pug.attr("alt", customer.text, true, true)) + "\u003E";
if ((customer.videoURL)) {
pug_html = pug_html + "\u003Ca" + (" class=\"wistia-popover[height=720,playerColor=7b796a,width=1280] play-button\""+pug.attr("href", customer.videoURL, true, true)) + "\u003E\u003Cspan class=\"play-icon\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"play-text\"\u003EWatch Video\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cp class=\"customer-text\"\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-links row\"\u003E\u003Cdiv class=\"website-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" target=\"_blank\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var category = $$obj[pug_index0];
if (category.data == "featured")
{
// iterate category.customers
;(function(){
  var $$obj = category.customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var customer = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv" + (" class=\"featured-customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv" + (" class=\"customer-image-container\""+pug.attr("style", pug.style("background-color:" + customer.color), false, true)) + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)+pug.attr("alt", customer.text, true, true)) + "\u003E";
if ((customer.videoURL)) {
pug_html = pug_html + "\u003Ca" + (" class=\"wistia-popover[height=720,playerColor=7b796a,width=1280] play-button\""+pug.attr("href", customer.videoURL, true, true)) + "\u003E\u003Cspan class=\"play-icon\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"play-text\"\u003EWatch Video\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cp class=\"customer-text\"\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-links row\"\u003E\u003Cdiv class=\"website-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" target=\"_blank\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var customer = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv" + (" class=\"featured-customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv" + (" class=\"customer-image-container\""+pug.attr("style", pug.style("background-color:" + customer.color), false, true)) + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)+pug.attr("alt", customer.text, true, true)) + "\u003E";
if ((customer.videoURL)) {
pug_html = pug_html + "\u003Ca" + (" class=\"wistia-popover[height=720,playerColor=7b796a,width=1280] play-button\""+pug.attr("href", customer.videoURL, true, true)) + "\u003E\u003Cspan class=\"play-icon\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"play-text\"\u003EWatch Video\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cp class=\"customer-text\"\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-links row\"\u003E\u003Cdiv class=\"website-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link col-xs-6\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" target=\"_blank\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"customers-quotes-slider\"\u003E\u003Cdiv class=\"carousel\" id=\"carousel\" data-ride=\"carousel\" data-interval=\"15000\" data-pause=\"true\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"carousel-inner\" role=\"listbox\"\u003E\u003Cdiv class=\"slide-1 item active\"\u003E\u003Cdiv class=\"customer-quote animated fadeIn\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-schneider-electric-475741417f.png\" alt=\"Schneider Electric\"\u003E\u003Cquote class=\"customer-text\"\u003E‘Auth0 is an authentication-as-a-service solution that was built by developers with the modern developer in mind.’\u003C\u002Fquote\u003E\u003Cspan class=\"customer-signature\"\u003E\u003Cimg class=\"customer-avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fquotes-01-berard-927acfd3e9.png\" alt=\"Stephen Berard\"\u003EStephen Berard - Schneider Electric\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-2 item\"\u003E\u003Cdiv class=\"customer-quote animated fadeIn\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-mindjet-b5fc05d718.png\" alt=\"Mindjet\"\u003E\u003Cquote class=\"customer-text\"\u003E‘We took a strategic bet on Auth0 by using their sophisticated identity infrastructure, rather than building it ourselves.’\u003C\u002Fquote\u003E\u003Cspan class=\"customer-signature\"\u003E\u003Cimg class=\"customer-avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fquotes-02-gardner-eb982af51b.png\" alt=\"James Gardener\"\u003EJames Gardener - Mindjet\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-3 item\"\u003E\u003Cdiv class=\"customer-quote animated fadeIn\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-safari-books-06802c2150.svg\" alt=\"Safari Books\"\u003E\u003Cquote class=\"customer-text\"\u003E‘Having Auth0 around to provide immediate answers to our questions saved our developers a great deal of time.’\u003C\u002Fquote\u003E\u003Cspan class=\"customer-signature\"\u003E\u003Cimg class=\"customer-avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fquotes-03-concepcion-b2f10ddde2.png\" alt=\"Cris Concepcion\"\u003ECris Concepcion - Safari Books Online\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-4 item\"\u003E\u003Cdiv class=\"customer-quote animated fadeIn\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-jet-privilege-9c95f9f445.png\" alt=\"Jet Privilege\"\u003E\u003Cquote class=\"customer-text\"\u003E‘It’s a continual process, but we’re doing something now that we only dreamed of before. And in terms of a solution design, there was nothing that Auth0 was unable to do.’\u003C\u002Fquote\u003E\u003Cspan class=\"customer-signature\"\u003E\u003Cimg class=\"customer-avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fquotes-04-date-5ea39e5cfb.png\" alt=\"Amol Date\"\u003EAmol Date - JetPrivilege\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-5 item\"\u003E\u003Cdiv class=\"customer-quote animated fadeIn\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-harvard-medical-school-a8eadc1508.svg\" alt=\"Harvard Medical School\"\u003E\u003Cquote class=\"customer-text\"\u003E‘This was the only SaaS platform we looked at because it was clear that it was outstanding. Honestly.’\u003C\u002Fquote\u003E\u003Cspan class=\"customer-signature\"\u003E\u003Cimg class=\"customer-avatar\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Fquotes-05-bernick-1f96fbaf6e.png\" alt=\"David Bernick\"\u003EDavid Bernick - Harvard Medical School\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-6 item\"\u003E\u003Cdiv class=\"customer-quote animated fadeIn\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Ffc-05-m&amp;s-ac3336a6bc.png\" alt=\"Marks &amp; Spencer\"\u003E\u003Cquote class=\"customer-text\"\u003E‘Auth0 provided the perfect fit of out-of-the-box features, flexibility and enterprise-level service.’\u003C\u002Fquote\u003E\u003Cspan class=\"customer-signature\"\u003EAKQA - Marketing partner to Marks & Spencer\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Col class=\"carousel-indicators\"\u003E\u003Cli class=\"active\" data-target=\"#carousel\" data-slide-to=\"0\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"1\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"2\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"3\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"4\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"5\"\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"customers\" id=\"categories\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch3 class=\"section-title\"\u003ECategories\u003C\u002Fh3\u003E\u003Cdiv class=\"categories-nav-holder\"\u003E\u003Cul class=\"nav nav-categories nav-center nav-tabs\"\u003E\u003Cli class=\"category active\" data-category=\"all\"\u003E\u003Ca href=\"#\"\u003EAll\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
// iterate customers
;(function(){
  var $$obj = customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var category = $$obj[pug_index3];
if (category.data !== "featured")
{
pug_html = pug_html + "\u003Cli" + (" class=\"category\""+pug.attr("data-category", category.data, true, true)) + "\u003E\u003Ca href=\"#\"\u003E" + (pug.escape(null == (pug_interp = category.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var category = $$obj[pug_index3];
if (category.data !== "featured")
{
pug_html = pug_html + "\u003Cli" + (" class=\"category\""+pug.attr("data-category", category.data, true, true)) + "\u003E\u003Ca href=\"#\"\u003E" + (pug.escape(null == (pug_interp = category.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003Cform class=\"search-form\"\u003E\u003Cdiv class=\"form-group search-control\"\u003E\u003Ci class=\"icon-budicon-489\"\u003E\u003C\u002Fi\u003E\u003Cinput class=\"search-input form-control\" id=\"search-input\" type=\"text\" placeholder=\"Search for customers\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customers-gallery-container\"\u003E";
// iterate customers
;(function(){
  var $$obj = customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var category = $$obj[pug_index4];
// iterate category.customers
;(function(){
  var $$obj = category.customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var customer = $$obj[pug_index5];
if (category.data !== "featured")
{
pug_html = pug_html + "\u003Cdiv" + (" class=\"flex-col\""+pug.attr("data-category", category.data, true, true)+pug.attr("data-search", customer.text.substring(0,50).toLowerCase(), true, true)) + "\u003E\u003Cdiv" + (" class=\"customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv class=\"customer-image-container\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)) + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-info\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"customer-links\"\u003E";
if(customer.caseStudyUrl)
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" rel=\"external\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
else
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var customer = $$obj[pug_index5];
if (category.data !== "featured")
{
pug_html = pug_html + "\u003Cdiv" + (" class=\"flex-col\""+pug.attr("data-category", category.data, true, true)+pug.attr("data-search", customer.text.substring(0,50).toLowerCase(), true, true)) + "\u003E\u003Cdiv" + (" class=\"customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv class=\"customer-image-container\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)) + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-info\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"customer-links\"\u003E";
if(customer.caseStudyUrl)
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" rel=\"external\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
else
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var category = $$obj[pug_index4];
// iterate category.customers
;(function(){
  var $$obj = category.customers;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var customer = $$obj[pug_index6];
if (category.data !== "featured")
{
pug_html = pug_html + "\u003Cdiv" + (" class=\"flex-col\""+pug.attr("data-category", category.data, true, true)+pug.attr("data-search", customer.text.substring(0,50).toLowerCase(), true, true)) + "\u003E\u003Cdiv" + (" class=\"customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv class=\"customer-image-container\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)) + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-info\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"customer-links\"\u003E";
if(customer.caseStudyUrl)
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" rel=\"external\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
else
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var customer = $$obj[pug_index6];
if (category.data !== "featured")
{
pug_html = pug_html + "\u003Cdiv" + (" class=\"flex-col\""+pug.attr("data-category", category.data, true, true)+pug.attr("data-search", customer.text.substring(0,50).toLowerCase(), true, true)) + "\u003E\u003Cdiv" + (" class=\"customer\""+pug.attr("id", customer.hashName ? customer.hashName : '', true, true)) + "\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cdiv class=\"customer-image-container\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003E\u003Cimg" + (pug.attr("src", "/pages/customers/img/" + customer.img, true, true)) + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-info\"\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = customer.text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"customer-links\"\u003E";
if(customer.caseStudyUrl)
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"case-study-link\"\u003E\u003Ca" + (pug.attr("href", customer.caseStudyUrl, true, true)+" rel=\"external\"") + "\u003ECase Study\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
else
{
pug_html = pug_html + "\u003Cdiv class=\"website-link\"\u003E\u003Ca" + (pug.attr("href", customer.websiteUrl, true, true)+" target=\"_blank\"") + "\u003EWebsite\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"customers" in locals_for_with?locals_for_with.customers:typeof customers!=="undefined"?customers:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["browser"] = pug_interp = function(url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Cdiv class=\"btns\"\u003E\u003Ci class=\"close\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"min\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"max\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"location-bar\"\u003E\u003Ci class=\"icon-budicon-285\"\u003E\u003C\u002Fi\u003E";
if (url) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = url) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003Ehttps:\u002F\u002Fmanage.auth0.com\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"menu-button\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"dashboard-page theme-dark\"\u003E\u003Cdiv class=\"spinner-container\"\u003E\u003Cdiv class=\"auth0-spinner\"\u003E\u003Cdiv class=\"spinner\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"spinner-bg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"js-intro-text animated invisible intro-text\"\u003E\u003Ch1\u003EHow It Works\u003C\u002Fh1\u003E\u003Ch3\u003EAuth0 is an enterprise-grade platform for modern identity.\u003Cbr\u003EWe give you tools that eliminate the friction of authentication for\nyour applications and APIs - all accessible through\nyour account dashboard.\u003C\u002Fh3\u003E\u003Ca class=\"btn btn-success btn-lg invisible login\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"dashboard-top\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"page-hero\"\u003E\u003Cdiv class=\"main-screenshot\"\u003E\u003Cdiv class=\"tooltips\"\u003E\u003Cdiv class=\"js-animation-stack\"\u003E\u003Cdiv class=\"box-tip box-tip-sidebar\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"0\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003ESidebar\u003C\u002Fh5\u003E\u003Cp\u003EEasily navigate through the set-up process or quickly access a particular feature.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box-tip box-tip-users\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"1\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003EUsers\u003C\u002Fh5\u003E\u003Cp\u003EQuickly view the latest logins\u003Cbr\u003Eand new sign-ups.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box-tip box-tip-stats\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"2\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003EStats\u003C\u002Fh5\u003E\u003Cp\u003EView important stats at-a-glance, right from your dashboard homepage.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box-tip box-tip-search\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"3\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003ESearch\u003C\u002Fh5\u003E\u003Cp\u003EQuickly and easily find and access your apps or dashboard features.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"p-dashboard-1 invisible\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fp-dashboard-6fc11ba51b.png\"\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"p-dashboard-2 invisible\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fp-dashboard-2-4fcb50c958.png\"\u003E\u003Cimg class=\"mobile-screen invisible\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fmobile-screenshot-5e3c50548f.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"section section-overview blue-gradient\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003EOverview\u003C\u002Fh2\u003E\u003Cp\u003EYou can easily and quickly connect your apps, choose identity providers, add users, set up rules, customize your login page and access analytics from your Auth0 dashboard. It really is identity made simple for developers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-apps\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-339\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003EApps\u003C\u002Fh2\u003E\u003Cp\u003EEasily connect any application on any device,\u003Cbr\u003Erunning on any platform.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"js-contains-videos\"\u003E\u003Cdiv class=\"browser-wallpaper shadow-box\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_w1qzsic31w endVideoBehavior=reset\" id=\"wistia_w1qzsic31w\" data-source=\"w1qzsic31w\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/apps");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row app-features\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"medium-icon rounded-icon any-app icon-budicon-254\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EAny application on any device\u003Cbr\u003Eand  any platform\u003C\u002Fh5\u003E\u003Cp\u003ETell us what you want to connect and get a seed project or customized instructions for connecting an existing app.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"medium-icon rounded-icon sdk icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EMultiple SDKs\u003C\u002Fh5\u003E\u003Cp\u003EAccess open-sourced official SDKs for\u003Cbr\u003E all popular web, mobile and native platforms, tailored to your specific account.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"medium-icon rounded-icon login-icon icon-budicon-375\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003ELogin Box Integration\u003C\u002Fh5\u003E\u003Cp\u003EUse our Login Widget or your own UI. Either way, we’ll help you set it up (with just a few lines of JavaScript).\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section-quote blue-gradient\"\u003E\u003Cdiv class=\"js-animated fadeIn\"\u003E\u003Ch5\u003EFrom our customers\u003C\u002Fh5\u003E\u003Cblockquote\u003E\u003Cp\u003E\"The Auth0 platform makes it easier for our developers and engineers to swiftly implement something ordinarily complicated.\"\u003C\u002Fp\u003E\u003C\u002Fblockquote\u003E\u003Cauthor\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Fhow-it-works\u002Fstephen-quote.jpg\"\u003E\u003Cstrong\u003EStephen Berard,\u003C\u002Fstrong\u003E\u003Cspan\u003E Senior Global Software Architect at Schneider Electric\u003C\u002Fspan\u003E\u003C\u002Fauthor\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-users clearfix\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-292\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003EUsers\u003C\u002Fh2\u003E\u003Cp\u003EAdd or remove users, modify profile and authorization attributes,\u003Cbr\u003Eand identify root-cause user login issues in minutes with a simple,\u003Cbr\u003Eintuitive and powerful web interface.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"user-list\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"shadow-box\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fuserlist-5ae6355485.png\"\u003E";
}
}, "https://manage.auth0.com/users");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row profiles-row\"\u003E\u003Cdiv class=\"pull-right text-subsection\"\u003E\u003Cdiv class=\"profiles-left\"\u003E\u003Ch3\u003EProfiles\u003C\u002Fh3\u003E\u003Cp\u003EAccess detailed profile information for each of your users, including authentication details, devices, login history and locations.\u003C\u002Fp\u003E\u003Cdiv class=\"subsection-showcase js-switch-profile\"\u003E\u003Cdiv class=\"profiles\"\u003E\u003Cdiv class=\"profile left\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-2-17aff08570.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"profile center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-1-8d7a6eeaf3.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"profile right\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-3-c762a6f9a4.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"profile back\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-4-a728c31bdb.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nav\"\u003E\u003Cdiv class=\"dot\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dot selected\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dot\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dot\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row edit-user-row\"\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"pull-left text-subsection\"\u003E\u003Cdiv class=\"manage-left\"\u003E\u003Ch3\u003EManage\u003C\u002Fh3\u003E\u003Cp\u003EEasily edit user profile information, remove or block users, or sign in as a user.\u003C\u002Fp\u003E\u003Cdiv class=\"subsection-showcase js-animated\"\u003E\u003Cdiv class=\"modal-edit js-edit-user-animation\"\u003E\u003Cdiv class=\"modal-edit-header\"\u003E\u003Ch5\u003EEDITING\u003C\u002Fh5\u003E\u003Ch4\u003Ericky@auth0.com\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-edit-content\"\u003E\u003Cform class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"Ricardo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"ricardo@auth0.com\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"Ricky22\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"N\u002FA\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"N\u002FA\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"N\u002FA\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-edit-footer\"\u003E\u003Cbutton class=\"btn btn-success btn-sm\"\u003Esave\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions-list\"\u003E\u003Cp class=\"change\"\u003E\u003Ci class=\"icon-budicon-290\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESign In as user\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"add\"\u003E\u003Ci class=\"icon-budicon-272\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EEdit\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"block\"\u003E\u003Ci class=\"icon-budicon-306\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ERemove\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row impersonate\"\u003E\u003Cdiv class=\"content\"\u003E\u003Ch3\u003ESign In As\u003C\u002Fh3\u003E\u003Cp\u003EWhatever the reason, Auth0 allows you to easily sign in as a user.\u003C\u002Fp\u003E\u003Cdiv class=\"select-user\"\u003E\u003Cdiv class=\"bubble-user icon-budicon-178\"\u003E\u003Cp\u003ESelect User\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dots-fill\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bubble-impersonate icon-budicon-315\"\u003E\u003Cp\u003EImpersonate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clean-gradient windows-row\"\u003E\u003Cdiv class=\"windows-tab shadow-box pull-left\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg class=\"desktop\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fsignin-972632254f.png\"\u003E";
}
}, "https://manage.auth0.com/user/12312312312");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"windows-tab shadow-box pull-right\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg class=\"desktop\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fmaterial-006b4d84a8.png\"\u003E";
}
}, "https://myapp.com");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"windows-linked\"\u003E\u003Csvg class=\"dots-no-fill\" width=\"73px\" height=\"20px\" viewbox=\"0 0 73 20\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cg stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"Shape-+-Shape-+-Shape\" sketch:type=\"MSLayerGroup\" fill=\"#44C7F4\"\u003E\u003Cpath class=\"shape s3 js-animated\" d=\"M60,2.33333333 L62.4594595,0 L73,10 L62.4594595,20 L60,17.6666667 L68.0810811,10 L60,2.33333333 Z\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath class=\"shape s2 js-animated\" d=\"M30,2.33333333 L32.4594595,0 L43,10 L32.4594595,20 L30,17.6666667 L38.0810811,10 L30,2.33333333 Z\" fill-opacity=\"0.6\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath class=\"shape s1 js-animated\" d=\"M0,2.33333333 L2.45945946,0 L13,10 L2.45945946,20 L0,17.6666667 L8.08108108,10 L0,2.33333333 Z\" fill-opacity=\"0.3\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-connections\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-339\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003EConnections\u003C\u002Fh2\u003E\u003Cp\u003EConnect your users to your apps in whatever ways you choose.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tabs js-video-switcher\"\u003E\u003Cdiv class=\"tab-content\"\u003E\u003Cdiv class=\"tab-list\"\u003E\u003Ca class=\"social active\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-292\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003ESocial\u003C\u002Fh5\u003E\u003Cp\u003E Authenticate users with popular social providers (Facebook, Twitter, etc).\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"enterprise\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-606\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EEnterprise\u003C\u002Fh5\u003E\u003Cp\u003EAuthenticate enterprise users using AD, LDAP, SAML and more.\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"database\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-690\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EDatabase\u003C\u002Fh5\u003E\u003Cp\u003EStore users’ credentials securely in Auth0’s data store or  your own.\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"passwordless\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-469\"\u003E\u003C\u002Fi\u003E\u003Ch5 class=\"abbr-desktop\"\u003EPasswordless\u003C\u002Fh5\u003E\u003Ch5 class=\"abbr-mobile\"\u003EPwdless\u003C\u002Fh5\u003E\u003Cp\u003EUse connections that don’t require the user to remember a password.\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"screenshots\"\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_ocd3f2o29y endVideoBehavior=reset\" id=\"wistia_ocd3f2o29y\" data-source=\"ocd3f2o29y\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/social");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_zwlxwzn141 endVideoBehavior=reset\" id=\"wistia_zwlxwzn141\" data-source=\"zwlxwzn141\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/enterprise");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_yb68zx3l0m endVideoBehavior=reset\" id=\"wistia_yb68zx3l0m\" data-source=\"yb68zx3l0m\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/database");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E\u003Cdiv class=\"iphone-dash animated fadeInUp hide\"\u003E\u003Cdiv class=\"hand-container\"\u003E\u003Cimg class=\"hand\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fpasswordless-3e471d6f9f.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_k35hr7f2fu dash-demo endVideoBehavior=reset\" id=\"wistia_k35hr7f2fu\" data-source=\"k35hr7f2fu\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/passwordless");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-lock\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"lock-intro\"\u003E\u003Cdiv class=\"content\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flock-logo-e12cf459ec.svg\"\u003E\u003Cp\u003EThe easiest way of securing your\u003Cbr\u003Ewebsite and mobile apps.\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"dashboard-lock\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"showcase-area\"\u003E\u003Cdiv class=\"iphone-lock animated fadeInUp hide\"\u003E\u003Cdiv class=\"hand-container\"\u003E\u003Cimg class=\"hand\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-c8d6945135.svg\"\u003E\u003Cdiv class=\"lock-no-googleplus\" id=\"iphone\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper js-contains-videos\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_sdwbx1gx5o lock-demo endVideoBehavior=reset\" id=\"wistia_sdwbx1gx5o\" data-source=\"sdwbx1gx5o\" style=\"width:900px;height:557px;\"\u003E\u003C\u002Fdiv\u003E";
}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-connections section-extensibility\"\u003E\u003Cdiv class=\"container\"\u003E\u003Csvg class=\"hide\" width=\"1500px\" id=\"networks\" height=\"231px\" viewbox=\"0 0 1500 231\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cg id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"Network\" sketch:type=\"MSLayerGroup\" transform=\"translate(0.000000, 1.000000)\"\u003E\u003Cpath id=\"Line\" d=\"M257.5,168.5 L295.5,74.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-15\" d=\"M386,187 L294,75\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-3\" d=\"M357,104 L295.5,74.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-6\" d=\"M434.5,142.5 L370.5,110.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-17\" d=\"M450,220 L434.5,142.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-44\" d=\"M434,141 L436.5,41.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-39\" d=\"M496,183 L479,98\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-16\" d=\"M454,20 L365.5,106.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-18\" d=\"M626,81 L475.5,98.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-19\" d=\"M786,62 L635.5,79.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-20\" d=\"M699,183 L634.5,79.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-21\" d=\"M699,183.5 L585.5,183.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-46\" d=\"M584,183.5 L495.5,183.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-38\" d=\"M1207,167 L1117,164\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-12\" d=\"M451,220 L386,188\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-13\" d=\"M585,185 C585,185 566.203879,169.441489 556.805819,161.662233 C531.370546,140.608155 480.5,98.5 480.5,98.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-11\" d=\"M475,101 L434.5,142.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-42\" d=\"M255,171 L213,215\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-14\" d=\"M490,189 L451.5,218.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-9\" d=\"M384,181 L366.5,109.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line\" d=\"M176.5,87.5 L250.286858,161.286858\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-43\" d=\"M170.5,81.5 L212.5,214.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-45\" d=\"M0.5,8.5 L213.5,218.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-40\" d=\"M255.5,168.5 L382.5,188.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-37\" d=\"M877.5,148.5 L915.5,54.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-22\" d=\"M1006,167 L914,55\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-23\" d=\"M985.5,88.5 L914.5,53.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-24\" d=\"M1052,120 L990.5,90.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-25\" d=\"M1071,200 L1055.5,122.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-26\" d=\"M1074,0 L985.5,86.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-27\" d=\"M1246,61 L1095.5,78.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-28\" d=\"M1494.5,31.5 L1255.5,59.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-29\" d=\"M1319,163 L1254.5,59.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-30\" d=\"M1320,167.5 L1206.5,167.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-41\" d=\"M1493,29 L1319.5,166\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-31\" d=\"M1071,200 L1006.5,167.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-32\" d=\"M1205,165 C1205,165 1186.20388,149.441489 1176.80582,141.662233 C1151.37055,120.608155 1100.5,78.5 1100.5,78.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-33\" d=\"M1096,80 L1055.5,121.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-34\" d=\"M1110,169 L1071.5,198.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-35\" d=\"M1004,161 L986.5,89.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-36\" d=\"M796.5,67.5 L870.286858,141.286858\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Ccircle id=\"Oval-50\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"790\" cy=\"61\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-51\" stroke=\"#1F242E\" stroke-width=\"2\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"915\" cy=\"54\" r=\"6\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-37\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"170\" cy=\"81\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-40\" stroke=\"#1F242E\" stroke-width=\"2\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"295\" cy=\"74\" r=\"6\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-39\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"257\" cy=\"168\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-61\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"213\" cy=\"217\" r=\"5\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-42\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"366\" cy=\"108\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-44\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"386\" cy=\"188\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-47\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"449\" cy=\"221\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-43\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"479\" cy=\"98\" r=\"5\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-48\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"634\" cy=\"80\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-49\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"699\" cy=\"186\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-45\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"584\" cy=\"184\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Cpath id=\"Oval-46\" d=\"M497,192 C501.418278,192 505,188.418278 505,184 C505,179.581722 501.418278,176 497,176 C492.581722,176 489,179.581722 489,184 C489,188.418278 492.581722,192 497,192 L497,192 L497,192 Z\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Ccircle id=\"Oval-52\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"877\" cy=\"148\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-53\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"986\" cy=\"88\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-54\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1006\" cy=\"168\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-55\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1098\" cy=\"78\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-56\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1254\" cy=\"60\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-57\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1319\" cy=\"166\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-57-2\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1490\" cy=\"33\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-57-3\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"436\" cy=\"43\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-58\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1207\" cy=\"167\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Cpath id=\"Oval-59\" d=\"M1117,172 C1121.41828,172 1125,168.418278 1125,164 C1125,159.581722 1121.41828,156 1117,156 C1112.58172,156 1109,159.581722 1109,164 C1109,168.418278 1112.58172,172 1117,172 L1117,172 L1117,172 Z\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Oval-60\" d=\"M1071,208 C1075.41828,208 1079,204.418278 1079,200 C1079,195.581722 1075.41828,192 1071,192 C1066.58172,192 1063,195.581722 1063,200 C1063,204.418278 1066.58172,208 1071,208 L1071,208 L1071,208 Z\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-424\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003EExtensibility\u003C\u002Fh2\u003E\u003Cp\u003EFully customize any stage of the authentication\u003Cbr\u003Eand authorization pipeline.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tabs js-video-switcher\"\u003E\u003Cdiv class=\"tab-content\"\u003E\u003Cdiv class=\"tab-list\"\u003E\u003Ca class=\"rules active\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-173\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003ERules\u003C\u002Fh5\u003E\u003Cp\u003EEasily create your own rules that will be executed as part of the authentication pipeline every time a user authenticates to an app.\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"emails\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-778\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EEmails\u003C\u002Fh5\u003E\u003Cp\u003ECustomize and turn on or off email templates to verify users, change passwords and welcome them to your application.\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"addons\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-325\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EAdd-ons\u003C\u002Fh5\u003E\u003Cp\u003EAuth0 offers additional features such as premium support, guaranteed SLA and\u003Cbr\u003E3rd party app SSO.\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"screenshots\"\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_kpxvm1hg3u endVideoBehavior=reset\" id=\"wistia_kpxvm1hg3u\" data-source=\"kpxvm1hg3u\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/rules");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_436ragkpmt lock-demo endVideoBehavior=reset\" id=\"wistia_436ragkpmt\" data-source=\"436ragkpmt\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/emails");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_5q738mjeip endVideoBehavior=reset\" id=\"wistia_5q738mjeip\" data-source=\"5q738mjeip\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/apps/addons");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-mobile\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-7\"\u003E\u003Cimg class=\"iphone-left hide js-animated-after fadeInUp\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-2-56d4c9bc89.png\"\u003E\u003Cimg class=\"iphone-right js-animated fadeInUp\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-1-19443be8d0.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003Ch2\u003EMobile Ready\u003C\u002Fh2\u003E\u003Cp\u003EAuth0 works with every popular mobile platform, including iOS, Android and\nWindows Phone 8. Users can seamlessly authenticate through the mobile-ready\nLock widget and, coming soon, you'll be able to access your dashboard through a mobile-friendly interface, too.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-end\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"small-icon support icon-budicon-513\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003ESupport 24\u002F7\u003C\u002Fh4\u003E\u003Cp\u003EWe’re always available to&nbsp;\u003Ca href=\"\u002Fsupport\"\u003Ehelp\u003C\u002Fa\u003E. Browse our&nbsp;\u003Ca href=\"\u002Fdocs\"\u003E documentation\u003C\u002Fa\u003E or reach out via email or chat, anytime. We’ll do what it takes to continually delight our subscribers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"small-icon fairly icon-budicon-112\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003EFair Pricing\u003C\u002Fh4\u003E\u003Cp\u003EGet a full-featured, free developer account. No credit card required. No commitment. When you’re ready to go to production we’ve got flexible pricing plans\u003Ca href=\"\u002Fpricing\"\u003E to fit your needs.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"small-icon logs icon-budicon-754\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003ELogs\u003C\u002Fh4\u003E\u003Cp\u003EAccess user logs showing login and registration information for a rolling two-day time frame, or upgrade your account to see and search logs for longer periods of time.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"create-account\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EStart your free trial today\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"dashboard-bottom\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math) {var rand  = Math.random();
var lockSlideActive = rand > 0.3 ? 'active' : '';
var auth0SlideActive = rand <= 0.3 ? 'active' : '';




pug_html = pug_html + "\u003Cdiv class=\"enterprise-page page-content\"\u003E\u003Cstyle type=\"text\u002Fcss\"\u003E.wow {\n  visibility: hidden;\n}\n\u003C\u002Fstyle\u003E\u003Cdiv class=\"carousel hero\" id=\"carousel\" data-ride=\"carousel\" data-interval=\"10000\" data-pause=\"true\"\u003E\u003Cdiv class=\"carousel-control-wrapper\"\u003E\u003Ca class=\"left carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"prev\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"right carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"next\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"carousel-inner\" role=\"listbox\"\u003E\u003Cdiv class=\"slide slide-1 item active\"\u003E\u003Cdiv class=\"hero-side-pane left\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"hero-text-content animated fadeIn col-xs-12 col-sm-6\"\u003E\u003Ch1 class=\"hero-header\"\u003EIdentity that\u003Cbr class=\"rm-break\"\u003E Just Works\u003C\u002Fh1\u003E\u003Cp class=\"hero-description\"\u003EAuthentication, Authorization and Identity Management are essential to every Web and mobile app.\u003Cbr \u002F\u003E\u003Cbr \u002F\u003E\nAuth0 handles those functions as a self-hosted appliance and a public cloud service so your team can focus and save time.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"https:\u002F\u002Fauth0.com\u002Fhow-it-works\"\u003EHOW IT WORKS\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-side-pane right animated fadeIn\"\u003E\u003Cdiv class=\"hero-graphic-container\"\u003E\u003Cimg class=\"hero-side-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-slide-01-74e5533d3f.png\" alt=\"Cloud Identity\"\u003E\u003Cdiv class=\"animation-overlay\"\u003E\u003Cdiv class=\"modem\"\u003E\u003Cdiv class=\"left-lights\"\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"right-lights\"\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modem\"\u003E\u003Cdiv class=\"left-lights\"\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"right-lights\"\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modem\"\u003E\u003Cdiv class=\"left-lights\"\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"right-lights\"\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"light\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide slide-2 item\"\u003E\u003Cdiv class=\"hero-side-pane left\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"hero-text-content animated fadeIn col-xs-12 col-sm-12 col-sm-6\"\u003E\u003Ch1 class=\"hero-header\"\u003EWho Uses\u003Cbr class=\"rm-break\"\u003E Auth0?\u003C\u002Fh1\u003E\u003Cp class=\"hero-description\"\u003EEnterprises of all sizes are powering their digital initiatives with Auth0.\u003Cbr \u002F\u003E\u003Cbr \u002F\u003E\nOur customers use Auth0’s IDaaS to support the latest best practices: multifactor auth, social logins and passwordless login.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"\u002Fcustomers\"\u003EOUR CUSTOMERS\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-side-pane right animated fadeIn\"\u003E\u003Cimg class=\"hero-side-image hidden-sm hidden-md hidden-lg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-slide-02-mobile-071209f929.png\" alt=\"Auth0 Customers\"\u003E\u003Cimg class=\"hero-side-image hidden-xs hidden-lg\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-slide-02-tablet-ed35b9a4ff.png\" alt=\"Auth0 Customers\"\u003E\u003Cdiv class=\"brand-circles-container animated fadeIn hidden-xs hidden-sm hidden-md\"\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-safari-91af3de588.svg\" alt=\"Safari Books Online\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-schneider-5a59167023.svg\" alt=\"Schneider Electric\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-houghton-4b87092568.svg\" alt=\"Houghton Mifflin Harcourt\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-chrobinson-4d57d85dec.png\" alt=\"C.H. Robinson Worldwide, Inc.\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-jetprivilege-3797807c04.png\" alt=\"Jet Privilege\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-marks-spencer-f948189271.svg\" alt=\"Marks &amp; Spencer\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-harvard-90c69a9ab9.svg\" alt=\"Harvard Medical School\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-newscorp-0dab593d7b.svg\" alt=\"NewsCorp\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-optimizely-996efbfb3d.svg\" alt=\"Optimizely\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"brand-circle\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fhero-logo-dowjones-82f152280f.svg\" alt=\"Dow Jones\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide slide-3 item\"\u003E\u003Cdiv class=\"hero-side-pane left\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"hero-text-content animated fadeIn col-xs-12 col-sm-12 col-sm-6\"\u003E\u003Ch1 class=\"hero-header\"\u003EBe an \u003Cbr class=\"rm-break\"\u003E Authentication Hero\u003C\u002Fh1\u003E\u003Cp class=\"hero-description animated fadeIn\"\u003EWith Auth0, enabling social login is a simple slider. Add Facebook, Google, Weibo, or dozens of other providers.\u003Cbr \u002F\u003E\u003Cbr \u002F\u003E\nFeatures like SAML, LDAP, Salesforce, legacy database connectors, multifactor, passwordless, and Touch ID are just as easy and secure.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003EBE A HERO\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-side-pane right animated fadeIn\"\u003E\u003Cdiv class=\"system-container\"\u003E\u003Cdiv class=\"system-orbits\"\u003E\u003Cdiv class=\"orbit1\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"orbit2\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"orbit3\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"orbit4\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"system-content\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fauth0-badge-c89b60cf14.svg\" alt=\"Auth0 Logo\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"system-particles\"\u003E";
for(var x = 0;x <= 11;x++)
{
pug_html = pug_html + "\u003Cdiv class=\"system-particle\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Col class=\"carousel-indicators\"\u003E\u003Cli class=\"active\" data-target=\"#carousel\" data-slide-to=\"0\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"1\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"2\"\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"featured-customers\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-12 col-md-4\"\u003E\u003Cdiv class=\"customer\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fschneider-electric-case-study\u002F\" rel=\"external\"\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fcustomer-schneider-logo-9ce31ac812.png\" alt=\"Enterprise Identity Case Study - Schneider Electric\"\u003E\u003Cp class=\"customer-description\"\u003E\"The Auth0 platform makes it easier for our developers and engineers to swiftly implement something ordinarily complicated.\"\u003C\u002Fp\u003E\u003Cspan class=\"customer-signature\"\u003EStephen Berard, \u003Cbr\u003E\nSchneider Electric\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-link\"\u003E\u003Cspan\u003ERead the case Study\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4\"\u003E\u003Cdiv class=\"customer\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fharvard-medical-school-identity-secures-nih-research\u002F\" rel=\"external\"\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fcustomer-harvard-logo-788c718abb.png\" alt=\"Enterprise Identity Case Study - Harvard Medical School\"\u003E\u003Cp class=\"customer-description\"\u003E\"I’m a big proponent of letting experts do what they do best. I didn’t want to rely on building ourselves.\"\u003C\u002Fp\u003E\u003Cspan class=\"customer-signature\"\u003EDavid Bernick, \u003Cbr\u003E\nHarvard Medical School\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-link\"\u003E\u003Cspan\u003ERead the case Study\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-4\"\u003E\u003Cdiv class=\"customer\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fmarks-spencer-auth0-authentication-scalability-in-action\u002F\" rel=\"external\"\u003E\u003Cdiv class=\"customer-content\"\u003E\u003Cimg class=\"customer-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fcustomer-smarksspencer-logo-7a580f163e.png\" alt=\"Enterprise Identity Case Study - Marks &amp; Spencer\"\u003E\u003Cp class=\"customer-description\"\u003E\"Auth0 provided the perfect fit of out-of-the-box features, flexibility and enterprise-level service.\"\u003C\u002Fp\u003E\u003Cspan class=\"customer-signature\"\u003EAKQA delivering to\u003Cbr\u003E\nMarks & Spencer\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customer-link\"\u003E\u003Cspan\u003ERead the case Study\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"all-purpose\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"all-purpose-title\"\u003EWorks Everywhere\u003C\u002Fdiv\u003E\u003Cdiv class=\"all-purpose-description\"\u003EAuth0 is a universal identity clearinghouse. Any application - mobile, web, enterprise - written with any framework. And any Identity Provider (IdP) from popular social sites to enterprise IdPs like Active Directory, SAML, and legacy databases. \u003Cbr \u002F\u003E\nWith just a few lines of code, you can implement secure, comprehensive identity management.\u003C\u002Fdiv\u003E\u003Cdiv class=\"all-purpose-graph\"\u003E\u003Cdiv class=\"left-circle-graph\"\u003E\u003Cdiv class=\"circle-content\"\u003E\u003Ch3 class=\"circle-title\"\u003ESDKs\u003C\u002Fh3\u003E\u003Cp class=\"circle-subtitle\"\u003Eany development stack\u003C\u002Fp\u003E\u003Cdiv class=\"top-row-logos\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"android\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fnative\u002Fandroid\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"apple\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fnative\u002Fios-objc\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"middle-row-logos\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"php\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fphp\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"python\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fpython\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"nodejs\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fnodejs\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-row-logos\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"java\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Fjava\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"windows\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fquickstart\u002Fwebapp\u002Faspnet\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"circle-subtitle\"\u003Eand many more\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"auth0-badge wow fadeIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fstyleguide\u002Fcomponents\u002F1.0.8\u002Fmedia\u002Flogos\u002Fimg\u002Fbadge.png\" alt=\"Auth0 Logo\" data-wow-delay=\"1s\"\u003E\u003Cdiv class=\"right-circle-graph\"\u003E\u003Cdiv class=\"circle-content\"\u003E\u003Ch3 class=\"circle-title\"\u003EIdPs\u003C\u002Fh3\u003E\u003Cp class=\"circle-subtitle\"\u003Eany source of identity\u003C\u002Fp\u003E\u003Cdiv class=\"top-row-logos\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"facebook\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fsocial\u002Ffacebook\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"twitter\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fsocial\u002Ftwitter\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"middle-row-logos\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"aws\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fsocial\u002Famazon\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"cloud\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fsocial\u002Fsalesforce\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"saml\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-row-logos\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"aad\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fenterprise\u002Fazure-active-directory\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"google\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fsocial\u002Fgoogle\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"circle-subtitle\"\u003E+39 more\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-links\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\" rel=\"external\"\u003EMore SDKs\u003C\u002Fa\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\" rel=\"external\"\u003EMore IdPs\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"business-focus\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch1 class=\"business-title\"\u003EBusiness Focus\u003C\u002Fh1\u003E\u003Cp class=\"business-description\"\u003EBy using Auth0, development teams gain business focus.\nYou can integrate new IdP’s instantly, enable the latest best practices like multifactor authentication or progressive user profiling, and provide security services like rejected password rate limiting.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"build-buy-graph\"\u003E\u003Cdiv class=\"left-col\"\u003E\u003Cp class=\"painted\"\u003ECompetitive Advantage\u003C\u002Fp\u003E\u003Cdiv class=\"fade-bar\"\u003E\u003C\u002Fdiv\u003E\u003Cp class=\"painted\"\u003EPlatform\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"right-col\"\u003E\u003Cdiv class=\"graph-row\"\u003E\u003Cdiv class=\"graph-cell small\"\u003E\u003Cp class=\"painted\"\u003EBuild this\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"graph-cell big\"\u003E\u003Cp class=\"painted\"\u003EYOUR BUSINESS CORE APPLICATION VALUE\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"graph-row\"\u003E\u003Cdiv class=\"graph-cell small\"\u003E\u003Cp class=\"painted\"\u003EBuy this\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"graph-cell big\"\u003E\u003Cdiv class=\"inner-cell\"\u003E\u003Cspan class=\"auth0-cell\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fauth0-small-badge-2403a5b44c.svg\" alt=\"Auth0 Logo\"\u003E\u003Cp\u003EAUTH0 IDaaS\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"inner-cell\"\u003E\u003Cp class=\"painted\"\u003EOTHER\u003Cbr class=\"rm-break\"\u003E SERVICES\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"inner-cell big\"\u003E\u003Cp class=\"painted\"\u003EAPPLICATION STACK\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"http:\u002F\u002Fresources.auth0.com\u002Fbuild-vs-buy-evaluating-identity-management\u002F\" rel=\"external\"\u003EBUILD vs BUY\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"modern-standards\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cimg class=\"modern-standards-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fjwt-logo-189bdd211e.svg\" alt=\"Json Web Tokens Logo\"\u003E\u003Ch1 class=\"modern-standards-title\"\u003EModern Standards\u003C\u002Fh1\u003E\u003Cp class=\"modern-standards-description\"\u003EAuth0 uses JSON Web Tokens (JWT) to implement security protocols like Single Sign-On with OAuth.\nJWT’s benefits include fast verification, openness (RFC 7519), security, and interoperability.\nAuth0 also supports OpenID, SAML, LDAP, Active Directory and REST.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fjson-web-tokens\u002F\" rel=\"external\"\u003EHow to use JWT Tokens\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"trusted\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1 class=\"title\"\u003ETrusted\u003C\u002Fh1\u003E\u003Cdiv class=\"flex-container\"\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"trusted-card\"\u003E\u003Cdiv class=\"trusted-content\"\u003E\u003Cdiv class=\"trusted-icon security\"\u003E\u003Ci class=\"icon-budicon-285 icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-headline\"\u003ESecurity\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-description\"\u003EWe follow the latest security bulletins, fixing issues so you don’t have to.\nAnd you can gain the benefit of powerful security features like Multi-factor Authentication - in minutes.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-link\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"trusted-card\"\u003E\u003Cdiv class=\"trusted-content\"\u003E\u003Cdiv class=\"trusted-icon scalability\"\u003E\u003Ci class=\"icon-budicon-378 icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-headline\"\u003EScalability\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-description\"\u003EFirst impressions count. Auth0 makes it effortless to deliver a brilliant user experience that adds sparkle to your brand.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-link\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Favailability-trust\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"trusted-card\"\u003E\u003Cdiv class=\"trusted-content\"\u003E\u003Cdiv class=\"trusted-icon simplicity\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fenterprise\u002Fimg\u002Fauth0-shape-f316431392.svg\" alt=\"Auth0 Logo\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-headline\"\u003ESimplicity\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-description\"\u003EAuth0 is a modern Identity-as-a-Service platform able to tackle the most demanding use cases.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-link\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flock\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flex-col\"\u003E\u003Cdiv class=\"trusted-card interoperability\"\u003E\u003Cdiv class=\"trusted-content\"\u003E\u003Cdiv class=\"trusted-icon interoperability\"\u003E\u003Ci class=\"icon-budicon-341 icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-headline\"\u003EInteroperability\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-description\"\u003EWe follow the latest security bulletins, fixing issues so you don’t have to.\nAnd you can gain the benefit of powerful security features like Multi-factor Authentication - in minutes.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"trusted-link\"\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fmigrate-user-database-auth0\u002F\" rel=\"external\"\u003EDB MIGRATION EXAMPLE\u003C\u002Fa\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2016\u002F02\u002F02\u002Fswitching-from-social-logins-to-saml-in-minutes-with-auth0\u002F\" rel=\"external\"\u003EEASY SAML INTEGRATION\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"contact-form-section\" id=\"contact-us\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cform class=\"contact-form\"\u003E\u003Ch1 class=\"form-title\"\u003EContact Us\u003C\u002Fh1\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel\u003EName\u003Cinput type=\"text\" name=\"name\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel\u003ECompany\u003Cinput type=\"text\" name=\"company\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel for=\"email\"\u003EEmail\u003Cinput type=\"email\" name=\"email\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel\u003ERole\u003Cselect name=\"role\" required\u003E\u003Coption\u003ESoftware Developer\u003C\u002Foption\u003E\u003Coption\u003EEngineering Exec \u002F Management\u003C\u002Foption\u003E\u003Coption\u003EC-Level\u003C\u002Foption\u003E\u003Coption\u003EIT operations\u003C\u002Foption\u003E\u003Coption\u003EProduct Management\u003C\u002Foption\u003E\u003Coption\u003ESales\u003C\u002Foption\u003E\u003Coption\u003EMarketing\u003C\u002Foption\u003E\u003Coption\u003ESecurity & Compliance\u003C\u002Foption\u003E\u003Coption\u003EOther\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Clabel class=\"textarea\"\u003EMessage\u003Ctextarea name=\"message\" required\u003E\u003C\u002Ftextarea\u003E\u003C\u002Flabel\u003E\u003Cbutton class=\"btn btn-lg btn-success\" type=\"submit\"\u003Esend\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"events-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fevents-landing\u002Fimg\u002Flogo-speaker-2e438aa3f3.svg\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EAuth0 Talks\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-info\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"column event-title\"\u003E\u003Ch2\u003EMake your SPA a maximum security prison\u003C\u002Fh2\u003E\u003Cp\u003ELearn how to add authentication to an Angular 1 and Angular 2 app very easily!\u003C\u002Fp\u003E\u003Cdiv class=\"host\"\u003E\u003Cimg src=\"https:\u002F\u002Fwww.gravatar.com\u002Favatar\u002Fdf6c864847fba9687d962cb80b482764?size=200\"\u003E\u003Ch3\u003EMartín Gontovnikas\u003C\u002Fh3\u003E\u003Cp\u003EDeveloper Advocate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column event-spot\"\u003E\u003Cdiv class=\"event-logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fd1n4bbuvjcnilu.cloudfront.net\u002FContent\u002Fng\u002Fangu\u002Fimages\u002Fangularu_100x100bluenew.png\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EAngularU\u003C\u002Fh3\u003E\u003Cdiv class=\"date\"\u003E\u003Ci class=\"icon-budicon-629\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EJune 22th, 2015\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"place\"\u003E\u003Ci class=\"icon-budicon-632\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESan Francisco, California\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"introduction\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EIntroduction\u003C\u002Fh2\u003E\u003Cp\u003EEverybody has been creating Single Page Apps lately. They look neat and fast. Handling authentication in an SPA can be tricky though: Cookies, Tokens, keeping the user authenticated and handling rights to access URLs and resources are some of the things we need to take care of. In this talk, we’ll learn how to add authentication to an AngularJS app with a live coding session in which we’ll go from a regular SPA to a fully secured one.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"slides\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"btn btn-success\" href=\"\u002F\u002Fmgonto.github.io\u002Fa-token-walks-into-a-SPA\u002F\" target=\"_blank\"\u003EGet Slides\u003C\u002Fa\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-708\"\u003E\u003C\u002Fi\u003ESlides\u003C\u002Fh2\u003E\u003Ciframe src=\"\u002F\u002Fmgonto.github.io\u002Fa-token-walks-into-a-SPA\u002F\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"resources\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-732\"\u003E\u003C\u002Fi\u003EExtra Resources\u003C\u002Fh2\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Fa-token-walks-into-a-SPA\" target=\"_blank\"\u003E\u003Ch4\u003ESlides\u003C\u002Fh4\u003E\u003Cp\u003EThis repository has the HTML and CSS for the slides.\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Fa-token-walks-into-a-SPA\" target=\"_blank\"\u003Egithub.com\u002Fmgonto\u002Fa-token-walks-into-a-SPA\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2015\u002F05\u002F14\u002Fcreating-your-first-real-world-angular-2-app-from-authentication-to-calling-an-api-and-everything-in-between\u002F\" target=\"_blank\"\u003E\u003Ch4\u003EAdd authentication to an Angular 2 app blogpost\u003C\u002Fh4\u003E\u003Cp\u003EA blogpost explaining how to add authentication to an Angular 2 app\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2015\u002F05\u002F14\u002Fcreating-your-first-real-world-angular-2-app-from-authentication-to-calling-an-api-and-everything-in-between\u002F\" target=\"_blank\"\u003Eauth0.com\u002Fblog\u002F2015\u002F05\u002F14\u002Fcreating-your-first-angular-2-app\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fangular2-authentication-sample\" target=\"_blank\"\u003E\u003Ch4\u003ESample code\u003C\u002Fh4\u003E\u003Cp\u003EThe sample repository shown on the presentation can be downloaded here\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fangular2-authentication-sample\" target=\"_blank\"\u003Egithub.com\u002Fauth0\u002Fangular2-authentication-sample\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2014\u002F01\u002F07\u002Fangularjs-authentication-with-cookies-vs-token\u002F\" target=\"_blank\"\u003E\u003Ch4\u003EAdd authentication to an angularjs 1 app blogpost\u003C\u002Fh4\u003E\u003Cp\u003EA blogpost explaining how to add authentication to an angular 1 app\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2014\u002F01\u002F07\u002Fangularjs-authentication-with-cookies-vs-token\u002F\" target=\"_blank\"\u003Eauth0.com\u002Fblog\u002F2014\u002F01\u002F07\u002Fangularjs-authentication-with-cookies-vs-token\u002F\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EUse Auth0 for free\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"events-angularu\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"events-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fevents-landing\u002Fimg\u002Flogo-speaker-2e438aa3f3.svg\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EAuth0 Talks\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-info\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"column event-title\"\u003E\u003Ch2\u003EDeath to cookies: Long live JSON Web Tokens\u003C\u002Fh2\u003E\u003Cp\u003ELearn how to add authentication to a Vanilla JS SPA very easily using JSON Web Tokens!\u003C\u002Fp\u003E\u003Cdiv class=\"host\"\u003E\u003Cimg src=\"https:\u002F\u002Fwww.gravatar.com\u002Favatar\u002Fdf6c864847fba9687d962cb80b482764?size=200\"\u003E\u003Ch3\u003EMartín Gontovnikas\u003C\u002Fh3\u003E\u003Cp\u003EDoer\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column event-spot\"\u003E\u003Cdiv class=\"event-logo\"\u003E\u003Cimg src=\"http:\u002F\u002F2015.cascadiajs.com\u002Fassets\u002Fimg\u002Faqua-tree.svg\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003ECascadia Fest\u003C\u002Fh3\u003E\u003Cdiv class=\"date\"\u003E\u003Ci class=\"icon-budicon-629\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EJuly 8th, 2015\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"place\"\u003E\u003Ci class=\"icon-budicon-632\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESemiahmoo, Washington\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"introduction\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EIntroduction\u003C\u002Fh2\u003E\u003Cp\u003ECookies have been around for decades and have served us well. Nobody questions their usefulness. However, modern apps demand a better approach. This session is all about the natural successor to cookies: using a token-based design. Tokens help build apps that are assembled on multiple stacks, that use your own and 3rd party APIs, that run on-premises and the cloud. They help easily “flow” user identity across all layers and security contexts, regardless of how they authenticated. And they help you deal with CORS and XSRF. Join a code session in which we’ll implement a token-based app using AngularJs and an API.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"slides\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"btn btn-success\" href=\"\u002F\u002Fmgonto.github.io\u002Fdeath-to-cookies-cascadia\u002F\" target=\"_blank\"\u003EGet Slides\u003C\u002Fa\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-708\"\u003E\u003C\u002Fi\u003ESlides\u003C\u002Fh2\u003E\u003Ciframe src=\"\u002F\u002Fmgonto.github.io\u002Fdeath-to-cookies-cascadia\u002F\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"resources\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-732\"\u003E\u003C\u002Fi\u003EExtra Resources\u003C\u002Fh2\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Fdeath-to-cookies-cascadia\" target=\"_blank\"\u003E\u003Ch4\u003ESlides\u003C\u002Fh4\u003E\u003Cp\u003EThis repository has the HTML and CSS for the slides.\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Fdeath-to-cookies-cascadia\" target=\"_blank\"\u003Egithub.com\u002Fmgonto\u002Fdeath-to-cookies-cascadia\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fjwt.io\" target=\"_blank\"\u003E\u003Ch4\u003EJSON Web Token debugger & OSS repos browser\u003C\u002Fh4\u003E\u003Cp\u003EDebug JSON Web Tokens and learn which is the best OSS JWT handler for each language\u003C\u002Fp\u003E\u003Ca href=\"http:\u002F\u002Fjwt.io\" target=\"_blank\"\u003Ejwt.io\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fspa-jwt-authentication-tutorial\" target=\"_blank\"\u003E\u003Ch4\u003ESample code\u003C\u002Fh4\u003E\u003Cp\u003EThe sample repository shown on the presentation can be downloaded here\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fspa-jwt-authentication-tutorial\" target=\"_blank\"\u003Egithub.com\u002Fauth0\u002Fangular2-authentication-sample\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2015\u002F04\u002F09\u002Fadding-authentication-to-your-react-flux-app\u002F\" target=\"_blank\"\u003E\u003Ch4\u003EAdd authentication to a React app blogpost\u003C\u002Fh4\u003E\u003Cp\u003EA blogpost explaining how to add authentication to a React app\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2015\u002F04\u002F09\u002Fadding-authentication-to-your-react-flux-app\u002F\" target=\"_blank\"\u003Eauth0.com\u002Fblog\u002F2014\u002F01\u002F07\u002Fangularjs-authentication-with-cookies-vs-token\u002F\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EUse Auth0 for free\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"events-cascadia\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"events-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fevents-landing\u002Fimg\u002Flogo-speaker-2e438aa3f3.svg\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EAuth0 Talks\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-info\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"column event-title\"\u003E\u003Ch2\u003ERethinking backend with webtasks\u003C\u002Fh2\u003E\u003Cp\u003ELearn what Webtasks are and how we can write Backend code in our FrontEnd app.\u003C\u002Fp\u003E\u003Cdiv class=\"host\"\u003E\u003Cimg src=\"https:\u002F\u002Fwww.gravatar.com\u002Favatar\u002Fdf6c864847fba9687d962cb80b482764?size=200\"\u003E\u003Ch3\u003EMartín Gontovnikas\u003C\u002Fh3\u003E\u003Cp\u003EDeveloper Advocate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column event-spot\"\u003E\u003Cdiv class=\"event-logo\" style=\"background-color:#000;\"\u003E\u003Cimg src=\"http:\u002F\u002Ffrontendconf.ch\u002Fwp-content\u002Fuploads\u002F2015\u002F05\u002Flogo-frontend-conference-zurich-no-text-white.png\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EFEC 2015\u003C\u002Fh3\u003E\u003Cdiv class=\"date\"\u003E\u003Ci class=\"icon-budicon-629\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EAugust 26th, 2015\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"place\"\u003E\u003Ci class=\"icon-budicon-632\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EZurich, Switzerland\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"introduction\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EIntroduction\u003C\u002Fh2\u003E\u003Cp\u003EYou are writing a mobile or HTML5 web application that needs just a little bit of a backend. Maybe you want to access MongoDB, send an SMS, or an e-mail. Do you really need to host your own Node.js service to run this small snippet of backend logic? In this talk I will take a hard look at the role of the backend in modern applications. I will introduce the concept of a webtask – a lightweight representation of backend logic that can safely be embedded in a client application. I will show how you can use modern container technologies based on CoreOS and Docker to build a generic runtime for securely executing web tasks directly from a mobile or HTML5 application. You don’t need a backend to run backend code.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"slides\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"btn btn-success\" href=\"https:\u002F\u002Fmgonto.github.io\u002Ffront-is-the-new-back\u002F\" target=\"_blank\"\u003EGet Slides\u003C\u002Fa\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-708\"\u003E\u003C\u002Fi\u003ESlides\u003C\u002Fh2\u003E\u003Ciframe src=\"https:\u002F\u002Fmgonto.github.io\u002Ffront-is-the-new-back\u002F\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"resources\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-732\"\u003E\u003C\u002Fi\u003EExtra Resources\u003C\u002Fh2\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Ffront-is-the-new-back\" target=\"_blank\"\u003E\u003Ch4\u003ESlides and Code samples\u003C\u002Fh4\u003E\u003Cp\u003EThis repository has the HTML and JS for the slides as well as the code samples shown in the presentation\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Ffront-is-the-new-back\" target=\"_blank\"\u003Egithub.com\u002Fmgonto\u002Ffront-is-the-new-back\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fwebtask.io\" target=\"_blank\"\u003E\u003Ch4\u003EWebtask.io\u003C\u002Fh4\u003E\u003Cp\u003EWebtask playground\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fwebtask.io\" target=\"_blank\"\u003Ewebtask.io\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fwebtask-runner\" target=\"_blank\"\u003E\u003Ch4\u003EWebtask Runner\u003C\u002Fh4\u003E\u003Cp\u003EOpen source Webtask runner shown in the presentation\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fwebtask-runner\" target=\"_blank\"\u003Egithub.com\u002Fauth0\u002Fwebtask-runner\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Ftomasz.janczuk.org\u002F2015\u002F04\u002Frethinking-backend-with-webtasks.html\" target=\"_blank\"\u003E\u003Ch4\u003EWebtask concenpt explanation\u003C\u002Fh4\u003E\u003Cp\u003EBlogpost explaining Webtask concept\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Ftomasz.janczuk.org\u002F2015\u002F04\u002Frethinking-backend-with-webtasks.html\" target=\"_blank\"\u003Etomasz.janczuk.org\u002F2015\u002F04\u002Frethinking-backend-with-webtasks.html\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EUse Auth0 for free\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"events-fec15\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"events-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fevents-landing\u002Fimg\u002Flogo-speaker-2e438aa3f3.svg\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EAuth0 Talks\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-info\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"column event-title\"\u003E\u003Ch2\u003EReactive FrontEnd\u003C\u002Fh2\u003E\u003Cp\u003ELearn what Observables, Stream and Reactive Programming are in this amazing talk\u003C\u002Fp\u003E\u003Cdiv class=\"host\"\u003E\u003Cimg src=\"https:\u002F\u002Fwww.gravatar.com\u002Favatar\u002Fdf6c864847fba9687d962cb80b482764?size=200\"\u003E\u003Ch3\u003EMartín Gontovnikas\u003C\u002Fh3\u003E\u003Cp\u003EDeveloper Advocate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column event-spot\"\u003E\u003Cdiv class=\"event-logo\"\u003E\u003Cimg src=\"http:\u002F\u002Fforwardjs.com\u002Fsummit\u002Fimg\u002Fforward3-logo@2x.png\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EForwardJS\u003C\u002Fh3\u003E\u003Cdiv class=\"date\"\u003E\u003Ci class=\"icon-budicon-629\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EJuly 28th, 2015\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"place\"\u003E\u003Ci class=\"icon-budicon-632\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESan Fransisco, California\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"introduction\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EIntroduction\u003C\u002Fh2\u003E\u003Cp\u003EAngularJS, React and other FrontEnd frameworks are performant enough for most apps, most of the time; But what happens when you're trying to push every drop of performance out of your browser app? Making your Webapp performant and at the same time have nice, loosely coupled code based on resauble blocks is extremely hard. How would you handle a fire hose of data from socket pushes streaming to your UI while you've got mouse hover events firing? Reactive Programming is the answer to these questions. In this talk, we'll learn first what Reactive Programming really means and then we'll dive into practical examples on how Netflix is leveraging Reactive Programming to make performant, scalable and loosely coupled apps.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"slides\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"btn btn-success\" href=\"http:\u002F\u002Fmgonto.github.io\u002Freactive-frontend-oscon\u002F\" target=\"_blank\"\u003EGet Slides\u003C\u002Fa\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-708\"\u003E\u003C\u002Fi\u003ESlides\u003C\u002Fh2\u003E\u003Ciframe src=\"\u002F\u002Fmgonto.github.io\u002Freactive-frontend-oscon\u002F\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"resources\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-732\"\u003E\u003C\u002Fi\u003EExtra Resources\u003C\u002Fh2\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Freactive-frontend-oscon\" target=\"_blank\"\u003E\u003Ch4\u003ESlides and Code samples\u003C\u002Fh4\u003E\u003Cp\u003EThis repository has the HTML and CSS for the slides as well as the code samples shown in the presentation\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Freactive-frontend-oscon\" target=\"_blank\"\u003Egithub.com\u002Fmgonto\u002Freactive-frontend-oscon\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fwww.coursera.org\u002Fcourse\u002Freactive\" target=\"_blank\"\u003E\u003Ch4\u003ECourse on Reactive Programming\u003C\u002Fh4\u003E\u003Cp\u003EA great Coursera course on Reactive Programming from the creators of Scala\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fwww.coursera.org\u002Fcourse\u002Freactive\" target=\"_blank\"\u003Ewww.coursera.org\u002Fcourse\u002Freactive\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fegghead.io\u002Ftechnologies\u002Frx\" target=\"_blank\"\u003E\u003Ch4\u003ELessons about RxJS\u003C\u002Fh4\u003E\u003Cp\u003EGreat lessons about RxJS\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fegghead.io\u002Ftechnologies\u002Frx\" target=\"_blank\"\u003Eegghead.io\u002Ftechnologies\u002Frx\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002FReactive-Extensions\u002FRxJS\" target=\"_blank\"\u003E\u003Ch4\u003ERxJS Github repository\u003C\u002Fh4\u003E\u003Cp\u003ERxJS Github repository\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002FReactive-Extensions\u002FRxJS\" target=\"_blank\"\u003Egithub.com\u002FReactive-Extensions\u002FRxJS\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EUse Auth0 for free\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"events-oscon\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"events-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fevents-landing\u002Fimg\u002Flogo-speaker-2e438aa3f3.svg\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EAuth0 Talks\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-info\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"column event-title\"\u003E\u003Ch2\u003EAngular 2: The new horizon\u003C\u002Fh2\u003E\u003Cp\u003ELearn all the basic angular 2 concepts with this talk and small sample\u003C\u002Fp\u003E\u003Cdiv class=\"host\"\u003E\u003Cimg src=\"https:\u002F\u002Fwww.gravatar.com\u002Favatar\u002Fdf6c864847fba9687d962cb80b482764?size=200\"\u003E\u003Ch3\u003EMartín Gontovnikas\u003C\u002Fh3\u003E\u003Cp\u003EDeveloper Advocate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column event-spot\"\u003E\u003Cdiv class=\"event-logo\"\u003E\u003Cimg src=\"http:\u002F\u002Fjquerysf.com\u002Fimages\u002Fjqsf-logo.svg\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EjQuerySF\u003C\u002Fh3\u003E\u003Cdiv class=\"date\"\u003E\u003Ci class=\"icon-budicon-629\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EJune 22th, 2015\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"place\"\u003E\u003Ci class=\"icon-budicon-632\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESan Francisco, California\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"introduction\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EIntroduction\u003C\u002Fh2\u003E\u003Cp\u003EEverything we used to know (and love?) from Angular 1 has died. No more $scope, services, factories and controllers. Is it good that they died? Why? In this talk, I'll answer those questions and we'll learn all of the key concepts of Angular 2 with a Live Coding demo! Be aware, this session isn't for those faint-hearted.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"slides\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"btn btn-success\" href=\"http:\u002F\u002Fmgonto.github.io\u002Fangular2-the-new-horizon\u002F\" target=\"_blank\"\u003EGet Slides\u003C\u002Fa\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-708\"\u003E\u003C\u002Fi\u003ESlides\u003C\u002Fh2\u003E\u003Ciframe src=\"\u002F\u002Fmgonto.github.io\u002Fangular2-the-new-horizon\u002F\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"resources\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-732\"\u003E\u003C\u002Fi\u003EExtra Resources\u003C\u002Fh2\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Fangular2-the-new-horizon\" target=\"_blank\"\u003E\u003Ch4\u003ESlides\u003C\u002Fh4\u003E\u003Cp\u003EThis repository has the HTML and CSS for the slides.\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Fangular2-the-new-horizon\" target=\"_blank\"\u003Egithub.com\u002Fmgonto\u002Fangular2-the-new-horizon\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"http:\u002F\u002Fvictorsavkin.com\u002Fpost\u002F118372404541\u002Fthe-core-concepts-of-angular-2\" target=\"_blank\"\u003E\u003Ch4\u003ECore Concepts of Angular 2\u003C\u002Fh4\u003E\u003Cp\u003EA great blogpost by an Angular team core member about the core concepts of Angular 2\u003C\u002Fp\u003E\u003Ca href=\"http:\u002F\u002Fvictorsavkin.com\u002Fpost\u002F118372404541\u002Fthe-core-concepts-of-angular-2\" target=\"_blank\"\u003Evictorsavkin.com\u002Fpost\u002F118372404541\u002Fthe-core-concepts-of-angular-2\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fangular2-the-new-horizon-sample\" target=\"_blank\"\u003E\u003Ch4\u003ESample code\u003C\u002Fh4\u003E\u003Cp\u003EThe sample repository shown on the presentation can be downloaded here\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fangular2-the-new-horizon-sample\" target=\"_blank\"\u003Egithub.com\u002Fauth0\u002Fangular2-the-new-horizon-sample\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fwww.youtube.com\u002Fwatch?v=YhcOeJP06Zc\" target=\"_blank\"\u003E\u003Ch4\u003EAngular 2 glossary\u003C\u002Fh4\u003E\u003Cp\u003EA great talk by David East about the glossary for Angular 2 in which the differences in all the terms are explained\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fwww.youtube.com\u002Fwatch?v=YhcOeJP06Zc\" target=\"_blank\"\u003Ewww.youtube.com\u002Fwatch?v=YhcOeJP06Zc\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EUse Auth0 for free\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"events-jquerysf\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"events-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fevents-landing\u002Fimg\u002Flogo-speaker-2e438aa3f3.svg\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EAuth0 Talks\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"event-info\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"column event-title\"\u003E\u003Ch2\u003EReactive FrontEnd\u003C\u002Fh2\u003E\u003Cp\u003ELearn what Observables, Stream and Reactive Programming are in this amazing talk\u003C\u002Fp\u003E\u003Cdiv class=\"host\"\u003E\u003Cimg src=\"https:\u002F\u002Fwww.gravatar.com\u002Favatar\u002Fdf6c864847fba9687d962cb80b482764?size=200\"\u003E\u003Ch3\u003EMartín Gontovnikas\u003C\u002Fh3\u003E\u003Cp\u003EDeveloper Advocate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column event-spot\"\u003E\u003Cdiv class=\"event-logo\" style=\"background-color:#000;\"\u003E\u003Cimg src=\"http:\u002F\u002Fcdn.oreillystatic.com\u002Fen\u002Fassets\u002F1\u002Fevent\u002F129\u002Foscon2015_logo_rev_notag.svg\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EOSCON\u003C\u002Fh3\u003E\u003Cdiv class=\"date\"\u003E\u003Ci class=\"icon-budicon-629\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EJuly 23rd, 2015\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"place\"\u003E\u003Ci class=\"icon-budicon-632\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EPortland, Oregon\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"introduction\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EIntroduction\u003C\u002Fh2\u003E\u003Cp\u003EAngularJS, React and other FrontEnd frameworks are performant enough for most apps, most of the time; But what happens when you're trying to push every drop of performance out of your browser app? Making your Webapp performant and at the same time have nice, loosely coupled code based on resauble blocks is extremely hard. How would you handle a fire hose of data from socket pushes streaming to your UI while you've got mouse hover events firing? Reactive Programming is the answer to these questions. In this talk, we'll learn first what Reactive Programming really means and then we'll dive into practical examples on how Netflix is leveraging Reactive Programming to make performant, scalable and loosely coupled apps.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"slides\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"btn btn-success\" href=\"http:\u002F\u002Fmgonto.github.io\u002Freactive-frontend-oscon\u002F\" target=\"_blank\"\u003EGet Slides\u003C\u002Fa\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-708\"\u003E\u003C\u002Fi\u003ESlides\u003C\u002Fh2\u003E\u003Ciframe src=\"\u002F\u002Fmgonto.github.io\u002Freactive-frontend-oscon\u002F\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"resources\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003E\u003Ci class=\"icon-budicon-732\"\u003E\u003C\u002Fi\u003EExtra Resources\u003C\u002Fh2\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Freactive-frontend-oscon\" target=\"_blank\"\u003E\u003Ch4\u003ESlides and Code samples\u003C\u002Fh4\u003E\u003Cp\u003EThis repository has the HTML and CSS for the slides as well as the code samples shown in the presentation\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fmgonto\u002Freactive-frontend-oscon\" target=\"_blank\"\u003Egithub.com\u002Fmgonto\u002Freactive-frontend-oscon\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fwww.coursera.org\u002Fcourse\u002Freactive\" target=\"_blank\"\u003E\u003Ch4\u003ECourse on Reactive Programming\u003C\u002Fh4\u003E\u003Cp\u003EA great Coursera course on Reactive Programming from the creators of Scala\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fwww.coursera.org\u002Fcourse\u002Freactive\" target=\"_blank\"\u003Ewww.coursera.org\u002Fcourse\u002Freactive\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"column\"\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fegghead.io\u002Ftechnologies\u002Frx\" target=\"_blank\"\u003E\u003Ch4\u003ELessons about RxJS\u003C\u002Fh4\u003E\u003Cp\u003EGreat lessons about RxJS\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fegghead.io\u002Ftechnologies\u002Frx\" target=\"_blank\"\u003Eegghead.io\u002Ftechnologies\u002Frx\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003Carticle\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002FReactive-Extensions\u002FRxJS\" target=\"_blank\"\u003E\u003Ch4\u003ERxJS Github repository\u003C\u002Fh4\u003E\u003Cp\u003ERxJS Github repository\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgithub.com\u002FReactive-Extensions\u002FRxJS\" target=\"_blank\"\u003Egithub.com\u002FReactive-Extensions\u002FRxJS\u003C\u002Fa\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EUse Auth0 for free\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"events-oscon\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["browser"] = pug_interp = function(url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Cdiv class=\"btns\"\u003E\u003Ci class=\"close\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"min\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"max\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"location-bar\"\u003E";
if (url) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = url) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003Ehttps:\u002F\u002Fmanage.auth0.com\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"hero-flex-container\"\u003E\u003Cdiv class=\"info\"\u003E\u003Cimg class=\"logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fguardian-hero-logo-06f7f6e70e.svg\" alt=\"Guardian\"\u003E\u003Cdiv class=\"content\"\u003E\u003Ch1 class=\"h1\"\u003EMultifactor Made Easy\u003C\u002Fh1\u003E\u003Cp class=\"h4\"\u003EThe most usable and friction-free multifactor authentication experience available\u003C\u002Fp\u003E\u003Cp class=\"cta-area\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003EUse Auth0 for free\u003C\u002Fa\u003E\u003Cspan class=\"or\"\u003Eor\u003C\u002Fspan\u003E\u003Ca class=\"medium-link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fmultifactor-authentication\u002Fguardian\" rel=\"external\"\u003ERead the docs\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp class=\"get-app\"\u003E\u003Cspan class=\"small-caps\"\u003EGet the app\u003C\u002Fspan\u003E\u003Ca class=\"apple\" href=\"https:\u002F\u002Fitunes.apple.com\u002Fus\u002Fapp\u002Fauth0-guardian\u002Fid1093447833?ls=1&amp;mt=8\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fapple-store-4fb1d423ec.svg\" alt=\"Apple Store logo\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"play\" href=\"https:\u002F\u002Fplay.google.com\u002Fstore\u002Fapps\u002Fdetails?id=com.auth0.guardian\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fplay-store-87e443b2e8.svg\" alt=\"Play Store logo\"\u003E\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"stage\"\u003E\u003Cdiv class=\"phone-container\"\u003E\u003Cimg class=\"screen\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fiphone-hero-screen-77b3d4e9d3.svg\" alt=\"iPhone screen with Guardian\"\u003E\u003C\u002Fdiv\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg class=\"avatar-mfa\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbrowser-hero-screen-avatar-1ad54c2261.png\" alt=\"Demo app avatar\"\u003E\u003Cimg class=\"success-mfa\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbrowser-hero-screen-c80589f5ac.svg\" alt=\"Demo app login\"\u003E";
}
}, "https://www.yourapp.com");
pug_html = pug_html + ("\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"scroll-down js-scroll-hiw text-center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fmouse-cd3e45a9c7.svg\" alt=\"Mouse icon\"\u003E\u003Cdiv class=\"small-caps\"\u003EScroll down\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(945).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(942).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(943).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(946).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(947).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(944).call(this, locals)) ? "" : pug_interp));;return pug_html;};
module.exports = template;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-did\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-left\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fdid-icon-7a701fe67e.svg\"\u003E\u003Ch2 class=\"h1\"\u003EDefense In Depth\u003C\u002Fh2\u003E\u003Cp class=\"h4\"\u003EOver 50% of users admit to reusing the same password for multiple services, so even if your authentication system follows all the best practices, a compromised account elsewhere can lead to unauthorized access in your system.\u003C\u002Fp\u003E\u003Cp class=\"h4\"\u003EWith multifactor authentication, even if the user's password is compromised\u003Cstrong\u003E- the bad guys can't get in.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-right cut-off-mobile\"\u003E\u003Cdiv class=\"phone-container\"\u003E\u003Cimg class=\"contain\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fdefense-iphone-ce1bee3c06.svg\" alt=\"iPhone with Guardian app\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-etu\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-left\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cdiv class=\"phone-container\"\u003E\u003Cimg class=\"iwatch\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fwatch-ccb87116c6.svg\" alt=\"Apple Watch with Guardian notification\"\u003E\u003Cimg class=\"phone\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fhero-iphone-fd25832b3f.svg\" alt=\"iPhone illustration\" height=\"489\"\u003E\u003Cvideo class=\"animated fadeIn\" width=\"210\" height=\"375\" id=\"hero-video\" autoplay loop\u003E\u003Csource src=\"https:\u002F\u002Fembed-ssl.wistia.com\u002Fdeliveries\u002F3184dc67e9683a143efbfdb260d8059869594744\u002Fmfa-hero-loop.mp4\"\u003EYour browser does not support the video tag.\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-right\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fetu-icon-5a80a0f2fe.svg\" alt=\"Easy To Use\"\u003E\u003Ch2 class=\"h1\"\u003EEasy to use\u003C\u002Fh2\u003E\u003Cp class=\"h4\"\u003EUsers are security-conscious but experience trumps all. The Guardian app removes the need to for fiddly codes - approve or deny a login attempt from your smartphone.\u003C\u002Fp\u003E\u003Cp class=\"h4\"\u003EPush notifications simplify the process even further. Approve or deny login requests without ever opening the app. It even works with your Android Wear or Apple Watch.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-stei text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fhiw-icon-2bfd9905d1.svg\" alt=\"How To Enable\"\u003E\u003Ch2 class=\"h1\"\u003ESlide to enable\u003C\u002Fh2\u003E\u003Cp class=\"h4 text-half-column\"\u003EImplementing MFA in your app with Guardian is as simple as flipping a switch, no code required.\u003C\u002Fp\u003E\u003Cp class=\"cta-area\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003EUse Auth0 for free\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-default\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fmultifactor-authentication\u002Fguardian\" rel=\"external\"\u003ERead the docs\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cimg class=\"contain\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbottom-screenshot-07eb5f11ce.png\" alt=\"Auth0's Manage page with MFA panel\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"section section-hiw text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fhiw-icon-2bfd9905d1.svg\"\u003E\u003Ch2 class=\"h1\"\u003EHow It Works\u003C\u002Fh2\u003E\u003Cp class=\"h4 text-half-column\"\u003EUsers will appreciate Guardian as it removes the need for one-time codes, simply download the app and approve login requests with the tap of a button.\u003C\u002Fp\u003E\u003Cdiv class=\"placeholder-media\"\u003E\u003Cvideo id=\"guardian-video\" width=\"100%\"\u003E\u003Csource src=\"https:\u002F\u002Fembed-ssl.wistia.com\u002Fdeliveries\u002Fc78f78f06ea9e23216a9f2109c3f8545cdcb27d1\u002Fmfa-mobile-video.mp4\"\u003EYour browser does not support the video tag.\u003C\u002Fvideo\u003E\u003Ca class=\"play-me-again\" href=\"#\"\u003E\u003Ci class=\"icon-budicon-257\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-etu\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-left\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbuild-icon-f21a612b89.svg\" alt=\"White-label multifactor icon\"\u003E\u003Ch2 class=\"h1\"\u003EWhite-label multifactor\u003C\u002Fh2\u003E\u003Cp class=\"h4\"\u003EUse the Guardian Mobile SDKs — available for \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fmultifactor-authentication\u002Fdeveloper\u002Flibraries\u002Fios\"\u003EiOS\u003C\u002Fa\u003E and \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fmultifactor-authentication\u002Fdeveloper\u002Flibraries\u002Fandroid\"\u003EAndroid\u003C\u002Fa\u003E — to build your own white-label multifactor authentication application with complete control over the branding and look-and-feel.\u003C\u002Fp\u003E\u003Cp class=\"h4\"\u003EYou can also use our \u003Ca href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Fauth0-guardian.js\"\u003EJavaScript library\u003C\u002Fa\u003E to extend and customize the Guardian widget to suit your web application's specific needs and individual style.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-right\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cimg class=\"sdk-demo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fsdk-a0dac2f267.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-sms-choice\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-left text-center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fsms-icon-a03191b110.svg\"\u003E\u003Ch2 class=\"h1\"\u003ESMS Support\u003C\u002Fh2\u003E\u003Cp class=\"h4 copy-text\"\u003EUsers don’t need the Guardian app or even a smartphone to benefit from the protection of our advanced MFA features. Any phone capable of receiving SMS text messages can be used to receive one-time codes.\u003C\u002Fp\u003E\u003Cimg class=\"contain pt30\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fnokia-phone-15653a22a8.svg\" alt=\"Nokia 1100 phone with SMS\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-right text-center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fyc-icon-75e7af95c9.svg\" alt=\"Smartphone with Microsoft Authenticator app\"\u003E\u003Ch2 class=\"h1\"\u003EYour Choice\u003C\u002Fh2\u003E\u003Cp class=\"h4 copy-text\"\u003EOur MFA solution works everywhere. Use the Guardian iOS or Android app to receive push notifications, get one-time codes delivered via SMS or connect with a third party token generation app such as Google Authenticator.\u003C\u002Fp\u003E\u003Cimg class=\"contain\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fms-phone-eb4eb40b90.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"guest-authors-page page-content\"\u003E\u003Cstyle type=\"text\u002Fcss\"\u003E.wow {\n  visibility: hidden;\n}\n\u003C\u002Fstyle\u003E\u003Csection class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"hero-text-content col-xs-12 col-md-5\"\u003E\u003Ch1 class=\"hero-header\"\u003EThe Auth0 \u003Cbr class=\"rd-break\"\u003E Guest Author Program\u003C\u002Fh1\u003E\u003Cp class=\"hero-description\"\u003EDo you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? \u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success join-us\" href=\"#contact-us\" rel=\"external\"\u003EJOIN US\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-image-content col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguest-authors\u002Fimg\u002Fhero-guest-59812099cc.svg\" alt=\"Guest Authors Program\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"what-we-look\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch1 class=\"title-text\"\u003EWhat We’re Looking For\u003C\u002Fh1\u003E\u003Cp class=\"simple-text\"\u003EFor the most part, our blog content is technical. We show people how to get things done with modern technologies, and we pride ourselves on being thorough and comprehensive about it.\nOur technical content is wide ranging and there are a lot of different frameworks, languages, and concepts that we’re interested in. Some of the ones we especially like are:\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technologies-gallery\" id=\"tech-gallery\"\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Ci class=\"icon icon-budicon-243\" title=\"Mobile\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003EMobile\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Ci class=\"icon icon-budicon-280\" title=\"Authentication\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003EAuthentication\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Ci class=\"icon icon-budicon-285\" title=\"Security\" aria-hidden=\"true\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003ESecurity\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Cimg class=\"logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fstyleguide\u002Fcomponents\u002F1.0.8\u002Fmedia\u002Fcircle-logo\u002Fimg\u002Fvanillajs.svg\" alt=\"Vanilla JS\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003EModern JS\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Cimg class=\"logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fstyleguide\u002Fcomponents\u002F1.0.8\u002Fmedia\u002Fcircle-logo\u002Fimg\u002Fangular.svg\" alt=\"Angular\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003EAngular 2\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Cimg class=\"logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fstyleguide\u002Fcomponents\u002F1.0.8\u002Fmedia\u002Fcircle-logo\u002Fimg\u002Freact.svg\" alt=\"React\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003EReact\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"technology\"\u003E\u003Cdiv class=\"tech-image\"\u003E\u003Cimg class=\"logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguest-authors\u002Fimg\u002Ficon-node-3acdef3cb0.svg\" alt=\"Node\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tech-title\"\u003E\u003Cp\u003ENode\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"who-we-look\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"flex-wrapper\"\u003E\u003Cdiv class=\"image-content\"\u003E \u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguest-authors\u002Fimg\u002Flooking-for-6ebe6a37f6.svg\" alt=\"We are looking for you!\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-content\"\u003E\u003Ch1 class=\"title-text\"\u003EWho We’re Looking For\u003C\u002Fh1\u003E\u003Cp class=\"simple-text\"\u003EAre you a developer with experience writing tutorials and creating sample projects? Do you like to dig deep into how things work? Do you push past JavaScript fatigue and learn about new things anyway? \n\u003Cbr\u003E If so, we’re looking for you :)\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"whats-in\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch1 class=\"title-text\"\u003EWhat’s in it For You\u003C\u002Fh1\u003E\u003Cul\u003E\u003Cli\u003EWe believe that you deserve great pay for your content.\u003Cbr class=\"rm-break\"\u003E We pay up to $200 USD per article.\u003C\u002Fli\u003E\u003Cli\u003EGuest writing for Auth0 also means that you’ll be featured on one of the web’s most popular technical blogs. We’re in Alexa's top 7,000 websites for the US and we have over 250,000 new monthly unique visitors. We’ll also promote your content tirelessly, so you can be sure your articles will be well read.\u003C\u002Fli\u003E\u003Cli\u003EFinally, you’ll get to help developers get stuff done. Many developers will look to your quality content as a trusted resource for their learning.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"get-started\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"image-content\"\u003E\u003Cimg class=\"pencil-draw\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguest-authors\u002Fimg\u002Fpencil-9bbdd3f805.svg\" alt=\"Start Writing Now!\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-content\"\u003E\u003Ch1 class=\"title-text\"\u003EReady to Get Started?\u003C\u002Fh1\u003E\u003Cp class=\"simple-text\"\u003EIf you’d like to join us as a guest writer, we’d love to hear from you!\u003C\u002Fp\u003E\u003Cp class=\"intro-text\"\u003ETo get started, send us a note and let us know who you are by answering these three questions:\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003EWhat’s your favorite frontend\u002Fbackend framework and why?\u003C\u002Fli\u003E\u003Cli\u003EWhat is it that you like about authoring technical content?\u003C\u002Fli\u003E\u003Cli\u003EWhat’s an article that you’ve recently read that you really liked?\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp class=\"intro-text\"\u003EWe’ll also need some writing samples\u003C\u002Fp\u003E\u003Cp class=\"simple-text\"\u003ESend us three of your best articles and the corresponding Github repos that go along with them.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"contact-form-section\" id=\"contact-us\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cform class=\"contact-form\"\u003E\u003Ch1 class=\"form-title\"\u003EJoin Us as a Guest Author!\u003C\u002Fh1\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel\u003EName *\u003Cinput type=\"text\" name=\"name\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel\u003ECompany *\u003Cinput type=\"text\" name=\"company\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel for=\"email\"\u003EEmail *\u003Cinput type=\"email\" name=\"email\" required\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6\"\u003E\u003Clabel\u003ERole *\u003Cselect name=\"role\"\u003E\u003Coption\u003ESoftware Developer\u003C\u002Foption\u003E\u003Coption\u003EEngineering Exec \u002F Management\u003C\u002Foption\u003E\u003Coption\u003EC-Level\u003C\u002Foption\u003E\u003Coption\u003EIT operations\u003C\u002Foption\u003E\u003Coption\u003EProduct Management\u003C\u002Foption\u003E\u003Coption\u003ESales\u003C\u002Foption\u003E\u003Coption\u003EMarketing\u003C\u002Foption\u003E\u003Coption\u003ESecurity & Compliance\u003C\u002Foption\u003E\u003Coption\u003EOther\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Clabel class=\"textarea\"\u003EMessage *\u003Ctextarea name=\"message\" required\u003E\u003C\u002Ftextarea\u003E\u003C\u002Flabel\u003E\u003Cbutton class=\"btn btn-lg btn-success\" type=\"submit\"\u003Esend\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (glossaryApp, initialState) {pug_html = pug_html + "\u003Cdiv class=\"identity-glossary-page\"\u003E\u003Cscript\u003E" + (null == (pug_interp = initialState) ? "" : pug_interp) + "\u003C\u002Fscript\u003E\u003Cdiv class=\"glossary-app\"\u003E" + (null == (pug_interp = glossaryApp) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"glossaryApp" in locals_for_with?locals_for_with.glossaryApp:typeof glossaryApp!=="undefined"?glossaryApp:undefined,"initialState" in locals_for_with?locals_for_with.initialState:typeof initialState!=="undefined"?initialState:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (culture, jobs) {pug_html = pug_html + "\u003Cdiv class=\"jobs-page\"\u003E\u003Cdiv class=\"banner-diagonal\"\u003E\u003Cdiv class=\"banner-content\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fteam_2-f0383dcaa1.jpg\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info-post-slider\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1\u003EJobs at Auth0\u003C\u002Fh1\u003E\u003Cp\u003EWe're looking for people who care deeply about quality, team work and want to build software that people love.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"#job-openings\" data=\"scroll-to\"\u003EView Job Openings\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"who-we-are\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EWho we are\u003C\u002Fh2\u003E\u003Cp\u003EUltimately, we strive for an internet with fewer passwords. Our vision is to provide the simplest and most secure identity platform for developers, to make the internet safer. We're looking for people to join us on this journey.\u003C\u002Fp\u003E\u003Cdiv class=\"con-slider\"\u003E\u003Cdiv class=\"owl-carousel\" id=\"owl-who\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fwho-4-a09eddf2c8.jpg\" alt=\"\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fwho-3-8badeac33b.jpg\" alt=\"\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fwho-2-fe6d90d847.jpg\" alt=\"\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fwho-1-5259ed9a00.jpg\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info\"\u003E\u003Cul\u003E\u003Cli\u003E\u003Ci class=\"icon-budicon-627\"\u003E\u003C\u002Fi\u003EFlexible work hours\u003C\u002Fli\u003E\u003Cli\u003E\u003Ci class=\"icon-budicon-83\"\u003E\u003C\u002Fi\u003ECompetitive equity\u003C\u002Fli\u003E\u003Cli\u003E\u003Ci class=\"icon-budicon-468\"\u003E\u003C\u002Fi\u003EExtraordinary benefits\u003C\u002Fli\u003E\u003Cli\u003E\u003Ci class=\"icon-budicon-237\"\u003E\u003C\u002Fi\u003ETop-of-the-Line Macbooks and other great tools\u003C\u002Fli\u003E\u003Cli\u003E\u003Ci class=\"icon-budicon-377\"\u003E\u003C\u002Fi\u003EEmbrace Distributed Work\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"culture\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003ECulture\u003C\u002Fh2\u003E\u003Cp\u003ETeamwork, passion for technology, passion for helping customers.\u003C\u002Fp\u003E\u003Cp\u003EAmbition for improving our industry.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slider-holder\"\u003E\u003Cdiv class=\"owl-carousel\" id=\"owl-culture\"\u003E";
// iterate culture
;(function(){
  var $$obj = culture;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cimg" + (pug.attr("src", item.img, true, true)+" alt=\"\"") + "\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = item.text) ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = item.date) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"item\"\u003E\u003Cimg" + (pug.attr("src", item.img, true, true)+" alt=\"\"") + "\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = item.text) ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = item.date) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"what-we-do\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EWhat we do\u003C\u002Fh2\u003E\u003Cp\u003EThis video explains how we build our large, highly available, scalable services. It includes lessons learnt related to cross cutting concerns such as authentication, authorization, documentation, validation, rate limiting and geo-redundancy.\u003C\u002Fp\u003E\u003Cdiv class=\"video-container\"\u003E\u003Ciframe class=\"video-frame\" src=\"https:\u002F\u002Fwww.youtube.com\u002Fembed\u002FOoA-gx-19tQ\" allowfullscreen frameborder=\"0\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"jobs\" id=\"job-openings\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EJob openings\u003C\u002Fh2\u003E\u003Cp class=\"js-join-stats join-hidden\"\u003EJoin a company that’s issued&nbsp;\u003Cstrong id=\"tokens\"\u003E\u003C\u002Fstrong\u003E\u003Cstrong\u003E tokens\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cnav class=\"menu-bar\"\u003E\u003Cspan class=\"active filter\" data-filter=\"all\"\u003EAll\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".marketing\"\u003EMarketing\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".customer-success\"\u003ECustomer Success\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".engineer\"\u003EEngineering\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".security\"\u003ESecurity\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".design\"\u003EDesign\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".s-m\"\u003ESales\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".finance\"\u003EFinance\u003C\u002Fspan\u003E\u003Cspan class=\"filter\" data-filter=\".h-r\"\u003EHuman Resources\u003C\u002Fspan\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"jobs__items\"\u003E";
// iterate jobs
;(function(){
  var $$obj = jobs;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var job = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["jobs__item","mix",job.group], [false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"jobs-item__container\"\u003E\u003Cdiv class=\"jobs-item__name\"\u003E" + (pug.escape(null == (pug_interp = job.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"jobs-item__location\"\u003E" + (pug.escape(null == (pug_interp = job.location) ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = job.type) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca" + (" class=\"jobs-item__more\""+pug.attr("href", "/jobs/" + job.group + "/" + job.id, true, true)+" rel=\"nofollow\"") + "\u003ERead More\u003C\u002Fa\u003E\u003Cdiv" + (" class=\"modal\""+pug.attr("id", job.id, true, true)+" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"") + "\u003E\u003Cdiv class=\"modal-backdrop\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-dialog\"\u003E\u003Cdiv class=\"modal-content\"\u003E\u003Cdiv class=\"modal-header has-border\"\u003E\u003Cbutton class=\"close\" type=\"button\" data-dismiss=\"modal\"\u003E\u003Cspan aria-hidden=\"true\"\u003E×\u003C\u002Fspan\u003E\u003Cspan class=\"sr-only\"\u003EClose\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Ch4 class=\"modal-title\" id=\"myModalLabel\"\u003E" + (pug.escape(null == (pug_interp = job.title) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E" + (null == (pug_interp = job.content) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer\"\u003E\u003Ca" + (" class=\"btn btn-primary\""+pug.attr("href", job.link, true, true)+" target=\"_blank\"") + "\u003EApply\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var job = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["jobs__item","mix",job.group], [false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"jobs-item__container\"\u003E\u003Cdiv class=\"jobs-item__name\"\u003E" + (pug.escape(null == (pug_interp = job.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"jobs-item__location\"\u003E" + (pug.escape(null == (pug_interp = job.location) ? "" : pug_interp)) + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = job.type) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca" + (" class=\"jobs-item__more\""+pug.attr("href", "/jobs/" + job.group + "/" + job.id, true, true)+" rel=\"nofollow\"") + "\u003ERead More\u003C\u002Fa\u003E\u003Cdiv" + (" class=\"modal\""+pug.attr("id", job.id, true, true)+" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"") + "\u003E\u003Cdiv class=\"modal-backdrop\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-dialog\"\u003E\u003Cdiv class=\"modal-content\"\u003E\u003Cdiv class=\"modal-header has-border\"\u003E\u003Cbutton class=\"close\" type=\"button\" data-dismiss=\"modal\"\u003E\u003Cspan aria-hidden=\"true\"\u003E×\u003C\u002Fspan\u003E\u003Cspan class=\"sr-only\"\u003EClose\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003Ch4 class=\"modal-title\" id=\"myModalLabel\"\u003E" + (pug.escape(null == (pug_interp = job.title) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E" + (null == (pug_interp = job.content) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer\"\u003E\u003Ca" + (" class=\"btn btn-primary\""+pug.attr("href", job.link, true, true)+" target=\"_blank\"") + "\u003EApply\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"jobs-look-more\"\u003EDon’t see the position you are looking for?\u003Ca href=\"mailto:jobs@auth0.com\"\u003E Submit a general application.\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"where-we-are\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EWhere we are\u003C\u002Fh2\u003E\u003Cp\u003EOffices\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"map\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fjobs\u002Fimg\u002Fmap-5f9892722c.svg\" alt=\"\"\u003E\u003Cdiv class=\"tooltip tooltip-1 hq wow bounceIn\"\u003E\u003Cdiv class=\"glow wow blip\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESeattle HQ\u003C\u002Fp\u003E\u003Cp class=\"grey\"\u003E10900 NE 8th St #700, Bellevue, WA\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgoo.gl\u002Fmaps\u002F1gLQGBsgugE2\" target=\"_blank\"\u003EView on Google Maps\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-2 hq wow bounceIn\"\u003E\u003Cdiv class=\"glow wow blip\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EBuenos Aires HQ\u003C\u002Fp\u003E\u003Cp class=\"grey\"\u003EEl Salvador 5718, CABA\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fgoo.gl\u002Fmaps\u002FekAb93KPqtQ2\" target=\"_blank\"\u003EView on Google Maps\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-3 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EBrussels\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-4 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003ESydney\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-5 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EPhiladelphia\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-6 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EMountain View\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-7 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ECordoba\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-8 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EDetroit\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-9 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EFlorianopolis\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-10 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EUnited Kingdom\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-11 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESouth Africa\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-12 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EHungary\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-13 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003EJapan\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-14 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003ETaiwan\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-15 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EPoland\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-16 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EChile\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-17 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESpain\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-18 wow bounceIn\"\u003E\u003Cdiv class=\"hold left\"\u003E\u003Cp\u003ENew Zealand\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-19 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EGreece\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-20 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESri Lanka\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-21 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ENigeria\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-22 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EFrance\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-23 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EColombia\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-24 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003EIndia\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip tooltip-25 wow bounceIn\"\u003E\u003Cdiv class=\"hold\"\u003E\u003Cp\u003ESweden\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"contacts\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch2\u003EJoin Us\u003C\u002Fh2\u003E\u003Cp\u003E\u003Ca href=\"mailto:jobs@auth0.com\"\u003Ejobs@auth0.com\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"social\"\u003E\u003Cli class=\"twitter\"\u003E\u003Ca href=\"http:\u002F\u002Ftwitter.com\u002Fauth0\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"git\"\u003E\u003Ca href=\"http:\u002F\u002Fgithub.com\u002Fauth0\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"dribble\"\u003E\u003Ca href=\"http:\u002F\u002Fdribbble.com\u002Fauth0\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"talk\"\u003E\u003Ca href=\"mailto:info@auth0.com\" target=\"_blank\"\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"culture" in locals_for_with?locals_for_with.culture:typeof culture!=="undefined"?culture:undefined,"jobs" in locals_for_with?locals_for_with.jobs:typeof jobs!=="undefined"?jobs:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csvg height=\"228\" viewbox=\"0 0 671 228\" width=\"671\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(1)\"\u003E\u003Cg class=\"js-animate-circles\" fill=\"#E3E5E7\" transform=\"translate(59 20)\"\u003E\u003Ccircle cx=\"2\" cy=\"75\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"63\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"51\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"39\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"27\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"15\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"2\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"13\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"25\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"37\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"49\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"61\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"73\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"84\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"97\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"109\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"121\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"133\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"145\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"157\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"168\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"180\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"193\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"205\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"217\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"229\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"240\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"314\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"326\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"338\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"350\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"361\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"374\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"386\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"398\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"410\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"421\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"434\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"446\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"458\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"470\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"481\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"492\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"505\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"517\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"529\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"540\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"2\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"13\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"24\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"36\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"47\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"58\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"551\" cy=\"70\" r=\"2\"\u003E\u003C\u002Fcircle\u003E\u003C\u002Fg\u003E\u003Cg stroke-width=\"1.5\" transform=\"translate(585 127)\"\u003E\u003Cpath d=\"M45.75 80H2.25C.975 80 0 78.943 0 77.736V2.264C0 1.057.975 0 2.25 0h43.5C47.025 0 48 1.057 48 2.264v75.472C48 78.943 47.025 80 45.75 80z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M5.25 7.547h37.5v61.887H5.25z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"24\" cy=\"74.717\" rx=\"2.25\" ry=\"2.264\" stroke=\"#222228\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M20.25 3.774h7.5M22.05 28.755l-9.225 16.15c-.9 1.51.225 3.397 1.95 3.397H33.3c1.725 0 2.85-1.887 1.95-3.396l-9.225-16.15c-.975-1.51-3.075-1.51-3.975 0l-9.225 16.15c-.9 1.51.225 3.396 1.95 3.396H33.3c1.725 0 2.85-1.887 1.95-3.396l-9.225-16.15c-.975-1.51-3.075-1.51-3.975 0z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M24 33.208v8.3M24 43.02v2.263\" stroke=\"#EB5424\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M45.75 80H2.25C.975 80 0 78.943 0 77.736V2.264C0 1.057.975 0 2.25 0h43.5C47.025 0 48 1.057 48 2.264v75.472C48 78.943 47.025 80 45.75 80z\" stroke=\"#222228\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003Cg transform=\"translate(28 133)\"\u003E\u003Cpath d=\"M0 0h58.276v19.644H0zM0 24.178h58.276v19.644H0zM50.805 48.356H0V68h48.563\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"13.448\" cy=\"12.089\" fill=\"#EB5424\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse cx=\"7.471\" cy=\"12.089\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M52.3 6.044V13.6M47.816 6.044V13.6M43.333 6.044V13.6\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"7.471\" cy=\"36.267\" fill=\"#EB5424\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse cx=\"13.448\" cy=\"36.267\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M52.3 30.222v7.556M47.816 30.222v7.556M43.333 30.222v7.556\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"13.448\" cy=\"60.444\" fill=\"#EB5424\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cellipse cx=\"7.471\" cy=\"60.444\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003Cpath d=\"M51.552 56.667H65V68H51.552zM63.506 56.667v-3.023c0-2.946-2.316-5.288-5.23-5.288-2.914 0-5.23 2.342-5.23 5.288v3.023\" stroke=\"#EB5424\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cpath d=\"M58.276 60.444v5.29\" stroke=\"#222228\" stroke-width=\"1.5\"\u003E\u003C\u002Fpath\u003E\u003Cellipse cx=\"58.276\" cy=\"61.2\" fill=\"#222228\" rx=\"1.494\" ry=\"1.511\"\u003E\u003C\u002Fellipse\u003E\u003C\u002Fg\u003E\u003Cpath d=\"M345.757 36.404l-4.49-13.905 11.752-8.592h-14.527L334.003.004 334 0h14.53l4.49 13.907.004-.003c2.608 8.068-.078 17.244-7.267 22.5zm-23.508 0l-.005.003L334 45l11.757-8.596-11.754-8.593-11.754 8.594zm-7.267-22.5c-2.745 8.505.442 17.516 7.263 22.502V36.4l4.49-13.903-11.748-8.59h14.523L334 .005l.002-.004h-14.53l-4.49 13.905z\" fill=\"#EB5424\"\u003E\u003C\u002Fpath\u003E\u003Ccircle cx=\"60\" cy=\"167\" r=\"60\" stroke=\"#E3E5E7\" stroke-width=\"2\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle cx=\"609\" cy=\"167\" r=\"60\" stroke=\"#E3E5E7\" stroke-width=\"2\"\u003E\u003C\u002Fcircle\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;





pug_html = pug_html + "\u003Cdiv class=\"breached-passwords-page page-content\"\u003E\u003Csection class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"hero-text-content col-xs-12 col-md-6\"\u003E\u003Ch1 class=\"hero-header\"\u003E貴社のユーザーとサービスをパスワードの漏洩から守ります。\u003C\u002Fh1\u003E\u003Cp class=\"hero-description\"\u003Eパスワードの侵害の検知により、第三者のデータ侵害によるクレデンシャルの漏洩から貴社のユーザーを守り、通知を行います。貴社のユーザーがパスワードをリセットするまでアクセスを制限することも選択できます。\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success enable-now\" href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fanomaly\" rel=\"external\"\u003E使ってみる\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-transparent join-us\" href=\"javascript:signup()\"\u003E無料トライアル\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-news-content col-xs-12 col-md-6\"\u003E\u003Cdiv class=\"news-1 go-down\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"news-2 go-down\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"news-3 go-up\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"news-4 go-up\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"how-it-works\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fhiw-icon-2bfd9905d1.svg\"\u003E\u003Ch2 class=\"h2\"\u003Eその働き\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003EAuth0は、間断なく更新される数億件に上る漏洩したクレデンシャル情報を保持しています。パスワードによるログインやサインアップの試みの全ては、このデータベースでチェックされ、該当するものは全てリアルタイムに遮断されます。\u003C\u002Fp\u003E\u003Cdiv class=\"example-content\"\u003E\u003Cvideo id=\"breached-video-jp\" width=\"100%\"\u003E\u003Csource src=\"\u002Fpages\u002Fbreached-passwords\u002Fresources\u002Fvideos\u002Fbreached-video.mp4\"\u003E\u003C\u002Fvideo\u003E\u003Ca class=\"play-me-again\" href=\"#\"\u003E\u003Ci class=\"icon-budicon-257\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"benefits\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fbenefits-icon-eeeb4ead7a.svg\"\u003E\u003Ch2 class=\"h2\"\u003Eその利点\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003E多くの場合、自分自身のパスワードが漏洩していることに気付いていないものです。パスワード侵害の検知をアプリ側で可能にして、ユーザーが危険にさらされている場合には通知を行うことで、ブランドの認識を高めます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"benefits-details\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center visible-md visible-lg\"\u003E" + (null == (pug_interp = __webpack_require__(951).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12 col-md-6 benefit-left\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fservice-providers-icon-2183fd545f.svg\"\u003E\u003Ch2 class=\"h2\"\u003Eサービスプロバイダー向け\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column text-benefit\"\u003Eデータ侵害で盗まれたクレデンシャルを使って第三者に成り済ますハッカーを遮断します。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-center col-xs-12 col-md-6 benefit-right\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fend-users-icon-a033ef8c1d.svg\"\u003E\u003Ch2 class=\"h2\"\u003Eエンドユーザ向け\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column text-benefit\"\u003Eクレデンシャルが危うくなっている場合にデータ侵害の通知を受け取ることで、アカウントの安全を保てます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"flip-counter\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Ch2 class=\"h2\"\u003E世界中で漏れ続けるパスワード\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003Eご覧のように、ますますパスワードは盗まれ、データ侵害により漏洩し続けています。\u003C\u002Fp\u003E\u003Cdiv class=\"counter\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"enable text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"text-center col-xs-12\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fbreached-passwords\u002Fimg\u002Fenable-icon-3a9e5829ec.svg\"\u003E\u003Ch2 class=\"h2\"\u003Eパスワード侵害検知を直ぐ入れましょう\u003C\u002Fh2\u003E\u003Cp class=\"text-half-column\"\u003Eパスワード侵害検知機能の試演をご利用いただけます\u003C\u002Fp\u003E\u003Ca class=\"btn btn-lg btn-success enable-now\" href=\"https:\u002F\u002Fmanage.auth0.com\u002F#\u002Fanomaly\" rel=\"external\"\u003EENABLE NOW\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-transparent enable-learn-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fanomaly-detection\" rel=\"external\"\u003ELEARN MORE\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-container\"\u003E\u003Cdiv class=\"switcher\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EBreached Password Detection\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["browser"] = pug_interp = function(url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Cdiv class=\"btns\"\u003E\u003Ci class=\"close\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"min\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"max\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"location-bar\"\u003E";
if (url) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = url) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003Ehttps:\u002F\u002Fmanage.auth0.com\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"hero\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"hero-flex-container\"\u003E\u003Cdiv class=\"info\"\u003E\u003Cimg class=\"logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fguardian-hero-logo-06f7f6e70e.svg\" alt=\"Guardian\"\u003E\u003Cdiv class=\"content\"\u003E\u003Ch1 class=\"h4\"\u003E使い勝手が良くストレスの少ない複数要素認証 (MFA) です。\u003C\u002Fh1\u003E\u003Cp class=\"cta-area\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003E無料トライアル\u003C\u002Fa\u003E\u003Ca class=\"link\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fmultifactor-authentication\u002Fguardian\" rel=\"external\"\u003E&nbsp;&nbsp;&nbsp;詳しい説明\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp class=\"get-app\"\u003E\u003Cspan class=\"small-caps\"\u003Eアプリケーションをダウンロード\u003C\u002Fspan\u003E\u003Ca class=\"apple\" href=\"https:\u002F\u002Fitunes.apple.com\u002Fus\u002Fapp\u002Fauth0-guardian\u002Fid1093447833?ls=1&amp;mt=8\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fapple-store-4fb1d423ec.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"play\" href=\"https:\u002F\u002Fplay.google.com\u002Fstore\u002Fapps\u002Fdetails?id=com.auth0.guardian\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fplay-store-87e443b2e8.svg\"\u003E\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"stage\"\u003E\u003Cdiv class=\"phone-container\"\u003E\u003Cimg class=\"screen\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fiphone-hero-screen-77b3d4e9d3.svg\"\u003E\u003C\u002Fdiv\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg class=\"avatar-mfa\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbrowser-hero-screen-avatar-1ad54c2261.png\"\u003E\u003Cimg class=\"success-mfa\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbrowser-hero-screen-c80589f5ac.svg\"\u003E";
}
}, "https://www.yourapp.com");
pug_html = pug_html + ("\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"scroll-down js-scroll-hiw text-center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fmouse-cd3e45a9c7.svg\"\u003E\u003Cdiv class=\"small-caps\"\u003E下にスクロール\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(957).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(954).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(955).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(958).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(956).call(this, locals)) ? "" : pug_interp));;return pug_html;};
module.exports = template;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-did\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-left\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fdid-icon-7a701fe67e.svg\"\u003E\u003Ch2 class=\"h1\"\u003E徹底した防御\u003C\u002Fh2\u003E\u003Cp class=\"h4\"\u003E５０％以上の人達が、複数のサービスに同じパスワードを使っていると認めています。このため、認証システムがあらゆる最善の方法に従うものだったとしても、どこかのこのようなアカウントから、システムへの不正アクセスにつながるリスクは生じてしまいます。\u003C\u002Fp\u003E\u003Cp class=\"h4\"\u003E複数要素認証では、もしユーザーパスワードが盗まれ危うくなっても、\u003Cstrong\u003E不正アクセスを許しません。\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-right cut-off-mobile\"\u003E\u003Cdiv class=\"phone-container\"\u003E\u003Cimg class=\"contain\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fdefense-iphone-ce1bee3c06.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-etu\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-left\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cdiv class=\"phone-container\"\u003E\u003Cimg class=\"iwatch\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fwatch-ccb87116c6.svg\"\u003E\u003Cimg class=\"phone\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fhero-iphone-fd25832b3f.svg\" height=\"489\"\u003E\u003Cvideo class=\"animated fadeIn\" width=\"210\" height=\"375\" id=\"hero-video\" autoplay loop\u003E\u003Csource src=\"\u002Fpages\u002Fguardian\u002Fresources\u002Fvideos\u002Fmfa-hero-loop.mp4\"\u003EYour browser does not support the video tag.\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-right\"\u003E\u003Cdiv class=\"flex-content\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fetu-icon-5a80a0f2fe.svg\"\u003E\u003Ch2 class=\"h1\"\u003E簡単な操作\u003C\u002Fh2\u003E\u003Cp class=\"h4\"\u003Eセキュリティに対する意識を持つユーザにとっても、エクスペリエンスはとても大切です。Guardian アプリで、スマートフォンからのログインの試みを許可するか拒否するか判別するためのやっかいなコード開発から解放されます。\u003C\u002Fp\u003E\u003Cp class=\"h4\"\u003Eプッシュ通知は、そのプロセスをさらに簡素化します。アプリを立ち上げることもなく、ログイン要求の許可または拒否を行います。また、Android Wear や Apple Watch でも利用できます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-stei text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fhiw-icon-2bfd9905d1.svg\"\u003E\u003Ch2 class=\"h1\"\u003Eスライドさせて\u003C\u002Fh2\u003E\u003Cp class=\"h4 text-half-column\"\u003E複数要素認証のアプリへの実装は、Guardianであればコードは不要で、画面上のスイッチを入れるだけで簡単です。\u003C\u002Fp\u003E\u003Cp class=\"cta-area\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003ETry it for free\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-default\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fmultifactor-authentication\u002Fguardian\" rel=\"external\"\u003ERead the docs\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cimg class=\"contain\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fbottom-screenshot-07eb5f11ce.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"section section-hiw text-center\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fhiw-icon-2bfd9905d1.svg\"\u003E\u003Ch2 class=\"h1\"\u003Eその働き\u003C\u002Fh2\u003E\u003Cp class=\"h4 text-half-column\" style=\"max-width: 73%;\"\u003Eワンタイムコードの必要は無くなり、ただ単にアプリをダウンロードして、ボタンを押してログインリクエストを許可するだけのGuardian の良さがお分かりになることでしょう。\u003C\u002Fp\u003E\u003Cdiv class=\"placeholder-media\"\u003E\u003Cvideo id=\"guardian-video-jp\" width=\"100%\" autoplay\u003E\u003Csource src=\"https:\u002F\u002Fembed-ssl.wistia.com\u002Fdeliveries\u002Fc78f78f06ea9e23216a9f2109c3f8545cdcb27d1\u002Fmfa-mobile-video.mp4\"\u003EYour browser does not support the video tag.\u003C\u002Fvideo\u003E\u003Ca class=\"play-me-again\" href=\"#\"\u003E\u003Ci class=\"icon-budicon-257\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"section section-sms-choice\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 stage clearfix\"\u003E\u003Cdiv class=\"half-holder is-left text-center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fsms-icon-a03191b110.svg\"\u003E\u003Ch2 class=\"h1\"\u003ESMS 対応\u003C\u002Fh2\u003E\u003Cp class=\"h4 copy-text\"\u003EGuardian アプリやスマートフォンさえ必要としないユーザでも、先進のAuth0 複数要素認証の機能で防御できます。SMSテキストメッセージ受信機能を持つ電話があれば、ワンタイムコードを受け取って利用できます。\u003C\u002Fp\u003E\u003Cimg class=\"contain pt30\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fnokia-phone-15653a22a8.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-md-6 info clearfix\"\u003E\u003Cdiv class=\"half-holder is-right text-center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fyc-icon-75e7af95c9.svg\"\u003E\u003Ch2 class=\"h1\"\u003E多様な選択肢\u003C\u002Fh2\u003E\u003Cp class=\"h4 copy-text\"\u003EAuth0 の複数要素認証は、どこでも利用可能です。Guardian アプリを iOS か Android 上で動かしてプッシュ通知を受け取ったり、SMS 経由でワンタイムコードを受け取ったり、または Google Authenticator のような他社アプリのトークンで接続します。\u003C\u002Fp\u003E\u003Cimg class=\"contain\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fguardian\u002Fassets\u002Fms-phone-eb4eb40b90.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (playgroundLock) {pug_html = pug_html + "\u003Cdiv class=\"interactive-section tab-pane fadeIn animated active\" id=\"playground-next\" role=\"tabpanel\"\u003E" + (null == (pug_interp = playgroundLock) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"playgroundLock" in locals_for_with?locals_for_with.playgroundLock:typeof playgroundLock!=="undefined"?playgroundLock:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"interactive-section tab-pane fadeIn animated\" id=\"interactive-passwordless-section\" role=\"tabpanel\"\u003E\u003Cdiv class=\"interactive-section-inner\"\u003E\u003Cdiv class=\"col-sm-6 code-block\"\u003E\u003Col class=\"code\"\u003E\u003Cli class=\"lock-li-method\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003Evar\u003C\u002Fspan\u003E\u003Cspan class=\"lock-li-text\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Choose the method to initialize the lock with.\"\u003Emethod\u003C\u002Fspan\u003E\u003Cspan class=\"lock-li-text\"\u003E =\u003C\u002Fspan\u003E\u003Cdiv class=\"fake-select-cont\" data-name=\"method\"\u003E\u003Cspan class=\"fake-select\"\u003E\u003Cspan class=\"current-option\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-arrow-down\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"select-options\"\u003E\u003Cspan class=\"select-value\" data-selected data-value=\"magiclink\"\u003Emagiclink\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"sms\"\u003Esms\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"emailcode\"\u003Eemailcode\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"social\"\u003Esocial\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-options\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003Evar options = {\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-disabled indent\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003EConnections will only be enabled if social method is chosen\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-connections lock-li-disabled indent\" data-enable-criteria=\"social\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Allow the user to close the lock.\"\u003Econnections:\u003C\u002Fspan\u003E\u003Cdiv class=\"fake-select-cont\" data-name=\"connections\"\u003E\u003Cspan class=\"fake-select\"\u003E\u003Cspan class=\"current-option\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-arrow-down\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"select-options\"\u003E\u003Cspan class=\"select-value\" data-value=\"[&quot;github&quot;, &quot;google-oauth2&quot;]\" data-selected\u003E[\"github\", \"google-oauth2\"]\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"[&quot;github&quot;, &quot;windowslive&quot;]\"\u003E[\"github\", \"windowslive\"]\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"[&quot;github&quot;, &quot;facebook&quot;]\"\u003E[\"github\", \"facebook\"]\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"[&quot;facebook&quot;, &quot;twitter&quot;]\"\u003E[\"facebook\", \"twitter\"]\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"[&quot;facebook&quot;, &quot;twitter&quot;, &quot;windowslive&quot;, &quot;google-oauth2&quot;]\"\u003E[\"facebook\", \"twitter\", \"windowslive\", \"google-oauth2\"]\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-color indent\" data-enable-criteria=\"non-social\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003EprimaryColor:\u003C\u002Fspan\u003E\u003Cinput type=\"text\" id=\"passwordless-color\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-icon indent\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003Eicon:\u003C\u002Fspan\u003E\u003Cdiv class=\"fake-select-cont\" data-name=\"icon\"\u003E\u003Cspan class=\"fake-select\"\u003E\u003Cspan class=\"current-option\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-arrow-down\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"select-options\"\u003E\u003Cspan class=\"select-value\" data-selected data-value=\"img\u002Flogo-tmz.svg\"\u003Eimg\u002Flogo-tmz.svg\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"img\u002Fsafari.svg\"\u003Eimg\u002Fsafari.svg\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"img\u002Fschneider.svg\"\u003Eimg\u002Fschneider.svg\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-gravatar indent\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\" data-toggle=\"tooltip\" data-placement=\"left\" title=\"Enable auto-fetching of user's Gravatar picture when e-mail is entered.\"\u003Egravatar:\u003C\u002Fspan\u003E\u003Cdiv class=\"fake-select-cont\" data-name=\"gravatar\"\u003E\u003Cspan class=\"fake-select\"\u003E\u003Cspan class=\"current-option\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-arrow-down\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"select-options\"\u003E\u003Cspan class=\"select-value\" data-selected data-value=\"true\"\u003Etrue\u003C\u002Fspan\u003E\u003Cspan class=\"select-value\" data-value=\"false\"\u003Efalse\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003E};\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-lock\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003Evar lock = new Auth0LockPasswordless(cid, domain);\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"lock-li-final-call\"\u003E\u003Cspan class=\"lock-li-content\"\u003E\u003Cspan class=\"lock-li-text\"\u003Elock[method](options);\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"iphone-hand col-sm-6 fadeInUpSubtle animated\"\u003E\u003Cdiv class=\"hide-scrollbars\" id=\"interactive-passwordless\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math) {var rand  = Math.random();
var lockSlideActive = rand > 0.3 ? 'active' : '';
var auth0SlideActive = rand <= 0.3 ? 'active' : '';
pug_mixins["slide_left"] = pug_interp = function(title, blockquote_description, blockquote_image, blockquote_author, blockquote_company, learn_more){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"vertical-align animated fadeIn slide-left\"\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003Cblockquote\u003E\u003Cp\u003E「\u003Cspan\u003E" + (pug.escape(null == (pug_interp = blockquote_description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E」\u003C\u002Fp\u003E\u003Cauthor\u003E\u003Cimg" + (pug.attr("src", blockquote_image, true, true)) + "\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = blockquote_author) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E,\u003Cspan\u003E" + (pug.escape(null == (pug_interp = blockquote_company) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fauthor\u003E\u003C\u002Fblockquote\u003E\u003Cdiv class=\"cta-action\"\u003E\u003Cdiv class=\"success\"\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003E無料トライアル\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"default\"\u003E\u003Ca" + (" class=\"btn btn-lg btn-default\""+pug.attr("href", learn_more || "/how-it-works", false, true)) + "\u003E詳しく知る\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"theme-dark carousel\" id=\"carousel\" data-ride=\"carousel\" data-interval=\"15000\" data-pause=\"true\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"left carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"prev\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"right carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"next\"\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"carousel-inner theme-dark\" role=\"listbox\"\u003E\u003Cdiv class=\"slide-2 row item active\"\u003E\u003Cdiv class=\"col-md-6\"\u003E";
pug_mixins["slide_left"]("認証を貴社のWEBサイトやモバイルアプリに導入しましょう！　１０分かかりません。", "Auth0を使って、SNSのプロフィールや個人情報についてより使いやすい環境をお客様に提供できました。", "https://cdn.auth0.com/website/assets/pages/homepage/img/avatar-7b1b7174a8.png", "Amol Date", "JetPrivilege");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"vertical-align ilustrations\"\u003E\u003Cdiv class=\"browser-container\"\u003E\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E\u003Cimg class=\"illustration-header\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-2-header-95ea7ef157.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"illustration-aircraft slideInUp\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-2-aircraft-a6f87eb60c.png\"\u003E\u003Cimg class=\"illustration-phone slideInUp3\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-2-phone-7ea778c28b.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sdks fadeIn\"\u003E\u003Cdiv class=\"circle-logo\" data-name=\"angular\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"nodejs\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"apple\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"ember\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"android\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"rails\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"vanillajs\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"go\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"net\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"php\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"circle-logo\" data-name=\"python\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-1 row item\"\u003E\u003Cdiv class=\"col-md-6\"\u003E";
pug_mixins["slide_left"]("すべての社内アプリへの社員のアクセスがシングルサインオン（SSO）で簡単に。", "Auth0を使うことで、アイデンティティ管理の計画や統合化が簡単になり、セキュリティの心配も無くなりました。", "https://cdn.auth0.com/website/assets/pages/homepage/img/avatar-7b1b7174a8.png", "Stephan Berard", "Schneider Electric");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"vertical-align ilustrations\"\u003E\u003Cimg class=\"illustration-lock animated fadeIn\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-1-lock-e73d10f6ab.png\"\u003E\u003Cimg class=\"illustration-iphone-left animated fadeInRight\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-1-iphone-left-a9435f6de2.png\"\u003E\u003Cimg class=\"illustration-iphone-right animated fadeInLeft\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-1-iphone-right-1f364e2370.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-3 row item\"\u003E\u003Cdiv class=\"col-md-6\"\u003E";
pug_mixins["slide_left"]("エンタープライズカスタマーは、保有するクレデンシャル（資格証明）でログインができます。", "カスタマーのシングルサインオン用のハブとしてAuth0を使って統合化することで開発が容易になり、その結果、顧客ベースが著しく増大しました。", "https://cdn.auth0.com/website/assets/pages/homepage/img/avatar-7b1b7174a8.png", "Cris Concepcion", "Safari Books Online");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"vertical-align ilustrations phones\"\u003E\u003Cimg class=\"illustration illustration-a animated\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-3a1-ef1eabfad1.png\"\u003E\u003Cimg class=\"illustration illustration-b animated\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fslide-3b2-e0b73fabf0.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"slide-4 row item\"\u003E\u003Cdiv class=\"col-md-6\"\u003E";
pug_mixins["slide_left"]("私たちのクラウド、貴社のクラウドやサーバー、どこからでもホストが可能です。", "Auth0は素晴らしいソリューションです。導入は容易でインフラ周りの要求は最小限にとどまります。", "https://cdn.auth0.com/website/assets/pages/homepage/img/avatar-7b1b7174a8.png", "Amol Date", "JetPrivilege");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"vertical-align animated fadeIn ilustrations\"\u003E\u003Cdiv class=\"premises-box-premises premises-box\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003EOn Premises\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"premises-box-vms premises-box last\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003EVM's\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"premises-box-iaas premises-box\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003EIaaS\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"premises-box-auth0 premises-box last\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003Cspan\u003EAuth0 Cloud\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Col class=\"carousel-indicators\"\u003E\u003Cli class=\"active\" data-target=\"#carousel\" data-slide-to=\"0\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"1\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"2\"\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"#carousel\" data-slide-to=\"3\"\u003E\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"ribbon-homepage\"\u003E\u003Cspan class=\"ribbon-icon icon-budicon-761\"\u003E\u003C\u002Fspan\u003E&nbsp;&nbsp;\u003Cspan\u003E\u003Ca href=\"\u002Fbreached-passwords\u002F\"\u003Eパスワード侵害の検知\u003C\u002Fa\u003E及び\u003Ca href=\"\u002Fguardian\u002F\"\u003EGuardianの多要素認証\u003C\u002Fa\u003Eのご紹介\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"customers theme-light\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch5\u003E\u003C\u002Fh5\u003E\u003Ca class=\"schneider\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fschneider-electric-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-schneider-8882b5d735.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"harper\" target=\"_blank\" href=\"\u002Fcustomers#harper\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-harper-485f833932.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"jet\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fjetprivilege-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-jet-26aa6f780e.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"newscorp\" target=\"_blank\" href=\"\u002Fcustomers#newscorp\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-newscorp-0dab593d7b.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"dow-jones\" target=\"_blank\" href=\"\u002Fcustomers#dow-jones\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-dow-jones-4eda673898.png\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"safari\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fsafari-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-safari-c6183c6e13.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"bluetooth-sig\" target=\"_blank\" href=\"\u002Fcustomers#bluetooth-sig\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-bluetooth-sig-633aa879fd.svg\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"houghton-mifflin-harcourt\" target=\"_blank\" href=\"\u002Fcustomers#houghton-mifflin-harcourt\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-houghton-mifflin-harcourt-efd84ddb0f.png\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"polaris\" target=\"_blank\" href=\"\u002Fcustomers#polaris\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-polaris-industries-5ee70ef168.svg\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"interactive\"\u003E\u003Cdiv class=\"page-title theme-light\"\u003E\u003Ch2\u003EAuth0の動きを見る\u003C\u002Fh2\u003E\u003Cp\u003E四角で囲まれたコードは選択可能なオプションですので、ここを変えてAuth0の実際の動きを見てみましょう。logging inやsigning upを変えることで、スマホの画面が変化します。ユーザーにとっても開発者にとっても簡単に使えるAuth0を実感して下さい。\u003C\u002Fp\u003E\u003Cul class=\"tabs\" role=\"tablist\"\u003E\u003Cli class=\"active\" role=\"presentation\"\u003E\u003Ca href=\"#interactive-lock-section\" role=\"tab\" data-toggle=\"tab\"\u003ELock\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli role=\"presentation\"\u003E\u003Ca href=\"#interactive-passwordless-section\" role=\"tab\" data-toggle=\"tab\"\u003EPasswordless\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-content theme-dark\"\u003E\u003Cdiv class=\"white-line\"\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(959).call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = __webpack_require__(960).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"global-sdk\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"global-block col-sm-6\"\u003E\u003Cdiv class=\"page-title-small\"\u003E\u003Ch2\u003Eグローバル\u003C\u002Fh2\u003E\u003Cp\u003E弊社は、１６７ヵ国以上に及ぶ顧客に恵まれ、３大陸に冗長化クラウドデータセンターを有し、お客様へのサービス提供のために理想的な場所へ拠点を置いております。\u003C\u002Fp\u003E\u003Ca href=\"\u002Favailability-trust\"\u003Eもっと知る\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"map\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Fmap-16558415ab.svg\"\u003E\u003Cdiv class=\"flag usa\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flag eu\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flag au\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"stats\"\u003E\u003Cspan class=\"datacenters\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E３地域\u003C\u002Fspan\u003E\u003Cspan class=\"uptime\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E稼働時間99.98%\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sdk-block col-sm-6\"\u003E\u003Cdiv class=\"page-title-small\"\u003E\u003Ch2\u003E開発は容易です\u003C\u002Fh2\u003E\u003Cp\u003E開発に際して専門性を気にすることは必要ありません。\u003C\u002Fbr\u003EAuth0は、役に立つサンプルコード、チュートリアルや有効なドキュメントを提供します。\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\"\u003Eドキュメンテーション\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sdks\"\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fclient-platforms\u002Fangularjs\" data-name=\"angular\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fclient-platforms\u002Fangular2\" data-name=\"angular2\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fserver-platforms\u002Fphp\" data-name=\"php\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fserver-apis\u002Fruby\" data-name=\"ruby\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fnative-platforms\u002Fios-objc\" data-name=\"apple\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fclient-platforms\u002Femberjs\" data-name=\"ember\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fnative-platforms\u002Fandroid\" data-name=\"android\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fjava-overview\" data-name=\"java\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fclient-platforms\u002Fvanillajs\" data-name=\"vanillajs\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fserver-platforms\u002Fgolang\" data-name=\"go\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fclient-platforms\u002Freact\" data-name=\"react\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"circle-logo\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fserver-platforms\u002Fnodejs\" data-name=\"nodejs\" rel=\"external\"\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:signup()\"\u003E無料トライアルを開始する\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["browser"] = pug_interp = function(url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Cdiv class=\"btns\"\u003E\u003Ci class=\"close\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"min\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"max\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"location-bar\"\u003E\u003Ci class=\"icon-budicon-285\"\u003E\u003C\u002Fi\u003E";
if (url) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = url) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003Ehttps:\u002F\u002Fmanage.auth0.com\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"menu-button\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"jp-dashboard-page theme-dark\"\u003E\u003Cdiv class=\"spinner-container\"\u003E\u003Cdiv class=\"auth0-spinner\"\u003E\u003Cdiv class=\"spinner\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"spinner-bg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"js-intro-text animated invisible intro-text\"\u003E\u003Ch1\u003EAuth0の仕組み\u003C\u002Fh1\u003E\u003Ch3\u003EAuth0は、最新のエンタープライズ向けのプラットフォームです。\u003Cbr\u003E貴社のアプリケーションやAPI（アカウントダッシュボードからアクセス可能）で、ストレスの無い認証が可能なツールを提供します。\u003C\u002Fh3\u003E\u003Ca class=\"btn btn-success btn-lg invisible login\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"dashboard-top\"\u003E無料トライアル\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"page-hero\"\u003E\u003Cdiv class=\"main-screenshot\"\u003E\u003Cdiv class=\"tooltips\"\u003E\u003Cdiv class=\"js-animation-stack\"\u003E\u003Cdiv class=\"box-tip box-tip-sidebar\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"0\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003ESidebar\u003C\u002Fh5\u003E\u003Cp\u003EEasily navigate through the set-up process or quickly access a particular feature.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box-tip box-tip-users\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"1\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003EUsers\u003C\u002Fh5\u003E\u003Cp\u003EQuickly view the latest logins\u003Cbr\u003Eand new sign-ups.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box-tip box-tip-stats\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"2\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003EStats\u003C\u002Fh5\u003E\u003Cp\u003EView important stats at-a-glance, right from your dashboard homepage.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box-tip box-tip-search\"\u003E\u003Cdiv class=\"mark-red hide fadeInUp\" data-order=\"3\"\u003E\u003Cdiv class=\"glow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"shape\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip top\"\u003E\u003Cdiv class=\"tooltip-inner\"\u003E\u003Ch5\u003ESearch\u003C\u002Fh5\u003E\u003Cp\u003EQuickly and easily find and access your apps or dashboard features.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tooltip-arrow\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"p-dashboard-1 invisible\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fp-dashboard-6fc11ba51b.png\"\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"p-dashboard-2 invisible\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fp-dashboard-2-4fcb50c958.png\"\u003E\u003Cimg class=\"mobile-screen invisible\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fmobile-screenshot-5e3c50548f.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"section section-overview blue-gradient\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003E概要\u003C\u002Fh2\u003E\u003Cp\u003EAuth0のダッシュボードでは、簡単にアプリケーションに接続し、アイデンティティプロバイダーを選び、ユーザーを追加し、ルールをセットアップし、ログインページをカスタマイズし、分析にアクセスできます。開発者にとって容易で理想的な環境を提供します。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-apps\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-339\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003EApps\u003C\u002Fh2\u003E\u003Cp\u003Eすべてのデバイス上のどのようなアプリケーションにも接続でき、すべてのプラットフォームで動きます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"js-contains-videos\"\u003E\u003Cdiv class=\"browser-wallpaper shadow-box\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_w1qzsic31w endVideoBehavior=reset\" id=\"wistia_w1qzsic31w\" data-source=\"w1qzsic31w\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/apps");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row app-features\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"medium-icon rounded-icon any-app icon-budicon-254\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eデバイスやプラットフォーム上のアプリケーション\u003C\u002Fh5\u003E\u003Cp\u003E貴社が求める既存のアプリケーションの接続に関する方法、参考にしたいプロジェクトや必要なカスタマイズされたインストラクションについて教えて下さい。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"medium-icon rounded-icon sdk icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003EマルチSDK\u003C\u002Fh5\u003E\u003Cp\u003Eすべての一般的なWEB、モバイルやプラットフォーム、貴社の特殊なアカウントについて、オープンソースのオフィシャルなSDKが用意されており、アクセス可能です。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"medium-icon rounded-icon login-icon icon-budicon-375\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eログインボックスの統合\u003C\u002Fh5\u003E\u003Cp\u003E弊社のログインウイジェットないしは貴社のUIのどちらでも、セットアップをサポートします（実際には数行のJavaScriptになります）。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section-quote blue-gradient\"\u003E\u003Cdiv class=\"js-animated fadeIn\"\u003E\u003Ch5\u003Eカスタマーボイス\u003C\u002Fh5\u003E\u003Cblockquote\u003E\u003Cp\u003E「 Auth0のプラットフォームを使うことで、開発者やエンジニアを複雑な開発から解放し、開発を容易にしました。」\u003C\u002Fp\u003E\u003C\u002Fblockquote\u003E\u003Cauthor\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Fhow-it-works\u002Fstephen-quote.jpg\"\u003E\u003Cstrong\u003EStephen Berard,\u003C\u002Fstrong\u003E\u003Cspan\u003E Senior Global Software Architect at Schneider Electric\u003C\u002Fspan\u003E\u003C\u002Fauthor\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-users clearfix\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-292\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003Eユーザー\u003C\u002Fh2\u003E\u003Cp\u003Eユーザーの追加や削除、プロフィールや認証属性の修正、ログインでの問題の切り分けが、シンプルかつ直感的でパワフルなWEBインタフェースを使用して、数分で可能です。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"user-list\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"shadow-box\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fuserlist-5ae6355485.png\"\u003E";
}
}, "https://manage.auth0.com/users");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row profiles-row\"\u003E\u003Cdiv class=\"pull-right text-subsection\"\u003E\u003Cdiv class=\"profiles-left\"\u003E\u003Ch3\u003Eプロフィール\u003C\u002Fh3\u003E\u003Cp\u003E各ユーザーごとの詳細なプロフィール情報にアクセス可能です。このプロフィール情報には、認証の詳細情報、デバイス、ログインの履歴やログインの場所の情報が含まれます。\u003C\u002Fp\u003E\u003Cdiv class=\"subsection-showcase js-switch-profile\"\u003E\u003Cdiv class=\"profiles\"\u003E\u003Cdiv class=\"profile left\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-2-17aff08570.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"profile center\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-1-8d7a6eeaf3.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"profile right\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-3-c762a6f9a4.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"profile back\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fusers-4-a728c31bdb.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nav\"\u003E\u003Cdiv class=\"dot\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dot selected\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dot\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dot\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row edit-user-row\"\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"pull-left text-subsection\"\u003E\u003Cdiv class=\"manage-left\"\u003E\u003Ch3\u003E管理\u003C\u002Fh3\u003E\u003Cp\u003Eユーザープロフィールの修正、ユーザーの削除やブロック、ユーザーとしてのサインインが簡単にできます。\u003C\u002Fp\u003E\u003Cdiv class=\"subsection-showcase js-animated\"\u003E\u003Cdiv class=\"modal-edit js-edit-user-animation\"\u003E\u003Cdiv class=\"modal-edit-header\"\u003E\u003Ch5\u003EEDITING\u003C\u002Fh5\u003E\u003Ch4\u003Ericky@auth0.com\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-edit-content\"\u003E\u003Cform class=\"form-horizontal\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"Ricardo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"ricardo@auth0.com\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"Ricky22\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"N\u002FA\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"N\u002FA\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"col-xs-8 col-xs-offset-2\"\u003E\u003Cinput class=\"form-control input-text\" type=\"text\" value=\"N\u002FA\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-edit-footer\"\u003E\u003Cbutton class=\"btn btn-success btn-sm\"\u003Esave\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"actions-list\"\u003E\u003Cp class=\"change\"\u003E\u003Ci class=\"icon-budicon-290\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESign In as user\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"add\"\u003E\u003Ci class=\"icon-budicon-272\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EEdit\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp class=\"block\"\u003E\u003Ci class=\"icon-budicon-306\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ERemove\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row impersonate\"\u003E\u003Cdiv class=\"content\"\u003E\u003Ch3\u003Eサインイン\u003C\u002Fh3\u003E\u003Cp\u003E理由がどうであれ、Auth0ではユーザーとしてログインが簡単にできます。\u003C\u002Fp\u003E\u003Cdiv class=\"select-user\"\u003E\u003Cdiv class=\"bubble-user icon-budicon-178\"\u003E\u003Cp\u003ESelect User\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dots-fill\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bubble-impersonate icon-budicon-315\"\u003E\u003Cp\u003EImpersonate\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"clean-gradient windows-row\"\u003E\u003Cdiv class=\"windows-tab shadow-box pull-left\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg class=\"desktop\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fsignin-972632254f.png\"\u003E";
}
}, "https://manage.auth0.com/user/12312312312");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"windows-tab shadow-box pull-right\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg class=\"desktop\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fmaterial-006b4d84a8.png\"\u003E";
}
}, "https://myapp.com");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"windows-linked\"\u003E\u003Csvg class=\"dots-no-fill\" width=\"73px\" height=\"20px\" viewbox=\"0 0 73 20\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cg stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"Shape-+-Shape-+-Shape\" sketch:type=\"MSLayerGroup\" fill=\"#44C7F4\"\u003E\u003Cpath class=\"shape s3 js-animated\" d=\"M60,2.33333333 L62.4594595,0 L73,10 L62.4594595,20 L60,17.6666667 L68.0810811,10 L60,2.33333333 Z\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath class=\"shape s2 js-animated\" d=\"M30,2.33333333 L32.4594595,0 L43,10 L32.4594595,20 L30,17.6666667 L38.0810811,10 L30,2.33333333 Z\" fill-opacity=\"0.6\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath class=\"shape s1 js-animated\" d=\"M0,2.33333333 L2.45945946,0 L13,10 L2.45945946,20 L0,17.6666667 L8.08108108,10 L0,2.33333333 Z\" fill-opacity=\"0.3\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-connections\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-339\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003E接続\u003C\u002Fh2\u003E\u003Cp\u003E貴社が選んだ接続方法で貴社のユーザーをアプリケーションに接続することができます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tabs js-video-switcher\"\u003E\u003Cdiv class=\"tab-content\"\u003E\u003Cdiv class=\"tab-list\"\u003E\u003Ca class=\"social active\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-292\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eソーシャル\u003C\u002Fh5\u003E\u003Cp\u003E一般的なソーシャルプロバイダー（Facebook、Twitterなど）でのユーザー認証\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"enterprise\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-606\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eエンタープライズ\u003C\u002Fh5\u003E\u003Cp\u003EAD、LDAP、SAMLなどを使ったエンタープライズユーザーの認証\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"database\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-690\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eデータベース\u003C\u002Fh5\u003E\u003Cp\u003Eユーザーのクレデンシャル（資格情報）をAuth0でも貴社でも安全に保存できます。\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"passwordless\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-469\"\u003E\u003C\u002Fi\u003E\u003Ch5 class=\"abbr-desktop\"\u003Eパスワードレス\u003C\u002Fh5\u003E\u003Ch5 class=\"abbr-mobile\"\u003Eパスワードレス\u003C\u002Fh5\u003E\u003Cp\u003Eユーザーがパスワードを思い出す必要の無いコネクションが使えます。\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"screenshots\"\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_ocd3f2o29y endVideoBehavior=reset\" id=\"wistia_ocd3f2o29y\" data-source=\"ocd3f2o29y\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/social");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_zwlxwzn141 endVideoBehavior=reset\" id=\"wistia_zwlxwzn141\" data-source=\"zwlxwzn141\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/enterprise");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_yb68zx3l0m endVideoBehavior=reset\" id=\"wistia_yb68zx3l0m\" data-source=\"yb68zx3l0m\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/database");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E\u003Cdiv class=\"iphone-dash animated fadeInUp hide\"\u003E\u003Cdiv class=\"hand-container\"\u003E\u003Cimg class=\"hand\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fpasswordless-3e471d6f9f.svg\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_k35hr7f2fu dash-demo endVideoBehavior=reset\" id=\"wistia_k35hr7f2fu\" data-source=\"k35hr7f2fu\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/connections/passwordless");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-lock\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"lock-intro\"\u003E\u003Cdiv class=\"content\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flock-logo-e12cf459ec.svg\"\u003E\u003Cp\u003E貴社のWEBサイトやモバイルアプリケー\u003Cbr\u003Eションを守る簡単な方法\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"dashboard-lock\"\u003E無料トライアルを開始する\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"showcase-area\"\u003E\u003Cdiv class=\"iphone-lock animated fadeInUp hide\"\u003E\u003Cdiv class=\"hand-container\"\u003E\u003Cimg class=\"hand\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-c8d6945135.svg\"\u003E\u003Cdiv class=\"lock-no-googleplus\" id=\"iphone\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper js-contains-videos\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_sdwbx1gx5o lock-demo endVideoBehavior=reset\" id=\"wistia_sdwbx1gx5o\" data-source=\"sdwbx1gx5o\" style=\"width:900px;height:557px;\"\u003E\u003C\u002Fdiv\u003E";
}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-connections section-extensibility\"\u003E\u003Cdiv class=\"container\"\u003E\u003Csvg class=\"hide\" width=\"1500px\" id=\"networks\" height=\"231px\" viewbox=\"0 0 1500 231\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cg id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"Network\" sketch:type=\"MSLayerGroup\" transform=\"translate(0.000000, 1.000000)\"\u003E\u003Cpath id=\"Line\" d=\"M257.5,168.5 L295.5,74.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-15\" d=\"M386,187 L294,75\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-3\" d=\"M357,104 L295.5,74.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-6\" d=\"M434.5,142.5 L370.5,110.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-17\" d=\"M450,220 L434.5,142.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-44\" d=\"M434,141 L436.5,41.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-39\" d=\"M496,183 L479,98\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-16\" d=\"M454,20 L365.5,106.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-18\" d=\"M626,81 L475.5,98.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-19\" d=\"M786,62 L635.5,79.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-20\" d=\"M699,183 L634.5,79.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-21\" d=\"M699,183.5 L585.5,183.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-46\" d=\"M584,183.5 L495.5,183.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-38\" d=\"M1207,167 L1117,164\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-12\" d=\"M451,220 L386,188\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-13\" d=\"M585,185 C585,185 566.203879,169.441489 556.805819,161.662233 C531.370546,140.608155 480.5,98.5 480.5,98.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-11\" d=\"M475,101 L434.5,142.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-42\" d=\"M255,171 L213,215\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-14\" d=\"M490,189 L451.5,218.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-9\" d=\"M384,181 L366.5,109.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line\" d=\"M176.5,87.5 L250.286858,161.286858\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-43\" d=\"M170.5,81.5 L212.5,214.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-45\" d=\"M0.5,8.5 L213.5,218.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-40\" d=\"M255.5,168.5 L382.5,188.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-37\" d=\"M877.5,148.5 L915.5,54.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-22\" d=\"M1006,167 L914,55\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-23\" d=\"M985.5,88.5 L914.5,53.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-24\" d=\"M1052,120 L990.5,90.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-25\" d=\"M1071,200 L1055.5,122.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-26\" d=\"M1074,0 L985.5,86.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-27\" d=\"M1246,61 L1095.5,78.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-28\" d=\"M1494.5,31.5 L1255.5,59.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-29\" d=\"M1319,163 L1254.5,59.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-30\" d=\"M1320,167.5 L1206.5,167.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-41\" d=\"M1493,29 L1319.5,166\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-31\" d=\"M1071,200 L1006.5,167.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-32\" d=\"M1205,165 C1205,165 1186.20388,149.441489 1176.80582,141.662233 C1151.37055,120.608155 1100.5,78.5 1100.5,78.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-33\" d=\"M1096,80 L1055.5,121.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-34\" d=\"M1110,169 L1071.5,198.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-35\" d=\"M1004,161 L986.5,89.5\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Line-36\" d=\"M796.5,67.5 L870.286858,141.286858\" stroke=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Ccircle id=\"Oval-50\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"790\" cy=\"61\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-51\" stroke=\"#1F242E\" stroke-width=\"2\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"915\" cy=\"54\" r=\"6\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-37\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"170\" cy=\"81\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-40\" stroke=\"#1F242E\" stroke-width=\"2\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"295\" cy=\"74\" r=\"6\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-39\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"257\" cy=\"168\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-61\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"213\" cy=\"217\" r=\"5\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-42\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"366\" cy=\"108\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-44\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"386\" cy=\"188\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-47\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"449\" cy=\"221\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-43\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"479\" cy=\"98\" r=\"5\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-48\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"634\" cy=\"80\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-49\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"699\" cy=\"186\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-45\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"584\" cy=\"184\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Cpath id=\"Oval-46\" d=\"M497,192 C501.418278,192 505,188.418278 505,184 C505,179.581722 501.418278,176 497,176 C492.581722,176 489,179.581722 489,184 C489,188.418278 492.581722,192 497,192 L497,192 L497,192 Z\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Ccircle id=\"Oval-52\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"877\" cy=\"148\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-53\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"986\" cy=\"88\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-54\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1006\" cy=\"168\" r=\"7\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-55\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1098\" cy=\"78\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-56\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1254\" cy=\"60\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-57\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1319\" cy=\"166\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-57-2\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1490\" cy=\"33\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-57-3\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"436\" cy=\"43\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Ccircle id=\"Oval-58\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\" cx=\"1207\" cy=\"167\" r=\"8\"\u003E\u003C\u002Fcircle\u003E\u003Cpath id=\"Oval-59\" d=\"M1117,172 C1121.41828,172 1125,168.418278 1125,164 C1125,159.581722 1121.41828,156 1117,156 C1112.58172,156 1109,159.581722 1109,164 C1109,168.418278 1112.58172,172 1117,172 L1117,172 L1117,172 Z\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Oval-60\" d=\"M1071,208 C1075.41828,208 1079,204.418278 1079,200 C1079,195.581722 1075.41828,192 1071,192 C1066.58172,192 1063,195.581722 1063,200 C1063,204.418278 1066.58172,208 1071,208 L1071,208 L1071,208 Z\" stroke=\"#1F242E\" stroke-width=\"3\" fill=\"#293448\" sketch:type=\"MSShapeGroup\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Cspan class=\"icon-badge icon-budicon-424\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003E拡張性\u003C\u002Fh2\u003E\u003Cp\u003E認証や認可のパイプラインのどこでもカスタマイズが可能です。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tabs js-video-switcher\"\u003E\u003Cdiv class=\"tab-content\"\u003E\u003Cdiv class=\"tab-list\"\u003E\u003Ca class=\"rules active\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-173\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eルール\u003C\u002Fh5\u003E\u003Cp\u003E毎回のアプリケーションへのユーザー認証で、認証パイプラインの一部として実行するルールが簡単に作成できます。\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"emails\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-778\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003E電子メール\u003C\u002Fh5\u003E\u003Cp\u003Eユーザー確認、パスワード変更、ウエルカムメッセージ等の電子メールテンプレートのカスタマイズや使用・不使用の設定が可能です。\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"addons\" href=\"\"\u003E\u003Cspan\u003E\u003Ci class=\"small-icon icon-budicon-325\"\u003E\u003C\u002Fi\u003E\u003Ch5\u003Eアドオン\u003C\u002Fh5\u003E\u003Cp\u003EAuth0では、プレミアムサポート、保証されたSLAやサードパーティーアプリSSOなどの追加が可能です。\u003C\u002Fp\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"screenshots\"\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_kpxvm1hg3u endVideoBehavior=reset\" id=\"wistia_kpxvm1hg3u\" data-source=\"kpxvm1hg3u\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/rules");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_436ragkpmt lock-demo endVideoBehavior=reset\" id=\"wistia_436ragkpmt\" data-source=\"436ragkpmt\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/emails");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"video-wrapper animated fadeInUpBig hide\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wistia_embed wistia_async_5q738mjeip endVideoBehavior=reset\" id=\"wistia_5q738mjeip\" data-source=\"5q738mjeip\"\u003E\u003C\u002Fdiv\u003E";
}
}, "https://manage.auth0.com/apps/addons");
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-mobile\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-7\"\u003E\u003Cimg class=\"iphone-left hide js-animated-after fadeInUp\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-2-56d4c9bc89.png\"\u003E\u003Cimg class=\"iphone-right js-animated fadeInUp\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-1-19443be8d0.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-5\"\u003E\u003Ch2\u003Eモバイル対応\u003C\u002Fh2\u003E\u003Cp\u003EAuth0は、iOS、アンドロイドやウィンドウズフォーン８などのすべての一般的なモバイルに対応しています。モバイルに対応している Lockウイジェットを使うことで、ユーザーはシームレスに認証ができます。近い将来、モバイルに適したインターフェースを使うことでダッシュボードに簡単にアクセスが可能になります。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"section section-end\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"small-icon support icon-budicon-513\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003E２４ｘ７のサポート\u003C\u002Fh4\u003E\u003Cp\u003Eヘルプデスクはいつでも受付可能です。必要な文書の閲覧、電子メールやチャットはいつでも可能です。私達はいつでもお客様を喜ばせたいと思っています。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"small-icon fairly icon-budicon-112\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003E適正な価格\u003C\u002Fh4\u003E\u003Cp\u003Eフル機能の無料のデベロッパーアカウントを取得して下さい。クレジットカードは必要ありません。実際の導入時に、貴社のニーズにあった柔軟な価格をご用意しています。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Ci class=\"small-icon logs icon-budicon-754\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003Eログ\u003C\u002Fh4\u003E\u003Cp\u003E最近２日間のログイン及び登録情報のユーザーログにアクセス可能です。もっと長い期間が必要でしたら、アカウントのアップグレードで対応可能です。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"create-account\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"dashboard-bottom\"\u003E無料のトライアルを開始する\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["browser"] = pug_interp = function(direction){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Cdiv class=\"btns\"\u003E\u003Ci class=\"close\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"min\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"max\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"location-bar\"\u003E\u003Cspan class=\"green\"\u003Ehttps\u003C\u002Fspan\u003E\u003Cspan class=\"gray\"\u003E:\u002F\u002F\u003C\u002Fspan\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = direction) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"jp-why-page page-content\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1\u003E何故Auth0が選ばれるのか？\u003C\u002Fh1\u003E\u003Cp\u003Eアイデンティティは、開発者のためにシンプルに。\u003C\u002Fp\u003E\u003Ca class=\"wistia-popover[height=720,playerColor=7b796a,width=1280] btn-play js-play-track\" href=\"\u002F\u002Ffast.wistia.net\u002Fembed\u002Fiframe\u002Ffu7ww3h1yx?popover=true\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"why-auth0-banner\"\u003E無料トライアルを開始する\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"demo-steps\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003E時間を節約してハッピーに。本当に大切なことに集中しましょう。\u003C\u002Fh2\u003E\u003Cp\u003Eどのようなスタック／デバイス／クラウドであっても、また、どのようなアイデンティティプロバイダーであっても、アプリやAPIへの認証・認可を提供。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"started-steps\"\u003E\u003Cdiv class=\"number-step\"\u003E\u003Cdiv class=\"step s1\"\u003E\u003Cspan\u003E1\u003C\u002Fspan\u003E\u003Cp\u003E無料のデベロッパーアカウントを作成する\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step s2\"\u003E\u003Cspan\u003E2\u003C\u002Fspan\u003E\u003Cp\u003Eアイデンティティプロバイダーを選ぶ\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step s3\"\u003E\u003Cspan\u003E3\u003C\u002Fspan\u003E\u003Cp\u003ESDKの選択や弊社ソリューションのAPIの呼び出し\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step s4\"\u003E\u003Cspan\u003E4\u003C\u002Fspan\u003E\u003Cp\u003E貴社のアプリケーションやAPIに接続する\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-step-content start-steps\"\u003E\u003Cdiv class=\"browser-step b1\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv id=\"lock-demo-step\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"text-password-input\"\u003E\u003Cdiv class=\"text-input\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"password-input\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'manage.auth0.com');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-step b2\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wrapper\"\u003E\u003Ch5\u003EIdentity Providers\u003C\u002Fh5\u003E\u003Cdiv class=\"grid-social\"\u003E\u003Cul\u003E\u003Cli data-social=\"facebook\"\u003E\u003Cdiv class=\"social-logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Ffacebook-e0a0fb6c8b.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switcher\"\u003E\u003Cdiv class=\"uiswitch\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli data-social=\"google\"\u003E\u003Cdiv class=\"social-logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Fgoogle-01ea05dbaf.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switcher\"\u003E\u003Cdiv class=\"uiswitch\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli data-social=\"linkedin\"\u003E\u003Cdiv class=\"social-logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Flinkedin-ad300e8a62.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switcher\"\u003E\u003Cdiv class=\"uiswitch\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli data-social=\"twitter\"\u003E\u003Cdiv class=\"social-logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Ftwitter-4efaae2fb1.svg\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switcher\"\u003E\u003Cdiv class=\"uiswitch\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli data-social=\"windows\"\u003E\u003Cdiv class=\"social-logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Fwindows-live-d404d08fa5.png\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switcher\"\u003E\u003Cdiv class=\"uiswitch\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-step b3\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"wrapper step-b3a\"\u003E\u003Ch5\u003EApplication Type\u003C\u002Fh5\u003E\u003Cdiv class=\"grid-apptype\"\u003E\u003Cul\u003E\u003Cli class=\"application-type-item\"\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003ENative Mobile App\u003C\u002Fh4\u003E\u003Cp\u003EAn app that runs natively in devices.\u003C\u002Fp\u003E\u003Cbutton class=\"select-button\"\u003ESelect\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli class=\"application-type-item\"\u003E\u003Ci class=\"icon-budicon-349\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003ESingle Page App\u003C\u002Fh4\u003E\u003Cp\u003EAn app that runs natively in devices.\u003C\u002Fp\u003E\u003Cbutton class=\"select-button\"\u003ESelect\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli class=\"application-type-item\"\u003E\u003Ci class=\"icon-budicon-378\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003ERegular Web App\u003C\u002Fh4\u003E\u003Cp\u003EAn app that runs natively in devices.\u003C\u002Fp\u003E\u003Cbutton class=\"select-button\"\u003E\u003Cspan\u003ESelect\u003C\u002Fspan\u003E\u003Ci class=\"icon-budicon-470\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003Cli class=\"application-type-item\"\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Ch4\u003EHybrid Mobile App\u003C\u002Fh4\u003E\u003Cp\u003EAn app that runs natively in devices.\u003C\u002Fp\u003E\u003Cbutton class=\"select-button\"\u003ESelect\u003C\u002Fbutton\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wrapper step-b3b\"\u003E\u003Ch5\u003EPlatform\u003C\u002Fh5\u003E\u003Cdiv class=\"grid-platforms\"\u003E\u003Cul\u003E\u003Cli\u003E\u003Cdiv class=\"logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Fnode-8b98c008fd.png\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ENODE.JS\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cdiv class=\"logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Fgolang-020fc83e13.png\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EGO\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cdiv class=\"logo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhy-auth0\u002Fimg\u002Flogos\u002Frails-b2a622e7f0.png\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ERUBY API\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wrapper step-b3c\"\u003E\u003Ch5\u003ECopy this code:\u003C\u002Fh5\u003E\u003Cpre\u003E\u003Ccode class=\"html\"\u003E&lt;script src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fjs\u002Flock-7.0.min.js\"&gt;&lt;\u002Fscript&gt;\n&lt;script type=\"text\u002Fjavascript\"&gt;\n  var lock = new Auth0Lock('4N28qGxpvbvu4xBdSbY2U7C7OAJS4B29', 'matias.auth0.com');\n&nsbp;\n  function signin() {\n    lock.show({\n      callbackURL: 'http:\u002F\u002Flocalhost:CHANGE-TO-YOUR-PORT\u002Fcallback',\n      responseType: 'code',\n      authParams: {\n        scope: 'openid profile'\n      }\n    });\n  }\n&lt;\u002Fscript&gt;\n&lt;button onclick=\"signin()\"&gt;Login&lt;\u002Fbutton&gt;\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003C\u002Fdiv\u003E";
}
}, 'manage.auth0.com');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-step b4\"\u003E\u003Cdiv class=\"step-b4a\"\u003E\u003Cdiv class=\"wrapper\"\u003E\u003Cpre\u003E\u003Ccode class=\"html\"\u003E&lt;script src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fjs\u002Flock-7.0.min.js\"&gt;&lt;\u002Fscript&gt;\n&lt;script type=\"text\u002Fjavascript\"&gt;\n  var lock = new Auth0Lock('4N28qGxpvbvu4xBdSbY2U7C7OAJS4B29', 'iamevilrabbit.auth0.com');\n&nsbp;\n  function signin() {\n    lock.show({\n      callbackURL: 'http:\u002F\u002Flocalhost:CHANGE-TO-YOUR-PORT\u002Fcallback',\n      responseType: 'code',\u003C\u002Fcode\u003E\u003Ccode class=\"code-input\"\u003E\u003C\u002Fcode\u003E\u003Ccode class=\"html\"\u003E      authParams: {\n        scope: 'openid profile'\n      }\n    });\n  }\n&lt;\u002Fscript&gt;\n&lt;button onclick=\"signin()\"&gt;Login&lt;\u002Fbutton&gt;\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step-b4b\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv id=\"lock-demo-step-2\"\u003E\u003C\u002Fdiv\u003E";
}
}, 'myapp.com');
pug_html = pug_html + "\u003Cdiv class=\"iphone-device\"\u003E\u003Cimg class=\"iphone-img\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fdashboard\u002Fimg\u002Fiphone-c8d6945135.svg\"\u003E\u003Cdiv id=\"lock-demo-iphone\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"play-me-again\" href=\"#\"\u003E\u003Ci class=\"icon-budicon-257\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"started-bottom\"\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"why-auth0-get-started\"\u003E無料トライアルを開始する\u003C\u002Fa\u003E\u003Cp\u003E\u003Ca href=\"\u002Fhow-it-works\"\u003Eダッシュボードにについてもっと知る\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"our-mission\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003Eこれまでのアイデンティティのインフラは、既に古いものとなっています。\u003C\u002Fh2\u003E\u003Cp\u003E最新のクラウドハイブリッドのアプリケーションやAPIの急速な複雑化\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cnav class=\"nav-pills mobile swiper-container\"\u003E\u003Cdiv class=\"swiper-wrapper\"\u003E\u003Ca class=\"swiper-slide active\" href=\"#specialized-apps\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-374\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E特化したアプリ\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#specialized-stacks\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-661\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E特化したスタック\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#apps-apis\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-342\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EアプリとAPI\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#multiple-devices\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Eマルチデバイス\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#on-prem\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-156\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Eオンプレミスとクラウド\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cnav class=\"nav-pills no-mobile\"\u003E\u003Cdiv class=\"content\"\u003E\u003Ca class=\"active\" href=\"#specialized-apps\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-374\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E特化したアプリ\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#specialized-stacks\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-661\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E特化したスタック\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#apps-apis\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-342\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EアプリとAPI\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#multiple-devices\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Eマルチデバイス\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#on-prem\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-156\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003Eオンプレミスとクラウド\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"tab-content\"\u003E\u003Cdiv class=\"tab-pane active\" id=\"specialized-apps\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003E時代遅れの世界\u003C\u002Fh3\u003E\u003Cp\u003Eオンプレミスのいくつかのコアなアプリケーション\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003E最新の世界\u003C\u002Fh3\u003E\u003Cp\u003E特殊なケースを解決する、特化した多くのアプリケーション\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"specialized-stacks\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003E時代遅れの世界\u003C\u002Fh3\u003E\u003Cp\u003Eシングルベンダースタック\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003E最新の世界\u003C\u002Fh3\u003E\u003Cp\u003Eベストオブブリードのプラットフォーム、言語、コンポーネントの混合と組み合わせ\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"apps-apis\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003E時代遅れの世界\u003C\u002Fh3\u003E\u003Cp\u003EWEBアプリケーションやリッチクライアントアプリケーション\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003E最新の世界\u003C\u002Fh3\u003E\u003Cp\u003EWEBアプリケーション、HTML５のシングルページアプリケーション、HTTP APIを使用するモバイルネイティブアプリ\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"multiple-devices\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003E時代遅れの世界\u003C\u002Fh3\u003E\u003Cp\u003EデスクトップPC\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003E最新の世界\u003C\u002Fh3\u003E\u003Cp\u003Eノートパソコン、タブレット、スマートフォンやIoT接続機器\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"on-prem\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003E時代遅れの世界\u003C\u002Fh3\u003E\u003Cp\u003Eすべてがファイアウォールの中のオンプレミス\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003E最新の世界\u003C\u002Fh3\u003E\u003Cp\u003Eプライベートクラウド、パブリッククラウドとオンプレミスの混合\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"makes-it-easy\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"rows\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003EAuth0で簡単に\u003C\u002Fh2\u003E\u003Cp\u003E開発者にとってのアイデンティティアクセス管理を簡単にするソリューション特性。この分野の専門家によって生み出されました。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row features-list\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-333\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003E拡張性\u003C\u002Fh5\u003E\u003Cp\u003Eクローズの必要の無い、チェックボックスタイプの構成ツール。新しいポリシーやアプリケーション、新プラットフォームに対応するための認証・認可パイプラインのどの段階でも完全なカスタマイズが可能です。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-342\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EシンプルなAPI\u003C\u002Fh5\u003E\u003Cp\u003E強固でシンプルかつ安全なHTTPS APIへの接続は、他のツールや方法とのシームレスな統合には不可欠なものです。Auth0では、どのようなスタック／デバイス／クラウドであっても、また、どのようなアイデンティティプロバイダーであっても、アプリやAPIへの認証・認可が可能となります。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-341\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003Eユーザーが中心\u003C\u002Fh5\u003E\u003Cp\u003E複数のアイデンティティプロバイダーのサポートは必須です。Auth0を使うことによって、貴社のユーザーが最も通じたクレデンシャルで認証を受けられるように簡単に設定できます。エンタープライズ、ソーシャルないしはアプリの特有性に合わせて数行のJavaScriptでフルカスタマイズ可能なAuth0のウイジェットにより、エンタープライズ対応の登録／ログイン用ボックスを直ぐに作れます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-535\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003E業界標準プロトコル\u003C\u002Fh5\u003E\u003Cp\u003EAuth0は、ベンダーロックインとならない SAML、OpenID Connect、JSON Web Token、OAuth 2.0、OAuth 1.0a、WS-Federation や OpenIDなどの業界スタンダードをサポートしています。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-330\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003ESDK\u003C\u002Fh5\u003E\u003Cp\u003Eアプリケーションは、現在では広い範囲のテクノロジースタック上に構築されます。Auth0は、貴社の好みの言語とスタックによって深いインテグレーションが可能となるよう、すべての一般的なウェブ、モバイル、およびネイティブプラットフォームのSDKを提供しています。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-692\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003E分析\u003C\u002Fh5\u003E\u003Cp\u003Eユーザーの動きを可視化することは、より適切でより素早い意思決定を可能にします。Auth0は、何が起こっているかを容易に知るために用意されたパワフルなレポートと分析へのアクセスを提供します。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-640\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003E多要素認証\u003C\u002Fh5\u003E\u003Cp\u003E強化されたセキュリティを稼働中のアプリケーションに適用したいですか？ Auth0を使うことで、多要素認証がものの数分で可能になります。\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fget-started-with-mfa\" rel=\"external\"\u003Eもっと知る\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003E端末を問いません\u003C\u002Fh5\u003E\u003Cp\u003E貴社のユーザーはアプリケーションをマルチデバイスで使っていますか？問題はありません。ユーザーの認証と認可は、ユーザーがどのデバイスを使っていても首尾一貫して管理できます。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-189\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003Eスケーラビリティと信頼性\u003C\u002Fh5\u003E\u003Cp\u003E認証はユーザーの利用において非常に重要です。ユーザーはログインができないと何もできません。Auth0は可用性を真剣にとらえています。弊社は、貴社のユーザー数の規模によらず、安心な保障されたSLAをオファーしています。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-168\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003Eシングルサインオン\u003C\u002Fh5\u003E\u003Cp\u003Eシンプルなステップだけで、貴社のユーザーは複数のアプリケーションへログイン可能です。\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fhow-to-implement-single-sign-on\" rel=\"external\"\u003Eもっと知る\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-156\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003Eハイブリッドなクラウド環境\u003C\u002Fh5\u003E\u003Cp\u003EAuth0はオンプレミスでもクラウドでも稼働します。貴社のビジネスに最適な方をお選び下さい。\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-842\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003Eソーシャルログイン\u003C\u002Fh5\u003E\u003Cp\u003Eエンドユーザーの好みのソーシャルネットワークプロバイダーの既存ログイン情報を使って、登録とログインが簡単にできます。\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fsocial-login\" rel=\"external\"\u003Eもっと知る\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"quote-partner\"\u003E\u003Ch5\u003Eカスタマーボイス\u003C\u002Fh5\u003E\u003Cblockquote\u003E\u003Cp\u003E「顧客へのソリューションを自ら構築し、ホストしセキュリティを管理する費用と必要なリソースを考えると、Auth0は現実的な選択肢だ。」\u003C\u002Fp\u003E\u003C\u002Fblockquote\u003E\u003Cdiv class=\"author\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Fwhy-auth0\u002Fcris-quote.jpeg\"\u003E\u003Cstrong\u003ECris Concepcion,\u003C\u002Fstrong\u003E\u003Cp\u003E‎Engineering Manager at Safari Books Online\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"lock-container clearfix\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row hero-area\"\u003E\u003Cdiv class=\"col-sm-5 hero-copy\"\u003E\u003Cdiv class=\"vertical-align\"\u003E\u003Ch1 class=\"lock-logo\"\u003ELock\u003C\u002Fh1\u003E\u003Cp\u003EThe easiest way of securing your website and mobile apps.\u003C\u002Fp\u003E\u003Cdiv class=\"button-container\"\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:signup()\"\u003EUSE AUTH0 FOR FREE\u003C\u002Fa\u003E\u003Ca class=\"btn btn-lg btn-default get-lock\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flibraries\u002Flock\" target=\"_blank\"\u003ERead the docs\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"github\" href=\"https:\u002F\u002Fgithub.com\u002Fauth0\u002Flock\" target=\"_blank\"\u003Eor fork the repository from\u003Cspan class=\"icon-1392070209-icon-social-github\"\u003E\u003C\u002Fspan\u003E\u003Cstrong\u003EGitHub\u003C\u002Fstrong\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-7 hero-illustration\"\u003E\u003Cdiv class=\"devices devices-ready\"\u003E\u003Cdiv class=\"iphone iphone-left\"\u003E\u003Cdiv class=\"vertical-align\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Fphone-left-fe4c7bb269.png\" alt=\"iPhone with TMZ app using Lock\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hand-container\"\u003E\u003Cdiv class=\"vertical-align\"\u003E\u003Cdiv id=\"iphone-container\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"iphone iphone-right\"\u003E\u003Cdiv class=\"vertical-align\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Fphone-right-af9dc0ab2b.png\" alt=\"iPhone with Schneider Electric app using Lock\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"how-it-works enable-onview\"\u003E\u003Cdiv class=\"interactive\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cdiv class=\"page-title\"\u003E\u003Ch2\u003EThe Login Box done right\u003C\u002Fh2\u003E\u003Cp\u003ELock is an embeddable login form for desktop, tablet and mobile devices.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-content theme-dark\"\u003E\u003Cdiv id=\"interactive-lock-section\"\u003E\u003Cdiv class=\"white-line\"\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = __webpack_require__(334).call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"modes\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"page-title\"\u003E\u003Ch2\u003EModes\u003C\u002Fh2\u003E\u003Cp\u003EMultiple modes are available, overlay, embed, hosted and of course, Lock is mobile ready and dynamically display properly on phone and tablets.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 mode-item\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Fmode-1-0114f13bf4.png\" alt=\"Lock overlay mode\"\u003E\u003Ch5\u003EOverlay\u003C\u002Fh5\u003E\u003Cp\u003EThe default mode shows Lock as a modal dialog\u003C\u002Fp\u003E\u003Cp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flibraries\u002Flock\u002Fv9\u002Fdisplay-modes#overlay-mode\" target=\"_new\"\u003EView Example\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 mode-item\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Fmode-2-d885f77fce.png\" alt=\"Lock embed mode\"\u003E\u003Ch5\u003EEmbed\u003C\u002Fh5\u003E\u003Cp\u003ELock can be embedded in a div\u003C\u002Fp\u003E\u003Cp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flibraries\u002Flock\u002Fv9\u002Fdisplay-modes#embedded-mode\" target=\"_new\"\u003EView Example\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 mode-item\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Fmode-3-72e200d30e.png\" alt=\"Lock hosted mode\"\u003E\u003Ch5\u003EHosted\u003C\u002Fh5\u003E\u003Cp\u003EOr simply use Auth0 Hosted Login if you don't want to add Lock to your app\u003C\u002Fp\u003E\u003Cp\u003E\u003Ca href=\"https:\u002F\u002Fmatugit.auth0.com\u002Flogin?client=bm70oLevwEM6PjICBnczyNySHjFkDcNR\" target=\"_new\"\u003EView Example\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-3 mode-item mode-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Fmode-4-c119f5932c.png\" alt=\"Lock mobile ready\"\u003E\u003Ch5\u003EMobile Ready\u003C\u002Fh5\u003E\u003Cp\u003ELock works great on tablets and mobile phones, including iPhones, iPads, and Android devices.\u003C\u002Fp\u003E\u003Cp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flibraries\u002Flock-ios\" target=\"_new\"\u003ERead More\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"connections\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cdiv class=\"page-title\"\u003E\u003Ch2\u003EConnections\u003C\u002Fh2\u003E\u003Cp\u003ESupport more authentication options becomes as simple\u003Cbr\u003Eas toggling a radio button.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"clearfix big-tabs tabs-connections\"\u003E\u003Cli class=\"active\" data-target=\"social\"\u003E\u003Ca href=\"#\" data-target=\"social\"\u003EIntegrating with APIs\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"enterprise\"\u003E\u003Ca href=\"#\" data-target=\"enterprise\"\u003EIntegrating with Enterprise\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli data-target=\"database\"\u003E\u003Ca href=\"#\" data-target=\"database\"\u003EDIFFERENT DATABASES\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"browser-background\"\u003E\u003Cdiv class=\"browser-lite\"\u003E\u003Cdiv class=\"browser-toolbar visible-lg-block\"\u003E\u003Cdiv class=\"button\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"button\"\u003E\u003C\u002Fdiv\u003E\u003Ci class=\"r\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"y\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"g\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"input\"\u003EAuth0 Dashboard\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E\u003Cdiv class=\"connection-category\" id=\"social\"\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial amazon\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial dropbox\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial facebook\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial github\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial gmail\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial google\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection off\"\u003E\u003Ci class=\"zocial googleplus\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial guest\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial linkedin\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial openid\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial paypal\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial stackoverflow\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial thecity\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial twitter\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection off\"\u003E\u003Ci class=\"zocial vk\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial windows\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial yahoo\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial office365\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial thirtysevensignals\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial salesforce\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial waad\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection off\"\u003E\u003Ci class=\"zocial yahoo\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial box\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial aol\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial renren\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial baidu\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial fitbit\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial yandex\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial wordpress\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial dwolla\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial shopify\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial yammer\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial miicard\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial soundcloud\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial evernote\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial yandex\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial ebay\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial sharepoint\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial weibo\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial instagram\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Ci class=\"zocial thecity\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hide connection-category\" id=\"enterprise\"\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-google-apps-858bb64d5a.png\" alt=\"Google Apps logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-pf-1787036e25.png\" alt=\"Ping Federate logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-office-54f20e343d.png\" alt=\"Office logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-ca-c5f4b5b9ae.png\" alt=\"ca technologies logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-ad-e66d27a705.png\" alt=\"Active Directory logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-ldap-ffc7f13098.png\" alt=\"LDAP logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-saml-eb805541f5.png\" alt=\"SAML logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-adfs-087e250d0a.png\" alt=\"ADFS logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hide connection-category\" id=\"database\"\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-aspnet-1f8e3dc2ab.png\" alt=\"ASP.NET logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-mongodb-00567ed4e3.png\" alt=\"mongoDB logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-mysql-1e77a578a4.png\" alt=\"MySQL logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-postgresql-93130b9dc5.png\" alt=\"PostgreSQL logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-sqlserver-c89ed191f2.png\" alt=\"Microsoft SQL Server 2012 logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-azure-sql-f328120e2d.png\" alt=\"Microsoft SQL Azure logo\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"connection\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Flock\u002Fimg\u002Flogo-request-c8912aef09.png\" alt=\"Basic Auth\"\u003E\u003Cdiv class=\"cb\"\u003E\u003Ci\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EStart your free trial today\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:signup()\" target=\"_blank\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"mcc-page simple-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci class=\"icon-budicon-433\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003E Model Contract Clause\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EPlease carefully review these European Commission Standard Contractual Clauses (processors), because it is a binding legal document. The data exporter consents and agrees that\u003C\u002Fp\u003E\u003Col type=\"i\"\u003E\u003Cli\u003Eit is the controller of personal data transferred from the European Economic Area (EEA) to the United States or other countries not deemed to provide adequate security for such data, and\u003C\u002Fli\u003E\u003Cli\u003Ean electronic signature (manifested by clicking “I accept”), meets the requirements of an original signature as if actually signed in writing.  At the request of data importer, any electronically signed document must be re-executed by data exporter in original form. No party hereto may raise the use of an electronic signature as a defense to the enforcement of these clauses.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003Ch3\u003EStandard Contractual Clauses (processors)\u003C\u002Fh3\u003E\u003Cp\u003E\u003Cstrong\u003EFor the purposes of Article 26(2) of Directive 95\u002F46\u002FEC for the transfer of personal data to processors established in third countries which do not ensure an adequate level of data protection, the non-Auth0 legal entity accepting the Clauses (the “Data Exporter”) and Auth0 Inc., 10900 NE 8th Street, Suite 700, Bellevue, WA, 98004, USA (the “Data Importer”) each a “party”; together “the parties”, HAVE AGREED on the following Contractual Clauses (the “Clauses”) in order to adduce adequate safeguards with respect to the protection of privacy and fundamental rights and freedoms of individuals for the transfer by the data exporter to the data importer of the personal data specified in Appendix 1.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EThe Clauses (including Appendices 1 and 2) are effective from the date the non-Auth0 entity has both: (i) executed a valid “Auth0 Service Agreement” (collectively the “Services Agreement”) or is otherwise an authorized customer affiliate under such Services Agreement; and (ii) clicked to accept these Clauses. A “Auth0 Service Agreement” means an Auth0 Service Agreement entered into with Auth0 Inc.,.\u003C\u002Fp\u003E\u003Cp\u003EIf you are accepting on behalf of the Data Exporter, you represent and warrant that: (i) you have full legal authority to bind your employer, or the applicable entity, to these terms and conditions; (ii) you have read and understand the Clauses; and (iii) you agree, on behalf of the party that you represent, to the Clauses. If you do not have the legal authority to bind the Data Exporter, please do not click the “I Accept” button below. The Clauses shall automatically expire on the termination or expiry of the Auth0 Service Agreement. The parties agree that where Data Exporter has been presented with these Clauses and clicked to accept these terms electronically, such acceptance shall constitute execution of the entirety of the Clauses by both parties, subject to the effective date described above.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EClause 1\u003C\u002Fh3\u003E\u003Cp\u003EDefinitions\u003C\u002Fp\u003E\u003Cp\u003EFor the purposes of the Clauses:\u003Col type=\"a\"\u003E\u003Cli\u003E'personal data', 'special categories of data', 'process\u002Fprocessing', 'controller', 'processor', 'data subject' and 'supervisory authority' shall have the same meaning as in Directive 95\u002F46\u002FEC of the European Parliament and of the Council of 24 October 1995 on the protection of individuals with regard to the processing of personal data and on the free movement of such data[1];\u003C\u002Fli\u003E\u003Cli\u003E'the data exporter' means the controller who transfers the personal data;\u003C\u002Fli\u003E\u003Cli\u003E'the data importer' means the processor who agrees to receive from the data exporter personal data intended for processing on his behalf after the transfer in accordance with his instructions and the terms of the Clauses and who is not subject to a third country's system ensuring adequate protection within the meaning of Article 25(1) of Directive 95\u002F46\u002FEC;\u003C\u002Fli\u003E\u003Cli\u003E'the subprocessor' means any processor engaged by the data importer or by any other subprocessor of the data importer who agrees to receive from the data importer or from any other subprocessor of the data importer personal data exclusively intended for processing activities to be carried out on behalf of the data exporter after the transfer in accordance with his instructions, the terms of the Clauses and the terms of the written subcontract;\u003C\u002Fli\u003E\u003Cli\u003E'the applicable data protection law' means the legislation protecting the fundamental rights and freedoms of individuals and, in particular, their right to privacy with respect to the processing of personal data applicable to a data controller in the Member State in which the data exporter is established;\u003C\u002Fli\u003E\u003Cli\u003E'technical and organisational security measures' means those measures aimed at protecting personal data against accidental or unlawful destruction or accidental loss, alteration, unauthorised disclosure or access, in particular where the processing involves the transmission of data over a network, and against all other unlawful forms of processing.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 2\u003C\u002Fh3\u003E\u003Cp\u003EDetails of the transfer\u003C\u002Fp\u003E\u003Cp\u003EThe details of the transfer and in particular the special categories of personal data where applicable are specified in Appendix 1 which forms an integral part of the Clauses.\u003C\u002Fp\u003E\u003Ch3\u003EClause 3\u003C\u002Fh3\u003E\u003Cp\u003EThird-party beneficiary clause\u003Col\u003E\u003Cli\u003EThe data subject can enforce against the data exporter this Clause, Clause 4(b) to (i), Clause 5(a) to (e), and (g) to (j), Clause 6(1) and (2), Clause 7, Clause 8(2), and Clauses 9 to 12 as third-party beneficiary.\u003C\u002Fli\u003E\u003Cli\u003EThe data subject can enforce against the data importer this Clause, Clause 5(a) to (e) and (g), Clause 6, Clause 7, Clause 8(2), and Clauses 9 to 12, in cases where the data exporter has factually disappeared or has ceased to exist in law unless any successor entity has assumed the entire legal obligations of the data exporter by contract or by operation of law, as a result of which it takes on the rights and obligations of the data exporter, in which case the data subject can enforce them against such entity.\u003C\u002Fli\u003E\u003Cli\u003EThe data subject can enforce against the subprocessor this Clause, Clause 5(a) to (e) and (g), Clause 6, Clause 7, Clause 8(2), and Clauses 9 to 12, in cases where both the data exporter and the data importer have factually disappeared or ceased to exist in law or have become insolvent, unless any successor entity has assumed the entire legal obligations of the data exporter by contract or by operation of law as a result of which it takes on the rights and obligations of the data exporter, in which case the data subject can enforce them against such entity. Such third-party liability of the subprocessor shall be limited to its own processing operations under the Clauses.\u003C\u002Fli\u003E\u003Cli\u003EThe parties do not object to a data subject being represented by an association or other body if the data subject so expressly wishes and if permitted by national law.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 4\u003C\u002Fh3\u003E\u003Cp\u003EObligations of the data exporter\u003C\u002Fp\u003E\u003Cp\u003EThe data exporter agrees and warrants:\u003Col type=\"a\"\u003E\u003Cli\u003Ethat the processing, including the transfer itself, of the personal data has been and will continue to be carried out in accordance with the relevant provisions of the applicable data protection law (and, where applicable, has been notified to the relevant authorities of the Member State where the data exporter is established) and does not violate the relevant provisions of that State;\u003C\u002Fli\u003E\u003Cli\u003Ethat it has instructed and throughout the duration of the personal data processing services will instruct the data importer to process the personal data transferred only on the data exporter's behalf and in accordance with the applicable data protection law and the Clauses;\u003C\u002Fli\u003E\u003Cli\u003Ethat the data importer will provide sufficient guarantees in respect of the technical and organisational security measures specified in Appendix 2 to this contract;\u003C\u002Fli\u003E\u003Cli\u003Ethat after assessment of the requirements of the applicable data protection law, the security measures are appropriate to protect personal data against accidental or unlawful destruction or accidental loss, alteration, unauthorised disclosure or access, in particular where the processing involves the transmission of data over a network, and against all other unlawful forms of processing, and that these measures ensure a level of security appropriate to the risks presented by the processing and the nature of the data to be protected having regard to the state of the art and the cost of their implementation;\u003C\u002Fli\u003E\u003Cli\u003Ethat it will ensure compliance with the security measures;\u003C\u002Fli\u003E\u003Cli\u003Ethat, if the transfer involves special categories of data, the data subject has been informed or will be informed before, or as soon as possible after, the transfer that its data could be transmitted to a third country not providing adequate protection within the meaning of Directive 95\u002F46\u002FEC;\u003C\u002Fli\u003E\u003Cli\u003Eto forward any notification received from the data importer or any subprocessor pursuant to Clause 5(b) and Clause 8(3) to the data protection supervisory authority if the data exporter decides to continue the transfer or to lift the suspension;\u003C\u002Fli\u003E\u003Cli\u003Eto make available to the data subjects upon request a copy of the Clauses, with the exception of Appendix 2, and a summary description of the security measures, as well as a copy of any contract for subprocessing services which has to be made in accordance with the Clauses, unless the Clauses or the contract contain commercial information, in which case it may remove such commercial information;\u003C\u002Fli\u003E\u003Cli\u003Ethat, in the event of subprocessing, the processing activity is carried out in accordance with Clause 11 by a subprocessor providing at least the same level of protection for the personal data and the rights of data subject as the data importer under the Clauses; and\u003C\u002Fli\u003E\u003Cli\u003Ethat it will ensure compliance with Clause 4(a) to (i).\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 5\u003C\u002Fh3\u003E\u003Cp\u003EObligations of the data importer[2]\u003C\u002Fp\u003E\u003Cp\u003EThe data importer agrees and warrants:\u003Col type=\"a\"\u003E\u003Cli\u003Eto process the personal data only on behalf of the data exporter and in compliance with its instructions and the Clauses; if it cannot provide such compliance for whatever reasons, it agrees to inform promptly the data exporter of its inability to comply, in which case the data exporter is entitled to suspend the transfer of data and\u002For terminate the contract;\u003C\u002Fli\u003E\u003Cli\u003Ethat it has no reason to believe that the legislation applicable to it prevents it from fulfilling the instructions received from the data exporter and its obligations under the contract and that in the event of a change in this legislation which is likely to have a substantial adverse effect on the warranties and obligations provided by the Clauses, it will promptly notify the change to the data exporter as soon as it is aware, in which case the data exporter is entitled to suspend the transfer of data and\u002For terminate the contract;\u003C\u002Fli\u003E\u003Cli\u003Ethat it has implemented the technical and organisational security measures specified in Appendix 2 before processing the personal data transferred;\u003C\u002Fli\u003E\u003Cli\u003Ethat it will promptly notify the data exporter about:\u003Col type=\"i\"\u003E\u003Cli\u003Eany legally binding request for disclosure of the personal data by a law enforcement authority unless otherwise prohibited, such as a prohibition under criminal law to preserve the confidentiality of a law enforcement investigation,\u003C\u002Fli\u003E\u003Cli\u003Eany accidental or unauthorised access, and\u003C\u002Fli\u003E\u003Cli\u003Eany request received directly from the data subjects without responding to that request, unless it has been otherwise authorised to do so;\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fli\u003E\u003Cli\u003Eto deal promptly and properly with all inquiries from the data exporter relating to its processing of the personal data subject to the transfer and to abide by the advice of the supervisory authority with regard to the processing of the data transferred;\u003C\u002Fli\u003E\u003Cli\u003Eat the request of the data exporter to submit its data processing facilities for audit of the processing activities covered by the Clauses which shall be carried out by the data exporter or an inspection body composed of independent members and in possession of the required professional qualifications bound by a duty of confidentiality, selected by the data exporter, where applicable, in agreement with the supervisory authority;\u003C\u002Fli\u003E\u003Cli\u003Eto make available to the data subject upon request a copy of the Clauses, or any existing contract for subprocessing, unless the Clauses or contract contain commercial information, in which case it may remove such commercial information, with the exception of Appendix 2 which shall be replaced by a summary description of the security measures in those cases where the data subject is unable to obtain a copy from the data exporter;\u003C\u002Fli\u003E\u003Cli\u003Ethat, in the event of subprocessing, it has previously informed the data exporter and obtained its prior written consent;\u003C\u002Fli\u003E\u003Cli\u003Ethat the processing services by the subprocessor will be carried out in accordance with Clause 11;\u003C\u002Fli\u003E\u003Cli\u003Eto send promptly a copy of any subprocessor agreement it concludes under the Clauses to the data exporter.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 6\u003C\u002Fh3\u003E\u003Cp\u003ELiability\u003Col\u003E\u003Cli\u003EThe parties agree that any data subject, who has suffered damage as a result of any breach of the obligations referred to in Clause 3 or in Clause 11 by any party or subprocessor is entitled to receive compensation from the data exporter for the damage suffered.\u003C\u002Fli\u003E\u003Cli\u003EIf a data subject is not able to bring a claim for compensation in accordance with paragraph 1 against the data exporter, arising out of a breach by the data importer or his subprocessor of any of their obligations referred to in Clause 3 or in Clause 11, because the data exporter has factually disappeared or ceased to exist in law or has become insolvent, the data importer agrees that the data subject may issue a claim against the data importer as if it were the data exporter, unless any successor entity has assumed the entire legal obligations of the data exporter by contract of by operation of law, in which case the data subject can enforce its rights against such entity.The data importer may not rely on a breach by a subprocessor of its obligations in order to avoid its own liabilities.\u003C\u002Fli\u003E\u003Cli\u003EIf a data subject is not able to bring a claim against the data exporter or the data importer referred to in paragraphs 1 and 2, arising out of a breach by the subprocessor of any of their obligations referred to in Clause 3 or in Clause 11 because both the data exporter and the data importer have factually disappeared or ceased to exist in law or have become insolvent, the subprocessor agrees that the data subject may issue a claim against the data subprocessor with regard to its own processing operations under the Clauses as if it were the data exporter or the data importer, unless any successor entity has assumed the entire legal obligations of the data exporter or data importer by contract or by operation of law, in which case the data subject can enforce its rights against such entity. The liability of the subprocessor shall be limited to its own processing operations under the Clauses.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 7\u003C\u002Fh3\u003E\u003Cp\u003EMediation and jurisdiction\u003Col\u003E\u003Cli\u003EThe data importer agrees that if the data subject invokes against it third-party beneficiary rights and\u002For claims compensation for damages under the Clauses, the data importer will accept the decision of the data subject:\u003Col type=\"a\"\u003E\u003Cli\u003E(a) \tto refer the dispute to mediation, by an independent person or, where applicable, by the supervisory authority;\u003C\u002Fli\u003E\u003Cli\u003E(b) \tto refer the dispute to the courts in the Member State in which the data exporter is established.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fli\u003E\u003Cli\u003EThe parties agree that the choice made by the data subject will not prejudice its substantive or procedural rights to seek remedies in accordance with other provisions of national or international law.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 8\u003C\u002Fh3\u003E\u003Cp\u003ECooperation with supervisory authorities\u003Col\u003E\u003Cli\u003EThe data exporter agrees to deposit a copy of this contract with the supervisory authority if it so requests or if such deposit is required under the applicable data protection law.\u003C\u002Fli\u003E\u003Cli\u003EThe parties agree that the supervisory authority has the right to conduct an audit of the data importer, and of any subprocessor, which has the same scope and is subject to the same conditions as would apply to an audit of the data exporter under the applicable data protection law.\u003C\u002Fli\u003E\u003Cli\u003EThe data importer shall promptly inform the data exporter about the existence of legislation applicable to it or any subprocessor preventing the conduct of an audit of the data importer, or any subprocessor, pursuant to paragraph 2. In such a case the data exporter shall be entitled to take the measures foreseen in Clause 5 (b).\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 9\u003C\u002Fh3\u003E\u003Cp\u003EGoverning Law\u003C\u002Fp\u003E\u003Cp\u003EThe Clauses shall be governed by the law of the Member State in which the data exporter is established.\u003C\u002Fp\u003E\u003Ch3\u003EClause 10\u003C\u002Fh3\u003E\u003Cp\u003EVariation of the contract\u003C\u002Fp\u003E\u003Cp\u003EThe parties undertake not to vary or modify the Clauses. This does not preclude the parties from adding clauses on business related issues where required as long as they do not contradict the Clause.\u003C\u002Fp\u003E\u003Ch3\u003EClause 11\u003C\u002Fh3\u003E\u003Cp\u003ESubprocessing\u003Col\u003E\u003Cli\u003EThe data importer shall not subcontract any of its processing operations performed on behalf of the data exporter under the Clauses without the prior written consent of the data exporter. Where the data importer subcontracts its obligations under the Clauses, with the consent of the data exporter, it shall do so only by way of a written agreement with the subprocessor which imposes the same obligations on the subprocessor as are imposed on the data importer under the Clauses[3]. Where the subprocessor fails to fulfil its data protection obligations under such written agreement the data importer shall remain fully liable to the data exporter for the performance of the subprocessor's obligations under such agreement.\u003C\u002Fli\u003E\u003Cli\u003EThe prior written contract between the data importer and the subprocessor shall also provide for a third-party beneficiary clause as laid down in Clause 3 for cases where the data subject is not able to bring the claim for compensation referred to in paragraph 1 of Clause 6 against the data exporter or the data importer because they have factually disappeared or have ceased to exist in law or have become insolvent and no successor entity has assumed the entire legal obligations of the data exporter or data importer by contract or by operation of law. Such third-party liability of the subprocessor shall be limited to its own processing operations under the Clauses.\u003C\u002Fli\u003E\u003Cli\u003EThe provisions relating to data protection aspects for subprocessing of the contract referred to in paragraph 1 shall be governed by the law of the Member State in which the data exporter is established.\u003C\u002Fli\u003E\u003Cli\u003EThe data exporter shall keep a list of subprocessing agreements concluded under the Clauses and notified by the data importer pursuant to Clause 5 (j), which shall be updated at least once a year. The list shall be available to the data exporter's data protection supervisory authority.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Ch3\u003EClause 12\u003C\u002Fh3\u003E\u003Cp\u003EObligation after the termination of personal data processing services\u003Col\u003E\u003Cli\u003EThe parties agree that on the termination of the provision of data processing services, the data importer and the subprocessor shall, at the choice of the data exporter, return all the personal data transferred and the copies thereof to the data exporter or shall destroy all the personal data and certify to the data exporter that it has done so, unless legislation imposed upon the data importer prevents it from returning or destroying all or part of the personal data transferred. In that case, the data importer warrants that it will guarantee the confidentiality of the personal data transferred and will not actively process the personal data transferred anymore.\u003C\u002Fli\u003E\u003Cli\u003EThe data importer and the subprocessor warrant that upon request of the data exporter and\u002For of the supervisory authority, it will submit its data processing facilities for an audit of the measures referred to in paragraph 1.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003Chr\u003E\u003Cp\u003E[i] Parties may reproduce definitions and meanings contained in Directive 95\u002F46\u002FEC within this Clause if they considered it better for the contract to stand alone.\u003Cbr\u003E[ii] Mandatory requirements of the national legislation applicable to the data importer which do not go beyond what is necessary in a democratic society on the basis of one of the interests listed in Article 13(1) of Directive 95\u002F46\u002FEC, that is, if they constitute a necessary measure to safeguard national security, defence, public security, the prevention, investigation, detection and prosecution of criminal offences or of breaches of ethics for the regulated professions, an important economic or financial interest of the State or the protection of the data subject or the rights and freedoms of others, are not in contradiction with the standard contractual clauses. Some examples of such mandatory requirements which do not go beyond what is necessary in a democratic society are, inter alia, internationally recognised sanctions, tax-reporting requirements or anti-money-laundering reporting requirements.\u003Cbr\u003E[iii] This requirement may be satisfied by the subprocessor co-signing the contract entered into between the data exporter and the data importer under this Decision.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EAppendix 1\u003C\u002Fh3\u003E\u003Cp\u003EAppendix 1 to the Standard Contractual Clauses\u003C\u002Fp\u003E\u003Cp\u003EThis Appendix forms part of the Clauses of the Standard Contractual Clauses and is to be considered as part of any agreement to the Standard Contractual Clauses.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EData Exporter\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EThe data exporter has purchased authentication Services from the data importer which include the processing of personal data.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EData Importer\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EThe Data Importer, a global provider of technology services for businesses, has agreed to provide authentication Services to data exporter (on a software-as-a-service basis) including the processing of personal data.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EData Subjects\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EThe personal data transferred by the data exporter to the data importer concerns the following categories of data subjects:\u003C\u002Fp\u003E\u003Cp\u003EData exporter’s customers and end-users\u003C\u002Fp\u003E\u003Cp\u003EData exporter’s employees, consultant and agents authorized by data exporter to use the Services and\u002For identified to serve as customer contacts.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003ECategories of data\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EData exporter may provide names, emails, street addresses, and phone numbers with respect to its employees, consultants and agents authorized by data exporter to use the Services and\u002For identified to serve as customer contacts.\u003C\u002Fp\u003E\u003Cp\u003EData exporter selects the categories of data collected by, and\u002For provided to, data importer for purposes of providing the authentication Services and related processing. All these activities are conducted electronically, so data importer has no visibility into the selections by data exporter, but assumes that the categories of data would be those commonly used for authentication purposes, such as log-in credentials, first name, last name and email address.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003ESpecial categories of data (if appropriate)\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003ENot applicable.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EProcessing operations\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EThe personal data transferred will be subject to the following basic processing activities:\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EScope of Processing.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EPersonal data may be processed only to comply with Instructions by (or at the direction of) Data Exporter (and as defined in the Terms of Service or Service Agreement) in order to provide the Services.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EStorage\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EPersonal data will be stored by data importer.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EAccess\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EData exporter will have the ability to configure the Services, access, correct, block, export and delete data from the Services in accordance with the Terms of Service or Service Agreement.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003ETermination\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EAfter termination or expiry of the applicable Services Agreement, data importer will delete the data exporter’s data from the Service.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content content-last\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EAppendix 2\u003C\u002Fh3\u003E\u003Cp\u003EAppendix 2 to the Standard Contractual Clauses\u003C\u002Fp\u003E\u003Cp\u003EThis Appendix forms part of the Clauses of the Standard Contractual Clauses and is considered to be part of any agreement to the Standard Contractual Clauses.\u003C\u002Fp\u003E\u003Cp\u003EDescription of the technical and organisational security measures implemented by the Data Importer in accordance with Clauses 4(c) and 5(c) (or document\u002Flegislation attached):\u003C\u002Fp\u003E\u003Cp\u003EThe Data Importer currently abides by the security standards in this Appendix 2. The Data Importer may update or modify these security standards from time to time provided such updates and modifications will not result in a degradation of the overall security of the Services during the term of the Service Agreement.\u003Col\u003E\u003Cli\u003EHosting Infrastructure.Infrastructure. The Data Importer hosts its services in geographically distributed, secure data centers operated by Amazon Web Services (AWS) and Microsoft Azure.\nRedundancy. The services are replicated across multiple data centers within a geographic region to eliminate single points of failure using an active\u002Fpassive configuration in order to minimize the impact of environmental risks.\nMonitoring. The services are protected by automated monitoring which is designed to detect a variety of failure conditions and which will, when appropriate, trigger failover mechanisms.\nBackups. Backups are performed on a regular basis and stored in a secondary site within the same geographic region.\nBusiness Continuity. The Data Importer replicates its service and data over multiple data centers within a geographic region to protect against loss of service or data.  The Data Importer conducts periodic tests of failover and data backup procedures to ensure readiness for business continuity and disaster recovery.\u003C\u002Fli\u003E\u003Cli\u003ENetworks & Transmission.Network Data Transmission.\nAll interactions between users, administrators and Auth0 modules are done using the Secure Socket Layer (SSL) or Transport Layer Security (TLS) standard cryptographic protocols.\nNetwork Security. The Data Importer employs multiple layers of DOS protection, Intrusion Detection, Rate Limiting and other network security services from both its hosting providers and third party providers.\nEncryption Technologies. The Data Importer makes HTTPS encryption (also referred to as SSL or TLS connection) available.\u003C\u002Fli\u003E\u003Cli\u003EPolicies and ProceduresPolicies. The Data Importer has written, approved policies governing Account Management, Acceptable Use, Data Retention, Employee Code of Conduct, Encryption, Incident Response, Information Sensitivity, Use of Mobile Devices, Password Protection, Patch Management and Risk Management.\nProcedures. The Data Importer has written and approved procedures for Data Breach Notification, Change Management, Communication, Disaster Recovery, DoS Response, System Backup and Recovery, and Monitoring.\nSecurity Response. The Data Importer monitors a variety of communication channels for security incidents, and the Data Importer’s security personnel will react promptly to known incidents.\u003C\u002Fli\u003E\u003Cli\u003EAccess Controls.Access Procedures. The Data Importer maintains formal access procedures for allowing access to the production service and components involved in building the production service.  Only authorized employees are allowed access to these restricted components and all access is approved by an employee’s manager and service owner. Only a small number of individuals are approved to access the restricted components.  Audit records are maintained to indicate who has access to restricted components.\nAccess Mechanisms. Access to the Data Importer’s production service and build infrastructure occurs only over a secured channel and require two-factor authentication.\nLogging. Access to the Data Importer’s production service and build infrastructure is done using unique IDs and is logged.\nInfrastructure Security Personnel. The Data Importer maintains several security policies governing its personnel. The Data Importer’s infrastructure security personnel are responsible for the ongoing monitoring of the Data Importer’s security infrastructure, the review of the Services, and responding to security incidents.\u003C\u002Fli\u003E\u003Cli\u003EData Protection.In Transit.  All interactions between users, administrators and Auth0 modules are done using the Secure Socket Layer (SSL) or Transport Layer Security (TLS) standard cryptographic protocols\nAt Rest. The Data Importer uses cryptographic hashing and encryption mechanisms to protect sensitive information such as cryptographic keys and application secrets.\nRedundancy. The Data Importer stores data in a multi-tenant environment within the Data Importer’s hosted infrastructure. The data and service are replicated across multiple hosted datacenters within the same geographic region.\nData Isolation. The Data Importer logically isolates the Data Exporter’s data, and the Data Exporter has a large degree of  control over the specific data stored in the Service.\nData Deletion.\nThe Data Importer provides to the Data Exporter a mechanism that can be used to delete the Data Exporter’s data.\u003C\u002Fli\u003E\u003Cli\u003ESoftwareCode Review. The Data Importer employs a code review process to improve the security of the code used to provide the Services.  All changes to the service are reviewed and approved by a senior engineer other than the author of the change.\nAutomated testing. Each software build is subjected to a comprehensive suite of automated tests.\nSecurity Scan.  The Data Importer employs a third party to scan the Service for security vulnerabilities on a periodic basis.\u003C\u002Fli\u003E\u003Cli\u003EStaff Conduct and Security.Staff Conduct. The Data Importer personnel are required to conduct themselves in a manner consistent with the company’s guidelines regarding confidentiality, business ethics, usage, compliance and professional standards.\nBackground Checks. The Data Importer conducts reasonably appropriate backgrounds checks to the extent legally permissible and in accordance with applicable local labor law and statutory regulations.\u003C\u002Fli\u003E\u003Cli\u003ESubprocessor Security.Prior to onboarding Subprocessors that will handle any data provided by a Data Exporter, the Data Importer conducts an audit of the security and privacy practices of Subprocessors to ensure Subprocessors provide a level of security and privacy appropriate to their access to data and the scope of the services they are engaged to provide.\u003C\u002Fli\u003E\u003Cli\u003EData Privacy Office.The Data Privacy Office of the Data Importer can be contacted by the Data Exporter’s administrators using the mechanism defined at: https:\u002F\u002Fauth0.com\u002Fprivacy (or via such other means as may be provided by the Data Importer).\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (repos) {pug_html = pug_html + "\u003Cdiv class=\"jumbotron has-header banner-open-source\"\u003E\u003Cdiv class=\"banner-content\"\u003E\u003Ch1\u003EOpen Source\u003C\u002Fh1\u003E\u003Cp\u003EProjects built at Auth0.\u003C\u002Fp\u003E\u003Cp\u003E\u003Ca class=\"btn btn-lg btn-success\" href=\"javascript:signup()\"\u003ECreate Free Account\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cem\u003ENo credit card required • No commitment\u003C\u002Fem\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"masonry-nav\"\u003E\u003Cul\u003E\u003Cli class=\"active\"\u003E\u003Ca href=\"#\"\u003EAll\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"JavaScript\"\u003E\u003Ca href=\"#javascript\"\u003EJavascript\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Ca href=\"#c#\"\u003EC#\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"CSS\"\u003E\u003Ca href=\"#css\"\u003ECSS\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"Ruby\"\u003E\u003Ca href=\"#ruby\"\u003ERUBY\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"PHP\"\u003E\u003Ca href=\"#php\"\u003EPHP\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"Objective-C\"\u003E\u003Ca href=\"#objective-c\"\u003EObjective-C\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"Java\"\u003E\u003Ca href=\"#java\"\u003EJava\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"masonry-cards\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv id=\"repos\"\u003E";
// iterate repos
;(function(){
  var $$obj = repos;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var repo = $$obj[pug_index0];
if(repo.description)
{
pug_html = pug_html + "\u003Cdiv" + (" class=\"col-sm-3 repo-card-container\""+pug.attr("data-language", repo.language ? repo.language.toLowerCase() : 'none', true, true)) + "\u003E\u003Cdiv class=\"repo-card\"\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["card " + repo.language], [true]), false, true)) + "\u003E\u003Cdiv class=\"card-content\"\u003E\u003Cspan" + (" class=\"circle-logo\""+pug.attr("data-name", repo.language ? repo.language.toLowerCase() : 'none', true, true)+" rel=\"external\"") + "\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Ca" + (" class=\"card-title\""+pug.attr("href", repo.html_url, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = repo.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Ca" + (" class=\"card-description\""+pug.attr("href", repo.html_url, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = repo.description) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cdiv class=\"card-stats\"\u003E\u003Ca" + (pug.attr("href", repo.html_url, true, true)) + "\u003E\u003Ci class=\"icon-budicon-172\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = repo.forks_count) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca" + (" class=\"stars\""+pug.attr("href", repo.html_url, true, true)) + "\u003E\u003Ci class=\"icon-budicon-466\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"stargazers_count\"\u003E" + (pug.escape(null == (pug_interp = repo.stargazers_count) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var repo = $$obj[pug_index0];
if(repo.description)
{
pug_html = pug_html + "\u003Cdiv" + (" class=\"col-sm-3 repo-card-container\""+pug.attr("data-language", repo.language ? repo.language.toLowerCase() : 'none', true, true)) + "\u003E\u003Cdiv class=\"repo-card\"\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["card " + repo.language], [true]), false, true)) + "\u003E\u003Cdiv class=\"card-content\"\u003E\u003Cspan" + (" class=\"circle-logo\""+pug.attr("data-name", repo.language ? repo.language.toLowerCase() : 'none', true, true)+" rel=\"external\"") + "\u003E\u003Cdiv class=\"logo\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003Ca" + (" class=\"card-title\""+pug.attr("href", repo.html_url, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = repo.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Ca" + (" class=\"card-description\""+pug.attr("href", repo.html_url, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = repo.description) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cdiv class=\"card-stats\"\u003E\u003Ca" + (pug.attr("href", repo.html_url, true, true)) + "\u003E\u003Ci class=\"icon-budicon-172\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = repo.forks_count) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca" + (" class=\"stars\""+pug.attr("href", repo.html_url, true, true)) + "\u003E\u003Ci class=\"icon-budicon-466\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"stargazers_count\"\u003E" + (pug.escape(null == (pug_interp = repo.stargazers_count) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"repos" in locals_for_with?locals_for_with.repos:typeof repos!=="undefined"?repos:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"partners-page page-content\"\u003E\u003C!-- section banner--\u003E\u003Csection class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-md-6 col-md-offset-6\"\u003E\u003Ch1\u003E Become an \u003Cbr \u002F\u003E\nAuth0 Partner\u003C\u002Fh1\u003E\u003Ch2\u003EGrow your business in an increasingly developer-centric world of apps, IoT devices and cloud where identity is the new firewall.\u003C\u002Fh2\u003E\u003Cp\u003EThe Auth0 Partner Program provides a frictionless experience for partners so together we can deliver amazing solutions to customers. We build true collaborative partnerships and impart industry leading expertise and thought leadership to bring partners along on an incredible journey of success in a rapidly growing market.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"#section-form\" data-go-to\u003EBecome a Partner\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"ico\" id=\"ico\"\u003E\u003Cspan class=\"ico-twitter\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"ico-android\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"ico-windows\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"ico-smartphone\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"ico-node-js\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"ico-market\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C!-- section slider 1--\u003E\u003Csection class=\"section-slider top\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"item item-1\"\u003E\u003Ch1\u003ESolution Partner\u003C\u002Fh1\u003E\u003Cp\u003ESolution Partners consult, resell or refer and are helping customers build new apps or integrate identity solutions in to existing apps and complex environments.\u003C\u002Fp\u003E\u003Cdiv class=\"images\"\u003E\u003Cimg class=\"img-responsive center-block img-layer-2\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fpartner-layer-2-282882fc73.png\" alt=\"Solution Partner Image\"\u003E\u003Cimg class=\"img-responsive center-block img-layer-1\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fpartner-layer-1-1f7eee3aa6.png\" alt=\"Solution Partner Image\"\u003E\u003Cimg class=\"img-responsive img-smartphone\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fslider-smartphone-4909c03c14.png\" alt=\"Solution Partner Image\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row description\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cp\u003EThe emergence of next-generation cloud and mobile technology, extensible development frameworks and APIs combined with the driving pace of innovation has seen an explosion in custom built apps and the rise of developers as integral stakeholders in enabling a company’s users and customers to do more.  Increasingly developers - not IT Pros - are becoming the new technology buyers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cp\u003EAuth0 plugs you in to this opportunity through our unique identity platform built by developers for developers. This creates an incredible opportunity for technology solution providers to address this new audience, deepen customer relationships and uncover new opportunities.  As a recent IDC Report put it:  “Miss the developers, miss the market”.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"blockquote\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cblockquote\u003E\u003Cp\u003E“Allows us to get sophisticated customer identity requirements in to production quicker than ever before. Everyone succeeds at the end of the day!”\u003C\u002Fp\u003E\u003C\u002Fblockquote\u003E\u003Cfooter\u003E\u003Ccite\u003E\u003Ca href=\"#\"\u003EPatrick Curran,\u003C\u002Fa\u003E Director Federal Group, \u003Cbr\u002F\u003E\nPlanet Technologies\u003C\u002Fcite\u003E\u003C\u002Ffooter\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C!-- section slider 2--\u003E\u003Csection class=\"section-slider\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"item item-2\"\u003E\u003Ch1\u003ETechnology Partner\u003C\u002Fh1\u003E\u003Cp\u003ETechnology Partners leverage the Auth0 platform to integrate, market and sell their own repeatable B2B solutions.\u003C\u002Fp\u003E\u003Cdiv class=\"images\"\u003E\u003Cdiv class=\"browser-1\"\u003E\u003Cimg class=\"img-browser\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fbrowser-1-40b0fd68d4.png\" alt=\"\"\u003E\u003Cimg class=\"img-browser-shadow\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fbrowser-shadow-1-941dc274d6.png\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-2\"\u003E\u003Cimg class=\"img-browser\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fbrowser-2-adafd3325e.png\" alt=\"\"\u003E\u003Cimg class=\"img-browser-shadow\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fbrowser-shadow-2-ad05b3b673.png\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-3\"\u003E\u003Cimg class=\"img-browser\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fbrowser-3-fdef6572aa.png\" alt=\"\"\u003E\u003Cimg class=\"img-browser-shadow\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpartners\u002Fimg\u002Fbrowser-shadow-2-ad05b3b673.png\" alt=\"\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row description\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cp\u003ESecure identity management is the very fabric protecting your customers' credentials within your solution. It’s the barricade that keeps the bad actors out while letting employees, customers, and partners in.  \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cp\u003EEasily extend the value proposition of your solution, improve developer efficiency within your own team and drive user adoption of your solution. Technology partners even discover incremental revenue opportunities through providing sophisticated identity scenarios that previously were not possible.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"blockquote\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cblockquote\u003E\u003Cp\u003E\"Built and operated to the highest standards needed for us to take our own solution to customers with confidence.\"\u003C\u002Fp\u003E\u003C\u002Fblockquote\u003E\u003Cfooter\u003E\u003Ccite\u003E\u003Ca href=\"#\"\u003ENiels Flensted- Jensen,\u003C\u002Fa\u003E Co-founder, Grean\u003C\u002Fcite\u003E\u003C\u002Ffooter\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C!-- section form--\u003E\u003Csection class=\"section-form\" id=\"section-form\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cul class=\"options\" id=\"options-tabs\"\u003E\u003Cli class=\"li-become active\"\u003E\u003Ca class=\"become\" href=\"#become-a-partner\" data-toggle=\"tab\"\u003EBecome a Partner\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"li-partner\"\u003E\u003Ca class=\"partner\" href=\"#find-a-partner\" data-toggle=\"tab\"\u003EFind a Partner\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"section-form-wrapper tab-content\"\u003E\u003Cdiv class=\"become-a-partner tab-pane fadeIn active\" id=\"become-a-partner\"\u003E\u003Ch2\u003EReady to get started? Provide your details to receive further information and schedule a 1:1 meeting with our Partner Success team.\u003C\u002Fh2\u003E\u003Cform\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cinput type=\"hidden\" name=\"form\" value=\"Become a Partner\"\u003E\u003Cinput class=\"form-control\" name=\"company\" placeholder=\"Company Name\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cinput class=\"form-control\" name=\"website\" placeholder=\"Website\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cinput class=\"form-control\" name=\"contact\" placeholder=\"Contact Name\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cinput class=\"form-control\" name=\"email\" placeholder=\"Email\" required type=\"email\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cinput class=\"form-control\" name=\"phone\" placeholder=\"Phone\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cinput class=\"form-control\" name=\"city\" placeholder=\"City\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cinput class=\"form-control\" name=\"country\" placeholder=\"Country\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ctextarea class=\"form-control textarea\" name=\"msg\" row=\"3\" required placeholder=\"Brief description of partner opportunity...\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cbutton class=\"btn btn-success btn-lg btn-block\" type=\"submit\"\u003EBecome a Partner \u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"find-a-partner tab-pane fadeIn\" id=\"find-a-partner\"\u003E\u003Ch2\u003ENeed to solve a sophisticated identity challenge? Our network of partners extends around the globe.  Partners offer experise from security consulting and systems integration to implementation and application development.\u003C\u002Fh2\u003E\u003Cform\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cinput type=\"hidden\" name=\"form\" value=\"Find a Partner\"\u003E\u003Cinput class=\"form-control\" name=\"company\" placeholder=\"Company Name\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cinput class=\"form-control\" name=\"website\" placeholder=\"Website\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cinput class=\"form-control\" name=\"contact\" placeholder=\"Contact Name\" required\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cinput class=\"form-control\" name=\"email\" placeholder=\"Email\" required type=\"email\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cinput class=\"form-control\" name=\"phone\" placeholder=\"Phone\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-left\"\u003E\u003Cinput class=\"form-control\" name=\"city\" placeholder=\"City\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-xs-12 col-sm-6 col-right\"\u003E\u003Cinput class=\"form-control\" name=\"country\" placeholder=\"Country\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ctextarea class=\"form-control textarea\" name=\"msg\" row=\"3\" required placeholder=\"Brief description of partner opportunity...\"\u003E\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cbutton class=\"btn btn-success btn-lg btn-block\" type=\"submit\"\u003EFind a Partner\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_mixins["browser"] = pug_interp = function(direction){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Cdiv class=\"btns\"\u003E\u003Ci class=\"close\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"min\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"max\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"location-bar\"\u003E\u003Ci class=\"icon-budicon-285\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"green\"\u003Ehttps\u003C\u002Fspan\u003E\u003Cspan class=\"gray\"\u003E:\u002F\u002F\u003C\u002Fspan\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = direction) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"menu-button\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"passwordless-page page-content\"\u003E\u003Csection class=\"intro\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"center-content\"\u003E\u003Cdiv class=\"title-content\"\u003E\u003Ch1\u003EYour Email or Phone become the password\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"lock-content\"\u003E\u003Cdiv class=\"auth0-lock-vector\"\u003E\u003Csvg width=\"300px\" height=\"450px\" viewbox=\"0 0 300 450\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"\u003E\u003Cg transform=\"translate(-570.000000, -327.000000)\"\u003E\u003Cg transform=\"translate(570.000000, 327.000000)\"\u003E\u003Cpath d=\"M1,127 L299,127\" stroke=\"#FFFFFF\" stroke-linecap=\"square\" opacity=\"0.3\"\u003E\u003C\u002Fpath\u003E\u003Cpath class=\"lock-rect-up\" d=\"M1,376 L299,376\" stroke=\"#FFFFFF\" stroke-linecap=\"square\" opacity=\"0.3\"\u003E\u003C\u002Fpath\u003E\u003Crect stroke=\"#FFFFFF\" opacity=\"0.3\" x=\"35\" y=\"148\" width=\"230\" height=\"30\" rx=\"5\"\u003E\u003C\u002Frect\u003E\u003Crect stroke=\"#FFFFFF\" opacity=\"0.3\" x=\"35\" y=\"208\" width=\"230\" height=\"40\" rx=\"5\"\u003E\u003C\u002Frect\u003E\u003Crect class=\"pwd-input\" stroke=\"#FFFFFF\" opacity=\"0.3\" x=\"35\" y=\"258\" width=\"230\" height=\"40\" rx=\"5\"\u003E\u003C\u002Frect\u003E\u003Cpath d=\"M150,149 L150,177\" stroke=\"#FFFFFF\" stroke-linecap=\"square\" opacity=\"0.3\"\u003E\u003C\u002Fpath\u003E\u003Crect class=\"lock-rect-up\" opacity=\"0.200000003\" fill=\"#FFFFFF\" x=\"80\" y=\"328\" width=\"140\" height=\"4\" rx=\"2\"\u003E\u003C\u002Frect\u003E\u003Crect opacity=\"0.200000003\" fill=\"#FFFFFF\" x=\"60\" y=\"160\" width=\"60\" height=\"6\" rx=\"3\"\u003E\u003C\u002Frect\u003E\u003Crect opacity=\"0.200000003\" fill=\"#FFFFFF\" x=\"175\" y=\"160\" width=\"40\" height=\"6\" rx=\"3\"\u003E\u003C\u002Frect\u003E\u003Crect opacity=\"0.200000003\" fill=\"#FFFFFF\" x=\"222\" y=\"160\" width=\"20\" height=\"6\" rx=\"3\"\u003E\u003C\u002Frect\u003E\u003Cg transform=\"translate(110.000000, 225.000000)\" fill=\"#FFFFFF\"\u003E\u003Crect opacity=\"0.200000003\" x=\"0\" y=\"0\" width=\"80\" height=\"6\" rx=\"3\"\u003E\u003C\u002Frect\u003E\u003Cg class=\"pwd-dots\" transform=\"translate(2.000000, 50.000000)\" opacity=\"0.2\"\u003E\u003Crect x=\"0\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"10\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"20\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"30\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"40\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"50\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"60\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003Crect x=\"70\" y=\"0\" width=\"6\" height=\"6\" rx=\"10\"\u003E\u003C\u002Frect\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003Ccircle fill=\"#535356\" cx=\"150\" cy=\"65\" r=\"30\"\u003E\u003C\u002Fcircle\u003E\u003Crect class=\"lock-rect-up\" opacity=\"0.200000003\" fill=\"#FFFFFF\" x=\"110\" y=\"410\" width=\"80\" height=\"6\" rx=\"3\"\u003E\u003C\u002Frect\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-lock opened\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv id=\"new-lock-animated\"\u003E\u003C\u002Fdiv\u003E";
}
}, 'yourapp.com');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"inbox-confirmation\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Csvg width=\"935px\" height=\"50px\" viewbox=\"0 0 935 50\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cg id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"passwordless-6\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-253.000000, -367.000000)\"\u003E\u003Cg id=\"Lock-+-Group-+-http:\u002F\u002Fmywebapp.com-+-Rectangle-16-+-iphone6-last-+-Group-+-fab\" sketch:type=\"MSLayerGroup\" transform=\"translate(253.000000, 327.000000)\"\u003E\u003Cg id=\"Group\" transform=\"translate(0.000000, 40.000000)\"\u003E\u003Cg id=\"Settings-+-menu\"\u003E\u003Crect id=\"Rectangle-38\" fill=\"#4990E2\" sketch:type=\"MSShapeGroup\" x=\"0\" y=\"0\" width=\"935\" height=\"50\"\u003E\u003C\u002Frect\u003E\u003Ctext id=\"Inbox\" sketch:type=\"MSTextLayer\" font-family=\"Roboto\" font-size=\"20\" font-weight=\"normal\" fill=\"#FFFFFF\"\u003E\u003Ctspan x=\"73\" y=\"31\"\u003EInbox\u003C\u002Ftspan\u003E\u003C\u002Ftext\u003E\u003Cg id=\"menu\" transform=\"translate(17.000000, 12.000000)\" sketch:type=\"MSShapeGroup\"\u003E\u003Crect id=\"bounds\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"\u003E\u003C\u002Frect\u003E\u003Cpath id=\"Shape\" d=\"M3,18 L21,18 L21,16 L3,16 L3,18 L3,18 Z M3,13 L21,13 L21,11 L3,11 L3,13 L3,13 Z M3,6 L3,8 L21,8 L21,6 L3,6 L3,6 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003Csvg class=\"email-new\" width=\"48px\" height=\"53px\" viewbox=\"0 0 48 53\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cdefs\u003E\u003Clineargradient id=\"linearGradient-1\" x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"99.0214445%\"\u003E\u003Cstop stop-color=\"#000000\" stop-opacity=\"0\" offset=\"0%\"\u003E\u003C\u002Fstop\u003E\u003Cstop stop-color=\"#000000\" stop-opacity=\"0.02\" offset=\"80%\"\u003E\u003C\u002Fstop\u003E\u003Cstop stop-color=\"#000000\" stop-opacity=\"0.04\" offset=\"100%\"\u003E\u003C\u002Fstop\u003E\u003C\u002Flineargradient\u003E\u003Clineargradient id=\"linearGradient-2\" x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"100%\"\u003E\u003Cstop stop-color=\"#FFFFFF\" stop-opacity=\"0.12\" offset=\"0%\"\u003E\u003C\u002Fstop\u003E\u003Cstop stop-color=\"#FFFFFF\" stop-opacity=\"0.06\" offset=\"20%\"\u003E\u003C\u002Fstop\u003E\u003Cstop stop-color=\"#FFFFFF\" stop-opacity=\"0\" offset=\"100%\"\u003E\u003C\u002Fstop\u003E\u003C\u002Flineargradient\u003E\u003Cfilter id=\"filter-3\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterunits=\"objectBoundingBox\"\u003E\u003Cfeoffset dx=\"0\" dy=\"5\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"\u003E\u003C\u002Ffeoffset\u003E\u003Cfegaussianblur stddeviation=\"2.5\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"\u003E\u003C\u002Ffegaussianblur\u003E\u003Cfecolormatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.168 0\" in=\"shadowBlurOuter1\" type=\"matrix\" result=\"shadowMatrixOuter1\"\u003E\u003C\u002Ffecolormatrix\u003E\u003Cfeoffset dx=\"0\" dy=\"0\" in=\"SourceAlpha\" result=\"shadowOffsetOuter2\"\u003E\u003C\u002Ffeoffset\u003E\u003Cfegaussianblur stddeviation=\"2.5\" in=\"shadowOffsetOuter2\" result=\"shadowBlurOuter2\"\u003E\u003C\u002Ffegaussianblur\u003E\u003Cfecolormatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.084 0\" in=\"shadowBlurOuter2\" type=\"matrix\" result=\"shadowMatrixOuter2\"\u003E\u003C\u002Ffecolormatrix\u003E\u003Cfemerge\u003E\u003Cfemergenode in=\"shadowMatrixOuter1\"\u003E\u003C\u002Ffemergenode\u003E\u003Cfemergenode in=\"shadowMatrixOuter2\"\u003E\u003C\u002Ffemergenode\u003E\u003Cfemergenode in=\"SourceGraphic\"\u003E\u003C\u002Ffemergenode\u003E\u003C\u002Ffemerge\u003E\u003C\u002Ffilter\u003E\u003Ccircle id=\"path-4\" cx=\"20\" cy=\"20\" r=\"20\"\u003E\u003C\u002Fcircle\u003E\u003C\u002Fdefs\u003E\u003Cg id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"passwordless-6\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-1124.000000, -833.000000)\"\u003E\u003Cg id=\"Lock-+-Group-+-http:\u002F\u002Fmywebapp.com-+-Rectangle-16-+-iphone6-last-+-Group-+-fab\" sketch:type=\"MSLayerGroup\" transform=\"translate(253.000000, 327.000000)\"\u003E\u003Cg id=\"fab\" transform=\"translate(875.000000, 510.000000)\"\u003E\u003Cg id=\"button-bg\" filter=\"url(#filter-3)\" stroke-width=\"0.666666667\"\u003E\u003Cuse stroke=\"url(#linearGradient-1)\" fill=\"#DB4437\" fill-rule=\"evenodd\" sketch:type=\"MSShapeGroup\" xlink:href=\"#path-4\"\u003E\u003C\u002Fuse\u003E\u003Cuse stroke=\"url(#linearGradient-2)\" fill=\"none\" xlink:href=\"#path-4\"\u003E\u003C\u002Fuse\u003E\u003C\u002Fg\u003E\u003Cg id=\"add\" transform=\"translate(11.428571, 11.428571)\" sketch:type=\"MSShapeGroup\"\u003E\u003Cpath id=\"bounds\" d=\"M17.1428571,0 L0,0 L0,17.1428571 L17.1428571,17.1428571 L17.1428571,0 Z\"\u003E\u003C\u002Fpath\u003E\u003Cpath id=\"Shape\" d=\"M13.5714286,7.85714286 L9.28571429,7.85714286 L9.28571429,3.57142857 L7.85714286,3.57142857 L7.85714286,7.85714286 L3.57142857,7.85714286 L3.57142857,9.28571429 L7.85714286,9.28571429 L7.85714286,13.5714286 L9.28571429,13.5714286 L9.28571429,9.28571429 L13.5714286,9.28571429 L13.5714286,7.85714286 L13.5714286,7.85714286 Z\" fill=\"#FFFFFF\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003Cdiv class=\"email-content\"\u003E\u003Cdiv class=\"email-subject\"\u003E\u003Cp\u003EPlease Verify Your Auth0 Account\u003C\u002Fp\u003E\u003Csvg width=\"2px\" height=\"8px\" viewbox=\"0 0 2 8\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" xmlns:sketch=\"http:\u002F\u002Fwww.bohemiancoding.com\u002Fsketch\u002Fns\"\u003E\u003Cg id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\"\u003E\u003Cg id=\"passwordless-6\" sketch:type=\"MSArtboardGroup\" transform=\"translate(-1049.000000, -438.000000)\" fill=\"#000000\" opacity=\"0.539999962\"\u003E\u003Cg id=\"Lock-+-Group-+-http:\u002F\u002Fmywebapp.com-+-Rectangle-16-+-iphone6-last-+-Group-+-fab\" sketch:type=\"MSLayerGroup\" transform=\"translate(253.000000, 327.000000)\"\u003E\u003Cg id=\"Group\" transform=\"translate(0.000000, 40.000000)\" sketch:type=\"MSShapeGroup\"\u003E\u003Cg id=\"more\" transform=\"translate(794.000000, 69.000000)\"\u003E\u003Cpath id=\"Shape\" d=\"M3,8 C3.55,8 4,8.45 4,9 C4,9.55 3.55,10 3,10 C2.45,10 2,9.55 2,9 C2,8.45 2.45,8 3,8 L3,8 Z M3,7 C2.45,7 2,6.55 2,6 C2,5.45 2.45,5 3,5 C3.55,5 4,5.45 4,6 C4,6.55 3.55,7 3,7 L3,7 Z M3,4 C2.45,4 2,3.55 2,3 C2,2.45 2.45,2 3,2 C3.55,2 4,2.45 4,3 C4,3.55 3.55,4 3,4 L3,4 Z\" transform=\"translate(3.000000, 6.000000) scale(1, -1) translate(-3.000000, -6.000000) \"\u003E\u003C\u002Fpath\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"email-body\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fbadge-967bdae8f4.svg\" alt=\"Auth0 Badge\"\u003E\u003Ch3\u003EClick and confirm that you want to sign in to Auth0. This link will expire in five minutes.\u003C\u002Fh3\u003E\u003Ca class=\"btn btn-success btn-md\" href=\"\" data-link\u003ESign in to Auth0\u003C\u002Fa\u003E\u003Ch4\u003EOr sign in using this link\u003C\u002Fh4\u003E\u003Csmall\u003Ehttps:\u002F\u002Fauth0.auth0.com\u002Flo\u002Fverify_email?ticket=BnZ9624jpAXbJOALr7Tlbu4awKWffD9i#\u003C\u002Fsmall\u003E\u003Cp\u003EIf you are having any issues with your account, please don't hesitate to contact us by replying to this mail.\u003C\u002Fp\u003E\u003Cp\u003EThanks!\u003Cbr\u003EAuth0\u003C\u002Fp\u003E\u003Chr\u003E\u003Csmall\u003EIf you did not make this request, please contact us by replying to this mail.\u003C\u002Fsmall\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'inbox.google.com');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"app-confirmation\"\u003E";
pug_mixins["browser"].call({
block: function(){
pug_html = pug_html + "\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fimg-site-e81712ca1d.png\" alt=\"Browser Image\"\u003E\u003Cdiv class=\"check-content\"\u003E\u003Csvg class=\"checkmark\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" viewbox=\"0 0 52 52\"\u003E\u003Ccircle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"\u003E\u003C\u002Fcircle\u003E\u003Cpath class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fsvg\u003E\u003Ch2\u003ENow you are logged in!\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E";
}
}, 'yourapp.com');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"paragraph-content\"\u003E\u003Ch1 class=\"logo-passwordless\"\u003EPasswordless\u003C\u002Fh1\u003E\u003Ch2\u003ELog in without Passwords.\u003Cbr\u003EEasy and Secure.\u003C\u002Fh2\u003E\u003Ca class=\"btn btn-primary btn-lg\" href=\"\" data-play\u003ESee how\u003C\u002Fa\u003E\u003Ca class=\"btn btn-primary btn-lg\" href=\"\" data-replay\u003EWatch Again\u003Ci class=\"icon-budicon-434\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca class=\"btn btn-default btn-lg\" href=\"https:\u002F\u002Fauth0.com\u002Fblog\u002F2015\u002F09\u002F30\u002Fauth0-passwordless-email-authentication-and-sms-login-without-passwords\u002F\" target=\"_blank\" data-explore-docs\u003ERead the announcement\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-phones-container\"\u003E\u003Cdiv class=\"top-phone-wLock-container\"\u003E\u003Cdiv class=\"top-iphone-lock-container hide-scrollbars\"\u003E\u003Cdiv class=\"mobile-lock-fix\" id=\"top-iphone-lock\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"iphone6\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fiphone-white-f63526398b.png\" alt=\"iPhone with Passwordless on Auth0.com website\"\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"iphone5\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fiphone5-top-banner-c865eb6e46.png\" alt=\"iPhone with Passwordless on a mobile app\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"implementation\" id=\"imp\"\u003E\u003Cdiv class=\"dummy-skew\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cspan class=\"icon-budicon-342\"\u003E\u003C\u002Fspan\u003E\u003Ch2\u003EEasy to implement\u003C\u002Fh2\u003E\u003Cdiv class=\"get-code\"\u003E\u003Cnav class=\"nav-text\"\u003E\u003Ca href=\"#sms\" data-sms\u003ESMS\u003C\u002Fa\u003E\u003Ca class=\"active\" href=\"#magic-link\" data-link\u003EMagic Link\u003C\u002Fa\u003E\u003Ca href=\"#touchID\" data-touchID\u003ETouch ID\u003C\u002Fa\u003E\u003C\u002Fnav\u003E\u003Cnav class=\"nav-lock\"\u003E\u003Cspan class=\"lock-tab\" id=\"sms-inline\" data-lock=\"sms\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"lock-tab active\" id=\"magic-link-inline\" data-lock=\"magic-link\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"lock-tab\" data-lock=\"touchID\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fimg-lock-touchID-202773375f.png\" alt=\"TouchID logo\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"nav-content\"\u003E\u003Cdiv class=\"code-content\" id=\"sms\"\u003E\u003Cpre\u003E\u003Ccode\u003E&lt;button id=&quot;signin-sms&quot;&gt;Login&lt;\u002Fbutton&gt;\n\n&lt;script src=&quot;\u002F\u002Fcdn2.auth0.com\u002Fjs\u002Flock-passwordless-2.min.js&quot;&gt;&lt;\u002Fscript&gt;\n&lt;script type=&quot;text\u002Fjavascript&quot;&gt;\n  document.getElementById('signin-sms').onclick = function () {\n    var pwdless = new Auth0LockPasswordless('client-id', 'app-domain');\n    pwdless.sms(function (err, profile, id_token) {\n      \u002F\u002F Passwordless Authentication handler\n    });\n  }\n&lt;\u002Fscript&gt;\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless\" target=\"_blank\"\u003ERead the full documentation\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"code-content active\" id=\"magic-link\"\u003E\u003Cpre\u003E\u003Ccode\u003E&lt;button id=&quot;magic-link&quot;&gt;Login&lt;\u002Fbutton&gt;\n\n&lt;script src=&quot;\u002F\u002Fcdn2.auth0.com\u002Fjs\u002Flock-passwordless-2.min.js&quot;&gt;&lt;\u002Fscript&gt;\n&lt;script type=&quot;text\u002Fjavascript&quot;&gt;\n  document.getElementById('magic-link').onclick = function () {\n    var pwdless = new Auth0LockPasswordless('client-id', 'app-domain');\n    pwdless.magiclink(function (err, profile, id_token) {\n      \u002F\u002F Passwordless Authentication handler\n    });\n  }\n&lt;\u002Fscript&gt;\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless\" target=\"_blank\"\u003ERead the full documentation\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"code-content\" id=\"touchID\"\u003E\u003Cpre\u003E\u003Ccode class=\"swift\"\u003Elet lock = A0Lock(clientId: &quot;YOUR_CLIENT_ID&quot;, domain: &quot;YOUR_DOMAIN&quot;)\nlet controller = lock.newTouchIDViewController()\ncontroller.onAuthenticationBlock = { (profile, token) in\n    \u002F\u002F profile has all the user props\n    \u002F\u002F token has a JWT and refreshToken (store it somewhere)\n    self.dismissViewControllerAnimated(true, completion: nil)\n};\nlock.presentTouchIDController(controller, fromController: self)\u003C\u002Fcode\u003E\u003C\u002Fpre\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless\u002Fios-touch-id-swift\" target=\"_blank\"\u003ERead the full TouchID documentation\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"sdk\" id=\"sdk\"\u003E\u003Cdiv class=\"top-cont\"\u003E\u003Cdiv class=\"text-container wow fadeInUpSubtle\"\u003E\u003Cdiv class=\"text-content\"\u003E\u003Ch2\u003EWorks everywhere\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ELock Passwordless is an embeddable widget that encapsulates the best practices for authentication with SMS and Email for Desktop, Tablet, and Mobile Devices.\u003C\u002Fp\u003E\u003Cp\u003E\u003Ca class=\"btn btn-default btn-lg\" href=\"https:\u002F\u002Fauth0.github.io\u002Flock-passwordless\u002F\" target=\"_blank\"\u003ETest in the playground\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"macbook-cont\"\u003E\u003Cdiv class=\"macbook-inner wow fadeInRightSubtle custom-anim-3d\"\u003E\u003Ca class=\"macbook-flag flag wow customRotateInRight\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless#passwordless-on-single-page-apps\" target=\"_blank\"\u003E\u003Cspan class=\"web-icon icon\"\u003E\u003C\u002Fspan\u003E\u003Cp\u003EWeb SDK\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Ca class=\"iphone-flag flag mobile-flag\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless#passwordless-on-ios\" target=\"_blank\"\u003E\u003Cspan class=\"apple-icon icon\"\u003E\u003C\u002Fspan\u003E\u003Cp\u003EiOS SDK\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Ca class=\"nexus-flag flag mobile-flag\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless#passwordless-on-android\" target=\"_blank\"\u003E\u003Cspan class=\"android-icon icon\"\u003E\u003C\u002Fspan\u003E\u003Cp\u003EAndroid SDK\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Cimg class=\"macbook\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fmacbook2-7ed3bbe995.png\" alt=\"Macbook with a demo app login with Passwordless\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"bottom-cont\"\u003E\u003Cdiv class=\"iphone-cont\"\u003E\u003Cdiv class=\"iphone-inner wow fadeInUp custom-anim-3d\"\u003E\u003Ca class=\"iphone-flag flag wow customRotateInLeft\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless\u002Fios-sms-swift\" target=\"_blank\"\u003E\u003Cspan class=\"apple-icon icon\"\u003E\u003C\u002Fspan\u003E\u003Cp\u003EiOS SDK\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"sdk-iphone-lock-container hide-scrollbars\"\u003E\u003Cdiv class=\"mobile-lock-fix\" id=\"sdk-iphone-lock\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"iphone\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fiphone-white-f63526398b.png\" alt=\"iPhone with Passwordless\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nexus-cont show-mobile\"\u003E\u003Cdiv class=\"nexus-inner wow fadeInUpSubtle custom-anim-3d\"\u003E\u003Ca class=\"nexus-flag flag wow customRotateInRight\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless#passwordless-on-android\" target=\"_blank\"\u003E\u003Cspan class=\"android-icon icon\"\u003E\u003C\u002Fspan\u003E\u003Cp\u003EAndroid SDK\u003C\u002Fp\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"sdk-nexus-lock-container hide-scrollbars\"\u003E\u003Cdiv id=\"sdk-nexus-lock\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"nexus\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpasswordless\u002Fimg\u002Fnexus-43d0c411e6.png\" alt=\"Nexus with Passwordless\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"qna-section\" id=\"qna\"\u003E\u003Cdiv class=\"qna-outer\"\u003E\u003Cdiv class=\"dummy-skew\"\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"qna container\"\u003E\u003Cspan class=\"icon-budicon-793\"\u003E\u003C\u002Fspan\u003E\u003Ch3 class=\"qna-title\"\u003EQuestions & Answers\u003C\u002Fh3\u003E\u003Cdiv class=\"clearfix\"\u003E\u003Cdiv class=\"questions\"\u003E\u003Cspan class=\"icon-budicon-463 prev-arrow\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"icon-budicon-461 next-arrow\"\u003E\u003C\u002Fspan\u003E\u003Ca href=\"#brute-force\"\u003E\u003Cp\u003EWhat happens if someone tries to brute-force guess the code?\u003C\u002Fp\u003E\u003Cspan class=\"icon-budicon-461\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#time-click\"\u003E\u003Cp\u003EHow long do I have to click on the login link or enter the code?\u003C\u002Fp\u003E\u003Cspan class=\"icon-budicon-461\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#email-access\"\u003E\u003Cp\u003EWhat if someone gains access to my email account or steals\u002Flost my phone?\u003C\u002Fp\u003E\u003Cspan class=\"icon-budicon-461\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#send-sms\"\u003E\u003Cp\u003EIs it possible to send an SMS instead of an email to deliver the one-time code?\u003C\u002Fp\u003E\u003Cspan class=\"icon-budicon-461\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"answers\"\u003E\u003Cdiv class=\"answers-inner\"\u003E\u003Cdiv id=\"brute-force\"\u003E\u003Cp\u003EAuth0's brute-force protection system will block the hacker's IP address after too many attempts, and the application owner will be notified by email.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"time-click\"\u003E\u003Cp\u003ELogin links or codes will expire after 5 minutes by default, but this timeout is configurable.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"email-access\"\u003E\u003Cp\u003EIf someone gets access to your email account or can read your SMS messages, they can login as you using passwordless authentication. The same risk as with common password resets by email, without multi-factor authentication.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"send-sms\"\u003E\u003Cp\u003EYes. Either e-mail or SMS can be used.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cp\u003E\u003Ca class=\"read-more-qa\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless\u002Ffaq\" target=\"_blank\"\u003ERead more questions & answers\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EStart your free trial today\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:signup()\" target=\"_blank\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpress\u002Fimg\u002Fauth0-badge-5c9de7e409.svg\" alt=\"Press &amp; Media Resources icon\" width=\"\" height=\"\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EPress & Media Resources\u003C\u002Fh1\u003E\u003Cp\u003E For Press & Media enquiries \u003Cbr\u003Econtact \u003Ca href=\"mailto:press@auth0.com\"\u003Epress@auth0.com\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"presskit-banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Ch2\u003E Need some assets? \u003Ca href=\"https:\u002F\u002Fcdn2.auth0.com\u002Fwebsite\u002Fauth0-assets-press-kit.zip\" download target=\"_blank\" rel=\"noopener noreferrer\"\u003EDownload Press Kit\u003C\u002Fa\u003E\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (details, initialState) {pug_html = pug_html + "\u003Cdiv class=\"press-page\"\u003E\u003C!-- #section banner--\u003E" + (null == (pug_interp = __webpack_require__(969).call(this, locals)) ? "" : pug_interp) + "\u003C!-- #section banner--\u003E" + (null == (pug_interp = __webpack_require__(970).call(this, locals)) ? "" : pug_interp) + "\u003C!-- section content app--\u003E\u003Cscript\u003E" + (null == (pug_interp = initialState) ? "" : pug_interp) + "\u003C\u002Fscript\u003E\u003Cdiv class=\"press-app\"\u003E" + (null == (pug_interp = details) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"details" in locals_for_with?locals_for_with.details:typeof details!=="undefined"?details:undefined,"initialState" in locals_for_with?locals_for_with.initialState:typeof initialState!=="undefined"?initialState:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (_, features, filterPlans, planKey, plans) {var plan = plans.findByPlanKey(planKey)
var index = _.findIndex(plans.models, { plan: planKey })
var prevPlan = index && _.at(plans.models, index - 1)[0];
var prevPlanIndex = index && index - 1;
var currentFeatures = features.filter(function (feature) {
  var featureAvailableForPlans = feature.plans.filter(filterPlans).length;
  var isNotInPreviousPlans = (plans.length - index) === featureAvailableForPlans;
  var isNotFiltered = plan.hasFeature(feature);
  return isNotInPreviousPlans && isNotFiltered;
});
var prevPlanFeatures = prevPlan && features.filter(function (feature) {
  var featureAvailableForPlans = feature.plans.filter(filterPlans).length;
  var isNotInPreviousPlans = (plans.length - prevPlanIndex) === featureAvailableForPlans;
  var isNotFiltered = prevPlan.hasFeature(feature);
  return isNotInPreviousPlans && isNotFiltered;
});
var prevPlanFeaturesArray = prevPlan && _.map(prevPlanFeatures.models).map(function (f) {
  return f.friendlyName
})
var freeFeatures = [
  'Passwordless & TouchID Login',
  'Lock for Web, iOS & Android',
  'Up to 2 social identity providers',
  'Rules & Webtask.io subscription'
];

pug_mixins["check-icon"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg class=\"check-icon-white\" width=\"12px\" height=\"9px\" viewBox=\"423 363 12 9\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\"\u003E\n\u003Cpolygon id=\"Path-2\" stroke=\"none\" fill=\"#FFFFFF\" fill-rule=\"evenodd\" points=\"426.355216 371.158394 427.068452 371.87163 427.775506 371.152265 434.41029 364.401955 432.983923 363 426.349139 369.750309 427.769429 369.74418 424.414214 366.388964 423 367.803178\"\u003E\u003C\u002Fpolygon\u003E\n\u003C\u002Fsvg\u003E";
};
pug_mixins["prev-plan-mixin"] = pug_interp = function(plan, features){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E" + (pug.escape(null == (pug_interp = 'also includes:') ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
if ('free' === plan.plan) {
// iterate freeFeatures
;(function(){
  var $$obj = freeFeatures;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var feature = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
else {
// iterate features
;(function(){
  var $$obj = features;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var feature = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index1];
pug_html = pug_html + "\u003Cli class=\"subfeature\"\u003E";
pug_mixins["check-icon"]();
pug_html = pug_html + (pug.escape(null == (pug_interp = feature) ? "" : pug_interp)) + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

}
};
pug_mixins["feature-item"] = pug_interp = function(title, feature){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cp" + (" class=\"only-tooltip\""+" data-toggle=\"tooltip\" data-placement=\"bottom\" data-container=\"body\" data-trigger=\"hover\""+pug.attr("data-original-title", feature.description, true, true)) + "\u003E";
if (feature.link) {
pug_html = pug_html + "\u003Ca" + (" class=\"feature-link\""+pug.attr("href", feature.link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fp\u003E";
};
pug_mixins["plan-features"] = pug_interp = function(plan, prevPlan){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var logFeature = plan.planFeatures.findByFeatureKey('logs');
var logFeatureTitle = logFeature.getDescription() + ' of ' + logFeature.feature.friendlyName
var socialConnFeature = plan.planFeatures.findByFeatureKey('social_connections');
var socialConnFeatureTitle = (socialConnFeature.getDescription() ||  'Unlimited') + ' Social Identity Providers'
var enterpriseConnFeature = plan.planFeatures.findByFeatureKey('enterprise_connections');
var enterpriseConnFeatureTitle = enterpriseConnFeature && (enterpriseConnFeature.getDescription() ||  'Unlimited') + ' Enterprise Identity Providers';

pug_html = pug_html + "\u003Cul class=\"feature-list\"\u003E";
if (prevPlan) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E" + (pug.escape(null == (pug_interp = 'All ' + prevPlan.name + ' Features') ? "" : pug_interp)) + "\u003Cspan class=\"submenu-icon\"\u003E\u003C\u002Fspan\u003E\u003Cul class=\"feature-sublist\"\u003E";
pug_mixins["prev-plan-mixin"](prevPlan, prevPlanFeaturesArray);
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](logFeatureTitle, logFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](socialConnFeatureTitle, socialConnFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
if (enterpriseConnFeature) {
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](enterpriseConnFeatureTitle, enterpriseConnFeature.feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
// iterate currentFeatures.models
;(function(){
  var $$obj = currentFeatures.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](feature.friendlyName, feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli class=\"feature\"\u003E";
pug_mixins["feature-item"](feature.friendlyName, feature);
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"plan-features\"\u003E";
pug_mixins["plan-features"](plan, prevPlan);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"_" in locals_for_with?locals_for_with._:typeof _!=="undefined"?_:undefined,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"filterPlans" in locals_for_with?locals_for_with.filterPlans:typeof filterPlans!=="undefined"?filterPlans:undefined,"planKey" in locals_for_with?locals_for_with.planKey:typeof planKey!=="undefined"?planKey:undefined,"plans" in locals_for_with?locals_for_with.plans:typeof plans!=="undefined"?plans:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (features, featuresByTag, planHighlighting, plans, sortTags) {pug_html = pug_html + "\u003Cdiv class=\"features-table-cont\"\u003E\u003Cdiv class=\"features-divisions-outer\"\u003E\u003Cdiv class=\"features-divisions\"\u003E\u003Cdiv class=\"division dummy-div\"\u003E\u003C\u002Fdiv\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var plan = $$obj[pug_index0];
var activePlan = plan.isSomeByKey(planHighlighting) ? 'active' : '';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["division","js-plan-name","plan-name",[plan.custom ? 'custom' : '', plan.plan.toLowerCase(), activePlan ]], [false,false,false,true]), false, true)+pug.attr("data-plan", plan.plan.toLowerCase(), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = plan.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index0];
var activePlan = plan.isSomeByKey(planHighlighting) ? 'active' : '';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["division","js-plan-name","plan-name",[plan.custom ? 'custom' : '', plan.plan.toLowerCase(), activePlan ]], [false,false,false,true]), false, true)+pug.attr("data-plan", plan.plan.toLowerCase(), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = plan.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"features-table\"\u003E";
// iterate features.groupByTags().sort(sortTags).groups
;(function(){
  var $$obj = features.groupByTags().sort(sortTags).groups;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var group = $$obj[pug_index1];
featuresByTag = group.features
if ((group.key)) {
pug_html = pug_html + "\u003Ctr class=\"feature-row header-row js-tag\"\u003E\u003Ctd" + (pug.attr("colspan", plans.length + 1, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = group.key) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
// iterate featuresByTag.models
;(function(){
  var $$obj = featuresByTag.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var plan = $$obj[pug_index3];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index3];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var plan = $$obj[pug_index4];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index4];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var group = $$obj[pug_index1];
featuresByTag = group.features
if ((group.key)) {
pug_html = pug_html + "\u003Ctr class=\"feature-row header-row js-tag\"\u003E\u003Ctd" + (pug.attr("colspan", plans.length + 1, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = group.key) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
// iterate featuresByTag.models
;(function(){
  var $$obj = featuresByTag.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var feature = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var plan = $$obj[pug_index6];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index6];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var plan = $$obj[pug_index7];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index7];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E";}.call(this,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"featuresByTag" in locals_for_with?locals_for_with.featuresByTag:typeof featuresByTag!=="undefined"?featuresByTag:undefined,"planHighlighting" in locals_for_with?locals_for_with.planHighlighting:typeof planHighlighting!=="undefined"?planHighlighting:undefined,"plans" in locals_for_with?locals_for_with.plans:typeof plans!=="undefined"?plans:undefined,"sortTags" in locals_for_with?locals_for_with.sortTags:typeof sortTags!=="undefined"?sortTags:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (tooltip) {var fixedPlan = {id: 'fixed', title: 'Packages', cssClass: 'fixed active', iconClass: 'icon-budicon-647' };
var customPlan = {id: 'custom', title: 'Build a Custom Plan', cssClass: 'custom', iconClass: 'icon-budicon-327' };
var tabs = [fixedPlan, customPlan];
var free = ['Passwordless & TouchID Login', 'Lock for Web, iOS & Android', 'Up to 2 social identity providers', 'Rules & Webtask.io subscription'];
var dev = ['All Free Features', 'Social Connections', 'Email Notifications', 'Custom Email Provider', 'Impersonation'];
var devPro = ['All Developer Features', 'Delegation', 'AD Connector', 'Account Linking', 'Custom Emails', 'Password Complexity', 'MFA Consumer'];
var enterprise = ['All Developer Pro Features', 'SOC2 & HIPAA/BAA Compliance', 'On Premise Deployment', 'Database Migration', 'MFA Consumer & Enterprise', 'Enterprise Add-On Delegation', 'Password Complexity', 'SLA', 'Enterprise Support', 'Consolidation of user stores'];
pug_html = pug_html + "\u003Clink rel=\"stylesheet\" type=\"text\u002Fcss\" href=\"\u002F\u002Fcdn2.auth0.com\u002Fpricing-widget\u002Fpricing-widget-4.3.min.css\"\u003E";
pug_mixins["plan-sliders"] = pug_interp = function(sliders){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (sliders['social'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-slider\" data-user-slider=\"social\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-data\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"A user that has authenticated with username\u002Fpassword, passwordless connections or any social provider in the last 30 days, counted per application.\"\u003E\u003Cspan data-user-count=\"social\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"slider-detail\"\u003ERegular Active Users\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
if (sliders['enterprise'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-slider\" data-user-slider=\"enterprise\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-data\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"A user that has authenticated using an enterprise connection like SAML, Active Directory or LDAP among others in the last 30 days, counted per application.\"\u003E\u003Cspan data-user-count=\"enterprise\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"slider-detail\"\u003EEnterprise Active Users\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
if (sliders['employee'])
{
pug_html = pug_html + "\u003Cdiv class=\"plan-slider\" data-user-slider=\"employee\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-data\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"An internal employee of your company that authenticated with any connection or identity provider.\"\u003E\u003Cspan data-user-count=\"employee\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"slider-detail\"\u003EEmployees\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["plan-price"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan class=\"money-sign\"\u003E$\u003C\u002Fspan\u003E\u003Cspan class=\"price-amount\" data-price-tag=\"\"\u003E0\u003C\u002Fspan\u003E\u003Cspan class=\"price-time\" data-time-period=\"\"\u003E\u002Fmo\u003C\u002Fspan\u003E";
};
pug_mixins["plan-usage-switch"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"plan-usage-toggle\"\u003E\u003Cform class=\"plan-usage-form\"\u003E\u003Cdiv class=\"switch-group\" data-toggle=\"tooltip\" data-placement=\"top\" data-container=\"body\" title=\"You should choose this option if it will be external people the ones who will authenticate against the applications and APIs you've created or acquired.\"\u003E\u003Cinput id=\"external\" type=\"radio\" name=\"usage\" value=\"external\" checked\u003E\u003Clabel for=\"external\"\u003E\u003Cspan class=\"only-tooltip\"\u003EExternal Users\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-group\" data-toggle=\"tooltip\" data-placement=\"top\" data-container=\"body\" title=\"You should choose this option if it will be your company employees the ones who will authenticate against the applications and APIs you've created or acquired.\"\u003E\u003Cinput id=\"internal\" type=\"radio\" name=\"usage\" value=\"internal\"\u003E\u003Clabel for=\"internal\"\u003E\u003Cspan class=\"only-tooltip\"\u003EInternal Users\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["plan-actions"] = pug_interp = function(button){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cbutton class=\"plan-cta btn btn-lg btn-success js-start-now\" data-plan-checkout\u003E" + (pug.escape(null == (pug_interp = button.text) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Ca class=\"plan-cta btn btn-lg btn-success js-buy-now hide\" href=\"\u002F\u002Fmanage.auth0.com\u002F#\u002Faccount\u002Fbilling\u002Fsubscription\"\u003E" + (pug.escape(null == (pug_interp = button.text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (button.customText) {
pug_html = pug_html + "\u003Cbutton class=\"plan-cta btn btn-lg btn-success js-plan-contact-sales custom-deal open-contact-form-modal\"\u003E" + (pug.escape(null == (pug_interp = button.customText) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
}
};
pug_mixins["plan-box"] = pug_interp = function(plan, name, planClass, description, button, sliders, showPrice, subtitle, onlyTooltip){
var block = (this && this.block), attributes = (this && this.attributes) || {};
showPrice = typeof showPrice === 'undefined' ? true : false
subtitle  = typeof subtitle === 'undefined' ? '' : 'has-subtitle'
tooltip = typeof onlyTooltip === 'undefined' ? false : true
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["plan-box",planClass], [false,true]), false, true)+pug.attr("data-plan", plan, true, true)) + "\u003E\u003Cdiv class=\"plan-box-inner\"\u003E\u003Cdiv class=\"plan-header\"\u003E\u003Ch3" + (pug.attr("class", pug.classes(["plan-title",subtitle], [false,true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = name) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-body\"\u003E\u003Cdiv class=\"plan-image\"\u003E\u003Cimg" + (pug.attr("src", '/pages/pricing/img/illustration-' + plan + '.svg', true, true)+pug.attr("alt", plan, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
if ((plan!=='enterprise')) {
pug_html = pug_html + "\u003Cdiv class=\"plan-price\"\u003E";
pug_mixins["plan-price"]();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cspan class=\"price-alt-text\"\u003EGet in touch\u003C\u002Fspan\u003E";
}
if ((plan=='enterprise')) {
pug_html = pug_html + "\u003Ch2 class=\"ent-alt-text\"\u003EContact Us\u003C\u002Fh2\u003E";
}
if ((plan!=='enterprise')) {
pug_html = pug_html + "\u003Cdiv class=\"plan-details\"\u003E";
if ((plan=='developer-pro')) {
pug_mixins["plan-usage-switch"]();
}
pug_mixins["plan-sliders"](sliders);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if ((plan=='enterprise')) {
pug_html = pug_html + "\u003Cp class=\"plan-description\"\u003E" + (pug.escape(null == (pug_interp = description) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"plan-ctas-cont\"\u003E";
pug_mixins["plan-actions"](button);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"js-plan-features-container\""+pug.attr("data-plan", plan, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"fixed-plans\" id=\"pricing-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cnoscript\u003E\u003Cimg height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https:\u002F\u002Fanalytics.twitter.com\u002Fi\u002Fadsct?txn_id=l4ru9&p_id=Twitter\" \u002F\u003E\n\u003Cimg height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"\u002F\u002Ft.co\u002Fi\u002Fadsct?txn_id=l4ru9&p_id=Twitter\" \u002F\u003E\u003C\u002Fnoscript\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1\u003EFlexible pricing,\u003Cbr class=\"rm-break\"\u003E for developers and companies\u003C\u002Fh1\u003E\u003Cp\u003EEverything you need to start using Auth0\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"free-plan-module\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"free-plan-outer\" data-plan=\"free\"\u003E\u003Cdiv class=\"free-plan-details\"\u003E\u003Ch2\u003E7,000 free active users &\u003Cbr\u003E unlimited logins\u003C\u002Fh2\u003E\u003Cul class=\"feature-list\"\u003E\u003Cli class=\"feature\"\u003EPasswordless & TouchID Login\u003C\u002Fli\u003E\u003Cli class=\"feature\"\u003ELock for Web, iOS & Android\u003C\u002Fli\u003E\u003Cli class=\"feature\"\u003EUp to 2 social identity providers\u003C\u002Fli\u003E\u003Cli class=\"feature\"\u003ERules & Webtask.io subscription\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"free-plan-price\"\u003E\u003Cdiv class=\"price-header\"\u003ESTART ON OUR FREE PLAN\u003C\u002Fdiv\u003E\u003Cdiv class=\"price-body\"\u003E\u003Ch2 class=\"price-tag\"\u003E";
pug_mixins["plan-price"]();
pug_html = pug_html + "\u003C\u002Fh2\u003E";
pug_mixins["plan-actions"]({ text: 'Start Now' });
pug_html = pug_html + "\u003Cp class=\"price-disclaimer\"\u003ENo credit card required\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"open-source-banner\"\u003E\u003Cp\u003EHave an open source project? Get Auth0 for free with our \u003Cspan class=\"only-tooltip\" data-toggle=\"tooltip\" data-placement=\"bottom\" data-container=\"body\" title=\"Are you building an open source project that is completely non-profit? If you add an attribution badge on your website, you and your collaborators can use all the Auth0 features without limits!\"\u003E\u003Cspan class=\"tip-text\"\u003EOpen Source Program\u003C\u002Fspan\u003E\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Ca class=\"open-contact-oss\"\u003ELearn More\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"plans-switch\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"switch-container\"\u003E\u003Cdiv class=\"switch-cont\"\u003E\u003Cdiv class=\"switch-plan\" data-view=\"fixed-plans\"\u003E\u003Ca class=\"switch-item active\" href=\"#\" data-interval=\"month\"\u003EMonthly\u003C\u002Fa\u003E\u003Ca class=\"switch-item\" href=\"#\" data-interval=\"year\"\u003EAnnually\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"switch-text\"\u003ESubscribe for a year and get a month free.\u003Cbr\u003E\nPay for active users or employees based on your type of organization.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"pricing-module\" data-pricing-category=\"developers\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"module-plans-outer\"\u003E";
pug_mixins["plan-box"]('developer', 'Developer', 'developer' ,'Use any social identity providers to authenticate, manage users with a powerful dashboard, and customize and extend authentication processes programatically.', { text: 'TRY IT FOR FREE', customText: 'CONTACT US' }, { social: true });
pug_mixins["plan-box"]('developer-pro', 'Developer Pro', 'developer-pro-external' ,'Enterprise identity providers support, impersonation and additional security features including password complexity rules and multi-factor authentication among others.', { text: 'TRY IT FOR FREE', customText: 'CONTACT US' }, { social: true, enterprise: true }, undefined, true);
pug_mixins["plan-box"]('developer-pro', 'Developer Pro', 'developer-pro-internal hide' ,'Enterprise identity providers support, impersonation and additional security features including password complexity rules and multi-factor authentication among others.', { text: 'TRY IT FOR FREE', customText: 'CONTACT US' }, { employee: true}, undefined, true);
pug_mixins["plan-box"]('enterprise', 'Enterprise', 'enterprise', 'Ideal for your mission critical applications. Get a secure, universal identity platform that just works. High SLA environment with enterprise-grade support, SOC 2, HIPAA/BAA, Privacy Shield certifications and audit reports as well as private cloud or on-premise deployments.', { text: 'TALK TO SALES', customText: 'TALK TO SALES' }, {}, undefined, true);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"enterprise-addons theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"enterprise-addon-container\"\u003E\u003Cdiv class=\"enterprise-addons-header\"\u003E\u003Cimg class=\"section-heading-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-addons-1b23d1097d.svg\" alt=\"features\"\u003E\u003Ch2 class=\"section-title\"\u003EEnterprise Addons\u003C\u002Fh2\u003E\u003Cp class=\"enterprise-addons-description\"\u003EGet the most out of your Auth0 subscription by adding our enterprise-grade, web-scale add-ons. Try them for free!\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-lg btn-success js-general-contact-sales open-contact-form-modal\"\u003ETALK TO SALES\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"addons-list\"\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Fbreached-passwords-logo-ddbcd43a85.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003EBreached Password Detection\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EKeep your users and services safe from password leaks and intruders. Protects and notifies your users when their credentials are leaked by a data breach of a third party or when somebody is trying to force their way into their account.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"button btn btn-lg btn-success\" href=\"javascript:signup()\"\u003ETry it for free\u003C\u002Fa\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fbreached-passwords\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Fguardian-logo-510772a3a5.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003EMultifactor Auth with Guardian\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EThe most usable and friction-free multifactor authentication experience available. Use the Guardian iOS or Android app to receive push notifications, get one-time codes delivered via SMS or connect with a third party token generation app such as Google Authenticator.\u003C\u002Fp\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"button btn btn-lg btn-success\" href=\"javascript:signup()\"\u003ETry it for free\u003C\u002Fa\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fguardian\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-premium-support-dcd8155364.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003EPreferred Support\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EPreferred level of support agreement that includes extended support hours including an available 24\u002F7 option with 1 hour response time and a dedicated customer success manager to help you with your on boarding and on going experience with Auth0.\u003C\u002Fp\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fsupport#ticket-response-times\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"addon-component\"\u003E\u003Cdiv class=\"addon-box\"\u003E\u003Cimg class=\"addon-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-sla-9995-a6257c73dc.svg\"\u003E\u003Cdiv class=\"addon-detail\"\u003E\u003Ch4 class=\"addon-title\"\u003ESLA 99.95%\u003C\u002Fh4\u003E\u003Cp class=\"addon-description\"\u003EAuth0 commits to deliver 99.95% level of end-user availability of service, with financial incentives to perform.\u003C\u002Fp\u003E\u003Cdiv class=\"addon-footer\"\u003E\u003Ca class=\"read-more\" href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fsupport\u002Fsla\"\u003ERead more\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"pricing-full-features\" id=\"full-features\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"features-header\"\u003E\u003Cimg class=\"section-heading-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-scale-9fa1ab64ce.svg\" alt=\"features\"\u003E\u003Ch2 class=\"section-title\"\u003ECompare our features, side by side\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"features-table-outer-cont\"\u003E\u003Cdiv class=\"js-features-table-container\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"faq theme-dark\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cdiv class=\"faq-header\"\u003E\u003Cimg class=\"section-heading-image\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fpricing\u002Fimg\u002Ficon-faq-86386d9b51.svg\" alt=\"Frecuently Asked Questions\"\u003E\u003Ch2 class=\"section-title\"\u003EFrequently Asked Questions\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"faq-outer-container\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Cul class=\"question-list\"\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhy should I trust Auth0 with my users?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003ESecurity is our utmost priority. For starters, we follow security best practices for storing user credentials: they are never stored in plain text, and all passwords are hashed and salted using the \u003Ca href=\"https:\u002F\u002Fen.wikipedia.org\u002Fwiki\u002FBcrypt\"\u003Ebcrypt\u003C\u002Fa\u003E algorithm, a state-of-the-art algorithm designed to prevent brute-force attacks even in case of a breach. Furthermore, our implementation of TLS has received an “A+” score in \u003Ca href=\"https:\u002F\u002Fwww.ssllabs.com\u002Fssltest\u002Fanalyze.html?d=manage.auth0.com\"\u003EQualsys’ SSL Labs SSL Server test\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EWe also implement proactive security measures for your projects such as password breach detection, using a huge database of leaked passwords, and brute-force attack detection. Automated rate-limiting checks and denial of service mitigation procedures are also in place.\u003C\u002Fp\u003E\u003Cp\u003EYou can learn more about security at Auth0 at our \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fsecurity\u002F\"\u003Esecurity page\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat happens if I stop using Auth0? How do I know my user's data is safe?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EYour data is safe as long as it’s stored in our servers. If you choose to stop using Auth0, exporting your data is a simple matter. Head over to the Auth0 Dashboard and go to the extensions page. Select “User Import\u002FExport” and proceed to enable the extension. If you need help using the extension, check our \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fextensions\u002Fuser-import-export\"\u003Edocs\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EIf you feel the export extension does not fill your needs, the \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fapi\u002Fmanagement\u002Fv2#!\"\u003EAuth0 management API\u003C\u002Fa\u003E lets you fully inspect all the data from your account. With it, you can export all data to any format.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat's the difference between regular users and enterprise users? How is the user count computed?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EUsers are differentiated according to what type of connection is required for them. Regular users are connected through a standard database connection (username + password), a passwordless scheme (SMS, E-mail, TouchID) or a \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\"\u003Esocial connection\u003C\u002Fa\u003E (of which there are more than 30 providers). Enterprise users, on the other hand, are connected through an enterprise connection such as Active Directory, WS-Federation or LDAP. You can find all about the different types of connections in the \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\"\u003Edocs\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EBoth the regular users and the enterprise users are counted as active if they logged in at least once in the last 30 days. Employee users are always counted, regardless of their activity.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EIf I surpass the 7000 users Free Plan do I need to select the Developer Plan with up to 10,000 users?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EYes, if you pass the 7,000 users mark, you need to select the Developer Plan (or any of the other plans that fit your needs) and select the right amount of users for your use case. Paid plans let you pick a custom number of users, from 1,000 up to 100,000 or more. Up to 7,000 users, a special, lower, per-user price is computed, to recoup for the users of the free plan. Regardless of the number of users you pick, you always get all the added benefits of the paid plans, such as 2 days log retention and unlimited social providers.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat are the different deployment models and the difference of private cloud vs appliance?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EAuth0 can run as a third-party service on the Auth0 cloud, or it can be installed to your own internal systems or cloud. In particular, Auth0 supports \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Foverview\u002Fdeployment-models\"\u003Efour different types of deployment modes\u003C\u002Fa\u003E:\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003EAuth0 cloud, multi-tenant\u003C\u002Fli\u003E\u003Cli\u003EAuth0 cloud, single-tenant (dedicated)\u003C\u002Fli\u003E\u003Cli\u003ECustomer’s cloud (private cloud)\u003C\u002Fli\u003E\u003Cli\u003ECustomer’s data centre (appliance)\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EWhat's Auth0's uptime and status?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EAuth0 systems have over 99.9% monthly uptime figures. You can check the current and past status and uptime figures at the \u003Ca href=\"https:\u002F\u002Fstatus.auth0.com\u002F\"\u003Estatus\u003C\u002Fa\u003E and \u003Ca href=\"http:\u002F\u002Fuptime.auth0.com\u002F\"\u003Euptime\u003C\u002Fa\u003E pages.\u003C\u002Fp\u003E\u003Cp\u003EEnterprise users can optionally request a Service Level Agreement (SLA) with 99.95% availability for an added cost.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003Cli class=\"question-item\"\u003E\u003Cdiv class=\"question-title\"\u003EHow long does my trial last?\u003C\u002Fdiv\u003E\u003Cdiv class=\"question-answer\"\u003E\u003Cp\u003EThe trial period lasts 22 days. After that, the free plan gets activated automatically. If you wish to continue using some of the features from our Developer, Developer Pro or Enterprise plans, please choose one from above.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";}.call(this,"tooltip" in locals_for_with?locals_for_with.tooltip:typeof tooltip!=="undefined"?tooltip:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"privacy-page simple-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci class=\"icon-budicon-433\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003E Privacy Policy\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ELast update: September 14, 2016\u003C\u002Fh3\u003E\u003Cp\u003EWe at Auth0®, Inc. (\"Auth0®,\" \"we,\" \"us,\" or \"our\") created this Privacy Policy (\"Privacy Policy\") because we know that you care about how information you provide to us is used and shared. This Privacy Policy relates to the information collection and use practices of Auth0® in connection with our online services (\"Services\"), which are made available to you through our website located at auth0.com (the \"Site\").\u003C\u002Fp\u003E\u003Cp\u003EThis Privacy Policy applies to visitors to the Site, who view only publicly-available content (the “Visitors”) and subscribers who have signed up to access and use our Services (“Subscribers”). \u003C\u002Fp\u003E\u003Cp\u003EBy visiting our Site, Visitors are agreeing to the terms of this Privacy Policy and the accompanying Terms of Service. By signing up, accessing and\u002For using our Services or by clicking “I Accept”, each Subscriber is agreeing to the terms of this Privacy Policy and the accompanying Terms of Service. \u003C\u002Fp\u003E\u003Cp\u003ECapitalized terms not defined in this Privacy Policy shall have the meaning set forth in our Terms of Service\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EInformation We Collect\u003C\u002Fh3\u003E\u003Cp\u003EWhen you sign up to use the Services, either as an individual or on behalf of a company, you may be asked to provide us with the following information: your first name, last name, email address, and company name (if applicable).\u003C\u002Fp\u003E\u003Cp\u003EYou may choose to sign-in using your GitHub, Google, Microsoft or any other third party identity provider account (“Third Party IdP”). By signing-in using your Third Party IdP, you are authorizing Auth0® to collect, store, and use, in accordance with this Privacy Policy, any and all information that you have authorized the  Third Party IdP to  provide to Auth0®.  Such information may include your first and last name, unique identifier, e-mail address and picture.\u003C\u002Fp\u003E\u003Cp\u003EWe will collect billing and payment information which may include your credit card number, billing address, and other payment related information (“Billing Information”). Billing Information is collected and processed by our third-party payment processor operating as our agent (See, Onward Transfers to Third Parties). Auth0 does not directly obtain or process any Billing Information.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca name=\"cookies\"\u003E\u003C\u002Fa\u003E\u003Ch3\u003EInformation Collected Using Cookies\u003C\u002Fh3\u003E\u003Cp\u003ELike most websites, we use automatic data collection technology when you visit the Site to collect information that identifies your computer. This comprises information about your operating system, your IP addresses, browser type and language, referring pages and URLs, keywords, date and time, and what sections of the Site you visit (the \"Usage Information\").\u003C\u002Fp\u003E\u003Cp\u003EWe collect this Usage Information by using cookies. Cookies are small packets of data that a website stores on your computer's hard drive so that your computer will \"remember\" information about your visit. You can reject cookies by following the directions provided by your browser vendor or by your Internet provider's \"help\" file. If you reject cookies, you may still visit the Site, but may not be able to use some areas of the Site.\u003C\u002Fp\u003E\u003Cp\u003EWe use cookies on our Site (and the Usage Information collected) to help us identify you and analyze how you use our Site.\u003C\u002Fp\u003E\u003Cp\u003EWe also work with trusted third party partners which use cookies to collect Usage Information about how visitors use our Site, for example, which pages our visitors go to most often, and if they get error messages on those pages. Until you become an Auth0® subscriber, these performance cookies don't collect information that identifies you as an individual. The Usage Information gathered is only used to improve how our Site works. The trusted third parties we currently work with include the following (click on the links to view these organizations' privacy policies and find out more about what data they hold about you, what they do with it, and how to opt-out from certain data collection):\u003Cul\u003E\u003Cli\u003E \u003Ca href=\"http:\u002F\u002Ftools.google.com\u002Fdlpage\u002Fgaoptout\"\u003EGoogle Analytics\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E \u003Ca href=\"https:\u002F\u002Fsegment.com\u002Fdocs\u002Flegal\u002Fprivacy\"\u003ESegment.io\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E \u003Ca href=\"https:\u002F\u002Fwww.facebook.com\u002Fbusiness\"\u003EFacbook Pixel\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E \u003Ca href=\"http:\u002F\u002Flegal.marketo.com\u002Fprivacy\"\u003EMarketo\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E \u003Ca href=\"https:\u002F\u002Fmouseflow.com\"\u003EMouseflow\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli\u003E \u003Ca href=\"https:\u002F\u002Fpriceonomics.com\"\u003EPriceonomics\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp\u003EWe also use one or more third-party remarketing services (including Twitter and Google AdWords) to advertise to our Visitors and Subscribers on third party websites. It could mean that we advertise to previous Visitors who haven’t completed a task on our Site, for example using the contact form to make an enquiry. These third-party remarketing service providers use cookies to serve ads based on a past visit to the Site. Any data collected by such third party remarketing service providers will be used in accordance with this Privacy Policy and the privacy policy of such third party remarketing services provider. For more information on such third party remarketing service providers, including how to opt out from certain data collection, please visit the following links:.\u003C\u002Fp\u003E\u003Cp\u003EFor Google AdWords, you can set preferences for how Google advertises to you using the Google Ad Preferences page, and if you want to you can opt out of interest-based advertising entirely by cookie settings or permanently using a browser plugin.\u003C\u002Fp\u003E\u003Cp\u003EFor Twitter, please visit: \u003Ca href=\"https:\u002F\u002Fsupport.twitter.com\u002Farticles\u002F20171365\"\u003Ehttps:\u002F\u002Fsupport.twitter.com\u002Farticles\u002F20171365\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp\u003EWe also use certain cookies which are strictly necessary for the provision of the Services to customers' end users who have requested those Services (for example, so that we can identify customers' end users). Use of these cookies is essential to enable us to provide the Services requested by customers' end users.\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EInformation Collected through the Site That IS NOT Covered by this Privacy Policy.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003ERegistered Users may voluntarily post information using blogs and other similar features available through the Site. NONE of the information you provide using these features is protected by this Privacy Policy. THIS PRIVACY POLICY DOES NOT APPLY TO ANY INFORMATION (INCLUDING PERSONAL INFORMATION) THAT YOU PROVIDE USING BLOGS, OR OTHER SIMILAR FEATURES AVAILABLE THROUGH THE SITE. ALL SUCH INFORMATION IS PUBLIC INFORMATION AND MAY BE SEEN, COLLECTED OR USED BY ANY USER OF THE SITE. By posting such information, you consent to the transfer of such information (including any personal information) from your country of origin to the US, and you acknowledge that the EU-US Privacy Shield Framework does not apply to such information (including any personal information).\u003C\u002Fp\u003E\u003Cp\u003E\u003Cstrong\u003EInformation Collected and Stored on Behalf of Our Customers Using the Services.\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EAs part of the Services, Auth0® collects authentication data from your end users as per your instructions (“End User Authentication Data”), and may also receive End User Authentication Data from you. End User Authentication Data may, as determined solely by Auth0® customers, include personal information regarding your end users. Auth0® processes and stores End User Authentication Data for purposes of providing the Services. Auth0® does not have any relationship, contractual or otherwise, with your end users. You, as the customer (and specifically not Auth0®) are solely responsible for providing notice to, and obtaining all consents and other assurances required under applicable law from, your end users regarding the collection, transfer, processing and storage of End User Authentication Data by Auth0® including, for any end users that are residents of the European Economic Area.\u003C\u002Fp\u003E\u003Cp\u003EIf you are an end user who would like to correct or delete your End User Authentication Data, please contact the customer, your application, API or service provider or contact us directly as set forth in the Section titled “Access to Personal Information” below.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EHow We Use Your Information\u003C\u002Fh3\u003E\u003Cp\u003EWe will use your Personal Data and Usage Information (together, “Information”) for the following purposes:\u003Cul\u003E\u003Cli\u003ETo respond to your requests and to provide you with the Services;\u003C\u002Fli\u003E\u003Cli\u003ETo respond to your inquiries and contact you about changes to the Site, and\u002For the Services;\u003C\u002Fli\u003E\u003Cli\u003ETo send you notices (for example, in the form of e-mails, mailings, and the like) regarding products or services you are receiving, and for billing and collection purposes;\u003C\u002Fli\u003E\u003Cli\u003ETo improve the Site and\u002For the Services;\u003C\u002Fli\u003E\u003Cli\u003EFor any other purposes disclosed at the time the information is collected or to which you consent.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp\u003EWe may also use your information to improve our Site, and\u002For the Services, and may use cookies and other information to enable us to customize your user experience.\u003C\u002Fp\u003E\u003Cp\u003EWe may analyze your Personal Data in aggregate form which does not identify you personally. We may share this aggregate data with our parent, affiliates, agents, advertisers, manufacturers and business partners.\u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003EOnward Transfer to Third Parties\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003ELike many businesses, we hire other companies to perform certain business-related services. We may disclose personal information to certain types of third party companies but only to the extent needed to enable them to provide such services. The types of companies that may receive personal information and their functions are: mail services (hard copy and email); hosting services; database management\u002Fback-up services; monitoring services; customer support and customer relationship management services; accounting services; and payment processors. All such third parties function as our agents, performing services at our instruction and on our behalf pursuant to contracts which require they provide at least the same level of privacy protection as is required by this Privacy Policy and implemented by Auth0.  You may opt out of having your personal information transferred to any or all of our categories of agents by contacting us at \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E.  Please allow us a reasonable time to process your request.\u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003EOpt-In to Certain Onward Transfers:\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EWe will not transfer your personal information to a third party controller without first providing you with information regarding the identity of such controller or the nature of such controller’s business, and obtaining your opt-in consent.\u003C\u002Fp\u003E\u003Cp\u003EWe will not disclose your sensitive personal information to any third party without first obtaining your opt-in consent. You may grant such consent by contacting us at \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E. In each instance, please allow us a reasonable time to process your response. \u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003EBusiness Transfers\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EIn the event of a merger, dissolution or similar corporate event, or the sale of all or substantially all of our assets, we expect that the information that we have collected, including personal information, would be transferred to the surviving entity in a merger or the acquiring entity. All such transfers shall be subject to our commitments with respect to the privacy and confidentiality of such personal information as set forth in this Privacy Policy. \u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003EDisclosures to Public Authorities, Other Third Parties\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EWe may be required to disclose personal information in response to lawful requests by public authorities, including for the purpose of meeting national security or law enforcement requirements. We may also disclose personal information to other third parties when compelled to do so by government authorities or required by law or regulation including, but not limited to, in response to court orders and subpoenas. \u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003EOpt-Out for Direct Marketing\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EYou may opt out at any time from the use of your personal information for direct marketing purposes by contacting us at \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E. Please allow us a reasonable time to process your request.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EHow We Protect Your Information\u003C\u002Fh3\u003E\u003Cp\u003EAuth0 implements reasonable and appropriate security measures to protect your personal information from loss, misuse and unauthorized access, disclosure, alteration and destruction, taking into account the risks involved in processing and the nature of such data, and comply with applicable laws and regulations.  Auth0® is SOC-2 compliant and will continue to be SOC 2 compliant. Auth0® conducts vulnerability scans and audits of its servers and networks at least annually. \u003C\u002Fp\u003E\u003Cp\u003EPlease understand, however, that no security system is impenetrable. We cannot guarantee the security of our databases, nor can we guarantee that the information you supply will not be intercepted while being transmitted to and from us over the Internet. In particular, e-mail sent to or from the Site may not be secure, and you should therefore take special care in deciding what information you send to us via e-mail.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EAccess to Personal Information\u003C\u002Fh3\u003E\u003Cp\u003EUpon request to \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E, we will provide you with confirmation as to whether we are processing your personal information, and have the data communicated to you within a reasonable time. You have the right to access, correct, amend or delete your personal information where it is inaccurate or has been processed in violation of this Privacy Policy. We may require payment of a non-excessive fee to defray our expenses in this regard. Please allow us a reasonable time to respond to your inquiries and requests. \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ERetention of Personal Information\u003C\u002Fh3\u003E\u003Cp\u003EWe will retain your personal information in a form that identifies you only for as long as it serves the purpose(s) for which it was initially collected as stated in this Privacy Policy, or subsequently authorized. We may continue processing your personal information for longer periods, but only for the time and to the extent such processing reasonably serves the purposes of archiving in the public interest, journalism, literature and art, scientific or historical research and statistical analysis, and subject to the protection of this Privacy Policy. After such time periods have expired, we may either delete your personal information or retain it in a form such that it does not identify you personally.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EYour Choices\u003C\u002Fh3\u003E\u003Cp\u003EIf you wish to stop receiving e-mails from us, please send us a message via \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E. You may also choose to unsubscribe from our emails by following the instructions in the bottom of the email.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ELinks\u003C\u002Fh3\u003E\u003Cp\u003EThe Site and the Services may contain content, services, advertising and other materials that link to External Sites. Auth0® does not endorse and is not responsible for the content of any such External Sites. Please refer to the terms of use and privacy policies of the External Sites for more information\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ECalifornia Residents\u003C\u002Fh3\u003E\u003Cp\u003EUnder California Civil Code Section 1798.83, California residents who have an established business relationship with Auth0® may choose to opt out of our sharing your personal information with third parties for direct marketing purposes.  If you are a California resident and (1) you wish to opt out; or (2) you wish to request certain information regarding our disclosure of your Personal Information to third parties for the direct marketing purposes, please send an e-mail to \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E with “Privacy Policy” in the subject line. \u003C\u002Fp\u003E\u003Cp\u003EIn addition, Auth0® does not monitor, recognize, or honor any opt-out or do not track mechanisms, including general web browser “Do Not Track” settings and\u002For signals.\u003C\u002Fp\u003E\u003Cp\u003E \u003Cstrong\u003EImportant Notice to All Non-US Residents\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E\u003Cp\u003EOur servers are located in the US. If you are located outside of the US, please be aware that any information provided to us, including personal information, will be transferred from your country of origin to the US. Except in the case of data transfers under the EU-US Privacy Shield and the U.S.-Swiss Safe Harbor Framework, your decision to provide such data to us, or allow us to collect such data it through our Website or the Services, constitutes your consent to this data transfer. \u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EImportant Notice for Residents of the European Economic Area\u003C\u002Fh3\u003E\u003Cp\u003E Auth0® complies with the EU-US Privacy Shield Framework as set forth by the US Department of Commerce regarding the collection, use, and retention of personal information from the EU. Auth0® has certified that it adheres to the Privacy Shield principles of Notice, Choice, Accountability for Onward Transfer, Security, Data Integrity and Purpose Limitation, Access, Recourse, Enforcement and Liability, and the Supplemental Principles (the “Privacy Shield Principles”). If there is a conflict between this Privacy Policy and the Privacy Shield Principles, the Privacy Shield Principles shall govern. We are committed to applying the Privacy Shield Principles to all personal information received from the EU, Iceland, Liechtenstein and Norway (referred to herein as the “EU”) in reliance upon the Privacy Shield. With regard to the Principle of Accountability for Onward Transfer, for example, we remain liable if our agent processes such personal information in a manner inconsistent with the Privacy Shield Principles, unless we prove that we are not responsible for the event giving rise to the damage. To learn more about the Privacy Shield program, and to view our certification page, please visit: \u003Ca href=\"https:\u002F\u002Fwww.privacyshield.gov\u002F\"\u003Ehttps:\u002F\u002Fwww.privacyshield.gov\u002F\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp\u003EAuth0® is subject to the investigatory and enforcement powers of the Federal Trade Commission. We are committed to resolving complaints from EU data subjects pursuant to the Recourse, Enforcement and Liability Principle. \u003C\u002Fp\u003E\u003Cp\u003EIn compliance with the EU-US Privacy Shield Principles, Auth0® commits to resolve complaints about your privacy and our collection or use of your personal information.  EU individuals with inquiries or complaints regarding this Privacy Policy should first contact Auth0® at \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EAuth0® has further committed to refer unresolved privacy complaints under the EU-US Privacy Shield Principles to BBB PRIVACY SHIELD, a non-profit alternative dispute resolution provider located in the United States and operated by the Council of Better Business Bureaus. If you do not receive timely acknowledgment of your complaint, or if your complaint is not satisfactorily addressed by Auth0®, please visit www.bbb.org\u002FEU-privacy-shield\u002Ffor-eu-consumers\u002F for more information and to file a complaint. If these processes do not result in a resolution, you may also contact your local data protection authority, the US Department of Commerce, and\u002For the Federal Trade Commission for assistance. If your complaint still remains unresolved, then you have the right to invoke binding arbitration by the Privacy Shield Panel upon written notice to Auth0® at \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EUS-Swiss Safe Harbor Framework\u003C\u002Fh3\u003E\u003Cp\u003EAuth0® complies with the U.S.-Swiss Safe Harbor Framework as set forth by the U.S. Department of Commerce regarding the collection, use, and retention of personal information from Switzerland. Auth0® has certified that it adheres to the Safe Harbor Privacy Principles of notice, choice, onward transfer, security, data integrity, access and enforcement. If there is any conflict between the policies in this Privacy Policy and the Safe Harbor Privacy Principles, the Safe Harbor Privacy Principles shall govern.  To learn more about the US-Swiss Safe Harbor and to view our certification page, please visit: \u003Ca href=\"http:\u002F\u002Fwww.export.gov\u002Fsafeharbor\"\u003Ehttp:\u002F\u002Fwww.export.gov\u002Fsafeharbor\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003Cp\u003EAuth0® has further committed to refer unresolved privacy complaints under the US-Swiss Safe Harbor to an independent dispute resolution mechanism operated by the Council of Better Business Bureaus. If you do not receive timely acknowledgment of your complaint, or if your complaint is not satisfactorily addressed, please visit www.bbb.org\u002Fus\u002Fsafe-harbor-complaints for more information and to file a complaint.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EQuestions\u003C\u002Fh3\u003E\u003Cp\u003EIf you have any questions regarding this Privacy Policy, please contact us as set forth in the \"How to Contact Us\" section below. We will investigate your question, respond to your inquiry, and attempt to resolve any concerns regarding your privacy question.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EChildren\u003C\u002Fh3\u003E\u003Cp\u003EWe do not knowingly collect Personal Data from children under the age of 13 through the Site and\u002For the Services. If you are under 13, please do not give us any Personal Data. We encourage parents and legal guardians to monitor their children’s Internet usage and to help enforce our Privacy Policy by instructing their children to never provide Personal Data through the Site without their permission. If you have reason to believe that a child under the age of 13 has provided Personal Data to us, please contact us, and we will endeavor to delete that information from our databases.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EChanges to This Privacy Policy\u003C\u002Fh3\u003E\u003Cp\u003EThis Privacy Policy is effective as of the date stated at the top of this Privacy Policy. We may change this Privacy Policy from time to time, and will notify you of any changes during your next log-in to your account. This notification will include a link to the updated Privacy Policy. Your continued use of our Services after this notification will be deemed acceptance of the new Privacy Policy.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content content-last\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EHow to Contact Us\u003C\u002Fh3\u003E\u003Cp\u003EIf you have questions about this Privacy Policy, please send us a message via \u003Ca href=\"mailto:privacy@auth0.com\"\u003Eprivacy@auth0.com\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (initialState, resourceApp) {pug_html = pug_html + "\u003Cdiv class=\"resources-page\"\u003E\u003Cscript\u003E" + (null == (pug_interp = initialState) ? "" : pug_interp) + "\u003C\u002Fscript\u003E\u003Cdiv class=\"resource-app\"\u003E" + (null == (pug_interp = resourceApp) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"initialState" in locals_for_with?locals_for_with.initialState:typeof initialState!=="undefined"?initialState:undefined,"resourceApp" in locals_for_with?locals_for_with.resourceApp:typeof resourceApp!=="undefined"?resourceApp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"jumbotron has-header\"\u003E\u003Ch2\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fimg\u002Flock-icon-06759bc0e5.svg\" alt=\"\" data-no-retina=\"\"\u003E\u003C\u002Fh2\u003E\u003Ch1\u003EAuth0 Security & Privacy\u003C\u002Fh1\u003E\u003Cp\u003E We've built state-of-the-art security into our product, to protect your business and your users. Get our security white paper to learn our information security approach, and check out our list of certifications and compliance capabilities. \u003C\u002Fp\u003E\u003Ca class=\"download-link\" href=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fsecurity\u002Fauth0s-information-security.pdf\" rel=\"external\" target=\"_blank\"\u003E\u003Csvg fill=\"#FFFFFF\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\"  xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z\"\u002F\u003E\n\u003Cpath d=\"M0 0h24v24H0z\" fill=\"none\"\u002F\u003E\n\u003C\u002Fsvg\u003EDownload white Paper\u003C\u002Fa\u003E\u003C\u002Fsection\u003E\u003Csection class=\"sec-features\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3 class=\"text-center\"\u003ETrust, Front and Center\u003C\u002Fh3\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cdiv class=\"sec-features__item\"\u003E\u003Ch4\u003EEncryption, Password Hashing\u003C\u002Fh4\u003E\u003Cp\u003EAuth0 helps you prevent critical identity data from falling into the wrong hands. We never store passwords as clear text - they are always hashed (and salted) securely using bcrypt. Both data at rest and in motion is encrypted - all network communication uses TLS with at least 128-bit AES encryption. The connection uses TLS v1.2, and it is encrypted and authenticated using AES_128_GCM and uses ECDHE_RSA as the key exchange mechanism. Qualsys' SSL Labs \u003Ca href=\"https:\u002F\u002Fwww.ssllabs.com\u002Fssltest\u002Fanalyze.html?d=manage.auth0.com\" target=\"_blank\"\u003Escored Auth0's SSL implementation as \"A+\"\u003C\u002Fa\u003E on their SSL Server test.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sec-features__item\"\u003E\u003Ch4\u003EPassword Complexity\u003C\u002Fh4\u003E\u003Cp\u003EWith Auth0 you can enforce five levels of password complexity, as well as custom rules implementing \u003Ca href=\"https:\u002F\u002Fwww.owasp.org\u002Findex.php\u002FAuthentication_Cheat_Sheet#Implement_Proper_Password_Strength_Controls\" target=\"_blank\"\u003EOWASP recommendations\u003C\u002Fa\u003E and more.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sec-features__item\"\u003E\u003Ch4\u003EAttack Prevention, Mitigation\u003C\u002Fh4\u003E\u003Cp\u003EAuth0 services are architected with high-availability and resilience in mind. Auth0 applications have built-in rate limiting and automated blocking features to mitigate advanced denial of service or authentication attacks. Our network infrastructure is protected against volumetric attacks by our cloud providers, in addition to a dedicated DDoS mitigation service.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E \u003Cdiv class=\"sec-features__item\"\u003E\u003Ch4\u003ESecure Infrastructure\u003C\u002Fh4\u003E\u003Cp\u003EAuth0 takes advantage of the industry's most sophisticated, battle-tested infrastructure. We run on hardened Linux hosts with automatic security patching, carefully-configured security groups, segmented VPCs, and role-based access controls, combined with many other advanced protections built into the cloud infrastructure.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sec-features__item\"\u003E\u003Ch4\u003EAccount Verification\u003C\u002Fh4\u003E\u003Cp\u003EAuth0 safeguards your users with default email verification at account creation time and during password resets.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sec-features__item\"\u003E\u003Ch4\u003EStandards-based Identity\u003C\u002Fh4\u003E\u003Cp\u003EFrom the start, Auth0 has been built on tested, verified identity standards, including LDAP, SAML, OAuth, OpenID, OpenID Connect, and JSON Web Tokens (JWTs) - all of the common and most popular identity standards. Auth0 participates in standards organizations like the OpenID Foundation. We make it easy to leverage these powerful standards to shield your own applications and APIs.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"sert\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3 class=\"text-center\"\u003ECompliance and Certifications\u003C\u002Fh3\u003E\u003Cdiv class=\"sert__items clearfix\"\u003E\u003Cdiv class=\"sert-item col-md-3\"\u003E\u003Cdiv class=\"sert-item__img\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fimg\u002FSOC2-Logo_Revised@2x-0f84ee2ef4.png\" alt=\"SOC 2 Logo\" width=\"141\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item__text\"\u003EAuth0 is SOC 2 Type II certified - an independent auditor has evaluated our product, infrastructure, and policies, and certifies that Auth0 complies with their stringent requirements.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item col-md-3\"\u003E\u003Cdiv class=\"sert-item__img\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fimg\u002Feu-us-shield-border@2x-0455ed7ca0.png\" alt=\"EU-US Privacy Shield Framework\" width=\"101\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item__text\"\u003EAuth0 conforms with the brand-new EU-US Privacy Shield Framework for regulating privacy in data flows between the European Union and the United States. This Framework replaces the EU-US Safe Harbor Framework repudiated in 2015.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item col-md-3\"\u003E\u003Cdiv class=\"sert-item__img\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fimg\u002Fhipaa-logo@2x-d99da7c64e.png\" alt=\"HIPAA Logo\" width=\"250\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item__text\"\u003EAuth0 offers HIPAA BAA agreements to companies in the healthcare industry that must comply with HIPAA regulations for safeguarding patient privacy and sensitive health information.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item col-md-3\"\u003E\u003Cdiv class=\"sert-item__img\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fimg\u002FOpenID_Certified@2x-5fd6453603.png\" alt=\"We are OpenID Certified\" width=\"210\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sert-item__text\"\u003EAuth0 conforms to the OpenID Connect protocol, and our products are certified by the OpenID Foundation, of which we are active members. We strive to use open standards and specifications to deliver excellent interoperability for our customers.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"practice\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3 class=\"text-center\"\u003EPractice What We Preach\u003C\u002Fh3\u003E\u003Cp class=\"section-subheader\"\u003EIt isn't enough to integrate security features into the product itself. Auth0 runs its business using the most up-to-date and effective security procedures, including:\u003C\u002Fp\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cul class=\"avialability__list\"\u003E\u003Cli\u003EThoroughly documented policies and procedures - complying with SOC2 certification requirements.\u003C\u002Fli\u003E\u003Cli\u003ERegular, in-depth security training for all employees.\u003C\u002Fli\u003E\u003Cli\u003EBackground checks and confidentiality agreements for all employees who access Auth0 systems or who might come into contact with customer data.\u003C\u002Fli\u003E\u003Cli\u003ESSO to all systems using a single Auth0 verified identity, with mandatory MFA for this identity. Auth0 does everything it can to avoid systems that authenticate using only passwords without MFA.\u003C\u002Fli\u003E\u003Cli\u003EMandatory full-disk encryption for all employee laptops and development systems.\u003C\u002Fli\u003E\u003Cli\u003EFormal change control and configuration management following the most stringent and up-to-date secure operational practices - version controlled, traceable, and audited.\u003C\u002Fli\u003E\u003Cli\u003EIndependent penetration testing and code audits several times per year, bringing real-world expertise and insight to bear in validating the security of Auth0's implementations and procedures.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-md-6\"\u003E\u003Cul class=\"avialability__list\"\u003E\u003Cli\u003EA well-regarded \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fwhitehat\"\u003Ewhite hat security reporting program\u003C\u002Fa\u003E with rewards and recognition for reported vulnerabilities. Contact Auth0's security team directly at \u003Ca href=\"mailto:security@auth0.com\"\u003Esecurity@auth0.com\u003C\u002Fa\u003E.\u003Cp\u003E\u003Ca class=\"btn btn-default btn-md download-pgp\" href=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fresources\u002Fauth0-security-pgp-2c49276d04.asc\" rel=\"external\"\u003EDownload our PGP key\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fli\u003E\u003Cli\u003EComprehensive logging, auditing, and intrusion detection for both product and infrastructure events, machine learning analytics for anomaly detection, and automated tools running around the clock and around the world - all backed by the sharp eyes of our security and DevOps teams.\u003C\u002Fli\u003E\u003Cli\u003EWatching private security mailing lists and alerting systems for threat intelligence - quickly responding to and mitigating potential security issues for our infrastructure and customers, and actively participating in the security research community.\u003C\u002Fli\u003E\u003Cli\u003EAn incident response plan to handle those worst-case scenarios - intrusions and security breaches, DDoS attacks, or any other issue. Auth0 can call upon advanced forensics specialists to help put a lid on the damage and safeguard our customers, should something slip through Auth0's defenses.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"sec-team\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EA Team of Specialists\u003C\u002Fh3\u003E\u003Cdiv class=\"media\"\u003E\u003Cdiv class=\"media__text\"\u003E\u003Cp\u003E Why are we so dedicated to leaving no stone unturned in protecting our customers? It's in our DNA. Auth0 was founded and built by some of the foremost security and identity experts in the world - \u003Cstrong\u003EMatias Woloski, Eugenio Pace, and Jared Hanson. \u003C\u002Fstrong\u003EMatias and Eugenio have implemented federated identity projects for Fortune 500 companies, and are \u003Ca href=\"http:\u002F\u002Fwww.amazon.com\u002FClaims-Based-Identity-Control-Patterns-Practices\u002Fdp\u002F0735640599\" target=\"_blank\"\u003Epublished authors\u003C\u002Fa\u003E. Jared is the author of the most popular authentication framework for Node.js: \u003Ca href=\"http:\u002F\u002Fpassportjs.org\u002F\" target=\"_blank\"\u003Epassport.js\u003C\u002Fa\u003E. \u003C\u002Fp\u003E\u003Cp\u003EAuth0's Head of Security, \u003Cstrong\u003EEugene Kogan\u003C\u002Fstrong\u003E, holds multiple certifications (CISSP, CEH) and has nearly two decades in the field. He previously worked on infrastructure security and analysis for organizations such as AT&T, Amazon.com, and the US Department of Defense. Auth0's engineering team is selected and hired based on demonstrating a deep knowledge of identity and information security principles. No wonder we're so committed to our customers' security!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cimg class=\"media__img\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fsecurity\u002Fimg\u002Fteam@2x-d1180c6535.png\" alt=\"Auth0's specialists team\" width=\"428\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (signupFormApp) {pug_html = pug_html + "\u003Cdiv class=\"signup page-content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"col-sm-6 pull-right\"\u003E\u003Cdiv id=\"signup-app\"\u003E" + (null == (pug_interp = signupFormApp) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6 pull-left\"\u003E\u003Cdiv class=\"signup-header\"\u003E\u003Ca href=\"\u002F\" target=\"_blank\"\u003E\u003Cimg class=\"auth0-logo\" src=\"https:\u002F\u002Fcdn.auth0.com\u002Fstyleguide\u002Fcomponents\u002F1.0.8\u002Fmedia\u002Flogos\u002Fimg\u002Fbadge.svg\" alt=\"Auth0\"\u003E\u003C\u002Fa\u003E\u003Ch3\u003ETry the world’s #1 authentication-as-a-service platform for free!\u003C\u002Fh3\u003E\u003Cp\u003ELet Auth0 handle the complexities of secure authentication so you can focus on building your app!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"signup-description\"\u003E\u003Ch2\u003EStart for free and save time with Auth0!\u003C\u002Fh2\u003E\u003Cul class=\"signup-benefits\"\u003E\u003Cli class=\"icon-budicon-470\"\u003E7,000 free active users & unlimited logins\u003C\u002Fli\u003E\u003Cli class=\"icon-budicon-470\"\u003EPasswordless & TouchID Login\u003C\u002Fli\u003E\u003Cli class=\"icon-budicon-470\"\u003ELock for Web, iOS & Android\u003C\u002Fli\u003E\u003Cli class=\"icon-budicon-470\"\u003EUp to 2 social identity providers\u003C\u002Fli\u003E\u003Cli class=\"icon-budicon-470\"\u003ERules & Webtask.io subscription\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"try-button\"\u003E\u003Cdiv class=\"btn btn-success btn-lg\"\u003ETRY AUTH0 FOR FREE\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003EBuilt for developers\u003Cbr \u002F\u003EPowered for the enterprise\u003C\u002Fh3\u003E\u003Cdiv class=\"signup-clients\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-atlassian-color-7830cc62b0.svg\" alt=\"Atlassian\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-hmh-color-ab0a4583c1.svg\" alt=\"Houghton Mifflin Harcourt\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fcustomers\u002Fimg\u002Flogo-harvard-medical-school-a8eadc1508.svg\" alt=\"Harvard Medical School\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-nvidia-color-6b3d90dfc2.svg\" alt=\"Nvidia\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"signupFormApp" in locals_for_with?locals_for_with.signupFormApp:typeof signupFormApp!=="undefined"?signupFormApp:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"terms-page simple-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci class=\"icon-budicon-433\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003E Terms of Service\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ELast update: May 4, 2016\u003C\u002Fh3\u003E\u003Cp\u003EAuth0®, Inc. (\"Auth0®,\" \"we,\" \"us,\" or \"our\") owns and operates the website located at auth0.com (the \"Site\"). Please read these Terms of Service carefully. These Terms of Service state the terms and conditions under which you may use our services which are available through the Site (the \"Services\"). By using the Site, or any Services of Auth0®, you acknowledge that you have read, understood, and agree to be legally bound by these Terms of Service and you represent and warrant that you are at least 18 years old. If you are accepting these Terms of Service on behalf of a company or other legal entity, you represent that you have the authority to bind such entity to the terms and conditions set forth herein. If you do not have such authority, or if you do not agree to any of these terms, then you are not permitted to use the Services. These Terms of Service may be updated by us from time to time without notice to you. If we change any material terms of these Terms of Service, we will message you at the email address(es) registered to your account as well as notify you at your next login to your account. Unless you cancel your subscription upon receiving any of these notifications, continued use of the Services or Site will be deemed acceptance of the updated Terms of Service.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EThe Services; End User Authentication Data\u003C\u002Fh3\u003E\u003Cp\u003EThrough the Site, we offer authentication Services on a subscription basis (\"Subscription\") to our customers. As part of the Services, Auth0® collects and\u002For receives End User Authentication Data from our customer’s end users. Our customers own the End User Authentication Data from their own end users. You hereby grant us an irrevocable, non-exclusive, worldwide, royalty-free, sublicensable, transferable license to use your End User Authentication Data as reasonably necessary for us to provide the Services.\u003C\u002Fp\u003E\u003Cp\u003EThe features and functionality of the Services available to you will be based on the Subscription package you choose. We reserve the right to change, suspend, or discontinue all or any part of the Services and\u002For the Subscription packages at any time without prior notice or liability. If we materially change any part of the Services and\u002For the Subscription packages we will message you at the email address(es) registered to your account as well as notify you at your next login to your account.  The notice will designate a reasonable period of time after which the new terms will take effect.\u003C\u002Fp\u003E\u003Cp\u003EAny new features that augment or enhance the current Services and\u002For the Subscription packages, including the release of new tools and resources, shall be subject to the Terms of Service. Your continued use of the Services after any such changes shall constitute your consent to such changes. You may access your End User Authentication Data via an Application Program Interface (“API”) and these Terms of Service govern your use of the API. We reserve the right to change, suspend, or discontinue your access to the API (or any part thereof) without prior notice or liability.\u003C\u002Fp\u003E\u003Cp\u003EWe may, from time to time, require you to install software updates provided by us or by third parties to continue accessing the Services.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ERegistration\u003C\u002Fh3\u003E\u003Cp\u003EYou are welcome to browse the Site as a visitor without providing any information to us. If you would like to use the Services, you will need to register as a user (a \"Registered User\") by creating an account. During the registration process, you will have to provide either a valid email address and password, or alternatively credentials to authenticate with a third party federated identity provider with whom you have an established account (e.g. GitHub, Google, Microsoft) which will in turn with your permission provide us the email address associated with that account. You will also be asked to provide a unique identifier for your account domain. You may also invite individuals who are authorized and permitted by you to use the Services (\"Authorized Users\") through your dashboard after you login to your account at https:\u002F\u002Fauth0.com. If you provide a list of Authorized Users to Auth0®, Auth0® will enable such Authorized Users to use the Services using the company credentials. You will be responsible to Auth0® for any and all acts or omissions of the Authorized Users. You represent and warrant that all registration information you submit is truthful and accurate and you will maintain the accuracy of such information. You are solely responsible for the confidentiality of your user account, as well as for its use and misuse. You will promptly inform us of any need to deactivate a user name or password. We reserve the right to delete or change your user name and\u002For password at any time and for any reason.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EFees, Subscription Period, and Automatic Renewal\u003C\u002Fh3\u003E\u003Cp\u003EThe Services are provided to you for such period as agreed by the parties and set forth in an invoice (the \"Subscription Period\"), at our then-current pricing as set forth at https:\u002F\u002Fauth0.com\u002Fpricing, or such other pricing as agreed by the parties and set forth in an invoice (the \"Fees\").\u003C\u002Fp\u003E\u003Cp\u003EYou agree to pay any applicable Fees. We may use a third party service provider (\"Third Party\") to process your payment in connection with your use of the Services. You warrant and represent that you are the valid owner or an authorized user, of the credit card you provide to such Third Party, and that all credit information is accurate.\u003C\u002Fp\u003E\u003Cp\u003EIt is important to note that when you sign up to use the Services, your Subscription Period will automatically renew on an annual basis (or such other renewal period as agreed upon in an invoice) until you cancel it. You may cancel your Subscription Period at any time by deleting your account through your dashboard after you login to your account at https:\u002F\u002Fauth0.com and the cancellation will take effect at the end of the current Subscription Period subject to the terms and conditions set forth in the Section titled \"Effect of Termination.\" If you do not cancel, then your Subscription Period will automatically renew.\u003C\u002Fp\u003E\u003Cp\u003EUnless otherwise agreed by the parties in an invoice, Fees shall automatically be adjusted upon each renewal of your Subscription Period to our then-current pricing. In addition, we reserve the right to change the Fees, or institute new or additional Fees, at any time upon notice to you.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EUse of Personal Data\u003C\u002Fh3\u003E\u003Cp\u003EYour use of the Site and\u002For the Services may involve the transmission to us of your personal data and\u002For the personal data of your end users (\"Personal Data\"). Our policies with respect to the collection and use of such Personal Data are governed according to our Privacy Policy (located at https:\u002F\u002Fauth0.com\u002Fprivacy, which is hereby incorporated by reference in its entirety.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ELicense Grant; Restrictions on Use\u003C\u002Fh3\u003E\u003Cul\u003E\u003Cli\u003ESubject to the terms and conditions set forth herein, Auth0® hereby grants to you and to the Authorized Users (if any) during the applicable Subscription Period, a limited, non-exclusive, non-transferable license, without the right to grant sublicenses, to use the Services.\u003C\u002Fli\u003E\u003Cli\u003EYou will not (and shall ensure that any Authorized Users or third parties do not): (i) reverse engineer, decompile, disassemble, or otherwise attempt to discern the source code or interface protocols of the Services; (ii) modify, adapt, or translate the Services; (iii) make any copies of the Auth0® Intellectual Property (as defined below); (iv) resell, distribute, or sublicense the Services; (v) make the Services available on a \"service bureau\" basis; (vi) remove or modify any proprietary marking or restrictive legends placed on the Auth0® Intellectual Property; (vii) use the Services in violation of any applicable laws or for any purpose not specifically permitted in these Terms of Service; or (viii) introduce into the Services any software, virus, worm, \"back door,\" Trojan Horse, or similar harmful code. You may not use or access the Services if you are our direct competitor, except with our prior written consent. In addition, you may not access the Services for purposes of monitoring performance or functionality, or for any other benchmarking or competitive purposes. In addition to the terms and conditions contained herein, you agree to abide by Auth0®’s Community Guidelines set forth below.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EAuth0® Intellectual Property\u003C\u002Fh3\u003E\u003Cp\u003EAs between Auth0® and you, Auth0® shall own all right, title, and interest in and to (i) the Services including, without limitation, all source code, object code, operating instructions, and interfaces developed for or relating to the same; (ii) all modifications, enhancements, revisions, changes, copies, partial copies, translations, compilations, improvements, and derivative works of the foregoing, and all intellectual property rights therein; and (iii) any other materials available on the Site and\u002For the Services that are provided by or on behalf of Auth0® and all intellectual property rights therein (collectively, the “Auth0® Intellectual Property”). Except as expressly permitted in these Terms of Service, you have no rights in or to the Auth0® Intellectual Property.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EUser Generated Content\u003C\u002Fh3\u003E\u003Cp\u003EYou may post and\u002For create content through the Services (hereinafter, \"User Generated Content\"). We cannot and do not review it all--we may act as a passive conduit for distribution of the User Generated Content. That said, we may remove User Generated Content that does not adhere to our Community Guidelines, or that is offensive or otherwise unacceptable to us in our sole discretion. Remember, once you submit User Generated Content through the Services, including any Personal Data, it may be accessible by other users. You retain all copyrights and other intellectual property rights in and to the User Generated Content. However, you hereby grant us an irrevocable, non-exclusive, worldwide, royalty-free, sublicensable, transferable license to use your User Generated Content as reasonably necessary for us to provide the Services.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ECommunity Guidelines\u003C\u002Fh3\u003E\u003Cp\u003EBy accessing and\u002For using the Site or the Services, you hereby agree that:\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003EYou will not use the Site or the Services for any unlawful purpose;\u003C\u002Fli\u003E\u003Cli\u003EYou will not upload, post, e-mail, transmit, or otherwise make available any content that:\u003Cul\u003E\u003Cli\u003Einfringes any copyright, trademark, right of publicity, or other proprietary rights of any person or entity; or\u003C\u002Fli\u003E\u003Cli\u003Eis threatening, tortious, defamatory, libelous, indecent, obscene, pornographic, sexually explicit, invasive of another’s privacy, or promotes extreme violence or cruelty to animals, or contains hate speech (i.e., speech that attacks or demeans a group based on race or ethnic origin, religion, disability, gender, age, veteran status, and\u002For sexual orientation\u002Fgender identity; or\u003C\u002Fli\u003E\u003Cli\u003Ediscloses any sensitive information about another person, including that person’s e-mail address, postal address, phone number, credit card information, or any similar information.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fli\u003E\u003Cli\u003EYou will not \"stalk\" or otherwise harass another user of the Services;\u003C\u002Fli\u003E\u003Cli\u003EYou will not impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity; and\u003C\u002Fli\u003E\u003Cli\u003EYou will not interfere with or attempt to interrupt the proper operation of the Services through the use of any virus, device, information collection or transmission mechanism, software or routine, or access or attempt to gain access to any data, files, or passwords related to the Services through hacking, password or data mining, or any other means.\u003C\u002Fli\u003E\u003Cli\u003EYou will not abuse or send excessively frequent requests to our Services via the API.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EUnsolicited Information\u003C\u002Fh3\u003E\u003Cp\u003EBy submitting any unsolicited information and materials, including comments, ideas, questions, designs, and other similar communications (collectively, \"Unsolicited Information\") to us, you agree to be bound by the following terms and conditions. If you do not agree with these terms and conditions, you should not provide us with any Unsolicited Information. All Unsolicited Information will be considered NON-CONFIDENTIAL and NON-PROPRIETARY. We, or any of our affiliates, may use such communication or material for any purpose whatsoever, including, but not limited to, reproduction, disclosure, transmission, publication, broadcast, and further posting. Further, we and our affiliates are free to use any ideas, concepts, know-how, or techniques contained in any communication or material you send to us for any purpose whatsoever, including, but not limited to, developing, manufacturing, and marketing products. By submitting any Unsolicited Information, you are granting us a perpetual, royalty-free and irrevocable right and license to use, reproduce, modify, adapt, publish, translate, distribute, transmit, publicly display, publicly perform, sublicense, create derivative works from, transfer and sell such Unsolicited Information and to use your name and other identifying information in connection with such Unsolicited Information.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EDisclaimer and Limitation of Liability\u003C\u002Fh3\u003E\u003Cp\u003EYOU ACKNOWLEDGE AND AGREE THAT THE SITE AND THE SERVICES PROVIDE CONNECTORS THAT ALLOW YOU TO INTERACT WITH APPLICATIONS CREATED BY YOU OR ANY THIRD PARTY. AUTH0 MAY OR MAY NOT HAVE ANY CONTRACTUAL RELATIONSHIP WITH SUCH THIRD PARTIES AND AUTH0 WILL USE COMMERCIALLY REASONABLE EFFORTS TO RESOLVE ANY CONNECTIVITY ISSUES THAT MAY ARISE FROM CHANGES MADE BY SUCH THIRD PARTIES. IN NO EVENT SHALL AUTH0, ITS AFFILIATES, SUBSIDIARIES, OR ITS OR THEIR OFFICERS, DIRECTORS, EMPLOYEES OR AGENTS (COLLECTIVELY THE \"AUTH0 PARTIES\") BE LIABLE OR RESPONSIBLE FOR ANY BROKEN CONNECTIONS OR CHANGES TO THIRD PARTY APPLICATIONS.\u003C\u002Fp\u003E\u003Cp\u003EYOU ACKNOWLEDGE AND AGREE THAT THE SITE AND THE SERVICES, INCLUDING, WITHOUT LIMITATION, ALL CONTENT, AUTH0 INTELLECTUAL PROPERTY, FUNCTIONS AND OTHER MATERIALS, ARE PROVIDED \"AS IS\" AND \"AS AVAILABLE.\" AUTH0 DOES NOT MAKE AND HEREBY DISCLAIMS ANY AND ALL WARRANTIES EXPRESS, IMPLIED OR STATUTORY, INCLUDING, WITHOUT LIMITATION, ANY WARRANTIES OF TITLE, MERCHANTABILITY, NONINFRINGEMENT, FITNESS FOR A PARTICULAR PURPOSE, AVAILABILITY, ERROR-FREE OR UNINTERRUPTED OPERATION, SECURITY OF HOSTED DATA, AND ANY WARRANTIES ARISING FROM A COURSE OF DEALING, COURSE OF PERFORMANCE OR USAGE OF TRADE. AUTH0 SHALL NOT BE LIABLE FOR ANY DAMAGES TO YOUR COMPUTER EQUIPMENT OR OTHER PROPERTY ON ACCOUNT OF YOUR ACCESS TO OR USE OF THE SERVICES.\u003C\u002Fp\u003E\u003Cp\u003EIN NO EVENT SHALL AUTH0 BE LIABLE FOR SPECIAL, INDIRECT, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, INCLUDING WITHOUT LIMITATION LOST PROFITS, REVENUES OR SAVINGS, OR LOSS OF DATA, ARISING OUT OF OR RELATING TO THIS AGREEMENT, EVEN IF AUTH0 HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES IN ADVANCE. IN NO EVENT SHALL THE TOTAL CUMULATIVE LIABILITY OF AUTH0 FOR DIRECT DAMAGES ARISING UNDER THESE TERMS OF USE OR RELATING THERETO, EXCEED, THE TOTAL FEES PAID BY YOU IN THE ONE (1) MONTH IMMEDIATELY PRECEDING SUCH CLAIM. BECAUSE SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR NEGLIGENCE, CONSEQUENTIAL, INCIDENTAL OR OTHER DAMAGES, IN SUCH JURISDICTIONS AUTH0 LIABILITY IS LIMITED TO THE GREATEST EXTENT PERMITTED BY APPLICABLE LAW.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EExternal Sites\u003C\u002Fh3\u003E\u003Cp\u003EThe Site and the Services may contain links to third-party websites (\"External Sites\"), but Auth0® does not endorse and is not responsible for the content of any such External Sites. Please refer to the terms of use and privacy policies of the External Sites for more information.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EIndemnification\u003C\u002Fh3\u003E\u003Cp\u003EYou agree to defend, indemnify, and hold Auth0® harmless from and against any and all claims, actions, or demands and relating costs, damages and liability (including, without limitation, reasonable attorneys’ fees) arising or resulting from: (i) your breach of these Terms of Service; (ii) your access to, use, or misuse of the Site or the Services; (iii) any User Generated Content provided through your account; and (iv) your violation of any third-party right, including without limitation any intellectual property, or privacy right.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ECompliance with Applicable Laws\u003C\u002Fh3\u003E\u003Cp\u003EThe Site and the Services are based in the United States. We make no claims concerning whether the Site, the Services, or the Auth0® Intellectual Property may be downloaded, viewed, or be appropriate for use outside of the United States. If you access the Site, the Services or the Auth0® Intellectual Property from outside of the United States, you do so at your own risk. Whether inside or outside of the United States, you are solely responsible for ensuring compliance with the laws of your specific jurisdiction.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EExport Control\u003C\u002Fh3\u003E\u003Cp\u003EYou may not use or otherwise export or re-export the Service except as authorized by United States law and the laws of the jurisdiction(s) in which the Service was obtained. In particular, but without limitation, the Service may not be exported or re-exported (a) into any U.S. embargoed countries or (b) to anyone on the U.S. Treasury Department's list of Specially Designated Nationals or the U.S. Department of Commerce Denied Person's List or Entity List. By using the Service, You represent and warrant that You are not located in any such country or on any such list. You also agree that You will not use the Service for any purposes prohibited by United States law.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ETerm and Termination\u003C\u002Fh3\u003E\u003Cp\u003E\u003Cul\u003E\u003Cli\u003EThese Terms of Service shall be effective from the time you begin using the Site, or any Services of Auth0®, and shall continue until terminated by either party as set forth herein (\"Term\").\u003C\u002Fli\u003E\u003Cli\u003EWe may modify these Terms of Service, without penalty or liability, at any time, for any or no reason, upon thirty (30) days written notice to you. We may terminate and\u002For suspend your registration or your use of the Services immediately if you violate the terms and conditions of these Terms of Service.\u003C\u002Fli\u003E\u003Cli\u003EUpon the termination of these Terms of Service and\u002For the termination or cancellation of your Subscription Period: (i) all rights and licenses granted hereunder will immediately cease; (ii) you will immediately cease all use and access of the Services and other materials provided in connection with the Services, including, without limitation, any and all of our software and software code; and (iii) you shall immediately pay Auth0® all fees dues through and including the effective date of termination. YOU AGREE THAT AUTH0 WILL NOT BE LIABLE TO YOU OR ANY OTHER PARTY FOR ANY TERMINATION OF YOUR ACCESS TO THE SERVICES IN ACCORDANCE WITH THESE TERMS OF SERVICE.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ECopyright Complaints\u003C\u002Fh3\u003E\u003Cp\u003EIf you believe the Site contains any content that infringes your copyright, please contact our Copyright Agent, as detailed below, with the following information:\u003Cul\u003E\u003Cli\u003EAn electronic or physical signature of the person authorized to act on behalf of the owner of the copyright interest;\u003C\u002Fli\u003E\u003Cli\u003EA description of the copyrighted work that you claim has been infringed;\u003C\u002Fli\u003E\u003Cli\u003EA description of where the material that you claim is infringing is located on the Site;\u003C\u002Fli\u003E\u003Cli\u003EYour address, telephone number and email address;\u003C\u002Fli\u003E\u003Cli\u003EA statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent or the law; and\u003C\u002Fli\u003E\u003Cli\u003EA statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or duly authorized to act on the copyright owner’s behalf.\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp\u003ETo contact our Copyright Agent by regular mail, please write to:\u003C\u002Fp\u003E\u003Cp\u003E\u003C\u002Fp\u003ECopyright Agent\u003Cbr\u003EAuth0®, Inc.\u003Cbr\u003E10900 NE 8th Street, Suite 700\u003Cbr\u003EBellevue, WA, 98004\u003Cbr\u003E\u003Cp\u003ETo contact our Copyright Agent by email, please write to legal@auth0.com, with COPYRIGHT NOTICE in the subject line.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content content-last\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EMiscellaneous\u003C\u002Fh3\u003E\u003Cp\u003EIn the event that any portion of these Terms of Service is held to be invalid or unenforceable, then such portion shall be construed in accordance with the applicable law as nearly as possible to reflect the original intentions of the parties, and the remainder of these Terms of Service shall remain in full force and effect. This section, the section entitled Auth0® Intellectual Property, Indemnification, Disclaimer and Limitation of Liability and Effect of Termination shall survive the termination of these Terms of Service. You may not assign these Terms of Service. No waiver shall be effective unless in writing. Neither the course of conduct between parties nor trade practice shall act to modify any provision of these Terms of Service. These Terms of Service shall be governed by and construed in accordance with the laws of the State of Washington. Except for proceedings commenced by Auth0® to protect its intellectual property or confidential information which may be brought in any court of competent jurisdiction, the parties mutually agree that any and all disputes arising hereunder shall be resolved exclusively by state or federal courts located in the State of Washington. These Terms of Service contain the entire agreement of the parties concerning its subject matter, and supersede all existing agreements and all other oral, written or other communication between the parties concerning the subject matter.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"whitehat-page simple-page\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ci class=\"icon-banner icon-budicon-288\"\u003E\u003C\u002Fi\u003E\u003Ch1\u003EResponsible Disclosure Program\u003Cbr\u003Eand Security Researcher Hall of Fame\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ELast update: November 18, 2015\u003C\u002Fh3\u003E\u003Cp\u003EAt Auth0, Inc., we take security of our users’ data very seriously. If you have discovered or believe you have discovered potential security vulnerabilities in an Auth0 Service, we encourage you to disclose your discovery to us as quickly as possible in accordance with this \u003Cem\u003E Responsible Disclosure Program\u003C\u002Fem\u003E.\u003C\u002Fp\u003E\u003Cp\u003EWe will work with you to validate and respond to security vulnerabilities that you report to us. Because public disclosure of a security vulnerability could put the entire Auth0 community at risk, we require that you keep such potential vulnerabilities confidential until we are able to address them. We will not take legal action against you or suspend or terminate your access to any Auth0 Services, provided that you discover and report security vulnerabilities in accordance with this \u003Cstrong\u003EResponsible Disclosure Program\u003C\u002Fstrong\u003E. Auth0 reserves all of its legal rights in the event of any noncompliance.\u003C\u002Fp\u003E\u003Cp\u003ECapitalized terms not defined in this \u003Cstrong\u003EResponsible Disclosure Program\u003C\u002Fstrong\u003E shall have the meaning set forth in our" + (pug.escape(null == (pug_interp = " ") ? "" : pug_interp)) + "\u003Ca href=\"\u002Fterms\"\u003ETerms of Use\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EDiscovering Security Vulnerabilities\u003C\u002Fh3\u003E\u003Cp\u003EWe encourage responsible security research on the Auth0 services and products, including Webtask. We allow you to conduct vulnerability research and testing on the Auth0 Services to which you have authorized access. In no event shall your research and testing involve:\u003Col\u003E\u003Cli\u003EAccessing, or attempting to access, accounts or data that does not belong to you or your Authorized Users,\u003C\u002Fli\u003E\u003Cli\u003EAny attempt to modify or destroy any data,\u003C\u002Fli\u003E\u003Cli\u003EExecuting, or attempting to execute, a denial of service attack,\u003C\u002Fli\u003E\u003Cli\u003ESending, or attempting to send, unsolicited or unauthorized email, spam or other forms of unsolicited messages,\u003C\u002Fli\u003E\u003Cli\u003ETesting third party websites, applications or services that integrate with the Auth0 Services,\u003C\u002Fli\u003E\u003Cli\u003EPosting, transmitting, uploading, linking to, sending or storing malware, viruses or similar harmful software, or otherwise attempting to interrupt or degrade the Auth0 services, and\u003C\u002Fli\u003E\u003Cli\u003EAny activity that violates any applicable law.\u003C\u002Fli\u003E\u003C\u002Fol\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EReporting Security Vulnerabilities\u003C\u002Fh3\u003E\u003Cp\u003EIf you believe you have discovered a security vulnerability issue, please share the details with Auth0 by sending an email to \u003Ca href=\"mailto:whitehat@auth0.com\"\u003Ewhitehat@auth0.com\u003C\u002Fa\u003E. In reporting a potential security vulnerability issue you shall include the following:\u003Cul\u003E\u003Cli\u003EAn adequate description and information regarding the security vulnerability that will allow Auth0 to reproduce your steps and the issue,\u003C\u002Fli\u003E\u003Cli\u003EYour email address\u003C\u002Fli\u003E\u003Cli\u003EYour name and Twitter handle as you would like it to appear in our \u003Cstrong\u003ESecurity Researcher Hall of Fame\u003C\u002Fstrong\u003E (if selected).\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003Cp\u003EAuth0 will acknowledge receipt of your report within 24 hours, provide you with an estimated timetable for resolution of the vulnerability, notify you when the vulnerability is fixed, and, with your permission, publicly acknowledge your responsible disclosure.\u003C\u002Fp\u003E\u003Cp\u003EEmail communication between you and Auth0, including without limitation, emails you send to Auth0 reporting a potential security vulnerability, should not contain any of your proprietary information. The contents of all email communication you send to Auth0 shall be considered non-proprietary. Auth0, or any of its affiliates, may use such communication or material for any purpose whatsoever, including, but not limited to, reproduction, disclosure, transmission, publication, broadcast, and further posting. Further, Auth0 and its affiliates are free to use any ideas, concepts, know-how, or techniques contained in any communication or material you send to Auth0 for any purpose whatsoever, including, but not limited to, fixing, developing, manufacturing, and marketing products. By submitting any information, you are granting Auth0 a perpetual, royalty-free and irrevocable right and license to use, reproduce, modify, adapt, publish, translate, distribute, transmit, publicly display, publicly perform, sublicense, create derivative works from, transfer and sell such information.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003EIssues not to Report\u003C\u002Fh3\u003E\u003Cp\u003EThe following is a partial list of issues that we ask for you \u003Cstrong\u003Enot\u003C\u002Fstrong\u003E to report, unless you believe there is an actual vulnerability:\u003Cul\u003E\u003Cli\u003ECSRF on forms that are available to anonymous users\u003C\u002Fli\u003E\u003Cli\u003EDisclosure of known public files or directories (e.g. robots.txt)\u003C\u002Fli\u003E\u003Cli\u003EDomain Name System Security Extensions (DNSSEC) configuration suggestions\u003C\u002Fli\u003E\u003Cli\u003EBanner disclosure on common\u002Fpublic services\u003C\u002Fli\u003E\u003Cli\u003EHTTP\u002FHTTPS\u002FSSL\u002FTLS security header configuration suggestions\u003C\u002Fli\u003E\u003Cli\u003ELack of Secure\u002FHTTPOnly flags on non-sensitive cookies\u003C\u002Fli\u003E\u003Cli\u003ELogout Cross-Site Request Forgery (logout CSRF)\u003C\u002Fli\u003E\u003Cli\u003EPhishing or Social Engineering Techniques\u003C\u002Fli\u003E\u003Cli\u003EPresence of application or web browser 'autocomplete' or 'save password' functionality\u003C\u002Fli\u003E\u003Cli\u003ESender Policy Framework (SPF) configuration suggestions\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"content content-last\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch3\u003ERecognition\u003C\u002Fh3\u003E\u003Cp\u003EResearchers that responsibly disclose in accordance with this \u003Cstrong\u003EResponsible Disclosure Program\u003C\u002Fstrong\u003E are eligible for inclusion in our \u003Cstrong\u003ESecurity Researcher Hall of Fame\u003C\u002Fstrong\u003E. Whether or not a security vulnerability report is in compliance with this \u003Cstrong\u003EResponsible Disclosure Program\u003C\u002Fstrong\u003E and a Researcher is eligible for inclusion in our \u003Cstrong\u003EHall of Fame\u003C\u002Fstrong\u003E is in our sole discretion. We reserve the right to cancel this recognition program at any time without notice. Auth0 does not compensate researchers for identifying potential or confirmed security vulnerabilities. Any requests for monetary compensation or any other type of consideration will be deemed in violation of this \u003Cstrong\u003EResponsible Disclosure Program\u003C\u002Fstrong\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"banner-hall banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ca name=\"hall-of-fame\"\u003E\u003C\u002Fa\u003E\u003Ci class=\"icon-budicon-544 icon-banner\"\u003E\u003C\u002Fi\u003E\u003Ch2\u003EResearcher Hall of Fame\u003C\u002Fh2\u003E\u003Cp\u003EAuth0 thanks the following researchers that have helped keep the Auth0 services safe by reporting security vulnerability responsibly in accordance with our Responsible Disclosure Program:\u003C\u002Fp\u003E\u003Cdiv class=\"hall-users\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cstrong class=\"icon-budicon-300\"\u003E\u003C\u002Fstrong\u003E\u003Cspan class=\"username\"\u003ETim McLean\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"\u002F\u002Ftwitter.com\u002FMcLean0\"\u003E@McLean0\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-1-22f1b11c39.jpeg\"\u003E\u003Cspan class=\"username\"\u003ENabin kc\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002FN_Cnew\"\u003E@N_Cnew\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-2-c3753a0e26.jpeg\"\u003E\u003Cspan class=\"username\"\u003EManjesh S\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002FManjesh24\"\u003E@Manjesh24\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-3-eafc980a07.jpeg\"\u003E\u003Cspan class=\"username\"\u003ESalman Khan\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002FSalmanKhanChamp\"\u003E@SalmanKhanChamp\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-4-47a4ead854.jpeg\"\u003E\u003Cspan class=\"username\"\u003ESukhmeet Singh\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002FMadGuyyy\"\u003E@MadGuyyy\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-5-d9863328aa.png\"\u003E\u003Cspan class=\"username\"\u003EKatelyn Sills\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002Fkatelyn_sills\"\u003E@katelyn_sills\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-6-93c53b87f1.jpeg\"\u003E\u003Cspan class=\"username\"\u003EBritton Reeder-Thompson\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002Fbrittonrt\"\u003E@brittonrt\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-7-8aa0317591.png\"\u003E\u003Cspan class=\"username\"\u003EDavid Dworken\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002Fddworken\"\u003E@ddworken\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cstrong class=\"icon-budicon-300\"\u003E\u003C\u002Fstrong\u003E\u003Cspan class=\"username\"\u003EJacek Sowinski\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002FtheDzaku\"\u003E@theDzaku\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-8-ae23f88642.jpeg\"\u003E\u003Cspan class=\"username\"\u003ETanuj Jane\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"http:\u002F\u002Ftwitter.com\u002Ftanujjane\"\u003E@tanujjane\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cstrong class=\"icon-budicon-300\"\u003E\u003C\u002Fstrong\u003E\u003Cspan class=\"username\"\u003ESatheesh Raj\u003C\u002Fspan\u003E\u003Ca href=\"https:\u002F\u002Fwww.facebook.com\u002FUaA3ks1\"\u003ESatheesh Raj\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-9-359931cfa6.png\"\u003E\u003Cspan class=\"username\"\u003ERyan Pendergast\u003C\u002Fspan\u003E\u003Ca href=\"http:\u002F\u002Ftwitter.com\u002Frynop\"\u003E@rynop\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cstrong class=\"icon-budicon-300\"\u003E\u003C\u002Fstrong\u003E\u003Cspan class=\"username\"\u003EHamza Grindi\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"https:\u002F\u002Ftwitter.com\u002FHamza_G0\"\u003E@Hamza_G0\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cstrong class=\"icon-budicon-300\"\u003E\u003C\u002Fstrong\u003E\u003Cspan class=\"username\"\u003EAmine HM\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-10-6a24ea5091.jpg\"\u003E\u003Cspan class=\"username\"\u003EKamil Sevi\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"https:\u002F\u002Ftwitter.com\u002Fkamilsevi\"\u003E@kamilsevi\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwhitehat\u002Fimg\u002Favatar-11-04720f021f.jpg\"\u003E\u003Cspan class=\"username\"\u003EKartik Singh\u003C\u002Fspan\u003E\u003Ca class=\"twitter\" href=\"https:\u002F\u002Ftwitter.com\u002Fkartik0816\"\u003E@kartik0816\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;





pug_html = pug_html + "\u003Cdiv class=\"why-page page-content\"\u003E\u003Cdiv class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Ch1\u003EWhy Auth0\u003C\u002Fh1\u003E\u003Cp\u003EIdentity made simple for Developers\u003C\u002Fp\u003E\u003Ca class=\"wistia-popover[height=720,playerColor=7b796a,width=1280] btn-play js-play-track\" href=\"\u002F\u002Ffast.wistia.net\u002Fembed\u002Fiframe\u002Ffu7ww3h1yx?popover=true\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"why-auth0-banner\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"demo-steps\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003ESave time. Be happy. Focus on what really matters.\u003C\u002Fh2\u003E\u003Cp\u003EAuthenticate and authorize apps and APIs with any identity provider running on any stack any device or cloud.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"started-steps\"\u003E\u003Cdiv class=\"number-step\"\u003E\u003Cdiv class=\"step s1\"\u003E\u003Cspan\u003E1\u003C\u002Fspan\u003E\u003Cp\u003ECreate your free developer account\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step s2\"\u003E\u003Cspan\u003E2\u003C\u002Fspan\u003E\u003Cp\u003EChoose identity providers\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step s3\"\u003E\u003Cspan\u003E3\u003C\u002Fspan\u003E\u003Cp\u003EChoose an SDK or call our API\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step s4\"\u003E\u003Cspan\u003E4\u003C\u002Fspan\u003E\u003Cp\u003EHook it up to your app or API\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-step-content start-steps\"\u003E\u003Cvideo id=\"why-video\" width=\"100%\"\u003E\u003Csource src=\"https:\u002F\u002Fembed-ssl.wistia.com\u002Fdeliveries\u002Fc76eb8f29b01c93c1a8f6122f2dc5c22da4ee517\u002Fwhyauth0-video.mp4\"\u003E\u003C\u002Fvideo\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"play-me-again\" href=\"#\"\u003E\u003Ci class=\"icon-budicon-257\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"started-bottom\"\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" target=\"_blank\" data-track=\"why-auth0-get-started\"\u003EUse Auth0 for Free\u003C\u002Fa\u003E\u003Cp\u003EOr&nbsp;\u003Ca href=\"\u002Fhow-it-works\"\u003Elearn more\u003C\u002Fa\u003E about the dashboard.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"our-mission\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003ETraditional Identity Infrastructure is Obsolete\u003C\u002Fh2\u003E\u003Cp\u003EIdentity in modern cloud-hybrid apps and APIs are radically more complex\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cnav class=\"nav-pills mobile swiper-container\"\u003E\u003Cdiv class=\"swiper-wrapper\"\u003E\u003Ca class=\"swiper-slide active\" href=\"#specialized-apps\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-374\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESpecialized Apps\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#specialized-stacks\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-661\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESpecialized Stacks\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#apps-apis\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-342\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EApps and APIs\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#multiple-devices\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EMultiple Devices\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"swiper-slide\" href=\"#on-prem\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-156\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EOn-Premises + Cloud\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cnav class=\"nav-pills no-mobile\"\u003E\u003Cdiv class=\"content\"\u003E\u003Ca class=\"active\" href=\"#specialized-apps\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-374\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESpecialized Apps\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#specialized-stacks\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-661\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESpecialized Stacks\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#apps-apis\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-342\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EApps and APIs\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#multiple-devices\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EMultiple Devices\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca href=\"#on-prem\" data-toggle=\"tab\"\u003E\u003Ci class=\"icon-budicon-156\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EOn-Premises + Cloud\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cdiv class=\"tab-content\"\u003E\u003Cdiv class=\"tab-pane active\" id=\"specialized-apps\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003EThe Old World\u003C\u002Fh3\u003E\u003Cp\u003EA few core applications running on-premises\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003EThe New World\u003C\u002Fh3\u003E\u003Cp\u003EMany specialized applications solving specific use cases\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"specialized-stacks\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003EThe Old World\u003C\u002Fh3\u003E\u003Cp\u003ESingle vendor stack\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003EThe New World\u003C\u002Fh3\u003E\u003Cp\u003EMix and match of best­-of­-breed platforms, languages, and components\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"apps-apis\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003EThe Old World\u003C\u002Fh3\u003E\u003Cp\u003EWeb applications or rich client applications\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003EThe New World\u003C\u002Fh3\u003E\u003Cp\u003EWeb applications, HTML5 single page applications, mobile native apps consuming HTTP APIs\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"multiple-devices\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003EThe Old World\u003C\u002Fh3\u003E\u003Cp\u003EDesktop PCs\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003EThe New World\u003C\u002Fh3\u003E\u003Cp\u003ELaptops, tablets, phones, and the internet of things\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"tab-pane\" id=\"on-prem\"\u003E\u003Cdiv class=\"old-new\"\u003E\u003Cdiv class=\"old-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ch3\u003EThe Old World\u003C\u002Fh3\u003E\u003Cp\u003EEverything is on-premise behind the firewall\u003C\u002Fp\u003E\u003Ci class=\"icon-budicon-435\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new-world\"\u003E\u003Cdiv class=\"on-content\"\u003E\u003Ci class=\"icon-budicon-499\"\u003E\u003C\u002Fi\u003E\u003Ch3\u003EThe New World\u003C\u002Fh3\u003E\u003Cp\u003EMix between private cloud, public cloud, and on-premise\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"makes-it-easy\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"rows\"\u003E\u003Cdiv class=\"center-title-block\"\u003E\u003Ch2\u003EAuth0 Makes it Easy\u003C\u002Fh2\u003E\u003Cp\u003EProduct attributes that simplify identity for developers, created by experts in security.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row features-list\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-333\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EExtensibility\u003C\u002Fh5\u003E\u003Cp\u003ENo more closed, checkbox-based configuration tools. Auth0 allows you to fully customize any stage of the authentication and authorization pipeline to adapt to new policies, new applications, and new platforms.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-342\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003ESimple APIs\u003C\u002Fh5\u003E\u003Cp\u003EConnecting to a robust, simple and secure HTTPS API is key to allowing seamless integration with other tools and experiences. Auth0 allows you to authenticate and authorize apps and APIs with any identity provider running on any stack on any device or cloud.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-341\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EUser-centered\u003C\u002Fh5\u003E\u003Cp\u003EIt's critical to support multiple identity providers. Auth0 makes it easy for you to give  your users the ability to authenticate with the credentials they are most familiar with. Enterprise, social, or app-specific. Auth0’s widget gives you a fully customizable, enterprise-ready login\u002Fregistration box with just a few lines of JavaScript.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-535\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EStandard Protocols\u003C\u002Fh5\u003E\u003Cp\u003EAuth0 supports industry standards such as SAML, OpenID Connect, JSON Web Token, OAuth 2.0, OAuth 1.0a, WS­-Federation and OpenID, preventing vendor lock-in.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-330\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003ESDKs\u003C\u002Fh5\u003E\u003Cp\u003EApplications are now built on a broad spectrum of technology stacks. Auth0 provides SDKs for all popular web, mobile and native platforms, allowing for deep integration with the language and stack of your preference.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-692\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EAnalytics\u003C\u002Fh5\u003E\u003Cp\u003EVisibility into users' activity means better, faster decision-making. Auth0 gives you access to powerful reporting & analytics so you can easily see what’s going on.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-640\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EMultifactor Authentication\u003C\u002Fh5\u003E\u003Cp\u003EDo you want to provide enhanced security to your mission-critical applications? With Auth0 you can enable Multifactor Authentication in minutes.\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fget-started-with-mfa\" rel=\"external\"\u003EView More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-243\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EDevice Agnostic\u003C\u002Fh5\u003E\u003Cp\u003EAre your users running your app on multiple devices? No problem. User authentication and authorization is managed consistently across the user’s device of choice.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-189\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003EScalable & Reliable\u003C\u002Fh5\u003E\u003Cp\u003EAuthentication is part of the critical path for availability. If users can't login, they can't do anything. Auth0 takes availability seriously. We offer a guaranteed SLA so you don’t have to worry, no matter how big your user base is.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-168\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003ESingle Sign On\u003C\u002Fh5\u003E\u003Cp\u003ELet your users log into multiple applications just once by following some simple steps.\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fhow-to-implement-single-sign-on\" rel=\"external\"\u003EView More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-156\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003ECloud Hybrid\u003C\u002Fh5\u003E\u003Cp\u003EAuth0 runs on-premises and in the cloud, allowing you to choose which option is right for business.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Cspan\u003E\u003Ci class=\"icon-budicon-842\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Ch5\u003ESocial Login\u003C\u002Fh5\u003E\u003Cp\u003ESimplify registrations and logins for end users allowing them to use existing login information from their favorite social network provider.\u003C\u002Fp\u003E\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fsocial-login\" rel=\"external\"\u003EView More\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"quote-partner\"\u003E\u003Ch5\u003EFrom our customers\u003C\u002Fh5\u003E\u003Cblockquote\u003E\u003Cp\u003E\"Compared to the costs and resources required to build, host, and secure a custom solution,  Auth0 was a sensible choice.”\u003C\u002Fp\u003E\u003C\u002Fblockquote\u003E\u003Cdiv class=\"author\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn2.auth0.com\u002Fblog\u002Fwhy-auth0\u002Fcris-quote.jpeg\" alt=\"Cris Concepcion Photo\"\u003E\u003Cstrong\u003ECris Concepcion,\u003C\u002Fstrong\u003E\u003Cp\u003E‎Engineering Manager at Safari Books Online\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Cdiv class=\"auth-catalog-page\"\u003E\u003Cdiv class=\"auth0-for-free clearfix\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fauth-catalog\u002Fimg\u002Ficon-active-user-97e4b42ee7.svg\" alt=\"Auth0 Active Users\"\u003E\u003Ch3\u003EGet Auth0 free for 7,000 \u003Cspan class=\"power\"\u003Eactive users \u003C\u002Fspan\u003Eper month with unlimited logins\u003C\u002Fh3\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cul class=\"text-left\"\u003E\u003Cli\u003E\u003Cspan\u003ESingle Sign On\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EPasswordless Login\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EUp to 2 Social Identity Providers\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-6\"\u003E\u003Cul class=\"text-left\"\u003E\u003Cli\u003E\u003Cspan\u003EMultifactor Authentication\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EUser Management\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan\u003EExtensibility (Run custom code on Auth\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"signup-button btn btn-success btn-lg\" href=\"javascript:void(0);\" onclick=\"signup(this)\" data-track=\"auth-catalog-bottom\"\u003ESign Up Free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"auth-catalog-page\"\u003E\u003Cdiv class=\"customers\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"h3\"\u003ESome of the companies that trust us every day\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003Ca class=\"atlassian\" href=\"\u002Fcustomers\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-atlassian-color-7830cc62b0.svg\" alt=\"Atlassian - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"pbs\" href=\"\u002Fcustomers\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-pbs-f8e4a8a436.svg\" alt=\"PBS - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"nvidia\" href=\"\u002Fcustomers\" target=\"_blank\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-nvidia-color-6b3d90dfc2.svg\" alt=\"NVIDIA - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"mozilla\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-mozilla-color-641b413898.svg\" alt=\"Mozilla - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"bluetooth-sig\" target=\"_blank\" href=\"\u002Fcustomers#bluetooth-sig\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-bluetooth-color-632a4ebcf4.svg\" alt=\"Bluetooth - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"financialtimes\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-financialtimes-color-2cb7e44652.svg\" alt=\"Financial Times - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"jet\" target=\"_blank\" href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fjetprivilege-case-study\u002F\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-jet-color-bbd05033a3.svg\" alt=\"Jet - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"houghton\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-hmh-color-ab0a4583c1.svg\" alt=\"HMH - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"optimizely\" target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-optimizely-color-4d45421a3e.svg\" alt=\"Optimizely - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"polaris\" target=\"_blank\" href=\"\u002Fcustomers#polaris\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-polaris-industries-color-0bc2488a05.svg\" alt=\"Polaris - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"harper\" target=\"_blank\" href=\"\u002Fcustomers#harper\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-harper-color-eb07400b01.svg\" alt=\"Harper - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca class=\"newscorp\" target=\"_blank\" href=\"\u002Fcustomers#newscorp\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fhomepage\u002Fimg\u002Flogo-news-corp-color-0953d795df.svg\" alt=\"News Corp - Authentication Customer\"\u003E\u003C\u002Fa\u003E\u003Ca target=\"_blank\" href=\"\u002Fcustomers\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(0);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"wordpress-page\"\u003E\u003Csection class=\"banner\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-sm-12\"\u003E\u003Cdiv class=\"wplogo\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwordpress\u002Fimg\u002Fwplogo-eaca45592f.png\" alt=\"WordPress Logo\"\u003E\u003C\u002Fdiv\u003E\u003Ch1\u003EWordPress Login Plugin - Pain Free\u003C\u002Fh1\u003E\u003Cp\u003EConnect WordPress to every login system on Earth. Really.\u003C\u002Fp\u003E\u003Ca class=\"btn btn-success btn-lg\" href=\"https:\u002F\u002Fwordpress.org\u002Fplugins\u002Fauth0\u002F\" target=\"_blank\"\u003EDownload Plugin\u003C\u002Fa\u003E\u003Cdiv class=\"browser\"\u003E\u003Cdiv class=\"browser-toolbar\"\u003E\u003Ci style=\"background-color: #fc625c;\"\u003E\u003C\u002Fi\u003E\u003Ci style=\"background-color: #fdbc40;\"\u003E\u003C\u002Fi\u003E\u003Ci style=\"background-color: #34c849;\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"browser-content\"\u003E\u003Cdiv class=\"twentytwenty-container\" id=\"beforeafter\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwordpress\u002Fimg\u002Fwp-screen-763003b331.png\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwordpress\u002Fimg\u002Fauth0-screen-45e8034687.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"connections enable-onview\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"page-title\"\u003E\u003Ch2\u003EWhat You Get\u003C\u002Fh2\u003E\u003Cp\u003EOur plugin makes it easy to connect WordPress to any login system. We have them all covered – from Facebook to Google, from Active Directory to LDAP. Our simple dashboard puts you in control – secure your WordPress site instantly.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"flexy-row\"\u003E\u003Cdiv class=\"info-box\"\u003E\u003Ch3\u003ESocial Login\u003C\u002Fh3\u003E\u003Cp\u003EAdd Google Authentication, Facebook Login, Twitter and Microsoft Account to your WordPress site. Go beyond with many more including GitHub, Yahoo!, PayPal & AOL. If you can think of it, \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fsocial-login\u002F\"\u003Ewe can connect to it.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"phone\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwordpress\u002Fimg\u002FiPhone-2fc912dc37.png\" alt=\"iPhone 6 with Auth0 WordPress\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info-box\"\u003E\u003Ch3\u003EEnterprise Authentication\u003C\u002Fh3\u003E\u003Cp\u003EConnect your WordPress site in minutes to common enterprise authentication systems like Active Directory, ADFS and LDAP. Something else? We have Azure, Saleforce, Office 365 and \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fidentityproviders\"\u003Eany other enterprise system you can think of.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info-box info-box--pullup\"\u003E\u003Ch3\u003EMulti-Factor Authentication\u003C\u002Fh3\u003E\u003Cp\u003EYou can easily set up multi-factor authentication to secure your site. We integrate with common systems like Google Authenticator \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Flearn\u002Fmultifactor-authentication\u002F\"\u003Eand more.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"info-box info-box--last info-box--pullup\"\u003E\u003Ch3\u003EAnd More\u003C\u002Fh3\u003E\u003Cp\u003E \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fsso\u002Fsingle-sign-on\"\u003ESingle Sign-On\u003C\u002Fa\u003E, \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Fconnections\u002Fpasswordless\"\u003EPasswordless\u003C\u002Fa\u003E, \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Frules\"\u003ERules\u003C\u002Fa\u003E, \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flibraries\u002Flock-ios\"\u003EiOS\u003C\u002Fa\u003E,\u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\u002Flibraries\u002Flock-android\"\u003EAndroid\u003C\u002Fa\u003E and complete control over the look and feel of your login box.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"how-it-works\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"page-title\"\u003E\u003Ch2\u003EHow it Works\u003C\u002Fh2\u003E\u003Cp\u003EOur plugin replaces and extends your existing WordPress login box. All your existing users are still there, only now you can also let people login with any system imaginable. It’s simple:\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"normal-row\"\u003E\u003Cdiv class=\"step-by-step\"\u003E\u003Cdiv class=\"step\"\u003E\u003Cdiv class=\"line\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"bullet\"\u003E1\u003C\u002Fspan\u003E\u003Cp\u003E \u003Ca href=\"javascript:signup()\"\u003ECreate an Auth0 Account\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step\"\u003E\u003Cdiv class=\"line\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"bullet\"\u003E2\u003C\u002Fspan\u003E\u003Cp\u003E\u003Ca href=\"https:\u002F\u002Fwordpress.org\u002Fplugins\u002Fauth0\u002F\"\u003EInstall the plugin\u003C\u002Fa\u003E on your WordPress site. Go to Plugins \u003E Add New and search for “Auth0”\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step\"\u003E\u003Cdiv class=\"line\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"bullet\"\u003E3\u003C\u002Fspan\u003E\u003Cp\u003EConnect the two. When installing the plugin it will prompt you to log in to Auth0\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step\"\u003E\u003Cspan class=\"bullet\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwordpress\u002Fimg\u002Fcheck-4ebc4bf521.svg\"\u003E\u003C\u002Fspan\u003E\u003Cp\u003EThat's it, you're done!\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"picture\"\u003E\u003Cimg src=\"https:\u002F\u002Fcdn.auth0.com\u002Fwebsite\u002Fassets\u002Fpages\u002Fwordpress\u002Fimg\u002Fbrowser-cfe13858f2.png\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"more\"\u003E\u003Cdiv class=\"duo\"\u003E\u003Cdiv class=\"feature control\"\u003E\u003Ch3\u003EControl your site\u003C\u002Fh3\u003E\u003Cp\u003EThe Auth0 plugin allows you to control and secure your login environment with a simple and powerful settings page. Simply go to Plugins \u003E Auth0 on your WordPress admin page.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"feature\"\u003E\u003Ch3\u003EAnd More\u003C\u002Fh3\u003E\u003Cp\u003EWant more control? \u003Ca href=\"http:\u002F\u002Fmanage.auth0.com\u002F\"\u003ELogin to your Auth0 dashboard\u003C\u002Fa\u003E for advanced features and fine tune control over every detail of the login experience. Customize your login form and fire JavaScript events with \u003Ca href=\"http:\u002F\u002Fmanage.auth0.com\u002F\"\u003Ethe dashboard\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"look-more\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"page-title\"\u003E\u003Ch2\u003ELooking for more\u003C\u002Fh2\u003E\u003Cp\u003EExplore our \u003Ca href=\"https:\u002F\u002Fauth0.com\u002Fdocs\"\u003Edetailed documentation\u003C\u002Fa\u003E, \u003Ca href=\"https:\u002F\u002Fwww.youtube.com\u002Fchannel\u002FUCUlQ5VoIzE_kFbYjzUwHTKA\" target=\"_blank\"\u003Ewatch our videos\u003C\u002Fa\u003E, \u003Ca href=\"http:\u002F\u002Ffeedback.auth0.com\u002Fforums\u002F306253-general\"\u003Esend us feedback\u003C\u002Fa\u003E and \u003Ca href=\"https:\u002F\u002Fsupport.auth0.com\"\u003Econtact us\u003C\u002Fa\u003E with any query you have.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"try-free\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cp\u003EStart your free trial today\u003C\u002Fp\u003E\u003Ca class=\"login btn btn-success btn-lg\" href=\"javascript:signup()\" target=\"_blank\"\u003EGet started for free\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),
/* 983 */,
/* 984 */,
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(338);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos));
            val = options.decoder(part.slice(pos + 1));
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObjectRecursive(chain, val, options) {
    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (
            !isNaN(index) &&
            root !== cleanRoot &&
            String(index) === cleanRoot &&
            index >= 0 &&
            (options.parseArrays && index <= options.arrayLimit)
        ) {
            obj = [];
            obj[index] = parseObject(chain, val, options);
        } else {
            obj[cleanRoot] = parseObject(chain, val, options);
        }
    }

    return obj;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts || {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(338);
var formats = __webpack_require__(337);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix);
            return [formatter(keyValue) + '=' + formatter(encoder(obj))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts || {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats.default;
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(15);

var focusNode = __webpack_require__(282);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(107);
var ExecutionEnvironment = __webpack_require__(22);
var FallbackCompositionState = __webpack_require__(995);
var SyntheticCompositionEvent = __webpack_require__(1032);
var SyntheticInputEvent = __webpack_require__(1035);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(339);
var ExecutionEnvironment = __webpack_require__(22);
var ReactInstrumentation = __webpack_require__(37);

var camelizeStyleName = __webpack_require__(738);
var dangerousStyleValue = __webpack_require__(1041);
var hyphenateStyleName = __webpack_require__(745);
var memoizeStringOnly = __webpack_require__(748);
var warning = __webpack_require__(7);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(106);
var EventPropagators = __webpack_require__(107);
var ExecutionEnvironment = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);
var SyntheticEvent = __webpack_require__(46);

var getEventTarget = __webpack_require__(206);
var isEventSupported = __webpack_require__(207);
var isTextInputElement = __webpack_require__(356);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === 'topInput') {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === 'topClick') {
    return targetInst;
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(22);

var createNodesFromMarkup = __webpack_require__(741);
var emptyFunction = __webpack_require__(32);
var invariant = __webpack_require__(5);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(107);
var ReactDOMComponentTree = __webpack_require__(15);
var SyntheticMouseEvent = __webpack_require__(134);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var PooledClass = __webpack_require__(65);

var getTextContentAccessor = __webpack_require__(354);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(85);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(86);

var instantiateReactComponent = __webpack_require__(355);
var KeyEscapeUtils = __webpack_require__(198);
var shouldUpdateReactComponent = __webpack_require__(208);
var traverseAllChildren = __webpack_require__(358);
var warning = __webpack_require__(7);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(364);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(194);
var ReactDOMIDOperations = __webpack_require__(1005);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var React = __webpack_require__(87);
var ReactComponentEnvironment = __webpack_require__(200);
var ReactCurrentOwner = __webpack_require__(47);
var ReactErrorUtils = __webpack_require__(201);
var ReactInstanceMap = __webpack_require__(108);
var ReactInstrumentation = __webpack_require__(37);
var ReactNodeTypes = __webpack_require__(349);
var ReactReconciler = __webpack_require__(86);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(79);
var invariant = __webpack_require__(5);
var shallowEqual = __webpack_require__(166);
var shouldUpdateReactComponent = __webpack_require__(208);
var warning = __webpack_require__(7);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(15);
var ReactDefaultInjection = __webpack_require__(1013);
var ReactMount = __webpack_require__(348);
var ReactReconciler = __webpack_require__(86);
var ReactUpdates = __webpack_require__(41);
var ReactVersion = __webpack_require__(1026);

var findDOMNode = __webpack_require__(1042);
var getHostComponentFromComposite = __webpack_require__(353);
var renderSubtreeIntoContainer = __webpack_require__(1049);
var warning = __webpack_require__(7);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var AutoFocusUtils = __webpack_require__(988);
var CSSPropertyOperations = __webpack_require__(990);
var DOMLazyTree = __webpack_require__(84);
var DOMNamespaces = __webpack_require__(195);
var DOMProperty = __webpack_require__(85);
var DOMPropertyOperations = __webpack_require__(341);
var EventPluginHub = __webpack_require__(106);
var EventPluginRegistry = __webpack_require__(196);
var ReactBrowserEventEmitter = __webpack_require__(133);
var ReactDOMComponentFlags = __webpack_require__(342);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMInput = __webpack_require__(1006);
var ReactDOMOption = __webpack_require__(1007);
var ReactDOMSelect = __webpack_require__(343);
var ReactDOMTextarea = __webpack_require__(1010);
var ReactInstrumentation = __webpack_require__(37);
var ReactMultiChild = __webpack_require__(1019);
var ReactServerRenderingTransaction = __webpack_require__(1024);

var emptyFunction = __webpack_require__(32);
var escapeTextContentForBrowser = __webpack_require__(136);
var invariant = __webpack_require__(5);
var isEventSupported = __webpack_require__(207);
var shallowEqual = __webpack_require__(166);
var validateDOMNesting = __webpack_require__(209);
var warning = __webpack_require__(7);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(209);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var DOMLazyTree = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(15);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(194);
var ReactDOMComponentTree = __webpack_require__(15);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var DOMPropertyOperations = __webpack_require__(341);
var LinkedValueUtils = __webpack_require__(199);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        // eslint-disable-next-line
        if (value != valueAsNumber) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
        // eslint-disable-next-line
      } else if (value != node.value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var React = __webpack_require__(87);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMSelect = __webpack_require__(343);

var warning = __webpack_require__(7);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

var getNodeForCharacterOffset = __webpack_require__(1046);
var getTextContentAccessor = __webpack_require__(354);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var DOMChildrenOperations = __webpack_require__(194);
var DOMLazyTree = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(15);

var escapeTextContentForBrowser = __webpack_require__(136);
var invariant = __webpack_require__(5);
var validateDOMNesting = __webpack_require__(209);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(13);

var LinkedValueUtils = __webpack_require__(199);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var ReactUpdates = __webpack_require__(41);
var Transaction = __webpack_require__(135);

var emptyFunction = __webpack_require__(32);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(987);
var BeforeInputEventPlugin = __webpack_require__(989);
var ChangeEventPlugin = __webpack_require__(991);
var DefaultEventPluginOrder = __webpack_require__(993);
var EnterLeaveEventPlugin = __webpack_require__(994);
var HTMLDOMPropertyConfig = __webpack_require__(996);
var ReactComponentBrowserEnvironment = __webpack_require__(998);
var ReactDOMComponent = __webpack_require__(1001);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactDOMEmptyComponent = __webpack_require__(1003);
var ReactDOMTreeTraversal = __webpack_require__(1011);
var ReactDOMTextComponent = __webpack_require__(1009);
var ReactDefaultBatchingStrategy = __webpack_require__(1012);
var ReactEventListener = __webpack_require__(1016);
var ReactInjection = __webpack_require__(1017);
var ReactReconcileTransaction = __webpack_require__(1022);
var SVGDOMPropertyConfig = __webpack_require__(1027);
var SelectEventPlugin = __webpack_require__(1028);
var SimpleEventPlugin = __webpack_require__(1029);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(106);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var EventListener = __webpack_require__(281);
var ExecutionEnvironment = __webpack_require__(22);
var PooledClass = __webpack_require__(65);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactUpdates = __webpack_require__(41);

var getEventTarget = __webpack_require__(206);
var getUnboundedScrollPosition = __webpack_require__(743);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(85);
var EventPluginHub = __webpack_require__(106);
var EventPluginUtils = __webpack_require__(197);
var ReactComponentEnvironment = __webpack_require__(200);
var ReactEmptyComponent = __webpack_require__(344);
var ReactBrowserEventEmitter = __webpack_require__(133);
var ReactHostComponent = __webpack_require__(346);
var ReactUpdates = __webpack_require__(41);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(1040);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactComponentEnvironment = __webpack_require__(200);
var ReactInstanceMap = __webpack_require__(108);
var ReactInstrumentation = __webpack_require__(37);

var ReactCurrentOwner = __webpack_require__(47);
var ReactReconciler = __webpack_require__(86);
var ReactChildReconciler = __webpack_require__(997);

var emptyFunction = __webpack_require__(32);
var flattenChildren = __webpack_require__(1043);
var invariant = __webpack_require__(5);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(5);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var CallbackQueue = __webpack_require__(340);
var PooledClass = __webpack_require__(65);
var ReactBrowserEventEmitter = __webpack_require__(133);
var ReactInputSelection = __webpack_require__(347);
var ReactInstrumentation = __webpack_require__(37);
var Transaction = __webpack_require__(135);
var ReactUpdateQueue = __webpack_require__(202);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(1020);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var PooledClass = __webpack_require__(65);
var Transaction = __webpack_require__(135);
var ReactInstrumentation = __webpack_require__(37);
var ReactServerUpdateQueue = __webpack_require__(1025);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(202);

var warning = __webpack_require__(7);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(107);
var ExecutionEnvironment = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInputSelection = __webpack_require__(347);
var SyntheticEvent = __webpack_require__(46);

var getActiveElement = __webpack_require__(283);
var isTextInputElement = __webpack_require__(356);
var shallowEqual = __webpack_require__(166);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var EventListener = __webpack_require__(281);
var EventPropagators = __webpack_require__(107);
var ReactDOMComponentTree = __webpack_require__(15);
var SyntheticAnimationEvent = __webpack_require__(1030);
var SyntheticClipboardEvent = __webpack_require__(1031);
var SyntheticEvent = __webpack_require__(46);
var SyntheticFocusEvent = __webpack_require__(1034);
var SyntheticKeyboardEvent = __webpack_require__(1036);
var SyntheticMouseEvent = __webpack_require__(134);
var SyntheticDragEvent = __webpack_require__(1033);
var SyntheticTouchEvent = __webpack_require__(1037);
var SyntheticTransitionEvent = __webpack_require__(1038);
var SyntheticUIEvent = __webpack_require__(109);
var SyntheticWheelEvent = __webpack_require__(1039);

var emptyFunction = __webpack_require__(32);
var getEventCharCode = __webpack_require__(204);
var invariant = __webpack_require__(5);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(46);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(46);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(46);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(134);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(109);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(46);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(109);

var getEventCharCode = __webpack_require__(204);
var getEventKey = __webpack_require__(1044);
var getEventModifierState = __webpack_require__(205);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(109);

var getEventModifierState = __webpack_require__(205);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(46);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(134);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(339);
var warning = __webpack_require__(7);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(47);
var ReactDOMComponentTree = __webpack_require__(15);
var ReactInstanceMap = __webpack_require__(108);

var getHostComponentFromComposite = __webpack_require__(353);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(198);
var traverseAllChildren = __webpack_require__(358);
var warning = __webpack_require__(7);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(364);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(204);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(22);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(136);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(348);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(45);
var createClass = __webpack_require__(733);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.__esModule = true;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _isPlainObject = __webpack_require__(360);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _shallowEqual = __webpack_require__(1056);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _handleResponse = __webpack_require__(1055);

var _handleResponse2 = _interopRequireDefault(_handleResponse);

var _buildRequest = __webpack_require__(1052);

var _buildRequest2 = _interopRequireDefault(_buildRequest);

var _checkTypes = __webpack_require__(1053);

var _checkTypes2 = _interopRequireDefault(_checkTypes);

var _PromiseState = __webpack_require__(359);

var _PromiseState2 = _interopRequireDefault(_PromiseState);

var _hoistNonReactStatics = __webpack_require__(751);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(285);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(1089);

var _warning2 = _interopRequireDefault(_warning);

var _omit = __webpack_require__(870);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapPropsToRequestsToProps = function defaultMapPropsToRequestsToProps() {
  return {};
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

// Helps track hot reloading.
var nextVersion = 0;

function connectFactory() {
  var defaults = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  function connectImpl(map) {
    var deprecatedOptionsArgument = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var finalOptions = options;
    if ('withRef' in deprecatedOptionsArgument) {
      (0, _warning2.default)(false, 'The options argument is deprecated in favor of `connect.options()`. In a future release, support will be removed.');
      finalOptions = Object.assign({}, options, { withRef: deprecatedOptionsArgument.withRef });
    }

    (0, _warning2.default)(!(Function.prototype.isPrototypeOf(defaults.buildRequest) && Function.prototype.isPrototypeOf(defaults.Request)), 'Both buildRequest and Request were provided in `connect.defaults()`. ' + 'However, this custom Request would only be used in the default buildRequest.');

    return connect(map, defaults, finalOptions);
  }

  connectImpl.defaults = function () {
    var overrides = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    (0, _checkTypes2.default)(overrides);
    return connectFactory(Object.assign({}, defaults, overrides, { headers: Object.assign({}, defaults.headers, overrides.headers) }), options);
  };

  connectImpl.options = function () {
    var overrides = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    return connectFactory(defaults, Object.assign({}, options, overrides));
  };

  return connectImpl;
}

exports.default = connectFactory({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

var omitChildren = (0, _omit2.default)('children');

function connect(mapPropsToRequestsToProps, defaults, options) {
  var finalMapPropsToRequestsToProps = mapPropsToRequestsToProps || defaultMapPropsToRequestsToProps;
  var dependsOnProps = finalMapPropsToRequestsToProps.length >= 1;
  var dependsOnContext = finalMapPropsToRequestsToProps.length == 2;

  var topFetch = undefined;
  var topRequest = undefined;
  if (typeof window !== 'undefined') {
    if (window.fetch) {
      topFetch = window.fetch.bind(window);
    }
    if (window.Request) {
      topRequest = window.Request.bind(window);
    }
  } else if (typeof global !== 'undefined') {
    if (global.fetch) {
      topFetch = global.fetch.bind(global);
    }
    if (global.Request) {
      topRequest = global.Request.bind(global);
    }
  } else if (typeof self !== 'undefined') {
    if (self.fetch) {
      topFetch = self.fetch.bind(self);
    }
    if (self.Request) {
      topRequest = self.Request.bind(self);
    }
  }

  defaults = Object.assign({
    buildRequest: _buildRequest2.default,
    credentials: 'same-origin',
    fetch: topFetch,
    force: false,
    handleResponse: _handleResponse2.default,
    method: 'GET',
    redirect: 'follow',
    refreshing: false,
    refreshInterval: 0,
    Request: topRequest
  }, defaults);

  (0, _checkTypes2.default)(defaults);

  options = Object.assign({
    withRef: false,
    pure: true
  }, options);

  // Helps track hot reloading.
  var version = nextVersion++;

  function coerceMappings(rawMappings) {
    (0, _invariant2.default)((0, _isPlainObject2.default)(rawMappings), '`mapPropsToRequestsToProps` must return an object. Instead received %s.', rawMappings);

    var mappings = {};
    Object.keys(rawMappings).forEach(function (prop) {
      mappings[prop] = coerceMapping(prop, rawMappings[prop]);
    });
    return mappings;
  }

  function coerceMapping(prop, mapping, parent) {
    if (Function.prototype.isPrototypeOf(mapping)) {
      return mapping;
    }

    if (typeof mapping === 'string') {
      mapping = { url: mapping };
    }

    (0, _invariant2.default)((0, _isPlainObject2.default)(mapping), 'Request for `%s` must be either a string or a plain object. Instead received %s', prop, mapping);
    (0, _invariant2.default)(mapping.hasOwnProperty('url') || mapping.hasOwnProperty('value'), 'Request object for `%s` must have `url` (or `value`) attribute.', prop);
    (0, _invariant2.default)(!(mapping.hasOwnProperty('url') && mapping.hasOwnProperty('value')), 'Request object for `%s` must not have both `url` and `value` attributes.', prop);

    (0, _checkTypes2.default)(mapping);

    if (parent) {
      mapping.parent = parent.parent || parent;
    }

    mapping = assignDefaults(mapping, parent);

    (0, _invariant2.default)((0, _isPlainObject2.default)(mapping.meta), 'meta for `%s` must be a plain object. Instead received %s', prop, mapping.meta);

    mapping.equals = function (that) {
      var _this = this;

      that = that.parent || that;

      if (this.comparison !== undefined) {
        return this.comparison === that.comparison;
      }

      return ['value', 'url', 'method', 'headers', 'body'].every(function (c) {
        return (0, _shallowEqual2.default)(_this[c], that[c]);
      });
    }.bind(mapping);

    return mapping;
  }

  function assignDefaults(mapping, parent) {
    var rawHeaders = Object.assign({}, defaults.headers, mapping.headers);
    var headers = {};
    for (var key in rawHeaders) {
      // Discard headers with falsy values
      if (rawHeaders.hasOwnProperty(key) && rawHeaders[key]) {
        headers[key] = rawHeaders[key];
      }
    }

    return Object.assign({
      meta: {}
    }, defaults, parent ? {
      fetch: parent.fetch,
      buildRequest: parent.buildRequest,
      handleResponse: parent.handleResponse,
      Request: parent.Request,
      comparison: parent.comparison,
      then: undefined,
      andThen: undefined
    } : {}, mapping, { headers: headers });
  }

  return function wrapWithConnect(WrappedComponent) {
    var RefetchConnect = function (_Component) {
      _inherits(RefetchConnect, _Component);

      function RefetchConnect(props, context) {
        _classCallCheck(this, RefetchConnect);

        var _this2 = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this2.version = version;
        _this2.state = { mappings: {}, startedAts: {}, data: {}, refreshTimeouts: {} };
        return _this2;
      }

      RefetchConnect.prototype.componentWillMount = function componentWillMount() {
        this.refetchDataFromProps();
      };

      RefetchConnect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        if (!options.pure || dependsOnProps && !(0, _shallowEqual2.default)(omitChildren(this.props), omitChildren(nextProps)) || dependsOnContext && !(0, _shallowEqual2.default)(this.context, nextContext)) {
          this.refetchDataFromProps(nextProps, nextContext);
        }
      };

      RefetchConnect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return !options.pure || this.state.data != nextState.data || !(0, _shallowEqual2.default)(this.props, nextProps);
      };

      RefetchConnect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.clearAllRefreshTimeouts();
        this._unmounted = true;
      };

      RefetchConnect.prototype.render = function render() {
        var ref = options.withRef ? 'wrappedInstance' : null;
        return _react2.default.createElement(WrappedComponent, _extends({}, this.state.data, this.props, { ref: ref }));
      };

      RefetchConnect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2.default)(options.withRef, 'To access the wrapped instance, you need to specify { withRef: true } in .options().');

        return this.refs.wrappedInstance;
      };

      RefetchConnect.prototype.refetchDataFromProps = function refetchDataFromProps() {
        var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
        var context = arguments.length <= 1 || arguments[1] === undefined ? this.context : arguments[1];

        this.refetchDataFromMappings(finalMapPropsToRequestsToProps(omitChildren(props), context) || {});
      };

      RefetchConnect.prototype.refetchDataFromMappings = function refetchDataFromMappings(mappings) {
        var _this3 = this;

        mappings = coerceMappings(mappings);
        Object.keys(mappings).forEach(function (prop) {
          var mapping = mappings[prop];

          if (Function.prototype.isPrototypeOf(mapping)) {
            _this3.setAtomicState(prop, new Date(), mapping, function () {
              _this3.refetchDataFromMappings(mapping.apply(undefined, arguments));
            });
            return;
          }

          if (mapping.force || !mapping.equals(_this3.state.mappings[prop] || {})) {
            _this3.refetchDatum(prop, mapping);
          }
        });
      };

      RefetchConnect.prototype.refetchDatum = function refetchDatum(prop, mapping) {
        var startedAt = new Date();

        if (this.state.refreshTimeouts[prop]) {
          window.clearTimeout(this.state.refreshTimeouts[prop]);
        }

        return this.createPromise(prop, mapping, startedAt);
      };

      RefetchConnect.prototype.createPromise = function createPromise(prop, mapping, startedAt) {
        var _this4 = this;

        var meta = mapping.meta;
        var initPS = this.createInitialPromiseState(prop, mapping);
        var onFulfillment = this.createPromiseStateOnFulfillment(prop, mapping, startedAt);
        var onRejection = this.createPromiseStateOnRejection(prop, mapping, startedAt);

        if (mapping.hasOwnProperty('value')) {
          if (mapping.value instanceof Promise) {
            this.setAtomicState(prop, startedAt, mapping, initPS(meta));
            return mapping.value.then(onFulfillment(meta), onRejection(meta));
          } else {
            return onFulfillment(meta)(mapping.value);
          }
        } else {
          var request = mapping.buildRequest(mapping);
          meta.request = request;
          this.setAtomicState(prop, startedAt, mapping, initPS(meta));

          var fetched = mapping.fetch(request);
          return fetched.then(function (response) {
            meta.response = response;
            meta.component = _this4.refs.wrappedInstance;

            return response;
          }).then(mapping.handleResponse).then(onFulfillment(meta), onRejection(meta));
        }
      };

      RefetchConnect.prototype.createInitialPromiseState = function createInitialPromiseState(prop, mapping) {
        var _this5 = this;

        return function (meta) {
          if (typeof mapping.refreshing == 'function') {
            var current = _this5.state.data[prop];
            if (current) {
              current.value = mapping.refreshing(current.value);
            }
            return _PromiseState2.default.refresh(current, meta);
          } else if (mapping.refreshing) {
            return _PromiseState2.default.refresh(_this5.state.data[prop], meta);
          } else {
            return _PromiseState2.default.create(meta);
          }
        };
      };

      RefetchConnect.prototype.createPromiseStateOnFulfillment = function createPromiseStateOnFulfillment(prop, mapping, startedAt) {
        var _this6 = this;

        return function (meta) {
          return function (value) {
            var refreshTimeout = null;
            if (mapping.refreshInterval > 0) {
              refreshTimeout = window.setTimeout(function () {
                _this6.refetchDatum(prop, Object.assign({}, mapping, { refreshing: true, force: true }));
              }, mapping.refreshInterval);
            }

            if (mapping.then) {
              var thenMapping = mapping.then(value, meta);
              if (typeof thenMapping !== 'undefined') {
                _this6.refetchDatum(prop, coerceMapping(null, thenMapping, mapping));
                return;
              }
            }

            _this6.setAtomicState(prop, startedAt, mapping, _PromiseState2.default.resolve(value, meta), refreshTimeout, function () {
              if (mapping.andThen) {
                _this6.refetchDataFromMappings(mapping.andThen(value, meta));
              }
            });
          };
        };
      };

      RefetchConnect.prototype.createPromiseStateOnRejection = function createPromiseStateOnRejection(prop, mapping, startedAt) {
        var _this7 = this;

        return function (meta) {
          return function (reason) {
            if (mapping.catch) {
              var catchMapping = mapping.catch(reason, meta);
              if (typeof catchMapping !== 'undefined') {
                _this7.refetchDatum(prop, coerceMapping(null, catchMapping, mapping));
                return;
              }
            }

            _this7.setAtomicState(prop, startedAt, mapping, _PromiseState2.default.reject(reason, meta), null, function () {
              if (mapping.andCatch) {
                _this7.refetchDataFromMappings(mapping.andCatch(reason, meta));
              }
            });
          };
        };
      };

      RefetchConnect.prototype.setAtomicState = function setAtomicState(prop, startedAt, mapping, datum, refreshTimeout, callback) {
        if (this._unmounted) {
          return;
        }

        this.setState(function (prevState) {
          var _Object$assign, _Object$assign2, _Object$assign3, _Object$assign4;

          if (startedAt < prevState.startedAts[prop]) {
            return {};
          }

          return {
            startedAts: Object.assign({}, prevState.startedAts, (_Object$assign = {}, _Object$assign[prop] = startedAt, _Object$assign)),
            mappings: Object.assign({}, prevState.mappings, (_Object$assign2 = {}, _Object$assign2[prop] = mapping, _Object$assign2)),
            data: Object.assign({}, prevState.data, (_Object$assign3 = {}, _Object$assign3[prop] = datum, _Object$assign3)),
            refreshTimeouts: Object.assign({}, prevState.refreshTimeouts, (_Object$assign4 = {}, _Object$assign4[prop] = refreshTimeout, _Object$assign4))
          };
        }, callback);
      };

      RefetchConnect.prototype.clearAllRefreshTimeouts = function clearAllRefreshTimeouts() {
        var _this8 = this;

        Object.keys(this.state.refreshTimeouts).forEach(function (prop) {
          clearTimeout(_this8.state.refreshTimeouts[prop]);
        });
      };

      return RefetchConnect;
    }(_react.Component);

    RefetchConnect.displayName = 'Refetch.connect(' + getDisplayName(WrappedComponent) + ')';
    RefetchConnect.WrappedComponent = WrappedComponent;

    if (dependsOnContext && WrappedComponent.contextTypes) {
      RefetchConnect.contextTypes = WrappedComponent.contextTypes;
    }

    if (false) {
      RefetchConnect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.clearAllRefreshTimeouts();
        this.refetchDataFromProps();
      };
    }

    return (0, _hoistNonReactStatics2.default)(RefetchConnect, WrappedComponent);
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildRequest;
function buildRequest(mapping) {
  return new mapping.Request(mapping.url, {
    method: mapping.method,
    headers: mapping.headers,
    credentials: mapping.credentials,
    redirect: mapping.redirect,
    body: mapping.body
  });
}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.default = checkTypes;

var _invariant = __webpack_require__(285);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(360);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function typecheck(types, name, obj) {
  (0, _invariant2.default)(Array.isArray(types) ? types.some(function (t) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === t;
  }) : (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === types, name + ' must be ' + (Array.isArray(types) ? 'one of' : 'a') + ' ' + types + '. Instead received a %s.', typeof obj === 'undefined' ? 'undefined' : _typeof(obj));
}

var checks = {
  buildRequest: function buildRequest(fn) {
    typecheck('function', 'buildRequest', fn);
  },
  credentials: function credentials(str) {
    var allowed = ['omit', 'same-origin', 'include'];
    (0, _invariant2.default)(allowed.indexOf(str) !== -1, 'credentials must be one of ' + allowed.join(', ') + '. Instead got %s.', str ? str.toString() : str);
  },
  fetch: function fetch(fn) {
    typecheck('function', 'fetch', fn);
  },
  handleResponse: function handleResponse(fn) {
    typecheck('function', 'handleResponse', fn);
  },
  headers: function headers(obj) {
    (0, _invariant2.default)((0, _isPlainObject2.default)(obj), 'headers must be a plain object with string values. Instead received a %s.', typeof obj === 'undefined' ? 'undefined' : _typeof(obj));
  },
  method: function method(str) {
    typecheck('string', 'method', str);
  },
  redirect: function redirect(str) {
    var allowed = ['follow', 'error', 'manual'];
    (0, _invariant2.default)(allowed.indexOf(str) !== -1, 'redirect must be one of ' + allowed.join(', ') + '. Instead got %s.', str ? str.toString() : str);
  },
  refreshInterval: function refreshInterval(num) {
    typecheck('number', 'refreshInterval', num);
    (0, _invariant2.default)(num >= 0, 'refreshInterval must be positive or 0.');
    (0, _invariant2.default)(num !== Infinity, 'refreshInterval must not be Infinity.');
  },
  Request: function Request(fn) {
    typecheck('function', 'Request', fn);
  },
  then: function then(fn) {
    typecheck(['function', 'undefined'], 'then', fn);
  },
  andThen: function andThen(fn) {
    typecheck(['function', 'undefined'], 'andThen', fn);
  },
  catch: function _catch(fn) {
    typecheck(['function', 'undefined'], 'catch', fn);
  },
  andCatch: function andCatch(fn) {
    typecheck(['function', 'undefined'], 'andCatch', fn);
  }
};

function checkTypes(mapping) {
  Object.keys(mapping).forEach(function (key) {
    if (checks[key]) {
      checks[key](mapping[key]);
    }
  });
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = newError;
function newError(cause) {
  var e = new Error(parse(cause));
  e.cause = cause;
  return e;
}

function parse(cause) {
  var error = cause.error;
  var message = cause.message;

  if (error) {
    return error;
  } else if (message) {
    return message;
  } else {
    return '';
  }
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = handleResponse;

var _errors = __webpack_require__(1054);

var _errors2 = _interopRequireDefault(_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleResponse(response) {
  if (response.headers.get('content-length') === '0' || response.status === 204) {
    return;
  }

  var json = response.json(); // TODO: support other response types

  if (response.status >= 200 && response.status < 300) {
    // TODO: support custom acceptable statuses
    return json;
  } else {
    return json.then(function (cause) {
      return Promise.reject((0, _errors2.default)(cause));
    });
  }
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objA === null || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(110);

var _Select2 = _interopRequireDefault(_Select);

var _utilsStripDiacritics = __webpack_require__(363);

var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);

var propTypes = {
	autoload: _react2['default'].PropTypes.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _react2['default'].PropTypes.any, // object to use to cache results; set to null/false to disable caching
	children: _react2['default'].PropTypes.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _react2['default'].PropTypes.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _react2['default'].PropTypes.bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _react2['default'].PropTypes.oneOfType([// replaces the placeholder while options are loading
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	loadOptions: _react2['default'].PropTypes.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	options: _react.PropTypes.array.isRequired, // array of options
	placeholder: _react2['default'].PropTypes.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	noResultsText: _react2['default'].PropTypes.oneOfType([// field noResultsText, displayed when no options come back from the server
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
	searchPromptText: _react2['default'].PropTypes.oneOfType([// label to prompt for search input
	_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]),
	onInputChange: _react2['default'].PropTypes.func, // optional for keeping track of what is being typed
	value: _react2['default'].PropTypes.any };

// initial field value
var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = (function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);

		this._cache = props.cache === defaultCache ? {} : props.cache;

		this.state = {
			isLoading: false,
			options: props.options
		};

		this._onInputChange = this._onInputChange.bind(this);
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;

			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this.props[prop] !== nextProps[prop]) {
					_this.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props;
			var ignoreAccents = _props.ignoreAccents;
			var ignoreCase = _props.ignoreCase;
			var onInputChange = _props.onInputChange;

			if (ignoreAccents) {
				inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props;
			var loadingPlaceholder = _props2.loadingPlaceholder;
			var noResultsText = _props2.noResultsText;
			var searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;

			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props;
			var children = _props3.children;
			var loadingPlaceholder = _props3.loadingPlaceholder;
			var placeholder = _props3.placeholder;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;

			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
						_this3.clearOptions();
					}
					_this3.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
})(_react.Component);

exports['default'] = Async;

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};
module.exports = exports['default'];

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(110);

var _Select2 = _interopRequireDefault(_Select);

function reduce(obj) {
	var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = _react2['default'].createClass({
	displayName: 'AsyncCreatableSelect',

	render: function render() {
		var _this = this;

		return _react2['default'].createElement(
			_Select2['default'].Async,
			this.props,
			function (asyncProps) {
				return _react2['default'].createElement(
					_Select2['default'].Creatable,
					_this.props,
					function (creatableProps) {
						return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function (input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function (ref) {
								creatableProps.ref(ref);
								asyncProps.ref(ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(110);

var _Select2 = _interopRequireDefault(_Select);

var _utilsDefaultFilterOptions = __webpack_require__(361);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(362);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var Creatable = _react2['default'].createClass({
	displayName: 'CreatableSelect',

	propTypes: {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _react2['default'].PropTypes.func,

		// See Select.propTypes.filterOptions
		filterOptions: _react2['default'].PropTypes.any,

		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _react2['default'].PropTypes.func,

		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _react2['default'].PropTypes.func,

		// See Select.propTypes.menuRenderer
		menuRenderer: _react2['default'].PropTypes.any,

		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _react2['default'].PropTypes.func,

		// input change handler: function (inputValue) {}
		onInputChange: _react2['default'].PropTypes.func,

		// input keyDown handler: function (event) {}
		onInputKeyDown: _react2['default'].PropTypes.func,

		// new option click handler: function (option) {}
		onNewOptionClick: _react2['default'].PropTypes.func,

		// See Select.propTypes.options
		options: _react2['default'].PropTypes.array,

		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _react2['default'].PropTypes.func,

		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _react2['default'].PropTypes.func
	},

	// Default prop methods
	statics: {
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	},

	getDefaultProps: function getDefaultProps() {
		return {
			filterOptions: _utilsDefaultFilterOptions2['default'],
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		};
	},

	createNewOption: function createNewOption() {
		var _props = this.props;
		var isValidNewOption = _props.isValidNewOption;
		var newOptionCreator = _props.newOptionCreator;
		var onNewOptionClick = _props.onNewOptionClick;
		var _props$options = _props.options;
		var options = _props$options === undefined ? [] : _props$options;
		var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;

		if (isValidNewOption({ label: this.inputValue })) {
			var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
			var _isOptionUnique = this.isOptionUnique({ option: option });

			// Don't add the same option twice.
			if (_isOptionUnique) {
				if (onNewOptionClick) {
					onNewOptionClick(option);
				} else {
					options.unshift(option);

					this.select.selectValue(option);
				}
			}
		}
	},

	filterOptions: function filterOptions() {
		var _props2 = this.props;
		var filterOptions = _props2.filterOptions;
		var isValidNewOption = _props2.isValidNewOption;
		var options = _props2.options;
		var promptTextCreator = _props2.promptTextCreator;

		// TRICKY Check currently selected options as well.
		// Don't display a create-prompt for a value that's selected.
		// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
		var excludeOptions = arguments[2] || [];

		var filteredOptions = filterOptions.apply(undefined, arguments) || [];

		if (isValidNewOption({ label: this.inputValue })) {
			var _newOptionCreator = this.props.newOptionCreator;

			var option = _newOptionCreator({
				label: this.inputValue,
				labelKey: this.labelKey,
				valueKey: this.valueKey
			});

			// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
			// For multi-selects, this would remove it from the filtered list.
			var _isOptionUnique2 = this.isOptionUnique({
				option: option,
				options: excludeOptions.concat(filteredOptions)
			});

			if (_isOptionUnique2) {
				var _prompt = promptTextCreator(this.inputValue);

				this._createPlaceholderOption = _newOptionCreator({
					label: _prompt,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				filteredOptions.unshift(this._createPlaceholderOption);
			}
		}

		return filteredOptions;
	},

	isOptionUnique: function isOptionUnique(_ref2) {
		var option = _ref2.option;
		var options = _ref2.options;
		var isOptionUnique = this.props.isOptionUnique;

		options = options || this.select.filterOptions();

		return isOptionUnique({
			labelKey: this.labelKey,
			option: option,
			options: options,
			valueKey: this.valueKey
		});
	},

	menuRenderer: function menuRenderer(params) {
		var menuRenderer = this.props.menuRenderer;

		return menuRenderer(_extends({}, params, {
			onSelect: this.onOptionSelect,
			selectValue: this.onOptionSelect
		}));
	},

	onInputChange: function onInputChange(input) {
		var onInputChange = this.props.onInputChange;

		if (onInputChange) {
			onInputChange(input);
		}

		// This value may be needed in between Select mounts (when this.select is null)
		this.inputValue = input;
	},

	onInputKeyDown: function onInputKeyDown(event) {
		var _props3 = this.props;
		var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
		var onInputKeyDown = _props3.onInputKeyDown;

		var focusedOption = this.select.getFocusedOption();

		if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
			this.createNewOption();

			// Prevent decorated Select from doing anything additional with this keyDown event
			event.preventDefault();
		} else if (onInputKeyDown) {
			onInputKeyDown(event);
		}
	},

	onOptionSelect: function onOptionSelect(option, event) {
		if (option === this._createPlaceholderOption) {
			this.createNewOption();
		} else {
			this.select.selectValue(option);
		}
	},

	render: function render() {
		var _this = this;

		var _props4 = this.props;
		var newOptionCreator = _props4.newOptionCreator;
		var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;

		var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

		var children = this.props.children;

		// We can't use destructuring default values to set the children,
		// because it won't apply work if `children` is null. A falsy check is
		// more reliable in real world use-cases.
		if (!children) {
			children = defaultChildren;
		}

		var props = _extends({}, restProps, {
			allowCreate: true,
			filterOptions: this.filterOptions,
			menuRenderer: this.menuRenderer,
			onInputChange: this.onInputChange,
			onInputKeyDown: this.onInputKeyDown,
			ref: function ref(_ref) {
				_this.select = _ref;

				// These values may be needed in between Select mounts (when this.select is null)
				if (_ref) {
					_this.labelKey = _ref.props.labelKey;
					_this.valueKey = _ref.props.valueKey;
				}
			}
		});

		return children(props);
	}
});

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option;
	var options = _ref3.options;
	var labelKey = _ref3.labelKey;
	var valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label;
	var labelKey = _ref5.labelKey;
	var valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

module.exports = Creatable;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(42);

var _classnames2 = _interopRequireDefault(_classnames);

var Option = _react2['default'].createClass({
	displayName: 'Option',

	propTypes: {
		children: _react2['default'].PropTypes.node,
		className: _react2['default'].PropTypes.string, // className (based on mouse position)
		instancePrefix: _react2['default'].PropTypes.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
		isFocused: _react2['default'].PropTypes.bool, // the option is focused
		isSelected: _react2['default'].PropTypes.bool, // the option is selected
		onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
		onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
		onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
		option: _react2['default'].PropTypes.object.isRequired, // object that is base for that option
		optionIndex: _react2['default'].PropTypes.number },
	// index of the option, used to generate unique ids for aria
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},

	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},

	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props;
		var option = _props.option;
		var instancePrefix = _props.instancePrefix;
		var optionIndex = _props.optionIndex;

		var className = (0, _classnames2['default'])(this.props.className, option.className);

		return option.disabled ? _react2['default'].createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2['default'].createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(42);

var _classnames2 = _interopRequireDefault(_classnames);

var Value = _react2['default'].createClass({

	displayName: 'Value',

	propTypes: {
		children: _react2['default'].PropTypes.node,
		disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
		id: _react2['default'].PropTypes.string, // Unique id for the value - used for aria
		onClick: _react2['default'].PropTypes.func, // method to handle click on value label
		onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
		value: _react2['default'].PropTypes.object.isRequired },

	// the option object for this value
	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},

	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},

	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'×'
		);
	},

	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2['default'].createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},

	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}

});

module.exports = Value;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports["default"] = arrowRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2["default"].createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
}

;
module.exports = exports["default"];

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = clearRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function clearRenderer() {
	return _react2['default'].createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

;
module.exports = exports['default'];

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _Cursor = __webpack_require__(2);

	var _Cursor2 = _interopRequireDefault(_Cursor);

	var _utils = __webpack_require__(4);

	var utils = _interopRequireWildcard(_utils);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Typist = function (_Component) {
	  _inherits(Typist, _Component);

	  function Typist(props) {
	    _classCallCheck(this, Typist);

	    var _this = _possibleConstructorReturn(this, (Typist.__proto__ || Object.getPrototypeOf(Typist)).call(this, props));

	    _this.state = {
	      text: [],
	      isDone: false
	    };

	    _this.onTypingDone = function () {
	      if (!_this.mounted) {
	        return;
	      }
	      _this.setState({ isDone: true });
	      _this.props.onTypingDone();
	    };

	    _this.delayGenerator = function (line, lineIdx, character, charIdx) {
	      var mean = _this.props.avgTypingDelay;
	      var std = _this.props.stdTypingDelay;
	      return _this.props.delayGenerator(mean, std, {
	        line: line,
	        lineIdx: lineIdx,
	        character: character,
	        charIdx: charIdx,
	        defDelayGenerator: function defDelayGenerator() {
	          var mn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mean;
	          var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : std;
	          return utils.gaussianRnd(mn, st);
	        }
	      });
	    };

	    _this.typeLine = function (line, lineIdx) {
	      if (!_this.mounted) {
	        return Promise.resolve();
	      }
	      var onLineTyped = _this.props.onLineTyped;


	      return new Promise(function (resolve, reject) {
	        _this.setState({ text: _this.state.text.concat(['']) }, function () {
	          utils.eachPromise(line, _this.typeCharacter, line, lineIdx).then(function () {
	            return onLineTyped(line, lineIdx);
	          }).then(resolve).catch(reject);
	        });
	      });
	    };

	    _this.typeCharacter = function (character, charIdx, line, lineIdx) {
	      if (!_this.mounted) {
	        return Promise.resolve();
	      }
	      var onCharacterTyped = _this.props.onCharacterTyped;


	      return new Promise(function (resolve) {
	        var text = _this.state.text.slice();
	        text[lineIdx] += character;
	        _this.setState({ text: text }, function () {
	          onCharacterTyped(character, charIdx);
	          var delay = _this.delayGenerator(line, lineIdx, character, charIdx);
	          setTimeout(resolve, delay);
	        });
	      });
	    };

	    _this.mounted = false;
	    _this.linesToType = [];

	    if (props.children) {
	      _this.linesToType = utils.extractText(props.children);
	    }
	    return _this;
	  }

	  _createClass(Typist, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      var _props = this.props;
	      var children = _props.children;
	      var startDelay = _props.startDelay;

	      if (children) {
	        if (startDelay > 0 && typeof window !== 'undefined') {
	          setTimeout(this.typeAllLines.bind(this), startDelay);
	        } else {
	          this.typeAllLines();
	        }
	      } else {
	        this.onTypingDone();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      for (var idx = 0; idx < nextState.text.length; idx++) {
	        var txt = this.state.text[idx];
	        var ntxt = nextState.text[idx];
	        if (txt !== ntxt && ntxt.length > 0) return true;
	      }
	      return this.state.isDone !== nextState.isDone;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'typeAllLines',
	    value: function typeAllLines() {
	      var _this2 = this;

	      var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.linesToType;

	      return utils.eachPromise(lines, this.typeLine).then(function () {
	        return _this2.onTypingDone();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var className = _props2.className;
	      var cursor = _props2.cursor;
	      var isDone = this.state.isDone;

	      var innerTree = utils.extractTreeWithText(this.props.children, this.state.text);

	      return _react2.default.createElement(
	        'div',
	        { className: 'Typist ' + className },
	        innerTree,
	        _react2.default.createElement(_Cursor2.default, _extends({ isDone: isDone }, cursor))
	      );
	    }
	  }]);

	  return Typist;
	}(_react.Component);

	Typist.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  avgTypingDelay: _react.PropTypes.number,
	  stdTypingDelay: _react.PropTypes.number,
	  startDelay: _react.PropTypes.number,
	  cursor: _react.PropTypes.object,
	  onCharacterTyped: _react.PropTypes.func,
	  onLineTyped: _react.PropTypes.func,
	  onTypingDone: _react.PropTypes.func,
	  delayGenerator: _react.PropTypes.func
	};
	Typist.defaultProps = {
	  className: '',
	  avgTypingDelay: 70,
	  stdTypingDelay: 25,
	  startDelay: 0,
	  cursor: {},
	  onCharacterTyped: function onCharacterTyped() {},
	  onLineTyped: function onLineTyped() {},
	  onTypingDone: function onTypingDone() {},
	  delayGenerator: utils.gaussianRnd
	};
	exports.default = Typist;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var Cursor = function (_Component) {
	  _inherits(Cursor, _Component);

	  function Cursor(props) {
	    _classCallCheck(this, Cursor);

	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, props));

	    _this._isReRenderingCursor = false;
	    _this.state = {
	      shouldRender: _this.props.show
	    };
	    return _this;
	  }

	  _createClass(Cursor, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;

	      var shouldHide = !this.props.isDone && nextProps.isDone && this.props.hideWhenDone;
	      if (shouldHide) {
	        setTimeout(function () {
	          return _this2.setState({ shouldRender: false });
	        }, this.props.hideWhenDoneDelay);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props;
	      var show = _props.show;
	      var isDone = _props.isDone;

	      if (!show) {
	        return;
	      }
	      if (isDone) {
	        return;
	      }
	      if (this._isReRenderingCursor) {
	        return;
	      }

	      // In webkit and blink, rendering the cursor alongside the text as it
	      // animates sometimes causes the text to stop rendering when it reaches
	      // a new line break, even though the underlying DOM /does/ contain
	      // the text. This seems to happen when the space available for the text is
	      // at a specific width that makes it so the line break happens within a
	      // word.
	      // Using dev tools, when in this state, if you modify the dom or any style,
	      // it immediately renders all of the text in its correct position.
	      // Given that observation, this is a hackish solutions that re-renders the
	      // cursor every time a character is rendered, just to ensure that the text
	      // is rendered correctly.
	      // See #13 and #15 for more details
	      this._reRenderCursor();
	    }
	  }, {
	    key: '_reRenderCursor',
	    value: function _reRenderCursor() {
	      var _this3 = this;

	      this._isReRenderingCursor = true;
	      this.setState({ shouldRender: false }, function () {
	        _this3.setState({ shouldRender: true }, function () {
	          _this3._isReRenderingCursor = false;
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.shouldRender) {
	        var className = this.props.blink ? ' Cursor--blinking' : '';
	        return _react2.default.createElement(
	          'span',
	          { className: 'Cursor' + className },
	          this.props.element
	        );
	      }
	      return null;
	    }
	  }]);

	  return Cursor;
	}(_react.Component);

	Cursor.propTypes = {
	  blink: _react.PropTypes.bool,
	  show: _react.PropTypes.bool,
	  element: _react.PropTypes.node,
	  hideWhenDone: _react.PropTypes.bool,
	  hideWhenDoneDelay: _react.PropTypes.number,
	  isDone: _react.PropTypes.bool
	};
	Cursor.defaultProps = {
	  blink: true,
	  show: true,
	  element: '|',
	  hideWhenDone: false,
	  hideWhenDoneDelay: 1000,
	  isDone: false
	};
	exports.default = Cursor;

/***/ },
/* 3 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sleep = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	exports.gaussianRnd = gaussianRnd;
	exports.eachPromise = eachPromise;
	exports.exclude = exclude;
	exports.extractText = extractText;
	exports.elementFactoryMaker = elementFactoryMaker;
	exports.extractTreeWithText = extractTreeWithText;

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var sleep = exports.sleep = function sleep(val) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, val);
	  });
	};

	function gaussianRnd(mean, std) {
	  var times = 12;
	  var sum = 0;
	  for (var idx = 0; idx < times; idx++) {
	    sum += Math.random();
	  }
	  sum -= times / 2;
	  return Math.round(sum * std) + mean;
	}

	function eachPromise(arr, iterator) {
	  for (var _len = arguments.length, extraArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    extraArgs[_key - 2] = arguments[_key];
	  }

	  var promiseReducer = function promiseReducer(prev, current, idx) {
	    return prev.then(function () {
	      return iterator.apply(undefined, [current, idx].concat(extraArgs));
	    });
	  };
	  return Array.from(arr).reduce(promiseReducer, Promise.resolve());
	}

	function exclude(obj, keys) {
	  var res = {};
	  for (var key in obj) {
	    if (keys.indexOf(key) === -1) {
	      res[key] = obj[key];
	    }
	  }
	  return res;
	}

	function extractText(toType) {
	  var st = toType ? [toType] : [];
	  var lines = [];

	  while (st.length > 0) {
	    var cur = st.pop();

	    if (_react2.default.isValidElement(cur)) {
	      _react2.default.Children.forEach(cur.props.children, function (child) {
	        st.push(child);
	      });
	    } else {
	      if (Array.isArray(cur)) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;

	        try {
	          for (var _iterator = cur[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var el = _step.value;

	            st.push(el);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else {
	        lines.unshift(cur);
	      }
	    }
	  }
	  return lines;
	}

	function elementFactoryMaker() {
	  var key = 0;
	  return function (el) {
	    var tag = el.type;
	    var props = exclude(el.props, ['children']);
	    props.key = 'Typist-el-' + key++;
	    return _react2.default.createElement.bind(null, tag, props);
	  };
	}

	function extractTreeWithText() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }

	  if (!args[0]) return void 0;
	  var factMaker = elementFactoryMaker();

	  var inner = function inner(tree, text, textIdx) {
	    if (textIdx >= text.length) return [null, textIdx];
	    var idx = textIdx;
	    var recurse = function recurse(ch) {
	      var _inner = inner(ch, text, idx);

	      var _inner2 = _slicedToArray(_inner, 2);

	      var child = _inner2[0];
	      var advIdx = _inner2[1];

	      idx = advIdx;
	      return child;
	    };

	    // Recursively call on children of React Element
	    if (_react2.default.isValidElement(tree)) {
	      var fact = factMaker(tree);
	      var children = _react2.default.Children.map(tree.props.children, recurse) || [];
	      return [fact.apply(undefined, _toConsumableArray(children)), idx];
	    }

	    // Recursively call on array
	    if (Array.isArray(tree)) {
	      var _children = tree.map(recurse);
	      return [_children, idx];
	    }

	    // Return text
	    return [text[idx], idx + 1];
	  };
	  return inner.apply(undefined, args.concat([0]))[0];
	}

/***/ }
/******/ ]);

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(89);

var invariant = __webpack_require__(5);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(1066);
var ReactElement = __webpack_require__(88);

var emptyFunction = __webpack_require__(32);
var traverseAllChildren = __webpack_require__(1077);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(89),
    _assign = __webpack_require__(13);

var ReactComponent = __webpack_require__(210);
var ReactElement = __webpack_require__(88);
var ReactPropTypeLocationNames = __webpack_require__(1070);
var ReactNoopUpdateQueue = __webpack_require__(211);

var emptyObject = __webpack_require__(79);
var invariant = __webpack_require__(5);
var warning = __webpack_require__(7);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

var didWarnDeprecated = false;

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
      didWarnDeprecated = true;
    }

    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(88);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(88),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(332);

module.exports = factory(isValidElement);

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(13);

var ReactComponent = __webpack_require__(210);
var ReactNoopUpdateQueue = __webpack_require__(211);

var emptyObject = __webpack_require__(79);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(89);

var ReactElement = __webpack_require__(88);

var invariant = __webpack_require__(5);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(89);

var ReactCurrentOwner = __webpack_require__(47);
var REACT_ELEMENT_TYPE = __webpack_require__(365);

var getIteratorFn = __webpack_require__(1074);
var invariant = __webpack_require__(5);
var KeyEscapeUtils = __webpack_require__(1065);
var warning = __webpack_require__(7);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(64)))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Randomize the order of the elements in a given array.
 * @param {Array} arr - The given array.
 * @param {Object} [options] - Optional configuration options.
 * @param {Boolean} [options.copy] - Sets if should return a shuffled copy of the given array. By default it's a falsy value.
 * @param {Function} [options.rng] - Specifies a custom random number generator.
 * @returns {Array}
 */
function shuffle(arr, options) {

  if (!Array.isArray(arr)) {
    throw new Error('shuffle expect an array as parameter.');
  }

  options = options || {};

  var collection = arr,
      len = arr.length,
      rng = options.rng || Math.random,
      random,
      temp;

  if (options.copy === true) {
    collection = arr.slice();
  }

  while (len) {
    random = Math.floor(rng() * len);
    len -= 1;
    temp = collection[len];
    collection[len] = collection[random];
    collection[random] = temp;
  }

  return collection;
};

/**
 * Pick one or more random elements from the given array.
 * @param {Array} arr - The given array.
 * @param {Object} [options] - Optional configuration options.
 * @param {Number} [options.picks] - Specifies how many random elements you want to pick. By default it picks 1.
 * @param {Function} [options.rng] - Specifies a custom random number generator.
 * @returns {Object}
 */
shuffle.pick = function(arr, options) {

  if (!Array.isArray(arr)) {
    throw new Error('shuffle.pick() expect an array as parameter.');
  }

  options = options || {};

  var rng = options.rng || Math.random,
      picks = options.picks || 1;

  if (typeof picks === 'number' && picks !== 1) {
    var len = arr.length,
        collection = arr.slice(),
        random = [],
        index;

    while (picks && len) {
      index = Math.floor(rng() * len);
      random.push(collection[index]);
      collection.splice(index, 1);
      len -= 1;
      picks -= 1;
    }

    return random;
  }

  return arr[Math.floor(rng() * arr.length)];
};

/**
 * Expose
 */
module.exports = shuffle;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Spectrum Colorpicker v1.8.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

(function (factory) {
    "use strict";

    if (true) { // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(214)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof exports == "object" && typeof module == "object") { // CommonJS
        module.exports = factory(require('jquery'));
    }
    else { // Browser
        factory(jQuery);
    }
})(function($, undefined) {
    "use strict";

    var defaultOpts = {

        // Callbacks
        beforeShow: noop,
        move: noop,
        change: noop,
        show: noop,
        hide: noop,

        // Options
        color: false,
        flat: false,
        showInput: false,
        allowEmpty: false,
        showButtons: true,
        clickoutFiresChange: true,
        showInitial: false,
        showPalette: false,
        showPaletteOnly: false,
        hideAfterPaletteSelect: false,
        togglePaletteOnly: false,
        showSelectionPalette: true,
        localStorageKey: false,
        appendTo: "body",
        maxSelectionSize: 7,
        cancelText: "cancel",
        chooseText: "choose",
        togglePaletteMoreText: "more",
        togglePaletteLessText: "less",
        clearText: "Clear Color Selection",
        noColorSelectedText: "No Color Selected",
        preferredFormat: false,
        className: "", // Deprecated - use containerClassName and replacerClassName instead.
        containerClassName: "",
        replacerClassName: "",
        showAlpha: false,
        theme: "sp-light",
        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
        selectionPalette: [],
        disabled: false,
        offset: null
    },
    spectrums = [],
    IE = !!/msie/i.exec( window.navigator.userAgent ),
    rgbaSupport = (function() {
        function contains( str, substr ) {
            return !!~('' + str).indexOf(substr);
        }

        var elem = document.createElement('div');
        var style = elem.style;
        style.cssText = 'background-color:rgba(0,0,0,.5)';
        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
    })(),
    replaceInput = [
        "<div class='sp-replacer'>",
            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
            "<div class='sp-dd'>&#9660;</div>",
        "</div>"
    ].join(''),
    markup = (function () {

        // IE does not support gradients with multiple stops, so we need to simulate
        //  that for the rainbow slider with 8 divs that each have a single gradient
        var gradientFix = "";
        if (IE) {
            for (var i = 1; i <= 6; i++) {
                gradientFix += "<div class='sp-" + i + "'></div>";
            }
        }

        return [
            "<div class='sp-container sp-hidden'>",
                "<div class='sp-palette-container'>",
                    "<div class='sp-palette sp-thumb sp-cf'></div>",
                    "<div class='sp-palette-button-container sp-cf'>",
                        "<button type='button' class='sp-palette-toggle'></button>",
                    "</div>",
                "</div>",
                "<div class='sp-picker-container'>",
                    "<div class='sp-top sp-cf'>",
                        "<div class='sp-fill'></div>",
                        "<div class='sp-top-inner'>",
                            "<div class='sp-color'>",
                                "<div class='sp-sat'>",
                                    "<div class='sp-val'>",
                                        "<div class='sp-dragger'></div>",
                                    "</div>",
                                "</div>",
                            "</div>",
                            "<div class='sp-clear sp-clear-display'>",
                            "</div>",
                            "<div class='sp-hue'>",
                                "<div class='sp-slider'></div>",
                                gradientFix,
                            "</div>",
                        "</div>",
                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
                    "</div>",
                    "<div class='sp-input-container sp-cf'>",
                        "<input class='sp-input' type='text' spellcheck='false'  />",
                    "</div>",
                    "<div class='sp-initial sp-thumb sp-cf'></div>",
                    "<div class='sp-button-container sp-cf'>",
                        "<a class='sp-cancel' href='#'></a>",
                        "<button type='button' class='sp-choose'></button>",
                    "</div>",
                "</div>",
            "</div>"
        ].join("");
    })();

    function paletteTemplate (p, color, className, opts) {
        var html = [];
        for (var i = 0; i < p.length; i++) {
            var current = p[i];
            if(current) {
                var tiny = tinycolor(current);
                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
                var formattedString = tiny.toString(opts.preferredFormat || "rgb");
                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
            } else {
                var cls = 'sp-clear-display';
                html.push($('<div />')
                    .append($('<span data-color="" style="background-color:transparent;" class="' + cls + '"></span>')
                        .attr('title', opts.noColorSelectedText)
                    )
                    .html()
                );
            }
        }
        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
    }

    function hideAll() {
        for (var i = 0; i < spectrums.length; i++) {
            if (spectrums[i]) {
                spectrums[i].hide();
            }
        }
    }

    function instanceOptions(o, callbackContext) {
        var opts = $.extend({}, defaultOpts, o);
        opts.callbacks = {
            'move': bind(opts.move, callbackContext),
            'change': bind(opts.change, callbackContext),
            'show': bind(opts.show, callbackContext),
            'hide': bind(opts.hide, callbackContext),
            'beforeShow': bind(opts.beforeShow, callbackContext)
        };

        return opts;
    }

    function spectrum(element, o) {

        var opts = instanceOptions(o, element),
            flat = opts.flat,
            showSelectionPalette = opts.showSelectionPalette,
            localStorageKey = opts.localStorageKey,
            theme = opts.theme,
            callbacks = opts.callbacks,
            resize = throttle(reflow, 10),
            visible = false,
            isDragging = false,
            dragWidth = 0,
            dragHeight = 0,
            dragHelperHeight = 0,
            slideHeight = 0,
            slideWidth = 0,
            alphaWidth = 0,
            alphaSlideHelperWidth = 0,
            slideHelperHeight = 0,
            currentHue = 0,
            currentSaturation = 0,
            currentValue = 0,
            currentAlpha = 1,
            palette = [],
            paletteArray = [],
            paletteLookup = {},
            selectionPalette = opts.selectionPalette.slice(0),
            maxSelectionSize = opts.maxSelectionSize,
            draggingClass = "sp-dragging",
            shiftMovementDirection = null;

        var doc = element.ownerDocument,
            body = doc.body,
            boundElement = $(element),
            disabled = false,
            container = $(markup, doc).addClass(theme),
            pickerContainer = container.find(".sp-picker-container"),
            dragger = container.find(".sp-color"),
            dragHelper = container.find(".sp-dragger"),
            slider = container.find(".sp-hue"),
            slideHelper = container.find(".sp-slider"),
            alphaSliderInner = container.find(".sp-alpha-inner"),
            alphaSlider = container.find(".sp-alpha"),
            alphaSlideHelper = container.find(".sp-alpha-handle"),
            textInput = container.find(".sp-input"),
            paletteContainer = container.find(".sp-palette"),
            initialColorContainer = container.find(".sp-initial"),
            cancelButton = container.find(".sp-cancel"),
            clearButton = container.find(".sp-clear"),
            chooseButton = container.find(".sp-choose"),
            toggleButton = container.find(".sp-palette-toggle"),
            isInput = boundElement.is("input"),
            isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
            shouldReplace = isInput && !flat,
            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
            offsetElement = (shouldReplace) ? replacer : boundElement,
            previewElement = replacer.find(".sp-preview-inner"),
            initialColor = opts.color || (isInput && boundElement.val()),
            colorOnShow = false,
            currentPreferredFormat = opts.preferredFormat,
            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
            isEmpty = !initialColor,
            allowEmpty = opts.allowEmpty && !isInputTypeColor;

        function applyOptions() {

            if (opts.showPaletteOnly) {
                opts.showPalette = true;
            }

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

            if (opts.palette) {
                palette = opts.palette.slice(0);
                paletteArray = $.isArray(palette[0]) ? palette : [palette];
                paletteLookup = {};
                for (var i = 0; i < paletteArray.length; i++) {
                    for (var j = 0; j < paletteArray[i].length; j++) {
                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
                        paletteLookup[rgb] = true;
                    }
                }
            }

            container.toggleClass("sp-flat", flat);
            container.toggleClass("sp-input-disabled", !opts.showInput);
            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
            container.toggleClass("sp-clear-enabled", allowEmpty);
            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
            container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
            container.toggleClass("sp-palette-disabled", !opts.showPalette);
            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
            container.toggleClass("sp-initial-disabled", !opts.showInitial);
            container.addClass(opts.className).addClass(opts.containerClassName);

            reflow();
        }

        function initialize() {

            if (IE) {
                container.find("*:not(input)").attr("unselectable", "on");
            }

            applyOptions();

            if (shouldReplace) {
                boundElement.after(replacer).hide();
            }

            if (!allowEmpty) {
                clearButton.hide();
            }

            if (flat) {
                boundElement.after(container).hide();
            }
            else {

                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
                if (appendTo.length !== 1) {
                    appendTo = $("body");
                }

                appendTo.append(container);
            }

            updateSelectionPaletteFromStorage();

            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
                if (!disabled) {
                    toggle();
                }

                e.stopPropagation();

                if (!$(e.target).is("input")) {
                    e.preventDefault();
                }
            });

            if(boundElement.is(":disabled") || (opts.disabled === true)) {
                disable();
            }

            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
            container.click(stopPropagation);

            // Handle user typed input
            textInput.change(setFromTextInput);
            textInput.bind("paste", function () {
                setTimeout(setFromTextInput, 1);
            });
            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });

            cancelButton.text(opts.cancelText);
            cancelButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                revert();
                hide();
            });

            clearButton.attr("title", opts.clearText);
            clearButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();
                isEmpty = true;
                move();

                if(flat) {
                    //for the flat style, this is a change event
                    updateOriginalInput(true);
                }
            });

            chooseButton.text(opts.chooseText);
            chooseButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                if (IE && textInput.is(":focus")) {
                    textInput.trigger('change');
                }

                if (isValid()) {
                    updateOriginalInput(true);
                    hide();
                }
            });

            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
            toggleButton.bind("click.spectrum", function (e) {
                e.stopPropagation();
                e.preventDefault();

                opts.showPaletteOnly = !opts.showPaletteOnly;

                // To make sure the Picker area is drawn on the right, next to the
                // Palette area (and not below the palette), first move the Palette
                // to the left to make space for the picker, plus 5px extra.
                // The 'applyOptions' function puts the whole container back into place
                // and takes care of the button-text and the sp-palette-only CSS class.
                if (!opts.showPaletteOnly && !flat) {
                    container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
                }
                applyOptions();
            });

            draggable(alphaSlider, function (dragX, dragY, e) {
                currentAlpha = (dragX / alphaWidth);
                isEmpty = false;
                if (e.shiftKey) {
                    currentAlpha = Math.round(currentAlpha * 10) / 10;
                }

                move();
            }, dragStart, dragStop);

            draggable(slider, function (dragX, dragY) {
                currentHue = parseFloat(dragY / slideHeight);
                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }
                move();
            }, dragStart, dragStop);

            draggable(dragger, function (dragX, dragY, e) {

                // shift+drag should snap the movement to either the x or y axis.
                if (!e.shiftKey) {
                    shiftMovementDirection = null;
                }
                else if (!shiftMovementDirection) {
                    var oldDragX = currentSaturation * dragWidth;
                    var oldDragY = dragHeight - (currentValue * dragHeight);
                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

                    shiftMovementDirection = furtherFromX ? "x" : "y";
                }

                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

                if (setSaturation) {
                    currentSaturation = parseFloat(dragX / dragWidth);
                }
                if (setValue) {
                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
                }

                isEmpty = false;
                if (!opts.showAlpha) {
                    currentAlpha = 1;
                }

                move();

            }, dragStart, dragStop);

            if (!!initialColor) {
                set(initialColor);

                // In case color was black - update the preview UI and set the format
                // since the set function will not run (default color is black).
                updateUI();
                currentPreferredFormat = opts.preferredFormat || tinycolor(initialColor).format;

                addColorToSelectionPalette(initialColor);
            }
            else {
                updateUI();
            }

            if (flat) {
                show();
            }

            function paletteElementClick(e) {
                if (e.data && e.data.ignore) {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                }
                else {
                    set($(e.target).closest(".sp-thumb-el").data("color"));
                    move();
                    updateOriginalInput(true);
                    if (opts.hideAfterPaletteSelect) {
                      hide();
                    }
                }

                return false;
            }

            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            paletteContainer.delegate(".sp-thumb-el", paletteEvent, paletteElementClick);
            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, paletteElementClick);
        }

        function updateSelectionPaletteFromStorage() {

            if (localStorageKey && window.localStorage) {

                // Migrate old palettes over to new format.  May want to remove this eventually.
                try {
                    var oldPalette = window.localStorage[localStorageKey].split(",#");
                    if (oldPalette.length > 1) {
                        delete window.localStorage[localStorageKey];
                        $.each(oldPalette, function(i, c) {
                             addColorToSelectionPalette(c);
                        });
                    }
                }
                catch(e) { }

                try {
                    selectionPalette = window.localStorage[localStorageKey].split(";");
                }
                catch (e) { }
            }
        }

        function addColorToSelectionPalette(color) {
            if (showSelectionPalette) {
                var rgb = tinycolor(color).toRgbString();
                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
                    selectionPalette.push(rgb);
                    while(selectionPalette.length > maxSelectionSize) {
                        selectionPalette.shift();
                    }
                }

                if (localStorageKey && window.localStorage) {
                    try {
                        window.localStorage[localStorageKey] = selectionPalette.join(";");
                    }
                    catch(e) { }
                }
            }
        }

        function getUniqueSelectionPalette() {
            var unique = [];
            if (opts.showPalette) {
                for (var i = 0; i < selectionPalette.length; i++) {
                    var rgb = tinycolor(selectionPalette[i]).toRgbString();

                    if (!paletteLookup[rgb]) {
                        unique.push(selectionPalette[i]);
                    }
                }
            }

            return unique.reverse().slice(0, opts.maxSelectionSize);
        }

        function drawPalette() {

            var currentColor = get();

            var html = $.map(paletteArray, function (palette, i) {
                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
            });

            updateSelectionPaletteFromStorage();

            if (selectionPalette) {
                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
            }

            paletteContainer.html(html.join(""));
        }

        function drawInitial() {
            if (opts.showInitial) {
                var initial = colorOnShow;
                var current = get();
                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
            }
        }

        function dragStart() {
            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
                reflow();
            }
            isDragging = true;
            container.addClass(draggingClass);
            shiftMovementDirection = null;
            boundElement.trigger('dragstart.spectrum', [ get() ]);
        }

        function dragStop() {
            isDragging = false;
            container.removeClass(draggingClass);
            boundElement.trigger('dragstop.spectrum', [ get() ]);
        }

        function setFromTextInput() {

            var value = textInput.val();

            if ((value === null || value === "") && allowEmpty) {
                set(null);
                updateOriginalInput(true);
            }
            else {
                var tiny = tinycolor(value);
                if (tiny.isValid()) {
                    set(tiny);
                    updateOriginalInput(true);
                }
                else {
                    textInput.addClass("sp-validation-error");
                }
            }
        }

        function toggle() {
            if (visible) {
                hide();
            }
            else {
                show();
            }
        }

        function show() {
            var event = $.Event('beforeShow.spectrum');

            if (visible) {
                reflow();
                return;
            }

            boundElement.trigger(event, [ get() ]);

            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
                return;
            }

            hideAll();
            visible = true;

            $(doc).bind("keydown.spectrum", onkeydown);
            $(doc).bind("click.spectrum", clickout);
            $(window).bind("resize.spectrum", resize);
            replacer.addClass("sp-active");
            container.removeClass("sp-hidden");

            reflow();
            updateUI();

            colorOnShow = get();

            drawInitial();
            callbacks.show(colorOnShow);
            boundElement.trigger('show.spectrum', [ colorOnShow ]);
        }

        function onkeydown(e) {
            // Close on ESC
            if (e.keyCode === 27) {
                hide();
            }
        }

        function clickout(e) {
            // Return on right click.
            if (e.button == 2) { return; }

            // If a drag event was happening during the mouseup, don't hide
            // on click.
            if (isDragging) { return; }

            if (clickoutFiresChange) {
                updateOriginalInput(true);
            }
            else {
                revert();
            }
            hide();
        }

        function hide() {
            // Return if hiding is unnecessary
            if (!visible || flat) { return; }
            visible = false;

            $(doc).unbind("keydown.spectrum", onkeydown);
            $(doc).unbind("click.spectrum", clickout);
            $(window).unbind("resize.spectrum", resize);

            replacer.removeClass("sp-active");
            container.addClass("sp-hidden");

            callbacks.hide(get());
            boundElement.trigger('hide.spectrum', [ get() ]);
        }

        function revert() {
            set(colorOnShow, true);
        }

        function set(color, ignoreFormatChange) {
            if (tinycolor.equals(color, get())) {
                // Update UI just in case a validation error needs
                // to be cleared.
                updateUI();
                return;
            }

            var newColor, newHsv;
            if (!color && allowEmpty) {
                isEmpty = true;
            } else {
                isEmpty = false;
                newColor = tinycolor(color);
                newHsv = newColor.toHsv();

                currentHue = (newHsv.h % 360) / 360;
                currentSaturation = newHsv.s;
                currentValue = newHsv.v;
                currentAlpha = newHsv.a;
            }
            updateUI();

            if (newColor && newColor.isValid() && !ignoreFormatChange) {
                currentPreferredFormat = opts.preferredFormat || newColor.getFormat();
            }
        }

        function get(opts) {
            opts = opts || { };

            if (allowEmpty && isEmpty) {
                return null;
            }

            return tinycolor.fromRatio({
                h: currentHue,
                s: currentSaturation,
                v: currentValue,
                a: Math.round(currentAlpha * 100) / 100
            }, { format: opts.format || currentPreferredFormat });
        }

        function isValid() {
            return !textInput.hasClass("sp-validation-error");
        }

        function move() {
            updateUI();

            callbacks.move(get());
            boundElement.trigger('move.spectrum', [ get() ]);
        }

        function updateUI() {

            textInput.removeClass("sp-validation-error");

            updateHelperLocations();

            // Update dragger background color (gradients take care of saturation and value).
            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
            dragger.css("background-color", flatColor.toHexString());

            // Get a format that alpha will be included in (hex and names ignore alpha)
            var format = currentPreferredFormat;
            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
                    format = "rgb";
                }
            }

            var realColor = get({ format: format }),
                displayColor = '';

             //reset background info for preview element
            previewElement.removeClass("sp-clear-display");
            previewElement.css('background-color', 'transparent');

            if (!realColor && allowEmpty) {
                // Update the replaced elements background with icon indicating no color selection
                previewElement.addClass("sp-clear-display");
            }
            else {
                var realHex = realColor.toHexString(),
                    realRgb = realColor.toRgbString();

                // Update the replaced elements background color (with actual selected color)
                if (rgbaSupport || realColor.alpha === 1) {
                    previewElement.css("background-color", realRgb);
                }
                else {
                    previewElement.css("background-color", "transparent");
                    previewElement.css("filter", realColor.toFilter());
                }

                if (opts.showAlpha) {
                    var rgb = realColor.toRgb();
                    rgb.a = 0;
                    var realAlpha = tinycolor(rgb).toRgbString();
                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

                    if (IE) {
                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
                    }
                    else {
                        alphaSliderInner.css("background", "-webkit-" + gradient);
                        alphaSliderInner.css("background", "-moz-" + gradient);
                        alphaSliderInner.css("background", "-ms-" + gradient);
                        // Use current syntax gradient on unprefixed property.
                        alphaSliderInner.css("background",
                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
                    }
                }

                displayColor = realColor.toString(format);
            }

            // Update the text entry input as it changes happen
            if (opts.showInput) {
                textInput.val(displayColor);
            }

            if (opts.showPalette) {
                drawPalette();
            }

            drawInitial();
        }

        function updateHelperLocations() {
            var s = currentSaturation;
            var v = currentValue;

            if(allowEmpty && isEmpty) {
                //if selected color is empty, hide the helpers
                alphaSlideHelper.hide();
                slideHelper.hide();
                dragHelper.hide();
            }
            else {
                //make sure helpers are visible
                alphaSlideHelper.show();
                slideHelper.show();
                dragHelper.show();

                // Where to show the little circle in that displays your current selected color
                var dragX = s * dragWidth;
                var dragY = dragHeight - (v * dragHeight);
                dragX = Math.max(
                    -dragHelperHeight,
                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
                );
                dragY = Math.max(
                    -dragHelperHeight,
                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
                );
                dragHelper.css({
                    "top": dragY + "px",
                    "left": dragX + "px"
                });

                var alphaX = currentAlpha * alphaWidth;
                alphaSlideHelper.css({
                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
                });

                // Where to show the bar that displays your current selected hue
                var slideY = (currentHue) * slideHeight;
                slideHelper.css({
                    "top": (slideY - slideHelperHeight) + "px"
                });
            }
        }

        function updateOriginalInput(fireCallback) {
            var color = get(),
                displayColor = '',
                hasChanged = !tinycolor.equals(color, colorOnShow);

            if (color) {
                displayColor = color.toString(currentPreferredFormat);
                // Update the selection palette with the current color
                addColorToSelectionPalette(color);
            }

            if (isInput) {
                boundElement.val(displayColor);
            }

            if (fireCallback && hasChanged) {
                callbacks.change(color);
                boundElement.trigger('change', [ color ]);
            }
        }

        function reflow() {
            if (!visible) {
                return; // Calculations would be useless and wouldn't be reliable anyways
            }
            dragWidth = dragger.width();
            dragHeight = dragger.height();
            dragHelperHeight = dragHelper.height();
            slideWidth = slider.width();
            slideHeight = slider.height();
            slideHelperHeight = slideHelper.height();
            alphaWidth = alphaSlider.width();
            alphaSlideHelperWidth = alphaSlideHelper.width();

            if (!flat) {
                container.css("position", "absolute");
                if (opts.offset) {
                    container.offset(opts.offset);
                } else {
                    container.offset(getOffset(container, offsetElement));
                }
            }

            updateHelperLocations();

            if (opts.showPalette) {
                drawPalette();
            }

            boundElement.trigger('reflow.spectrum');
        }

        function destroy() {
            boundElement.show();
            offsetElement.unbind("click.spectrum touchstart.spectrum");
            container.remove();
            replacer.remove();
            spectrums[spect.id] = null;
        }

        function option(optionName, optionValue) {
            if (optionName === undefined) {
                return $.extend({}, opts);
            }
            if (optionValue === undefined) {
                return opts[optionName];
            }

            opts[optionName] = optionValue;

            if (optionName === "preferredFormat") {
                currentPreferredFormat = opts.preferredFormat;
            }
            applyOptions();
        }

        function enable() {
            disabled = false;
            boundElement.attr("disabled", false);
            offsetElement.removeClass("sp-disabled");
        }

        function disable() {
            hide();
            disabled = true;
            boundElement.attr("disabled", true);
            offsetElement.addClass("sp-disabled");
        }

        function setOffset(coord) {
            opts.offset = coord;
            reflow();
        }

        initialize();

        var spect = {
            show: show,
            hide: hide,
            toggle: toggle,
            reflow: reflow,
            option: option,
            enable: enable,
            disable: disable,
            offset: setOffset,
            set: function (c) {
                set(c);
                updateOriginalInput();
            },
            get: get,
            destroy: destroy,
            container: container
        };

        spect.id = spectrums.push(spect) - 1;

        return spect;
    }

    /**
    * checkOffset - get the offset below/above and left/right element depending on screen position
    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
    */
    function getOffset(picker, input) {
        var extraY = 0;
        var dpWidth = picker.outerWidth();
        var dpHeight = picker.outerHeight();
        var inputHeight = input.outerHeight();
        var doc = picker[0].ownerDocument;
        var docElem = doc.documentElement;
        var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
        var viewHeight = docElem.clientHeight + $(doc).scrollTop();
        var offset = input.offset();
        offset.top += inputHeight;

        offset.left -=
            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
            Math.abs(offset.left + dpWidth - viewWidth) : 0);

        offset.top -=
            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
            Math.abs(dpHeight + inputHeight - extraY) : extraY));

        return offset;
    }

    /**
    * noop - do nothing
    */
    function noop() {

    }

    /**
    * stopPropagation - makes the code only doing this a little easier to read in line
    */
    function stopPropagation(e) {
        e.stopPropagation();
    }

    /**
    * Create a function bound to a given object
    * Thanks to underscore.js
    */
    function bind(func, obj) {
        var slice = Array.prototype.slice;
        var args = slice.call(arguments, 2);
        return function () {
            return func.apply(obj, args.concat(slice.call(arguments)));
        };
    }

    /**
    * Lightweight drag helper.  Handles containment within the element, so that
    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
    */
    function draggable(element, onmove, onstart, onstop) {
        onmove = onmove || function () { };
        onstart = onstart || function () { };
        onstop = onstop || function () { };
        var doc = document;
        var dragging = false;
        var offset = {};
        var maxHeight = 0;
        var maxWidth = 0;
        var hasTouch = ('ontouchstart' in window);

        var duringDragEvents = {};
        duringDragEvents["selectstart"] = prevent;
        duringDragEvents["dragstart"] = prevent;
        duringDragEvents["touchmove mousemove"] = move;
        duringDragEvents["touchend mouseup"] = stop;

        function prevent(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.returnValue = false;
        }

        function move(e) {
            if (dragging) {
                // Mouseup happened outside of window
                if (IE && doc.documentMode < 9 && !e.button) {
                    return stop();
                }

                var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
                var pageX = t0 && t0.pageX || e.pageX;
                var pageY = t0 && t0.pageY || e.pageY;

                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

                if (hasTouch) {
                    // Stop scrolling in iOS
                    prevent(e);
                }

                onmove.apply(element, [dragX, dragY, e]);
            }
        }

        function start(e) {
            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

            if (!rightclick && !dragging) {
                if (onstart.apply(element, arguments) !== false) {
                    dragging = true;
                    maxHeight = $(element).height();
                    maxWidth = $(element).width();
                    offset = $(element).offset();

                    $(doc).bind(duringDragEvents);
                    $(doc.body).addClass("sp-dragging");

                    move(e);

                    prevent(e);
                }
            }
        }

        function stop() {
            if (dragging) {
                $(doc).unbind(duringDragEvents);
                $(doc.body).removeClass("sp-dragging");

                // Wait a tick before notifying observers to allow the click event
                // to fire in Chrome.
                setTimeout(function() {
                    onstop.apply(element, arguments);
                }, 0);
            }
            dragging = false;
        }

        $(element).bind("touchstart mousedown", start);
    }

    function throttle(func, wait, debounce) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var throttler = function () {
                timeout = null;
                func.apply(context, args);
            };
            if (debounce) clearTimeout(timeout);
            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
        };
    }

    function inputTypeColorSupport() {
        return $.fn.spectrum.inputTypeColorSupport();
    }

    /**
    * Define a jQuery plugin
    */
    var dataID = "spectrum.id";
    $.fn.spectrum = function (opts, extra) {

        if (typeof opts == "string") {

            var returnValue = this;
            var args = Array.prototype.slice.call( arguments, 1 );

            this.each(function () {
                var spect = spectrums[$(this).data(dataID)];
                if (spect) {
                    var method = spect[opts];
                    if (!method) {
                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
                    }

                    if (opts == "get") {
                        returnValue = spect.get();
                    }
                    else if (opts == "container") {
                        returnValue = spect.container;
                    }
                    else if (opts == "option") {
                        returnValue = spect.option.apply(spect, args);
                    }
                    else if (opts == "destroy") {
                        spect.destroy();
                        $(this).removeData(dataID);
                    }
                    else {
                        method.apply(spect, args);
                    }
                }
            });

            return returnValue;
        }

        // Initializing a new instance of spectrum
        return this.spectrum("destroy").each(function () {
            var options = $.extend({}, opts, $(this).data());
            var spect = spectrum(this, options);
            $(this).data(dataID, spect.id);
        });
    };

    $.fn.spectrum.load = true;
    $.fn.spectrum.loadOpts = {};
    $.fn.spectrum.draggable = draggable;
    $.fn.spectrum.defaults = defaultOpts;
    $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
        if (typeof inputTypeColorSupport._cachedResult === "undefined") {
            var colorInput = $("<input type='color'/>")[0]; // if color element is supported, value will default to not null
            inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "";
        }
        return inputTypeColorSupport._cachedResult;
    };

    $.spectrum = { };
    $.spectrum.localization = { };
    $.spectrum.palettes = { };

    $.fn.spectrum.processNativeColorInputs = function () {
        var colorInputs = $("input[type=color]");
        if (colorInputs.length && !inputTypeColorSupport()) {
            colorInputs.spectrum({
                preferredFormat: "hex6"
            });
        }
    };

    // TinyColor v1.1.2
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License

    (function() {

    var trimLeft = /^[\s,#]+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        math = Math,
        mathRound = math.round,
        mathMin = math.min,
        mathMax = math.max,
        mathRandom = math.random;

    var tinycolor = function(color, opts) {

        color = (color) ? color : '';
        opts = opts || { };

        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) {
           return color;
        }
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
        }

        var rgb = inputToRGB(color);
        this._originalInput = color,
        this._r = rgb.r,
        this._g = rgb.g,
        this._b = rgb.b,
        this._a = rgb.a,
        this._roundA = mathRound(100*this._a) / 100,
        this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;

        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) { this._r = mathRound(this._r); }
        if (this._g < 1) { this._g = mathRound(this._g); }
        if (this._b < 1) { this._b = mathRound(this._b); }

        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    };

    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100*this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return (this._a == 1) ?
              "hsv("  + h + ", " + s + "%, " + v + "%)" :
              "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return (this._a == 1) ?
              "hsl("  + h + ", " + s + "%, " + l + "%)" :
              "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return '#' + this.toHex(allow3Char);
        },
        toHex8: function() {
            return rgbaToHex(this._r, this._g, this._b, this._a);
        },
        toHex8String: function() {
            return '#' + this.toHex8();
        },
        toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
              "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
            return (this._a == 1) ?
              "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
              "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) {
                return "transparent";
            }

            if (this._a < 1) {
                return false;
            }

            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";

            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = s.toHex8String();
            }

            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;

            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }

            return formattedString || this.toHexString();
        },

        _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },

        _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
                if (color.hasOwnProperty(i)) {
                    if (i === "a") {
                        newColor[i] = color[i];
                    }
                    else {
                        newColor[i] = convertToPercentage(color[i]);
                    }
                }
            }
            color = newColor;
        }

        return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {

        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var ok = false;
        var format = false;

        if (typeof color == "string") {
            color = stringInputToObject(color);
        }

        if (typeof color == "object") {
            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
                color.s = convertToPercentage(color.s);
                color.v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, color.s, color.v);
                ok = true;
                format = "hsv";
            }
            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
                color.s = convertToPercentage(color.s);
                color.l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, color.s, color.l);
                ok = true;
                format = "hsl";
            }

            if (color.hasOwnProperty("a")) {
                a = color.a;
            }
        }

        a = boundAlpha(a);

        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }


    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;

        if(max == min) {
            h = s = 0; // achromatic
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return { h: h, s: s, l: l };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;

        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);

        function hue2rgb(p, q, t) {
            if(t < 0) t += 1;
            if(t > 1) t -= 1;
            if(t < 1/6) return p + (q - p) * 6 * t;
            if(t < 1/2) return q;
            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }

        if(s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);

        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;

        var d = max - min;
        s = max === 0 ? 0 : d / max;

        if(max == min) {
            h = 0; // achromatic
        }
        else {
            switch(max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }
        return { h: h, s: s, v: v };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
     function hsvToRgb(h, s, v) {

        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);

        var i = math.floor(h),
            f = h - i,
            p = v * (1 - s),
            q = v * (1 - f * s),
            t = v * (1 - (1 - f) * s),
            mod = i % 6,
            r = [v, q, p, p, t, v][mod],
            g = [t, v, v, q, p, p][mod],
            b = [p, p, t, v, v, q][mod];

        return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];

        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }

        return hex.join("");
    }
        // `rgbaToHex`
        // Converts an RGBA color plus alpha transparency to hex
        // Assumes r, g, b and a are contained in the set [0, 255]
        // Returns an 8 character hex
        function rgbaToHex(r, g, b, a) {

            var hex = [
                pad2(convertDecimalToHex(a)),
                pad2(mathRound(r).toString(16)),
                pad2(mathRound(g).toString(16)),
                pad2(mathRound(b).toString(16))
            ];

            return hex.join("");
        }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
        if (!color1 || !color2) { return false; }
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };


    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function saturate(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }

    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    function brighten(color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
        return tinycolor(rgb);
    }

    function darken (color, amount) {
        amount = (amount === 0) ? 0 : (amount || 10);
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (mathRound(hsl.h) + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }

    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
    }

    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
        ];
    }

    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;

        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor(color)];

        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }

    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;

        while (results--) {
            ret.push(tinycolor({ h: h, s: s, v: v}));
            v = (v + modification) % 1;
        }

        return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function(color1, color2, amount) {
        amount = (amount === 0) ? 0 : (amount || 50);

        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();

        var p = amount / 100;
        var w = p * 2 - 1;
        var a = rgb2.a - rgb1.a;

        var w1;

        if (w * a == -1) {
            w1 = w;
        } else {
            w1 = (w + a) / (1 + w * a);
        }

        w1 = (w1 + 1) / 2;

        var w2 = 1 - w1;

        var rgba = {
            r: rgb2.r * w1 + rgb1.r * w2,
            g: rgb2.g * w1 + rgb1.g * w2,
            b: rgb2.b * w1 + rgb1.b * w2,
            a: rgb2.a * p  + rgb1.a * (1 - p)
        };

        return tinycolor(rgba);
    };


    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/AERT#color-contrast>

    // `readability`
    // Analyze the 2 colors and returns an object with the following properties:
    //    `brightness`: difference in brightness between the two colors
    //    `color`: difference in color/hue between the two colors
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        var rgb1 = c1.toRgb();
        var rgb2 = c2.toRgb();
        var brightnessA = c1.getBrightness();
        var brightnessB = c2.getBrightness();
        var colorDiff = (
            Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
            Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
            Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
        );

        return {
            brightness: Math.abs(brightnessA - brightnessB),
            color: colorDiff
        };
    };

    // `readable`
    // http://www.w3.org/TR/AERT#color-contrast
    // Ensure that foreground and background color combinations provide sufficient contrast.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    tinycolor.isReadable = function(color1, color2) {
        var readability = tinycolor.readability(color1, color2);
        return readability.brightness > 125 && readability.color > 500;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // *Example*
    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
    tinycolor.mostReadable = function(baseColor, colorList) {
        var bestColor = null;
        var bestScore = 0;
        var bestIsReadable = false;
        for (var i=0; i < colorList.length; i++) {

            // We normalize both around the "acceptable" breaking point,
            // but rank brightness constrast higher than hue.

            var readability = tinycolor.readability(baseColor, colorList[i]);
            var readable = readability.brightness > 125 && readability.color > 500;
            var score = 3 * (readability.brightness / 125) + (readability.color / 500);

            if ((readable && ! bestIsReadable) ||
                (readable && bestIsReadable && score > bestScore) ||
                ((! readable) && (! bestIsReadable) && score > bestScore)) {
                bestIsReadable = readable;
                bestScore = score;
                bestColor = tinycolor(colorList[i]);
            }
        }
        return bestColor;
    };


    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = { };
        for (var i in o) {
            if (o.hasOwnProperty(i)) {
                flipped[o[i]] = i;
            }
        }
        return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);

        if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
        }

        return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) { n = "100%"; }

        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));

        // Automatically convert percentage into number
        if (processPercent) {
            n = parseInt(n * max, 10) / 100;
        }

        // Handle floating point rounding errors
        if ((math.abs(n - max) < 0.000001)) {
            return 1;
        }

        // Convert into [0, 1] range if it isn't already
        return (n % max) / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) {
            n = (n * 100) + "%";
        }

        return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";

        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

        return {
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    })();

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        }
        else if (color == 'transparent') {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }

        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if ((match = matchers.rgb.exec(color))) {
            return { r: match[1], g: match[2], b: match[3] };
        }
        if ((match = matchers.rgba.exec(color))) {
            return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if ((match = matchers.hsl.exec(color))) {
            return { h: match[1], s: match[2], l: match[3] };
        }
        if ((match = matchers.hsla.exec(color))) {
            return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if ((match = matchers.hsv.exec(color))) {
            return { h: match[1], s: match[2], v: match[3] };
        }
        if ((match = matchers.hsva.exec(color))) {
            return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if ((match = matchers.hex8.exec(color))) {
            return {
                a: convertHexToDecimal(match[1]),
                r: parseIntFromHex(match[2]),
                g: parseIntFromHex(match[3]),
                b: parseIntFromHex(match[4]),
                format: named ? "name" : "hex8"
            };
        }
        if ((match = matchers.hex6.exec(color))) {
            return {
                r: parseIntFromHex(match[1]),
                g: parseIntFromHex(match[2]),
                b: parseIntFromHex(match[3]),
                format: named ? "name" : "hex"
            };
        }
        if ((match = matchers.hex3.exec(color))) {
            return {
                r: parseIntFromHex(match[1] + '' + match[1]),
                g: parseIntFromHex(match[2] + '' + match[2]),
                b: parseIntFromHex(match[3] + '' + match[3]),
                format: named ? "name" : "hex"
            };
        }

        return false;
    }

    window.tinycolor = tinycolor;
    })();

    $(function () {
        if ($.fn.spectrum.load) {
            $.fn.spectrum.processNativeColorInputs();
        }
    });

});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Check if `fn` is a function.
 *
 * @param {Function} fn
 * @return {Boolean}
 * @api private
 */
var isObject = __webpack_require__(212);

function isFunction(fn) {
  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
  return tag === '[object Function]';
}

module.exports = isFunction;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(212);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, read, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  return this;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
}

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on){
  // This is browser-only functionality. Node side is no-op.
  if(on==undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};


/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};


/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
}


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var utils = __webpack_require__(1085);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field){
    return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
module.exports = function shouldRetry(err, res) {
  if (err && err.code && ~ERROR_CODES.indexOf(err.code)) return true;
  if (res && res.status && res.status >= 500) return true;
  // Superagent timeout
  if (err && 'timeout' in err && err.code == 'ECONNABORTED') return true;
  if (err && 'crossDomain' in err) return true;
  return false;
};


/***/ }),
/* 1085 */
/***/ (function(module, exports) {


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, shouldStripCookie){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  if (shouldStripCookie) {
    delete header['cookie'];
  }
  return header;
};

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module Dependencies
 */

var expr;
try {
  expr = __webpack_require__(254);
} catch(e) {
  expr = __webpack_require__(254);
}

/**
 * Expose `toFunction()`.
 */

module.exports = toFunction;

/**
 * Convert `obj` to a `Function`.
 *
 * @param {Mixed} obj
 * @return {Function}
 * @api private
 */

function toFunction(obj) {
  switch ({}.toString.call(obj)) {
    case '[object Object]':
      return objectToFunction(obj);
    case '[object Function]':
      return obj;
    case '[object String]':
      return stringToFunction(obj);
    case '[object RegExp]':
      return regexpToFunction(obj);
    default:
      return defaultToFunction(obj);
  }
}

/**
 * Default to strict equality.
 *
 * @param {Mixed} val
 * @return {Function}
 * @api private
 */

function defaultToFunction(val) {
  return function(obj){
    return val === obj;
  };
}

/**
 * Convert `re` to a function.
 *
 * @param {RegExp} re
 * @return {Function}
 * @api private
 */

function regexpToFunction(re) {
  return function(obj){
    return re.test(obj);
  };
}

/**
 * Convert property `str` to a function.
 *
 * @param {String} str
 * @return {Function}
 * @api private
 */

function stringToFunction(str) {
  // immediate such as "> 20"
  if (/^ *\W+/.test(str)) return new Function('_', 'return _ ' + str);

  // properties such as "name.first" or "age > 18" or "age > 18 && age < 36"
  return new Function('_', 'return ' + get(str));
}

/**
 * Convert `object` to a function.
 *
 * @param {Object} object
 * @return {Function}
 * @api private
 */

function objectToFunction(obj) {
  var match = {};
  for (var key in obj) {
    match[key] = typeof obj[key] === 'string'
      ? defaultToFunction(obj[key])
      : toFunction(obj[key]);
  }
  return function(val){
    if (typeof val !== 'object') return false;
    for (var key in match) {
      if (!(key in val)) return false;
      if (!match[key](val[key])) return false;
    }
    return true;
  };
}

/**
 * Built the getter function. Supports getter style functions
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function get(str) {
  var props = expr(str);
  if (!props.length) return '_.' + str;

  var val, i, prop;
  for (i = 0; i < props.length; i++) {
    prop = props[i];
    val = '_.' + prop;
    val = "('function' == typeof " + val + " ? " + val + "() : " + val + ")";

    // mimic negative lookbehind to avoid problems with nested properties
    str = stripNested(prop, str, val);
  }

  return str;
}

/**
 * Mimic negative lookbehind to avoid problems with nested properties.
 *
 * See: http://blog.stevenlevithan.com/archives/mimic-lookbehind-javascript
 *
 * @param {String} prop
 * @param {String} str
 * @param {String} val
 * @return {String}
 * @api private
 */

function stripNested (prop, str, val) {
  return str.replace(new RegExp('(\\.)?' + prop, 'g'), function($0, $1) {
    return $1 ? $0 : val;
  });
}


/***/ }),
/* 1087 */
/***/ (function(module, exports) {


/**
 * Expose `toNoCase`.
 */

module.exports = toNoCase;


/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/;
var hasCamel = /[a-z][A-Z]/;
var hasSeparator = /[\W_]/;


/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase (string) {
  if (hasSpace.test(string)) return string.toLowerCase();

  if (hasSeparator.test(string)) string = unseparate(string);
  if (hasCamel.test(string)) string = uncamelize(string);
  return string.toLowerCase();
}


/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g;


/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate (string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : '';
  });
}


/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g;


/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize (string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ');
  });
}

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(1087);


/**
 * Expose `toSpaceCase`.
 */

module.exports = toSpaceCase;


/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */


function toSpaceCase (string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : '';
  });
}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1078);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(68),__webpack_require__(45),__webpack_require__(1)):"function"==typeof define&&define.amd?define(["classnames/bind","prop-types","react"],t):"object"==typeof exports?exports.Auth0WebsiteSubscriptionCenterPage=t(require("classnames/bind"),require("prop-types"),require("react")):e.Auth0WebsiteSubscriptionCenterPage=t(e["classnames/bind"],e["prop-types"],e.react)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}(function(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t))switch(typeof e[t]){case"function":break;case"object":e[t]=function(t){var n=t.slice(1),r=e[t[0]];return function(e,t,a){r.apply(this,[e,t,a].concat(n))}}(e[t]);break;default:e[t]=e[e[t]]}return e}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(9),o=r(a);t.default=o.default},function(e,t){e.exports=__webpack_require__(68)},function(e,t){e.exports=__webpack_require__(45)},function(e,t){e.exports=__webpack_require__(1)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=r(u),s=n(2),f=r(s),p=n(1),m=r(p),d=n(10),b=r(d),h=n(12),v=r(h),y=m.default.bind(b.default),_=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.saveEmail=function(e){e.preventDefault(),n.setState({email:n.emailInput.value},function(){n.props.onEmailChange(n.state.email)})},n.clearEmail=function(e){e.preventDefault(),n.setState({email:""},function(){n.props.onEmailChange(n.state.email)})},n.clearEmailInput=function(e){e.preventDefault(),n.emailInput.value=""},n.state={email:e.email||""},n}return l(t,e),i(t,[{key:"render",value:function(){var e=this,t=this.state.email,n=this.props.onUnsubscribeAllClick;return c.default.createElement("section",{className:y("email-form-section")},c.default.createElement("div",{className:"container"},c.default.createElement("form",{className:y("form-email")},t?c.default.createElement("span",{className:y("form-placeholder"),type:"text"},t):c.default.createElement("input",{className:y("form-input"),type:"text",placeholder:"user@user.com",ref:function(t){e.emailInput=t}}),c.default.createElement("div",{className:y("form-actions")},t?c.default.createElement("span",{className:y("button-wrapper")},"(not you?"," ",c.default.createElement("button",{className:y("form-edit"),onClick:this.clearEmail}," ","edit email"),")"):c.default.createElement("div",null,c.default.createElement("button",{className:y("form-save"),onClick:this.saveEmail},"(",c.default.createElement("span",null,"save"),")"),c.default.createElement("button",{className:y("form-clear"),dangerouslySetInnerHTML:{__html:v.default},onClick:this.clearEmailInput}))),c.default.createElement("button",{className:y("form-submit")+" btn btn-success btn-md",onClick:n,disabled:0===t.length},"Unsubscribe All"))))}}]),t}(u.Component);_.propTypes={email:f.default.string,onEmailChange:f.default.func.isRequired,onUnsubscribeAllClick:f.default.func.isRequired},t.default=_},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a=n(4),o=r(a);t.default=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.EmailForm=void 0;var a=n(5),o=r(a);t.EmailForm=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(3),c=r(u),s=n(2),f=r(s),p=n(1),m=r(p),d=n(6),b=n(11),h=r(b),v=m.default.bind(h.default),y=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.onUnsubscribeAllClick=function(e){e.preventDefault(),n.SubscriptionCenterInstance.unsubscribeFromAll()},n.onEmailChange=function(e){n.setState({email:e})},n.state={email:e.email||""},n}return l(t,e),i(t,[{key:"render",value:function(){var e=this,t=this.state.email,n=this.props.children;return c.default.createElement("div",null,c.default.createElement("div",{className:"jumbotron "+v("custom-jumbotron")},c.default.createElement("h2",null,c.default.createElement("img",{src:"https://cdn.auth0.com/blog/email-subs-icon.svg",role:"presentation"})),c.default.createElement("h1",null,"Email Subscription Center"),c.default.createElement("p",null,"Update your Auth0 subscription preferences below.")),c.default.createElement("div",{className:"widget-container"},c.default.createElement(d.EmailForm,{email:t,onUnsubscribeAllClick:this.onUnsubscribeAllClick,onEmailChange:this.onEmailChange}),c.default.createElement("div",{className:"container "+v("container-margin")},(0,u.cloneElement)(n,{email:t,ref:function(t){e.SubscriptionCenterInstance=t}}))))}}]),t}(u.Component);y.propTypes={email:f.default.string,children:f.default.node.isRequired},t.default=y},[13,7],[13,8],function(e,t){e.exports={"email-form-section":"_1UZQ","form-email":"_3zXX","form-input":"_3DtF","form-placeholder":"_1hOG","form-submit":"_3F10","form-actions":"_3XDK","button-wrapper":"_3evj","form-save":"_2Hrr","form-edit":"_3PSi","form-clear":"OPmW"}},function(e,t){e.exports={"container-margin":"_23v3","custom-jumbotron":"_1Orq"}},function(e,t){e.exports='<svg width="17" height="17" viewBox="0 0 17 17">\n  <title>Close</title>\n  <path d="M8.326 16.654C3.728 16.654 0 12.926 0 8.327 0 3.73 3.728 0 8.326 0c4.6 0 8.327 3.73 8.327 8.327 0 4.6-3.728 8.327-8.327 8.327zm0-15.544C4.34 1.11 1.11 4.342 1.11 8.327c0 3.985 3.23 7.217 7.216 7.217s7.217-3.232 7.217-7.217c0-3.985-3.23-7.217-7.217-7.217zm2.648 9.832c-.204.202-.546.19-.764-.025l-1.883-1.87-1.883 1.87c-.217.216-.56.228-.764.026-.204-.204-.192-.544.025-.76l1.883-1.872-1.883-1.87c-.217-.217-.228-.558-.024-.76.205-.203.547-.192.764.024l1.883 1.873 1.883-1.873c.218-.216.56-.227.764-.024.204.203.193.543-.025.76L9.065 8.31l1.883 1.874c.217.215.228.555.024.758z" fill="#000" />\n</svg>\n'},function(e,t,n,r){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var o=n(r),l=a(o);t.default=l.default}]))});
//# sourceMappingURL=website-subscription-center-page.js.map

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1093 */
/***/ (function(module, exports) {


/**
 * Check if `el` is within the document.
 *
 * @param {Element} el
 * @return {Boolean}
 * @api private
 */

module.exports = function(el) {
  var node = el;
  while (node = node.parentNode) {
    if (node == document) return true;
  }
  return false;
};

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "Pedro",
		"email": "pedro@auth0.com",
		"gravatarUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-1-0b0477ce8b.png",
		"profile": {
			"position": "VP of Product",
			"company": "Auth0",
			"hobbies": "Baseball, Diving",
			"age": "42",
			"location": "Jersey City, US"
		},
		"sampleAppUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-1-app-3538cb3cff.jpg",
		"connection": {
			"name": "DB-connection-1",
			"icon": "db"
		}
	},
	{
		"name": "Maggie",
		"email": "maggie@auth0.com",
		"gravatarUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-2-122458e6b7.png",
		"profile": {
			"position": "Head of Sales",
			"company": "Auth0",
			"hobbies": "Tennis, Driving",
			"age": "33",
			"location": "Jersey City, US"
		},
		"sampleAppUrl": "https://cdn.auth0.com/website/assets/pages/ab-variants/new-homepage/img/hero/persons/person-2-app-3c930cb339.jpg",
		"connection": {
			"name": "Active Directory",
			"icon": "db"
		}
	}
];

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = {
	"/": [
		"jp"
	],
	"/breached-passwords/": [
		"jp"
	],
	"/guardian/": [
		"jp"
	],
	"/multifactor-authentication/": [
		"jp"
	],
	"/how-it-works/": [
		"jp"
	],
	"/learn/build-or-buy-20-identity-management-questions/": [
		"jp"
	],
	"/learn/harvard-medical-school-identity-secures-nih-research/": [
		"jp"
	],
	"/learn/jetprivilege-case-study/": [
		"jp"
	],
	"/learn/marks-spencer-auth0-authentication-scalability-in-action/": [
		"jp"
	],
	"/learn/safari-case-study/": [
		"jp"
	],
	"/learn/schneider-electric-case-study/": [
		"jp"
	],
	"/signup/": [
		"jp"
	],
	"/why-auth0": [
		"jp"
	]
};

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = {
	"og:type": "website",
	"og:title": "Identity infrastructure, built for developers",
	"og:site_name": "Auth0",
	"og:description": "A universal identity platform for customers, employees and partners",
	"og:locale": "en_US",
	"og:url": "https://auth0.com",
	"og:image": "https://cdn.auth0.com/website/assets/modules/opengraph/1x-new-69e09d5054.png",
	"og:image:secure_url": "https://cdn.auth0.com/website/assets/modules/opengraph/1x-new-69e09d5054.png",
	"fb:app_id": "507756515938786"
};

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = {
	"twitter:card": "summary_large_image",
	"twitter:site": "@auth0",
	"twitter:creator": "@auth0",
	"twitter:title": "Auth0 - Identity infrastructure, for developers",
	"twitter:description": "A universal identity platform for customers, employees and partners",
	"twitter:image": [
		{
			"src": "https://cdn.auth0.com/website/assets/modules/twittercard/1x-new-383f8d95d1.png",
			"width": "1024",
			"height": "512"
		}
	]
};

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"new-homepage-page",
		"header-dark"
	],
	"title": "Single Sign On & Token Based Authentication",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"new-pricing-page",
		"header-dark"
	],
	"title": "Pricing",
	"metas": {
		"description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan."
	},
	"opengraph": {
		"og:title": "Pricing",
		"og:description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan.",
		"og:url": "https://auth0.com/pricing",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "Pricing",
		"twitter:description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan.",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"about-page",
		"header"
	],
	"title": "About",
	"metas": {
		"description": "Advanced identity management can be very hard. Very often, unnecessarily hard. At Auth0 we want to change that, by simplifying as much as possible."
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"ambassador-program"
	],
	"title": "Ambassador Program",
	"metas": {
		"description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?"
	},
	"opengraph": {
		"og:title": "Ambassador Program",
		"og:description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?",
		"og:url": "https://auth0.com/ambassador-program",
		"og:image": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-03c5b828c9.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-03c5b828c9.png"
	},
	"twittercard": {
		"twitter:title": "Ambassador Program",
		"twitter:description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-03c5b828c9.png"
			}
		]
	}
};

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"auth-catalog-index-page",
		"header-dark"
	],
	"title": "Authenticate your users with any Identity Provider",
	"metas": {
		"description": "Easily add authentication to your app. Includes, identity management, single sign on, multifactor authentication, social login and more."
	},
	"opengraph": {
		"og:title": "Authenticate your users with any Identity Provider",
		"og:description": "Easily add authentication to your app. Includes, identity management, single sign on, multifactor authentication, social login and more.",
		"og:sitename": "Auth0"
	},
	"twittercard": {
		"twitter:title": "Authenticate your users with any Identity Provider",
		"twitter:description": "Easily add authentication to your app. Includes, identity management, single sign on, multifactor authentication, social login and more."
	}
};

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"auth-catalog-index-page",
		"header-dark"
	],
	"title": "`${technology}` Authentication",
	"metas": {
		"description": "Easily add authentication to your `${technology}` app. Includes, identity management, single sign on, multifactor authentication, social login and more.",
		"robots": "index, follow"
	},
	"opengraph": {
		"og:title": "Log in to your `${technology}` App with any Identity Provider",
		"og:description": "Easily add authentication to your `${technology}`. Includes, identity management, single sign on, multifactor authentication, social login and more.",
		"og:sitename": "Auth0"
	},
	"twittercard": {
		"twitter:title": "Log in to your `${technology}` App with any Identity Provider",
		"twitter:description": "Easily add authentication to your `${technology}`. Includes, identity management, single sign on, multifactor authentication, social login and more."
	}
};

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"trust-page",
		"header-dark"
	],
	"title": "Availability & Trust",
	"metas": {
		"description": "At Auth0, availability and reliability are our priority. Making Auth0 resilient to failures (that happen all the time) is a continuous task for our engineering team."
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = {
	"v": "4.5.9",
	"fr": 29.9700012207031,
	"ip": 14.0000005702317,
	"op": 594.000024194116,
	"w": 450,
	"h": 420,
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 4,
					"nm": "\r01_auth0",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								655.919,
								615.669,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-139.581,
								-75.831,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											5.339,
											5.339
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.863,
											0.314,
											0.145,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-139.581,
											4.669
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667,
														0.667
													],
													"y": [
														1,
														1
													]
												},
												"o": {
													"x": [
														0.985,
														0.985
													],
													"y": [
														-0.011,
														-0.011
													]
												},
												"n": [
													"0p667_1_0p985_-0p011",
													"0p667_1_0p985_-0p011"
												],
												"t": 43.371,
												"s": [
													0,
													0
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 49.0000019958109
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-139.5,
													4
												],
												[
													-139.5,
													-335
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 1.033
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 3
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.09,
											0.122,
											0.235,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.794
													],
													"y": [
														-0.011
													]
												},
												"n": [
													"0p667_1_0p794_-0p011"
												],
												"t": 46,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 58.0000023623884
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 2,
									"ix": 4,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 612.000024927271,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "circle auth0 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.963
										],
										"y": [
											-0.008
										]
									},
									"n": [
										"0p667_1_0p963_-0p008"
									],
									"t": 58,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 62.0000025253118
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								655.947,
								337.686,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.947,
								89.686,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.893,
											0.893,
											0.333
										],
										"y": [
											-0.018,
											-0.018,
											0.333
										]
									},
									"n": [
										"0p667_1_0p893_-0p018",
										"0p667_1_0p893_-0p018",
										"0p667_0p667_0p333_0p333"
									],
									"t": 58,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 64.0000026067734
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.205,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"n": "0p205_1_0p333_0",
												"t": 62,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-6.589
															],
															[
																-6.589,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.589
															],
															[
																6.589,
																0
															]
														],
														"o": [
															[
																-6.589,
																0
															],
															[
																0,
																6.589
															],
															[
																0,
																0
															],
															[
																6.589,
																0
															],
															[
																0,
																-6.589
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																1.134,
																-11.95
															],
															[
																-10.816,
																0
															],
															[
																1.134,
																11.949
															],
															[
																0.865,
																11.949
															],
															[
																12.815,
																0
															],
															[
																0.865,
																-11.95
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-6.589
															],
															[
																-6.589,
																0
															],
															[
																0,
																0
															],
															[
																0,
																6.589
															],
															[
																6.589,
																0
															]
														],
														"o": [
															[
																-6.589,
																0
															],
															[
																0,
																6.589
															],
															[
																0,
																0
															],
															[
																6.589,
																0
															],
															[
																0,
																-6.589
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-40.866,
																-11.95
															],
															[
																-52.816,
																0
															],
															[
																-40.866,
																11.949
															],
															[
																40.865,
																11.949
															],
															[
																52.815,
																0
															],
															[
																40.865,
																-11.95
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 74.0000030140818
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											306.947,
											89.686
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.922,
									0.329,
									0.141,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.6
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "auth0 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.274
										],
										"y": [
											1.006
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p274_1p006_0p333_0"
									],
									"t": 78,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 86.5800035264757
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								689.033,
								337.686,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								341.033,
								89.686,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.117,
											0.117,
											0.667
										],
										"y": [
											1.005,
											1.005,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"0p117_1p005_0p333_0",
										"0p117_1p005_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 78,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 84.1287534266342
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													1.763,
													-1.267
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.64,
													1.945
												]
											],
											"v": [
												[
													2.9,
													3.351
												],
												[
													1.799,
													0
												],
												[
													4.681,
													-2.071
												],
												[
													1.118,
													-2.071
												],
												[
													0.017,
													-5.422
												],
												[
													0.017,
													-5.423
												],
												[
													3.58,
													-5.423
												],
												[
													4.682,
													-2.071
												],
												[
													4.683,
													-2.072
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-2.866,
													3.351
												],
												[
													-2.867,
													3.352
												],
												[
													0.016,
													5.423
												],
												[
													2.9,
													3.351
												],
												[
													0.017,
													1.28
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 2,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-1.673,
													-1.202
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.674,
													2.05
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-4.648,
													-2.072
												],
												[
													-4.648,
													-2.072
												],
												[
													-2.867,
													3.352
												],
												[
													-2.867,
													3.35
												],
												[
													-1.765,
													-0.001
												],
												[
													-4.647,
													-2.071
												],
												[
													-1.085,
													-2.071
												],
												[
													0.016,
													-5.422
												],
												[
													0.017,
													-5.423
												],
												[
													-3.547,
													-5.423
												]
											],
											"c": true
										}
									},
									"nm": "Path 3",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											341.017,
											89.686
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 6,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "COMPANY +",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								612.786,
								337.695,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-59.964,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPANY +",
										"j": 1,
										"tr": 80,
										"lh": 12,
										"fc": [
											0.92,
											0.33,
											0.14
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 68,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 80.0000032584668
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 4,
					"nm": "02_companyb_line\r",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								695.919,
								431.919,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-139.581,
								-305.581,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											5.339,
											5.339
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-139.581,
											-278.831
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0,
														0
													],
													"y": [
														1.001,
														1.001
													]
												},
												"o": {
													"x": [
														0.333,
														0.333
													],
													"y": [
														0,
														0
													]
												},
												"n": [
													"0_1p001_0p333_0",
													"0_1p001_0p333_0"
												],
												"t": 84,
												"s": [
													0,
													0
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 89.6287536506538
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-139.5,
													-279.5
												],
												[
													-139.5,
													-335
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 1.033
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 3
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.09,
											0.122,
											0.235,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.794
													],
													"y": [
														-0.006
													]
												},
												"n": [
													"0p667_1_0p794_-0p006"
												],
												"t": 86.629,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 93.0000037879676
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 2,
									"ix": 4,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 618.000025171656,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "b-circle Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.833
										],
										"y": [
											-0.012
										]
									},
									"n": [
										"0p667_1_0p833_-0p012"
									],
									"t": 90,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 96.0000039101602
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								724.851,
								393.306,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								376.851,
								145.306,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.666,
											0.666,
											0.333
										],
										"y": [
											-0.015,
											-0.015,
											0.333
										]
									},
									"n": [
										"0p667_1_0p666_-0p015",
										"0p667_1_0p666_-0p015",
										"0p667_0p667_0p333_0p333"
									],
									"t": 87,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 96.0000039101602
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0,
													"y": 1
												},
												"o": {
													"x": 0.333,
													"y": 0
												},
												"n": "0_1_0p333_0",
												"t": 94,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-28.917,
																-10.797
															],
															[
																-39.714,
																-0.001
															],
															[
																-28.917,
																10.796
															],
															[
																-28.958,
																10.796
															],
															[
																-18.163,
																-0.001
															],
															[
																-28.958,
																-10.797
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-41.042,
																-10.797
															],
															[
																-51.839,
																-0.001
															],
															[
																-41.042,
																10.796
															],
															[
																41.042,
																10.796
															],
															[
																51.837,
																-0.001
															],
															[
																41.042,
																-10.797
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 104.000004236007
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.6
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											376.852,
											145.306
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "COMPETITOR B",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								682.288,
								392.695,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-39.962,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPETITOR B",
										"j": 2,
										"tr": 80,
										"lh": 12,
										"fc": [
											0.05,
											0.07,
											0.19
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 104,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 116.000004724777
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 5,
					"nm": "\rCompetitor A",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								533.288,
								427.195,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-39.962,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPETITOR A",
										"j": 2,
										"tr": 80,
										"lh": 12,
										"fc": [
											0.05,
											0.07,
											0.19
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 58,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 70.0000028511585
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "\rcompetitor a - circle",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.833
										],
										"y": [
											-0.012
										]
									},
									"n": [
										"0p667_1_0p833_-0p012"
									],
									"t": 44,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 50.0000020365418
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								613.851,
								426.806,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								413.945,
								145.306,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667,
											0.667,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.666,
											0.666,
											0.333
										],
										"y": [
											-0.015,
											-0.015,
											0.333
										]
									},
									"n": [
										"0p667_1_0p666_-0p015",
										"0p667_1_0p666_-0p015",
										"0p667_0p667_0p333_0p333"
									],
									"t": 41,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 50.0000020365418
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0,
													"y": 1
												},
												"o": {
													"x": 0.167,
													"y": 0
												},
												"n": "0_1_0p167_0",
												"t": 48,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																36.236,
																-10.797
															],
															[
																25.44,
																-0.001
															],
															[
																36.236,
																10.796
															],
															[
																37.95,
																10.796
															],
															[
																48.746,
																-0.001
															],
															[
																37.95,
																-10.797
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																-5.953
															],
															[
																-5.953,
																0
															],
															[
																0,
																0
															],
															[
																0,
																5.953
															],
															[
																5.954,
																0
															]
														],
														"o": [
															[
																-5.953,
																0
															],
															[
																0,
																5.953
															],
															[
																0,
																0
															],
															[
																5.954,
																0
															],
															[
																0,
																-5.953
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-41.042,
																-10.797
															],
															[
																-51.839,
																-0.001
															],
															[
																-41.042,
																10.796
															],
															[
																41.042,
																10.796
															],
															[
																51.837,
																-0.001
															],
															[
																41.042,
																-10.797
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 58.0000023623884
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.6
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											376.852,
											145.306
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "\rcompetitor a - line",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								612.419,
								481.919,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								-139.581,
								-305.581,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											5.339,
											5.339
										]
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											-139.581,
											-278.831
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0,
														0
													],
													"y": [
														1.001,
														1.001
													]
												},
												"o": {
													"x": [
														0.333,
														0.333
													],
													"y": [
														0,
														0
													]
												},
												"n": [
													"0_1p001_0p333_0",
													"0_1p001_0p333_0"
												],
												"t": 38,
												"s": [
													0,
													0
												],
												"e": [
													100,
													100
												]
											},
											{
												"t": 43.6287517770354
											}
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-139.5,
													-279.5
												],
												[
													-139.5,
													-349.5
												]
											],
											"c": false
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 0,
										"k": 1.03
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"d": [
										{
											"n": "d",
											"nm": "dash",
											"v": {
												"a": 0,
												"k": 1.033
											}
										},
										{
											"n": "g",
											"nm": "gap",
											"v": {
												"a": 0,
												"k": 3
											}
										},
										{
											"n": "o",
											"nm": "offset",
											"v": {
												"a": 0,
												"k": 0
											}
										}
									],
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.09,
											0.122,
											0.235,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tm",
									"s": {
										"a": 0,
										"k": 0,
										"ix": 1
									},
									"e": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.794
													],
													"y": [
														-0.006
													]
												},
												"n": [
													"0p667_1_0p794_-0p006"
												],
												"t": 40.629,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 47.0000019143492
											}
										],
										"ix": 2
									},
									"o": {
										"a": 0,
										"k": 0,
										"ix": 3
									},
									"m": 2,
									"ix": 4,
									"nm": "Trim Paths 1",
									"mn": "ADBE Vector Filter - Trim"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 640.000026067734,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_3",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 5,
					"nm": "\r7_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 160,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 174.000007087165
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								820.172,
								627.445,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								34.422,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "COMPLIANCE",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 133,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 149.000006068894
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "\r7_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 130,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 137,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 160,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 174.000007087165
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								627.702,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 127,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 134.000005457932
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "\r6_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 133,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 149.000006068894
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								834.281,
								602.445,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								48.531,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "CERTIFICATIONS",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 112,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 127.000005172816
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "\r6_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 108,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 115,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 133,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 149.000006068894
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								603.202,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 105,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 112.000004561854
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 5,
					"nm": "\r5_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 112,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 127.000005172816
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								848.327,
								578.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								62.577,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "REDUCE SALES CYCLE",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 90,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 105.000004276738
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "\r5_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 86,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 93,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 112,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 127.000005172816
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								578.202,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 83,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 90.0000036657751
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 5,
					"nm": "\r4_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 90,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 105.000004276738
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								831.074,
								553.943,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								45.324,
								-3.557,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "MINIMIZE RISK",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 69,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 83.0000033806593
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 7,
					"ty": 4,
					"nm": "\r4_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 65,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 72,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 90,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 105.000004276738
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								553.202,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 62,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 69.0000028104276
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 8,
					"ty": 5,
					"nm": "\r3_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 69,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 83.0000033806593
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								841.395,
								528.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								55.645,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "INCREASE REVENUE",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														1
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_1_0p333_0"
												],
												"t": 48,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 62.0000025253118
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 9,
					"ty": 4,
					"nm": "\r3_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 44,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 51,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 69,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 83.0000033806593
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								528.702,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 41,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 48.0000019550801
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 10,
					"ty": 5,
					"nm": "\r2_text",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 51,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 62.0000025253118
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								834.167,
								503.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								48.417,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "SINGLE SIGN ON",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"k": 0
									},
									"ne": {
										"k": 0
									},
									"a": {
										"k": 100
									},
									"b": 0,
									"sh": 0,
									"s": {
										"k": 0
									},
									"e": {
										"k": 100
									},
									"o": {
										"k": 0
									}
								},
								"a": {}
							},
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.667
													],
													"y": [
														0.994
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p667_0p994_0p333_0"
												],
												"t": 30,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 39.0000015885026
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 11,
					"ty": 4,
					"nm": "\r2_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 23,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 30,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 51,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 62.0000025253118
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								503.702,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 20,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 27.0000010997325
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 12,
					"ty": 5,
					"nm": "1_text\r",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.667
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p667_1_0p333_0"
									],
									"t": 33,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 40.0000016292334
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								786.243,
								478.945,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0.493,
								-3.555,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 10,
										"f": "RobotoMono-Medium",
										"t": "SECURITY",
										"j": 0,
										"tr": 100,
										"lh": 12,
										"fc": [
											0.33,
											0.34,
											0.4
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								]
							}
						},
						"a": [
							{
								"s": {
									"t": 0,
									"xe": {
										"a": 0,
										"k": 0
									},
									"ne": {
										"a": 0,
										"k": 0
									},
									"a": {
										"a": 0,
										"k": 100
									},
									"b": 1,
									"rn": 0,
									"sh": 1,
									"s": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.169
													],
													"y": [
														0.992
													]
												},
												"o": {
													"x": [
														0.333
													],
													"y": [
														0
													]
												},
												"n": [
													"0p169_0p992_0p333_0"
												],
												"t": 12,
												"s": [
													0
												],
												"e": [
													100
												]
											},
											{
												"t": 22.0000008960784
											}
										]
									},
									"r": 1
								},
								"a": {
									"o": {
										"a": 0,
										"k": 0
									}
								}
							}
						]
					},
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 13,
					"ty": 4,
					"nm": "\r1_ok",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"1_1_0p333_0"
									],
									"t": 8,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0.333
										]
									},
									"n": [
										"0p833_0p833_0p333_0p333"
									],
									"t": 15,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 33,
									"s": [
										100
									],
									"e": [
										70
									]
								},
								{
									"t": 40.0000016292334
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								769.146,
								478.952,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								421.146,
								230.952,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											1,
											1,
											0.667
										],
										"y": [
											1,
											1,
											0.667
										]
									},
									"o": {
										"x": [
											0.333,
											0.333,
											0.333
										],
										"y": [
											0,
											0,
											0.333
										]
									},
									"n": [
										"1_1_0p333_0",
										"1_1_0p333_0",
										"0p667_0p667_0p333_0p333"
									],
									"t": 5,
									"s": [
										0,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 12.00000048877
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.198,
													0.011
												],
												[
													0.138,
													0.138
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.194,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.138,
													0.142
												]
											],
											"v": [
												[
													-0.973,
													2.938
												],
												[
													-1.492,
													2.723
												],
												[
													-4.082,
													0.132
												],
												[
													-3.045,
													-0.905
												],
												[
													-0.979,
													1.162
												],
												[
													3.032,
													-2.949
												],
												[
													4.082,
													-1.925
												],
												[
													-0.448,
													2.716
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.041,
											230.49
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"mn": "ADBE Vector Group"
						},
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-6.423,
													6.307
												],
												[
													6.424,
													6.307
												],
												[
													6.424,
													-6.306
												],
												[
													-6.423,
													-6.306
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												],
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													-0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													-0.405
												],
												[
													0,
													0
												],
												[
													0.405,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0.405
												]
											],
											"v": [
												[
													7.158,
													7.773
												],
												[
													-7.156,
													7.773
												],
												[
													-7.89,
													7.04
												],
												[
													-7.89,
													-7.04
												],
												[
													-7.156,
													-7.773
												],
												[
													7.158,
													-7.773
												],
												[
													7.891,
													-7.04
												],
												[
													7.891,
													7.04
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.922,
											0.329,
											0.141,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											421.146,
											230.952
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 11",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_4",
			"layers": [
				{
					"ddd": 0,
					"ind": 0,
					"ty": 4,
					"nm": "1 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0.99
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_0p99_0p333_0"
									],
									"t": 20,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0_0_0p167_0p167"
									],
									"t": 24,
									"s": [
										100
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 27,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0.995
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_0p995_0p333_0"
									],
									"t": 29,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0
										]
									},
									"n": [
										"0p833_1_0p167_0"
									],
									"t": 31,
									"s": [
										100
									],
									"e": [
										0
									]
								},
								{
									"i": {
										"x": [
											0
										],
										"y": [
											0.995
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_0p995_0p333_0"
									],
									"t": 33,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 35.0000014255792
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.03,
										"y": 0.957
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p03_0p957_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										484.933,
										0
									],
									"to": [
										0.00002379644502,
										-12.4206972122192,
										0
									],
									"ti": [
										-0.00002379644502,
										12.4206972122192,
										0
									]
								},
								{
									"t": 58.0000023623884
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								236.933,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Opacity - Overshoot",
							"mn": "ADBE Slider Control",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 0,
									"nm": "Slider",
									"mn": "ADBE Slider Control-0001",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 20,
										"x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
									}
								}
							]
						},
						{
							"ty": 5,
							"nm": "Opacity - Bounce",
							"mn": "ADBE Slider Control",
							"ix": 2,
							"en": 1,
							"ef": [
								{
									"ty": 0,
									"nm": "Slider",
									"mn": "ADBE Slider Control-0001",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 40,
										"x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
									}
								}
							]
						},
						{
							"ty": 5,
							"nm": "Opacity - Friction",
							"mn": "ADBE Slider Control",
							"ix": 3,
							"en": 1,
							"ef": [
								{
									"ty": 0,
									"nm": "Slider",
									"mn": "ADBE Slider Control-0001",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 40,
										"x": "var $bm_rt;\n$bm_rt = clamp(value, 0, 100);"
									}
								}
							]
						}
					],
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-85.233,
													-0.456
												],
												[
													0,
													49.693
												],
												[
													85.234,
													-0.456
												],
												[
													0,
													-49.665
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.127,
													0
												],
												[
													0.113,
													0.067
												],
												[
													0,
													0
												],
												[
													-0.002,
													0.257
												],
												[
													-0.223,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.257
												],
												[
													0.222,
													-0.131
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.127,
													0
												],
												[
													0,
													0
												],
												[
													-0.222,
													-0.131
												],
												[
													0.001,
													-0.257
												],
												[
													0,
													0
												],
												[
													0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													0.222,
													0.129
												],
												[
													0.001,
													0.257
												],
												[
													0,
													0
												],
												[
													-0.113,
													0.067
												]
											],
											"v": [
												[
													0,
													51.255
												],
												[
													-0.366,
													51.155
												],
												[
													-87.035,
													0.161
												],
												[
													-87.391,
													-0.465
												],
												[
													-87.03,
													-1.088
												],
												[
													-0.361,
													-51.126
												],
												[
													0.362,
													-51.126
												],
												[
													87.031,
													-1.088
												],
												[
													87.392,
													-0.465
												],
												[
													87.036,
													0.161
												],
												[
													0.367,
													51.155
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											236.917
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "2 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.015
										],
										"y": [
											1.023
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p015_1p023_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.211,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p211_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										506.833,
										0
									],
									"to": [
										-0.00002515883716,
										-8.77060222625732,
										0
									],
									"ti": [
										0.00002515883716,
										8.77060222625732,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								258.833,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-80.449,
													-0.436
												],
												[
													0,
													46.899
												],
												[
													80.451,
													-0.436
												],
												[
													0,
													-46.884
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.056,
													0.034
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													0,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													0.112,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.034
												]
											],
											"v": [
												[
													0,
													47.679
												],
												[
													-0.182,
													47.629
												],
												[
													-81.35,
													-0.127
												],
												[
													-81.529,
													-0.441
												],
												[
													-81.348,
													-0.752
												],
												[
													-0.18,
													-47.615
												],
												[
													0.182,
													-47.615
												],
												[
													81.349,
													-0.752
												],
												[
													81.53,
													-0.441
												],
												[
													81.352,
													-0.127
												],
												[
													0.184,
													47.629
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.669,
											258.825
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "3 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.197
										],
										"y": [
											0.993
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p197_0p993_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.338,
										"y": 0.972
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p338_0p972_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										529.356,
										0
									],
									"to": [
										0.00000535874142,
										-5.01690244674683,
										0
									],
									"ti": [
										-0.00000535874142,
										5.01690244674683,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								281.356,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-74.812,
													-0.406
												],
												[
													0,
													43.613
												],
												[
													74.812,
													-0.406
												],
												[
													0,
													-43.599
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.057,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.064
												],
												[
													0,
													0
												],
												[
													0.111,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.057,
													0.033
												]
											],
											"v": [
												[
													0,
													44.393
												],
												[
													-0.183,
													44.344
												],
												[
													-75.713,
													-0.096
												],
												[
													-75.891,
													-0.411
												],
												[
													-75.71,
													-0.721
												],
												[
													-0.18,
													-44.329
												],
												[
													0.181,
													-44.329
												],
												[
													75.711,
													-0.721
												],
												[
													75.892,
													-0.411
												],
												[
													75.713,
													-0.096
												],
												[
													0.184,
													44.344
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											281.348
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "4 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.182
										],
										"y": [
											1.003
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0p182_1p003_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.327,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p327_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										551.185,
										0
									],
									"to": [
										0.00004223414726,
										-1.37864756584167,
										0
									],
									"ti": [
										-0.00004223414726,
										1.37864756584167,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								303.185,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-69.362,
													-0.376
												],
												[
													0,
													40.436
												],
												[
													69.363,
													-0.376
												],
												[
													0,
													-40.422
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.056,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													0.111,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.033
												]
											],
											"v": [
												[
													0,
													41.216
												],
												[
													-0.183,
													41.167
												],
												[
													-70.263,
													-0.067
												],
												[
													-70.441,
													-0.38
												],
												[
													-70.26,
													-0.692
												],
												[
													-0.18,
													-41.152
												],
												[
													0.181,
													-41.152
												],
												[
													70.261,
													-0.692
												],
												[
													70.442,
													-0.38
												],
												[
													70.263,
													-0.067
												],
												[
													0.183,
													41.167
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											303.177
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "5 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											1.021
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_1p021_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.2,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p2_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										573.691,
										0
									],
									"to": [
										-0.0000099000481,
										2.37226295471191,
										0
									],
									"ti": [
										0.0000099000481,
										-2.37226295471191,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								325.691,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-63.784,
													-0.344
												],
												[
													0,
													37.185
												],
												[
													63.785,
													-0.344
												],
												[
													0,
													-37.171
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.064,
													0
												],
												[
													0.056,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.112,
													-0.064
												],
												[
													0,
													0
												],
												[
													-0.001,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.063,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.112,
													-0.064
												],
												[
													0,
													0
												],
												[
													0.112,
													0.064
												],
												[
													0,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.033
												]
											],
											"v": [
												[
													0,
													37.966
												],
												[
													-0.182,
													37.916
												],
												[
													-64.685,
													-0.035
												],
												[
													-64.863,
													-0.349
												],
												[
													-64.682,
													-0.66
												],
												[
													-0.181,
													-37.902
												],
												[
													0.181,
													-37.902
												],
												[
													64.684,
													-0.66
												],
												[
													64.865,
													-0.349
												],
												[
													64.686,
													-0.035
												],
												[
													0.184,
													37.916
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											325.683
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "6 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											1.021
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_1p021_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.2,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p2_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										595.96,
										0
									],
									"to": [
										-0.00004232497304,
										6.08375215530396,
										0
									],
									"ti": [
										0.00004232497304,
										-6.08375215530396,
										0
									]
								},
								{
									"t": 55.0000022401959
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								347.96,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-58.194,
													-0.313
												],
												[
													0,
													33.927
												],
												[
													58.194,
													-0.313
												],
												[
													0,
													-33.913
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.063,
													0
												],
												[
													0.056,
													0.033
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.129
												],
												[
													-0.112,
													0.064
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													0,
													-0.128
												],
												[
													0.111,
													-0.066
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.064,
													0
												],
												[
													0,
													0
												],
												[
													-0.111,
													-0.066
												],
												[
													0,
													-0.128
												],
												[
													0,
													0
												],
												[
													0.111,
													-0.065
												],
												[
													0,
													0
												],
												[
													0.111,
													0.064
												],
												[
													0.001,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.056,
													0.033
												]
											],
											"v": [
												[
													0,
													34.708
												],
												[
													-0.182,
													34.658
												],
												[
													-59.095,
													-0.004
												],
												[
													-59.273,
													-0.318
												],
												[
													-59.092,
													-0.629
												],
												[
													-0.181,
													-34.643
												],
												[
													0.181,
													-34.643
												],
												[
													59.094,
													-0.629
												],
												[
													59.273,
													-0.318
												],
												[
													59.095,
													-0.004
												],
												[
													0.184,
													34.658
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.757,
											0.765,
											0.788,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											347.951
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 4,
					"nm": "7 Outlines",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0
										],
										"y": [
											1
										]
									},
									"o": {
										"x": [
											0.333
										],
										"y": [
											0
										]
									},
									"n": [
										"0_1_0p333_0"
									],
									"t": 45,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 52.0000021180034
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.158,
										"y": 1
									},
									"o": {
										"x": 0.333,
										"y": 0
									},
									"n": "0p158_1_0p333_0",
									"t": 45,
									"s": [
										655.67,
										559.457,
										0
									],
									"e": [
										655.67,
										617.742,
										0
									],
									"to": [
										0.00000599452414,
										9.71416759490967,
										0
									],
									"ti": [
										-0.00000599452414,
										-9.71416759490967,
										0
									]
								},
								{
									"t": 58.0000023623884
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								307.67,
								369.742,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													-52.561,
													-0.275
												],
												[
													0,
													30.65
												],
												[
													52.56,
													-0.275
												],
												[
													0,
													-30.621
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0.126,
													0
												],
												[
													0.113,
													0.066
												],
												[
													0,
													0
												],
												[
													-0.001,
													0.257
												],
												[
													-0.223,
													0.129
												],
												[
													0,
													0
												],
												[
													-0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													-0.002,
													-0.257
												],
												[
													0.222,
													-0.131
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													-0.127,
													0
												],
												[
													0,
													0
												],
												[
													-0.222,
													-0.131
												],
												[
													0.002,
													-0.257
												],
												[
													0,
													0
												],
												[
													0.224,
													-0.129
												],
												[
													0,
													0
												],
												[
													0.223,
													0.129
												],
												[
													0.001,
													0.257
												],
												[
													0,
													0
												],
												[
													-0.113,
													0.066
												]
											],
											"v": [
												[
													0,
													32.211
												],
												[
													-0.367,
													32.112
												],
												[
													-54.363,
													0.342
												],
												[
													-54.72,
													-0.284
												],
												[
													-54.358,
													-0.907
												],
												[
													-0.362,
													-32.082
												],
												[
													0.361,
													-32.082
												],
												[
													54.357,
													-0.907
												],
												[
													54.719,
													-0.284
												],
												[
													54.362,
													0.342
												],
												[
													0.366,
													32.112
												]
											],
											"c": true
										}
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "mm",
									"mm": 1,
									"nm": "Merge Paths 1",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "mm",
									"mm": 4,
									"nm": "Merge Paths 2",
									"mn": "ADBE Vector Filter - Merge"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0.055,
											0.075,
											0.188,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											307.67,
											369.726
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 5,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 1500.00006109625,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		}
	],
	"fonts": {
		"list": [
			{
				"fName": "RobotoMono-Medium",
				"fFamily": "Roboto Mono",
				"fStyle": "Medium",
				"ascent": 75
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 0,
			"ty": 0,
			"nm": "3_auth0",
			"refId": "comp_0",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 66.0000026882351,
			"op": 1566.00006378449,
			"st": 66.0000026882351,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "2_companyb",
			"refId": "comp_1",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": -6.00000024438501,
			"op": 1494.00006085187,
			"st": -6.00000024438501,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 0,
			"nm": "1_companyA",
			"refId": "comp_2",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 15.0000006109625,
			"op": 1515.00006170722,
			"st": 15.0000006109625,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 0,
			"nm": "Texto derecha",
			"refId": "comp_3",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 155.000006313279,
			"op": 1655.00006740953,
			"st": 155.000006313279,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 0,
			"nm": "Graph",
			"refId": "comp_4",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						247,
						224,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						720,
						512,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"w": 1440,
			"h": 1024,
			"ip": 0,
			"op": 1500.00006109625,
			"st": 0,
			"bm": 0,
			"sr": 1
		}
	],
	"chars": [
		{
			"ch": "S",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.864,
												-15.357
											],
											[
												41.666,
												-11.89
											],
											[
												38.053,
												-9.603
											],
											[
												33.35,
												-8.545
											],
											[
												27.547,
												-8.814
											],
											[
												22.542,
												-10.685
											],
											[
												18.896,
												-14.128
											],
											[
												16.862,
												-19.19
											],
											[
												4.932,
												-21.338
											],
											[
												5.339,
												-16.658
											],
											[
												7.755,
												-10.749
											],
											[
												11.735,
												-6.014
											],
											[
												16.951,
												-2.457
											],
											[
												22.95,
												-0.13
											],
											[
												29.411,
												0.928
											],
											[
												37.907,
												0.513
											],
											[
												46.436,
												-2.376
											],
											[
												52.718,
												-7.65
											],
											[
												56.055,
												-15.25
											],
											[
												55.452,
												-24.185
											],
											[
												51.416,
												-31.03
											],
											[
												44.938,
												-36.19
											],
											[
												36.702,
												-39.844
											],
											[
												29.972,
												-41.886
											],
											[
												24.853,
												-44.01
											],
											[
												21.012,
												-46.899
											],
											[
												18.896,
												-50.781
											],
											[
												19.205,
												-55.404
											],
											[
												21.297,
												-58.935
											],
											[
												24.772,
												-61.36
											],
											[
												29.394,
												-62.5
											],
											[
												35.01,
												-62.207
											],
											[
												39.461,
												-60.205
											],
											[
												42.488,
												-56.779
											],
											[
												44.075,
												-52.181
											],
											[
												55.957,
												-50.391
											],
											[
												55.257,
												-56.55
											],
											[
												50.886,
												-64.136
											],
											[
												43.824,
												-69.425
											],
											[
												34.668,
												-72.07
											],
											[
												25,
												-71.614
											],
											[
												16.568,
												-68.489
											],
											[
												10.376,
												-63.045
											],
											[
												7.08,
												-55.452
											],
											[
												7.74,
												-46.639
											],
											[
												12.101,
												-39.949
											],
											[
												18.791,
												-34.993
											],
											[
												26.985,
												-31.575
											],
											[
												33.796,
												-29.467
											],
											[
												38.875,
												-27.149
											],
											[
												42.44,
												-24.064
											],
											[
												44.189,
												-20.003
											]
										],
										"o": [
											[
												42.561,
												-12.915
											],
											[
												39.387,
												-10.23
											],
											[
												34.993,
												-8.757
											],
											[
												29.476,
												-8.545
											],
											[
												24.064,
												-9.888
											],
											[
												19.938,
												-12.8
											],
											[
												17.334,
												-17.318
											],
											[
												16.699,
												-21.338
											],
											[
												4.964,
												-18.897
											],
											[
												6.771,
												-12.589
											],
											[
												10.262,
												-7.462
											],
											[
												15.12,
												-3.507
											],
											[
												20.89,
												-0.764
											],
											[
												27.246,
												0.716
											],
											[
												34.815,
												0.928
											],
											[
												43.831,
												-1.147
											],
											[
												50.928,
												-5.631
											],
											[
												55.387,
												-12.468
											],
											[
												56.055,
												-21.467
											],
											[
												53.043,
												-28.938
											],
											[
												47.314,
												-34.644
											],
											[
												39.534,
												-38.762
											],
											[
												31.819,
												-41.276
											],
											[
												26.423,
												-43.221
											],
											[
												22.119,
												-45.833
											],
											[
												19.319,
												-49.341
											],
											[
												18.896,
												-54.003
											],
											[
												20.442,
												-57.878
											],
											[
												23.478,
												-60.693
											],
											[
												27.767,
												-62.271
											],
											[
												33.203,
												-62.5
											],
											[
												38.134,
												-61.035
											],
											[
												41.642,
												-58.057
											],
											[
												43.693,
												-53.816
											],
											[
												44.238,
												-50.391
											],
											[
												55.924,
												-53.614
											],
											[
												52.653,
												-61.857
											],
											[
												46.427,
												-67.944
											],
											[
												37.866,
												-71.54
											],
											[
												28.059,
												-72.07
											],
											[
												19.14,
												-69.791
											],
											[
												12.141,
												-65.104
											],
											[
												7.74,
												-58.195
											],
											[
												7.08,
												-49.333
											],
											[
												10.376,
												-41.984
											],
											[
												16.365,
												-36.466
											],
											[
												24.227,
												-32.584
											],
											[
												31.868,
												-30.143
											],
											[
												37.345,
												-28.003
											],
											[
												41.447,
												-25.195
											],
											[
												43.84,
												-21.492
											],
											[
												44.189,
												-16.749
											]
										],
										"v": [
											[
												43.213,
												-14.136
											],
											[
												40.527,
												-11.06
											],
											[
												36.523,
												-9.18
											],
											[
												31.592,
												-8.545
											],
											[
												25.806,
												-9.351
											],
											[
												21.24,
												-11.743
											],
											[
												18.115,
												-15.723
											],
											[
												16.699,
												-21.338
											],
											[
												4.932,
												-21.338
											],
											[
												6.055,
												-14.624
											],
											[
												9.009,
												-9.106
											],
											[
												13.428,
												-4.761
											],
											[
												18.921,
												-1.611
											],
											[
												25.098,
												0.293
											],
											[
												31.592,
												0.928
											],
											[
												40.869,
												-0.317
											],
											[
												48.682,
												-4.004
											],
											[
												54.053,
												-10.059
											],
											[
												56.055,
												-18.408
											],
											[
												54.248,
												-26.562
											],
											[
												49.365,
												-32.837
											],
											[
												42.236,
												-37.476
											],
											[
												33.74,
												-40.723
											],
											[
												28.198,
												-42.554
											],
											[
												23.486,
												-44.922
											],
											[
												20.166,
												-48.12
											],
											[
												18.896,
												-52.441
											],
											[
												19.824,
												-56.641
											],
											[
												22.388,
												-59.814
											],
											[
												26.27,
												-61.816
											],
											[
												31.152,
												-62.5
											],
											[
												36.572,
												-61.621
											],
											[
												40.552,
												-59.131
											],
											[
												43.091,
												-55.298
											],
											[
												44.238,
												-50.391
											],
											[
												55.957,
												-50.391
											],
											[
												53.955,
												-59.204
											],
											[
												48.657,
												-66.04
											],
											[
												40.845,
												-70.483
											],
											[
												31.25,
												-72.07
											],
											[
												22.07,
												-70.703
											],
											[
												14.355,
												-66.797
											],
											[
												9.058,
												-60.62
											],
											[
												7.08,
												-52.393
											],
											[
												9.058,
												-44.312
											],
											[
												14.233,
												-38.208
											],
											[
												21.509,
												-33.789
											],
											[
												29.785,
												-30.762
											],
											[
												35.571,
												-28.735
											],
											[
												40.161,
												-26.172
											],
											[
												43.14,
												-22.778
											],
											[
												44.189,
												-18.311
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "S",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0.651,
												-1.221
											],
											[
												1.139,
												-0.83
											],
											[
												1.53,
												-0.423
											],
											[
												1.758,
												0
											],
											[
												1.741,
												0.537
											],
											[
												1.302,
												1.058
											],
											[
												0.781,
												1.595
											],
											[
												0.163,
												2.148
											],
											[
												0,
												0
											],
											[
												-0.716,
												-2.034
											],
											[
												-1.254,
												-1.643
											],
											[
												-1.693,
												-1.253
											],
											[
												-1.97,
												-0.846
											],
											[
												-2.148,
												-0.423
											],
											[
												-2.181,
												0
											],
											[
												-2.962,
												0.83
											],
											[
												-2.246,
												1.628
											],
											[
												-1.335,
												2.409
											],
											[
												0,
												3.158
											],
											[
												1.204,
												2.377
											],
											[
												2.051,
												1.807
											],
											[
												2.702,
												1.286
											],
											[
												2.962,
												0.879
											],
											[
												1.774,
												0.668
											],
											[
												1.367,
												0.912
											],
											[
												0.846,
												1.221
											],
											[
												0,
												1.66
											],
											[
												-0.619,
												1.237
											],
											[
												-1.091,
												0.879
											],
											[
												-1.498,
												0.456
											],
											[
												-1.758,
												0
											],
											[
												-1.562,
												-0.586
											],
											[
												-1.091,
												-1.074
											],
											[
												-0.603,
												-1.481
											],
											[
												-0.163,
												-1.79
											],
											[
												0,
												0
											],
											[
												1.302,
												2.654
											],
											[
												2.229,
												1.904
											],
											[
												2.979,
												1.058
											],
											[
												3.418,
												0
											],
											[
												2.93,
												-0.911
											],
											[
												2.213,
												-1.692
											],
											[
												1.318,
												-2.425
											],
											[
												0,
												-3.059
											],
											[
												-1.318,
												-2.327
											],
											[
												-2.132,
												-1.741
											],
											[
												-2.718,
												-1.204
											],
											[
												-2.8,
												-0.813
											],
											[
												-1.775,
												-0.732
											],
											[
												-1.286,
												-0.977
											],
											[
												-0.7,
												-1.286
											],
											[
												0,
												-1.692
											]
										],
										"o": [
											[
												-0.652,
												1.221
											],
											[
												-1.14,
												0.83
											],
											[
												-1.53,
												0.423
											],
											[
												-2.116,
												0
											],
											[
												-1.742,
												-0.537
											],
											[
												-1.302,
												-1.057
											],
											[
												-0.781,
												-1.595
											],
											[
												0,
												0
											],
											[
												0.032,
												2.441
											],
											[
												0.716,
												2.035
											],
											[
												1.253,
												1.644
											],
											[
												1.692,
												1.254
											],
											[
												1.969,
												0.847
											],
											[
												2.148,
												0.423
											],
											[
												3.223,
												0
											],
											[
												2.962,
												-0.83
											],
											[
												2.246,
												-1.627
											],
											[
												1.334,
												-2.409
											],
											[
												0,
												-3.059
											],
											[
												-1.205,
												-2.376
											],
											[
												-2.051,
												-1.807
											],
											[
												-2.702,
												-1.286
											],
											[
												-1.921,
												-0.553
											],
											[
												-1.775,
												-0.667
											],
											[
												-1.367,
												-0.911
											],
											[
												-0.847,
												-1.221
											],
											[
												0,
												-1.562
											],
											[
												0.618,
												-1.237
											],
											[
												1.09,
												-0.879
											],
											[
												1.497,
												-0.455
											],
											[
												2.051,
												0
											],
											[
												1.562,
												0.586
											],
											[
												1.09,
												1.074
											],
											[
												0.602,
												1.482
											],
											[
												0,
												0
											],
											[
												-0.033,
												-3.223
											],
											[
												-1.302,
												-2.653
											],
											[
												-2.23,
												-1.904
											],
											[
												-2.979,
												-1.057
											],
											[
												-3.191,
												0
											],
											[
												-2.93,
												0.912
											],
											[
												-2.214,
												1.693
											],
											[
												-1.318,
												2.425
											],
											[
												0,
												3.06
											],
											[
												1.318,
												2.328
											],
											[
												2.132,
												1.742
											],
											[
												2.718,
												1.205
											],
											[
												2.083,
												0.619
											],
											[
												1.774,
												0.732
											],
											[
												1.286,
												0.977
											],
											[
												0.7,
												1.286
											],
											[
												0,
												1.562
											]
										],
										"v": [
											[
												103.223,
												-14.136
											],
											[
												100.537,
												-11.06
											],
											[
												96.533,
												-9.18
											],
											[
												91.602,
												-8.545
											],
											[
												85.815,
												-9.351
											],
											[
												81.25,
												-11.743
											],
											[
												78.125,
												-15.723
											],
											[
												76.709,
												-21.338
											],
											[
												64.941,
												-21.338
											],
											[
												66.064,
												-14.624
											],
											[
												69.019,
												-9.106
											],
											[
												73.438,
												-4.761
											],
											[
												78.931,
												-1.611
											],
											[
												85.107,
												0.293
											],
											[
												91.602,
												0.928
											],
											[
												100.879,
												-0.317
											],
											[
												108.691,
												-4.004
											],
											[
												114.062,
												-10.059
											],
											[
												116.064,
												-18.408
											],
											[
												114.258,
												-26.562
											],
											[
												109.375,
												-32.837
											],
											[
												102.246,
												-37.476
											],
											[
												93.75,
												-40.723
											],
											[
												88.208,
												-42.554
											],
											[
												83.496,
												-44.922
											],
											[
												80.176,
												-48.12
											],
											[
												78.906,
												-52.441
											],
											[
												79.834,
												-56.641
											],
											[
												82.397,
												-59.814
											],
											[
												86.279,
												-61.816
											],
											[
												91.162,
												-62.5
											],
											[
												96.582,
												-61.621
											],
											[
												100.562,
												-59.131
											],
											[
												103.101,
												-55.298
											],
											[
												104.248,
												-50.391
											],
											[
												115.967,
												-50.391
											],
											[
												113.965,
												-59.204
											],
											[
												108.667,
												-66.04
											],
											[
												100.854,
												-70.483
											],
											[
												91.26,
												-72.07
											],
											[
												82.08,
												-70.703
											],
											[
												74.365,
												-66.797
											],
											[
												69.067,
												-60.62
											],
											[
												67.09,
												-52.393
											],
											[
												69.067,
												-44.312
											],
											[
												74.243,
												-38.208
											],
											[
												81.519,
												-33.789
											],
											[
												89.795,
												-30.762
											],
											[
												95.581,
												-28.735
											],
											[
												100.171,
												-26.172
											],
											[
												103.149,
												-22.778
											],
											[
												104.199,
												-18.311
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "S",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "E",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"o": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"v": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "E",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												108.936,
												-41.357
											],
											[
												79.688,
												-41.357
											],
											[
												79.688,
												-61.426
											],
											[
												113.574,
												-61.426
											],
											[
												113.574,
												-71.094
											],
											[
												67.92,
												-71.094
											],
											[
												67.92,
												0
											],
											[
												113.916,
												0
											],
											[
												113.916,
												-9.57
											],
											[
												79.688,
												-9.57
											],
											[
												79.688,
												-31.885
											],
											[
												108.936,
												-31.885
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "E",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "C",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.506,
												-21.826
											],
											[
												41.845,
												-14.265
											],
											[
												34.424,
												-8.447
											],
											[
												25.423,
												-9.033
											],
											[
												20.41,
												-12.971
											],
											[
												17.488,
												-19.36
											],
											[
												16.309,
												-27.604
											],
											[
												16.309,
												-40.479
											],
											[
												16.545,
												-46.207
											],
											[
												18.278,
												-53.898
											],
											[
												21.939,
												-59.586
											],
											[
												27.734,
												-62.598
											],
											[
												34.383,
												-62.272
											],
											[
												38.851,
												-60.034
											],
											[
												41.755,
												-56.128
											],
											[
												43.36,
												-50.813
											],
											[
												55.273,
												-48.73
											],
											[
												54.118,
												-55.5
											],
											[
												49.983,
												-63.752
											],
											[
												43.311,
												-69.352
											],
											[
												34.114,
												-72.119
											],
											[
												22.364,
												-71.28
											],
											[
												13.224,
												-65.65
											],
											[
												7.258,
												-56.518
											],
											[
												4.475,
												-44.71
											],
											[
												4.443,
												-30.664
											],
											[
												5.03,
												-22.2
											],
											[
												8.79,
												-11.165
											],
											[
												15.771,
												-3.165
											],
											[
												25.992,
												1.025
											],
											[
												37.149,
												0.48
											],
											[
												45.508,
												-3.247
											],
											[
												51.53,
												-9.66
											],
											[
												54.947,
												-18.408
											]
										],
										"o": [
											[
												43.115,
												-17.561
											],
											[
												37.549,
												-9.61
											],
											[
												27.652,
												-8.447
											],
											[
												21.842,
												-11.377
											],
											[
												18.262,
												-17.008
											],
											[
												16.545,
												-24.732
											],
											[
												16.309,
												-30.664
											],
											[
												16.309,
												-43.409
											],
											[
												17.488,
												-51.546
											],
											[
												20.491,
												-57.967
											],
											[
												25.52,
												-61.995
											],
											[
												32.519,
												-62.598
											],
											[
												37.541,
												-60.969
											],
											[
												40.934,
												-57.592
											],
											[
												42.96,
												-52.71
											],
											[
												43.555,
												-48.73
											],
											[
												54.914,
												-52.278
											],
											[
												51.644,
												-61.295
											],
											[
												45.816,
												-67.789
											],
											[
												37.451,
												-71.565
											],
											[
												26.106,
												-72.119
											],
											[
												15.918,
												-67.927
											],
											[
												8.895,
												-59.888
											],
											[
												5.045,
												-48.804
											],
											[
												4.443,
												-40.381
											],
											[
												4.475,
												-26.302
											],
											[
												7.178,
												-14.518
											],
											[
												13.086,
												-5.436
											],
											[
												22.217,
												0.187
											],
											[
												33.902,
												1.025
											],
											[
												42.976,
												-1.7
											],
											[
												49.804,
												-7.251
											],
											[
												54.134,
												-15.291
											],
											[
												55.273,
												-21.826
											]
										],
										"v": [
											[
												43.506,
												-21.826
											],
											[
												39.697,
												-11.938
											],
											[
												30.322,
												-8.447
											],
											[
												23.633,
												-10.205
											],
											[
												19.336,
												-14.99
											],
											[
												17.017,
												-22.046
											],
											[
												16.309,
												-30.664
											],
											[
												16.309,
												-40.479
											],
											[
												17.017,
												-48.877
											],
											[
												19.385,
												-55.933
											],
											[
												23.73,
												-60.791
											],
											[
												30.371,
												-62.598
											],
											[
												35.962,
												-61.621
											],
											[
												39.893,
												-58.813
											],
											[
												42.358,
												-54.419
											],
											[
												43.555,
												-48.73
											],
											[
												55.273,
												-48.73
											],
											[
												52.881,
												-58.398
											],
											[
												47.9,
												-65.771
											],
											[
												40.381,
												-70.459
											],
											[
												30.371,
												-72.119
											],
											[
												19.141,
												-69.604
											],
											[
												11.06,
												-62.769
											],
											[
												6.152,
												-52.661
											],
											[
												4.443,
												-40.381
											],
											[
												4.443,
												-30.664
											],
											[
												6.104,
												-18.359
											],
											[
												10.938,
												-8.301
											],
											[
												18.994,
												-1.489
											],
											[
												30.322,
												1.025
											],
											[
												40.063,
												-0.61
											],
											[
												47.656,
												-5.249
											],
											[
												52.832,
												-12.476
											],
											[
												55.273,
												-21.826
											]
										],
										"c": true
									}
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "C",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												2.148,
												-2.327
											],
											[
												4.102,
												0
											],
											[
												1.79,
												1.172
											],
											[
												1.074,
												2.019
											],
											[
												0.471,
												2.686
											],
											[
												0,
												3.06
											],
											[
												0,
												0
											],
											[
												-0.472,
												2.67
											],
											[
												-1.107,
												2.035
											],
											[
												-1.791,
												1.205
											],
											[
												-2.637,
												0
											],
											[
												-1.579,
												-0.651
											],
											[
												-1.042,
												-1.221
											],
											[
												-0.603,
												-1.709
											],
											[
												-0.195,
												-2.083
											],
											[
												0,
												0
											],
											[
												1.237,
												2.898
											],
											[
												2.083,
												2.019
											],
											[
												2.93,
												1.107
											],
											[
												3.743,
												0
											],
											[
												3.223,
												-1.676
											],
											[
												2.164,
												-2.881
											],
											[
												1.106,
												-3.857
											],
											[
												0.032,
												-4.329
											],
											[
												0,
												0
											],
											[
												-1.074,
												-3.841
											],
											[
												-2.148,
												-2.864
											],
											[
												-3.223,
												-1.676
											],
											[
												-4.33,
												0
											],
											[
												-2.914,
												1.09
											],
											[
												-2.148,
												2.002
											],
											[
												-1.302,
												2.816
											],
											[
												-0.326,
												3.418
											]
										],
										"o": [
											[
												-0.391,
												4.265
											],
											[
												-2.148,
												2.328
											],
											[
												-2.67,
												0
											],
											[
												-1.791,
												-1.172
											],
											[
												-1.074,
												-2.018
											],
											[
												-0.472,
												-2.686
											],
											[
												0,
												0
											],
											[
												0,
												-2.93
											],
											[
												0.471,
												-2.669
											],
											[
												1.106,
												-2.034
											],
											[
												1.79,
												-1.204
											],
											[
												2.148,
												0
											],
											[
												1.579,
												0.652
											],
											[
												1.041,
												1.221
											],
											[
												0.602,
												1.709
											],
											[
												0,
												0
											],
											[
												-0.359,
												-3.548
											],
											[
												-1.237,
												-2.897
											],
											[
												-2.084,
												-2.018
											],
											[
												-2.93,
												-1.106
											],
											[
												-4.265,
												0
											],
											[
												-3.223,
												1.677
											],
											[
												-2.165,
												2.881
											],
											[
												-1.107,
												3.857
											],
											[
												0,
												0
											],
											[
												0.032,
												4.362
											],
											[
												1.074,
												3.841
											],
											[
												2.148,
												2.865
											],
											[
												3.223,
												1.676
											],
											[
												3.58,
												0
											],
											[
												2.913,
												-1.09
											],
											[
												2.148,
												-2.002
											],
											[
												1.302,
												-2.815
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												103.516,
												-21.826
											],
											[
												99.707,
												-11.938
											],
											[
												90.332,
												-8.447
											],
											[
												83.643,
												-10.205
											],
											[
												79.346,
												-14.99
											],
											[
												77.026,
												-22.046
											],
											[
												76.318,
												-30.664
											],
											[
												76.318,
												-40.479
											],
											[
												77.026,
												-48.877
											],
											[
												79.395,
												-55.933
											],
											[
												83.74,
												-60.791
											],
											[
												90.381,
												-62.598
											],
											[
												95.972,
												-61.621
											],
											[
												99.902,
												-58.813
											],
											[
												102.368,
												-54.419
											],
											[
												103.564,
												-48.73
											],
											[
												115.283,
												-48.73
											],
											[
												112.891,
												-58.398
											],
											[
												107.91,
												-65.771
											],
											[
												100.391,
												-70.459
											],
											[
												90.381,
												-72.119
											],
											[
												79.15,
												-69.604
											],
											[
												71.069,
												-62.769
											],
											[
												66.162,
												-52.661
											],
											[
												64.453,
												-40.381
											],
											[
												64.453,
												-30.664
											],
											[
												66.113,
												-18.359
											],
											[
												70.947,
												-8.301
											],
											[
												79.004,
												-1.489
											],
											[
												90.332,
												1.025
											],
											[
												100.073,
												-0.61
											],
											[
												107.666,
												-5.249
											],
											[
												112.842,
												-12.476
											],
											[
												115.283,
												-21.826
											]
										],
										"c": true
									}
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "C",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "U",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												41.992,
												-71.094
											],
											[
												41.895,
												-23.486
											],
											[
												41.584,
												-19.303
											],
											[
												39.779,
												-14.087
											],
											[
												36.507,
												-10.424
											],
											[
												31.787,
												-8.594
											],
											[
												26.228,
												-8.96
											],
											[
												22.12,
												-11.451
											],
											[
												19.416,
												-15.657
											],
											[
												18.098,
												-21.305
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.348,
												-23.486
											],
											[
												6.965,
												-16.463
											],
											[
												10.84,
												-7.869
											],
											[
												17.399,
												-1.953
											],
											[
												26.318,
												0.977
											],
											[
												36.71,
												0.391
											],
											[
												45.019,
												-3.614
											],
											[
												50.715,
												-10.49
											],
											[
												53.58,
												-19.84
											],
											[
												53.516,
												-71.094
											]
										],
										"o": [
											[
												41.992,
												-71.094
											],
											[
												41.862,
												-21.305
											],
											[
												40.543,
												-15.657
											],
											[
												37.761,
												-11.451
											],
											[
												33.512,
												-8.96
											],
											[
												27.913,
												-8.594
											],
											[
												23.331,
												-10.424
											],
											[
												20.166,
												-14.087
											],
											[
												18.375,
												-19.303
											],
											[
												18.066,
												-23.486
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.38,
												-19.807
											],
											[
												9.244,
												-10.441
											],
											[
												14.942,
												-3.605
											],
											[
												23.128,
												0.391
											],
											[
												33.447,
												0.977
											],
											[
												42.537,
												-1.953
											],
											[
												49.121,
												-7.91
											],
											[
												52.994,
												-16.512
											],
											[
												53.613,
												-23.486
											],
											[
												53.516,
												-71.094
											]
										],
										"v": [
											[
												41.992,
												-71.094
											],
											[
												41.895,
												-23.486
											],
											[
												41.064,
												-17.48
											],
											[
												38.77,
												-12.769
											],
											[
												35.01,
												-9.692
											],
											[
												29.834,
												-8.594
											],
											[
												24.78,
												-9.692
											],
											[
												21.143,
												-12.769
											],
											[
												18.896,
												-17.48
											],
											[
												18.066,
												-23.486
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.348,
												-23.486
											],
											[
												8.105,
												-13.452
											],
											[
												12.891,
												-5.737
											],
											[
												20.264,
												-0.781
											],
											[
												29.834,
												0.977
											],
											[
												39.624,
												-0.781
											],
											[
												47.07,
												-5.762
											],
											[
												51.855,
												-13.501
											],
											[
												53.613,
												-23.486
											],
											[
												53.516,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "U",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.52,
												-1.823
											],
											[
												1.009,
												-1.318
											],
											[
												1.497,
												-0.732
											],
											[
												1.953,
												0
											],
											[
												1.448,
												0.732
											],
											[
												0.977,
												1.318
											],
											[
												0.52,
												1.823
											],
											[
												0.032,
												2.181
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.14,
												-3.011
											],
											[
												-2.051,
												-2.132
											],
											[
												-2.865,
												-1.172
											],
											[
												-3.516,
												0
											],
											[
												-2.914,
												1.172
											],
											[
												-2.051,
												2.148
											],
											[
												-1.14,
												3.011
											],
											[
												-0.033,
												3.646
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												-0.033,
												2.181
											],
											[
												-0.521,
												1.823
											],
											[
												-1.009,
												1.318
											],
											[
												-1.498,
												0.732
											],
											[
												-1.921,
												0
											],
											[
												-1.449,
												-0.732
											],
											[
												-0.977,
												-1.318
											],
											[
												-0.521,
												-1.823
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.032,
												3.679
											],
											[
												1.139,
												3.011
											],
											[
												2.051,
												2.132
											],
											[
												2.864,
												1.172
											],
											[
												3.613,
												0
											],
											[
												2.913,
												-1.172
											],
											[
												2.051,
												-2.148
											],
											[
												1.139,
												-3.011
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												102.002,
												-71.094
											],
											[
												101.904,
												-23.486
											],
											[
												101.074,
												-17.48
											],
											[
												98.779,
												-12.769
											],
											[
												95.02,
												-9.692
											],
											[
												89.844,
												-8.594
											],
											[
												84.79,
												-9.692
											],
											[
												81.152,
												-12.769
											],
											[
												78.906,
												-17.48
											],
											[
												78.076,
												-23.486
											],
											[
												77.979,
												-71.094
											],
											[
												66.455,
												-71.094
											],
											[
												66.357,
												-23.486
											],
											[
												68.115,
												-13.452
											],
											[
												72.9,
												-5.737
											],
											[
												80.273,
												-0.781
											],
											[
												89.844,
												0.977
											],
											[
												99.634,
												-0.781
											],
											[
												107.08,
												-5.762
											],
											[
												111.865,
												-13.501
											],
											[
												113.623,
												-23.486
											],
											[
												113.525,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "U",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "R",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												42.09,
												-30.469
											],
											[
												45.768,
												-32.34
											],
											[
												50.325,
												-36.149
											],
											[
												53.491,
												-41.121
											],
											[
												55.078,
												-47.249
											],
											[
												54.46,
												-56.363
											],
											[
												50.244,
												-63.923
											],
											[
												43.091,
												-68.806
											],
											[
												33.577,
												-71.061
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"o": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												44.01,
												-31.315
											],
											[
												48.958,
												-34.749
											],
											[
												52.604,
												-39.339
											],
											[
												54.761,
												-45.06
											],
											[
												55.078,
												-53.238
											],
											[
												51.986,
												-61.702
											],
											[
												45.752,
												-67.472
											],
											[
												36.939,
												-70.597
											],
											[
												29.932,
												-71.094
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"v": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												42.09,
												-30.469
											],
											[
												47.363,
												-33.545
											],
											[
												51.465,
												-37.744
											],
											[
												54.126,
												-43.091
											],
											[
												55.078,
												-49.658
											],
											[
												53.223,
												-59.033
											],
											[
												47.998,
												-65.698
											],
											[
												40.015,
												-69.702
											],
											[
												29.932,
												-71.094
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												19.189,
												-61.621
											],
											[
												29.932,
												-61.621
											],
											[
												33.838,
												-61.304
											],
											[
												38.566,
												-59.439
											],
											[
												41.764,
												-56.071
											],
											[
												43.311,
												-51.253
											],
											[
												42.985,
												-45.646
											],
											[
												40.763,
												-41.43
											],
											[
												36.979,
												-38.59
											],
											[
												31.933,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"o": [
											[
												19.189,
												-61.621
											],
											[
												31.983,
												-61.588
											],
											[
												37.158,
												-60.23
											],
											[
												40.877,
												-57.356
											],
											[
												43.001,
												-53.011
											],
											[
												43.311,
												-47.347
											],
											[
												41.682,
												-42.683
											],
											[
												38.386,
												-39.38
											],
											[
												33.724,
												-37.483
											],
											[
												29.98,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"v": [
											[
												19.189,
												-61.621
											],
											[
												29.932,
												-61.621
											],
											[
												35.498,
												-60.767
											],
											[
												39.722,
												-58.398
											],
											[
												42.383,
												-54.541
											],
											[
												43.311,
												-49.268
											],
											[
												42.334,
												-44.165
											],
											[
												39.575,
												-40.405
											],
											[
												35.352,
												-38.037
											],
											[
												29.98,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "R",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.595,
												1.205
											],
											[
												-1.14,
												1.595
											],
											[
												-0.635,
												1.97
											],
											[
												0,
												2.409
											],
											[
												1.237,
												2.67
											],
											[
												2.246,
												1.775
											],
											[
												3.076,
												0.896
											],
											[
												3.645,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.92,
												-0.846
											],
											[
												1.595,
												-1.204
											],
											[
												1.139,
												-1.595
											],
											[
												0.635,
												-1.969
											],
											[
												0,
												-3.58
											],
											[
												-1.237,
												-2.669
											],
											[
												-2.246,
												-1.774
											],
											[
												-3.076,
												-0.895
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												104.639,
												0
											],
											[
												117.139,
												0
											],
											[
												117.139,
												-0.586
											],
											[
												102.1,
												-30.469
											],
											[
												107.373,
												-33.545
											],
											[
												111.475,
												-37.744
											],
											[
												114.136,
												-43.091
											],
											[
												115.088,
												-49.658
											],
											[
												113.232,
												-59.033
											],
											[
												108.008,
												-65.698
											],
											[
												100.024,
												-69.702
											],
											[
												89.941,
												-71.094
											],
											[
												67.48,
												-71.094
											],
											[
												67.48,
												0
											],
											[
												79.199,
												0
											],
											[
												79.199,
												-27.734
											],
											[
												91.113,
												-27.734
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.66,
												-0.537
											],
											[
												-1.156,
												-1.041
											],
											[
												-0.619,
												-1.53
											],
											[
												0,
												-1.985
											],
											[
												0.651,
												-1.481
											],
											[
												1.188,
												-1.025
											],
											[
												1.627,
												-0.553
											],
											[
												1.953,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												2.051,
												0.033
											],
											[
												1.66,
												0.537
											],
											[
												1.155,
												1.042
											],
											[
												0.618,
												1.53
											],
											[
												0,
												1.921
											],
											[
												-0.652,
												1.482
											],
											[
												-1.189,
												1.025
											],
											[
												-1.628,
												0.554
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.199,
												-61.621
											],
											[
												89.941,
												-61.621
											],
											[
												95.508,
												-60.767
											],
											[
												99.731,
												-58.398
											],
											[
												102.393,
												-54.541
											],
											[
												103.32,
												-49.268
											],
											[
												102.344,
												-44.165
											],
											[
												99.585,
												-40.405
											],
											[
												95.361,
												-38.037
											],
											[
												89.99,
												-37.207
											],
											[
												79.199,
												-37.207
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "R",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "I",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"o": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"v": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "I",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												68.848,
												-61.377
											],
											[
												83.887,
												-61.377
											],
											[
												83.887,
												-9.668
											],
											[
												68.848,
												-9.668
											],
											[
												68.848,
												0
											],
											[
												111.133,
												0
											],
											[
												111.133,
												-9.668
											],
											[
												95.752,
												-9.668
											],
											[
												95.752,
												-61.377
											],
											[
												111.133,
												-61.377
											],
											[
												111.133,
												-71.094
											],
											[
												68.848,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "I",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "T",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"o": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"v": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "T",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												117.627,
												-71.094
											],
											[
												62.451,
												-71.094
											],
											[
												62.451,
												-61.426
											],
											[
												84.131,
												-61.426
											],
											[
												84.131,
												0
											],
											[
												95.801,
												0
											],
											[
												95.801,
												-61.426
											],
											[
												117.627,
												-61.426
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "T",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "Y",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"o": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"v": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"c": true
									}
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Y",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												75.293,
												-71.094
											],
											[
												62.207,
												-71.094
											],
											[
												84.229,
												-25.83
											],
											[
												84.326,
												0
											],
											[
												95.703,
												0
											],
											[
												95.801,
												-25.537
											],
											[
												117.969,
												-71.094
											],
											[
												104.883,
												-71.094
											],
											[
												90.088,
												-37.109
											]
										],
										"c": true
									}
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Y",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "N",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"o": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"v": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"c": true
									}
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "N",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.281,
												-71.094
											],
											[
												101.416,
												-71.094
											],
											[
												101.318,
												-22.314
											],
											[
												78.271,
												-71.094
											],
											[
												66.406,
												-71.094
											],
											[
												66.406,
												0
											],
											[
												78.271,
												0
											],
											[
												78.32,
												-48.926
											],
											[
												101.465,
												0
											],
											[
												113.281,
												0
											]
										],
										"c": true
									}
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "N",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "G",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												43.311,
												-12.646
											],
											[
												42.041,
												-11.271
											],
											[
												39.314,
												-9.846
											],
											[
												36.084,
												-8.959
											],
											[
												32.6,
												-8.594
											],
											[
												26.481,
												-9.261
											],
											[
												21.07,
												-13.386
											],
											[
												17.732,
												-19.905
											],
											[
												16.292,
												-28.142
											],
											[
												16.26,
												-39.99
											],
											[
												16.585,
												-45.793
											],
											[
												18.555,
												-53.62
											],
											[
												22.371,
												-59.399
											],
											[
												28.044,
												-62.451
											],
											[
												34.285,
												-62.166
											],
											[
												38.509,
												-60.205
											],
											[
												41.422,
												-56.755
											],
											[
												43.115,
												-51.969
											],
											[
												54.932,
												-50.049
											],
											[
												53.833,
												-56.495
											],
											[
												49.739,
												-64.283
											],
											[
												43.083,
												-69.548
											],
											[
												34,
												-72.07
											],
											[
												22.575,
												-71.232
											],
											[
												13.501,
												-65.592
											],
											[
												7.422,
												-56.396
											],
											[
												4.492,
												-44.385
											],
											[
												4.492,
												-31.104
											],
											[
												5.134,
												-22.412
											],
											[
												9.236,
												-11.206
											],
											[
												16.536,
												-3.174
											],
											[
												26.887,
												0.977
											],
											[
												36.335,
												0.732
											],
											[
												43.245,
												-0.928
											],
											[
												49.104,
												-3.727
											],
											[
												53.775,
												-7.454
											]
										],
										"o": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												42.757,
												-11.897
											],
											[
												40.283,
												-10.262
											],
											[
												37.199,
												-9.195
											],
											[
												33.74,
												-8.667
											],
											[
												28.792,
												-8.626
											],
											[
												22.64,
												-11.735
											],
											[
												18.628,
												-17.521
											],
											[
												16.593,
												-25.309
											],
											[
												16.26,
												-31.104
											],
											[
												16.292,
												-42.952
											],
											[
												17.692,
												-51.229
											],
											[
												20.899,
												-57.755
											],
											[
												25.92,
												-61.841
											],
											[
												32.536,
												-62.451
											],
											[
												37.248,
												-61.027
											],
											[
												40.592,
												-58.057
											],
											[
												42.659,
												-53.695
											],
											[
												43.408,
												-50.049
											],
											[
												54.606,
												-53.434
											],
											[
												51.391,
												-61.963
											],
											[
												45.572,
												-68.091
											],
											[
												37.288,
												-71.566
											],
											[
												26.22,
												-72.07
											],
											[
												16.194,
												-67.879
											],
											[
												9.107,
												-59.797
											],
											[
												5.078,
												-48.584
											],
											[
												4.492,
												-39.893
											],
											[
												4.524,
												-26.612
											],
											[
												7.511,
												-14.6
											],
											[
												13.761,
												-5.444
											],
											[
												23.112,
												0.146
											],
											[
												33.821,
												0.977
											],
											[
												41.056,
												-0.244
											],
											[
												47.282,
												-2.686
											],
											[
												52.359,
												-6.136
											],
											[
												54.98,
												-8.887
											]
										],
										"v": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												43.311,
												-12.646
											],
											[
												41.162,
												-10.767
											],
											[
												38.257,
												-9.521
											],
											[
												34.912,
												-8.813
											],
											[
												31.494,
												-8.594
											],
											[
												24.561,
												-10.498
											],
											[
												19.849,
												-15.454
											],
											[
												17.163,
												-22.607
											],
											[
												16.26,
												-31.104
											],
											[
												16.26,
												-39.99
											],
											[
												17.139,
												-48.511
											],
											[
												19.727,
												-55.688
											],
											[
												24.146,
												-60.62
											],
											[
												30.518,
												-62.451
											],
											[
												35.767,
												-61.597
											],
											[
												39.551,
												-59.131
											],
											[
												42.041,
												-55.225
											],
											[
												43.408,
												-50.049
											],
											[
												54.932,
												-50.049
											],
											[
												52.612,
												-59.229
											],
											[
												47.656,
												-66.187
											],
											[
												40.186,
												-70.557
											],
											[
												30.322,
												-72.07
											],
											[
												19.385,
												-69.556
											],
											[
												11.304,
												-62.695
											],
											[
												6.25,
												-52.49
											],
											[
												4.492,
												-39.893
											],
											[
												4.492,
												-31.104
											],
											[
												6.323,
												-18.506
											],
											[
												11.499,
												-8.325
											],
											[
												19.824,
												-1.514
											],
											[
												31.152,
												0.977
											],
											[
												38.696,
												0.244
											],
											[
												45.264,
												-1.807
											],
											[
												50.732,
												-4.932
											],
											[
												54.98,
												-8.887
											]
										],
										"c": true
									}
								},
								"nm": "G",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "G",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.879,
												-0.504
											],
											[
												1.057,
												-0.325
											],
											[
												1.172,
												-0.146
											],
											[
												1.106,
												0
											],
											[
												1.92,
												1.237
											],
											[
												1.221,
												2.068
											],
											[
												0.569,
												2.702
											],
											[
												0.032,
												2.962
											],
											[
												0,
												0
											],
											[
												-0.554,
												2.718
											],
											[
												-1.172,
												2.068
											],
											[
												-1.775,
												1.221
											],
											[
												-2.474,
												0
											],
											[
												-1.482,
												-0.569
											],
											[
												-1.042,
												-1.074
											],
											[
												-0.619,
												-1.53
											],
											[
												-0.293,
												-1.92
											],
											[
												0,
												0
											],
											[
												1.221,
												2.734
											],
											[
												2.083,
												1.904
											],
											[
												2.897,
												1.009
											],
											[
												3.678,
												0
											],
											[
												3.19,
												-1.676
											],
											[
												2.197,
												-2.897
											],
											[
												1.172,
												-3.906
											],
											[
												0,
												-4.492
											],
											[
												0,
												0
											],
											[
												-1.189,
												-3.906
											],
											[
												-2.263,
												-2.881
											],
											[
												-3.288,
												-1.66
											],
											[
												-4.265,
												0
											],
											[
												-2.361,
												0.488
											],
											[
												-2.019,
												0.879
											],
											[
												-1.628,
												1.205
											],
											[
												-1.205,
												1.433
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.554,
												0.749
											],
											[
												-0.879,
												0.505
											],
											[
												-1.058,
												0.326
											],
											[
												-1.172,
												0.146
											],
											[
												-2.702,
												-0.032
											],
											[
												-1.921,
												-1.237
											],
											[
												-1.221,
												-2.067
											],
											[
												-0.57,
												-2.702
											],
											[
												0,
												0
											],
											[
												0.032,
												-2.962
											],
											[
												0.553,
												-2.718
											],
											[
												1.172,
												-2.067
											],
											[
												1.774,
												-1.221
											],
											[
												2.018,
												0
											],
											[
												1.481,
												0.57
											],
											[
												1.041,
												1.074
											],
											[
												0.618,
												1.53
											],
											[
												0,
												0
											],
											[
												-0.326,
												-3.385
											],
											[
												-1.221,
												-2.734
											],
											[
												-2.084,
												-1.904
											],
											[
												-2.898,
												-1.009
											],
											[
												-4.102,
												0
											],
											[
												-3.191,
												1.677
											],
											[
												-2.197,
												2.898
											],
											[
												-1.172,
												3.906
											],
											[
												0,
												0
											],
											[
												0.032,
												4.492
											],
											[
												1.188,
												3.906
											],
											[
												2.262,
												2.881
											],
											[
												3.288,
												1.66
											],
											[
												2.669,
												0
											],
											[
												2.36,
												-0.488
											],
											[
												2.018,
												-0.879
											],
											[
												1.627,
												-1.204
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												114.893,
												-35.986
											],
											[
												90.576,
												-35.986
											],
											[
												90.576,
												-26.855
											],
											[
												103.418,
												-26.855
											],
											[
												103.32,
												-12.646
											],
											[
												101.172,
												-10.767
											],
											[
												98.267,
												-9.521
											],
											[
												94.922,
												-8.813
											],
											[
												91.504,
												-8.594
											],
											[
												84.57,
												-10.498
											],
											[
												79.858,
												-15.454
											],
											[
												77.173,
												-22.607
											],
											[
												76.27,
												-31.104
											],
											[
												76.27,
												-39.99
											],
											[
												77.148,
												-48.511
											],
											[
												79.736,
												-55.688
											],
											[
												84.155,
												-60.62
											],
											[
												90.527,
												-62.451
											],
											[
												95.776,
												-61.597
											],
											[
												99.561,
												-59.131
											],
											[
												102.051,
												-55.225
											],
											[
												103.418,
												-50.049
											],
											[
												114.941,
												-50.049
											],
											[
												112.622,
												-59.229
											],
											[
												107.666,
												-66.187
											],
											[
												100.195,
												-70.557
											],
											[
												90.332,
												-72.07
											],
											[
												79.395,
												-69.556
											],
											[
												71.313,
												-62.695
											],
											[
												66.26,
												-52.49
											],
											[
												64.502,
												-39.893
											],
											[
												64.502,
												-31.104
											],
											[
												66.333,
												-18.506
											],
											[
												71.509,
												-8.325
											],
											[
												79.834,
												-1.514
											],
											[
												91.162,
												0.977
											],
											[
												98.706,
												0.244
											],
											[
												105.273,
												-1.807
											],
											[
												110.742,
												-4.932
											],
											[
												114.99,
												-8.887
											]
										],
										"c": true
									}
								},
								"nm": "G",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "G",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "L",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"o": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"v": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "L",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												80.127,
												-71.094
											],
											[
												68.408,
												-71.094
											],
											[
												68.408,
												0
											],
											[
												114.014,
												0
											],
											[
												114.014,
												-9.57
											],
											[
												80.127,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "L",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": " ",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "O",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												55.469,
												-40.039
											],
											[
												54.931,
												-48.274
											],
											[
												51.171,
												-59.432
											],
											[
												44.197,
												-67.676
											],
											[
												34.033,
												-72.07
											],
											[
												24.308,
												-71.663
											],
											[
												17.472,
												-68.912
											],
											[
												12.101,
												-64.331
											],
											[
												8.179,
												-58.146
											],
											[
												5.622,
												-50.911
											],
											[
												4.443,
												-42.838
											],
											[
												4.443,
												-30.957
											],
											[
												4.972,
												-22.737
											],
											[
												8.667,
												-11.662
											],
											[
												15.494,
												-3.418
											],
											[
												25.52,
												0.977
											],
											[
												37.833,
												0.105
											],
											[
												46.916,
												-5.721
											],
											[
												52.783,
												-15.015
											],
											[
												55.469,
												-26.758
											]
										],
										"o": [
											[
												55.469,
												-44.238
											],
											[
												52.783,
												-56.021
											],
											[
												46.875,
												-65.324
											],
											[
												37.784,
												-71.192
											],
											[
												26.904,
												-72.07
											],
											[
												19.587,
												-70.036
											],
											[
												13.729,
												-66.047
											],
											[
												9.334,
												-60.327
											],
											[
												6.323,
												-53.425
											],
											[
												4.679,
												-45.572
											],
											[
												4.443,
												-40.039
											],
											[
												4.443,
												-26.758
											],
											[
												7.087,
												-15.055
											],
											[
												12.867,
												-5.77
											],
											[
												21.809,
												0.098
											],
											[
												34.082,
												0.977
											],
											[
												44.246,
												-3.377
											],
											[
												51.18,
												-11.613
											],
											[
												54.931,
												-22.729
											],
											[
												55.469,
												-30.957
											]
										],
										"v": [
											[
												55.469,
												-40.039
											],
											[
												53.857,
												-52.148
											],
											[
												49.023,
												-62.378
											],
											[
												40.991,
												-69.434
											],
											[
												29.736,
												-72.07
											],
											[
												21.948,
												-70.85
											],
											[
												15.601,
												-67.48
											],
											[
												10.718,
												-62.329
											],
											[
												7.251,
												-55.786
											],
											[
												5.151,
												-48.242
											],
											[
												4.443,
												-40.039
											],
											[
												4.443,
												-30.957
											],
											[
												6.03,
												-18.896
											],
											[
												10.767,
												-8.716
											],
											[
												18.652,
												-1.66
											],
											[
												29.785,
												0.977
											],
											[
												41.04,
												-1.636
											],
											[
												49.048,
												-8.667
											],
											[
												53.857,
												-18.872
											],
											[
												55.469,
												-30.957
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.701,
												-30.957
											],
											[
												43.432,
												-25.635
											],
											[
												41.797,
												-18.001
											],
											[
												38.224,
												-12.142
											],
											[
												32.454,
												-8.887
											],
											[
												24.959,
												-9.538
											],
											[
												20.092,
												-13.842
											],
											[
												17.318,
												-20.401
											],
											[
												16.243,
												-28.287
											],
											[
												16.211,
												-40.137
											],
											[
												16.463,
												-45.45
											],
											[
												17.994,
												-53.043
											],
											[
												21.427,
												-58.895
											],
											[
												27.099,
												-62.109
											],
											[
												34.626,
												-61.467
											],
											[
												39.6,
												-57.218
											],
											[
												42.513,
												-50.733
											],
											[
												43.668,
												-42.806
											]
										],
										"o": [
											[
												43.668,
												-28.287
											],
											[
												42.554,
												-20.361
											],
											[
												39.649,
												-13.834
											],
											[
												34.675,
												-9.538
											],
											[
												27.148,
												-8.887
											],
											[
												21.476,
												-12.142
											],
											[
												18.042,
												-18.042
											],
											[
												16.472,
												-25.642
											],
											[
												16.211,
												-30.957
											],
											[
												16.243,
												-42.806
											],
											[
												17.277,
												-50.691
											],
											[
												20.044,
												-57.21
											],
											[
												24.91,
												-61.467
											],
											[
												32.405,
												-62.109
											],
											[
												38.175,
												-58.895
											],
											[
												41.748,
												-53.083
											],
											[
												43.424,
												-45.459
											],
											[
												43.701,
												-40.137
											]
										],
										"v": [
											[
												43.701,
												-30.957
											],
											[
												42.993,
												-22.998
											],
											[
												40.723,
												-15.918
											],
											[
												36.45,
												-10.84
											],
											[
												29.785,
												-8.887
											],
											[
												23.218,
												-10.84
											],
											[
												19.067,
												-15.942
											],
											[
												16.895,
												-23.022
											],
											[
												16.211,
												-30.957
											],
											[
												16.211,
												-40.137
											],
											[
												16.87,
												-48.071
											],
											[
												19.019,
												-55.127
											],
											[
												23.169,
												-60.181
											],
											[
												29.736,
												-62.109
											],
											[
												36.401,
												-60.181
											],
											[
												40.674,
												-55.151
											],
											[
												42.969,
												-48.096
											],
											[
												43.701,
												-40.137
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "O",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												1.074,
												3.874
											],
											[
												2.148,
												2.946
											],
											[
												3.206,
												1.758
											],
											[
												4.297,
												0
											],
											[
												2.36,
												-0.813
											],
											[
												1.871,
												-1.432
											],
											[
												1.383,
												-2.002
											],
											[
												0.928,
												-2.36
											],
											[
												0.471,
												-2.669
											],
											[
												0,
												-2.799
											],
											[
												0,
												0
											],
											[
												-1.058,
												-3.841
											],
											[
												-2.1,
												-2.946
											],
											[
												-3.158,
												-1.758
											],
											[
												-4.265,
												0
											],
											[
												-3.207,
												1.741
											],
											[
												-2.132,
												2.946
											],
											[
												-1.074,
												3.857
											],
											[
												0,
												4.199
											]
										],
										"o": [
											[
												0,
												-4.199
											],
											[
												-1.074,
												-3.873
											],
											[
												-2.148,
												-2.946
											],
											[
												-3.207,
												-1.758
											],
											[
												-2.832,
												0
											],
											[
												-2.361,
												0.814
											],
											[
												-1.872,
												1.433
											],
											[
												-1.384,
												2.002
											],
											[
												-0.928,
												2.361
											],
											[
												-0.472,
												2.67
											],
											[
												0,
												0
											],
											[
												0,
												4.199
											],
											[
												1.057,
												3.841
											],
											[
												2.1,
												2.946
											],
											[
												3.157,
												1.758
											],
											[
												4.297,
												0
											],
											[
												3.206,
												-1.741
											],
											[
												2.132,
												-2.946
											],
											[
												1.074,
												-3.857
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												115.479,
												-40.039
											],
											[
												113.867,
												-52.148
											],
											[
												109.033,
												-62.378
											],
											[
												101.001,
												-69.434
											],
											[
												89.746,
												-72.07
											],
											[
												81.958,
												-70.85
											],
											[
												75.61,
												-67.48
											],
											[
												70.728,
												-62.329
											],
											[
												67.261,
												-55.786
											],
											[
												65.161,
												-48.242
											],
											[
												64.453,
												-40.039
											],
											[
												64.453,
												-30.957
											],
											[
												66.04,
												-18.896
											],
											[
												70.776,
												-8.716
											],
											[
												78.662,
												-1.66
											],
											[
												89.795,
												0.977
											],
											[
												101.05,
												-1.636
											],
											[
												109.058,
												-8.667
											],
											[
												113.867,
												-18.872
											],
											[
												115.479,
												-30.957
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0.439,
												-2.637
											],
											[
												1.074,
												-2.083
											],
											[
												1.774,
												-1.302
											],
											[
												2.669,
												0
											],
											[
												1.741,
												1.302
											],
											[
												1.025,
												2.1
											],
											[
												0.423,
												2.621
											],
											[
												0.032,
												2.67
											],
											[
												0,
												0
											],
											[
												-0.407,
												2.621
											],
											[
												-1.025,
												2.084
											],
											[
												-1.742,
												1.286
											],
											[
												-2.637,
												0
											],
											[
												-1.775,
												-1.286
											],
											[
												-1.074,
												-2.067
											],
											[
												-0.456,
												-2.637
											],
											[
												-0.033,
												-2.669
											]
										],
										"o": [
											[
												-0.033,
												2.67
											],
											[
												-0.439,
												2.637
											],
											[
												-1.074,
												2.084
											],
											[
												-1.775,
												1.302
											],
											[
												-2.637,
												0
											],
											[
												-1.742,
												-1.302
											],
											[
												-1.025,
												-2.1
											],
											[
												-0.423,
												-2.62
											],
											[
												0,
												0
											],
											[
												0.032,
												-2.669
											],
											[
												0.407,
												-2.62
											],
											[
												1.025,
												-2.083
											],
											[
												1.741,
												-1.286
											],
											[
												2.669,
												0
											],
											[
												1.774,
												1.286
											],
											[
												1.074,
												2.068
											],
											[
												0.455,
												2.637
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												103.711,
												-30.957
											],
											[
												103.003,
												-22.998
											],
											[
												100.732,
												-15.918
											],
											[
												96.46,
												-10.84
											],
											[
												89.795,
												-8.887
											],
											[
												83.228,
												-10.84
											],
											[
												79.077,
												-15.942
											],
											[
												76.904,
												-23.022
											],
											[
												76.221,
												-30.957
											],
											[
												76.221,
												-40.137
											],
											[
												76.88,
												-48.071
											],
											[
												79.028,
												-55.127
											],
											[
												83.179,
												-60.181
											],
											[
												89.746,
												-62.109
											],
											[
												96.411,
												-60.181
											],
											[
												100.684,
												-55.151
											],
											[
												102.979,
												-48.096
											],
											[
												103.711,
												-40.137
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "O",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "A",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"o": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"v": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"o": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"v": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "A",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												106.543,
												0
											],
											[
												118.604,
												0
											],
											[
												95.947,
												-71.094
											],
											[
												85.645,
												-71.094
											],
											[
												62.549,
												0
											],
											[
												74.658,
												0
											],
											[
												79.541,
												-16.504
											],
											[
												101.758,
												-16.504
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												90.771,
												-54.395
											],
											[
												98.828,
												-26.514
											],
											[
												82.52,
												-26.514
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "A",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "V",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												15.186,
												-71.094
											],
											[
												2.393,
												-71.094
											],
											[
												24.316,
												0
											],
											[
												35.498,
												0
											],
											[
												57.471,
												-71.094
											],
											[
												44.678,
												-71.094
											],
											[
												29.883,
												-17.822
											]
										],
										"o": [
											[
												15.186,
												-71.094
											],
											[
												2.393,
												-71.094
											],
											[
												24.316,
												0
											],
											[
												35.498,
												0
											],
											[
												57.471,
												-71.094
											],
											[
												44.678,
												-71.094
											],
											[
												29.883,
												-17.822
											]
										],
										"v": [
											[
												15.186,
												-71.094
											],
											[
												2.393,
												-71.094
											],
											[
												24.316,
												0
											],
											[
												35.498,
												0
											],
											[
												57.471,
												-71.094
											],
											[
												44.678,
												-71.094
											],
											[
												29.883,
												-17.822
											]
										],
										"c": true
									}
								},
								"nm": "V",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "V",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												75.195,
												-71.094
											],
											[
												62.402,
												-71.094
											],
											[
												84.326,
												0
											],
											[
												95.508,
												0
											],
											[
												117.48,
												-71.094
											],
											[
												104.688,
												-71.094
											],
											[
												89.893,
												-17.822
											]
										],
										"c": true
									}
								},
								"nm": "V",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "V",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "M",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.592,
												-71.094
											],
											[
												6.592,
												0
											],
											[
												17.627,
												0
											],
											[
												17.627,
												-24.414
											],
											[
												16.943,
												-54.395
											],
											[
												26.855,
												-21.484
											],
											[
												33.008,
												-21.484
											],
											[
												43.945,
												-55.566
											],
											[
												43.262,
												-24.414
											],
											[
												43.262,
												0
											],
											[
												54.297,
												0
											],
											[
												54.297,
												-71.094
											],
											[
												39.746,
												-71.094
											],
											[
												29.98,
												-40.381
											],
											[
												21.143,
												-71.094
											]
										],
										"o": [
											[
												6.592,
												-71.094
											],
											[
												6.592,
												0
											],
											[
												17.627,
												0
											],
											[
												17.627,
												-24.414
											],
											[
												16.943,
												-54.395
											],
											[
												26.855,
												-21.484
											],
											[
												33.008,
												-21.484
											],
											[
												43.945,
												-55.566
											],
											[
												43.262,
												-24.414
											],
											[
												43.262,
												0
											],
											[
												54.297,
												0
											],
											[
												54.297,
												-71.094
											],
											[
												39.746,
												-71.094
											],
											[
												29.98,
												-40.381
											],
											[
												21.143,
												-71.094
											]
										],
										"v": [
											[
												6.592,
												-71.094
											],
											[
												6.592,
												0
											],
											[
												17.627,
												0
											],
											[
												17.627,
												-24.414
											],
											[
												16.943,
												-54.395
											],
											[
												26.855,
												-21.484
											],
											[
												33.008,
												-21.484
											],
											[
												43.945,
												-55.566
											],
											[
												43.262,
												-24.414
											],
											[
												43.262,
												0
											],
											[
												54.297,
												0
											],
											[
												54.297,
												-71.094
											],
											[
												39.746,
												-71.094
											],
											[
												29.98,
												-40.381
											],
											[
												21.143,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "M",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												66.602,
												-71.094
											],
											[
												66.602,
												0
											],
											[
												77.637,
												0
											],
											[
												77.637,
												-24.414
											],
											[
												76.953,
												-54.395
											],
											[
												86.865,
												-21.484
											],
											[
												93.018,
												-21.484
											],
											[
												103.955,
												-55.566
											],
											[
												103.271,
												-24.414
											],
											[
												103.271,
												0
											],
											[
												114.307,
												0
											],
											[
												114.307,
												-71.094
											],
											[
												99.756,
												-71.094
											],
											[
												89.99,
												-40.381
											],
											[
												81.152,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "M",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "M",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "Z",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.516,
												-63.379
											],
											[
												53.467,
												-71.094
											],
											[
												5.176,
												-71.094
											],
											[
												5.176,
												-61.426
											],
											[
												39.648,
												-61.426
											],
											[
												4.883,
												-7.91
											],
											[
												4.932,
												0
											],
											[
												54.59,
												0
											],
											[
												54.59,
												-9.57
											],
											[
												18.701,
												-9.57
											]
										],
										"o": [
											[
												53.516,
												-63.379
											],
											[
												53.467,
												-71.094
											],
											[
												5.176,
												-71.094
											],
											[
												5.176,
												-61.426
											],
											[
												39.648,
												-61.426
											],
											[
												4.883,
												-7.91
											],
											[
												4.932,
												0
											],
											[
												54.59,
												0
											],
											[
												54.59,
												-9.57
											],
											[
												18.701,
												-9.57
											]
										],
										"v": [
											[
												53.516,
												-63.379
											],
											[
												53.467,
												-71.094
											],
											[
												5.176,
												-71.094
											],
											[
												5.176,
												-61.426
											],
											[
												39.648,
												-61.426
											],
											[
												4.883,
												-7.91
											],
											[
												4.932,
												0
											],
											[
												54.59,
												0
											],
											[
												54.59,
												-9.57
											],
											[
												18.701,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "Z",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Z",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.525,
												-63.379
											],
											[
												113.477,
												-71.094
											],
											[
												65.186,
												-71.094
											],
											[
												65.186,
												-61.426
											],
											[
												99.658,
												-61.426
											],
											[
												64.893,
												-7.91
											],
											[
												64.941,
												0
											],
											[
												114.6,
												0
											],
											[
												114.6,
												-9.57
											],
											[
												78.711,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "Z",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Z",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "K",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												45.703,
												0
											],
											[
												59.766,
												0
											],
											[
												34.375,
												-39.893
											],
											[
												58.545,
												-71.094
											],
											[
												44.238,
												-71.094
											],
											[
												25.537,
												-46.24
											],
											[
												19.043,
												-37.793
											],
											[
												19.043,
												-71.094
											],
											[
												7.178,
												-71.094
											],
											[
												7.178,
												0
											],
											[
												19.043,
												0
											],
											[
												19.043,
												-22.363
											],
											[
												26.66,
												-30.908
											]
										],
										"o": [
											[
												45.703,
												0
											],
											[
												59.766,
												0
											],
											[
												34.375,
												-39.893
											],
											[
												58.545,
												-71.094
											],
											[
												44.238,
												-71.094
											],
											[
												25.537,
												-46.24
											],
											[
												19.043,
												-37.793
											],
											[
												19.043,
												-71.094
											],
											[
												7.178,
												-71.094
											],
											[
												7.178,
												0
											],
											[
												19.043,
												0
											],
											[
												19.043,
												-22.363
											],
											[
												26.66,
												-30.908
											]
										],
										"v": [
											[
												45.703,
												0
											],
											[
												59.766,
												0
											],
											[
												34.375,
												-39.893
											],
											[
												58.545,
												-71.094
											],
											[
												44.238,
												-71.094
											],
											[
												25.537,
												-46.24
											],
											[
												19.043,
												-37.793
											],
											[
												19.043,
												-71.094
											],
											[
												7.178,
												-71.094
											],
											[
												7.178,
												0
											],
											[
												19.043,
												0
											],
											[
												19.043,
												-22.363
											],
											[
												26.66,
												-30.908
											]
										],
										"c": true
									}
								},
								"nm": "K",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "K",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												105.713,
												0
											],
											[
												119.775,
												0
											],
											[
												94.385,
												-39.893
											],
											[
												118.555,
												-71.094
											],
											[
												104.248,
												-71.094
											],
											[
												85.547,
												-46.24
											],
											[
												79.053,
												-37.793
											],
											[
												79.053,
												-71.094
											],
											[
												67.188,
												-71.094
											],
											[
												67.188,
												0
											],
											[
												79.053,
												0
											],
											[
												79.053,
												-22.363
											],
											[
												86.67,
												-30.908
											]
										],
										"c": true
									}
								},
								"nm": "K",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "K",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "D",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												24.414,
												0
											],
											[
												33.513,
												-0.798
											],
											[
												44.466,
												-6.225
											],
											[
												51.953,
												-15.437
											],
											[
												55.631,
												-27.929
											],
											[
												55.664,
												-38.184
											],
											[
												54.883,
												-47.517
											],
											[
												49.862,
												-59.016
											],
											[
												41.12,
												-67.057
											],
											[
												28.955,
												-71.061
											],
											[
												6.689,
												-71.094
											],
											[
												6.689,
												0
											]
										],
										"o": [
											[
												29.199,
												0
											],
											[
												41.195,
												-3.988
											],
											[
												49.87,
												-11.987
											],
											[
												54.883,
												-23.478
											],
											[
												55.664,
												-32.812
											],
											[
												55.631,
												-43.067
											],
											[
												51.953,
												-55.558
											],
											[
												44.426,
												-64.811
											],
											[
												33.341,
												-70.247
											],
											[
												24.072,
												-71.094
											],
											[
												6.689,
												-71.094
											],
											[
												6.689,
												0
											]
										],
										"v": [
											[
												24.414,
												0
											],
											[
												37.354,
												-2.393
											],
											[
												47.168,
												-9.106
											],
											[
												53.418,
												-19.458
											],
											[
												55.664,
												-32.812
											],
											[
												55.664,
												-38.184
											],
											[
												53.418,
												-51.538
											],
											[
												47.144,
												-61.914
											],
											[
												37.231,
												-68.652
											],
											[
												24.072,
												-71.094
											],
											[
												6.689,
												-71.094
											],
											[
												6.689,
												0
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												24.072,
												-61.621
											],
											[
												30.281,
												-60.994
											],
											[
												37.239,
												-57.072
											],
											[
												41.707,
												-50.488
											],
											[
												43.717,
												-41.699
											],
											[
												43.75,
												-32.812
											],
											[
												43.302,
												-26.106
											],
											[
												40.503,
												-17.928
											],
											[
												35.27,
												-12.28
											],
											[
												27.637,
												-9.456
											],
											[
												18.604,
												-9.424
											],
											[
												18.604,
												-61.621
											]
										],
										"o": [
											[
												27.392,
												-61.588
											],
											[
												35.196,
												-58.683
											],
											[
												40.494,
												-52.937
											],
											[
												43.302,
												-44.824
											],
											[
												43.75,
												-38.281
											],
											[
												43.717,
												-29.296
											],
											[
												41.707,
												-20.377
											],
											[
												37.281,
												-13.859
											],
											[
												30.452,
												-10.034
											],
											[
												24.414,
												-9.424
											],
											[
												18.604,
												-9.424
											],
											[
												18.604,
												-61.621
											]
										],
										"v": [
											[
												24.072,
												-61.621
											],
											[
												32.739,
												-59.839
											],
											[
												38.867,
												-55.005
											],
											[
												42.505,
												-47.656
											],
											[
												43.75,
												-38.281
											],
											[
												43.75,
												-32.812
											],
											[
												42.505,
												-23.242
											],
											[
												38.892,
												-15.894
											],
											[
												32.861,
												-11.157
											],
											[
												24.414,
												-9.424
											],
											[
												18.604,
												-9.424
											],
											[
												18.604,
												-61.621
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "D",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.841,
												1.595
											],
											[
												-2.702,
												2.881
											],
											[
												-1.465,
												4.021
											],
											[
												-0.033,
												4.883
											],
											[
												0,
												0
											],
											[
												1.465,
												4.021
											],
											[
												2.718,
												2.898
											],
											[
												3.889,
												1.595
											],
											[
												4.883,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												4.785,
												0
											],
											[
												3.841,
												-1.595
											],
											[
												2.702,
												-2.881
											],
											[
												1.465,
												-4.02
											],
											[
												0,
												0
											],
											[
												-0.033,
												-4.883
											],
											[
												-1.465,
												-4.02
											],
											[
												-2.718,
												-2.897
											],
											[
												-3.89,
												-1.595
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												84.424,
												0
											],
											[
												97.363,
												-2.393
											],
											[
												107.178,
												-9.106
											],
											[
												113.428,
												-19.458
											],
											[
												115.674,
												-32.812
											],
											[
												115.674,
												-38.184
											],
											[
												113.428,
												-51.538
											],
											[
												107.153,
												-61.914
											],
											[
												97.241,
												-68.652
											],
											[
												84.082,
												-71.094
											],
											[
												66.699,
												-71.094
											],
											[
												66.699,
												0
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-2.458,
												-1.155
											],
											[
												-1.628,
												-2.067
											],
											[
												-0.798,
												-2.832
											],
											[
												-0.033,
												-3.418
											],
											[
												0,
												0
											],
											[
												0.797,
												-2.864
											],
											[
												1.611,
												-2.034
											],
											[
												2.409,
												-1.123
											],
											[
												3.223,
												-0.032
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.32,
												0.033
											],
											[
												2.457,
												1.156
											],
											[
												1.627,
												2.068
											],
											[
												0.797,
												2.832
											],
											[
												0,
												0
											],
											[
												-0.033,
												3.516
											],
											[
												-0.798,
												2.865
											],
											[
												-1.611,
												2.035
											],
											[
												-2.409,
												1.123
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												84.082,
												-61.621
											],
											[
												92.749,
												-59.839
											],
											[
												98.877,
												-55.005
											],
											[
												102.515,
												-47.656
											],
											[
												103.76,
												-38.281
											],
											[
												103.76,
												-32.812
											],
											[
												102.515,
												-23.242
											],
											[
												98.901,
												-15.894
											],
											[
												92.871,
												-11.157
											],
											[
												84.424,
												-9.424
											],
											[
												78.613,
												-9.424
											],
											[
												78.613,
												-61.621
											]
										],
										"c": true
									}
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "D",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "F",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"o": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"v": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"c": true
									}
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "F",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												109.863,
												-39.893
											],
											[
												80.029,
												-39.893
											],
											[
												80.029,
												-61.426
											],
											[
												114.258,
												-61.426
											],
											[
												114.258,
												-71.094
											],
											[
												68.213,
												-71.094
											],
											[
												68.213,
												0
											],
											[
												80.029,
												0
											],
											[
												80.029,
												-30.273
											],
											[
												109.863,
												-30.273
											]
										],
										"c": true
									}
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "F",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "P",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												31.934,
												-27.246
											],
											[
												38.761,
												-27.8
											],
											[
												47.38,
												-31.266
											],
											[
												53.442,
												-37.32
											],
											[
												56.494,
												-45.655
											],
											[
												55.884,
												-55.461
											],
											[
												51.741,
												-63.208
											],
											[
												44.783,
												-68.482
											],
											[
												35.482,
												-71.061
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"o": [
											[
												35.482,
												-27.278
											],
											[
												44.783,
												-29.818
											],
											[
												51.741,
												-35.042
											],
											[
												55.884,
												-42.659
											],
											[
												56.494,
												-52.393
											],
											[
												53.442,
												-60.897
											],
											[
												47.38,
												-67.016
											],
											[
												38.761,
												-70.532
											],
											[
												31.934,
												-71.094
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"v": [
											[
												31.934,
												-27.246
											],
											[
												41.772,
												-28.809
											],
											[
												49.561,
												-33.154
											],
											[
												54.663,
												-39.99
											],
											[
												56.494,
												-48.975
											],
											[
												54.663,
												-58.179
											],
											[
												49.561,
												-65.112
											],
											[
												41.772,
												-69.507
											],
											[
												31.934,
												-71.094
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												19.873,
												-61.621
											],
											[
												31.934,
												-61.621
											],
											[
												35.694,
												-61.263
											],
											[
												40.153,
												-59.155
											],
											[
												43.213,
												-55.566
											],
											[
												44.678,
												-50.732
											],
											[
												44.385,
												-45.491
											],
											[
												42.366,
												-41.211
											],
											[
												38.818,
												-38.224
											],
											[
												33.919,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"o": [
											[
												19.873,
												-61.621
											],
											[
												33.919,
												-61.588
											],
											[
												38.818,
												-60.026
											],
											[
												42.366,
												-56.909
											],
											[
												44.385,
												-52.442
											],
											[
												44.678,
												-47.119
											],
											[
												43.213,
												-42.496
											],
											[
												40.153,
												-39.063
											],
											[
												35.694,
												-37.019
											],
											[
												31.934,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"v": [
											[
												19.873,
												-61.621
											],
											[
												31.934,
												-61.621
											],
											[
												37.256,
												-60.645
											],
											[
												41.26,
												-58.032
											],
											[
												43.799,
												-54.004
											],
											[
												44.678,
												-48.877
											],
											[
												43.799,
												-43.994
											],
											[
												41.26,
												-40.137
											],
											[
												37.256,
												-37.622
											],
											[
												31.934,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "P",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.011,
												1.009
											],
											[
												-2.181,
												1.888
											],
											[
												-1.221,
												2.67
											],
											[
												0,
												3.32
											],
											[
												1.221,
												2.718
											],
											[
												2.18,
												1.904
											],
											[
												3.011,
												1.025
											],
											[
												3.548,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.548,
												-0.032
											],
											[
												3.011,
												-1.009
											],
											[
												2.18,
												-1.888
											],
											[
												1.221,
												-2.669
											],
											[
												0,
												-3.418
											],
											[
												-1.221,
												-2.718
											],
											[
												-2.181,
												-1.904
											],
											[
												-3.011,
												-1.025
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												91.943,
												-27.246
											],
											[
												101.782,
												-28.809
											],
											[
												109.57,
												-33.154
											],
											[
												114.673,
												-39.99
											],
											[
												116.504,
												-48.975
											],
											[
												114.673,
												-58.179
											],
											[
												109.57,
												-65.112
											],
											[
												101.782,
												-69.507
											],
											[
												91.943,
												-71.094
											],
											[
												68.164,
												-71.094
											],
											[
												68.164,
												0
											],
											[
												79.883,
												0
											],
											[
												79.883,
												-27.246
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.562,
												-0.618
											],
											[
												-1.107,
												-1.123
											],
											[
												-0.586,
												-1.562
											],
											[
												0,
												-1.855
											],
											[
												0.586,
												-1.497
											],
											[
												1.106,
												-1.074
											],
											[
												1.562,
												-0.602
											],
											[
												1.985,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												1.985,
												0.033
											],
											[
												1.562,
												0.619
											],
											[
												1.106,
												1.123
											],
											[
												0.586,
												1.562
											],
											[
												0,
												1.758
											],
											[
												-0.586,
												1.498
											],
											[
												-1.107,
												1.074
											],
											[
												-1.562,
												0.603
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.883,
												-61.621
											],
											[
												91.943,
												-61.621
											],
											[
												97.266,
												-60.645
											],
											[
												101.27,
												-58.032
											],
											[
												103.809,
												-54.004
											],
											[
												104.688,
												-48.877
											],
											[
												103.809,
												-43.994
											],
											[
												101.27,
												-40.137
											],
											[
												97.266,
												-37.622
											],
											[
												91.943,
												-36.719
											],
											[
												79.883,
												-36.719
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "P",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "B",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												31.592,
												0
											],
											[
												38.322,
												-0.496
											],
											[
												46.949,
												-3.596
											],
											[
												53.06,
												-9.196
											],
											[
												56.152,
												-17.317
											],
											[
												55.875,
												-24.503
											],
											[
												53.971,
												-29.573
											],
											[
												50.594,
												-33.667
											],
											[
												45.735,
												-36.507
											],
											[
												49.593,
												-40.357
											],
											[
												54.41,
												-48.339
											],
											[
												53.858,
												-58.049
											],
											[
												49.568,
												-64.893
											],
											[
												42.505,
												-69.173
											],
											[
												33.35,
												-71.061
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"o": [
											[
												35.075,
												-0.032
											],
											[
												44.344,
												-2.287
											],
											[
												51.343,
												-7.047
											],
											[
												55.534,
												-14.339
											],
											[
												56.152,
												-22.656
											],
											[
												54.768,
												-27.986
											],
											[
												51.888,
												-32.438
											],
											[
												47.502,
												-35.717
											],
											[
												47.005,
												-38.428
											],
											[
												53.434,
												-45.337
											],
											[
												54.475,
												-55.175
											],
											[
												51.318,
												-62.899
											],
											[
												45.109,
												-68.017
											],
											[
												36.547,
												-70.67
											],
											[
												29.932,
												-71.094
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"v": [
											[
												31.592,
												0
											],
											[
												41.333,
												-1.392
											],
											[
												49.146,
												-5.322
											],
											[
												54.297,
												-11.768
											],
											[
												56.152,
												-20.703
											],
											[
												55.322,
												-26.245
											],
											[
												52.93,
												-31.006
											],
											[
												49.048,
												-34.692
											],
											[
												43.75,
												-37.061
											],
											[
												51.514,
												-42.847
											],
											[
												54.443,
												-51.855
											],
											[
												52.588,
												-60.474
											],
											[
												47.339,
												-66.455
											],
											[
												39.526,
												-69.922
											],
											[
												29.932,
												-71.094
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												32.324,
												-32.227
											],
											[
												35.856,
												-31.909
											],
											[
												40.12,
												-30.079
											],
											[
												43.001,
												-26.929
											],
											[
												44.385,
												-22.493
											],
											[
												44.068,
												-17.48
											],
											[
												41.926,
												-13.59
											],
											[
												38.395,
												-10.962
											],
											[
												33.642,
												-9.602
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"o": [
											[
												34.179,
												-32.194
											],
											[
												38.851,
												-30.835
											],
											[
												42.203,
												-28.125
											],
											[
												44.108,
												-24.097
											],
											[
												44.385,
												-19.01
											],
											[
												42.798,
												-14.746
											],
											[
												39.713,
												-11.701
											],
											[
												35.335,
												-9.888
											],
											[
												31.787,
												-9.57
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"v": [
											[
												32.324,
												-32.227
											],
											[
												37.354,
												-31.372
											],
											[
												41.162,
												-29.102
											],
											[
												43.555,
												-25.513
											],
											[
												44.385,
												-20.703
											],
											[
												43.433,
												-16.113
											],
											[
												40.82,
												-12.646
											],
											[
												36.865,
												-10.425
											],
											[
												31.787,
												-9.57
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												18.994,
												-61.426
											],
											[
												30.127,
												-61.426
											],
											[
												33.626,
												-61.189
											],
											[
												38.013,
												-59.846
											],
											[
												41.129,
												-57.178
											],
											[
												42.676,
												-53.108
											],
											[
												42.35,
												-48.25
											],
											[
												40.168,
												-44.685
											],
											[
												36.646,
												-42.309
											],
											[
												31.983,
												-41.194
											],
											[
												18.994,
												-41.162
											]
										],
										"o": [
											[
												18.994,
												-61.426
											],
											[
												31.95,
												-61.393
											],
											[
												36.686,
												-60.44
											],
											[
												40.259,
												-58.219
											],
											[
												42.366,
												-54.638
											],
											[
												42.676,
												-49.69
											],
											[
												41.047,
												-45.743
											],
											[
												37.955,
												-42.96
											],
											[
												33.618,
												-41.431
											],
											[
												30.225,
												-41.162
											],
											[
												18.994,
												-41.162
											]
										],
										"v": [
											[
												18.994,
												-61.426
											],
											[
												30.127,
												-61.426
											],
											[
												35.156,
												-60.815
											],
											[
												39.136,
												-59.033
											],
											[
												41.748,
												-55.908
											],
											[
												42.676,
												-51.318
											],
											[
												41.699,
												-46.997
											],
											[
												39.062,
												-43.823
											],
											[
												35.132,
												-41.87
											],
											[
												30.225,
												-41.162
											],
											[
												18.994,
												-41.162
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "B",
						"np": 6,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.011,
												0.896
											],
											[
												-2.197,
												1.726
											],
											[
												-1.237,
												2.572
											],
											[
												0,
												3.386
											],
											[
												0.553,
												1.742
											],
											[
												1.041,
												1.433
											],
											[
												1.546,
												1.025
											],
											[
												1.985,
												0.554
											],
											[
												-1.921,
												2.49
											],
											[
												-0.033,
												3.516
											],
											[
												1.27,
												2.425
											],
											[
												2.229,
												1.562
											],
											[
												2.979,
												0.749
											],
											[
												3.418,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.483,
												-0.032
											],
											[
												3.011,
												-0.895
											],
											[
												2.197,
												-1.725
											],
											[
												1.237,
												-2.571
											],
											[
												0,
												-1.953
											],
											[
												-0.554,
												-1.741
											],
											[
												-1.042,
												-1.432
											],
											[
												-1.546,
												-1.025
											],
											[
												3.255,
												-1.367
											],
											[
												1.92,
												-2.49
											],
											[
												0.032,
												-3.32
											],
											[
												-1.27,
												-2.425
											],
											[
												-2.23,
												-1.562
											],
											[
												-2.979,
												-0.748
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												91.602,
												0
											],
											[
												101.343,
												-1.392
											],
											[
												109.155,
												-5.322
											],
											[
												114.307,
												-11.768
											],
											[
												116.162,
												-20.703
											],
											[
												115.332,
												-26.245
											],
											[
												112.939,
												-31.006
											],
											[
												109.058,
												-34.692
											],
											[
												103.76,
												-37.061
											],
											[
												111.523,
												-42.847
											],
											[
												114.453,
												-51.855
											],
											[
												112.598,
												-60.474
											],
											[
												107.349,
												-66.455
											],
											[
												99.536,
												-69.922
											],
											[
												89.941,
												-71.094
											],
											[
												67.236,
												-71.094
											],
											[
												67.236,
												0
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-1.498,
												-0.537
											],
											[
												-1.042,
												-0.977
											],
											[
												-0.554,
												-1.416
											],
											[
												0,
												-1.79
											],
											[
												0.635,
												-1.367
											],
											[
												1.106,
												-0.944
											],
											[
												1.53,
												-0.537
											],
											[
												1.855,
												-0.032
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												1.855,
												0.033
											],
											[
												1.497,
												0.537
											],
											[
												1.041,
												0.977
											],
											[
												0.553,
												1.416
											],
											[
												0,
												1.693
											],
											[
												-0.635,
												1.367
											],
											[
												-1.107,
												0.945
											],
											[
												-1.53,
												0.537
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												92.334,
												-32.227
											],
											[
												97.363,
												-31.372
											],
											[
												101.172,
												-29.102
											],
											[
												103.564,
												-25.513
											],
											[
												104.395,
												-20.703
											],
											[
												103.442,
												-16.113
											],
											[
												100.83,
												-12.646
											],
											[
												96.875,
												-10.425
											],
											[
												91.797,
												-9.57
											],
											[
												79.004,
												-9.57
											],
											[
												79.004,
												-32.227
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.53,
												-0.374
											],
											[
												-1.123,
												-0.813
											],
											[
												-0.619,
												-1.27
											],
											[
												0,
												-1.79
											],
											[
												0.651,
												-1.253
											],
											[
												1.106,
												-0.862
											],
											[
												1.514,
												-0.439
											],
											[
												1.758,
												-0.032
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												1.823,
												0.033
											],
											[
												1.53,
												0.375
											],
											[
												1.123,
												0.814
											],
											[
												0.618,
												1.27
											],
											[
												0,
												1.628
											],
											[
												-0.652,
												1.254
											],
											[
												-1.107,
												0.863
											],
											[
												-1.514,
												0.439
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.004,
												-61.426
											],
											[
												90.137,
												-61.426
											],
											[
												95.166,
												-60.815
											],
											[
												99.146,
												-59.033
											],
											[
												101.758,
												-55.908
											],
											[
												102.686,
												-51.318
											],
											[
												101.709,
												-46.997
											],
											[
												99.072,
												-43.823
											],
											[
												95.142,
												-41.87
											],
											[
												90.234,
												-41.162
											],
											[
												79.004,
												-41.162
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "B",
						"np": 6,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "+",
			"size": 10,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												35.4,
												-58.887
											],
											[
												24.023,
												-58.887
											],
											[
												24.023,
												-39.062
											],
											[
												5.322,
												-39.062
											],
											[
												5.322,
												-28.076
											],
											[
												24.023,
												-28.076
											],
											[
												24.023,
												-7.129
											],
											[
												35.4,
												-7.129
											],
											[
												35.4,
												-28.076
											],
											[
												54.053,
												-28.076
											],
											[
												54.053,
												-39.062
											],
											[
												35.4,
												-39.062
											]
										],
										"o": [
											[
												35.4,
												-58.887
											],
											[
												24.023,
												-58.887
											],
											[
												24.023,
												-39.062
											],
											[
												5.322,
												-39.062
											],
											[
												5.322,
												-28.076
											],
											[
												24.023,
												-28.076
											],
											[
												24.023,
												-7.129
											],
											[
												35.4,
												-7.129
											],
											[
												35.4,
												-28.076
											],
											[
												54.053,
												-28.076
											],
											[
												54.053,
												-39.062
											],
											[
												35.4,
												-39.062
											]
										],
										"v": [
											[
												35.4,
												-58.887
											],
											[
												24.023,
												-58.887
											],
											[
												24.023,
												-39.062
											],
											[
												5.322,
												-39.062
											],
											[
												5.322,
												-28.076
											],
											[
												24.023,
												-28.076
											],
											[
												24.023,
												-7.129
											],
											[
												35.4,
												-7.129
											],
											[
												35.4,
												-28.076
											],
											[
												54.053,
												-28.076
											],
											[
												54.053,
												-39.062
											],
											[
												35.4,
												-39.062
											]
										],
										"c": true
									}
								},
								"nm": "+",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "+",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												95.41,
												-58.887
											],
											[
												84.033,
												-58.887
											],
											[
												84.033,
												-39.062
											],
											[
												65.332,
												-39.062
											],
											[
												65.332,
												-28.076
											],
											[
												84.033,
												-28.076
											],
											[
												84.033,
												-7.129
											],
											[
												95.41,
												-7.129
											],
											[
												95.41,
												-28.076
											],
											[
												114.062,
												-28.076
											],
											[
												114.062,
												-39.062
											],
											[
												95.41,
												-39.062
											]
										],
										"c": true
									}
								},
								"nm": "+",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "+",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		}
	]
};

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = {
	"v": "4.5.9",
	"fr": 29.9700012207031,
	"ip": 24.00000097754,
	"op": 271.000011038056,
	"w": 844,
	"h": 604,
	"ddd": 0,
	"assets": [
		{
			"id": "image_0",
			"w": 3456,
			"h": 2039,
			"u": "pages/b2b/img/",
			"p": "phone-grid-bg.png"
		}
	],
	"fonts": {
		"list": [
			{
				"fName": "RobotoMono-Medium",
				"fFamily": "Roboto Mono",
				"fStyle": "Medium",
				"ascent": 75
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 0,
			"ty": 5,
			"nm": "\r01_yourapp",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						457.875,
						522.376,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						33.875,
						5.876,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 13,
								"f": "RobotoMono-Medium",
								"t": "YOUR\rAPPLICATION",
								"j": 0,
								"tr": 60,
								"lh": 21,
								"fc": [
									0.33,
									0.34,
									0.4
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					}
				},
				"a": [
					{
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0
							},
							"ne": {
								"a": 0,
								"k": 0
							},
							"a": {
								"a": 0,
								"k": 100
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0
											],
											"y": [
												1.023
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0_1p023_0p333_0"
										],
										"t": 141,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 157.000006394741
									}
								]
							},
							"r": 1
						},
						"a": {
							"o": {
								"a": 0,
								"k": 0
							}
						}
					}
				]
			},
			"ip": 110.000004480392,
			"op": 439.000017880837,
			"st": 110.000004480392,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "\r01_youtapp",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						407.419,
						513.339,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						-139.581,
						-46.661,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									5.339,
									5.339
								]
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.329,
									0.341,
									0.4,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.03
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.329,
									0.341,
									0.4,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-139.581,
									-49.331
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667,
												0.667
											],
											"y": [
												1,
												1
											]
										},
										"o": {
											"x": [
												0.985,
												0.985
											],
											"y": [
												-0.011,
												-0.011
											]
										},
										"n": [
											"0p667_1_0p985_-0p011",
											"0p667_1_0p985_-0p011"
										],
										"t": 138.371,
										"s": [
											0,
											0
										],
										"e": [
											100,
											100
										]
									},
									{
										"t": 144.00000586524
									}
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-139.5,
											-48.5
										],
										[
											-139.5,
											-159
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.329,
									0.341,
									0.4,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.03
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"d": [
								{
									"n": "d",
									"nm": "dash",
									"v": {
										"a": 0,
										"k": 1.033
									}
								},
								{
									"n": "g",
									"nm": "gap",
									"v": {
										"a": 0,
										"k": 3
									}
								},
								{
									"n": "o",
									"nm": "offset",
									"v": {
										"a": 0,
										"k": 0
									}
								}
							],
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.09,
									0.122,
									0.235,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												1
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"1_1_0p333_0"
										],
										"t": 132,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 140.000005702317
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 2,
							"ix": 4,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 4,
					"mn": "ADBE Vector Group"
				}
			],
			"ip": 14.0000005702317,
			"op": 343.000013970676,
			"st": 14.0000005702317,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 5,
			"nm": "02_auth0_features\r",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						657.875,
						407.376,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						33.875,
						5.876,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 13,
								"f": "RobotoMono-Medium",
								"t": "AUTH0\rFEATURES",
								"j": 0,
								"tr": 60,
								"lh": 21,
								"fc": [
									0.92,
									0.33,
									0.14
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					}
				},
				"a": [
					{
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0
							},
							"ne": {
								"a": 0,
								"k": 0
							},
							"a": {
								"a": 0,
								"k": 100
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.216
											],
											"y": [
												0.982
											]
										},
										"o": {
											"x": [
												0.117
											],
											"y": [
												0.203
											]
										},
										"n": [
											"0p216_0p982_0p117_0p203"
										],
										"t": 121,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 137.000005580124
									}
								]
							},
							"r": 1
						},
						"a": {
							"o": {
								"a": 0,
								"k": 0
							}
						}
					}
				]
			},
			"ip": 82.0000033399285,
			"op": 411.000016740373,
			"st": 82.0000033399285,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "\r02_authofeatures",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						607.64,
						398.749,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						-139.36,
						6.749,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									5.339,
									5.339
								]
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								]
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.922,
									0.329,
									0.141,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.03
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.863,
									0.314,
									0.145,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-139.581,
									4.669
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667,
												0.667
											],
											"y": [
												1,
												1
											]
										},
										"o": {
											"x": [
												0.985,
												0.985
											],
											"y": [
												-0.011,
												-0.011
											]
										},
										"n": [
											"0p667_1_0p985_-0p011",
											"0p667_1_0p985_-0p011"
										],
										"t": 117.371,
										"s": [
											0,
											0
										],
										"e": [
											100,
											100
										]
									},
									{
										"t": 123.000005009893
									}
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-139.5,
											4
										],
										[
											-139.5,
											-159
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.922,
									0.329,
									0.141,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.03
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"d": [
								{
									"n": "d",
									"nm": "dash",
									"v": {
										"a": 0,
										"k": 1.033
									}
								},
								{
									"n": "g",
									"nm": "gap",
									"v": {
										"a": 0,
										"k": 3
									}
								},
								{
									"n": "o",
									"nm": "offset",
									"v": {
										"a": 0,
										"k": 0
									}
								}
							],
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.09,
									0.122,
									0.235,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												1
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"1_1_0p333_0"
										],
										"t": 111,
										"s": [
											100
										],
										"e": [
											0
										]
									},
									{
										"t": 119.000004846969
									}
								],
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 2,
							"ix": 4,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 4,
					"mn": "ADBE Vector Group"
				}
			],
			"ip": 0,
			"op": 329.000013400445,
			"st": 0,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "\r03_yourapp_line",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						282.5,
						187,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						-139.5,
						-115,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									5.339,
									5.339
								]
							},
							"p": {
								"a": 0,
								"k": [
									-1,
									0
								]
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.03
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-138.581,
									-157.831
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667,
												0.667
											],
											"y": [
												1,
												1
											]
										},
										"o": {
											"x": [
												0.985,
												0.985
											],
											"y": [
												-0.011,
												-0.011
											]
										},
										"n": [
											"0p667_1_0p985_-0p011",
											"0p667_1_0p985_-0p011"
										],
										"t": 96,
										"s": [
											0,
											0
										],
										"e": [
											100,
											100
										]
									},
									{
										"t": 101.628754139424
									}
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-139.5,
											-71
										],
										[
											-139.5,
											-159
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.03
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"d": [
								{
									"n": "d",
									"nm": "dash",
									"v": {
										"a": 0,
										"k": 1.033
									}
								},
								{
									"n": "g",
									"nm": "gap",
									"v": {
										"a": 0,
										"k": 3
									}
								},
								{
									"n": "o",
									"nm": "offset",
									"v": {
										"a": 0,
										"k": 0
									}
								}
							],
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.09,
									0.122,
									0.235,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0p833_1_0p333_0"
										],
										"t": 87,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 96.0000039101602
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 2,
							"ix": 4,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 4,
					"mn": "ADBE Vector Group"
				}
			],
			"ip": 0,
			"op": 329.000013400445,
			"st": 0,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 5,
			"nm": "\r03_YOURAPP_TEXT",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						224.219,
						158.379,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						-37.781,
						5.879,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 13,
								"f": "RobotoMono-Medium",
								"t": "YOUR APP\rLOGIN BOX",
								"j": 1,
								"tr": 60,
								"lh": 21,
								"fc": [
									0.97,
									0.97,
									0.97
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					}
				},
				"a": [
					{
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0
							},
							"ne": {
								"a": 0,
								"k": 0
							},
							"a": {
								"a": 0,
								"k": 100
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0
											],
											"y": [
												1.015
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0_1p015_0p333_0"
										],
										"t": 100,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 116.000004724777
									}
								]
							},
							"r": 1
						},
						"a": {
							"o": {
								"a": 0,
								"k": 0
							}
						}
					}
				]
			},
			"ip": 62.0000025253118,
			"op": 391.000015925757,
			"st": 62.0000025253118,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "01 Outlines 2",
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0
								],
								"y": [
									0.986
								]
							},
							"o": {
								"x": [
									0.142
								],
								"y": [
									0.003
								]
							},
							"n": [
								"0_0p986_0p142_0p003"
							],
							"t": 73,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 95.0000038694293
						}
					]
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0,
								"y": 0.994
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"n": "0_0p994_0p333_0",
							"t": 73,
							"s": [
								446,
								290,
								0
							],
							"e": [
								446,
								202,
								0
							],
							"to": [
								0,
								-14.6666669845581,
								0
							],
							"ti": [
								0,
								14.6666669845581,
								0
							]
						},
						{
							"t": 91.000003706506
						}
					]
				},
				"a": {
					"a": 0,
					"k": [
						145.098,
						85.996,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						130,
						130,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											10.384,
											-18.402
										],
										[
											-8.009,
											-29.02
										]
									],
									"c": false
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 1,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											31.78,
											-6.05
										],
										[
											50.068,
											4.507
										]
									],
									"c": false
								}
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 2,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-28.259,
											29.639
										],
										[
											-51.684,
											16.235
										]
									],
									"c": false
								}
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 3,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											5.895,
											3.422
										],
										[
											5.852,
											-3.361
										],
										[
											-5.912,
											-3.422
										],
										[
											-5.841,
											3.358
										]
									],
									"o": [
										[
											-5.9,
											-3.425
										],
										[
											-5.854,
											3.361
										],
										[
											5.907,
											3.418
										],
										[
											5.84,
											-3.357
										]
									],
									"v": [
										[
											60.026,
											-34.197
										],
										[
											38.745,
											-34.316
										],
										[
											38.853,
											-22.031
										],
										[
											60.122,
											-21.925
										]
									],
									"c": true
								}
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 4,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-17.617,
											-8.5
										],
										[
											-29.876,
											-1.461
										]
									],
									"c": false
								}
							},
							"nm": "Path 5",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 5,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											27.069,
											17.182
										],
										[
											-30.376,
											-15.832
										],
										[
											-42.651,
											-8.789
										],
										[
											14.862,
											24.206
										]
									],
									"c": true
								}
							},
							"nm": "Path 6",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 6,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											29.547,
											-16.684
										],
										[
											14.228,
											-7.882
										]
									],
									"c": false
								}
							},
							"nm": "Path 7",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 7,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-25.542,
											-30.817
										],
										[
											53.828,
											14.955
										]
									],
									"c": false
								}
							},
							"nm": "Path 8",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 8,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											69.089,
											6.17
										],
										[
											-10.132,
											-39.617
										]
									],
									"c": false
								}
							},
							"nm": "Path 9",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 9,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-69.142,
											-5.876
										],
										[
											10.613,
											39.833
										]
									],
									"c": false
								}
							},
							"nm": "Path 10",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 10,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.877,
											-0.504
										],
										[
											0,
											0
										],
										[
											0.892,
											0.51
										],
										[
											0,
											0
										],
										[
											-0.887,
											0.509
										],
										[
											0,
											0
										],
										[
											-0.893,
											-0.518
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.883,
											0.512
										],
										[
											0,
											0
										],
										[
											-0.881,
											0.507
										],
										[
											0,
											0
										],
										[
											-0.902,
											-0.516
										],
										[
											0,
											0
										],
										[
											0.883,
											-0.507
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											61.04,
											-22.785
										],
										[
											88.512,
											-6.86
										],
										[
											88.523,
											-5.019
										],
										[
											-8.612,
											50.9
										],
										[
											-11.822,
											50.895
										],
										[
											-88.487,
											7.089
										],
										[
											-88.513,
											5.234
										],
										[
											9.362,
											-50.9
										],
										[
											12.578,
											-50.88
										],
										[
											39.846,
											-35.072
										]
									],
									"c": false
								}
							},
							"nm": "Path 11",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1.033
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									146.836,
									84.478
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 13,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											3.904,
											2.217
										],
										[
											0,
											0
										],
										[
											-3.889,
											2.228
										],
										[
											0,
											0
										],
										[
											-3.889,
											-2.271
										],
										[
											0,
											0
										],
										[
											3.814,
											-2.198
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-3.962,
											-2.25
										],
										[
											0,
											0
										],
										[
											3.855,
											-2.209
										],
										[
											0,
											0
										],
										[
											3.833,
											2.238
										],
										[
											0,
											0
										],
										[
											-3.847,
											2.217
										]
									],
									"v": [
										[
											-44.394,
											78.349
										],
										[
											-136.076,
											26.287
										],
										[
											-136.21,
											18.177
										],
										[
											32.239,
											-78.357
										],
										[
											46.262,
											-78.244
										],
										[
											136.252,
											-25.689
										],
										[
											136.285,
											-17.659
										],
										[
											-30.36,
											78.349
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.09,
									0.122,
									0.235,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 80
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									1,
									1,
									1,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 2
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									145.099,
									85.566
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 3,
					"mn": "ADBE Vector Group"
				}
			],
			"ip": 0,
			"op": 1500.00006109625,
			"st": 0,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "02 Outlines 2",
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.198
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0p198_1_0p333_0"
							],
							"t": 73,
							"s": [
								0
							],
							"e": [
								100
							]
						},
						{
							"t": 94.0000038286985
						}
					]
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.054,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"n": "0p054_1_0p333_0",
							"t": 73,
							"s": [
								445,
								309,
								0
							],
							"e": [
								445,
								261,
								0
							],
							"to": [
								0,
								-8,
								0
							],
							"ti": [
								0,
								8,
								0
							]
						},
						{
							"t": 90.7237536952541
						}
					]
				},
				"a": {
					"a": 0,
					"k": [
						145.098,
						85.482,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						130,
						130,
						100
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											95.944,
											-8.812
										],
										[
											74.796,
											-21.255
										],
										[
											95.944,
											-33.465
										],
										[
											117.092,
											-21.255
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 1,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.089
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.177
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0.001,
											0.178
										],
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.088,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-0.154,
											-0.089
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.088
										],
										[
											-0.001,
											0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.078,
											0.045
										],
										[
											0.087,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.09
										],
										[
											-0.001,
											-0.177
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.079,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.089
										],
										[
											0,
											0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											77.045,
											-10.944
										],
										[
											66.275,
											-17.162
										],
										[
											65.775,
											-17.162
										],
										[
											43.633,
											-4.378
										],
										[
											43.383,
											-3.948
										],
										[
											43.63,
											-3.515
										],
										[
											53.939,
											2.551
										],
										[
											47.011,
											6.529
										],
										[
											18.118,
											-10.231
										],
										[
											25.232,
											-14.315
										],
										[
											36.899,
											-7.535
										],
										[
											37.151,
											-7.467
										],
										[
											37.404,
											-7.537
										],
										[
											59.546,
											-20.564
										],
										[
											59.792,
											-20.997
										],
										[
											59.542,
											-21.428
										],
										[
											48.406,
											-27.849
										],
										[
											54.985,
											-31.626
										],
										[
											65.946,
											-25.176
										],
										[
											66.2,
											-25.107
										],
										[
											66.453,
											-25.176
										],
										[
											76.741,
											-31.229
										],
										[
											83.531,
											-27.453
										],
										[
											73.552,
											-21.692
										],
										[
											73.302,
											-21.261
										],
										[
											73.549,
											-20.829
										],
										[
											83.78,
											-14.809
										]
									],
									"c": true
								}
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 2,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											87.174,
											-3.942
										],
										[
											66.025,
											8.502
										],
										[
											44.876,
											-3.942
										],
										[
											66.025,
											-16.152
										]
									],
									"c": true
								}
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 3,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											57.09,
											13.532
										],
										[
											47.027,
											19.456
										],
										[
											-33.843,
											-27.696
										],
										[
											-23.795,
											-33.387
										]
									],
									"c": true
								}
							},
							"nm": "Path 4",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 4,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-14.811,
											-38.745
										],
										[
											6.334,
											-50.952
										],
										[
											58.298,
											-20.991
										],
										[
											37.149,
											-8.546
										],
										[
											25.297,
											-15.434
										],
										[
											25.267,
											-15.488
										],
										[
											25.236,
											-15.47
										]
									],
									"c": true
								}
							},
							"nm": "Path 5",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 5,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											45.051,
											-38.63
										],
										[
											66.2,
											-50.84
										],
										[
											87.349,
											-38.63
										],
										[
											76.727,
											-32.381
										],
										[
											76.596,
											-32.454
										],
										[
											76.472,
											-32.231
										],
										[
											66.2,
											-26.187
										],
										[
											55.089,
											-32.725
										],
										[
											55.04,
											-32.81
										],
										[
											54.991,
											-32.782
										]
									],
									"c": true
								}
							},
							"nm": "Path 6",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 6,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											36.416,
											-43.495
										],
										[
											15.267,
											-55.939
										],
										[
											36.416,
											-68.149
										],
										[
											57.565,
											-55.939
										]
									],
									"c": true
								}
							},
							"nm": "Path 7",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 7,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.178
										],
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.001,
											0.178
										],
										[
											0.155,
											0.088
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.153,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.088,
											0
										],
										[
											-0.079,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											-0.177
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.155,
											-0.089
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0.178
										],
										[
											0.153,
											0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.088,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0.178
										],
										[
											0.154,
											0.088
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.088,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0.178
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.089
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.09
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.155,
											0.088
										],
										[
											-0.001,
											0.178
										],
										[
											0,
											0
										],
										[
											0.078,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.089
										],
										[
											0,
											0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.154,
											-0.088
										],
										[
											0,
											0
										],
										[
											-0.155,
											0.089
										],
										[
											-0.001,
											0.179
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										],
										[
											-0.155,
											0.088
										],
										[
											-0.001,
											0.179
										],
										[
											0,
											0
										],
										[
											0.078,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.089
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.078,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.09
										],
										[
											-0.001,
											-0.177
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.078,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.089
										],
										[
											-0.001,
											-0.178
										]
									],
									"v": [
										[
											118.336,
											-21.692
										],
										[
											96.194,
											-34.475
										],
										[
											95.694,
											-34.475
										],
										[
											84.54,
											-28.036
										],
										[
											77.74,
											-31.817
										],
										[
											88.595,
											-38.204
										],
										[
											88.842,
											-38.636
										],
										[
											88.592,
											-39.067
										],
										[
											66.45,
											-51.85
										],
										[
											65.95,
											-51.85
										],
										[
											55.08,
											-45.575
										],
										[
											48.316,
											-49.337
										],
										[
											58.812,
											-55.512
										],
										[
											59.058,
											-55.945
										],
										[
											58.808,
											-56.375
										],
										[
											36.666,
											-69.159
										],
										[
											36.166,
											-69.159
										],
										[
											14.025,
											-56.375
										],
										[
											13.775,
											-55.945
										],
										[
											14.021,
											-55.512
										],
										[
											36.163,
											-42.484
										],
										[
											36.416,
											-42.415
										],
										[
											36.67,
											-42.484
										],
										[
											47.317,
											-48.749
										],
										[
											54.072,
											-44.992
										],
										[
											43.808,
											-39.067
										],
										[
											43.558,
											-38.636
										],
										[
											43.805,
											-38.204
										],
										[
											53.993,
											-32.209
										],
										[
											47.404,
											-28.427
										],
										[
											6.583,
											-51.962
										],
										[
											6.084,
											-51.961
										],
										[
											-16.058,
											-39.178
										],
										[
											-16.308,
											-38.747
										],
										[
											-16.06,
											-38.313
										],
										[
											24.234,
											-14.895
										],
										[
											17.295,
											-10.912
										],
										[
											17.47,
											-10.607
										],
										[
											-23.541,
											-34.396
										],
										[
											-24.038,
											-34.398
										],
										[
											-35.093,
											-28.136
										],
										[
											-35.346,
											-27.705
										],
										[
											-35.098,
											-27.27
										],
										[
											46.776,
											20.466
										],
										[
											47.028,
											20.535
										],
										[
											47.281,
											20.465
										],
										[
											58.335,
											13.959
										],
										[
											58.582,
											13.527
										],
										[
											58.333,
											13.096
										],
										[
											48.01,
											7.108
										],
										[
											54.931,
											3.135
										],
										[
											65.772,
											9.513
										],
										[
											66.025,
											9.583
										],
										[
											66.278,
											9.513
										],
										[
											88.42,
											-3.515
										],
										[
											88.667,
											-3.948
										],
										[
											88.417,
											-4.378
										],
										[
											78.046,
											-10.365
										],
										[
											84.772,
											-14.225
										],
										[
											95.691,
											-7.801
										],
										[
											95.944,
											-7.732
										],
										[
											96.197,
											-7.801
										],
										[
											118.339,
											-20.829
										],
										[
											118.586,
											-21.261
										]
									],
									"c": true
								}
							},
							"nm": "Path 8",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 8,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											28.671,
											30.261
										],
										[
											-52.199,
											-16.89
										],
										[
											-42.151,
											-22.582
										],
										[
											38.735,
											24.337
										]
									],
									"c": true
								}
							},
							"nm": "Path 9",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 9,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-0.277
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.088,
											0
										],
										[
											-0.078,
											0.045
										],
										[
											0,
											0
										],
										[
											0,
											0.177
										],
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-0.276,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.078,
											0.045
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.09
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											10.104,
											27.893
										],
										[
											-13.279,
											27.893
										],
										[
											-13.813,
											28.581
										],
										[
											-13.813,
											42.057
										],
										[
											-18.576,
											44.801
										],
										[
											-47.185,
											28.201
										],
										[
											-41.141,
											24.734
										],
										[
											-30.491,
											31
										],
										[
											-30.236,
											31.069
										],
										[
											-29.982,
											31
										],
										[
											-7.84,
											17.971
										],
										[
											-7.593,
											17.539
										],
										[
											-7.843,
											17.108
										],
										[
											-18.051,
											11.215
										],
										[
											-11.968,
											7.724
										],
										[
											16.575,
											24.272
										]
									],
									"c": true
								}
							},
							"nm": "Path 10",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 10,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											9.187,
											29.419
										],
										[
											9.187,
											41.893
										],
										[
											-12.813,
											41.893
										],
										[
											-12.813,
											28.893
										],
										[
											9.45,
											28.893
										]
									],
									"c": true
								}
							},
							"nm": "Path 11",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 11,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-8.458,
											51.816
										],
										[
											-18.522,
											57.74
										],
										[
											-99.391,
											10.588
										],
										[
											-89.344,
											4.897
										]
									],
									"c": true
								}
							},
							"nm": "Path 12",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 12,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-36.057,
											55.343
										],
										[
											-64.42,
											38.89
										],
										[
											-58.583,
											35.539
										],
										[
											-30.294,
											52.033
										]
									],
									"c": true
								}
							},
							"nm": "Path 13",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 13,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-26.148,
											62.247
										],
										[
											-36.212,
											68.169
										],
										[
											-117.081,
											21.019
										],
										[
											-107.034,
											15.328
										],
										[
											-36.204,
											56.414
										],
										[
											-36.132,
											56.539
										],
										[
											-36.06,
											56.497
										]
									],
									"c": true
								}
							},
							"nm": "Path 14",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 14,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-51.384,
											17.544
										],
										[
											-30.235,
											5.334
										],
										[
											-9.086,
											17.544
										],
										[
											-30.235,
											29.989
										]
									],
									"c": true
								}
							},
							"nm": "Path 15",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 15,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-59.933,
											12.156
										],
										[
											-81.082,
											-0.288
										],
										[
											-59.933,
											-12.499
										],
										[
											-38.784,
											-0.288
										]
									],
									"c": true
								}
							},
							"nm": "Path 16",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 16,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0.155,
											-0.089
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.179
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.001,
											0.177
										],
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.153,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.088,
											0
										],
										[
											-0.078,
											0.045
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.155,
											-0.089
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.179
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.155,
											-0.089
										],
										[
											0,
											0
										],
										[
											0.001,
											-0.178
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0.177
										],
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.045
										],
										[
											0,
											0
										],
										[
											0,
											0.178
										],
										[
											0.154,
											0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.276
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0.177
										],
										[
											0.154,
											0.089
										]
									],
									"o": [
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										],
										[
											-0.155,
											0.088
										],
										[
											-0.001,
											0.179
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.09
										],
										[
											0,
											-0.178
										],
										[
											0,
											0
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.089
										],
										[
											0,
											0.177
										],
										[
											0,
											0
										],
										[
											0.078,
											0.045
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.089
										],
										[
											0,
											0.177
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										],
										[
											-0.156,
											0.088
										],
										[
											-0.001,
											0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										],
										[
											-0.156,
											0.088
										],
										[
											-0.001,
											0.179
										],
										[
											0,
											0
										],
										[
											0.078,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.078,
											0.045
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.277,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.078,
											0.046
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.153,
											-0.09
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-41.897,
											-23.59
										],
										[
											-42.394,
											-23.592
										],
										[
											-53.449,
											-17.331
										],
										[
											-53.702,
											-16.899
										],
										[
											-53.454,
											-16.464
										],
										[
											-12.965,
											7.143
										],
										[
											-19.052,
											10.637
										],
										[
											-29.985,
											4.325
										],
										[
											-30.485,
											4.325
										],
										[
											-42.282,
											11.136
										],
										[
											-49.3,
											7.06
										],
										[
											-37.537,
											0.139
										],
										[
											-37.291,
											-0.293
										],
										[
											-37.541,
											-0.724
										],
										[
											-59.683,
											-13.508
										],
										[
											-60.183,
											-13.508
										],
										[
											-82.325,
											-0.724
										],
										[
											-82.575,
											-0.293
										],
										[
											-82.328,
											0.139
										],
										[
											-60.186,
											13.167
										],
										[
											-59.933,
											13.236
										],
										[
											-59.68,
											13.167
										],
										[
											-50.289,
											7.642
										],
										[
											-43.281,
											11.712
										],
										[
											-52.627,
											17.108
										],
										[
											-52.877,
											17.539
										],
										[
											-52.63,
											17.971
										],
										[
											-42.129,
											24.15
										],
										[
											-48.176,
											27.621
										],
										[
											-89.09,
											3.888
										],
										[
											-89.587,
											3.886
										],
										[
											-100.641,
											10.148
										],
										[
											-100.895,
											10.58
										],
										[
											-100.647,
											11.014
										],
										[
											-59.58,
											34.958
										],
										[
											-65.419,
											38.311
										],
										[
											-106.78,
											14.319
										],
										[
											-107.277,
											14.317
										],
										[
											-118.331,
											20.579
										],
										[
											-118.585,
											21.01
										],
										[
											-118.337,
											21.445
										],
										[
											-36.463,
											69.18
										],
										[
											-36.211,
											69.249
										],
										[
											-35.958,
											69.179
										],
										[
											-24.904,
											62.674
										],
										[
											-24.657,
											62.242
										],
										[
											-24.906,
											61.811
										],
										[
											-35.058,
											55.922
										],
										[
											-29.297,
											52.615
										],
										[
											-18.773,
											58.751
										],
										[
											-18.521,
											58.819
										],
										[
											-18.268,
											58.75
										],
										[
											-7.214,
											52.244
										],
										[
											-6.967,
											51.811
										],
										[
											-7.216,
											51.38
										],
										[
											-17.56,
											45.518
										],
										[
											-12.747,
											42.893
										],
										[
											10.144,
											42.893
										],
										[
											10.187,
											42.118
										],
										[
											10.187,
											28.923
										],
										[
											17.344,
											24.947
										],
										[
											28.305,
											31.272
										],
										[
											28.614,
											31.34
										],
										[
											28.896,
											31.271
										],
										[
											39.965,
											24.765
										],
										[
											40.219,
											24.333
										],
										[
											39.973,
											23.902
										]
									],
									"c": true
								}
							},
							"nm": "Path 17",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 17,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											31.226,
											-30.476
										],
										[
											46.513,
											-21.709
										],
										[
											36.261,
											-15.678
										],
										[
											20.977,
											-24.559
										]
									],
									"c": true
								}
							},
							"nm": "Path 18",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 18,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											12.382,
											-29.417
										],
										[
											-2.902,
											-38.298
										],
										[
											7.346,
											-44.215
										],
										[
											22.634,
											-35.449
										]
									],
									"c": true
								}
							},
							"nm": "Path 19",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ind": 19,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.045
										],
										[
											0,
											0
										],
										[
											0.001,
											0.178
										],
										[
											0.155,
											0.089
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.001,
											0.179
										],
										[
											0.155,
											0.089
										],
										[
											0,
											0
										],
										[
											0.155,
											-0.089
										],
										[
											0,
											0
										],
										[
											0,
											-0.178
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										],
										[
											-0.087,
											0
										],
										[
											-0.078,
											0.046
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-0.178
										],
										[
											-0.154,
											-0.09
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											-0.001,
											-0.178
										],
										[
											0,
											0
										],
										[
											-0.154,
											-0.089
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.154,
											-0.09
										],
										[
											-0.001,
											-0.177
										],
										[
											0,
											0
										],
										[
											-0.153,
											-0.089
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.089
										],
										[
											0,
											0.178
										],
										[
											0,
											0
										],
										[
											0.078,
											0.045
										],
										[
											0.088,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.154,
											0.089
										],
										[
											0,
											0.179
										],
										[
											0,
											0
										],
										[
											0.078,
											0.044
										]
									],
									"v": [
										[
											36.263,
											-14.599
										],
										[
											36.516,
											-14.668
										],
										[
											47.762,
											-21.285
										],
										[
											48.008,
											-21.718
										],
										[
											47.757,
											-22.149
										],
										[
											31.473,
											-31.487
										],
										[
											30.975,
											-31.486
										],
										[
											25.57,
											-28.365
										],
										[
											18.884,
											-32.083
										],
										[
											23.883,
											-35.024
										],
										[
											24.13,
											-35.458
										],
										[
											23.878,
											-35.888
										],
										[
											7.594,
											-45.226
										],
										[
											7.095,
											-45.225
										],
										[
											-4.15,
											-38.732
										],
										[
											-4.4,
											-38.3
										],
										[
											-4.151,
											-37.867
										],
										[
											12.133,
											-28.406
										],
										[
											12.384,
											-28.338
										],
										[
											12.637,
											-28.408
										],
										[
											17.885,
											-31.495
										],
										[
											24.561,
											-27.782
										],
										[
											19.729,
											-24.993
										],
										[
											19.479,
											-24.561
										],
										[
											19.728,
											-24.127
										],
										[
											36.012,
											-14.666
										]
									],
									"c": true
								}
							},
							"nm": "Path 20",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge"
						},
						{
							"ty": "mm",
							"mm": 4,
							"nm": "Merge Paths 2",
							"mn": "ADBE Vector Filter - Merge"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.922,
									0.329,
									0.141,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									145.64,
									85.696
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 23,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											3.904,
											2.217
										],
										[
											0,
											0
										],
										[
											-3.889,
											2.228
										],
										[
											0,
											0
										],
										[
											-3.889,
											-2.271
										],
										[
											0,
											0
										],
										[
											3.814,
											-2.198
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-3.962,
											-2.25
										],
										[
											0,
											0
										],
										[
											3.855,
											-2.209
										],
										[
											0,
											0
										],
										[
											3.833,
											2.238
										],
										[
											0,
											0
										],
										[
											-3.847,
											2.217
										]
									],
									"v": [
										[
											-44.394,
											78.349
										],
										[
											-136.076,
											26.287
										],
										[
											-136.21,
											18.177
										],
										[
											32.239,
											-78.357
										],
										[
											46.262,
											-78.244
										],
										[
											136.252,
											-25.689
										],
										[
											136.285,
											-17.659
										],
										[
											-30.36,
											78.349
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.09,
									0.122,
									0.235,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 80
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.922,
									0.329,
									0.141,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 2
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									145.099,
									85.566
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 3,
					"mn": "ADBE Vector Group"
				}
			],
			"ip": 0,
			"op": 1500.00006109625,
			"st": 0,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "01 Outlines",
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0
								],
								"y": [
									0.986
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0_0p986_0p333_0"
							],
							"t": 50,
							"s": [
								100
							],
							"e": [
								20
							]
						},
						{
							"i": {
								"x": [
									0
								],
								"y": [
									1.014
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0_1p014_0p333_0"
							],
							"t": 54,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"i": {
								"x": [
									0
								],
								"y": [
									0.986
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0_0p986_0p333_0"
							],
							"t": 58,
							"s": [
								100
							],
							"e": [
								20
							]
						},
						{
							"i": {
								"x": [
									0
								],
								"y": [
									1.014
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0_1p014_0p333_0"
							],
							"t": 62,
							"s": [
								20
							],
							"e": [
								100
							]
						},
						{
							"t": 66.0000026882351
						}
					]
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0,
								"y": 1
							},
							"o": {
								"x": 0.053,
								"y": 0
							},
							"n": "0_1_0p053_0",
							"t": 66.974,
							"s": [
								441.145,
								209.49,
								0
							],
							"e": [
								441.145,
								329.49,
								0
							],
							"to": [
								0,
								20,
								0
							],
							"ti": [
								0,
								-20,
								0
							]
						},
						{
							"t": 81.0000032991976
						}
					]
				},
				"a": {
					"a": 0,
					"k": [
						744.283,
						1316.166,
						0
					]
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.128,
									0.128,
									0.667
								],
								"y": [
									1,
									1,
									0.667
								]
							},
							"o": {
								"x": [
									0.333,
									0.333,
									0.333
								],
								"y": [
									-0.004,
									-0.004,
									0.333
								]
							},
							"n": [
								"0p128_1_0p333_-0p004",
								"0p128_1_0p333_-0p004",
								"0p667_0p667_0p333_0p333"
							],
							"t": 26,
							"s": [
								111.556,
								111.556,
								100
							],
							"e": [
								131.556,
								131.556,
								100
							]
						},
						{
							"t": 50.0000020365418
						}
					]
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											3.904,
											2.217
										],
										[
											0,
											0
										],
										[
											-3.889,
											2.228
										],
										[
											0,
											0
										],
										[
											-3.889,
											-2.271
										],
										[
											0,
											0
										],
										[
											3.814,
											-2.197
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-3.962,
											-2.25
										],
										[
											0,
											0
										],
										[
											3.855,
											-2.209
										],
										[
											0,
											0
										],
										[
											3.833,
											2.238
										],
										[
											0,
											0
										],
										[
											-3.847,
											2.217
										]
									],
									"v": [
										[
											-44.394,
											78.349
										],
										[
											-136.076,
											26.287
										],
										[
											-136.21,
											18.177
										],
										[
											32.239,
											-78.357
										],
										[
											46.262,
											-78.244
										],
										[
											136.252,
											-25.689
										],
										[
											136.285,
											-17.659
										],
										[
											-30.36,
											78.349
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.329,
									0.341,
									0.4,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									746.962,
									1305.675
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											5.732,
											3.238
										],
										[
											0,
											0
										],
										[
											-5.708,
											3.27
										],
										[
											0,
											0
										],
										[
											-5.684,
											-3.334
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											5.573,
											-3.212
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-5.829,
											-3.292
										],
										[
											0,
											0
										],
										[
											5.643,
											-3.232
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											5.591,
											3.279
										],
										[
											0,
											0
										],
										[
											-5.637,
											3.249
										]
									],
									"v": [
										[
											-69.481,
											99.469
										],
										[
											-172.705,
											41.161
										],
										[
											-172.925,
											29.276
										],
										[
											51.844,
											-99.476
										],
										[
											72.356,
											-99.289
										],
										[
											127.214,
											-67.112
										],
										[
											173.031,
											-40.238
										],
										[
											173.061,
											-28.487
										],
										[
											-48.898,
											99.447
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.329,
									0.341,
									0.4,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 1
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									744.238,
									1307.933
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 2,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											3.114,
											1.822
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											5.639,
											-3.239
										],
										[
											0,
											0
										],
										[
											-0.262,
											-2.299
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-2.713,
											-1.529
										],
										[
											0,
											0
										],
										[
											-5.634,
											3.255
										],
										[
											0,
											0
										],
										[
											0.248,
											2.294
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.344,
											-2.358
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-5.688,
											-3.328
										],
										[
											0,
											0
										],
										[
											-3.054,
											1.753
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.226,
											2
										],
										[
											0,
											0
										],
										[
											5.736,
											3.231
										],
										[
											0,
											0
										],
										[
											3.006,
											-1.737
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											177.086,
											-42.034
										],
										[
											177.055,
											-42.028
										],
										[
											172.904,
											-48.646
										],
										[
											127.057,
											-75.469
										],
										[
											72.164,
											-107.583
										],
										[
											51.651,
											-107.748
										],
										[
											-172.974,
											21.253
										],
										[
											-177.138,
											27.646
										],
										[
											-177.154,
											27.649
										],
										[
											-177.136,
											44.064
										],
										[
											-172.724,
											49.562
										],
										[
											-69.435,
											107.755
										],
										[
											-48.851,
											107.709
										],
										[
											172.966,
											-20.471
										],
										[
											177.102,
											-26.833
										]
									],
									"c": true
								}
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.329,
									0.341,
									0.4,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"w": {
								"a": 0,
								"k": 3
							},
							"lc": 1,
							"lj": 2,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke"
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									744.31,
									1316.148
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 2,
					"mn": "ADBE Vector Group"
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0
									],
									"y": [
										0.989
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"n": [
									"0_0p989_0p333_0"
								],
								"t": 30,
								"s": [
									0
								],
								"e": [
									100
								]
							},
							{
								"t": 49.8900020320614
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 4,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim"
				}
			],
			"ip": 0,
			"op": 329.000013400445,
			"st": 0,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 2,
			"nm": "grilla.png",
			"cl": "png",
			"refId": "image_0",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						455,
						326,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						1728,
						1019.5,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						25,
						25,
						100
					]
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 329.000013400445,
			"st": 0,
			"bm": 0,
			"sr": 1
		}
	],
	"chars": [
		{
			"ch": "Y",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"o": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"v": [
											[
												15.283,
												-71.094
											],
											[
												2.197,
												-71.094
											],
											[
												24.219,
												-25.83
											],
											[
												24.316,
												0
											],
											[
												35.693,
												0
											],
											[
												35.791,
												-25.537
											],
											[
												57.959,
												-71.094
											],
											[
												44.873,
												-71.094
											],
											[
												30.078,
												-37.109
											]
										],
										"c": true
									}
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Y",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												75.293,
												-71.094
											],
											[
												62.207,
												-71.094
											],
											[
												84.229,
												-25.83
											],
											[
												84.326,
												0
											],
											[
												95.703,
												0
											],
											[
												95.801,
												-25.537
											],
											[
												117.969,
												-71.094
											],
											[
												104.883,
												-71.094
											],
											[
												90.088,
												-37.109
											]
										],
										"c": true
									}
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "Y",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "O",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												55.469,
												-40.039
											],
											[
												54.931,
												-48.274
											],
											[
												51.171,
												-59.432
											],
											[
												44.197,
												-67.676
											],
											[
												34.033,
												-72.07
											],
											[
												24.308,
												-71.663
											],
											[
												17.472,
												-68.912
											],
											[
												12.101,
												-64.331
											],
											[
												8.179,
												-58.146
											],
											[
												5.622,
												-50.911
											],
											[
												4.443,
												-42.838
											],
											[
												4.443,
												-30.957
											],
											[
												4.972,
												-22.737
											],
											[
												8.667,
												-11.662
											],
											[
												15.494,
												-3.418
											],
											[
												25.52,
												0.977
											],
											[
												37.833,
												0.105
											],
											[
												46.916,
												-5.721
											],
											[
												52.783,
												-15.015
											],
											[
												55.469,
												-26.758
											]
										],
										"o": [
											[
												55.469,
												-44.238
											],
											[
												52.783,
												-56.021
											],
											[
												46.875,
												-65.324
											],
											[
												37.784,
												-71.192
											],
											[
												26.904,
												-72.07
											],
											[
												19.587,
												-70.036
											],
											[
												13.729,
												-66.047
											],
											[
												9.334,
												-60.327
											],
											[
												6.323,
												-53.425
											],
											[
												4.679,
												-45.572
											],
											[
												4.443,
												-40.039
											],
											[
												4.443,
												-26.758
											],
											[
												7.087,
												-15.055
											],
											[
												12.867,
												-5.77
											],
											[
												21.809,
												0.098
											],
											[
												34.082,
												0.977
											],
											[
												44.246,
												-3.377
											],
											[
												51.18,
												-11.613
											],
											[
												54.931,
												-22.729
											],
											[
												55.469,
												-30.957
											]
										],
										"v": [
											[
												55.469,
												-40.039
											],
											[
												53.857,
												-52.148
											],
											[
												49.023,
												-62.378
											],
											[
												40.991,
												-69.434
											],
											[
												29.736,
												-72.07
											],
											[
												21.948,
												-70.85
											],
											[
												15.601,
												-67.48
											],
											[
												10.718,
												-62.329
											],
											[
												7.251,
												-55.786
											],
											[
												5.151,
												-48.242
											],
											[
												4.443,
												-40.039
											],
											[
												4.443,
												-30.957
											],
											[
												6.03,
												-18.896
											],
											[
												10.767,
												-8.716
											],
											[
												18.652,
												-1.66
											],
											[
												29.785,
												0.977
											],
											[
												41.04,
												-1.636
											],
											[
												49.048,
												-8.667
											],
											[
												53.857,
												-18.872
											],
											[
												55.469,
												-30.957
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.701,
												-30.957
											],
											[
												43.432,
												-25.635
											],
											[
												41.797,
												-18.001
											],
											[
												38.224,
												-12.142
											],
											[
												32.454,
												-8.887
											],
											[
												24.959,
												-9.538
											],
											[
												20.092,
												-13.842
											],
											[
												17.318,
												-20.401
											],
											[
												16.243,
												-28.287
											],
											[
												16.211,
												-40.137
											],
											[
												16.463,
												-45.45
											],
											[
												17.994,
												-53.043
											],
											[
												21.427,
												-58.895
											],
											[
												27.099,
												-62.109
											],
											[
												34.626,
												-61.467
											],
											[
												39.6,
												-57.218
											],
											[
												42.513,
												-50.733
											],
											[
												43.668,
												-42.806
											]
										],
										"o": [
											[
												43.668,
												-28.287
											],
											[
												42.554,
												-20.361
											],
											[
												39.649,
												-13.834
											],
											[
												34.675,
												-9.538
											],
											[
												27.148,
												-8.887
											],
											[
												21.476,
												-12.142
											],
											[
												18.042,
												-18.042
											],
											[
												16.472,
												-25.642
											],
											[
												16.211,
												-30.957
											],
											[
												16.243,
												-42.806
											],
											[
												17.277,
												-50.691
											],
											[
												20.044,
												-57.21
											],
											[
												24.91,
												-61.467
											],
											[
												32.405,
												-62.109
											],
											[
												38.175,
												-58.895
											],
											[
												41.748,
												-53.083
											],
											[
												43.424,
												-45.459
											],
											[
												43.701,
												-40.137
											]
										],
										"v": [
											[
												43.701,
												-30.957
											],
											[
												42.993,
												-22.998
											],
											[
												40.723,
												-15.918
											],
											[
												36.45,
												-10.84
											],
											[
												29.785,
												-8.887
											],
											[
												23.218,
												-10.84
											],
											[
												19.067,
												-15.942
											],
											[
												16.895,
												-23.022
											],
											[
												16.211,
												-30.957
											],
											[
												16.211,
												-40.137
											],
											[
												16.87,
												-48.071
											],
											[
												19.019,
												-55.127
											],
											[
												23.169,
												-60.181
											],
											[
												29.736,
												-62.109
											],
											[
												36.401,
												-60.181
											],
											[
												40.674,
												-55.151
											],
											[
												42.969,
												-48.096
											],
											[
												43.701,
												-40.137
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "O",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												1.074,
												3.874
											],
											[
												2.148,
												2.946
											],
											[
												3.206,
												1.758
											],
											[
												4.297,
												0
											],
											[
												2.36,
												-0.813
											],
											[
												1.871,
												-1.432
											],
											[
												1.383,
												-2.002
											],
											[
												0.928,
												-2.36
											],
											[
												0.471,
												-2.669
											],
											[
												0,
												-2.799
											],
											[
												0,
												0
											],
											[
												-1.058,
												-3.841
											],
											[
												-2.1,
												-2.946
											],
											[
												-3.158,
												-1.758
											],
											[
												-4.265,
												0
											],
											[
												-3.207,
												1.741
											],
											[
												-2.132,
												2.946
											],
											[
												-1.074,
												3.857
											],
											[
												0,
												4.199
											]
										],
										"o": [
											[
												0,
												-4.199
											],
											[
												-1.074,
												-3.873
											],
											[
												-2.148,
												-2.946
											],
											[
												-3.207,
												-1.758
											],
											[
												-2.832,
												0
											],
											[
												-2.361,
												0.814
											],
											[
												-1.872,
												1.433
											],
											[
												-1.384,
												2.002
											],
											[
												-0.928,
												2.361
											],
											[
												-0.472,
												2.67
											],
											[
												0,
												0
											],
											[
												0,
												4.199
											],
											[
												1.057,
												3.841
											],
											[
												2.1,
												2.946
											],
											[
												3.157,
												1.758
											],
											[
												4.297,
												0
											],
											[
												3.206,
												-1.741
											],
											[
												2.132,
												-2.946
											],
											[
												1.074,
												-3.857
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												115.479,
												-40.039
											],
											[
												113.867,
												-52.148
											],
											[
												109.033,
												-62.378
											],
											[
												101.001,
												-69.434
											],
											[
												89.746,
												-72.07
											],
											[
												81.958,
												-70.85
											],
											[
												75.61,
												-67.48
											],
											[
												70.728,
												-62.329
											],
											[
												67.261,
												-55.786
											],
											[
												65.161,
												-48.242
											],
											[
												64.453,
												-40.039
											],
											[
												64.453,
												-30.957
											],
											[
												66.04,
												-18.896
											],
											[
												70.776,
												-8.716
											],
											[
												78.662,
												-1.66
											],
											[
												89.795,
												0.977
											],
											[
												101.05,
												-1.636
											],
											[
												109.058,
												-8.667
											],
											[
												113.867,
												-18.872
											],
											[
												115.479,
												-30.957
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0.439,
												-2.637
											],
											[
												1.074,
												-2.083
											],
											[
												1.774,
												-1.302
											],
											[
												2.669,
												0
											],
											[
												1.741,
												1.302
											],
											[
												1.025,
												2.1
											],
											[
												0.423,
												2.621
											],
											[
												0.032,
												2.67
											],
											[
												0,
												0
											],
											[
												-0.407,
												2.621
											],
											[
												-1.025,
												2.084
											],
											[
												-1.742,
												1.286
											],
											[
												-2.637,
												0
											],
											[
												-1.775,
												-1.286
											],
											[
												-1.074,
												-2.067
											],
											[
												-0.456,
												-2.637
											],
											[
												-0.033,
												-2.669
											]
										],
										"o": [
											[
												-0.033,
												2.67
											],
											[
												-0.439,
												2.637
											],
											[
												-1.074,
												2.084
											],
											[
												-1.775,
												1.302
											],
											[
												-2.637,
												0
											],
											[
												-1.742,
												-1.302
											],
											[
												-1.025,
												-2.1
											],
											[
												-0.423,
												-2.62
											],
											[
												0,
												0
											],
											[
												0.032,
												-2.669
											],
											[
												0.407,
												-2.62
											],
											[
												1.025,
												-2.083
											],
											[
												1.741,
												-1.286
											],
											[
												2.669,
												0
											],
											[
												1.774,
												1.286
											],
											[
												1.074,
												2.068
											],
											[
												0.455,
												2.637
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												103.711,
												-30.957
											],
											[
												103.003,
												-22.998
											],
											[
												100.732,
												-15.918
											],
											[
												96.46,
												-10.84
											],
											[
												89.795,
												-8.887
											],
											[
												83.228,
												-10.84
											],
											[
												79.077,
												-15.942
											],
											[
												76.904,
												-23.022
											],
											[
												76.221,
												-30.957
											],
											[
												76.221,
												-40.137
											],
											[
												76.88,
												-48.071
											],
											[
												79.028,
												-55.127
											],
											[
												83.179,
												-60.181
											],
											[
												89.746,
												-62.109
											],
											[
												96.411,
												-60.181
											],
											[
												100.684,
												-55.151
											],
											[
												102.979,
												-48.096
											],
											[
												103.711,
												-40.137
											]
										],
										"c": true
									}
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "O",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "U",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												41.992,
												-71.094
											],
											[
												41.895,
												-23.486
											],
											[
												41.584,
												-19.303
											],
											[
												39.779,
												-14.087
											],
											[
												36.507,
												-10.424
											],
											[
												31.787,
												-8.594
											],
											[
												26.228,
												-8.96
											],
											[
												22.12,
												-11.451
											],
											[
												19.416,
												-15.657
											],
											[
												18.098,
												-21.305
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.348,
												-23.486
											],
											[
												6.965,
												-16.463
											],
											[
												10.84,
												-7.869
											],
											[
												17.399,
												-1.953
											],
											[
												26.318,
												0.977
											],
											[
												36.71,
												0.391
											],
											[
												45.019,
												-3.614
											],
											[
												50.715,
												-10.49
											],
											[
												53.58,
												-19.84
											],
											[
												53.516,
												-71.094
											]
										],
										"o": [
											[
												41.992,
												-71.094
											],
											[
												41.862,
												-21.305
											],
											[
												40.543,
												-15.657
											],
											[
												37.761,
												-11.451
											],
											[
												33.512,
												-8.96
											],
											[
												27.913,
												-8.594
											],
											[
												23.331,
												-10.424
											],
											[
												20.166,
												-14.087
											],
											[
												18.375,
												-19.303
											],
											[
												18.066,
												-23.486
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.38,
												-19.807
											],
											[
												9.244,
												-10.441
											],
											[
												14.942,
												-3.605
											],
											[
												23.128,
												0.391
											],
											[
												33.447,
												0.977
											],
											[
												42.537,
												-1.953
											],
											[
												49.121,
												-7.91
											],
											[
												52.994,
												-16.512
											],
											[
												53.613,
												-23.486
											],
											[
												53.516,
												-71.094
											]
										],
										"v": [
											[
												41.992,
												-71.094
											],
											[
												41.895,
												-23.486
											],
											[
												41.064,
												-17.48
											],
											[
												38.77,
												-12.769
											],
											[
												35.01,
												-9.692
											],
											[
												29.834,
												-8.594
											],
											[
												24.78,
												-9.692
											],
											[
												21.143,
												-12.769
											],
											[
												18.896,
												-17.48
											],
											[
												18.066,
												-23.486
											],
											[
												17.969,
												-71.094
											],
											[
												6.445,
												-71.094
											],
											[
												6.348,
												-23.486
											],
											[
												8.105,
												-13.452
											],
											[
												12.891,
												-5.737
											],
											[
												20.264,
												-0.781
											],
											[
												29.834,
												0.977
											],
											[
												39.624,
												-0.781
											],
											[
												47.07,
												-5.762
											],
											[
												51.855,
												-13.501
											],
											[
												53.613,
												-23.486
											],
											[
												53.516,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "U",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.52,
												-1.823
											],
											[
												1.009,
												-1.318
											],
											[
												1.497,
												-0.732
											],
											[
												1.953,
												0
											],
											[
												1.448,
												0.732
											],
											[
												0.977,
												1.318
											],
											[
												0.52,
												1.823
											],
											[
												0.032,
												2.181
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.14,
												-3.011
											],
											[
												-2.051,
												-2.132
											],
											[
												-2.865,
												-1.172
											],
											[
												-3.516,
												0
											],
											[
												-2.914,
												1.172
											],
											[
												-2.051,
												2.148
											],
											[
												-1.14,
												3.011
											],
											[
												-0.033,
												3.646
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												-0.033,
												2.181
											],
											[
												-0.521,
												1.823
											],
											[
												-1.009,
												1.318
											],
											[
												-1.498,
												0.732
											],
											[
												-1.921,
												0
											],
											[
												-1.449,
												-0.732
											],
											[
												-0.977,
												-1.318
											],
											[
												-0.521,
												-1.823
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.032,
												3.679
											],
											[
												1.139,
												3.011
											],
											[
												2.051,
												2.132
											],
											[
												2.864,
												1.172
											],
											[
												3.613,
												0
											],
											[
												2.913,
												-1.172
											],
											[
												2.051,
												-2.148
											],
											[
												1.139,
												-3.011
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												102.002,
												-71.094
											],
											[
												101.904,
												-23.486
											],
											[
												101.074,
												-17.48
											],
											[
												98.779,
												-12.769
											],
											[
												95.02,
												-9.692
											],
											[
												89.844,
												-8.594
											],
											[
												84.79,
												-9.692
											],
											[
												81.152,
												-12.769
											],
											[
												78.906,
												-17.48
											],
											[
												78.076,
												-23.486
											],
											[
												77.979,
												-71.094
											],
											[
												66.455,
												-71.094
											],
											[
												66.357,
												-23.486
											],
											[
												68.115,
												-13.452
											],
											[
												72.9,
												-5.737
											],
											[
												80.273,
												-0.781
											],
											[
												89.844,
												0.977
											],
											[
												99.634,
												-0.781
											],
											[
												107.08,
												-5.762
											],
											[
												111.865,
												-13.501
											],
											[
												113.623,
												-23.486
											],
											[
												113.525,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "U",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "R",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												42.09,
												-30.469
											],
											[
												45.768,
												-32.34
											],
											[
												50.325,
												-36.149
											],
											[
												53.491,
												-41.121
											],
											[
												55.078,
												-47.249
											],
											[
												54.46,
												-56.363
											],
											[
												50.244,
												-63.923
											],
											[
												43.091,
												-68.806
											],
											[
												33.577,
												-71.061
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"o": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												44.01,
												-31.315
											],
											[
												48.958,
												-34.749
											],
											[
												52.604,
												-39.339
											],
											[
												54.761,
												-45.06
											],
											[
												55.078,
												-53.238
											],
											[
												51.986,
												-61.702
											],
											[
												45.752,
												-67.472
											],
											[
												36.939,
												-70.597
											],
											[
												29.932,
												-71.094
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"v": [
											[
												44.629,
												0
											],
											[
												57.129,
												0
											],
											[
												57.129,
												-0.586
											],
											[
												42.09,
												-30.469
											],
											[
												47.363,
												-33.545
											],
											[
												51.465,
												-37.744
											],
											[
												54.126,
												-43.091
											],
											[
												55.078,
												-49.658
											],
											[
												53.223,
												-59.033
											],
											[
												47.998,
												-65.698
											],
											[
												40.015,
												-69.702
											],
											[
												29.932,
												-71.094
											],
											[
												7.471,
												-71.094
											],
											[
												7.471,
												0
											],
											[
												19.189,
												0
											],
											[
												19.189,
												-27.734
											],
											[
												31.104,
												-27.734
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												19.189,
												-61.621
											],
											[
												29.932,
												-61.621
											],
											[
												33.838,
												-61.304
											],
											[
												38.566,
												-59.439
											],
											[
												41.764,
												-56.071
											],
											[
												43.311,
												-51.253
											],
											[
												42.985,
												-45.646
											],
											[
												40.763,
												-41.43
											],
											[
												36.979,
												-38.59
											],
											[
												31.933,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"o": [
											[
												19.189,
												-61.621
											],
											[
												31.983,
												-61.588
											],
											[
												37.158,
												-60.23
											],
											[
												40.877,
												-57.356
											],
											[
												43.001,
												-53.011
											],
											[
												43.311,
												-47.347
											],
											[
												41.682,
												-42.683
											],
											[
												38.386,
												-39.38
											],
											[
												33.724,
												-37.483
											],
											[
												29.98,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"v": [
											[
												19.189,
												-61.621
											],
											[
												29.932,
												-61.621
											],
											[
												35.498,
												-60.767
											],
											[
												39.722,
												-58.398
											],
											[
												42.383,
												-54.541
											],
											[
												43.311,
												-49.268
											],
											[
												42.334,
												-44.165
											],
											[
												39.575,
												-40.405
											],
											[
												35.352,
												-38.037
											],
											[
												29.98,
												-37.207
											],
											[
												19.189,
												-37.207
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "R",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.595,
												1.205
											],
											[
												-1.14,
												1.595
											],
											[
												-0.635,
												1.97
											],
											[
												0,
												2.409
											],
											[
												1.237,
												2.67
											],
											[
												2.246,
												1.775
											],
											[
												3.076,
												0.896
											],
											[
												3.645,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.92,
												-0.846
											],
											[
												1.595,
												-1.204
											],
											[
												1.139,
												-1.595
											],
											[
												0.635,
												-1.969
											],
											[
												0,
												-3.58
											],
											[
												-1.237,
												-2.669
											],
											[
												-2.246,
												-1.774
											],
											[
												-3.076,
												-0.895
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												104.639,
												0
											],
											[
												117.139,
												0
											],
											[
												117.139,
												-0.586
											],
											[
												102.1,
												-30.469
											],
											[
												107.373,
												-33.545
											],
											[
												111.475,
												-37.744
											],
											[
												114.136,
												-43.091
											],
											[
												115.088,
												-49.658
											],
											[
												113.232,
												-59.033
											],
											[
												108.008,
												-65.698
											],
											[
												100.024,
												-69.702
											],
											[
												89.941,
												-71.094
											],
											[
												67.48,
												-71.094
											],
											[
												67.48,
												0
											],
											[
												79.199,
												0
											],
											[
												79.199,
												-27.734
											],
											[
												91.113,
												-27.734
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.66,
												-0.537
											],
											[
												-1.156,
												-1.041
											],
											[
												-0.619,
												-1.53
											],
											[
												0,
												-1.985
											],
											[
												0.651,
												-1.481
											],
											[
												1.188,
												-1.025
											],
											[
												1.627,
												-0.553
											],
											[
												1.953,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												2.051,
												0.033
											],
											[
												1.66,
												0.537
											],
											[
												1.155,
												1.042
											],
											[
												0.618,
												1.53
											],
											[
												0,
												1.921
											],
											[
												-0.652,
												1.482
											],
											[
												-1.189,
												1.025
											],
											[
												-1.628,
												0.554
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.199,
												-61.621
											],
											[
												89.941,
												-61.621
											],
											[
												95.508,
												-60.767
											],
											[
												99.731,
												-58.398
											],
											[
												102.393,
												-54.541
											],
											[
												103.32,
												-49.268
											],
											[
												102.344,
												-44.165
											],
											[
												99.585,
												-40.405
											],
											[
												95.361,
												-38.037
											],
											[
												89.99,
												-37.207
											],
											[
												79.199,
												-37.207
											]
										],
										"c": true
									}
								},
								"nm": "R",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "R",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": " ",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "A",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"o": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"v": [
											[
												46.533,
												0
											],
											[
												58.594,
												0
											],
											[
												35.938,
												-71.094
											],
											[
												25.635,
												-71.094
											],
											[
												2.539,
												0
											],
											[
												14.648,
												0
											],
											[
												19.531,
												-16.504
											],
											[
												41.748,
												-16.504
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"o": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"v": [
											[
												30.762,
												-54.395
											],
											[
												38.818,
												-26.514
											],
											[
												22.51,
												-26.514
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "A",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												106.543,
												0
											],
											[
												118.604,
												0
											],
											[
												95.947,
												-71.094
											],
											[
												85.645,
												-71.094
											],
											[
												62.549,
												0
											],
											[
												74.658,
												0
											],
											[
												79.541,
												-16.504
											],
											[
												101.758,
												-16.504
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												90.771,
												-54.395
											],
											[
												98.828,
												-26.514
											],
											[
												82.52,
												-26.514
											]
										],
										"c": true
									}
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "A",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "P",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												31.934,
												-27.246
											],
											[
												38.761,
												-27.8
											],
											[
												47.38,
												-31.266
											],
											[
												53.442,
												-37.32
											],
											[
												56.494,
												-45.655
											],
											[
												55.884,
												-55.461
											],
											[
												51.741,
												-63.208
											],
											[
												44.783,
												-68.482
											],
											[
												35.482,
												-71.061
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"o": [
											[
												35.482,
												-27.278
											],
											[
												44.783,
												-29.818
											],
											[
												51.741,
												-35.042
											],
											[
												55.884,
												-42.659
											],
											[
												56.494,
												-52.393
											],
											[
												53.442,
												-60.897
											],
											[
												47.38,
												-67.016
											],
											[
												38.761,
												-70.532
											],
											[
												31.934,
												-71.094
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"v": [
											[
												31.934,
												-27.246
											],
											[
												41.772,
												-28.809
											],
											[
												49.561,
												-33.154
											],
											[
												54.663,
												-39.99
											],
											[
												56.494,
												-48.975
											],
											[
												54.663,
												-58.179
											],
											[
												49.561,
												-65.112
											],
											[
												41.772,
												-69.507
											],
											[
												31.934,
												-71.094
											],
											[
												8.154,
												-71.094
											],
											[
												8.154,
												0
											],
											[
												19.873,
												0
											],
											[
												19.873,
												-27.246
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												19.873,
												-61.621
											],
											[
												31.934,
												-61.621
											],
											[
												35.694,
												-61.263
											],
											[
												40.153,
												-59.155
											],
											[
												43.213,
												-55.566
											],
											[
												44.678,
												-50.732
											],
											[
												44.385,
												-45.491
											],
											[
												42.366,
												-41.211
											],
											[
												38.818,
												-38.224
											],
											[
												33.919,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"o": [
											[
												19.873,
												-61.621
											],
											[
												33.919,
												-61.588
											],
											[
												38.818,
												-60.026
											],
											[
												42.366,
												-56.909
											],
											[
												44.385,
												-52.442
											],
											[
												44.678,
												-47.119
											],
											[
												43.213,
												-42.496
											],
											[
												40.153,
												-39.063
											],
											[
												35.694,
												-37.019
											],
											[
												31.934,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"v": [
											[
												19.873,
												-61.621
											],
											[
												31.934,
												-61.621
											],
											[
												37.256,
												-60.645
											],
											[
												41.26,
												-58.032
											],
											[
												43.799,
												-54.004
											],
											[
												44.678,
												-48.877
											],
											[
												43.799,
												-43.994
											],
											[
												41.26,
												-40.137
											],
											[
												37.256,
												-37.622
											],
											[
												31.934,
												-36.719
											],
											[
												19.873,
												-36.719
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "P",
						"np": 5,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.011,
												1.009
											],
											[
												-2.181,
												1.888
											],
											[
												-1.221,
												2.67
											],
											[
												0,
												3.32
											],
											[
												1.221,
												2.718
											],
											[
												2.18,
												1.904
											],
											[
												3.011,
												1.025
											],
											[
												3.548,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.548,
												-0.032
											],
											[
												3.011,
												-1.009
											],
											[
												2.18,
												-1.888
											],
											[
												1.221,
												-2.669
											],
											[
												0,
												-3.418
											],
											[
												-1.221,
												-2.718
											],
											[
												-2.181,
												-1.904
											],
											[
												-3.011,
												-1.025
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												91.943,
												-27.246
											],
											[
												101.782,
												-28.809
											],
											[
												109.57,
												-33.154
											],
											[
												114.673,
												-39.99
											],
											[
												116.504,
												-48.975
											],
											[
												114.673,
												-58.179
											],
											[
												109.57,
												-65.112
											],
											[
												101.782,
												-69.507
											],
											[
												91.943,
												-71.094
											],
											[
												68.164,
												-71.094
											],
											[
												68.164,
												0
											],
											[
												79.883,
												0
											],
											[
												79.883,
												-27.246
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.562,
												-0.618
											],
											[
												-1.107,
												-1.123
											],
											[
												-0.586,
												-1.562
											],
											[
												0,
												-1.855
											],
											[
												0.586,
												-1.497
											],
											[
												1.106,
												-1.074
											],
											[
												1.562,
												-0.602
											],
											[
												1.985,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												1.985,
												0.033
											],
											[
												1.562,
												0.619
											],
											[
												1.106,
												1.123
											],
											[
												0.586,
												1.562
											],
											[
												0,
												1.758
											],
											[
												-0.586,
												1.498
											],
											[
												-1.107,
												1.074
											],
											[
												-1.562,
												0.603
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.883,
												-61.621
											],
											[
												91.943,
												-61.621
											],
											[
												97.266,
												-60.645
											],
											[
												101.27,
												-58.032
											],
											[
												103.809,
												-54.004
											],
											[
												104.688,
												-48.877
											],
											[
												103.809,
												-43.994
											],
											[
												101.27,
												-40.137
											],
											[
												97.266,
												-37.622
											],
											[
												91.943,
												-36.719
											],
											[
												79.883,
												-36.719
											]
										],
										"c": true
									}
								},
								"nm": "P",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "P",
						"np": 5,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "\r",
			"size": 13,
			"style": "Medium",
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "L",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"o": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"v": [
											[
												20.117,
												-71.094
											],
											[
												8.398,
												-71.094
											],
											[
												8.398,
												0
											],
											[
												54.004,
												0
											],
											[
												54.004,
												-9.57
											],
											[
												20.117,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "L",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												80.127,
												-71.094
											],
											[
												68.408,
												-71.094
											],
											[
												68.408,
												0
											],
											[
												114.014,
												0
											],
											[
												114.014,
												-9.57
											],
											[
												80.127,
												-9.57
											]
										],
										"c": true
									}
								},
								"nm": "L",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "L",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "G",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												43.311,
												-12.646
											],
											[
												42.041,
												-11.271
											],
											[
												39.314,
												-9.846
											],
											[
												36.084,
												-8.959
											],
											[
												32.6,
												-8.594
											],
											[
												26.481,
												-9.261
											],
											[
												21.07,
												-13.386
											],
											[
												17.732,
												-19.905
											],
											[
												16.292,
												-28.142
											],
											[
												16.26,
												-39.99
											],
											[
												16.585,
												-45.793
											],
											[
												18.555,
												-53.62
											],
											[
												22.371,
												-59.399
											],
											[
												28.044,
												-62.451
											],
											[
												34.285,
												-62.166
											],
											[
												38.509,
												-60.205
											],
											[
												41.422,
												-56.755
											],
											[
												43.115,
												-51.969
											],
											[
												54.932,
												-50.049
											],
											[
												53.833,
												-56.495
											],
											[
												49.739,
												-64.283
											],
											[
												43.083,
												-69.548
											],
											[
												34,
												-72.07
											],
											[
												22.575,
												-71.232
											],
											[
												13.501,
												-65.592
											],
											[
												7.422,
												-56.396
											],
											[
												4.492,
												-44.385
											],
											[
												4.492,
												-31.104
											],
											[
												5.134,
												-22.412
											],
											[
												9.236,
												-11.206
											],
											[
												16.536,
												-3.174
											],
											[
												26.887,
												0.977
											],
											[
												36.335,
												0.732
											],
											[
												43.245,
												-0.928
											],
											[
												49.104,
												-3.727
											],
											[
												53.775,
												-7.454
											]
										],
										"o": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												42.757,
												-11.897
											],
											[
												40.283,
												-10.262
											],
											[
												37.199,
												-9.195
											],
											[
												33.74,
												-8.667
											],
											[
												28.792,
												-8.626
											],
											[
												22.64,
												-11.735
											],
											[
												18.628,
												-17.521
											],
											[
												16.593,
												-25.309
											],
											[
												16.26,
												-31.104
											],
											[
												16.292,
												-42.952
											],
											[
												17.692,
												-51.229
											],
											[
												20.899,
												-57.755
											],
											[
												25.92,
												-61.841
											],
											[
												32.536,
												-62.451
											],
											[
												37.248,
												-61.027
											],
											[
												40.592,
												-58.057
											],
											[
												42.659,
												-53.695
											],
											[
												43.408,
												-50.049
											],
											[
												54.606,
												-53.434
											],
											[
												51.391,
												-61.963
											],
											[
												45.572,
												-68.091
											],
											[
												37.288,
												-71.566
											],
											[
												26.22,
												-72.07
											],
											[
												16.194,
												-67.879
											],
											[
												9.107,
												-59.797
											],
											[
												5.078,
												-48.584
											],
											[
												4.492,
												-39.893
											],
											[
												4.524,
												-26.612
											],
											[
												7.511,
												-14.6
											],
											[
												13.761,
												-5.444
											],
											[
												23.112,
												0.146
											],
											[
												33.821,
												0.977
											],
											[
												41.056,
												-0.244
											],
											[
												47.282,
												-2.686
											],
											[
												52.359,
												-6.136
											],
											[
												54.98,
												-8.887
											]
										],
										"v": [
											[
												54.883,
												-35.986
											],
											[
												30.566,
												-35.986
											],
											[
												30.566,
												-26.855
											],
											[
												43.408,
												-26.855
											],
											[
												43.311,
												-12.646
											],
											[
												41.162,
												-10.767
											],
											[
												38.257,
												-9.521
											],
											[
												34.912,
												-8.813
											],
											[
												31.494,
												-8.594
											],
											[
												24.561,
												-10.498
											],
											[
												19.849,
												-15.454
											],
											[
												17.163,
												-22.607
											],
											[
												16.26,
												-31.104
											],
											[
												16.26,
												-39.99
											],
											[
												17.139,
												-48.511
											],
											[
												19.727,
												-55.688
											],
											[
												24.146,
												-60.62
											],
											[
												30.518,
												-62.451
											],
											[
												35.767,
												-61.597
											],
											[
												39.551,
												-59.131
											],
											[
												42.041,
												-55.225
											],
											[
												43.408,
												-50.049
											],
											[
												54.932,
												-50.049
											],
											[
												52.612,
												-59.229
											],
											[
												47.656,
												-66.187
											],
											[
												40.186,
												-70.557
											],
											[
												30.322,
												-72.07
											],
											[
												19.385,
												-69.556
											],
											[
												11.304,
												-62.695
											],
											[
												6.25,
												-52.49
											],
											[
												4.492,
												-39.893
											],
											[
												4.492,
												-31.104
											],
											[
												6.323,
												-18.506
											],
											[
												11.499,
												-8.325
											],
											[
												19.824,
												-1.514
											],
											[
												31.152,
												0.977
											],
											[
												38.696,
												0.244
											],
											[
												45.264,
												-1.807
											],
											[
												50.732,
												-4.932
											],
											[
												54.98,
												-8.887
											]
										],
										"c": true
									}
								},
								"nm": "G",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "G",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.879,
												-0.504
											],
											[
												1.057,
												-0.325
											],
											[
												1.172,
												-0.146
											],
											[
												1.106,
												0
											],
											[
												1.92,
												1.237
											],
											[
												1.221,
												2.068
											],
											[
												0.569,
												2.702
											],
											[
												0.032,
												2.962
											],
											[
												0,
												0
											],
											[
												-0.554,
												2.718
											],
											[
												-1.172,
												2.068
											],
											[
												-1.775,
												1.221
											],
											[
												-2.474,
												0
											],
											[
												-1.482,
												-0.569
											],
											[
												-1.042,
												-1.074
											],
											[
												-0.619,
												-1.53
											],
											[
												-0.293,
												-1.92
											],
											[
												0,
												0
											],
											[
												1.221,
												2.734
											],
											[
												2.083,
												1.904
											],
											[
												2.897,
												1.009
											],
											[
												3.678,
												0
											],
											[
												3.19,
												-1.676
											],
											[
												2.197,
												-2.897
											],
											[
												1.172,
												-3.906
											],
											[
												0,
												-4.492
											],
											[
												0,
												0
											],
											[
												-1.189,
												-3.906
											],
											[
												-2.263,
												-2.881
											],
											[
												-3.288,
												-1.66
											],
											[
												-4.265,
												0
											],
											[
												-2.361,
												0.488
											],
											[
												-2.019,
												0.879
											],
											[
												-1.628,
												1.205
											],
											[
												-1.205,
												1.433
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.554,
												0.749
											],
											[
												-0.879,
												0.505
											],
											[
												-1.058,
												0.326
											],
											[
												-1.172,
												0.146
											],
											[
												-2.702,
												-0.032
											],
											[
												-1.921,
												-1.237
											],
											[
												-1.221,
												-2.067
											],
											[
												-0.57,
												-2.702
											],
											[
												0,
												0
											],
											[
												0.032,
												-2.962
											],
											[
												0.553,
												-2.718
											],
											[
												1.172,
												-2.067
											],
											[
												1.774,
												-1.221
											],
											[
												2.018,
												0
											],
											[
												1.481,
												0.57
											],
											[
												1.041,
												1.074
											],
											[
												0.618,
												1.53
											],
											[
												0,
												0
											],
											[
												-0.326,
												-3.385
											],
											[
												-1.221,
												-2.734
											],
											[
												-2.084,
												-1.904
											],
											[
												-2.898,
												-1.009
											],
											[
												-4.102,
												0
											],
											[
												-3.191,
												1.677
											],
											[
												-2.197,
												2.898
											],
											[
												-1.172,
												3.906
											],
											[
												0,
												0
											],
											[
												0.032,
												4.492
											],
											[
												1.188,
												3.906
											],
											[
												2.262,
												2.881
											],
											[
												3.288,
												1.66
											],
											[
												2.669,
												0
											],
											[
												2.36,
												-0.488
											],
											[
												2.018,
												-0.879
											],
											[
												1.627,
												-1.204
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												114.893,
												-35.986
											],
											[
												90.576,
												-35.986
											],
											[
												90.576,
												-26.855
											],
											[
												103.418,
												-26.855
											],
											[
												103.32,
												-12.646
											],
											[
												101.172,
												-10.767
											],
											[
												98.267,
												-9.521
											],
											[
												94.922,
												-8.813
											],
											[
												91.504,
												-8.594
											],
											[
												84.57,
												-10.498
											],
											[
												79.858,
												-15.454
											],
											[
												77.173,
												-22.607
											],
											[
												76.27,
												-31.104
											],
											[
												76.27,
												-39.99
											],
											[
												77.148,
												-48.511
											],
											[
												79.736,
												-55.688
											],
											[
												84.155,
												-60.62
											],
											[
												90.527,
												-62.451
											],
											[
												95.776,
												-61.597
											],
											[
												99.561,
												-59.131
											],
											[
												102.051,
												-55.225
											],
											[
												103.418,
												-50.049
											],
											[
												114.941,
												-50.049
											],
											[
												112.622,
												-59.229
											],
											[
												107.666,
												-66.187
											],
											[
												100.195,
												-70.557
											],
											[
												90.332,
												-72.07
											],
											[
												79.395,
												-69.556
											],
											[
												71.313,
												-62.695
											],
											[
												66.26,
												-52.49
											],
											[
												64.502,
												-39.893
											],
											[
												64.502,
												-31.104
											],
											[
												66.333,
												-18.506
											],
											[
												71.509,
												-8.325
											],
											[
												79.834,
												-1.514
											],
											[
												91.162,
												0.977
											],
											[
												98.706,
												0.244
											],
											[
												105.273,
												-1.807
											],
											[
												110.742,
												-4.932
											],
											[
												114.99,
												-8.887
											]
										],
										"c": true
									}
								},
								"nm": "G",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "G",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "I",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"o": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"v": [
											[
												8.838,
												-61.377
											],
											[
												23.877,
												-61.377
											],
											[
												23.877,
												-9.668
											],
											[
												8.838,
												-9.668
											],
											[
												8.838,
												0
											],
											[
												51.123,
												0
											],
											[
												51.123,
												-9.668
											],
											[
												35.742,
												-9.668
											],
											[
												35.742,
												-61.377
											],
											[
												51.123,
												-61.377
											],
											[
												51.123,
												-71.094
											],
											[
												8.838,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "I",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												68.848,
												-61.377
											],
											[
												83.887,
												-61.377
											],
											[
												83.887,
												-9.668
											],
											[
												68.848,
												-9.668
											],
											[
												68.848,
												0
											],
											[
												111.133,
												0
											],
											[
												111.133,
												-9.668
											],
											[
												95.752,
												-9.668
											],
											[
												95.752,
												-61.377
											],
											[
												111.133,
												-61.377
											],
											[
												111.133,
												-71.094
											],
											[
												68.848,
												-71.094
											]
										],
										"c": true
									}
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "I",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "N",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"o": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"v": [
											[
												53.271,
												-71.094
											],
											[
												41.406,
												-71.094
											],
											[
												41.309,
												-22.314
											],
											[
												18.262,
												-71.094
											],
											[
												6.396,
												-71.094
											],
											[
												6.396,
												0
											],
											[
												18.262,
												0
											],
											[
												18.311,
												-48.926
											],
											[
												41.455,
												0
											],
											[
												53.271,
												0
											]
										],
										"c": true
									}
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "N",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.281,
												-71.094
											],
											[
												101.416,
												-71.094
											],
											[
												101.318,
												-22.314
											],
											[
												78.271,
												-71.094
											],
											[
												66.406,
												-71.094
											],
											[
												66.406,
												0
											],
											[
												78.271,
												0
											],
											[
												78.32,
												-48.926
											],
											[
												101.465,
												0
											],
											[
												113.281,
												0
											]
										],
										"c": true
									}
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "N",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "B",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												31.592,
												0
											],
											[
												38.322,
												-0.496
											],
											[
												46.949,
												-3.596
											],
											[
												53.06,
												-9.196
											],
											[
												56.152,
												-17.317
											],
											[
												55.875,
												-24.503
											],
											[
												53.971,
												-29.573
											],
											[
												50.594,
												-33.667
											],
											[
												45.735,
												-36.507
											],
											[
												49.593,
												-40.357
											],
											[
												54.41,
												-48.339
											],
											[
												53.858,
												-58.049
											],
											[
												49.568,
												-64.893
											],
											[
												42.505,
												-69.173
											],
											[
												33.35,
												-71.061
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"o": [
											[
												35.075,
												-0.032
											],
											[
												44.344,
												-2.287
											],
											[
												51.343,
												-7.047
											],
											[
												55.534,
												-14.339
											],
											[
												56.152,
												-22.656
											],
											[
												54.768,
												-27.986
											],
											[
												51.888,
												-32.438
											],
											[
												47.502,
												-35.717
											],
											[
												47.005,
												-38.428
											],
											[
												53.434,
												-45.337
											],
											[
												54.475,
												-55.175
											],
											[
												51.318,
												-62.899
											],
											[
												45.109,
												-68.017
											],
											[
												36.547,
												-70.67
											],
											[
												29.932,
												-71.094
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"v": [
											[
												31.592,
												0
											],
											[
												41.333,
												-1.392
											],
											[
												49.146,
												-5.322
											],
											[
												54.297,
												-11.768
											],
											[
												56.152,
												-20.703
											],
											[
												55.322,
												-26.245
											],
											[
												52.93,
												-31.006
											],
											[
												49.048,
												-34.692
											],
											[
												43.75,
												-37.061
											],
											[
												51.514,
												-42.847
											],
											[
												54.443,
												-51.855
											],
											[
												52.588,
												-60.474
											],
											[
												47.339,
												-66.455
											],
											[
												39.526,
												-69.922
											],
											[
												29.932,
												-71.094
											],
											[
												7.227,
												-71.094
											],
											[
												7.227,
												0
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												32.324,
												-32.227
											],
											[
												35.856,
												-31.909
											],
											[
												40.12,
												-30.079
											],
											[
												43.001,
												-26.929
											],
											[
												44.385,
												-22.493
											],
											[
												44.068,
												-17.48
											],
											[
												41.926,
												-13.59
											],
											[
												38.395,
												-10.962
											],
											[
												33.642,
												-9.602
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"o": [
											[
												34.179,
												-32.194
											],
											[
												38.851,
												-30.835
											],
											[
												42.203,
												-28.125
											],
											[
												44.108,
												-24.097
											],
											[
												44.385,
												-19.01
											],
											[
												42.798,
												-14.746
											],
											[
												39.713,
												-11.701
											],
											[
												35.335,
												-9.888
											],
											[
												31.787,
												-9.57
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"v": [
											[
												32.324,
												-32.227
											],
											[
												37.354,
												-31.372
											],
											[
												41.162,
												-29.102
											],
											[
												43.555,
												-25.513
											],
											[
												44.385,
												-20.703
											],
											[
												43.433,
												-16.113
											],
											[
												40.82,
												-12.646
											],
											[
												36.865,
												-10.425
											],
											[
												31.787,
												-9.57
											],
											[
												18.994,
												-9.57
											],
											[
												18.994,
												-32.227
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												18.994,
												-61.426
											],
											[
												30.127,
												-61.426
											],
											[
												33.626,
												-61.189
											],
											[
												38.013,
												-59.846
											],
											[
												41.129,
												-57.178
											],
											[
												42.676,
												-53.108
											],
											[
												42.35,
												-48.25
											],
											[
												40.168,
												-44.685
											],
											[
												36.646,
												-42.309
											],
											[
												31.983,
												-41.194
											],
											[
												18.994,
												-41.162
											]
										],
										"o": [
											[
												18.994,
												-61.426
											],
											[
												31.95,
												-61.393
											],
											[
												36.686,
												-60.44
											],
											[
												40.259,
												-58.219
											],
											[
												42.366,
												-54.638
											],
											[
												42.676,
												-49.69
											],
											[
												41.047,
												-45.743
											],
											[
												37.955,
												-42.96
											],
											[
												33.618,
												-41.431
											],
											[
												30.225,
												-41.162
											],
											[
												18.994,
												-41.162
											]
										],
										"v": [
											[
												18.994,
												-61.426
											],
											[
												30.127,
												-61.426
											],
											[
												35.156,
												-60.815
											],
											[
												39.136,
												-59.033
											],
											[
												41.748,
												-55.908
											],
											[
												42.676,
												-51.318
											],
											[
												41.699,
												-46.997
											],
											[
												39.062,
												-43.823
											],
											[
												35.132,
												-41.87
											],
											[
												30.225,
												-41.162
											],
											[
												18.994,
												-41.162
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "B",
						"np": 6,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-3.011,
												0.896
											],
											[
												-2.197,
												1.726
											],
											[
												-1.237,
												2.572
											],
											[
												0,
												3.386
											],
											[
												0.553,
												1.742
											],
											[
												1.041,
												1.433
											],
											[
												1.546,
												1.025
											],
											[
												1.985,
												0.554
											],
											[
												-1.921,
												2.49
											],
											[
												-0.033,
												3.516
											],
											[
												1.27,
												2.425
											],
											[
												2.229,
												1.562
											],
											[
												2.979,
												0.749
											],
											[
												3.418,
												0.033
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												3.483,
												-0.032
											],
											[
												3.011,
												-0.895
											],
											[
												2.197,
												-1.725
											],
											[
												1.237,
												-2.571
											],
											[
												0,
												-1.953
											],
											[
												-0.554,
												-1.741
											],
											[
												-1.042,
												-1.432
											],
											[
												-1.546,
												-1.025
											],
											[
												3.255,
												-1.367
											],
											[
												1.92,
												-2.49
											],
											[
												0.032,
												-3.32
											],
											[
												-1.27,
												-2.425
											],
											[
												-2.23,
												-1.562
											],
											[
												-2.979,
												-0.748
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												91.602,
												0
											],
											[
												101.343,
												-1.392
											],
											[
												109.155,
												-5.322
											],
											[
												114.307,
												-11.768
											],
											[
												116.162,
												-20.703
											],
											[
												115.332,
												-26.245
											],
											[
												112.939,
												-31.006
											],
											[
												109.058,
												-34.692
											],
											[
												103.76,
												-37.061
											],
											[
												111.523,
												-42.847
											],
											[
												114.453,
												-51.855
											],
											[
												112.598,
												-60.474
											],
											[
												107.349,
												-66.455
											],
											[
												99.536,
												-69.922
											],
											[
												89.941,
												-71.094
											],
											[
												67.236,
												-71.094
											],
											[
												67.236,
												0
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-1.498,
												-0.537
											],
											[
												-1.042,
												-0.977
											],
											[
												-0.554,
												-1.416
											],
											[
												0,
												-1.79
											],
											[
												0.635,
												-1.367
											],
											[
												1.106,
												-0.944
											],
											[
												1.53,
												-0.537
											],
											[
												1.855,
												-0.032
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												1.855,
												0.033
											],
											[
												1.497,
												0.537
											],
											[
												1.041,
												0.977
											],
											[
												0.553,
												1.416
											],
											[
												0,
												1.693
											],
											[
												-0.635,
												1.367
											],
											[
												-1.107,
												0.945
											],
											[
												-1.53,
												0.537
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												92.334,
												-32.227
											],
											[
												97.363,
												-31.372
											],
											[
												101.172,
												-29.102
											],
											[
												103.564,
												-25.513
											],
											[
												104.395,
												-20.703
											],
											[
												103.442,
												-16.113
											],
											[
												100.83,
												-12.646
											],
											[
												96.875,
												-10.425
											],
											[
												91.797,
												-9.57
											],
											[
												79.004,
												-9.57
											],
											[
												79.004,
												-32.227
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.53,
												-0.374
											],
											[
												-1.123,
												-0.813
											],
											[
												-0.619,
												-1.27
											],
											[
												0,
												-1.79
											],
											[
												0.651,
												-1.253
											],
											[
												1.106,
												-0.862
											],
											[
												1.514,
												-0.439
											],
											[
												1.758,
												-0.032
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												1.823,
												0.033
											],
											[
												1.53,
												0.375
											],
											[
												1.123,
												0.814
											],
											[
												0.618,
												1.27
											],
											[
												0,
												1.628
											],
											[
												-0.652,
												1.254
											],
											[
												-1.107,
												0.863
											],
											[
												-1.514,
												0.439
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												79.004,
												-61.426
											],
											[
												90.137,
												-61.426
											],
											[
												95.166,
												-60.815
											],
											[
												99.146,
												-59.033
											],
											[
												101.758,
												-55.908
											],
											[
												102.686,
												-51.318
											],
											[
												101.709,
												-46.997
											],
											[
												99.072,
												-43.823
											],
											[
												95.142,
												-41.87
											],
											[
												90.234,
												-41.162
											],
											[
												79.004,
												-41.162
											]
										],
										"c": true
									}
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "B",
						"np": 6,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "X",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												16.992,
												-71.094
											],
											[
												3.271,
												-71.094
											],
											[
												23.486,
												-35.84
											],
											[
												2.734,
												0
											],
											[
												16.602,
												0
											],
											[
												30.664,
												-26.904
											],
											[
												44.727,
												0
											],
											[
												58.447,
												0
											],
											[
												37.695,
												-35.84
											],
											[
												57.959,
												-71.094
											],
											[
												44.141,
												-71.094
											],
											[
												30.469,
												-44.629
											]
										],
										"o": [
											[
												16.992,
												-71.094
											],
											[
												3.271,
												-71.094
											],
											[
												23.486,
												-35.84
											],
											[
												2.734,
												0
											],
											[
												16.602,
												0
											],
											[
												30.664,
												-26.904
											],
											[
												44.727,
												0
											],
											[
												58.447,
												0
											],
											[
												37.695,
												-35.84
											],
											[
												57.959,
												-71.094
											],
											[
												44.141,
												-71.094
											],
											[
												30.469,
												-44.629
											]
										],
										"v": [
											[
												16.992,
												-71.094
											],
											[
												3.271,
												-71.094
											],
											[
												23.486,
												-35.84
											],
											[
												2.734,
												0
											],
											[
												16.602,
												0
											],
											[
												30.664,
												-26.904
											],
											[
												44.727,
												0
											],
											[
												58.447,
												0
											],
											[
												37.695,
												-35.84
											],
											[
												57.959,
												-71.094
											],
											[
												44.141,
												-71.094
											],
											[
												30.469,
												-44.629
											]
										],
										"c": true
									}
								},
								"nm": "X",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "X",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												77.002,
												-71.094
											],
											[
												63.281,
												-71.094
											],
											[
												83.496,
												-35.84
											],
											[
												62.744,
												0
											],
											[
												76.611,
												0
											],
											[
												90.674,
												-26.904
											],
											[
												104.736,
												0
											],
											[
												118.457,
												0
											],
											[
												97.705,
												-35.84
											],
											[
												117.969,
												-71.094
											],
											[
												104.15,
												-71.094
											],
											[
												90.479,
												-44.629
											]
										],
										"c": true
									}
								},
								"nm": "X",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "X",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "T",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"o": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"v": [
											[
												57.617,
												-71.094
											],
											[
												2.441,
												-71.094
											],
											[
												2.441,
												-61.426
											],
											[
												24.121,
												-61.426
											],
											[
												24.121,
												0
											],
											[
												35.791,
												0
											],
											[
												35.791,
												-61.426
											],
											[
												57.617,
												-61.426
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "T",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												117.627,
												-71.094
											],
											[
												62.451,
												-71.094
											],
											[
												62.451,
												-61.426
											],
											[
												84.131,
												-61.426
											],
											[
												84.131,
												0
											],
											[
												95.801,
												0
											],
											[
												95.801,
												-61.426
											],
											[
												117.627,
												-61.426
											]
										],
										"c": true
									}
								},
								"nm": "T",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "T",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "H",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.32,
												-71.094
											],
											[
												41.895,
												-71.094
											],
											[
												41.895,
												-41.357
											],
											[
												17.725,
												-41.357
											],
											[
												17.725,
												-71.094
											],
											[
												6.348,
												-71.094
											],
											[
												6.348,
												0
											],
											[
												17.725,
												0
											],
											[
												17.725,
												-31.738
											],
											[
												41.895,
												-31.738
											],
											[
												41.895,
												0
											],
											[
												53.32,
												0
											]
										],
										"o": [
											[
												53.32,
												-71.094
											],
											[
												41.895,
												-71.094
											],
											[
												41.895,
												-41.357
											],
											[
												17.725,
												-41.357
											],
											[
												17.725,
												-71.094
											],
											[
												6.348,
												-71.094
											],
											[
												6.348,
												0
											],
											[
												17.725,
												0
											],
											[
												17.725,
												-31.738
											],
											[
												41.895,
												-31.738
											],
											[
												41.895,
												0
											],
											[
												53.32,
												0
											]
										],
										"v": [
											[
												53.32,
												-71.094
											],
											[
												41.895,
												-71.094
											],
											[
												41.895,
												-41.357
											],
											[
												17.725,
												-41.357
											],
											[
												17.725,
												-71.094
											],
											[
												6.348,
												-71.094
											],
											[
												6.348,
												0
											],
											[
												17.725,
												0
											],
											[
												17.725,
												-31.738
											],
											[
												41.895,
												-31.738
											],
											[
												41.895,
												0
											],
											[
												53.32,
												0
											]
										],
										"c": true
									}
								},
								"nm": "H",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "H",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.33,
												-71.094
											],
											[
												101.904,
												-71.094
											],
											[
												101.904,
												-41.357
											],
											[
												77.734,
												-41.357
											],
											[
												77.734,
												-71.094
											],
											[
												66.357,
												-71.094
											],
											[
												66.357,
												0
											],
											[
												77.734,
												0
											],
											[
												77.734,
												-31.738
											],
											[
												101.904,
												-31.738
											],
											[
												101.904,
												0
											],
											[
												113.33,
												0
											]
										],
										"c": true
									}
								},
								"nm": "H",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "H",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "0",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												53.223,
												-44.043
											],
											[
												52.685,
												-52.677
											],
											[
												48.999,
												-62.605
											],
											[
												42.561,
												-69.107
											],
											[
												33.609,
												-72.119
											],
											[
												23.283,
												-71.516
											],
											[
												15.161,
												-67.326
											],
											[
												9.619,
												-59.676
											],
											[
												6.934,
												-48.633
											],
											[
												6.934,
												-27.051
											],
											[
												7.478,
												-18.416
											],
											[
												11.206,
												-8.488
											],
											[
												17.643,
												-1.985
											],
											[
												26.579,
												1.025
											],
											[
												36.93,
												0.423
											],
											[
												45.084,
												-3.767
											],
											[
												50.578,
												-11.417
											],
											[
												53.223,
												-22.461
											]
										],
										"o": [
											[
												53.223,
												-48.633
											],
											[
												50.537,
												-59.676
											],
											[
												44.995,
												-67.326
											],
											[
												36.832,
												-71.516
											],
											[
												26.481,
												-72.119
											],
											[
												17.586,
												-69.107
											],
											[
												11.157,
												-62.605
											],
											[
												7.471,
												-52.677
											],
											[
												6.934,
												-44.043
											],
											[
												6.934,
												-22.461
											],
											[
												9.659,
												-11.417
											],
											[
												15.21,
												-3.767
											],
											[
												23.372,
												0.423
											],
											[
												33.707,
												1.025
											],
											[
												42.659,
												-1.985
											],
											[
												49.055,
												-8.488
											],
											[
												52.693,
												-18.416
											],
											[
												53.223,
												-27.051
											]
										],
										"v": [
											[
												53.223,
												-44.043
											],
											[
												51.611,
												-56.177
											],
											[
												46.997,
												-64.966
											],
											[
												39.697,
												-70.312
											],
											[
												30.029,
												-72.119
											],
											[
												20.435,
												-70.312
											],
											[
												13.159,
												-64.966
											],
											[
												8.545,
												-56.177
											],
											[
												6.934,
												-44.043
											],
											[
												6.934,
												-27.051
											],
											[
												8.569,
												-14.917
											],
											[
												13.208,
												-6.128
											],
											[
												20.508,
												-0.781
											],
											[
												30.127,
												1.025
											],
											[
												39.795,
												-0.781
											],
											[
												47.07,
												-6.128
											],
											[
												51.636,
												-14.917
											],
											[
												53.223,
												-27.051
											]
										],
										"c": true
									}
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												18.652,
												-46.191
											],
											[
												19.596,
												-55.941
											],
											[
												26.22,
												-62.695
											],
											[
												36.336,
												-61.531
											],
											[
												41.145,
												-53.288
											],
											[
												18.652,
												-31.494
											]
										],
										"o": [
											[
												18.652,
												-51.789
											],
											[
												23.372,
												-61.345
											],
											[
												33.609,
												-62.695
											],
											[
												40.079,
												-56.876
											],
											[
												41.406,
												-48.438
											],
											[
												18.652,
												-31.494
											]
										],
										"v": [
											[
												18.652,
												-46.191
											],
											[
												21.484,
												-58.643
											],
											[
												30.029,
												-62.695
											],
											[
												38.208,
												-59.204
											],
											[
												41.406,
												-48.438
											],
											[
												18.652,
												-31.494
											]
										],
										"c": true
									}
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												41.504,
												-25
											],
											[
												37.711,
												-8.35
											],
											[
												19.336,
												-13.004
											],
											[
												41.504,
												-39.258
											]
										],
										"o": [
											[
												41.504,
												-13.899
											],
											[
												23.128,
												-8.35
											],
											[
												18.75,
												-22.314
											],
											[
												41.504,
												-39.258
											]
										],
										"v": [
											[
												41.504,
												-25
											],
											[
												30.127,
												-8.35
											],
											[
												18.75,
												-22.314
											],
											[
												41.504,
												-39.258
											]
										],
										"c": true
									}
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "0",
						"np": 6,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												1.074,
												3.5
											],
											[
												2.002,
												2.361
											],
											[
												2.864,
												1.205
											],
											[
												3.58,
												0
											],
											[
												2.848,
												-1.204
											],
											[
												2.002,
												-2.36
											],
											[
												1.074,
												-3.499
											],
											[
												0,
												-4.59
											],
											[
												0,
												0
											],
											[
												-1.091,
												-3.499
											],
											[
												-2.002,
												-2.36
											],
											[
												-2.865,
												-1.204
											],
											[
												-3.548,
												0
											],
											[
												-2.865,
												1.204
											],
											[
												-1.986,
												2.361
											],
											[
												-1.058,
												3.5
											],
											[
												0,
												4.59
											]
										],
										"o": [
											[
												0,
												-4.59
											],
											[
												-1.074,
												-3.499
											],
											[
												-2.002,
												-2.36
											],
											[
												-2.865,
												-1.204
											],
											[
												-3.548,
												0
											],
											[
												-2.849,
												1.205
											],
											[
												-2.002,
												2.361
											],
											[
												-1.074,
												3.5
											],
											[
												0,
												0
											],
											[
												0,
												4.59
											],
											[
												1.09,
												3.5
											],
											[
												2.002,
												2.361
											],
											[
												2.864,
												1.204
											],
											[
												3.58,
												0
											],
											[
												2.864,
												-1.204
											],
											[
												1.985,
												-2.36
											],
											[
												1.057,
												-3.499
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												113.232,
												-44.043
											],
											[
												111.621,
												-56.177
											],
											[
												107.007,
												-64.966
											],
											[
												99.707,
												-70.312
											],
											[
												90.039,
												-72.119
											],
											[
												80.444,
												-70.312
											],
											[
												73.169,
												-64.966
											],
											[
												68.555,
												-56.177
											],
											[
												66.943,
												-44.043
											],
											[
												66.943,
												-27.051
											],
											[
												68.579,
												-14.917
											],
											[
												73.218,
												-6.128
											],
											[
												80.518,
												-0.781
											],
											[
												90.137,
												1.025
											],
											[
												99.805,
												-0.781
											],
											[
												107.08,
												-6.128
											],
											[
												111.646,
												-14.917
											],
											[
												113.232,
												-27.051
											]
										],
										"c": true
									}
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 1,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												-1.888,
												2.702
											],
											[
												-3.809,
												0
											],
											[
												-1.872,
												-2.327
											],
											[
												-0.261,
												-4.85
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												-5.598
											],
											[
												1.888,
												-2.702
											],
											[
												3.58,
												0
											],
											[
												1.871,
												2.328
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												78.662,
												-46.191
											],
											[
												81.494,
												-58.643
											],
											[
												90.039,
												-62.695
											],
											[
												98.218,
												-59.204
											],
											[
												101.416,
												-48.438
											],
											[
												78.662,
												-31.494
											]
										],
										"c": true
									}
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ind": 2,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												7.584,
												0
											],
											[
												0.586,
												9.31
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												11.101
											],
											[
												-6.999,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												101.514,
												-25
											],
											[
												90.137,
												-8.35
											],
											[
												78.76,
												-22.314
											],
											[
												101.514,
												-39.258
											]
										],
										"c": true
									}
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "mm",
								"mm": 1,
								"nm": "Merge Paths 1",
								"mn": "ADBE Vector Filter - Merge"
							}
						],
						"nm": "0",
						"np": 6,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "F",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"o": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"v": [
											[
												49.854,
												-39.893
											],
											[
												20.02,
												-39.893
											],
											[
												20.02,
												-61.426
											],
											[
												54.248,
												-61.426
											],
											[
												54.248,
												-71.094
											],
											[
												8.203,
												-71.094
											],
											[
												8.203,
												0
											],
											[
												20.02,
												0
											],
											[
												20.02,
												-30.273
											],
											[
												49.854,
												-30.273
											]
										],
										"c": true
									}
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "F",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												109.863,
												-39.893
											],
											[
												80.029,
												-39.893
											],
											[
												80.029,
												-61.426
											],
											[
												114.258,
												-61.426
											],
											[
												114.258,
												-71.094
											],
											[
												68.213,
												-71.094
											],
											[
												68.213,
												0
											],
											[
												80.029,
												0
											],
											[
												80.029,
												-30.273
											],
											[
												109.863,
												-30.273
											]
										],
										"c": true
									}
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "F",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "E",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"o": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"v": [
											[
												48.926,
												-41.357
											],
											[
												19.678,
												-41.357
											],
											[
												19.678,
												-61.426
											],
											[
												53.564,
												-61.426
											],
											[
												53.564,
												-71.094
											],
											[
												7.91,
												-71.094
											],
											[
												7.91,
												0
											],
											[
												53.906,
												0
											],
											[
												53.906,
												-9.57
											],
											[
												19.678,
												-9.57
											],
											[
												19.678,
												-31.885
											],
											[
												48.926,
												-31.885
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "E",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												108.936,
												-41.357
											],
											[
												79.688,
												-41.357
											],
											[
												79.688,
												-61.426
											],
											[
												113.574,
												-61.426
											],
											[
												113.574,
												-71.094
											],
											[
												67.92,
												-71.094
											],
											[
												67.92,
												0
											],
											[
												113.916,
												0
											],
											[
												113.916,
												-9.57
											],
											[
												79.688,
												-9.57
											],
											[
												79.688,
												-31.885
											],
											[
												108.936,
												-31.885
											]
										],
										"c": true
									}
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "E",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "S",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.864,
												-15.357
											],
											[
												41.666,
												-11.89
											],
											[
												38.053,
												-9.603
											],
											[
												33.35,
												-8.545
											],
											[
												27.547,
												-8.814
											],
											[
												22.542,
												-10.685
											],
											[
												18.896,
												-14.128
											],
											[
												16.862,
												-19.19
											],
											[
												4.932,
												-21.338
											],
											[
												5.339,
												-16.658
											],
											[
												7.755,
												-10.749
											],
											[
												11.735,
												-6.014
											],
											[
												16.951,
												-2.457
											],
											[
												22.95,
												-0.13
											],
											[
												29.411,
												0.928
											],
											[
												37.907,
												0.513
											],
											[
												46.436,
												-2.376
											],
											[
												52.718,
												-7.65
											],
											[
												56.055,
												-15.25
											],
											[
												55.452,
												-24.185
											],
											[
												51.416,
												-31.03
											],
											[
												44.938,
												-36.19
											],
											[
												36.702,
												-39.844
											],
											[
												29.972,
												-41.886
											],
											[
												24.853,
												-44.01
											],
											[
												21.012,
												-46.899
											],
											[
												18.896,
												-50.781
											],
											[
												19.205,
												-55.404
											],
											[
												21.297,
												-58.935
											],
											[
												24.772,
												-61.36
											],
											[
												29.394,
												-62.5
											],
											[
												35.01,
												-62.207
											],
											[
												39.461,
												-60.205
											],
											[
												42.488,
												-56.779
											],
											[
												44.075,
												-52.181
											],
											[
												55.957,
												-50.391
											],
											[
												55.257,
												-56.55
											],
											[
												50.886,
												-64.136
											],
											[
												43.824,
												-69.425
											],
											[
												34.668,
												-72.07
											],
											[
												25,
												-71.614
											],
											[
												16.568,
												-68.489
											],
											[
												10.376,
												-63.045
											],
											[
												7.08,
												-55.452
											],
											[
												7.74,
												-46.639
											],
											[
												12.101,
												-39.949
											],
											[
												18.791,
												-34.993
											],
											[
												26.985,
												-31.575
											],
											[
												33.796,
												-29.467
											],
											[
												38.875,
												-27.149
											],
											[
												42.44,
												-24.064
											],
											[
												44.189,
												-20.003
											]
										],
										"o": [
											[
												42.561,
												-12.915
											],
											[
												39.387,
												-10.23
											],
											[
												34.993,
												-8.757
											],
											[
												29.476,
												-8.545
											],
											[
												24.064,
												-9.888
											],
											[
												19.938,
												-12.8
											],
											[
												17.334,
												-17.318
											],
											[
												16.699,
												-21.338
											],
											[
												4.964,
												-18.897
											],
											[
												6.771,
												-12.589
											],
											[
												10.262,
												-7.462
											],
											[
												15.12,
												-3.507
											],
											[
												20.89,
												-0.764
											],
											[
												27.246,
												0.716
											],
											[
												34.815,
												0.928
											],
											[
												43.831,
												-1.147
											],
											[
												50.928,
												-5.631
											],
											[
												55.387,
												-12.468
											],
											[
												56.055,
												-21.467
											],
											[
												53.043,
												-28.938
											],
											[
												47.314,
												-34.644
											],
											[
												39.534,
												-38.762
											],
											[
												31.819,
												-41.276
											],
											[
												26.423,
												-43.221
											],
											[
												22.119,
												-45.833
											],
											[
												19.319,
												-49.341
											],
											[
												18.896,
												-54.003
											],
											[
												20.442,
												-57.878
											],
											[
												23.478,
												-60.693
											],
											[
												27.767,
												-62.271
											],
											[
												33.203,
												-62.5
											],
											[
												38.134,
												-61.035
											],
											[
												41.642,
												-58.057
											],
											[
												43.693,
												-53.816
											],
											[
												44.238,
												-50.391
											],
											[
												55.924,
												-53.614
											],
											[
												52.653,
												-61.857
											],
											[
												46.427,
												-67.944
											],
											[
												37.866,
												-71.54
											],
											[
												28.059,
												-72.07
											],
											[
												19.14,
												-69.791
											],
											[
												12.141,
												-65.104
											],
											[
												7.74,
												-58.195
											],
											[
												7.08,
												-49.333
											],
											[
												10.376,
												-41.984
											],
											[
												16.365,
												-36.466
											],
											[
												24.227,
												-32.584
											],
											[
												31.868,
												-30.143
											],
											[
												37.345,
												-28.003
											],
											[
												41.447,
												-25.195
											],
											[
												43.84,
												-21.492
											],
											[
												44.189,
												-16.749
											]
										],
										"v": [
											[
												43.213,
												-14.136
											],
											[
												40.527,
												-11.06
											],
											[
												36.523,
												-9.18
											],
											[
												31.592,
												-8.545
											],
											[
												25.806,
												-9.351
											],
											[
												21.24,
												-11.743
											],
											[
												18.115,
												-15.723
											],
											[
												16.699,
												-21.338
											],
											[
												4.932,
												-21.338
											],
											[
												6.055,
												-14.624
											],
											[
												9.009,
												-9.106
											],
											[
												13.428,
												-4.761
											],
											[
												18.921,
												-1.611
											],
											[
												25.098,
												0.293
											],
											[
												31.592,
												0.928
											],
											[
												40.869,
												-0.317
											],
											[
												48.682,
												-4.004
											],
											[
												54.053,
												-10.059
											],
											[
												56.055,
												-18.408
											],
											[
												54.248,
												-26.562
											],
											[
												49.365,
												-32.837
											],
											[
												42.236,
												-37.476
											],
											[
												33.74,
												-40.723
											],
											[
												28.198,
												-42.554
											],
											[
												23.486,
												-44.922
											],
											[
												20.166,
												-48.12
											],
											[
												18.896,
												-52.441
											],
											[
												19.824,
												-56.641
											],
											[
												22.388,
												-59.814
											],
											[
												26.27,
												-61.816
											],
											[
												31.152,
												-62.5
											],
											[
												36.572,
												-61.621
											],
											[
												40.552,
												-59.131
											],
											[
												43.091,
												-55.298
											],
											[
												44.238,
												-50.391
											],
											[
												55.957,
												-50.391
											],
											[
												53.955,
												-59.204
											],
											[
												48.657,
												-66.04
											],
											[
												40.845,
												-70.483
											],
											[
												31.25,
												-72.07
											],
											[
												22.07,
												-70.703
											],
											[
												14.355,
												-66.797
											],
											[
												9.058,
												-60.62
											],
											[
												7.08,
												-52.393
											],
											[
												9.058,
												-44.312
											],
											[
												14.233,
												-38.208
											],
											[
												21.509,
												-33.789
											],
											[
												29.785,
												-30.762
											],
											[
												35.571,
												-28.735
											],
											[
												40.161,
												-26.172
											],
											[
												43.14,
												-22.778
											],
											[
												44.189,
												-18.311
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "S",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0.651,
												-1.221
											],
											[
												1.139,
												-0.83
											],
											[
												1.53,
												-0.423
											],
											[
												1.758,
												0
											],
											[
												1.741,
												0.537
											],
											[
												1.302,
												1.058
											],
											[
												0.781,
												1.595
											],
											[
												0.163,
												2.148
											],
											[
												0,
												0
											],
											[
												-0.716,
												-2.034
											],
											[
												-1.254,
												-1.643
											],
											[
												-1.693,
												-1.253
											],
											[
												-1.97,
												-0.846
											],
											[
												-2.148,
												-0.423
											],
											[
												-2.181,
												0
											],
											[
												-2.962,
												0.83
											],
											[
												-2.246,
												1.628
											],
											[
												-1.335,
												2.409
											],
											[
												0,
												3.158
											],
											[
												1.204,
												2.377
											],
											[
												2.051,
												1.807
											],
											[
												2.702,
												1.286
											],
											[
												2.962,
												0.879
											],
											[
												1.774,
												0.668
											],
											[
												1.367,
												0.912
											],
											[
												0.846,
												1.221
											],
											[
												0,
												1.66
											],
											[
												-0.619,
												1.237
											],
											[
												-1.091,
												0.879
											],
											[
												-1.498,
												0.456
											],
											[
												-1.758,
												0
											],
											[
												-1.562,
												-0.586
											],
											[
												-1.091,
												-1.074
											],
											[
												-0.603,
												-1.481
											],
											[
												-0.163,
												-1.79
											],
											[
												0,
												0
											],
											[
												1.302,
												2.654
											],
											[
												2.229,
												1.904
											],
											[
												2.979,
												1.058
											],
											[
												3.418,
												0
											],
											[
												2.93,
												-0.911
											],
											[
												2.213,
												-1.692
											],
											[
												1.318,
												-2.425
											],
											[
												0,
												-3.059
											],
											[
												-1.318,
												-2.327
											],
											[
												-2.132,
												-1.741
											],
											[
												-2.718,
												-1.204
											],
											[
												-2.8,
												-0.813
											],
											[
												-1.775,
												-0.732
											],
											[
												-1.286,
												-0.977
											],
											[
												-0.7,
												-1.286
											],
											[
												0,
												-1.692
											]
										],
										"o": [
											[
												-0.652,
												1.221
											],
											[
												-1.14,
												0.83
											],
											[
												-1.53,
												0.423
											],
											[
												-2.116,
												0
											],
											[
												-1.742,
												-0.537
											],
											[
												-1.302,
												-1.057
											],
											[
												-0.781,
												-1.595
											],
											[
												0,
												0
											],
											[
												0.032,
												2.441
											],
											[
												0.716,
												2.035
											],
											[
												1.253,
												1.644
											],
											[
												1.692,
												1.254
											],
											[
												1.969,
												0.847
											],
											[
												2.148,
												0.423
											],
											[
												3.223,
												0
											],
											[
												2.962,
												-0.83
											],
											[
												2.246,
												-1.627
											],
											[
												1.334,
												-2.409
											],
											[
												0,
												-3.059
											],
											[
												-1.205,
												-2.376
											],
											[
												-2.051,
												-1.807
											],
											[
												-2.702,
												-1.286
											],
											[
												-1.921,
												-0.553
											],
											[
												-1.775,
												-0.667
											],
											[
												-1.367,
												-0.911
											],
											[
												-0.847,
												-1.221
											],
											[
												0,
												-1.562
											],
											[
												0.618,
												-1.237
											],
											[
												1.09,
												-0.879
											],
											[
												1.497,
												-0.455
											],
											[
												2.051,
												0
											],
											[
												1.562,
												0.586
											],
											[
												1.09,
												1.074
											],
											[
												0.602,
												1.482
											],
											[
												0,
												0
											],
											[
												-0.033,
												-3.223
											],
											[
												-1.302,
												-2.653
											],
											[
												-2.23,
												-1.904
											],
											[
												-2.979,
												-1.057
											],
											[
												-3.191,
												0
											],
											[
												-2.93,
												0.912
											],
											[
												-2.214,
												1.693
											],
											[
												-1.318,
												2.425
											],
											[
												0,
												3.06
											],
											[
												1.318,
												2.328
											],
											[
												2.132,
												1.742
											],
											[
												2.718,
												1.205
											],
											[
												2.083,
												0.619
											],
											[
												1.774,
												0.732
											],
											[
												1.286,
												0.977
											],
											[
												0.7,
												1.286
											],
											[
												0,
												1.562
											]
										],
										"v": [
											[
												103.223,
												-14.136
											],
											[
												100.537,
												-11.06
											],
											[
												96.533,
												-9.18
											],
											[
												91.602,
												-8.545
											],
											[
												85.815,
												-9.351
											],
											[
												81.25,
												-11.743
											],
											[
												78.125,
												-15.723
											],
											[
												76.709,
												-21.338
											],
											[
												64.941,
												-21.338
											],
											[
												66.064,
												-14.624
											],
											[
												69.019,
												-9.106
											],
											[
												73.438,
												-4.761
											],
											[
												78.931,
												-1.611
											],
											[
												85.107,
												0.293
											],
											[
												91.602,
												0.928
											],
											[
												100.879,
												-0.317
											],
											[
												108.691,
												-4.004
											],
											[
												114.062,
												-10.059
											],
											[
												116.064,
												-18.408
											],
											[
												114.258,
												-26.562
											],
											[
												109.375,
												-32.837
											],
											[
												102.246,
												-37.476
											],
											[
												93.75,
												-40.723
											],
											[
												88.208,
												-42.554
											],
											[
												83.496,
												-44.922
											],
											[
												80.176,
												-48.12
											],
											[
												78.906,
												-52.441
											],
											[
												79.834,
												-56.641
											],
											[
												82.397,
												-59.814
											],
											[
												86.279,
												-61.816
											],
											[
												91.162,
												-62.5
											],
											[
												96.582,
												-61.621
											],
											[
												100.562,
												-59.131
											],
											[
												103.101,
												-55.298
											],
											[
												104.248,
												-50.391
											],
											[
												115.967,
												-50.391
											],
											[
												113.965,
												-59.204
											],
											[
												108.667,
												-66.04
											],
											[
												100.854,
												-70.483
											],
											[
												91.26,
												-72.07
											],
											[
												82.08,
												-70.703
											],
											[
												74.365,
												-66.797
											],
											[
												69.067,
												-60.62
											],
											[
												67.09,
												-52.393
											],
											[
												69.067,
												-44.312
											],
											[
												74.243,
												-38.208
											],
											[
												81.519,
												-33.789
											],
											[
												89.795,
												-30.762
											],
											[
												95.581,
												-28.735
											],
											[
												100.171,
												-26.172
											],
											[
												103.149,
												-22.778
											],
											[
												104.199,
												-18.311
											]
										],
										"c": true
									}
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "S",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		},
		{
			"ch": "C",
			"size": 13,
			"style": "Medium",
			"w": 60.01,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												43.506,
												-21.826
											],
											[
												41.845,
												-14.265
											],
											[
												34.424,
												-8.447
											],
											[
												25.423,
												-9.033
											],
											[
												20.41,
												-12.971
											],
											[
												17.488,
												-19.36
											],
											[
												16.309,
												-27.604
											],
											[
												16.309,
												-40.479
											],
											[
												16.545,
												-46.207
											],
											[
												18.278,
												-53.898
											],
											[
												21.939,
												-59.586
											],
											[
												27.734,
												-62.598
											],
											[
												34.383,
												-62.272
											],
											[
												38.851,
												-60.034
											],
											[
												41.755,
												-56.128
											],
											[
												43.36,
												-50.813
											],
											[
												55.273,
												-48.73
											],
											[
												54.118,
												-55.5
											],
											[
												49.983,
												-63.752
											],
											[
												43.311,
												-69.352
											],
											[
												34.114,
												-72.119
											],
											[
												22.364,
												-71.28
											],
											[
												13.224,
												-65.65
											],
											[
												7.258,
												-56.518
											],
											[
												4.475,
												-44.71
											],
											[
												4.443,
												-30.664
											],
											[
												5.03,
												-22.2
											],
											[
												8.79,
												-11.165
											],
											[
												15.771,
												-3.165
											],
											[
												25.992,
												1.025
											],
											[
												37.149,
												0.48
											],
											[
												45.508,
												-3.247
											],
											[
												51.53,
												-9.66
											],
											[
												54.947,
												-18.408
											]
										],
										"o": [
											[
												43.115,
												-17.561
											],
											[
												37.549,
												-9.61
											],
											[
												27.652,
												-8.447
											],
											[
												21.842,
												-11.377
											],
											[
												18.262,
												-17.008
											],
											[
												16.545,
												-24.732
											],
											[
												16.309,
												-30.664
											],
											[
												16.309,
												-43.409
											],
											[
												17.488,
												-51.546
											],
											[
												20.491,
												-57.967
											],
											[
												25.52,
												-61.995
											],
											[
												32.519,
												-62.598
											],
											[
												37.541,
												-60.969
											],
											[
												40.934,
												-57.592
											],
											[
												42.96,
												-52.71
											],
											[
												43.555,
												-48.73
											],
											[
												54.914,
												-52.278
											],
											[
												51.644,
												-61.295
											],
											[
												45.816,
												-67.789
											],
											[
												37.451,
												-71.565
											],
											[
												26.106,
												-72.119
											],
											[
												15.918,
												-67.927
											],
											[
												8.895,
												-59.888
											],
											[
												5.045,
												-48.804
											],
											[
												4.443,
												-40.381
											],
											[
												4.475,
												-26.302
											],
											[
												7.178,
												-14.518
											],
											[
												13.086,
												-5.436
											],
											[
												22.217,
												0.187
											],
											[
												33.902,
												1.025
											],
											[
												42.976,
												-1.7
											],
											[
												49.804,
												-7.251
											],
											[
												54.134,
												-15.291
											],
											[
												55.273,
												-21.826
											]
										],
										"v": [
											[
												43.506,
												-21.826
											],
											[
												39.697,
												-11.938
											],
											[
												30.322,
												-8.447
											],
											[
												23.633,
												-10.205
											],
											[
												19.336,
												-14.99
											],
											[
												17.017,
												-22.046
											],
											[
												16.309,
												-30.664
											],
											[
												16.309,
												-40.479
											],
											[
												17.017,
												-48.877
											],
											[
												19.385,
												-55.933
											],
											[
												23.73,
												-60.791
											],
											[
												30.371,
												-62.598
											],
											[
												35.962,
												-61.621
											],
											[
												39.893,
												-58.813
											],
											[
												42.358,
												-54.419
											],
											[
												43.555,
												-48.73
											],
											[
												55.273,
												-48.73
											],
											[
												52.881,
												-58.398
											],
											[
												47.9,
												-65.771
											],
											[
												40.381,
												-70.459
											],
											[
												30.371,
												-72.119
											],
											[
												19.141,
												-69.604
											],
											[
												11.06,
												-62.769
											],
											[
												6.152,
												-52.661
											],
											[
												4.443,
												-40.381
											],
											[
												4.443,
												-30.664
											],
											[
												6.104,
												-18.359
											],
											[
												10.938,
												-8.301
											],
											[
												18.994,
												-1.489
											],
											[
												30.322,
												1.025
											],
											[
												40.063,
												-0.61
											],
											[
												47.656,
												-5.249
											],
											[
												52.832,
												-12.476
											],
											[
												55.273,
												-21.826
											]
										],
										"c": true
									}
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "C",
						"np": 3,
						"mn": "ADBE Vector Group"
					},
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												2.148,
												-2.327
											],
											[
												4.102,
												0
											],
											[
												1.79,
												1.172
											],
											[
												1.074,
												2.019
											],
											[
												0.471,
												2.686
											],
											[
												0,
												3.06
											],
											[
												0,
												0
											],
											[
												-0.472,
												2.67
											],
											[
												-1.107,
												2.035
											],
											[
												-1.791,
												1.205
											],
											[
												-2.637,
												0
											],
											[
												-1.579,
												-0.651
											],
											[
												-1.042,
												-1.221
											],
											[
												-0.603,
												-1.709
											],
											[
												-0.195,
												-2.083
											],
											[
												0,
												0
											],
											[
												1.237,
												2.898
											],
											[
												2.083,
												2.019
											],
											[
												2.93,
												1.107
											],
											[
												3.743,
												0
											],
											[
												3.223,
												-1.676
											],
											[
												2.164,
												-2.881
											],
											[
												1.106,
												-3.857
											],
											[
												0.032,
												-4.329
											],
											[
												0,
												0
											],
											[
												-1.074,
												-3.841
											],
											[
												-2.148,
												-2.864
											],
											[
												-3.223,
												-1.676
											],
											[
												-4.33,
												0
											],
											[
												-2.914,
												1.09
											],
											[
												-2.148,
												2.002
											],
											[
												-1.302,
												2.816
											],
											[
												-0.326,
												3.418
											]
										],
										"o": [
											[
												-0.391,
												4.265
											],
											[
												-2.148,
												2.328
											],
											[
												-2.67,
												0
											],
											[
												-1.791,
												-1.172
											],
											[
												-1.074,
												-2.018
											],
											[
												-0.472,
												-2.686
											],
											[
												0,
												0
											],
											[
												0,
												-2.93
											],
											[
												0.471,
												-2.669
											],
											[
												1.106,
												-2.034
											],
											[
												1.79,
												-1.204
											],
											[
												2.148,
												0
											],
											[
												1.579,
												0.652
											],
											[
												1.041,
												1.221
											],
											[
												0.602,
												1.709
											],
											[
												0,
												0
											],
											[
												-0.359,
												-3.548
											],
											[
												-1.237,
												-2.897
											],
											[
												-2.084,
												-2.018
											],
											[
												-2.93,
												-1.106
											],
											[
												-4.265,
												0
											],
											[
												-3.223,
												1.677
											],
											[
												-2.165,
												2.881
											],
											[
												-1.107,
												3.857
											],
											[
												0,
												0
											],
											[
												0.032,
												4.362
											],
											[
												1.074,
												3.841
											],
											[
												2.148,
												2.865
											],
											[
												3.223,
												1.676
											],
											[
												3.58,
												0
											],
											[
												2.913,
												-1.09
											],
											[
												2.148,
												-2.002
											],
											[
												1.302,
												-2.815
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												103.516,
												-21.826
											],
											[
												99.707,
												-11.938
											],
											[
												90.332,
												-8.447
											],
											[
												83.643,
												-10.205
											],
											[
												79.346,
												-14.99
											],
											[
												77.026,
												-22.046
											],
											[
												76.318,
												-30.664
											],
											[
												76.318,
												-40.479
											],
											[
												77.026,
												-48.877
											],
											[
												79.395,
												-55.933
											],
											[
												83.74,
												-60.791
											],
											[
												90.381,
												-62.598
											],
											[
												95.972,
												-61.621
											],
											[
												99.902,
												-58.813
											],
											[
												102.368,
												-54.419
											],
											[
												103.564,
												-48.73
											],
											[
												115.283,
												-48.73
											],
											[
												112.891,
												-58.398
											],
											[
												107.91,
												-65.771
											],
											[
												100.391,
												-70.459
											],
											[
												90.381,
												-72.119
											],
											[
												79.15,
												-69.604
											],
											[
												71.069,
												-62.769
											],
											[
												66.162,
												-52.661
											],
											[
												64.453,
												-40.381
											],
											[
												64.453,
												-30.664
											],
											[
												66.113,
												-18.359
											],
											[
												70.947,
												-8.301
											],
											[
												79.004,
												-1.489
											],
											[
												90.332,
												1.025
											],
											[
												100.073,
												-0.61
											],
											[
												107.666,
												-5.249
											],
											[
												112.842,
												-12.476
											],
											[
												115.283,
												-21.826
											]
										],
										"c": true
									}
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group"
							}
						],
						"nm": "C",
						"np": 3,
						"mn": "ADBE Vector Group"
					}
				]
			},
			"fFamily": "Roboto Mono"
		}
	]
};

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"b2b",
		"header-dark"
	],
	"title": "Easier Enterprise Identity Management for your Business Partners",
	"metas": {
		"description": "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch."
	},
	"opengraph": {
		"og:title": "Easier Enterprise Identity Management for your Business Partners",
		"og:description": "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch.",
		"og:url": "https://auth0.com//b2b-enterprise-identity-management",
		"og:image": "https://cdn.auth0.com/website/assets/pages/b2b/img/b2b-share-card-46bd12cc43.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/b2b/img/b2b-share-card-46bd12cc43.png"
	},
	"twittercard": {
		"twitter:title": "Easier Enterprise Identity Management for your Business Partners",
		"twitter:description": "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/b2b/img/b2b-share-card-46bd12cc43.png"
			}
		]
	}
};

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"b2c"
	],
	"title": "Better, Easier Identity Management for B2C Companies",
	"metas": {
		"description": "Drive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics."
	},
	"opengraph": {
		"og:title": "Better, Easier Identity Management for B2C Companies",
		"og:description": "Drive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics.",
		"og:url": "https://auth0.com/b2c-customer-identity-management",
		"og:image": "https://cdn.auth0.com/website/assets/pages/b2c/img/b2c-new-twitter-card-85aafdf324.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/b2c/img/b2c-new-twitter-card-85aafdf324.png"
	},
	"twittercard": {
		"twitter:title": "Better, Easier Identity Management for B2C Companies",
		"twitter:description": "Drive new revenue by securely acquiring more customers, and driving more conversions and upsells using identity data and analytics.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/b2c/img/b2c-new-twitter-card-85aafdf324.png"
			}
		]
	}
};

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"breached-passwords-page"
	],
	"title": "Breached Password Detection",
	"metas": {
		"description": ""
	},
	"opengraph": {
		"og:title": "Breached Password Detection",
		"og:description": "Breached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.",
		"og:url": "https://auth0.com/breached-passwords",
		"og:image": "http://cdn2.auth0.com/blog/breached-twitter-card.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/breached-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Breached Password Detection",
		"twitter:description": "Breached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/breached-twitter-card.png"
			}
		]
	}
};

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports = [
	{
		"description": "Support for GeoHA with Elasticsearch. This allows user search via Elasticsearch to be used in GeoHA environments.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"silvio.massari@auth0.com",
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Logrotation added for elasticsearch. This should make sure logs are kept to a reasonable size, if Elasticsearch is enabled. The last 4 log files are retained.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Logrotation added for influxdb and telegraph. This should make sure logs are kept to a reasonable size, if instrumentation is enabled. The last 5 log files are retained.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Minimum master databases are now set properly for Elasticsearch on initial setup. This affects how many failed nodes ES requires to be available to maintain a writeable cluster.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "New version of limitd is available that addresses some memory leaks.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Nginx is now properly configured wtih the default server_names_hash_bucket size on initial installs.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "New event types are added to the statistics calculation in calculating active users.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Users can now be exported via the a0cli for a limited set of whitelisted fields.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Sensitive data is now required to be exported separately and stored seprately from standard backups. This keeps a better separation between keys and data. Both sets of backups are needed in order to succesfully complete restoration. Senstivie data is backuped up via the a0cli command line just like database backups.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Webtask components have been updated to the latest as of release time. While largely internal, it will allow the appliance to keep pace with the latest extensions.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "Old webtask images are now automatically removed after an appliance update. Webtask keep the current images plus the one for one release prior, all others will be removed.",
		"type": "added",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "A sandbox error is no longer displayed in the manage UI if a sandbox other than auth0-sandbox is enabled.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11638",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-05-01"
	},
	{
		"description": "SSO timeout setting now applies users API endpoint.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"cristofer.gonzales@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Webtask Editor is now available in appliance. This allow you to edit webtask right from a web page. See https://webtask.io/docs/editor for more details on the editor.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Hooks Feature is now available in appliance. This allows you to plug in code on specific events. See <a href=\"https://auth0.com/docs/hooks\" rel=\"external\">https://auth0.com/docs/hooks</a> for more details.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"javier.centurion@auth0.com",
			"geoff@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Webtask components have been updated. While mostly internal, this will allow the appliance to keep pace with the latest extensions.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Longer server name lengths can be accomodated in nginx via configuration.",
		"type": "added",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Grafana no longer restricts users by domain name.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "Mongo2es service properly stops and does not uninstall when transitioning to or from Elasticsearch.",
		"type": "fixed",
		"module": "Appliance",
		"release": "11112",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-03-21"
	},
	{
		"description": "auth0-server no longer logs sensitive data on failed requests",
		"type": "fixed",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Sandbox parameters should be properly created if missing for a tenant",
		"type": "fixed",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "From configuration, can enable tenant verification prior to creation of tenant log collections.",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Mongo client updated to 3.2 and added scripts to update the mongo database to 3.2",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Users modified/updated via the Users api are now properly forwarded to ElasticSearch, if enabled.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Usage calculations have now been updated to include breakdown per tenant per client per conneciton per strategy per month.",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "The new authentication pipeline is now included.  Please verify major auth flows before moving it to production.",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"crew-auth@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Webtask runtime components have been updated to 18.3.2",
		"type": "added",
		"module": "Appliance",
		"release": "10755",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-02-20"
	},
	{
		"description": "Elasticsearch Preview is now available to some customers as a limited release.",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari@auth0.com",
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Webtask runtime components have been updated to 17.3.5",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Webtask domain must now be setup as part of initial appliance node setup.",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Logs should not be truncated during configuration updates.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Webtask configuration overrides are now properly merged with standard default values.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "The default smtp address is used for emails from 2nd level brute force notifications.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "apt-mirror.it.auth0.com is now access via https instead of http.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Auth0 Docs use the correct client secret so will now show up.",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Use of the user search hint and user search timeout can now be modified if needed",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "API2 CPU and Memory limits can now be set, like for other services.",
		"type": "added",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "auth0-stats no longer hands on single-replica instances",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"dircue@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "The default redirect url can now be configure",
		"type": "fixed",
		"module": "Appliance",
		"release": "10258",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "Internet connectivity healthcheck moved from ping to HTTP HEAD request",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "api v1 has been split from `auth0-server` to run from a separate service, `auth0-api1`.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Ensure dhcpclient is stopped when switching networking from dynamic to static",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Webtask endpoints added to healthchecks for Appliance. ",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Appliance will no longer forward arbitrary `fwd.` parameters for authentication requests.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari@auth0.com",
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Add-as-arbiter scripts have been extended to support two-arbiter configurations",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"carlos.mostek@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Fixed a mis-match in per_page limits on user searches.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "The appliance can be setup to us proxies on initial install and during updates.",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Encryption and hashing keys are rotated during initial appliance setup when `set-as-first` is run.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "During re-configuration, webtask should be restarted only when necessary.",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Instrumentation metrics can now be sent to a DataDog endpoint by providing a DataDog API Key in configuration.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari@auth0.com",
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Azure WAAD thumbprints are now automatically updated nightly from one of the appliance nodes.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "The multifactor auth link now links to #/multifactor instead of #/guardian",
		"type": "fixed",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Webtask on the appliance is now upgraded to version 14.5.1.",
		"type": "added",
		"module": "Appliance",
		"release": "9632",
		"team": [
			"pablo.terradillos@auth0.com",
			"tomek@auth0.com"
		],
		"publishedAt": "2016-11-23"
	},
	{
		"description": "Per node instrumentation is now available. Instrumentation provides historical data and a UX for the node that shows system metrics, database metrics, and transaction rates. Detailed instrumentation for 24 hours is retained, and down-sampled metrics are available for 7 days.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"silvio@auth0.com",
			"rikaard.hosein@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Extensions are now supported. You must have configured webtasks (auth0-sandbox mode) for extensions to work, and a certificate issued by a public certificate authority. A few extensions from the public cloud do not work on the appliance, and you will not see those extensions in the extensions gallery.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"javier.centurion@auth0.com",
			"pablo.terradillos@auth0.com",
			"tomek@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "You can configure log retention in the dashboard. The log retention period applies to all tenants, and defaults to 30 days. Performance can be adversely affected by setting this beyond 30 days. Please consult your CSE.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "You can disable http for authenticated health checks in the management dashboard. By default both http and https are allowed, with the http interface intended for use on isolated networks. If you aren't on an isolated network or only want to allow https, then you can disable http.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The docker repository can now use port 443 instead of port 5000 for getting updates. In some environments using a non-standard port was problematic.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Improved CLI scriptability by always returning 0 on success, and 1 on failure. Also standardized output for commands, and error handling. The CLI also now automatically updates to the metadata version for the cluster release.",
		"type": "changed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "You can now add trusted certificates to the cert store on the appliance. This helps for certain situations, like the use of a transparent proxy.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Added a posture check to the configuration process. This ensures that the services came up correctly after configuration, and that all configuration has completed running.",
		"type": "added",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The client credentials authentication flow no longer depends upon webtasks.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Appliance tenants are now created as premium customers.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "When using proxy protocol (typically AWS), tenant logs fail when auth0-sandbox is configured (webtasks).",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The consistency checks at startup for tty1 (auth0-start) forced an application update sometimes when first adding a node to an operating cluster. These checks now only warn.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "The update process sometimes failed when both configuration and app updates are indicated. The app update is applied first, and it may in some circumstances apply invalid settings, causing a failure. Now configuration updates are always applied before application updates.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8986",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-10-13"
	},
	{
		"description": "Customers can disable TLS for SMTP. Normally Auth0 servers negotation TlS with SMTP servers using START_TLS. In some cases customers want to actively disable the use of TLS. You can now force TLS off for SMTP.",
		"type": "added",
		"module": "Appliance",
		"release": "8293",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-09-01"
	},
	{
		"description": "Performance fixes and enhancements.",
		"type": "changed",
		"module": "Appliance",
		"release": "8293",
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio@auth0.com"
		],
		"publishedAt": "2016-09-01"
	},
	{
		"description": "Filtering of patch releases done improperly, resulting in update to the latest version rather than selected version in some cases.",
		"type": "fixed",
		"module": "Appliance",
		"release": "8293",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-09-01"
	},
	{
		"description": "Open logout redirects are now disabled by default on new appliances. Logout redirects must be white listed.",
		"type": "changed",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "Webtasks are now enabled by default on new installations for rule execution.",
		"type": "changed",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "A connectivity command can now be ran against an instance in the cluster using the CLI to verify connecting on a ip address and port for each node.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "A nslookup command can now be ran against an instance in the cluster using the CLI to verify dns setup for each node.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "CSE can now adjust the maximum memory for several processes that can vary under load to match the profiles being used by the customer.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "An additional fix was made to backup decompression logic.",
		"type": "added",
		"module": "Appliance",
		"release": "7941",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-08-08"
	},
	{
		"description": "Increased keep-alive timeout to 100 seconds. Some technologies like .NET use a 100 second timeout limit, and the previous setting of 60 seconds could cause issues.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Added a default from email address. If a template does not specify a from address then this address is used. Additionally there is an option to send dashboard administrator invitations from the default email address rather than the inviting administrator. This helps customers using transactional email services where they must white list from email addresses.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Added the ability to turn off MX record checking for email recipients. In some cases customers use domains that do not have MX records for emails.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "The CLI would fail if an invalid key was specified for a user in the management dashboard. This fixes provides a clearer message and performs key checking.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7760",
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Improved diagnostics and troubleshooting view by adding RabbitMQ to service checks and showing each cluster node application version in the node view. RabbitMQ is responsible for queuing emails, and if it stops email will not be sent. This check now shows the status in the dashboard and also at the healthcheck endpoint.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Bulk user import now works on the appliance. Customers that have to import a large number of users can use the apiv2 mechanism for bulk user import.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"silvio@auth0.com"
		],
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Fixed an issue with invalid compression on large backups.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7760",
		"publishedAt": "2016-07-27"
	},
	{
		"description": "Information on response times for different authentication stages are now written to the logs. This helps customers understand where bottlenecks are occurring if logins are slow.",
		"type": "added",
		"module": "Appliance",
		"release": "7760",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Search queries for users and transaction logs can execute on a secondary database instance. This reduces the load on the primary database node, ensuring that authentication transactions are not affected by expensive search queries in high load environments.",
		"type": "added",
		"module": "Search",
		"release": "7247",
		"team": [
			"silvio@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "The management dashboard can now use a different SSL certificate than the tenant authentication domains. With this feature you could for example run your authentication endpoints on externally facing domains while using an internal domain for the dashboard.",
		"type": "added",
		"module": "Dashboard",
		"release": "7247",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "The apiv1 user search endpoint caches results of a count operation for 5 minutes. The number of users should be considered an approximate count when doing search operations using apiv1.",
		"type": "fixed",
		"module": "Appliance",
		"release": "7247",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Support for SSL offloading is now available. You can now configure the appliance to accept http. Your load balancer needs to provide a X-Forwarded-Proto header with this feature. The operational environment is responsible for ensuring http access is locked down to the load balancer.",
		"type": "added",
		"module": "Appliance",
		"release": "7247",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "For queries that return a large number of results, the apiv2 user search endpoint will not return a count if a time limit for counting matching users is exceeded. Doing overall count queries, or count queries for a connection are efficient and will return results even when there are millions of users.",
		"type": "fixed",
		"module": "Management API",
		"release": "7247",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Auth0 now periodically collects aggregate statistics from appliance clusters. Customers can request a dump of the statistics collected.",
		"type": "added",
		"module": "Stats",
		"release": "7247",
		"team": [
			"bob.brumfield@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Webtasks improve the execution of rules and custom database logic. Webtasks perform much better than the current 'node sandbox' mode and provide much better isolation than the optional 'eval' mode. Webtasks have many more node.js modules available for your rule logic to use.",
		"type": "added",
		"module": "Rules",
		"team": [
			"pablo.terradillos@auth0.com",
			"tomek@auth0.com"
		],
		"publishedAt": "2016-06-17"
	},
	{
		"description": "Performance of the management dashboard and user search improved. User search functionality is reduced as part of the performance improvement. You can now only sort users by email when doing a filtered search, and you can no longer sort by name or login count.",
		"type": "changed",
		"module": "Appliance",
		"release": "6975",
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-28"
	},
	{
		"description": "The CLI backup capability has been enhanced. You now will designate a specific instance for backup from the CLI. This ensures a backup does not degrade your normal cluster operations during the process. Additionally you must now have a dedicated backup volume on the designated backup instance. This ensures that a backup will not fill up volumes used for normal operations.",
		"type": "added",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "A CSE can now configure an appliance cluster to distribute load over more cores to support scale up as an alternative to scale out. Some types of authentications require expensive cryptographic operations where scale up may be a more desirable approach.",
		"type": "added",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "Services are now periodically checked and restarted by an independent process. Typically services do restart automatically, although in some unusual rapid failure modes a service may stop running. The monitoring service checks periodically for this condition and start any services that have failed their normal automatic restart. This additional monitoring function is off by default.",
		"type": "added",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "In this release a JSONP endpoint used for SSO has been disabled. This endpoint supported browsers before IE9. This exposes some potential vulnerabilities due to the weakness in the JSON protocol. A setting was also added that allows a customer to overrride the JSON disable on a per-tenant basis.",
		"type": "deprecated",
		"module": "appliance",
		"release": "6868",
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20"
	},
	{
		"description": "Provided access to the language in passwordless email templates",
		"type": "added",
		"module": "Passwordless emails",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "Added support for Bitbucket and Dropbox social connections.",
		"type": "added",
		"module": "Social Connections: Bitbucket, Social Connections: Dropbox",
		"team": [
			"gabriel@auth0.com",
			"victor@auth0.com",
			"richard.seldon@auth0.com"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "Remove support for JSONP on /ssodata endpoint. The \"Last time you logged in with\" feature will no longer be supported on IE 9.",
		"type": "removed",
		"module": "API",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-05-10"
	},
	{
		"description": "The VMWare image (OVA) now supports compatibility level 10. If you have an older version of ESX, we can still provide an OVA with compatibility level 8.",
		"type": "added",
		"module": "Appliance",
		"release": "6576",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-05"
	},
	{
		"description": "Added the ability to re-assign IP addresses for other cluster nodes using the command line interface. When a cluster is moved to a new network, then the nodes need to be provided with the ip addresses of the other nodes in order to re-establish the cluster. With the **re-ip** command, you can modify a node configuration for the ip addresses of the other nodes in the cluster.",
		"type": "added",
		"module": "Appliance",
		"release": "6576",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-05-05"
	},
	{
		"description": "Rate limiting is a feature that is now available on the appliance. Rate limiting uses a token bucket approach to limit the rates on various services such as user logins and API invocations. The feature helps prevent against brute force attacks.",
		"type": "added",
		"module": "Appliance",
		"release": "6576",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-05-02"
	},
	{
		"description": "Added logout `returnTo` URL validation. If the `returnTo` URL is not in the Allowed Logout URLs list, the request will be rejected. See the [docs](https://auth0.com/docs/logout#setting-allowed-logout-urls-at-the-account-level) for more information.",
		"type": "added",
		"module": "Server",
		"release": "6576",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-04-22"
	},
	{
		"description": "Added a new property on the **client** entity to allow users to specify how the client is going to perform authentication with the token endpoint. Values are `none`, `client_secret_post` and `client_secret_basic`. The `none` option is introduced for native applications which canâ€™t store secrets and use **PKCE** (see https://tools.ietf.org/html/rfc7636)",
		"type": "added",
		"module": "Management API",
		"team": [
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-04-07"
	},
	{
		"description": "Suppressed the error message in the change password flow in order to prevent user enumeration within the message. The API now returns HTTP 200.",
		"type": "changed",
		"module": "Connections: Database",
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "We included an extra validation in the `/tokeninfo` endpoint to verify that the account name in the URL matches the account for which the token was issued. Any call to the tokeninfo with a token from another account will return Unauthorized.",
		"type": "fixed",
		"module": "Authentication API",
		"team": [
			"sebastian.iacomuzzi@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "We deprecated the `current_user_device_credentials` scopes in the `/api/v2/device-credentials` endpoint for `POST` and `DELETE` methods. To use this endpoint we enabled **Basic authentication** with username and password from a database connection.",
		"type": "deprecated",
		"module": "APIv2",
		"team": [
			"sebastian.iacomuzzi@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-05"
	},
	{
		"description": "Geospatial information in audit log for audit login events is now available on the appliance. Previously geocoding was only available in the cloud.",
		"type": "added",
		"module": "Appliance",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "From the dashboard you can now test connectivity from an appliance instance to an IP address or DNS name and port. This enables you to see if low level connectivity exists between the appliance and other services like smtp or dns.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "Application and setting updates now provide clearer log output. \r\n\r\nApplication updates also apply system updates, and apply configuration after update to ensure the  appliance is in a consistent state. Application updates at `apt-mirror.it.auth0.com` which resolves to a small number of IP addresses to whitelist during update. System updates can be overridden to always come from the central mirror using a setting override in the dashboard (mirror url). \r\n\r\nIn the future the use of the central mirror will be included automatically for a release into the application update pipeline.",
		"type": "changed",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"chris@auth0.com"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "You can now programmatically query healthcheck endpoints (`/health/status/`) on CPU, memory, disk, services, network, internet, email, database and replica status. The service will return a `204` return code if OK, and a `520` return code if it is failing. If it is queried too frequently you may also get a `429` (_Too Many Requests_). You need to provide an API key (generated in the dashboard) in order to access these metrics.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"silvio.massari@auth0.com",
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "The Management Dashboard can be configured to run on a different port than 443. This way the manage dashboard will not be accessible with other services and can be blocked from external access.",
		"type": "changed",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "New command line interface for interacting with nodes in the appliance. \r\n\r\nThis is a beta release. The tool lets administrators automate tasks for the appliance and address specific nodes in the cluster. The beta release provides a commands to:\r\n* *ping* - Test connectivity to a server. Responds with pong, which confirms the end to end network and security connectivity are in place.\r\n* *create-key* - The CLI performs privileged operations, so a public/private key pair are used. You register the public key on the cluster through the dashboard. You can have multiple clients.\r\n* *backup-start* - This starts a backup on a cluster instance. If a backup already exists, it will be overwritten.\r\n* *backup-status* - Poll appliance for completion status\r\n* *backup-retrieve* - Retrieve a backup from the appliance so that you can store it off.\r\n\r\nRight now restores are performed manually working with a CSE if required.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"pablo.terradillos@auth0.com",
			"silvio@auth0.com"
		],
		"publishedAt": "2016-03-17"
	},
	{
		"description": "Users can now specify a list of URLs that are valid to redirect to after logging out from Auth0. The update can be done either from the [Dashboard](https://manage.auth0.com/#/account/advanced) or using the  [Management API](https://auth0.com/docs/api/v2#!/Tenants/patch_settings).",
		"type": "added",
		"module": "Dashboard / Management API",
		"release": "5970",
		"team": [
			"hernan.tierno@auth0.com",
			"tomas.chernov@auth0.com",
			"cristian@auth0.com"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "Added new `ext_nested_groups` option to `waad` connection strategy. When both `ext_groups` and `ext_nested_groups` are enabled we return all the groups that the user is a member of instead of only returning the ones that the user is direct member (for more information see this [MSDN article]( https://msdn.microsoft.com/Library/Azure/Ad/Graph/api/users-operations#UserFunctions))",
		"type": "added",
		"module": "Enterprise Connections",
		"release": "5970",
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "The `device-credentials` endpoint now supports basic authentication to perform `GET`, `POST`, and `DELETE` requests.",
		"type": "added",
		"module": "Management API",
		"release": "5970",
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-03-14"
	},
	{
		"description": "Added Profile Mapper for the integrated **AD-LDAP** appliance functionality so you can map attributes coming from your AD-LDAP source to the users Auth0 profile.",
		"type": "added",
		"module": "Appliance",
		"release": "5970",
		"team": [
			"jose@auth0.com",
			"pablo.terradillos@auth0.com"
		],
		"publishedAt": "2016-03-07"
	},
	{
		"description": "The flow to reset a password has been updated. \r\n\r\nIn this new flow, users enter their username or email address and receive an email with instructions to choose a new password. The old flow which required users to enter their new password and then confirm the change via email is still available but has been deprecated: it is no longer available for new tenants and existing tenants are recommended to disable it.",
		"type": "changed",
		"module": "Auth0 Lock v9",
		"release": "5970",
		"team": [
			"iaco@auth0.com",
			"gabriel@auth0.com",
			"ricky@auth0.com",
			"benjamin@auth0.com"
		],
		"publishedAt": "2016-03-01"
	},
	{
		"description": "Users can query logs using the **Management API v2**. \r\n\r\nYou can use the new `logs` endpoints to query logs. This is the new recommended way to query logs. The **API v1** logs endpoints will still be functional. See more info in the [docs](https://auth0.com/docs/api/v2#!/Logs/get_logs).",
		"type": "added",
		"module": "Management API",
		"release": "5970",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-02-26"
	},
	{
		"description": "Appliance **Configuration** has its own landing page. Unauthorized users are redirected to the Dashboard",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Added the ability to configure a cluster from the **tty1** interface",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "The **Management API** supports the query (\"q\") parameter when searching for users",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Enabled appliance update through a proxy",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Support to handle **base64** encoded secret in the SMS provider",
		"type": "added",
		"module": "users",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Full support for SAMLP logout",
		"type": "added",
		"module": "logout",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Replica set Health check status available in the **Configuration** section",
		"type": "added",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Settings page reorganized in logical sections. **Federated Logout** setting available; if is enabled",
		"type": "changed",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Moved **AD/LDAP** connection under the configuration section.",
		"type": "changed",
		"module": "appliance",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "In API (v1), `profileData` is returned for linked identities",
		"type": "fixed",
		"module": "api",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "New look & feel for the **Password change** form and **Email verification** page",
		"type": "changed",
		"module": "login-page",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "If a ticket throws an error use the tenant's custom error page (if available)",
		"type": "changed",
		"module": "errors",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Modify User details to not disclose access tokens from IDPs",
		"type": "fixed",
		"module": "dashboard",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "`/authorize` endpoint now accepts `auth_type` parameter for use with **Facebook**",
		"type": "fixed",
		"module": "social-connections",
		"release": "5590",
		"publishedAt": "2016-02-17"
	},
	{
		"description": "Added support for custom domains  https://github.com/auth0/auth0-users/pull/406",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Ability to reboot instance from dashboard",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Possibility to remove an application node under **Configuration** section",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Notifications to point to **Activity** section when it's required",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "**Activity** section for the appliance which will display the logs for any",
		"type": "added",
		"module": "appliance",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Ability to provide password after mail is sent via a `password change link` in the body of the mail.",
		"type": "added",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Give the possibility to unblock a user that was automatically blocked by brute force",
		"type": "added",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "**Change your SAML configuration** rule under **SAML** category",
		"type": "added",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "URL to documentation page on some enterprise connections",
		"type": "fixed",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Use the tenant logo in the authorize consent popup",
		"type": "added",
		"module": "oauth2",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "User status [endpoint](https://auth0.com/docs/api/v2#!/User_Blocks/get_user_blocks_by_id): `GET\t/api/v2/user-blocks/{id}`, `DELETE /api/v2/user-blocks/{id}`",
		"type": "added",
		"module": "api",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "**Account Settings:** when changing from custom error page to generic error page a confirmation dialog is displayed",
		"type": "changed",
		"module": "dashboard",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Login screen to [Lock 8.1](https://auth0.com/lock)",
		"type": "changed",
		"module": "users",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Adds additional claims to `/userinfo` in OIDC strict mode. If **profile** scope was granted: `given_name`, `family_name`, `nickname`, `picture`, `gender` and `locale`. If **email** scope was granted: `email` and `email_verified`.",
		"type": "changed",
		"module": "oidc",
		"release": "5394",
		"publishedAt": "2016-01-26"
	},
	{
		"description": "Appliance administrators are now able to select a specific version of Auth0 to update from the tty0",
		"type": "added",
		"module": "appliance",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "You can create custom login domains per tenant from Dashboard",
		"type": "added",
		"module": "appliance",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "You can configure Mobile settings for iOS and Android from the **Apps** section",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "From the **General** tab within **Account Settings**, you can configure the \"Oops\" page for unhandled errors",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "**Passwordless** connections are shown in the **Third Party Apps** section",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "New switch to **enable/disable cache** for AD/LDAP connections",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "For database connections, when enabling \"Use my own database\" it automatically disables \"Import Users to Auth0\" option",
		"type": "fixed",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "Users from a custom agreement with Auth0 are able to create accounts that depends on a parent account",
		"type": "added",
		"module": "dashboard",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "For `/i/authorize` endpoint, skips user consent if the user has previously granted it",
		"type": "changed",
		"module": "api",
		"release": "4975",
		"publishedAt": "2015-12-15"
	},
	{
		"description": "New \"Oops\" page (for unhandled errors) that can be customized for your account",
		"type": "added",
		"module": "errors",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Dwolla and Shopify social connector toggles are now fixed",
		"type": "fixed",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixed issue for database connections that caused import users script to not create users when signups were disabled",
		"type": "fixed",
		"module": "users",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixed a bug when the client has RS256 as JWT alg",
		"type": "fixed",
		"module": "mfa",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fix to support changing `email` and `email_verified` for any user identity (not just the main one)",
		"type": "fixed",
		"module": "users",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Disabled query response mode for implicit authorization request. This only applies to the new pipeline for **oauth2/i/authorize**",
		"type": "changed",
		"module": "oauth2",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Users can now checkout a free plan without billing or credit card information",
		"type": "changed",
		"module": "billing",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Improved configuration navigation menu and section",
		"type": "changed",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Updated the look and feel for Google Authenticator",
		"type": "changed",
		"module": "mfa",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Revamped the UI of the Applications **Quick Start** section",
		"type": "changed",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Updated sms connection to support liquid syntax",
		"type": "changed",
		"module": "sms",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "New pricing model under the subscription section. Additionally, added the ability to create different account subscriptions on sign-up.",
		"type": "changed",
		"module": "pricing",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Return error if audience is not allowed with google access token (this only applies to native mobile use cases)",
		"type": "changed",
		"module": "social-connections:google",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "`/userinfo` accepts JWT-encoded access tokens, in addition to existing opaque access tokens",
		"type": "added",
		"module": "api",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added a new console option to display if the instance meets the minimum requirements",
		"type": "added",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added reporting memory available in addition to memory free",
		"type": "added",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added ability to refresh Health Check records in the **Configuration | Troubleshoot** tab",
		"type": "added",
		"module": "appliance",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Easier access to the built-in webtask account through a new sidebar menu",
		"type": "added",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixed dashboard admin applications list not showing for invited users",
		"type": "fixed",
		"module": "dashboard",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Added the ability to turn off credentials (password hashes) caching for AD/LDAP connections",
		"type": "added",
		"module": "users",
		"release": "4605",
		"publishedAt": "2015-11-21"
	},
	{
		"description": "Fixes to the appliance update process",
		"type": "fixed",
		"module": "on-prem",
		"release": "4341",
		"publishedAt": "2015-10-23"
	},
	{
		"description": "Added support for multi language SMS templates",
		"type": "added",
		"module": "sms",
		"release": "4323",
		"publishedAt": "2015-10-22"
	},
	{
		"description": "Added SAML signout protocol support",
		"type": "added",
		"module": "saml",
		"release": "4323",
		"publishedAt": "2015-10-22"
	},
	{
		"description": "Enabled brute force protection by default for passwordless connections and prevent opt out",
		"type": "security",
		"module": "general",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added version pick list for appliance update",
		"type": "added",
		"module": "on-prem",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Allowed administrators to disable signup for passwordless",
		"type": "added",
		"module": "general",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Display ```app_metadata.name``` or ```user_metadata.name``` on user profile when available",
		"type": "added",
		"module": "dashboard",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added ability to create diagnostics package in the **Configuration** screen > **Troubleshoot** tab for appliance",
		"type": "added",
		"module": "on-prem",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added ability to search users by ```phone_number```",
		"type": "added",
		"module": "users-search",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "API now supports changing ```phone_number```, ```phone_number_verified``` and ```verify_phone_number``` when using the PATCH Users endpoint",
		"type": "added",
		"module": "api2",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "For passwordless emails, **HTML+Liquid** is the default selected syntax",
		"type": "changed",
		"module": "database-connections",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Fixed issue when going from multitenant to single tenant",
		"type": "fixed",
		"module": "on-prem",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Improved error messages when the password expires or when the password change is required",
		"type": "changed",
		"module": "ad-connector",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Improved the Users search by email",
		"type": "fixed",
		"module": "users-search",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Updated x509 library to support Mac OS X El Capitan",
		"type": "fixed",
		"module": "certificates",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Expanded documentation on [account linking](https://auth0.com/docs/link-accounts)",
		"type": "docs",
		"module": "link-accounts",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Added new [tutorial](https://auth0.com/docs/server-apis/relay) about Relay API",
		"type": "docs",
		"module": "docs",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Clarified steps for [Google authentication for Mobile devices](https://auth0.com/docs/native-platforms/android)",
		"type": "docs",
		"module": "docs",
		"release": "4295",
		"publishedAt": "2015-10-20"
	},
	{
		"description": "Improved health check implementation to show multiple appliance nodes",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Support multi tenancy enablement in the appliance dashboard",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Add support for liquid templates for \"from\" and \"subject\" fields in user emails",
		"type": "added",
		"module": "emails",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Enable SSO and MFA session timeout configuration for appliance",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "WS-Fed protocol: add more error details in logs",
		"type": "added",
		"module": "general",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Expose clients for a session in the context object so you know which applications a user has logged into",
		"type": "added",
		"module": "sso",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "liquid support for \"Redirect To\" url",
		"type": "added",
		"module": "emails",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added ability to edit user's email address in Users screen actions",
		"type": "added",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Improved display of healthcheck information for appliance",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added support for Liquid templates to Subject and From fields in email templates.",
		"type": "added",
		"module": "emails",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added nodes tab to the appliance configuration page for better visibility.",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Dashboard log entries will now include user's IP address",
		"type": "added",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "UI to manage SSO and MFA session",
		"type": "added",
		"module": "on-prem",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added [Nginx API Quickstart](https://auth0.com/docs/server-apis/nginx).",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Improve examples of how to obtain `access_token` for account linking",
		"type": "added",
		"module": "link-accounts",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added and refactored documentation on User Profile and Tokens",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added [Falcor API documentation](https://auth0.com/docs/server-apis/falcor)",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix parameter names expected for Layer addon",
		"type": "fixed",
		"module": "apps",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Improve error handling on twitter connections",
		"type": "fixed",
		"module": "social-connections",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix validation of client IDs for connections to be less restrictive",
		"type": "fixed",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix issues with create user when an ID had been used before",
		"type": "fixed",
		"module": "api2",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix case where empty search parameter passed to User Search",
		"type": "fixed",
		"module": "users-search",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Include error information in POST of SAMLResponse  StatusCode and StatusMessage fields instead of redirect with error description in query string.",
		"type": "fixed",
		"module": "saml",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fixed issues with enterprise forms not properly updating samlp and fed metadata certs",
		"type": "fixed",
		"module": "dashboard",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fixed an issue with the `user_id` when \"import users\" option used with custom database connection.",
		"type": "fixed",
		"module": "database-connections",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fixed issue with selection of signing key for LDAP connections",
		"type": "fixed",
		"module": "ad-connector",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Fix XSS in login page with `authParams` argument.",
		"type": "security",
		"module": "login-page",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added HSTS header to HTTP responses.",
		"type": "security",
		"module": "general",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Allow a rule to be saved even if it contains an error",
		"type": "changed",
		"module": "rules",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Add support for [passwordless authentication](https://auth0.com/docs/connections/passwordless)",
		"type": "added",
		"module": "passwordless",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added documentation for [android](http://auth0.com/docs/libraries/lock-android/native-social-authentication)/[iOS](http://auth0.com/docs/libraries/lock-ios/native-social-authentication) on how to add whitelist of mobile client IDs for Google authentication for native applications",
		"type": "added",
		"module": "docs",
		"release": "4013",
		"publishedAt": "2015-09-29"
	},
	{
		"description": "Added support for Twitter's `force_login`.",
		"type": "added",
		"module": "social-connections:twitter",
		"release": "3615",
		"publishedAt": "2015-08-31"
	},
	{
		"description": "Support for the `wauth` parameter has been added.",
		"type": "added",
		"module": "wsfed",
		"release": "3615",
		"publishedAt": "2015-08-31"
	},
	{
		"description": "Added support for attribute blacklist (field `conn.options.non_persistent_attrs`). Attributes blacklisted wonâ€™t be persisted in our databases for that connection.",
		"type": "added",
		"module": "general",
		"release": "3615",
		"publishedAt": "2015-08-31"
	},
	{
		"description": "Multiple performance improvements.",
		"type": "fixed",
		"module": "api2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Fixed connection update: custom options from connections were incorrectly removed.",
		"type": "fixed",
		"module": "connections",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Fixed unhandled error validating ip range.",
		"type": "fixed",
		"module": "enterprise-connections:ip",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "`PATCH /connections/:id:` prevent changing db customization if the connection has users.",
		"type": "fixed",
		"module": "api2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Improved error descriptions.",
		"type": "fixed",
		"module": "popup",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added `context.sso.with_auth0` and `context.sso.with_dbconn` attributes (see [protocols section](https://auth0.com/docs/rules)).",
		"type": "added",
		"module": "rules",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Support jwt for google-oauth2 added to `POST /oauth/access_token`",
		"type": "added",
		"module": "social-connections:google-oauth2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added `Allowed Mobile Client IDs` setting: Enable restricting connection token audience.",
		"type": "added",
		"module": "social-connections:google-oauth2",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added [Azure AD native tutorial](https://auth0.com/docs/connections/enterprise/azure-active-directory-native).",
		"type": "added",
		"module": "docs",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "\"Use my own database\" (custom database) cannot be enabled for connections containing at least one user.",
		"type": "changed",
		"module": "database-connections",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Change password confirmation links can now only be used once.",
		"type": "changed",
		"module": "reset-password",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "Added [Liquid](https://github.com/Shopify/liquid/wiki/Liquid-for-Designers) templating support.",
		"type": "fixed",
		"module": "emails",
		"release": "3601",
		"publishedAt": "2015-08-28"
	},
	{
		"description": "SSO between different database connections is now forbidden.",
		"type": "fixed",
		"module": "sso",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "When duplicate `name` or `client_id` occurs patching a connection status code 409 is now returned.",
		"type": "fixed",
		"module": "api2",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Fixed AD/LDAP Connector status not being displayed.",
		"type": "fixed",
		"module": "ad-ldap-connector",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added support for [Untappd](https://untappd.com/) as a social connection.",
		"type": "added",
		"module": "social-connections",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added `enabled_clients` field to PATCH connections responses",
		"type": "added",
		"module": "api2",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added logic to prevent syntax errors in rules and database connection scripts",
		"type": "fixed",
		"module": "rules",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Improved error messages when changing password and deleting users of custom connections.",
		"type": "added",
		"module": "api2",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added support for predefined `authParams` and `authParamsMap` parameters.",
		"type": "added",
		"module": "custom-oauth",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added `lastUsedUserID` to `/user/ssodata` response",
		"type": "added",
		"module": "sso",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Improved connection error handling",
		"type": "added",
		"module": "social-connections:facebook",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added `delete user` log events",
		"type": "added",
		"module": "logs",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added debug button to custom database connections.",
		"type": "added",
		"module": "database-connections",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Added [Office 365 provisioning doc](https://auth0.com/docs/integrations/office-365-custom-provisioning)",
		"type": "added",
		"module": "docs",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "Reading/writing signing keys is no longer allowed.",
		"type": "changed",
		"module": "keys",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "[appliance] Added timeout setting to the Auth0 Dashboard browser session. ![session timeout](https://cloud.githubusercontent.com/assets/178506/9208225/ad47e088-4048-11e5-8ae5-dea383f0fb9a.png)",
		"type": "added",
		"module": "configuration",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "[appliance] Improved the Auth0 Update UI. Added release notes of the version being downloaded (Online Update only). Added update events to Logs.",
		"type": "added",
		"module": "configuration",
		"release": "3454",
		"publishedAt": "2015-08-14"
	},
	{
		"description": "`POST /api/connections` now returns `enabled_clients` field in the response body.",
		"type": "fixed",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Linked users are now taken into account when calculating stats.",
		"type": "fixed",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Performance improvements for database logins.",
		"type": "fixed",
		"module": "general",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Removed `given_name`, `family_name`, `name`, `nickname` and `picture` properties from `POST /users`. Extra fields in the root user object are not longer allowed.",
		"type": "changed",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Fixed unlinking users with the following ID format: `{provider}|{connection}|{id}`.",
		"type": "fixed",
		"module": "unlink",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Added support for encrypted configuration to connections.",
		"type": "added",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Differentiate errors from sandbox from user's script errors.",
		"type": "added",
		"module": "rules",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Added documentation of tabs in [AD/LDAP Connector Admin Console](https://auth0.com/docs/connector/modify)",
		"type": "added",
		"module": "docs",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Documented [new events of Auth0 Lock](https://auth0.com/docs/libraries/lock/events)",
		"type": "added",
		"module": "docs",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Added support for JWT access tokens issued from Auth0 OAuth 2.0 endpoints",
		"type": "added",
		"module": "api2",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Replaced reset password bewits with tickets.",
		"type": "changed",
		"module": "reset-password",
		"release": "3258",
		"publishedAt": "2015-07-24"
	},
	{
		"description": "Deleting an user now returns 204 HTTP status code.",
		"type": "changed",
		"module": "api2",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Using azp to retrieve client info for POST users request.",
		"type": "changed",
		"module": "api2",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Auth0 bewits are now encrypted",
		"type": "security",
		"module": "reset-password",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added `PATCH /username`",
		"type": "added",
		"module": "api2",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added logs for `warnings during login`.",
		"type": "added",
		"module": "logs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added `api_limit` logs.",
		"type": "added",
		"module": "logs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Documented [Client certificates support in the AD/LDAP Connector](https://auth0.com/docs/connector/client-certificates)",
		"type": "added",
		"module": "ad-connector",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added `limit_ui` (limit on userinfo) logs.",
		"type": "added",
		"module": "logs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Improved docs for [Ember.js](https://auth0.com/docs/client-platforms/emberjs)",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Updated [SharePoint support](https://auth0.com/docs/integrations/sharepoint)",
		"type": "added",
		"module": "sharepoint",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Updated [custom signup (using API2)](https://auth0.com/docs/custom-signup)",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Updated [Ruby on Rails API Tutorial](https://auth0.com/docs/server-apis/rails) to use Knock gem",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Documented [nodes available in the Auth0 appliance](https://auth0.com/docs/appliance/modules)",
		"type": "added",
		"module": "docs",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Improved error and log reporting.",
		"type": "fixed",
		"module": "errors",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Multiple performance improvements",
		"type": "fixed",
		"module": "general",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Fixed wildcards in subdomains on popup mode",
		"type": "fixed",
		"module": "popup",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Fixed impersonation flow to include all identity-specific fields",
		"type": "fixed",
		"module": "impersonate",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "[rules] Improved error handling of rules errors during login.",
		"type": "fixed",
		"module": "login",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Patched against SSL _Alternate Chains Certificate Forgery_ vulnerability.",
		"type": "security",
		"module": "security",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Explicitly fail when using JWTs on Headers that are more than 512 bytes long (applies to every endpoint except `/ro`).",
		"type": "changed",
		"module": "general",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added rate limiting (and account blocking) for the `/ro` and the `/userinfo` endpoint",
		"type": "added",
		"module": "limitd",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added debugging capabilities for rules",
		"type": "added",
		"module": "rules",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added support for [passwordless connections](https://auth0.com/docs/connections/passwordless)",
		"type": "added",
		"module": "passwordless",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Added payment history and payment information",
		"type": "added",
		"module": "general",
		"release": "3191",
		"publishedAt": "2015-07-17"
	},
	{
		"description": "Don't allow changing password and email or email_verified in same request",
		"type": "changed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Set username for connection without `requires_username` is now prevented",
		"type": "changed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Removing personal info fields from user patch",
		"type": "changed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed utf8 encoding issues",
		"type": "fixed",
		"module": "login-page",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed sort by connection when searching users",
		"type": "fixed",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed link account when \"sso with auth0\" is enabled",
		"type": "fixed",
		"module": "account-linking",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Added support for `last_password_reset` field.",
		"type": "added",
		"module": "import-users",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Added Connector article: [Creating a Test Active Directory Domain Controller](https://auth0.com/docs/connector/test-dc)",
		"type": "added",
		"module": "docs",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Improved search user experience",
		"type": "added",
		"module": "search",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Added information on [signing/encryption and IDP-initiated SSO](https://auth0.com/docs/saml-configuration#9)",
		"type": "added",
		"module": "saml",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed Logjam vulnerability",
		"type": "security",
		"module": "security",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Fixed out-of-band write in utf8 decoder (v8 vulnerability)",
		"type": "security",
		"module": "api2",
		"release": "3081",
		"publishedAt": "2015-07-06"
	},
	{
		"description": "Improved user search indexing.",
		"type": "fixed",
		"module": "users-search",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Fixed IE issues by Added P3P headers.",
		"type": "fixed",
		"module": "general",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Improved error messages when editing rules and deleting users.",
		"type": "fixed",
		"module": "rules",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Fixed tenant dropdown menu. (accounts with more than 10 tenants were not displayed correctly).",
		"type": "fixed",
		"module": "tenants",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "[performance] Improved UI performance by fetching resources from CDN.",
		"type": "fixed",
		"module": "dashboard",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Performance improvements for Auth0 connections.",
		"type": "fixed",
		"module": "database-connections",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added schema info for add-ons: *Layer*, *AD RMS*, *MS CRM*, *Slack*.",
		"type": "added",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added `updated_at` property to users.",
		"type": "added",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Updated rule templates.",
		"type": "added",
		"module": "dashboard",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added delete script to custom database connections.",
		"type": "added",
		"module": "database-connections",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added [documentation](https://auth0.com/docs/saml/identity-providers/salesforce) for SalesForce as IDP.",
		"type": "added",
		"module": "docs",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Multifactor Authentication now is featured in a [separate section](https://manage.auth0.com/#/multifactor).",
		"type": "changed",
		"module": "mfa",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added [disable animations](https://auth0.com/docs/libraries/lock/ui-customization#2) in Lock section.",
		"type": "added",
		"module": "docs",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "`GET /users` methods now use `include_fields` instead of `exclude_fields`.",
		"type": "changed",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Jobs when completed successfully return 200 HTTP status code.",
		"type": "changed",
		"module": "api2",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Tenant names are now limited to 64 characters.",
		"type": "changed",
		"module": "general",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Fixed multiple issues with samlp logout. (`nameid` has value only, no attribs)",
		"type": "fixed",
		"module": "samlp",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Updated [Auth0 Android documentation](https://auth0.com/docs/libraries/lock-android).",
		"type": "added",
		"module": "docs",
		"release": "2921",
		"publishedAt": "2015-06-18"
	},
	{
		"description": "Added error codes for every API v2 error.",
		"type": "added",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Fixed: Failure to delete an user from auth0 Database Connection resulted in a 500 HTTP Stauts code.",
		"type": "fixed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "AD Connector: Added [admin dashboard section](https://auth0.com/docs/connector).",
		"type": "added",
		"module": "docs",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Changed `exclude_fields` to `include_fields` for `GET /client` endpoints.",
		"type": "changed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Positive assertions to read/write clients `jwtConfiguration.secretNotEncoded` and `custom_login_page_off`.",
		"type": "changed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "`POST /identity` takes connection_id not connection.",
		"type": "changed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "If email is PATCHed to the same value, and email_verified is not set then email_verified is taken from previous value.",
		"type": "fixed",
		"module": "api2",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "When creating an user, a custom made avatar with the initials is used if there is no gravatar picture associated with the email.",
		"type": "added",
		"module": "manage",
		"release": "2783",
		"publishedAt": "2015-05-29"
	},
	{
		"description": "Added error codes for endpoint logic.",
		"type": "added",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Updated iOS, Swift and Objective C [mobile documentation](https://auth0.com/docs).",
		"type": "fixed",
		"module": "docs",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Updated login page template (solves CORS issues). Added polyfills for IE8/9.",
		"type": "fixed",
		"module": "login-page",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Improved SAMLP logout and added a samlp logout callback: use `client.addons.samlp.logout.callback` to set the HTTP POST url.",
		"type": "added",
		"module": "samlp",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Updated the Auth0 Lock version appliance uses to 7.5",
		"type": "added",
		"module": "lock",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Added Layer as an app addon",
		"type": "added",
		"module": "addons",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Now Auth0 API returns and accepts rules in the order they are applied.",
		"type": "changed",
		"module": "rules",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Property `options.scripts.fetchUserProfile` is now mandatory for oauth1/2 connections",
		"type": "changed",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Setting `signing_keys` client property can only be done on global clients.",
		"type": "changed",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "User POST or PATCH of email/password is no longer allowed for disabled connections.",
		"type": "changed",
		"module": "api2",
		"release": "2666",
		"publishedAt": "2015-05-22"
	},
	{
		"description": "Added to Auth0.js docs [CORS section](https://auth0.com/docs/auth0js#16)",
		"type": "added",
		"module": "docs",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added all clients to SSO cookie",
		"type": "added",
		"module": "sso",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added [`POST /api/v2/device-credentials`](https://auth0.com/docs/apiv2#!/Device_Credentials/get_device_credentials) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added support to change connection names.",
		"type": "added",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Custom OAuth2 Examples: Added [Twitch IdP documentation](https://auth0.com/docs/oauth2-examples#6).",
		"type": "added",
		"module": "oauth2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Added docs about [CMS integrations](https://auth0.com/docs/cms): Joomla and Wordpress docs.",
		"type": "added",
		"module": "docs",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Response Status Codes: Changed `400`: `already exists` to `409`.",
		"type": "changed",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Changed devices endpoints to device-credentials",
		"type": "changed",
		"module": "api2",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Fixing XSS by introducing `@@config@@` replacement.   If you are using the default login page, you are not affected by this vulnerability and there is no action required on your behalf. Note: **The previous way of substituting variables in custom login pages will be deprecated by June 8th**. For more information contact us at [open a support ticket](https://support.auth0.com).",
		"type": "security",
		"module": "login-page",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Do not require state field when country does not have.",
		"type": "fixed",
		"module": "billing",
		"release": "2616",
		"publishedAt": "2015-05-15"
	},
	{
		"description": "Ask for connection id instead of name in users bulk import",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Improved log details",
		"type": "added",
		"module": "logs",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added section about [validating tokens to protocols](https://auth0.com/docs/protocols)",
		"type": "added",
		"module": "docs",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Fix log detail description which was shown as `[object Object]`.",
		"type": "fixed",
		"module": "logs",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Moved tickets endpoints to root from `/users/{id}/tickets/{type}` to `/tickets/{type}`",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "v2 ids are now limited to 16 alphanumeric characters.",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Now OpenID Connect is used by default (before it was WsFed)",
		"type": "changed",
		"module": "waad",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added `user_tickets` scope",
		"type": "changed",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added `POST /api/v2/jobs/verification-email` endpoint to send emails to users so they verify their email accounts by clicking a link",
		"type": "added",
		"module": "api2",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added logout for custom oauth1 and oauth2 strategies",
		"type": "added",
		"module": "custom-oauth",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Added UI to select protocol (wsfed vs. oidc) for Azure AD connections",
		"type": "added",
		"module": "waad",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Add ability to override client id and client secret for Window Azure AD connections.",
		"type": "added",
		"module": "waad",
		"release": "2562",
		"publishedAt": "2015-05-08"
	},
	{
		"description": "Support for email verification and password change ticket. Added [`POST api/v2/users/{id}/tickets/email_verification`](https://auth0.com/docs/apiv2#!/users/post_email_verification) and [`POST api/v2/users/{id}/tickets/password_change`](https://auth0.com/docs/apiv2#!/users/post_password_change) endpoint for email verification and password change.",
		"type": "added",
		"module": "api2",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Fixed when creating a _New Rule_ it can be saved without editing it.",
		"type": "fixed",
		"module": "rules",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Fixed dashboard stuck when trying to access to a deleted app.",
		"type": "fixed",
		"module": "apps",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added SAML metadata URL in advanced settings.",
		"type": "fixed",
		"module": "saml",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Disabled toggle and show notice for importing users to Auth0 when custom database is not enabled.",
		"type": "fixed",
		"module": "db-connections",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Preventing saving metadata on invalid json.",
		"type": "fixed",
		"module": "user-metadata",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Fixed Users > New User dialog not showing on IE10.",
		"type": "fixed",
		"module": "users",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added warning when attempting to overwrite a secure key/value pair.",
		"type": "changed",
		"module": "rules",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Logs are no longer displayed exclusively to owners.",
		"type": "changed",
		"module": "logs",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Users without names or emails were not editable.",
		"type": "fixed",
		"module": "users",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added field `conn.options.decryptionKey`.",
		"type": "added",
		"module": "samlp",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Added _redirect to_ and _url lifetime_ for blocked account emails.",
		"type": "added",
		"module": "emails",
		"release": "2516",
		"publishedAt": "2015-05-01"
	},
	{
		"description": "Improved allowed callback URL validations.",
		"type": "fixed",
		"module": "manage",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Fixed pagination issues on `users` section.  .",
		"type": "fixed",
		"module": "users",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Added [devices endpoints](https://auth0.com/docs/apiv2#!/users/get_devices).",
		"type": "added",
		"module": "api2",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Updated Auth0-laravel to be compatible with Laravel 5 docs: For more information check the [docs](https://auth0.com/docs/server-platforms/laravel) or the [tutorial](https://auth0.com/docs/server-apis/php-laravel).",
		"type": "added",
		"module": "docs",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Added [SAML provisioning](https://auth0.com/docs/saml-configuration#10) section.",
		"type": "added",
		"module": "docs",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Added [Email Providers](https://auth0.com/docs/email/providers) dashboard.",
		"type": "added",
		"module": "email-providers",
		"release": "2479",
		"publishedAt": "2015-04-25"
	},
	{
		"description": "Revamped User Metadata section.",
		"type": "added",
		"module": "dashboard",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added [React Native iOS tutorial](https://auth0.com/docs/native-platforms/ios-reactnative).",
		"type": "added",
		"module": "docs",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added [article](https://auth0.com/docs/metadata-in-rules) that explains how to work with user metadata in Rules.",
		"type": "added",
		"module": "docs",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Updated email section to include: [Blocked Account Email](https://auth0.com/docs/email#12) and [URL Lifetime](https://auth0.com/docs/email#7)",
		"type": "added",
		"module": "docs",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added \"device_id\" to refresh tokens",
		"type": "added",
		"module": "refresh-token",
		"release": "2425",
		"publishedAt": "2015-04-18"
	},
	{
		"description": "Added multi-region support in tenant creation: Users can choose where their Auth0 accounts will be running (Current regions supported: *Europe Central* and *US West*).",
		"type": "added",
		"module": "general",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added [master list of SAML apps Auth0 supports and their config](https://auth0.com/docs/saml-apps)",
		"type": "added",
		"module": "docs",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added TTL to emails sent by Auth0",
		"type": "added",
		"module": "emails",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Fixed certificate upload errors in SAMLP Connections",
		"type": "fixed",
		"module": "samlp",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added troubleshooting script to AD Connector ([docs](https://auth0.com/docs/connector/troubleshooting))",
		"type": "added",
		"module": "ad-connector",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added [explanation of SAML roles and generic instructions for SAML configuration](https://auth0.com/docs/saml-configuration)",
		"type": "added",
		"module": "saml",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added an easier way to search users in Auth0 ([docs](https://auth0.com/docs/users-search))",
		"type": "added",
		"module": "search",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added linking and unlinking of identities: [`POST /api/v2/users/{id}/identities`](https://auth0.com/docs/apiv2#!/users/post_identities) and [`DELETE /api/v2/users/{id}/identities/{provider}/{user_id}`](https://auth0.com/docs/apiv2#!/users/delete_provider_by_user_id) endpoints",
		"type": "added",
		"module": "api2",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Fixed: Invited users were not able to see custom database rules",
		"type": "fixed",
		"module": "dashboard",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Email for social users cannot be updated",
		"type": "changed",
		"module": "api2",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Fixed security issue with path browsing when downloading sample projects from docs.",
		"type": "security",
		"module": "docs",
		"release": "2359",
		"publishedAt": "2015-04-10"
	},
	{
		"description": "Added docs on [deployment models](https://auth0.com/docs/deployment)",
		"type": "added",
		"module": "docs",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "API Explorer for v2 [redesigned](https://docs.auth0.com/apiv2)",
		"type": "added",
		"module": "api2",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added [APIv2 /logout endpoint](https://auth0.com/docs/logout)",
		"type": "added",
		"module": "logout",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added Certificate Rollover: Auth0 detects when certificates expire on IdPs. When that happens, we automatically update the certificates or, if that is not possible, we send an email to the tenant owners to make manually the change.",
		"type": "added",
		"module": "certificates",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added documentation on [Email templates](https://auth0.com/docs/email), [Custom Email Flows](https://auth0.com/docs/email/custom) and [Using custom email providers](https://auth0.com/docs/email/providers)",
		"type": "added",
		"module": "docs",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added the ability to configure links TTL from email template",
		"type": "added",
		"module": "email",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Credentials are no longer removed when linking a profile",
		"type": "fixed",
		"module": "link-accounts",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added flag to block accounts after a great number of failed attempts. The email \"account blocked\" email can be configured.",
		"type": "added",
		"module": "database-connections",
		"release": "2274",
		"publishedAt": "2015-04-03"
	},
	{
		"description": "Added example of how to use custom OAuth2 strategy with [imgur](https://auth0.com/docs/oauth2-examples#4)",
		"type": "added",
		"module": "docs",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Allow SAML `RelayState` parameter",
		"type": "added",
		"module": "samlp",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Added tabs for enabling/disabling a social-connection in app.",
		"type": "added",
		"module": "dashboard",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Fixed confirm leaving edit user when the details are saved.",
		"type": "fixed",
		"module": "dashboard",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Fixed email validation issue for emails with _",
		"type": "fixed",
		"module": "import",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Added ability to sign SAML requests",
		"type": "added",
		"module": "samlp-connections",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "[api2] Custom Email Provider (Added [GET, POST, PATCH, DELETE /api/v2/emails/provider API2 endpoints](https://auth0.com/docs/apiv2#!/emails)):",
		"type": "added",
		"module": "emails",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Auth0's [European Instance](https://manage.auth0.com/login) is now available",
		"type": "added",
		"module": "general",
		"release": "2223",
		"publishedAt": "2015-03-27"
	},
	{
		"description": "Added [password policy section](https://auth0.com/docs/custom-signup#5) to custom signup documentation",
		"type": "added",
		"module": "docs",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Added [How to setup DigitalOcean as a custom OAuth2 connection](https://auth0.com/docs/oauth2-examples#3)",
		"type": "added",
		"module": "docs",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Error handling improvements",
		"type": "fixed",
		"module": "salesforce",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Custom database invalid script broke UI.",
		"type": "fixed",
		"module": "database-connection",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Rejecting invalid emails in PUT /api/users/email",
		"type": "fixed",
		"module": "email",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Remove sms users for connection when connection is deleted",
		"type": "fixed",
		"module": "sms",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Fixed issue with redirect when response_type is token",
		"type": "fixed",
		"module": "general",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Remove sms users when removing tenant",
		"type": "fixed",
		"module": "sms",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Fixing XSS in `internalOptions` field.",
		"type": "security",
		"module": "custom-login-page",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Images are no longer inlined when emails are sent",
		"type": "changed",
		"module": "email",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "New forbidden metadata fields: `user_metadata` and `app_metadata`",
		"type": "changed",
		"module": "metadata",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Added [React.js tutorial](https://auth0.com/docs/client-platforms/react)",
		"type": "added",
		"module": "docs",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Multiple Shopify fixes.",
		"type": "fixed",
		"module": "shopify",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Custom DB script timeout error are now visible.",
		"type": "fixed",
		"module": "database-connection",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Update S3 file when deleting or changing connections",
		"type": "fixed",
		"module": "api2",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Updated components to use jsonwebtoken to 4.2.0",
		"type": "security",
		"module": "general",
		"release": "2190",
		"publishedAt": "2015-03-20"
	},
	{
		"description": "Limitd in api v2",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`DELETE /api/v2/rules/{id}`](https://auth0.com/docs/apiv2#!/rules/delete_rules_by_id)",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [Kerberos support documentation](https://auth0.com/docs/connector/kerberos)",
		"type": "added",
		"module": "docs",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added option to re-send a verification e-mail to an user.",
		"type": "added",
		"module": "verification-email",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Performance: reduced number of requests to load connections.",
		"type": "fixed",
		"module": "dashboard",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Fixed page broken when submiting ADFS forms with an invalid file as cerificate",
		"type": "fixed",
		"module": "adfs",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Linkedin emails were always verified",
		"type": "changed",
		"module": "linkedin",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`GET api/v2/rules`](https://auth0.com/docs/apiv2#!/rules/get_rules) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`GET rules/{id}`](https://auth0.com/docs/apiv2#!/rules/get_rules_by_id) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`POST /api/v2/rules`](https://auth0.com/docs/apiv2#!/rules/post_rules) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Added [`PATCH /api/v2/rules/{id}`](https://auth0.com/docs/apiv2#!/rules/patch_rules_by_id) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Fixed issue that caused creation of users in connections that require username to fail (Added max length for connection name)",
		"type": "fixed",
		"module": "api2",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Fixed issue with Lock Auth0 badge footer not being hidden on paid accounts.",
		"type": "fixed",
		"module": "pricing",
		"release": "2150",
		"publishedAt": "2015-03-13"
	},
	{
		"description": "Users search implemented: [`GET /api/v2/users`](https://auth0.com/docs/apiv2#!/users/get_users).",
		"type": "added",
		"module": "api2",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Updated [documentation](https://auth0.com/docs/protocols) for WS-Fed endpoint",
		"type": "added",
		"module": "docs",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed missing clientID on WS-Fed endpoint",
		"type": "fixed",
		"module": "wsfed",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fix for Firefox switchboard checkboxes in [Social Connections](https://manage.auth0.com/#/connections/social)",
		"type": "fixed",
		"module": "social-connections",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Added [`PATCH connections/{id}`](https://auth0.com/docs/apiv2#!/users/patch_users_by_id) endpoint",
		"type": "added",
		"module": "api2",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Added [Office 365 integration docs](https://auth0.com/docs/integrations/office-365)",
		"type": "added",
		"module": "docs",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Added documentation for *[Rules source control using Github](https://auth0.com/docs/rules#8)*",
		"type": "added",
		"module": "rules",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Auth0 Proxy Updater: Operating System updates for intranet systems with no internet connection ([docs](https://auth0.com/docs/appliance/proxy-updater)).",
		"type": "added",
		"module": "on-prem",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed [`DELETE /users`](https://auth0.com/docs/apiv2#!/users/delete_users) query performance",
		"type": "fixed",
		"module": "performance",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed html entities escaping on reset and verify email endpoints when `tenant` or `clientID` were not found.",
		"type": "fixed",
		"module": "error-reporting",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Changed to use Open ID Connect instead of oauth2",
		"type": "changed",
		"module": "waad",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Updated Lock versions in docs and dashboard",
		"type": "changed",
		"module": "dashboard",
		"release": "2086",
		"publishedAt": "2015-03-06"
	},
	{
		"description": "Fixed broken Twilio doc link",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed impersonated users flag",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed sap addon settings",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed signedUp check",
		"type": "fixed",
		"module": "dashboard",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "When calling /api/v2/clients the callback field was not returned",
		"type": "fixed",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Removes SSLv3 support",
		"type": "security",
		"module": "general",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Use only global client for find user queries",
		"type": "fixed",
		"module": "api",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed [`PUT /users`](https://auth0.com/docs/api#!#put--api-users--user_id--metadata) when payload does not have any properties",
		"type": "fixed",
		"module": "api",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Fixed pricing v3 cases",
		"type": "fixed",
		"module": "pricing",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added [`GET /connections`](https://auth0.com/docs/apiv2#!/connections/get_connections)",
		"type": "added",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added generic Oauth1 strategy ([docs](https://auth0.com/docs/oauth1))",
		"type": "added",
		"module": "oauth1",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added [`DELETE /connections/{id}`](https://auth0.com/docs/apiv2#!/connections/delete_connections_by_id)",
		"type": "added",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added [`POST /connections`](https://auth0.com/docs/apiv2#!/connections/post_connections)",
		"type": "added",
		"module": "api2",
		"release": "2051",
		"publishedAt": "2015-02-28"
	},
	{
		"description": "Added logging for success signups for non-database connections",
		"type": "added",
		"module": "logs",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Error messages are now displayed correctly on fail",
		"type": "fixed",
		"module": "rules",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Small fixes",
		"type": "fixed",
		"module": "billing",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Fixed: Navigating to different connections and then changing the switch for one of them changes it for all the ones visited.",
		"type": "fixed",
		"module": "database-connections",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "API Call [`PATCH /api/v2/users`](https://auth0.com/docs/apiv2#!/users/patch_users_by_id) now returns updated user.",
		"type": "changed",
		"module": "api2",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Allow `whr` (Windows Home Realm) in the authParams",
		"type": "changed",
		"module": "waad",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Added wreply to Azure Active Directory connection",
		"type": "changed",
		"module": "waad",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Login page parameters were only replaced on their first occurence. For instance if the login page contained: `@@auth0Domain@@ @@auth0Domain@@` only the first placeholder was replaced: `auth0.com @@auth0Domain@@`.",
		"type": "fixed",
		"module": "login-page",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "In some conditions, [`DELETE /api/users/{user_id}`](https://auth0.com/docs/api#!#delete--api-users) was not removing the user correctly  .",
		"type": "fixed",
		"module": "api",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Parameter `samlpOptions` is now required to be a valid JSON object.",
		"type": "changed",
		"module": "samlp",
		"release": "1999",
		"publishedAt": "2015-02-20"
	},
	{
		"description": "Added geoip property to default context object (without a geoip property, some rules may breaks, for instance: https://github.com/auth0/rules/blob/master/rules/add-country.md)",
		"type": "fixed",
		"module": "rules",
		"release": "1999",
		"publishedAt": "2015-02-20"
	}
];

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports = [
	{
		"description": "Removed <code>client.resource_servers</code> from documented sample response.",
		"old": false,
		"type": "Changed",
		"module": "Management API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2017-05-29"
	},
	{
		"description": "<ul><li>Added support to query by identifier on <code>PATCH / GET / DELETE api/v2/resource-servers</code> endpoints.</li><li>Added pagination to <code>GET api/v2/clients</code> endpoint.</li></ul>",
		"old": false,
		"type": "Added",
		"module": "Management API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2017-05-29"
	},
	{
		"description": "<ul><li>Officially dropped support for Microsoft’s Internet Explorer 10.</li><li>Fixed issue in the APIs section’s Test tab: changing languages in the code viewers now change the language properly.</li><li>Fixed visual issue with code editors backgrounds in the User Details section when using Chrome in Windows 10.</li><li>Fixed overflowing of text when users have huge strings without spaces or breaks in their External Attributes Object.</li><li>Fixed issue with Delete Account prompt showing a default domain name instead of the correct domain for that account.</li><li>Fixed issue with positioning for SAML connections list pagination controls.</li><li>Fixed issue when uploading custom logo in Tenant Settings section would crash the browser.</li><li>Fixed issue with users with special characters in their IDs that could not be seen in the dashboard.</li><li>Improved UI for User Identities in User Details: replaced the old JSON viewer for a better-looking code editor.</li><li>Fixed SAMLP default mappings example to avoid getting parsing errors by default.</li><li>Now the API section is displayed by default.</li></ul>",
		"old": false,
		"type": "fixed",
		"module": "Management Dashboard",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-05-11"
	},
	{
		"description": "<p>New connection for PayPal Sandbox applications, it can be found in <a href='https://manage.auth0.com/#/connections/social'>Social Connections in dashboard</a></p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2017-05-09"
	},
	{
		"description": "<p>Server-side resource-owner password flows that use brute-force detection can now prevent erroneous blocking scenarios by utilizing the 'auth0-forwarded-for' header. See the <a href='https://auth0.com/docs/api-auth/tutorials/using-resource-owner-password-from-server-side'>documentation</a> for more details.</p>",
		"old": false,
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2017-04-12"
	},
	{
		"description": "<ul><li>Fixed outdated link in Sharepoint SSO Integration tutorial page.</li><li>Improved error message in the <a href='https://manage.auth0.com/#/emails'>Email Templates section</a> when the <code>from</code> field is not properly filled.</li><li>Fixed UI for form validations so they don’t linger after a successful submission of the form.</li><li>Added <code>read:user_idp_tokens</code> to available scopes for the <a href='https://manage.auth0.com/#/apis/management/scopes'>Management API</a>.</li></ul>",
		"old": false,
		"type": "fixed",
		"module": "Management Dashboard",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-04-05"
	},
	{
		"description": "<p>Rules will now run when calling <code>oauth/token</code> with <code>grant_type: password</code> or <code>grant_type: refresh_token</code>. For more information, check out <a href='https://auth0.com/docs/migrations#password-and-refresh-token-exchange-rules-migration-notice'>our documentation</a>.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"samuel.judson@auth0.com"
		],
		"publishedAt": "2017-02-23"
	},
	{
		"description": "<p><code>user.last_password_reset</code> will now be set immediately when the user changes their password, instead of waiting for the next login.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"german@auth0.com"
		],
		"publishedAt": "2017-03-14"
	},
	{
		"description": "<p>Added support for <code>read:user</code> scope when using Github social connections</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2017-03-08"
	},
	{
		"description": "<p>Added multifactor authentication capabilities to the oauth/token endpoint. See the <a href='https://auth0.com/docs/api-auth/tutorials/multifactor-resource-owner-password'>documentation</a> for more details.</p>",
		"old": false,
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"team": [
			"damian.fortuna@auth0.com",
			"jose.luis.diaz@auth0.com",
			"fredrik.liljegren@auth0.com"
		],
		"publishedAt": "2017-04-05"
	},
	{
		"description": "<ul><li>Added functionality to filter-as-you-type the tenant list in the tenant dropdown for tenant lists with more than 10 tenants in them.</li><li>Updated UI for the &lt;app_metadata&gt; and &lt;user_metadata&gt; properties, in the User Details section, to feature a full-featured editor with code folding.</li><li>Renamed the “Setup” button in SAMLP connections list to “Setup Instructions”.</li><li>Fixed a series of issues with dashboard invitees:<ul><li>Prevent non-owners from entering the “create SSO Integrations” route.</li><li>Prevent non-owners from entering the Logs section.</li><li>Prevent non-owners from entering the account sub-sections (Admins, Payment, etc.).</li></ul></li><li>Updated UI for Dashboard Admins to fix XSS vulnerability when deleting dashboard admins and relocated the row to add an admin to always be on top of the list to avoid scrolling in long lists.</li><li>Updated UI for User Details to account for long &lt;name&gt; and &lt;username&gt; properties by truncating them.</li><li>Added the possibility to save Sharepoint SSO Integrations &lt;external URLs&gt; as a comma-separated list to set multiple of them.</li></ul>",
		"old": false,
		"type": "fixed",
		"module": "Management Dashboard",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-03-10"
	},
	{
		"description": "<p>Updated the UI for the <a href='https://manage.auth0.com/#/apis/management/explorer'>API Explorer tab</a> to be able to configure the token expiration for the Management API.</p>",
		"old": false,
		"type": "added",
		"module": "Management API",
		"exclusive": "cloud",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-02-25"
	},
	{
		"description": "<p>Added a new property <description> for Clients, a free-text field to describe the client’s purpose.</p>",
		"old": false,
		"type": "added",
		"module": "Clients",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-02-22"
	},
	{
		"description": "<p>Guardian Authenticator for Android is now capable of scanning and managing any generic TOTP key.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"nicolas.ulrich@auth0.com"
		],
		"publishedAt": "2017-02-22"
	},
	{
		"description": "<p>Released new <a href='https://github.com/auth0/Lock.swift'>Lock for iOS</a> version written in Swift and <a href='https://github.com/auth0/Lock.swift/blob/master/MIGRATION.md'>migration guide</a> to help the transition.</p>",
		"old": false,
		"type": "added",
		"module": "SDKs",
		"exclusive": "",
		"team": [
			"hernan@auth0.com",
			"martin.walsh@auth0.com"
		],
		"publishedAt": "2017-02-16"
	},
	{
		"description": "<p>Added enhancements to SAML Single Logout to conform to the Single Logout Profile specification. With these enhancements, all SAML Service Providers you have configured for logout will be sent a <code>LogoutRequest</code> to the <code>logout.callback</code> URL you have configured in the SAML Add-on. If your Service Provider does not support Single Logout, you can set <code>logout.slo_enabled: false</code> in your SAML Add-on configuration. For more information, check out our <a href='https://auth0.com/docs/logout#saml-logout'>Logout documentation</a> and <a href='https://auth0.com/docs/protocols/saml/saml-configuration#logout'>SAML configuration documentation</a>.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"hernan.tierno@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "<p>Published <a href='https://github.com/auth0/auth0.js/releases/tag/v8.0.0'>auth0.js v8</a> and <a href='https://auth0.com/docs/libraries/auth0js/migration-guide'>migration guide</a> to help the transition.</p>",
		"old": false,
		"type": "added",
		"module": "SDKs",
		"exclusive": "",
		"team": [
			"german@auth0.com",
			"hernan@auth0.com"
		],
		"publishedAt": "2017-01-03"
	},
	{
		"description": "<p>Consolidated brute-force detection into a single Shield.</p>",
		"old": false,
		"type": "changed",
		"module": "Anomaly Detection",
		"exclusive": "cloud",
		"team": [
			"jose.luis.diaz@auth0.com"
		],
		"publishedAt": "2016-12-26"
	},
	{
		"description": "<p>Added client flag to disable SSO (<code>sso_disabled</code>) which can be set using the Management API. When this flag is set to <code>true</code>, an Auth0 session will not be created for any authentication using that client.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"hernan.tierno@auth0.com",
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-12-02"
	},
	{
		"description": "<p>It is now possible to pre-enroll users into Guardian via an enrollment email. See <a href='https://auth0.com/docs/multifactor-authentication/administrator/guardian-enrollment-email'>here</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"jose.luis.diaz@auth0.com"
		],
		"publishedAt": "2016-12-02"
	},
	{
		"description": "<p>Published new mobile SDKs for iOS (<a href='https://github.com/auth0/Guardian.swift'>Guardian.swift</a>) and Android (<a href='https://github.com/auth0/Guardian.Android'>Guardian.Android</a>) to make it simple to build custom Guardian mobile applications.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"nicolas.ulrich@auth0.com",
			"hernan@auth0.com"
		],
		"publishedAt": "2016-11-25"
	},
	{
		"description": "<p>nonce parameter is now mandatory if you are using implicit grant flow</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"samuel.judson@auth0.com"
		],
		"publishedAt": "2016-11-18"
	},
	{
		"description": "<p>Added <code>expires_in</code> to oauth/token endpoint</p>",
		"old": false,
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-12-01"
	},
	{
		"description": "<p>Upgraded Auth0 hosted login page to Lock 10.7.</p>",
		"old": false,
		"type": "changed",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"iaco@auth0.com"
		],
		"publishedAt": "2016-12-01"
	},
	{
		"description": "<p>Double quotes in assertions caused invalid SAML signature.</p>",
		"old": false,
		"type": "fixed",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-10-26"
	},
	{
		"description": "<p>Verification email does not display given_name attribute for custom DB.</p>",
		"old": false,
		"type": "fixed",
		"module": "Connections",
		"exclusive": "",
		"team": [
			"eduardo.diaz@auth0.com",
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-10-24"
	},
	{
		"description": "<p>Released new version of Lock for Web with several bugfixes and improvements including support for custom OAuth2 connections. See <a href='https://github.com/auth0/lock/blob/master/CHANGELOG.md'>Lock's changelog</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "Lock",
		"exclusive": "",
		"team": [
			"german@auth0.com",
			"benjamin@auth0.com",
			"cristian@auth0.com"
		],
		"publishedAt": "2016-11-02"
	},
	{
		"description": "<p>Released new major version of Lock for Android with redesigned UI and new features like custom OAuth2 connections support, password policy, etc. See the <a href='https://auth0.com/docs/libraries/lock-android'>docs</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "Lock",
		"exclusive": "",
		"team": [
			"luciano.balmaceda@auth0.com"
		],
		"publishedAt": "2016-09-21"
	},
	{
		"description": "<p>Published new mobile SDKs for iOS (<a href='https://github.com/auth0/Auth0.swift'>Auth0.swift</a>) and Android (<a href='https://github.com/auth0/Auth0.Android'>Auth0.Android</a>) to make it simple to build custom login screens using Auth0.</p>",
		"old": false,
		"type": "added",
		"module": "SDKs",
		"exclusive": "",
		"team": [
			"hernan@auth0.com",
			"luciano.balmaceda@auth0.com"
		],
		"publishedAt": "2016-10-06"
	},
	{
		"description": "<p>Added new Tenant settings for:<ul><li><code>default_audience</code> - Specifies the audience that clients will receive as a default if one isn't explicitly requested</li><li><code>default_directory</code> - Specifies a default directory connection to use when using <code>password grant</code> flow</li></ul></p>",
		"old": false,
		"type": "added",
		"module": "Settings",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com",
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-10-26"
	},
	{
		"description": "<p>Added paging to Database Connctions page to support large volume of connections</p>",
		"old": false,
		"type": "added",
		"module": "Connections",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com",
			"hugo.arregui@auth0.com",
			"yenkel@auth0.com"
		],
		"publishedAt": "2016-10-15"
	},
	{
		"description": "<p>Release of the UI-less client libraries for Guardian, allowing users to build custom Guardian widgets. See the library <a href='https://github.com/auth0/auth0-guardian.js'>here</a> for more information</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2016-10-31"
	},
	{
		"description": "<p>It is now possible to disable automatic SMS and email notifications during Passwordless user creation. See the <a href='https://auth0.com/docs/api/management/v2#!/Users/post_users'>docs</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "API",
		"exclusive": "",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-10-05"
	},
	{
		"description": "<p>When a user hits the rate limit for the <code>delegation</code> endpoint, log entries will now be visible in the tenant logs.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-09-26"
	},
	{
		"description": "<p>SSO Session Timeout can be customized in Tenant Settings > Advanced. This allows you to specify how long the SSO Cookie is valid.</p>",
		"old": false,
		"type": "added",
		"module": "SSO",
		"exclusive": "",
		"team": [
			"iaco@auth0.com",
			"hugo.arregui@auth0.com",
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2016-09-22"
	},
	{
		"description": "<p>You can now opt-in to preview the new OAuth2aaS pipeline in Account Settings > Advanced. This enables support for Advanced API Authorization scenarios including user consent.</p>",
		"old": false,
		"type": "added",
		"module": "OAuth2",
		"exclusive": "",
		"team": [
			"iaco@auth0.com",
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-09-21"
	},
	{
		"description": "<p>Database Connections now allow customizing the minimum and maximum length for usernames, up to 128 characters. This only applies if <code>Require Username</code> is on.</p><p><img src=\"https://cdn2.auth0.com/website/changelog/username-length.png\" alt=\"username length\"></p>",
		"old": false,
		"type": "added",
		"module": "Connections",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com",
			"eduardo.diaz@auth0.com",
			"hernan@auth0.com",
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-09-19"
	},
	{
		"description": "<p>Renamed the Delete All Users endpoint from <code>DELETE /api/v2/users</code> to <code>DELETE /api/v2/allusers</code> to avoid accidental deletion of users.</p>",
		"old": false,
		"type": "changed",
		"module": "API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-09-13"
	},
	{
		"description": "<p>Fixed error when custom DB scripts are set to <code>null</code></p>",
		"old": false,
		"type": "fixed",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-09-21"
	},
	{
		"description": "<p>Add <code>oid</code> claim to Azure AD user profiles</p>",
		"old": false,
		"type": "added",
		"module": "Enterprise Connections",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-09-07"
	},
	{
		"description": "<p>Auth0 Guardian now allows users to choose to 'remember this browser' and not be prompted for MFA for 30 days from a known system.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"fredrik.liljegren@auth0.com"
		],
		"publishedAt": "2016-10-05"
	},
	{
		"description": "<p>Releasing password breach detection, which protects Auth0 users in case their password is leaked via a breach at a different provider. Auth0 monitors announcments of breaches from other providers, and checks Auth0 users against the list of leaked accounts. In case of a match, the user will be prevented from logging in until their password is reset.</p>",
		"old": false,
		"type": "added",
		"module": "Password Breach Detection",
		"exclusive": "cloud",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-08-24"
	},
	{
		"description": "<p>Auth0 Guardian is now officially released -- a new and convenient way to perform multifactor authentication for logins. Guardian features 'push-notifications' as well as other standard authentication flows. See our full announcement <a href='https://auth0.com/blog/announcing-Auth0-Guardian-a-new-way-to-login'>here</a>.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com",
			"nicolas.ulrich@auth0.com",
			"hernan@auth0.com"
		],
		"publishedAt": "2016-08-25"
	},
	{
		"description": "<p>Added the ability to regenerate Guardian recovery codes. Please visit our <a href='https://auth0.com/docs/api/management/v2#!/Users/post_recovery_code_regeneration'>documentation</a> for details.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"fredrik.liljegren@auth0.com"
		],
		"publishedAt": "2016-08-29"
	},
	{
		"description": "<p>The API now has the ability to manage Guardian configuration. Please visit our <a href='https://auth0.com/docs/api/management/v2#!/Guardian/'>documentation</a> for full details.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2016-08-05"
	},
	{
		"description": "<p>SAML Response is now displayed in Tenant Logs when Debug Mode is enabled in the SAML Connection.</p>",
		"old": false,
		"type": "added",
		"module": "Logs",
		"exclusive": "",
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-09-02"
	},
	{
		"description": "<p>Update response from Device Credentials endpoint to include <code>type</code> and <code>user_id</code>.</p>",
		"old": false,
		"type": "added",
		"module": "API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-09-05"
	},
	{
		"description": "<p>Added ability to specify Client Logo on the client API</p>",
		"old": false,
		"type": "added",
		"module": "API",
		"exclusive": "",
		"team": [
			"german@auth0.com"
		],
		"publishedAt": "2016-08-24"
	},
	{
		"description": "<p>Guardian template is now customizable via the Hosted Pages section.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2016-08-17"
	},
	{
		"description": "<p>Fixed issue with Account Un-Linking where the secondary account would not show up in the Users list after being Un-Liked. Now, when Un-Linking two linked accounts, the secondary account will be restored and visible in Users.</p>",
		"old": false,
		"type": "fixed",
		"module": "Logs",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-08-09"
	},
	{
		"description": "<p>Bulk Import API has been upgraded with the following changes: <ul> <li>Added option to specify if the operation should should insert or upsert</li> <li>Added <code>external_id</code> parameter. The value is user defined and is returned with Job status; can be used for correlating multiple jobs.</li> <li>Job Status shows summary totals of successful/failed/inserted/updated</li> <li>Added ability to retrieve failed entries via API call to <code>GET /api/v2/jobs/{id}/errors</code></li> <li>Job Status is added to Tenant Logs which allows a custom WebHook to be trigged using the WebHook Logs Extension</li> </ul> </p>",
		"old": false,
		"type": "added",
		"module": "Bulk Import",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-08-05"
	},
	{
		"description": "<p>The Bitbucket Deployments extension allows you to deploy rules and database connection scripts from Bitbucket to Auth0. You can configure a Bitbucket repository, keep all your rules and database connection scripts there, and have them automatically deployed to Auth0 each time you push to your repository. <img src=\"https://cdn2.auth0.com/content/img/bitbucket-ext.png\" alt=\"extensions\"></p>",
		"old": false,
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"team": [
			"sandrino@auth0.com"
		],
		"publishedAt": "2016-08-01"
	},
	{
		"description": "<p>The <code>/authorize</code> endpoint now supports <code>response_mode=form_post</code> when the response_type is either <code>id_token</code> or <code>code token</code>.</p> <p>For example:<br> <code>/authorize?response_mode=form_post&client_id=…&redirect_uri=…&response_type=id_token</code></p>",
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-07-22"
	},
	{
		"description": "<p>Auth0 now supports full Client Credentials flow for API Authorizations. This allows server to server authorization for things like scripts, backend services, daemons, or any app that does not need to operate as a user.</p> <p>Enabling the API section can be done via Account Settings or by adding a new <strong>Non Interactive</strong> Client.</p> <p>The <strong>Application</strong> section in the Auth0 Dashboard has been renamed to <strong>Clients</strong> to clarify the distinction between APIs and Clients.</p> <p>This is the first step we are taking towards more complex API authorization scenarios. Other flows, such as User Consent, will be added in the near future. Please visit our full <a href='https://auth0.com/docs/api-auth'>documentation</a> for detailed information about API Authorization.</p>",
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"old": false,
		"team": [
			"jared@auth0.com",
			"martin.cabral@auth0.com",
			"yohanna.etchemendy@auth0.com",
			"tomas.chernov@auth0.com",
			"cristian@auth0.com",
			"matias@auth0.com"
		],
		"publishedAt": "2016-07-15"
	},
	{
		"description": "<p>Added password policy support for Password Dictionary and Password Personal Data.</p> <p><strong>Password Dictionary</strong>, when enabled, prevents the use of common passwords and allows for setting a custom dictionary with up to 200 entries.</p><p><strong>Password Personal Data</strong>, when enabled, prevents using personal data in the password, such as the user's name, parts of the email address, etc...</p>",
		"type": "added",
		"module": "Password Policy",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com",
			"jason.strutz@auth0.com",
			"alex@auth0.com"
		],
		"publishedAt": "2016-07-15"
	},
	{
		"description": "<p>Added ability to change Email for users in Passwordless connections.</p>",
		"type": "added",
		"module": "Connections: Passwordless",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com",
			"tomas.chernov@auth0.com",
			"jason.strutz@auth0.com"
		],
		"publishedAt": "2016-07-15"
	},
	{
		"description": "<p>Added support for Twillio Copilot in Passwordless Connections.</p>",
		"type": "added",
		"module": "Connections: Passwordless",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com",
			"jason.strutz@auth0.com"
		],
		"publishedAt": "2016-07-14"
	},
	{
		"description": "<p>Support for Fitbit OAuth2 apps. Added an upgrade mechanism for OAuth1 (deprecated) connections.</p>",
		"type": "changed",
		"module": "Social Connections: Fitbit",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com",
			"jason.strutz@auth0.com",
			"jeff.smith@auth0.com"
		],
		"publishedAt": "2016-07-12"
	},
	{
		"description": "<p>If a user requests multiple passwordless links/codes, emails may not arrive or be displayed in the correct order. Up till now, only the last code issued was valid, causing issues when opening the wrong email. This change allows the last 5 codes sent to be valid, but once one is used, the rest are invalidated.</p>",
		"type": "Changed",
		"module": "Passwordless",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-07-02"
	},
	{
		"description": "<p>The GitHub Deployments extension allows you to deploy rules and database connection scripts from GitHub to Auth0. You can configure a GitHub repository, keep all your rules and database connection scripts there, and have them automatically deployed to Auth0 each time you push to your repository. <img src=\"https://cdn2.auth0.com/content/img/github-ext.png\" alt=\"extensions\"></p>",
		"old": false,
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"team": [
			"sandrino@auth0.com"
		],
		"publishedAt": "2016-06-29"
	},
	{
		"description": "<p>Added Password History support to Database Connections' password policies.</p>",
		"type": "added",
		"module": "Password Policy",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com",
			"tomas.chernov@auth0.com",
			"yohanna.etchemendy@auth0.com",
			"jason.strutz@auth0.com",
			"alex@auth0.com"
		],
		"publishedAt": "2016-06-21"
	},
	{
		"description": "<p>Added support for the new Firebase SDK v3.</p>",
		"type": "added",
		"module": "Social Connections",
		"exclusive": "",
		"old": false,
		"team": [
			"martin@auth0.com",
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-05-28"
	},
	{
		"description": "<p>Introduced a new tenant settings flag <code>enable_client_connections</code> that will allow customers to switch between 2 flows when creating clients (Applications): <ul> <li>When creating a new client, create and enable existing connections (current flow, default)</li> <li>When creating a new client, create but don't enable my existing connections (new flow)</li> </ul> </p> <p>This setting can be turned off in  Account Settings > Advanced > Settings > Enable Client Connections or via the API using the <code>GET /api/v2/tenants/settings</code> endpoint.<p>",
		"type": "added",
		"module": "Tenant Settings",
		"exclusive": "",
		"old": false,
		"team": [
			"cristian@auth0.com"
		],
		"publishedAt": "2016-05-25"
	},
	{
		"description": "<p>Webtasks improve the execution of rules and custom database logic. Webtasks perform much better than the current 'node sandbox' mode and provide much better isolation than the optional 'eval' mode. Webtasks have many more node.js modules available for your rule logic to use.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Search queries for users and transaction logs can execute on a secondary database instance. This reduces the load on the primary database node, ensuring that authentication transactions are not affected by expensive search queries in high load environments.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Auth0 now periodically collects aggregate statistics from appliance clusters. Customers can request a dump of the statistics collected.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Support for SSL offloading is now available. You can now configure the appliance to accept http. Your load balancer needs to provide a X-Forwarded-Proto header with this feature. The operational environment is responsible for ensuring http access is locked down to the load balancer.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>The management dashboard can now use a different SSL certificate than the tenant authentication domains. With this feature you could for example run your authentication endpoints on externally facing domains while using an internal domain for the dashboard.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>For queries that return a large number of results, the apiv2 user search endpoint will not return a count if a time limit for counting matching users is exceeded. Doing overall count queries, or count queries for a connection are efficient and will return results even when there are millions of users.</p>",
		"type": "fixed",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"jose@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>The apiv1 user search endpoint caches results of a count operation for 5 minutes. The number of users should be considered an approximate count when doing search operations using apiv1.</p>",
		"type": "fixed",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"jose@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Performance of the management dashboard and user search improved. User search functionality is reduced as part of the performance improvement. You can now only sort users by email when doing a filtered search, and you can no longer sort by name or login count.</p>",
		"type": "changed",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-28",
		"release": "6975"
	},
	{
		"description": "<p>The CLI backup capability has been enhanced. You now will designate a specific instance for backup from the CLI. This ensures a backup does not degrade your normal cluster operations during the process. Additionally you must now have a dedicated backup volume on the designated backup instance. This ensures that a backup will not fill up volumes used for normal operations.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"description": "<p>A CSE can now configure an appliance cluster to distribute load over more cores to support scale up as an alternative to scale out. Some types of authentications require expensive cryptographic operations where scale up may be a more desirable approach.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"description": "<p>Services are now periodically checked and restarted by an independent process. Typically services do restart automatically, alhtough in some unusual rapid failure modes a service may stop running. The monitoring service checks periodically for this condition and start any services that have failed their normal automatic restart. This additional monitoring function is off by default.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"description": "<p>In this release a JSONP endpoint used for SSO has been disabled. This endpoint supported browsers before IE9. This exposes some potential vulnerabilities due to the weakness in the JSON protocol. A setting was also added that allows a customer to overrride the JSON disable on a per-tenant basis.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"id": "56f1b43060cfa53624e6e92f",
		"description": "<p>Extensions gallery now supports documentation. From now on, you will be able to check documetion before and after installing an extension.</p>\n<p><img src=\"https://cdn2.auth0.com/content/img/extensions-docs.png\" alt=\"extensions\"> <img src=\"https://cdn2.auth0.com/content/img/extensions-docs4.png\"  alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com",
			"victor@auth0.com",
			"maria@auth0.com"
		],
		"publishedAt": "2016-05-16"
	},
	{
		"description": "<p>Provided access to the language in passwordless email templates</p>\n",
		"type": "added",
		"module": "Passwordless emails",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "<p>Added support for <strong>Bitbucket</strong> and <strong>Dropbox</strong> social connections.</p><p>If you are using <strong>Lock</strong>, please upgrade to <strong>v9.2.0</strong>.</p>\n",
		"type": "added",
		"module": "Social Connections: Bitbucket, Social Connections: Dropbox",
		"exclusive": "",
		"old": false,
		"team": [
			"gabriel@auth0.com",
			"victor@auth0.com",
			"richard.seldon@auth0.com"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "<p>Integrate Rules Debugging with Real-time Logs extension </p>\n<p><img src=\"https://cdn2.auth0.com/content/img/rule-debug.gif\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Rules",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-05-09"
	},
	{
		"description": "<p>We shipped 7 new logging extensions. You can now export Auth0 logs to one of the following external systems: </p>\n<p><ul><li>Auth0 Logs to Papertrail</li><li>Auth0 Logs to Sumologic</li><li>Auth0 Logs to Splunk</li><li>Auth0 Logs to Logstash</li><li>Auth0 Logs to Mixpanel</li><li>Auth0 Logs to Logentries</li></ul> <p>Export operation executes at configurable intervals to ensure you always have access to recent logs.</p> <img src=\"https://cdn2.auth0.com/content/img/logs-ext.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"sandrino@auth0.com",
			"richard.seldon@auth0.com",
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-05-08"
	},
	{
		"description": "<p>New Extension: Real-time Webtask Logs </p>\n<p>This extension gives you the possibility to access to Webtask Logs in real-time. <img src=\"https://cdn2.auth0.com/content/img/real-time-logs-1.png\" alt=\"extensions\"> <img src=\"https://cdn2.auth0.com/content/img/real-time-logs-2.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"tomek@auth0.com",
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-05-02"
	},
	{
		"description": "<p>New Extension: Authorization Dashboard </p>\n<p>This extension gives you the possibility to manage group memberships for your users.</p><h5>Group Management</h5><p>Allows you to create groups with a name and a description. Users can be added and removed from groups. This can happen by opening the group and managing users from there, or by opening the user and manage the user's group memberships from there.</p><p><img src=\"https://cdn2.auth0.com/content/img/authz-groups-ext.png\" alt=\"extensions\"></p>\n<h5>User Management</h5><p>Besides managing everything from the group point of view you can also open a user and manage his/her group memberships there but also see the \"calculated\" group memberships for that user.</p><p><img src=\"https://cdn2.auth0.com/content/img/authz-apps-ext.png\" alt=\"extensions\"></p>\n<h5>Application Access</h5><p>In Auth0 the application access is very coarse grained. All users in a connection that is enabled for the application are able to access the application. With this extension you are now able to take this a step further. You are able to define that only groups \"Fabrikam Management\" and \"Fabrikam Finance\" are able to access the \"Reporting App\" containing reports about the company's financials.</p><p><img src=\"https://cdn2.auth0.com/content/img/authz-users-ext.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"sandrino@auth0.com",
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-04-08"
	},
	{
		"description": "<p>Added logout <code>returnTo</code> URL validation. If the <code>returnTo</code> URL is not in the Allowed Logout URLs list, the request will be rejected. See the <a href=\"https://auth0.com/docs/logout#setting-allowed-logout-urls-at-the-account-level\">docs</a> for more information.</p>\n",
		"type": "added",
		"module": "Server",
		"exclusive": "",
		"release": "6576",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-04-22"
	},
	{
		"description": "<p>Remove support for JSONP on the <code>/ssodata</code> endpoint. The <i>&quot;Last time you logged in with&quot;</i> feature will no longer be supported on IE 9.</p>\n",
		"type": "removed",
		"module": "API",
		"exclusive": "",
		"old": false,
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-05-10"
	},
	{
		"description": "<p>Added a new property on the <strong>client</strong> entity to allow users to specify how the client is going to perform authentication with the token endpoint. Values are <code>none</code>, <code>client_secret_post</code> and <code>client_secret_basic</code>. The <code>none</code> option is introduced for native applications which can’t store secrets and use <strong>PKCE</strong> (see <a href=\"https://tools.ietf.org/html/rfc7636\">https://tools.ietf.org/html/rfc7636</a>)</p>\n",
		"type": "added",
		"module": "Management API",
		"exclusive": "",
		"old": false,
		"team": [
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-04-07"
	},
	{
		"description": "<p>Suppressed the error message in the change password flow in order to prevent user enumeration within the message. The API now returns HTTP 200.</p>\n",
		"type": "changed",
		"module": "Connections: Database",
		"exclusive": "",
		"old": false,
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "<p>We included an extra validation in the <code>/tokeninfo</code> endpoint to verify that the account name in the URL matches the account for which the token was issued. Any call to the tokeninfo with a token from another account will return Unauthorized.</p>\n",
		"type": "fixed",
		"module": "Authentication API",
		"exclusive": "",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "<p>We deprecated the <code>current_user_device_credentials</code> scopes in the <code>/api/v2/device-credentials</code> endpoint for <code>POST</code> and <code>DELETE</code> methods. To use this endpoint we enabled <strong>Basic authentication</strong> with username and password from a database connection.</p>\n",
		"type": "deprecated",
		"module": "APIv2",
		"exclusive": "",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-05"
	},
	{
		"description": "<p>Users can now specify a list of URLs that are valid to redirect to after logging out from Auth0. The update can be done either from the <a href=\"https://manage.auth0.com/#/account/advanced\">Dashboard</a> or using the  <a href=\"https://auth0.com/docs/api/v2#!/Tenants/patch_settings\">Management API</a>.</p>\n",
		"type": "added",
		"module": "Dashboard / Management API",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com",
			"tomas.chernov@auth0.com",
			"cristian@auth0.com"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "<p>Added new <code>ext_nested_groups</code> option to <code>waad</code> connection strategy. When both <code>ext_groups</code> and <code>ext_nested_groups</code> are enabled we return all the groups that the user is a member of instead of only returning the ones that the user is direct member (for more information see this <a href=\"https://msdn.microsoft.com/Library/Azure/Ad/Graph/api/users-operations#UserFunctions\">MSDN article</a>)</p>\n",
		"type": "added",
		"module": "Enterprise Connections",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "<p>The <code>device-credentials</code> endpoint now supports basic authentication to perform <code>GET</code>, <code>POST</code>, and <code>DELETE</code> requests.</p>\n",
		"type": "added",
		"module": "Management API",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-03-14"
	},
	{
		"description": "<p>Extensions Gallery updated! </p>\n<p>This new version allows you to create your own extensions. <img src=\"https://cdn2.auth0.com/content/img/extensions-custom.gif\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions Gallery",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com",
			"victor@auth0.com"
		],
		"publishedAt": "2016-03-11"
	},
	{
		"description": "<p>The flow to reset a password has been updated. </p>\n<p>In this new flow, users enter their username or email address and receive an email with instructions to choose a new password. The old flow which required users to enter their new password and then confirm the change via email is still available but has been deprecated: it is no longer available for new tenants and existing tenants are recommended to disable it.</p>\n",
		"type": "changed",
		"module": "Auth0 Lock v9",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"gabriel@auth0.com",
			"ricky@auth0.com",
			"benjamin@auth0.com"
		],
		"publishedAt": "2016-03-01"
	},
	{
		"description": "<p>Extensions Gallery updated.</p>\n<p>This new version gives users the possibility to search for an extension, easily check which ones are installed and access to more information about an extension before installing it. Also, includes new extensions such as <code>Auth0 logs to Loggly</code>, <code>Auth0 logs to Azure blob storage</code>, <code>Auth0 logs to Application Insights</code>, <code>Auth0 AD/LDAP Connector Health Monitor</code> and <code>Auth0 Authentication API webhooks</code> <img src=\"https://cdn2.auth0.com/content/img/extensions-new-design.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com",
			"victor@auth0.com"
		],
		"publishedAt": "2016-02-29"
	},
	{
		"description": "<p>Users can query logs using the <strong>Management API v2</strong>. </p>\n<p>You can use the new <code>logs</code> endpoints to query logs. This is the new recommended way to query logs. The <strong>API v1</strong> logs endpoints will still be functional. See more info in the <a href=\"https://auth0.com/docs/api/v2#!/Logs/get_logs\">docs</a>.</p>\n",
		"type": "added",
		"module": "Management API",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-02-26"
	}
];

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"changelog-page",
		"header-dark"
	],
	"title": "Auth0 Changelog",
	"metas": {
		"description": "Advanced identity management can be very hard. Very often, unnecessarily hard. At Auth0 we want to change that, by simplifying as much as possible."
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports = [
	{
		"data": "featured",
		"title": "Featured Customer Stories",
		"customers": [
			{
				"img": "logo-schneider-electric.png",
				"text": "Schneider Electric: Streamlining Identity Management",
				"websiteUrl": "http://www.schneider-electric.com/",
				"caseStudyUrl": "https://auth0.com/learn/schneider-electric-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-jet-privilege.png",
				"text": "JetPrivilege: SSO Makes For A Seamless Travel Experience",
				"websiteUrl": "https://www.jetprivilege.com/",
				"caseStudyUrl": "https://auth0.com/learn/jetprivilege-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-safari-books.svg",
				"text": "Safari: Auth0 SSO Drives B2B Expansion",
				"websiteUrl": "https://www.safaribooksonline.com/",
				"caseStudyUrl": "https://auth0.com/learn/safari-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-harvard-medical-school.svg",
				"text": "Harvard Medical School: Identity Secures NIH Research",
				"websiteUrl": "https://undiagnosed.hms.harvard.edu/",
				"caseStudyUrl": "https://auth0.com/learn/harvard-medical-school-identity-secures-nih-research/",
				"videoURL": "//fast.wistia.net/embed/iframe/6gehzyd3w0?popover=true",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-marks-spencer.svg",
				"text": "Marks & Spencer: Auth0 Authentication Scalability In Action",
				"websiteUrl": "http://www.marksandspencer.com/",
				"caseStudyUrl": "https://auth0.com/learn/marks-spencer-auth0-authentication-scalability-in-action/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-bluetooth-sig.svg",
				"text": "Bluetooth Special Interest Group (SIG) Case Study",
				"websiteUrl": "https://www.bluetooth.com/",
				"caseStudyUrl": "https://auth0.com/learn/bluetooth-case-study/",
				"color": "#f8f8f8"
			}
		]
	},
	{
		"data": "logistics",
		"title": "Logistics",
		"customers": [
			{
				"hashName": "aeromexico",
				"img": "logo-aeromexico.svg",
				"text": "Aeromexico is Mexico's global airline. Operating more than 600 flights daily with hubs at the Mexico City International Airport and at the Monterrey International Airport.",
				"websiteUrl": "http://aeromexico.com"
			},
			{
				"img": "logo-freeformers.png",
				"text": "Freeformers helps transform some of the world's biggest companies for the digital age through exciting, hands-on workshops for everyone.",
				"websiteUrl": "https://freeformers.com/"
			},
			{
				"img": "logo-stage-3.png",
				"text": "Stage 3 Systems has supported the shipping industry with easy-to-use, secure, common-sense software solutions for their information technology needs for more than a decade.",
				"websiteUrl": "http://stage3systems.com/"
			}
		]
	},
	{
		"data": "healthcare",
		"title": "Healthcare",
		"customers": [
			{
				"img": "logo-fmi.png",
				"text": "The Friedrich Miescher Institute for Biomedical Research (FMI), based in Basel, Switzerland, is a world class center for basic research in life sciences and part of the Novartis Research Foundation.",
				"websiteUrl": "http://www.fmi.ch"
			},
			{
				"img": "logo-zyto.jpg",
				"text": "ZYTO is a global technology company that creates interfaces between the human body and digital technology to provide insights into personal health and wellness decisions.",
				"websiteUrl": "http://www.zyto.com"
			},
			{
				"img": "logo-SIB.png",
				"text": "The Swiss Institute of Bioinformatics is a world-renowned scientific consortium of research groups from both universities and the Swiss Federal Institutes of technology.",
				"websiteUrl": "http://www.isb-sib.ch"
			},
			{
				"img": "logo-bloodhub.png",
				"text": "BloodHub is a SaaS solution for the medical industry, simplifying the management of blood supplies.",
				"websiteUrl": "http://www.bloodhub.com"
			},
			{
				"img": "logo-wellintune.png",
				"text": "Wellintune is a comprehensive health management service and online platform that allows companies, individuals, and communities alike grow to be healthier.",
				"websiteUrl": "https://www.attunelife.com/"
			},
			{
				"img": "logo-kyruus.png",
				"text": "Kyruus is an enterprise healthcare provider solutions company that helps to optimize Patient Access, Referral Management, and Care Coordination operations.",
				"websiteUrl": "http://www.kyruus.com/"
			}
		]
	},
	{
		"data": "energy",
		"title": "Energy",
		"customers": [
			{
				"img": "logo-sinopec.svg",
				"text": "Sinopec Limited's parent, Sinopec Group, is one of the major State Owned petroleum energy and chemicals companies in China.",
				"websiteUrl": "http://english.sinopec.com/"
			},
			{
				"img": "logo-canem.png",
				"text": "Canem, Ltd. is a Canadian firm specializing in electrical contracting.",
				"websiteUrl": "http://www.canem.com"
			},
			{
				"img": "logo-tachyus.png",
				"text": "Tachyus creates technology to optimize energy production for the oil and gas industry.",
				"websiteUrl": "http://www.tachyus.com/"
			},
			{
				"img": "logo-agl.png",
				"text": "AGL is one of Australia's leading integrated energy companies and largest ASX listed owner, operator and developer of renewable energy generation in the country.",
				"websiteUrl": "http://www.agl.com.au"
			}
		]
	},
	{
		"data": "media",
		"title": "Media",
		"customers": [
			{
				"hashName": "PBS",
				"img": "logo-pbs.svg",
				"text": "PBS is an independently operated non-profit organization and is the most prominent provider of television programs to public television stations in the United States.",
				"websiteUrl": "http://www.pbs.org/"
			},
			{
				"hashName": "newscorp",
				"img": "logo-newscorp.svg",
				"text": "News Corp is a network of leading companies in the worlds of diversified media, news, education, and information services.",
				"websiteUrl": "http://www.newscorp.com/"
			},
			{
				"hashName": "harper",
				"img": "logo-harper.png",
				"text": "HarperCollins Publishers LLC is one of the world's largest publishing companies and is part of the 'Big Five' English-language publishing companies.",
				"websiteUrl": "http://www.harpercollins.com/"
			},
			{
				"hashName": "houghton-mifflin-harcourt",
				"img": "logo-houghton-mifflin-harcourt.png",
				"text": "Houghton Mifflin Harcourt is a global learning company dedicated to changing people’s lives by fostering passionate, curious learners.",
				"websiteUrl": "http://www.hmhco.com/"
			},
			{
				"hashName": "dow-jones",
				"img": "logo-dow-jones.png",
				"text": "Dow Jones & Company is an American publishing and financial information firm. Dow Jones has grown to be a worldwide news and information powerhouse.",
				"websiteUrl": "http://www.dowjones.com/"
			},
			{
				"img": "logo-music-memory.jpg",
				"text": "MUSIC & MEMORY℠ is a non-profit organization that brings personalized music into the lives of the elderly or infirm, vastly improving quality of life.",
				"websiteUrl": "http://musicandmemory.org/"
			},
			{
				"img": "logo-cm-group.png",
				"text": "CM Group is a leader in delivering eLearning and mobile learning to major companies worldwide. ",
				"websiteUrl": "http://www.cm-group.co.uk"
			},
			{
				"img": "logo-fubotv.png",
				"text": "fuboTV is a streaming TV service offering the best live soccer coverage 24x7. Featuring sports and entertainment programming.",
				"websiteUrl": "http://www.fubo.tv"
			},
			{
				"img": "logo-plan-3.png",
				"text": "Plan 3 consists in a diverse set of professionals creating streamlined services that leverage the latest in know-how. ",
				"websiteUrl": "http://plan3.se/"
			},
			{
				"img": "logo-medvid.png",
				"text": "medvid.io powers HIPAA Compliant Video Management and transforms the Doctor – Patient Relationship, One Video at a Time.",
				"websiteUrl": "https://reeldx.com/medvidio/"
			},
			{
				"img": "logo-infomedia.png",
				"text": "Infomedia is a worldwide leader in SaaS automotive parts and service systems which empower their dealer customers to deliver a superior service level.",
				"websiteUrl": "http://www.infomedia.com.au"
			},
			{
				"img": "logo-coleman.png",
				"text": "Coleman Insights is a firm that has has helped media properties build strong brands and develop great content since 1978.",
				"websiteUrl": "http://www.colemaninsights.com/"
			},
			{
				"img": "logo-southcomm.png",
				"text": "SouthComm is the nation’s second largest publisher of alternative weeklies. The company owns more than 30 titles targeting B2B and audiences around the country.",
				"websiteUrl": "http://www.southcomm.com/"
			},
			{
				"img": "logo-kinesis.png",
				"text": "Kinesis provides pragmatic and evidence based solutions to the climate problem. , It’s mission is to make organizations and cities more resilient, productive and sustainable.",
				"websiteUrl": "http://www.kinesis.org/"
			}
		]
	},
	{
		"data": "financial",
		"title": "Financial Services",
		"customers": [
			{
				"hashName": "financial-times",
				"img": "logo-financial-times.svg",
				"text": "The Financial Times is one of the world’s leading business news organisations, recognised internationally for its authority, integrity and accuracy.",
				"websiteUrl": "https://www.ft.com/"
			},
			{
				"hashName": "berkshire",
				"img": "logo-bhtp.png",
				"text": "As Berkshire Hathaway’s travel insurance arm, BHTP gives travelers the coverage they need in simpler and smarter ways than ever before.",
				"websiteUrl": "https://www.bhtp.com/"
			},
			{
				"img": "logo-sancor.png",
				"text": "Grupo Sancor Seguros is the premier Insurance Group in Argentina and a market leader across Latin America.",
				"websiteUrl": "https://www.gruposancorseguros.com/en"
			},
			{
				"img": "logo-concierge-auctions.png",
				"text": "Concierge Auctions is an innovative, online luxury real-estate auction house. A win-win for sellers, buyers, and agents alike.",
				"websiteUrl": "http://www.conciergeauctions.com"
			},
			{
				"img": "logo-advance.png",
				"text": "AdvancedREI is Deal Intelligence for Commercial Real Estate. It delivers advanced predictive analysis and insights to today's commercial real estate professionals.",
				"websiteUrl": "http://advancedrei.com/"
			},
			{
				"img": "logo-notient.png",
				"text": "Notient automates and aggregates peer-to-peer investments. Their system allows the novice or hands-off investor to be up and running with Notient in only a few clicks.",
				"websiteUrl": "https://notient.com/#!/aboutus"
			},
			{
				"img": "logo-simpology.png",
				"text": "Simpology is an Australia-based software company delivering powerful solutions for originating and processing loan applications.",
				"websiteUrl": "http://www.simpology.com.au"
			},
			{
				"img": "logo-nickel-swan.svg",
				"text": "Nickel & Swan offers a revolutionary equity option analytics platform to help optimize option trades, understand option data, and feel the market pulse.",
				"websiteUrl": "http://www.nickelandswan.com/"
			},
			{
				"img": "logo-spv.jpg",
				"text": "Sparebanken Vest, established in 1823, is Norway's third largest bank, and a financial services leader in Western Norway. With a focus on both private and corporate banking, Sparebanken Vest is committed to Norway's social and commercial development.",
				"websiteUrl": "https://www.spv.no/"
			}
		]
	},
	{
		"data": "retail",
		"title": "Retail",
		"customers": [
			{
				"hashName": "nandos",
				"img": "logo-nandos.svg",
				"text": "Nando's is an international casual dining restaurant chain originating from South Africa, with a Mozambican/Portuguese theme. Founded in 1987, Nando's operates about 1,000 outlets in 30 countries.",
				"websiteUrl": "http://www.nandos.com/"
			},
			{
				"img": "logo-russell-cellular.jpg",
				"text": "Russell Cellular is a Verizon Premium Retailer operating in the midwest and southern USA. Founded in 1993, Russell Cellular has over 250 retail locations in 22 states.",
				"websiteUrl": "http://www.russellcellular.com"
			},
			{
				"img": "logo-collect.png",
				"text": "Collect.it is a social community and marketplace serving the multi-billion dollar collectibles market.",
				"websiteUrl": "http://collect.it/"
			},
			{
				"img": "logo-redicarpet.png",
				"text": "Redi Carpet is one of the largest flooring suppliers to the apartment industry. The company offers next day flooring installation for multi-family apartments and homes.",
				"websiteUrl": "http://www.redicarpet.com/"
			},
			{
				"img": "logo-krrb.jpg",
				"text": "Krrb is a local classifieds, connecting your community with other communities around the world.",
				"websiteUrl": "https://krrb.com/"
			},
			{
				"img": "logo-directlease.png",
				"text": "DirectLease group is an online car lease company for Dutch, Belgian and German customers.",
				"websiteUrl": "http://directlease.nl/DLNl/home.do"
			},
			{
				"img": "logo-casestack.png",
				"text": "CaseStack is a leading logistics provider that specializes in applying efficient and sustainable supply chain solutions, including warehousing and transportation.",
				"websiteUrl": "https://ww2.casestack.com/"
			},
			{
				"img": "logo-foodjunky.png",
				"text": "Foodjunky is an online platform for ordering food. It makes the process easy for individuals, groups, and catering, so everyone's happy.",
				"websiteUrl": "http://www.foodjunky.com/"
			},
			{
				"img": "logo-clowder.svg",
				"text": "Clowder is premium coffee brewed and delivered to customers door within 15 minutes. Offices in NYC and Mountain View.",
				"websiteUrl": "https://www.clowder.nyc/"
			}
		]
	},
	{
		"data": "manufacturing",
		"title": "Manufacturing",
		"customers": [
			{
				"hashName": "polaris",
				"img": "logo-polaris-industries.svg",
				"text": "Polaris Industries is a global leader in the off-road consumer and millitary markets.",
				"websiteUrl": "http://www.polaris.com"
			},
			{
				"img": "logo-coop-tender.png",
				"text": "Coop Tender ™ Internet Wi-Fi Enabled Automatic Chicken Coop Door takes the hassles out of raising free-range chickens.",
				"websiteUrl": "http://cooptender.com/"
			}
		]
	},
	{
		"data": "software",
		"title": "Software / Design",
		"customers": [
			{
				"hashName": "atlassian",
				"img": "logo-atlassian.svg",
				"text": "Atlassian is a group of enterprise software companies that develops products for software developers, project managers, and content management.",
				"websiteUrl": "https://www.atlassian.com/"
			},
			{
				"hashName": "mozilla",
				"img": "logo-mozilla.svg",
				"text": "Mozilla is a technology not-for-profit dedicated to ensuring the Internet is a global public resource, open and accessible to all.  We do that by building products, technologies and programs that put people in control of their online lives.",
				"websiteUrl": "https://www.mozilla.org"
			},
			{
				"hashName": "nvidia",
				"img": "logo-nvidia.svg",
				"text": "NVIDIA is the world leader in visual computing. The GPU, their invention, serves as the visual cortex of modern computers and is at the heart of their products and services.",
				"websiteUrl": "https://www.nvidia.com/"
			},
			{
				"hashName": "bluetooth-sig",
				"img": "logo-bluetooth-sig.svg",
				"text": "The Bluetooth SIG is the body that oversees the development of Bluetooth standards and the licensing of the Bluetooth technologies and trademarks to manufacturers.",
				"websiteUrl": "http://www.bluetooth.com/"
			},
			{
				"img": "logo-redsequence.png",
				"text": "Red Sequence was founded in 2013, in order to develop cloud productivity apps for individuals and teams. It’s currently extending its application, Timestamp.",
				"websiteUrl": "http://www.redsequence.com/"
			},
			{
				"img": "logo-zudio.png",
				"text": "With Zudio, you can manage your Windows Azure Storage wherever you are, on any device with a modern web browser, no artificial licence restrictions.",
				"websiteUrl": "https://zud.io/"
			},
			{
				"img": "logo-giant-machines.png",
				"text": "Giant Machines authors custom software for companies large and small by providing consulting services to fit their customer’s needs.",
				"websiteUrl": "http://giantmachines.com/"
			},
			{
				"img": "logo-fadeit.svg",
				"text": "Fadeit is a software development company with expertise in a wide variety of IT subjects such as Internet of Things, Distributed Systems, Open Data, and more.",
				"websiteUrl": "http://fadeit.dk/da"
			},
			{
				"img": "logo-performant.png",
				"text": "Performant Software Solutions partners with researchers, scholars and entrepreneurs to create web and mobile software that educates, enriches and entertains.",
				"websiteUrl": "http://www.performantsoftware.com/"
			},
			{
				"img": "logo-contemplor.png",
				"text": "Contemplor Software has developed modeling and work product automation tools that revolutionize business.",
				"websiteUrl": "http://contemplorsoftware.com/"
			},
			{
				"img": "logo-dragonfly.png",
				"text": "Dragonfly Design Group provides graphic design and various services for PR firms, marketing consultants, entrepreneurs and even in-house art departments.",
				"websiteUrl": "http://dragonflydg.com/"
			},
			{
				"img": "logo-identillect.png",
				"text": "Identillect Technologies is an innovative email security company with a proprietary email encryption technology targeted at organizations, as well as individuals.",
				"websiteUrl": "https://identillect.com/"
			},
			{
				"img": "logo-kiosk-browser.png",
				"text": "Kiosk Browser has been designed for use on any android device and is great for creating public kiosks, interactive digital signage etc.",
				"websiteUrl": "http://www.android-kiosk.com/"
			},
			{
				"img": "logo-trueflow.png",
				"text": "TrueFlow is changing the way venues engage with users indoors using sensors, wifi and other radio signals within the venue, resulting in greater engagement.",
				"websiteUrl": "http://www.trueflow.io/"
			},
			{
				"img": "logo-stonetip.png",
				"text": "Stonetip specializes in mobile app development, with apps that are aimed at mapping, productivity and fitness.",
				"websiteUrl": "http://code.stonetip.com/about/"
			},
			{
				"img": "logo-mindjet.png",
				"text": "Mindjet is a collaborative work management software Mindjet's software products, are designed to visually and collaboratively manage information and tasks.",
				"websiteUrl": "https://www.mindjet.com"
			},
			{
				"img": "logo-trading-work.png",
				"text": "TradingWorks ensure their customers understand how their resources are being utilized and provide real time data to help them to maximize efficiency and results.",
				"websiteUrl": "http://www.tradingworks.com.br/"
			},
			{
				"img": "logo-sapho.png",
				"text": "Sapho provides an enterprise software platform for organizations to offer access to corporate information on mobile devices by utilizing software APIs.",
				"websiteUrl": "http://www.sapho.com/"
			},
			{
				"img": "logo-gridvision.png",
				"text": "GridVision transforms IT by automating and eliminating repetitive, mundane and complex activities such as monitoring computer systems and applications.",
				"websiteUrl": "http://www.grid-vision.com/"
			},
			{
				"img": "logo-agrippa.png",
				"text": "Agrippa Solutions provides services for project management, change management, enterprise architecture, quality assurance and other facets of IT.",
				"websiteUrl": "https://agrippa.azurewebsites.net/"
			},
			{
				"img": "logo-blinkmobile.jpg",
				"text": "BlinkMobile helps organizations more easily harness mobile and emerging technologies to quickly and securely extend their core business systems.",
				"websiteUrl": "http://blinkmobile.com.au/"
			},
			{
				"img": "logo-candoris.png",
				"text": "Candoris is an IT Systems Integration firm focused on implementing technology that increases the efficiency of businesses.",
				"websiteUrl": "http://www.candoris.com/"
			},
			{
				"img": "logo-timestamp.png",
				"text": "Timestamp is a time tracking application that will help you discover in what you consume your time.",
				"websiteUrl": "http://www.timestamphq.com/"
			},
			{
				"hashName": "amd",
				"img": "logo-amd.svg",
				"text": "Advanced Micro Devices, Inc. (AMD) is an American multinational semiconductor company based in Sunnyvale, California, United States, that develops computer processors and related technologies for business and consumer markets.",
				"websiteUrl": "http://www.amd.com/"
			}
		]
	},
	{
		"data": "online-services",
		"title": "Online Services / Analytics",
		"customers": [
			{
				"hashName": "optimizely",
				"img": "logo-optimizely.svg",
				"text": "Optimizely is the world’s leading experimentation platform, enabling businesses to deliver continuous experimentation and personalization across websites, mobile apps and connected devices.",
				"websiteUrl": "https://www.optimizely.com"
			},
			{
				"img": "logo-purestorage.svg",
				"text": "Pure Storage is an all-flash enterprise storage company that delivers high performance solutions for data centers, cloud computing, Big Data and real-time analytics.",
				"websiteUrl": "http://www.purestorage.com/"
			},
			{
				"img": "logo-cymbalstream.png",
				"text": "Cymbalstream delivers what others only talk about – rapid ROI, effective optimization and tools to manage your IT without the typical administrative overhead and cost.",
				"websiteUrl": "http://www.cymbalstream.com/"
			},
			{
				"img": "logo-blueip.jpg",
				"text": "BluIP is a leading wholesale provider of cloud-based voice technology. They deliver mission-critical products engineered for the SMB and LE Markets.",
				"websiteUrl": "http://www.bluip.com/"
			},
			{
				"img": "logo-ire.png",
				"text": "Ireckon uses their expertise to create powerful software solutions that solve business needs, on time and on budget. ",
				"websiteUrl": "http://www.ireckon.nl/"
			},
			{
				"img": "logo-10th-magnitude.svg",
				"text": "10th Magnitude, one of the top Microsoft Azure services firms in the US, provides customers with a full suite of cloud services.",
				"websiteUrl": "http://www.10thmagnitude.com/"
			},
			{
				"img": "logo-bang-the-table.jpg",
				"text": "Bang the Table delivers world-class interactive communications solutions branded with their client's identity.",
				"websiteUrl": "http://www.bangthetable.com/"
			},
			{
				"img": "logo-my-objectives.png",
				"text": "MyObjectives is performance management solution that is a low cost, SaaS solution that allows organizations of all sizes to implement Management by Gaming.",
				"websiteUrl": "http://www.allianceenterprises.com/myobjectives"
			},
			{
				"img": "logo-westat.png",
				"text": "Westat, Inc. specializes in executing non-partisan, scientifically valid research studies for a broad range of  organizations.",
				"websiteUrl": "http://www.westat.com/"
			},
			{
				"img": "logo-rapidminer.png",
				"text": "RapidMiner is an open source, predictive analytics platform that lets analysts quickly uncover opportunities and risks, and guide business decision.",
				"websiteUrl": "http://www.rapidminer.com/"
			},
			{
				"img": "logo-moving.png",
				"text": "Machine to Machine (M2M) Services. Data Mining and Business Intelligence. Ericsson Authorised Service Partner.",
				"websiteUrl": "http://movingdata.com"
			},
			{
				"img": "logo-peruse.png",
				"text": "Peruse.io is pioneering a new way to get answers to questions about your documents.",
				"websiteUrl": "https://peruse.io/"
			},
			{
				"img": "logo-datastreamx.svg",
				"text": "DataStreamX is a data marketplace for real-time data created from IoT, M2M and Big Data Applications.",
				"websiteUrl": "https://www.datastreamx.com/"
			},
			{
				"img": "logo-42.png",
				"text": "42 is a predictive analytics platform for retailers. 42 works with some of the world's best known brands and is backed by Y Combinator.",
				"websiteUrl": "https://42technologies.com/#/"
			},
			{
				"img": "logo-satalyst.png",
				"text": "Satalyst is focused on delivering high quality project based IT solutions and assists companies to realise the business benefits technology can offer.",
				"websiteUrl": "https://www.clowder.nyc/"
			},
			{
				"img": "logo-salt.svg",
				"text": "Salt provides a services that help customers build powerful datasets. They focus on turning big data into small data that is accessible, understandable, and actionable.",
				"websiteUrl": "http://salt.io/"
			}
		]
	}
];

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"customers-page"
	],
	"title": "Customers",
	"metas": {
		"description": "Auth0 is used by many companies and apps to manage their authentication. Learn who are they and how they use Auth0 as an Identity Platform."
	},
	"opengraph": {
		"og:title": "Customers",
		"og:description": "Auth0 is used by many companies and apps to manage their authentication. Learn who are they and how they use Auth0 as an Identity Platform.",
		"og:url": "https://auth0.com/customers",
		"og:image": "http://cdn2.auth0.com/blog/customers-twittercard-2x.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/customers-twittercard-2x.png"
	},
	"twittercard": {
		"twitter:title": "Customers",
		"twitter:description": "Auth0 is used by many companies and apps to manage their authentication. Learn who are they and how they use Auth0 as an Identity Platform",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/customers-twittercard-2x.png"
			}
		]
	}
};

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"dashboard-page",
		"header-dark"
	],
	"title": "Dashboard",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"enterprise-page"
	],
	"title": "Enterprise Identity Management",
	"metas": {
		"description": "Let Auth0 handle your Enterprise Authentication, Authorization and Identity Management so you can focus on your business."
	},
	"opengraph": {
		"og:title": "Enterprise Identity Management",
		"og:description": "Let Auth0 handle your Enterprise Authentication, Authorization and Identity Management so you can focus on your business.",
		"og:url": "https://auth0.com/enterprise",
		"og:image": "https://cdn.auth0.com/website/assets/pages/enterprise/img/enterprise-card-2-eb7dd5df38.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/enterprise/img/enterprise-card-2-eb7dd5df38.png"
	},
	"twittercard": {
		"twitter:title": "Enterprise Identity Management",
		"twitter:description": "Let Auth0 handle your Enterprise Authentication, Authorization and Identity Management so you can focus on your business.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/enterprise/img/enterprise-card-2-eb7dd5df38.png"
			}
		]
	}
};

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"events-page",
		"header-dark"
	],
	"title": "Events",
	"metas": {
		"description": "Events page"
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"mfa-page"
	],
	"title": "Auth0 Guardian",
	"metas": {
		"description": "Multifactor Made Easy: The most usable and friction-free multifactor authentication experience available"
	},
	"opengraph": {
		"og:title": "Auth0 Guardian",
		"og:description": "Multifactor Made Easy: The most usable and friction-free multifactor authentication experience available",
		"og:url": "https://auth0.com/guardian",
		"og:image": "https://cdn.auth0.com/website/assets/pages/guardian/assets/social-card-db858f505b.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/guardian/assets/social-card-db858f505b.png"
	},
	"twittercard": {
		"twitter:title": "Auth0 Guardian",
		"twitter:description": "Multifactor Made Easy: The most usable and friction-free multifactor authentication experience available",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/guardian/assets/social-card-db858f505b.png",
				"width": "2400",
				"height": "1260"
			}
		]
	}
};

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"guest-authors-page"
	],
	"title": "Auth0's Guest Author Program",
	"metas": {
		"description": "Do you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? Join us!"
	},
	"opengraph": {
		"og:title": "Auth0's Guest Author Program",
		"og:description": "Do you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? Join us!",
		"og:url": "https://auth0.com/guest-authors",
		"og:image": "http://cdn2.auth0.com/blog/guest-authors/twitter-card-2.png ",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/guest-authors/twitter-card-2.png"
	},
	"twittercard": {
		"twitter:title": "Auth0's Guest Author Program",
		"twitter:description": "Do you love learning new technologies and writing tutorials on how to use them? Want to get paid and have your content pushed to a wide audience? Join us!",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/guest-authors/twitter-card-2.png"
			}
		]
	}
};

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"identity-glossary"
	],
	"title": "Identity Glossary",
	"metas": {
		"description": "Crucial concepts in security have subtly different definitions. Identity Glossary helps you understand those subtle differences to keep your app secure."
	},
	"opengraph": {
		"og:title": "Identity Glossary",
		"og:description": "Crucial concepts in security have subtly different definitions. Identity Glossary helps you understand those subtle differences to keep your app secure.",
		"og:url": "https://auth0.com/identity-glossary",
		"og:image": "http://cdn2.auth0.com/blog/identity-glossary-twittercard.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/identity-glossary-twittercard.png"
	},
	"twittercard": {
		"twitter:title": "Identity Glossary",
		"twitter:description": "Crucial concepts in security have subtly different definitions. Identity Glossary helps you understand those subtle differences to keep your app secure.",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/identity-glossary-twittercard.png"
			}
		]
	},
	"canonical": "/identity-glossary"
};

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports = [
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-16-d87d0e94a6.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-1-58e65020cf.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-2-20aab6aae1.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-3-6a971fa845.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-5-681231bff6.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-6-f1e85089bc.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-7-cb99c67735.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-8-f606d1f1fb.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-9-b7f32f6d4c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-10-6554974d8c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-11-ae23911d1c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-12-7ca32624dd.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-13-d256301361.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-14-c22c7f4699.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-15-3c7ae5c715.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-17-16d1eb2ca7.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/offsite-2016/offsite-18-68019976a5.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "August 2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sailing/1-8f5c0cbd55.jpg",
		"text": "Sailing @ Puget Sound, Seattle",
		"date": "Sep 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/10-46d58f3831.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/7-3c196de0c7.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/3-4a81886f61.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/4-96cbb86095.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/6-35ae386149.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/8-527aaa5b60.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/9-54b6ad3338.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/2-1b4c4eb724.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/pdc/1-a04bc475d2.jpg",
		"text": "Offsite @ Playa del Carmen",
		"date": "Jun 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/21-af6bb9539a.jpg",
		"text": "Startupland Starbucks Buenos Aires",
		"date": "Jan 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/19-e85ad7d5f3.jpg",
		"text": "First company meeting @ Buenos Aires",
		"date": "Dec 2013"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/20-7e512b9995.jpg",
		"text": "Nodejs workshop by Jose and Matias",
		"date": "Oct 2013"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/1-6c757a6781.jpg",
		"text": "Mark at work @ Bellevue HQ",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/2-fefa0976a7.jpg",
		"text": "Authsado @ Gonto's house",
		"date": "March 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/3-a2ed06c5b6.jpg",
		"text": "Authsado 2 @ CTO's house",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/4-7f38b853d9.jpg",
		"text": "Rock'n Roll",
		"date": "Dec 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/5-bd6b6f87f9.jpg",
		"text": "Team lunch @ Burger Joint Palermo, BA",
		"date": "April 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/6-94584b33cf.jpg",
		"text": "The Gang",
		"date": "April 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/7-9175b1d4ce.jpg",
		"text": "Gonto & Woloski @ Devoxx Belgium",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/8-20bc3f5801.jpg",
		"text": "Team Dinner @ San Francisco",
		"date": "Jan 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/9-89b868ea90.jpg",
		"text": "DotJS Paris - Drone draw",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/10-3e8cbbceb7.jpg",
		"text": "JsConf.ar 2014",
		"date": "Dec 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/11-b94f32d435.jpg",
		"text": "Gonto Cheering @ Devoxx booth",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/12-9bf2fc94e4.jpg",
		"text": "GP leading @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/13-e5524a8112.jpg",
		"text": "Auth0 Team hiking @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/14-25fdd5f8d2.jpg",
		"text": "Booth ready @ OSCON 2014",
		"date": "July 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/15-064d2b21e0.jpg",
		"text": "Team dinner @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/16-f28f713873.jpg",
		"text": "Photoshoot @ Palermo",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/17-19ab362d31.jpg",
		"text": "Exhausted after building the booth until 10PM.",
		"date": "Nov 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/team/18-890d8b6acf.jpg",
		"text": "Think tank @ Offsite 2014 Cordoba, Arg",
		"date": "Oct 2014"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/1-8bf9402919.jpg",
		"text": "HACKATON SF",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/2-ca5c5f4138.jpg",
		"text": "Gonto being Gonto @ HACKATON SF",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/6-317763a60c.jpg",
		"text": "Team HACKATON SF",
		"date": "Feb 2015"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/jobs/img/sf/7-0bdacb1c0e.jpg",
		"text": "Drone trophy by @rauchg",
		"date": "Feb 2015"
	}
];

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"jobs-page",
		"header"
	],
	"title": "Jobs",
	"metas": {
		"description": "Jobs. We are always looking for talented people to join our team."
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"breached-passwords-page"
	],
	"title": "Breached Password Detection",
	"metas": {
		"description": ""
	},
	"opengraph": {
		"og:title": "Breached Password Detection",
		"og:description": "Breached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.",
		"og:url": "https://auth0.com/breached-passwords",
		"og:image": "http://cdn2.auth0.com/blog/breached-twitter-card.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/breached-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Breached Password Detection",
		"twitter:description": "Breached password detection protects and notifies your users when their credentials are leaked by a data breach of a third party. You can optionally prevent access until the user has reset their password.",
		"twitter:image": [
			{
				"src": "https://cdn2.auth0.com/blog/breached-twitter-card.png"
			}
		]
	}
};

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"mfa-page"
	],
	"title": "Auth0 Guardian",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"homepage-page",
		"header-dark"
	],
	"title": "Single Sign On & Token Based Authentication",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"jp-dashboard-page",
		"header-dark"
	],
	"title": "Dashboard",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"jp-whyauth0-page",
		"header-dark"
	],
	"title": "Why Auth0",
	"metas": {
		"description": "Identity in Modern Cloud-Hybrid Apps and APIs is Radically More Complex. Traditional Identity Infrastructure Is Obsolete"
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"lock-page",
		"header-dark"
	],
	"title": "Lock",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"mcc-page",
		"header-dark"
	],
	"title": "Model Contract Clause",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"notfound-page",
		"theme-dark"
	],
	"title": "Not found",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"opensource-page",
		"header-dark"
	],
	"title": "Open Source",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"partners-page",
		"header-dark"
	],
	"title": "Partners",
	"metas": {
		"description": "Grow your business in an increasingly developer-centric world of apps"
	},
	"opengraph": {
		"og:title": "",
		"og:description": "",
		"og:url": "https://auth0.com/partners",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "",
		"twitter:description": "",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"passwordless-page",
		"header-dark"
	],
	"title": "Passwordless: SMS Login and Email Authentication",
	"metas": {
		"description": "Get started with Passwordless. Token-based authentication to replace passwords. SMS Login and Email Authentication service."
	},
	"opengraph": {
		"og:title": "Passwordless: SMS Login and Email Authentication",
		"og:description": "Get started with Passwordless. Token-based authentication to replace passwords. SMS Login and Email Authentication service.",
		"og:url": "https://auth0.com/passwordless",
		"og:image": "http://cdn2.auth0.com/blog/passwordless/social-card.png",
		"og:image:secure_url": "https://cdn2.auth0.com/blog/passwordless/social-card.png"
	},
	"twittercard": {
		"twitter:title": "Passwordless: SMS Login and Email Authentication",
		"twitter:description": "Get started with Passwordless. Token-based authentication to replace passwords. SMS Login and Email Authentication service.",
		"twitter:image": [
			{
				"src": "http://cdn2.auth0.com/blog/passwordless/social-card.png"
			}
		]
	}
};

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"press-page",
		"header-dark"
	],
	"title": "Press & Media Resources",
	"metas": {
		"description": "Press page. Company mission, press & media resources."
	},
	"opengraph": {
		"og:title": "Press & Media Resources",
		"og:description": "Press page. Company mission, press & media resources. For enquiries contact press@auth0.com",
		"og:url": "https://auth0.com/press",
		"og:image": "https://cdn.auth0.com/website/assets/pages/press/img/press-twitter-card-f7ca0bcd3f.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/press/img/press-twitter-card-f7ca0bcd3f.png"
	},
	"twittercard": {
		"twitter:title": "Press & Media Resources",
		"twitter:description": "Press page. Company mission, press & media resources. For enquiries contact press@auth0.com",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/press/img/press-twitter-card-f7ca0bcd3f.png"
			}
		]
	}
};

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"pricing-page",
		"header-dark"
	],
	"title": "Pricing",
	"metas": {
		"description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan."
	},
	"opengraph": {
		"og:title": "Pricing",
		"og:description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan.",
		"og:url": "https://auth0.com/pricing",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "Pricing",
		"twitter:description": "Powerful authentication and authorization for your apps and APIs. Flexible pricing for developers and enterprises incl. a free forever dev plan.",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"privacy-page",
		"header-dark"
	],
	"title": "Privacy Policy",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"resources",
		"header-dark"
	],
	"title": "Resources",
	"metas": {
		"description": "Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year."
	},
	"opengraph": {
		"og:title": "Resources",
		"og:description": "Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year.",
		"og:url": "https://auth0.com/resources",
		"og:image": "https://cdn.auth0.com/website/assets/pages/resources/img/new-twitter-card-35f9a33c39.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/resources/img/new-twitter-card-35f9a33c39.png"
	},
	"twittercard": {
		"twitter:title": "Resources",
		"twitter:description": "Learn how we secure and solve the most complex identity use cases with an extensible, easy to integrate platform that powers trillions of logins every year.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/resources/img/new-twitter-card-35f9a33c39.png"
			}
		]
	},
	"canonical": "/resources"
};

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"security-page",
		"header-dark"
	],
	"title": "Security",
	"metas": {
		"description": "Policies Regarding Data Security & Confidentiality."
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"signup-page"
	],
	"title": "Sign Up",
	"metas": {
		"description": "Single Sign On & Token Based Authentication"
	},
	"opengraph": {
		"og:title": "Sign Up",
		"og:description": "Single Sign On & Token Based Authentication",
		"og:url": "https://auth0.com/signup",
		"og:image": "/pages/opengraph/1x-new.png",
		"og:image:secure_url": "/pages/opengraph/1x-new.png"
	},
	"twittercard": {
		"twitter:title": "Sign Up",
		"twitter:description": "Single Sign On & Token Based Authentication",
		"twitter:image": [
			{
				"src": "/pages/twittercard/1x-new.png"
			}
		]
	}
};

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"subscription-center-page"
	],
	"title": "Subscription Center",
	"metas": {
		"description": ""
	},
	"opengraph": {
		"og:title": "",
		"og:description": "",
		"og:url": "https://auth0.com/subscription-center",
		"og:image": "",
		"og:image:secure_url": ""
	},
	"twittercard": {
		"twitter:title": "",
		"twitter:description": "",
		"twitter:image": [
			{
				"src": ""
			}
		]
	}
};

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"tos-page",
		"header-dark"
	],
	"title": "Terms of Service",
	"metas": {},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"whitehat-page",
		"header-dark"
	],
	"title": "Whitehat",
	"metas": {
		"description": "Responsible Disclosure Program and Security Researcher Hall of Fame."
	},
	"opengraph": {},
	"twittercard": {}
};

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"whyauth0-page",
		"header-dark"
	],
	"title": "Why Auth0",
	"metas": {
		"description": "Identity in Modern Cloud-Hybrid Apps and APIs is Radically More Complex. Traditional Identity Infrastructure Is Obsolete"
	},
	"opengraph": {},
	"twittercard": {},
	"canonical": "/why-auth0"
};

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports = {
	"classes": [
		"wordpress-page",
		"header-dark"
	],
	"title": "WordPress Authentication",
	"metas": {
		"description": "Advanced Identity Management in WordPress can be very hard. At Auth0 we want to change that, by simplifying as much as possible."
	},
	"opengraph": {
		"og:title": "WordPress Authentication",
		"og:description": "Advanced Identity Management in WordPress can be very hard. At Auth0 we want to change that, by simplifying as much as possible.",
		"og:url": "https://auth0.com/wordpress",
		"og:image": "https://cdn.auth0.com/website/assets/pages/wordpress/img/twitter-card-1cc65617d8.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/wordpress/img/twitter-card-1cc65617d8.png"
	},
	"twittercard": {
		"twitter:title": "Passwordless: SMS Login and Email Authentication",
		"twitter:description": "Advanced Identity Management in WordPress can be very hard. At Auth0 we want to change that, by simplifying as much as possible.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/wordpress/img/twitter-card-1cc65617d8.png",
				"width": "2400",
				"height": "1600"
			}
		]
	}
};

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// client.271f875c.js